webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.locationType = exports.customTabType = exports.routeType = exports.routerType = exports.attachmentType = exports.gridStyleType = exports.mergeDocumentType = exports.columnObjectType = exports.uploadType = exports.dataType = exports.reduxFormInputType = exports.billingDetailsType = exports.invoiceType = exports.planDetailsType = exports.passwordType = exports.reportType = exports.selectOptionType = exports.flashType = exports.vendorType = exports.userType = exports.rowType = exports.documentFiltersType = exports.documentPropType = exports.paymentTypeType = exports.paginationType = exports.momentType = exports.focusedDocumentType = exports.envelopeType = exports.currencyType = exports.categoryType = exports.cardNumberType = exports.addressType = exports.accountType = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var accountType = exports.accountType = _propTypes2.default.shape({
  id: _propTypes2.default.string,
  label: _propTypes2.default.string,
  slug: _propTypes2.default.string
});

var addressType = exports.addressType = _propTypes2.default.shape({
  firstName: _propTypes2.default.string,
  lastName: _propTypes2.default.string,
  name: _propTypes2.default.string,
  surname: _propTypes2.default.string,
  streetLine1: _propTypes2.default.string,
  streetLine2: _propTypes2.default.string,
  city: _propTypes2.default.string,
  region: _propTypes2.default.string,
  postcode: _propTypes2.default.string,
  country: _propTypes2.default.string
});

var cardNumberType = exports.cardNumberType = _propTypes2.default.shape({
  name: _propTypes2.default.string,
  lastFourDigits: _propTypes2.default.string
});

var categoryType = exports.categoryType = _propTypes2.default.shape({
  id: _propTypes2.default.string,
  name: _propTypes2.default.string
});

var currencyType = exports.currencyType = _propTypes2.default.shape({
  code: _propTypes2.default.string,
  symbol: _propTypes2.default.string
});

var envelopeType = exports.envelopeType = _propTypes2.default.shape({
  code: _propTypes2.default.string,
  status: _propTypes2.default.string
});

var focusedDocumentType = exports.focusedDocumentType = _propTypes2.default.shape({
  id: _propTypes2.default.string,
  processingState: _propTypes2.default.string,
  type: _propTypes2.default.string,
  vendor: _propTypes2.default.string
});

var momentType = exports.momentType = _propTypes2.default.shape({
  _d: _propTypes2.default.date,
  format: _propTypes2.default.func
});

var paginationType = exports.paginationType = _propTypes2.default.shape({
  limit: _propTypes2.default.number,
  page: _propTypes2.default.number,
  totalResults: _propTypes2.default.number
});

var paymentTypeType = exports.paymentTypeType = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  type: _propTypes2.default.string,
  lastFourDigits: _propTypes2.default.string
})]);

var documentPropType = exports.documentPropType = _propTypes2.default.shape({
  id: _propTypes2.default.string,
  issued: _propTypes2.default.string,
  modified: _propTypes2.default.string,
  processingState: _propTypes2.default.string,
  source: _propTypes2.default.shape({ id: _propTypes2.default.string, name: _propTypes2.default.string }),
  uploaded: _propTypes2.default.string,
  vendor: _propTypes2.default.string,
  viewed: _propTypes2.default.bool
});

var documentFiltersType = exports.documentFiltersType = _propTypes2.default.shape({
  endDate: momentType,
  limit: _propTypes2.default.number,
  processingState: _propTypes2.default.string,
  orderDirection: _propTypes2.default.string,
  orderBy: _propTypes2.default.string,
  startDate: momentType,
  selectedVendors: _propTypes2.default.arrayOf(_propTypes2.default.string),
  totalMin: _propTypes2.default.string,
  totalMax: _propTypes2.default.string,
  viewed: _propTypes2.default.bool
});

var rowType = exports.rowType = _propTypes2.default.shape({
  currency: _propTypes2.default.string,
  id: _propTypes2.default.string,
  invoiceNumber: _propTypes2.default.string,
  issued: _propTypes2.default.string,
  tax: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  total: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  vendor: _propTypes2.default.string
});

var userType = exports.userType = _propTypes2.default.shape({
  email: _propTypes2.default.string,
  firstName: _propTypes2.default.string,
  id: _propTypes2.default.string,
  lastName: _propTypes2.default.string
});

var vendorType = exports.vendorType = _propTypes2.default.shape({
  name: _propTypes2.default.string
});

var flashType = exports.flashType = _propTypes2.default.shape({
  message: _propTypes2.default.string,
  type: _propTypes2.default.oneOf(["success", "error"])
});

var selectOptionType = exports.selectOptionType = _propTypes2.default.oneOfType([_propTypes2.default.shape({
  key: _propTypes2.default.string,
  name: _propTypes2.default.string
}), _propTypes2.default.string // Empty string
]);

var reportType = exports.reportType = _propTypes2.default.shape({
  documentIds: _propTypes2.default.arrayOf(_propTypes2.default.string),
  exported: _propTypes2.default.string,
  id: _propTypes2.default.string,
  name: _propTypes2.default.string,
  to: _propTypes2.default.string,
  url: _propTypes2.default.string
});

var passwordType = exports.passwordType = _propTypes2.default.shape({
  currentPassword: _propTypes2.default.string,
  newPassword: _propTypes2.default.string,
  newPasswordRepeated: _propTypes2.default.string
});

var planDetailsType = exports.planDetailsType = _propTypes2.default.shape({
  planType: _propTypes2.default.string,
  maxUsers: _propTypes2.default.number,
  subscriptionType: _propTypes2.default.string,
  overageFeePerDocument: _propTypes2.default.string,
  documentLimitPerMonth: _propTypes2.default.number,
  defaultPrice: _propTypes2.default.string,
  totalProcessedCount: _propTypes2.default.number,
  mailinProcessedCount: _propTypes2.default.number,
  digitalProcessedCount: _propTypes2.default.number,
  billableEnvelopeCount: _propTypes2.default.number,
  envelopeLimitPerMonth: _propTypes2.default.number,
  periodStart: _propTypes2.default.string,
  periodEnd: _propTypes2.default.string
});

var invoiceType = exports.invoiceType = _propTypes2.default.shape({
  createdAt: _propTypes2.default.string,
  currency: _propTypes2.default.string,
  invoiceNumber: _propTypes2.default.number,
  pdfUrl: _propTypes2.default.string,
  state: _propTypes2.default.string,
  tax: _propTypes2.default.number,
  total: _propTypes2.default.number,
  uuid: _propTypes2.default.string
});

var billingDetailsType = exports.billingDetailsType = _propTypes2.default.shape({
  expiryMonth: _propTypes2.default.string,
  expiryYear: _propTypes2.default.string,
  lastFourDigits: _propTypes2.default.string,
  name: _propTypes2.default.string,
  surname: _propTypes2.default.string
});

var reduxFormInputType = exports.reduxFormInputType = _propTypes2.default.shape({
  name: _propTypes2.default.string,
  onChange: _propTypes2.default.func.isRequired,
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, momentType, _propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.object), _propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.bool]).isRequired
});

var dataType = exports.dataType = _propTypes2.default.shape({
  key: _propTypes2.default.string,
  name: _propTypes2.default.string
});

var uploadType = exports.uploadType = _propTypes2.default.shape({
  id: _propTypes2.default.string,
  type: _propTypes2.default.string,
  name: _propTypes2.default.string
});

var columnObjectType = exports.columnObjectType = _propTypes2.default.shape({
  key: _propTypes2.default.string,
  name: _propTypes2.default.string,
  resizable: _propTypes2.default.bool,
  sortable: _propTypes2.default.bool,
  visible: _propTypes2.default.bool
});

var mergeDocumentType = exports.mergeDocumentType = _propTypes2.default.shape({
  vendor: mergeDocumentItem,
  date: mergeDocumentItem,
  total: mergeDocumentItem,
  tax: mergeDocumentItem,
  category: mergeDocumentItem,
  invoiceNumber: mergeDocumentItem,
  paymentType: mergeDocumentItem
});

var mergeDocumentItem = _propTypes2.default.shape({
  id: _propTypes2.default.string,
  data: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.shape({
    type: _propTypes2.default.string
  }), _propTypes2.default.arrayOf(_propTypes2.default.string)])
});

var gridStyleType = exports.gridStyleType = _propTypes2.default.shape({
  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  left: _propTypes2.default.number,
  position: _propTypes2.default.string,
  top: _propTypes2.default.number,
  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
});

var attachmentType = exports.attachmentType = _propTypes2.default.shape({
  name: _propTypes2.default.string,
  url: _propTypes2.default.string
});

var routerType = exports.routerType = _propTypes2.default.shape({
  params: _propTypes2.default.object
});

var routeType = exports.routeType = _propTypes2.default.shape({
  path: _propTypes2.default.string
});

var customTabType = exports.customTabType = _propTypes2.default.shape({
  id: _propTypes2.default.string,
  name: _propTypes2.default.string,
  filters: _propTypes2.default.object
});

var locationType = exports.locationType = _propTypes2.default.shape({
  pathname: _propTypes2.default.string
});

/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleButton = exports.Button = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = __webpack_require__(456);

var _bind2 = _interopRequireDefault(_bind);

var _button = __webpack_require__(1300);

var _button2 = _interopRequireDefault(_button);

var _loadingWhite = __webpack_require__(1391);

var _loadingWhite2 = _interopRequireDefault(_loadingWhite);

var _loadingGrey = __webpack_require__(528);

var _loadingGrey2 = _interopRequireDefault(_loadingGrey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = exports.Button = function Button(_ref) {
  var children = _ref.children,
      danger = _ref.danger,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      link = _ref.link,
      loading = _ref.loading,
      primary = _ref.primary,
      type = _ref.type;

  var buttonClassNames = getClassNames(danger, disabled, link, primary);
  return _react2.default.createElement(
    "button",
    {
      className: buttonClassNames,
      disabled: disabled,
      onClick: onClick,
      tabIndex: "-1",
      type: type
    },
    _react2.default.createElement(
      "span",
      { className: loading ? _button2.default.invisible : "" },
      children
    ),
    !loading ? null : loadingContent(primary, danger, disabled)
  );
};

Button.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string]).isRequired,
  danger: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  link: _propTypes2.default.bool,
  loading: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  primary: _propTypes2.default.bool,
  type: _propTypes2.default.oneOf(["button", "submit"])
};

Button.defaultProps = {
  danger: false,
  disabled: false,
  link: false,
  loading: false,
  onClick: function onClick() {},
  primary: false,
  type: "button"
};

var ToggleButton = exports.ToggleButton = function ToggleButton(_ref2) {
  var children = _ref2.children,
      danger = _ref2.danger,
      disabled = _ref2.disabled,
      isOpen = _ref2.isOpen,
      onOpenClick = _ref2.onOpenClick,
      onCloseClick = _ref2.onCloseClick,
      link = _ref2.link,
      loading = _ref2.loading,
      primary = _ref2.primary,
      type = _ref2.type;

  var buttonClassNames = getClassNames(danger, disabled, link, primary);
  return _react2.default.createElement(
    "button",
    {
      className: buttonClassNames,
      disabled: disabled,
      onClick: isOpen ? onCloseClick : onOpenClick,
      type: type
    },
    _react2.default.createElement(
      "span",
      { className: loading ? _button2.default.invisible : "" },
      children
    ),
    !loading ? null : loadingContent(primary, danger, disabled)
  );
};

ToggleButton.propTypes = Button.propTypes;
ToggleButton.defaultProps = Button.defaultProps;

var getClassNames = function getClassNames(danger, disabled, link, primary) {
  var bindedClassnames = _bind2.default.bind(_button2.default);
  var buttonClassNames = bindedClassnames({
    "button--danger-link": link && danger,
    "button--danger": danger && !disabled,
    "button--primary": primary && !disabled,
    "button--link": link,
    button: true
  });
  return buttonClassNames;
};

var loadingContent = function loadingContent(primary, danger, disabled) {
  return _react2.default.createElement(
    "span",
    { className: _button2.default["loading-container"] },
    _react2.default.createElement("img", { alt: "Loading", src: (primary || danger) && !disabled ? _loadingWhite2.default : _loadingGrey2.default })
  );
};

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var IconBase = function IconBase(_ref, _ref2) {
  var children = _ref.children;
  var color = _ref.color;
  var size = _ref.size;
  var style = _ref.style;
  var width = _ref.width;
  var height = _ref.height;

  var props = _objectWithoutProperties(_ref, ['children', 'color', 'size', 'style', 'width', 'height']);

  var _ref2$reactIconBase = _ref2.reactIconBase;
  var reactIconBase = _ref2$reactIconBase === undefined ? {} : _ref2$reactIconBase;

  var computedSize = size || reactIconBase.size || '1em';
  return _react2.default.createElement('svg', _extends({
    children: children,
    fill: 'currentColor',
    preserveAspectRatio: 'xMidYMid meet',
    height: height || computedSize,
    width: width || computedSize
  }, reactIconBase, props, {
    style: _extends({
      verticalAlign: 'middle',
      color: color || reactIconBase.color
    }, reactIconBase.style || {}, style)
  }));
};

IconBase.propTypes = {
  color: _propTypes2.default.string,
  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  style: _propTypes2.default.object
};

IconBase.contextTypes = {
  reactIconBase: _propTypes2.default.shape(IconBase.propTypes)
};

exports.default = IconBase;
module.exports = exports['default'];

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.endTourAction = exports.startTourAction = exports.toggleBetaModalAction = exports.endFirstTimeBetaModeAction = exports.endGlobalErrorAction = exports.fetchDocumentsAction = exports.endNotificationsModeAction = exports.startNotificationsModeAction = exports.setActiveAccountAction = exports.endSettingsModeAction = exports.startSettingsModeAction = exports.clearFlashMessageAction = exports.setFlashGenericErrorAction = exports.setFlashMessageAction = exports.changeSelectedAccountAction = exports.globalErrorAction = exports.END_TOUR = exports.START_TOUR = exports.TOGGLE_BETA_MODAL = exports.END_FIRST_TIME_BETA_MODE = exports.END_GLOBAL_ERROR = exports.SET_QUEUED_COUNT = exports.SET_EXPORT_FAILED_COUNT = exports.END_NOTIFICATIONS_MODE = exports.START_NOTIFICATIONS_MODE = exports.END_SETTINGS_MODE = exports.START_SETTINGS_MODE = exports.CLEAR_FLASH_MESSAGE = exports.SET_FLASH_MESSAGE = exports.UNKNOWN_ERROR = undefined;

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _reduxSegment = __webpack_require__(396);

var _localStorage = __webpack_require__(138);

var _storage = __webpack_require__(164);

var _documents = __webpack_require__(114);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UNKNOWN_ERROR = exports.UNKNOWN_ERROR = "actions/app/unknown-error";
var SET_FLASH_MESSAGE = exports.SET_FLASH_MESSAGE = "actions/app/set-flash-message";
var CLEAR_FLASH_MESSAGE = exports.CLEAR_FLASH_MESSAGE = "actions/app/clear-flash-message";
var START_SETTINGS_MODE = exports.START_SETTINGS_MODE = "actions/app/start-settings-mode";
var END_SETTINGS_MODE = exports.END_SETTINGS_MODE = "actions/app/end-settings-mode";
var START_NOTIFICATIONS_MODE = exports.START_NOTIFICATIONS_MODE = "actions/app/start-notifications-mode";
var END_NOTIFICATIONS_MODE = exports.END_NOTIFICATIONS_MODE = "actions/app/end-notifications-mode";
var SET_EXPORT_FAILED_COUNT = exports.SET_EXPORT_FAILED_COUNT = "actions/app/set-export-failed-count";
var SET_QUEUED_COUNT = exports.SET_QUEUED_COUNT = "actions/app/set-queued-count";
var END_GLOBAL_ERROR = exports.END_GLOBAL_ERROR = "actions/app/end-global-error";
var END_FIRST_TIME_BETA_MODE = exports.END_FIRST_TIME_BETA_MODE = "actions/app/end-first-time-beta-mode";
var TOGGLE_BETA_MODAL = exports.TOGGLE_BETA_MODAL = "actions/app/toggle-beta-modal";
var START_TOUR = exports.START_TOUR = "actions/app/start-tour";
var END_TOUR = exports.END_TOUR = "actions/app/end-tour";

var globalErrorAction = exports.globalErrorAction = function globalErrorAction() {
  return { type: UNKNOWN_ERROR };
};

var changeSelectedAccountAction = exports.changeSelectedAccountAction = function changeSelectedAccountAction(accountId, accountSlug) {
  _localStorage.storage.set(_localStorage.SELECTED_ACCOUNT_ID, accountId);
  _localStorage.storage.set(_localStorage.SELECTED_ACCOUNT_SLUG, accountSlug);
  setTimeout(function () {
    document.location.href = "/accounts/" + accountSlug + "/documents";
  }, 0);
  return {
    type: "NOOP",
    meta: {
      analytics: {
        eventType: _reduxSegment.EventTypes.track,
        eventPayload: { event: "Change account" }
      }
    }
  };
};

var setFlashMessageAction = exports.setFlashMessageAction = function setFlashMessageAction(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "success";
  return {
    type: SET_FLASH_MESSAGE,
    data: { message: message, type: type }
  };
};

var setFlashGenericErrorAction = exports.setFlashGenericErrorAction = function setFlashGenericErrorAction() {
  return {
    type: SET_FLASH_MESSAGE,
    data: { message: "Oops! An error occurred. Please try again later", type: "error" }
  };
};

var clearFlashMessageAction = exports.clearFlashMessageAction = function clearFlashMessageAction() {
  return {
    type: CLEAR_FLASH_MESSAGE
  };
};

var startSettingsModeAction = exports.startSettingsModeAction = function startSettingsModeAction() {
  return {
    type: START_SETTINGS_MODE
  };
};

var endSettingsModeAction = exports.endSettingsModeAction = function endSettingsModeAction() {
  return {
    type: END_SETTINGS_MODE
  };
};

var setActiveAccountAction = exports.setActiveAccountAction = function setActiveAccountAction(accountId) {
  (0, _storage.setActiveAccount)(accountId);
  return {
    type: "NOOP"
  };
};

var startNotificationsModeAction = exports.startNotificationsModeAction = function startNotificationsModeAction() {
  return {
    type: START_NOTIFICATIONS_MODE
  };
};

var endNotificationsModeAction = exports.endNotificationsModeAction = function endNotificationsModeAction() {
  return {
    type: END_NOTIFICATIONS_MODE
  };
};

var fetchDocumentsAction = exports.fetchDocumentsAction = function fetchDocumentsAction(accountId, filters) {
  return function (dispatch) {
    var exportFailedFilters = _ramda2.default.set(_ramda2.default.lensProp("selectedCategories"), ["Export failed"], filters);
    var queuedFilters = _ramda2.default.set(_ramda2.default.lensProp("selectedCategories"), ["Queued for Export"], filters);
    var pagination = {
      pageNumber: 1,
      limit: 1,
      totalCountFiltered: 0
    };
    return Promise.all([dispatchExportFailedPromise(accountId, exportFailedFilters, pagination, dispatch), dispatchQueuedPromise(accountId, queuedFilters, pagination, dispatch)]);
  };
};

var dispatchExportFailedPromise = function dispatchExportFailedPromise(accountId, filters, pagination, dispatch) {
  return (0, _documents.fetchDocuments)(accountId, filters, pagination).then(function (_ref) {
    var totalCountFiltered = _ref.totalCountFiltered;

    dispatch({
      type: SET_EXPORT_FAILED_COUNT,
      data: { exportFailedCount: totalCountFiltered }
    });
  });
};

var dispatchQueuedPromise = function dispatchQueuedPromise(accountId, filters, pagination, dispatch) {
  return (0, _documents.fetchDocuments)(accountId, filters, pagination).then(function (_ref2) {
    var totalCountFiltered = _ref2.totalCountFiltered;

    dispatch({
      type: SET_QUEUED_COUNT,
      data: { queuedCount: totalCountFiltered }
    });
  });
};

var endGlobalErrorAction = exports.endGlobalErrorAction = function endGlobalErrorAction() {
  return {
    type: END_GLOBAL_ERROR
  };
};

var endFirstTimeBetaModeAction = exports.endFirstTimeBetaModeAction = function endFirstTimeBetaModeAction(dontRemind) {
  return function (dispatch) {
    if (dontRemind) {
      return (0, _storage.putBetaViewedStatus)(true).then(function () {
        return dispatch({ type: END_FIRST_TIME_BETA_MODE });
      });
    }
    return dispatch({ type: END_FIRST_TIME_BETA_MODE });
  };
};

var toggleBetaModalAction = exports.toggleBetaModalAction = function toggleBetaModalAction(toggle) {
  return {
    type: TOGGLE_BETA_MODAL,
    data: { toggle: toggle }
  };
};

var startTourAction = exports.startTourAction = function startTourAction(tour) {
  return {
    type: START_TOUR,
    data: { tour: tour }
  };
};

var endTourAction = exports.endTourAction = function endTourAction() {
  return {
    type: END_TOUR
  };
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackIdentityAction = exports.trackEventAction = exports.trackPageAction = undefined;

var _reduxSegment = __webpack_require__(396);

var trackPageAction = exports.trackPageAction = function trackPageAction(pageTitle) {
  return {
    type: "NOOP",
    meta: {
      analytics: {
        eventType: _reduxSegment.EventTypes.page,
        eventPayload: { name: pageTitle }
      }
    }
  };
};

var trackEventAction = exports.trackEventAction = function trackEventAction(eventName) {
  return {
    type: "NOOP",
    meta: {
      analytics: {
        eventType: _reduxSegment.EventTypes.track,
        eventPayload: { event: eventName }
      }
    }
  };
};

var trackIdentityAction = exports.trackIdentityAction = function trackIdentityAction(id) {
  return {
    type: "NOOP",
    meta: {
      analytics: {
        eventType: _reduxSegment.EventTypes.identify,
        eventPayload: { userId: id }
      }
    }
  };
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DraggableModal = exports.Modal = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactAddonsCssTransitionGroup = __webpack_require__(400);

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _modal = __webpack_require__(1310);

var _modal2 = _interopRequireDefault(_modal);

var _reactDraggable = __webpack_require__(1778);

var _reactDraggable2 = _interopRequireDefault(_reactDraggable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Modal = exports.Modal = function Modal(_ref) {
  var children = _ref.children,
      onClose = _ref.onClose,
      isVisible = _ref.isVisible,
      transitionName = _ref.transitionName;

  if (!isVisible) {
    return null;
  }
  return _react2.default.createElement(
    _reactAddonsCssTransitionGroup2.default,
    {
      transitionEnterTimeout: 200,
      transitionLeaveTimeout: 300,
      transitionName: transitionName
    },
    _react2.default.createElement("button", { className: _modal2.default.modal, key: "modalOpen", onClick: onClose }),
    _react2.default.createElement(
      "div",
      { className: _modal2.default["modal-container"], onClick: onClose },
      _react2.default.createElement(
        "div",
        { className: _modal2.default["modal-box"], onClick: function onClick(e) {
            return e.stopPropagation();
          } },
        children
      )
    )
  );
};

Modal.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.element.isRequired, _propTypes2.default.arrayOf(_propTypes2.default.element)]).isRequired,
  isVisible: _propTypes2.default.bool.isRequired,
  onClose: _propTypes2.default.func.isRequired,
  transitionName: _propTypes2.default.string.isRequired
};

var DraggableModal = exports.DraggableModal = function DraggableModal(_ref2) {
  var handle = _ref2.handle,
      children = _ref2.children,
      _ref2$isDisabled = _ref2.isDisabled,
      isDisabled = _ref2$isDisabled === undefined ? false : _ref2$isDisabled,
      isVisible = _ref2.isVisible;

  if (!isVisible) {
    return null;
  }
  var isDraggable = isDisabled ? "" : _modal2.default["draggable-mode"];
  return _react2.default.createElement(
    _reactDraggable2.default,
    { disabled: isDisabled, handle: handle },
    _react2.default.createElement(
      "div",
      { className: _modal2.default["draggable-modal-container"] + " " + isDraggable },
      children
    )
  );
};

DraggableModal.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.element.isRequired, _propTypes2.default.arrayOf(_propTypes2.default.element)]).isRequired,
  handle: _propTypes2.default.string.isRequired,
  isDisabled: _propTypes2.default.bool.isRequired,
  isVisible: _propTypes2.default.bool.isRequired
};

/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var isValidEmail = exports.isValidEmail = function isValidEmail(email) {
  if (/\S+@\S+\.\S+/.test(email)) {
    return true;
  }
  return false;
};

var isValidUser = exports.isValidUser = function isValidUser(user) {
  if (user.firstName.length > 0 && user.lastName.length > 0 && isValidEmail(user.email)) {
    return true;
  }
  return false;
};

var isValidValue = exports.isValidValue = function isValidValue(value) {
  if (value === "" || value === null || value === undefined) {
    return false;
  }
  return true;
};

/***/ }),
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loading = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _loadingGrey = __webpack_require__(528);

var _loadingGrey2 = _interopRequireDefault(_loadingGrey);

var _loading = __webpack_require__(1309);

var _loading2 = _interopRequireDefault(_loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Loading = exports.Loading = function Loading() {
  return _react2.default.createElement(
    "span",
    { className: _loading2.default.loading },
    _react2.default.createElement("img", { alt: "Loading", className: _loading2.default.spinner, src: _loadingGrey2.default })
  );
};

/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreatableMultiSelect = exports.MultiCreatableSelect = exports.MultiSelect = exports.SimpleSelect = exports.CreatableSelect = exports.onChangeMapper = exports.optionsMapper = exports.valueMapper = exports.Select = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSelect = __webpack_require__(135);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _reactVirtualizedSelect = __webpack_require__(260);

var _reactVirtualizedSelect2 = _interopRequireDefault(_reactVirtualizedSelect);

var _plus = __webpack_require__(451);

var _plus2 = _interopRequireDefault(_plus);

var _customPropTypes = __webpack_require__(5);

__webpack_require__(1375);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var Select = exports.Select = function Select(_ref) {
  var data = _ref.data,
      onChange = _ref.onChange,
      placeholder = _ref.placeholder,
      value = _ref.value;
  return _react2.default.createElement(_reactVirtualizedSelect2.default, {
    clearable: false,
    onChange: onChangeMapper(onChange),
    options: optionsMapper(data),
    placeholder: placeholder,
    value: valueMapper(value)
  });
};

var valueMapper = exports.valueMapper = function valueMapper(v) {
  if (v === null || v === "" || v === undefined) {
    return null;
  }
  return { label: v.name, value: v.key, disabled: v.disabled, info: v.info };
};

var optionsMapper = exports.optionsMapper = function optionsMapper(data) {
  return data.map(valueMapper);
};

var onChangeMapper = exports.onChangeMapper = function onChangeMapper(onChange) {
  return function (data) {
    var newData = { key: data.value, name: data.label, info: data.info };
    onChange(newData);
  };
};

Select.propTypes = {
  data: _propTypes2.default.arrayOf(_customPropTypes.selectOptionType).isRequired,
  onChange: _propTypes2.default.func.isRequired, // (data: dataType) => void,
  placeholder: _propTypes2.default.string,
  value: _customPropTypes.selectOptionType
};

Select.defaultProps = {
  placeholder: undefined,
  value: null
};

var CreatableSelect = exports.CreatableSelect = function CreatableSelect(_ref2) {
  var accountId = _ref2.accountId,
      createOption = _ref2.createOption,
      data = _ref2.data,
      onChange = _ref2.onChange,
      placeholder = _ref2.placeholder,
      value = _ref2.value;
  return _react2.default.createElement(_reactVirtualizedSelect2.default, {
    clearable: false,
    onChange: onChangeMapper(onChange),
    options: optionsMapper(data),
    placeholder: placeholder,
    selectComponent: function selectComponent(props) {
      return _react2.default.createElement(_reactSelect.Creatable, _extends({}, props, {
        onNewOptionClick: function onNewOptionClick(label) {
          createOption(accountId, label.value);onChange({ name: label.value });
        },
        promptTextCreator: function promptTextCreator(label) {
          return "Add '" + label + "'";
        }
      }));
    },
    value: valueMapper(value)
  });
};

CreatableSelect.propTypes = Select.propTypes;
CreatableSelect.defaultProps = Select.defaultProps;

var SimpleSelect = exports.SimpleSelect = function SimpleSelect(_ref3) {
  var data = _ref3.data,
      onChange = _ref3.onChange,
      placeholder = _ref3.placeholder,
      value = _ref3.value;
  return _react2.default.createElement(_reactSelect2.default, {
    clearable: false,
    onChange: onChangeMapper(onChange),
    options: optionsMapper(data),
    placeholder: placeholder,
    searchable: false,
    value: valueMapper(value)
  });
};

SimpleSelect.propTypes = {
  data: _propTypes2.default.arrayOf(_customPropTypes.selectOptionType).isRequired,
  onChange: _propTypes2.default.func.isRequired, // (data: dataType) => void
  placeholder: _propTypes2.default.string,
  value: _customPropTypes.selectOptionType
};

SimpleSelect.defaultProps = {
  placeholder: "Select...",
  value: null
};

var MultiSelect = exports.MultiSelect = function MultiSelect(props) {
  return _react2.default.createElement(_reactSelect2.default, _extends({}, props, {
    clearable: false,
    multi: true,
    onBlur: function onBlur() {
      return props.input.onBlur([].concat(_toConsumableArray(props.input.value)));
    },
    onChange: function onChange(value) {
      return props.input.onChange(value);
    },
    options: optionsMapper(props.options),
    value: props.input.value
  }));
};

MultiSelect.propTypes = {
  input: _propTypes2.default.shape({
    onBlur: _propTypes2.default.func,
    onChange: _propTypes2.default.func,
    value: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_customPropTypes.selectOptionType), _propTypes2.default.string])
  }),
  options: _propTypes2.default.arrayOf(_customPropTypes.selectOptionType)
};

MultiSelect.defaultProps = {
  input: null,
  placeholder: "Select...",
  value: null
};

var MultiCreatableSelect = exports.MultiCreatableSelect = function MultiCreatableSelect(props) {
  var optionsRemapper = function optionsRemapper(options) {
    return options.map(function (option) {
      return { key: option.name, name: option.name };
    });
  };
  var newOptions = optionsRemapper(props.options);
  return _react2.default.createElement(_reactVirtualizedSelect2.default, _extends({}, props, {
    clearable: false,
    multi: true,
    onBlur: function onBlur() {
      return props.input.onBlur([].concat(_toConsumableArray(props.input.value)));
    },
    onChange: function onChange(value) {
      props.input.onChange(value);
    },
    options: optionsMapper(newOptions),
    placeholder: props.placeholder,
    selectComponent: selectComponentCreator,
    tabSelectsValue: false,
    value: props.input.value
  }));
};

MultiCreatableSelect.propTypes = {
  input: _customPropTypes.reduxFormInputType.isRequired,
  options: _propTypes2.default.arrayOf(_customPropTypes.categoryType).isRequired,
  placeholder: _propTypes2.default.string.isRequired
};

var selectComponentCreator = function selectComponentCreator(props) {
  return _react2.default.createElement(_reactSelect.Creatable, _extends({}, props, {
    onNewOptionClick: function onNewOptionClick(label) {
      props.addFunction(props.accountId, label.value);
      props.input.onChange([].concat(_toConsumableArray(props.input.value), [label.value]));
    },
    promptTextCreator: function promptTextCreator(label) {
      return renderAddLabel(label);
    },
    shouldKeyDownEventCreateNewOption: function shouldKeyDownEventCreateNewOption(_ref4) {
      var keyCode = _ref4.keyCode;
      return disableTab(keyCode);
    }
  }));
};

selectComponentCreator.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  addFunction: _propTypes2.default.func.isRequired,
  input: _customPropTypes.reduxFormInputType.isRequired
};

var CreatableMultiSelect = exports.CreatableMultiSelect = function CreatableMultiSelect(props) {
  var optionsRemapper = function optionsRemapper(options) {
    return options.map(function (option) {
      return { key: option.name, name: option.name };
    });
  };
  var newOptions = optionsRemapper(props.options);
  var valueRemapper = function valueRemapper(values) {
    return values.map(function (value) {
      return value.value;
    });
  };
  return _react2.default.createElement(_reactVirtualizedSelect2.default, _extends({}, props, {
    clearable: false,
    multi: true,
    onChange: function onChange(value) {
      props.onChange(props.field, valueRemapper(value));
    },
    options: optionsMapper(newOptions),
    placeholder: props.placeholder,
    selectComponent: selectCreator,
    tabSelectsValue: false,
    value: props.value
  }));
};

CreatableMultiSelect.propTypes = {
  field: _propTypes2.default.string.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  options: _propTypes2.default.arrayOf(_customPropTypes.categoryType).isRequired,
  placeholder: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

var selectCreator = function selectCreator(props) {
  return _react2.default.createElement(_reactSelect.Creatable, _extends({}, props, {
    onNewOptionClick: function onNewOptionClick(label) {
      props.addFunction(props.accountId, label.value);
      props.onChange([].concat(_toConsumableArray(props.value), [label.value]));
    },
    promptTextCreator: function promptTextCreator(label) {
      return renderAddLabel(label);
    },
    shouldKeyDownEventCreateNewOption: function shouldKeyDownEventCreateNewOption(_ref5) {
      var keyCode = _ref5.keyCode;
      return disableTab(keyCode);
    }
  }));
};

selectCreator.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  addFunction: _propTypes2.default.func.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  value: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

var disableTab = function disableTab(keyCode) {
  return keyCode === 13;
};

var renderAddLabel = function renderAddLabel(label) {
  return _react2.default.createElement(
    "span",
    null,
    _react2.default.createElement(_plus2.default, { size: 15 }),
    " Add '" + label + "'"
  );
};

/***/ }),
/* 46 */,
/* 47 */,
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.store = undefined;

var _redux = __webpack_require__(100);

var _reduxThunk = __webpack_require__(401);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _index = __webpack_require__(991);

var _developmentOnly = __webpack_require__(1895);

var _reduxSegment = __webpack_require__(396);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tracker = (0, _reduxSegment.createTracker)();

var store = exports.store = (0, _redux.createStore)(_index.reducers, (0, _developmentOnly.composeWithDevTools)((0, _redux.applyMiddleware)(_reduxThunk2.default, tracker)));

/***/ }),
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.firstTimeBetaAction = exports.findSelectedAccount = exports.loadStoredAccountIds = exports.bootstrapAction = exports.START_FIRST_TIME_BETA_MODE = exports.BOOTSTRAP_CUSTOM_TABS = exports.BOOTSTRAP_CARD_NUMBERS = exports.BOOTSTRAP_ACCOUNT_SETTINGS = exports.BOOTSTRAP_DOCUMENTS_ORDER = exports.BOOTSTRAP_VISIBLE_DOCUMENTS_COLUMNS = exports.LOADING_STOP = exports.BOOTSTRAP_CURRENCIES = exports.BOOTSTRAP_CATEGORIES = exports.BOOTSTRAP_ENVELOPES = exports.BOOTSTRAP_VENDORS = exports.BOOTSTRAP_CURRENT_USER_AND_ACCOUNTS = undefined;

var _accountSettings = __webpack_require__(413);

var _users = __webpack_require__(416);

var _vendors = __webpack_require__(417);

var _categories = __webpack_require__(265);

var _currencies = __webpack_require__(837);

var _envelopes = __webpack_require__(414);

var _cardNumbers = __webpack_require__(836);

var _storage = __webpack_require__(164);

var _localStorage = __webpack_require__(138);

var _validators = __webpack_require__(36);

var _trackingActions = __webpack_require__(26);

var _pendingDocumentsActions = __webpack_require__(195);

var _storage2 = __webpack_require__(164);

var BOOTSTRAP_CURRENT_USER_AND_ACCOUNTS = exports.BOOTSTRAP_CURRENT_USER_AND_ACCOUNTS = "actions/bootstrap/set-current-user-and-accounts";
var BOOTSTRAP_VENDORS = exports.BOOTSTRAP_VENDORS = "actions/bootstrap/bootstrap-vendors";
var BOOTSTRAP_ENVELOPES = exports.BOOTSTRAP_ENVELOPES = "actions/bootsrap/bootstrap-envelopes";
var BOOTSTRAP_CATEGORIES = exports.BOOTSTRAP_CATEGORIES = "actions/bootstrap/bootstrap-categories";
var BOOTSTRAP_CURRENCIES = exports.BOOTSTRAP_CURRENCIES = "actions/bootstrap/bootstrap-currencies";
var LOADING_STOP = exports.LOADING_STOP = "actions/bootstrap/loading-stop";
var BOOTSTRAP_VISIBLE_DOCUMENTS_COLUMNS = exports.BOOTSTRAP_VISIBLE_DOCUMENTS_COLUMNS = "actions/bootstrap/bootstrap-visible-documents-columns";
var BOOTSTRAP_DOCUMENTS_ORDER = exports.BOOTSTRAP_DOCUMENTS_ORDER = "actions/bootstrap/bootstrap-documents-order";
var BOOTSTRAP_ACCOUNT_SETTINGS = exports.BOOTSTRAP_ACCOUNT_SETTINGS = "actions/bootstrap/bootstrap-account-settings";
var BOOTSTRAP_CARD_NUMBERS = exports.BOOTSTRAP_CARD_NUMBERS = "actions/bootstrap/bootstrap-account-cards";
var BOOTSTRAP_CUSTOM_TABS = exports.BOOTSTRAP_CUSTOM_TABS = "actions/bootstrap/bootstrap-custom-tabs";
var START_FIRST_TIME_BETA_MODE = exports.START_FIRST_TIME_BETA_MODE = "actions/app/start-first-time-beta-mode";

var bootstrapAction = exports.bootstrapAction = function bootstrapAction() {
  return function (dispatch) {
    loadSavedDocumentsColumns(dispatch);
    loadSavedDocumentsOrder(dispatch);
    return loadStoredAccountIds().then(function (_ref) {
      var activeAccountId = _ref.activeAccountId,
          favouriteAccountId = _ref.favouriteAccountId;

      (0, _users.fetchCurrentUserAndAccounts)().then(function (_ref2) {
        var accounts = _ref2.accounts,
            user = _ref2.user;

        var selectedAccount = findSelectedAccount(accounts, activeAccountId, favouriteAccountId);
        firstTimeBetaAction(dispatch);
        (0, _storage.putActiveAccount)(selectedAccount.id);
        dispatch((0, _pendingDocumentsActions.fetchPendingDocumentsAction)(selectedAccount.id));
        dispatch({
          type: BOOTSTRAP_CURRENT_USER_AND_ACCOUNTS,
          data: { accounts: accounts.sort(accountSorter), selectedAccount: selectedAccount, user: user }
        });
        dispatch((0, _trackingActions.trackIdentityAction)(user.id));
        // storage.remove(SELECTED_ACCOUNT_ID);
        // storage.remove(SELECTED_ACCOUNT_SLUG);
        return selectedAccount;
      }).then(function (account) {
        return Promise.all([dispatchCustomTabsPromise(dispatch), dispatchVendorsPromise(account.id, dispatch), dispatchCategoriesPromise(account.id, dispatch), dispatchCurrenciesPromise(account.id, dispatch), dispatchEnvelopesPromise(account.id, dispatch), dispatchAccountSettingsPromise(account.id, dispatch), dispatchCardNumbersPromise(account.id, dispatch)]);
      }).then(function () {
        return Promise.resolve(dispatch({ type: LOADING_STOP }));
      });
    });
  };
};

var loadStoredAccountIds = exports.loadStoredAccountIds = function loadStoredAccountIds() {
  return Promise.all([(0, _storage.fetchActiveAccount)(), (0, _storage.fetchFavouriteAccount)()]).then(function (response) {
    return {
      activeAccountId: response[0],
      favouriteAccountId: response[1]
    };
  });
};

var findSelectedAccount = exports.findSelectedAccount = function findSelectedAccount(accounts, activeAccountId, favouriteAccountId) {
  var newSelectedAccountId = _localStorage.storage.get(_localStorage.SELECTED_ACCOUNT_ID);
  var selectedAccountId = void 0;
  if ((0, _validators.isValidValue)(newSelectedAccountId)) {
    selectedAccountId = newSelectedAccountId;
  } else if (favouriteAccountId) {
    selectedAccountId = favouriteAccountId;
  } else if (activeAccountId) {
    // && !favouriteid
    selectedAccountId = activeAccountId;
  } else {
    // && !activeAccountId)
    selectedAccountId = accounts[0].id;
  }
  var selectedAccount = accounts.find(function (account) {
    return account.id === selectedAccountId;
  });
  if (selectedAccount === undefined) {
    return accounts[0];
  }
  return selectedAccount;
};

var accountSorter = function accountSorter(accountA, accountB) {
  var a = accountA.label.toLowerCase();
  var b = accountB.label.toLowerCase();

  if (a > b) {
    return 1;
  }

  if (a < b) {
    return -1;
  }

  return 0;
};

var loadSavedDocumentsColumns = function loadSavedDocumentsColumns(dispatch) {
  var storedValues = _localStorage.storage.get(_localStorage.VISIBLE_DOCUMENTS_COLUMNS);
  if (storedValues === null || storedValues === undefined) {
    return null;
  }

  return dispatch({
    type: BOOTSTRAP_VISIBLE_DOCUMENTS_COLUMNS,
    data: { columnKeys: JSON.parse(storedValues) }
  });
};

var loadSavedDocumentsOrder = function loadSavedDocumentsOrder(dispatch) {
  var storedValue = _localStorage.storage.get(_localStorage.DOCUMENTS_SORTING_ORDER);
  if (storedValue === null || storedValue === undefined) {
    return null;
  }
  var data = JSON.parse(storedValue);
  return dispatch({
    type: BOOTSTRAP_DOCUMENTS_ORDER,
    data: data
  });
};

var dispatchAccountSettingsPromise = function dispatchAccountSettingsPromise(accountId, dispatch) {
  return (0, _accountSettings.fetchAccountSettings)(accountId).then(function (_ref3) {
    var accountSettings = _ref3.accountSettings;

    dispatch({
      type: BOOTSTRAP_ACCOUNT_SETTINGS,
      data: { accountSettings: accountSettings }
    });
  });
};

var dispatchVendorsPromise = function dispatchVendorsPromise(accountId, dispatch) {
  return (0, _vendors.fetchVendors)(accountId).then(function (_ref4) {
    var vendors = _ref4.vendors;

    dispatch({
      type: BOOTSTRAP_VENDORS,
      data: { vendors: vendors }
    });
  });
};

var dispatchCategoriesPromise = function dispatchCategoriesPromise(accountId, dispatch) {
  return (0, _categories.fetchCategories)(accountId).then(function (_ref5) {
    var categories = _ref5.categories;

    dispatch({
      type: BOOTSTRAP_CATEGORIES,
      data: { categories: categories }
    });
  });
};

var dispatchCurrenciesPromise = function dispatchCurrenciesPromise(accountId, dispatch) {
  return (0, _currencies.fetchCurrencies)(accountId).then(function (_ref6) {
    var currencies = _ref6.currencies;

    dispatch({
      type: BOOTSTRAP_CURRENCIES,
      data: { currencies: currencies }
    });
  });
};

var dispatchEnvelopesPromise = function dispatchEnvelopesPromise(accountId, dispatch) {
  return (0, _envelopes.fetchEnvelopes)(accountId).then(function (_ref7) {
    var envelopes = _ref7.envelopes;

    dispatch({
      type: BOOTSTRAP_ENVELOPES,
      data: { envelopes: envelopes }
    });
  });
};

var dispatchCardNumbersPromise = function dispatchCardNumbersPromise(accountId, dispatch) {
  return (0, _cardNumbers.fetchCardNumbers)(accountId).then(function (_ref8) {
    var cardNumbers = _ref8.cardNumbers;

    dispatch({
      type: BOOTSTRAP_CARD_NUMBERS,
      data: { cardNumbers: cardNumbers }
    });
  });
};

var dispatchCustomTabsPromise = function dispatchCustomTabsPromise(dispatch) {
  return (0, _storage.fetchCustomTabs)().then(function (response) {
    if (response) {
      dispatch({
        type: BOOTSTRAP_CUSTOM_TABS,
        data: { customTabs: response }
      });
    }
  });
};

var firstTimeBetaAction = exports.firstTimeBetaAction = function firstTimeBetaAction(dispatch) {
  return (0, _storage2.fetchViewedBetaStatus)().then(function (response) {
    if (response) {
      return null;
    }
    return dispatch({ type: START_FIRST_TIME_BETA_MODE });
  });
};

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.http = undefined;

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _store = __webpack_require__(48);

var _axios = __webpack_require__(397);

var _axios2 = _interopRequireDefault(_axios);

var _oauthActions = __webpack_require__(162);

var _appActions = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var authToken = function authToken() {
  return _ramda2.default.path(["oauth", "token"], _store.store.getState());
};

var instance = function instance() {
  return _axios2.default.create({
    baseURL: "https://api.squirrelstreet.com/v2",
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + authToken(),
      "Content-Type": "application/json"
    }
  });
};

var formDataInstance = function formDataInstance(url) {
  return _axios2.default.create({
    baseURL: url,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + authToken(),
      "Content-Type": "multipart/form-data"
    }
  });
};

var nonAjaxPost = function nonAjaxPost(url, data) {
  var form = document.createElement("form");
  form.method = "POST";
  form.action = url;
  form.setAttribute("style", "width: 0px; height: 0px");

  var keys = Object.keys(data);
  for (var i = 0; i < keys.length; i += 1) {
    var key = keys[i];

    if (data[key]) {
      var inputElement = document.createElement("input");
      inputElement.setAttribute("name", key);
      inputElement.setAttribute("value", data[key]);
      form.appendChild(inputElement);
    }
  }

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

var http = exports.http = {
  get: function get(path) {
    return instance().get(path).catch(errorCatcher);
  },
  post: function post(path, data) {
    return instance().post(path, data).catch(errorCatcher);
  },
  put: function put(path, data) {
    return instance().put(path, data).catch(errorCatcher);
  },
  delete: function _delete(path) {
    return instance().delete(path).catch(errorCatcher);
  },
  upload: function upload(path, data) {
    return formDataInstance("https://api.squirrelstreet.com/v2").post(path, data).catch(errorCatcher);
  },
  nonAjaxPost: nonAjaxPost
};

var errorCatcher = function errorCatcher(err) {
  var status = _ramda2.default.path(["response", "status"], err);

  /* TODO this is a temporary fix due to an issue where 401 responses from the API
   * are not compatible with CORS. It's impossible to read the response in JavaScript,
   * so for now, assume all network errors are 401s */
  if (status === undefined) {
    return _store.store.dispatch((0, _oauthActions.redirectToLoginAction)());
  }

  if (status >= 500) {
    return _store.store.dispatch((0, _appActions.globalErrorAction)());
  }

  return Promise.reject(err);
};

/***/ }),
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.redirectToBillingAction = exports.hideUpgradeDowngradeModalAction = exports.showUpgradeDowngradeModalAction = exports.setCancelSubscriptionVisibilityAction = exports.fetchPendingPlanAction = exports.updateDocReturnAction = exports.setRemoveSelfVisibilityAction = exports.setInviteUserVisibilityAction = exports.createUserAction = exports.removeUserAction = exports.saveCurrencyLocaleTaxAction = exports.saveBillingDetailsAction = exports.updateBillingDetailsAction = exports.updatePlanAction = exports.fetchBillingDetailsAction = exports.previousPageAction = exports.nextPageAction = exports.setPaginationLimitAction = exports.fetchBillingHistoryAction = exports.fetchPlansAction = exports.setPlanTypeDisplayAction = exports.saveAddressAction = exports.saveAccountSettingsAction = exports.fetchLocalesAction = exports.fetchAccountUsersAction = exports.fetchAccountDetailsAction = exports.DOCUMENT_RETURN_LOADING_STOP = exports.DOCUMENT_RETURN_LOADING = exports.REDIRECT_TO_BILLING = exports.UPDATE_CLT_SETTINGS = exports.UPDATE_ADDRESS = exports.UPDATE_ACCOUNT_NAME_AND_EMAIL = exports.HIDE_UPGRADE_DOWNGRADE_MODAL = exports.SHOW_UPGRADE_DOWNGRADE_MODAL = exports.SET_CANCEL_SUBSCRIPTION_VISIBILITY = exports.SET_PENDING_PLAN = exports.CHANGE_PLAN_LOADING_STOP = exports.CHANGE_PLAN_LOADING = exports.SET_DOC_RETURN_STATUS = exports.SET_REMOVE_SELF_VISIBILTIY = exports.NO_BILLING_DETAILS = exports.SET_INVITE_USER_VISIBILITY = exports.USER_CREATED = exports.USER_REMOVED = exports.SET_ACCOUNT_USERS = exports.UPDATE_BILLING_DETAILS = exports.SET_BILLING_DETAILS = exports.PREVIOUS_PAGE = exports.NEXT_PAGE = exports.SET_PAGINATION_LIMIT = exports.SET_BILLING_HISTORY = exports.UPDATE_PLAN = exports.SET_PLANS = exports.SET_PLAN_TYPE_DISPLAY = exports.SET_LOCALES = exports.SET_ACCOUNT_DETAILS = undefined;

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _store = __webpack_require__(48);

var _accountSettings = __webpack_require__(413);

var _appActions = __webpack_require__(25);

var _validators = __webpack_require__(36);

var _oauthActions = __webpack_require__(162);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET_ACCOUNT_DETAILS = exports.SET_ACCOUNT_DETAILS = "actions/account-settings/set-account-details";
var SET_LOCALES = exports.SET_LOCALES = "actions/account-settings/set-locales";
var SET_PLAN_TYPE_DISPLAY = exports.SET_PLAN_TYPE_DISPLAY = "actions/account-settings/set-plan-type-display";
var SET_PLANS = exports.SET_PLANS = "actions/account-settings/set-plans";
var UPDATE_PLAN = exports.UPDATE_PLAN = "actions/account-settings/update-plan";
var SET_BILLING_HISTORY = exports.SET_BILLING_HISTORY = "actions/account-settings/set-billing-history";
var SET_PAGINATION_LIMIT = exports.SET_PAGINATION_LIMIT = "actions/account-settings/set-pagination-limit";
var NEXT_PAGE = exports.NEXT_PAGE = "actions/account-settings/next-page";
var PREVIOUS_PAGE = exports.PREVIOUS_PAGE = "actions/account-settings/previous-page";
var SET_BILLING_DETAILS = exports.SET_BILLING_DETAILS = "actions/account-settings/set-billing-details";
var UPDATE_BILLING_DETAILS = exports.UPDATE_BILLING_DETAILS = "actions/account-settings/update-billing-details";
var SET_ACCOUNT_USERS = exports.SET_ACCOUNT_USERS = "actions/account-settings/set-account-users";
var USER_REMOVED = exports.USER_REMOVED = "actions/account-settings/user-removed";
var USER_CREATED = exports.USER_CREATED = "actions/account-settings/user-created";
var SET_INVITE_USER_VISIBILITY = exports.SET_INVITE_USER_VISIBILITY = "actions/account-settings/set-invite-user-visibility";
var NO_BILLING_DETAILS = exports.NO_BILLING_DETAILS = "actions/account-settings/no-billing-details";
var SET_REMOVE_SELF_VISIBILTIY = exports.SET_REMOVE_SELF_VISIBILTIY = "actions/account-settings/set-remove-self-visibility";
var SET_DOC_RETURN_STATUS = exports.SET_DOC_RETURN_STATUS = "actions/account-settings/set-doc-return-status";
var CHANGE_PLAN_LOADING = exports.CHANGE_PLAN_LOADING = "actions/account-settings/change-plan-loading";
var CHANGE_PLAN_LOADING_STOP = exports.CHANGE_PLAN_LOADING_STOP = "actions/account-settings/change-plan-loading-stop";
var SET_PENDING_PLAN = exports.SET_PENDING_PLAN = "actions/account-settings/set-pending-plan";
var SET_CANCEL_SUBSCRIPTION_VISIBILITY = exports.SET_CANCEL_SUBSCRIPTION_VISIBILITY = "actions/account-settings/set-cancel-subscription-visibility";
var SHOW_UPGRADE_DOWNGRADE_MODAL = exports.SHOW_UPGRADE_DOWNGRADE_MODAL = "actions/account-settings/show-upgrade-downgrade-modal";
var HIDE_UPGRADE_DOWNGRADE_MODAL = exports.HIDE_UPGRADE_DOWNGRADE_MODAL = "actions/account-settings/hide-upgrade-downgrade-modal";
var UPDATE_ACCOUNT_NAME_AND_EMAIL = exports.UPDATE_ACCOUNT_NAME_AND_EMAIL = "actions/account-settings/update-account-name-and-email";
var UPDATE_ADDRESS = exports.UPDATE_ADDRESS = "actions/account-settings/update-address";
var UPDATE_CLT_SETTINGS = exports.UPDATE_CLT_SETTINGS = "actions/account-settings/update-clt-settings";
var REDIRECT_TO_BILLING = exports.REDIRECT_TO_BILLING = "actions/account-settings/redirect-to-billing";
var DOCUMENT_RETURN_LOADING = exports.DOCUMENT_RETURN_LOADING = "actions/account-settings/documen-return-loading";
var DOCUMENT_RETURN_LOADING_STOP = exports.DOCUMENT_RETURN_LOADING_STOP = "actions/account-settings/documen-return-loading-stop";

var fetchAccountDetailsAction = exports.fetchAccountDetailsAction = function fetchAccountDetailsAction(accountId) {
  return function (dispatch) {
    (0, _accountSettings.fetchAccountDetails)(accountId).then(function (data) {
      dispatch({ type: SET_ACCOUNT_DETAILS, data: data });
    });
  };
};

var fetchAccountUsersAction = exports.fetchAccountUsersAction = function fetchAccountUsersAction(accountId) {
  return function (dispatch) {
    (0, _accountSettings.fetchAccountUsers)(accountId).then(function (_ref) {
      var maxUsers = _ref.maxUsers,
          users = _ref.users;

      dispatch({
        type: SET_ACCOUNT_USERS,
        data: { maxUsers: maxUsers, users: users }
      });
    });
  };
};

var fetchLocalesAction = exports.fetchLocalesAction = function fetchLocalesAction(accountId) {
  return function (dispatch) {
    (0, _accountSettings.fetchLocales)(accountId).then(function (_ref2) {
      var supportedLocales = _ref2.supportedLocales;

      dispatch({
        type: SET_LOCALES,
        data: { supportedLocales: supportedLocales }
      });
    });
  };
};

var saveAccountSettingsAction = exports.saveAccountSettingsAction = function saveAccountSettingsAction() {
  return function (dispatch) {
    var state = _store.store.getState();
    var accountId = state.app.selectedAccount.id;
    var form = _ramda2.default.path(["form", "accountNameAndEmailForm", "values"], state);
    var settings = {
      emailPin: form.emailPin,
      slug: form.slug,
      label: form.label
    };
    return (0, _accountSettings.putAccountSettings)(accountId, settings).then(function () {
      dispatch({
        type: UPDATE_ACCOUNT_NAME_AND_EMAIL,
        data: { settings: settings }
      });
      dispatch((0, _appActions.setFlashMessageAction)("Changes Saved"));
    }).catch(function (error) {
      dispatch((0, _appActions.setFlashMessageAction)(error.response.data.reason, "error"));
    });
  };
};

var saveAddressAction = exports.saveAddressAction = function saveAddressAction() {
  return function (dispatch) {
    var state = _store.store.getState();
    var accountId = state.app.selectedAccount.id;
    var address = _ramda2.default.path(["form", "mailInSettingsForm", "values"], state);
    var newAddress = _ramda2.default.set(_ramda2.default.lensProp("country"), address.country.name, address);
    return (0, _accountSettings.putAccountSettings)(accountId, { address: newAddress }).then(function () {
      dispatch({
        type: UPDATE_ADDRESS,
        data: { newAddress: newAddress }
      });
      dispatch((0, _appActions.setFlashMessageAction)("Changes Saved"));
    });
  };
};

var setPlanTypeDisplayAction = exports.setPlanTypeDisplayAction = function setPlanTypeDisplayAction(type) {
  return {
    type: SET_PLAN_TYPE_DISPLAY,
    data: { type: type }
  };
};

var fetchPlansAction = exports.fetchPlansAction = function fetchPlansAction(accountId) {
  return function (dispatch) {
    (0, _accountSettings.fetchPlans)(accountId).then(function (_ref3) {
      var plans = _ref3.plans;

      dispatch({
        type: SET_PLANS,
        data: { plans: plans }
      });
    }).then(function () {
      return dispatch(fetchPendingPlanAction(accountId));
    });
  };
};

var fetchBillingHistoryAction = exports.fetchBillingHistoryAction = function fetchBillingHistoryAction(accountId) {
  return function (dispatch) {
    (0, _accountSettings.fetchBillingHistory)(accountId).then(function (_ref4) {
      var invoices = _ref4.invoices;

      dispatch({
        type: SET_BILLING_HISTORY,
        data: { invoices: invoices }
      });
      /* This is a temporary solution to solve an issue where the width of the data grid (react-data-grid) is
       incorrect when a small number of rows are on display */
      window.dispatchEvent(new Event("resize"));
    });
  };
};

var setPaginationLimitAction = exports.setPaginationLimitAction = function setPaginationLimitAction(limit) {
  return {
    type: SET_PAGINATION_LIMIT,
    data: { limit: limit }
  };
};

var nextPageAction = exports.nextPageAction = function nextPageAction() {
  return {
    type: NEXT_PAGE
  };
};

var previousPageAction = exports.previousPageAction = function previousPageAction() {
  return {
    type: PREVIOUS_PAGE
  };
};

var fetchBillingDetailsAction = exports.fetchBillingDetailsAction = function fetchBillingDetailsAction(accountId) {
  return function (dispatch) {
    (0, _accountSettings.fetchBillingDetails)(accountId).then(function (_ref5) {
      var billingDetails = _ref5.billingDetails;

      dispatch({
        type: SET_BILLING_DETAILS,
        data: { billingDetails: billingDetails }
      });
    }).catch(function (error) {
      if (error.response.status !== 404) {
        return dispatch((0, _appActions.setFlashGenericErrorAction)());
      }
      return dispatch({ type: NO_BILLING_DETAILS });
    });
  };
};

var updatePlanAction = exports.updatePlanAction = function updatePlanAction(accountId, plan) {
  return function (dispatch) {
    dispatch({ type: CHANGE_PLAN_LOADING });
    var newPlan = { planType: plan.planType, subscriptionType: plan.subscriptionType };
    (0, _accountSettings.putNewPlan)(accountId, newPlan).then(function () {
      dispatch({
        type: UPDATE_PLAN,
        data: { plan: plan }
      });
    }).then(function () {
      return dispatch(fetchPendingPlanAction(accountId));
    }).then(function () {
      return dispatch((0, _appActions.setFlashMessageAction)("Account plan updated"));
    }).then(function () {
      return dispatch({ type: CHANGE_PLAN_LOADING_STOP });
    }).then(function () {
      return dispatch(hideUpgradeDowngradeModalAction());
    }).catch(function () {
      return dispatch({ type: CHANGE_PLAN_LOADING_STOP });
    });
  };
};

var updateBillingDetailsAction = exports.updateBillingDetailsAction = function updateBillingDetailsAction(field, payload) {
  return {
    type: UPDATE_BILLING_DETAILS,
    data: { field: field, payload: payload }
  };
};

var saveBillingDetailsAction = exports.saveBillingDetailsAction = function saveBillingDetailsAction(accountId, billingDetails) {
  return function (dispatch) {
    (0, _accountSettings.postBillingDetails)(accountId, billingDetails).then(function () {
      dispatch((0, _appActions.setFlashMessageAction)("Credit card saved"));
    }).catch(function () {
      dispatch((0, _appActions.setFlashGenericErrorAction)());
    });
  };
};

var saveCurrencyLocaleTaxAction = exports.saveCurrencyLocaleTaxAction = function saveCurrencyLocaleTaxAction() {
  return function (dispatch) {
    var state = _store.store.getState();
    var accountId = state.app.selectedAccount.id;
    var settings = _ramda2.default.path(["form", "currencyTaxLanguageForm", "values"], state);
    var newSettings = {
      currency: settings.currency.key,
      locale: settings.locale.key,
      showUniversalCategorySet: settings.isDefaultCategories,
      vat: settings.vat.toString()
    };
    return (0, _accountSettings.putCurrencyLocaleTax)(accountId, newSettings).then(function () {
      dispatch({
        type: UPDATE_CLT_SETTINGS,
        data: { newSettings: newSettings }
      });
      dispatch((0, _appActions.setFlashMessageAction)("Changes Saved"));
    }).catch(function () {
      return dispatch((0, _appActions.setFlashGenericErrorAction)());
    });
  };
};

var removeUserAction = exports.removeUserAction = function removeUserAction(accountId, userId) {
  return function (dispatch) {
    var state = _store.store.getState();
    var currentUserId = state.app.user.id;

    return (0, _accountSettings.deleteUser)(accountId, userId).then(function () {
      dispatch({
        type: USER_REMOVED,
        data: { userId: userId }
      });
    }).then(function () {
      if (userId === currentUserId) {
        return dispatch((0, _oauthActions.redirectToLoginAction)());
      }
      return dispatch((0, _appActions.setFlashMessageAction)("User Removed", "error"));
    }).catch(function () {
      return dispatch((0, _appActions.setFlashGenericErrorAction)());
    });
  };
};

var createUserAction = exports.createUserAction = function createUserAction() {
  return function (dispatch) {
    var state = _store.store.getState();
    var accountId = state.app.selectedAccount.id;
    var user = _ramda2.default.path(["form", "inviteUserForm", "values"], state);

    if (user && (0, _validators.isValidUser)(user)) {
      return (0, _accountSettings.createUser)(accountId, user).then(function (_ref6) {
        var newUser = _ref6.newUser;

        dispatch({
          type: USER_CREATED,
          data: { newUser: newUser }
        });
      }).then(function () {
        dispatch((0, _appActions.setFlashMessageAction)("Invitation Sent!"));
      }).catch(function () {
        dispatch((0, _appActions.setFlashGenericErrorAction)());
      });
    }
    return dispatch((0, _appActions.setFlashMessageAction)("Please check that the email and full name is entered properly.", "error"));
  };
};

var setInviteUserVisibilityAction = exports.setInviteUserVisibilityAction = function setInviteUserVisibilityAction(visible) {
  return {
    type: SET_INVITE_USER_VISIBILITY,
    data: { visible: visible }
  };
};

var setRemoveSelfVisibilityAction = exports.setRemoveSelfVisibilityAction = function setRemoveSelfVisibilityAction(visible) {
  return {
    type: SET_REMOVE_SELF_VISIBILTIY,
    data: { visible: visible }
  };
};

var updateDocReturnAction = exports.updateDocReturnAction = function updateDocReturnAction(accountId, isOn) {
  return function (dispatch) {
    dispatch({ type: DOCUMENT_RETURN_LOADING });
    return (0, _accountSettings.putDocReturn)(accountId, isOn).then(function () {
      if (isOn) {
        dispatch((0, _appActions.setFlashMessageAction)("Document Return Enabled"));
      }
      dispatch({
        type: SET_DOC_RETURN_STATUS,
        data: { isOn: isOn }
      });
      dispatch({ type: DOCUMENT_RETURN_LOADING_STOP });
    }).catch(function () {
      dispatch((0, _appActions.setFlashGenericErrorAction)());
      dispatch({ type: DOCUMENT_RETURN_LOADING_STOP });
    });
  };
};

var fetchPendingPlanAction = exports.fetchPendingPlanAction = function fetchPendingPlanAction(accountId) {
  return function (dispatch) {
    return (0, _accountSettings.fetchPendingPlan)(accountId).then(function (_ref7) {
      var cancelDate = _ref7.cancelDate,
          pendingPlan = _ref7.pendingPlan;

      dispatch({
        type: SET_PENDING_PLAN,
        data: { cancelDate: cancelDate, pendingPlan: pendingPlan }
      });
    });
  };
};

var setCancelSubscriptionVisibilityAction = exports.setCancelSubscriptionVisibilityAction = function setCancelSubscriptionVisibilityAction(visible) {
  return {
    type: SET_CANCEL_SUBSCRIPTION_VISIBILITY,
    data: { visible: visible }
  };
};

var showUpgradeDowngradeModalAction = exports.showUpgradeDowngradeModalAction = function showUpgradeDowngradeModalAction(plan) {
  return {
    type: SHOW_UPGRADE_DOWNGRADE_MODAL,
    data: { plan: plan }
  };
};

var hideUpgradeDowngradeModalAction = exports.hideUpgradeDowngradeModalAction = function hideUpgradeDowngradeModalAction() {
  return {
    type: HIDE_UPGRADE_DOWNGRADE_MODAL
  };
};

var redirectToBillingAction = exports.redirectToBillingAction = function redirectToBillingAction(accountId) {
  return function (dispatch) {
    return (0, _accountSettings.billingRedirect)(accountId).then(function () {
      dispatch({
        type: "NOOP"
      });
    });
  };
};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var pluralize = exports.pluralize = function pluralize(count, plural, singular) {
  var includeCount = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  if (includeCount) {
    return count === 1 ? "1 " + singular : count + " " + plural;
  }

  return count === 1 ? singular : plural;
};

var capitalize = exports.capitalize = function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

var normalizeNumber = exports.normalizeNumber = function normalizeNumber(value) {
  if (isNaN(value)) {
    return 0;
  }
  return value;
};

/***/ }),
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"row":"grid__row___4IJge","col-md-1":"grid__col-md-1___9N7aE","col-md-2":"grid__col-md-2___19cAw","col-md-3":"grid__col-md-3___1eZyo","col-md-4":"grid__col-md-4___1E462","col-md-5":"grid__col-md-5___3vgkp","col-md-6":"grid__col-md-6___3j16y","col-md-7":"grid__col-md-7___1k8Rg","col-md-8":"grid__col-md-8___2cydu","col-md-9":"grid__col-md-9___37EYE","col-md-10":"grid__col-md-10___3hTJH","col-md-11":"grid__col-md-11___1xwiR","col-md-12":"grid__col-md-12___1HtH2","no-gutter-left":"grid__no-gutter-left___tJ-x-","no-gutter-right":"grid__no-gutter-right___3Mdkt"};

/***/ }),
/* 96 */,
/* 97 */,
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(process, module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "css", function() { return css; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keyframes", function() { return keyframes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "injectGlobal", function() { return injectGlobal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isStyledComponent", function() { return isStyledComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "consolidateStreamedStyles", function() { return consolidateStreamedStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ThemeProvider", function() { return ThemeProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withTheme", function() { return withTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ServerStyleSheet", function() { return ServerStyleSheet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StyleSheetManager", function() { return StyleSheetManager; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS", function() { return __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylis__ = __webpack_require__(1981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_stylis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet__ = __webpack_require__(1980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_is__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_is__);








var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

// 
var isPlainObject = (function (x) {
  return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x.constructor === Object;
});

// 


/**
 * Parse errors.md and turn it into a simple hash of code: message
 */
var ERRORS =  false ? {
  "1": "Cannot create styled-component for component: %s.\n\n",
  "2": "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n* Are you trying to reuse it across renders?\n* Are you accidentally calling collectStyles twice?\n\n",
  "3": "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
  "4": "The `StyleSheetManager` expects a valid target or sheet prop!\n\n* Does this error occur on the client and is your target falsy?\n* Does this error occur on the server and is the sheet falsy?\n\n",
  "5": "The clone method cannot be used on the client!\n\n* Are you running in a client-like environment on the server?\n* Are you trying to run SSR on the client?\n\n",
  "6": "Trying to insert a new style tag, but the given Node is unmounted!\n\n* Are you using a custom target that isn't mounted?\n* Does your document not have a valid head element?\n* Have you accidentally removed a style tag manually?\n\n",
  "7": "ThemeProvider: Please return an object from your \"theme\" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n",
  "8": "ThemeProvider: Please make your \"theme\" prop an object.\n\n",
  "9": "Missing document `<head>`\n\n",
  "10": "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
  "11": "A plain React class (%s) has been interpolated into styles, probably as a component selector (https://www.styled-components.com/docs/advanced#referring-to-other-components). Only styled-component classes can be targeted in this fashion."
} : {};

/**
 * super basic version of sprintf
 */
function format() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var a = args[0];
  var b = [];
  var c = void 0;

  for (c = 1; c < args.length; c += 1) {
    b.push(args[c]);
  }

  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });

  return a;
}

/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 */

var StyledComponentsError = function (_Error) {
  inherits(StyledComponentsError, _Error);

  function StyledComponentsError(code) {
    classCallCheck(this, StyledComponentsError);

    for (var _len2 = arguments.length, interpolations = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      interpolations[_key2 - 1] = arguments[_key2];
    }

    if (true) {
      var _this = possibleConstructorReturn(this, _Error.call(this, 'An error occurred. See https://github.com/styled-components/styled-components/blob/master/src/utils/errors.md#' + code + ' for more information. ' + (interpolations ? 'Additional arguments: ' + interpolations.join(', ') : '')));
    } else {
      var _this = possibleConstructorReturn(this, _Error.call(this, format.apply(undefined, [ERRORS[code]].concat(interpolations))));
    }
    return possibleConstructorReturn(_this);
  }

  return StyledComponentsError;
}(Error);

// 

var objToCss = function objToCss(obj, prevKey) {
  var css = Object.keys(obj).filter(function (key) {
    var chunk = obj[key];
    return chunk !== undefined && chunk !== null && chunk !== false && chunk !== '';
  }).map(function (key) {
    if (isPlainObject(obj[key])) return objToCss(obj[key], key);
    return __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName___default()(key) + ': ' + obj[key] + ';';
  }).join(' ');
  return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
};

var flatten = function flatten(chunks, executionContext) {
  return chunks.reduce(function (ruleSet, chunk) {
    /* Remove falsey values */
    if (chunk === undefined || chunk === null || chunk === false || chunk === '') {
      return ruleSet;
    }

    /* Flatten ruleSet */
    if (Array.isArray(chunk)) {
      ruleSet.push.apply(ruleSet, flatten(chunk, executionContext));
      return ruleSet;
    }

    /* Handle other components */
    if (chunk.hasOwnProperty('styledComponentId')) {
      // $FlowFixMe not sure how to make this pass
      ruleSet.push('.' + chunk.styledComponentId);
      return ruleSet;
    }

    /* Either execute or defer the function */
    if (typeof chunk === 'function') {
      if (executionContext) {
        var nextChunk = chunk(executionContext);
        /* Throw if a React Element was given styles */
        if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(nextChunk)) {
          var elementName = chunk.displayName || chunk.name;
          throw new StyledComponentsError(11, elementName);
        }
        ruleSet.push.apply(ruleSet, flatten([nextChunk], executionContext));
      } else ruleSet.push(chunk);

      return ruleSet;
    }

    /* Handle objects */
    ruleSet.push(
    // $FlowFixMe have to add %checks somehow to isPlainObject
    isPlainObject(chunk) ? objToCss(chunk) : chunk.toString());

    return ruleSet;
  }, []);
};

// 

var COMMENT_REGEX = /^\s*\/\/.*$/gm;

// NOTE: This stylis instance is only used to split rules from SSR'd style tags
var stylisSplitter = new __WEBPACK_IMPORTED_MODULE_2_stylis___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: false,
  compress: false,
  semicolon: true
});

var stylis = new __WEBPACK_IMPORTED_MODULE_2_stylis___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: true,
  compress: false,
  semicolon: false // NOTE: This means "autocomplete missing semicolons"
});

// Wrap `insertRulePlugin to build a list of rules,
// and then make our own plugin to return the rules. This
// makes it easier to hook into the existing SSR architecture

var parsingRules = [];
// eslint-disable-next-line consistent-return
var returnRulesPlugin = function returnRulesPlugin(context) {
  if (context === -2) {
    var parsedRules = parsingRules;
    parsingRules = [];
    return parsedRules;
  }
};

var parseRulesPlugin = __WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet___default()(function (rule) {
  parsingRules.push(rule);
});

stylis.use([parseRulesPlugin, returnRulesPlugin]);
stylisSplitter.use([parseRulesPlugin, returnRulesPlugin]);

var stringifyRules = function stringifyRules(rules, selector, prefix) {
  var flatCSS = rules.join('').replace(COMMENT_REGEX, ''); // replace JS comments

  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;

  return stylis(prefix || !selector ? '' : selector, cssStr);
};

var splitByRules = function splitByRules(css) {
  return stylisSplitter('', css);
};

// 

function isStyledComponent(target) /* : %checks */{
  return (
    // $FlowFixMe TODO: flow for styledComponentId
    typeof target === 'function' && typeof target.styledComponentId === 'string'
  );
}

// 

/* This function is DEPRECATED and will be removed on the next major version release.
 * It was needed to rehydrate all style blocks prepended to chunks before React
 * tries to rehydrate its HTML stream. Since the master StyleSheet will now detect
 * the use of streamed style tags and will perform the rehydration earlier when needed
 * this function will not be needed anymore */
function consolidateStreamedStyles() {
  if (false) {
    // eslint-disable-next-line no-console
    console.warn('styled-components automatically does streaming SSR rehydration now.\n' + 'Calling consolidateStreamedStyles manually is no longer necessary and a noop now.\n' + '- Please remove the consolidateStreamedStyles call from your client.');
  }
}

// 
/* eslint-disable no-bitwise */

/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */
var charsLength = 52;

/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */
var getAlphabeticChar = function getAlphabeticChar(code) {
  return String.fromCharCode(code + (code > 25 ? 39 : 97));
};

/* input a number, usually a hash and convert it to base-52 */
var generateAlphabeticName = function generateAlphabeticName(code) {
  var name = '';
  var x = void 0;

  /* get a char and divide by alphabet-length */
  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
    name = getAlphabeticChar(x % charsLength) + name;
  }

  return getAlphabeticChar(x % charsLength) + name;
};

// 

var interleave = (function (strings, interpolations) {
  var result = [strings[0]];

  for (var i = 0, len = interpolations.length; i < len; i += 1) {
    result.push(interpolations[i], strings[i + 1]);
  }

  return result;
});

// 
var EMPTY_ARRAY = Object.freeze([]);
var EMPTY_OBJECT = Object.freeze({});

// 

var css = (function (styles) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  if (typeof styles === 'function' || isPlainObject(styles)) {
    // $FlowFixMe
    return flatten(interleave(EMPTY_ARRAY, [styles].concat(interpolations)));
  }

  // $FlowFixMe
  return flatten(interleave(styles, interpolations));
});

// 


var SC_ATTR = typeof process !== 'undefined' && __webpack_require__.i({"NODE_ENV":"production"}).SC_ATTR || 'data-styled-components';
var SC_STREAM_ATTR = 'data-styled-streamed';
var CONTEXT_KEY = '__styled-components-stylesheet__';

var IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;

var DISABLE_SPEEDY = "production" !== 'production';

// 
var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;

var extractComps = (function (maybeCSS) {
  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
  var existingComponents = [];
  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
    return match;
  });
  return existingComponents.map(function (_ref, i) {
    var componentId = _ref.componentId,
        matchIndex = _ref.matchIndex;

    var nextComp = existingComponents[i + 1];
    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
    return { componentId: componentId, cssFromDOM: cssFromDOM };
  });
});

// 
/* eslint-disable camelcase, no-undef */

var getNonce = (function () {
  return  true ? __webpack_require__.nc : null;
});

// 
// Helper to call a given function, only once
var once = (function (cb) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      cb();
    }
  };
});

// 
/* These are helpers for the StyleTags to keep track of the injected
 * rule names for each (component) ID that they're keeping track of.
 * They're crucial for detecting whether a name has already been
 * injected.
 * (This excludes rehydrated names) */

/* adds a new ID:name pairing to a names dictionary */
var addNameForId = function addNameForId(names, id, name) {
  if (name) {
    // eslint-disable-next-line no-param-reassign
    var namesForId = names[id] || (names[id] = Object.create(null));
    namesForId[name] = true;
  }
};

/* resets an ID entirely by overwriting it in the dictionary */
var resetIdNames = function resetIdNames(names, id) {
  // eslint-disable-next-line no-param-reassign
  names[id] = Object.create(null);
};

/* factory for a names dictionary checking the existance of an ID:name pairing */
var hasNameForId = function hasNameForId(names) {
  return function (id, name) {
    return names[id] !== undefined && names[id][name];
  };
};

/* stringifies names for the html/element output */
var stringifyNames = function stringifyNames(names) {
  var str = '';
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    str += Object.keys(names[id]).join(' ') + ' ';
  }
  return str.trim();
};

/* clones the nested names dictionary */
var cloneNames = function cloneNames(names) {
  var clone = Object.create(null);
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    clone[id] = _extends({}, names[id]);
  }
  return clone;
};

// 

/* These are helpers that deal with the insertRule (aka speedy) API
 * They are used in the StyleTags and specifically the speedy tag
 */

/* retrieve a sheet for a given style tag */
var sheetForTag = function sheetForTag(tag) {
  // $FlowFixMe
  if (tag.sheet) return tag.sheet;

  /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */
  var size = document.styleSheets.length;
  for (var i = 0; i < size; i += 1) {
    var sheet = document.styleSheets[i];
    // $FlowFixMe
    if (sheet.ownerNode === tag) return sheet;
  }

  /* we should always be able to find a tag */
  throw new StyledComponentsError(10);
};

/* insert a rule safely and return whether it was actually injected */
var safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
  /* abort early if cssRule string is falsy */
  if (!cssRule) return false;

  var maxIndex = sheet.cssRules.length;

  try {
    /* use insertRule and cap passed index with maxIndex (no of cssRules) */
    sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
  } catch (err) {
    /* any error indicates an invalid rule */
    return false;
  }

  return true;
};

/* deletes `size` rules starting from `removalIndex` */
var deleteRules = function deleteRules(sheet, removalIndex, size) {
  var lowerBound = removalIndex - size;
  for (var i = removalIndex; i > lowerBound; i -= 1) {
    sheet.deleteRule(i);
  }
};

// 

/* this marker separates component styles and is important for rehydration */
var makeTextMarker = function makeTextMarker(id) {
  return '\n/* sc-component-id: ' + id + ' */\n';
};

/* add up all numbers in array up until and including the index */
var addUpUntilIndex = function addUpUntilIndex(sizes, index) {
  var totalUpToIndex = 0;
  for (var i = 0; i <= index; i += 1) {
    totalUpToIndex += sizes[i];
  }

  return totalUpToIndex;
};

/* create a new style tag after lastEl */
var makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
  var el = document.createElement('style');
  el.setAttribute(SC_ATTR, '');

  var nonce = getNonce();
  if (nonce) {
    el.setAttribute('nonce', nonce);
  }

  /* Work around insertRule quirk in EdgeHTML */
  el.appendChild(document.createTextNode(''));

  if (target && !tagEl) {
    /* Append to target when no previous element was passed */
    target.appendChild(el);
  } else {
    if (!tagEl || !target || !tagEl.parentNode) {
      throw new StyledComponentsError(6);
    }

    /* Insert new style tag after the previous one */
    tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
  }

  return el;
};

/* takes a css factory function and outputs an html styled tag factory */
var wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
  return function (additionalAttrs) {
    var nonce = getNonce();
    var attrs = [nonce && 'nonce="' + nonce + '"', SC_ATTR + '="' + stringifyNames(names) + '"', additionalAttrs];

    var htmlAttr = attrs.filter(Boolean).join(' ');
    return '<style ' + htmlAttr + '>' + css() + '</style>';
  };
};

/* takes a css factory function and outputs an element factory */
var wrapAsElement = function wrapAsElement(css, names) {
  return function () {
    var _props;

    var props = (_props = {}, _props[SC_ATTR] = stringifyNames(names), _props);

    var nonce = getNonce();
    if (nonce) {
      // $FlowFixMe
      props.nonce = nonce;
    }

    // eslint-disable-next-line react/no-danger
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('style', _extends({}, props, { dangerouslySetInnerHTML: { __html: css() } }));
  };
};

var getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
  return function () {
    return Object.keys(markers);
  };
};

/* speedy tags utilise insertRule */
var makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);
  var sizes = [];

  var extractImport = getImportRuleTag !== undefined;
  /* indicates whther getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = sizes.length;
    sizes.push(0);
    resetIdNames(names, id);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var sheet = sheetForTag(el);
    var insertIndex = addUpUntilIndex(sizes, marker);

    var injectedRules = 0;
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var cssRule = cssRules[i];
      var mayHaveImport = extractImport; /* @import rules are reordered to appear first */
      if (mayHaveImport && cssRule.indexOf('@import') !== -1) {
        importRules.push(cssRule);
      } else if (safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
        mayHaveImport = false;
        injectedRules += 1;
      }
    }

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }

    sizes[marker] += injectedRules; /* add up no of injected rules */
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    var size = sizes[marker];
    var sheet = sheetForTag(el);
    var removalIndex = addUpUntilIndex(sizes, marker);
    deleteRules(sheet, removalIndex, size);
    sizes[marker] = 0;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var _sheetForTag = sheetForTag(el),
        cssRules = _sheetForTag.cssRules;

    var str = '';

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += makeTextMarker(id);
      var marker = markers[id];
      var end = addUpUntilIndex(sizes, marker);
      var size = sizes[marker];
      for (var i = end - size; i < end; i += 1) {
        var rule = cssRules[i];
        if (rule !== undefined) {
          str += rule.cssText;
        }
      }
    }

    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeTextNode = function makeTextNode(id) {
  return document.createTextNode(makeTextMarker(id));
};

var makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);

  var extractImport = getImportRuleTag !== undefined;

  /* indicates whther getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = makeTextNode(id);
    el.appendChild(markers[id]);
    names[id] = Object.create(null);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var rule = cssRules[i];
      var mayHaveImport = extractImport;
      if (mayHaveImport && rule.indexOf('@import') !== -1) {
        importRules.push(rule);
      } else {
        mayHaveImport = false;
        var separator = i === cssRulesSize - 1 ? '' : ' ';
        marker.appendData('' + rule + separator);
      }
    }

    addNameForId(names, id, name);

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    /* create new empty text node and replace the current one */
    var newMarker = makeTextNode(id);
    el.replaceChild(newMarker, marker);
    markers[id] = newMarker;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += markers[id].data;
    }
    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeServerTagInternal = function makeServerTagInternal(namesArg, markersArg) {
  var names = namesArg === undefined ? Object.create(null) : namesArg;
  var markers = markersArg === undefined ? Object.create(null) : markersArg;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    return markers[id] = [''];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    marker[0] += cssRules.join(' ');
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;
    marker[0] = '';
    resetIdNames(names, id);
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      var cssForId = markers[id][0];
      if (cssForId) {
        str += makeTextMarker(id) + cssForId;
      }
    }
    return str;
  };

  var clone = function clone() {
    var namesClone = cloneNames(names);
    var markersClone = Object.create(null);

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      markersClone[id] = [markers[id][0]];
    }

    return makeServerTagInternal(namesClone, markersClone);
  };

  var tag = {
    clone: clone,
    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: null,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };

  return tag;
};

var makeServerTag = function makeServerTag() {
  return makeServerTagInternal();
};

var makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
  if (IS_BROWSER && !forceServer) {
    var el = makeStyleTag(target, tagEl, insertBefore);

    if (DISABLE_SPEEDY) {
      return makeBrowserTag(el, getImportRuleTag);
    } else {
      return makeSpeedyTag(el, getImportRuleTag);
    }
  }

  return makeServerTag();
};

/* wraps a given tag so that rehydration is performed once when necessary */
var makeRehydrationTag = function makeRehydrationTag(tag, els, extracted, immediateRehydration) {
  /* rehydration function that adds all rules to the new tag */
  var rehydrate = once(function () {
    /* add all extracted components to the new tag */
    for (var i = 0, len = extracted.length; i < len; i += 1) {
      var _extracted$i = extracted[i],
          componentId = _extracted$i.componentId,
          cssFromDOM = _extracted$i.cssFromDOM;

      var cssRules = splitByRules(cssFromDOM);
      tag.insertRules(componentId, cssRules);
    }

    /* remove old HTMLStyleElements, since they have been rehydrated */
    for (var _i = 0, _len = els.length; _i < _len; _i += 1) {
      var el = els[_i];
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      }
    }
  });

  if (immediateRehydration) rehydrate();

  return _extends({}, tag, {
    /* add rehydration hook to insertion methods */
    insertMarker: function insertMarker(id) {
      rehydrate();
      return tag.insertMarker(id);
    },
    insertRules: function insertRules(id, cssRules, name) {
      rehydrate();
      return tag.insertRules(id, cssRules, name);
    }
  });
};

// 

var SPLIT_REGEX = /\s+/;

/* determine the maximum number of components before tags are sharded */
var MAX_SIZE = void 0;
if (IS_BROWSER) {
  /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */
  MAX_SIZE = DISABLE_SPEEDY ? 40 : 1000;
} else {
  /* for servers we do not need to shard at all */
  MAX_SIZE = -1;
}

var sheetRunningId = 0;
var master = void 0;

var StyleSheet = function () {
  /* a map from ids to tags */
  /* deferred rules for a given id */
  /* this is used for not reinjecting rules via hasNameForId() */
  /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */
  /* a list of tags belonging to this StyleSheet */
  /* a tag for import rules */
  /* current capacity until a new tag must be created */
  /* children (aka clones) of this StyleSheet inheriting all and future injections */

  function StyleSheet() {
    var _this = this;

    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IS_BROWSER ? document.head : null;
    var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    classCallCheck(this, StyleSheet);

    this.getImportRuleTag = function () {
      var importRuleTag = _this.importRuleTag;

      if (importRuleTag !== undefined) {
        return importRuleTag;
      }

      var firstTag = _this.tags[0];
      var insertBefore = true;

      return _this.importRuleTag = makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
    };

    sheetRunningId += 1;
    this.id = sheetRunningId;
    this.forceServer = forceServer;
    this.target = forceServer ? null : target;
    this.tagMap = {};
    this.deferred = {};
    this.rehydratedNames = {};
    this.ignoreRehydratedNames = {};
    this.tags = [];
    this.capacity = 1;
    this.clones = [];
  }

  /* rehydrate all SSR'd style tags */


  StyleSheet.prototype.rehydrate = function rehydrate() {
    if (!IS_BROWSER || this.forceServer) {
      return this;
    }

    var els = [];
    var extracted = [];
    var isStreamed = false;

    /* retrieve all of our SSR style elements from the DOM */
    var nodes = document.querySelectorAll('style[' + SC_ATTR + ']');
    var nodesSize = nodes.length;

    /* abort rehydration if no previous style tags were found */
    if (nodesSize === 0) {
      return this;
    }

    for (var i = 0; i < nodesSize; i += 1) {
      // $FlowFixMe: We can trust that all elements in this query are style elements
      var el = nodes[i];

      /* check if style tag is a streamed tag */
      if (!isStreamed) isStreamed = !!el.getAttribute(SC_STREAM_ATTR);

      /* retrieve all component names */
      var elNames = (el.getAttribute(SC_ATTR) || '').trim().split(SPLIT_REGEX);
      var elNamesSize = elNames.length;
      for (var j = 0; j < elNamesSize; j += 1) {
        var name = elNames[j];
        /* add rehydrated name to sheet to avoid readding styles */
        this.rehydratedNames[name] = true;
      }

      /* extract all components and their CSS */
      extracted.push.apply(extracted, extractComps(el.textContent));

      /* store original HTMLStyleElement */
      els.push(el);
    }

    /* abort rehydration if nothing was extracted */
    var extractedSize = extracted.length;
    if (extractedSize === 0) {
      return this;
    }

    /* create a tag to be used for rehydration */
    var tag = this.makeTag(null);
    var rehydrationTag = makeRehydrationTag(tag, els, extracted, isStreamed);

    /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */
    this.capacity = Math.max(1, MAX_SIZE - extractedSize);
    this.tags.push(rehydrationTag);

    /* retrieve all component ids */
    for (var _j = 0; _j < extractedSize; _j += 1) {
      this.tagMap[extracted[_j].componentId] = rehydrationTag;
    }

    return this;
  };

  /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
   * The master StyleSheet is targeted by injectGlobal, keyframes, and components outside of any
    * StyleSheetManager's context */


  /* reset the internal "master" instance */
  StyleSheet.reset = function reset() {
    var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    master = new StyleSheet(undefined, forceServer).rehydrate();
  };

  /* adds "children" to the StyleSheet that inherit all of the parents' rules
   * while their own rules do not affect the parent */


  StyleSheet.prototype.clone = function clone() {
    var sheet = new StyleSheet(this.target, this.forceServer);

    /* add to clone array */
    this.clones.push(sheet);

    /* clone all tags */
    sheet.tags = this.tags.map(function (tag) {
      var ids = tag.getIds();
      var newTag = tag.clone();

      /* reconstruct tagMap */
      for (var i = 0; i < ids.length; i += 1) {
        sheet.tagMap[ids[i]] = newTag;
      }

      return newTag;
    });

    /* clone other maps */
    sheet.rehydratedNames = _extends({}, this.rehydratedNames);
    sheet.deferred = _extends({}, this.deferred);

    return sheet;
  };

  /* force StyleSheet to create a new tag on the next injection */


  StyleSheet.prototype.sealAllTags = function sealAllTags() {
    this.capacity = 1;

    this.tags.forEach(function (tag) {
      // eslint-disable-next-line no-param-reassign
      tag.sealed = true;
    });
  };

  StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
    var lastEl = tag ? tag.styleTag : null;
    var insertBefore = false;

    return makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
  };

  /* get a tag for a given componentId, assign the componentId to one, or shard */
  StyleSheet.prototype.getTagForId = function getTagForId(id) {
    /* simply return a tag, when the componentId was already assigned one */
    var prev = this.tagMap[id];
    if (prev !== undefined && !prev.sealed) {
      return prev;
    }

    var tag = this.tags[this.tags.length - 1];

    /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */
    this.capacity -= 1;

    if (this.capacity === 0) {
      this.capacity = MAX_SIZE;
      tag = this.makeTag(tag);
      this.tags.push(tag);
    }

    return this.tagMap[id] = tag;
  };

  /* mainly for injectGlobal to check for its id */


  StyleSheet.prototype.hasId = function hasId(id) {
    return this.tagMap[id] !== undefined;
  };

  /* caching layer checking id+name to already have a corresponding tag and injected rules */


  StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
    /* exception for rehydrated names which are checked separately */
    if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) {
      return true;
    }

    var tag = this.tagMap[id];
    return tag !== undefined && tag.hasNameForId(id, name);
  };

  /* registers a componentId and registers it on its tag */


  StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
    /* don't inject when the id is already registered */
    if (this.tagMap[id] !== undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].deferredInject(id, cssRules);
    }

    this.getTagForId(id).insertMarker(id);
    this.deferred[id] = cssRules;
  };

  /* injects rules for a given id with a name that will need to be cached */


  StyleSheet.prototype.inject = function inject(id, cssRules, name) {
    var clones = this.clones;


    for (var i = 0; i < clones.length; i += 1) {
      clones[i].inject(id, cssRules, name);
    }

    var tag = this.getTagForId(id);

    /* add deferred rules for component */
    if (this.deferred[id] !== undefined) {
      // Combine passed cssRules with previously deferred CSS rules
      // NOTE: We cannot mutate the deferred array itself as all clones
      // do the same (see clones[i].inject)
      var rules = this.deferred[id].concat(cssRules);
      tag.insertRules(id, rules, name);

      this.deferred[id] = undefined;
    } else {
      tag.insertRules(id, cssRules, name);
    }
  };

  /* removes all rules for a given id, which doesn't remove its marker but resets it */


  StyleSheet.prototype.remove = function remove(id) {
    var tag = this.tagMap[id];
    if (tag === undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].remove(id);
    }

    /* remove all rules from the tag */
    tag.removeRules(id);
    /* ignore possible rehydrated names */
    this.ignoreRehydratedNames[id] = true;
    /* delete possible deferred rules */
    this.deferred[id] = undefined;
  };

  StyleSheet.prototype.toHTML = function toHTML() {
    return this.tags.map(function (tag) {
      return tag.toHTML();
    }).join('');
  };

  StyleSheet.prototype.toReactElements = function toReactElements() {
    var id = this.id;


    return this.tags.map(function (tag, i) {
      var key = 'sc-' + id + '-' + i;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(tag.toElement(), { key: key });
    });
  };

  createClass(StyleSheet, null, [{
    key: 'master',
    get: function get$$1() {
      return master || (master = new StyleSheet().rehydrate());
    }

    /* NOTE: This is just for backwards-compatibility with jest-styled-components */

  }, {
    key: 'instance',
    get: function get$$1() {
      return StyleSheet.master;
    }
  }]);
  return StyleSheet;
}();

var _StyleSheetManager$ch;

var StyleSheetManager = function (_Component) {
  inherits(StyleSheetManager, _Component);

  function StyleSheetManager() {
    classCallCheck(this, StyleSheetManager);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  StyleSheetManager.prototype.getChildContext = function getChildContext() {
    var _ref;

    return _ref = {}, _ref[CONTEXT_KEY] = this.sheetInstance, _ref;
  };

  StyleSheetManager.prototype.componentWillMount = function componentWillMount() {
    if (this.props.sheet) {
      this.sheetInstance = this.props.sheet;
    } else if (this.props.target) {
      this.sheetInstance = new StyleSheet(this.props.target);
    } else {
      throw new StyledComponentsError(4);
    }
  };

  StyleSheetManager.prototype.render = function render() {
    /* eslint-disable react/prop-types */
    // Flow v0.43.1 will report an error accessing the `children` property,
    // but v0.47.0 will not. It is necessary to use a type cast instead of
    // a "fixme" comment to satisfy both Flow versions.
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.only(this.props.children);
  };

  return StyleSheetManager;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

StyleSheetManager.childContextTypes = (_StyleSheetManager$ch = {}, _StyleSheetManager$ch[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(ServerStyleSheet)]).isRequired, _StyleSheetManager$ch);
 false ? StyleSheetManager.propTypes = {
  sheet: PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]),
  target: PropTypes.shape({
    appendChild: PropTypes.func.isRequired
  })
} : void 0;

// 

var ServerStyleSheet = function () {
  function ServerStyleSheet() {
    classCallCheck(this, ServerStyleSheet);

    /* The master sheet might be reset, so keep a reference here */
    this.masterSheet = StyleSheet.master;
    this.instance = this.masterSheet.clone();
    this.closed = false;
  }

  ServerStyleSheet.prototype.complete = function complete() {
    if (!this.closed) {
      /* Remove closed StyleSheets from the master sheet */
      var index = this.masterSheet.clones.indexOf(this.instance);
      this.masterSheet.clones.splice(index, 1);
      this.closed = true;
    }
  };

  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
    if (this.closed) {
      throw new StyledComponentsError(2);
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      StyleSheetManager,
      { sheet: this.instance },
      children
    );
  };

  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
    this.complete();
    return this.instance.toHTML();
  };

  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
    this.complete();
    return this.instance.toReactElements();
  };

  ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
    var _this = this;

    {
      throw new StyledComponentsError(3);
    }

    /* the tag index keeps track of which tags have already been emitted */
    var instance = this.instance;

    var instanceTagIndex = 0;

    var streamAttr = SC_STREAM_ATTR + '="true"';

    var transformer = new stream.Transform({
      transform: function appendStyleChunks(chunk, /* encoding */_, callback) {
        var tags = instance.tags;

        var html = '';

        /* retrieve html for each new style tag */
        for (; instanceTagIndex < tags.length; instanceTagIndex += 1) {
          var tag = tags[instanceTagIndex];
          html += tag.toHTML(streamAttr);
        }

        /* force our StyleSheets to emit entirely new tags */
        instance.sealAllTags();

        /* prepend style html to chunk */
        this.push(html + chunk);
        callback();
      }
    });

    readableStream.on('end', function () {
      return _this.complete();
    });
    readableStream.on('error', function (err) {
      _this.complete();

      // forward the error to the transform stream
      transformer.emit('error', err);
    });

    return readableStream.pipe(transformer);
  };

  return ServerStyleSheet;
}();

// 

var LIMIT = 200;

var createWarnTooManyClasses = (function (displayName) {
  var generatedClasses = {};
  var warningSeen = false;

  return function (className) {
    if (!warningSeen) {
      generatedClasses[className] = true;
      if (Object.keys(generatedClasses).length >= LIMIT) {
        // Unable to find latestRule in test environment.
        /* eslint-disable no-console, prefer-template */
        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs({\n' + '    style: ({ background }) => ({\n' + '      background,\n' + '    }),\n' + '  })`width: 100%;`\n\n' + '  <Component />');
        warningSeen = true;
        generatedClasses = {};
      }
    }
  };
});

// 

var determineTheme = (function (props, fallbackTheme, defaultProps) {
  // Props should take precedence over ThemeProvider, which should take precedence over
  // defaultProps, but React automatically puts defaultProps on props.

  /* eslint-disable react/prop-types */
  var isDefaultTheme = defaultProps && props.theme === defaultProps.theme;
  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme;
  /* eslint-enable */

  return theme;
});

// 
var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var dashesAtEnds = /(^-|-$)/g;

/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */
function escape(str) {
  return str
  // Replace all possible CSS selectors
  .replace(escapeRegex, '-')

  // Remove extraneous hyphens at the start and end
  .replace(dashesAtEnds, '');
}

// 

function getComponentName(target) {
  return target.displayName || target.name || 'Component';
}

// 

function isTag(target) /* : %checks */{
  return typeof target === 'string';
}

// 

function generateDisplayName(target) {
  return isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')';
}

// 
/* eslint-disable max-len */
/**
 * Trying to avoid the unknown-prop errors on styled components by filtering by
 * React's attribute whitelist.
 *
 * To regenerate this regex:
 *
 * 1. `npm i -g regexgen` (https://github.com/devongovett/regexgen)
 * 2. Run `regexgen` with the list of space-separated words below as input
 * 3. Surround the emitted regex with this: `/^(GENERATED_REGEX)$/` -- this will ensure a full string match
 *    and no false positives from partials
 * */
/*
children dangerouslySetInnerHTML key ref autoFocus defaultValue valueLink defaultChecked checkedLink innerHTML suppressContentEditableWarning onFocusIn onFocusOut className onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown onKeyPress onKeyUp onFocus onBlur onChange onInput onInvalid onSubmit onReset onClick onContextMenu onDoubleClick onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onAnimationStart onAnimationEnd onAnimationIteration onTransitionEnd onCopyCapture onCutCapture onPasteCapture onCompositionEndCapture onCompositionStartCapture onCompositionUpdateCapture onKeyDownCapture onKeyPressCapture onKeyUpCapture onFocusCapture onBlurCapture onChangeCapture onInputCapture onSubmitCapture onResetCapture onClickCapture onContextMenuCapture onDoubleClickCapture onDragCapture onDragEndCapture onDragEnterCapture onDragExitCapture onDragLeaveCapture onDragOverCapture onDragStartCapture onDropCapture onMouseDownCapture onMouseEnterCapture onMouseLeaveCapture onMouseMoveCapture onMouseOutCapture onMouseOverCapture onMouseUpCapture onSelectCapture onTouchCancelCapture onTouchEndCapture onTouchMoveCapture onTouchStartCapture onScrollCapture onWheelCapture onAbortCapture onCanPlayCapture onCanPlayThroughCapture onDurationChangeCapture onEmptiedCapture onEncryptedCapture onEndedCapture onErrorCapture onLoadedDataCapture onLoadedMetadataCapture onLoadStartCapture onPauseCapture onPlayCapture onPlayingCapture onProgressCapture onRateChangeCapture onSeekedCapture onSeekingCapture onStalledCapture onSuspendCapture onTimeUpdateCapture onVolumeChangeCapture onWaitingCapture onLoadCapture onAnimationStartCapture onAnimationEndCapture onAnimationIterationCapture onTransitionEndCapture accept acceptCharset accessKey action allowFullScreen allowTransparency alt as async autoComplete autoPlay capture cellPadding cellSpacing charSet challenge checked cite classID className cols colSpan content contentEditable contextMenu controlsList controls coords crossOrigin data dateTime default defer dir disabled download draggable encType form formAction formEncType formMethod formNoValidate formTarget frameBorder headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media mediaGroup method min minLength multiple muted name nonce noValidate open optimum pattern placeholder playsInline poster preload profile radioGroup readOnly referrerPolicy rel required reversed role rows rowSpan sandbox scope scoped scrolling seamless selected shape size sizes span spellCheck src srcDoc srcLang srcSet start step style summary tabIndex target title type useMap value width wmode wrap about datatype inlist prefix property resource typeof vocab autoCapitalize autoCorrect autoSave color itemProp itemScope itemType itemID itemRef results security unselectable accentHeight accumulate additive alignmentBaseline allowReorder alphabetic amplitude arabicForm ascent attributeName attributeType autoReverse azimuth baseFrequency baseProfile baselineShift bbox begin bias by calcMode capHeight clip clipPath clipRule clipPathUnits colorInterpolation colorInterpolationFilters colorProfile colorRendering contentScriptType contentStyleType cursor cx cy d decelerate descent diffuseConstant direction display divisor dominantBaseline dur dx dy edgeMode elevation enableBackground end exponent externalResourcesRequired fill fillOpacity fillRule filter filterRes filterUnits floodColor floodOpacity focusable fontFamily fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontWeight format from fx fy g1 g2 glyphName glyphOrientationHorizontal glyphOrientationVertical glyphRef gradientTransform gradientUnits hanging horizAdvX horizOriginX ideographic imageRendering in in2 intercept k k1 k2 k3 k4 kernelMatrix kernelUnitLength kerning keyPoints keySplines keyTimes lengthAdjust letterSpacing lightingColor limitingConeAngle local markerEnd markerMid markerStart markerHeight markerUnits markerWidth mask maskContentUnits maskUnits mathematical mode numOctaves offset opacity operator order orient orientation origin overflow overlinePosition overlineThickness paintOrder panose1 pathLength patternContentUnits patternTransform patternUnits pointerEvents points pointsAtX pointsAtY pointsAtZ preserveAlpha preserveAspectRatio primitiveUnits r radius refX refY renderingIntent repeatCount repeatDur requiredExtensions requiredFeatures restart result rotate rx ry scale seed shapeRendering slope spacing specularConstant specularExponent speed spreadMethod startOffset stdDeviation stemh stemv stitchTiles stopColor stopOpacity strikethroughPosition strikethroughThickness string stroke strokeDasharray strokeDashoffset strokeLinecap strokeLinejoin strokeMiterlimit strokeOpacity strokeWidth surfaceScale systemLanguage tableValues targetX targetY textAnchor textDecoration textRendering textLength to transform u1 u2 underlinePosition underlineThickness unicode unicodeBidi unicodeRange unitsPerEm vAlphabetic vHanging vIdeographic vMathematical values vectorEffect version vertAdvY vertOriginX vertOriginY viewBox viewTarget visibility widths wordSpacing writingMode x xHeight x1 x2 xChannelSelector xlinkActuate xlinkArcrole xlinkHref xlinkRole xlinkShow xlinkTitle xlinkType xmlBase xmlns xmlnsXlink xmlLang xmlSpace y y1 y2 yChannelSelector z zoomAndPan onPointerDown onPointerMove onPointerUp onPointerCancel onGotPointerCapture onLostPointerCapture onPointerEnter onPointerLeave onPointerOver onPointerOut class for autofocus allow allowUserMedia allowPaymentRequest
*/
/* eslint-enable max-len */

var ATTRIBUTE_REGEX = /^((?:s(?:uppressContentEditableWarn|croll|pac)|(?:shape|image|text)Render|(?:letter|word)Spac|vHang|hang)ing|(?:on(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:Animation|Touch|Load|Drag)Start|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|Lo(?:stPointer|ad)|TimeUpdate|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|GotPointer|MouseDown|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|KeyPress|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|P(?:rogress|laying)|DragEnd|Key(?:Down|Up)|(?:MouseU|Dro)p|(?:Wait|Seek)ing|Scroll|Focus|Paste|Abort|Drag|Play|Blur)Captur|alignmentBaselin|(?:limitingConeAng|xlink(?:(?:Arcr|R)o|Tit)|s(?:urfaceSca|ty|ca)|unselectab|baseProfi|fontSty|(?:focus|dragg)ab|multip|profi|tit)l|d(?:ominantBaselin|efaultValu)|onPointerLeav|a(?:uto(?:Capitaliz|Revers|Sav)|dditiv)|(?:(?:formNoValid|xlinkActu|noValid|accumul|rot)a|autoComple|decelera)t|(?:(?:attribute|item)T|datat)yp|onPointerMov|(?:attribute|glyph)Nam|playsInlin|(?:writing|input|edge)Mod|(?:formE|e)ncTyp|(?:amplitu|mo)d|(?:xlinkTy|itemSco|keyTy|slo)p|(?:xmlSpa|non)c|fillRul|(?:dateTi|na)m|r(?:esourc|ol)|xmlBas|wmod)e|(?:glyphOrientationHorizont|loc)al|(?:externalResourcesRequir|select|revers|mut)ed|c(?:o(?:lorInterpolationFilter|ord)s|o(?:lor(?:Interpolation)?|nt(?:rols|ent))|(?:ontentS(?:cript|tyle)Typ|o(?:ntentEditab|lorProfi)l|l(?:assNam|ipRul)|a(?:lcMod|ptur)|it)e|olorRendering|l(?:ipPathUnits|assID)|(?:ontrolsLis|apHeigh)t|h(?:eckedLink|a(?:llenge|rSet)|ildren|ecked)|ell(?:Spac|Padd)ing|o(?:ntextMenu|ls)|(?:rossOrigi|olSpa)n|l(?:ip(?:Path)?|ass)|ursor|[xy])|glyphOrientationVertical|d(?:angerouslySetInnerHTML|efaultChecked|ownload|isabled|isplay|[xy])|(?:s(?:trikethroughThickn|eaml)es|(?:und|ov)erlineThicknes|r(?:equiredExtension|adiu)|(?:requiredFeatur|tableValu|stitchTil|numOctav|filterR)e|key(?:(?:Splin|Tim)e|Param)|auto[Ff]ocu|header|bia)s|(?:(?:st(?:rikethroughPosi|dDevia)|(?:und|ov)erlinePosi|(?:textDecor|elev)a|orienta)tio|(?:strokeLinejo|orig)i|on(?:PointerDow|FocusI)|formActio|zoomAndPa|directio|(?:vers|act)io|rowSpa|begi|ico)n|o(?:n(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur)|rient)|p(?:reserveAspectRatio|ointsAt[X-Z]|anose1)|(?:(?:allowPaymentReque|(?:fontSize|length)Adju|manife)s|strokeMiterlimi|(?:(?:specularE|e)xpon|renderingInt|asc)en|(?:specularConsta|repeatCou|fontVaria)n|d(?:iffuseConsta|esce)n|baselineShif|vectorEffec|onPointerOu|(?:(?:mar(?:ker|gin)|x)H|accentH|fontW)eigh|markerStar|a(?:utoCorrec|bou)|onFocusOu|intercep|restar|forma|inlis|heigh|lis)t|(?:patternContent|ma(?:sk(?:Content)?|rker)|primitive|gradient|pattern|filter)Units|(?:(?:allowTranspar|baseFrequ)enc|re(?:ferrerPolic|adOnl)|(?:(?:st(?:roke|op)O|floodO|fillO|o)pac|integr|secur)it|visibilit|fontFamil|accessKe|propert|summar)y|(?:gradientT|patternT|t)ransform|(?:(?:st(?:rokeDasho|artO)|o)ffs|acceptChars|formTarg|viewTarg|srcS)et|(?:[xy]ChannelSelect|lightingCol|textAnch|floodCol|stopCol|operat|htmlF)or|(?:(?:enableBackgrou|markerE)n|s(?:p(?:readMetho|ee)|ee)|formMetho|(?:markerM|onInval)i|preloa|metho|kin)d|k(?:ernel(?:UnitLength|Matrix)|[1-4])|strokeDasharray|(?:onPointerCanc|lab)el|(?:allowFullScre|hidd)en|a(?:l(?:lowUserMedia|phabetic|t)|rabicForm|sync)|systemLanguage|(?:(?:o(?:nPointer(?:Ent|Ov)|rd)|allowReord|placehold|frameBord|paintOrd|post)e|repeatDu|d(?:efe|u))r|(?:pointerEve|keyPoi)nts|preserveAlpha|(?:strokeLineca|onPointerU|itemPro|useMa|wra|loo)p|v(?:Mathematical|ert(?:Origin[XY]|AdvY)|alues|ocab)|unicodeRange|h(?:oriz(?:Origin|Adv)X|ttpEquiv)|(?:vI|i)deographic|mathematical|u(?:nicodeBidi|[12])|(?:fontStretc|hig)h|vAlphabetic|(?:(?:mar(?:ker|gin)W|strokeW)id|azimu)th|(?:xmlnsXl|valueL)ink|mediaGroup|spellCheck|(?:text|m(?:in|ax))Length|(?:unitsPerE|optimu|fro)m|r(?:adioGroup|e(?:sults|f[XY]|l)|ows|[xy])|pathLength|(?:xlinkHr|glyphR)ef|innerHTML|xlinkShow|f(?:o(?:ntSize|rm?)|il(?:ter|l))|(?:tabInde|(?:sand|b)bo|viewBo)x|autoPlay|r(?:e(?:quired|sult|f))?|(?:(?:href|xml|src)La|kerni)ng|o(?:verflow|pen)|i(?:temRef|n2|s)|p(?:attern|oints)|unicode|d(?:efault|ata|ir)?|divisor|t(?:arget[XY]|o)|(?:stri|la)ng|(?:width|size)s|prefix|typeof|srcDoc|s(?:coped|te(?:m[hv]|p)|pan)|s(?:t(?:roke|art)|hape|cope|rc)|a(?:ccept|llow|s)|itemID|t(?:arget|ype)|m(?:edia|a(?:sk|x)|in)|value|width|x(?:mlns)?|size|href|k(?:ey)?|end|low|by|x[12]|y[12]|g[12]|i[dn]|f[xy]|[yz])$/;
/* From DOMProperty */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
var isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(x|data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));

var validAttr = (function (name) {
  return ATTRIBUTE_REGEX.test(name) || isCustomAttribute(name.toLowerCase());
});

// 

function hasInInheritanceChain(child, parent) {
  var target = child;

  while (target) {
    target = Object.getPrototypeOf(target);

    if (target && target === parent) {
      return true;
    }
  }

  return false;
}

// 
/**
 * Creates a broadcast that can be listened to, i.e. simple event emitter
 *
 * @see https://github.com/ReactTraining/react-broadcast
 */

var createBroadcast = function createBroadcast(initialState) {
  var listeners = {};
  var id = 0;
  var state = initialState;

  function publish(nextState) {
    state = nextState;

    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in listeners) {
      var listener = listeners[key];
      if (listener === undefined) {
        // eslint-disable-next-line no-continue
        continue;
      }

      listener(state);
    }
  }

  function subscribe(listener) {
    var currentId = id;
    listeners[currentId] = listener;
    id += 1;
    listener(state);
    return currentId;
  }

  function unsubscribe(unsubID) {
    listeners[unsubID] = undefined;
  }

  return { publish: publish, subscribe: subscribe, unsubscribe: unsubscribe };
};

var _contextShape, _ThemeProvider$contex;

// NOTE: DO NOT CHANGE, changing this is a semver major change!
var CHANNEL = '__styled-components__';
var CHANNEL_NEXT = CHANNEL + 'next__';

var CONTEXT_CHANNEL_SHAPE = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
  getTheme: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  subscribe: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  unsubscribe: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
});

var contextShape = (_contextShape = {}, _contextShape[CHANNEL] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, _contextShape[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _contextShape);

var warnChannelDeprecated = void 0;
if (false) {
  warnChannelDeprecated = once(function () {
    // eslint-disable-next-line no-console
    console.warn('Warning: Usage of `context.' + CHANNEL + '` as a function is deprecated. It will be replaced with the object on `.context.' + CHANNEL_NEXT + '` in a future version.');
  });
}

var isFunction = function isFunction(test) {
  return typeof test === 'function';
};

/**
 * Provide a theme to an entire react component tree via context and event listeners (have to do
 * both context and event emitter as pure components block context updates)
 */

var ThemeProvider = function (_Component) {
  inherits(ThemeProvider, _Component);

  function ThemeProvider() {
    classCallCheck(this, ThemeProvider);

    var _this = possibleConstructorReturn(this, _Component.call(this));

    _this.unsubscribeToOuterId = -1;

    _this.getTheme = _this.getTheme.bind(_this);
    return _this;
  }

  ThemeProvider.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
    // with the outer theme
    var outerContext = this.context[CHANNEL_NEXT];
    if (outerContext !== undefined) {
      this.unsubscribeToOuterId = outerContext.subscribe(function (theme) {
        _this2.outerTheme = theme;

        if (_this2.broadcast !== undefined) {
          _this2.publish(_this2.props.theme);
        }
      });
    }

    this.broadcast = createBroadcast(this.getTheme());
  };

  ThemeProvider.prototype.getChildContext = function getChildContext() {
    var _this3 = this,
        _babelHelpers$extends;

    return _extends({}, this.context, (_babelHelpers$extends = {}, _babelHelpers$extends[CHANNEL_NEXT] = {
      getTheme: this.getTheme,
      subscribe: this.broadcast.subscribe,
      unsubscribe: this.broadcast.unsubscribe
    }, _babelHelpers$extends[CHANNEL] = function (subscriber) {
      if (false) {
        warnChannelDeprecated();
      }

      // Patch the old `subscribe` provide via `CHANNEL` for older clients.
      var unsubscribeId = _this3.broadcast.subscribe(subscriber);
      return function () {
        return _this3.broadcast.unsubscribe(unsubscribeId);
      };
    }, _babelHelpers$extends));
  };

  ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.theme !== nextProps.theme) {
      this.publish(nextProps.theme);
    }
  };

  ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribeToOuterId !== -1) {
      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeToOuterId);
    }
  };

  // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation


  ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
    var theme = passedTheme || this.props.theme;

    if (isFunction(theme)) {
      var mergedTheme = theme(this.outerTheme);

      if (false) {
        throw new StyledComponentsError(7);
      }

      return mergedTheme;
    }

    if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : _typeof(theme)) !== 'object') {
      throw new StyledComponentsError(8);
    }

    return _extends({}, this.outerTheme, theme);
  };

  ThemeProvider.prototype.publish = function publish(theme) {
    this.broadcast.publish(this.getTheme(theme));
  };

  ThemeProvider.prototype.render = function render() {
    if (!this.props.children) {
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.only(this.props.children);
  };

  return ThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

ThemeProvider.childContextTypes = contextShape;
ThemeProvider.contextTypes = (_ThemeProvider$contex = {}, _ThemeProvider$contex[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$contex);

var _babelHelpers$extends;

// HACK for generating all static styles without needing to allocate
// an empty execution context every single time...
var STATIC_EXECUTION_CONTEXT = {};

var modifiedContextShape = _extends({}, contextShape, (_babelHelpers$extends = {}, _babelHelpers$extends[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(ServerStyleSheet)]), _babelHelpers$extends));

var identifiers = {};

/* We depend on components having unique IDs */
var generateId = function generateId(ComponentStyle, _displayName, parentComponentId) {
  var displayName = typeof _displayName !== 'string' ? 'sc' : escape(_displayName);

  /**
   * This ensures uniqueness if two components happen to share
   * the same displayName.
   */
  var nr = (identifiers[displayName] || 0) + 1;
  identifiers[displayName] = nr;

  var componentId = displayName + '-' + ComponentStyle.generateName(displayName + nr);

  return parentComponentId !== undefined ? parentComponentId + '-' + componentId : componentId;
};

var warnExtendDeprecated = function warnExtendDeprecated() {};
if (false) {
  warnExtendDeprecated = once(function () {
    // eslint-disable-next-line no-console
    console.warn('Warning: The "extend" API will be removed in the upcoming v4.0 release. Use styled(StyledComponent) instead. You can find more information here: https://github.com/styled-components/styled-components/issues/1546');
  });
}

// $FlowFixMe

var BaseStyledComponent = function (_Component) {
  inherits(BaseStyledComponent, _Component);

  function BaseStyledComponent() {
    var _temp, _this, _ret;

    classCallCheck(this, BaseStyledComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.attrs = {}, _this.state = {
      theme: null,
      generatedClassName: ''
    }, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
  }

  BaseStyledComponent.prototype.unsubscribeFromContext = function unsubscribeFromContext() {
    if (this.unsubscribeId !== -1) {
      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
    }
  };

  BaseStyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props) {
    var attrs = this.constructor.attrs;

    var context = _extends({}, props, { theme: theme });
    if (attrs === undefined) {
      return context;
    }

    this.attrs = Object.keys(attrs).reduce(function (acc, key) {
      var attr = attrs[key];

      // eslint-disable-next-line no-param-reassign
      acc[key] = typeof attr === 'function' && !hasInInheritanceChain(attr, __WEBPACK_IMPORTED_MODULE_1_react__["Component"]) ? attr(context) : attr;
      return acc;
    }, {});

    return _extends({}, context, this.attrs);
  };

  BaseStyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
    var _constructor = this.constructor,
        attrs = _constructor.attrs,
        componentStyle = _constructor.componentStyle,
        warnTooManyClasses = _constructor.warnTooManyClasses;

    var styleSheet = this.context[CONTEXT_KEY] || StyleSheet.master;

    // statically styled-components don't need to build an execution context object,
    // and shouldn't be increasing the number of class names
    if (componentStyle.isStatic && attrs === undefined) {
      return componentStyle.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, styleSheet);
    } else {
      var executionContext = this.buildExecutionContext(theme, props);
      var className = componentStyle.generateAndInjectStyles(executionContext, styleSheet);

      if (false) {
        warnTooManyClasses(className);
      }

      return className;
    }
  };

  BaseStyledComponent.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var componentStyle = this.constructor.componentStyle;

    var styledContext = this.context[CHANNEL_NEXT];

    // If this is a statically-styled component, we don't need to the theme
    // to generate or build styles.
    if (componentStyle.isStatic) {
      var generatedClassName = this.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, this.props);
      this.setState({ generatedClassName: generatedClassName });
      // If there is a theme in the context, subscribe to the event emitter. This
      // is necessary due to pure components blocking context updates, this circumvents
      // that by updating when an event is emitted
    } else if (styledContext !== undefined) {
      var subscribe = styledContext.subscribe;

      this.unsubscribeId = subscribe(function (nextTheme) {
        // This will be called once immediately
        var theme = determineTheme(_this2.props, nextTheme, _this2.constructor.defaultProps);

        var generatedClassName = _this2.generateAndInjectStyles(theme, _this2.props);

        _this2.setState({ theme: theme, generatedClassName: generatedClassName });
      });
    } else {
      // eslint-disable-next-line react/prop-types
      var theme = this.props.theme || EMPTY_OBJECT;
      var _generatedClassName = this.generateAndInjectStyles(theme, this.props);
      this.setState({ theme: theme, generatedClassName: _generatedClassName });
    }
  };

  BaseStyledComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this3 = this;

    // If this is a statically-styled component, we don't need to listen to
    // props changes to update styles
    var componentStyle = this.constructor.componentStyle;

    if (componentStyle.isStatic) {
      return;
    }

    this.setState(function (prevState) {
      var theme = determineTheme(nextProps, prevState.theme, _this3.constructor.defaultProps);
      var generatedClassName = _this3.generateAndInjectStyles(theme, nextProps);

      return { theme: theme, generatedClassName: generatedClassName };
    });
  };

  BaseStyledComponent.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unsubscribeFromContext();
  };

  BaseStyledComponent.prototype.render = function render() {
    // eslint-disable-next-line react/prop-types
    var innerRef = this.props.innerRef;
    var generatedClassName = this.state.generatedClassName;
    var _constructor2 = this.constructor,
        styledComponentId = _constructor2.styledComponentId,
        target = _constructor2.target;


    var isTargetTag = isTag(target);

    var className = [
    // eslint-disable-next-line react/prop-types
    this.props.className, styledComponentId, this.attrs.className, generatedClassName].filter(Boolean).join(' ');

    var baseProps = _extends({}, this.attrs, {
      className: className
    });

    if (isStyledComponent(target)) {
      baseProps.innerRef = innerRef;
    } else {
      baseProps.ref = innerRef;
    }

    var propsForElement = baseProps;
    var key = void 0;

    for (key in this.props) {
      // Don't pass through non HTML tags through to HTML elements
      // always omit innerRef
      if (key !== 'innerRef' && key !== 'className' && (!isTargetTag || validAttr(key))) {
        propsForElement[key] = key === 'style' && key in this.attrs ? _extends({}, this.attrs[key], this.props[key]) : this.props[key];
      }
    }

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(target, propsForElement);
  };

  return BaseStyledComponent;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var _StyledComponent = (function (ComponentStyle, constructWithOptions) {
  var createStyledComponent = function createStyledComponent(target, options, rules) {
    var _options$isClass = options.isClass,
        isClass = _options$isClass === undefined ? !isTag(target) : _options$isClass,
        _options$displayName = options.displayName,
        displayName = _options$displayName === undefined ? generateDisplayName(target) : _options$displayName,
        _options$componentId = options.componentId,
        componentId = _options$componentId === undefined ? generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId,
        _options$ParentCompon = options.ParentComponent,
        ParentComponent = _options$ParentCompon === undefined ? BaseStyledComponent : _options$ParentCompon,
        extendingRules = options.rules,
        attrs = options.attrs;


    var styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;

    var componentStyle = new ComponentStyle(extendingRules === undefined ? rules : extendingRules.concat(rules), attrs, styledComponentId);

    var StyledComponent = function (_ParentComponent) {
      inherits(StyledComponent, _ParentComponent);

      function StyledComponent() {
        classCallCheck(this, StyledComponent);
        return possibleConstructorReturn(this, _ParentComponent.apply(this, arguments));
      }

      StyledComponent.withComponent = function withComponent(tag) {
        var previousComponentId = options.componentId,
            optionsToCopy = objectWithoutProperties(options, ['componentId']);


        var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : escape(getComponentName(tag)));

        var newOptions = _extends({}, optionsToCopy, {
          componentId: newComponentId,
          ParentComponent: StyledComponent
        });

        return createStyledComponent(tag, newOptions, rules);
      };

      createClass(StyledComponent, null, [{
        key: 'extend',
        get: function get$$1() {
          var rulesFromOptions = options.rules,
              parentComponentId = options.componentId,
              optionsToCopy = objectWithoutProperties(options, ['rules', 'componentId']);


          var newRules = rulesFromOptions === undefined ? rules : rulesFromOptions.concat(rules);

          var newOptions = _extends({}, optionsToCopy, {
            rules: newRules,
            parentComponentId: parentComponentId,
            ParentComponent: StyledComponent
          });

          warnExtendDeprecated();

          return constructWithOptions(createStyledComponent, target, newOptions);
        }
      }]);
      return StyledComponent;
    }(ParentComponent);

    StyledComponent.attrs = attrs;
    StyledComponent.componentStyle = componentStyle;
    StyledComponent.contextTypes = modifiedContextShape;
    StyledComponent.displayName = displayName;
    StyledComponent.styledComponentId = styledComponentId;
    StyledComponent.target = target;


    if (false) {
      StyledComponent.warnTooManyClasses = createWarnTooManyClasses(displayName);
    }

    if (isClass) {
      __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(StyledComponent, target, {
        // all SC-specific things should not be hoisted
        attrs: true,
        componentStyle: true,
        displayName: true,
        extend: true,
        styledComponentId: true,
        target: true,
        warnTooManyClasses: true,
        withComponent: true
      });
    }

    return StyledComponent;
  };

  return createStyledComponent;
});

// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash(str) {
  var l = str.length | 0,
      h = l | 0,
      i = 0,
      k;

  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;

    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);

    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;

    l -= 4;
    ++i;
  }

  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }

  h ^= h >>> 13;
  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  h ^= h >>> 15;

  return h >>> 0;
}

// 

var areStylesCacheable = IS_BROWSER;

var isStaticRules = function isStaticRules(rules, attrs) {
  for (var i = 0, len = rules.length; i < len; i += 1) {
    var rule = rules[i];

    // recursive case
    if (Array.isArray(rule) && !isStaticRules(rule)) {
      return false;
    } else if (typeof rule === 'function' && !isStyledComponent(rule)) {
      // functions are allowed to be static if they're just being
      // used to get the classname of a nested styled component
      return false;
    }
  }

  if (attrs !== undefined) {
    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in attrs) {
      if (typeof attrs[key] === 'function') {
        return false;
      }
    }
  }

  return true;
};

var isHMREnabled = typeof module !== 'undefined' && module.hot && "production" !== 'production';

/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */
var _ComponentStyle = (function (nameGenerator, flatten, stringifyRules) {
  /* combines hashStr (murmurhash) and nameGenerator for convenience */
  var generateRuleHash = function generateRuleHash(str) {
    return nameGenerator(murmurhash(str));
  };

  var ComponentStyle = function () {
    function ComponentStyle(rules, attrs, componentId) {
      classCallCheck(this, ComponentStyle);

      this.rules = rules;
      this.isStatic = !isHMREnabled && isStaticRules(rules, attrs);
      this.componentId = componentId;

      if (!StyleSheet.master.hasId(componentId)) {
        var placeholder =  false ? ['.' + componentId + ' {}'] : [];

        StyleSheet.master.deferredInject(componentId, placeholder);
      }
    }

    /*
     * Flattens a rule set into valid CSS
     * Hashes it, wraps the whole chunk in a .hash1234 {}
     * Returns the hash to be injected on render()
     * */


    ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
      var isStatic = this.isStatic,
          componentId = this.componentId,
          lastClassName = this.lastClassName;

      if (areStylesCacheable && isStatic && lastClassName !== undefined && styleSheet.hasNameForId(componentId, lastClassName)) {
        return lastClassName;
      }

      var flatCSS = flatten(this.rules, executionContext);
      var name = generateRuleHash(this.componentId + flatCSS.join(''));

      if (!styleSheet.hasNameForId(componentId, name)) {
        styleSheet.inject(this.componentId, stringifyRules(flatCSS, '.' + name), name);
      }

      this.lastClassName = name;
      return name;
    };

    ComponentStyle.generateName = function generateName(str) {
      return generateRuleHash(str);
    };

    return ComponentStyle;
  }();

  return ComponentStyle;
});

// 
// Thanks to ReactDOMFactories for this handy list!

var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',

// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

// 

var _styled = (function (styledComponent, constructWithOptions) {
  var styled = function styled(tag) {
    return constructWithOptions(styledComponent, tag);
  };

  // Shorthands for all valid HTML Elements
  domElements.forEach(function (domElement) {
    styled[domElement] = styled(domElement);
  });

  return styled;
});

// 

var replaceWhitespace = function replaceWhitespace(str) {
  return str.replace(/\s|\\n/g, '');
};

var _keyframes = (function (nameGenerator, stringifyRules, css) {
  return function () {
    var styleSheet = StyleSheet.master;
    var rules = css.apply(undefined, arguments);
    var name = nameGenerator(murmurhash(replaceWhitespace(JSON.stringify(rules))));
    var id = 'sc-keyframes-' + name;

    if (!styleSheet.hasNameForId(id, name)) {
      styleSheet.inject(id, stringifyRules(rules, name, '@keyframes'), name);
    }

    return name;
  };
});

// 

var _injectGlobal = (function (stringifyRules, css) {
  var injectGlobal = function injectGlobal() {
    var styleSheet = StyleSheet.master;
    var rules = css.apply(undefined, arguments);
    var hash = murmurhash(JSON.stringify(rules));
    var id = 'sc-global-' + hash;

    if (!styleSheet.hasId(id)) {
      styleSheet.inject(id, stringifyRules(rules));
    }
  };

  return injectGlobal;
});

// 

var _constructWithOptions = (function (css) {
  var constructWithOptions = function constructWithOptions(componentConstructor, tag) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;

    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_is__["isValidElementType"])(tag)) {
      throw new StyledComponentsError(1, String(tag));
    }

    /* This is callable directly as a template function */
    // $FlowFixMe: Not typed to avoid destructuring arguments
    var templateFunction = function templateFunction() {
      return componentConstructor(tag, options, css.apply(undefined, arguments));
    };

    /* If config methods are called, wrap up a new template function and merge options */
    templateFunction.withConfig = function (config) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
    };
    templateFunction.attrs = function (attrs) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, {
        attrs: _extends({}, options.attrs || EMPTY_OBJECT, attrs)
      }));
    };

    return templateFunction;
  };

  return constructWithOptions;
});

// 

var withTheme = (function (Component$$1) {
  var isStatelessFunctionalComponent = typeof Component$$1 === 'function' &&
  // $FlowFixMe TODO: flow for prototype
  !(Component$$1.prototype && 'isReactComponent' in Component$$1.prototype);

  // NOTE: We can't pass a ref to a stateless functional component
  var shouldSetInnerRef = isStyledComponent(Component$$1) || isStatelessFunctionalComponent;

  var WithTheme = function (_React$Component) {
    inherits(WithTheme, _React$Component);

    function WithTheme() {
      var _temp, _this, _ret;

      classCallCheck(this, WithTheme);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = EMPTY_OBJECT, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
    }

    // NOTE: This is so that isStyledComponent passes for the innerRef unwrapping


    WithTheme.prototype.componentWillMount = function componentWillMount() {
      var _this2 = this;

      var defaultProps = this.constructor.defaultProps;

      var styledContext = this.context[CHANNEL_NEXT];
      var themeProp = determineTheme(this.props, undefined, defaultProps);
      if (styledContext === undefined && themeProp === undefined && "production" !== 'production') {
        // eslint-disable-next-line no-console
        console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps');
      } else if (styledContext === undefined && themeProp !== undefined) {
        this.setState({ theme: themeProp });
      } else {
        var subscribe = styledContext.subscribe;

        this.unsubscribeId = subscribe(function (nextTheme) {
          var theme = determineTheme(_this2.props, nextTheme, defaultProps);
          _this2.setState({ theme: theme });
        });
      }
    };

    WithTheme.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var defaultProps = this.constructor.defaultProps;

      this.setState(function (oldState) {
        var theme = determineTheme(nextProps, oldState.theme, defaultProps);

        return { theme: theme };
      });
    };

    WithTheme.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.unsubscribeId !== -1) {
        this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
      }
    };

    WithTheme.prototype.render = function render() {
      var props = _extends({
        theme: this.state.theme
      }, this.props);

      if (!shouldSetInnerRef) {
        props.ref = props.innerRef;
        delete props.innerRef;
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component$$1, props);
    };

    return WithTheme;
  }(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

  WithTheme.contextTypes = contextShape;
  WithTheme.displayName = 'WithTheme(' + getComponentName(Component$$1) + ')';
  WithTheme.styledComponentId = 'withTheme';


  return __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(WithTheme, Component$$1);
});

// 

/* eslint-disable */
var __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = {
  StyleSheet: StyleSheet
};

// 

/* Warning if you've imported this file on React Native */
if (false) {
  // eslint-disable-next-line no-console
  console.warn("It looks like you've imported 'styled-components' on React Native.\n" + "Perhaps you're looking to import 'styled-components/native'?\n" + 'Read more about this at https://www.styled-components.com/docs/basics#react-native');
}

/* Warning if there are several instances of styled-components */
if (false) {
  window['__styled-components-init__'] = window['__styled-components-init__'] || 0;

  if (window['__styled-components-init__'] === 1) {
    // eslint-disable-next-line no-console
    console.warn("It looks like there are several instances of 'styled-components' initialized in this application. " + 'This may cause dynamic styles not rendering properly, errors happening during rehydration process ' + 'and makes your application bigger without a good reason.\n\n' + 'See https://s-c.sh/2BAXzed for more info.');
  }

  window['__styled-components-init__'] += 1;
}

/* Instantiate singletons */
var ComponentStyle = _ComponentStyle(generateAlphabeticName, flatten, stringifyRules);
var constructWithOptions = _constructWithOptions(css);
var StyledComponent = _StyledComponent(ComponentStyle, constructWithOptions);

/* Instantiate exported singletons */
var keyframes = _keyframes(generateAlphabeticName, stringifyRules, css);
var injectGlobal = _injectGlobal(stringifyRules, css);
var styled = _styled(StyledComponent, constructWithOptions);

/* harmony default export */ __webpack_exports__["default"] = (styled);

//# sourceMappingURL=styled-components.browser.esm.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(176), __webpack_require__(192)(module)))

/***/ }),
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeVendors = exports.selectAllDocuments = exports.exportAll = exports.exportSelected = exports.deleteIncludeRule = exports.addIncludeRule = exports.fetchVendorRules = exports.getShareUrl = exports.deleteDocumentsPermanently = exports.uploadDocuments = exports.trashStatusMultipleDocuments = exports.mergeDocuments = exports.batchChangeViewedSetting = exports.batchDownloadDocuments = exports.putDocument = exports.batchAssignCategories = exports.batchUpdateDocuments = exports.fetchDocuments = undefined;

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _doubleEncode = __webpack_require__(1000);

var _http = __webpack_require__(61);

var _filtersToUrlParams = __webpack_require__(415);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchDocuments = exports.fetchDocuments = function fetchDocuments(accountId, filterData, pagination) {
  return _http.http.get("/accounts/" + accountId + "/documents?" + (0, _filtersToUrlParams.filtersToUrlParams)(filterData, pagination)).then(function (response) {
    var documents = _ramda2.default.path(["data", "documents"], response);
    var totalCountFiltered = _ramda2.default.path(["data", "totalCountFiltered"], response);
    var totalCount = _ramda2.default.path(["data", "totalCount"], response);
    var totalSumFiltered = _ramda2.default.path(["data", "totalSumFiltered"], response);

    return { documents: documents, response: response, totalCount: totalCount, totalCountFiltered: totalCountFiltered, totalSumFiltered: totalSumFiltered };
  });
};

var batchUpdateDocuments = exports.batchUpdateDocuments = function batchUpdateDocuments(accountId, documents, formData) {
  var vendor = _ramda2.default.path(["vendor", "name"], formData);
  var documentType = _ramda2.default.path(["documentType", "name"], formData);
  var currency = _ramda2.default.path(["currency", "name"], formData);
  var name = _ramda2.default.path(["name"], formData);

  if (vendor === undefined && documentType === undefined && currency === undefined && name === undefined) {
    return Promise.resolve(null);
  }

  var ajaxPromises = documents.map(function (document) {
    var data = updateDocumentValues(document, vendor, documentType, currency, name);
    return _http.http.put("/accounts/" + accountId + "/documents/" + document.id, data);
  });
  return Promise.all(ajaxPromises);
};

var updateDocumentValues = function updateDocumentValues(document, vendor, documentType, currency, name) {
  var data = _ramda2.default.clone(document);
  if (vendor) {
    data.vendor = vendor;
  }
  if (currency) {
    data.currency = currency;
  }
  if (name) {
    data.name = name;
  }
  if (documentType) {
    if (data.name !== undefined) {
      data.vendor = data.name;
    }
    if (data.vendor !== undefined) {
      data.name = data.vendor;
    }
    if (documentType === "receipt") {
      data.currency = data.currency ? data.currency : "AUD";
      data.categories = data.categories ? data.categories : [];
      data.total = data.total ? data.total : 0;
      data.tax = data.tax ? data.tax : 0;
    }
    data.type = documentType.toLowerCase();
  }
  return data;
};

var batchAssignCategories = exports.batchAssignCategories = function batchAssignCategories(accountId, documents, selectedCategories) {
  var ajaxPromises = documents.map(function (document) {
    var data = _ramda2.default.clone(document);
    if (selectedCategories.length === 0 || data.categories === undefined) {
      data.categories = [];
    }
    data.categories = _ramda2.default.uniq(_ramda2.default.concat(data.categories, selectedCategories));
    return _http.http.put("/accounts/" + accountId + "/documents/" + document.id, data);
  });
  return Promise.all(ajaxPromises);
};

var putDocument = exports.putDocument = function putDocument(accountId, documentId, data) {
  var document = JSON.stringify(data);
  return _http.http.put("/accounts/" + accountId + "/documents/" + documentId, document);
};

var batchDownloadDocuments = exports.batchDownloadDocuments = function batchDownloadDocuments(exportType, accountId, documentIds, emails) {
  return _http.http.post("/accounts/" + accountId + "/exports", {
    documents: documentIds,
    emails: emails,
    exportType: exportType
  });
};

var batchChangeViewedSetting = exports.batchChangeViewedSetting = function batchChangeViewedSetting(accountId, documents, isViewed) {
  var ajaxPromises = documents.map(function (document) {
    var newDocument = _ramda2.default.clone(document);
    newDocument.viewed = isViewed;
    return _http.http.put("/accounts/" + accountId + "/documents/" + document.id, newDocument);
  });
  return Promise.all(ajaxPromises);
};

var mergeDocuments = exports.mergeDocuments = function mergeDocuments(accountId, formData) {
  return _http.http.post("/accounts/" + accountId + "/documents", formData);
};

var trashStatusMultipleDocuments = exports.trashStatusMultipleDocuments = function trashStatusMultipleDocuments(accountId, documents, trashStatus) {
  var ajaxPromises = documents.map(function (document) {
    var newDocument = _ramda2.default.clone(document);
    newDocument.trashed = trashStatus;
    return _http.http.put("/accounts/" + accountId + "/documents/" + document.id, newDocument);
  });
  return Promise.all(ajaxPromises);
};

var uploadDocuments = exports.uploadDocuments = function uploadDocuments(accountId, formData) {
  return _http.http.upload("accounts/" + accountId + "/documents", formData);
};

var deleteDocumentsPermanently = exports.deleteDocumentsPermanently = function deleteDocumentsPermanently(accountId, documents) {
  var ajaxPromises = documents.map(function (document) {
    return _http.http.delete("/accounts/" + accountId + "/documents/" + document.id);
  });
  return Promise.all(ajaxPromises);
};

var getShareUrl = exports.getShareUrl = function getShareUrl(accountId, documentId) {
  return _http.http.post("/accounts/" + accountId + "/share-document/" + documentId).then(function (response) {
    var shareUrl = _ramda2.default.path(["data", "url"], response);
    return { shareUrl: shareUrl };
  });
};

var fetchVendorRules = exports.fetchVendorRules = function fetchVendorRules(accountId, documents) {
  var ajaxPromises = documents.map(function (document) {
    if (document.vendor === undefined || document.vendor === null || document.vendor === "") {
      return null;
    }
    return _http.http.get("accounts/" + accountId + "/vendors/" + (0, _doubleEncode.doubleEncode)(document.vendor) + "/rules");
  });
  return Promise.all(ajaxPromises).then(function (response) {
    var rules = response.map(function (rule) {
      return _ramda2.default.path(["data", "rules"], rule);
    });
    return { rules: rules, documents: documents };
  });
};

var addIncludeRule = exports.addIncludeRule = function addIncludeRule(accountId, categoryId, rule) {
  return _http.http.post("accounts/" + accountId + "/categories/" + categoryId + "/rules/vendors", rule);
};

var deleteIncludeRule = exports.deleteIncludeRule = function deleteIncludeRule(accountId, categoryId, vendorId) {
  return _http.http.delete("/accounts/" + accountId + "/categories/" + categoryId + "/rules/vendors/" + vendorId);
};

var exportSelected = exports.exportSelected = function exportSelected(accountId, documentIds) {
  return _http.http.post("/accounts/" + accountId + "/exports", {
    documents: documentIds,
    exportType: "accounting"
  });
};

var exportAll = exports.exportAll = function exportAll(accountId) {
  var queryString = "processing_state=PROCESSED&type=receipt&not_category=Exported&not_category=Do+not+export";
  var exportsObject = {
    exportType: "accounting",
    filter: queryString
  };
  return _http.http.post("/accounts/" + accountId + "/exports", exportsObject);
};

var selectAllDocuments = exports.selectAllDocuments = function selectAllDocuments(accountId, filters) {
  var pagination = {
    limit: 0,
    pageNumber: 0
  };
  return _http.http.get("/accounts/" + accountId + "/documents?" + (0, _filtersToUrlParams.filtersToUrlParams)(filters, pagination)).then(function (response) {
    var documents = _ramda2.default.path(["data", "documents"], response);
    var documentIds = _ramda2.default.pluck("id")(documents);
    return { documentIds: documentIds, documents: documents };
  });
};

var mergeVendors = exports.mergeVendors = function mergeVendors(accountId, documents, newVendor) {
  var ajaxPromises = documents.map(function (document) {
    var data = _ramda2.default.merge(document, { vendor: newVendor, name: newVendor });
    return _http.http.put("/accounts/" + accountId + "/documents/" + document.id, data);
  });
  return Promise.all(ajaxPromises);
};

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderPaymentTypeElement = exports.renderFormCalculateTaxElement = exports.renderFormNumberElement = exports.renderFormToggleElement = exports.renderFormElement = exports.FormButton = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSelect = __webpack_require__(135);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _reduxForm = __webpack_require__(35);

var _customPropTypes = __webpack_require__(5);

var _formElements = __webpack_require__(510);

var _formElements2 = _interopRequireDefault(_formElements);

var _datepicker = __webpack_require__(267);

var _button = __webpack_require__(7);

var _gstCalculator = __webpack_require__(423);

var _checkbox = __webpack_require__(266);

var _select = __webpack_require__(45);

var _paymentTypes = __webpack_require__(275);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormButton = exports.FormButton = function FormButton(_ref) {
  var text = _ref.text;
  return _react2.default.createElement(
    "div",
    { className: _formElements2.default["form-button"] },
    _react2.default.createElement(
      _button.Button,
      { primary: true, type: "submit" },
      text
    )
  );
};

FormButton.propTypes = { text: _propTypes2.default.string.isRequired };

var renderFormElement = exports.renderFormElement = function renderFormElement(title, name, type) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var addFunction = arguments[4];
  var accountId = arguments[5];
  return _react2.default.createElement(
    "div",
    { className: _formElements2.default["fields-container"] },
    _react2.default.createElement(
      "h4",
      null,
      title
    ),
    _react2.default.createElement(_reduxForm.Field, {
      accountId: accountId,
      addFunction: addFunction,
      component: componentType(type),
      name: name,
      options: options,
      placeholder: title
    })
  );
};

var componentType = function componentType(type) {
  switch (type) {
    case "text":
      return TextInput;
    case "select":
      return SelectInput;
    case "date":
      return DatePickerInput;
    case "notes":
      return NoteInput;
    case "createable":
      return CreateableSelectInput;
    default:
      return TextInput;
  }
};

var TextInput = function TextInput(props) {
  return _react2.default.createElement("input", _extends({}, props.input, { className: _formElements2.default.fields, placeholder: props.placeholder }));
};

TextInput.propTypes = {
  input: _customPropTypes.reduxFormInputType.isRequired,
  placeholder: _propTypes2.default.string.isRequired
};

var SelectInput = function SelectInput(props) {
  return _react2.default.createElement(_reactSelect2.default, _extends({}, props.input, {
    clearable: false,
    onBlur: function onBlur() {
      return props.input.onBlur(props.input.value);
    },
    onChange: (0, _select.onChangeMapper)(props.input.onChange),
    options: (0, _select.optionsMapper)(props.options),
    placeholder: props.placeholder,
    searchable: false,
    value: (0, _select.valueMapper)(props.input.value)
  }));
};

SelectInput.propTypes = {
  input: _customPropTypes.reduxFormInputType.isRequired,
  options: _propTypes2.default.arrayOf(_customPropTypes.selectOptionType).isRequired,
  placeholder: _propTypes2.default.string.isRequired
};

var DatePickerInput = function DatePickerInput(props) {
  return _react2.default.createElement(_datepicker.Datepicker, _extends({}, props.input, {
    isClearable: false,
    onDateSelected: function onDateSelected(e) {
      props.input.onChange(e);
    },
    placeholderText: "Enter a date",
    selected: props.input.value ? (0, _moment2.default)(props.input.value) : null
  }));
};

DatePickerInput.propTypes = { input: _customPropTypes.reduxFormInputType.isRequired };

var NoteInput = function NoteInput(props) {
  return _react2.default.createElement("textarea", _extends({}, props.input, { className: _formElements2.default.notes }));
};

NoteInput.propTypes = { input: _customPropTypes.reduxFormInputType.isRequired };

var CreateableSelectInput = function CreateableSelectInput(props) {
  return _react2.default.createElement(_select.MultiCreatableSelect, _extends({}, props, {
    accountId: props.accountId,
    addFunction: props.addFunction,
    placeholder: "Choose a category..."
  }));
};

CreateableSelectInput.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  addFunction: _propTypes2.default.func.isRequired
};

var renderFormToggleElement = exports.renderFormToggleElement = function renderFormToggleElement(title, name) {
  return _react2.default.createElement(
    "div",
    { className: _formElements2.default["fields-container"] },
    _react2.default.createElement(
      "h4",
      null,
      title
    ),
    _react2.default.createElement(_reduxForm.Field, {
      component: ToggleInput,
      name: name,
      parse: Boolean
    })
  );
};

var ToggleInput = function ToggleInput(props) {
  return _react2.default.createElement(_checkbox.Checkbox, {
    checked: props.input.value,
    disabled: false,
    onChange: props.input.value ? function () {
      return props.input.onChange(false);
    } : function () {
      return props.input.onChange(true);
    }
  });
};

ToggleInput.propTypes = {
  input: _customPropTypes.reduxFormInputType.isRequired
};

var renderFormNumberElement = exports.renderFormNumberElement = function renderFormNumberElement(title, name, min, max, step) {
  return _react2.default.createElement(
    "div",
    { className: _formElements2.default["fields-container"] },
    _react2.default.createElement(
      "h4",
      null,
      title
    ),
    _react2.default.createElement(_reduxForm.Field, {
      component: NumberInput,
      max: max,
      min: min,
      name: name,
      normalize: normalizeNumberField,
      placeholder: title,
      step: step,
      type: "text"
    })
  );
};

var normalizeNumberField = function normalizeNumberField(value) {
  if (isNaN(value)) {
    return 0;
  }
  return value;
};

var NumberInput = function NumberInput(props) {
  return _react2.default.createElement("input", _extends({}, props.input, {
    className: _formElements2.default.fields,
    max: props.max,
    min: props.min,
    placeholder: props.placeholder,
    step: props.step,
    type: "text"
  }));
};

NumberInput.defaultProps = {
  max: null,
  min: null
};

NumberInput.propTypes = {
  input: _customPropTypes.reduxFormInputType.isRequired,
  max: _propTypes2.default.string,
  min: _propTypes2.default.string,
  placeholder: _propTypes2.default.string.isRequired,
  step: _propTypes2.default.string.isRequired
};

var renderFormCalculateTaxElement = exports.renderFormCalculateTaxElement = function renderFormCalculateTaxElement(props) {
  return _react2.default.createElement(
    "div",
    { className: _formElements2.default["fields-container"] },
    _react2.default.createElement(_reduxForm.Field, {
      change: props.change,
      component: TaxButton,
      currency: props.currency,
      name: "tax-button",
      preferredCurrency: props.preferredCurrency,
      taxRate: props.taxRate,
      total: props.total
    })
  );
};

var TaxButton = function TaxButton(props) {
  return _react2.default.createElement(
    "div",
    { className: _formElements2.default.gst },
    _react2.default.createElement(_gstCalculator.GSTCalculator, props)
  );
};

renderFormCalculateTaxElement.propTypes = {
  change: _propTypes2.default.func.isRequired,
  currency: _propTypes2.default.string.isRequired,
  preferredCurrency: _propTypes2.default.string.isRequired,
  taxRate: _propTypes2.default.number.isRequired,
  total: _propTypes2.default.number.isRequired
};

var renderPaymentTypeElement = exports.renderPaymentTypeElement = function renderPaymentTypeElement(formPaymentType) {
  var className = formPaymentType.key === "credit-card" ? _formElements2.default["credit-card"] : _formElements2.default["other-payment"];
  return _react2.default.createElement(
    "div",
    { className: _formElements2.default["fields-container"] },
    _react2.default.createElement(
      "h4",
      null,
      "Payment Type"
    ),
    _react2.default.createElement(
      "div",
      { className: className },
      _react2.default.createElement(_reduxForm.Field, {
        component: SelectInput,
        name: "formPaymentType",
        options: _paymentTypes.paymentTypes,
        placeholder: "Choose a payment type"
      }),
      _react2.default.createElement(_reduxForm.Field, {
        component: NumberInput,
        max: "9999",
        min: "0",
        name: "cardNumber",
        placeholder: "Last four...",
        step: "1"
      })
    )
  );
};

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActiveFilterItem = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _activeFilterItem = __webpack_require__(1316);

var _activeFilterItem2 = _interopRequireDefault(_activeFilterItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActiveFilterItem = exports.ActiveFilterItem = function ActiveFilterItem(_ref) {
  var name = _ref.name,
      onRemove = _ref.onRemove;
  return _react2.default.createElement(
    "div",
    { className: _activeFilterItem2.default.container },
    name,
    renderRemoveButton(name, onRemove)
  );
};

ActiveFilterItem.defaultProps = {
  onRemove: null
};

ActiveFilterItem.propTypes = {
  name: _propTypes2.default.string.isRequired,
  onRemove: _propTypes2.default.func // (name: string) => void
};

var deleteButtonOnClick = function deleteButtonOnClick(name, callback) {
  return function () {
    return callback(name);
  };
};

var renderRemoveButton = function renderRemoveButton(name, onRemove) {
  if (onRemove === null) {
    return null;
  }
  return _react2.default.createElement("button", { className: _activeFilterItem2.default["remove-button"], onClick: deleteButtonOnClick(name, onRemove) });
};

/***/ }),
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateTotalFilterAction = exports.addTotalFilterAction = exports.updateNameAction = exports.removeNameFromFilterAction = exports.addNameToFilterAction = exports.setFiltersAction = exports.resetFiltersAction = exports.orderByAction = exports.setTrashViewAction = exports.updateSearchQueryAction = exports.removeViewedStatusFromFilterAction = exports.addViewedStatusToFilterAction = exports.removeDocumentTypeFromFilterAction = exports.addDocumentTypeToFilterAction = exports.removeSearchQueryFromFilterAction = exports.addSearchQueryToFilterAction = exports.removeCardNumberFromFilterAction = exports.addCardNumberToFilterAction = exports.removeCurrencyFromFilterAction = exports.removeEnvelopeFromFilterAction = exports.removePaymentTypeFromFilterAction = exports.addEnvelopeToFilterAction = exports.removeCategoryFromFilterAction = exports.removeVendorFromFilterAction = exports.addCurrencyToFilterAction = exports.addPaymentTypeToFilterAction = exports.addCategoryToFilterAction = exports.addVendorToFilterAction = exports.clearExportTypeFilterAction = exports.setExportTypeFilterAction = exports.addEndDateToFilterAction = exports.addStartDateToFilterAction = exports.UPDATE_TOTAL_FILTER = exports.ADD_TOTAL_MIN_TO_FILTER = exports.ADD_TOTAL_MAX_TO_FILTER = exports.UPDATE_NAME = exports.REMOVE_NAME_FROM_FILTER = exports.ADD_NAME_TO_FILTER = exports.SET_FILTERS = exports.REMOVE_VIEWED_STATUS_FROM_FILTER = exports.ADD_VIEWED_STATUS_TO_FILTER = exports.REMOVE_DOCUMENT_TYPE_FROM_FILTER = exports.ADD_DOCUMENT_TYPE_TO_FILTER = exports.RESET_FILTERS = exports.SET_TRASH_VIEW = exports.UPDATE_SEARCH_QUERY = exports.REMOVE_SEARCH_QUERY_FROM_FILTER = exports.ADD_SEARCH_QUERY_TO_FILTER = exports.REMOVE_CARD_NUMBER_FROM_FILTER = exports.ADD_CARD_NUMBER_TO_FILTER = exports.ORDER_BY = exports.REMOVE_ENVELOPE_FROM_FILTER = exports.ADD_END_DATE_TO_FILTER = exports.ADD_START_DATE_TO_FILTER = exports.ADD_ENVELOPE_TO_FILTER = exports.CLEAR_EXPORT_TYPE_FILTER = exports.SET_EXPORT_TYPE_FILTER = exports.REMOVE_CURRENCY_FROM_FILTER = exports.ADD_CURRENCY_TO_FILTER = exports.REMOVE_PAYMENT_TYPE_FROM_FILTER = exports.ADD_PAYMENT_TYPE_TO_FILTER = exports.REMOVE_CATEGORY_FROM_FILTER = exports.ADD_CATEGORY_TO_FILTER = exports.REMOVE_VENDOR_FROM_FILTER = exports.ADD_VENDOR_TO_FILTER = undefined;

var _documentsActions = __webpack_require__(161);

var _localStorage = __webpack_require__(138);

var _sharedActionGenerators = __webpack_require__(411);

var _store = __webpack_require__(48);

var ADD_VENDOR_TO_FILTER = exports.ADD_VENDOR_TO_FILTER = "actions/document-filters/add-vendor-to-filter";
var REMOVE_VENDOR_FROM_FILTER = exports.REMOVE_VENDOR_FROM_FILTER = "actions/document-filters/remove-vendor-from-filter";
var ADD_CATEGORY_TO_FILTER = exports.ADD_CATEGORY_TO_FILTER = "actions/document-filters/add-category-to-filter";
var REMOVE_CATEGORY_FROM_FILTER = exports.REMOVE_CATEGORY_FROM_FILTER = "actions/document-filters/remove-category-from-filter";
var ADD_PAYMENT_TYPE_TO_FILTER = exports.ADD_PAYMENT_TYPE_TO_FILTER = "actions/document-filters/add-payment-type-to-filter";
var REMOVE_PAYMENT_TYPE_FROM_FILTER = exports.REMOVE_PAYMENT_TYPE_FROM_FILTER = "actions/document-filters/remove-payment-type-to-filter";
var ADD_CURRENCY_TO_FILTER = exports.ADD_CURRENCY_TO_FILTER = "actions/document-filters/add-currency-to-filter";
var REMOVE_CURRENCY_FROM_FILTER = exports.REMOVE_CURRENCY_FROM_FILTER = "actions/document-filters/remove-currency-from-filter";
var SET_EXPORT_TYPE_FILTER = exports.SET_EXPORT_TYPE_FILTER = "actions/document-filters/set-export-type-filter";
var CLEAR_EXPORT_TYPE_FILTER = exports.CLEAR_EXPORT_TYPE_FILTER = "actions/document-filters/clear-export-type-filter";
var ADD_ENVELOPE_TO_FILTER = exports.ADD_ENVELOPE_TO_FILTER = "actions/document-filters/add-envelope-to-filter";
var ADD_START_DATE_TO_FILTER = exports.ADD_START_DATE_TO_FILTER = "actions/document-filters/add-start-date-to-filter";
var ADD_END_DATE_TO_FILTER = exports.ADD_END_DATE_TO_FILTER = "actions/document-filters/add-end-date-to-filter";
var REMOVE_ENVELOPE_FROM_FILTER = exports.REMOVE_ENVELOPE_FROM_FILTER = "actions/document-filters/remove-envelope-from-filter";
var ORDER_BY = exports.ORDER_BY = "actions/document-filters/order-by";
var ADD_CARD_NUMBER_TO_FILTER = exports.ADD_CARD_NUMBER_TO_FILTER = "actions/document-filters/add-card-number-to-filter";
var REMOVE_CARD_NUMBER_FROM_FILTER = exports.REMOVE_CARD_NUMBER_FROM_FILTER = "actions/document-filters/remove-card-number-from-filter";
var ADD_SEARCH_QUERY_TO_FILTER = exports.ADD_SEARCH_QUERY_TO_FILTER = "actions/document-filters/add-search-query-to-filter";
var REMOVE_SEARCH_QUERY_FROM_FILTER = exports.REMOVE_SEARCH_QUERY_FROM_FILTER = "actions/document-filters/remove-search-query-from-filter";
var UPDATE_SEARCH_QUERY = exports.UPDATE_SEARCH_QUERY = "actions/document-filters/update-search-query";
var SET_TRASH_VIEW = exports.SET_TRASH_VIEW = "actions/document-filters/set-trash-view";
var RESET_FILTERS = exports.RESET_FILTERS = "acitons/document-filters/reset-filters";
var ADD_DOCUMENT_TYPE_TO_FILTER = exports.ADD_DOCUMENT_TYPE_TO_FILTER = "actions/document-filters/add-document-type-to-filter";
var REMOVE_DOCUMENT_TYPE_FROM_FILTER = exports.REMOVE_DOCUMENT_TYPE_FROM_FILTER = "actions/document-filters/remove-document-type-from-filter";
var ADD_VIEWED_STATUS_TO_FILTER = exports.ADD_VIEWED_STATUS_TO_FILTER = "actions/document-filters/add-viewed-status-to-filter";
var REMOVE_VIEWED_STATUS_FROM_FILTER = exports.REMOVE_VIEWED_STATUS_FROM_FILTER = "actions/document-filters/remove-viewed-status-from-filter";
var SET_FILTERS = exports.SET_FILTERS = "actions/document-filters/set-filters";
var ADD_NAME_TO_FILTER = exports.ADD_NAME_TO_FILTER = "actions/document-filters/add-name-to-filter";
var REMOVE_NAME_FROM_FILTER = exports.REMOVE_NAME_FROM_FILTER = "actions/documents-filters/remove-name-from-filter";
var UPDATE_NAME = exports.UPDATE_NAME = "actions/documents-filters/update-name";
var ADD_TOTAL_MAX_TO_FILTER = exports.ADD_TOTAL_MAX_TO_FILTER = "actions/document-filters/add-total-max-to-filter";
var ADD_TOTAL_MIN_TO_FILTER = exports.ADD_TOTAL_MIN_TO_FILTER = "actions/document-filters/add-total-min-to-filter";
var UPDATE_TOTAL_FILTER = exports.UPDATE_TOTAL_FILTER = "actions/documents-filter/update-total-filter";

var addStartDateToFilterAction = exports.addStartDateToFilterAction = function addStartDateToFilterAction(date) {
  return (0, _sharedActionGenerators.filterActionGenerator)(ADD_START_DATE_TO_FILTER, _documentsActions.reloadDocuments, date);
};

var addEndDateToFilterAction = exports.addEndDateToFilterAction = function addEndDateToFilterAction(date) {
  return (0, _sharedActionGenerators.filterActionGenerator)(ADD_END_DATE_TO_FILTER, _documentsActions.reloadDocuments, date);
};

var setExportTypeFilterAction = exports.setExportTypeFilterAction = function setExportTypeFilterAction(key) {
  return (0, _sharedActionGenerators.filterActionGenerator)(SET_EXPORT_TYPE_FILTER, _documentsActions.reloadDocuments, key);
};

var clearExportTypeFilterAction = exports.clearExportTypeFilterAction = function clearExportTypeFilterAction() {
  return (0, _sharedActionGenerators.filterActionGenerator)(CLEAR_EXPORT_TYPE_FILTER, _documentsActions.reloadDocuments);
};

var addVendorToFilterAction = exports.addVendorToFilterAction = function addVendorToFilterAction(name) {
  return (0, _sharedActionGenerators.filterActionGenerator)(ADD_VENDOR_TO_FILTER, _documentsActions.reloadDocuments, name);
};

var addCategoryToFilterAction = exports.addCategoryToFilterAction = function addCategoryToFilterAction(name) {
  return (0, _sharedActionGenerators.filterActionGenerator)(ADD_CATEGORY_TO_FILTER, _documentsActions.reloadDocuments, name);
};

var addPaymentTypeToFilterAction = exports.addPaymentTypeToFilterAction = function addPaymentTypeToFilterAction(key) {
  return (0, _sharedActionGenerators.filterActionGenerator)(ADD_PAYMENT_TYPE_TO_FILTER, _documentsActions.reloadDocuments, key);
};

var addCurrencyToFilterAction = exports.addCurrencyToFilterAction = function addCurrencyToFilterAction(key) {
  return (0, _sharedActionGenerators.filterActionGenerator)(ADD_CURRENCY_TO_FILTER, _documentsActions.reloadDocuments, key);
};

var removeVendorFromFilterAction = exports.removeVendorFromFilterAction = function removeVendorFromFilterAction(name) {
  return (0, _sharedActionGenerators.filterActionGenerator)(REMOVE_VENDOR_FROM_FILTER, _documentsActions.reloadDocuments, name);
};

var removeCategoryFromFilterAction = exports.removeCategoryFromFilterAction = function removeCategoryFromFilterAction(name) {
  return (0, _sharedActionGenerators.filterActionGenerator)(REMOVE_CATEGORY_FROM_FILTER, _documentsActions.reloadDocuments, name);
};

var addEnvelopeToFilterAction = exports.addEnvelopeToFilterAction = function addEnvelopeToFilterAction(code) {
  return (0, _sharedActionGenerators.filterActionGenerator)(ADD_ENVELOPE_TO_FILTER, _documentsActions.reloadDocuments, code);
};

var removePaymentTypeFromFilterAction = exports.removePaymentTypeFromFilterAction = function removePaymentTypeFromFilterAction(key) {
  return (0, _sharedActionGenerators.filterActionGenerator)(REMOVE_PAYMENT_TYPE_FROM_FILTER, _documentsActions.reloadDocuments, key);
};

var removeEnvelopeFromFilterAction = exports.removeEnvelopeFromFilterAction = function removeEnvelopeFromFilterAction(code) {
  return (0, _sharedActionGenerators.filterActionGenerator)(REMOVE_ENVELOPE_FROM_FILTER, _documentsActions.reloadDocuments, code);
};

var removeCurrencyFromFilterAction = exports.removeCurrencyFromFilterAction = function removeCurrencyFromFilterAction(key) {
  return (0, _sharedActionGenerators.filterActionGenerator)(REMOVE_CURRENCY_FROM_FILTER, _documentsActions.reloadDocuments, key);
};

var addCardNumberToFilterAction = exports.addCardNumberToFilterAction = function addCardNumberToFilterAction(key) {
  return (0, _sharedActionGenerators.filterActionGenerator)(ADD_CARD_NUMBER_TO_FILTER, _documentsActions.reloadDocuments, key);
};

var removeCardNumberFromFilterAction = exports.removeCardNumberFromFilterAction = function removeCardNumberFromFilterAction(key) {
  return (0, _sharedActionGenerators.filterActionGenerator)(REMOVE_CARD_NUMBER_FROM_FILTER, _documentsActions.reloadDocuments, key);
};

var addSearchQueryToFilterAction = exports.addSearchQueryToFilterAction = function addSearchQueryToFilterAction(query) {
  return (0, _sharedActionGenerators.filterActionGenerator)(ADD_SEARCH_QUERY_TO_FILTER, _documentsActions.reloadDocuments, query);
};

var removeSearchQueryFromFilterAction = exports.removeSearchQueryFromFilterAction = function removeSearchQueryFromFilterAction() {
  return (0, _sharedActionGenerators.filterActionGenerator)(REMOVE_SEARCH_QUERY_FROM_FILTER, _documentsActions.reloadDocuments);
};

var addDocumentTypeToFilterAction = exports.addDocumentTypeToFilterAction = function addDocumentTypeToFilterAction(type) {
  return (0, _sharedActionGenerators.filterActionGenerator)(ADD_DOCUMENT_TYPE_TO_FILTER, _documentsActions.reloadDocuments, type);
};

var removeDocumentTypeFromFilterAction = exports.removeDocumentTypeFromFilterAction = function removeDocumentTypeFromFilterAction() {
  return (0, _sharedActionGenerators.filterActionGenerator)(REMOVE_DOCUMENT_TYPE_FROM_FILTER, _documentsActions.reloadDocuments);
};

var addViewedStatusToFilterAction = exports.addViewedStatusToFilterAction = function addViewedStatusToFilterAction(key) {
  return (0, _sharedActionGenerators.filterActionGenerator)(ADD_VIEWED_STATUS_TO_FILTER, _documentsActions.reloadDocuments, key);
};

var removeViewedStatusFromFilterAction = exports.removeViewedStatusFromFilterAction = function removeViewedStatusFromFilterAction() {
  return (0, _sharedActionGenerators.filterActionGenerator)(REMOVE_VIEWED_STATUS_FROM_FILTER, _documentsActions.reloadDocuments);
};

var updateSearchQueryAction = exports.updateSearchQueryAction = function updateSearchQueryAction(query) {
  return {
    type: UPDATE_SEARCH_QUERY,
    data: { query: query }
  };
};

var setTrashViewAction = exports.setTrashViewAction = function setTrashViewAction(isTrash) {
  return (0, _sharedActionGenerators.filterActionGenerator)(SET_TRASH_VIEW, _documentsActions.reloadDocuments, isTrash);
};

var orderByAction = exports.orderByAction = function orderByAction(key) {
  return function (dispatch) {
    dispatch({
      type: ORDER_BY,
      data: { key: key }
    });
    _localStorage.storage.set(_localStorage.DOCUMENTS_SORTING_ORDER, JSON.stringify({
      orderBy: key,
      orderDirection: _store.store.getState().documentFilters.orderDirection
    }));
    (0, _documentsActions.reloadDocuments)(dispatch);
  };
};

var resetFiltersAction = exports.resetFiltersAction = function resetFiltersAction() {
  return {
    type: RESET_FILTERS
  };
};

var setFiltersAction = exports.setFiltersAction = function setFiltersAction(filters) {
  return {
    type: SET_FILTERS,
    data: { filters: filters }
  };
};

var addNameToFilterAction = exports.addNameToFilterAction = function addNameToFilterAction(name) {
  return (0, _sharedActionGenerators.filterActionGenerator)(ADD_NAME_TO_FILTER, _documentsActions.reloadDocuments, name);
};

var removeNameFromFilterAction = exports.removeNameFromFilterAction = function removeNameFromFilterAction() {
  return (0, _sharedActionGenerators.filterActionGenerator)(REMOVE_NAME_FROM_FILTER, _documentsActions.reloadDocuments);
};

var updateNameAction = exports.updateNameAction = function updateNameAction(name) {
  return {
    type: UPDATE_NAME,
    data: { name: name }
  };
};

var addTotalFilterAction = exports.addTotalFilterAction = function addTotalFilterAction(type, value) {
  if (type === "min") {
    return (0, _sharedActionGenerators.filterActionGenerator)(ADD_TOTAL_MIN_TO_FILTER, _documentsActions.reloadDocuments, value);
  }
  return (0, _sharedActionGenerators.filterActionGenerator)(ADD_TOTAL_MAX_TO_FILTER, _documentsActions.reloadDocuments, value);
};

var updateTotalFilterAction = exports.updateTotalFilterAction = function updateTotalFilterAction(type, value) {
  return {
    type: UPDATE_TOTAL_FILTER,
    data: { type: type, value: value }
  };
};

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateDefaultInterfaceAction = exports.fetchDefaultInterfaceAction = exports.updateFavouriteAccountAction = exports.fetchFavouriteAccountAction = exports.saveNewPasswordAction = exports.saveUserNameAction = exports.saveUserEmailAction = exports.fetchUserSettingsAction = exports.UPDATE_DEFAULT_INTERFACE_LOADING_STOP = exports.UPDATE_DEFAULT_INTERFACE_LOADING = exports.SET_DEFAULT_INTERFACE = exports.UPDATE_DEFAULT_INTERFACE = exports.UPDATE_FAVOURITE_ACCOUNT = exports.SET_FAVOURITE_ACCOUNT = exports.UPDATE_USER_NAME = exports.UPDATE_USER_EMAIL = exports.SET_USER_SETTINGS = undefined;

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _store = __webpack_require__(48);

var _reduxForm = __webpack_require__(35);

var _userSettings = __webpack_require__(840);

var _storage = __webpack_require__(164);

var _appActions = __webpack_require__(25);

var _validators = __webpack_require__(36);

var _trackingActions = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET_USER_SETTINGS = exports.SET_USER_SETTINGS = "actions/user-settings/set-user-settings";
var UPDATE_USER_EMAIL = exports.UPDATE_USER_EMAIL = "actions/user-settings/update-user-email";
var UPDATE_USER_NAME = exports.UPDATE_USER_NAME = "action/user-settings/update-user-name";
var SET_FAVOURITE_ACCOUNT = exports.SET_FAVOURITE_ACCOUNT = "actions/user-settings/set-favourite-account";
var UPDATE_FAVOURITE_ACCOUNT = exports.UPDATE_FAVOURITE_ACCOUNT = "actions/user-settings/update-favourite-account";
var UPDATE_DEFAULT_INTERFACE = exports.UPDATE_DEFAULT_INTERFACE = "actions/user-settings/update-default-interface";
var SET_DEFAULT_INTERFACE = exports.SET_DEFAULT_INTERFACE = "actions/user-settings/set-default-interface";
var UPDATE_DEFAULT_INTERFACE_LOADING = exports.UPDATE_DEFAULT_INTERFACE_LOADING = "actions/user-settings/update-default-interface-loading";
var UPDATE_DEFAULT_INTERFACE_LOADING_STOP = exports.UPDATE_DEFAULT_INTERFACE_LOADING_STOP = "actions/user-settings/update-default-interface-loading-stop";

var fetchUserSettingsAction = exports.fetchUserSettingsAction = function fetchUserSettingsAction() {
  return function (dispatch) {
    (0, _userSettings.fetchUserSettings)().then(function (_ref) {
      var email = _ref.email,
          name = _ref.name,
          surname = _ref.surname;

      dispatch({
        type: SET_USER_SETTINGS,
        data: { email: email, name: name, surname: surname }
      });
    });
  };
};

var saveUserEmailAction = exports.saveUserEmailAction = function saveUserEmailAction() {
  return function (dispatch) {
    var state = _store.store.getState();
    var userDetails = _ramda2.default.path(["form", "userEmailForm", "values"], state);
    if (userDetails.newEmail === userDetails.confirmEmail && (0, _validators.isValidEmail)(userDetails.newEmail)) {
      var email = userDetails.newEmail;
      var name = userDetails.name;
      var surname = userDetails.surname;
      return (0, _userSettings.putUserDetails)({ email: email, name: name, surname: surname }).then(function () {
        dispatch({
          type: UPDATE_USER_EMAIL,
          data: { email: email }
        });
        dispatch((0, _appActions.setFlashMessageAction)("User email updated"));
        dispatch((0, _trackingActions.trackEventAction)("User email updated"));
      }).catch(function (error) {
        var errorObject = error.response;
        if (errorObject.status === 422) {
          return dispatch((0, _appActions.setFlashMessageAction)(errorObject.data.reason, "error"));
        }
        return dispatch((0, _appActions.setFlashGenericErrorAction)());
      });
    }
    return dispatch((0, _appActions.setFlashMessageAction)("Emails are invalid or do not match", "error"));
  };
};

var saveUserNameAction = exports.saveUserNameAction = function saveUserNameAction() {
  return function (dispatch) {
    var state = _store.store.getState();
    var userDetails = _ramda2.default.path(["form", "userNameForm", "values"], state);
    return (0, _userSettings.putUserDetails)(userDetails).then(function () {
      dispatch({
        type: UPDATE_USER_NAME,
        data: { userDetails: userDetails }
      });
      dispatch((0, _appActions.setFlashMessageAction)("Name updated"));
      dispatch((0, _trackingActions.trackEventAction)("User name updated"));
    }).catch(function () {
      dispatch((0, _appActions.setFlashGenericErrorAction)());
    });
  };
};

var saveNewPasswordAction = exports.saveNewPasswordAction = function saveNewPasswordAction() {
  return function (dispatch) {
    var state = _store.store.getState();
    var passwordDetails = _ramda2.default.path(["form", "userPasswordForm", "values"], state);
    if (passwordDetails.newPassword !== passwordDetails.newPasswordRepeated) {
      dispatch((0, _reduxForm.reset)("userPasswordForm"));
      return dispatch((0, _appActions.setFlashMessageAction)("Passwords do not match. Please try again", "error"));
    }
    return (0, _userSettings.postNewPassword)(passwordDetails).then(function () {
      dispatch((0, _appActions.setFlashMessageAction)("Password updated"));
      dispatch((0, _reduxForm.reset)("userPasswordForm"));
      dispatch((0, _trackingActions.trackEventAction)("Password updated"));
    }).catch(function (error) {
      dispatch((0, _reduxForm.reset)("userPasswordForm"));
      var errorObject = error.response;
      if (errorObject.status === 422) {
        return dispatch((0, _appActions.setFlashMessageAction)(errorObject.data.reason, "error"));
      }
      return dispatch((0, _appActions.setFlashGenericErrorAction)());
    });
  };
};

var fetchFavouriteAccountAction = exports.fetchFavouriteAccountAction = function fetchFavouriteAccountAction() {
  return function (dispatch) {
    return (0, _storage.fetchFavouriteAccount)().then(function (response) {
      var accountId = response || null;
      dispatch({
        type: SET_FAVOURITE_ACCOUNT,
        data: { accountId: accountId }
      });
    });
  };
};

var updateFavouriteAccountAction = exports.updateFavouriteAccountAction = function updateFavouriteAccountAction() {
  return function (dispatch) {
    var state = _store.store.getState();
    var selectedAccountId = _ramda2.default.path(["form", "favouriteAccountForm", "values", "favouriteAccount", "key"], state);

    return (0, _storage.putFavouriteAccount)(selectedAccountId).then(function () {
      dispatch({
        type: UPDATE_FAVOURITE_ACCOUNT,
        data: { selectedAccountId: selectedAccountId }
      });
      dispatch((0, _trackingActions.trackEventAction)("Favourite account set"));
      if (selectedAccountId) {
        dispatch((0, _appActions.setFlashMessageAction)("Favourite account saved."));
      } else {
        dispatch((0, _appActions.setFlashMessageAction)("Favourite account removed."));
      }
    });
  };
};

var fetchDefaultInterfaceAction = exports.fetchDefaultInterfaceAction = function fetchDefaultInterfaceAction() {
  return function (dispatch) {
    return (0, _storage.fetchDefaultInterface)().then(function (response) {
      var isBetaDefault = response || false;
      dispatch({
        type: SET_DEFAULT_INTERFACE,
        data: { isBetaDefault: isBetaDefault }
      });
    });
  };
};

var updateDefaultInterfaceAction = exports.updateDefaultInterfaceAction = function updateDefaultInterfaceAction(isBetaDefault) {
  return function (dispatch) {
    dispatch({ type: UPDATE_DEFAULT_INTERFACE_LOADING });
    return (0, _storage.putDefaultInterface)(isBetaDefault).then(function () {
      dispatch({
        type: UPDATE_DEFAULT_INTERFACE,
        data: { isBetaDefault: isBetaDefault }
      });
      if (isBetaDefault) {
        dispatch((0, _appActions.setFlashMessageAction)("Beta UI saved as default."));
        dispatch((0, _trackingActions.trackEventAction)("Beta UI saved as default"));
        dispatch({ type: UPDATE_DEFAULT_INTERFACE_LOADING_STOP });
      } else {
        dispatch((0, _appActions.setFlashMessageAction)("Beta UI remove as default."));
        dispatch((0, _trackingActions.trackEventAction)("Beta UI removed as default"));
        dispatch({ type: UPDATE_DEFAULT_INTERFACE_LOADING_STOP });
      }
    });
  };
};

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.storage = exports.SELECTED_ACCOUNT_ID = exports.SELECTED_ACCOUNT_SLUG = exports.DOCUMENTS_SORTING_ORDER = exports.VISIBLE_DOCUMENTS_COLUMNS = exports.OAUTH_STATE = exports.OAUTH_TOKEN = undefined;

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OAUTH_TOKEN = exports.OAUTH_TOKEN = "local-storage/keys/oauth/token";
var OAUTH_STATE = exports.OAUTH_STATE = "local-storage/keys/oauth/state";
var VISIBLE_DOCUMENTS_COLUMNS = exports.VISIBLE_DOCUMENTS_COLUMNS = "local-storage/keys/documents/visible-documents-columns";
var DOCUMENTS_SORTING_ORDER = exports.DOCUMENTS_SORTING_ORDER = "local-storage/keys/documents/documents-sorting-order";
var SELECTED_ACCOUNT_SLUG = exports.SELECTED_ACCOUNT_SLUG = "local-storage/keys/app/selected-account-slug";
var SELECTED_ACCOUNT_ID = exports.SELECTED_ACCOUNT_ID = "local-storage/keys/app/selected-account-id";

var isLocalStorageSupported = function isLocalStorageSupported() {
  try {
    var testKey = "test";
    var _storage = window.localStorage;
    _storage.setItem(testKey, "true");
    _storage.removeItem(testKey);
    return true;
  } catch (error) {
    return false;
  }
};

var cookie = {
  getItem: function getItem(key) {
    var data = parseCookieData();
    return data[key];
  },
  setItem: function setItem(key, value) {
    var data = parseCookieData();
    data[key] = value;
    var stringData = JSON.stringify(data);
    document.cookie = "localStorage=" + stringData;
  },
  removeItem: function removeItem(key) {
    var data = parseCookieData();
    var newData = _ramda2.default.dissoc(key, data);
    var stringData = JSON.stringify(newData);
    document.cookie = "localStorage=" + stringData;
  },
  isSet: function isSet(key) {
    var data = parseCookieData();
    var value = _ramda2.default.propOr(null, key, data);
    return value !== null;
  }
};

var parseCookieData = function parseCookieData() {
  var cookieName = "localStorage";
  var match = document.cookie.match(new RegExp(cookieName + "=([^;]+)"));
  if (match) {
    return JSON.parse(match[1]);
  }
  return {};
};

var storage = exports.storage = {
  set: function set(key, value) {
    if (isLocalStorageSupported()) {
      return localStorage.setItem(key, value);
    }
    return cookie.setItem(key, value);
  },
  get: function get(key) {
    if (isLocalStorageSupported()) {
      return localStorage.getItem(key);
    }
    return cookie.getItem(key);
  },
  remove: function remove(key) {
    if (isLocalStorageSupported()) {
      return localStorage.removeItem(key);
    }
    return cookie.removeItem(key);
  },
  isSet: function isSet(key) {
    if (isLocalStorageSupported()) {
      var _value = localStorage.getItem(key);
      return _value !== null && _value !== undefined;
    }
    var value = cookie.getItem(key);
    return value !== null && value !== undefined;
  }
};

/***/ }),
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteCustomTabAction = exports.endDeleteCustomTabModeAction = exports.startDeleteCustomTabModeAction = exports.updateCustomTabNameAction = exports.createCustomTabAction = exports.DELETE_CUSTOM_TAB_LOADING_STOP = exports.DELETE_CUSTOM_TAB_LOADING = exports.CREATE_CUSTOM_TAB_LOADING_STOP = exports.CREATE_CUSTOM_TAB_LOADING = exports.CUSTOM_TAB_DELETED = exports.END_DELETE_CUSTOM_TAB_MODE = exports.START_DELETE_CUSTOM_TAB_MODE = exports.UPDATE_CUSTOM_TAB_NAME = exports.CUSTOM_TAB_CREATED = undefined;

var _random = __webpack_require__(442);

var _storage = __webpack_require__(164);

var _appActions = __webpack_require__(25);

var CUSTOM_TAB_CREATED = exports.CUSTOM_TAB_CREATED = "actions/custom-tabs/custom-tab-created";
var UPDATE_CUSTOM_TAB_NAME = exports.UPDATE_CUSTOM_TAB_NAME = "actions/custom-tabs/update-custom-tab-name";
var START_DELETE_CUSTOM_TAB_MODE = exports.START_DELETE_CUSTOM_TAB_MODE = "actions/custom-tabs/start-delete-custom-tab-mode";
var END_DELETE_CUSTOM_TAB_MODE = exports.END_DELETE_CUSTOM_TAB_MODE = "actions/custom-tabs/end-delete-custom-tab-mode";
var CUSTOM_TAB_DELETED = exports.CUSTOM_TAB_DELETED = "actions/custom-tabs/custom-tab-deleted";
var CREATE_CUSTOM_TAB_LOADING = exports.CREATE_CUSTOM_TAB_LOADING = "actions/custom-tabs/create-custom-tab-loading";
var CREATE_CUSTOM_TAB_LOADING_STOP = exports.CREATE_CUSTOM_TAB_LOADING_STOP = "actions/custom-tabs/create-custom-tab-loading-stop";
var DELETE_CUSTOM_TAB_LOADING = exports.DELETE_CUSTOM_TAB_LOADING = "actions/custom-tabs/delete-custom-tab-loading";
var DELETE_CUSTOM_TAB_LOADING_STOP = exports.DELETE_CUSTOM_TAB_LOADING_STOP = "actions/custom-tabs/delete-custom-tab-loading-stop";

var createCustomTabAction = exports.createCustomTabAction = function createCustomTabAction(accountId, tabFilters, tabName) {
  return function (dispatch) {
    dispatch({ type: CREATE_CUSTOM_TAB_LOADING });
    var tabId = accountId + "-" + (0, _random.generateRandomString)();
    var customTab = {
      id: tabId,
      name: tabName,
      filters: tabFilters
    };
    return (0, _storage.putCustomTab)(customTab).then(function () {
      dispatch({
        type: CUSTOM_TAB_CREATED,
        data: { customTab: customTab }
      });
      dispatch((0, _appActions.setFlashMessageAction)("Custom Tab Created"));
      dispatch({ type: CREATE_CUSTOM_TAB_LOADING_STOP });
    });
  };
};

var updateCustomTabNameAction = exports.updateCustomTabNameAction = function updateCustomTabNameAction(name) {
  return {
    type: UPDATE_CUSTOM_TAB_NAME,
    data: { name: name }
  };
};

var startDeleteCustomTabModeAction = exports.startDeleteCustomTabModeAction = function startDeleteCustomTabModeAction(id) {
  return {
    type: START_DELETE_CUSTOM_TAB_MODE,
    data: { id: id }
  };
};

var endDeleteCustomTabModeAction = exports.endDeleteCustomTabModeAction = function endDeleteCustomTabModeAction() {
  return {
    type: END_DELETE_CUSTOM_TAB_MODE
  };
};

var deleteCustomTabAction = exports.deleteCustomTabAction = function deleteCustomTabAction(id) {
  return function (dispatch) {
    dispatch({ type: DELETE_CUSTOM_TAB_LOADING });
    return (0, _storage.removeCustomTab)(id).then(function (response) {
      dispatch({
        type: CUSTOM_TAB_DELETED,
        data: { customTabs: response }
      });
      dispatch({ type: DELETE_CUSTOM_TAB_LOADING_STOP });
      dispatch((0, _appActions.setFlashMessageAction)("Custom Tab Deleted", "error"));
    });
  };
};

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shiftReleasedAction = exports.shiftPressedAction = exports.endExportModeAction = exports.startExportModeAction = exports.clearRefreshIntervalsAction = exports.startRefreshIntervalsAction = exports.setGridWidthAction = exports.returnToDefaultColumnsAction = exports.hideGLCodesPanelAction = exports.showGLCodesPanelAction = exports.mapVendorRulesAction = exports.generateShareUrlAction = exports.selectAllDocumentsAction = exports.setDocumentViewerVisibilityAction = exports.deselectAllDocumentsAction = exports.selectMergeFieldAction = exports.deselectMergeDocumentAction = exports.selectMergeDocumentAction = exports.setDeletePermanentlyVisibilityAction = exports.deletePermanentlyAction = undefined;
exports.restoreDocumentsAction = exports.endFiltersDrawerModeAction = exports.startFiltersDrawerModeAction = exports.endDraggabilityAction = exports.startDraggabilityAction = exports.endDocViewerHamburgerModeAction = exports.startDocViewerHamburgerModeAction = exports.endHamburgerModeAction = exports.startHamburgerModeAction = exports.endMergeDocumentsModeAction = exports.startMergeDocumentsModeAction = exports.trashMultipleDocumentsAction = exports.setTrashMultipleDocumentsVisibilityAction = exports.findDefaultMergeDocument = exports.mergeDocumentsAction = exports.documentViewedAction = exports.setShareUrlVisibilityAction = exports.setChangeDocumentTypeVisibilityAction = exports.setTrashDocumentVisibilityAction = exports.submitBatchDownloadDocumentsAction = exports.endBatchDownloadModeAction = exports.startBatchDownloadModeAction = exports.endBatchCategoriesModeAction = exports.startBatchCategoriesModeAction = exports.submitBatchAssignCategoriesAction = exports.submitBatchEditAction = exports.endBatchEditModeAction = exports.startBatchEditModeAction = exports.deselectDocumentsAction = exports.selectDocumentsAction = exports.setEditColumnsVisibilityAction = exports.previousPageAction = exports.nextPageAction = exports.reloadDocuments = exports.toggleColumnAction = exports.setPaginationLimitAction = exports.fetchDocumentsAction = exports.SHIFT_RELEASED = exports.SHIFT_PRESSED = exports.END_EXPORT_MODE = exports.START_EXPORT_MODE = exports.CLEAR_REFRESH_INTERVALS = exports.SET_REFRESH_INTERVALS = exports.REFRESH_DOCUMENTS = exports.SET_GRID_WIDTH = exports.DEFAULT_COLUMNS = exports.HIDE_GL_CODES_PANEL = exports.SHOW_GL_CODES_PANEL = exports.SHARE_URL_GENERATED = exports.SET_DOCUMENT_VIEWER_VISIBILITY = exports.SELECT_MERGE_FIELD = exports.DESELECT_MERGE_DOCUMENT = exports.SELECT_MERGE_DOCUMENT = exports.SELECT_ALL_DOCUMENTS = exports.DESELECT_ALL_DOCUMENTS = exports.SET_DELETE_PERMANENTLY_VISIBILITY = exports.DELETE_DOCUMENTS_PERMANENTLY_LOADING_STOP = exports.DELETE_DOCUMENTS_PERMANENTLY_LOADING = exports.RESTORE_DOCUMENTS_LOADING_STOP = exports.RESTORE_DOCUMENTS_LOADING = exports.END_FILTERS_DRAWER_MODE = exports.START_FILTERS_DRAWER_MODE = exports.END_DOC_VIEWER_HAMBURGER_MODE = exports.START_DOC_VIEWER_HAMBURGER_MODE = exports.END_HAMBURGER_MODE = exports.START_HAMBURGER_MODE = exports.END_DRAGGABILITY = exports.START_DRAGGABILITY = exports.TRASH_MULTIPLE_DOCUMENTS_LOADING_STOP = exports.TRASH_MULTIPLE_DOCUMENTS_LOADING = exports.SET_TRASH_MULTIPLE_DOCUMENTS_VISIBILITY = exports.END_MERGE_DOCUMENTS_MODE = exports.START_MERGE_DOCUMENTS_MODE = exports.MERGE_DOCUMENTS_LOADING_STOP = exports.MERGE_DOCUMENTS_LOADING = exports.DOCUMENT_VIEWED = exports.SET_SHARE_URL_VISIBILITY = exports.SET_CHANGE_DOCUMENT_TYPE_VISIBILITY = exports.SET_TRASH_DOCUMENT_VISIBILITY = exports.END_BATCH_DOWNLOAD_MODE = exports.START_BATCH_DOWNLOAD_LOADING = exports.START_BATCH_DOWNLOAD_MODE = exports.BATCH_ASSIGN_CATEGORIES_LOADING_STOP = exports.BATCH_ASSIGN_CATEGORIES_LOADING = exports.BATCH_EDIT_LOADING_STOP = exports.BATCH_EDIT_LOADING = exports.SET_DOCUMENT_RULES = exports.END_BATCH_CATEGORIES_MODE = exports.START_BATCH_CATEGORIES_MODE = exports.END_BATCH_EDIT_MODE = exports.START_BATCH_EDIT_MODE = exports.DESELECT_DOCUMENTS = exports.SELECT_DOCUMENTS = exports.SET_EDIT_COLUMNS_VISIBILITY = exports.TOGGLE_COLUMN = exports.PREVIOUS_PAGE = exports.NEXT_PAGE = exports.SET_PAGINATION_LIMIT = exports.LOADING_START = exports.SET_DOCUMENTS = undefined;

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _store = __webpack_require__(48);

var _documents = __webpack_require__(114);

var _sharedActionGenerators = __webpack_require__(411);

var _trackingActions = __webpack_require__(26);

var _appActions = __webpack_require__(25);

var _localStorage = __webpack_require__(138);

var _filterCounter = __webpack_require__(440);

var _keyPress = __webpack_require__(198);

var _columnObjects = __webpack_require__(270);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET_DOCUMENTS = exports.SET_DOCUMENTS = "actions/documents/set-documents";
var LOADING_START = exports.LOADING_START = "actions/documents/loading-start";
var SET_PAGINATION_LIMIT = exports.SET_PAGINATION_LIMIT = "actions/documents/pagination-limit";
var NEXT_PAGE = exports.NEXT_PAGE = "actions/documents/next-page";
var PREVIOUS_PAGE = exports.PREVIOUS_PAGE = "actions/documents/previous-page";
var TOGGLE_COLUMN = exports.TOGGLE_COLUMN = "actions/documents/toggle-column";
var SET_EDIT_COLUMNS_VISIBILITY = exports.SET_EDIT_COLUMNS_VISIBILITY = "actions/documents/set-edit-columns-visibility";
var SELECT_DOCUMENTS = exports.SELECT_DOCUMENTS = "actions/documents/select-documents";
var DESELECT_DOCUMENTS = exports.DESELECT_DOCUMENTS = "actions/documents/deselect-documents";
var START_BATCH_EDIT_MODE = exports.START_BATCH_EDIT_MODE = "actions/documents/start-batch-edit-mode";
var END_BATCH_EDIT_MODE = exports.END_BATCH_EDIT_MODE = "actions/documents/end-batch-edit-mode";
var START_BATCH_CATEGORIES_MODE = exports.START_BATCH_CATEGORIES_MODE = "actions/documents/start-batch-categories-mode";
var END_BATCH_CATEGORIES_MODE = exports.END_BATCH_CATEGORIES_MODE = "action/documents/end-batch-categories-mode";
var SET_DOCUMENT_RULES = exports.SET_DOCUMENT_RULES = "actions/documents/set-document-rules";

var BATCH_EDIT_LOADING = exports.BATCH_EDIT_LOADING = "actions/documents/batch-edit-loading";
var BATCH_EDIT_LOADING_STOP = exports.BATCH_EDIT_LOADING_STOP = "actions/documents/batch-edit-loading-stop";

var BATCH_ASSIGN_CATEGORIES_LOADING = exports.BATCH_ASSIGN_CATEGORIES_LOADING = "actions/documents/start-batch-assign-categories-loading";
var BATCH_ASSIGN_CATEGORIES_LOADING_STOP = exports.BATCH_ASSIGN_CATEGORIES_LOADING_STOP = "actions/documents/batch-assign-categories-loading-stop";

var START_BATCH_DOWNLOAD_MODE = exports.START_BATCH_DOWNLOAD_MODE = "actions/documents/start-batch-download-mode";
var START_BATCH_DOWNLOAD_LOADING = exports.START_BATCH_DOWNLOAD_LOADING = "actions/documents/start-batch-download-loading";
var END_BATCH_DOWNLOAD_MODE = exports.END_BATCH_DOWNLOAD_MODE = "actions/documents/end-batch-download-mode";
var SET_TRASH_DOCUMENT_VISIBILITY = exports.SET_TRASH_DOCUMENT_VISIBILITY = "actions/documents/set-trash-document-visibility";
var SET_CHANGE_DOCUMENT_TYPE_VISIBILITY = exports.SET_CHANGE_DOCUMENT_TYPE_VISIBILITY = "actions/documents/set-change-document-type-visibility";
var SET_SHARE_URL_VISIBILITY = exports.SET_SHARE_URL_VISIBILITY = "actions/documents/set-share-url-visibility";
var DOCUMENT_VIEWED = exports.DOCUMENT_VIEWED = "actions/documents/document-viewed";

var MERGE_DOCUMENTS_LOADING = exports.MERGE_DOCUMENTS_LOADING = "actions/documents/merge-documents-loading";
var MERGE_DOCUMENTS_LOADING_STOP = exports.MERGE_DOCUMENTS_LOADING_STOP = "actions/documents/merge-documents-loading-stop";
var START_MERGE_DOCUMENTS_MODE = exports.START_MERGE_DOCUMENTS_MODE = "actions/documents/start-merge-documents-mode";
var END_MERGE_DOCUMENTS_MODE = exports.END_MERGE_DOCUMENTS_MODE = "actions/documents/end-merge-documents-mode";

var SET_TRASH_MULTIPLE_DOCUMENTS_VISIBILITY = exports.SET_TRASH_MULTIPLE_DOCUMENTS_VISIBILITY = "actions/documents/set-trash-multiple-documents-visibility";
var TRASH_MULTIPLE_DOCUMENTS_LOADING = exports.TRASH_MULTIPLE_DOCUMENTS_LOADING = "actions/documents/trash-multiple-documents-loading";
var TRASH_MULTIPLE_DOCUMENTS_LOADING_STOP = exports.TRASH_MULTIPLE_DOCUMENTS_LOADING_STOP = "actions/documents/trash-multiple-documents-loading-stop";
var START_DRAGGABILITY = exports.START_DRAGGABILITY = "actions/documents/start-draggability";
var END_DRAGGABILITY = exports.END_DRAGGABILITY = "actions/documents/end-draggability";

var START_HAMBURGER_MODE = exports.START_HAMBURGER_MODE = "actions/documents/start-hamburger-mode";
var END_HAMBURGER_MODE = exports.END_HAMBURGER_MODE = "actions/documents/end-hamburger-mode";
var START_DOC_VIEWER_HAMBURGER_MODE = exports.START_DOC_VIEWER_HAMBURGER_MODE = "actions/documents/start-doc-viewer-hamburger-mode";
var END_DOC_VIEWER_HAMBURGER_MODE = exports.END_DOC_VIEWER_HAMBURGER_MODE = "actions/documents/end-doc-viewer-hamburger-mode";
var START_FILTERS_DRAWER_MODE = exports.START_FILTERS_DRAWER_MODE = "actions/documents/start-filters-drawer-mode";
var END_FILTERS_DRAWER_MODE = exports.END_FILTERS_DRAWER_MODE = "actions/documents/end-filters-drawer-mode";
var RESTORE_DOCUMENTS_LOADING = exports.RESTORE_DOCUMENTS_LOADING = "actions/documents/restore-documents-loading";
var RESTORE_DOCUMENTS_LOADING_STOP = exports.RESTORE_DOCUMENTS_LOADING_STOP = "actions/documents/restore-documents-loading-stop";
var DELETE_DOCUMENTS_PERMANENTLY_LOADING = exports.DELETE_DOCUMENTS_PERMANENTLY_LOADING = "actions/documents/delete-documents-permanently-loading";
var DELETE_DOCUMENTS_PERMANENTLY_LOADING_STOP = exports.DELETE_DOCUMENTS_PERMANENTLY_LOADING_STOP = "actions/documents/delete-documents-permanently-loading-stop";
var SET_DELETE_PERMANENTLY_VISIBILITY = exports.SET_DELETE_PERMANENTLY_VISIBILITY = "actions/documents/set-delete-permanently-visibility";
var DESELECT_ALL_DOCUMENTS = exports.DESELECT_ALL_DOCUMENTS = "actions/documents/deselect-all-documents";
var SELECT_ALL_DOCUMENTS = exports.SELECT_ALL_DOCUMENTS = "actions/documents/select-all-documents";
var SELECT_MERGE_DOCUMENT = exports.SELECT_MERGE_DOCUMENT = "actions/documents/select-merge-document";
var DESELECT_MERGE_DOCUMENT = exports.DESELECT_MERGE_DOCUMENT = "actions/documents/deselect-merge-document";
var SELECT_MERGE_FIELD = exports.SELECT_MERGE_FIELD = "actions/documents/select-merge-field";
var SET_DOCUMENT_VIEWER_VISIBILITY = exports.SET_DOCUMENT_VIEWER_VISIBILITY = "actions/documents/set-document-viewer-visibility";
var SHARE_URL_GENERATED = exports.SHARE_URL_GENERATED = "actions/documents/share-url-generated";
var SHOW_GL_CODES_PANEL = exports.SHOW_GL_CODES_PANEL = "actions/documents/show-gl-codes-panel";
var HIDE_GL_CODES_PANEL = exports.HIDE_GL_CODES_PANEL = "actions/documents/hide-gl-codes-panel";
var DEFAULT_COLUMNS = exports.DEFAULT_COLUMNS = "actions/documents/default-columns";
var SET_GRID_WIDTH = exports.SET_GRID_WIDTH = "actions/documents/set-grid-width";
var REFRESH_DOCUMENTS = exports.REFRESH_DOCUMENTS = "actions/documents/refresh-documents";
var SET_REFRESH_INTERVALS = exports.SET_REFRESH_INTERVALS = "actions/documents/set-refresh-intervals";
var CLEAR_REFRESH_INTERVALS = exports.CLEAR_REFRESH_INTERVALS = "actions/documents/clear-refresh-intervals";
var START_EXPORT_MODE = exports.START_EXPORT_MODE = "actions/documents/start-export-mode";
var END_EXPORT_MODE = exports.END_EXPORT_MODE = "actions/documents/end-export-mode";
var SHIFT_PRESSED = exports.SHIFT_PRESSED = "actions/documents/shift-pressed";
var SHIFT_RELEASED = exports.SHIFT_RELEASED = "actions/documents/shift-released";

var fetchDocumentsAction = exports.fetchDocumentsAction = function fetchDocumentsAction(accountId, filters, pagination) {
  var showLoading = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var resetPageNumber = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  return function (dispatch) {
    var updatedPagination = resetPageNumber ? _ramda2.default.set(_ramda2.default.lensProp("pageNumber"), 1, pagination) : pagination;
    if (showLoading) {
      dispatch({ type: LOADING_START });
    }
    (0, _documents.fetchDocuments)(accountId, filters, updatedPagination).then(function (_ref) {
      var documents = _ref.documents,
          totalCount = _ref.totalCount,
          totalCountFiltered = _ref.totalCountFiltered,
          totalSumFiltered = _ref.totalSumFiltered;

      var filtersCount = (0, _filterCounter.filterCounter)(filters);
      dispatch({
        type: SET_DOCUMENTS,
        data: {
          documents: documents,
          filtersCount: filtersCount,
          totalCount: totalCount,
          totalCountFiltered: totalCountFiltered,
          resetPageNumber: resetPageNumber,
          totalSumFiltered: totalSumFiltered
        }
      });
      /* This is a temporary solution to solve an issue where the width of the data grid (react-data-grid) is
         incorrect when a small number of rows are on display */
      window.dispatchEvent(new Event("resize"));
    });
  };
};

var setPaginationLimitAction = exports.setPaginationLimitAction = function setPaginationLimitAction(limit) {
  return (0, _sharedActionGenerators.filterActionGenerator)(SET_PAGINATION_LIMIT, reloadDocuments, limit);
};

var toggleColumnAction = exports.toggleColumnAction = function toggleColumnAction(key) {
  return function (dispatch) {
    dispatch({
      type: TOGGLE_COLUMN,
      data: {
        key: key
      }
    });
    var columns = _ramda2.default.path(["documents", "columns"], _store.store.getState());
    var visibleColumns = columns.filter(function (col) {
      return col.visible === true;
    });
    var keys = visibleColumns.map(function (col) {
      return col.key;
    });
    _localStorage.storage.set(_localStorage.VISIBLE_DOCUMENTS_COLUMNS, JSON.stringify(keys));
    window.dispatchEvent(new Event("resize"));
  };
};

var reloadDocuments = exports.reloadDocuments = function reloadDocuments(dispatch) {
  var resetPageNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  setTimeout(function () {
    var state = _store.store.getState();
    var filters = state.documentFilters;
    var account = state.app.selectedAccount;
    var pagination = state.documents.pagination;
    dispatch(fetchDocumentsAction(account.id, filters, pagination, false, resetPageNumber));
  }, 0);
};

var nextPageAction = exports.nextPageAction = function nextPageAction() {
  return (0, _sharedActionGenerators.paginationActionGenerator)(NEXT_PAGE, reloadDocuments);
};

var previousPageAction = exports.previousPageAction = function previousPageAction() {
  return (0, _sharedActionGenerators.paginationActionGenerator)(PREVIOUS_PAGE, reloadDocuments);
};

var setEditColumnsVisibilityAction = exports.setEditColumnsVisibilityAction = function setEditColumnsVisibilityAction(visible) {
  return {
    type: SET_EDIT_COLUMNS_VISIBILITY,
    data: { visible: visible }
  };
};

var selectDocumentsAction = exports.selectDocumentsAction = function selectDocumentsAction(documentIds) {
  return {
    type: SELECT_DOCUMENTS,
    data: { documentIds: documentIds }
  };
};

var deselectDocumentsAction = exports.deselectDocumentsAction = function deselectDocumentsAction(documentIds) {
  return {
    type: DESELECT_DOCUMENTS,
    data: { documentIds: documentIds }
  };
};

var startBatchEditModeAction = exports.startBatchEditModeAction = function startBatchEditModeAction() {
  return {
    type: START_BATCH_EDIT_MODE
  };
};

var endBatchEditModeAction = exports.endBatchEditModeAction = function endBatchEditModeAction() {
  return {
    type: END_BATCH_EDIT_MODE
  };
};

var submitBatchEditAction = exports.submitBatchEditAction = function submitBatchEditAction() {
  return (0, _sharedActionGenerators.submitBatchEditActionGenerator)(BATCH_EDIT_LOADING, BATCH_EDIT_LOADING_STOP, reloadDocuments, "documentsBatchEdit", "documents");
};

var submitBatchAssignCategoriesAction = exports.submitBatchAssignCategoriesAction = function submitBatchAssignCategoriesAction() {
  return function (dispatch) {
    dispatch({
      type: BATCH_ASSIGN_CATEGORIES_LOADING
    });

    var state = _store.store.getState();
    var account = state.app.selectedAccount;
    var selectedCategories = _ramda2.default.pathOr([], ["form", "batchCategoriesForm", "values", "selectedCategories"], state);
    var documentIds = _ramda2.default.path(["documents", "selectedDocumentIds"], state);
    var documents = _ramda2.default.path(["documents", "documents"], state);
    var selectedDocuments = documentIds.map(function (id) {
      return documents.find(function (document) {
        return document.id === id;
      });
    });
    return (0, _documents.batchAssignCategories)(account.id, selectedDocuments, selectedCategories).then(function () {
      return reloadDocuments(dispatch, false);
    }).then(function () {
      dispatch({ type: BATCH_ASSIGN_CATEGORIES_LOADING_STOP });
      dispatch((0, _trackingActions.trackEventAction)("Batch assign categories"));
    }).catch(function () {
      return dispatch({ type: BATCH_ASSIGN_CATEGORIES_LOADING_STOP });
    });
  };
};

var startBatchCategoriesModeAction = exports.startBatchCategoriesModeAction = function startBatchCategoriesModeAction() {
  return {
    type: START_BATCH_CATEGORIES_MODE
  };
};

var endBatchCategoriesModeAction = exports.endBatchCategoriesModeAction = function endBatchCategoriesModeAction() {
  return {
    type: END_BATCH_CATEGORIES_MODE
  };
};

var startBatchDownloadModeAction = exports.startBatchDownloadModeAction = function startBatchDownloadModeAction() {
  return {
    type: START_BATCH_DOWNLOAD_MODE
  };
};

var endBatchDownloadModeAction = exports.endBatchDownloadModeAction = function endBatchDownloadModeAction() {
  return {
    type: END_BATCH_DOWNLOAD_MODE
  };
};

var submitBatchDownloadDocumentsAction = exports.submitBatchDownloadDocumentsAction = function submitBatchDownloadDocumentsAction() {
  return function (dispatch) {
    var state = _store.store.getState();
    var account = state.app.selectedAccount;
    var formData = _ramda2.default.path(["form", "batchDownloadDocumentsForm", "values"], state);
    var documentIds = _ramda2.default.path(["documents", "selectedDocumentIds"], state);
    var emails = formData.emails;
    var exportType = formData.exportType;
    var data = { account: account, formData: formData, documentIds: documentIds, emails: emails, exportType: exportType };
    return (0, _sharedActionGenerators.batchDownloadsSharedAction)(dispatch, data, startBatchDownloadModeAction, endBatchDownloadModeAction).then(function () {
      dispatch(endHamburgerModeAction());
      dispatch((0, _trackingActions.trackEventAction)("Batch download documents"));
    });
  };
};

var setTrashDocumentVisibilityAction = exports.setTrashDocumentVisibilityAction = function setTrashDocumentVisibilityAction(visible) {
  return {
    type: SET_TRASH_DOCUMENT_VISIBILITY,
    data: { visible: visible }
  };
};

var setChangeDocumentTypeVisibilityAction = exports.setChangeDocumentTypeVisibilityAction = function setChangeDocumentTypeVisibilityAction(visible) {
  return {
    type: SET_CHANGE_DOCUMENT_TYPE_VISIBILITY,
    data: { visible: visible }
  };
};

var setShareUrlVisibilityAction = exports.setShareUrlVisibilityAction = function setShareUrlVisibilityAction(visible) {
  return {
    type: SET_SHARE_URL_VISIBILITY,
    data: { visible: visible }
  };
};

var documentViewedAction = exports.documentViewedAction = function documentViewedAction(data) {
  return (0, _sharedActionGenerators.documentViewedActionGenerator)(DOCUMENT_VIEWED, data);
};

var mergeDocumentsAction = exports.mergeDocumentsAction = function mergeDocumentsAction() {
  return function (dispatch) {
    dispatch({
      type: MERGE_DOCUMENTS_LOADING
    });
    var state = _store.store.getState();
    var account = state.app.selectedAccount;
    var documentIds = _ramda2.default.path(["documents", "selectedDocumentIds"], state);
    var documents = _ramda2.default.path(["documents", "documents"], state);
    var selectedDocuments = documentIds.map(function (id) {
      return documents.find(function (document) {
        return document.id === id;
      });
    });
    var formData = new FormData();
    var newDocument = findDefaultMergeDocument("documents", selectedDocuments, state);
    newDocument.notes = newDocument.notes + " \n Merged from documents:";
    var ajaxPromises = selectedDocuments.map(function (doc) {
      return (0, _documents.putDocument)(account.id, doc.id, _ramda2.default.assoc("trashed", true, doc));
    });
    selectedDocuments.forEach(function (document) {
      var date = (0, _moment2.default)(document.issued).format("DD/MM/YY");
      formData.append("attachment", document.attachment.url);
      newDocument.notes = newDocument.notes + " \n - Vendor: " + document.vendor + ", Date: " + date;
    });
    formData.append("document", JSON.stringify(newDocument));
    return (0, _documents.mergeDocuments)(account.id, formData).then(function () {
      return Promise.all(ajaxPromises).then(reloadDocuments(dispatch, false)).then(function () {
        dispatch({ type: MERGE_DOCUMENTS_LOADING_STOP });
        dispatch(endMergeDocumentsModeAction());
        dispatch(endHamburgerModeAction());
        dispatch((0, _trackingActions.trackEventAction)("Merge documents"));
      }).catch(function () {
        return dispatch({ type: MERGE_DOCUMENTS_LOADING_STOP });
      });
    }).catch(function () {
      return dispatch({ type: MERGE_DOCUMENTS_LOADING_STOP });
    });
  };
};

var findDefaultMergeDocument = exports.findDefaultMergeDocument = function findDefaultMergeDocument(documentType, documents, state) {
  var mergeDocument = _ramda2.default.path([documentType, "mergeDocument"], state);
  var mergeDocumentId = _ramda2.default.path([documentType, "selectedMergeDocumentId"], state);
  var defaultMergeDocument = documents[0];
  if (mergeDocumentId !== "") {
    defaultMergeDocument = documents.find(function (document) {
      return document.id === mergeDocumentId;
    });
  }
  if (mergeDocument !== null) {
    defaultMergeDocument = _ramda2.default.merge(defaultMergeDocument, _ramda2.default.map(function (x) {
      return x.data;
    }, mergeDocument));
  }
  return defaultMergeDocument;
};

var setTrashMultipleDocumentsVisibilityAction = exports.setTrashMultipleDocumentsVisibilityAction = function setTrashMultipleDocumentsVisibilityAction(visible) {
  return {
    type: SET_TRASH_MULTIPLE_DOCUMENTS_VISIBILITY,
    data: { visible: visible }
  };
};

var trashMultipleDocumentsAction = exports.trashMultipleDocumentsAction = function trashMultipleDocumentsAction() {
  return function (dispatch) {
    dispatch({ type: TRASH_MULTIPLE_DOCUMENTS_LOADING });

    var state = _store.store.getState();
    var account = state.app.selectedAccount;
    var documentIds = _ramda2.default.path(["documents", "selectedDocumentIds"], state);
    var documents = _ramda2.default.path(["documents", "documents"], state);
    var selectedDocuments = documentIds.map(function (id) {
      return documents.find(function (document) {
        return document.id === id;
      });
    });
    return (0, _documents.trashStatusMultipleDocuments)(account.id, selectedDocuments, true).then(function () {
      return reloadDocuments(dispatch, false);
    }).then(function () {
      dispatch({ type: TRASH_MULTIPLE_DOCUMENTS_LOADING_STOP });
      dispatch((0, _trackingActions.trackEventAction)("Trash multiple documents"));
    }).catch(function () {
      return dispatch({ type: TRASH_MULTIPLE_DOCUMENTS_LOADING_STOP });
    });
  };
};

var startMergeDocumentsModeAction = exports.startMergeDocumentsModeAction = function startMergeDocumentsModeAction(documents, mergeDocumentId) {
  var mergeDocument = documents.find(function (document) {
    return document.id === mergeDocumentId;
  });
  return {
    type: START_MERGE_DOCUMENTS_MODE,
    data: { mergeDocument: mergeDocument }
  };
};

var endMergeDocumentsModeAction = exports.endMergeDocumentsModeAction = function endMergeDocumentsModeAction() {
  return {
    type: END_MERGE_DOCUMENTS_MODE
  };
};

var startHamburgerModeAction = exports.startHamburgerModeAction = function startHamburgerModeAction() {
  return {
    type: START_HAMBURGER_MODE
  };
};

var endHamburgerModeAction = exports.endHamburgerModeAction = function endHamburgerModeAction() {
  return {
    type: END_HAMBURGER_MODE
  };
};

var startDocViewerHamburgerModeAction = exports.startDocViewerHamburgerModeAction = function startDocViewerHamburgerModeAction() {
  return {
    type: START_DOC_VIEWER_HAMBURGER_MODE
  };
};

var endDocViewerHamburgerModeAction = exports.endDocViewerHamburgerModeAction = function endDocViewerHamburgerModeAction() {
  return {
    type: END_DOC_VIEWER_HAMBURGER_MODE
  };
};

var startDraggabilityAction = exports.startDraggabilityAction = function startDraggabilityAction() {
  setTimeout(function () {
    window.dispatchEvent(new Event("resize"));
  }, 0);
  return { type: START_DRAGGABILITY };
};

var endDraggabilityAction = exports.endDraggabilityAction = function endDraggabilityAction() {
  setTimeout(function () {
    window.dispatchEvent(new Event("resize"));
  }, 0);
  return { type: END_DRAGGABILITY };
};

var startFiltersDrawerModeAction = exports.startFiltersDrawerModeAction = function startFiltersDrawerModeAction() {
  return {
    type: START_FILTERS_DRAWER_MODE
  };
};

var endFiltersDrawerModeAction = exports.endFiltersDrawerModeAction = function endFiltersDrawerModeAction() {
  return {
    type: END_FILTERS_DRAWER_MODE
  };
};

var restoreDocumentsAction = exports.restoreDocumentsAction = function restoreDocumentsAction() {
  return function (dispatch) {
    dispatch({ type: RESTORE_DOCUMENTS_LOADING });
    var state = _store.store.getState();
    var account = state.app.selectedAccount;
    var documentIds = _ramda2.default.path(["documents", "selectedDocumentIds"], state);
    var documents = _ramda2.default.path(["documents", "documents"], state);
    var selectedDocuments = documentIds.map(function (id) {
      return documents.find(function (document) {
        return document.id === id;
      });
    });
    return (0, _documents.trashStatusMultipleDocuments)(account.id, selectedDocuments, false).then(function () {
      return reloadDocuments(dispatch, false);
    }).then(function () {
      dispatch({ type: RESTORE_DOCUMENTS_LOADING_STOP });
      dispatch((0, _appActions.setFlashMessageAction)("Documents restored"));
      dispatch((0, _trackingActions.trackEventAction)("Restore documents from trash"));
    }).catch(function () {
      return dispatch({ type: RESTORE_DOCUMENTS_LOADING_STOP });
    });
  };
};

var deletePermanentlyAction = exports.deletePermanentlyAction = function deletePermanentlyAction() {
  return function (dispatch) {
    dispatch({ type: DELETE_DOCUMENTS_PERMANENTLY_LOADING });
    var state = _store.store.getState();
    var account = state.app.selectedAccount;
    var documentIds = _ramda2.default.path(["documents", "selectedDocumentIds"], state);
    var documents = _ramda2.default.path(["documents", "documents"], state);
    var selectedDocuments = documentIds.map(function (id) {
      return documents.find(function (document) {
        return document.id === id;
      });
    });
    return (0, _documents.deleteDocumentsPermanently)(account.id, selectedDocuments).then(function () {
      return reloadDocuments(dispatch, false);
    }).then(function () {
      dispatch({ type: DELETE_DOCUMENTS_PERMANENTLY_LOADING_STOP });
      dispatch(setDeletePermanentlyVisibilityAction(false));
      dispatch((0, _appActions.setFlashMessageAction)("Documents deleted"));
      dispatch((0, _trackingActions.trackEventAction)("Delete documents permanently"));
    }).catch(function () {
      return dispatch({ type: DELETE_DOCUMENTS_PERMANENTLY_LOADING_STOP });
    });
  };
};

var setDeletePermanentlyVisibilityAction = exports.setDeletePermanentlyVisibilityAction = function setDeletePermanentlyVisibilityAction(visible) {
  return {
    type: SET_DELETE_PERMANENTLY_VISIBILITY,
    data: { visible: visible }
  };
};

var selectMergeDocumentAction = exports.selectMergeDocumentAction = function selectMergeDocumentAction(id, row) {
  return {
    type: SELECT_MERGE_DOCUMENT,
    data: { id: id, row: row }
  };
};

var deselectMergeDocumentAction = exports.deselectMergeDocumentAction = function deselectMergeDocumentAction() {
  return {
    type: DESELECT_MERGE_DOCUMENT
  };
};

var selectMergeFieldAction = exports.selectMergeFieldAction = function selectMergeFieldAction(field, data, id) {
  return {
    type: SELECT_MERGE_FIELD,
    data: { field: field, data: data, id: id }
  };
};

var deselectAllDocumentsAction = exports.deselectAllDocumentsAction = function deselectAllDocumentsAction() {
  return {
    type: DESELECT_ALL_DOCUMENTS
  };
};

var setDocumentViewerVisibilityAction = exports.setDocumentViewerVisibilityAction = function setDocumentViewerVisibilityAction(visible) {
  setTimeout(function () {
    window.dispatchEvent(new Event("resize"));
  }, 0);
  return {
    type: SET_DOCUMENT_VIEWER_VISIBILITY,
    data: { visible: visible }
  };
};

var selectAllDocumentsAction = exports.selectAllDocumentsAction = function selectAllDocumentsAction(accountId, filters) {
  return function (dispatch) {
    return (0, _documents.selectAllDocuments)(accountId, filters).then(function (_ref2) {
      var documentIds = _ref2.documentIds,
          documents = _ref2.documents;

      dispatch({
        type: SELECT_ALL_DOCUMENTS,
        data: { documentIds: documentIds, documents: documents }
      });
      dispatch((0, _trackingActions.trackEventAction)("selectAllDocuments"));
    });
  };
};

var generateShareUrlAction = exports.generateShareUrlAction = function generateShareUrlAction(accountId, documentId) {
  return function (dispatch) {
    return (0, _documents.getShareUrl)(accountId, documentId).then(function (_ref3) {
      var shareUrl = _ref3.shareUrl;

      dispatch({
        type: SHARE_URL_GENERATED,
        data: { shareUrl: shareUrl }
      });
    });
  };
};

var mapVendorRulesAction = exports.mapVendorRulesAction = function mapVendorRulesAction(accountId, documents) {
  return function (dispatch) {
    return (0, _documents.fetchVendorRules)(accountId, documents).then(function (_ref4) {
      var rules = _ref4.rules;

      var newDocuments = documents.map(function (document, index) {
        var newDocument = _ramda2.default.assoc("rules", rules[index] || [], document);
        if (document.categories === undefined) {
          newDocument.categories = [];
          return newDocument;
        }
        return newDocument;
      });
      dispatch({
        type: SET_DOCUMENT_RULES,
        data: { newDocuments: newDocuments }
      });
    });
  };
};

var showGLCodesPanelAction = exports.showGLCodesPanelAction = function showGLCodesPanelAction() {
  return {
    type: SHOW_GL_CODES_PANEL
  };
};

var hideGLCodesPanelAction = exports.hideGLCodesPanelAction = function hideGLCodesPanelAction() {
  return {
    type: HIDE_GL_CODES_PANEL
  };
};

var returnToDefaultColumnsAction = exports.returnToDefaultColumnsAction = function returnToDefaultColumnsAction() {
  return function (dispatch) {
    dispatch({ type: DEFAULT_COLUMNS });
    var columns = _columnObjects.columnObjects.filter(function (col) {
      return col.visible === true;
    });
    var keys = columns.map(function (col) {
      return col.key;
    });
    window.dispatchEvent(new Event("resize"));
    return _localStorage.storage.set(_localStorage.VISIBLE_DOCUMENTS_COLUMNS, JSON.stringify(keys));
  };
};

var setGridWidthAction = exports.setGridWidthAction = function setGridWidthAction(width) {
  return {
    type: SET_GRID_WIDTH,
    data: { width: width }
  };
};

var startRefreshIntervalsAction = exports.startRefreshIntervalsAction = function startRefreshIntervalsAction() {
  return function (dispatch) {
    var refreshInterval = setInterval(function () {
      var state = _store.store.getState();
      var filters = state.documentFilters;
      var account = state.app.selectedAccount;
      var pagination = state.documents.pagination;
      return fetchDocumentsForRefresh(account.id, filters, pagination, dispatch);
    }, 37000);
    var exportRefreshInterval = setInterval(function () {
      var state = _store.store.getState();
      var documents = state.documents.documents;
      var isExporting = documents.some(function (document) {
        return document.categories ? document.categories.indexOf("Queued for Export") > -1 : false;
      });
      if (isExporting) {
        var filters = state.documentFilters;
        var account = state.app.selectedAccount;
        var pagination = state.documents.pagination;
        return fetchDocumentsForRefresh(account.id, filters, pagination, dispatch);
      }
      return clearInterval(exportRefreshInterval);
    }, 7000);

    return dispatch({
      type: SET_REFRESH_INTERVALS,
      data: { intervalIds: [refreshInterval, exportRefreshInterval] }
    });
  };
};

var fetchDocumentsForRefresh = function fetchDocumentsForRefresh(accountId, filters, pagination, dispatch) {
  return (0, _documents.fetchDocuments)(accountId, filters, pagination).then(function (_ref5) {
    var documents = _ref5.documents;

    dispatch({
      type: REFRESH_DOCUMENTS,
      data: { documents: documents }
    });
  });
};

var clearRefreshIntervalsAction = exports.clearRefreshIntervalsAction = function clearRefreshIntervalsAction() {
  return function (dispatch) {
    var state = _store.store.getState();
    var intervalIds = state.documents.intervalIds;
    dispatch({ type: CLEAR_REFRESH_INTERVALS });
    return intervalIds.forEach(function (interval) {
      return clearInterval(interval);
    });
  };
};

var startExportModeAction = exports.startExportModeAction = function startExportModeAction() {
  return {
    type: START_EXPORT_MODE
  };
};

var endExportModeAction = exports.endExportModeAction = function endExportModeAction() {
  return {
    type: END_EXPORT_MODE
  };
};

var shiftPressedAction = exports.shiftPressedAction = function shiftPressedAction(e) {
  if ((0, _keyPress.isShiftPressed)(e)) {
    return {
      type: SHIFT_PRESSED
    };
  }
  return { type: "NOOP" };
};

var shiftReleasedAction = exports.shiftReleasedAction = function shiftReleasedAction(e) {
  if ((0, _keyPress.isShiftPressed)(e)) {
    return {
      type: SHIFT_RELEASED
    };
  }
  return { type: "NOOP" };
};

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newOauthTokenAction = exports.redirectToLoginAction = exports.setOauthTokenAction = exports.setOauthStateAction = exports.logoutAction = exports.SET_OAUTH_TOKEN = exports.SET_OAUTH_STATE = undefined;

var _random = __webpack_require__(442);

var _oauth = __webpack_require__(441);

var _localStorage = __webpack_require__(138);

var _appActions = __webpack_require__(25);

var _reactRouter = __webpack_require__(32);

var SET_OAUTH_STATE = exports.SET_OAUTH_STATE = "actions/oauth/set-oauth-state";
var SET_OAUTH_TOKEN = exports.SET_OAUTH_TOKEN = "actions/oauth/set-oauth-token";

var logoutAction = exports.logoutAction = function logoutAction() {
  _localStorage.storage.remove(_localStorage.OAUTH_STATE);
  _localStorage.storage.remove(_localStorage.OAUTH_TOKEN);
  (0, _oauth.logout)();
  return {
    type: "NOOP"
  };
};

var setOauthStateAction = exports.setOauthStateAction = function setOauthStateAction(newState) {
  return {
    type: SET_OAUTH_STATE,
    data: newState
  };
};

var setOauthTokenAction = exports.setOauthTokenAction = function setOauthTokenAction(newToken) {
  return {
    type: SET_OAUTH_TOKEN,
    data: newToken
  };
};

var redirectToLoginAction = exports.redirectToLoginAction = function redirectToLoginAction() {
  var oauthState = (0, _random.generateRandomString)();
  _localStorage.storage.set(_localStorage.OAUTH_STATE, oauthState);
  return function (dispatch) {
    dispatch(setOauthStateAction(oauthState));
    document.location.href = (0, _oauth.generateLoginUrl)(oauthState);
  };
};

var newOauthTokenAction = exports.newOauthTokenAction = function newOauthTokenAction(_ref) {
  var token = _ref.token,
      state = _ref.state;

  var currentOauthState = _localStorage.storage.get(_localStorage.OAUTH_STATE);
  return function (dispatch) {
    if (currentOauthState !== state) {
      dispatch({
        type: _appActions.UNKNOWN_ERROR,
        data: { message: "An error occurred while signing in" }
      });
    } else {
      _localStorage.storage.set(_localStorage.OAUTH_TOKEN, token);
      dispatch({
        type: SET_OAUTH_TOKEN,
        data: token
      });
    }
    _reactRouter.browserHistory.push("/");
  };
};

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updatePaymentTypeAction = exports.updateDocumentAction = exports.updateInlineDocumentAction = exports.submitChangeViewedSettingAction = exports.changeDocumentTypeAction = exports.trashDocumentAction = exports.reprocessDocumentAction = exports.saveDocumentAction = exports.unfocusDocumentAction = exports.focusDocumentAction = exports.removeCategoryAction = exports.UPDATE_PAYMENT_TYPE = exports.UPDATE_DOCUMENT = exports.UPDATE_DOCUMENT_INLINE = exports.CHANGE_DOCUMENT_TYPE = exports.REPROCESS_DOCUMENT = exports.REMOVE_CATEGORY = exports.SAVE_DOCUMENT = exports.UNFOCUS_DOCUMENT = exports.FOCUS_DOCUMENT = undefined;

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _store = __webpack_require__(48);

var _documents = __webpack_require__(114);

var _documentsActions = __webpack_require__(161);

var _appActions = __webpack_require__(25);

var _trackingActions = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FOCUS_DOCUMENT = exports.FOCUS_DOCUMENT = "actions/documents/focus-document";
var UNFOCUS_DOCUMENT = exports.UNFOCUS_DOCUMENT = "actions/documents/unfocus-document";
var SAVE_DOCUMENT = exports.SAVE_DOCUMENT = "actions/documents/save-document";
var REMOVE_CATEGORY = exports.REMOVE_CATEGORY = "actions/documents/remove-category";
var REPROCESS_DOCUMENT = exports.REPROCESS_DOCUMENT = "actions/documents/reprocess-document";
var CHANGE_DOCUMENT_TYPE = exports.CHANGE_DOCUMENT_TYPE = "actions/documents/change-document-type";
var UPDATE_DOCUMENT_INLINE = exports.UPDATE_DOCUMENT_INLINE = "actions/documents/update-document-inline";
var UPDATE_DOCUMENT = exports.UPDATE_DOCUMENT = "actions/documents/update-document";
var UPDATE_PAYMENT_TYPE = exports.UPDATE_PAYMENT_TYPE = "actions/documents/update-payment-type";

var removeCategoryAction = exports.removeCategoryAction = function removeCategoryAction(category) {
  return {
    type: REMOVE_CATEGORY,
    data: { category: category }
  };
};

var focusDocumentAction = exports.focusDocumentAction = function focusDocumentAction(row, style) {
  return {
    type: FOCUS_DOCUMENT,
    data: { row: row, style: style }
  };
};

var unfocusDocumentAction = exports.unfocusDocumentAction = function unfocusDocumentAction() {
  return { type: UNFOCUS_DOCUMENT };
};

var saveDocumentAction = exports.saveDocumentAction = function saveDocumentAction() {
  return function (dispatch) {
    var state = _store.store.getState();
    var accountId = state.app.selectedAccount.id;
    var document = state.updateDocument;
    document.name = document.vendor;
    return (0, _documents.putDocument)(accountId, document.id, document).then(function () {
      dispatch({
        type: SAVE_DOCUMENT,
        data: { document: document }
      });
      dispatch((0, _trackingActions.trackEventAction)("Document saved"));
      dispatch((0, _appActions.setFlashMessageAction)("Document saved."));
    });
  };
};

var reprocessDocumentAction = exports.reprocessDocumentAction = function reprocessDocumentAction(accountId) {
  return function (dispatch) {
    var document = _store.store.getState().updateDocument;
    var newDocument = _ramda2.default.clone(document);
    newDocument.processingState = "NEEDS_SYSTEM_PROCESSING";
    (0, _documents.putDocument)(accountId, document.id, newDocument).then(function () {
      dispatch({
        type: REPROCESS_DOCUMENT,
        data: { newDocument: newDocument }
      });
    }).then(function () {
      dispatch(unfocusDocumentAction());
      (0, _documentsActions.reloadDocuments)(dispatch);
      dispatch((0, _trackingActions.trackEventAction)("Document reprocessed"));
    }).catch(function () {
      return dispatch((0, _appActions.setFlashGenericErrorAction)());
    });
  };
};

var trashDocumentAction = exports.trashDocumentAction = function trashDocumentAction(accountId, document) {
  return function (dispatch) {
    (0, _documents.putDocument)(accountId, document.id, _ramda2.default.assoc("trashed", true, document)).then(function () {
      dispatch(unfocusDocumentAction());
      (0, _documentsActions.reloadDocuments)(dispatch);
      dispatch((0, _trackingActions.trackEventAction)("Document trashed"));
    }).catch(function () {
      return dispatch((0, _appActions.setFlashGenericErrorAction)());
    });
  };
};

var changeDocumentTypeAction = exports.changeDocumentTypeAction = function changeDocumentTypeAction(accountId) {
  return function (dispatch) {
    var state = _store.store.getState();
    var document = state.updateDocument;
    var defaultCurrency = state.accountSettings.currency;
    var newDocument = getDocumentForChange(document, defaultCurrency);
    (0, _documents.putDocument)(accountId, document.id, newDocument).then(function () {
      dispatch(unfocusDocumentAction());
      (0, _documentsActions.reloadDocuments)(dispatch);
      dispatch((0, _trackingActions.trackEventAction)("Document type changed"));
    }).catch(function () {
      return dispatch((0, _appActions.setFlashGenericErrorAction)());
    });
  };
};

var getDocumentForChange = function getDocumentForChange(document, defaultCurrency) {
  if (document.type === "receipt") {
    return _ramda2.default.merge(document, { name: document.vendor, type: "other" });
  }
  return _ramda2.default.merge(document, {
    currency: document.currency || defaultCurrency,
    vendor: document.name,
    type: "receipt"
  });
};

var submitChangeViewedSettingAction = exports.submitChangeViewedSettingAction = function submitChangeViewedSettingAction(isViewed) {
  return function (dispatch) {
    var state = _store.store.getState();
    var account = state.app.selectedAccount;
    var documentIds = _ramda2.default.path(["documents", "selectedDocumentIds"], state);
    var documents = _ramda2.default.path(["documents", "documents"], state);
    var selectedDocuments = documentIds.map(function (id) {
      return documents.find(function (document) {
        return document.id === id;
      });
    });
    dispatch((0, _trackingActions.trackEventAction)("Viewed setting changed"));

    return (0, _documents.batchChangeViewedSetting)(account.id, selectedDocuments, isViewed).then(function () {
      return (0, _documentsActions.reloadDocuments)(dispatch, false);
    }).catch(function () {
      return dispatch((0, _appActions.setFlashGenericErrorAction)());
    });
  };
};

var updateInlineDocumentAction = exports.updateInlineDocumentAction = function updateInlineDocumentAction(_ref) {
  var accountId = _ref.accountId,
      document = _ref.document,
      field = _ref.field,
      value = _ref.value;
  return function (dispatch) {
    var newDocument = _ramda2.default.set(_ramda2.default.lensProp(field), value, document);
    return (0, _documents.putDocument)(accountId, document.id, newDocument).then(function () {
      dispatch({
        type: UPDATE_DOCUMENT_INLINE,
        data: { document: newDocument, field: field, value: value }
      });
    });
  };
};

var updateDocumentAction = exports.updateDocumentAction = function updateDocumentAction(field, value) {
  return {
    type: UPDATE_DOCUMENT,
    data: { field: field, value: value }
  };
};

var updatePaymentTypeAction = exports.updatePaymentTypeAction = function updatePaymentTypeAction(field, value) {
  return {
    type: UPDATE_PAYMENT_TYPE,
    data: { field: field, value: value }
  };
};

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeCustomTab = exports.putCustomTab = exports.putBetaViewedStatus = exports.putDefaultInterface = exports.putFavouriteAccount = exports.putActiveAccount = exports.fetchCustomTabs = exports.fetchViewedBetaStatus = exports.fetchDefaultInterface = exports.fetchFavouriteAccount = exports.fetchActiveAccount = undefined;

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _http = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchActiveAccount = exports.fetchActiveAccount = function fetchActiveAccount() {
  return _http.http.get("/internal/storage").then(function (response) {
    return response.data.activeAccountId;
  });
};

var fetchFavouriteAccount = exports.fetchFavouriteAccount = function fetchFavouriteAccount() {
  return _http.http.get("/internal/storage").then(function (response) {
    return response.data.favouriteAccountId;
  });
};

var fetchDefaultInterface = exports.fetchDefaultInterface = function fetchDefaultInterface() {
  return _http.http.get("/internal/storage").then(function (response) {
    return response.data.isBetaDefault;
  });
};

var fetchViewedBetaStatus = exports.fetchViewedBetaStatus = function fetchViewedBetaStatus() {
  return _http.http.get("/internal/storage").then(function (response) {
    return response.data.hasViewedBeta;
  });
};

var fetchCustomTabs = exports.fetchCustomTabs = function fetchCustomTabs() {
  return _http.http.get("/internal/storage").then(function (response) {
    return response.data.customTabs;
  });
};

var putStorageCreator = function putStorageCreator(key, value, update) {
  return _http.http.get("internal/storage").then(function (response) {
    var storage = response.data;
    var newStorage = update(key, value, storage);
    return _http.http.put("/internal/storage", newStorage);
  });
};

var keyValueStorageUpdate = function keyValueStorageUpdate(key, value, storage) {
  return _ramda2.default.set(_ramda2.default.lensProp(key), value, storage);
};
var appendValueStorageUpdate = function appendValueStorageUpdate(key, value, storage) {
  var newArray = _ramda2.default.append(value, _ramda2.default.prop(key, storage));
  return _ramda2.default.set(_ramda2.default.lensProp(key), newArray, storage);
};

var putActiveAccount = exports.putActiveAccount = function putActiveAccount(accountId) {
  return putStorageCreator("activeAccountId", accountId, keyValueStorageUpdate);
};

var putFavouriteAccount = exports.putFavouriteAccount = function putFavouriteAccount(accountId) {
  return putStorageCreator("favouriteAccountId", accountId, keyValueStorageUpdate);
};

var putDefaultInterface = exports.putDefaultInterface = function putDefaultInterface(isBetaDefault) {
  return putStorageCreator("isBetaDefault", isBetaDefault, keyValueStorageUpdate);
};

var putBetaViewedStatus = exports.putBetaViewedStatus = function putBetaViewedStatus(hasViewedBeta) {
  return putStorageCreator("hasViewedBeta", hasViewedBeta, keyValueStorageUpdate);
};

var putCustomTab = exports.putCustomTab = function putCustomTab(customTab) {
  return putStorageCreator("customTabs", customTab, appendValueStorageUpdate);
};

var removeCustomTab = exports.removeCustomTab = function removeCustomTab(tabId) {
  return _http.http.get("internal/storage").then(function (response) {
    var storage = response.data;
    var customTabs = storage.customTabs;
    var tabIndex = _ramda2.default.findIndex(_ramda2.default.propEq("id", tabId))(customTabs);
    var newCustomTabs = _ramda2.default.remove(tabIndex, 1, customTabs);
    var newStorage = _ramda2.default.set(_ramda2.default.lensProp("customTabs"), newCustomTabs, storage);
    return _http.http.put("/internal/storage", newStorage).then(function () {
      return newCustomTabs;
    });
  });
};

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownModal = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dropdownModal = __webpack_require__(1305);

var _dropdownModal2 = _interopRequireDefault(_dropdownModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DropdownModal = exports.DropdownModal = function DropdownModal(_ref) {
  var children = _ref.children,
      onClose = _ref.onClose,
      offsetLeft = _ref.offsetLeft,
      offsetTop = _ref.offsetTop,
      visible = _ref.visible,
      width = _ref.width,
      _ref$arrowSide = _ref.arrowSide,
      arrowSide = _ref$arrowSide === undefined ? false : _ref$arrowSide;
  return visible ? content(children, onClose, offsetLeft, offsetTop, width, arrowSide) : null;
};

var content = function content(children, onClose, offsetLeft, offsetTop, width, arrowSide) {
  return _react2.default.createElement(
    "div",
    { className: _dropdownModal2.default.wrapper },
    _react2.default.createElement(
      "div",
      { className: changeArrowSide(arrowSide), style: { left: offsetLeft, top: offsetTop, width: width } },
      children
    ),
    _react2.default.createElement("div", { className: _dropdownModal2.default.background, onClick: onClose })
  );
};

var changeArrowSide = function changeArrowSide(arrowSide) {
  if (arrowSide) {
    return _dropdownModal2.default.container + " " + _dropdownModal2.default["arrow-side"];
  }
  return _dropdownModal2.default.container;
};

DropdownModal.propTypes = {
  children: _propTypes2.default.element.isRequired,
  offsetLeft: _propTypes2.default.number,
  offsetTop: _propTypes2.default.number,
  onClose: _propTypes2.default.func.isRequired,
  visible: _propTypes2.default.bool.isRequired,
  width: _propTypes2.default.number
};

DropdownModal.defaultProps = {
  offsetLeft: 0,
  offsetTop: 0,
  width: 250
};

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGridHeight = exports.getColumnWidth = exports.CellRenderer = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _reactVirtualized = __webpack_require__(113);

var _angleUp = __webpack_require__(1004);

var _angleUp2 = _interopRequireDefault(_angleUp);

var _customPropTypes = __webpack_require__(5);

var _gridComponents = __webpack_require__(1340);

var _gridComponents2 = _interopRequireDefault(_gridComponents);

var _categoryCellFormatter = __webpack_require__(431);

var _paymentTypeCellFormatter = __webpack_require__(434);

var _viewedCellFormatter = __webpack_require__(437);

var _downloadUrlCellFormatter = __webpack_require__(432);

var _uploadSourceCellFormatter = __webpack_require__(436);

var _moneyCellFormatter = __webpack_require__(433);

var _dateCellFormatter = __webpack_require__(269);

var _selectCellFormatter = __webpack_require__(435);

var _vendorRuleCellFormatter = __webpack_require__(889);

var _categoryRuleCellFormatter = __webpack_require__(882);

var _inputCellFormatter = __webpack_require__(884);

var _typeCellFormatter = __webpack_require__(888);

var _envelopesGridCellFormatters = __webpack_require__(883);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CellRenderer = exports.CellRenderer = function CellRenderer(_ref) {
  var columnIndex = _ref.columnIndex,
      rowIndex = _ref.rowIndex,
      style = _ref.style,
      parent = _ref.parent,
      newKey = _ref.newKey;

  var rowClassName = getRowClassName(rowIndex);
  if (rowIndex === 0) {
    return cellRendererTop({ columnIndex: columnIndex, style: style, parent: parent, rowIndex: rowIndex, newKey: newKey });
  }
  return cellRendererMain({ columnIndex: columnIndex, rowIndex: rowIndex, style: style, parent: parent, rowClassName: rowClassName, newKey: newKey });
};

CellRenderer.propTypes = {
  columnIndex: _propTypes2.default.number.isRequired,
  newKey: _propTypes2.default.string.isRequired,
  parent: _propTypes2.default.shape({ props: _propTypes2.default.object }).isRequired,
  rowIndex: _propTypes2.default.number.isRequired,
  style: _customPropTypes.gridStyleType.isRequired
};

var cellRendererTop = function cellRendererTop(_ref2) {
  var columnIndex = _ref2.columnIndex,
      style = _ref2.style,
      parent = _ref2.parent,
      rowIndex = _ref2.rowIndex,
      newKey = _ref2.newKey;
  var _parent$props = parent.props,
      cache = _parent$props.cache,
      columns = _parent$props.columns,
      orderDirection = _parent$props.orderDirection,
      orderBy = _parent$props.orderBy,
      onOrderBy = _parent$props.onOrderBy;

  var gridColumns = columns.filter(function (col) {
    return col.visible === true;
  });
  var column = gridColumns[columnIndex];
  var sortableClassName = column.sortable ? _gridComponents2.default.sortable : "";
  var isSortActive = column.key === orderBy;
  if (column.key === "select") {
    var _parent$props2 = parent.props,
        documents = _parent$props2.documents,
        selectedDocumentIds = _parent$props2.selectedDocumentIds,
        onRowsDeselected = _parent$props2.onRowsDeselected,
        onRowsSelected = _parent$props2.onRowsSelected;

    var ids = documents.map(function (document) {
      return document.id;
    });
    return _react2.default.createElement(
      _reactVirtualized.CellMeasurer,
      {
        cache: cache,
        columnIndex: columnIndex,
        key: newKey,
        parent: parent,
        rowIndex: rowIndex
      },
      _react2.default.createElement(
        "div",
        { className: _gridComponents2.default["select-all"], key: newKey, style: style },
        _react2.default.createElement(_selectCellFormatter.SelectCellFormatter, {
          id: ids,
          isSelected: selectedDocumentIds.length > 19,
          onRowsDeselected: onRowsDeselected,
          onRowsSelected: onRowsSelected
        })
      )
    );
  }
  return _react2.default.createElement(
    _reactVirtualized.CellMeasurer,
    {
      cache: cache,
      columnIndex: columnIndex,
      key: newKey,
      parent: parent,
      rowIndex: rowIndex
    },
    _react2.default.createElement(
      "div",
      {
        className: _gridComponents2.default.header + " " + sortableClassName,
        key: newKey,
        onClick: function onClick() {
          return sortable(onOrderBy, column);
        },
        style: style
      },
      _react2.default.createElement(
        "span",
        { className: _gridComponents2.default["header-content"] },
        column.name,
        sortIndicator(orderDirection, isSortActive)
      )
    )
  );
};

var sortable = function sortable(onOrderBy, column) {
  if (!column.sortable) {
    return null;
  }
  return onOrderBy(column.key);
};

var sortIndicator = function sortIndicator(orderDirection, isSortActive) {
  var className = orderDirection === "ASC" ? "up" : "down";
  if (isSortActive) {
    return _react2.default.createElement(_angleUp2.default, { className: _gridComponents2.default[className], size: 15 });
  }
  return null;
};

cellRendererTop.propTypes = {
  columnIndex: _propTypes2.default.number.isRequired,
  newKey: _propTypes2.default.string.isRequired,
  parent: _propTypes2.default.shape({ props: _propTypes2.default.object }).isRequired,
  rowIndex: _propTypes2.default.number.isRequired,
  style: _customPropTypes.gridStyleType.isRequired
};

var cellRendererMain = function cellRendererMain(_ref3) {
  var columnIndex = _ref3.columnIndex,
      rowIndex = _ref3.rowIndex,
      style = _ref3.style,
      parent = _ref3.parent,
      rowClassName = _ref3.rowClassName,
      newKey = _ref3.newKey;
  var _parent$props3 = parent.props,
      focusParam = _parent$props3.focusParam,
      documents = _parent$props3.documents,
      isRowFocusable = _parent$props3.isRowFocusable,
      columns = _parent$props3.columns,
      onFocusRow = _parent$props3.onFocusRow;

  var newDocuments = _ramda2.default.prepend({}, documents);
  var gridColumns = columns.filter(function (col) {
    return col.visible === true;
  });
  var row = newDocuments[rowIndex];
  var cellKey = gridColumns[columnIndex].key;
  var content = row[cellKey];
  var handleRowClick = isRowFocusable && cellKey !== "select" ? function () {
    return onFocusRow(row, style, focusParam);
  } : null;
  return cellFormatterContainer(columnIndex, cellKey, newKey, style, content, handleRowClick, row, rowIndex, rowClassName, parent);
};

cellRendererMain.propTypes = {
  columnIndex: _propTypes2.default.number.isRequired,
  newKey: _propTypes2.default.string.isRequired,
  parent: _propTypes2.default.shape({ props: _propTypes2.default.object }).isRequired,
  rowClassName: _propTypes2.default.string.isRequired,
  rowIndex: _propTypes2.default.number.isRequired,
  style: _customPropTypes.gridStyleType.isRequired
};

var cellFormatterContainer = function cellFormatterContainer(columnIndex, cellKey, key, style, content, handleRowClick, row, rowIndex, rowClassName, parent) {
  var isFocused = parent.props.focusedDocument && row.id === parent.props.focusedDocument.id;
  var viewedStyle = row.viewed === false ? _gridComponents2.default.unviewed : "";
  var focusedStyle = isFocused ? _gridComponents2.default.focused : "";
  var overflowStyle = cellKey === "type" || "source" ? _gridComponents2.default.overflow : "";
  var changingClasses = viewedStyle + " " + focusedStyle + " " + overflowStyle;
  return _react2.default.createElement(
    _reactVirtualized.CellMeasurer,
    {
      cache: parent.props.cache,
      columnIndex: columnIndex,
      key: key,
      parent: parent,
      rowIndex: rowIndex
    },
    _react2.default.createElement(
      "div",
      {
        className: _gridComponents2.default["main-cells"] + " " + rowClassName + " " + changingClasses,
        key: key,
        onClick: handleRowClick,
        style: style
      },
      cellFormatters(cellKey, key, style, content, parent, row, rowIndex, isFocused)
    )
  );
};

var cellFormatters = function cellFormatters(cellKey, key, style, content, parent, row, rowIndex, isFocused) {
  switch (cellKey) {
    case "select":
      return _react2.default.createElement(_selectCellFormatter.SelectCellFormatter, {
        documents: parent.props.documents,
        id: row.id,
        isSelected: parent.props.selectedDocumentIds.includes(row.id),
        isShiftPressed: parent.props.isShiftPressed,
        onRowsDeselected: parent.props.onRowsDeselected,
        onRowsSelected: parent.props.onRowsSelected,
        selectedDocumentIds: parent.props.selectedDocumentIds
      });
    case "issued":
      return _react2.default.createElement(_dateCellFormatter.DateCellFormatter, {
        accountId: parent.props.accountId,
        document: row,
        isFocused: isFocused,
        onUpdateInlineDocument: parent.props.onUpdateInlineDocument,
        value: content
      });
    case "type":
      return _react2.default.createElement(_typeCellFormatter.TypeCellFormatter, { value: content });
    case "uploaded":
    case "exported":
      return _react2.default.createElement(_dateCellFormatter.SimpleDateCellFormatter, { value: content });
    case "total":
      return _react2.default.createElement(_moneyCellFormatter.MoneyCellFormatter, {
        accountId: parent.props.accountId,
        currency: parent.props.currency,
        defaultCurrency: parent.props.preferredCurrency,
        document: row,
        field: "total",
        isFocused: isFocused,
        onUpdateDocument: parent.props.onUpdateDocument,
        onUpdateInlineDocument: parent.props.onUpdateInlineDocument,
        value: content
      });
    case "tax":
      return _react2.default.createElement(_moneyCellFormatter.MoneyCellFormatter, {
        accountId: parent.props.accountId,
        currency: parent.props.currency,
        defaultCurrency: parent.props.preferredCurrency,
        document: row,
        field: "tax",
        isFocused: isFocused,
        onUpdateDocument: parent.props.onUpdateDocument,
        onUpdateInlineDocument: parent.props.onUpdateInlineDocument,
        value: content
      });
    case "categories":
      return _react2.default.createElement(_categoryCellFormatter.CategoryCellFormatter, {
        documentCount: parent.props.documents.length,
        rowIndex: rowIndex,
        value: content
      });
    case "rules":
      return renderCorrectCellFormatter(content, parent.props, row);
    case "paymentType":
      return _react2.default.createElement(_paymentTypeCellFormatter.PaymentTypeCellFormatter, {
        documentCount: parent.props.documents.length,
        rowIndex: rowIndex,
        value: content
      });
    case "viewed":
      return _react2.default.createElement(_viewedCellFormatter.ViewedCellFormatter, { value: content });
    case "downloadUrl":
    case "url":
      return _react2.default.createElement(_downloadUrlCellFormatter.DownloadUrlCellFormatter, { value: row.attachment || content });
    case "source":
      return _react2.default.createElement(_uploadSourceCellFormatter.UploadSourceCellFormatter, { value: content });
    case "received":
      return _react2.default.createElement(_envelopesGridCellFormatters.ReceivedCellFormatter, { value: content });
    case "sent":
      return _react2.default.createElement(_envelopesGridCellFormatters.SentCellFormatter, { value: content });
    case "status":
      return _react2.default.createElement(_envelopesGridCellFormatters.StatusCellFormatter, { value: content });
    case "envelope":
      return _react2.default.createElement(_envelopesGridCellFormatters.EnvelopeCellFormatter, { value: content });
    case "envelopeUploaded":
      return _react2.default.createElement(_envelopesGridCellFormatters.EnvelopeUploadedCellFormatter, { value: content });
    case "code":
      return _react2.default.createElement(_envelopesGridCellFormatters.EnvelopeCellFormatter, {
        isLinkable: parent.props.isLinkable,
        onAddEnvelope: parent.props.onAddEnvelope,
        onSetFlashMessage: parent.props.onSetFlashMessage,
        slug: parent.props.slug,
        value: content
      });
    case "billable":
      return _react2.default.createElement(_envelopesGridCellFormatters.BillableCellFormatter, { value: content });
    case "vendor":
      return _react2.default.createElement(_inputCellFormatter.InputCellFormatter, {
        accountId: parent.props.accountId,
        document: row,
        documentCount: parent.props.documents.length,
        field: "vendor",
        isFocused: isFocused,
        onUpdateDocument: parent.props.onUpdateDocument,
        onUpdateInlineDocument: parent.props.onUpdateInlineDocument,
        rowIndex: rowIndex,
        value: content || row.name
      });
    case "invoiceNumber":
      return _react2.default.createElement(_inputCellFormatter.InputCellFormatter, {
        accountId: parent.props.accountId,
        document: row,
        documentCount: parent.props.documents.length,
        field: "invoiceNumber",
        isFocused: isFocused,
        onUpdateDocument: parent.props.onUpdateDocument,
        onUpdateInlineDocument: parent.props.onUpdateInlineDocument,
        rowIndex: rowIndex,
        value: content
      });
    default:
      return content;
  }
};

var getRowClassName = function getRowClassName(row) {
  if (row % 2 === 0) {
    return _gridComponents2.default["even-row"];
  }
  return _gridComponents2.default["odd-row"];
};

var getColumnWidth = exports.getColumnWidth = function getColumnWidth(index, width, visibleColumns) {
  if (visibleColumns[index].fixedWidth) {
    return visibleColumns[index].fixedWidth;
  }

  var _addFixedWidths = addFixedWidths(visibleColumns),
      fixedColumns = _addFixedWidths.fixedColumns,
      fixedWidth = _addFixedWidths.fixedWidth;

  var newWidth = width - fixedWidth;
  var extraRowWidth = visibleColumns.reduce(function (previous, current) {
    return { width: previous.width + current.width };
  });
  var extraColumnWidth = (1 - extraRowWidth.width) / (visibleColumns.length - fixedColumns);
  var columnWidth = visibleColumns[index].width + extraColumnWidth;
  return newWidth * columnWidth;
};

var addFixedWidths = function addFixedWidths(visibleColumns) {
  var fixedWidth = 0;
  var fixedColumns = 0;
  visibleColumns.forEach(function (column) {
    if (column.fixedWidth) {
      fixedColumns += 1;
      fixedWidth += column.fixedWidth;
    }
  });
  return { fixedColumns: fixedColumns, fixedWidth: fixedWidth };
};

var getGridHeight = exports.getGridHeight = function getGridHeight(limit, totalResults, rowHeight) {
  var rows = _ramda2.default.min(limit, totalResults);
  if (limit === -1) {
    return totalResults * rowHeight + 50;
  }
  if (rows === 0) {
    return 650;
  }
  return rows * rowHeight + 50;
};

var renderCorrectCellFormatter = function renderCorrectCellFormatter(content, props, row) {
  if (props.isManageVendorsPage) {
    return _react2.default.createElement(_vendorRuleCellFormatter.VendorRuleCellFormatter, {
      accountId: props.accountId,
      onDeleteIncludeRule: props.onDeleteIncludeRule,
      value: content,
      vendorName: row.name
    });
  }
  return _react2.default.createElement(_categoryRuleCellFormatter.CategoryRuleCellFormatter, {
    accountId: props.accountId,
    id: row.id,
    removeIncludeRule: props.onRemoveIncludeRule,
    value: content
  });
};

renderCorrectCellFormatter.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  isManageVendorsPage: _propTypes2.default.bool.isRequired,
  onDeleteIncludeRule: _propTypes2.default.func.isRequired,
  onRemoveIncludeRule: _propTypes2.default.func.isRequired
};

/***/ }),
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.orderCategoriesAction = exports.saveCategoryChangesAction = exports.setDeleteCategoriesVisibilityAction = exports.removeDropdownRuleAction = exports.updateIncludeVendorsAction = exports.updateCategoryNameAction = exports.unfocusCategoryAction = exports.focusCategoryAction = exports.deleteCategoriesAction = exports.deselectCategoriesAction = exports.selectCategoriesAction = exports.removeIncludeRuleAction = exports.updateNewCategoryNameAction = exports.setAddCategoryVisibilityAction = exports.createCategoryAction = exports.ORDER_CATEGORIES = exports.SAVE_CATEGORY_LOADING_STOP = exports.SAVE_CATEGORY_LOADING = exports.SET_DELETE_CATEGORIES_VISIBILITY = exports.UPDATE_INCLUDE_VENDORS = exports.REMOVE_DROPDOWN_RULE = exports.UPDATE_CATEGORY_NAME = exports.UNFOCUS_CATEGORY = exports.FOCUS_CATEGORY = exports.RELOAD_CATEGORIES = exports.DELETE_CATEGORIES_LOADING_STOP = exports.DELETE_CATEGORIES_LOADING = exports.DESELECT_CATEGORIES = exports.SELECT_CATEGORIES = exports.REMOVE_INCLUDE_RULE = exports.UPDATE_NEW_CATEGORY_NAME = exports.SET_ADD_CATEGORY_VISIBILITY = exports.CREATE_CATEGORY = undefined;

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _store = __webpack_require__(48);

var _appActions = __webpack_require__(25);

var _categories = __webpack_require__(265);

var _trackingActions = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CREATE_CATEGORY = exports.CREATE_CATEGORY = "actions/categories/create-category";
var SET_ADD_CATEGORY_VISIBILITY = exports.SET_ADD_CATEGORY_VISIBILITY = "actions/categories/set-add-category-visibility";
var UPDATE_NEW_CATEGORY_NAME = exports.UPDATE_NEW_CATEGORY_NAME = "actions/categories/update-new-category-name";
var REMOVE_INCLUDE_RULE = exports.REMOVE_INCLUDE_RULE = "actions/categories/remove-include-rule";
var SELECT_CATEGORIES = exports.SELECT_CATEGORIES = "actions/categories/select-categories";
var DESELECT_CATEGORIES = exports.DESELECT_CATEGORIES = "actions/categories/deselect-categories";
var DELETE_CATEGORIES_LOADING = exports.DELETE_CATEGORIES_LOADING = "actions/categories/delete-categories-loading";
var DELETE_CATEGORIES_LOADING_STOP = exports.DELETE_CATEGORIES_LOADING_STOP = "actions/categories/delete-categories-loading-stop";
var RELOAD_CATEGORIES = exports.RELOAD_CATEGORIES = "actions/categories/reload-categories";
var FOCUS_CATEGORY = exports.FOCUS_CATEGORY = "actions/categories/focus-category";
var UNFOCUS_CATEGORY = exports.UNFOCUS_CATEGORY = "actions/categories/unfocus-category";
var UPDATE_CATEGORY_NAME = exports.UPDATE_CATEGORY_NAME = "actions/categories/update-category-name";
var REMOVE_DROPDOWN_RULE = exports.REMOVE_DROPDOWN_RULE = "actions/categories/remove-dropdown-rule";
var UPDATE_INCLUDE_VENDORS = exports.UPDATE_INCLUDE_VENDORS = "actions/categories/update-include-vendors";
var SET_DELETE_CATEGORIES_VISIBILITY = exports.SET_DELETE_CATEGORIES_VISIBILITY = "actions/categories/set-delete-categories-visibility";
var SAVE_CATEGORY_LOADING = exports.SAVE_CATEGORY_LOADING = "actions/categories/save-category-loading";
var SAVE_CATEGORY_LOADING_STOP = exports.SAVE_CATEGORY_LOADING_STOP = "actions/categories/save-category-loading-stop";
var ORDER_CATEGORIES = exports.ORDER_CATEGORIES = "actions/categories/order-categories";

var reloadCategories = function reloadCategories(accountId, dispatch) {
  setTimeout(function () {
    (0, _categories.fetchCategories)(accountId).then(function (_ref) {
      var categories = _ref.categories;

      dispatch({
        type: RELOAD_CATEGORIES,
        data: { categories: categories }
      });
    });
  }, 0);
};

var createCategoryAction = exports.createCategoryAction = function createCategoryAction(accountId, newCategory) {
  return function (dispatch) {
    (0, _categories.createCategory)(accountId, newCategory).then(function (response) {
      dispatch({
        type: CREATE_CATEGORY,
        data: response.data
      });
      dispatch((0, _trackingActions.trackEventAction)("Category created"));
    }).catch(function () {
      return dispatch((0, _appActions.setFlashGenericErrorAction)());
    });
  };
};

var setAddCategoryVisibilityAction = exports.setAddCategoryVisibilityAction = function setAddCategoryVisibilityAction(visibility) {
  return {
    type: SET_ADD_CATEGORY_VISIBILITY,
    data: { visibility: visibility }
  };
};

var updateNewCategoryNameAction = exports.updateNewCategoryNameAction = function updateNewCategoryNameAction(name) {
  return {
    type: UPDATE_NEW_CATEGORY_NAME,
    data: { name: name }
  };
};

var removeIncludeRuleAction = exports.removeIncludeRuleAction = function removeIncludeRuleAction(accountId, categoryId, ruleId) {
  return function (dispatch) {
    (0, _categories.deleteIncludeRule)(accountId, categoryId, ruleId).then(function () {
      dispatch({
        type: REMOVE_INCLUDE_RULE,
        data: { categoryId: categoryId, ruleId: ruleId }
      });
      dispatch((0, _trackingActions.trackEventAction)("Include rule removed"));
      dispatch((0, _appActions.setFlashMessageAction)("Rule removed", "error"));
    });
  };
};

var selectCategoriesAction = exports.selectCategoriesAction = function selectCategoriesAction(categoryIds) {
  return {
    type: SELECT_CATEGORIES,
    data: { categoryIds: categoryIds }
  };
};

var deselectCategoriesAction = exports.deselectCategoriesAction = function deselectCategoriesAction(categoryIds) {
  return {
    type: DESELECT_CATEGORIES,
    data: { categoryIds: categoryIds }
  };
};

var deleteCategoriesAction = exports.deleteCategoriesAction = function deleteCategoriesAction() {
  return function (dispatch) {
    dispatch({ type: DELETE_CATEGORIES_LOADING });
    var state = _store.store.getState();
    var account = state.app.selectedAccount;
    var categoryIds = _ramda2.default.path(["categories", "selectedCategoryIds"], state);

    return (0, _categories.deleteCategories)(account.id, categoryIds).then(function () {
      reloadCategories(account.id, dispatch);
      dispatch({ type: DELETE_CATEGORIES_LOADING_STOP });
      dispatch((0, _trackingActions.trackEventAction)("Category deleted"));
    }).catch(function () {
      dispatch((0, _appActions.setFlashMessageAction)("Oops! Something went wrong. Please try again later", "error"));
      dispatch({ type: DELETE_CATEGORIES_LOADING_STOP });
    });
  };
};

var focusCategoryAction = exports.focusCategoryAction = function focusCategoryAction(category, style) {
  return {
    type: FOCUS_CATEGORY,
    data: { category: category, style: style }
  };
};

var unfocusCategoryAction = exports.unfocusCategoryAction = function unfocusCategoryAction() {
  return {
    type: UNFOCUS_CATEGORY
  };
};

var updateCategoryNameAction = exports.updateCategoryNameAction = function updateCategoryNameAction(name) {
  return {
    type: UPDATE_CATEGORY_NAME,
    data: { name: name }
  };
};

var updateIncludeVendorsAction = exports.updateIncludeVendorsAction = function updateIncludeVendorsAction(vendor) {
  return {
    type: UPDATE_INCLUDE_VENDORS,
    data: { vendor: vendor }
  };
};

var removeDropdownRuleAction = exports.removeDropdownRuleAction = function removeDropdownRuleAction(rule) {
  var isNew = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function (dispatch) {
    dispatch({
      type: REMOVE_DROPDOWN_RULE,
      data: { rule: rule, isNew: isNew }
    });
  };
};

var setDeleteCategoriesVisibilityAction = exports.setDeleteCategoriesVisibilityAction = function setDeleteCategoriesVisibilityAction(visibility) {
  return {
    type: SET_DELETE_CATEGORIES_VISIBILITY,
    data: { visibility: visibility }
  };
};

var saveCategoryChangesAction = exports.saveCategoryChangesAction = function saveCategoryChangesAction(data) {
  return function (dispatch) {
    dispatch({ type: SAVE_CATEGORY_LOADING });
    (0, _categories.createIncludeRules)(data.accountId, data.focusedCategory.id, data.newIncludeRules).then(function () {
      return (0, _categories.saveCategory)(data.accountId, data.focusedCategory);
    }).then(function () {
      return dispatch((0, _appActions.setFlashMessageAction)("Category Saved"));
    }).then(function () {
      return reloadCategories(data.accountId, dispatch);
    }).then(function () {
      return dispatch({ type: SAVE_CATEGORY_LOADING_STOP });
    }).catch(function () {
      return dispatch((0, _appActions.setFlashMessageAction)("Oops! Something went wrong. Please try again later", "error"));
    });
  };
};

var orderCategoriesAction = exports.orderCategoriesAction = function orderCategoriesAction(column) {
  return {
    type: ORDER_CATEGORIES,
    data: { column: column }
  };
};

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeSourceFilterAction = exports.addSourceFilterAction = exports.removeStuckStatusFilterAction = exports.addStuckStatusFilterAction = exports.endFiltersModeAction = exports.startFiltersModeAction = exports.filterPendingDocumentsAction = exports.dropRejectAction = exports.changeDocumentTypeAction = exports.reprocessPendingDocumentAction = exports.cancelProcessingAllDocumentsAction = exports.processAllDocumentsAction = exports.trashPendingDocumentAction = exports.savePendingOtherDocumentAction = exports.savePendingDocumentAction = exports.setTrashDocumentVisibilityAction = exports.cancelProcessingAction = exports.focusPendingDocumentAction = exports.uploadErrorAction = exports.reloadPendingDocuments = exports.fetchPendingDocumentsAction = exports.dropDocumentAction = exports.REMOVE_SOURCE_FILTER = exports.ADD_SOURCE_FILTER = exports.REMOVE_STUCK_STATUS_FILTER = exports.ADD_STUCK_STATUS_FILTER = exports.END_FILTERS_MODE = exports.START_FILTERS_MODE = exports.CANCEL_PROCESSING_LOADING_STOP = exports.CANCEL_PROCESSING_LOADING = exports.UPLOAD_LOADING_END = exports.UPLOAD_LOADING_START = exports.CHANGE_DOCUMENT_TYPE = exports.REPROCESS_PENDING_DOCUMENT = exports.CANCEL_PROCESSING_ALL_DOCUMENTS = exports.PROCESS_ALL_DOCUMENTS = exports.SET_TRASH_DOCUMENT_VISIBILITY = exports.CANCEL_PROCESSING = exports.FOCUS_PENDING_DOCUMENT = exports.LOADING_START = exports.UPLOAD_ERROR = exports.SET_PENDING_DOCUMENTS = exports.DOCUMENT_UPLOADED = undefined;

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _documents = __webpack_require__(114);

var _store = __webpack_require__(48);

var _appActions = __webpack_require__(25);

var _trackingActions = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DOCUMENT_UPLOADED = exports.DOCUMENT_UPLOADED = "actions/pending-documents/document-uploaded";
var SET_PENDING_DOCUMENTS = exports.SET_PENDING_DOCUMENTS = "actions/pending-documents/set-pending-documents";
var UPLOAD_ERROR = exports.UPLOAD_ERROR = "actions/pending-documents/upload-error";
var LOADING_START = exports.LOADING_START = "actions/pending-documents/loading-start";
var FOCUS_PENDING_DOCUMENT = exports.FOCUS_PENDING_DOCUMENT = "actions/pending-documents/focus-pending-document";
var CANCEL_PROCESSING = exports.CANCEL_PROCESSING = "actions/pending-documents/cancel-processing";
var SET_TRASH_DOCUMENT_VISIBILITY = exports.SET_TRASH_DOCUMENT_VISIBILITY = "actions/pending-documents/set-trash-document-visibility";
var PROCESS_ALL_DOCUMENTS = exports.PROCESS_ALL_DOCUMENTS = "actions/pending-documents/process-all-documents";
var CANCEL_PROCESSING_ALL_DOCUMENTS = exports.CANCEL_PROCESSING_ALL_DOCUMENTS = "actions/pending-documents/cancel-processing-all-documents";
var REPROCESS_PENDING_DOCUMENT = exports.REPROCESS_PENDING_DOCUMENT = "actions/pending-documents/reprocess-pending-document";
var CHANGE_DOCUMENT_TYPE = exports.CHANGE_DOCUMENT_TYPE = "actions/pending-documents/change-document-type";
var UPLOAD_LOADING_START = exports.UPLOAD_LOADING_START = "actions/pending-documents/upload-loading-start";
var UPLOAD_LOADING_END = exports.UPLOAD_LOADING_END = "actions/pending-documents/upload-loading-end";
var CANCEL_PROCESSING_LOADING = exports.CANCEL_PROCESSING_LOADING = "actions/pending-documents/cancel-processing-loading";
var CANCEL_PROCESSING_LOADING_STOP = exports.CANCEL_PROCESSING_LOADING_STOP = "actions/pending-documents/cancel-processing-loading-stop";
var START_FILTERS_MODE = exports.START_FILTERS_MODE = "actions/pending-documents/start-filters-mode";
var END_FILTERS_MODE = exports.END_FILTERS_MODE = "actions/pending-documents/end-filters-mode";
var ADD_STUCK_STATUS_FILTER = exports.ADD_STUCK_STATUS_FILTER = "actions/pending-documents/add-stuck-status-filter";
var REMOVE_STUCK_STATUS_FILTER = exports.REMOVE_STUCK_STATUS_FILTER = "actions/pending-documents/remove-stuck-status-filter";
var ADD_SOURCE_FILTER = exports.ADD_SOURCE_FILTER = "actions/pending-documents/add-source-filter";
var REMOVE_SOURCE_FILTER = exports.REMOVE_SOURCE_FILTER = "actions/pending-documents/remove-source-filter";

var dropDocumentAction = exports.dropDocumentAction = function dropDocumentAction(accountId, files) {
  return function (dispatch) {
    dispatch({ type: UPLOAD_LOADING_START });
    var ajaxPromises = files.map(function (file) {
      var formData = new FormData();
      formData.append("document", JSON.stringify({ processingState: "NEEDS_SYSTEM_PROCESSING" }));
      formData.append("attachment", file);
      return (0, _documents.uploadDocuments)(accountId, formData).then(function (document) {
        dispatch({
          type: DOCUMENT_UPLOADED,
          data: document
        });
        dispatch((0, _trackingActions.trackEventAction)("Document uploaded"));
      });
    });
    return Promise.all(ajaxPromises).then(function () {
      return dispatch({ type: UPLOAD_LOADING_END });
    });
  };
};

var fetchPendingDocumentsAction = exports.fetchPendingDocumentsAction = function fetchPendingDocumentsAction(accountId) {
  return function (dispatch) {
    var pagination = {
      orderBy: "uploaded",
      orderDirection: "DSC",
      processingState: ["NEEDS_SYSTEM_PROCESSING", "NEEDS_USER_PROCESSING"]
    };
    var limit = { limit: 250, pageNumber: 1 };
    dispatch({
      type: LOADING_START
    });
    (0, _documents.fetchDocuments)(accountId, pagination, limit).then(function (_ref) {
      var documents = _ref.documents,
          totalCount = _ref.totalCount,
          totalCountFiltered = _ref.totalCountFiltered,
          totalSumFiltered = _ref.totalSumFiltered;

      var newDocuments = documents.map(function (document) {
        if (document.type === "unknown") {
          return _ramda2.default.set(_ramda2.default.lensProp("type"), "document", document);
        }
        return document;
      });
      dispatch({
        type: SET_PENDING_DOCUMENTS,
        data: {
          newDocuments: newDocuments,
          totalCount: totalCount,
          totalCountFiltered: totalCountFiltered,
          totalSumFiltered: totalSumFiltered
        }
      });
    });
  };
};

var reloadPendingDocuments = exports.reloadPendingDocuments = function reloadPendingDocuments(dispatch) {
  setTimeout(function () {
    var state = _store.store.getState();
    var account = state.app.selectedAccount;
    dispatch(fetchPendingDocumentsAction(account.id));
  }, 0);
};

var uploadErrorAction = exports.uploadErrorAction = function uploadErrorAction(error) {
  return {
    type: UPLOAD_ERROR,
    data: { error: error }
  };
};

var focusPendingDocumentAction = exports.focusPendingDocumentAction = function focusPendingDocumentAction(document) {
  return {
    type: FOCUS_PENDING_DOCUMENT,
    data: { document: document }
  };
};

var cancelProcessingAction = exports.cancelProcessingAction = function cancelProcessingAction(document) {
  return function (dispatch) {
    var newDocument = _ramda2.default.clone(document);
    newDocument.processingState = "NEEDS_USER_PROCESSING";
    dispatch({
      type: CANCEL_PROCESSING,
      data: { newDocument: newDocument }
    });
    dispatch((0, _trackingActions.trackEventAction)("Processing cancelled"));
    return (0, _documents.putDocument)(document.accountId, document.id, newDocument);
  };
};

var setTrashDocumentVisibilityAction = exports.setTrashDocumentVisibilityAction = function setTrashDocumentVisibilityAction(visibility) {
  return {
    type: SET_TRASH_DOCUMENT_VISIBILITY,
    data: { visibility: visibility }
  };
};

var savePendingDocumentAction = exports.savePendingDocumentAction = function savePendingDocumentAction() {
  return function (dispatch) {
    var state = _store.store.getState();
    var accountId = state.app.selectedAccount.id;
    var focusedDocument = state.pendingDocuments.focusedDocument;
    var formValues = _ramda2.default.path(["form", "pendingReceiptForm", "values"], state);
    var newCategories = formValues.categories.map(function (category) {
      return category.label || category;
    });
    var newIssued = _moment2.default.isMoment(formValues.issued) ? formValues.issued.utc().format() : (0, _moment2.default)().utc().format();
    var newDocument = _ramda2.default.merge(focusedDocument, {
      categories: newCategories,
      currency: formValues.currency.key,
      invoiceNumber: formValues.invoiceNumber,
      issued: newIssued,
      notes: formValues.notes,
      paymentType: { type: formValues.formPaymentType.key, lastFourDigits: formValues.cardNumber },
      processingState: "PROCESSED",
      tax: formValues.tax,
      total: formValues.total,
      type: focusedDocument.type === "unknown" ? "receipt" : focusedDocument.type,
      vendor: formValues.vendor
    });
    dispatch((0, _trackingActions.trackEventAction)("Pending document saved"));
    (0, _documents.putDocument)(accountId, focusedDocument.id, newDocument).then(function () {
      reloadPendingDocuments(dispatch);
    });
  };
};

var savePendingOtherDocumentAction = exports.savePendingOtherDocumentAction = function savePendingOtherDocumentAction() {
  return function (dispatch) {
    var state = _store.store.getState();
    var accountId = state.app.selectedAccount.id;
    var focusedDocument = state.pendingDocuments.focusedDocument;
    var formValues = _ramda2.default.path(["form", "pendingOtherDocumentForm", "values"], state);
    var newIssued = formValues.issued ? formValues.issued.utc().format() : (0, _moment2.default)().utc().format();
    var newDocument = {
      id: focusedDocument.id,
      issued: newIssued,
      name: formValues.name,
      notes: formValues.notes,
      processingState: "PROCESSED",
      type: "other"
    };
    dispatch((0, _trackingActions.trackEventAction)("Pending other document saved"));
    (0, _documents.putDocument)(accountId, focusedDocument.id, newDocument).then(function () {
      reloadPendingDocuments(dispatch);
    });
  };
};

var trashPendingDocumentAction = exports.trashPendingDocumentAction = function trashPendingDocumentAction(accountId, document) {
  return function (dispatch) {
    return (0, _documents.putDocument)(accountId, document.id, _ramda2.default.assoc("trashed", true, document)).then(function () {
      reloadPendingDocuments(dispatch);
      dispatch((0, _trackingActions.trackEventAction)("Pending document trashed"));
    });
  };
};

var processAllDocumentsAction = exports.processAllDocumentsAction = function processAllDocumentsAction(pendingDocuments) {
  return function (dispatch) {
    var ajaxPromises = pendingDocuments.map(function (document) {
      var newDocument = _ramda2.default.clone(document);
      newDocument.processingState = "NEEDS_SYSTEM_PROCESSING";
      return (0, _documents.putDocument)(document.accountId, document.id, newDocument);
    });
    return Promise.all(ajaxPromises).then(function (response) {
      var documents = _ramda2.default.map(function (n) {
        return n.data;
      }, response);
      dispatch({
        type: PROCESS_ALL_DOCUMENTS,
        data: { documents: documents }
      });
      dispatch((0, _trackingActions.trackEventAction)("Process all documents"));
      reloadPendingDocuments(dispatch);
    });
  };
};

var cancelProcessingAllDocumentsAction = exports.cancelProcessingAllDocumentsAction = function cancelProcessingAllDocumentsAction(pendingDocuments) {
  return function (dispatch) {
    dispatch({ type: CANCEL_PROCESSING_LOADING });
    var ajaxPromises = pendingDocuments.map(function (document) {
      var newDocument = _ramda2.default.clone(document);
      newDocument.processingState = "NEEDS_USER_PROCESSING";
      return (0, _documents.putDocument)(document.accountId, document.id, newDocument);
    });
    return Promise.all(ajaxPromises).then(function (response) {
      var documents = _ramda2.default.map(function (n) {
        return n.data;
      }, response);
      dispatch({
        type: CANCEL_PROCESSING_ALL_DOCUMENTS,
        data: { documents: documents }
      });
      dispatch({ type: CANCEL_PROCESSING_LOADING_STOP });
      dispatch((0, _trackingActions.trackEventAction)("Cancel processing all documents"));
    });
  };
};

var reprocessPendingDocumentAction = exports.reprocessPendingDocumentAction = function reprocessPendingDocumentAction(document) {
  return function (dispatch) {
    var newDocument = _ramda2.default.clone(document);
    newDocument.processingState = "NEEDS_SYSTEM_PROCESSING";
    dispatch({
      type: REPROCESS_PENDING_DOCUMENT,
      data: { newDocument: newDocument }
    });
    return (0, _documents.putDocument)(document.accountId, document.id, newDocument).then(function () {
      reloadPendingDocuments(dispatch);
    });
  };
};

var changeDocumentTypeAction = exports.changeDocumentTypeAction = function changeDocumentTypeAction(type) {
  return {
    type: CHANGE_DOCUMENT_TYPE,
    data: { type: type }
  };
};

var dropRejectAction = exports.dropRejectAction = function dropRejectAction() {
  return function (dispatch) {
    return dispatch((0, _appActions.setFlashMessageAction)("Upload Failed. Please check that the document is under 8MB and that\n  it is one of the following file types: .jpg, .jpeg, .gif, .png, .tiff, .pdf, .txt, .doc, .docx,\n  .csv, .xls, .xlsx, .ods, .odt", "error"));
  };
};

var filterPendingDocumentsAction = exports.filterPendingDocumentsAction = function filterPendingDocumentsAction(filterType) {
  return function (dispatch) {
    var state = _store.store.getState();
    var pendingDocuments = state.pendingDocuments.pendingDocuments;
    var filter = state.pendingDocuments[filterType];
    var newPendingDocuments = pendingDocuments.filter(function (document) {
      if (filter.key === "status_stuck" && document.processingState === "NEEDS_OVERALL_PROCESSING" && document.queued_for_data_entry === false || filter.key === "status_not_stuck" && document.processingState !== "NEEDS_OVERALL_PROCESSING" || filter.key === "source_email" && document.source.type === "email" || filter.key === "source_mobile" && document.source.type === "mobile" || filter.key === "source_integration" && document.source.type === "integration") {
        return document;
      }
      return null;
    });
    return dispatch({
      type: SET_PENDING_DOCUMENTS,
      data: { newDocuments: newPendingDocuments }
    });
  };
};

var startFiltersModeAction = exports.startFiltersModeAction = function startFiltersModeAction() {
  return {
    type: START_FILTERS_MODE
  };
};

var endFiltersModeAction = exports.endFiltersModeAction = function endFiltersModeAction() {
  return {
    type: END_FILTERS_MODE
  };
};

var addStuckStatusFilterAction = exports.addStuckStatusFilterAction = function addStuckStatusFilterAction(filter) {
  return function (dispatch) {
    dispatch({
      type: ADD_STUCK_STATUS_FILTER,
      data: { filter: filter }
    });
    return dispatch(filterPendingDocumentsAction("statusFilter"));
  };
};

var removeStuckStatusFilterAction = exports.removeStuckStatusFilterAction = function removeStuckStatusFilterAction(accountId) {
  return function (dispatch) {
    dispatch(fetchPendingDocumentsAction(accountId));
    return dispatch({ type: REMOVE_STUCK_STATUS_FILTER });
  };
};

var addSourceFilterAction = exports.addSourceFilterAction = function addSourceFilterAction(filter) {
  return function (dispatch) {
    dispatch({
      type: ADD_SOURCE_FILTER,
      data: { filter: filter }
    });
    return dispatch(filterPendingDocumentsAction("sourceFilter"));
  };
};

var removeSourceFilterAction = exports.removeSourceFilterAction = function removeSourceFilterAction(accountId) {
  return function (dispatch) {
    dispatch(fetchPendingDocumentsAction(accountId));
    return dispatch({ type: REMOVE_SOURCE_FILTER });
  };
};

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InlineTabs = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(32);

var _timesCircle = __webpack_require__(1013);

var _timesCircle2 = _interopRequireDefault(_timesCircle);

var _inlineTabs = __webpack_require__(1307);

var _inlineTabs2 = _interopRequireDefault(_inlineTabs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InlineTabs = exports.InlineTabs = function InlineTabs(_ref) {
  var tabValues = _ref.tabValues;
  return _react2.default.createElement(
    "div",
    { className: _inlineTabs2.default.container },
    tabValues.map(renderTab)
  );
};

var tabValueType = _propTypes2.default.shape({
  name: _propTypes2.default.string,
  path: _propTypes2.default.string,
  isSelected: _propTypes2.default.bool
});

InlineTabs.propTypes = {
  tabValues: _propTypes2.default.arrayOf(tabValueType).isRequired
};

var renderTab = function renderTab(data) {
  if (data.isSelected) {
    return _react2.default.createElement(
      Tab,
      { key: data.name, selected: true },
      renderTabContents(data)
    );
  }
  return _react2.default.createElement(
    Tab,
    { key: data.name, path: data.path },
    renderTabContents(data)
  );
};

var Tab = function Tab(_ref2) {
  var children = _ref2.children,
      path = _ref2.path,
      selected = _ref2.selected;
  return _react2.default.createElement(
    _reactRouter.Link,
    {
      className: selected ? _inlineTabs2.default["tab--selected"] : _inlineTabs2.default.tab,
      to: path
    },
    children
  );
};

Tab.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired,
  path: _propTypes2.default.string,
  selected: _propTypes2.default.bool
};

Tab.defaultProps = {
  path: null,
  selected: false
};

var renderTabContents = function renderTabContents(data) {
  if (!data.isCustom) {
    return data.name;
  }
  return _react2.default.createElement(
    "div",
    { className: _inlineTabs2.default["custom-tab-container"] },
    _react2.default.createElement(
      "span",
      { className: _inlineTabs2.default.name },
      data.name
    ),
    _react2.default.createElement(
      "span",
      { className: _inlineTabs2.default.delete, onClick: function onClick(e) {
          e.preventDefault();data.onDelete();
        } },
      _react2.default.createElement(_timesCircle2.default, { size: 12 })
    )
  );
};

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLastFinancialYear = exports.getThisFinancialYear = undefined;

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getThisFinancialYear = exports.getThisFinancialYear = function getThisFinancialYear(currency) {
  var date = (0, _moment2.default)();
  var thisYear = date.year();

  var _getLocalisedDates = getLocalisedDates(currency, thisYear),
      localisedStartDate = _getLocalisedDates.localisedStartDate,
      localisedEndDate = _getLocalisedDates.localisedEndDate;

  return getFYDateRange(localisedStartDate, localisedEndDate, thisYear, date);
};

var getLastFinancialYear = exports.getLastFinancialYear = function getLastFinancialYear(currency) {
  var _getThisFinancialYear = getThisFinancialYear(currency),
      startDate = _getThisFinancialYear.startDate,
      endDate = _getThisFinancialYear.endDate;

  startDate = startDate.subtract(1, "years");
  endDate = endDate.subtract(1, "years");
  return { startDate: startDate, endDate: endDate };
};

var getLocalisedDates = function getLocalisedDates(currency, thisYear) {
  var localisedStartDate = (0, _moment2.default)().year(thisYear).month(6).startOf("month");
  var localisedEndDate = (0, _moment2.default)().year(thisYear).month(5).endOf("month");
  if (currency === "NZD") {
    localisedStartDate = (0, _moment2.default)().year(thisYear).month(3).startOf("month");
    localisedEndDate = (0, _moment2.default)().year(thisYear).month(2).endOf("month");
  }
  return { localisedStartDate: localisedStartDate, localisedEndDate: localisedEndDate };
};

var getFYDateRange = function getFYDateRange(localisedStartDate, localisedEndDate, thisYear, date) {
  if (date.isAfter(localisedEndDate)) {
    return { startDate: localisedStartDate, endDate: localisedEndDate.year(thisYear + 1) };
  }
  return { startDate: localisedStartDate.year(thisYear - 1), endDate: localisedEndDate };
};

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onHeaderSearch = exports.isShiftPressed = exports.onEnterPressed = undefined;

var _reactRouter = __webpack_require__(32);

var onEnterPressed = exports.onEnterPressed = function onEnterPressed(e, value, action) {
  if (e.key === "Enter") {
    return action(value);
  }
  return null;
};

var isShiftPressed = exports.isShiftPressed = function isShiftPressed(e) {
  if (e.key === "Shift") {
    return true;
  }
  return false;
};

var onHeaderSearch = exports.onHeaderSearch = function onHeaderSearch(e, value, action, selectedAccount, location) {
  if (e.key === "Enter") {
    if (location.pathname === "/accounts/" + selectedAccount.slug + "/documents/all") {
      return action(value);
    }
    _reactRouter.browserHistory.push("/accounts/" + selectedAccount.slug + "/documents/all");
    return action(value);
  }
  return null;
};

/***/ }),
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"dropdown__container___2RyUu","animation":"dropdown__animation___2OjKX","row-container":"dropdown__row-container___13AwU","options":"dropdown__options___1MWni","actions-container":"dropdown__actions-container___2Thv4","cancel":"dropdown__cancel___2ToIr","other-document-animation":"dropdown__other-document-animation___3VIOh","unviewed":"dropdown__unviewed___19DW3","categories-row":"dropdown__categories-row___2_QE1","fields":"dropdown__fields___1RgaK","system":"dropdown__system___2GMbe","handle":"dropdown__handle___3Qpcs","toolbar":"dropdown__toolbar___2uOPQ","right-arrow":"dropdown__right-arrow___1XBEH","dropdown-buttons":"dropdown__dropdown-buttons___bpfZZ","row":"dropdown__row___3iH77","flex":"dropdown__flex___3DLiD","other-flex":"dropdown__other-flex___2UVgt","categories":"dropdown__categories___3Hxr6","export-error":"dropdown__export-error___3qz7b","export-tooltip":"dropdown__export-tooltip___3Lo8b","export-error-text":"dropdown__export-error-text___2vWdm","warning":"dropdown__warning___kFcvJ"};

/***/ }),
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestEnvelopeAction = exports.setCoversheetAction = exports.setSendEnvelopeVisibilityAction = exports.setRequestEnvelopeVisibilityAction = exports.SET_PROCESSING_ENVELOPES = exports.SET_SEND_ENVELOPE_VISIBILITY = exports.SET_REQUEST_ENVELOPE_VISIBILITY = exports.SET_COVERSHEET = undefined;

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _store = __webpack_require__(48);

var _appActions = __webpack_require__(25);

var _envelopes = __webpack_require__(414);

var _trackingActions = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET_COVERSHEET = exports.SET_COVERSHEET = "actions/manage-envelopes/set-coversheet";
var SET_REQUEST_ENVELOPE_VISIBILITY = exports.SET_REQUEST_ENVELOPE_VISIBILITY = "actions/manage-envelopes/set-request-envelope-visibility";
var SET_SEND_ENVELOPE_VISIBILITY = exports.SET_SEND_ENVELOPE_VISIBILITY = "actions/manage-envelopes/set-send-envelope-visibility";
var SET_PROCESSING_ENVELOPES = exports.SET_PROCESSING_ENVELOPES = "actions/envelopes/set-processing-envelopes";

var setRequestEnvelopeVisibilityAction = exports.setRequestEnvelopeVisibilityAction = function setRequestEnvelopeVisibilityAction(visibility) {
  return {
    type: SET_REQUEST_ENVELOPE_VISIBILITY,
    data: { visibility: visibility }
  };
};

var setSendEnvelopeVisibilityAction = exports.setSendEnvelopeVisibilityAction = function setSendEnvelopeVisibilityAction(visibility) {
  return {
    type: SET_SEND_ENVELOPE_VISIBILITY,
    data: { visibility: visibility }
  };
};

var setCoversheetAction = exports.setCoversheetAction = function setCoversheetAction(accountId) {
  return function (dispatch) {
    var authToken = _ramda2.default.path(["oauth", "token"], _store.store.getState());
    var coversheetUrl = "https://api.squirrelstreet.com/v2" + "/accounts/" + accountId + "/coversheet?access_token=" + authToken;
    dispatch({
      type: SET_COVERSHEET,
      data: { coversheetUrl: coversheetUrl }
    });
  };
};

var requestEnvelopeAction = exports.requestEnvelopeAction = function requestEnvelopeAction(accountId) {
  return function (dispatch) {
    return (0, _envelopes.requestEnvelope)(accountId).then(function () {
      dispatch((0, _appActions.setFlashMessageAction)("The squirrels have been informed. An envelope is on its way!"));
      dispatch(setRequestEnvelopeVisibilityAction(false));
      dispatch((0, _trackingActions.trackEventAction)("Envelope requested"));
    }).catch(function (response) {
      dispatch((0, _appActions.setFlashMessageAction)(response.response.data.reason, "error"));
      dispatch(setRequestEnvelopeVisibilityAction(false));
    });
  };
};

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createIncludeRules = exports.saveCategory = exports.deleteCategories = exports.deleteIncludeRule = exports.createCategory = exports.fetchCategories = undefined;

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _http = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchCategories = exports.fetchCategories = function fetchCategories(accountId) {
  return _http.http.get("/accounts/" + accountId + "/categories").then(function (response) {
    var categories = _ramda2.default.pathOr([], ["data", "categories"], response);
    return { categories: categories, response: response };
  });
};

var createCategory = exports.createCategory = function createCategory(accountId, data) {
  return _http.http.post("/accounts/" + accountId + "/categories", { name: data });
};

var deleteIncludeRule = exports.deleteIncludeRule = function deleteIncludeRule(accountId, categoryId, ruleId) {
  return _http.http.delete("/accounts/" + accountId + "/categories/" + categoryId + "/rules/vendors/" + ruleId);
};

var deleteCategories = exports.deleteCategories = function deleteCategories(accountId, selectedCategoryIds) {
  var ajaxPromises = selectedCategoryIds.map(function (id) {
    return _http.http.delete("/accounts/" + accountId + "/categories/" + id);
  });
  return Promise.all(ajaxPromises);
};

var saveCategory = exports.saveCategory = function saveCategory(accountId, category) {
  return _http.http.put("/accounts/" + accountId + "/categories/" + category.id, category);
};

var createIncludeRules = exports.createIncludeRules = function createIncludeRules(accountId, categoryId, newRules) {
  var ajaxPromises = newRules.map(function (rule) {
    var newRule = _ramda2.default.clone(rule);
    newRule.vendorName = rule.name || rule.vendorName;
    newRule.action = "include";
    return _http.http.post("accounts/" + accountId + "/categories/" + categoryId + "/rules/vendors", newRule);
  });
  return Promise.all(ajaxPromises);
};

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkbox = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _checkbox = __webpack_require__(1301);

var _checkbox2 = _interopRequireDefault(_checkbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Checkbox = exports.Checkbox = function Checkbox(_ref) {
  var checked = _ref.checked,
      disabled = _ref.disabled,
      onChange = _ref.onChange;
  return _react2.default.createElement("button", { className: classNames(checked), disabled: disabled, onClick: onChange, type: "button" });
};

Checkbox.propTypes = {
  checked: _propTypes2.default.bool.isRequired,
  disabled: _propTypes2.default.bool,
  onChange: _propTypes2.default.func.isRequired
};

Checkbox.defaultProps = {
  disabled: false
};

var classNames = function classNames(checked) {
  return checked ? _checkbox2.default["container--checked"] : _checkbox2.default.container;
};

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Datepicker = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDatepicker = __webpack_require__(193);

var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);

var _customPropTypes = __webpack_require__(5);

__webpack_require__(508);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Datepicker = exports.Datepicker = function Datepicker(_ref) {
  var children = _ref.children,
      isClearable = _ref.isClearable,
      onDateSelected = _ref.onDateSelected,
      selected = _ref.selected,
      placeholderText = _ref.placeholderText;
  return _react2.default.createElement(
    _reactDatepicker2.default,
    {
      dateFormat: ["DD/MM/YYYY", "DD/MM/YY", "D/M/YY", "D/M/YYYY"],
      isClearable: isClearable,
      onChange: dateSelector(onDateSelected),
      placeholderText: placeholderText,
      selected: selected
    },
    children
  );
};

var dateSelector = function dateSelector(onDateSelected) {
  return function (date) {
    return onDateSelected(date);
  };
};

Datepicker.propTypes = {
  children: _propTypes2.default.element,
  isClearable: _propTypes2.default.bool.isRequired,
  onDateSelected: _propTypes2.default.func.isRequired, // (date) => void
  placeholderText: _propTypes2.default.string.isRequired,
  selected: _propTypes2.default.oneOfType([_customPropTypes.momentType, _propTypes2.default.string])
};

Datepicker.defaultProps = {
  children: null,
  selected: null
};

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.labelForExportType = exports.ExportTypeSelector = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _customPropTypes = __webpack_require__(5);

var _checkIntegration = __webpack_require__(274);

var _select = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExportTypeSelector = exports.ExportTypeSelector = function ExportTypeSelector(_ref) {
  var categories = _ref.categories,
      onChange = _ref.onChange;

  var integrationStatus = (0, _checkIntegration.findIntegrationInUse)(categories);
  var integrationText = (0, _checkIntegration.getIntegrationText)(integrationStatus, "", "Accounting software");
  var newOptions = _ramda2.default.clone(options);
  newOptions[0].name = integrationText;
  return _react2.default.createElement(_select.SimpleSelect, { data: newOptions, onChange: onChange, placeholder: "Select export type..." });
};

ExportTypeSelector.propTypes = {
  categories: _propTypes2.default.arrayOf(_customPropTypes.categoryType).isRequired,
  onChange: _propTypes2.default.func.isRequired // ({ key: string, name: string}) => void
};

var options = [{ disabled: true, key: "label2", name: "Accounting Software" }, { key: "accounting", name: "Has been exported" }, { key: "not-accounting", name: "Has not been exported" }, { disabled: true, key: "label0", name: "CSV" }, { key: "csv", name: "Has been exported to CSV" }, { key: "not-csv", name: "Has not been exported to CSV" }, { disabled: true, key: "label1", name: "PDF" }, { key: "pdf", name: "Has been exported to PDF" }, { key: "not-pdf", name: "Has not been exported to PDF" }];

var labelForExportType = exports.labelForExportType = function labelForExportType(exportType) {
  return (options.find(function (option) {
    return option.key === exportType;
  }) || {}).name;
};

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimpleDateCellFormatter = exports.DateCellFormatter = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _reactDatepicker = __webpack_require__(193);

var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);

var _customPropTypes = __webpack_require__(5);

var _validators = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DateCellFormatter = exports.DateCellFormatter = function DateCellFormatter(_ref) {
  var accountId = _ref.accountId,
      document = _ref.document,
      isFocused = _ref.isFocused,
      onUpdateInlineDocument = _ref.onUpdateInlineDocument,
      value = _ref.value;

  if (isFocused) {
    var datepickerValue = value ? (0, _moment2.default)(value) : (0, _moment2.default)();
    return _react2.default.createElement(_reactDatepicker2.default, {
      dateFormat: ["DD/MM/YYYY", "DD/MM/YY", "D/M/YY", "D/M/YYYY"],
      isClearable: false,
      onChange: function onChange(e) {
        return onUpdateInlineDocument({ accountId: accountId, document: document, field: "issued", value: e.utc().format() });
      },
      placeholderText: "Select a date...",
      selected: datepickerValue
    });
  }
  return _react2.default.createElement(SimpleDateCellFormatter, { value: value });
};

DateCellFormatter.defaultProps = {
  value: null
};

DateCellFormatter.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  document: _customPropTypes.documentPropType.isRequired,
  isFocused: _propTypes2.default.bool.isRequired,
  onUpdateInlineDocument: _propTypes2.default.func.isRequired,
  value: _propTypes2.default.string
};

var SimpleDateCellFormatter = exports.SimpleDateCellFormatter = function SimpleDateCellFormatter(_ref2) {
  var value = _ref2.value;

  if (!(0, _validators.isValidValue)(value)) {
    return _react2.default.createElement("span", null);
  }
  return _react2.default.createElement(
    "span",
    { title: (0, _moment2.default)(value).fromNow() },
    (0, _moment2.default)(value).format("DD/MM/YY")
  );
};

SimpleDateCellFormatter.defaultProps = {
  value: null
};

SimpleDateCellFormatter.propTypes = {
  value: _propTypes2.default.string
};

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeOtherDocumentsColumnObjects = exports.mergeDocumentsColumnObjects = exports.otherDocsColumnObjects = exports.columnObjects = undefined;

var _categoryCellFormatter = __webpack_require__(431);

var _paymentTypeCellFormatter = __webpack_require__(434);

var _viewedCellFormatter = __webpack_require__(437);

var _downloadUrlCellFormatter = __webpack_require__(432);

var _uploadSourceCellFormatter = __webpack_require__(436);

var _moneyCellFormatter = __webpack_require__(433);

var _dateCellFormatter = __webpack_require__(269);

var _timeCellFormatter = __webpack_require__(886);

var _nameCellFormatter = __webpack_require__(885);

var _selectCellFormatter = __webpack_require__(435);

var _attachmentCellFormatter = __webpack_require__(881);

var columnObjects = exports.columnObjects = [{
  key: "select",
  name: "Select",
  visible: true,
  fixedWidth: 40,
  width: 0
}, {
  key: "type",
  name: "Type",
  visible: true,
  fixedWidth: 40,
  width: 0
}, {
  key: "vendor",
  name: "Vendor/Name",
  resizable: true,
  sortable: true,
  visible: true,
  width: 0.15
}, {
  formatter: _dateCellFormatter.DateCellFormatter,
  key: "issued",
  name: "Date",
  resizable: true,
  sortable: true,
  visible: true,
  fixedWidth: 80,
  width: 0
}, {
  formatter: _moneyCellFormatter.MoneyCellFormatter,
  key: "total",
  name: "Total",
  resizable: true,
  sortable: true,
  visible: true,
  width: 0.15
}, {
  formatter: _moneyCellFormatter.MoneyCellFormatter,
  key: "tax",
  name: "Tax",
  resizable: true,
  sortable: true,
  visible: true,
  width: 0.10
}, {
  formatter: _categoryCellFormatter.CategoryCellFormatter,
  key: "categories",
  name: "Category",
  resizable: true,
  visible: true,
  width: 0.4
}, {
  key: "invoiceNumber",
  name: "Invoice #",
  resizable: true,
  visible: false,
  width: 0.1
}, {
  formatter: _paymentTypeCellFormatter.PaymentTypeCellFormatter,
  key: "paymentType",
  name: "Payment type",
  resizable: true,
  sortable: true,
  visible: false,
  width: 0.1
}, {
  formatter: _timeCellFormatter.TimeCellFormatter,
  key: "uploaded",
  name: "Uploaded",
  resizable: true,
  sortable: true,
  visible: true,
  fixedWidth: 70,
  width: 0
}, {
  formatter: _downloadUrlCellFormatter.DownloadUrlCellFormatter,
  key: "downloadUrl",
  name: "DL",
  resizable: true,
  visible: false,
  fixedWidth: 40,
  width: 0
}, {
  formatter: _uploadSourceCellFormatter.UploadSourceCellFormatter,
  key: "source",
  name: "Source",
  resizable: true,
  visible: false,
  fixedWidth: 55,
  width: 0
}];

var otherDocsColumnObjects = exports.otherDocsColumnObjects = [{
  key: "select",
  visible: true
}, {
  formatter: _nameCellFormatter.NameCellFormatter,
  key: "name",
  name: "Name",
  resizable: true,
  sortable: true,
  visible: true,
  width: 200
}, {
  formatter: _dateCellFormatter.DateCellFormatter,
  key: "issued",
  name: "Date",
  resizable: true,
  sortable: true,
  visible: true,
  width: 150
}, {
  key: "notes",
  name: "Notes",
  resizable: true,
  sortable: false,
  visible: true
}, {
  formatter: _timeCellFormatter.TimeCellFormatter,
  key: "uploaded",
  name: "Uploaded at",
  resizable: true,
  sortable: true,
  visible: true
}, {
  formatter: _viewedCellFormatter.ViewedCellFormatter,
  key: "viewed",
  name: "Viewed",
  resizable: true,
  sortable: true,
  visible: true
}, {
  formatter: _downloadUrlCellFormatter.DownloadUrlCellFormatter,
  key: "downloadUrl",
  name: "Download",
  resizable: true,
  sortable: false,
  visible: true
}, {
  formatter: _uploadSourceCellFormatter.UploadSourceCellFormatter,
  key: "source",
  name: "Upload Source",
  resizable: true,
  sortable: true,
  visible: true
}];

var mergeDocumentsColumnObjects = exports.mergeDocumentsColumnObjects = [{
  formatter: _selectCellFormatter.SelectCellFormatter,
  key: "isSelected",
  name: ""
}, {
  formatter: _attachmentCellFormatter.AttachmentCellFormatter,
  key: "attachment",
  name: "Image"
}, {
  key: "vendor",
  name: "Vendor"
}, {
  formatter: _dateCellFormatter.SimpleDateCellFormatter,
  key: "issued",
  name: "Date"
}, {
  formatter: _moneyCellFormatter.SimpleMoneyCellFormatter,
  getRowMetaData: function getRowMetaData(row) {
    return row;
  },
  key: "total",
  name: "Total"
}, {
  key: "currency",
  name: "Currency"
}, {
  formatter: _moneyCellFormatter.SimpleMoneyCellFormatter,
  key: "tax",
  name: "Tax"
}, {
  formatter: _categoryCellFormatter.CategoryCellFormatter,
  key: "categories",
  name: "Category"
}, {
  key: "invoiceNumber",
  name: "Invoice #"
}, {
  formatter: _paymentTypeCellFormatter.PaymentTypeCellFormatter,
  key: "paymentType",
  name: "Payment type"
}];

var mergeOtherDocumentsColumnObjects = exports.mergeOtherDocumentsColumnObjects = [{
  formatter: _selectCellFormatter.SelectCellFormatter,
  key: "isSelected",
  name: ""
}, {
  formatter: _attachmentCellFormatter.AttachmentCellFormatter,
  key: "attachment",
  name: "Image"
}, {
  key: "name",
  name: "Name"
}, {
  formatter: _dateCellFormatter.DateCellFormatter,
  key: "issued",
  name: "Date"
}];

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SettingsInlineTabs = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _inlineTabs = __webpack_require__(196);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SettingsInlineTabs = exports.SettingsInlineTabs = function SettingsInlineTabs(_ref) {
  var currentPage = _ref.currentPage,
      slug = _ref.slug;
  return _react2.default.createElement(_inlineTabs.InlineTabs, { tabValues: tabValues(currentPage, slug) });
};

SettingsInlineTabs.propTypes = {
  currentPage: _propTypes2.default.oneOf(["account", "user", "integration"]).isRequired,
  slug: _propTypes2.default.string.isRequired
};

var tabValues = function tabValues(currentPage, slug) {
  return [{
    name: "Account Settings",
    path: "/accounts/" + slug + "/settings/account/usage",
    isSelected: currentPage === "account"
  }, {
    name: "User Settings",
    path: "/accounts/" + slug + "/settings/user/info",
    isSelected: currentPage === "user"
  }, {
    name: "Integration Settings",
    path: "/accounts/" + slug + "/settings/integration",
    isSelected: currentPage === "integration"
  }];
};

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentTypeSelector = exports.ProcessingFields = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _processingFields = __webpack_require__(326);

var _processingFields2 = _interopRequireDefault(_processingFields);

var _receiptFields = __webpack_require__(947);

var _otherFields = __webpack_require__(942);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _customPropTypes = __webpack_require__(5);

var _stringHelpers = __webpack_require__(68);

var _select = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProcessingFields = exports.ProcessingFields = function ProcessingFields(props) {
  var focusedDocument = props.focusedDocument;

  var newCurrency = focusedDocument.currency || props.preferredCurrency;
  var initialValues = {
    categories: focusedDocument.categories || [],
    cardNumber: null,
    currency: { key: newCurrency, name: newCurrency },
    formPaymentType: { key: "credit-card", name: "Card" },
    invoiceNumber: focusedDocument.invoiceNumber || "",
    issued: focusedDocument.issued || "",
    notes: focusedDocument.notes || "",
    tax: focusedDocument.tax || 0,
    total: focusedDocument.total || 0,
    vendor: focusedDocument.vendor || ""
  };

  if (focusedDocument !== null) {
    if (props.documentType === "receipt") {
      return _react2.default.createElement(
        "div",
        { className: _processingFields2.default["fields-container"] },
        _react2.default.createElement(_receiptFields.ReceiptFields, _extends({}, props, {
          dateSelection: dateSelection,
          initialValues: initialValues,
          makeMomentObj: makeMomentObj,
          valueMapper: valueMapper
        }))
      );
    }
    return _react2.default.createElement(
      "div",
      { className: _processingFields2.default["fields-container"] },
      _react2.default.createElement(_otherFields.OtherFields, _extends({}, props, {
        dateSelection: dateSelection,
        makeMomentObj: makeMomentObj,
        valueMapper: valueMapper
      }))
    );
  }
  return null;
};

ProcessingFields.defaultProps = {
  focusedDocument: null
};

ProcessingFields.propTypes = {
  documentType: _propTypes2.default.string.isRequired,
  focusedDocument: _customPropTypes.documentPropType,
  preferredCurrency: _propTypes2.default.string.isRequired
};

var documentTypes = [{ key: "receipt", name: "Receipt" }, { key: "other", name: "Other" }];

var valueMapper = function valueMapper(value) {
  return { name: value, key: value };
};
var makeMomentObj = function makeMomentObj(date) {
  return (0, _moment2.default)(date);
};
var dateSelection = function dateSelection(e, onUpdateDocument) {
  var momentInstance = e === null ? (0, _moment2.default)() : (0, _moment2.default)(e);
  onUpdateDocument("issued", momentInstance.utc().format());
};

var DocumentTypeSelector = exports.DocumentTypeSelector = function DocumentTypeSelector(_ref) {
  var documentType = _ref.documentType,
      onChangeDocumentType = _ref.onChangeDocumentType;
  return _react2.default.createElement(
    "div",
    { className: _processingFields2.default.section },
    _react2.default.createElement(
      "h4",
      null,
      "Document type"
    ),
    _react2.default.createElement(
      "div",
      { className: _processingFields2.default["fields-wrapper"] },
      _react2.default.createElement(_select.Select, {
        clearable: false,
        data: documentTypes,
        onChange: function onChange(e) {
          onChangeDocumentType(e.key);
        },
        placeholder: "Choose a document type",
        value: valueMapper((0, _stringHelpers.capitalize)(documentType))
      })
    )
  );
};

DocumentTypeSelector.propTypes = {
  documentType: _propTypes2.default.string.isRequired,
  onChangeDocumentType: _propTypes2.default.func.isRequired
};

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UploadInlineTabs = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _uploadInlineTabs = __webpack_require__(1374);

var _uploadInlineTabs2 = _interopRequireDefault(_uploadInlineTabs);

var _inlineTabs = __webpack_require__(196);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UploadInlineTabs = exports.UploadInlineTabs = function UploadInlineTabs(_ref) {
  var accountSlug = _ref.accountSlug,
      currentPage = _ref.currentPage;
  return _react2.default.createElement(
    "div",
    { className: _uploadInlineTabs2.default.container + " manual3" },
    _react2.default.createElement(_inlineTabs.InlineTabs, { tabValues: tabValues(currentPage, accountSlug) })
  );
};

UploadInlineTabs.propTypes = {
  accountSlug: _propTypes2.default.string.isRequired,
  currentPage: _propTypes2.default.oneOf(["upload", "awaiting-digital", "awaiting-mailin"]).isRequired
};

var tabValues = function tabValues(currentPage, accountSlug) {
  return [{
    name: "Upload",
    path: "/accounts/" + accountSlug + "/upload",
    isSelected: currentPage === "upload"
  }, {
    name: "Awaiting Digital Submissions",
    path: "/accounts/" + accountSlug + "/awaiting-digital",
    isSelected: currentPage === "awaiting-digital"
  }, {
    name: "Awaiting Mail in",
    path: "/accounts/" + accountSlug + "/awaiting-mailin",
    isSelected: currentPage === "awaiting-mailin"
  }];
};

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIntegrationText = exports.findIntegrationInUse = undefined;

var _validators = __webpack_require__(36);

var glPrefixes = ["Xero", "MYOB", "SageOne", "QBO", "SaasuV2"];

var findIntegrationInUse = exports.findIntegrationInUse = function findIntegrationInUse(categories) {
  return glPrefixes.find(function (prefix) {
    return categories.some(function (category) {
      return category.name.startsWith(prefix);
    });
  });
};

var getIntegrationText = exports.getIntegrationText = function getIntegrationText(integrationStatus, integrationText, noIntegrationText) {
  if ((0, _validators.isValidValue)(integrationStatus)) {
    return integrationText + " " + integrationStatus;
  }
  return noIntegrationText;
};

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var paymentTypes = exports.paymentTypes = [{ key: "credit-card", name: "Card" }, { key: "cash", name: "Cash" }, { key: "check", name: "Cheque" }, { key: "paypal", name: "PayPal" }, { key: "other", name: "Other" }];

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__(24);

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaExclamationTriangle = function FaExclamationTriangle(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm22.9 30.7v-4.2q0-0.4-0.3-0.6t-0.5-0.2h-4.2q-0.3 0-0.5 0.2t-0.3 0.6v4.2q0 0.3 0.3 0.5t0.5 0.2h4.2q0.3 0 0.5-0.2t0.3-0.5z m-0.1-8.4l0.4-10.2q0-0.3-0.2-0.4-0.3-0.3-0.5-0.3h-5q-0.2 0-0.5 0.3-0.2 0.1-0.2 0.4l0.4 10.2q0 0.3 0.2 0.4t0.5 0.2h4.2q0.3 0 0.5-0.2t0.2-0.4z m-0.3-20.8l17.1 31.4q0.8 1.4 0 2.8-0.4 0.7-1 1.1t-1.5 0.3h-34.2q-0.8 0-1.5-0.3t-1-1.1q-0.8-1.4 0-2.8l17.1-31.4q0.4-0.7 1.1-1.1t1.4-0.4 1.4 0.4 1.1 1.1z' })
        )
    );
};

exports.default = FaExclamationTriangle;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__(24);

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaSearch = function FaSearch(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm27.2 18.6q0-4.2-2.9-7.1t-7.1-2.9-7 2.9-3 7.1 2.9 7 7.1 3 7.1-3 2.9-7z m11.4 18.5q0 1.2-0.8 2.1t-2 0.8q-1.2 0-2-0.8l-7.7-7.7q-4 2.8-8.9 2.8-3.2 0-6.1-1.3t-5-3.3-3.4-5-1.2-6.1 1.2-6.1 3.4-5.1 5-3.3 6.1-1.2 6.1 1.2 5 3.3 3.4 5.1 1.2 6.1q0 4.9-2.7 8.9l7.6 7.6q0.8 0.9 0.8 2z' })
        )
    );
};

exports.default = FaSearch;

/***/ }),
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"dashboard__container___2JyA3","dashboard":"dashboard__dashboard___3otJX","usage-container":"dashboard__usage-container___2FLpi","upload":"dashboard__upload___1a556","ruler":"dashboard__ruler___14wDP"};

/***/ }),
/* 323 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"active-filters__container___2vQ_F","active-filter-group":"active-filters__active-filter-group___u0Uaf","group-title":"active-filters__group-title___1MsRC"};

/***/ }),
/* 324 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"title":"document-filters__title___2XmOX","field-cell":"document-filters__field-cell___2n39X","container":"document-filters__container___SCjoB","payment-type":"document-filters__payment-type___10zan","fields":"document-filters__fields___3EhVq","search":"document-filters__search___1BPXz","search-button":"document-filters__search-button___31Djs","name":"document-filters__name___1uDpw","close":"document-filters__close___Nb23H","trash":"document-filters__trash___96tbs","trash-icon":"document-filters__trash-icon___19zFW","end-container":"document-filters__end-container___1GCrd","start-container":"document-filters__start-container___3JSp1","total":"document-filters__total___2-cf7","plus-button":"document-filters__plus-button___TIvhT"};

/***/ }),
/* 325 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"focus-cell-formatters__container___2doGj","input":"focus-cell-formatters__input___1rXyS","currency":"focus-cell-formatters__currency___3Uakh","tooltip-top":"focus-cell-formatters__tooltip-top___61fPu","tooltip-bottom":"focus-cell-formatters__tooltip-bottom___1DJvx"};

/***/ }),
/* 326 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"fields-container":"processing-fields__fields-container___zMAuC","fields-wrapper":"processing-fields__fields-wrapper___1UHty","section":"processing-fields__section___13uhb","save":"processing-fields__save___2AAru","trash":"processing-fields__trash___BI8JD","reprocess":"processing-fields__reprocess___38gij"};

/***/ }),
/* 327 */,
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/img/open-squirrel.83998c58ff.svg";

/***/ }),
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var createResizeDetector = _interopDefault(__webpack_require__(1289));
var React = __webpack_require__(0);
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(__webpack_require__(1));
var ReactDOM = _interopDefault(__webpack_require__(44));
var invariant = _interopDefault(__webpack_require__(33));
var throttle = _interopDefault(__webpack_require__(1512));
var debounce = _interopDefault(__webpack_require__(1507));
var isShallowEqual = _interopDefault(__webpack_require__(1978));

var instances = {};

// Lazily require to not cause bug
// https://github.com/ctrlplusb/react-sizeme/issues/6
function resizeDetector() {
  var strategy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'scroll';

  if (!instances[strategy]) {
    instances[strategy] = createResizeDetector({
      strategy: strategy
    });
  }

  return instances[strategy];
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

/* eslint-disable react/no-multi-comp */

var defaultConfig = {
  monitorWidth: true,
  monitorHeight: false,
  monitorPosition: false,
  refreshRate: 16,
  refreshMode: 'throttle',
  noPlaceholder: false,
  resizeDetectorStrategy: 'scroll'
};

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

/**
 * This is a utility wrapper component that will allow our higher order
 * component to get a ref handle on our wrapped components html.
 * @see https://gist.github.com/jimfb/32b587ee6177665fb4cf
 */

var ReferenceWrapper = function (_Component) {
  inherits(ReferenceWrapper, _Component);

  function ReferenceWrapper() {
    classCallCheck(this, ReferenceWrapper);
    return possibleConstructorReturn(this, (ReferenceWrapper.__proto__ || Object.getPrototypeOf(ReferenceWrapper)).apply(this, arguments));
  }

  createClass(ReferenceWrapper, [{
    key: 'render',
    value: function render() {
      return React.Children.only(this.props.children);
    }
  }]);
  return ReferenceWrapper;
}(React.Component);

ReferenceWrapper.displayName = 'SizeMeReferenceWrapper';

ReferenceWrapper.propTypes = { children: PropTypes.element.isRequired };

function Placeholder(_ref) {
  var className = _ref.className,
      style = _ref.style;

  // Lets create the props for the temp element.
  var phProps = {};

  // We will use any provided className/style or else make the temp
  // container take the full available space.
  if (!className && !style) {
    phProps.style = { width: '100%', height: '100%' };
  } else {
    if (className) {
      phProps.className = className;
    }
    if (style) {
      phProps.style = style;
    }
  }

  return React__default.createElement('div', phProps);
}
Placeholder.displayName = 'SizeMePlaceholder';
Placeholder.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object

  /**
   * As we need to maintain a ref on the root node that is rendered within our
   * SizeMe component we need to wrap our entire render in a sub component.
   * Without this, we lose the DOM ref after the placeholder is removed from
   * the render and the actual component is rendered.
   * It took me forever to figure this out, so tread extra careful on this one!
   */
};var renderWrapper = function renderWrapper(WrappedComponent) {
  function SizeMeRenderer(props) {
    var explicitRef = props.explicitRef,
        className = props.className,
        style = props.style,
        size = props.size,
        disablePlaceholder = props.disablePlaceholder,
        onSize = props.onSize,
        restProps = objectWithoutProperties(props, ['explicitRef', 'className', 'style', 'size', 'disablePlaceholder', 'onSize']);


    var noSizeData = size == null || size.width == null && size.height == null && size.position == null;

    var renderPlaceholder = noSizeData && !disablePlaceholder;

    var renderProps = {
      className: className,
      style: style
    };

    if (size != null) {
      renderProps.size = size;
    }

    var toRender = renderPlaceholder ? React__default.createElement(Placeholder, { className: className, style: style }) : React__default.createElement(WrappedComponent, _extends({}, renderProps, restProps));

    return React__default.createElement(
      ReferenceWrapper,
      { ref: explicitRef },
      toRender
    );
  }

  SizeMeRenderer.displayName = 'SizeMeRenderer(' + getDisplayName(WrappedComponent) + ')';

  SizeMeRenderer.propTypes = {
    explicitRef: PropTypes.func.isRequired,
    className: PropTypes.string,
    style: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    size: PropTypes.shape({
      width: PropTypes.number, // eslint-disable-line react/no-unused-prop-types
      height: PropTypes.number // eslint-disable-line react/no-unused-prop-types
    }),
    disablePlaceholder: PropTypes.bool,
    onSize: PropTypes.func
  };

  return SizeMeRenderer;
};

/**
 * :: config -> Component -> WrappedComponent
 *
 * Higher order component that allows the wrapped component to become aware
 * of it's size, by receiving it as an object within it's props.
 *
 * @param  monitorWidth
 *   Default true, whether changes in the element's width should be monitored,
 *   causing a size property to be broadcast.
 * @param  monitorHeight
 *   Default false, whether changes in the element's height should be monitored,
 *   causing a size property to be broadcast.
 *
 * @return The wrapped component.
 */
function withSize() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultConfig;
  var _config$monitorWidth = config.monitorWidth,
      monitorWidth = _config$monitorWidth === undefined ? defaultConfig.monitorWidth : _config$monitorWidth,
      _config$monitorHeight = config.monitorHeight,
      monitorHeight = _config$monitorHeight === undefined ? defaultConfig.monitorHeight : _config$monitorHeight,
      _config$monitorPositi = config.monitorPosition,
      monitorPosition = _config$monitorPositi === undefined ? defaultConfig.monitorPosition : _config$monitorPositi,
      _config$refreshRate = config.refreshRate,
      refreshRate = _config$refreshRate === undefined ? defaultConfig.refreshRate : _config$refreshRate,
      _config$refreshMode = config.refreshMode,
      refreshMode = _config$refreshMode === undefined ? defaultConfig.refreshMode : _config$refreshMode,
      _config$noPlaceholder = config.noPlaceholder,
      noPlaceholder = _config$noPlaceholder === undefined ? defaultConfig.noPlaceholder : _config$noPlaceholder,
      _config$resizeDetecto = config.resizeDetectorStrategy,
      resizeDetectorStrategy = _config$resizeDetecto === undefined ? defaultConfig.resizeDetectorStrategy : _config$resizeDetecto;


  invariant(monitorWidth || monitorHeight || monitorPosition, 'You have to monitor at least one of the width, height, or position when using "sizeMe"');

  invariant(refreshRate >= 16, "It is highly recommended that you don't put your refreshRate lower than " + '16 as this may cause layout thrashing.');

  invariant(refreshMode === 'throttle' || refreshMode === 'debounce', 'The refreshMode should have a value of "throttle" or "debounce"');

  var refreshDelayStrategy = refreshMode === 'throttle' ? throttle : debounce;

  return function WrapComponent(WrappedComponent) {
    var SizeMeRenderWrapper = renderWrapper(WrappedComponent);

    var SizeAwareComponent = function (_React$Component) {
      inherits(SizeAwareComponent, _React$Component);

      function SizeAwareComponent() {
        var _ref2;

        var _temp, _this2, _ret;

        classCallCheck(this, SizeAwareComponent);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this2 = possibleConstructorReturn(this, (_ref2 = SizeAwareComponent.__proto__ || Object.getPrototypeOf(SizeAwareComponent)).call.apply(_ref2, [this].concat(args))), _this2), _this2.state = {
          width: undefined,
          height: undefined,
          position: undefined
        }, _this2.determineStrategy = function (props) {
          if (props.onSize) {
            if (!_this2.callbackState) {
              _this2.callbackState = _extends({}, _this2.state);
            }
            _this2.strategy = 'callback';
          } else {
            _this2.strategy = 'render';
          }
        }, _this2.strategisedSetState = function (state) {
          if (_this2.strategy === 'callback') {
            _this2.callbackState = state;
            _this2.props.onSize(state);
          }
          _this2.setState(state);
        }, _this2.strategisedGetState = function () {
          return _this2.strategy === 'callback' ? _this2.callbackState : _this2.state;
        }, _this2.refCallback = function (element) {
          _this2.element = element;
        }, _this2.hasSizeChanged = function (current, next) {
          var c = current;
          var n = next;
          var cp = c.position || {};
          var np = n.position || {};

          return monitorHeight && c.height !== n.height || monitorPosition && (cp.top !== np.top || cp.left !== np.left || cp.bottom !== np.bottom || cp.right !== np.right) || monitorWidth && c.width !== n.width;
        }, _this2.checkIfSizeChanged = refreshDelayStrategy(function (el) {
          var _el$getBoundingClient = el.getBoundingClientRect(),
              width = _el$getBoundingClient.width,
              height = _el$getBoundingClient.height,
              right = _el$getBoundingClient.right,
              left = _el$getBoundingClient.left,
              top = _el$getBoundingClient.top,
              bottom = _el$getBoundingClient.bottom;

          var next = {
            width: monitorWidth ? width : null,
            height: monitorHeight ? height : null,
            position: monitorPosition ? { right: right, left: left, top: top, bottom: bottom } : null
          };

          if (_this2.hasSizeChanged(_this2.strategisedGetState(), next)) {
            _this2.strategisedSetState(next);
          }
        }, refreshRate), _temp), possibleConstructorReturn(_this2, _ret);
      }

      createClass(SizeAwareComponent, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.detector = resizeDetector(resizeDetectorStrategy);
          this.determineStrategy(this.props);
          this.handleDOMNode(true);
        }
      }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
          this.determineStrategy(nextProps);
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
          this.handleDOMNode();
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          // Change our size checker to a noop just in case we have some
          // late running events.
          this.hasSizeChanged = function () {
            return undefined;
          };
          this.checkIfSizeChanged = function () {
            return undefined;
          };

          if (this.domEl) {
            this.detector.uninstall(this.domEl);
            this.domEl = null;
          }
        }
      }, {
        key: 'handleDOMNode',
        value: function handleDOMNode(first) {
          var found = this.element && ReactDOM.findDOMNode(this.element);

          if (!found) {
            // If we previously had a dom node then we need to ensure that
            // we remove any existing listeners to avoid memory leaks.
            if (!first && this.domEl) {
              this.detector.removeAllListeners(this.domEl);
              this.domEl = null;
            }
            return;
          }

          if (!first && this.domEl) {
            this.detector.removeAllListeners(this.domEl);
          }

          this.domEl = found;
          this.detector.listenTo(this.domEl, this.checkIfSizeChanged);
        }
      }, {
        key: 'render',
        value: function render() {
          var disablePlaceholder = withSize.enableSSRBehaviour || withSize.noPlaceholders || noPlaceholder || this.strategy === 'callback';

          var size = _extends({}, this.state);

          return React__default.createElement(SizeMeRenderWrapper, _extends({
            explicitRef: this.refCallback,
            size: this.strategy === 'callback' ? null : size,
            disablePlaceholder: disablePlaceholder
          }, this.props));
        }
      }]);
      return SizeAwareComponent;
    }(React__default.Component);

    SizeAwareComponent.displayName = 'SizeMe(' + getDisplayName(WrappedComponent) + ')';
    SizeAwareComponent.propTypes = {
      onSize: PropTypes.func
    };


    SizeAwareComponent.WrappedComponent = WrappedComponent;

    return SizeAwareComponent;
  };
}

/**
 * Allow SizeMe to run within SSR environments.  This is a "global" behaviour
 * flag that should be set within the initialisation phase of your application.
 *
 * Warning: don't set this flag unless you need to as using it may cause
 * extra render cycles to happen within your components depending on the logic
 * contained within them around the usage of the `size` data.
 *
 * DEPRECATED: Please use the global disablePlaceholders
 */
withSize.enableSSRBehaviour = false;

/**
 * Global configuration allowing to disable placeholder rendering for all
 * sizeMe components.
 */
withSize.noPlaceholders = false;

var SizeMe = function (_Component) {
  inherits(SizeMe, _Component);

  function SizeMe(props) {
    classCallCheck(this, SizeMe);

    var _this = possibleConstructorReturn(this, (SizeMe.__proto__ || Object.getPrototypeOf(SizeMe)).call(this, props));

    _initialiseProps.call(_this);

    var children = props.children,
        render = props.render,
        sizeMeConfig = objectWithoutProperties(props, ['children', 'render']);

    _this.createComponent(sizeMeConfig);
    _this.state = {
      size: {
        width: undefined,
        height: undefined
      }
    };
    return _this;
  }

  createClass(SizeMe, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          prevChildren = _props.children,
          prevRender = _props.render,
          prevSizeMeConfig = objectWithoutProperties(_props, ['children', 'render']);
      var nextChildren = nextProps.children,
          nextRender = nextProps.render,
          nextSizeMeConfig = objectWithoutProperties(nextProps, ['children', 'render']);

      if (!isShallowEqual(prevSizeMeConfig, nextSizeMeConfig)) {
        this.createComponent(nextSizeMeConfig);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var SizeAware = this.SizeAware;

      var render = this.props.children || this.props.render;
      return React__default.createElement(
        SizeAware,
        { onSize: this.onSize },
        render({ size: this.state.size })
      );
    }
  }]);
  return SizeMe;
}(React.Component);

SizeMe.propTypes = {
  children: PropTypes.func,
  render: PropTypes.func
};
SizeMe.defaultProps = {
  children: undefined,
  render: undefined
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.createComponent = function (config) {
    _this2.SizeAware = withSize(config)(function (_ref) {
      var children = _ref.children;
      return children;
    });
  };

  this.onSize = function (size) {
    return _this2.setState({ size: size });
  };
};

withSize.SizeMe = SizeMe;
withSize.withSize = withSize;

module.exports = withSize;
//# sourceMappingURL=react-sizeme.js.map


/***/ }),
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bestPositionOf = exports.safe = exports.isOutsideY = exports.isOutsideX = exports.isHoriz = exports.isBody = exports.inView = exports.getNodeRect = void 0;

var _lodash = _interopRequireDefault(__webpack_require__(1511));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getNodeRect = function getNodeRect(node) {
  return (0, _lodash.default)(node.getBoundingClientRect(), ['top', 'right', 'bottom', 'left', 'width', 'height']);
};

exports.getNodeRect = getNodeRect;

var inView = function inView(_ref) {
  var top = _ref.top,
      right = _ref.right,
      bottom = _ref.bottom,
      left = _ref.left,
      w = _ref.w,
      h = _ref.h,
      _ref$threshold = _ref.threshold,
      threshold = _ref$threshold === void 0 ? 0 : _ref$threshold;
  return top >= 0 + threshold && left >= 0 + threshold && bottom <= h - threshold && right <= w - threshold;
};

exports.inView = inView;

var isBody = function isBody(node) {
  return node === document.querySelector('body') || node === document.querySelector('html');
};

exports.isBody = isBody;

var isHoriz = function isHoriz(pos) {
  return /(left|right)/.test(pos);
};

exports.isHoriz = isHoriz;

var isOutsideX = function isOutsideX(val, windowWidth) {
  return val > windowWidth;
};

exports.isOutsideX = isOutsideX;

var isOutsideY = function isOutsideY(val, windowHeight) {
  return val > windowHeight;
};

exports.isOutsideY = isOutsideY;

var safe = function safe(sum) {
  return sum < 0 ? 0 : sum;
};

exports.safe = safe;

var bestPositionOf = function bestPositionOf(positions) {
  return Object.keys(positions).map(function (p) {
    return {
      position: p,
      value: positions[p]
    };
  }).sort(function (a, b) {
    return b.value - a.value;
  }).map(function (p) {
    return p.position;
  });
};

exports.bestPositionOf = bestPositionOf;

/***/ }),
/* 394 */,
/* 395 */,
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EventTypes = exports.createMetaReducer = exports.createTracker = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(1969);

var _types = __webpack_require__(808);

var _types2 = _interopRequireDefault(_types);

var _configuration = __webpack_require__(1964);

var _identify = __webpack_require__(1966);

var _page = __webpack_require__(1967);

var _track = __webpack_require__(1968);

var _alias = __webpack_require__(1963);

var _group = __webpack_require__(1965);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function emit(type, fields, _ref) {
  var client = _ref.client;

  var currentClient = client();

  if (currentClient && typeof currentClient[type] === 'function') {
    currentClient[type].apply(currentClient, _toConsumableArray(fields));
  } else {
    (0, _utils.warn)('The analytics client you provided doesn\'t support ' + type + ' events. Make sure that the anaytics.js script is loaded.');
  }
}

function createTracker() {
  var customOptions = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var options = {
    mapper: _extends({}, _configuration.defaultMapper.mapper, customOptions.mapper),
    client: customOptions.client ? function () {
      return customOptions.client;
    } : _configuration.defaultClient
  };

  if (!options.client) {
    (0, _utils.warn)('Could not find an analytics client. Provide a client to' + 'createTracker or make sure that the anaytics.js script' + 'is loaded and executed before your application code.');
  }

  return function (store) {
    return function (next) {
      return function (action) {
        return handleAction(store.getState.bind(store), next, action, options);
      };
    };
  };
}

function createMetaReducer() {
  var customOptions = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var options = {
    mapper: _extends({}, _configuration.defaultMapper.mapper, customOptions.mapper),
    client: customOptions.client ? function () {
      return customOptions.client;
    } : _configuration.defaultClient
  };

  if (!options.client) {
    (0, _utils.warn)('Could not find an analytics client. Provide a client to' + 'createTracker or make sure that the anaytics.js script' + 'is loaded and executed before your application code.');
  }

  return function (reducer) {
    return function (prevState, action) {

      if (action.meta && action.meta.analytics) {
        return handleReducerSpec(reducer, prevState, action, options);
      }

      if (typeof options.mapper[action.type] === 'function') {
        var getState = function getState() {
          return prevState;
        };
        var analytics = options.mapper[action.type](getState, action);

        return handleReducerSpec(reducer, prevState, appendAction(action, analytics), options);
      }

      if (typeof options.mapper[action.type] === 'string') {
        var _analytics = { eventType: options.mapper[action.type] };
        return handleReducerSpec(reducer, prevState, appendAction(action, _analytics), options);
      }

      return reducer(prevState, action);
    };
  };
}

function handleReducerSpec(reducer, prevState, action, options) {
  var spec = action.meta.analytics;

  if (Array.isArray(spec)) {
    spec.forEach(function (s) {
      return handleIndividualSpec(s, action, options);
    });
  } else {
    handleIndividualSpec(spec, action, options);
  }

  return reducer(prevState, action);
}

function appendAction(action, analytics) {

  action.meta = _extends({}, action.meta, {
    analytics: Array.isArray(analytics) ? analytics : _extends({}, analytics)
  });

  return action;
}

function handleAction(getState, next, action, options) {

  if (action.meta && action.meta.analytics) {
    return handleSpec(next, action, options);
  }

  if (typeof options.mapper[action.type] === 'function') {

    var analytics = options.mapper[action.type](getState, action);
    return handleSpec(next, appendAction(action, analytics), options);
  }

  if (typeof options.mapper[action.type] === 'string') {

    var _analytics2 = { eventType: options.mapper[action.type] };
    return handleSpec(next, appendAction(action, _analytics2), options);
  }

  return next(action);
}

function getFields(type, fields, actionType) {
  var _typeFieldHandlers;

  var typeFieldHandlers = (_typeFieldHandlers = {}, _defineProperty(_typeFieldHandlers, _types2.default.identify, _identify.extractIdentifyFields), _defineProperty(_typeFieldHandlers, _types2.default.page, _page.extractPageFields), _defineProperty(_typeFieldHandlers, _types2.default.track, function (eventFields) {
    return (0, _track.extractTrackFields)(eventFields, actionType);
  }), _defineProperty(_typeFieldHandlers, _types2.default.alias, _alias.extractAliasFields), _defineProperty(_typeFieldHandlers, _types2.default.group, _group.extractGroupFields), _defineProperty(_typeFieldHandlers, _types2.default.reset, function () {
    return [];
  }), _typeFieldHandlers);

  return typeFieldHandlers[type](fields);
}

function getEventType(spec) {
  if (typeof spec === 'string') {
    return spec;
  }

  return spec.eventType;
}

function handleIndividualSpec(spec, action, options) {
  var type = getEventType(spec);

  // In case the eventType was not specified or set to `null`, ignore this individual spec.
  if (type && type.length) {
    var fields = getFields(type, spec.eventPayload || {}, action.type);

    if (fields instanceof Error) return (0, _utils.warn)(fields);

    emit(type, fields, options);
  }
}

function handleSpec(next, action, options) {
  var spec = action.meta.analytics;

  if (Array.isArray(spec)) {
    spec.forEach(function (s) {
      return handleIndividualSpec(s, action, options);
    });
  } else {
    handleIndividualSpec(spec, action, options);
  }

  return next(action);
}

exports.createTracker = createTracker;
exports.createMetaReducer = createMetaReducer;
exports.EventTypes = _types2.default;

/***/ }),
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchDashboardDetailsAction = exports.DASHBOARD_LOADING_STOP = exports.SET_PENDING_DOCUMENTS = exports.SET_DOCUMENT_USAGE_DETAILS = exports.SET_USAGE_DETAILS = undefined;

var _dashboard = __webpack_require__(838);

var SET_USAGE_DETAILS = exports.SET_USAGE_DETAILS = "actions/dashboard/set-usage-details";
var SET_DOCUMENT_USAGE_DETAILS = exports.SET_DOCUMENT_USAGE_DETAILS = "actions/dashboard/set-document-usage-details";
var SET_PENDING_DOCUMENTS = exports.SET_PENDING_DOCUMENTS = "actions/dashboard/set-pending-documents";
var DASHBOARD_LOADING_STOP = exports.DASHBOARD_LOADING_STOP = "actions/dashboard/dashboard-loading-stop";

var dispatchFetchUsageDetailsPromise = function dispatchFetchUsageDetailsPromise(accountId, dispatch) {
  return (0, _dashboard.fetchUsageDetails)(accountId).then(function (usageDetails) {
    dispatch({
      type: SET_USAGE_DETAILS,
      data: { usageDetails: usageDetails }
    });
  });
};

var dispatchFetchDocumentUsageDetailsPromise = function dispatchFetchDocumentUsageDetailsPromise(accountId, dispatch) {
  var urlParams = "limit=1&offset=0&include_total_sum_filtered=true&trashed=false&processing_state=PROCESSED";
  (0, _dashboard.fetchDocumentUsageDetails)(accountId, urlParams).then(function (response) {
    var totalCount = response.totalCount;
    var totalSumFiltered = response.totalSumFiltered;
    dispatch({
      type: SET_DOCUMENT_USAGE_DETAILS,
      data: { totalCount: totalCount, totalSumFiltered: totalSumFiltered }
    });
  });
};

var dispatchFetchPendingDocumentsPromise = function dispatchFetchPendingDocumentsPromise(accountId, dispatch) {
  var urlParams = "trashed=false&or_processing_state=NEEDS_SYSTEM_PROCESSING&or_processing_state=NEEDS_USER_PROCESSING";
  (0, _dashboard.fetchDocumentUsageDetails)(accountId, urlParams).then(function (response) {
    var pendingDocumentCount = response.totalCountFiltered;
    dispatch({
      type: SET_PENDING_DOCUMENTS,
      data: { pendingDocumentCount: pendingDocumentCount }
    });
  });
};

var fetchDashboardDetailsAction = exports.fetchDashboardDetailsAction = function fetchDashboardDetailsAction(accountId) {
  return function (dispatch) {
    return Promise.all([dispatchFetchUsageDetailsPromise(accountId, dispatch), dispatchFetchDocumentUsageDetailsPromise(accountId, dispatch), dispatchFetchPendingDocumentsPromise(accountId, dispatch)]).then(function () {
      return dispatch({ type: DASHBOARD_LOADING_STOP });
    });
  };
};

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linkAccountAction = exports.exportAllAction = exports.exportSelectedAction = exports.addRuleErrorAction = exports.setViewedDocumentUrlAction = exports.removeIncludeRuleAction = exports.addIncludeRuleAction = exports.setGlCodeAction = exports.splitCategoriesAction = exports.SET_VIEWED_DOCUMENT_URL = exports.REMOVE_INCLUDE_RULE = exports.ADD_INCLUDE_RULE = exports.SET_GL_CODE = exports.SPLIT_CATEGORIES = undefined;

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _reactRouter = __webpack_require__(32);

var _store = __webpack_require__(48);

var _documents = __webpack_require__(114);

var _appActions = __webpack_require__(25);

var _documentsActions = __webpack_require__(161);

var _trackingActions = __webpack_require__(26);

var _splitCategories2 = __webpack_require__(444);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SPLIT_CATEGORIES = exports.SPLIT_CATEGORIES = "actions/documents/exports/split-categories";
var SET_GL_CODE = exports.SET_GL_CODE = "actions/documents/exports/set-gl-code";
var ADD_INCLUDE_RULE = exports.ADD_INCLUDE_RULE = "actions/documents/exports/add-include-rule";
var REMOVE_INCLUDE_RULE = exports.REMOVE_INCLUDE_RULE = "actions/documents/exports/remove-include-rule";
var SET_VIEWED_DOCUMENT_URL = exports.SET_VIEWED_DOCUMENT_URL = "actions/documents/exports/set-viewed-document-url";

var splitCategoriesAction = exports.splitCategoriesAction = function splitCategoriesAction(categories) {
  var _splitCategories = (0, _splitCategories2.splitCategories)(categories),
      glCodes = _splitCategories.glCodes,
      newCategories = _splitCategories.newCategories,
      trackingCodes = _splitCategories.trackingCodes;

  var strippedGlCodes = glCodes.map(function (category) {
    var newCategory = _ramda2.default.clone(category);
    var newName = _ramda2.default.drop(1, category.name.split("-")).join("-");
    newCategory.newName = newName;
    return newCategory;
  });
  return {
    type: SPLIT_CATEGORIES,
    data: { strippedGlCodes: strippedGlCodes, newCategories: newCategories, trackingCodes: trackingCodes }
  };
};

var setGlCodeAction = exports.setGlCodeAction = function setGlCodeAction(document, glCode) {
  return function (dispatch) {
    var newDocument = _ramda2.default.clone(document);
    if (!newDocument.categories) {
      newDocument.categories = [];
    }
    if (glCode.key === "clear-category") {
      var nonGLCategories = document.categories.filter(function (category) {
        return !(0, _splitCategories2.doesCategoryStartWithGlPrefix)({ name: category });
      });
      newDocument.categories = nonGLCategories;
      dispatch({
        type: SET_GL_CODE,
        data: { document: newDocument }
      });
      return (0, _documents.putDocument)(document.accountId, document.id, newDocument);
    }
    var prefix = glCode.key.split("-").shift();
    var index = newDocument.categories.findIndex(function (code) {
      return code.indexOf(prefix) > -1;
    });
    if (index > -1) {
      newDocument.categories.splice(index, 1, glCode.key);
    } else {
      newDocument.categories.push(glCode.key);
    }
    dispatch({
      type: SET_GL_CODE,
      data: { document: newDocument }
    });
    dispatch((0, _trackingActions.trackEventAction)("GL code added to document"));
    return (0, _documents.putDocument)(document.accountId, document.id, newDocument);
  };
};

var addIncludeRuleAction = exports.addIncludeRuleAction = function addIncludeRuleAction(data) {
  return function (dispatch) {
    var state = _store.store.getState();
    var categories = state.categories.categories;
    var categoryId = _ramda2.default.find(_ramda2.default.propEq("name", data.glCode.name))(categories).id;
    var rule = {
      action: "include",
      vendorName: data.vendorName
    };
    dispatch({
      type: ADD_INCLUDE_RULE
    });
    dispatch((0, _trackingActions.trackEventAction)("Include rule added to document"));
    return (0, _documents.addIncludeRule)(data.accountId, categoryId, rule).then(function () {
      dispatch((0, _appActions.setFlashMessageAction)("Rule created"));
    });
  };
};

var removeIncludeRuleAction = exports.removeIncludeRuleAction = function removeIncludeRuleAction(data) {
  return function (dispatch) {
    var accountId = data.accountId,
        categoryId = data.categoryId,
        ruleId = data.ruleId;

    (0, _documents.deleteIncludeRule)(accountId, categoryId, ruleId).then(function () {
      dispatch({
        type: REMOVE_INCLUDE_RULE,
        data: { categoryId: categoryId, ruleId: ruleId }
      });
      dispatch((0, _appActions.setFlashMessageAction)("Rule removed", "error"));
      dispatch((0, _trackingActions.trackEventAction)("Include rule removed from document"));
    });
  };
};

var setViewedDocumentUrlAction = exports.setViewedDocumentUrlAction = function setViewedDocumentUrlAction(url) {
  return {
    type: SET_VIEWED_DOCUMENT_URL,
    data: url
  };
};

var addRuleErrorAction = exports.addRuleErrorAction = function addRuleErrorAction() {
  return (0, _appActions.setFlashMessageAction)("Please add a GL code before adding a rule", "error");
};

var exportSelectedAction = exports.exportSelectedAction = function exportSelectedAction(accountId, selectedDocumentIds) {
  return function (dispatch) {
    return (0, _documents.exportSelected)(accountId, selectedDocumentIds).then(function () {
      dispatch((0, _documentsActions.endExportModeAction)());
      dispatch((0, _appActions.setFlashMessageAction)("Documents queued for export."));
      dispatch((0, _trackingActions.trackEventAction)("Export selected"));
    }).then(function () {
      return (0, _documentsActions.reloadDocuments)(dispatch);
    });
  };
};

var exportAllAction = exports.exportAllAction = function exportAllAction(accountId) {
  return function (dispatch) {
    return (0, _documents.exportAll)(accountId).then(function () {
      dispatch((0, _documentsActions.endExportModeAction)());
      dispatch((0, _appActions.setFlashMessageAction)("Documents queued for export."));
      dispatch((0, _trackingActions.trackEventAction)("Export all"));
    }).then(function () {
      return (0, _documentsActions.reloadDocuments)(dispatch);
    });
  };
};

var linkAccountAction = exports.linkAccountAction = function linkAccountAction(accountSlug) {
  _reactRouter.browserHistory.push("/accounts/" + accountSlug + "/settings/integration");
  return {
    type: "NOOP"
  };
};

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.submitReportAction = exports.fetchReportsAction = exports.SET_REPORTS = undefined;

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _store = __webpack_require__(48);

var _reduxForm = __webpack_require__(35);

var _reports = __webpack_require__(839);

var _validators = __webpack_require__(36);

var _appActions = __webpack_require__(25);

var _trackingActions = __webpack_require__(26);

var _filtersToUrlParams = __webpack_require__(415);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET_REPORTS = exports.SET_REPORTS = "actions/reports/set-reports";

var fetchReportsAction = exports.fetchReportsAction = function fetchReportsAction(accountId) {
  return function (dispatch) {
    (0, _reports.fetchReports)(accountId).then(function (_ref) {
      var reports = _ref.reports;

      dispatch({
        type: SET_REPORTS,
        data: { reports: reports }
      });
    });
  };
};

var submitReportAction = exports.submitReportAction = function submitReportAction() {
  return function (dispatch) {
    var state = _store.store.getState();
    var accountId = state.app.selectedAccount.id;
    var form = _ramda2.default.path(["form", "reports", "values"], state);
    var newVendors = form.vendors ? form.vendors.map(function (vendorData) {
      return vendorData.value;
    }) : null;
    var newCategories = form.categories ? form.categories.map(function (category) {
      return category.value;
    }) : null;
    var newForm = _ramda2.default.merge(form, { vendors: newVendors, categories: newCategories });
    if (reportFormValidationErrorMessage(form) !== null) {
      return dispatch((0, _appActions.setFlashMessageAction)(reportFormValidationErrorMessage(form), "error"));
    }
    var urlFilterString = (0, _filtersToUrlParams.reportFilterStringGenerator)(newForm);
    var reportObject = {
      emails: form.email ? [form.email] : [],
      exportType: form.type.key,
      filter: urlFilterString,
      name: form.name || null
    };

    return (0, _reports.submitReport)(accountId, reportObject).then(function () {
      dispatch((0, _appActions.setFlashMessageAction)("Report Sent! Please wait a few moments for your report to be generated."));
      dispatch((0, _reduxForm.reset)("reports"));
      dispatch((0, _trackingActions.trackEventAction)("Report submitted"));
    }).catch(function () {
      dispatch((0, _appActions.setFlashGenericErrorAction)());
    });
  };
};

var reportFormValidationErrorMessage = function reportFormValidationErrorMessage(form) {
  if (form === undefined) {
    return "Please fill out the form";
  }
  if (form.startDate === undefined || form.endDate === undefined) {
    return "Please provide a date range";
  }
  if (!(0, _moment2.default)(form.startDate).isValid() || !(0, _moment2.default)(form.endDate).isValid()) {
    return "Please enter a valid date";
  }
  if (form.email !== undefined && !(0, _validators.isValidEmail)(form.email)) {
    return "Please enter a valid email";
  }
  if (form.type === undefined) {
    return "Please enter a report type";
  }
  return null;
};

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.batchDownloadsSharedAction = exports.submitBatchEditActionGenerator = exports.documentViewedActionGenerator = exports.paginationActionGenerator = exports.filterActionGenerator = undefined;

var _store = __webpack_require__(48);

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _documents = __webpack_require__(114);

var _appActions = __webpack_require__(25);

var _stringHelpers = __webpack_require__(68);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var filterActionGenerator = exports.filterActionGenerator = function filterActionGenerator(actionType, ajaxFunction, update) {
  return function (dispatch) {
    dispatch({
      type: actionType,
      data: { update: update }
    });
    ajaxFunction(dispatch);
  };
};

var paginationActionGenerator = exports.paginationActionGenerator = function paginationActionGenerator(actionType, ajaxFunction) {
  return function (dispatch) {
    dispatch({
      type: actionType
    });
    ajaxFunction(dispatch, false);
  };
};

var documentViewedActionGenerator = exports.documentViewedActionGenerator = function documentViewedActionGenerator(actionType, data) {
  return function (dispatch) {
    var newDocument = _ramda2.default.clone(data.document);
    newDocument.viewed = true;
    return (0, _documents.putDocument)(data.accountId, data.document.id, newDocument).then(function (response) {
      dispatch({
        type: actionType,
        data: { document: response.data }
      });
    });
  };
};

var submitBatchEditActionGenerator = exports.submitBatchEditActionGenerator = function submitBatchEditActionGenerator(actionTypeStart, actionTypeEnd, ajaxFunction, formName, page) {
  return function (dispatch) {
    dispatch({
      type: actionTypeStart
    });
    var state = _store.store.getState();
    var account = state.app.selectedAccount;
    var formData = _ramda2.default.path(["form", formName, "values"], state);
    var documentIds = _ramda2.default.path([page, "selectedDocumentIds"], state);
    var documents = _ramda2.default.path([page, "documents"], state);
    var selectedDocuments = documentIds.map(function (id) {
      return documents.find(function (document) {
        return document.id === id;
      });
    });
    (0, _documents.batchUpdateDocuments)(account.id, selectedDocuments, formData).then(function () {
      return ajaxFunction(dispatch, false);
    }).then(function () {
      dispatch({ type: actionTypeEnd });
    }).catch(function () {
      return dispatch({ type: actionTypeEnd });
    });
  };
};

var batchDownloadsSharedAction = exports.batchDownloadsSharedAction = function batchDownloadsSharedAction(dispatch, data, onStartAction, onEndAction) {
  dispatch(onStartAction);
  return (0, _documents.batchDownloadDocuments)(data.exportType, data.account.id, data.documentIds, data.emails).then(function () {
    dispatch((0, _appActions.setFlashMessageAction)("A link will be sent to the email " + (0, _stringHelpers.pluralize)(data.emails.length, "addresses", "address", false) + " shortly"));
    dispatch(onEndAction());
  }).catch(function () {
    dispatch((0, _appActions.setFlashMessageAction)("An unknown error occurred. Please try again in a few moments", "error"));
    dispatch(onEndAction());
  });
};

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeVendorsAction = exports.selectMergeVendorAction = exports.endMergeVendorsModeAction = exports.startMergeVendorsModeAction = exports.orderVendorsAction = exports.deleteIncludeRuleAction = exports.selectCategoryForRuleAction = exports.endAddVendorRulesModeAction = exports.startAddVendorRulesModeAction = exports.addVendorRulesAction = exports.deselectVendorsAction = exports.selectVendorsAction = exports.fetchVendorsAction = exports.MERGE_VENDORS_LOADING_STOP = exports.MERGE_VENDORS_LOADING_START = exports.SELECT_MERGE_VENDOR = exports.MERGE_VENDORS = exports.END_MERGE_VENDORS_MODE = exports.START_MERGE_VENDORS_MODE = exports.ORDER_VENDORS = exports.DELETE_VENDOR_RULE = exports.SELECT_CATEGORY_FOR_RULE = exports.END_ADD_VENDOR_RULES_MODE = exports.START_ADD_VENDOR_RULES_MODE = exports.REMOVE_VENDOR_RULES_LOADING_STOP = exports.ADD_VENDOR_RULES_LOADING_STOP = exports.REMOVE_VENDOR_RULES_LOADING = exports.ADD_VENDOR_RULES_LOADING = exports.REMOVE_VENDOR_RULES = exports.ADD_VENDOR_RULES = exports.DESELECT_VENDORS = exports.SELECT_VENDORS = exports.LOADING_STOP = exports.LOADING_START = exports.FETCH_VENDORS = undefined;

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _store = __webpack_require__(48);

var _categories = __webpack_require__(265);

var _documents = __webpack_require__(114);

var _appActions = __webpack_require__(25);

var _vendors = __webpack_require__(417);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FETCH_VENDORS = exports.FETCH_VENDORS = "actions/manage-vendors/fetch-vendors";
var LOADING_START = exports.LOADING_START = "actions/manage-vendors/loading-start";
var LOADING_STOP = exports.LOADING_STOP = "actions/manage-vendors/loading-stop";
var SELECT_VENDORS = exports.SELECT_VENDORS = "actions/manage-vendors/select-vendors";
var DESELECT_VENDORS = exports.DESELECT_VENDORS = "actions/manage-vendors/deselect-vendors";
var ADD_VENDOR_RULES = exports.ADD_VENDOR_RULES = "actions/manage-vendors/add-vendor-rules";
var REMOVE_VENDOR_RULES = exports.REMOVE_VENDOR_RULES = "actions/manage-vendors/remove-vendor-rules";
var ADD_VENDOR_RULES_LOADING = exports.ADD_VENDOR_RULES_LOADING = "actions/manage-vendors/add-vendor-rules-loading";
var REMOVE_VENDOR_RULES_LOADING = exports.REMOVE_VENDOR_RULES_LOADING = "actions/manage-vendors/remove-vendor-rules-loading";
var ADD_VENDOR_RULES_LOADING_STOP = exports.ADD_VENDOR_RULES_LOADING_STOP = "actions/manage-vendors/add-vendor-rules-loading-stop";
var REMOVE_VENDOR_RULES_LOADING_STOP = exports.REMOVE_VENDOR_RULES_LOADING_STOP = "actions/manage-vendors/remove-vendor-rules-loading-stop";
var START_ADD_VENDOR_RULES_MODE = exports.START_ADD_VENDOR_RULES_MODE = "actions/manage-vendors/start-add-vendor-rules-mode";
var END_ADD_VENDOR_RULES_MODE = exports.END_ADD_VENDOR_RULES_MODE = "actions/manage-vendors/end-add-vendor-rules-mode";
var SELECT_CATEGORY_FOR_RULE = exports.SELECT_CATEGORY_FOR_RULE = "actions/manage-vendors/select-category-for-rule";
var DELETE_VENDOR_RULE = exports.DELETE_VENDOR_RULE = "actions/manage-vendors/delete-vendor-rule";
var ORDER_VENDORS = exports.ORDER_VENDORS = "actions/manage-vendors/order-vendors";
var START_MERGE_VENDORS_MODE = exports.START_MERGE_VENDORS_MODE = "actions/manage-vendors/start-merge-vendors-mode";
var END_MERGE_VENDORS_MODE = exports.END_MERGE_VENDORS_MODE = "actions/manage-vendors/end-merge-vendors-mode";
var MERGE_VENDORS = exports.MERGE_VENDORS = "actions/manage-vendors/merge-vendors";
var SELECT_MERGE_VENDOR = exports.SELECT_MERGE_VENDOR = "actions/manage-vendors/select-merge-vendor";
var MERGE_VENDORS_LOADING_START = exports.MERGE_VENDORS_LOADING_START = "actions/manage-vendors/merge-vendors-loading-start";
var MERGE_VENDORS_LOADING_STOP = exports.MERGE_VENDORS_LOADING_STOP = "actions/manage-vendors/merge-vendors-loading-stop";

var fetchVendorsAction = exports.fetchVendorsAction = function fetchVendorsAction() {
  return function (dispatch) {
    dispatch({ type: LOADING_START });
    var state = _store.store.getState();
    var vendors = state.vendors.vendors;
    var categories = state.categories.categories;
    var newVendors = vendors.map(function (vendor) {
      var rules = categories.filter(function (category) {
        if (_ramda2.default.findIndex(_ramda2.default.propEq("vendorName", vendor.name))(category.rules.includeVendors) > -1) {
          return category;
        }
        return null;
      });
      var newVendor = _ramda2.default.clone(vendor);
      newVendor.id = vendor.name;
      return _ramda2.default.assoc("rules", rules, newVendor);
    });
    return dispatch({
      type: FETCH_VENDORS,
      data: { newVendors: newVendors }
    });
  };
};

var selectVendorsAction = exports.selectVendorsAction = function selectVendorsAction(vendorIds) {
  return {
    type: SELECT_VENDORS,
    data: { vendorIds: vendorIds }
  };
};

var deselectVendorsAction = exports.deselectVendorsAction = function deselectVendorsAction(vendorIds) {
  return {
    type: DESELECT_VENDORS,
    data: { vendorIds: vendorIds }
  };
};

var addVendorRulesAction = exports.addVendorRulesAction = function addVendorRulesAction() {
  return function (dispatch) {
    var state = _store.store.getState();
    var categories = state.categories.categories;
    var accountId = state.app.selectedAccount.id;
    var vendors = state.vendors.selectedVendorIds;
    var category = state.vendors.selectedCategory;
    dispatch({ type: ADD_VENDOR_RULES_LOADING });
    var newVendors = vendors.map(function (vendor) {
      return { vendorName: vendor };
    });
    return (0, _categories.createIncludeRules)(accountId, category.info, newVendors).then(function (response) {
      var vendorRule = response[0].data;
      dispatch({ type: ADD_VENDOR_RULES, data: { vendors: vendors, category: category, vendorRule: vendorRule, categories: categories } });
      dispatch({ type: ADD_VENDOR_RULES_LOADING_STOP });
      dispatch((0, _appActions.setFlashMessageAction)("Rule added"));
    }).catch(function () {
      dispatch((0, _appActions.setFlashGenericErrorAction)());
      dispatch({ type: ADD_VENDOR_RULES_LOADING_STOP });
    });
  };
};

var startAddVendorRulesModeAction = exports.startAddVendorRulesModeAction = function startAddVendorRulesModeAction() {
  return {
    type: START_ADD_VENDOR_RULES_MODE
  };
};

var endAddVendorRulesModeAction = exports.endAddVendorRulesModeAction = function endAddVendorRulesModeAction() {
  return {
    type: END_ADD_VENDOR_RULES_MODE
  };
};

var selectCategoryForRuleAction = exports.selectCategoryForRuleAction = function selectCategoryForRuleAction(category) {
  return {
    type: SELECT_CATEGORY_FOR_RULE,
    data: { category: category }
  };
};

var deleteIncludeRuleAction = exports.deleteIncludeRuleAction = function deleteIncludeRuleAction(accountId, category, vendor) {
  return function (dispatch) {
    return (0, _categories.deleteIncludeRule)(accountId, category.id, vendor.id).then(function () {
      dispatch({
        type: DELETE_VENDOR_RULE,
        data: { vendor: vendor, category: category }
      });
      dispatch((0, _appActions.setFlashMessageAction)("Rule removed", "error"));
    });
  };
};

var orderVendorsAction = exports.orderVendorsAction = function orderVendorsAction(column) {
  return {
    type: ORDER_VENDORS,
    data: { column: column }
  };
};

var startMergeVendorsModeAction = exports.startMergeVendorsModeAction = function startMergeVendorsModeAction() {
  return {
    type: START_MERGE_VENDORS_MODE
  };
};

var endMergeVendorsModeAction = exports.endMergeVendorsModeAction = function endMergeVendorsModeAction() {
  return {
    type: END_MERGE_VENDORS_MODE
  };
};

var selectMergeVendorAction = exports.selectMergeVendorAction = function selectMergeVendorAction(vendor) {
  return {
    type: SELECT_MERGE_VENDOR,
    data: { vendor: vendor }
  };
};

var mergeVendorsAction = exports.mergeVendorsAction = function mergeVendorsAction(accountId, vendor, vendors) {
  return function (dispatch) {
    dispatch({ type: MERGE_VENDORS_LOADING_START });
    var dropSelected = function dropSelected(vendorName) {
      return vendorName === vendor.key;
    };
    var limit = { limit: 0, pageNumber: 1 };
    var filterData = {
      orderBy: "uploaded",
      orderDirection: "DSC",
      processingState: "PROCESSED",
      isTrash: false,
      selectedVendors: _ramda2.default.dropWhile(dropSelected, vendors)
    };
    return (0, _documents.fetchDocuments)(accountId, filterData, limit).then(function (_ref) {
      var documents = _ref.documents;
      return (0, _documents.mergeVendors)(accountId, documents, vendor.key);
    }).then(function () {
      return (0, _vendors.fetchVendors)(accountId);
    }).then(function (response) {
      dispatch({
        type: MERGE_VENDORS,
        data: { vendors: response.vendors }
      });
      dispatch({ type: MERGE_VENDORS_LOADING_STOP });
    }).then(function () {
      return dispatch(fetchVendorsAction());
    });
  };
};

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.billingRedirect = exports.fetchPendingPlan = exports.putDocReturn = exports.postBillingDetails = exports.createUser = exports.deleteUser = exports.fetchAccountUsers = exports.fetchBillingDetails = exports.fetchBillingHistory = exports.putNewPlan = exports.putCurrencyLocaleTax = exports.fetchLocales = exports.putAccountSettings = exports.fetchPlans = exports.fetchAccountDetails = exports.fetchAccountSettings = undefined;

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _http = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchAccountSettings = exports.fetchAccountSettings = function fetchAccountSettings(accountId) {
  return _http.http.get("/accounts/" + accountId + "/settings").then(function (response) {
    var accountSettings = response.data;
    accountSettings.vat = parseFloat(accountSettings.vat);
    return { accountSettings: accountSettings };
  });
};

var fetchAccountDetails = exports.fetchAccountDetails = function fetchAccountDetails(accountId) {
  return _http.http.get("/accounts/" + accountId + "?include_usage=true").then(function (response) {
    var accountDetails = response.data;
    var planDetails = _ramda2.default.path(["data", "plan"], response);
    return { accountDetails: accountDetails, planDetails: planDetails };
  });
};

var fetchPlans = exports.fetchPlans = function fetchPlans(accountId) {
  return _http.http.get("accounts/" + accountId + "/plans").then(function (response) {
    var plans = _ramda2.default.path(["data", "plans"], response);
    return { plans: plans };
  });
};

var putAccountSettings = exports.putAccountSettings = function putAccountSettings(accountId, settings) {
  return _http.http.put("/accounts/" + accountId, settings);
};

var fetchLocales = exports.fetchLocales = function fetchLocales(accountId) {
  return _http.http.get("/accounts/" + accountId + "/locales").then(function (response) {
    var supportedLocales = _ramda2.default.path(["data", "supported"], response);
    return { supportedLocales: supportedLocales, response: response };
  });
};

var putCurrencyLocaleTax = exports.putCurrencyLocaleTax = function putCurrencyLocaleTax(accountId, settings) {
  return _http.http.put("/accounts/" + accountId + "/settings", settings);
};

var putNewPlan = exports.putNewPlan = function putNewPlan(accountId, plan) {
  return _http.http.put("accounts/" + accountId + "/plan", plan);
};

var fetchBillingHistory = exports.fetchBillingHistory = function fetchBillingHistory(accountId) {
  return _http.http.get("accounts/" + accountId + "/billing/invoices").then(function (response) {
    var invoices = _ramda2.default.path(["data", "invoices"], response);
    return { invoices: invoices };
  });
};

var fetchBillingDetails = exports.fetchBillingDetails = function fetchBillingDetails(accountId) {
  return _http.http.get("accounts/" + accountId + "/billing-info").then(function (response) {
    var billingDetails = response.data;
    return { billingDetails: billingDetails };
  });
};

var fetchAccountUsers = exports.fetchAccountUsers = function fetchAccountUsers(accountId) {
  return _http.http.get("/accounts/" + accountId + "/users").then(function (response) {
    var maxUsers = _ramda2.default.path(["data", "maxUsers"], response);
    var users = _ramda2.default.path(["data", "users"], response);
    return { maxUsers: maxUsers, users: users };
  });
};

var deleteUser = exports.deleteUser = function deleteUser(accountId, userId) {
  return _http.http.delete("accounts/" + accountId + "/users/" + userId);
};

var createUser = exports.createUser = function createUser(accountId, user) {
  return _http.http.post("accounts/" + accountId + "/users", user).then(function (response) {
    var newUser = response.data;
    return { newUser: newUser };
  });
};

var postBillingDetails = exports.postBillingDetails = function postBillingDetails() {
  // eslint-disable-next-line no-console
  console.warn("This is a stub");
  return Promise.resolve({
    expiryMonth: "2",
    expiryYear: "2020",
    lastFourDigits: "1111",
    name: "Test",
    surname: "Test"
  });
};

var putDocReturn = exports.putDocReturn = function putDocReturn(accountId, isOn) {
  return _http.http.put("accounts/" + accountId + "/settings", { docReturn: isOn });
};

var fetchPendingPlan = exports.fetchPendingPlan = function fetchPendingPlan(accountId) {
  return _http.http.get("accounts/" + accountId + "/plan").then(function (response) {
    var cancelDate = _ramda2.default.pathOr(null, ["data", "expired"], response);
    var pendingPlan = _ramda2.default.pathOr(null, ["data", "pendingPlan"], response);
    return { cancelDate: cancelDate, pendingPlan: pendingPlan };
  });
};

var billingRedirect = exports.billingRedirect = function billingRedirect(accountId) {
  var data = {
    account_id: accountId,
    redirect_uri: "https://app.squirrelstreet.com" + "/member/v2/settings#billing_history"
  };
  return _http.http.nonAjaxPost("https://app.squirrelstreet.com" + "/member/set-account.htm", data);
};

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestEnvelope = exports.fetchEnvelopes = undefined;

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _http = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchEnvelopes = exports.fetchEnvelopes = function fetchEnvelopes(accountId) {
  return _http.http.get("/accounts/" + accountId + "/envelopes").then(function (response) {
    var envelopes = _ramda2.default.pathOr([], ["data", "envelopes"], response);
    return { envelopes: envelopes, response: response };
  });
};

var requestEnvelope = exports.requestEnvelope = function requestEnvelope(accountId) {
  var envelope = { quantity: 1 };
  return _http.http.post("/accounts/" + accountId + "/envelopes", envelope);
};

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportFilterStringGenerator = exports.filtersToUrlParams = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var filtersToUrlParams = exports.filtersToUrlParams = function filtersToUrlParams(_ref, pagination) {
  var endDate = _ref.endDate,
      exportType = _ref.exportType,
      isExports = _ref.isExports,
      isTrash = _ref.isTrash,
      orderBy = _ref.orderBy,
      orderDirection = _ref.orderDirection,
      processingState = _ref.processingState,
      selectedCardNumbers = _ref.selectedCardNumbers,
      selectedCategories = _ref.selectedCategories,
      selectedCurrencies = _ref.selectedCurrencies,
      selectedEnvelopes = _ref.selectedEnvelopes,
      selectedName = _ref.selectedName,
      selectedPaymentTypes = _ref.selectedPaymentTypes,
      selectedSearchQueryString = _ref.selectedSearchQueryString,
      selectedVendors = _ref.selectedVendors,
      startDate = _ref.startDate,
      totalMin = _ref.totalMin,
      totalMax = _ref.totalMax,
      type = _ref.type,
      viewedStatus = _ref.viewedStatus;
  return limitQuery(pagination.limit).concat(offsetQuery(pagination)).concat("&include_total_sum_filtered=true").concat(documentTypeQuery(type)).concat(showTrashQuery(isTrash)).concat(processingStateQuery(processingState)).concat(orderQuery(orderBy, orderDirection)).concat(startDateQuery(startDate)).concat(endDateQuery(endDate)).concat(currencyQuery(selectedCurrencies)).concat(vendorsQuery(selectedVendors)).concat(categoriesQuery(selectedCategories)).concat(paymentTypesQuery(selectedPaymentTypes)).concat(cardNumbersQuery(selectedCardNumbers)).concat(envelopesQuery(selectedEnvelopes)).concat(viewedQuery(viewedStatus)).concat(exportTypeQuery(exportType)).concat(totalMinQuery(totalMin)).concat(totalMaxQuery(totalMax)).concat(searchQueryStringQuery(selectedSearchQueryString)).concat(selectedNameQuery(selectedName)).concat(exportsPageQuery(isExports));
};

var reportFilterStringGenerator = exports.reportFilterStringGenerator = function reportFilterStringGenerator(_ref2) {
  var categories = _ref2.categories,
      endDate = _ref2.endDate,
      startDate = _ref2.startDate,
      vendors = _ref2.vendors;
  return "trashed=false&processing_state=PROCESSED".concat(startDateQuery(startDate)).concat(endDateQuery(endDate)).concat(categoriesQuery(categories)).concat(vendorsQuery(vendors)).concat("&order_by_asc=issued");
};

var offset = function offset(_ref3) {
  var limit = _ref3.limit,
      pageNumber = _ref3.pageNumber;
  return (pageNumber - 1) * limit;
};
var offsetQuery = function offsetQuery(pagination) {
  return "&offset=" + offset(pagination);
};

var encodeString = function encodeString(value) {
  return encodeURIComponent(value).replace(/%20/g, "+");
};

var limitQuery = function limitQuery(limit) {
  return "limit=" + limit;
};

var processingStateQuery = function processingStateQuery(processingState) {
  if (processingState === null || processingState === undefined) {
    return "";
  }
  if ((typeof processingState === "undefined" ? "undefined" : _typeof(processingState)) === "object") {
    return "&or_processing_state=" + processingState[0] + "&or_processing_state=" + processingState[1];
  }
  return "&processing_state=" + processingState;
};

var orderQuery = function orderQuery(orderBy, orderDirection) {
  if (orderBy === "paymentType" && orderDirection) {
    var newOrderBy = "payment_type";
    var newOrderDirection = orderDirection === "ASC" ? "asc" : "desc";
    return "&order_by_" + newOrderDirection + "=" + newOrderBy + "&order_by_" + newOrderDirection + "=last_four_digits";
  }
  if (orderBy && orderDirection) {
    return "&order_by_" + (orderDirection === "ASC" ? "asc" : "desc") + "=" + orderBy;
  }
  return "";
};

var startDateQuery = function startDateQuery(startDate) {
  return dateQuery(startDate, "start");
};
var endDateQuery = function endDateQuery(endDate) {
  return dateQuery(endDate, "end");
};

var dateQuery = function dateQuery(date, type) {
  if (date === null || date === undefined) {
    return "";
  }
  var newDate = (0, _moment2.default)(date);
  var minMax = type === "start" ? "min" : "max";
  var uriDate = newDate.format("YYYY-MM-DDTHH:mm:ss[Z]");
  return "&issued_" + minMax + "=" + uriDate;
};

var vendorsQuery = function vendorsQuery(selectedVendors) {
  if ((selectedVendors || []).length === 0) {
    return "";
  }
  return selectedVendors.reduce(function (prev, curr) {
    return prev + "&or_vendor=" + encodeString(curr);
  }, "");
};

var categoriesQuery = function categoriesQuery(selectedCategories) {
  if ((selectedCategories || []).length === 0) {
    return "";
  }
  if (_ramda2.default.indexOf("No category", selectedCategories) > -1) {
    return "&is_empty=category";
  }
  return selectedCategories.reduce(function (prev, curr) {
    return prev + "&or_category=" + encodeString(curr);
  }, "");
};

var viewedQuery = function viewedQuery(viewed) {
  if (viewed === null || viewed === undefined || viewed === "") {
    return "";
  }
  return "&viewed=" + (viewed === "viewed");
};

var totalQuery = function totalQuery(total, type) {
  if (total === "" || total === null || total === undefined) {
    return "";
  }
  return "&total_" + type + "=" + total;
};

var paymentTypesQuery = function paymentTypesQuery(selectedPaymentTypes) {
  if ((selectedPaymentTypes || []).length === 0) {
    return "";
  }

  if (selectedPaymentTypes[0] === "none") {
    return "&is_empty=payment_type";
  }

  return selectedPaymentTypes.reduce(function (prev, curr) {
    return prev + "&or_payment_type=" + encodeString(curr);
  }, "");
};

var cardNumbersQuery = function cardNumbersQuery(cards) {
  if ((cards || []).length === 0) {
    return "";
  }
  return "&last_four_digits=" + encodeString(cards);
};

var currencyQuery = function currencyQuery(selectedCurrencies) {
  if ((selectedCurrencies || []).length === 0) {
    return "";
  }
  return selectedCurrencies.reduce(function (prev, curr) {
    return prev + "&or_currency=" + encodeString(curr);
  }, "");
};

var exportTypeQuery = function exportTypeQuery(exportType) {
  if (exportType === null || exportType === undefined) {
    return "";
  }

  switch (exportType) {
    case "csv":
      return "&or_export_history_to=csv&or_export_history_to=CSV";
    case "not-csv":
      return "&not_export_history_to=csv&not_export_history_to=CSV";
    case "pdf":
      return "&export_history_to=pdf";
    case "not-pdf":
      return "&not_export_history_to=pdf";
    case "accounting":
      return "&or_category=Exported&or_category=Do+not+export&or_category=XERO" + "&or_category=SAASU&or_category=QB&or_category=QuickBooks+Online";
    case "not-accounting":
      return "&not_category=Exported&not_category=Do+not+export&not_category=XERO" + "&not_category=SAASU&not_category=QB&not_category=QuickBooks+Online";
    default:
      return "";
  }
};

var envelopesQuery = function envelopesQuery(selectedEnvelopes) {
  if ((selectedEnvelopes || []).length === 0) {
    return "";
  }
  if (selectedEnvelopes.indexOf("none") > -1) {
    return "&is_empty=envelope";
  }
  return selectedEnvelopes.reduce(function (prev, curr) {
    return prev + "&or_envelope=" + encodeString(curr);
  }, "");
};

var totalMinQuery = function totalMinQuery(total) {
  return totalQuery(total, "min");
};
var totalMaxQuery = function totalMaxQuery(total) {
  return totalQuery(total, "max");
};

var exportsPageQuery = function exportsPageQuery(isExports) {
  if (isExports) {
    return "&not_category=Exported&not_category=Do+not+export";
  }
  return "";
};

var documentTypeQuery = function documentTypeQuery(type) {
  switch (type) {
    case "receipt":
      return "&type=receipt";
    case "other":
      return "&type=other";
    default:
      return "";
  }
};

var searchQueryStringQuery = function searchQueryStringQuery(query) {
  if (query === null || query === undefined || query === "") {
    return "";
  }
  return "&q=" + query;
};

var showTrashQuery = function showTrashQuery(isTrash) {
  if (isTrash) {
    return "&trashed=true";
  }
  return "&trashed=false";
};

var selectedNameQuery = function selectedNameQuery(name) {
  if (name) {
    return "&name=" + name;
  }
  return "";
};

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchCurrentUserAndAccounts = undefined;

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _http = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchCurrentUserAndAccounts = exports.fetchCurrentUserAndAccounts = function fetchCurrentUserAndAccounts() {
  return _http.http.get("/user").then(function (response) {
    var user = _ramda2.default.pick(["id", "firstName", "lastName", "email"], response.data);
    var rawAccountData = _ramda2.default.path(["data", "accounts"], response);
    var accounts = rawAccountData.map(function (data) {
      return _ramda2.default.pick(["id", "label", "slug", "preferredCurrency"], data);
    });

    return {
      accounts: accounts,
      response: response,
      user: user
    };
  });
};

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchVendors = undefined;

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _http = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchVendors = exports.fetchVendors = function fetchVendors(accountId) {
  return _http.http.get("/accounts/" + accountId + "/vendors").then(function (response) {
    var vendors = _ramda2.default.pathOr([], ["data", "vendors"], response);
    return { response: response, vendors: vendors };
  });
};

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AutomateInlineTabs = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _inlineTabs = __webpack_require__(196);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AutomateInlineTabs = exports.AutomateInlineTabs = function AutomateInlineTabs(_ref) {
  var currentPage = _ref.currentPage,
      slug = _ref.slug;
  return _react2.default.createElement(
    "span",
    { className: "automate2" },
    _react2.default.createElement(_inlineTabs.InlineTabs, { tabValues: tabValues(currentPage, slug) })
  );
};

AutomateInlineTabs.propTypes = {
  currentPage: _propTypes2.default.oneOf(["manage-categories", "manage-vendors"]).isRequired,
  slug: _propTypes2.default.string.isRequired
};

var tabValues = function tabValues(currentPage, slug) {
  return [{
    name: "Manage Categories",
    path: "/accounts/" + slug + "/automate/manage-categories",
    isSelected: currentPage === "manage-categories"
  }, {
    name: "Manage Vendors",
    path: "/accounts/" + slug + "/automate/manage-vendors",
    isSelected: currentPage === "manage-vendors"
  }];
};

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateRange = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _datepicker = __webpack_require__(267);

var _button = __webpack_require__(7);

var _financialYear = __webpack_require__(197);

var _customPropTypes = __webpack_require__(5);

var _dateRange = __webpack_require__(1303);

var _dateRange2 = _interopRequireDefault(_dateRange);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DateRange = exports.DateRange = function DateRange(_ref) {
  var currency = _ref.currency,
      endDate = _ref.endDate,
      onAddEndDate = _ref.onAddEndDate,
      onAddStartDate = _ref.onAddStartDate,
      startDate = _ref.startDate;
  return _react2.default.createElement(
    "div",
    { className: _dateRange2.default.container },
    _react2.default.createElement(
      "div",
      { className: _dateRange2.default["start-date-container"] },
      renderDatepicker(currency, endDate, onAddEndDate, onAddStartDate, "Start date", true, startDate)
    ),
    _react2.default.createElement(
      "div",
      { className: _dateRange2.default["end-date-container"] },
      renderDatepicker(currency, endDate, onAddEndDate, onAddStartDate, "End date", false, startDate)
    )
  );
};

DateRange.propTypes = {
  currency: _propTypes2.default.string.isRequired,
  endDate: _customPropTypes.momentType,
  onAddEndDate: _propTypes2.default.func.isRequired, // (data: dataType) => void
  onAddStartDate: _propTypes2.default.func.isRequired,
  startDate: _customPropTypes.momentType
};

DateRange.defaultProps = {
  endDate: null,
  startDate: null
};

var renderDatepicker = function renderDatepicker(currency, endDate, onAddEndDate, onAddStartDate, placeholder, isStart, startDate) {
  return _react2.default.createElement(
    _datepicker.Datepicker,
    {
      endDate: endDate,
      isClearable: true,
      onDateSelected: isStart ? onAddStartDate : onAddEndDate,
      placeholderText: placeholder,
      selected: isStart ? startDate : endDate,
      selectsEnd: isStart,
      selectsStart: isStart,
      startDate: startDate
    },
    _react2.default.createElement(SelectFinancialYear, { currency: currency, onAddEndDate: onAddEndDate, onAddStartDate: onAddStartDate })
  );
};

var SelectFinancialYear = function SelectFinancialYear(_ref2) {
  var currency = _ref2.currency,
      onAddEndDate = _ref2.onAddEndDate,
      onAddStartDate = _ref2.onAddStartDate;
  return _react2.default.createElement(
    "div",
    { className: _dateRange2.default["financial-year"] },
    _react2.default.createElement(
      _button.Button,
      { link: true, onClick: function onClick() {
          return getFinancialYearRange(onAddEndDate, onAddStartDate, true, currency);
        } },
      "Last financial year"
    ),
    _react2.default.createElement(
      _button.Button,
      { link: true, onClick: function onClick() {
          return getFinancialYearRange(onAddEndDate, onAddStartDate, false, currency);
        } },
      "This financial year"
    )
  );
};

SelectFinancialYear.propTypes = {
  currency: _propTypes2.default.string.isRequired,
  onAddEndDate: _propTypes2.default.func.isRequired, // (data: dataType) => void
  onAddStartDate: _propTypes2.default.func.isRequired
};

var getFinancialYearRange = function getFinancialYearRange(onAddEndDate, onAddStartDate, isLast, currency) {
  var _ref3 = isLast ? (0, _financialYear.getLastFinancialYear)(currency) : (0, _financialYear.getThisFinancialYear)(currency),
      startDate = _ref3.startDate,
      endDate = _ref3.endDate;

  onAddStartDate(startDate);
  onAddEndDate(endDate);
};

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Drawer = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _drawer = __webpack_require__(1304);

var _drawer2 = _interopRequireDefault(_drawer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Drawer = exports.Drawer = function Drawer(_ref) {
  var children = _ref.children,
      isDrawerMode = _ref.isDrawerMode,
      onEndDrawerMode = _ref.onEndDrawerMode;

  if (!isDrawerMode) {
    return null;
  }
  return _react2.default.createElement(
    "div",
    { className: _drawer2.default["drawer-container"] },
    _react2.default.createElement(
      "div",
      { className: _drawer2.default.drawer },
      _react2.default.createElement(
        "div",
        { className: _drawer2.default.close, onClick: onEndDrawerMode },
        "+"
      ),
      children
    ),
    _react2.default.createElement("div", { className: _drawer2.default["close-drawer"], onClick: onEndDrawerMode })
  );
};

Drawer.propTypes = {
  children: _propTypes2.default.element.isRequired,
  isDrawerMode: _propTypes2.default.bool.isRequired,
  onEndDrawerMode: _propTypes2.default.func.isRequired
};

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoItems = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _noCategories = __webpack_require__(1342);

var _noCategories2 = _interopRequireDefault(_noCategories);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NoItems = exports.NoItems = function NoItems(_ref) {
  var name = _ref.name;
  return _react2.default.createElement(
    "div",
    { className: _noCategories2.default.title },
    _react2.default.createElement(
      "h2",
      null,
      "You have no ",
      name,
      "."
    )
  );
};

NoItems.propTypes = {
  name: _propTypes2.default.string.isRequired
};

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaginationBar = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _paginationBar = __webpack_require__(1311);

var _paginationBar2 = _interopRequireDefault(_paginationBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaginationBar = exports.PaginationBar = function PaginationBar(_ref) {
  var limit = _ref.limit,
      onChangeLimit = _ref.onChangeLimit,
      onNextPage = _ref.onNextPage,
      onPreviousPage = _ref.onPreviousPage,
      pageNumber = _ref.pageNumber,
      totalResults = _ref.totalResults;
  return _react2.default.createElement(
    "div",
    { className: _paginationBar2.default.container },
    _react2.default.createElement(
      "div",
      { className: _paginationBar2.default["page-numbers"] },
      _react2.default.createElement("button", {
        className: _paginationBar2.default["previous-button"],
        disabled: pageNumber === 1,
        onClick: onPreviousPage
      }),
      _react2.default.createElement(
        "div",
        null,
        "Page ",
        pageNumber,
        " of ",
        calculateTotalPages(limit, totalResults)
      ),
      _react2.default.createElement("button", {
        className: _paginationBar2.default["next-button"],
        disabled: pageNumber === calculateTotalPages(limit, totalResults),
        onClick: onNextPage
      })
    ),
    _react2.default.createElement(
      "div",
      { className: _paginationBar2.default["limit-controls"] },
      renderLimitButton(limit, 20, onChangeLimit),
      renderLimitButton(limit, 100, onChangeLimit),
      renderLimitButton(limit, 250, onChangeLimit)
    )
  );
};

PaginationBar.propTypes = {
  limit: _propTypes2.default.number.isRequired,
  onChangeLimit: _propTypes2.default.func.isRequired, // (number) => void
  onNextPage: _propTypes2.default.func.isRequired, // () => void
  onPreviousPage: _propTypes2.default.func.isRequired, // () => void
  pageNumber: _propTypes2.default.number.isRequired,
  totalResults: _propTypes2.default.number.isRequired
};

var renderLimitButton = function renderLimitButton(currentLimit, limit, onChangeLimit) {
  return _react2.default.createElement(
    "button",
    { disabled: currentLimit === limit, onClick: changeLimit(limit, onChangeLimit) },
    limit
  );
};

var changeLimit = function changeLimit(value, onChangeLimit) {
  return function () {
    onChangeLimit(value);
  };
};
var calculateTotalPages = function calculateTotalPages(limit, totalResults) {
  return _ramda2.default.max(1, Math.ceil(totalResults / limit));
};

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GSTCalculator = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _customPropTypes = __webpack_require__(5);

var _gstCalculator = __webpack_require__(1327);

var _gstCalculator2 = _interopRequireDefault(_gstCalculator);

var _gst = __webpack_require__(1002);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GSTCalculator = exports.GSTCalculator = function GSTCalculator(_ref) {
  var change = _ref.change,
      currency = _ref.currency,
      preferredCurrency = _ref.preferredCurrency,
      taxRate = _ref.taxRate,
      total = _ref.total;

  if (currency === preferredCurrency || currency.key === preferredCurrency) {
    var gst = (0, _gst.calculateGST)(total, currency, taxRate);
    return _react2.default.createElement(
      "button",
      {
        className: _gstCalculator2.default["gst-button"],
        onClick: function onClick(e) {
          e.preventDefault();change("tax", gst);
        }
      },
      "Calculate GST"
    );
  }
  return null;
};

GSTCalculator.propTypes = {
  change: _propTypes2.default.func.isRequired,
  currency: _customPropTypes.selectOptionType.isRequired,
  preferredCurrency: _propTypes2.default.string.isRequired,
  taxRate: _propTypes2.default.number.isRequired,
  total: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired
};

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoPendingFiltered = exports.NoPending = exports.NoDocuments = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(32);

var _noDocuments = __webpack_require__(514);

var _noDocuments2 = _interopRequireDefault(_noDocuments);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var APP_STORE_URL = "https://itunes.apple.com/au/app/shoeboxed-australia-document/id1044924996?mt=8";
var PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=au.com.shoeboxed.android";
var REJECTION_SUPPORT_URL = "https://support.squirrelstreet.com/support/solutions/articles/\n  24000015064-one-of-my-documents-was-rejected-what-do-i-do-";

var NoDocuments = exports.NoDocuments = function NoDocuments(_ref) {
  var accountSlug = _ref.accountSlug,
      totalCount = _ref.totalCount;
  return totalCount === 0 ? blankSlate(accountSlug) : noResults();
};

NoDocuments.propTypes = {
  accountSlug: _propTypes2.default.string.isRequired,
  totalCount: _propTypes2.default.number.isRequired
};

var NoPending = exports.NoPending = function NoPending(_ref2) {
  var accountSlug = _ref2.accountSlug;
  return _react2.default.createElement(
    "div",
    { className: _noDocuments2.default["no-pending"] },
    _react2.default.createElement(
      "h2",
      null,
      "Looks like you don\u2019t have any documents squirreling away at the moment!"
    ),
    _react2.default.createElement(
      "h3",
      null,
      "Want to upload documents? Simply click \xA0",
      _react2.default.createElement(
        _reactRouter.Link,
        { to: "/accounts/" + accountSlug + "/upload" },
        "here"
      ),
      "\xA0and drag your files into the box."
    ),
    _react2.default.createElement(
      "h4",
      null,
      "What\u2019s this page about?"
    ),
    _react2.default.createElement(
      "div",
      null,
      "It contains all your digital submissions awaiting processing. Those include documents that you have emailed, uploaded from your computer or snapped from your phone using our mobile app. Once they are processed by our team of operators or manually by yourself, they will automatically disappear from this list."
    ),
    _react2.default.createElement(
      "h4",
      null,
      "What can I do on this page?"
    ),
    _react2.default.createElement(
      "div",
      null,
      _react2.default.createElement(
        "ul",
        null,
        _react2.default.createElement(
          "li",
          null,
          "Check that your digital submissions made it through to Squirrel Street. You can also view their image here, so easy to see if you sent the same one twice by mistake"
        ),
        _react2.default.createElement(
          "li",
          null,
          "Enjoy our DIY feature. This is a great option for users on our DIY plan. You can submit an unlimited number of digital documents and manually enter them at no cost:",
          _react2.default.createElement(
            "ol",
            null,
            _react2.default.createElement(
              "li",
              null,
              "Click on a document to the left to select it"
            ),
            _react2.default.createElement(
              "li",
              null,
              "If the document is a document, fill in the details in the fields below. If the document is another document, click on 'Change type'."
            ),
            _react2.default.createElement(
              "li",
              null,
              "Click on 'Save' at the bottom, and the document will go into the account."
            )
          )
        )
      )
    ),
    _react2.default.createElement(
      "h4",
      null,
      "You thought you uploaded a document but you can\u2019t see it here?"
    ),
    _react2.default.createElement(
      "div",
      null,
      "Check your mails for a rejection notice. Indeed, you\u2019ll receive an email notification when your document is blurry, multiple tax invoices have been scanned in as one document without total amount paid, or your document is incomplete or cropped such that we can't extract fields such as Vendor name or Total."
    ),
    _react2.default.createElement(
      "div",
      null,
      "Check out our ",
      _react2.default.createElement(
        "a",
        { href: REJECTION_SUPPORT_URL },
        "What to do after a rejection notice"
      ),
      " FAQ."
    )
  );
};

NoPending.propTypes = {
  accountSlug: _propTypes2.default.string.isRequired
};

var NoPendingFiltered = exports.NoPendingFiltered = function NoPendingFiltered() {
  return _react2.default.createElement(
    "div",
    { className: _noDocuments2.default["no-pending"] },
    _react2.default.createElement(
      "h2",
      null,
      "Oops!"
    ),
    _react2.default.createElement(
      "div",
      null,
      "There are no documents that match the selected filters."
    )
  );
};

var blankSlate = function blankSlate(accountSlug) {
  return _react2.default.createElement(
    "div",
    { className: _noDocuments2.default["blank-slate"] },
    _react2.default.createElement(
      "h3",
      null,
      "Darn! Looks like you haven't squirreled away any documents yet!"
    ),
    blankSlateText(accountSlug)
  );
};

var noResults = function noResults() {
  return _react2.default.createElement(
    "div",
    { className: _noDocuments2.default["no-results"] },
    _react2.default.createElement(
      "h3",
      null,
      "No documents found"
    )
  );
};

var blankSlateText = function blankSlateText(accountSlug) {
  return _react2.default.createElement(
    "p",
    null,
    "Use the ",
    _react2.default.createElement(
      "a",
      { href: APP_STORE_URL },
      "iOS"
    ),
    " or ",
    _react2.default.createElement(
      "a",
      { href: PLAY_STORE_URL },
      "Android"
    ),
    " mobile apps to capture and submit a document, or upload a document directly from your computer on\xA0",
    _react2.default.createElement(
      _reactRouter.Link,
      { to: "/accounts/" + accountSlug + "/upload" },
      "the submit page"
    ),
    ". Your documents will be listed here once processed and ready."
  );
};

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentsInlineTabs = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _inlineTabs = __webpack_require__(196);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DocumentsInlineTabs = exports.DocumentsInlineTabs = function DocumentsInlineTabs(props) {
  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(_inlineTabs.InlineTabs, { tabValues: tabValues(props) })
  );
};

var hardCodedTabs = function hardCodedTabs(accountSlug, currentPage) {
  return [{
    name: "All Documents",
    path: "/accounts/" + accountSlug + "/documents/all",
    isSelected: currentPage === "all" || currentPage === "all/:filter"
  }, {
    name: "This Financial Year",
    path: "/accounts/" + accountSlug + "/documents/this-financial-year",
    isSelected: currentPage === "this-financial-year"
  }];
};

var tabValues = function tabValues(_ref) {
  var accountSlug = _ref.accountSlug,
      currentPage = _ref.currentPage,
      customTabs = _ref.customTabs,
      onStartDeleteCustomTabMode = _ref.onStartDeleteCustomTabMode,
      routeParams = _ref.routeParams;

  var initialTabs = hardCodedTabs(accountSlug, currentPage);
  if (!customTabs) {
    return _ramda2.default.append(addTabObject(accountSlug, currentPage), initialTabs);
  }
  var selected = currentPage === "custom/:customTab" ? routeParams.customTab : currentPage;
  var customTabArray = customTabs.map(function (tab) {
    return {
      id: tab.id,
      name: tab.name,
      path: "/accounts/" + accountSlug + "/documents/custom/" + tab.id,
      isCustom: true,
      isSelected: selected === tab.id,
      onDelete: function onDelete() {
        return onStartDeleteCustomTabMode(tab.id);
      }
    };
  });

  if (customTabs.length > 2) {
    return _ramda2.default.concat(initialTabs, customTabArray);
  }
  var newCustomTabArray = _ramda2.default.append(addTabObject(accountSlug, currentPage), customTabArray);
  return _ramda2.default.concat(initialTabs, newCustomTabArray);
};

var addTabObject = function addTabObject(accountSlug, currentPage) {
  return {
    name: "+",
    path: "/accounts/" + accountSlug + "/documents/custom-tab",
    isSelected: currentPage === "custom-tab"
  };
};

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExportButton = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _exportButton = __webpack_require__(1324);

var _exportButton2 = _interopRequireDefault(_exportButton);

var _button = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExportButton = exports.ExportButton = function ExportButton(_ref) {
  var accountSlug = _ref.accountSlug,
      glCodes = _ref.glCodes,
      onLinkAccount = _ref.onLinkAccount,
      onStartExportMode = _ref.onStartExportMode,
      selectedDocumentIds = _ref.selectedDocumentIds;
  return _react2.default.createElement(
    "span",
    { className: _exportButton2.default.button },
    renderExportButton(accountSlug, glCodes, selectedDocumentIds, onLinkAccount, onStartExportMode)
  );
};

ExportButton.propTypes = {
  accountSlug: _react.PropTypes.string.isRequired,
  glCodes: _react.PropTypes.arrayOf(_react.PropTypes.object).isRequired,
  onLinkAccount: _react.PropTypes.func.isRequired,
  onStartExportMode: _react.PropTypes.func.isRequired,
  selectedDocumentIds: _react.PropTypes.arrayOf(_react.PropTypes.string).isRequired
};

var renderExportButton = function renderExportButton(accountSlug, glCodes, selectedDocumentIds, onLinkAccount, onStartExportMode) {
  // TODO: This is a temporary fix until the API call for GET integration details is created.
  // Until then we have to judge whether or not an integration exists based on the existence of GL codes.
  if (glCodes.length === 0) {
    return _react2.default.createElement(
      _button.Button,
      { onClick: function onClick() {
          return onLinkAccount(accountSlug);
        }, primary: true },
      "Link your accounting software"
    );
  }
  if (selectedDocumentIds.length > 0) {
    return _react2.default.createElement(
      _button.Button,
      { onClick: function onClick() {
          return onStartExportMode();
        }, primary: true },
      "Export Selected"
    );
  }
  return _react2.default.createElement(
    _button.Button,
    { onClick: function onClick() {
        return onStartExportMode();
      }, primary: true },
    "Export All"
  );
};

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActiveFilters = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _activeFilters = __webpack_require__(323);

var _activeFilters2 = _interopRequireDefault(_activeFilters);

var _exportTypeSelector = __webpack_require__(268);

var _activeFilterItem = __webpack_require__(116);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActiveFilters = exports.ActiveFilters = function ActiveFilters(_ref) {
  var exportType = _ref.exportType,
      isExports = _ref.isExports,
      onClearExportType = _ref.onClearExportType,
      onRemoveCardNumber = _ref.onRemoveCardNumber,
      onRemoveCategory = _ref.onRemoveCategory,
      onRemoveCurrency = _ref.onRemoveCurrency,
      onRemoveDocumentType = _ref.onRemoveDocumentType,
      onRemoveEnvelope = _ref.onRemoveEnvelope,
      onRemoveNameFromFilter = _ref.onRemoveNameFromFilter,
      onRemovePaymentType = _ref.onRemovePaymentType,
      onRemoveSearchQuery = _ref.onRemoveSearchQuery,
      onRemoveVendor = _ref.onRemoveVendor,
      onRemoveViewedStatus = _ref.onRemoveViewedStatus,
      searchQueryString = _ref.searchQueryString,
      selectedCardNumbers = _ref.selectedCardNumbers,
      selectedCategories = _ref.selectedCategories,
      selectedCurrencies = _ref.selectedCurrencies,
      selectedDocumentType = _ref.selectedDocumentType,
      selectedEnvelopes = _ref.selectedEnvelopes,
      selectedName = _ref.selectedName,
      selectedPaymentTypes = _ref.selectedPaymentTypes,
      selectedVendors = _ref.selectedVendors,
      viewedStatus = _ref.viewedStatus;

  var isEmptyResult = isEmpty(searchQueryString, selectedCardNumbers, selectedCategories, selectedCurrencies, selectedDocumentType, selectedDocumentType, selectedVendors, selectedName, selectedPaymentTypes, selectedEnvelopes, exportType, viewedStatus);
  if (isEmptyResult) {
    return null;
  }
  return _react2.default.createElement(
    "div",
    { className: _activeFilters2.default.container },
    renderExportFilter(isExports),
    renderSearchQuery("document type", selectedDocumentType, onRemoveDocumentType),
    renderSelectedItems("categories", selectedCategories, onRemoveCategory),
    renderSelectedItems("currencies", selectedCurrencies, onRemoveCurrency),
    renderSelectedItems("envelopes", selectedEnvelopes, onRemoveEnvelope),
    renderSelectedExportType(exportType, onClearExportType),
    renderSelectedItems("payment types", selectedPaymentTypes, onRemovePaymentType),
    renderSelectedItems("vendors", selectedVendors, onRemoveVendor),
    renderSelectedItems("card numbers", selectedCardNumbers, onRemoveCardNumber),
    renderSearchQuery("search query", searchQueryString, onRemoveSearchQuery),
    renderSearchQuery("name", selectedName, onRemoveNameFromFilter),
    renderViewedStatus("viewed status", viewedStatus, onRemoveViewedStatus)
  );
};

ActiveFilters.propTypes = {
  exportType: _propTypes2.default.string,
  isExports: _propTypes2.default.bool.isRequired,
  onClearExportType: _propTypes2.default.func.isRequired, // (string) => void
  onRemoveCardNumber: _propTypes2.default.func.isRequired, // (string) => void
  onRemoveCategory: _propTypes2.default.func.isRequired, // (string) => void
  onRemoveCurrency: _propTypes2.default.func.isRequired, // (string) => void
  onRemoveDocumentType: _propTypes2.default.func.isRequired,
  onRemoveEnvelope: _propTypes2.default.func.isRequired, // (string) => void
  onRemoveNameFromFilter: _propTypes2.default.func,
  onRemovePaymentType: _propTypes2.default.func.isRequired, // (string) => void
  onRemoveSearchQuery: _propTypes2.default.func,
  onRemoveVendor: _propTypes2.default.func.isRequired, // (string) => void
  onRemoveViewedStatus: _propTypes2.default.func.isRequired,
  searchQueryString: _propTypes2.default.string,
  selectedCardNumbers: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  selectedCategories: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  selectedCurrencies: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  selectedDocumentType: _propTypes2.default.string,
  selectedEnvelopes: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  selectedName: _propTypes2.default.string,
  selectedPaymentTypes: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  selectedVendors: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  viewedStatus: _propTypes2.default.string.isRequired
};

ActiveFilters.defaultProps = {
  exportType: null,
  name: "",
  onRemoveSearchQuery: null,
  onRemoveName: null,
  onRemoveNameFromFilter: null,
  searchQueryString: null,
  selectedDocumentType: null,
  selectedName: null
};

var renderSelectedExportType = function renderSelectedExportType(exportType, onClearExportType) {
  return exportType === null ? null : renderSelectedItems("export type", [(0, _exportTypeSelector.labelForExportType)(exportType)], onClearExportType);
};

var renderSelectedItems = function renderSelectedItems(name, items, onRemoveItem) {
  if (items.length === 0) {
    return null;
  }
  return _react2.default.createElement(
    "div",
    { className: _activeFilters2.default["active-filter-group"] },
    _react2.default.createElement(
      "span",
      { className: _activeFilters2.default["group-title"] },
      "Selected ",
      name
    ),
    _react2.default.createElement(
      "div",
      null,
      items.map(function (item) {
        return renderItem(item, onRemoveItem, name);
      })
    )
  );
};

var renderSearchQuery = function renderSearchQuery(name, item, onRemoveItem) {
  if (item === null || item === "") {
    return null;
  }
  return _react2.default.createElement(
    "div",
    { className: _activeFilters2.default["active-filter-group"] },
    _react2.default.createElement(
      "span",
      { className: _activeFilters2.default["group-title"] },
      "Selected ",
      name
    ),
    _react2.default.createElement(
      "div",
      null,
      renderItem(item, onRemoveItem, name)
    )
  );
};

var renderViewedStatus = function renderViewedStatus(name, item, onRemoveItem) {
  if (item === "") {
    return null;
  }
  return _react2.default.createElement(
    "div",
    { className: _activeFilters2.default["active-filter-group"] },
    _react2.default.createElement(
      "span",
      { className: _activeFilters2.default["group-title"] },
      "Selected ",
      name
    ),
    _react2.default.createElement(
      "div",
      null,
      renderItem(item, onRemoveItem, name)
    )
  );
};

var renderItem = function renderItem(item, onRemoveItem, name) {
  return _react2.default.createElement(
    "span",
    { key: name + "-" + item },
    _react2.default.createElement(_activeFilterItem.ActiveFilterItem, { name: item, onRemove: onRemoveItem })
  );
};

var isEmpty = function isEmpty(searchQueryString, selectedCardNumbers, selectedCategories, selectedCurrencies, selectedDocumentType, selectedVendors, selectedName, selectedPaymentTypes, selectedEnvelopes, exportType) {
  return searchQueryString === null && selectedName === null && selectedCardNumbers.length === 0 && selectedCategories.length === 0 && selectedCurrencies.length === 0 && selectedDocumentType === null && selectedVendors.length === 0 && selectedPaymentTypes.length === 0 && selectedEnvelopes.length === 0 && exportType === null;
};

var renderExportFilter = function renderExportFilter(isExports) {
  if (isExports) {
    return _react2.default.createElement(
      "div",
      { className: _activeFilters2.default["active-filter-group"] },
      _react2.default.createElement(
        "span",
        { className: _activeFilters2.default["group-title"] },
        "Export page filter"
      ),
      _react2.default.createElement(
        "div",
        null,
        renderItem("Has not been exported", null, "not-exported")
      )
    );
  }
  return null;
};

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentTypeSelector = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _select = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DocumentTypeSelector = exports.DocumentTypeSelector = function DocumentTypeSelector(_ref) {
  var onChange = _ref.onChange;
  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      "span",
      null,
      "Document Type"
    ),
    _react2.default.createElement(_select.SimpleSelect, {
      data: options,
      onChange: onChange,
      placeholder: "Select a document type..."
    })
  );
};

DocumentTypeSelector.propTypes = {
  onChange: _propTypes2.default.func.isRequired
};

var options = [{ key: "receipt", name: "Receipt" }, { key: "other", name: "Other document" }];

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentTypeFilterField = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSelect = __webpack_require__(135);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _paymentTypeFilterField = __webpack_require__(1331);

var _paymentTypeFilterField2 = _interopRequireDefault(_paymentTypeFilterField);

var _customPropTypes = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaymentTypeFilterField = exports.PaymentTypeFilterField = function PaymentTypeFilterField(_ref) {
  var cardNumbers = _ref.cardNumbers,
      lastFourDigits = _ref.lastFourDigits,
      onAddPaymentType = _ref.onAddPaymentType,
      onAddCardNumber = _ref.onAddCardNumber,
      selectedPaymentTypes = _ref.selectedPaymentTypes;

  if (selectedPaymentTypes.indexOf("credit-card") > -1) {
    return _react2.default.createElement(
      "div",
      null,
      _react2.default.createElement(
        "div",
        { className: _paymentTypeFilterField2.default["payment-title"] },
        "Payment Type"
      ),
      _react2.default.createElement(
        "div",
        { className: _paymentTypeFilterField2.default["digits-title"] },
        "Last four digits"
      ),
      _react2.default.createElement(
        "div",
        { className: _paymentTypeFilterField2.default["payment-type-container"] },
        _react2.default.createElement(_reactSelect2.default, {
          className: _paymentTypeFilterField2.default["shared-select"],
          onChange: onAddPaymentType,
          options: mapPaymentTypes(paymentTypes),
          placeholder: "Add a payment type"
        }),
        _react2.default.createElement(_reactSelect2.default, {
          className: _paymentTypeFilterField2.default["shared-select"] + " " + _paymentTypeFilterField2.default.lastFourDigits,
          defaultValue: lastFourDigits || "",
          onChange: function onChange(e) {
            onAddCardNumber(e);
          },
          options: mapCardNumbers(cardNumbers),
          placeholder: "Last four digits..."
        })
      )
    );
  }
  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      "div",
      null,
      "Payment Type"
    ),
    _react2.default.createElement(_reactSelect2.default, {
      onChange: onAddPaymentType,
      options: mapPaymentTypes(paymentTypes),
      placeholder: "Add a payment type"
    })
  );
};

PaymentTypeFilterField.defaultProps = {
  lastFourDigits: null
};

PaymentTypeFilterField.propTypes = {
  cardNumbers: _propTypes2.default.arrayOf(_customPropTypes.cardNumberType).isRequired,
  lastFourDigits: _propTypes2.default.string,
  onAddCardNumber: _propTypes2.default.func.isRequired,
  onAddPaymentType: _propTypes2.default.func.isRequired,
  selectedPaymentTypes: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired
};

var paymentTypes = [{ key: "credit-card", name: "Card" }, { key: "cash", name: "Cash" }, { key: "check", name: "Cheque" }, { key: "paypal", name: "PayPal" }, { key: "other", name: "Other" }];
var mapPaymentTypes = function mapPaymentTypes(payments) {
  return payments.map(function (payment) {
    return { label: payment.name, key: payment.key };
  });
};
var mapCardNumbers = function mapCardNumbers(cardNumbers) {
  return cardNumbers.filter(function (card) {
    return card.lastFourDigits !== null;
  }).map(function (card) {
    return { label: card.name, key: card.lastFourDigits };
  });
};

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrashDocumentModal = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _modal = __webpack_require__(27);

var _button = __webpack_require__(7);

var _trashDocumentModal = __webpack_require__(1334);

var _trashDocumentModal2 = _interopRequireDefault(_trashDocumentModal);

var _customPropTypes = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TrashDocumentModal = exports.TrashDocumentModal = function TrashDocumentModal(_ref) {
  var accountId = _ref.accountId,
      focusedDocument = _ref.focusedDocument,
      isTrashDocumentVisible = _ref.isTrashDocumentVisible,
      onHideTrashDocument = _ref.onHideTrashDocument,
      onTrashDocument = _ref.onTrashDocument;
  return _react2.default.createElement(
    _modal.Modal,
    {
      isVisible: isTrashDocumentVisible,
      onClose: onHideTrashDocument,
      transitionName: "trash-document"
    },
    _react2.default.createElement(
      "div",
      null,
      _react2.default.createElement(
        "h3",
        null,
        "Send document to trash?"
      ),
      _react2.default.createElement(
        "div",
        { className: _trashDocumentModal2.default.buttons },
        _react2.default.createElement(
          _button.Button,
          { link: true, onClick: onHideTrashDocument },
          "cancel"
        ),
        _react2.default.createElement(
          _button.Button,
          { danger: true, onClick: function onClick() {
              onTrashDocument(accountId, focusedDocument);onHideTrashDocument();
            } },
          "Trash"
        )
      )
    )
  );
};

TrashDocumentModal.defaultProps = {
  focusedDocument: null
};

TrashDocumentModal.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  focusedDocument: _customPropTypes.focusedDocumentType,
  isTrashDocumentVisible: _propTypes2.default.bool.isRequired,
  onHideTrashDocument: _propTypes2.default.func.isRequired,
  onTrashDocument: _propTypes2.default.func.isRequired
};

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CategoryCellFormatter = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _reactSizeme = __webpack_require__(386);

var _categoryCell = __webpack_require__(511);

var _categoryCell2 = _interopRequireDefault(_categoryCell);

var _validators = __webpack_require__(36);

var _xeroIcon = __webpack_require__(1400);

var _xeroIcon2 = _interopRequireDefault(_xeroIcon);

var _myobIcon = __webpack_require__(1392);

var _myobIcon2 = _interopRequireDefault(_myobIcon);

var _sageIcon = __webpack_require__(1397);

var _sageIcon2 = _interopRequireDefault(_sageIcon);

var _qboIcon = __webpack_require__(1394);

var _qboIcon2 = _interopRequireDefault(_qboIcon);

var _saasuIcon = __webpack_require__(1396);

var _saasuIcon2 = _interopRequireDefault(_saasuIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CategoryCell = function CategoryCell(_ref) {
  var documentCount = _ref.documentCount,
      rowIndex = _ref.rowIndex,
      size = _ref.size,
      value = _ref.value;

  var newValue = typeof value === "string" ? JSON.parse(value) : value;
  if (!(0, _validators.isValidValue)(newValue) || newValue.length === 0) {
    return null;
  }
  var charLength = newValue.reduce(function (a, b) {
    return a + b.length;
  }, 0);
  var length = charLength * 5 + newValue.length * 27;
  var tooltipStyle = rowIndex < documentCount / 2 ? _categoryCell2.default["tooltip-bottom"] : _categoryCell2.default["tooltip-top"];
  return _react2.default.createElement(
    "div",
    { className: _categoryCell2.default.container },
    newValue.map(renderCategory),
    renderTooltip(length, size, newValue, tooltipStyle)
  );
};

var CategoryCellFormatter = exports.CategoryCellFormatter = (0, _reactSizeme.withSize)()(CategoryCell);

CategoryCell.defaultProps = {
  value: []
};

CategoryCell.propTypes = {
  documentCount: _propTypes2.default.number.isRequired,
  rowIndex: _propTypes2.default.number.isRequired,
  size: _propTypes2.default.shape({ size: _propTypes2.default.number }).isRequired,
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]) // Stringified JSON
};

var renderTooltip = function renderTooltip(length, size, value, tooltipStyle) {
  if (length > size.width) {
    return _react2.default.createElement(
      "div",
      { className: tooltipStyle },
      value.map(renderCategory)
    );
  }
  return null;
};

var renderCategory = function renderCategory(categoryName, index) {
  return _react2.default.createElement(
    "div",
    { className: _categoryCell2.default.tag, key: categoryName + "-" + index },
    renderSpecialCategoryPrefix(categoryName),
    renderCategoryName(categoryName)
  );
};

var renderSpecialCategoryPrefix = function renderSpecialCategoryPrefix(name) {
  switch (true) {
    case name.startsWith("Xero"):
      return _react2.default.createElement("img", { alt: "xero icon", className: _categoryCell2.default.icon, height: 12, src: _xeroIcon2.default });
    case name.startsWith("MYOB"):
      return _react2.default.createElement("img", { alt: "myob icon", className: _categoryCell2.default.icon, height: 12, src: _myobIcon2.default });
    case name.startsWith("SageOne"):
      return _react2.default.createElement("img", { alt: "sage one icon", className: _categoryCell2.default.icon, height: 12, src: _sageIcon2.default });
    case name.startsWith("QBO"):
      return _react2.default.createElement("img", { alt: "qbo icon", className: _categoryCell2.default.icon, height: 12, src: _qboIcon2.default });
    case name.startsWith("SaasuV2"):
      return _react2.default.createElement("img", { alt: "saasu icon", className: _categoryCell2.default.icon, height: 12, src: _saasuIcon2.default });
    case "Export failed":
      return _react2.default.createElement(
        "span",
        { className: _categoryCell2.default.warn },
        "!"
      );
    default:
      return null;
  }
};

var renderCategoryName = function renderCategoryName(name) {
  if (name.startsWith("Xero") || name.startsWith("MYOB") || name.startsWith("SageOne") || name.startsWith("QBO") || name.startsWith("SassuV2")) {
    return _ramda2.default.drop(1, name.split("-")).join("-");
  }
  return name;
};

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DownloadUrlCellFormatter = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _download = __webpack_require__(1009);

var _download2 = _interopRequireDefault(_download);

var _customPropTypes = __webpack_require__(5);

var _validators = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DownloadUrlCellFormatter = exports.DownloadUrlCellFormatter = function DownloadUrlCellFormatter(_ref) {
  var value = _ref.value;

  if (!(0, _validators.isValidValue)(value)) {
    return _react2.default.createElement("span", null);
  }
  return _react2.default.createElement(
    "a",
    { href: value.url || value, rel: "noopener noreferrer", tabIndex: -1, target: "_blank" },
    _react2.default.createElement(_download2.default, { size: 20 })
  );
};

DownloadUrlCellFormatter.defaultProps = {
  value: null
};

DownloadUrlCellFormatter.propTypes = {
  value: _propTypes2.default.oneOfType([_customPropTypes.attachmentType, _propTypes2.default.string])
};

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimpleMoneyCellFormatter = exports.MoneyCellFormatter = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusCellFormatters = __webpack_require__(325);

var _focusCellFormatters2 = _interopRequireDefault(_focusCellFormatters);

var _customPropTypes = __webpack_require__(5);

var _validators = __webpack_require__(36);

var _stringHelpers = __webpack_require__(68);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MoneyCellFormatter = exports.MoneyCellFormatter = function MoneyCellFormatter(_ref) {
  var accountId = _ref.accountId,
      defaultCurrency = _ref.defaultCurrency,
      document = _ref.document,
      field = _ref.field,
      isFocused = _ref.isFocused,
      onUpdateDocument = _ref.onUpdateDocument,
      onUpdateInlineDocument = _ref.onUpdateInlineDocument,
      value = _ref.value;

  if (isFocused && document.type === "receipt") {
    return _react2.default.createElement(
      "div",
      null,
      _react2.default.createElement("input", {
        className: _focusCellFormatters2.default.input,
        defaultValue: value,
        onBlur: function onBlur(e) {
          return onUpdateInlineDocument({ accountId: accountId, document: document, field: field, value: (0, _stringHelpers.normalizeNumber)(e.target.value) });
        },
        onChange: function onChange(e) {
          return onUpdateDocument(field, (0, _stringHelpers.normalizeNumber)(e.target.value));
        },
        type: "text"
      })
    );
  }
  return _react2.default.createElement(SimpleMoneyCellFormatter, {
    currency: document.currency,
    defaultCurrency: defaultCurrency,
    value: value
  });
};

MoneyCellFormatter.defaultProps = {
  currency: "AUD",
  defaultCurrency: "AUD",
  value: undefined
};

MoneyCellFormatter.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  defaultCurrency: _propTypes2.default.string,
  document: _customPropTypes.documentPropType.isRequired,
  field: _propTypes2.default.string.isRequired,
  isFocused: _propTypes2.default.bool.isRequired,
  onUpdateDocument: _propTypes2.default.func.isRequired,
  onUpdateInlineDocument: _propTypes2.default.func.isRequired,
  value: _react2.default.PropTypes.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};

var SimpleMoneyCellFormatter = exports.SimpleMoneyCellFormatter = function SimpleMoneyCellFormatter(_ref2) {
  var currency = _ref2.currency,
      defaultCurrency = _ref2.defaultCurrency,
      value = _ref2.value;

  if (!(0, _validators.isValidValue)(value)) {
    return _react2.default.createElement("div", null);
  }
  var currencySymbol = getCurrencySymbol(currency, defaultCurrency, value);
  if (currency !== defaultCurrency) {
    return _react2.default.createElement(
      "div",
      null,
      _react2.default.createElement(
        "i",
        null,
        value < 0 ? "-" : "",
        currencySymbol,
        formatNumber(value)
      )
    );
  }
  return _react2.default.createElement(
    "div",
    null,
    value < 0 ? "-" : "",
    currencySymbol,
    formatNumber(value)
  );
};

SimpleMoneyCellFormatter.defaultProps = {
  currency: "AUD",
  defaultCurrency: "AUD",
  value: undefined
};

SimpleMoneyCellFormatter.propTypes = {
  currency: _propTypes2.default.string,
  defaultCurrency: _propTypes2.default.string,
  value: _react2.default.PropTypes.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};

var getCurrencySymbol = function getCurrencySymbol(currency) {
  switch (currency) {
    case "HKD":
    case "NZD":
    case "USD":
    case "CAD":
    case "AUD":
    case "SGD":
      return _react2.default.createElement(
        "span",
        null,
        "$",
        _react2.default.createElement(
          "span",
          { className: _focusCellFormatters2.default.currency },
          currency
        )
      );
    case "CHF":
      return _react2.default.createElement(
        "span",
        null,
        "Fr",
        _react2.default.createElement(
          "span",
          { className: _focusCellFormatters2.default.currency },
          currency
        )
      );
    case "MXN":
      return _react2.default.createElement(
        "span",
        null,
        "Ps",
        _react2.default.createElement(
          "span",
          { className: _focusCellFormatters2.default.currency },
          currency
        )
      );
    case "EUR":
      return _react2.default.createElement(
        "span",
        null,
        "\u20AC",
        _react2.default.createElement(
          "span",
          { className: _focusCellFormatters2.default.currency },
          currency
        )
      );
    case "SEK":
    case "DKK":
    case "NOK":
      return _react2.default.createElement(
        "span",
        null,
        "Kr",
        _react2.default.createElement(
          "span",
          { className: _focusCellFormatters2.default.currency },
          currency
        )
      );
    case "JPY":
    case "CNY":
      return _react2.default.createElement(
        "span",
        null,
        "\xA5",
        _react2.default.createElement(
          "span",
          { className: _focusCellFormatters2.default.currency },
          currency
        )
      );
    case "PLN":
      return _react2.default.createElement(
        "span",
        null,
        "z\u0142",
        _react2.default.createElement(
          "span",
          { className: _focusCellFormatters2.default.currency },
          currency
        )
      );
    case "GBP":
      return _react2.default.createElement(
        "span",
        null,
        "\xA3",
        _react2.default.createElement(
          "span",
          { className: _focusCellFormatters2.default.currency },
          currency
        )
      );
    case "PHP":
      return _react2.default.createElement(
        "span",
        null,
        "\u20B1",
        _react2.default.createElement(
          "span",
          { className: _focusCellFormatters2.default.currency },
          currency
        )
      );
    case "ZAR":
      return _react2.default.createElement(
        "span",
        null,
        "R",
        _react2.default.createElement(
          "span",
          { className: _focusCellFormatters2.default.currency },
          currency
        )
      );
    case "CZK":
      return _react2.default.createElement(
        "span",
        null,
        "K\u010D",
        _react2.default.createElement(
          "span",
          { className: _focusCellFormatters2.default.currency },
          currency
        )
      );
    case "INR":
      return _react2.default.createElement(
        "span",
        null,
        "\u20B9",
        _react2.default.createElement(
          "span",
          { className: _focusCellFormatters2.default.currency },
          currency
        )
      );
    case "IDR":
      return _react2.default.createElement(
        "span",
        null,
        "Rp",
        _react2.default.createElement(
          "span",
          { className: _focusCellFormatters2.default.currency },
          currency
        )
      );
    case "RON":
      return _react2.default.createElement(
        "span",
        null,
        "lei",
        _react2.default.createElement(
          "span",
          { className: _focusCellFormatters2.default.currency },
          currency
        )
      );
    case "THB":
      return _react2.default.createElement(
        "span",
        null,
        "\u0E3F",
        _react2.default.createElement(
          "span",
          { className: _focusCellFormatters2.default.currency },
          currency
        )
      );
    case "HUF":
      return _react2.default.createElement(
        "span",
        null,
        "ft",
        _react2.default.createElement(
          "span",
          { className: _focusCellFormatters2.default.currency },
          currency
        )
      );
    case "MYR":
      return _react2.default.createElement(
        "span",
        null,
        "RM",
        _react2.default.createElement(
          "span",
          { className: _focusCellFormatters2.default.currency },
          currency
        )
      );
    default:
      return _react2.default.createElement(
        "span",
        null,
        "$",
        _react2.default.createElement(
          "span",
          { className: _focusCellFormatters2.default.currency },
          currency
        )
      );
  }
};

var formatNumber = function formatNumber(number) {
  return Math.abs(number).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentTypeCellFormatter = exports.PaymentTypeCell = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSizeme = __webpack_require__(386);

var _validators = __webpack_require__(36);

var _focusCellFormatters = __webpack_require__(325);

var _focusCellFormatters2 = _interopRequireDefault(_focusCellFormatters);

var _customPropTypes = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaymentTypeCell = exports.PaymentTypeCell = function PaymentTypeCell(_ref) {
  var documentCount = _ref.documentCount,
      rowIndex = _ref.rowIndex,
      size = _ref.size,
      value = _ref.value;

  if (!(0, _validators.isValidValue)(value)) {
    return _react2.default.createElement(
      "div",
      null,
      "Other"
    );
  }

  var newValue = value;
  if (typeof value === "string") {
    newValue = JSON.parse(value);
  }

  var length = newValue.type ? newValue.type.length * 5 : 0;
  length = newValue.lastFourDigits ? length += newValue.lastFourDigits.length * 5 : length;
  var tooltipStyle = rowIndex < documentCount / 2 ? _focusCellFormatters2.default["tooltip-bottom"] : _focusCellFormatters2.default["tooltip-top"];
  return _react2.default.createElement(
    "div",
    { className: _focusCellFormatters2.default.container },
    renderValue(newValue),
    renderTooltip(length, size, newValue, tooltipStyle)
  );
};

PaymentTypeCell.defaultProps = {
  value: {}
};

PaymentTypeCell.propTypes = {
  documentCount: _propTypes2.default.number.isRequired,
  rowIndex: _propTypes2.default.number.isRequired,
  size: _propTypes2.default.shape({ size: _propTypes2.default.number }).isRequired,
  value: _customPropTypes.paymentTypeType
};

var PaymentTypeCellFormatter = exports.PaymentTypeCellFormatter = (0, _reactSizeme.withSize)()(PaymentTypeCell);

var renderTooltip = function renderTooltip(length, size, value, tooltipStyle) {
  if (length > size.width) {
    return _react2.default.createElement(
      "div",
      { className: tooltipStyle },
      renderValue(value)
    );
  }
  return null;
};

var renderValue = function renderValue(newValue) {
  switch (newValue.type) {
    case "credit-card":
      return _react2.default.createElement(
        "div",
        null,
        "Credit card ",
        newValue.lastFourDigits ? "(" + newValue.lastFourDigits + ")" : ""
      );
    case "cash":
      return _react2.default.createElement(
        "div",
        null,
        "Cash"
      );
    case "cheque":
    case "check":
      return _react2.default.createElement(
        "div",
        null,
        "Cheque"
      );
    case "paypal":
      return _react2.default.createElement(
        "div",
        null,
        "PayPal"
      );
    default:
      return _react2.default.createElement(
        "div",
        null,
        "Other"
      );
  }
};

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectCellFormatter = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _customPropTypes = __webpack_require__(5);

var _selectCellFormatter = __webpack_require__(1337);

var _selectCellFormatter2 = _interopRequireDefault(_selectCellFormatter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectCellFormatter = exports.SelectCellFormatter = function SelectCellFormatter(_ref) {
  var documents = _ref.documents,
      id = _ref.id,
      isSelected = _ref.isSelected,
      isShiftPressed = _ref.isShiftPressed,
      onRowsDeselected = _ref.onRowsDeselected,
      onRowsSelected = _ref.onRowsSelected,
      selectedDocumentIds = _ref.selectedDocumentIds;

  if (isSelected) {
    return _react2.default.createElement("div", { className: _selectCellFormatter2.default.checkbox + " " + _selectCellFormatter2.default.selected, onClick: function onClick() {
        return onRowsDeselected(id);
      } });
  }
  return _react2.default.createElement("div", {
    className: _selectCellFormatter2.default.checkbox,
    onClick: function onClick() {
      return multiSelectOrNot(documents, id, isShiftPressed, onRowsSelected, selectedDocumentIds);
    }
  });
};

SelectCellFormatter.defaultProps = {
  documents: [],
  id: null,
  isShiftPressed: false,
  selectedDocumentIds: []
};

SelectCellFormatter.propTypes = {
  documents: _propTypes2.default.arrayOf(_customPropTypes.documentPropType),
  id: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.string]),
  isSelected: _propTypes2.default.bool.isRequired,
  isShiftPressed: _propTypes2.default.bool,
  onRowsDeselected: _propTypes2.default.func.isRequired,
  onRowsSelected: _propTypes2.default.func.isRequired,
  selectedDocumentIds: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

var multiSelectOrNot = function multiSelectOrNot(documents, id, isShiftPressed, onRowsSelected, selectedDocumentIds) {
  if (selectedDocumentIds.length > 0 && isShiftPressed) {
    var currentIndex = _ramda2.default.findIndex(_ramda2.default.propEq("id", id))(documents);
    var lastIndex = _ramda2.default.findIndex(_ramda2.default.propEq("id", selectedDocumentIds[selectedDocumentIds.length - 1]))(documents);
    var first = currentIndex > lastIndex ? lastIndex : currentIndex;
    var second = currentIndex > lastIndex ? currentIndex : lastIndex;
    var multiSelectArray = _ramda2.default.slice(first, second + 1, documents);
    return multiSelectArray.forEach(function (document) {
      return onRowsSelected(document.id);
    });
  }
  return onRowsSelected(id);
};

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UploadSourceCellFormatter = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _envelope = __webpack_require__(447);

var _envelope2 = _interopRequireDefault(_envelope);

var _exchange = __webpack_require__(1010);

var _exchange2 = _interopRequireDefault(_exchange);

var _at = __webpack_require__(1005);

var _at2 = _interopRequireDefault(_at);

var _cloudUpload = __webpack_require__(446);

var _cloudUpload2 = _interopRequireDefault(_cloudUpload);

var _question = __webpack_require__(1012);

var _question2 = _interopRequireDefault(_question);

var _uploadSourceCellFormatter = __webpack_require__(1339);

var _uploadSourceCellFormatter2 = _interopRequireDefault(_uploadSourceCellFormatter);

var _customPropTypes = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UploadSourceCellFormatter = exports.UploadSourceCellFormatter = function UploadSourceCellFormatter(_ref) {
  var value = _ref.value;

  var _getSourceValue = getSourceValue(value),
      source = _getSourceValue.source,
      tooltip = _getSourceValue.tooltip;

  return _react2.default.createElement(
    "div",
    { className: _uploadSourceCellFormatter2.default.container },
    source,
    _react2.default.createElement(
      "div",
      { className: _uploadSourceCellFormatter2.default.tooltip, style: { left: -tooltip.length * 4 - 20 } },
      tooltip
    )
  );
};

UploadSourceCellFormatter.propTypes = {
  value: _customPropTypes.uploadType.isRequired
};

var getSourceValue = function getSourceValue(value) {
  switch (value.type) {
    case "mail":
      return { source: _react2.default.createElement(_envelope2.default, { size: 15 }), tooltip: "Envelope" };
    case "integration":
      return { source: _react2.default.createElement(_exchange2.default, { size: 15 }), tooltip: "Integration" };
    case "email":
      return { source: _react2.default.createElement(_at2.default, { size: 15 }), tooltip: "Email" };
    case "web":
      return { source: _react2.default.createElement(_cloudUpload2.default, { size: 15 }), tooltip: "Web Upload" };
    case "unknown":
    default:
      return { source: _react2.default.createElement(_question2.default, { size: 15 }), tooltip: "Unknown" };
  }
};

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewedCellFormatter = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _validators = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ViewedCellFormatter = exports.ViewedCellFormatter = function ViewedCellFormatter(_ref) {
  var value = _ref.value;

  if (!(0, _validators.isValidValue)(value)) {
    return _react2.default.createElement("span", null);
  }
  return _react2.default.createElement(
    "div",
    null,
    " ",
    value ? "Yes" : "No",
    " "
  );
};

ViewedCellFormatter.propTypes = {
  value: _propTypes2.default.bool.isRequired
};

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ManageEnvelopes = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _reactVirtualized = __webpack_require__(113);

var _manageEnvelopes = __webpack_require__(1343);

var _manageEnvelopes2 = _interopRequireDefault(_manageEnvelopes);

var _customPropTypes = __webpack_require__(5);

var _button = __webpack_require__(7);

var _requestEnvelopeModal = __webpack_require__(895);

var _sendEnvelopeModal = __webpack_require__(896);

var _noEnvelopes = __webpack_require__(894);

var _gridComponents = __webpack_require__(166);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ManageEnvelopes = function ManageEnvelopes(props) {
  var envelopes = props.envelopes;
  if (props.isAwaitingMailin) {
    envelopes = _ramda2.default.filter(function (envelope) {
      return (0, _moment2.default)(envelope.received).isValid() && envelope.uploaded === null;
    }, props.envelopes);
  }
  var columns = getColumns(props.isAwaitingMailin);
  return _react2.default.createElement(
    "div",
    { className: _manageEnvelopes2.default.container },
    _react2.default.createElement(
      "div",
      { className: _manageEnvelopes2.default.title },
      _react2.default.createElement(
        "h1",
        null,
        props.title
      ),
      _react2.default.createElement(
        "div",
        { className: _manageEnvelopes2.default["envelope-actions"] },
        _react2.default.createElement(
          _button.Button,
          { onClick: props.onShowSendEnvelope },
          "Send your own envelope"
        ),
        _react2.default.createElement(
          _button.Button,
          { onClick: props.onShowRequestEnvelope, primary: true },
          "Request a magic envelope"
        )
      )
    ),
    _react2.default.createElement(
      "div",
      null,
      _react2.default.createElement(
        _reactVirtualized.AutoSizer,
        { disableHeight: true },
        function (_ref) {
          var width = _ref.width;
          return _react2.default.createElement(_reactVirtualized.Grid, _extends({}, props, {
            cache: cache,
            cellRenderer: function cellRenderer(_ref2) {
              var gridProps = _objectWithoutProperties(_ref2, []);

              return _react2.default.createElement(_gridComponents.CellRenderer, _extends({}, gridProps, { newKey: gridProps.key }));
            },
            className: _manageEnvelopes2.default.grid,
            columnCount: columns.length,
            columns: columns,
            columnWidth: width / columns.length,
            documents: envelopes,
            fixedColumnCount: 1,
            fixedRowCount: 1,
            height: (0, _gridComponents.getGridHeight)(-1, envelopes.length, 45),
            isRowFocusable: false,
            isSelectable: false,
            noContentRenderer: function noContentRenderer() {
              return _react2.default.createElement(_noEnvelopes.NoEnvelopes, null);
            },
            rowCount: envelopes.length + 1,
            rowHeight: 45,
            selectedDocumentIds: [],
            width: width
          }));
        }
      )
    ),
    _react2.default.createElement(_requestEnvelopeModal.RequestEnvelopeModal, {
      accountId: props.accountId,
      isRequestEnvelopeVisible: props.isRequestEnvelopeVisible,
      onHideRequestEnvelope: props.onHideRequestEnvelope,
      onRequestEnvelope: props.onRequestEnvelope
    }),
    _react2.default.createElement(_sendEnvelopeModal.SendEnvelopeModal, {
      coversheetUrl: props.coversheetUrl,
      isSendEnvelopeVisible: props.isSendEnvelopeVisible,
      onHideSendEnvelope: props.onHideSendEnvelope
    })
  );
};

exports.ManageEnvelopes = ManageEnvelopes;
ManageEnvelopes.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  coversheetUrl: _propTypes2.default.string.isRequired,
  envelopes: _propTypes2.default.arrayOf(_customPropTypes.envelopeType).isRequired,
  isAwaitingMailin: _propTypes2.default.bool.isRequired,
  isRequestEnvelopeVisible: _propTypes2.default.bool.isRequired,
  isSendEnvelopeVisible: _propTypes2.default.bool.isRequired,
  onHideRequestEnvelope: _propTypes2.default.func.isRequired,
  onHideSendEnvelope: _propTypes2.default.func.isRequired,
  onRequestEnvelope: _propTypes2.default.func.isRequired,
  onShowRequestEnvelope: _propTypes2.default.func.isRequired,
  onShowSendEnvelope: _propTypes2.default.func.isRequired,
  title: _propTypes2.default.string.isRequired
};

var getColumns = function getColumns(isAwaitingMailin) {
  if (isAwaitingMailin) {
    return [{
      key: "code",
      name: "Envelope Code",
      visible: true
    }, {
      key: "received",
      name: "Envelope Received",
      visible: true
    }, {
      key: "billable",
      name: "Billable Envelope",
      visible: true
    }];
  }
  return [{
    key: "code",
    name: "Envelope Code",
    visible: true
  }, {
    key: "envelopeUploaded",
    name: "Uploaded",
    visible: true
  }, {
    key: "received",
    name: "Envelope Received",
    visible: true
  }, {
    key: "sent",
    name: "Envelope Sent",
    visible: true
  }, {
    key: "status",
    name: "Envelope Status",
    visible: true
  }];
};

var cache = new _reactVirtualized.CellMeasurerCache({
  defaultWidth: 75,
  minWidth: 75,
  fixedHeight: true
});

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapEnvelopeUploadedKey = exports.ManageEnvelopesContainer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _reactRedux = __webpack_require__(11);

var _customPropTypes = __webpack_require__(5);

var _manageEnvelopes = __webpack_require__(438);

var _envelopesActions = __webpack_require__(264);

var _trackingActions = __webpack_require__(26);

var _documentFiltersActions = __webpack_require__(136);

var _appActions = __webpack_require__(25);

var _loading = __webpack_require__(38);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ManageEnvelopesPage = function (_React$Component) {
  _inherits(ManageEnvelopesPage, _React$Component);

  function ManageEnvelopesPage() {
    _classCallCheck(this, ManageEnvelopesPage);

    return _possibleConstructorReturn(this, (ManageEnvelopesPage.__proto__ || Object.getPrototypeOf(ManageEnvelopesPage)).apply(this, arguments));
  }

  _createClass(ManageEnvelopesPage, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.props.init(this.props.accountId);
      this.props.trackPage();
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.isLoading) {
        return _react2.default.createElement(_loading.Loading, null);
      }
      return _react2.default.createElement(_manageEnvelopes.ManageEnvelopes, _extends({}, this.props, {
        envelopes: mapEnvelopeUploadedKey(this.props.envelopes),
        isAwaitingMailin: false,
        isLinkable: true,
        title: "Envelope History"
      }));
    }
  }]);

  return ManageEnvelopesPage;
}(_react2.default.Component);

ManageEnvelopesPage.defaultProps = {
  envelopes: []
};

ManageEnvelopesPage.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  envelopes: _propTypes2.default.arrayOf(_customPropTypes.envelopeType),
  init: _propTypes2.default.func.isRequired,
  isLoading: _propTypes2.default.bool.isRequired,
  trackPage: _propTypes2.default.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    accountId: state.app.selectedAccount.id,
    coversheetUrl: state.envelopes.coversheetUrl,
    envelopes: state.envelopes.envelopes,
    isLoading: state.envelopes.isLoading,
    isRequestEnvelopeVisible: state.envelopes.isRequestEnvelopeVisible,
    isSendEnvelopeVisible: state.envelopes.isSendEnvelopeVisible,
    slug: state.app.selectedAccount.slug
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    init: function init(accountId) {
      return dispatch((0, _envelopesActions.setCoversheetAction)(accountId));
    },
    trackPage: function trackPage() {
      return dispatch((0, _trackingActions.trackPageAction)("Manage envelopes page"));
    },
    onAddEnvelope: function onAddEnvelope(code) {
      return dispatch((0, _documentFiltersActions.addEnvelopeToFilterAction)(code));
    },
    onHideRequestEnvelope: function onHideRequestEnvelope() {
      return dispatch((0, _envelopesActions.setRequestEnvelopeVisibilityAction)(false));
    },
    onHideSendEnvelope: function onHideSendEnvelope() {
      return dispatch((0, _envelopesActions.setSendEnvelopeVisibilityAction)(false));
    },
    onRequestEnvelope: function onRequestEnvelope(accountId) {
      return dispatch((0, _envelopesActions.requestEnvelopeAction)(accountId));
    },
    onSetFlashMessage: function onSetFlashMessage(message) {
      return dispatch((0, _appActions.setFlashMessageAction)(message));
    },
    onShowRequestEnvelope: function onShowRequestEnvelope() {
      return dispatch((0, _envelopesActions.setRequestEnvelopeVisibilityAction)(true));
    },
    onShowSendEnvelope: function onShowSendEnvelope() {
      return dispatch((0, _envelopesActions.setSendEnvelopeVisibilityAction)(true));
    }
  };
};

var ManageEnvelopesContainer = exports.ManageEnvelopesContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ManageEnvelopesPage);

var mapEnvelopeUploadedKey = exports.mapEnvelopeUploadedKey = function mapEnvelopeUploadedKey(envelopes) {
  return envelopes.map(function (envelope) {
    return _ramda2.default.assoc("envelopeUploaded", envelope.uploaded, envelope);
  });
};

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var filterCounter = exports.filterCounter = function filterCounter(_ref) {
  var endDate = _ref.endDate,
      exportType = _ref.exportType,
      selectedCardNumbers = _ref.selectedCardNumbers,
      selectedCategories = _ref.selectedCategories,
      selectedCurrencies = _ref.selectedCurrencies,
      selectedEnvelopes = _ref.selectedEnvelopes,
      selectedPaymentTypes = _ref.selectedPaymentTypes,
      selectedSearchQueryString = _ref.selectedSearchQueryString,
      selectedVendors = _ref.selectedVendors,
      startDate = _ref.startDate,
      type = _ref.type,
      viewedStatus = _ref.viewedStatus;

  var filtersCount = 0;
  if (endDate !== null) {
    filtersCount += 1;
  }
  if (exportType !== null) {
    filtersCount += 1;
  }
  if (selectedSearchQueryString !== undefined && selectedSearchQueryString !== null) {
    filtersCount += 1;
  }
  if (startDate !== null) {
    filtersCount += 1;
  }
  if (type !== null) {
    filtersCount += 1;
  }
  if (viewedStatus !== "") {
    filtersCount += 1;
  }
  filtersCount += selectedCardNumbers.length;
  filtersCount += selectedCategories.length;
  filtersCount += selectedCurrencies.length;
  filtersCount += selectedEnvelopes.length;
  filtersCount += selectedPaymentTypes.length;
  filtersCount += selectedVendors.length;
  return filtersCount;
};

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var logout = exports.logout = function logout() {
  document.location.href = "https://id.squirrelstreet.com/logout";
};

var generateLoginUrl = exports.generateLoginUrl = function generateLoginUrl(oauthState) {
  var scopeAndResponseType = "scope=internal&response_type=token";
  var result = "https://id.squirrelstreet.com/oauth/authorize" + "?";
  return result.concat("client_id=" + "SQRLST_WEB_APP_NEWUI_BETA").concat("&" + scopeAndResponseType).concat("&state=" + oauthState).concat("&redirect_uri=" + "https://beta.squirrelstreet.com/oauth");
};

var parseOauthCallback = exports.parseOauthCallback = function parseOauthCallback(hash) {
  var token = parseToken(hash);
  var state = parseState(hash);
  return { token: token, state: state };
};

var parseToken = function parseToken(hash) {
  var tokenRegex = /access_token=([^&]+)/;
  var tokenResult = hash.match(tokenRegex);
  if (tokenResult === null || tokenResult === undefined) {
    return null;
  }
  return tokenResult[1];
};

var parseState = function parseState(hash) {
  var stateRegex = /state=([^&]+)/;
  var stateResult = hash.match(stateRegex);
  if (stateResult === null || stateResult === undefined) {
    return null;
  }
  return stateResult[1];
};

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var generateRandomString = exports.generateRandomString = function generateRandomString() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 20;

  var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var values = new Uint32Array(length);
  var crypto = window.crypto ? window.crypto : window.msCrypto;
  crypto.getRandomValues(values);

  var output = "";

  for (var i = 0; i < length; i += 1) {
    var mod = values[i] % characters.length;
    var result = characters[mod];
    output += result;
  }
  return output;
};

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var exportErrorRegex = /\[\[\s+export error:\s+(.*?)\]\]/;

var getExportErrorText = exports.getExportErrorText = function getExportErrorText(string) {
  return string.match(exportErrorRegex);
};

var removeExportErrorText = exports.removeExportErrorText = function removeExportErrorText(string) {
  return string.replace(exportErrorRegex, "");
};

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.excludeDisplayCategories = exports.doesCategoryStartWithGlPrefix = exports.splitCategories = undefined;

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var splitCategories = exports.splitCategories = function splitCategories(categories) {
  var _selectTrackingCodeCa = selectTrackingCodeCategories(categories),
      trackingCodes = _selectTrackingCodeCa.trackingCodes,
      passedCategories = _selectTrackingCodeCa.passedCategories;

  var _selectGlCodeCategori = selectGlCodeCategories(passedCategories),
      glCodes = _selectGlCodeCategori.glCodes,
      newPassedCategories = _selectGlCodeCategori.newPassedCategories;

  var newCategories = selectNewCategories(newPassedCategories);
  return { glCodes: glCodes, newCategories: newCategories, trackingCodes: trackingCodes };
};

var selectTrackingCodeCategories = function selectTrackingCodeCategories(categories) {
  var trackingCodes = categories.filter(doesCategoryStartWithTrackingPrefix);
  var passedCategories = _ramda2.default.difference(categories, trackingCodes);
  return { trackingCodes: trackingCodes, passedCategories: passedCategories };
};
var selectGlCodeCategories = function selectGlCodeCategories(passedCategories) {
  var glCodes = passedCategories.filter(doesCategoryStartWithGlPrefix);
  var newPassedCategories = _ramda2.default.difference(passedCategories, glCodes);
  return { glCodes: glCodes, newPassedCategories: newPassedCategories };
};

var selectNewCategories = function selectNewCategories(categories) {
  return categories.filter(excludedCategories);
};

var doesCategoryStartWithTrackingPrefix = function doesCategoryStartWithTrackingPrefix(category) {
  var trackingPrefixes = ["Xerov2 Tracking", "MYOB ARLive Job"];
  return trackingPrefixes.some(function (tracking) {
    return category.name.startsWith(tracking);
  });
};

var doesCategoryStartWithGlPrefix = exports.doesCategoryStartWithGlPrefix = function doesCategoryStartWithGlPrefix(category) {
  var glPrefixes = ["Xero", "MYOB", "SageOne", "QBO", "SaasuV2"];
  return glPrefixes.some(function (gl) {
    return category.name.startsWith(gl);
  });
};

var excludedCategories = function excludedCategories(category) {
  var excluded = ["Exported", "Export failed", "Do not export", "Xero", "MYOB", "SageOne", "QBO", "SaasuV2"];
  return excluded.every(function (ex) {
    return !category.name.startsWith(ex);
  });
};

var excludeDisplayCategories = exports.excludeDisplayCategories = function excludeDisplayCategories(categories) {
  var displayCategories = [];
  var excludedDisplayCategories = ["Exported", "Xero", "MYOB", "SageOne", "QBO", "SaasuV2"];
  categories.forEach(function (category) {
    if (!excludedDisplayCategories.some(function (ex) {
      return category.startsWith(ex);
    })) {
      displayCategories.push(category);
    }
  });
  return displayCategories;
};

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__(24);

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaBars = function FaBars(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm37.3 30v2.9q0 0.5-0.4 1t-1 0.4h-31.5q-0.6 0-1-0.4t-0.4-1v-2.9q0-0.6 0.4-1t1-0.4h31.5q0.5 0 1 0.4t0.4 1z m0-11.4v2.8q0 0.6-0.4 1t-1 0.5h-31.5q-0.6 0-1-0.5t-0.4-1v-2.8q0-0.6 0.4-1t1-0.5h31.5q0.5 0 1 0.5t0.4 1z m0-11.5v2.9q0 0.6-0.4 1t-1 0.4h-31.5q-0.6 0-1-0.4t-0.4-1v-2.9q0-0.5 0.4-1t1-0.4h31.5q0.5 0 1 0.4t0.4 1z' })
        )
    );
};

exports.default = FaBars;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__(24);

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaCloudUpload = function FaCloudUpload(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm26.6 19.3q0-0.3-0.2-0.4l-7.3-7.4q-0.2-0.1-0.5-0.1t-0.5 0.1l-7.3 7.3q-0.2 0.3-0.2 0.5 0 0.3 0.2 0.5t0.5 0.2h4.6v7.3q0 0.3 0.2 0.5t0.5 0.2h4q0.3 0 0.5-0.2t0.2-0.5v-7.3h4.6q0.3 0 0.5-0.2t0.2-0.5z m13.3 6q0 3.3-2.4 5.7t-5.6 2.3h-22.6q-3.8 0-6.6-2.7t-2.7-6.6q0-2.7 1.5-5t3.9-3.4q-0.1-0.6-0.1-0.9 0-4.4 3.1-7.5t7.5-3.1q3.3 0 6 1.8t3.9 4.8q1.5-1.3 3.4-1.3 2.2 0 3.8 1.5t1.5 3.8q0 1.6-0.8 2.8 2.7 0.7 4.4 2.9t1.8 4.9z' })
        )
    );
};

exports.default = FaCloudUpload;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__(24);

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaEnvelope = function FaEnvelope(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm40 15.8v17.8q0 1.4-1 2.5t-2.6 1h-32.8q-1.5 0-2.6-1t-1-2.5v-17.8q1 1.1 2.3 2 8 5.5 11 7.7 1.3 0.9 2.1 1.5t2.1 1 2.5 0.6h0q1.2 0 2.5-0.6t2.1-1 2.1-1.5q3.7-2.8 11.1-7.7 1.2-0.9 2.2-1.9z m0-6.5q0 1.7-1.1 3.4t-2.7 2.7q-8.4 5.8-10.5 7.3-0.2 0.1-0.9 0.6t-1.2 0.9-1.2 0.7-1.3 0.6-1.1 0.2h0q-0.5 0-1.1-0.2t-1.3-0.6-1.2-0.7-1.2-0.9-0.9-0.6q-2.1-1.5-5.9-4.1t-4.6-3.2q-1.3-0.9-2.6-2.6t-1.2-3q0-1.8 0.9-2.9t2.7-1.2h32.8q1.5 0 2.5 1.1t1.1 2.5z' })
        )
    );
};

exports.default = FaEnvelope;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__(24);

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaFileTextO = function FaFileTextO(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35.8 8.5q0.6 0.6 1 1.7t0.5 1.9v25.8q0 0.8-0.6 1.5t-1.6 0.6h-30q-0.9 0-1.5-0.6t-0.6-1.5v-35.8q0-0.8 0.6-1.5t1.5-0.6h20q0.9 0 2 0.4t1.7 1.1z m-9.9-5.5v8.4h8.4q-0.3-0.6-0.5-0.9l-7-7q-0.3-0.2-0.9-0.5z m8.5 34.1v-22.8h-9.3q-0.9 0-1.5-0.6t-0.6-1.6v-9.2h-17.1v34.2h28.5z m-22.8-19.2q0-0.4 0.2-0.6t0.5-0.2h15.7q0.3 0 0.5 0.2t0.2 0.6v1.4q0 0.3-0.2 0.5t-0.5 0.2h-15.7q-0.3 0-0.5-0.2t-0.2-0.5v-1.4z m16.4 5q0.3 0 0.5 0.2t0.2 0.5v1.4q0 0.3-0.2 0.5t-0.5 0.2h-15.7q-0.3 0-0.5-0.2t-0.2-0.5v-1.4q0-0.3 0.2-0.5t0.5-0.2h15.7z m0 5.7q0.3 0 0.5 0.2t0.2 0.5v1.4q0 0.3-0.2 0.5t-0.5 0.2h-15.7q-0.3 0-0.5-0.2t-0.2-0.5v-1.4q0-0.3 0.2-0.5t0.5-0.2h15.7z' })
        )
    );
};

exports.default = FaFileTextO;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__(24);

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaFilter = function FaFilter(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35.8 6.6q0.4 0.9-0.3 1.5l-11 11.1v16.5q0 1-0.9 1.3-0.3 0.1-0.5 0.1-0.6 0-1-0.4l-5.7-5.7q-0.5-0.4-0.5-1v-10.8l-11-11q-0.7-0.7-0.3-1.6 0.4-0.9 1.3-0.9h28.6q0.9 0 1.3 0.9z' })
        )
    );
};

exports.default = FaFilter;

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__(24);

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaPencil = function FaPencil(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm11.1 34.3l2-2-5.2-5.3-2 2v2.4h2.8v2.9h2.4z m11.7-20.7q0-0.5-0.5-0.5-0.2 0-0.4 0.1l-12.1 12.1q-0.1 0.2-0.1 0.4 0 0.5 0.4 0.5 0.3 0 0.4-0.2l12.1-12.1q0.2-0.1 0.2-0.3z m-1.2-4.3l9.3 9.3-18.6 18.5h-9.3v-9.2z m15.2 2.1q0 1.2-0.8 2l-3.7 3.7-9.3-9.2 3.7-3.7q0.8-0.9 2-0.9 1.2 0 2 0.9l5.3 5.2q0.8 0.9 0.8 2z' })
        )
    );
};

exports.default = FaPencil;

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__(24);

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaPlus = function FaPlus(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35.9 16.4v4.3q0 0.9-0.6 1.5t-1.5 0.7h-9.3v9.2q0 0.9-0.6 1.6t-1.5 0.6h-4.3q-0.9 0-1.5-0.6t-0.7-1.6v-9.2h-9.3q-0.9 0-1.5-0.7t-0.6-1.5v-4.3q0-0.9 0.6-1.5t1.5-0.6h9.3v-9.3q0-0.9 0.7-1.5t1.5-0.6h4.3q0.9 0 1.5 0.6t0.6 1.5v9.3h9.3q0.9 0 1.5 0.6t0.6 1.5z' })
        )
    );
};

exports.default = FaPlus;

/***/ }),
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(this && this[arg] || arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(this, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(this && this[key] || key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var detector = module.exports = {};

detector.isIE = function(version) {
    function isAnyIeVersion() {
        var agent = navigator.userAgent.toLowerCase();
        return agent.indexOf("msie") !== -1 || agent.indexOf("trident") !== -1 || agent.indexOf(" edge/") !== -1;
    }

    if(!isAnyIeVersion()) {
        return false;
    }

    if(!version) {
        return true;
    }

    //Shamelessly stolen from https://gist.github.com/padolsey/527683
    var ieVersion = (function(){
        var undef,
            v = 3,
            div = document.createElement("div"),
            all = div.getElementsByTagName("i");

        do {
            div.innerHTML = "<!--[if gt IE " + (++v) + "]><i></i><![endif]-->";
        }
        while (all[0]);

        return v > 4 ? v : undef;
    }());

    return version === ieVersion;
};

detector.isLegacyOpera = function() {
    return !!window.opera;
};


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = module.exports = {};

/**
 * Loops through the collection and calls the callback for each element. if the callback returns truthy, the loop is broken and returns the same value.
 * @public
 * @param {*} collection The collection to loop through. Needs to have a length property set and have indices set from 0 to length - 1.
 * @param {function} callback The callback to be called for each element. The element will be given as a parameter to the callback. If this callback returns truthy, the loop is broken and the same value is returned.
 * @returns {*} The value that a callback has returned (if truthy). Otherwise nothing.
 */
utils.forEach = function(collection, callback) {
    for(var i = 0; i < collection.length; i++) {
        var result = callback(collection[i]);
        if(result) {
            return result;
        }
    }
};


/***/ }),
/* 508 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 509 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"actions":"edit-columns-modal__actions___3pgK8"};

/***/ }),
/* 510 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"form":"form-elements__form___3ijpL","field-cell":"form-elements__field-cell___1-SKR","fields":"form-elements__fields___-L2Gm","form-button":"form-elements__form-button___1hOQF","credit-card":"form-elements__credit-card___1D8Da","other-payment":"form-elements__other-payment___2Bw_j","gst":"form-elements__gst___2ImYQ","notes":"form-elements__notes___27Iga"};

/***/ }),
/* 511 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"category-cell__container___3cag8","tag":"category-cell__tag___3NELA","close":"category-cell__close___gENfU","warn":"category-cell__warn___assXT","icon":"category-cell__icon___1_Qxh","tooltip-top":"category-cell__tooltip-top___1r96W","tooltip-bottom":"category-cell__tooltip-bottom___24tth"};

/***/ }),
/* 512 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"viewer-container":"document-viewer__viewer-container___3qgz6","framer":"document-viewer__framer___2AEKR","resizeable":"document-viewer__resizeable___1nKrE","viewer-modal":"document-viewer__viewer-modal___3lluh","placeholder":"document-viewer__placeholder___3bZoy","placeholder-text":"document-viewer__placeholder-text___2OWVs","toolbar":"document-viewer__toolbar___309Xz","toolbar-buttons":"document-viewer__toolbar-buttons___jMeDo","dropdown-buttons":"document-viewer__dropdown-buttons___3jzgw","toolbar-top":"document-viewer__toolbar-top___3wJBk","dock-icon":"document-viewer__dock-icon___dhZK6","draggable-container":"document-viewer__draggable-container___q58Ht","draggable-toolbar":"document-viewer__draggable-toolbar___3v6l-","export-document-modal":"document-viewer__export-document-modal___l0ftf","export-framer":"document-viewer__export-framer___3thuM","export-iframe-button":"document-viewer__export-iframe-button___2xgVu","close":"document-viewer__close___LeF28","close-document":"document-viewer__close-document___SREN1","blank":"document-viewer__blank___3DraP","left-arrow":"document-viewer__left-arrow___1agvk","right-arrow":"document-viewer__right-arrow___3rUUi"};

/***/ }),
/* 513 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"multi-document-actions-container__container___3Uzgl","fadein":"multi-document-actions-container__fadein___2Pb2E","info-label":"multi-document-actions-container__info-label___2DWam","edit-icon":"multi-document-actions-container__edit-icon___2-ETJ","actions-buttons":"multi-document-actions-container__actions-buttons___3tAVu","trash":"multi-document-actions-container__trash___1KBZL","trash-actions":"multi-document-actions-container__trash-actions___398b8","back":"multi-document-actions-container__back___lZro6","fadein-fadeout":"multi-document-actions-container__fadein-fadeout___2uaqX"};

/***/ }),
/* 514 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"no-results":"no-documents__no-results___3HUoP","blank-slate":"no-documents__blank-slate___KDI3e","no-pending":"no-documents__no-pending___1qcV6"};

/***/ }),
/* 515 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"buttons":"trash-multiple-documents__buttons___37WWv"};

/***/ }),
/* 516 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"field-cell":"add-category-modal__field-cell___3IoJ1","fields":"add-category-modal__fields___3vezM","button-container":"add-category-modal__button-container___3-G5b"};

/***/ }),
/* 517 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"manage-categories__container___2S7I4","controls-container":"manage-categories__controls-container___3CgoQ","grid-container":"manage-categories__grid-container___2nP8p","bottom-grid":"manage-categories__bottom-grid___2ud2s","top-grid":"manage-categories__top-grid___3vCYl"};

/***/ }),
/* 518 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"controls":"envelope-modals__controls___1owYA","address":"envelope-modals__address___2jBEK"};

/***/ }),
/* 519 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"integration-settings__container___ysAuw","iframe-container":"integration-settings__iframe-container___2-n2-","iframe":"integration-settings__iframe___3IuMW"};

/***/ }),
/* 520 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"menu":"settings-menus__menu___3fxYZ","active-menu-item":"settings-menus__active-menu-item___C4zwo"};

/***/ }),
/* 521 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"settings__container___3KNCr","child-container":"settings__child-container___2MZaR","grid-spacing":"settings__grid-spacing___3EzFE"};

/***/ }),
/* 522 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"plan-container":"subscription-settings__plan-container___mlKc7","toggle":"subscription-settings__toggle___23ivk","toggle-button":"subscription-settings__toggle-button___1K6yg","toggle-button--active":"subscription-settings__toggle-button--active___tXesw","active":"subscription-settings__active___3x4zU","price":"subscription-settings__price___1McR-","button":"subscription-settings__button___1l6z9","column":"subscription-settings__column___1V_BJ","grid":"subscription-settings__grid___UeMkC","name":"subscription-settings__name___3eugy","per":"subscription-settings__per___35UT9","cell":"subscription-settings__cell___2NLl2","plan":"subscription-settings__plan___18S-u","pending":"subscription-settings__pending___3xrxU","diy":"subscription-settings__diy___3Xu0u","cancel":"subscription-settings__cancel___3Auzk"};

/***/ }),
/* 523 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"form-container":"user-settings__form-container___7ycLG","field-cell":"user-settings__field-cell___1ZRz9","fields":"user-settings__fields___Fe-Lb"};

/***/ }),
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/img/loading-grey.32acfae82a.svg";

/***/ }),
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(0), __webpack_require__(1), __webpack_require__(1027));
	else if(typeof define === 'function' && define.amd)
		define(["react", "prop-types", "clipboard"], factory);
	else if(typeof exports === 'object')
		exports["ReactClipboard"] = factory(require("react"), require("prop-types"), require("clipboard"));
	else
		root["ReactClipboard"] = factory(root["React"], root["PropTypes"], root["Clipboard"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ClipboardButton = function (_React$Component) {
  _inherits(ClipboardButton, _React$Component);

  function ClipboardButton() {
    _classCallCheck(this, ClipboardButton);

    return _possibleConstructorReturn(this, (ClipboardButton.__proto__ || Object.getPrototypeOf(ClipboardButton)).apply(this, arguments));
  }

  _createClass(ClipboardButton, [{
    key: 'propsWith',


    /* Returns a object with all props that fulfill a certain naming pattern
     *
     * @param {RegExp} regexp - Regular expression representing which pattern
     *                          you'll be searching for.
     * @param {Boolean} remove - Determines if the regular expression should be
     *                           removed when transmitting the key from the props
     *                           to the new object.
     *
     * e.g:
     *
     * // Considering:
     * // this.props = {option-foo: 1, onBar: 2, data-foobar: 3 data-baz: 4};
     *
     * // *RegExps not using // so that this comment doesn't break up
     * this.propsWith(option-*, true); // returns {foo: 1}
     * this.propsWith(on*, true); // returns {Bar: 2}
     * this.propsWith(data-*); // returns {data-foobar: 1, data-baz: 4}
     */
    value: function propsWith(regexp) {
      var remove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var object = {};

      Object.keys(this.props).forEach(function (key) {
        if (key.search(regexp) !== -1) {
          var objectKey = remove ? key.replace(regexp, '') : key;
          object[objectKey] = this.props[key];
        }
      }, this);

      return object;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clipboard && this.clipboard.destroy();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Support old API by trying to assign this.props.options first;
      var options = this.props.options || this.propsWith(/^option-/, true);
      var element = _react2.default.version.match(/0\.13(.*)/) ? this.refs.element.getDOMNode() : this.element;
      var Clipboard = __webpack_require__(3);
      this.clipboard = new Clipboard(element, options);

      var callbacks = this.propsWith(/^on/, true);
      Object.keys(callbacks).forEach(function (callback) {
        this.clipboard.on(callback.toLowerCase(), this.props['on' + callback]);
      }, this);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var attributes = _extends({
        type: this.getType(),
        className: this.props.className || '',
        style: this.props.style || {},
        ref: function ref(element) {
          _this2.element = element;
        },
        onClick: this.props.onClick
      }, this.propsWith(/^data-/), this.propsWith(/^button-/, true));

      return _react2.default.createElement(this.getComponent(), attributes, this.props.children);
    }
  }, {
    key: 'getType',
    value: function getType() {
      if (this.getComponent() === 'button' || this.getComponent() === 'input') {
        return this.props.type || 'button';
      } else {
        return undefined;
      }
    }
  }, {
    key: 'getComponent',
    value: function getComponent() {
      return this.props.component || 'button';
    }
  }]);

  return ClipboardButton;
}(_react2.default.Component);

ClipboardButton.propTypes = {
  options: function options(props, propName, componentName) {
    var options = props[propName];
    if (options && (typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object' || Array.isArray(options)) {
      return new Error('Invalid props \'' + propName + '\' supplied to \'' + componentName + '\'. ' + ('\'' + propName + '\' is not an object.'));
    }

    if (props['option-text'] !== undefined) {
      var optionText = props['option-text'];
      if (typeof optionText !== 'function') {
        return new Error('Invalid props \'option-text\' supplied to \'' + componentName + '\'. ' + '\'option-text\' is not a function.');
      }
    }
  },
  type: _propTypes2.default.string,
  className: _propTypes2.default.string,
  style: _propTypes2.default.object,
  component: _propTypes2.default.string,
  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.object])
};
ClipboardButton.defaultProps = {
  onClick: function onClick() {} };
exports.default = ClipboardButton;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ })
/******/ ]);
});

/***/ }),
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(__webpack_require__(98));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  padding: 0;\n  outline: 0;\n  border: 0;\n  background: none;\n  font-size: 0;\n  cursor: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var _default = _styledComponents.default.button(_templateObject(), function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
});

exports.default = _default;

/***/ }),
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var EventTypes = {
  identify: 'identify',
  page: 'page',
  track: 'track',
  alias: 'alias',
  group: 'group',
  reset: 'reset'
};

exports.default = EventTypes;

/***/ }),
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _tools = __webpack_require__(813);

exports.default = function (target) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$duration = _ref.duration,
      duration = _ref$duration === undefined ? 500 : _ref$duration,
      _ref$context = _ref.context,
      context = _ref$context === undefined ? window : _ref$context,
      _ref$offset = _ref.offset,
      offset = _ref$offset === undefined ? 0 : _ref$offset,
      _ref$ease = _ref.ease,
      ease = _ref$ease === undefined ? 'easeInOutCubic' : _ref$ease,
      callback = _ref.callback;

  if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) !== 'object') return;

  var start = context.scrollTop || window.pageYOffset;
  var end = (0, _tools.calcEndPoint)(target, context, offset);
  var clock = performance.now();
  var rAF = window.requestAnimationFrame;

  var tick = function tick() {
    var elapsed = performance.now() - clock;
    var pos = (0, _tools.setPosition)(start, end, elapsed, duration, ease);
    if (context !== window) {
      context.scrollTop = pos;
    } else {
      window.scroll(0, pos);
    }

    if (elapsed > duration) {
      typeof callback === 'function' && callback(target);
    } else {
      rAF(tick);
    }
  };

  tick();
};

module.exports = exports['default'];

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var easeFunctions = exports.easeFunctions = {
  linear: function linear(t) {
    return t;
  },
  easeInQuad: function easeInQuad(t) {
    return t * t;
  },
  easeOutQuad: function easeOutQuad(t) {
    return t * (2 - t);
  },
  easeInOutQuad: function easeInOutQuad(t) {
    return t < .5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  },
  easeInCubic: function easeInCubic(t) {
    return t * t * t;
  },
  easeOutCubic: function easeOutCubic(t) {
    return --t * t * t + 1;
  },
  easeInOutCubic: function easeInOutCubic(t) {
    return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
  },
  easeInQuart: function easeInQuart(t) {
    return t * t * t * t;
  },
  easeOutQuart: function easeOutQuart(t) {
    return 1 - --t * t * t * t;
  },
  easeInOutQuart: function easeInOutQuart(t) {
    return t < .5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
  },
  easeInQuint: function easeInQuint(t) {
    return t * t * t * t * t;
  },
  easeOutQuint: function easeOutQuint(t) {
    return 1 + --t * t * t * t * t;
  },
  easeInOutQuint: function easeInOutQuint(t) {
    return t < .5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
  }
};

var isNumeric = exports.isNumeric = function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
};

var setPosition = exports.setPosition = function setPosition(begin, end, elapsed, duration) {
  var ease = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'easeInOutCubic';

  return elapsed > duration ? end : begin + (end - begin) * easeFunctions[ease](elapsed / duration);
};

var calcEndPoint = exports.calcEndPoint = function calcEndPoint(target) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  if (isNumeric(target)) {
    return parseInt(target) + offset;
  }

  var y = context === window ? window.pageYOffset : context.scrollTop - context.getBoundingClientRect().top;

  var distance = target.nodeName.toLowerCase() === 'html' ? -y : target.getBoundingClientRect().top + y;

  return distance + offset;
};

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(398);

var _reactDom = __webpack_require__(44);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _app = __webpack_require__(841);

var _store = __webpack_require__(48);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var container = document.getElementById("app-container");

_reactDom2.default.render((0, _app.App)({ store: _store.store }), container);

/***/ }),
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */
/***/ (function(module, exports) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 145);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var core = __webpack_require__(19);
var hide = __webpack_require__(11);
var redefine = __webpack_require__(12);
var ctx = __webpack_require__(20);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(4);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(52)('wks');
var uid = __webpack_require__(37);
var Symbol = __webpack_require__(2).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(22);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(3)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(1);
var IE8_DOM_DEFINE = __webpack_require__(109);
var toPrimitive = __webpack_require__(24);
var dP = Object.defineProperty;

exports.f = __webpack_require__(7) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(25);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(8);
var createDesc = __webpack_require__(36);
module.exports = __webpack_require__(7) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var hide = __webpack_require__(11);
var has = __webpack_require__(14);
var SRC = __webpack_require__(37)('src');
var $toString = __webpack_require__(178);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(19).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var fails = __webpack_require__(3);
var defined = __webpack_require__(25);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 14 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(53);
var defined = __webpack_require__(25);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(54);
var createDesc = __webpack_require__(36);
var toIObject = __webpack_require__(15);
var toPrimitive = __webpack_require__(24);
var has = __webpack_require__(14);
var IE8_DOM_DEFINE = __webpack_require__(109);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(7) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(14);
var toObject = __webpack_require__(9);
var IE_PROTO = __webpack_require__(77)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "version", function() { return version; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOM", function() { return DOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Children", function() { return Children; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createClass", function() { return createClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createPortal", function() { return createPortal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createFactory", function() { return createFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createElement", function() { return createElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cloneElement", function() { return cloneElement$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isValidElement", function() { return isValidElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findDOMNode", function() { return findDOMNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unmountComponentAtNode", function() { return unmountComponentAtNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Component", function() { return Component$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PureComponent", function() { return PureComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unstable_renderSubtreeIntoContainer", function() { return renderSubtreeIntoContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unstable_batchedUpdates", function() { return unstable_batchedUpdates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return extend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "PropTypes", function() { return __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact__ = __webpack_require__(153);




var version = '15.1.0'; // trick libraries to think we are react

var ELEMENTS = 'a abbr address area article aside audio b base bdi bdo big blockquote body br button canvas caption cite code col colgroup data datalist dd del details dfn dialog div dl dt em embed fieldset figcaption figure footer form h1 h2 h3 h4 h5 h6 head header hgroup hr html i iframe img input ins kbd keygen label legend li link main map mark menu menuitem meta meter nav noscript object ol optgroup option output p param picture pre progress q rp rt ruby s samp script section select small source span strong style sub summary sup table tbody td textarea tfoot th thead time title tr track u ul var video wbr circle clipPath defs ellipse g image line linearGradient mask path pattern polygon polyline radialGradient rect stop svg text tspan'.split(' ');

var REACT_ELEMENT_TYPE = (typeof Symbol!=='undefined' && Symbol.for && Symbol.for('react.element')) || 0xeac7;

var COMPONENT_WRAPPER_KEY = (typeof Symbol!=='undefined' && Symbol.for) ? Symbol.for('__preactCompatWrapper') : '__preactCompatWrapper';

// don't autobind these methods since they already have guaranteed context.
var AUTOBIND_BLACKLIST = {
	constructor: 1,
	render: 1,
	shouldComponentUpdate: 1,
	componentWillReceiveProps: 1,
	componentWillUpdate: 1,
	componentDidUpdate: 1,
	componentWillMount: 1,
	componentDidMount: 1,
	componentWillUnmount: 1,
	componentDidUnmount: 1
};


var CAMEL_PROPS = /^(?:accent|alignment|arabic|baseline|cap|clip|color|fill|flood|font|glyph|horiz|marker|overline|paint|stop|strikethrough|stroke|text|underline|unicode|units|v|vector|vert|word|writing|x)[A-Z]/;


var BYPASS_HOOK = {};

/*global process*/
var DEV = false;
try {
	DEV = process.env.NODE_ENV!=='production';
}
catch (e) {}

// a component that renders nothing. Used to replace components for unmountComponentAtNode.
function EmptyComponent() { return null; }



// make react think we're react.
var VNode = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["c" /* h */])('a', null).constructor;
VNode.prototype.$$typeof = REACT_ELEMENT_TYPE;
VNode.prototype.preactCompatUpgraded = false;
VNode.prototype.preactCompatNormalized = false;

Object.defineProperty(VNode.prototype, 'type', {
	get: function() { return this.nodeName; },
	set: function(v) { this.nodeName = v; },
	configurable:true
});

Object.defineProperty(VNode.prototype, 'props', {
	get: function() { return this.attributes; },
	set: function(v) { this.attributes = v; },
	configurable:true
});



var oldEventHook = __WEBPACK_IMPORTED_MODULE_1_preact__["d" /* options */].event;
__WEBPACK_IMPORTED_MODULE_1_preact__["d" /* options */].event = function (e) {
	if (oldEventHook) { e = oldEventHook(e); }
	e.persist = Object;
	e.nativeEvent = e;
	return e;
};


var oldVnodeHook = __WEBPACK_IMPORTED_MODULE_1_preact__["d" /* options */].vnode;
__WEBPACK_IMPORTED_MODULE_1_preact__["d" /* options */].vnode = function (vnode) {
	if (!vnode.preactCompatUpgraded) {
		vnode.preactCompatUpgraded = true;

		var tag = vnode.nodeName,
			attrs = vnode.attributes = vnode.attributes==null ? {} : extend({}, vnode.attributes);

		if (typeof tag==='function') {
			if (tag[COMPONENT_WRAPPER_KEY]===true || (tag.prototype && 'isReactComponent' in tag.prototype)) {
				if (vnode.children && String(vnode.children)==='') { vnode.children = undefined; }
				if (vnode.children) { attrs.children = vnode.children; }

				if (!vnode.preactCompatNormalized) {
					normalizeVNode(vnode);
				}
				handleComponentVNode(vnode);
			}
		}
		else {
			if (vnode.children && String(vnode.children)==='') { vnode.children = undefined; }
			if (vnode.children) { attrs.children = vnode.children; }

			if (attrs.defaultValue) {
				if (!attrs.value && attrs.value!==0) {
					attrs.value = attrs.defaultValue;
				}
				delete attrs.defaultValue;
			}

			handleElementVNode(vnode, attrs);
		}
	}

	if (oldVnodeHook) { oldVnodeHook(vnode); }
};

function handleComponentVNode(vnode) {
	var tag = vnode.nodeName,
		a = vnode.attributes;

	vnode.attributes = {};
	if (tag.defaultProps) { extend(vnode.attributes, tag.defaultProps); }
	if (a) { extend(vnode.attributes, a); }
}

function handleElementVNode(vnode, a) {
	var shouldSanitize, attrs, i;
	if (a) {
		for (i in a) { if ((shouldSanitize = CAMEL_PROPS.test(i))) { break; } }
		if (shouldSanitize) {
			attrs = vnode.attributes = {};
			for (i in a) {
				if (a.hasOwnProperty(i)) {
					attrs[ CAMEL_PROPS.test(i) ? i.replace(/([A-Z0-9])/, '-$1').toLowerCase() : i ] = a[i];
				}
			}
		}
	}
}



// proxy render() since React returns a Component reference.
function render$1(vnode, parent, callback) {
	var prev = parent && parent._preactCompatRendered && parent._preactCompatRendered.base;

	// ignore impossible previous renders
	if (prev && prev.parentNode!==parent) { prev = null; }

	// default to first Element child
	if (!prev && parent) { prev = parent.firstElementChild; }

	// remove unaffected siblings
	for (var i=parent.childNodes.length; i--; ) {
		if (parent.childNodes[i]!==prev) {
			parent.removeChild(parent.childNodes[i]);
		}
	}

	var out = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["e" /* render */])(vnode, parent, prev);
	if (parent) { parent._preactCompatRendered = out && (out._component || { base: out }); }
	if (typeof callback==='function') { callback(); }
	return out && out._component || out;
}


var ContextProvider = function () {};

ContextProvider.prototype.getChildContext = function () {
	return this.props.context;
};
ContextProvider.prototype.render = function (props) {
	return props.children[0];
};

function renderSubtreeIntoContainer(parentComponent, vnode, container, callback) {
	var wrap = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["c" /* h */])(ContextProvider, { context: parentComponent.context }, vnode);
	var renderContainer = render$1(wrap, container);
	var component = renderContainer._component || renderContainer.base;
	if (callback) { callback.call(component, renderContainer); }
	return component;
}

function Portal(props) {
	renderSubtreeIntoContainer(this, props.vnode, props.container);
}

function createPortal(vnode, container) {
	return Object(__WEBPACK_IMPORTED_MODULE_1_preact__["c" /* h */])(Portal, { vnode: vnode, container: container });
}


function unmountComponentAtNode(container) {
	var existing = container._preactCompatRendered && container._preactCompatRendered.base;
	if (existing && existing.parentNode===container) {
		Object(__WEBPACK_IMPORTED_MODULE_1_preact__["e" /* render */])(Object(__WEBPACK_IMPORTED_MODULE_1_preact__["c" /* h */])(EmptyComponent), container, existing);
		return true;
	}
	return false;
}



var ARR = [];

// This API is completely unnecessary for Preact, so it's basically passthrough.
var Children = {
	map: function(children, fn, ctx) {
		if (children == null) { return null; }
		children = Children.toArray(children);
		if (ctx && ctx!==children) { fn = fn.bind(ctx); }
		return children.map(fn);
	},
	forEach: function(children, fn, ctx) {
		if (children == null) { return null; }
		children = Children.toArray(children);
		if (ctx && ctx!==children) { fn = fn.bind(ctx); }
		children.forEach(fn);
	},
	count: function(children) {
		return children && children.length || 0;
	},
	only: function(children) {
		children = Children.toArray(children);
		if (children.length!==1) { throw new Error('Children.only() expects only one child.'); }
		return children[0];
	},
	toArray: function(children) {
		if (children == null) { return []; }
		return ARR.concat(children);
	}
};


/** Track current render() component for ref assignment */
var currentComponent;


function createFactory(type) {
	return createElement.bind(null, type);
}


var DOM = {};
for (var i=ELEMENTS.length; i--; ) {
	DOM[ELEMENTS[i]] = createFactory(ELEMENTS[i]);
}

function upgradeToVNodes(arr, offset) {
	for (var i=offset || 0; i<arr.length; i++) {
		var obj = arr[i];
		if (Array.isArray(obj)) {
			upgradeToVNodes(obj);
		}
		else if (obj && typeof obj==='object' && !isValidElement(obj) && ((obj.props && obj.type) || (obj.attributes && obj.nodeName) || obj.children)) {
			arr[i] = createElement(obj.type || obj.nodeName, obj.props || obj.attributes, obj.children);
		}
	}
}

function isStatelessComponent(c) {
	return typeof c==='function' && !(c.prototype && c.prototype.render);
}


// wraps stateless functional components in a PropTypes validator
function wrapStatelessComponent(WrappedComponent) {
	return createClass({
		displayName: WrappedComponent.displayName || WrappedComponent.name,
		render: function() {
			return WrappedComponent(this.props, this.context);
		}
	});
}


function statelessComponentHook(Ctor) {
	var Wrapped = Ctor[COMPONENT_WRAPPER_KEY];
	if (Wrapped) { return Wrapped===true ? Ctor : Wrapped; }

	Wrapped = wrapStatelessComponent(Ctor);

	Object.defineProperty(Wrapped, COMPONENT_WRAPPER_KEY, { configurable:true, value:true });
	Wrapped.displayName = Ctor.displayName;
	Wrapped.propTypes = Ctor.propTypes;
	Wrapped.defaultProps = Ctor.defaultProps;

	Object.defineProperty(Ctor, COMPONENT_WRAPPER_KEY, { configurable:true, value:Wrapped });

	return Wrapped;
}


function createElement() {
	var args = [], len = arguments.length;
	while ( len-- ) args[ len ] = arguments[ len ];

	upgradeToVNodes(args, 2);
	return normalizeVNode(__WEBPACK_IMPORTED_MODULE_1_preact__["c" /* h */].apply(void 0, args));
}


function normalizeVNode(vnode) {
	vnode.preactCompatNormalized = true;

	applyClassName(vnode);

	if (isStatelessComponent(vnode.nodeName)) {
		vnode.nodeName = statelessComponentHook(vnode.nodeName);
	}

	var ref = vnode.attributes.ref,
		type = ref && typeof ref;
	if (currentComponent && (type==='string' || type==='number')) {
		vnode.attributes.ref = createStringRefProxy(ref, currentComponent);
	}

	applyEventNormalization(vnode);

	return vnode;
}


function cloneElement$1(element, props) {
	var children = [], len = arguments.length - 2;
	while ( len-- > 0 ) children[ len ] = arguments[ len + 2 ];

	if (!isValidElement(element)) { return element; }
	var elementProps = element.attributes || element.props;
	var node = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["c" /* h */])(
		element.nodeName || element.type,
		extend({}, elementProps),
		element.children || elementProps && elementProps.children
	);
	// Only provide the 3rd argument if needed.
	// Arguments 3+ overwrite element.children in preactCloneElement
	var cloneArgs = [node, props];
	if (children && children.length) {
		cloneArgs.push(children);
	}
	else if (props && props.children) {
		cloneArgs.push(props.children);
	}
	return normalizeVNode(__WEBPACK_IMPORTED_MODULE_1_preact__["b" /* cloneElement */].apply(void 0, cloneArgs));
}


function isValidElement(element) {
	return element && ((element instanceof VNode) || element.$$typeof===REACT_ELEMENT_TYPE);
}


function createStringRefProxy(name, component) {
	return component._refProxies[name] || (component._refProxies[name] = function (resolved) {
		if (component && component.refs) {
			component.refs[name] = resolved;
			if (resolved===null) {
				delete component._refProxies[name];
				component = null;
			}
		}
	});
}


function applyEventNormalization(ref) {
	var nodeName = ref.nodeName;
	var attributes = ref.attributes;

	if (!attributes || typeof nodeName!=='string') { return; }
	var props = {};
	for (var i in attributes) {
		props[i.toLowerCase()] = i;
	}
	if (props.ondoubleclick) {
		attributes.ondblclick = attributes[props.ondoubleclick];
		delete attributes[props.ondoubleclick];
	}
	// for *textual inputs* (incl textarea), normalize `onChange` -> `onInput`:
	if (props.onchange && (nodeName==='textarea' || (nodeName.toLowerCase()==='input' && !/^fil|che|rad/i.test(attributes.type)))) {
		var normalized = props.oninput || 'oninput';
		if (!attributes[normalized]) {
			attributes[normalized] = multihook([attributes[normalized], attributes[props.onchange]]);
			delete attributes[props.onchange];
		}
	}
}


function applyClassName(vnode) {
	var a = vnode.attributes || (vnode.attributes = {});
	classNameDescriptor.enumerable = 'className' in a;
	if (a.className) { a.class = a.className; }
	Object.defineProperty(a, 'className', classNameDescriptor);
}


var classNameDescriptor = {
	configurable: true,
	get: function() { return this.class; },
	set: function(v) { this.class = v; }
};

function extend(base, props) {
	var arguments$1 = arguments;

	for (var i=1, obj = (void 0); i<arguments.length; i++) {
		if ((obj = arguments$1[i])) {
			for (var key in obj) {
				if (obj.hasOwnProperty(key)) {
					base[key] = obj[key];
				}
			}
		}
	}
	return base;
}


function shallowDiffers(a, b) {
	for (var i in a) { if (!(i in b)) { return true; } }
	for (var i$1 in b) { if (a[i$1]!==b[i$1]) { return true; } }
	return false;
}


function findDOMNode(component) {
	return component && (component.base || component.nodeType === 1 && component) || null;
}


function F(){}

function createClass(obj) {
	function cl(props, context) {
		bindAll(this);
		Component$1.call(this, props, context, BYPASS_HOOK);
		newComponentHook.call(this, props, context);
	}

	obj = extend({ constructor: cl }, obj);

	// We need to apply mixins here so that getDefaultProps is correctly mixed
	if (obj.mixins) {
		applyMixins(obj, collateMixins(obj.mixins));
	}
	if (obj.statics) {
		extend(cl, obj.statics);
	}
	if (obj.propTypes) {
		cl.propTypes = obj.propTypes;
	}
	if (obj.defaultProps) {
		cl.defaultProps = obj.defaultProps;
	}
	if (obj.getDefaultProps) {
		cl.defaultProps = obj.getDefaultProps.call(cl);
	}

	F.prototype = Component$1.prototype;
	cl.prototype = extend(new F(), obj);

	cl.displayName = obj.displayName || 'Component';

	return cl;
}


// Flatten an Array of mixins to a map of method name to mixin implementations
function collateMixins(mixins) {
	var keyed = {};
	for (var i=0; i<mixins.length; i++) {
		var mixin = mixins[i];
		for (var key in mixin) {
			if (mixin.hasOwnProperty(key) && typeof mixin[key]==='function') {
				(keyed[key] || (keyed[key]=[])).push(mixin[key]);
			}
		}
	}
	return keyed;
}


// apply a mapping of Arrays of mixin methods to a component prototype
function applyMixins(proto, mixins) {
	for (var key in mixins) { if (mixins.hasOwnProperty(key)) {
		proto[key] = multihook(
			mixins[key].concat(proto[key] || ARR),
			key==='getDefaultProps' || key==='getInitialState' || key==='getChildContext'
		);
	} }
}


function bindAll(ctx) {
	for (var i in ctx) {
		var v = ctx[i];
		if (typeof v==='function' && !v.__bound && !AUTOBIND_BLACKLIST.hasOwnProperty(i)) {
			(ctx[i] = v.bind(ctx)).__bound = true;
		}
	}
}


function callMethod(ctx, m, args) {
	if (typeof m==='string') {
		m = ctx.constructor.prototype[m];
	}
	if (typeof m==='function') {
		return m.apply(ctx, args);
	}
}

function multihook(hooks, skipDuplicates) {
	return function() {
		var arguments$1 = arguments;
		var this$1 = this;

		var ret;
		for (var i=0; i<hooks.length; i++) {
			var r = callMethod(this$1, hooks[i], arguments$1);

			if (skipDuplicates && r!=null) {
				if (!ret) { ret = {}; }
				for (var key in r) { if (r.hasOwnProperty(key)) {
					ret[key] = r[key];
				} }
			}
			else if (typeof r!=='undefined') { ret = r; }
		}
		return ret;
	};
}


function newComponentHook(props, context) {
	propsHook.call(this, props, context);
	this.componentWillReceiveProps = multihook([propsHook, this.componentWillReceiveProps || 'componentWillReceiveProps']);
	this.render = multihook([propsHook, beforeRender, this.render || 'render', afterRender]);
}


function propsHook(props, context) {
	if (!props) { return; }

	// React annoyingly special-cases single children, and some react components are ridiculously strict about this.
	var c = props.children;
	if (c && Array.isArray(c) && c.length===1 && (typeof c[0]==='string' || typeof c[0]==='function' || c[0] instanceof VNode)) {
		props.children = c[0];

		// but its totally still going to be an Array.
		if (props.children && typeof props.children==='object') {
			props.children.length = 1;
			props.children[0] = props.children;
		}
	}

	// add proptype checking
	if (DEV) {
		var ctor = typeof this==='function' ? this : this.constructor,
			propTypes = this.propTypes || ctor.propTypes;
		var displayName = this.displayName || ctor.name;

		if (propTypes) {
			__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.checkPropTypes(propTypes, props, 'prop', displayName);
		}
	}
}


function beforeRender(props) {
	currentComponent = this;
}

function afterRender() {
	if (currentComponent===this) {
		currentComponent = null;
	}
}



function Component$1(props, context, opts) {
	__WEBPACK_IMPORTED_MODULE_1_preact__["a" /* Component */].call(this, props, context);
	this.state = this.getInitialState ? this.getInitialState() : {};
	this.refs = {};
	this._refProxies = {};
	if (opts!==BYPASS_HOOK) {
		newComponentHook.call(this, props, context);
	}
}
extend(Component$1.prototype = new __WEBPACK_IMPORTED_MODULE_1_preact__["a" /* Component */](), {
	constructor: Component$1,

	isReactComponent: {},

	replaceState: function(state, callback) {
		var this$1 = this;

		this.setState(state, callback);
		for (var i in this$1.state) {
			if (!(i in state)) {
				delete this$1.state[i];
			}
		}
	},

	getDOMNode: function() {
		return this.base;
	},

	isMounted: function() {
		return !!this.base;
	}
});



function PureComponent(props, context) {
	Component$1.call(this, props, context);
}
F.prototype = Component$1.prototype;
PureComponent.prototype = new F();
PureComponent.prototype.isPureReactComponent = true;
PureComponent.prototype.shouldComponentUpdate = function(props, state) {
	return shallowDiffers(this.props, props) || shallowDiffers(this.state, state);
};

function unstable_batchedUpdates(callback) {
	callback();
}

var index = {
	version: version,
	DOM: DOM,
	PropTypes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a,
	Children: Children,
	render: render$1,
	createClass: createClass,
	createPortal: createPortal,
	createFactory: createFactory,
	createElement: createElement,
	cloneElement: cloneElement$1,
	isValidElement: isValidElement,
	findDOMNode: findDOMNode,
	unmountComponentAtNode: unmountComponentAtNode,
	Component: Component$1,
	PureComponent: PureComponent,
	unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer,
	unstable_batchedUpdates: unstable_batchedUpdates,
	__spread: extend
};

/* harmony default export */ __webpack_exports__["default"] = (index);

//# sourceMappingURL=preact-compat.es.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(28)))

/***/ }),
/* 19 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.4' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(10);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 21 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 22 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(3);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(4);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 25 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(0);
var core = __webpack_require__(19);
var fails = __webpack_require__(3);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(20);
var IObject = __webpack_require__(53);
var toObject = __webpack_require__(9);
var toLength = __webpack_require__(6);
var asc = __webpack_require__(93);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 28 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = __webpack_require__(102);

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = __webpack_require__(149)(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(152)();
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(7)) {
  var LIBRARY = __webpack_require__(32);
  var global = __webpack_require__(2);
  var fails = __webpack_require__(3);
  var $export = __webpack_require__(0);
  var $typed = __webpack_require__(69);
  var $buffer = __webpack_require__(101);
  var ctx = __webpack_require__(20);
  var anInstance = __webpack_require__(43);
  var propertyDesc = __webpack_require__(36);
  var hide = __webpack_require__(11);
  var redefineAll = __webpack_require__(45);
  var toInteger = __webpack_require__(22);
  var toLength = __webpack_require__(6);
  var toIndex = __webpack_require__(137);
  var toAbsoluteIndex = __webpack_require__(39);
  var toPrimitive = __webpack_require__(24);
  var has = __webpack_require__(14);
  var classof = __webpack_require__(48);
  var isObject = __webpack_require__(4);
  var toObject = __webpack_require__(9);
  var isArrayIter = __webpack_require__(90);
  var create = __webpack_require__(40);
  var getPrototypeOf = __webpack_require__(17);
  var gOPN = __webpack_require__(41).f;
  var getIterFn = __webpack_require__(92);
  var uid = __webpack_require__(37);
  var wks = __webpack_require__(5);
  var createArrayMethod = __webpack_require__(27);
  var createArrayIncludes = __webpack_require__(59);
  var speciesConstructor = __webpack_require__(56);
  var ArrayIterators = __webpack_require__(95);
  var Iterators = __webpack_require__(50);
  var $iterDetect = __webpack_require__(64);
  var setSpecies = __webpack_require__(42);
  var arrayFill = __webpack_require__(94);
  var arrayCopyWithin = __webpack_require__(126);
  var $DP = __webpack_require__(8);
  var $GOPD = __webpack_require__(16);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(132);
var $export = __webpack_require__(0);
var shared = __webpack_require__(52)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(135))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(37)('meta');
var isObject = __webpack_require__(4);
var has = __webpack_require__(14);
var setDesc = __webpack_require__(8).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(3)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(5)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(11)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.omit = exports.noop = exports.applyIOSIframeResizeHack = exports.applyIOSFooterHack = exports.debounce = exports.fixSafariScroll = exports.isElementInViewport = exports.onMessage = exports.ensureMetaViewport = exports.replaceExistingKeys = exports.appendParamsToUrl = exports.updateQueryStringParameter = exports.randomString = exports.DOMAIN = undefined;

var _customEvent = __webpack_require__(154);

var _customEvent2 = _interopRequireDefault(_customEvent);

var _isUrl = __webpack_require__(155);

var _isUrl2 = _interopRequireDefault(_isUrl);

var _urlParse = __webpack_require__(103);

var _urlParse2 = _interopRequireDefault(_urlParse);

var _isobject = __webpack_require__(158);

var _isobject2 = _interopRequireDefault(_isobject);

var _mobileDetection = __webpack_require__(57);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var DOMAIN_REGEXP = /(\.typeform)\.(com|io)$/;
var DOMAIN = exports.DOMAIN = 'admin.typeform.com';

var randomString = exports.randomString = function randomString() {
  return Math.random().toString(36).substr(2, 5);
};

var updateQueryStringParameter = exports.updateQueryStringParameter = function updateQueryStringParameter(key, value, uri) {
  var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
  var separator = uri.indexOf('?') !== -1 ? '&' : '?';
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + '=' + value + '$2');
  }

  return uri + separator + key + '=' + value;
};

var appendParamsToUrl = exports.appendParamsToUrl = function appendParamsToUrl(url, params) {
  var queryParameters = [];

  var _UrlParse = (0, _urlParse2.default)(url, true),
      query = _UrlParse.query,
      origin = _UrlParse.origin,
      pathname = _UrlParse.pathname;

  var path = pathname.replace(/\/$/, ''); // remove trailing slash
  var parameters = Object.assign({}, query, params);

  Object.keys(parameters).forEach(function (key) {
    queryParameters.push(encodeURIComponent(key) + '=' + encodeURIComponent(parameters[key]));
  });

  return '' + origin + path + '?' + queryParameters.join('&');
};

var replaceExistingKeys = exports.replaceExistingKeys = function replaceExistingKeys(obj, replacer) {
  return Object.keys(replacer).reduce(function (acc, oldKey) {
    var newKey = replacer[oldKey];
    if (newKey != null && obj[oldKey] != null && obj[oldKey] !== false) {
      acc[newKey] = obj[oldKey];
    }

    return acc;
  }, {});
};

var ensureMetaViewport = exports.ensureMetaViewport = function ensureMetaViewport() {
  if (!document.querySelector) {
    return;
  }

  var viewport = document.querySelector('meta[name=viewport]');
  var viewportContent = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0';

  if (viewport) {
    viewport.setAttribute('content', viewportContent);
  } else {
    var metaTag = document.createElement('meta');
    metaTag.content = viewportContent;
    metaTag.name = 'viewport';
    document.head.appendChild(metaTag);
  }
};

var acceptMessageOrigin = function acceptMessageOrigin(e) {
  if (process.env.NODE_ENV === 'development') {
    return true;
  }

  // deal with polymorphistic legacy: some events come from jQuery, other Vanilla JS
  var re = new RegExp('^(?:f|ht)tp(?:s)?://([^/]+)', 'im');
  var matches = e.origin.match(re);
  if (matches && matches.length > 1) {
    var domain = matches[1].toString();

    // to test this in local you will need to whitelist your local domain
    if (!DOMAIN_REGEXP.test(domain)) {
      return false;
    }
  } else {
    return false;
  }

  return true;
};

var onMessage = exports.onMessage = function onMessage(e) {
  e = e.originalEvent || e;
  if (!acceptMessageOrigin(e)) {
    return false;
  }

  if ((0, _isUrl2.default)(e.data)) {
    window.location.href = e.data;
    return;
  }

  if ((0, _isobject2.default)(e.data) && e.data.hasOwnProperty('type')) {
    window.dispatchEvent(new _customEvent2.default(e.data.type, { detail: e.data }));
    return;
  }

  window.dispatchEvent(new _customEvent2.default(e.data));
};

var isElementInViewport = exports.isElementInViewport = function isElementInViewport(el) {
  var rect = el.getBoundingClientRect();

  var margin = rect.height * 0.2; // 20% of margin
  var docWidth = window.innerWidth || document.documentElement.clientWidth;
  var docHeight = window.innerHeight || document.documentElement.clientHeight;

  return rect.top >= -margin && rect.left >= -margin && rect.bottom <= docHeight + margin && rect.right <= docWidth + margin;
};

// RD-712
var fixSafariScroll = exports.fixSafariScroll = function fixSafariScroll(iframe) {
  if ((0, _mobileDetection.isMobile)(navigator.userAgent) || !(0, _mobileDetection.isSafari)(navigator.userAgent)) {
    return;
  }

  iframe.addEventListener('load', function () {
    return setTimeout(function () {
      var originalHeight = window.getComputedStyle(iframe).height;
      iframe.setAttribute('height', iframe.offsetHeight + 1 + 'px');
      return setTimeout(function () {
        iframe.setAttribute('height', originalHeight);
      }, 1);
    }, 1000);
  });
};

var debounce = exports.debounce = function debounce(func, wait, context) {
  var timeout = void 0;
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var debounced = function debounced() {
      timeout = null;
      func.call.apply(func, [context].concat(args));
    };

    clearTimeout(timeout);
    timeout = setTimeout(debounced, wait);
  };
};

// Fix RD-731, footer not fully visible on iOS devices
var applyIOSFooterHack = exports.applyIOSFooterHack = function applyIOSFooterHack(element) {
  if (!(0, _mobileDetection.isIOSDevice)(navigator.userAgent)) {
    return;
  }

  element.setAttribute('scrolling', 'no');
  element.style.height = '1px';
  element.style.minHeight = '100%';
};

var applyIOSIframeResizeHack = exports.applyIOSIframeResizeHack = function applyIOSIframeResizeHack(element) {
  if (!(0, _mobileDetection.isIOSDevice)(navigator.userAgent)) {
    return;
  }

  element.style.maxHeight = '100%';
  element.style.maxWidth = '100%';
  element.style.minHeight = '100%';
  element.style.minWidth = '100%';
  element.style.width = 0;
};

var noop = exports.noop = function noop() {
  return null;
};

var omit = function omit(key, object) {
  var deletedKey = object[key],
      otherKeys = _objectWithoutProperties(object, [key]);

  return otherKeys;
};
exports.omit = omit;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 36 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 37 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(111);
var enumBugKeys = __webpack_require__(78);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(22);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(1);
var dPs = __webpack_require__(112);
var enumBugKeys = __webpack_require__(78);
var IE_PROTO = __webpack_require__(77)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(75)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(79).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(111);
var hiddenKeys = __webpack_require__(78).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(2);
var dP = __webpack_require__(8);
var DESCRIPTORS = __webpack_require__(7);
var SPECIES = __webpack_require__(5)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 43 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(20);
var call = __webpack_require__(124);
var isArrayIter = __webpack_require__(90);
var anObject = __webpack_require__(1);
var toLength = __webpack_require__(6);
var getIterFn = __webpack_require__(92);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(12);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(4);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(8).f;
var has = __webpack_require__(14);
var TAG = __webpack_require__(5)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(21);
var TAG = __webpack_require__(5)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var defined = __webpack_require__(25);
var fails = __webpack_require__(3);
var spaces = __webpack_require__(81);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 50 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 51 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(19);
var global = __webpack_require__(2);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(32) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(21);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 54 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(1);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(1);
var aFunction = __webpack_require__(10);
var SPECIES = __webpack_require__(5)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var isScreenBig = exports.isScreenBig = function isScreenBig() {
  return window.screen.width >= 1024 && window.screen.height >= 768;
};

var isMobile = exports.isMobile = function isMobile(ua) {
  return (/mobile|tablet|android/i.test(ua.toLowerCase())
  );
};

var isSafari = exports.isSafari = function isSafari(ua) {
  return (/^((?!chrome|android).)*safari/i.test(ua.toLowerCase())
  );
};

var isIOSDevice = exports.isIOSDevice = function isIOSDevice(ua) {
  return (/ip(hone|od|ad)/i.test(ua.toLowerCase())
  );
};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.keyframes = exports.injectGlobal = exports.css = undefined;

var _react = __webpack_require__(18);

var _react2 = _interopRequireDefault(_react);

var _createEmotion = __webpack_require__(160);

var _createEmotion2 = _interopRequireDefault(_createEmotion);

var _createEmotionStyled = __webpack_require__(165);

var _createEmotionStyled2 = _interopRequireDefault(_createEmotionStyled);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var context = typeof global !== 'undefined' ? global : {};

var emotion = (0, _createEmotion2.default)(context);

var css = exports.css = emotion.css;
var injectGlobal = exports.injectGlobal = emotion.injectGlobal;
var keyframes = exports.keyframes = emotion.keyframes;
exports.default = (0, _createEmotionStyled2.default)(emotion, _react2.default);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(15);
var toLength = __webpack_require__(6);
var toAbsoluteIndex = __webpack_require__(39);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 60 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(21);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(22);
var defined = __webpack_require__(25);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(4);
var cof = __webpack_require__(21);
var MATCH = __webpack_require__(5)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(5)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(48);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(128);
var redefine = __webpack_require__(12);
var hide = __webpack_require__(11);
var fails = __webpack_require__(3);
var defined = __webpack_require__(25);
var wks = __webpack_require__(5);
var regexpExec = __webpack_require__(96);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(2);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(12);
var redefineAll = __webpack_require__(45);
var meta = __webpack_require__(33);
var forOf = __webpack_require__(44);
var anInstance = __webpack_require__(43);
var isObject = __webpack_require__(4);
var fails = __webpack_require__(3);
var $iterDetect = __webpack_require__(64);
var setToStringTag = __webpack_require__(47);
var inheritIfRequired = __webpack_require__(82);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var hide = __webpack_require__(11);
var uid = __webpack_require__(37);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(32) || !__webpack_require__(3)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(2)[K];
});


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(10);
var ctx = __webpack_require__(20);
var forOf = __webpack_require__(44);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(18);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(29);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Iframe = function (_Component) {
  _inherits(Iframe, _Component);

  function Iframe(props) {
    _classCallCheck(this, Iframe);

    var _this = _possibleConstructorReturn(this, (Iframe.__proto__ || Object.getPrototypeOf(Iframe)).call(this, props));

    _this.iframeRef = null;
    _this.loadHandler = _this.loadHandler.bind(_this);
    return _this;
  }

  // Fixes scroll not responding in renderer v1


  _createClass(Iframe, [{
    key: 'loadHandler',
    value: function loadHandler() {
      var _this2 = this;

      this.iframeRef.style.height = this.iframeRef.offsetHeight + 1 + 'px';
      setTimeout(function () {
        _this2.iframeRef.style.height = '';
        (0, _utils.applyIOSFooterHack)(_this2.iframeRef);
        (0, _utils.applyIOSIframeResizeHack)(_this2.iframeRef);

        _this2.props.onLoad && _this2.props.onLoad(_this2.iframeRef);
      }, 1);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.src !== this.props.src;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          style = _props.style,
          rest = _objectWithoutProperties(_props, ['style']);

      return _react2.default.createElement('iframe', _extends({}, rest, {
        'data-qa': 'iframe',
        frameBorder: '0',
        height: '100%',
        onLoad: this.loadHandler,
        ref: function ref(node) {
          _this3.iframeRef = node;
        },
        src: this.props.src,
        style: _extends({ border: 0 }, style),
        width: '100%'
      }));
    }
  }]);

  return Iframe;
}(_react.Component);

Iframe.propTypes = {
  src: _propTypes2.default.string.isRequired,
  onLoad: _propTypes2.default.func,
  style: _propTypes2.default.object
};

exports.default = Iframe;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(4);
var document = __webpack_require__(2).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var core = __webpack_require__(19);
var LIBRARY = __webpack_require__(32);
var wksExt = __webpack_require__(110);
var defineProperty = __webpack_require__(8).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(52)('keys');
var uid = __webpack_require__(37);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 78 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(2).document;
module.exports = document && document.documentElement;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(4);
var anObject = __webpack_require__(1);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(20)(Function.call, __webpack_require__(16).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(4);
var setPrototypeOf = __webpack_require__(80).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(22);
var defined = __webpack_require__(25);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 84 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 85 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(32);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(12);
var hide = __webpack_require__(11);
var Iterators = __webpack_require__(50);
var $iterCreate = __webpack_require__(87);
var setToStringTag = __webpack_require__(47);
var getPrototypeOf = __webpack_require__(17);
var ITERATOR = __webpack_require__(5)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(40);
var descriptor = __webpack_require__(36);
var setToStringTag = __webpack_require__(47);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(11)(IteratorPrototype, __webpack_require__(5)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(63);
var defined = __webpack_require__(25);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(5)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(50);
var ITERATOR = __webpack_require__(5)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(8);
var createDesc = __webpack_require__(36);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(48);
var ITERATOR = __webpack_require__(5)('iterator');
var Iterators = __webpack_require__(50);
module.exports = __webpack_require__(19).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(267);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(9);
var toAbsoluteIndex = __webpack_require__(39);
var toLength = __webpack_require__(6);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(34);
var step = __webpack_require__(127);
var Iterators = __webpack_require__(50);
var toIObject = __webpack_require__(15);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(86)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(55);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(62)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(20);
var invoke = __webpack_require__(117);
var html = __webpack_require__(79);
var cel = __webpack_require__(75);
var global = __webpack_require__(2);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(21)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var macrotask = __webpack_require__(98).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(21)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(10);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(2);
var DESCRIPTORS = __webpack_require__(7);
var LIBRARY = __webpack_require__(32);
var $typed = __webpack_require__(69);
var hide = __webpack_require__(11);
var redefineAll = __webpack_require__(45);
var fails = __webpack_require__(3);
var anInstance = __webpack_require__(43);
var toInteger = __webpack_require__(22);
var toLength = __webpack_require__(6);
var toIndex = __webpack_require__(137);
var gOPN = __webpack_require__(41).f;
var dP = __webpack_require__(8).f;
var arrayFill = __webpack_require__(94);
var setToStringTag = __webpack_require__(47);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (process.env.NODE_ENV === 'production') {
  module.exports = __webpack_require__(147);
} else {
  module.exports = __webpack_require__(148);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var required = __webpack_require__(156)
  , qs = __webpack_require__(157)
  , protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\S\s]*)/i
  , slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//;

/**
 * These are the parse rules for the URL parser, it informs the parser
 * about:
 *
 * 0. The char it Needs to parse, if it's a string it should be done using
 *    indexOf, RegExp using exec and NaN means set as current value.
 * 1. The property we should set when parsing this value.
 * 2. Indication if it's backwards or forward parsing, when set as number it's
 *    the value of extra chars that should be split off.
 * 3. Inherit from location if non existing in the parser.
 * 4. `toLowerCase` the resulting value.
 */
var rules = [
  ['#', 'hash'],                        // Extract from the back.
  ['?', 'query'],                       // Extract from the back.
  function sanitize(address) {          // Sanitize what is left of the address
    return address.replace('\\', '/');
  },
  ['/', 'pathname'],                    // Extract from the back.
  ['@', 'auth', 1],                     // Extract from the front.
  [NaN, 'host', undefined, 1, 1],       // Set left over value.
  [/:(\d+)$/, 'port', undefined, 1],    // RegExp the back.
  [NaN, 'hostname', undefined, 1, 1]    // Set left over.
];

/**
 * These properties should not be copied or inherited from. This is only needed
 * for all non blob URL's as a blob URL does not include a hash, only the
 * origin.
 *
 * @type {Object}
 * @private
 */
var ignore = { hash: 1, query: 1 };

/**
 * The location object differs when your code is loaded through a normal page,
 * Worker or through a worker using a blob. And with the blobble begins the
 * trouble as the location object will contain the URL of the blob, not the
 * location of the page where our code is loaded in. The actual origin is
 * encoded in the `pathname` so we can thankfully generate a good "default"
 * location from it so we can generate proper relative URL's again.
 *
 * @param {Object|String} loc Optional default location object.
 * @returns {Object} lolcation object.
 * @public
 */
function lolcation(loc) {
  var globalVar;

  if (typeof window !== 'undefined') globalVar = window;
  else if (typeof global !== 'undefined') globalVar = global;
  else if (typeof self !== 'undefined') globalVar = self;
  else globalVar = {};

  var location = globalVar.location || {};
  loc = loc || location;

  var finaldestination = {}
    , type = typeof loc
    , key;

  if ('blob:' === loc.protocol) {
    finaldestination = new Url(unescape(loc.pathname), {});
  } else if ('string' === type) {
    finaldestination = new Url(loc, {});
    for (key in ignore) delete finaldestination[key];
  } else if ('object' === type) {
    for (key in loc) {
      if (key in ignore) continue;
      finaldestination[key] = loc[key];
    }

    if (finaldestination.slashes === undefined) {
      finaldestination.slashes = slashes.test(loc.href);
    }
  }

  return finaldestination;
}

/**
 * @typedef ProtocolExtract
 * @type Object
 * @property {String} protocol Protocol matched in the URL, in lowercase.
 * @property {Boolean} slashes `true` if protocol is followed by "//", else `false`.
 * @property {String} rest Rest of the URL that is not part of the protocol.
 */

/**
 * Extract protocol information from a URL with/without double slash ("//").
 *
 * @param {String} address URL we want to extract from.
 * @return {ProtocolExtract} Extracted information.
 * @private
 */
function extractProtocol(address) {
  var match = protocolre.exec(address);

  return {
    protocol: match[1] ? match[1].toLowerCase() : '',
    slashes: !!match[2],
    rest: match[3]
  };
}

/**
 * Resolve a relative URL pathname against a base URL pathname.
 *
 * @param {String} relative Pathname of the relative URL.
 * @param {String} base Pathname of the base URL.
 * @return {String} Resolved pathname.
 * @private
 */
function resolve(relative, base) {
  var path = (base || '/').split('/').slice(0, -1).concat(relative.split('/'))
    , i = path.length
    , last = path[i - 1]
    , unshift = false
    , up = 0;

  while (i--) {
    if (path[i] === '.') {
      path.splice(i, 1);
    } else if (path[i] === '..') {
      path.splice(i, 1);
      up++;
    } else if (up) {
      if (i === 0) unshift = true;
      path.splice(i, 1);
      up--;
    }
  }

  if (unshift) path.unshift('');
  if (last === '.' || last === '..') path.push('');

  return path.join('/');
}

/**
 * The actual URL instance. Instead of returning an object we've opted-in to
 * create an actual constructor as it's much more memory efficient and
 * faster and it pleases my OCD.
 *
 * It is worth noting that we should not use `URL` as class name to prevent
 * clashes with the global URL instance that got introduced in browsers.
 *
 * @constructor
 * @param {String} address URL we want to parse.
 * @param {Object|String} [location] Location defaults for relative paths.
 * @param {Boolean|Function} [parser] Parser for the query string.
 * @private
 */
function Url(address, location, parser) {
  if (!(this instanceof Url)) {
    return new Url(address, location, parser);
  }

  var relative, extracted, parse, instruction, index, key
    , instructions = rules.slice()
    , type = typeof location
    , url = this
    , i = 0;

  //
  // The following if statements allows this module two have compatibility with
  // 2 different API:
  //
  // 1. Node.js's `url.parse` api which accepts a URL, boolean as arguments
  //    where the boolean indicates that the query string should also be parsed.
  //
  // 2. The `URL` interface of the browser which accepts a URL, object as
  //    arguments. The supplied object will be used as default values / fall-back
  //    for relative paths.
  //
  if ('object' !== type && 'string' !== type) {
    parser = location;
    location = null;
  }

  if (parser && 'function' !== typeof parser) parser = qs.parse;

  location = lolcation(location);

  //
  // Extract protocol information before running the instructions.
  //
  extracted = extractProtocol(address || '');
  relative = !extracted.protocol && !extracted.slashes;
  url.slashes = extracted.slashes || relative && location.slashes;
  url.protocol = extracted.protocol || location.protocol || '';
  address = extracted.rest;

  //
  // When the authority component is absent the URL starts with a path
  // component.
  //
  if (!extracted.slashes) instructions[3] = [/(.*)/, 'pathname'];

  for (; i < instructions.length; i++) {
    instruction = instructions[i];

    if (typeof instruction === 'function') {
      address = instruction(address);
      continue;
    }

    parse = instruction[0];
    key = instruction[1];

    if (parse !== parse) {
      url[key] = address;
    } else if ('string' === typeof parse) {
      if (~(index = address.indexOf(parse))) {
        if ('number' === typeof instruction[2]) {
          url[key] = address.slice(0, index);
          address = address.slice(index + instruction[2]);
        } else {
          url[key] = address.slice(index);
          address = address.slice(0, index);
        }
      }
    } else if ((index = parse.exec(address))) {
      url[key] = index[1];
      address = address.slice(0, index.index);
    }

    url[key] = url[key] || (
      relative && instruction[3] ? location[key] || '' : ''
    );

    //
    // Hostname, host and protocol should be lowercased so they can be used to
    // create a proper `origin`.
    //
    if (instruction[4]) url[key] = url[key].toLowerCase();
  }

  //
  // Also parse the supplied query string in to an object. If we're supplied
  // with a custom parser as function use that instead of the default build-in
  // parser.
  //
  if (parser) url.query = parser(url.query);

  //
  // If the URL is relative, resolve the pathname against the base URL.
  //
  if (
      relative
    && location.slashes
    && url.pathname.charAt(0) !== '/'
    && (url.pathname !== '' || location.pathname !== '')
  ) {
    url.pathname = resolve(url.pathname, location.pathname);
  }

  //
  // We should not add port numbers if they are already the default port number
  // for a given protocol. As the host also contains the port number we're going
  // override it with the hostname which contains no port number.
  //
  if (!required(url.port, url.protocol)) {
    url.host = url.hostname;
    url.port = '';
  }

  //
  // Parse down the `auth` for the username and password.
  //
  url.username = url.password = '';
  if (url.auth) {
    instruction = url.auth.split(':');
    url.username = instruction[0] || '';
    url.password = instruction[1] || '';
  }

  url.origin = url.protocol && url.host && url.protocol !== 'file:'
    ? url.protocol +'//'+ url.host
    : 'null';

  //
  // The href is just the compiled result.
  //
  url.href = url.toString();
}

/**
 * This is convenience method for changing properties in the URL instance to
 * insure that they all propagate correctly.
 *
 * @param {String} part          Property we need to adjust.
 * @param {Mixed} value          The newly assigned value.
 * @param {Boolean|Function} fn  When setting the query, it will be the function
 *                               used to parse the query.
 *                               When setting the protocol, double slash will be
 *                               removed from the final url if it is true.
 * @returns {URL} URL instance for chaining.
 * @public
 */
function set(part, value, fn) {
  var url = this;

  switch (part) {
    case 'query':
      if ('string' === typeof value && value.length) {
        value = (fn || qs.parse)(value);
      }

      url[part] = value;
      break;

    case 'port':
      url[part] = value;

      if (!required(value, url.protocol)) {
        url.host = url.hostname;
        url[part] = '';
      } else if (value) {
        url.host = url.hostname +':'+ value;
      }

      break;

    case 'hostname':
      url[part] = value;

      if (url.port) value += ':'+ url.port;
      url.host = value;
      break;

    case 'host':
      url[part] = value;

      if (/:\d+$/.test(value)) {
        value = value.split(':');
        url.port = value.pop();
        url.hostname = value.join(':');
      } else {
        url.hostname = value;
        url.port = '';
      }

      break;

    case 'protocol':
      url.protocol = value.toLowerCase();
      url.slashes = !fn;
      break;

    case 'pathname':
    case 'hash':
      if (value) {
        var char = part === 'pathname' ? '/' : '#';
        url[part] = value.charAt(0) !== char ? char + value : value;
      } else {
        url[part] = value;
      }
      break;

    default:
      url[part] = value;
  }

  for (var i = 0; i < rules.length; i++) {
    var ins = rules[i];

    if (ins[4]) url[ins[1]] = url[ins[1]].toLowerCase();
  }

  url.origin = url.protocol && url.host && url.protocol !== 'file:'
    ? url.protocol +'//'+ url.host
    : 'null';

  url.href = url.toString();

  return url;
}

/**
 * Transform the properties back in to a valid and full URL string.
 *
 * @param {Function} stringify Optional query stringify function.
 * @returns {String} Compiled version of the URL.
 * @public
 */
function toString(stringify) {
  if (!stringify || 'function' !== typeof stringify) stringify = qs.stringify;

  var query
    , url = this
    , protocol = url.protocol;

  if (protocol && protocol.charAt(protocol.length - 1) !== ':') protocol += ':';

  var result = protocol + (url.slashes ? '//' : '');

  if (url.username) {
    result += url.username;
    if (url.password) result += ':'+ url.password;
    result += '@';
  }

  result += url.host + url.pathname;

  query = 'object' === typeof url.query ? stringify(url.query) : url.query;
  if (query) result += '?' !== query.charAt(0) ? '?'+ query : query;

  if (url.hash) result += url.hash;

  return result;
}

Url.prototype = { set: set, toString: toString };

//
// Expose the URL parser and some additional properties that might be useful for
// others or testing.
//
Url.extractProtocol = extractProtocol;
Url.location = lolcation;
Url.qs = qs;

module.exports = Url;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.POPUP_MODES = exports.DRAWER_RIGHT = exports.DRAWER = exports.POPUP = exports.DEFAULT_AUTOCLOSE_TIMEOUT = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _POPUP_MODES;

var _react = __webpack_require__(18);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(29);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _scrollbarWidth = __webpack_require__(159);

var _scrollbarWidth2 = _interopRequireDefault(_scrollbarWidth);

var _styles = __webpack_require__(58);

var _styles2 = _interopRequireDefault(_styles);

var _iframe = __webpack_require__(74);

var _iframe2 = _interopRequireDefault(_iframe);

var _spinner = __webpack_require__(167);

var _spinner2 = _interopRequireDefault(_spinner);

var _utils = __webpack_require__(35);

var _close = __webpack_require__(169);

var _close2 = _interopRequireDefault(_close);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ESC_KEY_CODE = 27;
var CLOSE_BUTTON_WIDTH = 30;

var DEFAULT_AUTOCLOSE_TIMEOUT = exports.DEFAULT_AUTOCLOSE_TIMEOUT = 5;
var POPUP = exports.POPUP = 'popup';
var DRAWER = exports.DRAWER = 'drawer_left';
var DRAWER_RIGHT = exports.DRAWER_RIGHT = 'drawer_right';
var POPUP_MODES = exports.POPUP_MODES = (_POPUP_MODES = {}, _defineProperty(_POPUP_MODES, POPUP, 'popup-blank'), _defineProperty(_POPUP_MODES, DRAWER, 'popup-classic'), _defineProperty(_POPUP_MODES, DRAWER_RIGHT, 'popup-drawer'), _POPUP_MODES);

var BaseWrapper = /*#__PURE__*/(0, _styles2.default)('div', {
  target: 'e1o3ysfi0'
})('visibility:', function (p) {
  return p.open ? 'visible' : 'hidden';
}, ';opacity:', function (p) {
  return p.open ? 1 : 0;
}, ';position:', function (p) {
  return p.isContained ? 'absolute' : 'fixed';
}, ';max-width:100%;z-index:10001;');

var Overlay = /*#__PURE__*/(0, _styles2.default)('div', {
  target: 'e1o3ysfi1'
})('visibility:', function (p) {
  return p.appearing ? 'hidden' : 'visible';
}, ';opacity:', function (p) {
  return p.appearing ? 0 : 1;
}, ';transition:opacity 200ms ease,visibility 0s linear ', function (p) {
  return p.appearing ? '200ms' : '0s';
}, ';background:rgba(0,0,0,0.85);position:', function (p) {
  return p.isContained ? 'absolute' : 'fixed';
}, ';overflow:', function (p) {
  return p.isContained ? 'hidden' : 'auto';
}, ';left:0;top:0;right:0;bottom:0;z-index:10000;min-height:100%;');

var popupWrapper = /*#__PURE__*/(0, _styles2.default)(BaseWrapper, {
  target: 'e1o3ysfi2'
})('width:', function (p) {
  return p.isContained ? 'calc(100% - 80px)' : 'calc(100vw - 80px)';
}, ';height:', function (p) {
  return p.isContained ? 'calc(100% - 80px)' : 'calc(100vh - 80px)';
}, ';top:40px;left:40px;transition:all 300ms ease-out;');

var drawerWrapper = /*#__PURE__*/(0, _styles2.default)(BaseWrapper, {
  target: 'e1o3ysfi3'
})('transition:all 400ms ease-out;width:', function (p) {
  return p.width;
}, 'px;height:100%;top:0;');

var drawerLeftWrapper = /*#__PURE__*/(0, _styles2.default)(drawerWrapper, {
  target: 'e1o3ysfi4'
})('left:', function (p) {
  return !p.open ? -(p.width - CLOSE_BUTTON_WIDTH) : 0;
}, 'px;');

var drawerRightWrapper = /*#__PURE__*/(0, _styles2.default)(drawerWrapper, {
  target: 'e1o3ysfi5'
})('right:', function (p) {
  return !p.open ? -(p.width - CLOSE_BUTTON_WIDTH) : 0;
}, 'px;');

var BaseCloseImage = /*#__PURE__*/(0, _styles2.default)('img', {
  target: 'e1o3ysfi6'
})('position:absolute;padding:8px;cursor:pointer;width:initial;max-width:initial;');

var closeImagePopup = /*#__PURE__*/(0, _styles2.default)(BaseCloseImage, {
  target: 'e1o3ysfi7'
})('top:-34px;right:-34px;');

var closeImageLeft = /*#__PURE__*/(0, _styles2.default)(BaseCloseImage, {
  target: 'e1o3ysfi8'
})('top:12px;right:-38px;');

var closeImageRight = /*#__PURE__*/(0, _styles2.default)(BaseCloseImage, {
  target: 'e1o3ysfi9'
})('top:12px;left:-38px;right:auto;');

var Popup = function (_Component) {
  _inherits(Popup, _Component);

  function Popup(props) {
    _classCallCheck(this, Popup);

    var _this = _possibleConstructorReturn(this, (Popup.__proto__ || Object.getPrototypeOf(Popup)).call(this, props));

    _this.state = {
      frameAnimate: false,
      iframeLoaded: false,
      popupAnimate: true,
      transitionEnded: false
    };

    _this.onIframeLoad = _this.onIframeLoad.bind(_this);
    _this.onKeyDown = _this.onKeyDown.bind(_this);
    _this.onAutoClose = _this.onAutoClose.bind(_this);
    _this.animateBeforeClose = _this.animateBeforeClose.bind(_this);
    _this.onTransitionEnd = _this.onTransitionEnd.bind(_this);
    _this.onFormSubmit = _this.onFormSubmit.bind(_this);
    return _this;
  }

  _createClass(Popup, [{
    key: 'onIframeLoad',
    value: function onIframeLoad(iframeRef) {
      var _this2 = this;

      this.setState({ iframeLoaded: true }, function () {
        setTimeout(function () {
          _this2.setState({ frameAnimate: true });
          if (iframeRef && iframeRef.contentWindow) {
            iframeRef.contentWindow.focus();
          }
        }, 500);
      });
    }
  }, {
    key: 'animateBeforeClose',
    value: function animateBeforeClose() {
      var _this3 = this;

      this.setState({ frameAnimate: false, popupAnimate: false }, function () {
        setTimeout(function () {
          _this3.setState({ popupAnimate: true }, function () {
            setTimeout(_this3.props.onClose, 400);
          });
        }, 400);
      });
    }
  }, {
    key: 'onKeyDown',
    value: function onKeyDown(e) {
      var key = document.all ? e.keyCode : e.which;
      if (key === ESC_KEY_CODE) {
        this.animateBeforeClose();
      }
    }
  }, {
    key: 'onAutoClose',
    value: function onAutoClose(e) {
      var _this4 = this;

      var canSetAutocloseDelay = e.detail.isProPlus || e.detail.canSetAutocloseDelay;
      var _props$options = this.props.options,
          isAutoCloseEnabled = _props$options.isAutoCloseEnabled,
          autoClose = _props$options.autoClose;

      var timeout = (canSetAutocloseDelay ? autoClose : DEFAULT_AUTOCLOSE_TIMEOUT) * 1000;

      if (isAutoCloseEnabled) {
        setTimeout(function () {
          _this4.animateBeforeClose();
        }, timeout);
      }
    }
  }, {
    key: 'onTransitionEnd',
    value: function onTransitionEnd(event) {
      if (event.target === this.wrapper) {
        this.setState({
          transitionEnded: this.state.frameAnimate
        });
      }
    }
  }, {
    key: 'onFormSubmit',
    value: function onFormSubmit() {
      var onSubmit = this.props.options.onSubmit;

      onSubmit();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this5 = this;

      window.addEventListener('message', _utils.onMessage);
      window.addEventListener('keydown', this.onKeyDown);
      window.addEventListener('form-close', this.animateBeforeClose);
      window.addEventListener('ESC', this.animateBeforeClose);
      window.addEventListener('embed-auto-close-popup', this.onAutoClose);
      window.addEventListener('form-submit', this.onFormSubmit);

      setTimeout(function () {
        _this5.setState({
          popupAnimate: false
        });
      }, 100);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('message', _utils.onMessage);
      window.removeEventListener('keydown', this.onKeyDown);
      window.removeEventListener('form-close', this.animateBeforeClose);
      window.removeEventListener('ESC', this.animateBeforeClose);
      window.removeEventListener('embed-auto-close-popup', this.onAutoClose);
      window.removeEventListener('form-submit', this.onFormSubmit);
    }
  }, {
    key: 'getWrapperComponent',
    value: function getWrapperComponent(mode) {
      if (mode === DRAWER_RIGHT) return drawerRightWrapper;
      if (mode === DRAWER) return drawerLeftWrapper;
      return popupWrapper;
    }
  }, {
    key: 'getCloseImage',
    value: function getCloseImage(mode) {
      if (mode === DRAWER_RIGHT) return closeImageRight;
      if (mode === DRAWER) return closeImageLeft;
      return closeImagePopup;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var iframeStyles = null;
      var options = this.props.options;
      var drawerWidth = options.drawerWidth,
          hideScrollbars = options.hideScrollbars,
          isContained = options.isContained,
          mode = options.mode;


      if (hideScrollbars) {
        iframeStyles = {
          width: 'calc(100% + ' + (0, _scrollbarWidth2.default)() + 'px)'
        };
      }

      if (mode === POPUP) {
        iframeStyles = _extends({}, iframeStyles, {
          WebkitMaskImage: '-webkit-radial-gradient(circle, white, black)',
          WebkitTransform: 'translateZ(0)'
        });
      }

      var Wrapper = this.getWrapperComponent(mode);
      var CloseImage = this.getCloseImage(mode);

      return _react2.default.createElement(
        Overlay,
        { appearing: this.state.popupAnimate, isContained: isContained },
        _react2.default.createElement(_spinner2.default, { stopped: this.state.iframeLoaded }),
        _react2.default.createElement(
          Wrapper,
          {
            'data-qa': 'popup-mode-' + mode,
            innerRef: function innerRef(node) {
              _this6.wrapper = node;
            },
            isContained: isContained,
            mode: mode,
            onTransitionEnd: this.onTransitionEnd,
            open: this.state.frameAnimate,
            width: drawerWidth
          },
          this.state.iframeLoaded && _react2.default.createElement(CloseImage, {
            alt: 'close-typeform',
            'data-qa': 'popup-close-button',
            mode: mode,
            onClick: this.animateBeforeClose,
            src: _close2.default
          }),
          _react2.default.createElement(_iframe2.default, {
            onLoad: this.onIframeLoad,
            src: this.props.url,
            style: iframeStyles
          })
        )
      );
    }
  }]);

  return Popup;
}(_react.Component);

Popup.propTypes = {
  url: _propTypes2.default.string.isRequired,
  options: _propTypes2.default.object.isRequired,
  onClose: _propTypes2.default.func,
  width: _propTypes2.default.number,
  height: _propTypes2.default.number
};

exports.default = Popup;

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(18);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(29);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = __webpack_require__(58);

var _styles2 = _interopRequireDefault(_styles);

var _closeIcon = __webpack_require__(170);

var _closeIcon2 = _interopRequireDefault(_closeIcon);

var _iframe = __webpack_require__(74);

var _iframe2 = _interopRequireDefault(_iframe);

var _dataService = __webpack_require__(107);

var _dataService2 = _interopRequireDefault(_dataService);

var _store = __webpack_require__(108);

var _store2 = _interopRequireDefault(_store);

var _utils = __webpack_require__(35);

var _popup = __webpack_require__(104);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DOMAIN = 'admin.typeform.com';
var TYPE = 'popup';

var Wrapper = /*#__PURE__*/(0, _styles2.default)('div', {
  target: 'e4550h40'
})('visibility:', function (p) {
  return p.open ? 'visible' : 'hidden';
}, ';opacity:', function (p) {
  return p.open ? 1 : 0;
}, ';background-color:', function (p) {
  return p.backgroundColor;
}, ';position:fixed !important;z-index:1000;left:0 !important;right:0 !important;top:0 !important;bottom:0 !important;overflow:hidden !important;height:100%;transition:all 400ms ease ', function (props) {
  return props.openDelay;
}, 's;');

(0, _styles.injectGlobal)('.__typeform-embed-mobile-modal-open{overflow:hidden !important;position:fixed !important;top:0 !important;left:0 !important;right:0 !important;bottom:0 !important;}');

var MobileModal = function (_Component) {
  _inherits(MobileModal, _Component);

  function MobileModal(props) {
    _classCallCheck(this, MobileModal);

    var _this = _possibleConstructorReturn(this, (MobileModal.__proto__ || Object.getPrototypeOf(MobileModal)).call(this, props));

    _this.state = {
      backgroundColor: 'transparent',
      buttonColor: '#FFF'
    };

    _this.onAutoClose = _this.onAutoClose.bind(_this);
    _this.onFormSubmit = _this.onFormSubmit.bind(_this);
    _this.close = _this.close.bind(_this);
    return _this;
  }

  _createClass(MobileModal, [{
    key: 'onAutoClose',
    value: function onAutoClose(e) {
      var _this2 = this;

      var canSetAutocloseDelay = e.detail.isProPlus || e.detail.canSetAutocloseDelay;
      var _props = this.props,
          isAutoCloseEnabled = _props.isAutoCloseEnabled,
          autoClose = _props.autoClose;

      var timeout = (canSetAutocloseDelay ? autoClose : _popup.DEFAULT_AUTOCLOSE_TIMEOUT) * 1000;

      if (isAutoCloseEnabled) {
        setTimeout(function () {
          _this2.close();
        }, timeout);
      }
    }
  }, {
    key: 'onFormSubmit',
    value: function onFormSubmit() {
      var onSubmit = this.props.onSubmit;

      onSubmit && onSubmit();
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this3 = this;

      var uid = _dataService2.default.getUidFromURL(this.props.url);

      _dataService2.default.getFormData(uid, DOMAIN).then(function (data) {
        return (0, _store2.default)(uid, TYPE, _this3.props.url, _this3.props.buttonText, data);
      }).then(function (_ref) {
        var form = _ref.form;

        _this3.setState({
          backgroundColor: '#' + form['background-color'],
          buttonColor: '#' + form['button-color']
        });
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('message', _utils.onMessage);
      window.addEventListener('embed-auto-close-popup', this.onAutoClose);
      window.addEventListener('form-submit', this.onFormSubmit);

      if (this.props.open) {
        this.open();
      }
    }
  }, {
    key: 'open',
    value: function open() {
      var _this4 = this;

      setTimeout(function () {
        _this4.originalBodyScrollTop = window.document.body.scrollTop;
        document.body.classList.add('__typeform-embed-mobile-modal-open');
      }, this.props.openDelay * 1000 + 500);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.open && this.props.open) {
        this.open();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('message', _utils.onMessage);
      window.removeEventListener('embed-auto-close-popup', this.onAutoClose);
      window.removeEventListener('form-submit', this.onFormSubmit);

      document.body.classList.remove('__typeform-embed-mobile-modal-open');
    }
  }, {
    key: 'close',
    value: function close() {
      var _this5 = this;

      document.body.classList.remove('__typeform-embed-mobile-modal-open');
      setTimeout(function () {
        window.document.body.scrollTop = _this5.originalBodyScrollTop;
      }, 40);

      if (this.props.onClose) {
        this.props.onClose();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          url = _props2.url,
          open = _props2.open;
      var _state = this.state,
          backgroundColor = _state.backgroundColor,
          buttonColor = _state.buttonColor;


      return _react2.default.createElement(
        Wrapper,
        {
          backgroundColor: backgroundColor,
          'data-qa': 'mobile-modal',
          open: open,
          openDelay: this.props.openDelay
        },
        open && _react2.default.createElement(_iframe2.default, { src: url }),
        _react2.default.createElement(_closeIcon2.default, {
          color: buttonColor,
          dataQa: 'close-button-mobile',
          onClick: this.close
        })
      );
    }
  }]);

  return MobileModal;
}(_react.Component);

MobileModal.propTypes = {
  url: _propTypes2.default.string,
  open: _propTypes2.default.bool,
  isAutoCloseEnabled: _propTypes2.default.bool,
  buttonText: _propTypes2.default.string,
  onClose: _propTypes2.default.func,
  onSubmit: _propTypes2.default.func,
  autoClose: _propTypes2.default.number,
  openDelay: _propTypes2.default.number
};

MobileModal.defaultProps = {
  open: false,
  openDelay: 0,
  autoClose: null
};

exports.default = MobileModal;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fetchJsonp = __webpack_require__(171);

var _fetchJsonp2 = _interopRequireDefault(_fetchJsonp);

var _urlParse = __webpack_require__(103);

var _urlParse2 = _interopRequireDefault(_urlParse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DataService = {
  generateURL: function generateURL(uid, domain) {
    return 'https://' + domain + '/app/embed/' + uid + '?jsoncallback=?';
  },
  getFormData: function getFormData(uid, domain) {
    var url = this.generateURL(uid, domain);
    return (0, _fetchJsonp2.default)(url, { jsonpCallback: 'jsoncallback' }).then(function (res) {
      return res.json();
    });
  },
  getAccountFromURL: function getAccountFromURL(url) {
    return url.split('/')[2].split('.')[0];
  },
  getUidFromURL: function getUidFromURL(url) {
    var _UrlParse = (0, _urlParse2.default)(url, true),
        pathname = _UrlParse.pathname,
        query = _UrlParse.query;

    var path = pathname.replace(/\/$/, ''); // remove trailing slash
    var uid = path.replace(/\/to\/(.+)$/, '$1');

    if (uid === '/renderer') {
      return query.uid;
    }

    return uid;
  },
  getDomainFromUrl: function getDomainFromUrl(url) {
    return url.split('/')[2];
  },
  getDOMElementData: function getDOMElementData($element) {
    return {
      url: $element.data('url'),
      text: $element.data('text')
    };
  }
};

exports.default = DataService;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mobileDetection = __webpack_require__(57);

var defaultData = {
  'account-name': 'admin',
  name: 'Typeform',
  'welcome-image': '',
  'font-google': '',
  'primary-color': '#222',
  'background-image': '',
  'background-color': '#DDD',
  'background-repeat': '',
  'background-brightness': '',
  'button-color': '#AAA'
};

var store = function store(uid, type, url, buttonText) {
  var data = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : defaultData;

  return {
    isMobile: (0, _mobileDetection.isMobile)(navigator.userAgent),
    'account-name': data['account-name'] || 'admin',
    type: type,
    form: {
      uid: uid,
      url: url,
      ready: false, // not implemented
      buttonText: buttonText,
      name: data['name'] || '',
      'welcome-image': data['welcome-image'],
      'font-google': data['font-google'],
      'primary-color': data['primary-color'],
      'background-image': data['background-image'],
      'background-color': data['background-color'],
      'background-repeat': data['background-repeat'],
      'background-brightness': data['background-brightness'],
      'button-color': data['button-color']
    }
  };
};

exports.default = store;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(7) && !__webpack_require__(3)(function () {
  return Object.defineProperty(__webpack_require__(75)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(5);


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(14);
var toIObject = __webpack_require__(15);
var arrayIndexOf = __webpack_require__(59)(false);
var IE_PROTO = __webpack_require__(77)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(8);
var anObject = __webpack_require__(1);
var getKeys = __webpack_require__(38);

module.exports = __webpack_require__(7) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(15);
var gOPN = __webpack_require__(41).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(38);
var gOPS = __webpack_require__(60);
var pIE = __webpack_require__(54);
var toObject = __webpack_require__(9);
var IObject = __webpack_require__(53);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(3)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 115 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(10);
var isObject = __webpack_require__(4);
var invoke = __webpack_require__(117);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 117 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(2).parseInt;
var $trim = __webpack_require__(49).trim;
var ws = __webpack_require__(81);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(2).parseFloat;
var $trim = __webpack_require__(49).trim;

module.exports = 1 / $parseFloat(__webpack_require__(81) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(21);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(4);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 122 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(84);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(1);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(10);
var toObject = __webpack_require__(9);
var IObject = __webpack_require__(53);
var toLength = __webpack_require__(6);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(9);
var toAbsoluteIndex = __webpack_require__(39);
var toLength = __webpack_require__(6);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 127 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(96);
__webpack_require__(0)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(7) && /./g.flags != 'g') __webpack_require__(8).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(55)
});


/***/ }),
/* 130 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(1);
var isObject = __webpack_require__(4);
var newPromiseCapability = __webpack_require__(100);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(133);
var validate = __webpack_require__(46);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(68)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(8).f;
var create = __webpack_require__(40);
var redefineAll = __webpack_require__(45);
var ctx = __webpack_require__(20);
var anInstance = __webpack_require__(43);
var forOf = __webpack_require__(44);
var $iterDefine = __webpack_require__(86);
var step = __webpack_require__(127);
var setSpecies = __webpack_require__(42);
var DESCRIPTORS = __webpack_require__(7);
var fastKey = __webpack_require__(33).fastKey;
var validate = __webpack_require__(46);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(133);
var validate = __webpack_require__(46);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(68)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(2);
var each = __webpack_require__(27)(0);
var redefine = __webpack_require__(12);
var meta = __webpack_require__(33);
var assign = __webpack_require__(114);
var weak = __webpack_require__(136);
var isObject = __webpack_require__(4);
var validate = __webpack_require__(46);
var NATIVE_WEAK_MAP = __webpack_require__(46);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(68)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(45);
var getWeak = __webpack_require__(33).getWeak;
var anObject = __webpack_require__(1);
var isObject = __webpack_require__(4);
var anInstance = __webpack_require__(43);
var forOf = __webpack_require__(44);
var createArrayMethod = __webpack_require__(27);
var $has = __webpack_require__(14);
var validate = __webpack_require__(46);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(22);
var toLength = __webpack_require__(6);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(41);
var gOPS = __webpack_require__(60);
var anObject = __webpack_require__(1);
var Reflect = __webpack_require__(2).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(61);
var isObject = __webpack_require__(4);
var toLength = __webpack_require__(6);
var ctx = __webpack_require__(20);
var IS_CONCAT_SPREADABLE = __webpack_require__(5)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(6);
var repeat = __webpack_require__(83);
var defined = __webpack_require__(25);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(38);
var toIObject = __webpack_require__(15);
var isEnum = __webpack_require__(54).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(48);
var from = __webpack_require__(143);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(44);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 144 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeFullScreen = exports.makeWidget = exports.makePopup = undefined;

var _makePopup = __webpack_require__(146);

var _makePopup2 = _interopRequireDefault(_makePopup);

var _makeWidget = __webpack_require__(172);

var _makeWidget2 = _interopRequireDefault(_makeWidget);

var _makeFullScreen = __webpack_require__(174);

var _makeFullScreen2 = _interopRequireDefault(_makeFullScreen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (!window._babelPolyfill) {
  __webpack_require__(175);
}

exports.makePopup = _makePopup2.default;
exports.makeWidget = _makeWidget2.default;
exports.makeFullScreen = _makeFullScreen2.default;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = makePopup;

var _react = __webpack_require__(18);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(18);

var _utils = __webpack_require__(35);

var _mobileDetection = __webpack_require__(57);

var _popup = __webpack_require__(104);

var _popup2 = _interopRequireDefault(_popup);

var _mobileModal = __webpack_require__(106);

var _mobileModal2 = _interopRequireDefault(_mobileModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_DRAWER_WIDTH = 800;

var defaultOptions = {
  mode: _popup.POPUP,
  autoOpen: false,
  isModalOpen: false,
  autoClose: _popup.DEFAULT_AUTOCLOSE_TIMEOUT,
  hideFooter: false,
  hideHeaders: false,
  hideScrollbars: false,
  disableSubmit: false,
  drawerWidth: DEFAULT_DRAWER_WIDTH,
  onSubmit: _utils.noop
};

var queryStringKeys = {
  embedType: 'typeform-embed',
  hideFooter: 'embed-hide-footer',
  hideHeaders: 'embed-hide-headers',
  disableSubmit: '__dangerous-disable-submissions'
};

var renderComponent = function renderComponent(url, domNode, options, onClose) {
  if (!(0, _mobileDetection.isMobile)(navigator.userAgent) && (0, _mobileDetection.isScreenBig)()) {
    var urlWithQueryString = (0, _utils.appendParamsToUrl)(url, (0, _utils.replaceExistingKeys)(options, queryStringKeys));

    (0, _reactDom.render)(_react2.default.createElement(_popup2.default, { onClose: onClose, options: options, url: urlWithQueryString }), domNode);
  } else {
    (0, _utils.ensureMetaViewport)();
    (0, _reactDom.render)(_react2.default.createElement(_mobileModal2.default, {
      autoClose: options.autoClose,
      buttonText: options.buttonText,
      isAutoCloseEnabled: options.isAutoCloseEnabled,
      onClose: onClose,
      onSubmit: options.onSubmit,
      open: true,
      url: url
    }), domNode);
  }
};

function makePopup(url, options) {
  options = _extends({}, defaultOptions, options, {
    isAutoCloseEnabled: options.autoClose !== undefined,
    embedType: _popup.POPUP_MODES[options.mode]
  });

  if (!Number.isSafeInteger(options.drawerWidth)) {
    throw new Error('Whoops! You provided an invalid \'drawerWidth\' option: "' + options.drawerWidth + '". It must be a number.');
  }

  var domNode = document.createElement('div');
  options.isContained = options.container !== undefined;
  options.container = options.container || document.body;
  options.container.appendChild(domNode);

  var popup = {
    open: function open() {
      renderComponent(url, domNode, options, this.close);
    },
    close: function close() {
      window.postMessage('form-close', '*');
      (0, _reactDom.unmountComponentAtNode)(domNode);
    }
  };

  if (options.autoOpen) {
    popup.open();
  }

  return popup;
}

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.memo"):
60115,r=b?Symbol.for("react.lazy"):60116;function t(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case r:case q:case d:return u}}}function v(a){return t(a)===m}exports.typeOf=t;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;
exports.Fragment=e;exports.Lazy=r;exports.Memo=q;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===r||a.$$typeof===q||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||t(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return t(a)===k};
exports.isContextProvider=function(a){return t(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return t(a)===n};exports.isFragment=function(a){return t(a)===e};exports.isLazy=function(a){return t(a)===r};exports.isMemo=function(a){return t(a)===q};exports.isPortal=function(a){return t(a)===d};exports.isProfiler=function(a){return t(a)===g};exports.isStrictMode=function(a){return t(a)===f};
exports.isSuspense=function(a){return t(a)===p};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/** @license React v16.8.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */





if (process.env.NODE_ENV !== "production") {
  (function() {
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;

var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace;
var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' ||
  // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE);
}

/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

{
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`lowPriorityWarning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

var lowPriorityWarning$1 = lowPriorityWarning;

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;
    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;
          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;
              default:
                return $$typeof;
            }
        }
      case REACT_LAZY_TYPE:
      case REACT_MEMO_TYPE:
      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
}

// AsyncMode is deprecated along with isAsyncMode
var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;

var hasWarnedAboutDeprecatedIsAsyncMode = false;

// AsyncMode should be deprecated
function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true;
      lowPriorityWarning$1(false, 'The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }
  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.typeOf = typeOf;
exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isValidElementType = isValidElementType;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
  })();
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactIs = __webpack_require__(102);
var assign = __webpack_require__(150);

var ReactPropTypesSecret = __webpack_require__(73);
var checkPropTypes = __webpack_require__(151);

var has = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        if (getPropType(value) === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret = __webpack_require__(73);
  var loggedTypeFailures = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
}

module.exports = checkPropTypes;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(73);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return h; });
/* unused harmony export createElement */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return cloneElement; });
/* unused harmony export createRef */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Component; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return render; });
/* unused harmony export rerender */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return options; });
var VNode = function VNode() {};

var options = {};

var stack = [];

var EMPTY_CHILDREN = [];

function h(nodeName, attributes) {
	var children = EMPTY_CHILDREN,
	    lastSimple,
	    child,
	    simple,
	    i;
	for (i = arguments.length; i-- > 2;) {
		stack.push(arguments[i]);
	}
	if (attributes && attributes.children != null) {
		if (!stack.length) stack.push(attributes.children);
		delete attributes.children;
	}
	while (stack.length) {
		if ((child = stack.pop()) && child.pop !== undefined) {
			for (i = child.length; i--;) {
				stack.push(child[i]);
			}
		} else {
			if (typeof child === 'boolean') child = null;

			if (simple = typeof nodeName !== 'function') {
				if (child == null) child = '';else if (typeof child === 'number') child = String(child);else if (typeof child !== 'string') simple = false;
			}

			if (simple && lastSimple) {
				children[children.length - 1] += child;
			} else if (children === EMPTY_CHILDREN) {
				children = [child];
			} else {
				children.push(child);
			}

			lastSimple = simple;
		}
	}

	var p = new VNode();
	p.nodeName = nodeName;
	p.children = children;
	p.attributes = attributes == null ? undefined : attributes;
	p.key = attributes == null ? undefined : attributes.key;

	if (options.vnode !== undefined) options.vnode(p);

	return p;
}

function extend(obj, props) {
  for (var i in props) {
    obj[i] = props[i];
  }return obj;
}

function applyRef(ref, value) {
  if (ref != null) {
    if (typeof ref == 'function') ref(value);else ref.current = value;
  }
}

var defer = typeof Promise == 'function' ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout;

function cloneElement(vnode, props) {
  return h(vnode.nodeName, extend(extend({}, vnode.attributes), props), arguments.length > 2 ? [].slice.call(arguments, 2) : vnode.children);
}

var IS_NON_DIMENSIONAL = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i;

var items = [];

function enqueueRender(component) {
	if (!component._dirty && (component._dirty = true) && items.push(component) == 1) {
		(options.debounceRendering || defer)(rerender);
	}
}

function rerender() {
	var p;
	while (p = items.pop()) {
		if (p._dirty) renderComponent(p);
	}
}

function isSameNodeType(node, vnode, hydrating) {
	if (typeof vnode === 'string' || typeof vnode === 'number') {
		return node.splitText !== undefined;
	}
	if (typeof vnode.nodeName === 'string') {
		return !node._componentConstructor && isNamedNode(node, vnode.nodeName);
	}
	return hydrating || node._componentConstructor === vnode.nodeName;
}

function isNamedNode(node, nodeName) {
	return node.normalizedNodeName === nodeName || node.nodeName.toLowerCase() === nodeName.toLowerCase();
}

function getNodeProps(vnode) {
	var props = extend({}, vnode.attributes);
	props.children = vnode.children;

	var defaultProps = vnode.nodeName.defaultProps;
	if (defaultProps !== undefined) {
		for (var i in defaultProps) {
			if (props[i] === undefined) {
				props[i] = defaultProps[i];
			}
		}
	}

	return props;
}

function createNode(nodeName, isSvg) {
	var node = isSvg ? document.createElementNS('http://www.w3.org/2000/svg', nodeName) : document.createElement(nodeName);
	node.normalizedNodeName = nodeName;
	return node;
}

function removeNode(node) {
	var parentNode = node.parentNode;
	if (parentNode) parentNode.removeChild(node);
}

function setAccessor(node, name, old, value, isSvg) {
	if (name === 'className') name = 'class';

	if (name === 'key') {} else if (name === 'ref') {
		applyRef(old, null);
		applyRef(value, node);
	} else if (name === 'class' && !isSvg) {
		node.className = value || '';
	} else if (name === 'style') {
		if (!value || typeof value === 'string' || typeof old === 'string') {
			node.style.cssText = value || '';
		}
		if (value && typeof value === 'object') {
			if (typeof old !== 'string') {
				for (var i in old) {
					if (!(i in value)) node.style[i] = '';
				}
			}
			for (var i in value) {
				node.style[i] = typeof value[i] === 'number' && IS_NON_DIMENSIONAL.test(i) === false ? value[i] + 'px' : value[i];
			}
		}
	} else if (name === 'dangerouslySetInnerHTML') {
		if (value) node.innerHTML = value.__html || '';
	} else if (name[0] == 'o' && name[1] == 'n') {
		var useCapture = name !== (name = name.replace(/Capture$/, ''));
		name = name.toLowerCase().substring(2);
		if (value) {
			if (!old) node.addEventListener(name, eventProxy, useCapture);
		} else {
			node.removeEventListener(name, eventProxy, useCapture);
		}
		(node._listeners || (node._listeners = {}))[name] = value;
	} else if (name !== 'list' && name !== 'type' && !isSvg && name in node) {
		try {
			node[name] = value == null ? '' : value;
		} catch (e) {}
		if ((value == null || value === false) && name != 'spellcheck') node.removeAttribute(name);
	} else {
		var ns = isSvg && name !== (name = name.replace(/^xlink:?/, ''));

		if (value == null || value === false) {
			if (ns) node.removeAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase());else node.removeAttribute(name);
		} else if (typeof value !== 'function') {
			if (ns) node.setAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase(), value);else node.setAttribute(name, value);
		}
	}
}

function eventProxy(e) {
	return this._listeners[e.type](options.event && options.event(e) || e);
}

var mounts = [];

var diffLevel = 0;

var isSvgMode = false;

var hydrating = false;

function flushMounts() {
	var c;
	while (c = mounts.shift()) {
		if (options.afterMount) options.afterMount(c);
		if (c.componentDidMount) c.componentDidMount();
	}
}

function diff(dom, vnode, context, mountAll, parent, componentRoot) {
	if (!diffLevel++) {
		isSvgMode = parent != null && parent.ownerSVGElement !== undefined;

		hydrating = dom != null && !('__preactattr_' in dom);
	}

	var ret = idiff(dom, vnode, context, mountAll, componentRoot);

	if (parent && ret.parentNode !== parent) parent.appendChild(ret);

	if (! --diffLevel) {
		hydrating = false;

		if (!componentRoot) flushMounts();
	}

	return ret;
}

function idiff(dom, vnode, context, mountAll, componentRoot) {
	var out = dom,
	    prevSvgMode = isSvgMode;

	if (vnode == null || typeof vnode === 'boolean') vnode = '';

	if (typeof vnode === 'string' || typeof vnode === 'number') {
		if (dom && dom.splitText !== undefined && dom.parentNode && (!dom._component || componentRoot)) {
			if (dom.nodeValue != vnode) {
				dom.nodeValue = vnode;
			}
		} else {
			out = document.createTextNode(vnode);
			if (dom) {
				if (dom.parentNode) dom.parentNode.replaceChild(out, dom);
				recollectNodeTree(dom, true);
			}
		}

		out['__preactattr_'] = true;

		return out;
	}

	var vnodeName = vnode.nodeName;
	if (typeof vnodeName === 'function') {
		return buildComponentFromVNode(dom, vnode, context, mountAll);
	}

	isSvgMode = vnodeName === 'svg' ? true : vnodeName === 'foreignObject' ? false : isSvgMode;

	vnodeName = String(vnodeName);
	if (!dom || !isNamedNode(dom, vnodeName)) {
		out = createNode(vnodeName, isSvgMode);

		if (dom) {
			while (dom.firstChild) {
				out.appendChild(dom.firstChild);
			}
			if (dom.parentNode) dom.parentNode.replaceChild(out, dom);

			recollectNodeTree(dom, true);
		}
	}

	var fc = out.firstChild,
	    props = out['__preactattr_'],
	    vchildren = vnode.children;

	if (props == null) {
		props = out['__preactattr_'] = {};
		for (var a = out.attributes, i = a.length; i--;) {
			props[a[i].name] = a[i].value;
		}
	}

	if (!hydrating && vchildren && vchildren.length === 1 && typeof vchildren[0] === 'string' && fc != null && fc.splitText !== undefined && fc.nextSibling == null) {
		if (fc.nodeValue != vchildren[0]) {
			fc.nodeValue = vchildren[0];
		}
	} else if (vchildren && vchildren.length || fc != null) {
			innerDiffNode(out, vchildren, context, mountAll, hydrating || props.dangerouslySetInnerHTML != null);
		}

	diffAttributes(out, vnode.attributes, props);

	isSvgMode = prevSvgMode;

	return out;
}

function innerDiffNode(dom, vchildren, context, mountAll, isHydrating) {
	var originalChildren = dom.childNodes,
	    children = [],
	    keyed = {},
	    keyedLen = 0,
	    min = 0,
	    len = originalChildren.length,
	    childrenLen = 0,
	    vlen = vchildren ? vchildren.length : 0,
	    j,
	    c,
	    f,
	    vchild,
	    child;

	if (len !== 0) {
		for (var i = 0; i < len; i++) {
			var _child = originalChildren[i],
			    props = _child['__preactattr_'],
			    key = vlen && props ? _child._component ? _child._component.__key : props.key : null;
			if (key != null) {
				keyedLen++;
				keyed[key] = _child;
			} else if (props || (_child.splitText !== undefined ? isHydrating ? _child.nodeValue.trim() : true : isHydrating)) {
				children[childrenLen++] = _child;
			}
		}
	}

	if (vlen !== 0) {
		for (var i = 0; i < vlen; i++) {
			vchild = vchildren[i];
			child = null;

			var key = vchild.key;
			if (key != null) {
				if (keyedLen && keyed[key] !== undefined) {
					child = keyed[key];
					keyed[key] = undefined;
					keyedLen--;
				}
			} else if (min < childrenLen) {
					for (j = min; j < childrenLen; j++) {
						if (children[j] !== undefined && isSameNodeType(c = children[j], vchild, isHydrating)) {
							child = c;
							children[j] = undefined;
							if (j === childrenLen - 1) childrenLen--;
							if (j === min) min++;
							break;
						}
					}
				}

			child = idiff(child, vchild, context, mountAll);

			f = originalChildren[i];
			if (child && child !== dom && child !== f) {
				if (f == null) {
					dom.appendChild(child);
				} else if (child === f.nextSibling) {
					removeNode(f);
				} else {
					dom.insertBefore(child, f);
				}
			}
		}
	}

	if (keyedLen) {
		for (var i in keyed) {
			if (keyed[i] !== undefined) recollectNodeTree(keyed[i], false);
		}
	}

	while (min <= childrenLen) {
		if ((child = children[childrenLen--]) !== undefined) recollectNodeTree(child, false);
	}
}

function recollectNodeTree(node, unmountOnly) {
	var component = node._component;
	if (component) {
		unmountComponent(component);
	} else {
		if (node['__preactattr_'] != null) applyRef(node['__preactattr_'].ref, null);

		if (unmountOnly === false || node['__preactattr_'] == null) {
			removeNode(node);
		}

		removeChildren(node);
	}
}

function removeChildren(node) {
	node = node.lastChild;
	while (node) {
		var next = node.previousSibling;
		recollectNodeTree(node, true);
		node = next;
	}
}

function diffAttributes(dom, attrs, old) {
	var name;

	for (name in old) {
		if (!(attrs && attrs[name] != null) && old[name] != null) {
			setAccessor(dom, name, old[name], old[name] = undefined, isSvgMode);
		}
	}

	for (name in attrs) {
		if (name !== 'children' && name !== 'innerHTML' && (!(name in old) || attrs[name] !== (name === 'value' || name === 'checked' ? dom[name] : old[name]))) {
			setAccessor(dom, name, old[name], old[name] = attrs[name], isSvgMode);
		}
	}
}

var recyclerComponents = [];

function createComponent(Ctor, props, context) {
	var inst,
	    i = recyclerComponents.length;

	if (Ctor.prototype && Ctor.prototype.render) {
		inst = new Ctor(props, context);
		Component.call(inst, props, context);
	} else {
		inst = new Component(props, context);
		inst.constructor = Ctor;
		inst.render = doRender;
	}

	while (i--) {
		if (recyclerComponents[i].constructor === Ctor) {
			inst.nextBase = recyclerComponents[i].nextBase;
			recyclerComponents.splice(i, 1);
			return inst;
		}
	}

	return inst;
}

function doRender(props, state, context) {
	return this.constructor(props, context);
}

function setComponentProps(component, props, renderMode, context, mountAll) {
	if (component._disable) return;
	component._disable = true;

	component.__ref = props.ref;
	component.__key = props.key;
	delete props.ref;
	delete props.key;

	if (typeof component.constructor.getDerivedStateFromProps === 'undefined') {
		if (!component.base || mountAll) {
			if (component.componentWillMount) component.componentWillMount();
		} else if (component.componentWillReceiveProps) {
			component.componentWillReceiveProps(props, context);
		}
	}

	if (context && context !== component.context) {
		if (!component.prevContext) component.prevContext = component.context;
		component.context = context;
	}

	if (!component.prevProps) component.prevProps = component.props;
	component.props = props;

	component._disable = false;

	if (renderMode !== 0) {
		if (renderMode === 1 || options.syncComponentUpdates !== false || !component.base) {
			renderComponent(component, 1, mountAll);
		} else {
			enqueueRender(component);
		}
	}

	applyRef(component.__ref, component);
}

function renderComponent(component, renderMode, mountAll, isChild) {
	if (component._disable) return;

	var props = component.props,
	    state = component.state,
	    context = component.context,
	    previousProps = component.prevProps || props,
	    previousState = component.prevState || state,
	    previousContext = component.prevContext || context,
	    isUpdate = component.base,
	    nextBase = component.nextBase,
	    initialBase = isUpdate || nextBase,
	    initialChildComponent = component._component,
	    skip = false,
	    snapshot = previousContext,
	    rendered,
	    inst,
	    cbase;

	if (component.constructor.getDerivedStateFromProps) {
		state = extend(extend({}, state), component.constructor.getDerivedStateFromProps(props, state));
		component.state = state;
	}

	if (isUpdate) {
		component.props = previousProps;
		component.state = previousState;
		component.context = previousContext;
		if (renderMode !== 2 && component.shouldComponentUpdate && component.shouldComponentUpdate(props, state, context) === false) {
			skip = true;
		} else if (component.componentWillUpdate) {
			component.componentWillUpdate(props, state, context);
		}
		component.props = props;
		component.state = state;
		component.context = context;
	}

	component.prevProps = component.prevState = component.prevContext = component.nextBase = null;
	component._dirty = false;

	if (!skip) {
		rendered = component.render(props, state, context);

		if (component.getChildContext) {
			context = extend(extend({}, context), component.getChildContext());
		}

		if (isUpdate && component.getSnapshotBeforeUpdate) {
			snapshot = component.getSnapshotBeforeUpdate(previousProps, previousState);
		}

		var childComponent = rendered && rendered.nodeName,
		    toUnmount,
		    base;

		if (typeof childComponent === 'function') {

			var childProps = getNodeProps(rendered);
			inst = initialChildComponent;

			if (inst && inst.constructor === childComponent && childProps.key == inst.__key) {
				setComponentProps(inst, childProps, 1, context, false);
			} else {
				toUnmount = inst;

				component._component = inst = createComponent(childComponent, childProps, context);
				inst.nextBase = inst.nextBase || nextBase;
				inst._parentComponent = component;
				setComponentProps(inst, childProps, 0, context, false);
				renderComponent(inst, 1, mountAll, true);
			}

			base = inst.base;
		} else {
			cbase = initialBase;

			toUnmount = initialChildComponent;
			if (toUnmount) {
				cbase = component._component = null;
			}

			if (initialBase || renderMode === 1) {
				if (cbase) cbase._component = null;
				base = diff(cbase, rendered, context, mountAll || !isUpdate, initialBase && initialBase.parentNode, true);
			}
		}

		if (initialBase && base !== initialBase && inst !== initialChildComponent) {
			var baseParent = initialBase.parentNode;
			if (baseParent && base !== baseParent) {
				baseParent.replaceChild(base, initialBase);

				if (!toUnmount) {
					initialBase._component = null;
					recollectNodeTree(initialBase, false);
				}
			}
		}

		if (toUnmount) {
			unmountComponent(toUnmount);
		}

		component.base = base;
		if (base && !isChild) {
			var componentRef = component,
			    t = component;
			while (t = t._parentComponent) {
				(componentRef = t).base = base;
			}
			base._component = componentRef;
			base._componentConstructor = componentRef.constructor;
		}
	}

	if (!isUpdate || mountAll) {
		mounts.push(component);
	} else if (!skip) {

		if (component.componentDidUpdate) {
			component.componentDidUpdate(previousProps, previousState, snapshot);
		}
		if (options.afterUpdate) options.afterUpdate(component);
	}

	while (component._renderCallbacks.length) {
		component._renderCallbacks.pop().call(component);
	}if (!diffLevel && !isChild) flushMounts();
}

function buildComponentFromVNode(dom, vnode, context, mountAll) {
	var c = dom && dom._component,
	    originalComponent = c,
	    oldDom = dom,
	    isDirectOwner = c && dom._componentConstructor === vnode.nodeName,
	    isOwner = isDirectOwner,
	    props = getNodeProps(vnode);
	while (c && !isOwner && (c = c._parentComponent)) {
		isOwner = c.constructor === vnode.nodeName;
	}

	if (c && isOwner && (!mountAll || c._component)) {
		setComponentProps(c, props, 3, context, mountAll);
		dom = c.base;
	} else {
		if (originalComponent && !isDirectOwner) {
			unmountComponent(originalComponent);
			dom = oldDom = null;
		}

		c = createComponent(vnode.nodeName, props, context);
		if (dom && !c.nextBase) {
			c.nextBase = dom;

			oldDom = null;
		}
		setComponentProps(c, props, 1, context, mountAll);
		dom = c.base;

		if (oldDom && dom !== oldDom) {
			oldDom._component = null;
			recollectNodeTree(oldDom, false);
		}
	}

	return dom;
}

function unmountComponent(component) {
	if (options.beforeUnmount) options.beforeUnmount(component);

	var base = component.base;

	component._disable = true;

	if (component.componentWillUnmount) component.componentWillUnmount();

	component.base = null;

	var inner = component._component;
	if (inner) {
		unmountComponent(inner);
	} else if (base) {
		if (base['__preactattr_'] != null) applyRef(base['__preactattr_'].ref, null);

		component.nextBase = base;

		removeNode(base);
		recyclerComponents.push(component);

		removeChildren(base);
	}

	applyRef(component.__ref, null);
}

function Component(props, context) {
	this._dirty = true;

	this.context = context;

	this.props = props;

	this.state = this.state || {};

	this._renderCallbacks = [];
}

extend(Component.prototype, {
	setState: function setState(state, callback) {
		if (!this.prevState) this.prevState = this.state;
		this.state = extend(extend({}, this.state), typeof state === 'function' ? state(this.state, this.props) : state);
		if (callback) this._renderCallbacks.push(callback);
		enqueueRender(this);
	},
	forceUpdate: function forceUpdate(callback) {
		if (callback) this._renderCallbacks.push(callback);
		renderComponent(this, 2);
	},
	render: function render() {}
});

function render(vnode, parent, merge) {
  return diff(merge, vnode, {}, false, parent, false);
}

function createRef() {
	return {};
}

var preact = {
	h: h,
	createElement: h,
	cloneElement: cloneElement,
	createRef: createRef,
	Component: Component,
	render: render,
	rerender: rerender,
	options: options
};

/* unused harmony default export */ var _unused_webpack_default_export = (preact);

//# sourceMappingURL=preact.mjs.map


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
var NativeCustomEvent = global.CustomEvent;

function useNative () {
  try {
    var p = new NativeCustomEvent('cat', { detail: { foo: 'bar' } });
    return  'cat' === p.type && 'bar' === p.detail.foo;
  } catch (e) {
  }
  return false;
}

/**
 * Cross-browser `CustomEvent` constructor.
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent.CustomEvent
 *
 * @public
 */

module.exports = useNative() ? NativeCustomEvent :

// IE >= 9
'undefined' !== typeof document && 'function' === typeof document.createEvent ? function CustomEvent (type, params) {
  var e = document.createEvent('CustomEvent');
  if (params) {
    e.initCustomEvent(type, params.bubbles, params.cancelable, params.detail);
  } else {
    e.initCustomEvent(type, false, false, void 0);
  }
  return e;
} :

// IE <= 8
function CustomEvent (type, params) {
  var e = document.createEventObject();
  e.type = type;
  if (params) {
    e.bubbles = Boolean(params.bubbles);
    e.cancelable = Boolean(params.cancelable);
    e.detail = params.detail;
  } else {
    e.bubbles = false;
    e.cancelable = false;
    e.detail = void 0;
  }
  return e;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ }),
/* 155 */
/***/ (function(module, exports) {


/**
 * Expose `isUrl`.
 */

module.exports = isUrl;

/**
 * RegExps.
 * A URL must match #1 and then at least one of #2/#3.
 * Use two levels of REs to avoid REDOS.
 */

var protocolAndDomainRE = /^(?:\w+:)?\/\/(\S+)$/;

var localhostDomainRE = /^localhost[\:?\d]*(?:[^\:?\d]\S*)?$/
var nonLocalhostDomainRE = /^[^\s\.]+\.\S{2,}$/;

/**
 * Loosely validate a URL `string`.
 *
 * @param {String} string
 * @return {Boolean}
 */

function isUrl(string){
  if (typeof string !== 'string') {
    return false;
  }

  var match = string.match(protocolAndDomainRE);
  if (!match) {
    return false;
  }

  var everythingAfterProtocol = match[1];
  if (!everythingAfterProtocol) {
    return false;
  }

  if (localhostDomainRE.test(everythingAfterProtocol) ||
      nonLocalhostDomainRE.test(everythingAfterProtocol)) {
    return true;
  }

  return false;
}


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Check if we're required to add a port number.
 *
 * @see https://url.spec.whatwg.org/#default-port
 * @param {Number|String} port Port number we need to check
 * @param {String} protocol Protocol we need to check against.
 * @returns {Boolean} Is it a default port for the given protocol
 * @api private
 */
module.exports = function required(port, protocol) {
  protocol = protocol.split(':')[0];
  port = +port;

  if (!port) return false;

  switch (protocol) {
    case 'http':
    case 'ws':
    return port !== 80;

    case 'https':
    case 'wss':
    return port !== 443;

    case 'ftp':
    return port !== 21;

    case 'gopher':
    return port !== 70;

    case 'file':
    return false;
  }

  return port !== 0;
};


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty
  , undef;

/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String} The decoded string.
 * @api private
 */
function decode(input) {
  return decodeURIComponent(input.replace(/\+/g, ' '));
}

/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */
function querystring(query) {
  var parser = /([^=?&]+)=?([^&]*)/g
    , result = {}
    , part;

  while (part = parser.exec(query)) {
    var key = decode(part[1])
      , value = decode(part[2]);

    //
    // Prevent overriding of existing properties. This ensures that build-in
    // methods like `toString` or __proto__ are not overriden by malicious
    // querystrings.
    //
    if (key in result) continue;
    result[key] = value;
  }

  return result;
}

/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */
function querystringify(obj, prefix) {
  prefix = prefix || '';

  var pairs = []
    , value
    , key;

  //
  // Optionally prefix with a '?' if needed
  //
  if ('string' !== typeof prefix) prefix = '?';

  for (key in obj) {
    if (has.call(obj, key)) {
      value = obj[key];

      //
      // Edge cases where we actually want to encode the value to an empty
      // string instead of the stringified value.
      //
      if (!value && (value === null || value === undef || isNaN(value))) {
        value = '';
      }

      pairs.push(encodeURIComponent(key) +'='+ encodeURIComponent(value));
    }
  }

  return pairs.length ? prefix + pairs.join('&') : '';
}

//
// Expose the module.
//
exports.stringify = querystringify;
exports.parse = querystring;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



module.exports = function isObject(val) {
  return val != null && typeof val === 'object' && Array.isArray(val) === false;
};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Generated by CoffeeScript 1.9.1
(function() {
  'use strict';
  var getScrollbarWidth, scrollbarWidth;

  scrollbarWidth = null;

  getScrollbarWidth = function(recalculate) {
    var div1, div2;
    if (recalculate == null) {
      recalculate = false;
    }
    if ((scrollbarWidth != null) && !recalculate) {
      return scrollbarWidth;
    }
    if (document.readyState === 'loading') {
      return null;
    }
    div1 = document.createElement('div');
    div2 = document.createElement('div');
    div1.style.width = div2.style.width = div1.style.height = div2.style.height = '100px';
    div1.style.overflow = 'scroll';
    div2.style.overflow = 'hidden';
    document.body.appendChild(div1);
    document.body.appendChild(div2);
    scrollbarWidth = Math.abs(div1.scrollHeight - div2.scrollHeight);
    document.body.removeChild(div1);
    document.body.removeChild(div2);
    return scrollbarWidth;
  };

  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return getScrollbarWidth;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== 'undefined') {
    module.exports = getScrollbarWidth;
  } else {
    this.getScrollbarWidth = getScrollbarWidth;
  }

}).call(this);


/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_memoize__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_unitless__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_hash__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_stylis__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet__);






var hyphenateRegex = /[A-Z]|^ms/g;
var processStyleName = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_memoize__["a" /* default */])(function (styleName) {
  return styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
  if (value == null || typeof value === 'boolean') {
    return '';
  }

  if (__WEBPACK_IMPORTED_MODULE_1__emotion_unitless__["a" /* default */][key] !== 1 && key.charCodeAt(1) !== 45 && // custom properties
  !isNaN(value) && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (process.env.NODE_ENV !== 'production') {
  var contentValuePattern = /(attr|calc|counters?|url)\(/;
  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    return oldProcessStyleValue(key, value);
  };
}

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'function':
        if (process.env.NODE_ENV !== 'production') {
          console.error('Passing functions to cx is deprecated and will be removed in the next major version of Emotion.\n' + 'Please call the function before passing it to cx.');
        }

        toAdd = classnames([arg()]);
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};
var isBrowser = typeof document !== 'undefined';

/*

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance
- 'polyfills' on server side

// usage

import StyleSheet from 'glamor/lib/sheet'
let styleSheet = new StyleSheet()

styleSheet.inject()
- 'injects' the stylesheet into the page (or into memory if on server)

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function makeStyleTag(opts) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', opts.key || '');

  if (opts.nonce !== undefined) {
    tag.setAttribute('nonce', opts.nonce);
  }

  tag.appendChild(document.createTextNode('')) // $FlowFixMe
  ;
  (opts.container !== undefined ? opts.container : document.head).appendChild(tag);
  return tag;
}

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(options) {
    this.isSpeedy = process.env.NODE_ENV === 'production'; // the big drawback here is that the css won't be editable in devtools

    this.tags = [];
    this.ctr = 0;
    this.opts = options;
  }

  var _proto = StyleSheet.prototype;

  _proto.inject = function inject() {
    if (this.injected) {
      throw new Error('already injected!');
    }

    this.tags[0] = makeStyleTag(this.opts);
    this.injected = true;
  };

  _proto.speedy = function speedy(bool) {
    if (this.ctr !== 0) {
      // cannot change speedy mode after inserting any rule to sheet. Either call speedy(${bool}) earlier in your app, or call flush() before speedy(${bool})
      throw new Error("cannot change speedy now");
    }

    this.isSpeedy = !!bool;
  };

  _proto.insert = function insert(rule, sourceMap) {
    // this is the ultrafast version, works across browsers
    if (this.isSpeedy) {
      var tag = this.tags[this.tags.length - 1];
      var sheet = sheetForTag(tag);

      try {
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (process.env.NODE_ENV !== 'production') {
          console.warn('illegal rule', rule); // eslint-disable-line no-console
        }
      }
    } else {
      var _tag = makeStyleTag(this.opts);

      this.tags.push(_tag);

      _tag.appendChild(document.createTextNode(rule + (sourceMap || '')));
    }

    this.ctr++;

    if (this.ctr % 65000 === 0) {
      this.tags.push(makeStyleTag(this.opts));
    }
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0; // todo - look for remnants in document.styleSheets

    this.injected = false;
  };

  return StyleSheet;
}();

function createEmotion(context, options) {
  if (context.__SECRET_EMOTION__ !== undefined) {
    return context.__SECRET_EMOTION__;
  }

  if (options === undefined) options = {};
  var key = options.key || 'css';

  if (process.env.NODE_ENV !== 'production') {
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var current;

  function insertRule(rule) {
    current += rule;

    if (isBrowser) {
      sheet.insert(rule, currentSourceMap);
    }
  }

  var insertionPlugin = __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet___default()(insertRule);
  var stylisOptions;

  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }

  var caches = {
    registered: {},
    inserted: {},
    nonce: options.nonce,
    key: key
  };
  var sheet = new StyleSheet(options);

  if (isBrowser) {
    // 🚀
    sheet.inject();
  }

  var stylis = new __WEBPACK_IMPORTED_MODULE_3__emotion_stylis__["a" /* default */](stylisOptions);
  stylis.use(options.stylisPlugins)(insertionPlugin);
  var currentSourceMap = '';

  function handleInterpolation(interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) {
      return '';
    }

    switch (typeof interpolation) {
      case 'boolean':
        return '';

      case 'function':
        if (interpolation.__emotion_styles !== undefined) {
          var selector = interpolation.toString();

          if (selector === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
            throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
          }

          return selector;
        }

        if (this === undefined && process.env.NODE_ENV !== 'production') {
          console.error('Interpolating functions in css calls is deprecated and will be removed in the next major version of Emotion.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        return handleInterpolation.call(this, this === undefined ? interpolation() : // $FlowFixMe
        interpolation(this.mergedProps, this.context), couldBeSelectorInterpolation);

      case 'object':
        return createStringFromObject.call(this, interpolation);

      default:
        var cached = caches.registered[interpolation];
        return couldBeSelectorInterpolation === false && cached !== undefined ? cached : interpolation;
    }
  }

  var objectToStringCache = new WeakMap();

  function createStringFromObject(obj) {
    if (objectToStringCache.has(obj)) {
      // $FlowFixMe
      return objectToStringCache.get(obj);
    }

    var string = '';

    if (Array.isArray(obj)) {
      obj.forEach(function (interpolation) {
        string += handleInterpolation.call(this, interpolation, false);
      }, this);
    } else {
      Object.keys(obj).forEach(function (key) {
        if (typeof obj[key] !== 'object') {
          if (caches.registered[obj[key]] !== undefined) {
            string += key + "{" + caches.registered[obj[key]] + "}";
          } else {
            string += processStyleName(key) + ":" + processStyleValue(key, obj[key]) + ";";
          }
        } else {
          if (key === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
            throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
          }

          if (Array.isArray(obj[key]) && typeof obj[key][0] === 'string' && caches.registered[obj[key][0]] === undefined) {
            obj[key].forEach(function (value) {
              string += processStyleName(key) + ":" + processStyleValue(key, value) + ";";
            });
          } else {
            string += key + "{" + handleInterpolation.call(this, obj[key], false) + "}";
          }
        }
      }, this);
    }

    objectToStringCache.set(obj, string);
    return string;
  }

  var name;
  var stylesWithLabel;
  var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;

  var createClassName = function createClassName(styles, identifierName) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__emotion_hash__["a" /* default */])(styles + identifierName) + identifierName;
  };

  if (process.env.NODE_ENV !== 'production') {
    var oldCreateClassName = createClassName;
    var sourceMappingUrlPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;

    createClassName = function createClassName(styles, identifierName) {
      return oldCreateClassName(styles.replace(sourceMappingUrlPattern, function (sourceMap) {
        currentSourceMap = sourceMap;
        return '';
      }), identifierName);
    };
  }

  var createStyles = function createStyles(strings) {
    var stringMode = true;
    var styles = '';
    var identifierName = '';

    if (strings == null || strings.raw === undefined) {
      stringMode = false;
      styles += handleInterpolation.call(this, strings, false);
    } else {
      styles += strings[0];
    }

    for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    interpolations.forEach(function (interpolation, i) {
      styles += handleInterpolation.call(this, interpolation, styles.charCodeAt(styles.length - 1) === 46 // .
      );

      if (stringMode === true && strings[i + 1] !== undefined) {
        styles += strings[i + 1];
      }
    }, this);
    stylesWithLabel = styles;
    styles = styles.replace(labelPattern, function (match, p1) {
      identifierName += "-" + p1;
      return '';
    });
    name = createClassName(styles, identifierName);
    return styles;
  };

  if (process.env.NODE_ENV !== 'production') {
    var oldStylis = stylis;

    stylis = function stylis(selector, styles) {
      oldStylis(selector, styles);
      currentSourceMap = '';
    };
  }

  function insert(scope, styles) {
    if (caches.inserted[name] === undefined) {
      current = '';
      stylis(scope, styles);
      caches.inserted[name] = current;
    }
  }

  var css = function css() {
    var styles = createStyles.apply(this, arguments);
    var selector = key + "-" + name;

    if (caches.registered[selector] === undefined) {
      caches.registered[selector] = stylesWithLabel;
    }

    insert("." + selector, styles);
    return selector;
  };

  var keyframes = function keyframes() {
    var styles = createStyles.apply(this, arguments);
    var animation = "animation-" + name;
    insert('', "@keyframes " + animation + "{" + styles + "}");
    return animation;
  };

  var injectGlobal = function injectGlobal() {
    var styles = createStyles.apply(this, arguments);
    insert('', styles);
  };

  function getRegisteredStyles(registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function (className) {
      if (caches.registered[className] !== undefined) {
        registeredStyles.push(className);
      } else {
        rawClassName += className + " ";
      }
    });
    return rawClassName;
  }

  function merge(className, sourceMap) {
    var registeredStyles = [];
    var rawClassName = getRegisteredStyles(registeredStyles, className);

    if (registeredStyles.length < 2) {
      return className;
    }

    return rawClassName + css(registeredStyles, sourceMap);
  }

  function cx() {
    for (var _len2 = arguments.length, classNames = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      classNames[_key2] = arguments[_key2];
    }

    return merge(classnames(classNames));
  }

  function hydrateSingleId(id) {
    caches.inserted[id] = true;
  }

  function hydrate(ids) {
    ids.forEach(hydrateSingleId);
  }

  function flush() {
    if (isBrowser) {
      sheet.flush();
      sheet.inject();
    }

    caches.inserted = {};
    caches.registered = {};
  }

  if (isBrowser) {
    var chunks = document.querySelectorAll("[data-emotion-" + key + "]");
    Array.prototype.forEach.call(chunks, function (node) {
      // $FlowFixMe
      sheet.tags[0].parentNode.insertBefore(node, sheet.tags[0]); // $FlowFixMe

      node.getAttribute("data-emotion-" + key).split(' ').forEach(hydrateSingleId);
    });
  }

  var emotion = {
    flush: flush,
    hydrate: hydrate,
    cx: cx,
    merge: merge,
    getRegisteredStyles: getRegisteredStyles,
    injectGlobal: injectGlobal,
    keyframes: keyframes,
    css: css,
    sheet: sheet,
    caches: caches
  };
  context.__SECRET_EMOTION__ = emotion;
  return emotion;
}

/* harmony default export */ __webpack_exports__["default"] = (createEmotion);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(28)))

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ __webpack_exports__["a"] = (unitlessKeys);


/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */
// murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash2_32_gc(str) {
  var l = str.length,
      h = l ^ l,
      i = 0,
      k;

  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
    l -= 4;
    ++i;
  }

  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }

  h ^= h >>> 13;
  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  h ^= h >>> 15;
  return (h >>> 0).toString(36);
}

/* harmony default export */ __webpack_exports__["a"] = (murmurhash2_32_gc);


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e, m).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e, m).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        switch (d.constructor) {
          case Array:
            for (var c = 0, e = d.length; c < e; ++c) {
              T(d[c]);
            }

            break;

          case Function:
            S[A++] = d;
            break;

          case Boolean:
            Y = !!d | 0;
        }

    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ __webpack_exports__["a"] = (stylis_min);


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

(function (factory) {
	 true ? (module['exports'] = factory()) :
		typeof define === 'function' && define['amd'] ? define(factory()) :
			(window['stylisRuleSheet'] = factory())
}(function () {

	'use strict'

	return function (insertRule) {
		var delimiter = '/*|*/'
		var needle = delimiter+'}'

		function toSheet (block) {
			if (block)
				try {
					insertRule(block + '}')
				} catch (e) {}
		}

		return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64)
						return insertRule(content+';'), ''
					break
				// selector
				case 2:
					if (ns === 0)
						return content + delimiter
					break
				// at-rule
				case 3:
					switch (ns) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0]+content), ''
						default:
							return content + (at === 0 ? delimiter : '')
					}
				case -2:
					content.split(needle).forEach(toSheet)
			}
		}
	}
}))


/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_is_prop_valid__ = __webpack_require__(166);



function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var channel = '__EMOTION_THEMING__';

// https://github.com/styled-components/styled-components/blob/e05b3fe247e9d956bcde786cec376e32afb85bca/src/utils/create-broadcast.js

var _contextTypes;
var contextTypes = (_contextTypes = {}, _contextTypes[channel] = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object, _contextTypes);

function setTheme(theme) {
  this.setState({
    theme: theme
  });
}
var testPickPropsOnStringTag = __WEBPACK_IMPORTED_MODULE_1__emotion_is_prop_valid__["a" /* default */];
var testPickPropsOnComponent = function testPickPropsOnComponent(key) {
  return key !== 'theme' && key !== 'innerRef';
};
var testAlwaysTrue = function testAlwaysTrue() {
  return true;
};
var pickAssign = function pickAssign(testFn, target) {
  var i = 2;
  var length = arguments.length;

  for (; i < length; i++) {
    var source = arguments[i];

    var _key = void 0;

    for (_key in source) {
      if (testFn(_key)) {
        target[_key] = source[_key];
      }
    }
  }

  return target;
};

var warnedAboutExtractStatic = false;

function createEmotionStyled(emotion, view) {
  var _createStyled = function createStyled(tag, options) {
    if (process.env.NODE_ENV !== 'production') {
      if (tag === undefined) {
        throw new Error('You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.');
      }
    }

    var staticClassName;
    var identifierName;
    var stableClassName;
    var shouldForwardProp;

    if (options !== undefined) {
      staticClassName = options.e;
      identifierName = options.label;
      stableClassName = options.target;
      shouldForwardProp = tag.__emotion_forwardProp && options.shouldForwardProp ? function (propName) {
        return tag.__emotion_forwardProp(propName) && // $FlowFixMe
        options.shouldForwardProp(propName);
      } : options.shouldForwardProp;
    }

    var isReal = tag.__emotion_real === tag;
    var baseTag = staticClassName === undefined ? isReal && tag.__emotion_base || tag : tag;

    if (typeof shouldForwardProp !== 'function') {
      shouldForwardProp = typeof baseTag === 'string' && baseTag.charAt(0) === baseTag.charAt(0).toLowerCase() ? testPickPropsOnStringTag : testPickPropsOnComponent;
    }

    return function () {
      var args = arguments;
      var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];

      if (identifierName !== undefined) {
        styles.push("label:" + identifierName + ";");
      }

      if (staticClassName === undefined) {
        if (args[0] == null || args[0].raw === undefined) {
          styles.push.apply(styles, args);
        } else {
          styles.push(args[0][0]);
          var len = args.length;
          var i = 1;

          for (; i < len; i++) {
            styles.push(args[i], args[0][i]);
          }
        }
      } else if (process.env.NODE_ENV !== 'production' && !warnedAboutExtractStatic) {
        console.warn('extractStatic is deprecated and will be removed in emotion@10. We recommend disabling extractStatic or using other libraries like linaria or css-literal-loader');
        warnedAboutExtractStatic = true;
      }

      var Styled =
      /*#__PURE__*/
      function (_view$Component) {
        _inheritsLoose(Styled, _view$Component);

        function Styled() {
          return _view$Component.apply(this, arguments) || this;
        }

        var _proto = Styled.prototype;

        _proto.componentWillMount = function componentWillMount() {
          if (this.context[channel] !== undefined) {
            this.unsubscribe = this.context[channel].subscribe(setTheme.bind(this));
          }
        };

        _proto.componentWillUnmount = function componentWillUnmount() {
          if (this.unsubscribe !== undefined) {
            this.context[channel].unsubscribe(this.unsubscribe);
          }
        };

        _proto.render = function render() {
          var props = this.props,
              state = this.state;
          this.mergedProps = pickAssign(testAlwaysTrue, {}, props, {
            theme: state !== null && state.theme || props.theme || {}
          });
          var className = '';
          var classInterpolations = [];

          if (props.className) {
            if (staticClassName === undefined) {
              className += emotion.getRegisteredStyles(classInterpolations, props.className);
            } else {
              className += props.className + " ";
            }
          }

          if (staticClassName === undefined) {
            className += emotion.css.apply(this, styles.concat(classInterpolations));
          } else {
            className += staticClassName;
          }

          if (stableClassName !== undefined) {
            className += " " + stableClassName;
          }

          return view.createElement(baseTag, // $FlowFixMe
          pickAssign(shouldForwardProp, {}, props, {
            className: className,
            ref: props.innerRef
          }));
        };

        return Styled;
      }(view.Component);

      Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";

      if (tag.defaultProps !== undefined) {
        // $FlowFixMe
        Styled.defaultProps = tag.defaultProps;
      }

      Styled.contextTypes = contextTypes;
      Styled.__emotion_styles = styles;
      Styled.__emotion_base = baseTag;
      Styled.__emotion_real = Styled;
      Styled.__emotion_forwardProp = shouldForwardProp;
      Object.defineProperty(Styled, 'toString', {
        value: function value() {
          if (process.env.NODE_ENV !== 'production' && stableClassName === undefined) {
            return 'NO_COMPONENT_SELECTOR';
          } // $FlowFixMe


          return "." + stableClassName;
        }
      });

      Styled.withComponent = function (nextTag, nextOptions) {
        return _createStyled(nextTag, nextOptions !== undefined ? // $FlowFixMe
        pickAssign(testAlwaysTrue, {}, options, nextOptions) : options).apply(void 0, styles);
      };

      return Styled;
    };
  };

  if (process.env.NODE_ENV !== 'production' && typeof Proxy !== 'undefined') {
    _createStyled = new Proxy(_createStyled, {
      get: function get(target, property) {
        switch (property) {
          // react-hot-loader tries to access this stuff
          case '__proto__':
          case 'name':
          case 'prototype':
          case 'displayName':
            {
              return target[property];
            }

          default:
            {
              throw new Error("You're trying to use the styled shorthand without babel-plugin-emotion." + ("\nPlease install and setup babel-plugin-emotion or use the function call syntax(`styled('" + property + "')` instead of `styled." + property + "`)"));
            }
        }
      }
    });
  }

  return _createStyled;
}

/* harmony default export */ __webpack_exports__["default"] = (createEmotionStyled);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(28)))

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_memoize__ = __webpack_require__(105);


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|default|defer|dir|disabled|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|itemProp|itemScope|itemType|itemID|itemRef|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class)|(on[A-Z].*)|((data|aria|x)-.*))$/i;
var index = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_memoize__["a" /* default */])(reactPropsRegex.test.bind(reactPropsRegex));

/* harmony default export */ __webpack_exports__["a"] = (index);


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(18);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(29);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _spin = __webpack_require__(168);

var _spin2 = _interopRequireDefault(_spin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultConfig = {
  lines: 16,
  length: 3,
  width: 3,
  radius: 14,
  color: '#FFFFFF',
  speed: 2.1,
  trail: 60,
  shadow: false,
  hwaccel: false,
  top: '50%',
  left: '50%',
  position: 'absolute',
  zIndex: 999
};

var Spinner = function (_Component) {
  _inherits(Spinner, _Component);

  function Spinner() {
    _classCallCheck(this, Spinner);

    return _possibleConstructorReturn(this, (Spinner.__proto__ || Object.getPrototypeOf(Spinner)).apply(this, arguments));
  }

  _createClass(Spinner, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.instantiateSpinner(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (newProps.config.color !== this.props.config.color) {
        this.spinner.stop();
        // the Spinner API doesn't provide a method to change its options after instantiation,
        // so the only way to do so is to reinstantiate the spinner ¯\_(ツ)_/¯
        this.instantiateSpinner(newProps);
      } else {
        if (newProps.stopped === true && !this.props.stopped) {
          this.spinner.stop();
        } else if (!newProps.stopped && this.props.stopped === true) {
          this.spinner.spin(this.container);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.spinner.stop();
    }
  }, {
    key: 'instantiateSpinner',
    value: function instantiateSpinner(props) {
      this.spinner = new _spin2.default(_extends({}, defaultConfig, props.config));
      if (!props.stopped) {
        this.spinner.spin(this.container);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement('div', { ref: function ref(node) {
          _this2.container = node;
        } });
    }
  }]);

  return Spinner;
}(_react.Component);

Spinner.propTypes = {
  config: _propTypes2.default.object,
  stopped: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  style: _propTypes2.default.object
};

Spinner.defaultProps = {
  config: defaultConfig,
  className: '',
  style: {}
};

exports.default = Spinner;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Copyright (c) 2011-2014 Felix Gnass
 * Licensed under the MIT license
 * http://spin.js.org/
 *
 * Example:
    var opts = {
      lines: 12             // The number of lines to draw
    , length: 7             // The length of each line
    , width: 5              // The line thickness
    , radius: 10            // The radius of the inner circle
    , scale: 1.0            // Scales overall size of the spinner
    , corners: 1            // Roundness (0..1)
    , color: '#000'         // #rgb or #rrggbb
    , opacity: 1/4          // Opacity of the lines
    , rotate: 0             // Rotation offset
    , direction: 1          // 1: clockwise, -1: counterclockwise
    , speed: 1              // Rounds per second
    , trail: 100            // Afterglow percentage
    , fps: 20               // Frames per second when using setTimeout()
    , zIndex: 2e9           // Use a high z-index by default
    , className: 'spinner'  // CSS class to assign to the element
    , top: '50%'            // center vertically
    , left: '50%'           // center horizontally
    , shadow: false         // Whether to render a shadow
    , hwaccel: false        // Whether to use hardware acceleration (might be buggy)
    , position: 'absolute'  // Element positioning
    }
    var target = document.getElementById('foo')
    var spinner = new Spinner(opts).spin(target)
 */
;(function (root, factory) {

  /* CommonJS */
  if (typeof module == 'object' && module.exports) module.exports = factory()

  /* AMD module */
  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))

  /* Browser global */
  else root.Spinner = factory()
}(this, function () {
  "use strict"

  var prefixes = ['webkit', 'Moz', 'ms', 'O'] /* Vendor prefixes */
    , animations = {} /* Animation rules keyed by their name */
    , useCssAnimations /* Whether to use CSS animations or setTimeout */
    , sheet /* A stylesheet to hold the @keyframe or VML rules. */

  /**
   * Utility function to create elements. If no tag name is given,
   * a DIV is created. Optionally properties can be passed.
   */
  function createEl (tag, prop) {
    var el = document.createElement(tag || 'div')
      , n

    for (n in prop) el[n] = prop[n]
    return el
  }

  /**
   * Appends children and returns the parent.
   */
  function ins (parent /* child1, child2, ...*/) {
    for (var i = 1, n = arguments.length; i < n; i++) {
      parent.appendChild(arguments[i])
    }

    return parent
  }

  /**
   * Creates an opacity keyframe animation rule and returns its name.
   * Since most mobile Webkits have timing issues with animation-delay,
   * we create separate rules for each line/segment.
   */
  function addAnimation (alpha, trail, i, lines) {
    var name = ['opacity', trail, ~~(alpha * 100), i, lines].join('-')
      , start = 0.01 + i/lines * 100
      , z = Math.max(1 - (1-alpha) / trail * (100-start), alpha)
      , prefix = useCssAnimations.substring(0, useCssAnimations.indexOf('Animation')).toLowerCase()
      , pre = prefix && '-' + prefix + '-' || ''

    if (!animations[name]) {
      sheet.insertRule(
        '@' + pre + 'keyframes ' + name + '{' +
        '0%{opacity:' + z + '}' +
        start + '%{opacity:' + alpha + '}' +
        (start+0.01) + '%{opacity:1}' +
        (start+trail) % 100 + '%{opacity:' + alpha + '}' +
        '100%{opacity:' + z + '}' +
        '}', sheet.cssRules.length)

      animations[name] = 1
    }

    return name
  }

  /**
   * Tries various vendor prefixes and returns the first supported property.
   */
  function vendor (el, prop) {
    var s = el.style
      , pp
      , i

    prop = prop.charAt(0).toUpperCase() + prop.slice(1)
    if (s[prop] !== undefined) return prop
    for (i = 0; i < prefixes.length; i++) {
      pp = prefixes[i]+prop
      if (s[pp] !== undefined) return pp
    }
  }

  /**
   * Sets multiple style properties at once.
   */
  function css (el, prop) {
    for (var n in prop) {
      el.style[vendor(el, n) || n] = prop[n]
    }

    return el
  }

  /**
   * Fills in default values.
   */
  function merge (obj) {
    for (var i = 1; i < arguments.length; i++) {
      var def = arguments[i]
      for (var n in def) {
        if (obj[n] === undefined) obj[n] = def[n]
      }
    }
    return obj
  }

  /**
   * Returns the line color from the given string or array.
   */
  function getColor (color, idx) {
    return typeof color == 'string' ? color : color[idx % color.length]
  }

  // Built-in defaults

  var defaults = {
    lines: 12             // The number of lines to draw
  , length: 7             // The length of each line
  , width: 5              // The line thickness
  , radius: 10            // The radius of the inner circle
  , scale: 1.0            // Scales overall size of the spinner
  , corners: 1            // Roundness (0..1)
  , color: '#000'         // #rgb or #rrggbb
  , opacity: 1/4          // Opacity of the lines
  , rotate: 0             // Rotation offset
  , direction: 1          // 1: clockwise, -1: counterclockwise
  , speed: 1              // Rounds per second
  , trail: 100            // Afterglow percentage
  , fps: 20               // Frames per second when using setTimeout()
  , zIndex: 2e9           // Use a high z-index by default
  , className: 'spinner'  // CSS class to assign to the element
  , top: '50%'            // center vertically
  , left: '50%'           // center horizontally
  , shadow: false         // Whether to render a shadow
  , hwaccel: false        // Whether to use hardware acceleration (might be buggy)
  , position: 'absolute'  // Element positioning
  }

  /** The constructor */
  function Spinner (o) {
    this.opts = merge(o || {}, Spinner.defaults, defaults)
  }

  // Global defaults that override the built-ins:
  Spinner.defaults = {}

  merge(Spinner.prototype, {
    /**
     * Adds the spinner to the given target element. If this instance is already
     * spinning, it is automatically removed from its previous target b calling
     * stop() internally.
     */
    spin: function (target) {
      this.stop()

      var self = this
        , o = self.opts
        , el = self.el = createEl(null, {className: o.className})

      css(el, {
        position: o.position
      , width: 0
      , zIndex: o.zIndex
      , left: o.left
      , top: o.top
      })

      if (target) {
        target.insertBefore(el, target.firstChild || null)
      }

      el.setAttribute('role', 'progressbar')
      self.lines(el, self.opts)

      if (!useCssAnimations) {
        // No CSS animation support, use setTimeout() instead
        var i = 0
          , start = (o.lines - 1) * (1 - o.direction) / 2
          , alpha
          , fps = o.fps
          , f = fps / o.speed
          , ostep = (1 - o.opacity) / (f * o.trail / 100)
          , astep = f / o.lines

        ;(function anim () {
          i++
          for (var j = 0; j < o.lines; j++) {
            alpha = Math.max(1 - (i + (o.lines - j) * astep) % f * ostep, o.opacity)

            self.opacity(el, j * o.direction + start, alpha, o)
          }
          self.timeout = self.el && setTimeout(anim, ~~(1000 / fps))
        })()
      }
      return self
    }

    /**
     * Stops and removes the Spinner.
     */
  , stop: function () {
      var el = this.el
      if (el) {
        clearTimeout(this.timeout)
        if (el.parentNode) el.parentNode.removeChild(el)
        this.el = undefined
      }
      return this
    }

    /**
     * Internal method that draws the individual lines. Will be overwritten
     * in VML fallback mode below.
     */
  , lines: function (el, o) {
      var i = 0
        , start = (o.lines - 1) * (1 - o.direction) / 2
        , seg

      function fill (color, shadow) {
        return css(createEl(), {
          position: 'absolute'
        , width: o.scale * (o.length + o.width) + 'px'
        , height: o.scale * o.width + 'px'
        , background: color
        , boxShadow: shadow
        , transformOrigin: 'left'
        , transform: 'rotate(' + ~~(360/o.lines*i + o.rotate) + 'deg) translate(' + o.scale*o.radius + 'px' + ',0)'
        , borderRadius: (o.corners * o.scale * o.width >> 1) + 'px'
        })
      }

      for (; i < o.lines; i++) {
        seg = css(createEl(), {
          position: 'absolute'
        , top: 1 + ~(o.scale * o.width / 2) + 'px'
        , transform: o.hwaccel ? 'translate3d(0,0,0)' : ''
        , opacity: o.opacity
        , animation: useCssAnimations && addAnimation(o.opacity, o.trail, start + i * o.direction, o.lines) + ' ' + 1 / o.speed + 's linear infinite'
        })

        if (o.shadow) ins(seg, css(fill('#000', '0 0 4px #000'), {top: '2px'}))
        ins(el, ins(seg, fill(getColor(o.color, i), '0 0 1px rgba(0,0,0,.1)')))
      }
      return el
    }

    /**
     * Internal method that adjusts the opacity of a single line.
     * Will be overwritten in VML fallback mode below.
     */
  , opacity: function (el, i, val) {
      if (i < el.childNodes.length) el.childNodes[i].style.opacity = val
    }

  })


  function initVML () {

    /* Utility function to create a VML tag */
    function vml (tag, attr) {
      return createEl('<' + tag + ' xmlns="urn:schemas-microsoft.com:vml" class="spin-vml">', attr)
    }

    // No CSS transforms but VML support, add a CSS rule for VML elements:
    sheet.addRule('.spin-vml', 'behavior:url(#default#VML)')

    Spinner.prototype.lines = function (el, o) {
      var r = o.scale * (o.length + o.width)
        , s = o.scale * 2 * r

      function grp () {
        return css(
          vml('group', {
            coordsize: s + ' ' + s
          , coordorigin: -r + ' ' + -r
          })
        , { width: s, height: s }
        )
      }

      var margin = -(o.width + o.length) * o.scale * 2 + 'px'
        , g = css(grp(), {position: 'absolute', top: margin, left: margin})
        , i

      function seg (i, dx, filter) {
        ins(
          g
        , ins(
            css(grp(), {rotation: 360 / o.lines * i + 'deg', left: ~~dx})
          , ins(
              css(
                vml('roundrect', {arcsize: o.corners})
              , { width: r
                , height: o.scale * o.width
                , left: o.scale * o.radius
                , top: -o.scale * o.width >> 1
                , filter: filter
                }
              )
            , vml('fill', {color: getColor(o.color, i), opacity: o.opacity})
            , vml('stroke', {opacity: 0}) // transparent stroke to fix color bleeding upon opacity change
            )
          )
        )
      }

      if (o.shadow)
        for (i = 1; i <= o.lines; i++) {
          seg(i, -2, 'progid:DXImageTransform.Microsoft.Blur(pixelradius=2,makeshadow=1,shadowopacity=.3)')
        }

      for (i = 1; i <= o.lines; i++) seg(i)
      return ins(el, g)
    }

    Spinner.prototype.opacity = function (el, i, val, o) {
      var c = el.firstChild
      o = o.shadow && o.lines || 0
      if (c && i + o < c.childNodes.length) {
        c = c.childNodes[i + o]; c = c && c.firstChild; c = c && c.firstChild
        if (c) c.opacity = val
      }
    }
  }

  if (typeof document !== 'undefined') {
    sheet = (function () {
      var el = createEl('style', {type : 'text/css'})
      ins(document.getElementsByTagName('head')[0], el)
      return el.sheet || el.styleSheet
    }())

    var probe = css(createEl('group'), {behavior: 'url(#default#VML)'})

    if (!vendor(probe, 'transform') && probe.adj) initVML()
    else useCssAnimations = vendor(probe, 'animation')
  }

  return Spinner

}));


/***/ }),
/* 169 */
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,R0lGODlhEQARAIAAAODn7P///yH5BAEHAAEALAAAAAARABEAAAIqBIKpab3v3EMyVHWtWZluf0za0XFNKDJfCq5i5JpomdUxqKLQVmInqyoAADs="

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(18);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(29);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = __webpack_require__(58);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Root = /*#__PURE__*/(0, _styles2.default)('div', {
  target: 'e1m9xwad0'
})('position:absolute;z-index:1001;top:0;right:0;font-size:20px;font-family:sans-serif;width:50px;height:50px;');

var closeArrow = /*#__PURE__*/(0, _styles.css)('border-radius:0;display:block;height:2px;width:25px;position:absolute;right:6px;top:6px;');

var ArrowLeft = /*#__PURE__*/(0, _styles2.default)('span', {
  target: 'e1m9xwad1'
})(closeArrow, ' background-color:', function (p) {
  return p.backgroundColor;
}, ';transform:translate(0,13px) rotate3d(0,0,1,-135deg);');

var ArrowRight = /*#__PURE__*/(0, _styles2.default)('span', {
  target: 'e1m9xwad2'
})(closeArrow, ' background-color:', function (p) {
  return p.backgroundColor;
}, ';transform:translate(0,13px) rotate3d(0,0,1,-45deg);');

var CloseIcon = function CloseIcon(_ref) {
  var color = _ref.color,
      onClick = _ref.onClick,
      dataQa = _ref.dataQa;
  return _react2.default.createElement(
    Root,
    { 'data-qa': dataQa, onClick: onClick },
    _react2.default.createElement(ArrowLeft, { backgroundColor: color }),
    _react2.default.createElement(ArrowRight, { backgroundColor: color })
  );
};

CloseIcon.propTypes = {
  color: _propTypes2.default.string,
  dataQa: _propTypes2.default.string,
  onClick: _propTypes2.default.func
};

exports.default = CloseIcon;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== 'undefined' && typeof module !== 'undefined') {
    factory(exports, module);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, mod);
    global.fetchJsonp = mod.exports;
  }
})(this, function (exports, module) {
  'use strict';

  var defaultOptions = {
    timeout: 5000,
    jsonpCallback: 'callback',
    jsonpCallbackFunction: null
  };

  function generateCallbackFunction() {
    return 'jsonp_' + Date.now() + '_' + Math.ceil(Math.random() * 100000);
  }

  function clearFunction(functionName) {
    // IE8 throws an exception when you try to delete a property on window
    // http://stackoverflow.com/a/1824228/751089
    try {
      delete window[functionName];
    } catch (e) {
      window[functionName] = undefined;
    }
  }

  function removeScript(scriptId) {
    var script = document.getElementById(scriptId);
    if (script) {
      document.getElementsByTagName('head')[0].removeChild(script);
    }
  }

  function fetchJsonp(_url) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    // to avoid param reassign
    var url = _url;
    var timeout = options.timeout || defaultOptions.timeout;
    var jsonpCallback = options.jsonpCallback || defaultOptions.jsonpCallback;

    var timeoutId = undefined;

    return new Promise(function (resolve, reject) {
      var callbackFunction = options.jsonpCallbackFunction || generateCallbackFunction();
      var scriptId = jsonpCallback + '_' + callbackFunction;

      window[callbackFunction] = function (response) {
        resolve({
          ok: true,
          // keep consistent with fetch API
          json: function json() {
            return Promise.resolve(response);
          }
        });

        if (timeoutId) clearTimeout(timeoutId);

        removeScript(scriptId);

        clearFunction(callbackFunction);
      };

      // Check if the user set their own params, and if not add a ? to start a list of params
      url += url.indexOf('?') === -1 ? '?' : '&';

      var jsonpScript = document.createElement('script');
      jsonpScript.setAttribute('src', '' + url + jsonpCallback + '=' + callbackFunction);
      if (options.charset) {
        jsonpScript.setAttribute('charset', options.charset);
      }
      jsonpScript.id = scriptId;
      document.getElementsByTagName('head')[0].appendChild(jsonpScript);

      timeoutId = setTimeout(function () {
        reject(new Error('JSONP request to ' + _url + ' timed out'));

        clearFunction(callbackFunction);
        removeScript(scriptId);
        window[callbackFunction] = function () {
          clearFunction(callbackFunction);
        };
      }, timeout);

      // Caught if got 404/500
      jsonpScript.onerror = function () {
        reject(new Error('JSONP request to ' + _url + ' failed'));

        clearFunction(callbackFunction);
        removeScript(scriptId);
        if (timeoutId) clearTimeout(timeoutId);
      };
    });
  }

  // export as global function
  /*
  let local;
  if (typeof global !== 'undefined') {
    local = global;
  } else if (typeof self !== 'undefined') {
    local = self;
  } else {
    try {
      local = Function('return this')();
    } catch (e) {
      throw new Error('polyfill failed because global object is unavailable in this environment');
    }
  }
  local.fetchJsonp = fetchJsonp;
  */

  module.exports = fetchJsonp;
});

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = makeWidget;

var _react = __webpack_require__(18);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(18);

var _utils = __webpack_require__(35);

var _mobileDetection = __webpack_require__(57);

var _widget = __webpack_require__(173);

var _widget2 = _interopRequireDefault(_widget);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultOptions = {
  mode: 'embed-widget',
  hideFooter: false,
  hideHeaders: false,
  hideScrollbars: false,
  disableSubmit: false,
  onSubmit: _utils.noop
};

var queryStringKeys = {
  mode: 'typeform-embed',
  hideFooter: 'embed-hide-footer',
  hideHeaders: 'embed-hide-headers',
  opacity: 'embed-opacity',
  disableSubmit: '__dangerous-disable-submissions'
};

function makeWidget(element, url, options) {
  options = _extends({}, defaultOptions, options);

  var enabledFullscreen = (0, _mobileDetection.isMobile)(navigator.userAgent);

  var queryStrings = (0, _utils.replaceExistingKeys)(options, queryStringKeys);

  if (enabledFullscreen) {
    queryStrings = _extends({}, (0, _utils.omit)('embed-opacity', queryStrings), {
      'add-placeholder-ws': true
    });
  }

  var urlWithQueryString = (0, _utils.appendParamsToUrl)(url, queryStrings);

  var embedId = (0, _utils.randomString)();

  (0, _reactDom.render)(_react2.default.createElement(_widget2.default, {
    embedId: embedId,
    enabledFullscreen: enabledFullscreen,
    options: options,
    url: urlWithQueryString
  }), element);
}

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(18);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(29);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = __webpack_require__(58);

var _styles2 = _interopRequireDefault(_styles);

var _mobileModal = __webpack_require__(106);

var _mobileModal2 = _interopRequireDefault(_mobileModal);

var _utils = __webpack_require__(35);

var _iframe = __webpack_require__(74);

var _iframe2 = _interopRequireDefault(_iframe);

var _dataService = __webpack_require__(107);

var _dataService2 = _interopRequireDefault(_dataService);

var _store = __webpack_require__(108);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEBOUNCE_WAIT = 200;

var WidgetWrapper = /*#__PURE__*/(0, _styles2.default)('div', {
  target: 'e12baen60'
})('height:100%;position:relative;');

var checkEmbedHash = function checkEmbedHash(embedId, event) {
  return event.detail && event.detail.embedId === embedId;
};

var PlaceholderAnimationAppear = /*#__PURE__*/(0, _styles.keyframes)('10%{opacity:1;}25%{top:0;left:0;width:100%;height:100%;opacity:1;}70%{top:0;left:0;width:100%;height:100%;opacity:1;}100%{top:0;left:0;width:100%;height:100%;opacity:0;}');

var PlaceholderAnimationDisappear = /*#__PURE__*/(0, _styles.keyframes)('100%{opacity:0;}75%{opacity:1;}25%{opacity:1;}0%{opacity:0;}');

var Placeholder = /*#__PURE__*/(0, _styles2.default)('div', {
  target: 'e12baen61'
})('position:fixed;top:', function (props) {
  return props.top;
}, 'px;left:', function (props) {
  return props.left;
}, 'px;height:', function (props) {
  return props.height ? props.height + 'px' : '100%';
}, ';width:', function (props) {
  return props.width ? props.width + 'px' : '100%';
}, ';animation:', function (props) {
  return props.open ? PlaceholderAnimationAppear : PlaceholderAnimationDisappear;
}, ' 1.5s ease;visibility:', function (props) {
  return props.visible ? 'visible' : 'hidden';
}, ';background:', function (props) {
  return props.backgroundColor;
}, ';opacity:0;pointer-events:none;');

var IframeWrapper = /*#__PURE__*/(0, _styles2.default)('div', {
  target: 'e12baen62'
})('height:100%;width:100%;overflow:hidden;background:', function (props) {
  return props.backgroundColor;
}, ';');

var Widget = function (_Component) {
  _inherits(Widget, _Component);

  function Widget(props) {
    _classCallCheck(this, Widget);

    var _this = _possibleConstructorReturn(this, (Widget.__proto__ || Object.getPrototypeOf(Widget)).call(this, props));

    _this.state = {
      isFormReady: false,
      isIframeFocused: false,
      isFullscreen: false,
      closeIconColor: 'black',
      backgroundColor: 'transparent'
    };

    _this.onFormReady = _this.onFormReady.bind(_this);
    _this.focusIframe = _this.focusIframe.bind(_this);
    _this.onFormSubmit = _this.onFormSubmit.bind(_this);
    _this.goFullScreen = _this.goFullScreen.bind(_this);
    _this.handleClose = _this.handleClose.bind(_this);
    _this.reloadIframe = _this.reloadIframe.bind(_this);
    _this.debouncedScroll = (0, _utils.debounce)(_this.focusIframe, DEBOUNCE_WAIT, _this);
    return _this;
  }

  _createClass(Widget, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      window.addEventListener('message', _utils.onMessage);
      window.addEventListener('form-ready', this.onFormReady);
      window.addEventListener('scroll', this.debouncedScroll);
      window.addEventListener('form-submit', this.onFormSubmit);
      window.addEventListener('welcome-screen-hidden', this.goFullScreen);

      var uid = _dataService2.default.getUidFromURL(this.props.url);

      _dataService2.default.getFormData(uid, _utils.DOMAIN).then(function (resp) {
        return (0, _store2.default)(uid, '', _this2.props.url, '', resp);
      }).then(function (data) {
        _this2.setState({
          closeIconColor: '#' + data.form['button-color'],
          backgroundColor: '#' + data.form['background-color']
        });
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('message', _utils.onMessage);
      window.removeEventListener('form-ready', this.onFormReady);
      window.removeEventListener('scroll', this.debouncedScroll);
      window.removeEventListener('form-submit', this.onFormSubmit);
      window.removeEventListener('welcome-screen-hidden', this.goFullScreen);
    }
  }, {
    key: 'goFullScreen',
    value: function goFullScreen(event) {
      if (!checkEmbedHash(this.props.embedId, event)) {
        return;
      }

      if (this.props.enabledFullscreen) {
        this.setState({ isFullscreen: true });

        setTimeout(this.reloadIframe, 3000);
      }
    }
  }, {
    key: 'handleClose',
    value: function handleClose() {
      this.setState({ isFullscreen: false });
    }
  }, {
    key: 'onFormReady',
    value: function onFormReady() {
      var _this3 = this;

      this.setState({
        isFormReady: true
      }, function () {
        _this3.focusIframe();
      });
    }
  }, {
    key: 'reloadIframe',
    value: function reloadIframe() {
      // Re-assign the source of the iframe, makes it reload cross-browser
      this.iframe.iframeRef.src = this.iframe.iframeRef.src;
    }
  }, {
    key: 'onFormSubmit',
    value: function onFormSubmit() {
      var options = this.props.options;

      options.onSubmit && options.onSubmit();
    }
  }, {
    key: 'focusIframe',
    value: function focusIframe() {
      if (this.props.enabledFullscreen) return;

      var iframeRef = this.iframe.iframeRef;


      if (!iframeRef || !iframeRef.contentWindow) {
        return;
      }

      var isIframeInViewport = (0, _utils.isElementInViewport)(iframeRef);
      var canPostMessage = this.state.isFormReady && !this.state.isIframeFocused && isIframeInViewport && iframeRef.contentWindow != null;

      if (canPostMessage) {
        iframeRef.contentWindow.postMessage('embed-focus', '*');
        this.setState({
          isIframeFocused: true
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _state = this.state,
          isFullscreen = _state.isFullscreen,
          closeIconColor = _state.closeIconColor,
          backgroundColor = _state.backgroundColor,
          isFormReady = _state.isFormReady;
      var enabledFullscreen = this.props.enabledFullscreen;


      var iframePosition = this.iframe && this.iframe.iframeRef.getBoundingClientRect();

      var inlineIframeUrl = (0, _utils.updateQueryStringParameter)('typeform-embed-id', this.props.embedId, this.props.url);

      if (enabledFullscreen) {
        inlineIframeUrl = (0, _utils.updateQueryStringParameter)('__dangerous-disable-submissions', 'true', inlineIframeUrl);
      }

      var fullscreenIframeUrl = (0, _utils.updateQueryStringParameter)('typeform-welcome', '0', this.props.url);

      return _react2.default.createElement(
        WidgetWrapper,
        null,
        _react2.default.createElement(
          IframeWrapper,
          {
            backgroundColor: enabledFullscreen ? backgroundColor : 'transparent'
          },
          _react2.default.createElement(_iframe2.default, {
            frameBorder: '0',
            height: '100%',
            ref: function ref(node) {
              _this4.iframe = node;
            },
            src: inlineIframeUrl,
            width: '100%'
          })
        ),
        enabledFullscreen && _react2.default.createElement(Placeholder, {
          backgroundColor: backgroundColor,
          bottom: iframePosition && iframePosition.bottom,
          height: iframePosition && iframePosition.height,
          left: iframePosition && iframePosition.left,
          open: isFullscreen,
          right: iframePosition && iframePosition.right,
          top: iframePosition && iframePosition.top,
          visible: isFormReady,
          width: iframePosition && iframePosition.width
        }),
        enabledFullscreen && _react2.default.createElement(_mobileModal2.default, {
          backgroundColor: backgroundColor,
          buttonColor: closeIconColor,
          onClose: this.handleClose,
          open: isFullscreen,
          openDelay: 0.3,
          url: fullscreenIframeUrl
        })
      );
    }
  }]);

  return Widget;
}(_react.Component);

Widget.propTypes = {
  url: _propTypes2.default.string,
  options: _propTypes2.default.object.isRequired,
  enabledFullscreen: _propTypes2.default.bool,
  embedId: _propTypes2.default.string
};

Widget.defaultProps = {
  options: {},
  enabledFullscreen: false
};

exports.default = Widget;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = makeFullScreen;

var _utils = __webpack_require__(35);

var defaultOptions = {
  mode: 'embed-fullpage',
  disableSubmit: false,
  onSubmit: _utils.noop
};

var queryStringKeys = {
  mode: 'typeform-embed',
  disableSubmit: '__dangerous-disable-submissions'
};

function makeFullScreen(iframe, url, options) {
  options = _extends({}, defaultOptions, options);

  iframe.src = (0, _utils.appendParamsToUrl)(url, (0, _utils.replaceExistingKeys)(options, queryStringKeys));

  var onFormSubmit = function onFormSubmit() {
    options.onSubmit();
  };

  (0, _utils.ensureMetaViewport)();
  (0, _utils.fixSafariScroll)(iframe);

  // Fix scroll inside the iframe (renderer v1)
  iframe.onload = function () {
    setTimeout(function () {
      iframe.style.height = '';
      (0, _utils.applyIOSFooterHack)(iframe);
      (0, _utils.applyIOSIframeResizeHack)(iframe);
    }, 1);

    iframe.contentWindow.focus();
  };

  window.addEventListener('message', _utils.onMessage);
  window.addEventListener('form-submit', onFormSubmit);
}

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(176);

__webpack_require__(373);

__webpack_require__(374);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(177);
__webpack_require__(180);
__webpack_require__(181);
__webpack_require__(182);
__webpack_require__(183);
__webpack_require__(184);
__webpack_require__(185);
__webpack_require__(186);
__webpack_require__(187);
__webpack_require__(188);
__webpack_require__(189);
__webpack_require__(190);
__webpack_require__(191);
__webpack_require__(192);
__webpack_require__(193);
__webpack_require__(194);
__webpack_require__(195);
__webpack_require__(196);
__webpack_require__(197);
__webpack_require__(198);
__webpack_require__(199);
__webpack_require__(200);
__webpack_require__(201);
__webpack_require__(202);
__webpack_require__(203);
__webpack_require__(204);
__webpack_require__(205);
__webpack_require__(206);
__webpack_require__(207);
__webpack_require__(208);
__webpack_require__(209);
__webpack_require__(210);
__webpack_require__(211);
__webpack_require__(212);
__webpack_require__(213);
__webpack_require__(214);
__webpack_require__(215);
__webpack_require__(216);
__webpack_require__(217);
__webpack_require__(218);
__webpack_require__(219);
__webpack_require__(220);
__webpack_require__(221);
__webpack_require__(222);
__webpack_require__(223);
__webpack_require__(224);
__webpack_require__(225);
__webpack_require__(226);
__webpack_require__(227);
__webpack_require__(228);
__webpack_require__(229);
__webpack_require__(230);
__webpack_require__(231);
__webpack_require__(232);
__webpack_require__(233);
__webpack_require__(234);
__webpack_require__(235);
__webpack_require__(236);
__webpack_require__(237);
__webpack_require__(238);
__webpack_require__(239);
__webpack_require__(240);
__webpack_require__(241);
__webpack_require__(242);
__webpack_require__(243);
__webpack_require__(244);
__webpack_require__(245);
__webpack_require__(246);
__webpack_require__(247);
__webpack_require__(248);
__webpack_require__(249);
__webpack_require__(250);
__webpack_require__(251);
__webpack_require__(252);
__webpack_require__(253);
__webpack_require__(254);
__webpack_require__(255);
__webpack_require__(257);
__webpack_require__(258);
__webpack_require__(260);
__webpack_require__(261);
__webpack_require__(262);
__webpack_require__(263);
__webpack_require__(264);
__webpack_require__(265);
__webpack_require__(266);
__webpack_require__(268);
__webpack_require__(269);
__webpack_require__(270);
__webpack_require__(271);
__webpack_require__(272);
__webpack_require__(273);
__webpack_require__(274);
__webpack_require__(275);
__webpack_require__(276);
__webpack_require__(277);
__webpack_require__(278);
__webpack_require__(279);
__webpack_require__(280);
__webpack_require__(95);
__webpack_require__(281);
__webpack_require__(128);
__webpack_require__(282);
__webpack_require__(129);
__webpack_require__(283);
__webpack_require__(284);
__webpack_require__(285);
__webpack_require__(286);
__webpack_require__(287);
__webpack_require__(132);
__webpack_require__(134);
__webpack_require__(135);
__webpack_require__(288);
__webpack_require__(289);
__webpack_require__(290);
__webpack_require__(291);
__webpack_require__(292);
__webpack_require__(293);
__webpack_require__(294);
__webpack_require__(295);
__webpack_require__(296);
__webpack_require__(297);
__webpack_require__(298);
__webpack_require__(299);
__webpack_require__(300);
__webpack_require__(301);
__webpack_require__(302);
__webpack_require__(303);
__webpack_require__(304);
__webpack_require__(305);
__webpack_require__(306);
__webpack_require__(307);
__webpack_require__(308);
__webpack_require__(309);
__webpack_require__(310);
__webpack_require__(311);
__webpack_require__(312);
__webpack_require__(313);
__webpack_require__(314);
__webpack_require__(315);
__webpack_require__(316);
__webpack_require__(317);
__webpack_require__(318);
__webpack_require__(319);
__webpack_require__(320);
__webpack_require__(321);
__webpack_require__(322);
__webpack_require__(323);
__webpack_require__(324);
__webpack_require__(325);
__webpack_require__(326);
__webpack_require__(327);
__webpack_require__(328);
__webpack_require__(329);
__webpack_require__(330);
__webpack_require__(331);
__webpack_require__(332);
__webpack_require__(333);
__webpack_require__(334);
__webpack_require__(335);
__webpack_require__(336);
__webpack_require__(337);
__webpack_require__(338);
__webpack_require__(339);
__webpack_require__(340);
__webpack_require__(341);
__webpack_require__(342);
__webpack_require__(343);
__webpack_require__(344);
__webpack_require__(345);
__webpack_require__(346);
__webpack_require__(347);
__webpack_require__(348);
__webpack_require__(349);
__webpack_require__(350);
__webpack_require__(351);
__webpack_require__(352);
__webpack_require__(353);
__webpack_require__(354);
__webpack_require__(355);
__webpack_require__(356);
__webpack_require__(357);
__webpack_require__(358);
__webpack_require__(359);
__webpack_require__(360);
__webpack_require__(361);
__webpack_require__(362);
__webpack_require__(363);
__webpack_require__(364);
__webpack_require__(365);
__webpack_require__(366);
__webpack_require__(367);
__webpack_require__(368);
__webpack_require__(369);
__webpack_require__(370);
__webpack_require__(371);
__webpack_require__(372);
module.exports = __webpack_require__(19);


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(2);
var has = __webpack_require__(14);
var DESCRIPTORS = __webpack_require__(7);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(12);
var META = __webpack_require__(33).KEY;
var $fails = __webpack_require__(3);
var shared = __webpack_require__(52);
var setToStringTag = __webpack_require__(47);
var uid = __webpack_require__(37);
var wks = __webpack_require__(5);
var wksExt = __webpack_require__(110);
var wksDefine = __webpack_require__(76);
var enumKeys = __webpack_require__(179);
var isArray = __webpack_require__(61);
var anObject = __webpack_require__(1);
var isObject = __webpack_require__(4);
var toIObject = __webpack_require__(15);
var toPrimitive = __webpack_require__(24);
var createDesc = __webpack_require__(36);
var _create = __webpack_require__(40);
var gOPNExt = __webpack_require__(113);
var $GOPD = __webpack_require__(16);
var $DP = __webpack_require__(8);
var $keys = __webpack_require__(38);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(41).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(54).f = $propertyIsEnumerable;
  __webpack_require__(60).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(32)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(11)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(52)('native-function-to-string', Function.toString);


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(38);
var gOPS = __webpack_require__(60);
var pIE = __webpack_require__(54);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(40) });


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(7), 'Object', { defineProperty: __webpack_require__(8).f });


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(7), 'Object', { defineProperties: __webpack_require__(112) });


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(15);
var $getOwnPropertyDescriptor = __webpack_require__(16).f;

__webpack_require__(26)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(9);
var $getPrototypeOf = __webpack_require__(17);

__webpack_require__(26)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(9);
var $keys = __webpack_require__(38);

__webpack_require__(26)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(26)('getOwnPropertyNames', function () {
  return __webpack_require__(113).f;
});


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(4);
var meta = __webpack_require__(33).onFreeze;

__webpack_require__(26)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(4);
var meta = __webpack_require__(33).onFreeze;

__webpack_require__(26)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(4);
var meta = __webpack_require__(33).onFreeze;

__webpack_require__(26)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(4);

__webpack_require__(26)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(4);

__webpack_require__(26)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(4);

__webpack_require__(26)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(0);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(114) });


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { is: __webpack_require__(115) });


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(80).set });


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(48);
var test = {};
test[__webpack_require__(5)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(12)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(0);

$export($export.P, 'Function', { bind: __webpack_require__(116) });


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(8).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(7) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(4);
var getPrototypeOf = __webpack_require__(17);
var HAS_INSTANCE = __webpack_require__(5)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(8).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(118);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(119);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(2);
var has = __webpack_require__(14);
var cof = __webpack_require__(21);
var inheritIfRequired = __webpack_require__(82);
var toPrimitive = __webpack_require__(24);
var fails = __webpack_require__(3);
var gOPN = __webpack_require__(41).f;
var gOPD = __webpack_require__(16).f;
var dP = __webpack_require__(8).f;
var $trim = __webpack_require__(49).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(40)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(7) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(12)(global, NUMBER, $Number);
}


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toInteger = __webpack_require__(22);
var aNumberValue = __webpack_require__(120);
var repeat = __webpack_require__(83);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(3)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $fails = __webpack_require__(3);
var aNumberValue = __webpack_require__(120);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(0);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(0);
var _isFinite = __webpack_require__(2).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', { isInteger: __webpack_require__(121) });


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(0);
var isInteger = __webpack_require__(121);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(119);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(118);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(0);
var log1p = __webpack_require__(122);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(0);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(0);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(0);
var sign = __webpack_require__(84);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(0);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(0);
var $expm1 = __webpack_require__(85);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { fround: __webpack_require__(123) });


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(0);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(0);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(3)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { log1p: __webpack_require__(122) });


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { sign: __webpack_require__(84) });


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(85);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(3)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(85);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toAbsoluteIndex = __webpack_require__(39);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(15);
var toLength = __webpack_require__(6);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(49)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(62)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(86)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $at = __webpack_require__(62)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(6);
var context = __webpack_require__(88);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(89)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(0);
var context = __webpack_require__(88);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(89)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(83)
});


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(6);
var context = __webpack_require__(88);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(89)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(13)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(13)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(13)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(13)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(13)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(13)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(13)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(13)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(13)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(13)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(13)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(13)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(13)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(0);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(9);
var toPrimitive = __webpack_require__(24);

$export($export.P + $export.F * __webpack_require__(3)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(0);
var toISOString = __webpack_require__(256);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(3);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(12)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(5)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(11)(proto, TO_PRIMITIVE, __webpack_require__(259));


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(1);
var toPrimitive = __webpack_require__(24);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(0);

$export($export.S, 'Array', { isArray: __webpack_require__(61) });


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(20);
var $export = __webpack_require__(0);
var toObject = __webpack_require__(9);
var call = __webpack_require__(124);
var isArrayIter = __webpack_require__(90);
var toLength = __webpack_require__(6);
var createProperty = __webpack_require__(91);
var getIterFn = __webpack_require__(92);

$export($export.S + $export.F * !__webpack_require__(64)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var createProperty = __webpack_require__(91);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(3)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(0);
var toIObject = __webpack_require__(15);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(53) != Object || !__webpack_require__(23)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var html = __webpack_require__(79);
var cof = __webpack_require__(21);
var toAbsoluteIndex = __webpack_require__(39);
var toLength = __webpack_require__(6);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(3)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var aFunction = __webpack_require__(10);
var toObject = __webpack_require__(9);
var fails = __webpack_require__(3);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(23)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $forEach = __webpack_require__(27)(0);
var STRICT = __webpack_require__(23)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(4);
var isArray = __webpack_require__(61);
var SPECIES = __webpack_require__(5)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $map = __webpack_require__(27)(1);

$export($export.P + $export.F * !__webpack_require__(23)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $filter = __webpack_require__(27)(2);

$export($export.P + $export.F * !__webpack_require__(23)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $some = __webpack_require__(27)(3);

$export($export.P + $export.F * !__webpack_require__(23)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $every = __webpack_require__(27)(4);

$export($export.P + $export.F * !__webpack_require__(23)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(125);

$export($export.P + $export.F * !__webpack_require__(23)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(125);

$export($export.P + $export.F * !__webpack_require__(23)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $indexOf = __webpack_require__(59)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(23)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(15);
var toInteger = __webpack_require__(22);
var toLength = __webpack_require__(6);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(23)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { copyWithin: __webpack_require__(126) });

__webpack_require__(34)('copyWithin');


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { fill: __webpack_require__(94) });

__webpack_require__(34)('fill');


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(27)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(34)(KEY);


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(27)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(34)(KEY);


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(42)('Array');


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var inheritIfRequired = __webpack_require__(82);
var dP = __webpack_require__(8).f;
var gOPN = __webpack_require__(41).f;
var isRegExp = __webpack_require__(63);
var $flags = __webpack_require__(55);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(7) && (!CORRECT_NEW || __webpack_require__(3)(function () {
  re2[__webpack_require__(5)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(12)(global, 'RegExp', $RegExp);
}

__webpack_require__(42)('RegExp');


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(129);
var anObject = __webpack_require__(1);
var $flags = __webpack_require__(55);
var DESCRIPTORS = __webpack_require__(7);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(12)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(3)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(1);
var toLength = __webpack_require__(6);
var advanceStringIndex = __webpack_require__(97);
var regExpExec = __webpack_require__(65);

// @@match logic
__webpack_require__(66)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(1);
var toObject = __webpack_require__(9);
var toLength = __webpack_require__(6);
var toInteger = __webpack_require__(22);
var advanceStringIndex = __webpack_require__(97);
var regExpExec = __webpack_require__(65);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(66)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(1);
var sameValue = __webpack_require__(115);
var regExpExec = __webpack_require__(65);

// @@search logic
__webpack_require__(66)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(63);
var anObject = __webpack_require__(1);
var speciesConstructor = __webpack_require__(56);
var advanceStringIndex = __webpack_require__(97);
var toLength = __webpack_require__(6);
var callRegExpExec = __webpack_require__(65);
var regexpExec = __webpack_require__(96);
var fails = __webpack_require__(3);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(66)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(32);
var global = __webpack_require__(2);
var ctx = __webpack_require__(20);
var classof = __webpack_require__(48);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(4);
var aFunction = __webpack_require__(10);
var anInstance = __webpack_require__(43);
var forOf = __webpack_require__(44);
var speciesConstructor = __webpack_require__(56);
var task = __webpack_require__(98).set;
var microtask = __webpack_require__(99)();
var newPromiseCapabilityModule = __webpack_require__(100);
var perform = __webpack_require__(130);
var userAgent = __webpack_require__(67);
var promiseResolve = __webpack_require__(131);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(5)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(45)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(47)($Promise, PROMISE);
__webpack_require__(42)(PROMISE);
Wrapper = __webpack_require__(19)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(64)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(136);
var validate = __webpack_require__(46);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(68)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $typed = __webpack_require__(69);
var buffer = __webpack_require__(101);
var anObject = __webpack_require__(1);
var toAbsoluteIndex = __webpack_require__(39);
var toLength = __webpack_require__(6);
var isObject = __webpack_require__(4);
var ArrayBuffer = __webpack_require__(2).ArrayBuffer;
var speciesConstructor = __webpack_require__(56);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(3)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(42)(ARRAY_BUFFER);


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
$export($export.G + $export.W + $export.F * !__webpack_require__(69).ABV, {
  DataView: __webpack_require__(101).DataView
});


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(30)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(30)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(30)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(30)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(30)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(30)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(30)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(30)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(30)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(10);
var anObject = __webpack_require__(1);
var rApply = (__webpack_require__(2).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(3)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(0);
var create = __webpack_require__(40);
var aFunction = __webpack_require__(10);
var anObject = __webpack_require__(1);
var isObject = __webpack_require__(4);
var fails = __webpack_require__(3);
var bind = __webpack_require__(116);
var rConstruct = (__webpack_require__(2).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(8);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(1);
var toPrimitive = __webpack_require__(24);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(3)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(0);
var gOPD = __webpack_require__(16).f;
var anObject = __webpack_require__(1);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(1);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(87)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(16);
var getPrototypeOf = __webpack_require__(17);
var has = __webpack_require__(14);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(4);
var anObject = __webpack_require__(1);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(16);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(1);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(0);
var getProto = __webpack_require__(17);
var anObject = __webpack_require__(1);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(1);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(138) });


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(1);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(8);
var gOPD = __webpack_require__(16);
var getPrototypeOf = __webpack_require__(17);
var has = __webpack_require__(14);
var $export = __webpack_require__(0);
var createDesc = __webpack_require__(36);
var anObject = __webpack_require__(1);
var isObject = __webpack_require__(4);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(0);
var setProto = __webpack_require__(80);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(0);
var $includes = __webpack_require__(59)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(34)('includes');


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(139);
var toObject = __webpack_require__(9);
var toLength = __webpack_require__(6);
var aFunction = __webpack_require__(10);
var arraySpeciesCreate = __webpack_require__(93);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(34)('flatMap');


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(139);
var toObject = __webpack_require__(9);
var toLength = __webpack_require__(6);
var toInteger = __webpack_require__(22);
var arraySpeciesCreate = __webpack_require__(93);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(34)('flatten');


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(0);
var $at = __webpack_require__(62)(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(140);
var userAgent = __webpack_require__(67);

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(140);
var userAgent = __webpack_require__(67);

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(49)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(49)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(0);
var defined = __webpack_require__(25);
var toLength = __webpack_require__(6);
var isRegExp = __webpack_require__(63);
var getFlags = __webpack_require__(55);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(87)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(76)('asyncIterator');


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(76)('observable');


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(0);
var ownKeys = __webpack_require__(138);
var toIObject = __webpack_require__(15);
var gOPD = __webpack_require__(16);
var createProperty = __webpack_require__(91);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $values = __webpack_require__(141)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $entries = __webpack_require__(141)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(9);
var aFunction = __webpack_require__(10);
var $defineProperty = __webpack_require__(8);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(7) && $export($export.P + __webpack_require__(70), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(9);
var aFunction = __webpack_require__(10);
var $defineProperty = __webpack_require__(8);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(7) && $export($export.P + __webpack_require__(70), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(9);
var toPrimitive = __webpack_require__(24);
var getPrototypeOf = __webpack_require__(17);
var getOwnPropertyDescriptor = __webpack_require__(16).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(7) && $export($export.P + __webpack_require__(70), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(9);
var toPrimitive = __webpack_require__(24);
var getPrototypeOf = __webpack_require__(17);
var getOwnPropertyDescriptor = __webpack_require__(16).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(7) && $export($export.P + __webpack_require__(70), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(142)('Map') });


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(142)('Set') });


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(71)('Map');


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(71)('Set');


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(71)('WeakMap');


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(71)('WeakSet');


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(72)('Map');


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(72)('Set');


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(72)('WeakMap');


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(72)('WeakSet');


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.G, { global: __webpack_require__(2) });


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.S, 'System', { global: __webpack_require__(2) });


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(0);
var cof = __webpack_require__(21);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var scale = __webpack_require__(144);
var fround = __webpack_require__(123);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { scale: __webpack_require__(144) });


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(0);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(0);
var core = __webpack_require__(19);
var global = __webpack_require__(2);
var speciesConstructor = __webpack_require__(56);
var promiseResolve = __webpack_require__(131);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(0);
var newPromiseCapability = __webpack_require__(100);
var perform = __webpack_require__(130);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(31);
var anObject = __webpack_require__(1);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(31);
var anObject = __webpack_require__(1);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(31);
var anObject = __webpack_require__(1);
var getPrototypeOf = __webpack_require__(17);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(134);
var from = __webpack_require__(143);
var metadata = __webpack_require__(31);
var anObject = __webpack_require__(1);
var getPrototypeOf = __webpack_require__(17);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(31);
var anObject = __webpack_require__(1);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(31);
var anObject = __webpack_require__(1);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(31);
var anObject = __webpack_require__(1);
var getPrototypeOf = __webpack_require__(17);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(31);
var anObject = __webpack_require__(1);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(31);
var anObject = __webpack_require__(1);
var aFunction = __webpack_require__(10);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(0);
var microtask = __webpack_require__(99)();
var process = __webpack_require__(2).process;
var isNode = __webpack_require__(21)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(0);
var global = __webpack_require__(2);
var core = __webpack_require__(19);
var microtask = __webpack_require__(99)();
var OBSERVABLE = __webpack_require__(5)('observable');
var aFunction = __webpack_require__(10);
var anObject = __webpack_require__(1);
var anInstance = __webpack_require__(43);
var redefineAll = __webpack_require__(45);
var hide = __webpack_require__(11);
var forOf = __webpack_require__(44);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(42)('Observable');


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(2);
var $export = __webpack_require__(0);
var userAgent = __webpack_require__(67);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $task = __webpack_require__(98);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(95);
var getKeys = __webpack_require__(38);
var redefine = __webpack_require__(12);
var global = __webpack_require__(2);
var hide = __webpack_require__(11);
var Iterators = __webpack_require__(50);
var wks = __webpack_require__(5);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(375);
module.exports = __webpack_require__(19).RegExp.escape;


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(0);
var $re = __webpack_require__(376)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 376 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ })
/******/ ]);

/***/ }),
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchCardNumbers = undefined;

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _http = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchCardNumbers = exports.fetchCardNumbers = function fetchCardNumbers(accountId) {
  return _http.http.get("/accounts/" + accountId + "/credit-cards").then(function (response) {
    var cardNumbers = _ramda2.default.pathOr([], ["data", "creditCards"], response);
    return { cardNumbers: cardNumbers, response: response };
  });
};

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchCurrencies = undefined;

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _http = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchCurrencies = exports.fetchCurrencies = function fetchCurrencies(accountId) {
  return _http.http.get("/accounts/" + accountId + "/currencies").then(function (response) {
    var currencies = _ramda2.default.pathOr([], ["data", "supported"], response);
    return { response: response, currencies: currencies };
  });
};

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchDocumentUsageDetails = exports.fetchUsageDetails = undefined;

var _http = __webpack_require__(61);

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchUsageDetails = exports.fetchUsageDetails = function fetchUsageDetails(accountId) {
  return _http.http.get("accounts/" + accountId + "?include_usage=true").then(function (response) {
    var usageDetails = _ramda2.default.pathOr([], ["data", "plan"], response);
    return usageDetails;
  });
};

var fetchDocumentUsageDetails = exports.fetchDocumentUsageDetails = function fetchDocumentUsageDetails(accountId, urlParams) {
  return _http.http.get("accounts/" + accountId + "/documents?" + urlParams).then(function (response) {
    return response.data;
  });
};

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.submitReport = exports.fetchReports = undefined;

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _http = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchReports = exports.fetchReports = function fetchReports(accountId) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 25;
  return _http.http.get("/accounts/" + accountId + "/exports?limit=" + limit).then(function (response) {
    var reports = _ramda2.default.pathOr([], ["data", "exports"], response);
    return { response: response, reports: reports };
  });
};

var submitReport = exports.submitReport = function submitReport(accountId, report) {
  return _http.http.post("accounts/" + accountId + "/exports", report);
};

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postNewPassword = exports.putUserDetails = exports.fetchUserSettings = undefined;

var _http = __webpack_require__(61);

var fetchUserSettings = exports.fetchUserSettings = function fetchUserSettings() {
  return _http.http.get("/user").then(function (response) {
    return response.data;
  });
};

var putUserDetails = exports.putUserDetails = function putUserDetails(userDetails) {
  return _http.http.put("/user", userDetails);
};

var postNewPassword = exports.postNewPassword = function postNewPassword(passwordDetails) {
  return _http.http.post("/user/password", passwordDetails);
};

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.App = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

__webpack_require__(1299);

__webpack_require__(1313);

var _routes = __webpack_require__(998);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var App = exports.App = function App(_ref) {
  var store = _ref.store;
  return _react2.default.createElement(
    _reactRedux.Provider,
    { store: store },
    _routes.routes
  );
};

App.propTypes = {
  store: _propTypes2.default.func.isRequired
};

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppHeader = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _customPropTypes = __webpack_require__(5);

var _notifications = __webpack_require__(900);

var _reactRouter = __webpack_require__(32);

var _select = __webpack_require__(45);

var _settingsModal = __webpack_require__(927);

var _keyPress = __webpack_require__(198);

var _appHeader = __webpack_require__(1298);

var _appHeader2 = _interopRequireDefault(_appHeader);

var _squirrelstreetLogoHeader = __webpack_require__(1399);

var _squirrelstreetLogoHeader2 = _interopRequireDefault(_squirrelstreetLogoHeader);

var _cog = __webpack_require__(1008);

var _cog2 = _interopRequireDefault(_cog);

var _bellO = __webpack_require__(1006);

var _bellO2 = _interopRequireDefault(_bellO);

var _search = __webpack_require__(277);

var _search2 = _interopRequireDefault(_search);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AppHeader = exports.AppHeader = function AppHeader(_ref) {
  var user = _ref.user,
      accounts = _ref.accounts,
      exportFailedCount = _ref.exportFailedCount,
      isNotificationsMode = _ref.isNotificationsMode,
      isNotificationsViewed = _ref.isNotificationsViewed,
      isSettingsMode = _ref.isSettingsMode,
      location = _ref.location,
      onAddSearchQuery = _ref.onAddSearchQuery,
      onChangeSelectedAccount = _ref.onChangeSelectedAccount,
      onEndNotificationsMode = _ref.onEndNotificationsMode,
      onEndSettingsMode = _ref.onEndSettingsMode,
      onLogout = _ref.onLogout,
      onStartNotificationsMode = _ref.onStartNotificationsMode,
      onStartSettingsMode = _ref.onStartSettingsMode,
      onUpdateSearchQuery = _ref.onUpdateSearchQuery,
      pendingDocuments = _ref.pendingDocuments,
      queuedCount = _ref.queuedCount,
      searchQueryString = _ref.searchQueryString,
      selectedAccount = _ref.selectedAccount;

  var notificationsLength = pendingDocuments.length + queuedCount + exportFailedCount;
  var onSearch = function onSearch(query) {
    if (location.pathname === "/accounts/" + selectedAccount.slug + "/documents/all") {
      return onAddSearchQuery(query);
    }
    _reactRouter.browserHistory.push("/accounts/" + selectedAccount.slug + "/documents/all");
    return onAddSearchQuery(query);
  };
  return _react2.default.createElement(
    "div",
    { className: _appHeader2.default.container },
    renderBetaBanner(),
    _react2.default.createElement(
      "div",
      { className: _appHeader2.default.content },
      _react2.default.createElement("img", { alt: "Squirrel Street logo", className: _appHeader2.default.logo, src: _squirrelstreetLogoHeader2.default }),
      navigationPanel(selectedAccount, pendingDocuments.length),
      _react2.default.createElement(
        "div",
        { className: _appHeader2.default["account-details"] },
        _react2.default.createElement(
          "div",
          { className: _appHeader2.default.search },
          _react2.default.createElement("input", {
            className: _appHeader2.default.fields,
            onChange: function onChange(e) {
              return onUpdateSearchQuery(e.target.value);
            },
            onKeyDown: function onKeyDown(e) {
              return (0, _keyPress.onHeaderSearch)(e, searchQueryString, onAddSearchQuery, selectedAccount, location);
            },
            placeholder: "Search...",
            value: searchQueryString
          }),
          _react2.default.createElement(_search2.default, { className: _appHeader2.default["search-button"], onClick: function onClick() {
              return onSearch(searchQueryString);
            } })
        ),
        _react2.default.createElement(
          "div",
          {
            className: renderNotificationsStyle(isNotificationsViewed, notificationsLength),
            onClick: onStartNotificationsMode
          },
          _react2.default.createElement(_bellO2.default, { size: 15 })
        ),
        _react2.default.createElement(_notifications.Notifications, {
          accountSlug: selectedAccount.slug,
          exportFailedCount: exportFailedCount,
          isNotificationsMode: isNotificationsMode,
          onEndNotificationsMode: onEndNotificationsMode,
          pendingDocumentsCount: pendingDocuments.length,
          queuedCount: queuedCount
        }),
        _react2.default.createElement(
          "div",
          { className: _appHeader2.default.dropdown + " overview6", onClick: onStartSettingsMode },
          user.firstName,
          " ",
          user.lastName,
          " \xA0",
          _react2.default.createElement(_cog2.default, { size: 15 })
        ),
        _react2.default.createElement(_settingsModal.SettingsModal, {
          isSettingsMode: isSettingsMode,
          onEndSettingsMode: onEndSettingsMode,
          onLogout: onLogout,
          selectedAccount: selectedAccount
        }),
        renderSelectContainer(accounts, onChangeSelectedAccount, selectedAccount)
      )
    )
  );
};

AppHeader.propTypes = {
  accounts: _propTypes2.default.arrayOf(_customPropTypes.accountType).isRequired,
  exportFailedCount: _propTypes2.default.number.isRequired,
  isNotificationsMode: _propTypes2.default.bool.isRequired,
  isNotificationsViewed: _propTypes2.default.bool.isRequired,
  isSettingsMode: _propTypes2.default.bool.isRequired,
  location: _customPropTypes.locationType.isRequired,
  onAddSearchQuery: _propTypes2.default.func.isRequired,
  onChangeSelectedAccount: _propTypes2.default.func.isRequired, // (string) => void
  onEndNotificationsMode: _propTypes2.default.func.isRequired,
  onEndSettingsMode: _propTypes2.default.func.isRequired,
  onLogout: _propTypes2.default.func.isRequired, // () => void
  onStartNotificationsMode: _propTypes2.default.func.isRequired,
  onStartSettingsMode: _propTypes2.default.func.isRequired,
  onUpdateSearchQuery: _propTypes2.default.func.isRequired,
  pendingDocuments: _propTypes2.default.arrayOf(_customPropTypes.documentPropType).isRequired,
  queuedCount: _propTypes2.default.number.isRequired,
  searchQueryString: _propTypes2.default.string.isRequired,
  selectedAccount: _customPropTypes.accountType.isRequired,
  user: _customPropTypes.userType.isRequired
};

var navigationPanel = function navigationPanel(selectedAccount, pendingDocumentsCount) {
  return _react2.default.createElement(
    "div",
    { className: _appHeader2.default["navigation-panel__container"] },
    _react2.default.createElement(
      "ul",
      null,
      _react2.default.createElement(
        "li",
        null,
        _react2.default.createElement(
          _reactRouter.Link,
          {
            activeClassName: _appHeader2.default["navigation-panel__selected"],
            className: "overview1",
            to: "/accounts/" + selectedAccount.slug + "/dashboard"
          },
          "Dashboard"
        )
      ),
      _react2.default.createElement(
        "li",
        null,
        _react2.default.createElement(
          _reactRouter.Link,
          {
            activeClassName: _appHeader2.default["navigation-panel__selected"],
            className: "overview2 upload1 manual1",
            to: "/accounts/" + selectedAccount.slug + "/upload"
          },
          "Submit ",
          renderPendingCount(pendingDocumentsCount)
        )
      ),
      _react2.default.createElement(
        "li",
        null,
        _react2.default.createElement(
          _reactRouter.Link,
          {
            activeClassName: _appHeader2.default["navigation-panel__selected"],
            className: "overview3 documents1",
            to: "/accounts/" + selectedAccount.slug + "/documents"
          },
          "View and export"
        )
      ),
      _react2.default.createElement(
        "li",
        null,
        _react2.default.createElement(
          _reactRouter.Link,
          {
            activeClassName: _appHeader2.default["navigation-panel__selected"],
            className: "overview4 automate1",
            to: "/accounts/" + selectedAccount.slug + "/automate"
          },
          "Automate"
        )
      ),
      _react2.default.createElement(
        "li",
        null,
        _react2.default.createElement(
          _reactRouter.Link,
          {
            activeClassName: _appHeader2.default["navigation-panel__selected"],
            className: "overview5",
            to: "/accounts/" + selectedAccount.slug + "/reports"
          },
          "Report"
        )
      )
    )
  );
};

var mapAccounts = function mapAccounts(accounts) {
  return accounts.map(accountMapper);
};
var accountMapper = function accountMapper(account) {
  return { key: account.id, name: account.label, info: account.slug };
};

var renderSelectContainer = function renderSelectContainer(accounts, onChangeSelectedAccount, selectedAccount) {
  if (accounts.length === 1) {
    return null;
  }
  return _react2.default.createElement(
    "div",
    { className: _appHeader2.default["select-container"] },
    _react2.default.createElement(_select.Select, {
      data: mapAccounts(accounts),
      onChange: function onChange(item) {
        onChangeSelectedAccount(item.key, item.info);
      },
      value: accountMapper(selectedAccount)
    })
  );
};

var renderPendingCount = function renderPendingCount(pendingDocumentsCount) {
  if (pendingDocumentsCount === 0) {
    return null;
  }
  return "(" + pendingDocumentsCount + ")";
};

var renderNotificationsStyle = function renderNotificationsStyle(isNotificationsViewed, notificationsLength) {
  if (!isNotificationsViewed && notificationsLength > 0) {
    return _appHeader2.default.unviewed + " " + _appHeader2.default["notifications-button"];
  }
  return _appHeader2.default["notifications-button"];
};

var renderBetaBanner = function renderBetaBanner() {
  if (true) {
    return _react2.default.createElement("div", { className: _appHeader2.default["beta-banner"] });
  }
  return null;
};

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColumnsEditor = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _columnsEditor = __webpack_require__(1302);

var _columnsEditor2 = _interopRequireDefault(_columnsEditor);

var _grid = __webpack_require__(95);

var _grid2 = _interopRequireDefault(_grid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ColumnsEditor = exports.ColumnsEditor = function ColumnsEditor(_ref) {
  var columns = _ref.columns,
      onToggle = _ref.onToggle;
  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      "h4",
      { className: _columnsEditor2.default.title },
      "Toggle column visibility"
    ),
    _react2.default.createElement(
      "div",
      { className: _columnsEditor2.default["selection-container"] },
      columns.map(function (column) {
        return renderColumn(column, onToggle);
      })
    )
  );
};

var columnType = _propTypes2.default.shape({
  key: _propTypes2.default.string,
  name: _propTypes2.default.string,
  visible: _propTypes2.default.bool
});

ColumnsEditor.propTypes = {
  columns: _propTypes2.default.arrayOf(columnType).isRequired,
  onToggle: _propTypes2.default.func.isRequired // (string) => void
};

var renderColumn = function renderColumn(column, onToggle) {
  return _react2.default.createElement(
    "div",
    { className: _grid2.default["col-md-4"] + " " + _columnsEditor2.default.cell, key: "column-container-" + column.name },
    _react2.default.createElement("input", {
      checked: column.visible,
      id: "column-" + column.key,
      onChange: function onChange() {
        return onToggle(column.key);
      },
      type: "checkbox"
    }),
    _react2.default.createElement(
      "label",
      { htmlFor: "column-" + column.key },
      column.name
    )
  );
};

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditColumnsModal = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _editColumnsModal = __webpack_require__(509);

var _editColumnsModal2 = _interopRequireDefault(_editColumnsModal);

var _modal = __webpack_require__(27);

var _button = __webpack_require__(7);

var _columnsEditor = __webpack_require__(843);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditColumnsModal = exports.EditColumnsModal = function EditColumnsModal(_ref) {
  var isEditColumnsVisible = _ref.isEditColumnsVisible,
      columns = _ref.columns,
      onClose = _ref.onClose,
      onReturnToDefaultColumns = _ref.onReturnToDefaultColumns,
      onToggleColumn = _ref.onToggleColumn;
  return _react2.default.createElement(
    _modal.Modal,
    {
      isVisible: isEditColumnsVisible,
      onClose: onClose,
      transitionName: "edit-documents-columns"
    },
    _react2.default.createElement(_columnsEditor.ColumnsEditor, { columns: columns, onToggle: onToggleColumn }),
    _react2.default.createElement(
      "div",
      { className: _editColumnsModal2.default.actions },
      _react2.default.createElement(
        _button.Button,
        { link: true, onClick: onReturnToDefaultColumns },
        "Return to defaults"
      ),
      _react2.default.createElement(
        _button.Button,
        { onClick: onClose, primary: true },
        "Done"
      )
    )
  );
};

EditColumnsModal.propTypes = {
  columns: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  isEditColumnsVisible: _propTypes2.default.bool.isRequired,
  onClose: _propTypes2.default.func.isRequired,
  onReturnToDefaultColumns: _propTypes2.default.func.isRequired,
  onToggleColumn: _propTypes2.default.func.isRequired
};

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlashMessage = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _flashMessage = __webpack_require__(1306);

var _flashMessage2 = _interopRequireDefault(_flashMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FlashMessage = exports.FlashMessage = function FlashMessage(_ref) {
  var message = _ref.message,
      type = _ref.type,
      onHide = _ref.onHide;

  if (message === "" || message === null || message === undefined) {
    return null;
  }

  return _react2.default.createElement(
    "div",
    { className: cssClass(type) },
    message,
    delayHide(onHide)
  );
};

FlashMessage.propTypes = {
  message: _propTypes2.default.string,
  onHide: _propTypes2.default.func.isRequired,
  type: _propTypes2.default.oneOf(["success", "error"])
};

FlashMessage.defaultProps = {
  message: null,
  type: "success"
};

var delayHide = function delayHide(onHide) {
  setTimeout(function () {
    onHide();
  }, 4000);
  return null;
};

var cssClass = function cssClass(type) {
  return _flashMessage2.default["container--" + type];
};

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ItemBox = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _itemBox = __webpack_require__(1308);

var _itemBox2 = _interopRequireDefault(_itemBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemBox = exports.ItemBox = function ItemBox(_ref) {
  var denominator = _ref.denominator,
      info = _ref.info,
      number = _ref.number;
  return _react2.default.createElement(
    "div",
    { className: _itemBox2.default.container },
    _react2.default.createElement(
      "div",
      { className: _itemBox2.default.text },
      numberSize(number),
      renderDenominator(denominator),
      _react2.default.createElement(
        "div",
        null,
        info
      )
    )
  );
};

ItemBox.propTypes = {
  denominator: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]).isRequired,
  info: _propTypes2.default.string.isRequired,
  number: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired
};

var renderDenominator = function renderDenominator(denominator) {
  if (denominator) {
    return _react2.default.createElement(
      "span",
      { className: _itemBox2.default.denominator },
      " / ",
      denominator
    );
  }
  return null;
};

var numberSize = function numberSize(number) {
  if (number.length > 5) {
    return _react2.default.createElement(
      "h1",
      { className: _itemBox2.default.small },
      number
    );
  }
  return _react2.default.createElement(
    "h1",
    null,
    number
  );
};

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioTab = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _customPropTypes = __webpack_require__(5);

var _radioTab = __webpack_require__(1312);

var _radioTab2 = _interopRequireDefault(_radioTab);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RadioTab = exports.RadioTab = function RadioTab(_ref) {
  var onChange = _ref.onChange,
      options = _ref.options,
      selectedOptionKey = _ref.selectedOptionKey;
  return _react2.default.createElement(
    "div",
    { className: _radioTab2.default.container },
    options.map(renderOption(onChange, selectedOptionKey))
  );
};

RadioTab.propTypes = {
  onChange: _propTypes2.default.func.isRequired, // (selectOptionType) => void
  options: _propTypes2.default.arrayOf(_customPropTypes.selectOptionType).isRequired,
  selectedOptionKey: _propTypes2.default.string
};

RadioTab.defaultProps = {
  selectedOptionKey: null
};

var renderOption = function renderOption(onChange, selectedOptionKey) {
  return function (option) {
    return _react2.default.createElement(Option, {
      data: option,
      key: option.key,
      onClick: onChange,
      selected: option.key === selectedOptionKey
    });
  };
};

var Option = function Option(_ref2) {
  var data = _ref2.data,
      _onClick = _ref2.onClick,
      selected = _ref2.selected;
  return _react2.default.createElement(
    "div",
    {
      className: selected ? _radioTab2.default.option + " " + _radioTab2.default["option--selected"] : _radioTab2.default.option,
      onClick: function onClick() {
        return _onClick(data);
      }
    },
    data.name
  );
};

Option.propTypes = {
  data: _customPropTypes.selectOptionType.isRequired,
  onClick: _propTypes2.default.func.isRequired,
  selected: _propTypes2.default.bool.isRequired
};

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextField = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _removeButton = __webpack_require__(1395);

var _removeButton2 = _interopRequireDefault(_removeButton);

var _textField = __webpack_require__(1314);

var _textField2 = _interopRequireDefault(_textField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextField = exports.TextField = function TextField(_ref) {
  var disabled = _ref.disabled,
      _onChange = _ref.onChange,
      onClear = _ref.onClear,
      placeholder = _ref.placeholder,
      type = _ref.type,
      value = _ref.value;
  return _react2.default.createElement(
    "div",
    { className: _textField2.default.container },
    _react2.default.createElement("input", {
      className: classNames(onClear),
      disabled: disabled,
      onChange: function onChange(e) {
        return _onChange(e.target.value);
      },
      placeholder: placeholder,
      type: type,
      value: value
    }),
    onClear && value.length > 0 ? renderClearButton(onClear) : null
  );
};

TextField.propTypes = {
  disabled: _propTypes2.default.bool,
  onChange: _propTypes2.default.func.isRequired, // (string) => void
  onClear: _propTypes2.default.func, // () => void
  placeholder: _propTypes2.default.string,
  type: _propTypes2.default.string,
  value: _propTypes2.default.string.isRequired
};

TextField.defaultProps = {
  disabled: false,
  onClear: undefined,
  placeholder: null,
  type: "text"
};

var classNames = function classNames(onClear) {
  if (onClear) {
    return _textField2.default.input + " " + _textField2.default["input--clearable"];
  }
  return _textField2.default.input;
};

var renderClearButton = function renderClearButton(onClear) {
  return _react2.default.createElement("img", {
    alt: "Clear",
    className: _textField2.default["clear-button"],
    height: 16,
    onClick: onClear,
    src: _removeButton2.default,
    width: 16
  });
};

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnknownErrorMessage = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(32);

var _unknownErrorMessage = __webpack_require__(1315);

var _unknownErrorMessage2 = _interopRequireDefault(_unknownErrorMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UnknownErrorMessage = exports.UnknownErrorMessage = function UnknownErrorMessage(_ref) {
  var accountSlug = _ref.accountSlug,
      isGlobalError = _ref.isGlobalError,
      onEndGlobalError = _ref.onEndGlobalError;

  var isErrorSpecific = !isGlobalError;
  if (isErrorSpecific) {
    return null;
  }
  return _react2.default.createElement(
    "div",
    { className: _unknownErrorMessage2.default.container },
    _react2.default.createElement(
      "div",
      { className: _unknownErrorMessage2.default.inner },
      _react2.default.createElement(
        "span",
        { className: _unknownErrorMessage2.default.close, onClick: onEndGlobalError },
        "+"
      ),
      _react2.default.createElement(
        "h2",
        null,
        "Oh no... an error has occurred"
      ),
      _react2.default.createElement(
        "div",
        { className: _unknownErrorMessage2.default["five-hundred"] },
        "500"
      ),
      _react2.default.createElement(
        "p",
        null,
        "Please try ",
        _react2.default.createElement(
          "a",
          { href: "/" },
          "reloading the page"
        ),
        " in a few moments."
      ),
      _react2.default.createElement(
        "p",
        null,
        "Please ",
        _react2.default.createElement(
          _reactRouter.Link,
          { to: "/accounts/" + accountSlug + "/issue-tracking-form" },
          "report this issue"
        ),
        "\xA0and/or contact us at \xA0",
        _react2.default.createElement(
          "a",
          { href: "mailto:help@squirrelstreet.com" },
          "help@squirrelstreet.com"
        )
      )
    )
  );
};

UnknownErrorMessage.propTypes = {
  accountSlug: _propTypes2.default.string.isRequired,
  isGlobalError: _propTypes2.default.bool.isRequired,
  onEndGlobalError: _propTypes2.default.func.isRequired
};

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dashboard = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dashboard = __webpack_require__(322);

var _dashboard2 = _interopRequireDefault(_dashboard);

var _tourMenu = __webpack_require__(935);

var _noUsageDashboard = __webpack_require__(851);

var _usageDashboard = __webpack_require__(852);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Dashboard = exports.Dashboard = function Dashboard(props) {
  return _react2.default.createElement(
    "div",
    { className: _dashboard2.default.container },
    _react2.default.createElement(
      "div",
      { className: _dashboard2.default.dashboard },
      _react2.default.createElement(Usage, props),
      _react2.default.createElement(_tourMenu.TourMenu, props)
    )
  );
};

Dashboard.propTypes = {
  onStartTour: _propTypes2.default.func.isRequired
};

var Usage = function Usage(props) {
  if (props.totalCount === 0) {
    return _react2.default.createElement(_noUsageDashboard.NoUsageDashboard, { name: props.name });
  }
  return _react2.default.createElement(_usageDashboard.UsageDashboard, props);
};

Usage.propTypes = {
  name: _propTypes2.default.string.isRequired,
  totalCount: _propTypes2.default.number.isRequired
};

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoUsageDashboard = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _appStoreLogo = __webpack_require__(1387);

var _appStoreLogo2 = _interopRequireDefault(_appStoreLogo);

var _dashboard = __webpack_require__(322);

var _dashboard2 = _interopRequireDefault(_dashboard);

var _button = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NoUsageDashboard = exports.NoUsageDashboard = function NoUsageDashboard(_ref) {
  var name = _ref.name;
  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      "h1",
      null,
      "Hey there ",
      name,
      "!"
    ),
    _react2.default.createElement(
      "div",
      { className: _dashboard2.default["usage-container"] },
      _react2.default.createElement(
        "h1",
        null,
        "It looks like you haven't uploaded anything yet!"
      ),
      _react2.default.createElement(
        "div",
        { className: _dashboard2.default.upload },
        _react2.default.createElement(
          _button.Button,
          { primary: true },
          "Click here to upload a document"
        )
      ),
      _react2.default.createElement(
        "h2",
        null,
        "Or download our iPhone app:"
      ),
      _react2.default.createElement(
        "a",
        {
          href: "https://itunes.apple.com/au/app/shoeboxed-australia-document/id1044924996?mt=8",
          rel: "noopener noreferrer",
          target: "_blank"
        },
        _react2.default.createElement("img", { alt: "app store logo", src: _appStoreLogo2.default })
      )
    )
  );
};

NoUsageDashboard.propTypes = {
  name: _propTypes2.default.string.isRequired
};

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UsageDashboard = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dashboard = __webpack_require__(322);

var _dashboard2 = _interopRequireDefault(_dashboard);

var _itemBox = __webpack_require__(846);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UsageDashboard = exports.UsageDashboard = function UsageDashboard(props) {
  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      "h1",
      null,
      "Hey there ",
      props.name,
      "!"
    ),
    _react2.default.createElement(
      "div",
      { className: _dashboard2.default["usage-container"] },
      _react2.default.createElement(
        "h2",
        null,
        "This Months Usage:"
      ),
      _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(_itemBox.ItemBox, {
          denominator: false,
          info: "Documents processing",
          number: props.pendingDocumentCount
        }),
        _react2.default.createElement(_itemBox.ItemBox, {
          denominator: props.documentLimit,
          info: "Documents",
          number: props.documentCount
        }),
        _react2.default.createElement(_itemBox.ItemBox, {
          denominator: props.envelopeLimit,
          info: "Envelopes",
          number: props.envelopeCount
        })
      ),
      _react2.default.createElement("div", { className: _dashboard2.default.ruler }),
      _react2.default.createElement(
        "h2",
        null,
        "Totals:"
      ),
      _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(_itemBox.ItemBox, {
          denominator: false,
          info: "Total Documents",
          number: props.totalCount
        }),
        _react2.default.createElement(_itemBox.ItemBox, {
          denominator: false,
          info: "Total Document Value",
          number: "$" + props.totalSumFiltered
        }),
        _react2.default.createElement(_itemBox.ItemBox, {
          denominator: false,
          info: "Number of Vendors",
          number: props.vendorsCount
        })
      )
    )
  );
};

UsageDashboard.propTypes = {
  documentCount: _propTypes2.default.number.isRequired,
  documentLimit: _propTypes2.default.number.isRequired,
  envelopeCount: _propTypes2.default.number.isRequired,
  envelopeLimit: _propTypes2.default.number.isRequired,
  name: _propTypes2.default.string.isRequired,
  pendingDocumentCount: _propTypes2.default.number.isRequired,
  totalCount: _propTypes2.default.number.isRequired,
  totalSumFiltered: _propTypes2.default.string.isRequired,
  vendorsCount: _propTypes2.default.number.isRequired
};

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomTabFilters = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _customTabFilters = __webpack_require__(1320);

var _customTabFilters2 = _interopRequireDefault(_customTabFilters);

var _search = __webpack_require__(277);

var _search2 = _interopRequireDefault(_search);

var _customPropTypes = __webpack_require__(5);

var _keyPress = __webpack_require__(198);

var _filterCounter = __webpack_require__(440);

var _validators = __webpack_require__(36);

var _select = __webpack_require__(45);

var _button = __webpack_require__(7);

var _dateRange = __webpack_require__(419);

var _paymentTypeFilterField = __webpack_require__(429);

var _exportTypeSelector = __webpack_require__(268);

var _documentTypeSelector = __webpack_require__(428);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomTabFilters = exports.CustomTabFilters = function CustomTabFilters(_ref) {
  var accountId = _ref.accountId,
      cardNumbers = _ref.cardNumbers,
      categories = _ref.categories,
      currencies = _ref.currencies,
      customTabName = _ref.customTabName,
      endDate = _ref.endDate,
      envelopes = _ref.envelopes,
      filters = _ref.filters,
      isCreateCustomTabLoading = _ref.isCreateCustomTabLoading,
      lastFourDigits = _ref.lastFourDigits,
      onAddCardNumber = _ref.onAddCardNumber,
      onAddCategory = _ref.onAddCategory,
      onAddCurrency = _ref.onAddCurrency,
      onAddDocumentType = _ref.onAddDocumentType,
      onAddEndDate = _ref.onAddEndDate,
      onAddEnvelope = _ref.onAddEnvelope,
      onAddSearchQuery = _ref.onAddSearchQuery,
      onAddPaymentType = _ref.onAddPaymentType,
      onAddStartDate = _ref.onAddStartDate,
      onAddVendor = _ref.onAddVendor,
      onAddViewedStatus = _ref.onAddViewedStatus,
      onCreateCustomTab = _ref.onCreateCustomTab,
      onSetExportType = _ref.onSetExportType,
      onUpdateCustomTabName = _ref.onUpdateCustomTabName,
      onUpdateSearchQuery = _ref.onUpdateSearchQuery,
      preferredCurrency = _ref.preferredCurrency,
      searchQueryString = _ref.searchQueryString,
      selectedPaymentTypes = _ref.selectedPaymentTypes,
      startDate = _ref.startDate,
      vendors = _ref.vendors;
  return _react2.default.createElement(
    "div",
    { className: _customTabFilters2.default.container },
    _react2.default.createElement(
      "div",
      { className: _customTabFilters2.default.action },
      _react2.default.createElement(
        _button.Button,
        {
          disabled: (0, _filterCounter.filterCounter)(filters) === 0 || !(0, _validators.isValidValue)(customTabName),
          loading: isCreateCustomTabLoading,
          onClick: function onClick() {
            return onCreateCustomTab(accountId, filters, customTabName);
          },
          primary: true
        },
        "Create tab"
      )
    ),
    _react2.default.createElement(
      "h3",
      null,
      "Create a custom documents tab!"
    ),
    _react2.default.createElement(
      "h4",
      null,
      "Choose a name for your custom tab:"
    ),
    _react2.default.createElement(
      "div",
      { className: _customTabFilters2.default["field-cell"] },
      _react2.default.createElement("input", {
        className: _customTabFilters2.default["input-field"],
        onChange: function onChange(e) {
          return onUpdateCustomTabName(e.target.value);
        },
        placeholder: "E.g. Other Documents",
        value: customTabName
      })
    ),
    _react2.default.createElement(
      "h4",
      null,
      "Choose the default filters for your custom tab:"
    ),
    _react2.default.createElement(
      "div",
      { className: _customTabFilters2.default["field-cell"] },
      _react2.default.createElement(_documentTypeSelector.DocumentTypeSelector, { onChange: onAddDocumentType })
    ),
    _react2.default.createElement(
      "div",
      { className: _customTabFilters2.default["field-cell"] },
      _react2.default.createElement(
        "span",
        null,
        "Vendor"
      ),
      _react2.default.createElement(_select.Select, { data: mapVendors(vendors), onChange: onAddVendor, placeholder: "Select a vendor..." })
    ),
    _react2.default.createElement(
      "div",
      { className: _customTabFilters2.default["field-cell"] },
      _react2.default.createElement(
        "span",
        null,
        "Category"
      ),
      _react2.default.createElement(_select.Select, { data: mapCategories(categories), onChange: onAddCategory, placeholder: "Select a category..." })
    ),
    _react2.default.createElement(
      "div",
      { className: _customTabFilters2.default["field-cell"] },
      _react2.default.createElement(
        "span",
        null,
        "Date Range"
      ),
      _react2.default.createElement(_dateRange.DateRange, {
        currency: preferredCurrency,
        endDate: endDate,
        onAddEndDate: onAddEndDate,
        onAddStartDate: onAddStartDate,
        startDate: startDate
      })
    ),
    _react2.default.createElement(
      "div",
      { className: _customTabFilters2.default["field-cell"] },
      _react2.default.createElement(
        "span",
        null,
        "Envelope"
      ),
      _react2.default.createElement(_select.Select, {
        data: mapEnvelopes(envelopes),
        onChange: onAddEnvelope,
        placeholder: "Select an envelope..."
      })
    ),
    _react2.default.createElement(
      "div",
      { className: _customTabFilters2.default["field-cell"] },
      _react2.default.createElement(
        "span",
        null,
        "Currency"
      ),
      _react2.default.createElement(_select.SimpleSelect, {
        data: mapCurrencies(currencies),
        onChange: onAddCurrency,
        placeholder: "Select a currency..."
      })
    ),
    _react2.default.createElement(
      "div",
      { className: _customTabFilters2.default["field-cell"] },
      _react2.default.createElement(
        "span",
        null,
        "Viewed"
      ),
      _react2.default.createElement(_select.SimpleSelect, {
        data: viewedArray,
        onChange: onAddViewedStatus,
        placeholder: "Select viewed status..."
      })
    ),
    _react2.default.createElement(
      "div",
      { className: _customTabFilters2.default["field-cell"] },
      _react2.default.createElement(
        "span",
        null,
        "Search"
      ),
      _react2.default.createElement(
        "div",
        { className: _customTabFilters2.default.search },
        _react2.default.createElement("input", {
          className: _customTabFilters2.default["search-field"],
          onChange: function onChange(e) {
            return onUpdateSearchQuery(e.target.value);
          },
          onKeyDown: function onKeyDown(e) {
            return (0, _keyPress.onEnterPressed)(e, searchQueryString, onAddSearchQuery);
          },
          placeholder: "Search for documents here",
          value: searchQueryString
        }),
        _react2.default.createElement(_search2.default, { className: _customTabFilters2.default["search-button"] })
      )
    ),
    _react2.default.createElement(
      "div",
      { className: _customTabFilters2.default["field-cell"] },
      _react2.default.createElement(
        "span",
        null,
        "Export Type"
      ),
      _react2.default.createElement(_exportTypeSelector.ExportTypeSelector, { categories: categories, onChange: onSetExportType })
    ),
    _react2.default.createElement(
      "div",
      { className: _customTabFilters2.default["field-cell"] + " " + _customTabFilters2.default["payment-type-container"] },
      _react2.default.createElement(
        "div",
        { className: _customTabFilters2.default["payment-type"] },
        _react2.default.createElement(_paymentTypeFilterField.PaymentTypeFilterField, {
          cardNumbers: cardNumbers,
          lastFourDigits: lastFourDigits,
          onAddCardNumber: onAddCardNumber,
          onAddPaymentType: onAddPaymentType,
          selectedPaymentTypes: selectedPaymentTypes
        })
      )
    )
  );
};

CustomTabFilters.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  cardNumbers: _propTypes2.default.arrayOf(_customPropTypes.cardNumberType).isRequired,
  categories: _propTypes2.default.arrayOf(_customPropTypes.categoryType).isRequired,
  currencies: _propTypes2.default.arrayOf(_customPropTypes.currencyType).isRequired,
  customTabName: _propTypes2.default.string.isRequired,
  endDate: _customPropTypes.momentType,
  envelopes: _propTypes2.default.arrayOf(_customPropTypes.envelopeType).isRequired,
  filters: _customPropTypes.documentFiltersType.isRequired,
  isCreateCustomTabLoading: _propTypes2.default.bool.isRequired,
  lastFourDigits: _propTypes2.default.string,
  onAddCardNumber: _propTypes2.default.func.isRequired, // (string) => void
  onAddCategory: _propTypes2.default.func.isRequired, // ({ key: string, name: string }) => void
  onAddCurrency: _propTypes2.default.func.isRequired, // ({ key: string, name: string }) => void
  onAddDocumentType: _propTypes2.default.func.isRequired,
  onAddEndDate: _propTypes2.default.func.isRequired,
  onAddEnvelope: _propTypes2.default.func.isRequired, // ({ key: string, name: string }) => void
  onAddPaymentType: _propTypes2.default.func.isRequired, // ({ key: string, name: string }) => void
  onAddSearchQuery: _propTypes2.default.func.isRequired,
  onAddStartDate: _propTypes2.default.func.isRequired,
  onAddVendor: _propTypes2.default.func.isRequired, // ({key: string, name: string}) => void
  onAddViewedStatus: _propTypes2.default.func.isRequired,
  onCreateCustomTab: _propTypes2.default.func.isRequired,
  onSetExportType: _propTypes2.default.func.isRequired, // (string) => void
  onUpdateCustomTabName: _propTypes2.default.func.isRequired,
  onUpdateSearchQuery: _propTypes2.default.func.isRequired,
  preferredCurrency: _propTypes2.default.string.isRequired,
  searchQueryString: _propTypes2.default.string.isRequired,
  selectedPaymentTypes: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  startDate: _customPropTypes.momentType,
  vendors: _propTypes2.default.arrayOf(_customPropTypes.vendorType).isRequired
};

CustomTabFilters.defaultProps = {
  endDate: null,
  exportType: null,
  lastFourDigits: null,
  selectedSearchQueryString: null,
  startDate: null,
  type: null
};

var mapEnvelopes = function mapEnvelopes(envelopes) {
  return envelopes.map(function (envelope) {
    return { key: envelope.code, name: envelope.code };
  });
};
var mapCategories = function mapCategories(categories) {
  return categories.map(function (category) {
    return { key: category.name, name: category.name };
  });
};
var mapCurrencies = function mapCurrencies(currencies) {
  return currencies.map(function (currency) {
    return { key: currency.code, name: currency.code };
  });
};
var mapVendors = function mapVendors(vendors) {
  return vendors.map(function (vendor) {
    return { key: vendor.name, name: vendor.name };
  });
};

var viewedArray = [{
  key: "viewed",
  name: "Viewed"
}, {
  key: "unviewed",
  name: "Unviewed"
}];

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomTab = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _customPropTypes = __webpack_require__(5);

var _customTab = __webpack_require__(1321);

var _customTab2 = _interopRequireDefault(_customTab);

var _documentsInlineTabs = __webpack_require__(425);

var _customTabFilters = __webpack_require__(853);

var _activeFilters = __webpack_require__(427);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomTab = exports.CustomTab = function CustomTab(props) {
  return _react2.default.createElement(
    "div",
    { className: _customTab2.default.container },
    _react2.default.createElement(_documentsInlineTabs.DocumentsInlineTabs, {
      accountSlug: props.accountSlug,
      currentPage: props.route.path,
      customTabs: props.customTabs,
      onStartDeleteCustomTabMode: props.onStartDeleteCustomTabMode
    }),
    _react2.default.createElement(
      "div",
      { className: _customTab2.default["filters-container"] },
      _react2.default.createElement(_customTabFilters.CustomTabFilters, _extends({}, props, { isExports: false })),
      _react2.default.createElement(
        "div",
        { className: _customTab2.default.active },
        _react2.default.createElement(
          "h3",
          null,
          "Your custom filters:"
        ),
        _react2.default.createElement(_activeFilters.ActiveFilters, _extends({}, props, {
          isExports: false,
          searchQueryString: props.selectedSearchQueryString,
          selectedDocumentType: props.type
        }))
      )
    )
  );
};

CustomTab.propTypes = {
  accountSlug: _propTypes2.default.string.isRequired,
  customTabs: _propTypes2.default.arrayOf(_customPropTypes.customTabType),
  onStartDeleteCustomTabMode: _propTypes2.default.func.isRequired,
  route: _customPropTypes.routeType.isRequired,
  selectedSearchQueryString: _propTypes2.default.string,
  type: _propTypes2.default.string
};

CustomTab.defaultProps = {
  customTabs: [],
  selectedSearchQueryString: null,
  type: null
};

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderShowDocumentViewerButton = exports.renderTextForFilterButton = exports.DataGridActionsPanel = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = __webpack_require__(456);

var _bind2 = _interopRequireDefault(_bind);

var _editColumnsModal = __webpack_require__(844);

var _stringHelpers = __webpack_require__(68);

var _pencil = __webpack_require__(450);

var _pencil2 = _interopRequireDefault(_pencil);

var _filter = __webpack_require__(449);

var _filter2 = _interopRequireDefault(_filter);

var _book = __webpack_require__(1007);

var _book2 = _interopRequireDefault(_book);

var _trash = __webpack_require__(1014);

var _trash2 = _interopRequireDefault(_trash);

var _fileTextO = __webpack_require__(448);

var _fileTextO2 = _interopRequireDefault(_fileTextO);

var _dataGridActionsPanel = __webpack_require__(1322);

var _dataGridActionsPanel2 = _interopRequireDefault(_dataGridActionsPanel);

var _customPropTypes = __webpack_require__(5);

var _exportButton = __webpack_require__(426);

var _currencySymbol = __webpack_require__(999);

var _checkIntegration = __webpack_require__(274);

var _multiDocumentActionsContainer = __webpack_require__(862);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DataGridActionsPanel = exports.DataGridActionsPanel = function DataGridActionsPanel(props) {
  return _react2.default.createElement(
    "div",
    { className: "documents5" },
    _react2.default.createElement(StandardActionPanel, _extends({}, props, { selectedDocumentsCount: props.selectedDocumentIds.length })),
    _react2.default.createElement(_multiDocumentActionsContainer.MultiDocumentActionsContainer, _extends({}, props, { userEmail: props.currentUser.email }))
  );
};

DataGridActionsPanel.propTypes = {
  currentUser: _propTypes2.default.shape({
    email: _propTypes2.default.string
  }).isRequired,
  selectedDocumentIds: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired
};

var StandardActionPanel = function StandardActionPanel(props) {
  var columns = props.columns,
      currencies = props.currencies,
      filtersCount = props.filtersCount,
      isDocumentViewerVisible = props.isDocumentViewerVisible,
      isEditColumnsVisible = props.isEditColumnsVisible,
      isGLCodesVisible = props.isGLCodesVisible,
      isTrash = props.isTrash,
      onAddDocumentType = props.onAddDocumentType,
      onHideDocumentViewer = props.onHideDocumentViewer,
      onHideEditColumns = props.onHideEditColumns,
      onHideGLCodesPanel = props.onHideGLCodesPanel,
      onRemoveDocumentType = props.onRemoveDocumentType,
      onReturnToDefaultColumns = props.onReturnToDefaultColumns,
      onShowDocumentViewer = props.onShowDocumentViewer,
      onShowEditColumns = props.onShowEditColumns,
      onShowGLCodesPanel = props.onShowGLCodesPanel,
      onStartDraggableMode = props.onStartDraggableMode,
      onStartFiltersDrawerMode = props.onStartFiltersDrawerMode,
      onToggleColumn = props.onToggleColumn,
      pagination = props.pagination,
      preferredCurrency = props.preferredCurrency,
      selectedDocumentsCount = props.selectedDocumentsCount;

  var integration = (0, _checkIntegration.findIntegrationInUse)(props.categories);
  var bindedClassnames = _bind2.default.bind(_dataGridActionsPanel2.default);
  var actionsPanelClassNames = bindedClassnames({
    trash: isTrash,
    "standard-action-panel__container": true
  });
  if (selectedDocumentsCount > 0) {
    return null;
  }

  return _react2.default.createElement(
    "div",
    { className: actionsPanelClassNames },
    _react2.default.createElement(
      "div",
      { className: _dataGridActionsPanel2.default["results-found"] },
      documentsInformationLabel(pagination, currencies, preferredCurrency, isTrash),
      _react2.default.createElement(
        "div",
        { className: _dataGridActionsPanel2.default.actions },
        renderEditGLCodesButton({
          integration: integration,
          isGLCodesVisible: isGLCodesVisible,
          isTrash: isTrash,
          onHideDocumentViewer: onHideDocumentViewer,
          onHideGLCodesPanel: onHideGLCodesPanel,
          onRemoveDocumentType: onRemoveDocumentType,
          onShowGLCodesPanel: onShowGLCodesPanel,
          onAddDocumentType: onAddDocumentType
        }),
        renderShowDocumentViewerButton(isDocumentViewerVisible, isGLCodesVisible, onShowDocumentViewer, onStartDraggableMode),
        _react2.default.createElement(
          "button",
          { onClick: onShowEditColumns },
          _react2.default.createElement(_pencil2.default, { className: _dataGridActionsPanel2.default.icon, size: 15 }),
          "Edit columns"
        ),
        _react2.default.createElement(
          "button",
          { onClick: onStartFiltersDrawerMode },
          _react2.default.createElement(_filter2.default, { className: _dataGridActionsPanel2.default.icon, size: 15 }),
          renderTextForFilterButton(filtersCount)
        ),
        renderButtonsForTrash(props)
      )
    ),
    _react2.default.createElement(_editColumnsModal.EditColumnsModal, {
      columns: columns,
      isEditColumnsVisible: isEditColumnsVisible,
      onClose: onHideEditColumns,
      onReturnToDefaultColumns: onReturnToDefaultColumns,
      onToggleColumn: onToggleColumn
    })
  );
};

StandardActionPanel.propTypes = {
  categories: _propTypes2.default.arrayOf(_customPropTypes.categoryType).isRequired,
  columns: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  currencies: _propTypes2.default.arrayOf(_customPropTypes.currencyType).isRequired,
  filtersCount: _propTypes2.default.number.isRequired,
  isDocumentViewerVisible: _propTypes2.default.bool.isRequired,
  isEditColumnsVisible: _propTypes2.default.bool.isRequired,
  isGLCodesVisible: _propTypes2.default.bool.isRequired,
  isTrash: _propTypes2.default.bool.isRequired,
  onAddDocumentType: _propTypes2.default.func.isRequired,
  onHideDocumentViewer: _propTypes2.default.func.isRequired,
  onHideEditColumns: _propTypes2.default.func.isRequired,
  onHideGLCodesPanel: _propTypes2.default.func.isRequired,
  onRemoveDocumentType: _propTypes2.default.func.isRequired,
  onReturnToDefaultColumns: _propTypes2.default.func.isRequired,
  onShowDocumentViewer: _propTypes2.default.func.isRequired,
  onShowEditColumns: _propTypes2.default.func.isRequired,
  onShowGLCodesPanel: _propTypes2.default.func.isRequired,
  onStartDraggableMode: _propTypes2.default.func.isRequired,
  onStartFiltersDrawerMode: _propTypes2.default.func.isRequired,
  onToggleColumn: _propTypes2.default.func.isRequired,
  pagination: _customPropTypes.paginationType.isRequired,
  preferredCurrency: _propTypes2.default.string.isRequired,
  selectedDocumentsCount: _propTypes2.default.number.isRequired
};

StandardActionPanel.defaultProps = {
  glCodes: []
};

var documentsInformationLabel = function documentsInformationLabel(pagination, currencies, preferredCurrency, isTrash) {
  var documentsFound = (0, _stringHelpers.pluralize)(pagination.totalCountFiltered, "documents", "document");
  var currencySymbol = (0, _currencySymbol.preferredCurrencySymbol)(currencies, preferredCurrency);
  var total = pagination.totalSumFiltered;
  var currencyCode = preferredCurrency === "AUD" || preferredCurrency === "NZD" ? "" : preferredCurrency;
  var trash = isTrash ? " in trash" : "";
  return _react2.default.createElement(
    "div",
    null,
    documentsFound,
    trash,
    _react2.default.createElement(
      "span",
      { className: _dataGridActionsPanel2.default.total },
      "Total: ",
      currencySymbol,
      total,
      " ",
      currencyCode
    )
  );
};

var renderTextForFilterButton = exports.renderTextForFilterButton = function renderTextForFilterButton(filtersCount) {
  if (filtersCount === 0) {
    return "Filters";
  }
  return _react2.default.createElement(
    "span",
    { className: _dataGridActionsPanel2.default["active-filters"] },
    (0, _stringHelpers.pluralize)(filtersCount, "filters applied", "filter applied", true)
  );
};

var renderShowDocumentViewerButton = exports.renderShowDocumentViewerButton = function renderShowDocumentViewerButton(isDocumentViewerVisible, isGLCodesVisible, onShowDocumentViewer, onStartDraggableMode) {
  if (isDocumentViewerVisible) {
    return null;
  }
  var click = isGLCodesVisible ? function () {
    onStartDraggableMode();onShowDocumentViewer();
  } : onShowDocumentViewer;
  return _react2.default.createElement(
    "button",
    { onClick: click },
    _react2.default.createElement(_fileTextO2.default, { className: _dataGridActionsPanel2.default.icon, height: 15 }),
    "Show document viewer"
  );
};

var renderEditGLCodesButton = function renderEditGLCodesButton(props) {
  if (props.integration) {
    return toggleGLCodesButton(props);
  }
  return null;
};

var toggleGLCodesButton = function toggleGLCodesButton(_ref) {
  var isGLCodesVisible = _ref.isGLCodesVisible,
      isTrash = _ref.isTrash,
      onAddDocumentType = _ref.onAddDocumentType,
      onHideDocumentViewer = _ref.onHideDocumentViewer,
      onHideGLCodesPanel = _ref.onHideGLCodesPanel,
      onRemoveDocumentType = _ref.onRemoveDocumentType,
      onShowGLCodesPanel = _ref.onShowGLCodesPanel;

  if (isTrash) {
    return null;
  }
  if (isGLCodesVisible) {
    return _react2.default.createElement(
      "button",
      { onClick: function onClick() {
          onHideGLCodesPanel();onRemoveDocumentType();
        } },
      _react2.default.createElement(_book2.default, { className: _dataGridActionsPanel2.default.icon, height: 15 }),
      "Hide GL codes panel"
    );
  }
  return _react2.default.createElement(
    "button",
    {
      onClick: function onClick() {
        onHideDocumentViewer();
        onShowGLCodesPanel();
        onAddDocumentType({ key: "receipt" });
      }
    },
    _react2.default.createElement(_book2.default, { className: _dataGridActionsPanel2.default.icon, height: 15 }),
    "Edit GL codes"
  );
};

toggleGLCodesButton.propTypes = {
  isGLCodesVisible: _propTypes2.default.bool.isRequired,
  isTrash: _propTypes2.default.bool.isRequired,
  onAddDocumentType: _propTypes2.default.func.isRequired,
  onHideDocumentViewer: _propTypes2.default.func.isRequired,
  onHideGLCodesPanel: _propTypes2.default.func.isRequired,
  onRemoveDocumentType: _propTypes2.default.func.isRequired,
  onShowGLCodesPanel: _propTypes2.default.func.isRequired
};

var renderExportAllButton = function renderExportAllButton(accountId, accountSlug, filters, glCodes, onExportAll, onLinkAccount, onStartExportMode) {
  if (filters.type !== "other") {
    return _react2.default.createElement(_exportButton.ExportButton, {
      accountSlug: accountSlug,
      glCodes: glCodes,
      onLinkAccount: onLinkAccount,
      onStartExportMode: onStartExportMode,
      selectedDocumentIds: []
    });
  }
  return null;
};

var renderButtonsForTrash = function renderButtonsForTrash(props) {
  if (props.isTrash) {
    return _react2.default.createElement(
      "button",
      { className: _dataGridActionsPanel2.default["exit-trash"], onClick: props.onExitTrash },
      _react2.default.createElement(_trash2.default, { className: _dataGridActionsPanel2.default.icon, size: 15 }),
      "Exit trash"
    );
  }

  if (props.isGLCodesVisible) {
    return renderExportAllButton(props.accountId, props.accountSlug, props.filters, props.glCodes, props.onExportAll, props.onLinkAccount, props.onStartExportMode);
  }

  return _react2.default.createElement(
    "div",
    { className: _dataGridActionsPanel2.default.buttons },
    _react2.default.createElement(
      "button",
      { onClick: props.onShowTrash },
      _react2.default.createElement(_trash2.default, { className: _dataGridActionsPanel2.default.icon, size: 15 }),
      "View trash"
    ),
    renderExportAllButton(props.accountId, props.accountSlug, props.filters, props.glCodes, props.onExportAll, props.onLinkAccount, props.onStartExportMode)
  );
};

renderButtonsForTrash.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  accountSlug: _propTypes2.default.string.isRequired,
  filters: _customPropTypes.documentFiltersType.isRequired,
  glCodes: _propTypes2.default.arrayOf(_customPropTypes.categoryType),
  isGLCodesVisible: _propTypes2.default.bool.isRequired,
  isTrash: _propTypes2.default.bool.isRequired,
  onExitTrash: _propTypes2.default.func.isRequired,
  onExportAll: _propTypes2.default.func.isRequired,
  onLinkAccount: _propTypes2.default.func.isRequired,
  onShowTrash: _propTypes2.default.func.isRequired,
  onStartExportMode: _propTypes2.default.func.isRequired
};

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentViewer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _documentViewer = __webpack_require__(512);

var _documentViewer2 = _interopRequireDefault(_documentViewer);

var _customPropTypes = __webpack_require__(5);

var _renderedDocument = __webpack_require__(864);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DocumentViewer = exports.DocumentViewer = function DocumentViewer(props) {
  if (props.isDocumentViewerVisible) {
    return renderDocumentViewer(props);
  }
  return null;
};

DocumentViewer.propTypes = {
  isDocumentViewerVisible: _propTypes2.default.bool.isRequired
};

var renderDocumentViewer = function renderDocumentViewer(props) {
  var draggableStyle = props.isDraggable ? _documentViewer2.default["viewer-modal"] : "";
  if (props.focusedDocument.id && props.focusedDocument.attachment) {
    return _react2.default.createElement(
      "div",
      { className: _documentViewer2.default["viewer-container"] + " documents4 " + draggableStyle },
      _react2.default.createElement(_renderedDocument.RenderedDocument, props)
    );
  }

  if (props.isGLCodesVisible) {
    return _react2.default.createElement(
      "div",
      { className: _documentViewer2.default["viewer-container"] + " " + draggableStyle },
      _react2.default.createElement(_renderedDocument.RenderedDocument, _extends({}, props, { focusedDocument: props.documents[0] }))
    );
  }

  return _react2.default.createElement(
    "div",
    { className: _documentViewer2.default.placeholder },
    _react2.default.createElement(
      "div",
      { className: _documentViewer2.default["placeholder-text"] },
      _react2.default.createElement(
        "span",
        { className: _documentViewer2.default.blank + " " + _documentViewer2.default.close, onClick: props.onHideDocumentViewer },
        "+"
      ),
      _react2.default.createElement(
        "h3",
        { className: _documentViewer2.default.text },
        "Click on a document on the left ",
        _react2.default.createElement("br", null),
        " and it will appear here!"
      )
    )
  );
};

renderDocumentViewer.propTypes = {
  documents: _propTypes2.default.arrayOf(_customPropTypes.documentPropType).isRequired,
  focusedDocument: _customPropTypes.focusedDocumentType.isRequired,
  isDraggable: _propTypes2.default.bool.isRequired,
  isGLCodesVisible: _propTypes2.default.bool.isRequired,
  onHideDocumentViewer: _propTypes2.default.func.isRequired
};

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownActionsPanel = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _dropdown = __webpack_require__(224);

var _dropdown2 = _interopRequireDefault(_dropdown);

var _bars = __webpack_require__(445);

var _bars2 = _interopRequireDefault(_bars);

var _angleLeft = __webpack_require__(1003);

var _angleLeft2 = _interopRequireDefault(_angleLeft);

var _angleRight = __webpack_require__(1780);

var _angleRight2 = _interopRequireDefault(_angleRight);

var _customPropTypes = __webpack_require__(5);

var _dropdownModal = __webpack_require__(165);

var _button = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DropdownActionsPanel = exports.DropdownActionsPanel = function DropdownActionsPanel(_ref) {
  var accountId = _ref.accountId,
      documents = _ref.documents,
      focusedDocument = _ref.focusedDocument,
      isDocViewerHamburgerMode = _ref.isDocViewerHamburgerMode,
      onEndDocViewerHamburgerMode = _ref.onEndDocViewerHamburgerMode,
      onFocusDocument = _ref.onFocusDocument,
      onDocumentViewed = _ref.onDocumentViewed,
      onReprocessDocument = _ref.onReprocessDocument,
      onShowChangeDocType = _ref.onShowChangeDocType,
      onShowShareUrl = _ref.onShowShareUrl,
      onShowTrashDocument = _ref.onShowTrashDocument,
      onStartDocViewerHamburgerMode = _ref.onStartDocViewerHamburgerMode,
      onUnfocusDocument = _ref.onUnfocusDocument,
      rowHeight = _ref.rowHeight;

  var focusedDocumentIndex = _ramda2.default.findIndex(_ramda2.default.propEq("id", focusedDocument.id), documents);
  var cleanDocuments = documents.map(function (document) {
    return _ramda2.default.merge(document, { downloadUrl: _ramda2.default.path(["attachment", "url"], document) });
  });
  var newStyle = function newStyle(offset) {
    return _ramda2.default.set(_ramda2.default.lensProp("top"), focusedDocument.style.top + offset, focusedDocument.style);
  };
  return _react2.default.createElement(
    "div",
    { className: _dropdown2.default.toolbar },
    _react2.default.createElement(
      _button.Button,
      {
        disabled: focusedDocumentIndex === 0,
        onClick: function onClick() {
          onUnfocusDocument();
          onFocusDocument(cleanDocuments[focusedDocumentIndex - 1], newStyle(rowHeight * -1));
          onDocumentViewed({ accountId: accountId, document: cleanDocuments[focusedDocumentIndex - 1] });
        }
      },
      _react2.default.createElement(_angleLeft2.default, { size: 15 })
    ),
    _react2.default.createElement(
      _button.ToggleButton,
      {
        isOpen: isDocViewerHamburgerMode,
        onCloseClick: onEndDocViewerHamburgerMode,
        onOpenClick: onStartDocViewerHamburgerMode
      },
      _react2.default.createElement(_bars2.default, { size: 15 })
    ),
    _react2.default.createElement(
      _dropdownModal.DropdownModal,
      {
        offsetLeft: -40,
        offsetTop: 20,
        onClose: onEndDocViewerHamburgerMode,
        visible: isDocViewerHamburgerMode,
        width: 200
      },
      _react2.default.createElement(
        "div",
        { className: _dropdown2.default["dropdown-buttons"] },
        _react2.default.createElement(
          _button.Button,
          { link: true, onClick: function onClick() {
              onReprocessDocument(accountId);
            } },
          "Reprocess Document"
        ),
        _react2.default.createElement(
          _button.Button,
          { link: true, onClick: onShowChangeDocType },
          "Change Document Type"
        ),
        _react2.default.createElement(
          _button.Button,
          { link: true, onClick: onShowShareUrl },
          "Share Document"
        ),
        _react2.default.createElement(
          _button.Button,
          { link: true, onClick: function onClick() {
              window.open(cleanDocuments[focusedDocumentIndex].downloadUrl);
            } },
          "Download document"
        ),
        _react2.default.createElement(
          _button.Button,
          { danger: true, link: true, onClick: onShowTrashDocument },
          "Trash"
        )
      )
    ),
    _react2.default.createElement(
      "div",
      { className: _dropdown2.default["right-arrow"] },
      _react2.default.createElement(
        _button.Button,
        {
          disabled: focusedDocumentIndex === cleanDocuments.length - 1,
          onClick: function onClick() {
            onUnfocusDocument();
            onFocusDocument(cleanDocuments[focusedDocumentIndex + 1], newStyle(rowHeight));
            onDocumentViewed({ accountId: accountId, document: cleanDocuments[focusedDocumentIndex + 1] });
          }
        },
        _react2.default.createElement(_angleRight2.default, { size: 15 })
      )
    )
  );
};

DropdownActionsPanel.defaultProps = {
  focusedDocument: null
};

DropdownActionsPanel.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  documents: _propTypes2.default.arrayOf(_customPropTypes.documentPropType).isRequired,
  focusedDocument: _customPropTypes.documentPropType,
  isDocViewerHamburgerMode: _propTypes2.default.bool.isRequired,
  onDocumentViewed: _propTypes2.default.func.isRequired,
  onEndDocViewerHamburgerMode: _propTypes2.default.func.isRequired,
  onFocusDocument: _propTypes2.default.func.isRequired,
  onReprocessDocument: _propTypes2.default.func.isRequired,
  onShowChangeDocType: _propTypes2.default.func.isRequired,
  onShowShareUrl: _propTypes2.default.func.isRequired,
  onShowTrashDocument: _propTypes2.default.func.isRequired,
  onStartDocViewerHamburgerMode: _propTypes2.default.func.isRequired,
  onUnfocusDocument: _propTypes2.default.func.isRequired,
  rowHeight: _propTypes2.default.number.isRequired
};

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TaxCalculator = exports.NumberInput = exports.FormComponent = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSelect = __webpack_require__(135);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _customPropTypes = __webpack_require__(5);

var _formElements = __webpack_require__(510);

var _formElements2 = _interopRequireDefault(_formElements);

var _datepicker = __webpack_require__(267);

var _gstCalculator = __webpack_require__(423);

var _select = __webpack_require__(45);

var _paymentTypes = __webpack_require__(275);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormComponent = exports.FormComponent = function FormComponent(props) {
  return _react2.default.createElement(
    "div",
    { className: _formElements2.default["fields-container"] },
    _react2.default.createElement(
      "h4",
      null,
      props.title
    ),
    _react2.default.createElement(Component, props)
  );
};

FormComponent.propTypes = {
  title: _propTypes2.default.string.isRequired
};

var Component = function Component(props) {
  switch (props.type) {
    case "text":
      return _react2.default.createElement(TextInput, props);
    case "select":
      return _react2.default.createElement(SelectInput, props);
    case "date":
      return _react2.default.createElement(DatePickerInput, props);
    case "notes":
      return _react2.default.createElement(NoteInput, props);
    case "createable":
      return _react2.default.createElement(CreateableSelectInput, props);
    case "number":
      return _react2.default.createElement(NumberInput, props);
    case "paymentType":
      return _react2.default.createElement(PaymentTypeInput, props);
    default:
      return _react2.default.createElement(TextInput, props);
  }
};

Component.propTypes = {
  type: _propTypes2.default.string.isRequired
};

var TextInput = function TextInput(props) {
  return _react2.default.createElement("input", {
    className: _formElements2.default.fields,
    onChange: function onChange(e) {
      return props.onChange(props.field, e.target.value);
    },
    placeholder: props.placeholder,
    value: props.value
  });
};

TextInput.defaultProps = {
  value: ""
};

TextInput.propTypes = {
  field: _propTypes2.default.string.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  placeholder: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.string
};

var SelectInput = function SelectInput(props) {
  return _react2.default.createElement(_reactSelect2.default, {
    clearable: false,
    onChange: function onChange(e) {
      return props.onChange(props.field, e.value);
    },
    options: (0, _select.optionsMapper)(props.options),
    placeholder: props.placeholder,
    searchable: false,
    value: (0, _select.valueMapper)(props.value)
  });
};

SelectInput.defaultProps = {
  value: null
};

SelectInput.propTypes = {
  field: _propTypes2.default.string.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  options: _propTypes2.default.arrayOf(_customPropTypes.selectOptionType).isRequired,
  placeholder: _propTypes2.default.string.isRequired,
  value: _customPropTypes.selectOptionType
};

var NumberInput = exports.NumberInput = function NumberInput(props) {
  return _react2.default.createElement("input", {
    className: _formElements2.default.fields,
    maxLength: props.max,
    onChange: function onChange(e) {
      return props.onChange(props.field, e.target.value);
    },
    placeholder: props.placeholder,
    type: "text",
    value: normalizeNumber(props.value)
  });
};

NumberInput.defaultProps = {
  max: null,
  value: ""
};

NumberInput.propTypes = {
  field: _propTypes2.default.string.isRequired,
  max: _propTypes2.default.string,
  onChange: _propTypes2.default.func.isRequired,
  placeholder: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
};

var normalizeNumber = function normalizeNumber(value) {
  if (isNaN(value)) {
    return 0;
  }
  return value;
};

var TaxCalculator = exports.TaxCalculator = function TaxCalculator(props) {
  return _react2.default.createElement(
    "div",
    { className: _formElements2.default.gst },
    _react2.default.createElement(_gstCalculator.GSTCalculator, props)
  );
};

var PaymentTypeInput = function PaymentTypeInput(props) {
  var className = props.valueType.key === "credit-card" ? _formElements2.default["credit-card"] : _formElements2.default["other-payment"];
  return _react2.default.createElement(
    "div",
    { className: className },
    _react2.default.createElement(SelectInput, {
      field: "type",
      onChange: props.onChange,
      options: _paymentTypes.paymentTypes,
      placeholder: "Choose a payment type",
      value: props.valueType
    }),
    _react2.default.createElement(NumberInput, {
      field: "lastFourDigits",
      max: "4",
      name: "cardNumber",
      onChange: props.onChange,
      placeholder: "Last four...",
      value: props.valueNumber
    })
  );
};

PaymentTypeInput.defaultProps = {
  valueNumber: "",
  valueType: null
};

PaymentTypeInput.propTypes = {
  onChange: _propTypes2.default.func.isRequired,
  valueNumber: _propTypes2.default.string,
  valueType: _customPropTypes.selectOptionType
};

var DatePickerInput = function DatePickerInput(props) {
  return _react2.default.createElement(_datepicker.Datepicker, {
    isClearable: false,
    onDateSelected: function onDateSelected(e) {
      props.onChange(props.field, e.utc().format());
    },
    placeholderText: "Enter a date",
    selected: props.value ? (0, _moment2.default)(props.value) : null
  });
};

DatePickerInput.propTypes = {
  field: _propTypes2.default.string.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  value: _propTypes2.default.string
};

var NoteInput = function NoteInput(props) {
  return _react2.default.createElement("textarea", {
    className: _formElements2.default.notes,
    onChange: function onChange(e) {
      return props.onChange(props.field, e.target.value);
    },
    value: props.value
  });
};

NoteInput.propTypes = {
  field: _propTypes2.default.string.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  value: _propTypes2.default.string
};

var CreateableSelectInput = function CreateableSelectInput(props) {
  return _react2.default.createElement(_select.CreatableMultiSelect, props);
};

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OtherDocumentForm = exports.renderExportError = exports.ReceiptForm = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _exclamationTriangle = __webpack_require__(276);

var _exclamationTriangle2 = _interopRequireDefault(_exclamationTriangle);

var _regex = __webpack_require__(443);

var _dropdown = __webpack_require__(224);

var _dropdown2 = _interopRequireDefault(_dropdown);

var _customPropTypes = __webpack_require__(5);

var _dropdownComponents = __webpack_require__(858);

var _button = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReceiptForm = exports.ReceiptForm = function ReceiptForm(props) {
  var formFields = props.columns.filter(function (column) {
    return !column.visible && (column.key === "vendor" || column.key === "issued" || column.key === "total" || column.key === "invoiceNumber" || column.key === "categories" || column.key === "currency");
  });

  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      "div",
      { className: _dropdown2.default.row },
      renderReceiptVariableFields(formFields, props),
      _react2.default.createElement(
        "div",
        { className: _dropdown2.default.flex },
        _react2.default.createElement(_dropdownComponents.FormComponent, {
          field: "tax",
          max: null,
          onChange: props.onUpdateDocument,
          placeholder: "$0.00",
          title: "Tax",
          type: "number",
          value: props.focusedDocument.tax
        }),
        _react2.default.createElement(_dropdownComponents.TaxCalculator, {
          change: props.onUpdateDocument,
          currency: props.focusedDocument.currency,
          preferredCurrency: props.preferredCurrency,
          taxRate: props.taxRate,
          total: props.focusedDocument.total
        })
      ),
      _react2.default.createElement(
        "div",
        { className: _dropdown2.default.flex },
        _react2.default.createElement(_dropdownComponents.FormComponent, {
          field: "currency",
          onChange: props.onUpdateDocument,
          options: mapCurrencies(props.currencies),
          placeholder: "Choose a currency",
          title: "Currency",
          type: "select",
          value: cleanCurrencyValue(props.focusedDocument.currency)
        })
      ),
      _react2.default.createElement(
        "div",
        { className: _dropdown2.default.flex },
        _react2.default.createElement(_dropdownComponents.FormComponent, {
          field: "paymentType",
          onChange: props.onUpdatePaymentType,
          placeholder: "Choose a payment type",
          title: "Payment Type",
          type: "paymentType",
          valueNumber: props.focusedDocument.paymentType.lastFourDigits,
          valueType: props.formPaymentType
        })
      ),
      _react2.default.createElement(
        "div",
        { className: _dropdown2.default.flex },
        _react2.default.createElement(_dropdownComponents.FormComponent, {
          field: "notes",
          onChange: props.onUpdateDocument,
          title: "Notes",
          type: "notes",
          value: props.notes
        })
      ),
      _react2.default.createElement(
        "div",
        { className: _dropdown2.default.flex + " " + _dropdown2.default.categories },
        _react2.default.createElement(_dropdownComponents.FormComponent, {
          accountId: props.accountId,
          addFunction: props.onCreateCategory,
          field: "categories",
          onChange: props.onUpdateDocument,
          options: props.categories,
          placeholder: "Add a category...",
          title: "Categories",
          type: "createable",
          value: props.focusedDocument.categories
        })
      )
    ),
    renderExportError(props.focusedDocument.notes),
    _react2.default.createElement(
      "div",
      { className: _dropdown2.default["actions-container"] },
      _react2.default.createElement(
        "div",
        { className: _dropdown2.default.cancel },
        _react2.default.createElement(
          _button.Button,
          { link: true, onClick: function onClick() {
              return props.onUnfocusDocument();
            } },
          "cancel"
        )
      ),
      _react2.default.createElement(
        _button.Button,
        { onClick: function onClick() {
            props.onSaveDocument();props.onUnfocusDocument();
          }, primary: true },
        "Save"
      )
    )
  );
};

var renderExportError = exports.renderExportError = function renderExportError(notes) {
  var error = (0, _regex.getExportErrorText)(notes);
  if (error) {
    return _react2.default.createElement(
      "div",
      { className: _dropdown2.default["export-error"] },
      _react2.default.createElement(_exclamationTriangle2.default, { className: _dropdown2.default.warning, size: 15 }),
      _react2.default.createElement(
        "span",
        { className: _dropdown2.default["export-error-text"] },
        "Export Error"
      ),
      _react2.default.createElement(
        "div",
        { className: _dropdown2.default["export-tooltip"] },
        error[1]
      )
    );
  }
  return null;
};

var renderReceiptVariableFields = function renderReceiptVariableFields(formFields, props) {
  return formFields.map(function (field) {
    switch (field.key) {
      case "vendor":
        return _react2.default.createElement(
          "div",
          { className: _dropdown2.default.flex, key: field.key },
          _react2.default.createElement(_dropdownComponents.FormComponent, {
            field: "vendor",
            onChange: props.onUpdateDocument,
            placeholder: "Enter a vendor...",
            title: "Vendor",
            type: "text",
            value: props.focusedDocument.vendor
          })
        );
      case "issued":
        return _react2.default.createElement(
          "div",
          { className: _dropdown2.default.flex, key: field.key },
          _react2.default.createElement(_dropdownComponents.FormComponent, {
            field: "issued",
            onChange: props.onUpdateDocument,
            title: "Date",
            type: "date",
            value: props.focusedDocument.issued
          })
        );
      case "total":
        return _react2.default.createElement(
          "div",
          { className: _dropdown2.default.flex, key: field.key },
          _react2.default.createElement(_dropdownComponents.FormComponent, {
            field: "total",
            max: null,
            onChange: props.onUpdateDocument,
            placeholder: "$0.00",
            title: "Total",
            type: "number",
            value: props.focusedDocument.total
          })
        );
      case "invoiceNumber":
        return _react2.default.createElement(
          "div",
          { className: _dropdown2.default.flex, key: field.key },
          _react2.default.createElement(_dropdownComponents.FormComponent, {
            field: "invoiceNumber",
            onChange: props.onUpdateDocument,
            placeholder: "Enter an invoice number...",
            title: "Invoice Number",
            type: "text",
            value: props.focusedDocument.invoiceNumber
          })
        );
      default:
        return null;
    }
  });
};

ReceiptForm.defaultProps = {
  formPaymentType: { type: "" }
};

ReceiptForm.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  categories: _propTypes2.default.arrayOf(_customPropTypes.categoryType).isRequired,
  columns: _propTypes2.default.arrayOf(_customPropTypes.columnObjectType).isRequired,
  currencies: _propTypes2.default.arrayOf(_customPropTypes.currencyType).isRequired,
  focusedDocument: _customPropTypes.documentPropType.isRequired,
  formPaymentType: _customPropTypes.paymentTypeType,
  notes: _propTypes2.default.string.isRequired,
  onCreateCategory: _propTypes2.default.func.isRequired,
  onSaveDocument: _propTypes2.default.func.isRequired,
  onUnfocusDocument: _propTypes2.default.func.isRequired,
  onUpdateDocument: _propTypes2.default.func.isRequired,
  onUpdatePaymentType: _propTypes2.default.func.isRequired,
  preferredCurrency: _propTypes2.default.string.isRequired,
  taxRate: _propTypes2.default.number.isRequired
};

var mapCurrencies = function mapCurrencies(currencies) {
  return currencies.map(function (currency) {
    return { key: currency.code, name: currency.code };
  });
};
var cleanCurrencyValue = function cleanCurrencyValue(currency) {
  return { key: currency, name: currency };
};

var OtherDocumentForm = exports.OtherDocumentForm = function OtherDocumentForm(props) {
  var formFields = props.columns.filter(function (column) {
    return !column.visible && (column.key === "vendor" || column.key === "issued");
  });
  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      "div",
      { className: _dropdown2.default.row },
      renderOtherDocumentVariableFields(formFields, props),
      _react2.default.createElement(
        "div",
        { className: _dropdown2.default["other-flex"] },
        _react2.default.createElement(_dropdownComponents.FormComponent, {
          field: "notes",
          onChange: props.onUpdateDocument,
          title: "Notes",
          type: "notes",
          value: props.focusedDocument.notes
        })
      )
    ),
    _react2.default.createElement(
      "div",
      { className: _dropdown2.default["actions-container"] },
      _react2.default.createElement(
        "div",
        { className: _dropdown2.default.cancel },
        _react2.default.createElement(
          _button.Button,
          { link: true, onClick: function onClick() {
              return props.onUnfocusDocument();
            } },
          "cancel"
        )
      ),
      _react2.default.createElement(
        _button.Button,
        { onClick: function onClick() {
            props.onSaveDocument();props.onUnfocusDocument();
          }, primary: true },
        "Save"
      )
    )
  );
};

OtherDocumentForm.propTypes = {
  columns: _propTypes2.default.arrayOf(_customPropTypes.columnObjectType).isRequired,
  focusedDocument: _customPropTypes.documentPropType.isRequired,
  onSaveDocument: _propTypes2.default.func.isRequired,
  onUnfocusDocument: _propTypes2.default.func.isRequired,
  onUpdateDocument: _propTypes2.default.func.isRequired
};

var renderOtherDocumentVariableFields = function renderOtherDocumentVariableFields(formFields, props) {
  return formFields.map(function (field) {
    switch (field.key) {
      case "issued":
        return _react2.default.createElement(
          "div",
          { className: _dropdown2.default["other-flex"], key: field.key },
          _react2.default.createElement(_dropdownComponents.FormComponent, {
            field: "issued",
            onChange: props.onUpdateDocument,
            title: "Date",
            type: "date",
            value: props.focusedDocument.issued
          })
        );
      case "vendor":
        return _react2.default.createElement(
          "div",
          { className: _dropdown2.default["other-flex"], key: field.key },
          _react2.default.createElement(_dropdownComponents.FormComponent, {
            field: "vendor",
            onChange: props.onUpdateDocument,
            placeholder: "Enter a name...",
            title: "Name",
            type: "text",
            value: props.focusedDocument.vendor || props.focusedDocument.name
          })
        );
      default:
        return null;
    }
  });
};

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dropdown = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dropdown = __webpack_require__(224);

var _dropdown2 = _interopRequireDefault(_dropdown);

var _customPropTypes = __webpack_require__(5);

var _regex = __webpack_require__(443);

var _dropdownActionsPanel = __webpack_require__(857);

var _paymentTypes = __webpack_require__(275);

var _dropdownForms = __webpack_require__(859);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Dropdown = exports.Dropdown = function Dropdown(props) {
  if (props.focusedDocument.id === null) {
    return null;
  }
  var newStyle = { top: props.focusedDocument.style.top + props.rowHeight * 2 };
  return _react2.default.createElement(
    "div",
    { className: _dropdown2.default.container, style: newStyle },
    _react2.default.createElement(_dropdownActionsPanel.DropdownActionsPanel, _extends({}, props, {
      documents: props.documents,
      focusedDocument: props.focusedDocument,
      onFocusDocument: props.onFocusDocument,
      onShowTrashDocument: props.onShowTrashDocument
    })),
    renderForm(props, props.focusedDocument)
  );
};

Dropdown.defaultProps = {
  focusedDocument: null
};

Dropdown.propTypes = {
  documents: _propTypes2.default.arrayOf(_customPropTypes.documentPropType).isRequired,
  focusedDocument: _customPropTypes.documentPropType,
  onFocusDocument: _propTypes2.default.func.isRequired,
  onShowTrashDocument: _propTypes2.default.func.isRequired,
  rowHeight: _propTypes2.default.number.isRequired
};

var renderForm = function renderForm(props, focusedDocument) {
  if (focusedDocument.type === "other") {
    return _react2.default.createElement(_dropdownForms.OtherDocumentForm, props);
  }
  return _react2.default.createElement(_dropdownForms.ReceiptForm, _extends({}, props, {
    formPaymentType: cleanPaymentType(focusedDocument.paymentType),
    notes: (0, _regex.removeExportErrorText)(focusedDocument.notes)
  }));
};
var cleanPaymentType = function cleanPaymentType(paymentType) {
  return _paymentTypes.paymentTypes.find(function (type) {
    return type.key === paymentType.type;
  });
};

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExportModal = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _customPropTypes = __webpack_require__(5);

var _editColumnsModal = __webpack_require__(509);

var _editColumnsModal2 = _interopRequireDefault(_editColumnsModal);

var _modal = __webpack_require__(27);

var _button = __webpack_require__(7);

var _checkIntegration = __webpack_require__(274);

var _stringHelpers = __webpack_require__(68);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExportModal = exports.ExportModal = function ExportModal(_ref) {
  var accountId = _ref.accountId,
      accountSlug = _ref.accountSlug,
      categories = _ref.categories,
      glCodes = _ref.glCodes,
      isExportMode = _ref.isExportMode,
      onClose = _ref.onClose,
      onExportAll = _ref.onExportAll,
      onExportSelected = _ref.onExportSelected,
      onLinkAccount = _ref.onLinkAccount,
      selectedDocumentIds = _ref.selectedDocumentIds;
  return _react2.default.createElement(
    _modal.Modal,
    {
      isVisible: isExportMode,
      onClose: onClose,
      transitionName: "export-modal"
    },
    renderExportText(categories, selectedDocumentIds),
    _react2.default.createElement(
      "div",
      { className: _editColumnsModal2.default.actions },
      _react2.default.createElement(
        _button.Button,
        { link: true, onClick: onClose },
        "cancel"
      ),
      renderExportButton(accountId, accountSlug, onExportAll, onExportSelected, glCodes, selectedDocumentIds, onLinkAccount)
    )
  );
};

ExportModal.defaultProps = {
  selectedDocumentIds: []
};

ExportModal.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  accountSlug: _propTypes2.default.string.isRequired,
  categories: _propTypes2.default.arrayOf(_customPropTypes.categoryType).isRequired,
  glCodes: _propTypes2.default.arrayOf(_customPropTypes.categoryType).isRequired,
  isExportMode: _propTypes2.default.bool.isRequired,
  onClose: _propTypes2.default.func.isRequired,
  onExportAll: _propTypes2.default.func.isRequired,
  onExportSelected: _propTypes2.default.func.isRequired,
  onLinkAccount: _propTypes2.default.func.isRequired,
  selectedDocumentIds: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

var renderExportText = function renderExportText(categories, selectedDocumentIds) {
  var activeIntegration = (0, _checkIntegration.findIntegrationInUse)(categories);
  if (selectedDocumentIds.length > 0) {
    return _react2.default.createElement(
      "h3",
      null,
      "Export ",
      (0, _stringHelpers.pluralize)(selectedDocumentIds.length, "documents", "document"),
      " to ",
      activeIntegration,
      "?"
    );
  }
  return _react2.default.createElement(
    "h3",
    null,
    "Export all documents to ",
    activeIntegration,
    "?"
  );
};

var renderExportButton = function renderExportButton(accountId, accountSlug, onExportAll, onExportSelected, glCodes, selectedDocumentIds, onLinkAccount) {
  // TODO: This is a temporary fix until the API call for GET integration details is created.
  // Until then we have to judge whether or not an integration exists based on the existence of GL codes.
  if (glCodes.length === 0) {
    return _react2.default.createElement(
      _button.Button,
      { onClick: function onClick() {
          return onLinkAccount(accountSlug);
        }, primary: true },
      "Link your accounting software"
    );
  }
  if (selectedDocumentIds.length > 0) {
    return _react2.default.createElement(
      _button.Button,
      { onClick: function onClick() {
          return onExportSelected(accountId, selectedDocumentIds);
        }, primary: true },
      "Export Selected"
    );
  }
  return _react2.default.createElement(
    _button.Button,
    { onClick: function onClick() {
        return onExportAll(accountId);
      }, primary: true },
    "Export All"
  );
};

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderSelectAllButton = exports.MultiDocumentActionsContainer = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _stringHelpers = __webpack_require__(68);

var _button = __webpack_require__(7);

var _dropdownModal = __webpack_require__(165);

var _multiDocumentActionsContainer = __webpack_require__(513);

var _multiDocumentActionsContainer2 = _interopRequireDefault(_multiDocumentActionsContainer);

var _exportButton = __webpack_require__(426);

var _batchEditForm = __webpack_require__(876);

var _customPropTypes = __webpack_require__(5);

var _assignCategoriesForm = __webpack_require__(874);

var _trashMultipleDocumentsModal = __webpack_require__(879);

var _deletePermanentlyModal = __webpack_require__(873);

var _multiDocumentsActionsHamburger = __webpack_require__(863);

var _columnObjects = __webpack_require__(270);

var _pencil = __webpack_require__(450);

var _pencil2 = _interopRequireDefault(_pencil);

var _bars = __webpack_require__(445);

var _bars2 = _interopRequireDefault(_bars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MultiDocumentActionsContainer = exports.MultiDocumentActionsContainer = function MultiDocumentActionsContainer(props) {
  if (props.selectedDocumentIds.length > 0) {
    return content(props);
  }
  return null;
};

MultiDocumentActionsContainer.propTypes = {
  categories: _propTypes2.default.arrayOf(_customPropTypes.categoryType).isRequired,
  currencies: _propTypes2.default.arrayOf(_customPropTypes.currencyType).isRequired,
  documents: _propTypes2.default.arrayOf(_customPropTypes.documentPropType).isRequired,
  isBatchCategoriesMode: _propTypes2.default.bool.isRequired,
  isBatchDownloadLoading: _propTypes2.default.bool.isRequired,
  isBatchEditLoading: _propTypes2.default.bool.isRequired,
  isBatchEditMode: _propTypes2.default.bool.isRequired,
  isMergeDocumentsLoading: _propTypes2.default.bool.isRequired,
  isMergeDocumentsMode: _propTypes2.default.bool.isRequired,
  isTrashMultipleDocumentsLoading: _propTypes2.default.bool.isRequired,
  isTrashMultipleDocumentsVisible: _propTypes2.default.bool.isRequired,
  onChangeViewedSetting: _propTypes2.default.func.isRequired,
  onCreateCategory: _propTypes2.default.func.isRequired,
  onEndBatchCategoriesMode: _propTypes2.default.func.isRequired,
  onEndBatchDownloadMode: _propTypes2.default.func.isRequired,
  onEndBatchEditMode: _propTypes2.default.func.isRequired,
  onEndMergeDocumentsMode: _propTypes2.default.func.isRequired,
  onMergeDocuments: _propTypes2.default.func.isRequired,
  onStartBatchCategoriesMode: _propTypes2.default.func.isRequired,
  onStartBatchDownloadMode: _propTypes2.default.func.isRequired,
  onStartBatchEditMode: _propTypes2.default.func.isRequired,
  onStartMergeDocumentsMode: _propTypes2.default.func.isRequired,
  onSubmitBatchDownloadDocuments: _propTypes2.default.func.isRequired,
  onSubmitBatchEdit: _propTypes2.default.func.isRequired,
  onTrashDocument: _propTypes2.default.func.isRequired,
  selectedDocumentIds: _propTypes2.default.arrayOf(_propTypes2.default.string),
  userEmail: _propTypes2.default.string.isRequired,
  vendors: _propTypes2.default.arrayOf(_customPropTypes.vendorType).isRequired
};

var content = function content(_ref) {
  var accountId = _ref.accountId,
      accountSlug = _ref.accountSlug,
      categories = _ref.categories,
      currencies = _ref.currencies,
      filters = _ref.filters,
      glCodes = _ref.glCodes,
      isBatchCategoriesMode = _ref.isBatchCategoriesMode,
      isBatchCategoriesLoading = _ref.isBatchCategoriesLoading,
      isBatchDownloadMode = _ref.isBatchDownloadMode,
      isBatchDownloadLoading = _ref.isBatchDownloadLoading,
      isBatchEditLoading = _ref.isBatchEditLoading,
      isBatchEditMode = _ref.isBatchEditMode,
      isDeletePermanentlyLoading = _ref.isDeletePermanentlyLoading,
      isDeletePermanentlyVisible = _ref.isDeletePermanentlyVisible,
      isHamburgerMode = _ref.isHamburgerMode,
      isMergeDocumentsLoading = _ref.isMergeDocumentsLoading,
      isMergeDocumentsMode = _ref.isMergeDocumentsMode,
      isRestoreDocumentsLoading = _ref.isRestoreDocumentsLoading,
      isTrash = _ref.isTrash,
      isTrashMultipleDocumentsLoading = _ref.isTrashMultipleDocumentsLoading,
      isTrashMultipleDocumentsVisible = _ref.isTrashMultipleDocumentsVisible,
      mergeDocument = _ref.mergeDocument,
      onChangeViewedSetting = _ref.onChangeViewedSetting,
      onCreateCategory = _ref.onCreateCategory,
      onDeletePermanently = _ref.onDeletePermanently,
      onDeselectAllDocuments = _ref.onDeselectAllDocuments,
      onDeselectMergeDocument = _ref.onDeselectMergeDocument,
      onEndBatchCategoriesMode = _ref.onEndBatchCategoriesMode,
      onEndBatchDownloadMode = _ref.onEndBatchDownloadMode,
      onEndBatchEditMode = _ref.onEndBatchEditMode,
      onEndHamburgerMode = _ref.onEndHamburgerMode,
      onEndMergeDocumentsMode = _ref.onEndMergeDocumentsMode,
      onMergeDocuments = _ref.onMergeDocuments,
      onHideDeletePermanently = _ref.onHideDeletePermanently,
      onHideTrashMultipleDocuments = _ref.onHideTrashMultipleDocuments,
      onRestoreDocuments = _ref.onRestoreDocuments,
      onSelectAllDocuments = _ref.onSelectAllDocuments,
      onShowDeletePermanently = _ref.onShowDeletePermanently,
      onSelectMergeDocument = _ref.onSelectMergeDocument,
      onSelectMergeField = _ref.onSelectMergeField,
      onStartBatchCategoriesMode = _ref.onStartBatchCategoriesMode,
      onStartBatchDownloadMode = _ref.onStartBatchDownloadMode,
      onStartBatchEditMode = _ref.onStartBatchEditMode,
      onStartHamburgerMode = _ref.onStartHamburgerMode,
      onStartMergeDocumentsMode = _ref.onStartMergeDocumentsMode,
      onSubmitBatchAssignCategories = _ref.onSubmitBatchAssignCategories,
      onSubmitBatchDownloadDocuments = _ref.onSubmitBatchDownloadDocuments,
      onSubmitBatchEdit = _ref.onSubmitBatchEdit,
      onShowTrashMultipleDocuments = _ref.onShowTrashMultipleDocuments,
      onStartExportMode = _ref.onStartExportMode,
      onTrashMultipleDocuments = _ref.onTrashMultipleDocuments,
      preferredCurrency = _ref.preferredCurrency,
      documents = _ref.documents,
      selectedMergeDocumentId = _ref.selectedMergeDocumentId,
      selectedDocumentIds = _ref.selectedDocumentIds,
      userEmail = _ref.userEmail,
      vendors = _ref.vendors;

  if (isTrash) {
    return _react2.default.createElement(
      "div",
      { className: _multiDocumentActionsContainer2.default.container },
      _react2.default.createElement(
        "div",
        { className: _multiDocumentActionsContainer2.default["trash-actions"] },
        _react2.default.createElement(
          "span",
          { className: _multiDocumentActionsContainer2.default.back, onClick: onDeselectAllDocuments },
          "\u2B05 Back"
        ),
        _react2.default.createElement(
          "span",
          { className: _multiDocumentActionsContainer2.default["info-label"] },
          (0, _stringHelpers.pluralize)(selectedDocumentIds.length, "documents selected", "document selected"),
          renderSelectAllButton(selectedDocumentIds, onSelectAllDocuments, accountId, filters)
        ),
        _react2.default.createElement(
          _button.Button,
          { loading: isRestoreDocumentsLoading, onClick: onRestoreDocuments },
          "Restore"
        ),
        _react2.default.createElement(
          _button.Button,
          { danger: true, onClick: onShowDeletePermanently },
          "Delete Permanently"
        )
      ),
      _react2.default.createElement(_deletePermanentlyModal.DeletePermanentlyModal, {
        isDeletePermanentlyLoading: isDeletePermanentlyLoading,
        isDeletePermanentlyVisible: isDeletePermanentlyVisible,
        onDeletePermanently: onDeletePermanently,
        onHideDeletePermanently: onHideDeletePermanently,
        selectedIds: selectedDocumentIds
      })
    );
  }
  return _react2.default.createElement(
    "div",
    { className: _multiDocumentActionsContainer2.default.container },
    _react2.default.createElement(
      "span",
      { className: _multiDocumentActionsContainer2.default.back, onClick: onDeselectAllDocuments },
      "\u2B05 Back"
    ),
    _react2.default.createElement(
      "span",
      { className: _multiDocumentActionsContainer2.default["info-label"] },
      (0, _stringHelpers.pluralize)(selectedDocumentIds.length, "documents selected", "document selected"),
      renderSelectAllButton(selectedDocumentIds, onSelectAllDocuments, accountId, filters)
    ),
    _react2.default.createElement(
      "div",
      { className: _multiDocumentActionsContainer2.default["actions-buttons"] },
      batchEditButton(onStartBatchEditMode),
      _react2.default.createElement(
        _dropdownModal.DropdownModal,
        { offsetLeft: -116, offsetTop: 20, onClose: onEndBatchEditMode, visible: isBatchEditMode },
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(_batchEditForm.BatchEditForm, {
            currencies: currencies,
            isLoading: isBatchEditLoading,
            onClose: onEndBatchEditMode,
            onSubmitBatchEdit: onSubmitBatchEdit,
            vendors: vendors
          })
        )
      ),
      _react2.default.createElement(
        _button.Button,
        { onClick: onStartBatchCategoriesMode },
        "Assign categories"
      ),
      _react2.default.createElement(
        _dropdownModal.DropdownModal,
        {
          offsetLeft: -146,
          offsetTop: 20,
          onClose: onEndBatchCategoriesMode,
          visible: isBatchCategoriesMode,
          width: 350
        },
        _react2.default.createElement(_assignCategoriesForm.AssignCategoriesForm, {
          accountId: accountId,
          categories: categories,
          isLoading: isBatchCategoriesLoading,
          onCancel: onEndBatchCategoriesMode,
          onCreateCategory: onCreateCategory,
          onSave: onSubmitBatchAssignCategories
        })
      ),
      _react2.default.createElement(_exportButton.ExportButton, {
        accountSlug: accountSlug,
        glCodes: glCodes,
        onLinkAccount: function onLinkAccount() {
          return null;
        },
        onStartExportMode: onStartExportMode,
        selectedDocumentIds: selectedDocumentIds
      }),
      _react2.default.createElement(
        _button.Button,
        { onClick: onStartHamburgerMode },
        _react2.default.createElement(_bars2.default, { size: 15 })
      ),
      _react2.default.createElement(
        _dropdownModal.DropdownModal,
        {
          offsetLeft: -50,
          offsetTop: 20,
          onClose: onEndHamburgerMode,
          visible: isHamburgerMode,
          width: 180
        },
        _react2.default.createElement(_multiDocumentsActionsHamburger.MultiDocumentsActionsHamburger, {
          columns: _columnObjects.mergeDocumentsColumnObjects,
          documents: documents,
          isBatchDownloadLoading: isBatchDownloadLoading,
          isBatchDownloadMode: isBatchDownloadMode,
          isMergeDocumentsLoading: isMergeDocumentsLoading,
          isMergeDocumentsMode: isMergeDocumentsMode,
          mergeDocument: mergeDocument,
          onChangeViewedSetting: onChangeViewedSetting,
          onDeselectMergeDocument: onDeselectMergeDocument,
          onEndBatchDownloadMode: onEndBatchDownloadMode,
          onEndHamburgerMode: onEndHamburgerMode,
          onEndMergeDocumentsMode: onEndMergeDocumentsMode,
          onMergeDocuments: onMergeDocuments,
          onSelectMergeDocument: onSelectMergeDocument,
          onSelectMergeField: onSelectMergeField,
          onStartBatchDownloadMode: onStartBatchDownloadMode,
          onStartHamburgerMode: onStartHamburgerMode,
          onStartMergeDocumentsMode: onStartMergeDocumentsMode,
          onSubmitBatchDownloadDocuments: onSubmitBatchDownloadDocuments,
          preferredCurrency: preferredCurrency,
          selectedDocumentIds: selectedDocumentIds,
          selectedMergeDocumentId: selectedMergeDocumentId,
          userEmail: userEmail
        })
      ),
      _react2.default.createElement(
        "div",
        { className: _multiDocumentActionsContainer2.default.trash },
        _react2.default.createElement(
          _button.Button,
          { danger: true, onClick: onShowTrashMultipleDocuments },
          "Trash"
        ),
        _react2.default.createElement(_trashMultipleDocumentsModal.TrashMultipleDocumentsModal, {
          isTrashMultipleDocumentsLoading: isTrashMultipleDocumentsLoading,
          isTrashMultipleDocumentsVisible: isTrashMultipleDocumentsVisible,
          onHideTrashMultipleDocuments: onHideTrashMultipleDocuments,
          onTrashMultipleDocuments: onTrashMultipleDocuments
        })
      )
    )
  );
};

content.propTypes = MultiDocumentActionsContainer.propTypes;

var batchEditButton = function batchEditButton(onStartBatchEditMode) {
  return _react2.default.createElement(
    _button.Button,
    { onClick: onStartBatchEditMode },
    _react2.default.createElement(
      "span",
      null,
      _react2.default.createElement(_pencil2.default, { className: _multiDocumentActionsContainer2.default["edit-icon"], size: 15 }),
      "Batch edit"
    )
  );
};

var renderSelectAllButton = exports.renderSelectAllButton = function renderSelectAllButton(selectedDocumentIds, onSelectAllDocuments, accountId, filters) {
  if (selectedDocumentIds.length >= 20) {
    return _react2.default.createElement(
      _button.Button,
      { link: true, onClick: function onClick() {
          return onSelectAllDocuments(accountId, filters);
        } },
      "select all"
    );
  }
  return null;
};

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiDocumentsActionsHamburger = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _multiDocumentActionsContainer = __webpack_require__(513);

var _multiDocumentActionsContainer2 = _interopRequireDefault(_multiDocumentActionsContainer);

var _customPropTypes = __webpack_require__(5);

var _dropdownModal = __webpack_require__(165);

var _button = __webpack_require__(7);

var _mergeDocumentsModal = __webpack_require__(877);

var _batchDownloadForm = __webpack_require__(875);

var _setViewedDisplay = __webpack_require__(865);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MultiDocumentsActionsHamburger = exports.MultiDocumentsActionsHamburger = function MultiDocumentsActionsHamburger(_ref) {
  var columns = _ref.columns,
      isBatchDownloadLoading = _ref.isBatchDownloadLoading,
      isBatchDownloadMode = _ref.isBatchDownloadMode,
      isMergeDocumentsLoading = _ref.isMergeDocumentsLoading,
      isMergeDocumentsMode = _ref.isMergeDocumentsMode,
      mergeDocument = _ref.mergeDocument,
      onChangeViewedSetting = _ref.onChangeViewedSetting,
      onDeselectMergeDocument = _ref.onDeselectMergeDocument,
      onEndBatchDownloadMode = _ref.onEndBatchDownloadMode,
      onEndMergeDocumentsMode = _ref.onEndMergeDocumentsMode,
      onMergeDocuments = _ref.onMergeDocuments,
      onSelectMergeDocument = _ref.onSelectMergeDocument,
      onSelectMergeField = _ref.onSelectMergeField,
      onStartBatchDownloadMode = _ref.onStartBatchDownloadMode,
      onStartMergeDocumentsMode = _ref.onStartMergeDocumentsMode,
      onSubmitBatchDownloadDocuments = _ref.onSubmitBatchDownloadDocuments,
      preferredCurrency = _ref.preferredCurrency,
      documents = _ref.documents,
      selectedMergeDocumentId = _ref.selectedMergeDocumentId,
      selectedDocumentIds = _ref.selectedDocumentIds,
      userEmail = _ref.userEmail;

  var findDocuments = function findDocuments(id) {
    return documents.find(function (document) {
      return document.id === id;
    });
  };
  var selectedDocuments = selectedDocumentIds.map(findDocuments);
  return _react2.default.createElement(
    "div",
    { className: _multiDocumentActionsContainer2.default["hamburger-menu"] },
    _react2.default.createElement(
      _button.Button,
      { link: true, onClick: onStartBatchDownloadMode },
      "Download as..."
    ),
    _react2.default.createElement(
      _dropdownModal.DropdownModal,
      {
        offsetLeft: -50,
        offsetTop: 20,
        onClose: onEndBatchDownloadMode,
        visible: isBatchDownloadMode,
        width: 350
      },
      _react2.default.createElement(_batchDownloadForm.BatchDownloadForm, {
        defaultEmail: userEmail,
        isLoading: isBatchDownloadLoading,
        onCancel: onEndBatchDownloadMode,
        onSave: onSubmitBatchDownloadDocuments
      })
    ),
    _react2.default.createElement(_setViewedDisplay.SetViewedDisplay, {
      documents: documents,
      onChangeViewedSetting: onChangeViewedSetting,
      selectedDocumentIds: selectedDocumentIds
    }),
    renderMergeDocumentsButton(onStartMergeDocumentsMode, documents, selectedDocumentIds, selectedDocuments),
    _react2.default.createElement(_mergeDocumentsModal.MergeDocumentsModal, {
      columns: columns,
      documents: documents,
      isMergeDocumentsLoading: isMergeDocumentsLoading,
      isMergeDocumentsMode: isMergeDocumentsMode,
      mergeDocument: mergeDocument,
      onDeselectMergeDocument: onDeselectMergeDocument,
      onEndMergeDocumentsMode: onEndMergeDocumentsMode,
      onMergeDocuments: onMergeDocuments,
      onSelectMergeDocument: onSelectMergeDocument,
      onSelectMergeField: onSelectMergeField,
      preferredCurrency: preferredCurrency,
      selectedDocuments: selectedDocuments,
      selectedMergeDocumentId: selectedMergeDocumentId
    })
  );
};

MultiDocumentsActionsHamburger.defaultProps = {
  mergeDocument: null,
  selectedMergeDocumentId: "",
  selectedDocumentIds: []
};

MultiDocumentsActionsHamburger.propTypes = {
  columns: _propTypes2.default.arrayOf(_customPropTypes.dataType).isRequired,
  documents: _propTypes2.default.arrayOf(_customPropTypes.documentPropType).isRequired,
  isBatchDownloadLoading: _propTypes2.default.bool.isRequired,
  isBatchDownloadMode: _propTypes2.default.bool.isRequired,
  isMergeDocumentsLoading: _propTypes2.default.bool.isRequired,
  isMergeDocumentsMode: _propTypes2.default.bool.isRequired,
  mergeDocument: _customPropTypes.mergeDocumentType,
  onChangeViewedSetting: _propTypes2.default.func.isRequired,
  onDeselectMergeDocument: _propTypes2.default.func.isRequired,
  onEndBatchDownloadMode: _propTypes2.default.func.isRequired,
  onEndMergeDocumentsMode: _propTypes2.default.func.isRequired,
  onMergeDocuments: _propTypes2.default.func.isRequired,
  onSelectMergeDocument: _propTypes2.default.func.isRequired,
  onSelectMergeField: _propTypes2.default.func.isRequired,
  onStartBatchDownloadMode: _propTypes2.default.func.isRequired,
  onStartMergeDocumentsMode: _propTypes2.default.func.isRequired,
  onSubmitBatchDownloadDocuments: _propTypes2.default.func.isRequired,
  preferredCurrency: _propTypes2.default.string.isRequired,
  selectedDocumentIds: _propTypes2.default.arrayOf(_propTypes2.default.string),
  selectedMergeDocumentId: _propTypes2.default.string,
  userEmail: _propTypes2.default.string.isRequired
};

var renderMergeDocumentsButton = function renderMergeDocumentsButton(onStartMergeDocumentsMode, documents, selectedDocumentIds, selectedDocuments) {
  var isAllDocuments = selectedDocuments.some(function (document) {
    return document.type !== "receipt";
  });
  if (selectedDocumentIds.length === 1 || isAllDocuments) {
    return null;
  }
  return _react2.default.createElement(
    _button.Button,
    { link: true, onClick: function onClick() {
        return onStartMergeDocumentsMode(documents, selectedDocumentIds[0]);
      } },
    "Merge documents"
  );
};

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RenderedDocument = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSticky = __webpack_require__(259);

var _customPropTypes = __webpack_require__(5);

var _longArrowUp = __webpack_require__(1011);

var _longArrowUp2 = _interopRequireDefault(_longArrowUp);

var _documentViewer = __webpack_require__(512);

var _documentViewer2 = _interopRequireDefault(_documentViewer);

var _modal = __webpack_require__(27);

var _button = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RenderedDocument = exports.RenderedDocument = function RenderedDocument(props) {
  if (!props.isDraggable) {
    return _react2.default.createElement(
      _reactSticky.Sticky,
      { stickyStyle: { top: "150px" }, topOffset: -200 },
      _react2.default.createElement(Document, props)
    );
  }
  return _react2.default.createElement(Document, props);
};

RenderedDocument.propTypes = {
  isDraggable: _propTypes2.default.bool.isRequired
};

var Document = function Document(_ref) {
  var focusedDocument = _ref.focusedDocument,
      isDraggable = _ref.isDraggable,
      onEndDraggableMode = _ref.onEndDraggableMode,
      onHideDocumentViewer = _ref.onHideDocumentViewer,
      onStartDraggableMode = _ref.onStartDraggableMode;
  return _react2.default.createElement(
    _modal.DraggableModal,
    { handle: ".toolbar", isDisabled: !isDraggable, isVisible: true },
    _react2.default.createElement(
      "div",
      { className: _documentViewer2.default["draggable-container"] },
      _react2.default.createElement(
        "div",
        { className: _documentViewer2.default.toolbar + " toolbar " + draggableClass(isDraggable) },
        _react2.default.createElement(
          "span",
          { className: _documentViewer2.default["toolbar-buttons"] },
          _react2.default.createElement(
            _button.Button,
            { onClick: isDraggable ? onEndDraggableMode : onStartDraggableMode },
            _react2.default.createElement(_longArrowUp2.default, { className: isDraggable ? _documentViewer2.default["right-arrow"] : _documentViewer2.default["left-arrow"], size: 15 })
          ),
          _react2.default.createElement(
            "span",
            { className: _documentViewer2.default.close + " " + _documentViewer2.default["close-document"], onClick: onHideDocumentViewer },
            "+"
          )
        ),
        _react2.default.createElement("iframe", { className: isDraggable ? _documentViewer2.default.resizeable : _documentViewer2.default.framer, src: focusedDocument.attachment.url })
      )
    )
  );
};

Document.propTypes = {
  focusedDocument: _customPropTypes.focusedDocumentType.isRequired,
  isDraggable: _propTypes2.default.bool.isRequired,
  onEndDraggableMode: _propTypes2.default.func.isRequired,
  onHideDocumentViewer: _propTypes2.default.func.isRequired,
  onStartDraggableMode: _propTypes2.default.func.isRequired
};

var draggableClass = function draggableClass(isDraggable) {
  if (isDraggable) {
    return _documentViewer2.default["draggable-toolbar"];
  }
  return null;
};

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SetViewedDisplay = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _customPropTypes = __webpack_require__(5);

var _button = __webpack_require__(7);

var _setViewedDisplay = __webpack_require__(1332);

var _setViewedDisplay2 = _interopRequireDefault(_setViewedDisplay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SetViewedDisplay = exports.SetViewedDisplay = function SetViewedDisplay(_ref) {
  var onChangeViewedSetting = _ref.onChangeViewedSetting,
      documents = _ref.documents,
      selectedDocumentIds = _ref.selectedDocumentIds;

  var selectedDocuments = selectedDocumentIds.map(function (id) {
    return documents.find(function (document) {
      return document.id === id;
    });
  });
  var viewedArray = selectedDocuments.filter(function (doc) {
    return doc.viewed === true;
  });
  switch (viewedArray.length) {
    case selectedDocuments.length:
      return _react2.default.createElement(
        _button.Button,
        { link: true, onClick: function onClick() {
            onChangeViewedSetting(false);
          } },
        "Mark as unviewed"
      );
    case 0:
      return _react2.default.createElement(
        _button.Button,
        { link: true, onClick: function onClick() {
            onChangeViewedSetting(true);
          } },
        "Mark as viewed"
      );
    default:
      return _react2.default.createElement(
        "div",
        { className: _setViewedDisplay2.default["viewed-buttons"] },
        _react2.default.createElement(
          "div",
          { className: _setViewedDisplay2.default.button },
          _react2.default.createElement(
            _button.Button,
            { link: true, onClick: function onClick() {
                onChangeViewedSetting(true);
              } },
            "Mark as viewed"
          )
        ),
        _react2.default.createElement(
          "div",
          { className: _setViewedDisplay2.default.button },
          _react2.default.createElement(
            _button.Button,
            { link: true, onClick: function onClick() {
                onChangeViewedSetting(false);
              } },
            "Mark as unviewed"
          )
        )
      );
  }
};

SetViewedDisplay.propTypes = {
  documents: _propTypes2.default.arrayOf(_customPropTypes.documentPropType).isRequired,
  onChangeViewedSetting: _propTypes2.default.func.isRequired,
  selectedDocumentIds: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired
};

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GeneralLedgerActionsPanel = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _openSquirrel = __webpack_require__(328);

var _openSquirrel2 = _interopRequireDefault(_openSquirrel);

var _exclamationTriangle = __webpack_require__(276);

var _exclamationTriangle2 = _interopRequireDefault(_exclamationTriangle);

var _categoriesActionsPanel = __webpack_require__(1318);

var _categoriesActionsPanel2 = _interopRequireDefault(_categoriesActionsPanel);

var _grid = __webpack_require__(399);

var _grid2 = _interopRequireDefault(_grid);

var _reactVirtualizedSelect = __webpack_require__(260);

var _reactVirtualizedSelect2 = _interopRequireDefault(_reactVirtualizedSelect);

var _customPropTypes = __webpack_require__(5);

var _splitCategories = __webpack_require__(444);

var _financialYear = __webpack_require__(197);

var _validators = __webpack_require__(36);

var _button = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GeneralLedgerActionsPanel = exports.GeneralLedgerActionsPanel = function GeneralLedgerActionsPanel(props) {
  if (props.isGLCodesVisible && props.filters.type !== "other") {
    return renderGeneralLedgerPanel(props);
  }
  return null;
};

var renderGeneralLedgerPanel = function renderGeneralLedgerPanel(props) {
  if (props.glCodes.length === 0) {
    return _react2.default.createElement(
      "div",
      { className: _categoriesActionsPanel2.default["categories-actions-container"] + " " + _categoriesActionsPanel2.default.none },
      _react2.default.createElement(
        "div",
        { className: _categoriesActionsPanel2.default["no-integration"] },
        _react2.default.createElement("img", { alt: "open armed squirrel", className: _categoriesActionsPanel2.default.squirrel, src: _openSquirrel2.default }),
        _react2.default.createElement(
          "p",
          null,
          "Darn! It looks like you haven't set up your accounting integration yet."
        ),
        _react2.default.createElement(
          _button.Button,
          { onClick: props.onLinkAccount, primary: true },
          "Link your accounting software"
        )
      )
    );
  }

  return _react2.default.createElement(
    "div",
    { className: _categoriesActionsPanel2.default["categories-actions-container"] },
    _react2.default.createElement(
      "div",
      { className: _categoriesActionsPanel2.default["categories-title"] },
      "GL Codes"
    ),
    props.documents.map(function (document, index, documentsArray) {
      return renderRules(document, index, documentsArray, props);
    })
  );
};

renderGeneralLedgerPanel.defaultProps = {
  glCodes: []
};

renderGeneralLedgerPanel.propTypes = {
  documents: _react.PropTypes.arrayOf(_customPropTypes.documentPropType).isRequired,
  glCodes: _react.PropTypes.arrayOf(_customPropTypes.categoryType),
  onLinkAccount: _react.PropTypes.func.isRequired
};

var renderRules = function renderRules(document, index, documentsArray, props) {
  var data = (0, _splitCategories.splitCategories)(categoriesMapper(document.categories));
  return _react2.default.createElement(
    "div",
    { className: _grid2.default.row, key: document.id },
    _react2.default.createElement(
      "div",
      { className: _categoriesActionsPanel2.default["export-documents"] + " " + _grid2.default["col-sm-9"] },
      _react2.default.createElement(_reactVirtualizedSelect2.default, {
        clearable: true,
        onChange: function onChange(value) {
          props.setGlCode(document, value);
        },
        onInputKeyDown: function onInputKeyDown(e) {
          nextDocument(e, index, documentsArray, props.setDocumentUrl);
        },
        options: optionsMapper(props.glCodes),
        placeholder: "Enter a GL code for vendor: " + document.vendor,
        resetValue: { key: "clear-category" },
        value: getValue(data)
      })
    ),
    _react2.default.createElement(
      "div",
      { className: _categoriesActionsPanel2.default["rule-creation"] + " " + _grid2.default["col-sm-1"] },
      _react2.default.createElement(
        _button.Button,
        {
          onClick: changeOnClick(data, document, props.onAddIncludeRule, props.onAddRuleError),
          primary: true
        },
        "+"
      ),
      _react2.default.createElement(
        "div",
        { className: _categoriesActionsPanel2.default.tooltip + " " + _categoriesActionsPanel2.default["rule-tooltip"] },
        "Add a new rule"
      )
    ),
    renderError(document, props.preferredCurrency)
  );
};

renderRules.defaultProps = {
  glCodes: []
};

renderRules.propTypes = {
  glCodes: _react.PropTypes.arrayOf(_customPropTypes.categoryType),
  onAddIncludeRule: _react.PropTypes.func.isRequired,
  onAddRuleError: _react.PropTypes.func.isRequired,
  preferredCurrency: _react.PropTypes.string.isRequired,
  setDocumentUrl: _react.PropTypes.func.isRequired,
  setGlCode: _react.PropTypes.func.isRequired
};

var nextDocument = function nextDocument(e, index, documentsArray, setDocumentUrl) {
  if (e.key === "Tab") {
    setDocumentUrl(documentsArray[index + 1].attachment.url);
  }
  return null;
};

var categoriesMapper = function categoriesMapper(categories) {
  return (categories || []).map(function (category) {
    var strippedCategory = _ramda2.default.drop(1, category.split("-")).join("-");
    return { name: category, key: strippedCategory };
  });
};

var optionsMapper = function optionsMapper(value) {
  return value.map(function (val) {
    return { label: val.newName, value: val.newName, key: val.name };
  });
};

var getValue = function getValue(data) {
  if (data.glCodes[0] === undefined) {
    return null;
  }
  return { label: data.glCodes[0].key, value: data.glCodes[0].name };
};

var changeOnClick = function changeOnClick(data, document, onAddIncludeRule, onAddRuleError) {
  var accountId = document.accountId;
  var vendorName = document.vendor;
  var glCode = data.glCodes.length > 0 ? data.glCodes[0] : [];
  if (data.glCodes.length === 0) {
    return function () {
      return onAddRuleError();
    };
  }
  return function () {
    return onAddIncludeRule({ accountId: accountId, glCode: glCode, vendorName: vendorName });
  };
};

var renderError = function renderError(document, preferredCurrency) {
  var message = getErrorMessage(document, preferredCurrency);
  var errorColor = message.includes(">10% GST") ? _categoriesActionsPanel2.default.red : null;
  if (message !== "") {
    return _react2.default.createElement(
      "div",
      { className: _grid2.default["col-md-2"] + " " + _categoriesActionsPanel2.default.error },
      _react2.default.createElement(_exclamationTriangle2.default, { className: _categoriesActionsPanel2.default.warning + " " + errorColor, size: 14 }),
      _react2.default.createElement(
        "div",
        { className: _categoriesActionsPanel2.default.tooltip + " " + _categoriesActionsPanel2.default["error-tooltip"] },
        message
      )
    );
  }
  return null;
};

var getErrorMessage = function getErrorMessage(document, preferredCurrency) {
  var errorMessage = "";
  if (!(0, _validators.isValidValue)(document.tax) || document.tax === 0) {
    errorMessage = "No GST";
  }
  if (document.tax > document.total * 0.1) {
    var text = errorMessage.length > 0 ? ", >10% GST" : ">10% GST";
    errorMessage += text;
  }
  if ((0, _moment2.default)().isBefore(document.issued)) {
    var _text = errorMessage.length > 0 ? ", receipt is future dated" : "Receipt is future dated";
    errorMessage += _text;
  }

  var _getThisFinancialYear = (0, _financialYear.getThisFinancialYear)(preferredCurrency),
      startDate = _getThisFinancialYear.startDate,
      endDate = _getThisFinancialYear.endDate;

  if (!(0, _moment2.default)(document.issued).isBetween(startDate, endDate)) {
    var _text2 = errorMessage.length > 0 ? ", document is from last financial year" : "Document is from last financial year";
    errorMessage += _text2;
  }
  return errorMessage;
};

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentFilters = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _documentFilters = __webpack_require__(324);

var _documentFilters2 = _interopRequireDefault(_documentFilters);

var _search = __webpack_require__(277);

var _search2 = _interopRequireDefault(_search);

var _plus = __webpack_require__(451);

var _plus2 = _interopRequireDefault(_plus);

var _customPropTypes = __webpack_require__(5);

var _keyPress = __webpack_require__(198);

var _select = __webpack_require__(45);

var _dateRange = __webpack_require__(419);

var _paymentTypeFilterField = __webpack_require__(429);

var _activeFilters = __webpack_require__(427);

var _exportTypeSelector = __webpack_require__(268);

var _documentTypeSelector = __webpack_require__(428);

var _totalRange = __webpack_require__(868);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DocumentFilters = exports.DocumentFilters = function DocumentFilters(_ref) {
  var cardNumbers = _ref.cardNumbers,
      categories = _ref.categories,
      currencies = _ref.currencies,
      endDate = _ref.endDate,
      envelopes = _ref.envelopes,
      exportType = _ref.exportType,
      isExports = _ref.isExports,
      lastFourDigits = _ref.lastFourDigits,
      name = _ref.name,
      onAddCardNumber = _ref.onAddCardNumber,
      onAddCategory = _ref.onAddCategory,
      onAddCurrency = _ref.onAddCurrency,
      onAddDocumentType = _ref.onAddDocumentType,
      onAddEndDate = _ref.onAddEndDate,
      onAddEnvelope = _ref.onAddEnvelope,
      onAddSearchQuery = _ref.onAddSearchQuery,
      onAddNameToFilter = _ref.onAddNameToFilter,
      onAddPaymentType = _ref.onAddPaymentType,
      onAddStartDate = _ref.onAddStartDate,
      onAddTotalFilter = _ref.onAddTotalFilter,
      onAddVendor = _ref.onAddVendor,
      onAddViewedStatus = _ref.onAddViewedStatus,
      onClearExportType = _ref.onClearExportType,
      onRemoveCardNumber = _ref.onRemoveCardNumber,
      onRemoveCategory = _ref.onRemoveCategory,
      onRemoveCurrency = _ref.onRemoveCurrency,
      onRemoveDocumentType = _ref.onRemoveDocumentType,
      onRemoveEnvelope = _ref.onRemoveEnvelope,
      onRemoveSearchQuery = _ref.onRemoveSearchQuery,
      onRemoveNameFromFilter = _ref.onRemoveNameFromFilter,
      onRemovePaymentType = _ref.onRemovePaymentType,
      onRemoveVendor = _ref.onRemoveVendor,
      onRemoveViewedStatus = _ref.onRemoveViewedStatus,
      onSetExportType = _ref.onSetExportType,
      onUpdateName = _ref.onUpdateName,
      onUpdateSearchQuery = _ref.onUpdateSearchQuery,
      onUpdateTotalFilter = _ref.onUpdateTotalFilter,
      preferredCurrency = _ref.preferredCurrency,
      searchQueryString = _ref.searchQueryString,
      selectedCardNumbers = _ref.selectedCardNumbers,
      selectedCategories = _ref.selectedCategories,
      selectedCurrencies = _ref.selectedCurrencies,
      selectedEnvelopes = _ref.selectedEnvelopes,
      selectedPaymentTypes = _ref.selectedPaymentTypes,
      selectedName = _ref.selectedName,
      selectedSearchQueryString = _ref.selectedSearchQueryString,
      selectedVendors = _ref.selectedVendors,
      startDate = _ref.startDate,
      totalMax = _ref.totalMax,
      totalMin = _ref.totalMin,
      type = _ref.type,
      vendors = _ref.vendors,
      viewedStatus = _ref.viewedStatus;
  return _react2.default.createElement(
    "div",
    { className: _documentFilters2.default.container },
    _react2.default.createElement(
      "h3",
      { className: _documentFilters2.default.title },
      "Filter by:"
    ),
    _react2.default.createElement(
      "div",
      { className: _documentFilters2.default["field-cell"] },
      _react2.default.createElement(_documentTypeSelector.DocumentTypeSelector, { onChange: onAddDocumentType })
    ),
    _react2.default.createElement(
      "div",
      { className: _documentFilters2.default["field-cell"] },
      _react2.default.createElement(
        "span",
        null,
        "Vendor"
      ),
      _react2.default.createElement(_select.Select, { data: mapVendors(vendors), onChange: onAddVendor, placeholder: "Select a vendor..." })
    ),
    _react2.default.createElement(
      "div",
      { className: _documentFilters2.default["field-cell"] },
      _react2.default.createElement(
        "span",
        null,
        "Document name"
      ),
      _react2.default.createElement(
        "div",
        { className: _documentFilters2.default.search },
        _react2.default.createElement("input", {
          className: _documentFilters2.default.fields,
          onChange: function onChange(e) {
            return onUpdateName(e.target.value);
          },
          onKeyDown: function onKeyDown(e) {
            return (0, _keyPress.onEnterPressed)(e, name, onAddNameToFilter);
          },
          placeholder: "Add a document name",
          value: name
        }),
        _react2.default.createElement(_plus2.default, { className: _documentFilters2.default["plus-button"], onClick: function onClick() {
            return onAddNameToFilter(name);
          } })
      )
    ),
    _react2.default.createElement(
      "div",
      { className: _documentFilters2.default["field-cell"] },
      _react2.default.createElement(
        "span",
        null,
        "Category"
      ),
      _react2.default.createElement(_select.Select, { data: mapCategories(categories), onChange: onAddCategory, placeholder: "Select a category..." })
    ),
    _react2.default.createElement(
      "div",
      { className: _documentFilters2.default["field-cell"] },
      _react2.default.createElement(
        "span",
        null,
        "Total"
      ),
      _react2.default.createElement(_totalRange.TotalRange, {
        onAddTotalFilter: onAddTotalFilter,
        onUpdateTotalFilter: onUpdateTotalFilter,
        totalMax: totalMax,
        totalMin: totalMin
      })
    ),
    _react2.default.createElement(
      "div",
      { className: _documentFilters2.default["field-cell"] },
      _react2.default.createElement(
        "span",
        null,
        "Date Range"
      ),
      _react2.default.createElement(_dateRange.DateRange, {
        currency: preferredCurrency,
        endDate: endDate,
        onAddEndDate: onAddEndDate,
        onAddStartDate: onAddStartDate,
        startDate: startDate
      })
    ),
    _react2.default.createElement(
      "div",
      { className: _documentFilters2.default["field-cell"] },
      _react2.default.createElement(
        "span",
        null,
        "Envelope"
      ),
      _react2.default.createElement(_select.Select, {
        data: mapEnvelopes(envelopes),
        onChange: onAddEnvelope,
        placeholder: "Select an envelope..."
      })
    ),
    _react2.default.createElement(
      "div",
      { className: _documentFilters2.default["field-cell"] },
      _react2.default.createElement(
        "span",
        null,
        "Currency"
      ),
      _react2.default.createElement(_select.SimpleSelect, {
        data: mapCurrencies(currencies),
        onChange: onAddCurrency,
        placeholder: "Select a currency..."
      })
    ),
    _react2.default.createElement(
      "div",
      { className: _documentFilters2.default["field-cell"] },
      _react2.default.createElement(
        "span",
        null,
        "Viewed"
      ),
      _react2.default.createElement(_select.SimpleSelect, {
        data: viewedArray,
        onChange: onAddViewedStatus,
        placeholder: "Select viewed status..."
      })
    ),
    _react2.default.createElement(
      "div",
      { className: _documentFilters2.default["field-cell"] },
      _react2.default.createElement(
        "span",
        null,
        "Search"
      ),
      _react2.default.createElement(
        "div",
        { className: _documentFilters2.default.search },
        _react2.default.createElement("input", {
          className: _documentFilters2.default.fields,
          onChange: function onChange(e) {
            return onUpdateSearchQuery(e.target.value);
          },
          onKeyDown: function onKeyDown(e) {
            return (0, _keyPress.onEnterPressed)(e, searchQueryString, onAddSearchQuery);
          },
          placeholder: "Search for documents here",
          value: searchQueryString
        }),
        _react2.default.createElement(_search2.default, { className: _documentFilters2.default["search-button"], onClick: function onClick() {
            return onAddSearchQuery(searchQueryString);
          } })
      )
    ),
    _react2.default.createElement(
      "div",
      { className: _documentFilters2.default["field-cell"] },
      _react2.default.createElement(
        "span",
        null,
        "Export Type"
      ),
      _react2.default.createElement(_exportTypeSelector.ExportTypeSelector, { categories: categories, onChange: onSetExportType })
    ),
    _react2.default.createElement(
      "div",
      { className: _documentFilters2.default["field-cell"] + " " + _documentFilters2.default["payment-type-container"] },
      _react2.default.createElement(
        "div",
        { className: _documentFilters2.default["payment-type"] },
        _react2.default.createElement(_paymentTypeFilterField.PaymentTypeFilterField, {
          cardNumbers: cardNumbers,
          lastFourDigits: lastFourDigits,
          onAddCardNumber: onAddCardNumber,
          onAddPaymentType: onAddPaymentType,
          selectedPaymentTypes: selectedPaymentTypes
        })
      )
    ),
    _react2.default.createElement(_activeFilters.ActiveFilters, {
      exportType: exportType,
      isExports: isExports,
      onClearExportType: onClearExportType,
      onRemoveCardNumber: onRemoveCardNumber,
      onRemoveCategory: onRemoveCategory,
      onRemoveCurrency: onRemoveCurrency,
      onRemoveDocumentType: onRemoveDocumentType,
      onRemoveEnvelope: onRemoveEnvelope,
      onRemoveNameFromFilter: onRemoveNameFromFilter,
      onRemovePaymentType: onRemovePaymentType,
      onRemoveSearchQuery: onRemoveSearchQuery,
      onRemoveVendor: onRemoveVendor,
      onRemoveViewedStatus: onRemoveViewedStatus,
      searchQueryString: selectedSearchQueryString,
      selectedCardNumbers: selectedCardNumbers,
      selectedCategories: selectedCategories,
      selectedCurrencies: selectedCurrencies,
      selectedDocumentType: type,
      selectedEnvelopes: selectedEnvelopes,
      selectedName: selectedName,
      selectedPaymentTypes: selectedPaymentTypes,
      selectedVendors: selectedVendors,
      viewedStatus: viewedStatus
    })
  );
};

DocumentFilters.defaultProps = {
  endDate: null,
  exportType: null,
  lastFourDigits: null,
  name: "",
  selectedSearchQueryString: null,
  startDate: null,
  totalMax: "",
  totalMin: "",
  type: null
};

DocumentFilters.propTypes = {
  cardNumbers: _propTypes2.default.arrayOf(_customPropTypes.cardNumberType).isRequired,
  categories: _propTypes2.default.arrayOf(_customPropTypes.categoryType).isRequired,
  currencies: _propTypes2.default.arrayOf(_customPropTypes.currencyType).isRequired,
  endDate: _customPropTypes.momentType,
  envelopes: _propTypes2.default.arrayOf(_customPropTypes.envelopeType).isRequired,
  exportType: _propTypes2.default.string,
  isExports: _propTypes2.default.bool.isRequired,
  lastFourDigits: _propTypes2.default.string,
  name: _propTypes2.default.string,
  onAddCardNumber: _propTypes2.default.func.isRequired, // (string) => void
  onAddCategory: _propTypes2.default.func.isRequired, // ({ key: string, name: string }) => void
  onAddCurrency: _propTypes2.default.func.isRequired, // ({ key: string, name: string }) => void
  onAddDocumentType: _propTypes2.default.func.isRequired,
  onAddEndDate: _propTypes2.default.func.isRequired,
  onAddEnvelope: _propTypes2.default.func.isRequired, // ({ key: string, name: string }) => void
  onAddNameToFilter: _propTypes2.default.func.isRequired,
  onAddPaymentType: _propTypes2.default.func.isRequired, // ({ key: string, name: string }) => void
  onAddSearchQuery: _propTypes2.default.func.isRequired,
  onAddStartDate: _propTypes2.default.func.isRequired,
  onAddTotalFilter: _propTypes2.default.func.isRequired,
  onAddVendor: _propTypes2.default.func.isRequired, // ({key: string, name: string}) => void
  onAddViewedStatus: _propTypes2.default.func.isRequired,
  onClearExportType: _propTypes2.default.func.isRequired, // () => void
  onRemoveCardNumber: _propTypes2.default.func.isRequired,
  onRemoveCategory: _propTypes2.default.func.isRequired, // (string) => void
  onRemoveCurrency: _propTypes2.default.func.isRequired, // (string) => void
  onRemoveDocumentType: _propTypes2.default.func.isRequired,
  onRemoveEnvelope: _propTypes2.default.func.isRequired, // (string) => void
  onRemoveNameFromFilter: _propTypes2.default.func.isRequired,
  onRemovePaymentType: _propTypes2.default.func.isRequired, // (string) => void
  onRemoveSearchQuery: _propTypes2.default.func.isRequired,
  onRemoveVendor: _propTypes2.default.func.isRequired, // (string) => void
  onRemoveViewedStatus: _propTypes2.default.func.isRequired,
  onSetExportType: _propTypes2.default.func.isRequired, // (string) => void
  onUpdateName: _propTypes2.default.func.isRequired,
  onUpdateSearchQuery: _propTypes2.default.func.isRequired,
  onUpdateTotalFilter: _propTypes2.default.func.isRequired,
  preferredCurrency: _propTypes2.default.string.isRequired,
  searchQueryString: _propTypes2.default.string.isRequired,
  selectedCardNumbers: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  selectedCategories: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  selectedCurrencies: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  selectedEnvelopes: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  selectedName: _propTypes2.default.string.isRequired,
  selectedPaymentTypes: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  selectedSearchQueryString: _propTypes2.default.string,
  selectedVendors: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  startDate: _customPropTypes.momentType,
  totalMax: _propTypes2.default.string,
  totalMin: _propTypes2.default.string,
  type: _propTypes2.default.string,
  vendors: _propTypes2.default.arrayOf(_customPropTypes.vendorType).isRequired,
  viewedStatus: _propTypes2.default.string.isRequired
};

var mapEnvelopes = function mapEnvelopes(envelopes) {
  var newEnvelopes = envelopes.map(function (envelope) {
    return { key: envelope.code, name: envelope.code };
  });
  return _ramda2.default.prepend({ key: "none", name: "No Envelopes" }, newEnvelopes);
};
var mapCategories = function mapCategories(categories) {
  var newCategories = categories.map(function (category) {
    return { key: category.name, name: category.name };
  });
  return _ramda2.default.prepend({ key: "none", name: "No category" }, newCategories);
};
var mapCurrencies = function mapCurrencies(currencies) {
  return currencies.map(function (currency) {
    return { key: currency.code, name: currency.code };
  });
};
var mapVendors = function mapVendors(vendors) {
  return vendors.map(function (vendor) {
    return { key: vendor.name, name: vendor.name };
  });
};

var viewedArray = [{
  key: "viewed",
  name: "Viewed"
}, {
  key: "unviewed",
  name: "Unviewed"
}];

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TotalRange = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _documentFilters = __webpack_require__(324);

var _documentFilters2 = _interopRequireDefault(_documentFilters);

var _stringHelpers = __webpack_require__(68);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TotalRange = exports.TotalRange = function TotalRange(_ref) {
  var onAddTotalFilter = _ref.onAddTotalFilter,
      onUpdateTotalFilter = _ref.onUpdateTotalFilter,
      totalMax = _ref.totalMax,
      totalMin = _ref.totalMin;
  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      "div",
      { className: _documentFilters2.default["start-container"] },
      _react2.default.createElement("input", {
        className: _documentFilters2.default.total,
        defaultValue: totalMin,
        onBlur: function onBlur(e) {
          return onAddTotalFilter("min", (0, _stringHelpers.normalizeNumber)(e.target.value));
        },
        onChange: function onChange(e) {
          return onUpdateTotalFilter("min", (0, _stringHelpers.normalizeNumber)(e.target.value));
        },
        placeholder: "Minimum total",
        type: "text"
      })
    ),
    _react2.default.createElement(
      "div",
      { className: _documentFilters2.default["end-container"] },
      _react2.default.createElement("input", {
        className: _documentFilters2.default.total,
        defaultValue: totalMax,
        onBlur: function onBlur(e) {
          return onAddTotalFilter("max", (0, _stringHelpers.normalizeNumber)(e.target.value));
        },
        onChange: function onChange(e) {
          return onUpdateTotalFilter("max", (0, _stringHelpers.normalizeNumber)(e.target.value));
        },
        placeholder: "Maximum total",
        type: "text"
      })
    )
  );
};

TotalRange.defaultProps = {
  totalMax: "",
  totalMin: ""
};

TotalRange.propTypes = {
  onAddTotalFilter: _propTypes2.default.func.isRequired,
  onUpdateTotalFilter: _propTypes2.default.func.isRequired,
  totalMax: _propTypes2.default.string,
  totalMin: _propTypes2.default.string
};

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderEmptyRow = exports.getRow = exports.getGridStyle = exports.Inbox = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _inbox = __webpack_require__(1328);

var _inbox2 = _interopRequireDefault(_inbox);

var _grid = __webpack_require__(95);

var _grid2 = _interopRequireDefault(_grid);

var _reactVirtualized = __webpack_require__(113);

var _customPropTypes = __webpack_require__(5);

var _documentViewer = __webpack_require__(856);

var _paginationBar = __webpack_require__(422);

var _dataGridActionsPanel = __webpack_require__(855);

var _changeDoctypeModal = __webpack_require__(871);

var _trashDocumentModal = __webpack_require__(430);

var _shareUrlModal = __webpack_require__(878);

var _documentFilters = __webpack_require__(867);

var _noDocuments = __webpack_require__(424);

var _drawer = __webpack_require__(420);

var _dropdown = __webpack_require__(860);

var _gridComponents = __webpack_require__(166);

var _generalLedgerActionsPanel = __webpack_require__(866);

var _documentsInlineTabs = __webpack_require__(425);

var _exportModal = __webpack_require__(861);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Inbox = function Inbox(props) {
  var rowHeight = 45;
  var visibleColumns = props.columns.filter(function (col) {
    return col.visible === true;
  });
  var focusDocument = function focusDocument(document, style, focusParam) {
    props.onDocumentViewed({ accountId: focusParam, document: document });
    props.onFocusDocument(document, style);
  };
  return _react2.default.createElement(
    "div",
    { className: _inbox2.default.container },
    _react2.default.createElement(_documentsInlineTabs.DocumentsInlineTabs, {
      accountSlug: props.accountSlug,
      currentPage: props.route.path,
      customTabs: props.customTabs,
      onStartDeleteCustomTabMode: props.onStartDeleteCustomTabMode,
      routeParams: props.router.params
    }),
    _react2.default.createElement(
      _drawer.Drawer,
      {
        isDrawerMode: props.isFiltersDrawerMode,
        onEndDrawerMode: props.onEndFiltersDrawerMode
      },
      _react2.default.createElement(_documentFilters.DocumentFilters, _extends({}, props, { isExports: false }))
    ),
    _react2.default.createElement(
      "div",
      { className: _grid2.default.row },
      _react2.default.createElement(
        "div",
        {
          className: getGridStyle("table", props.isDraggable, props.isDocumentViewerVisible, props.isGLCodesVisible)
        },
        _react2.default.createElement(_dataGridActionsPanel.DataGridActionsPanel, props),
        _react2.default.createElement(
          "div",
          { className: "documents3" },
          _react2.default.createElement(
            _reactVirtualized.AutoSizer,
            { disableHeight: true, onResize: function onResize(_ref) {
                var width = _ref.width;
                return props.onSetGridWidth(width);
              } },
            function () {
              return _react2.default.createElement(_reactVirtualized.MultiGrid, _extends({}, props, {
                cache: cache,
                cellRenderer: function cellRenderer(_ref2) {
                  var gridProps = _objectWithoutProperties(_ref2, []);

                  return _react2.default.createElement(_gridComponents.CellRenderer, _extends({}, gridProps, { newKey: gridProps.key }));
                },
                classNameBottomRightGrid: _inbox2.default["bottom-grid"],
                classNameTopRightGrid: _inbox2.default["top-grid"],
                columnCount: visibleColumns.length,
                columnWidth: function columnWidth(_ref3) {
                  var index = _ref3.index;
                  return (0, _gridComponents.getColumnWidth)(index, props.gridWidth, visibleColumns);
                },
                documents: props.documents,
                fixedRowCount: 1,
                focusParam: props.accountId,
                height: (0, _gridComponents.getGridHeight)(props.pagination.limit, props.documents.length, rowHeight),
                isRowFocusable: true,
                isSelectable: true,
                key: props.gridWidth + "-" + visibleColumns,
                noContentRenderer: function noContentRenderer() {
                  return renderEmptyRow(props.accountSlug, props.allDocumentsTotal);
                },
                onFocusRow: focusDocument,
                rowCount: props.documents.length + 1,
                rowHeight: rowHeight,
                selectedDocumentIds: props.selectedDocumentIds,
                width: props.gridWidth
              }));
            }
          ),
          _react2.default.createElement(_dropdown.Dropdown, _extends({}, props, { rowHeight: rowHeight }))
        ),
        _react2.default.createElement(_paginationBar.PaginationBar, _extends({}, props, {
          limit: props.pagination.limit,
          onChangeLimit: props.onSetPaginationLimit,
          pageNumber: props.pagination.pageNumber,
          totalResults: props.pagination.totalCountFiltered
        }))
      ),
      _react2.default.createElement(
        "div",
        {
          className: getGridStyle("viewer", props.isDraggable, props.isDocumentViewerVisible, props.isGLCodesVisible)
        },
        _react2.default.createElement(_documentViewer.DocumentViewer, {
          documents: props.documents,
          focusedDocument: props.focusedDocument,
          isDocumentViewerVisible: props.isDocumentViewerVisible,
          isDraggable: props.isDraggable,
          isGLCodesVisible: props.isGLCodesVisible,
          onEndDraggableMode: props.onEndDraggableMode,
          onHideDocumentViewer: props.onHideDocumentViewer,
          onStartDraggableMode: props.onStartDraggableMode
        }),
        _react2.default.createElement(_generalLedgerActionsPanel.GeneralLedgerActionsPanel, {
          accountId: props.accountId,
          documents: props.documents,
          filters: props.filters,
          glCodes: props.glCodes,
          isGLCodesLoading: props.isGLCodesLoading,
          isGLCodesVisible: props.isGLCodesVisible,
          onAddIncludeRule: props.onAddIncludeRule,
          onAddRuleError: props.onAddRuleError,
          onLinkAccount: props.onLinkAccount,
          onMapVendorRules: props.onMapVendorRules,
          onRemoveIncludeRule: props.onRemoveIncludeRule,
          preferredCurrency: props.selectedAccount.preferredCurrency,
          setDocumentUrl: props.onSetViewedDocumentUrl,
          setGlCode: props.onSetGlCode
        })
      )
    ),
    _react2.default.createElement(_changeDoctypeModal.ChangeDocumentTypeModal, {
      accountId: props.accountId,
      documentType: props.focusedDocument.type,
      isChangeDocTypeVisible: props.isChangeDocTypeVisible,
      onChangeDocType: props.onChangeDocType,
      onHideChangeDocType: props.onHideChangeDocType
    }),
    _react2.default.createElement(_shareUrlModal.ShareUrlModal, {
      accountId: props.accountId,
      documentId: props.focusedDocument.id,
      generatedShareUrl: props.generatedShareUrl,
      isShareUrlVisible: props.isShareUrlVisible,
      onGenerateShareUrl: props.onGenerateShareUrl,
      onHideShareUrl: props.onHideShareUrl,
      onSetFlashMessage: props.onSetFlashMessage,
      shareUrl: props.focusedDocument.shareUrl
    }),
    _react2.default.createElement(_trashDocumentModal.TrashDocumentModal, {
      accountId: props.accountId,
      focusedDocument: props.focusedDocument,
      isTrashDocumentVisible: props.isTrashDocumentVisible,
      onHideTrashDocument: props.onHideTrashDocument,
      onTrashDocument: props.onTrashDocument
    }),
    _react2.default.createElement(_exportModal.ExportModal, {
      accountId: props.accountId,
      accountSlug: props.accountSlug,
      categories: props.categories,
      glCodes: props.glCodes,
      isExportMode: props.isExportMode,
      onClose: props.onEndExportMode,
      onExportAll: props.onExportAll,
      onExportSelected: props.onExportSelected,
      onLinkAccount: props.onLinkAccount,
      selectedDocumentIds: props.selectedDocumentIds
    })
  );
};

exports.Inbox = Inbox;
Inbox.defaultProps = {
  customTabs: [],
  generatedShareUrl: "",
  glCodes: []
};

Inbox.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  accountSlug: _propTypes2.default.string.isRequired,
  allDocumentsTotal: _propTypes2.default.number.isRequired,
  categories: _propTypes2.default.arrayOf(_customPropTypes.categoryType).isRequired,
  columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    key: _propTypes2.default.string,
    name: _propTypes2.default.string,
    sortable: _propTypes2.default.bool,
    visible: _propTypes2.default.bool
  })).isRequired,
  customTabs: _propTypes2.default.arrayOf(_customPropTypes.customTabType),
  documents: _propTypes2.default.arrayOf(_customPropTypes.documentPropType).isRequired,
  filters: _customPropTypes.documentFiltersType.isRequired,
  focusedDocument: _customPropTypes.focusedDocumentType.isRequired,
  generatedShareUrl: _propTypes2.default.string,
  glCodes: _propTypes2.default.arrayOf(_customPropTypes.categoryType),
  gridWidth: _propTypes2.default.number.isRequired,
  isChangeDocTypeVisible: _propTypes2.default.bool.isRequired,
  isDocumentViewerVisible: _propTypes2.default.bool.isRequired,
  isDraggable: _propTypes2.default.bool.isRequired,
  isExportMode: _propTypes2.default.bool.isRequired,
  isFiltersDrawerMode: _propTypes2.default.bool.isRequired,
  isGLCodesLoading: _propTypes2.default.bool.isRequired,
  isGLCodesVisible: _propTypes2.default.bool.isRequired,
  isShareUrlVisible: _propTypes2.default.bool.isRequired,
  isTrashDocumentVisible: _propTypes2.default.bool.isRequired,
  onAddIncludeRule: _propTypes2.default.func.isRequired,
  onAddRuleError: _propTypes2.default.func.isRequired,
  onChangeDocType: _propTypes2.default.func.isRequired,
  onDocumentViewed: _propTypes2.default.func.isRequired,
  onEndDraggableMode: _propTypes2.default.func.isRequired,
  onEndExportMode: _propTypes2.default.func.isRequired,
  onEndFiltersDrawerMode: _propTypes2.default.func.isRequired,
  onExportAll: _propTypes2.default.func.isRequired,
  onExportSelected: _propTypes2.default.func.isRequired,
  onFocusDocument: _propTypes2.default.func.isRequired,
  onGenerateShareUrl: _propTypes2.default.func.isRequired,
  onHideChangeDocType: _propTypes2.default.func.isRequired,
  onHideDocumentViewer: _propTypes2.default.func.isRequired,
  onHideShareUrl: _propTypes2.default.func.isRequired,
  onHideTrashDocument: _propTypes2.default.func.isRequired,
  onLinkAccount: _propTypes2.default.func.isRequired,
  onMapVendorRules: _propTypes2.default.func.isRequired,
  onRemoveIncludeRule: _propTypes2.default.func.isRequired,
  onSetFlashMessage: _propTypes2.default.func.isRequired,
  onSetGlCode: _propTypes2.default.func.isRequired,
  onSetGridWidth: _propTypes2.default.func.isRequired,
  onSetPaginationLimit: _propTypes2.default.func.isRequired,
  onSetViewedDocumentUrl: _propTypes2.default.func.isRequired,
  onStartDeleteCustomTabMode: _propTypes2.default.func.isRequired,
  onStartDraggableMode: _propTypes2.default.func.isRequired,
  onTrashDocument: _propTypes2.default.func.isRequired,
  pagination: _customPropTypes.paginationType.isRequired,
  route: _customPropTypes.routeType.isRequired,
  router: _customPropTypes.routerType.isRequired,
  selectedAccount: _customPropTypes.accountType.isRequired,
  selectedDocumentIds: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired
};

Inbox.defaultProps = {
  endDate: null,
  exportType: null,
  startDate: null
};

var getGridStyle = exports.getGridStyle = function getGridStyle(type, isDraggable, isDocumentViewerVisible, isGLCodesVisible) {
  if (type === "table") {
    return getTableStyle(isDraggable, isDocumentViewerVisible, isGLCodesVisible);
  }
  return getSideBarStyle(isDraggable, isDocumentViewerVisible, isGLCodesVisible);
};

var getTableStyle = function getTableStyle(isDraggable, isDocumentViewerVisible, isGLCodesVisible) {
  if (isDocumentViewerVisible && !isDraggable) {
    return _grid2.default["col-md-8"];
  }
  if (isGLCodesVisible) {
    return _grid2.default["col-md-8"] + " " + _inbox2.default["gl-grid"];
  }
  return _grid2.default["col-md-12"];
};

var getSideBarStyle = function getSideBarStyle(isDraggable, isDocumentViewerVisible, isGLCodesVisible) {
  if (isDocumentViewerVisible && !isDraggable) {
    return _grid2.default["col-md-4"];
  }
  if (isGLCodesVisible) {
    return _grid2.default["col-md-4"] + " " + _inbox2.default["gl-panel"];
  }
  return "";
};

var getRow = exports.getRow = function getRow(documents, selectedDocumentIds, selectedAccount) {
  var cleanData = documents.map(function (document) {
    return _ramda2.default.merge(document, {
      isSelected: selectedDocumentIds.includes(document.id),
      categories: JSON.stringify(document.categories),
      defaultCurrency: selectedAccount.preferredCurrency,
      downloadUrl: _ramda2.default.path(["attachment", "url"], document),
      paymentType: JSON.stringify(document.paymentType)
    });
  });
  return function (index) {
    return cleanData[index];
  };
};

var renderEmptyRow = exports.renderEmptyRow = function renderEmptyRow(accountSlug, allDocumentsCount) {
  return _react2.default.createElement(_noDocuments.NoDocuments, { accountSlug: accountSlug, totalCount: allDocumentsCount });
};

var cache = new _reactVirtualized.CellMeasurerCache({
  defaultWidth: 75,
  minWidth: 75,
  fixedHeight: true
});

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MergeGrid = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _customPropTypes = __webpack_require__(5);

var _mergeGrid = __webpack_require__(1330);

var _mergeGrid2 = _interopRequireDefault(_mergeGrid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MergeGrid = exports.MergeGrid = function MergeGrid(props) {
  return _react2.default.createElement(
    "table",
    { className: _mergeGrid2.default.table },
    _react2.default.createElement(
      "thead",
      { className: _mergeGrid2.default.thead },
      _react2.default.createElement(TableHeaders, { columns: props.columns })
    ),
    _react2.default.createElement(TableData, props)
  );
};

MergeGrid.propTypes = {
  columns: _propTypes2.default.arrayOf(_customPropTypes.columnObjectType).isRequired
};

var TableHeaders = function TableHeaders(_ref) {
  var columns = _ref.columns;

  var headers = columns.map(function (column) {
    return _react2.default.createElement(
      "th",
      { className: _mergeGrid2.default.th, key: column.key },
      column.name
    );
  });
  return _react2.default.createElement(
    "tr",
    null,
    headers
  );
};

TableHeaders.propTypes = { columns: _propTypes2.default.arrayOf(_customPropTypes.columnObjectType).isRequired };

var TableData = function TableData(props) {
  var data = props.rows.map(function (row) {
    return _react2.default.createElement(TableRow, _extends({}, props, { key: row.id, row: row }));
  });
  return _react2.default.createElement(
    "tbody",
    null,
    data
  );
};

TableData.propTypes = MergeGrid.propTypes;

var TableRow = function TableRow(_ref2) {
  var columns = _ref2.columns,
      onCellSelected = _ref2.onCellSelected,
      onRowsDeselected = _ref2.onRowsDeselected,
      onRowsSelected = _ref2.onRowsSelected,
      row = _ref2.row,
      selectedFields = _ref2.selectedFields;

  var rowItems = columns.map(function (column) {
    if (column.formatter !== undefined) {
      return _react2.default.createElement(ColumnFormatter, {
        column: column,
        key: row.id + "-" + column.key,
        onCellSelected: onCellSelected,
        onRowsDeselected: onRowsDeselected,
        onRowsSelected: onRowsSelected,
        row: row,
        selectedFields: selectedFields
      });
    }
    return _react2.default.createElement(
      "td",
      {
        className: cellClassNameToggle(selectedFields, column, row),
        key: row.id + "-" + column.key,
        onClick: function onClick() {
          return onCellSelected(column.key, row[column.key], row.id);
        }
      },
      row[column.key]
    );
  });
  return _react2.default.createElement(
    "tr",
    { className: row.isSelected ? _mergeGrid2.default["selected-row"] : _mergeGrid2.default.tr, key: row.id },
    rowItems
  );
};

TableRow.propTypes = {
  columns: _propTypes2.default.arrayOf(_customPropTypes.columnObjectType).isRequired,
  onCellSelected: _propTypes2.default.func.isRequired,
  onRowsDeselected: _propTypes2.default.func.isRequired,
  onRowsSelected: _propTypes2.default.func.isRequired,
  row: _customPropTypes.rowType.isRequired,
  selectedFields: _customPropTypes.mergeDocumentType
};

var ColumnFormatter = function ColumnFormatter(_ref3) {
  var column = _ref3.column,
      onRowsDeselected = _ref3.onRowsDeselected,
      onRowsSelected = _ref3.onRowsSelected,
      onCellSelected = _ref3.onCellSelected,
      row = _ref3.row,
      selectedFields = _ref3.selectedFields;

  var Formatter = column.formatter;
  if (column.key === "isSelected") {
    return _react2.default.createElement(
      "td",
      { className: _mergeGrid2.default.td },
      _react2.default.createElement(Formatter, {
        id: row.id,
        isSelected: row[column.key],
        onRowsDeselected: onRowsDeselected,
        onRowsSelected: onRowsSelected
      })
    );
  }
  return _react2.default.createElement(
    "td",
    {
      className: cellClassNameToggle(selectedFields, column, row),
      onClick: function onClick() {
        return onCellSelected(column.key, row[column.key], row.id);
      }
    },
    _react2.default.createElement(Formatter, { value: row[column.key] })
  );
};

ColumnFormatter.defaultProps = {
  selectedFields: null
};

ColumnFormatter.propTypes = {
  column: _customPropTypes.columnObjectType.isRequired,
  onCellSelected: _propTypes2.default.func.isRequired,
  onRowsDeselected: _propTypes2.default.func.isRequired,
  onRowsSelected: _propTypes2.default.func.isRequired,
  row: _customPropTypes.rowType.isRequired,
  selectedFields: _customPropTypes.mergeDocumentType
};

var cellClassNameToggle = function cellClassNameToggle(selectedFields, column, row) {
  var id = _ramda2.default.path([column.key, "id"], selectedFields);
  return id === row.id ? _mergeGrid2.default.td + " " + _mergeGrid2.default.td__active : _mergeGrid2.default.td;
};

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChangeDocumentTypeModal = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _modal = __webpack_require__(27);

var _button = __webpack_require__(7);

var _changeDoctypeModal = __webpack_require__(1319);

var _changeDoctypeModal2 = _interopRequireDefault(_changeDoctypeModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChangeDocumentTypeModal = exports.ChangeDocumentTypeModal = function ChangeDocumentTypeModal(_ref) {
  var accountId = _ref.accountId,
      documentType = _ref.documentType,
      isChangeDocTypeVisible = _ref.isChangeDocTypeVisible,
      onChangeDocType = _ref.onChangeDocType,
      onHideChangeDocType = _ref.onHideChangeDocType;
  return _react2.default.createElement(
    _modal.Modal,
    {
      isVisible: isChangeDocTypeVisible,
      onClose: onHideChangeDocType,
      transitionName: "change-doc-type"
    },
    _react2.default.createElement(
      "div",
      null,
      _react2.default.createElement(
        "h3",
        null,
        "Change document type to ",
        documentType === "receipt" ? "other document" : "receipt",
        "?"
      ),
      _react2.default.createElement(
        "div",
        { className: _changeDoctypeModal2.default.buttons },
        _react2.default.createElement(
          _button.Button,
          { link: true, onClick: onHideChangeDocType },
          "cancel"
        ),
        _react2.default.createElement(
          _button.Button,
          { onClick: function onClick() {
              onChangeDocType(accountId);onHideChangeDocType();
            }, primary: true },
          "Confirm"
        )
      )
    )
  );
};

ChangeDocumentTypeModal.defaultProps = {
  documentType: undefined
};

ChangeDocumentTypeModal.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  documentType: _propTypes2.default.string,
  isChangeDocTypeVisible: _propTypes2.default.bool.isRequired,
  onChangeDocType: _propTypes2.default.func.isRequired,
  onHideChangeDocType: _propTypes2.default.func.isRequired
};

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeleteCustomTabModal = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _addCategoryModal = __webpack_require__(516);

var _addCategoryModal2 = _interopRequireDefault(_addCategoryModal);

var _modal = __webpack_require__(27);

var _button = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeleteCustomTabModal = exports.DeleteCustomTabModal = function DeleteCustomTabModal(_ref) {
  var customTabRemoveId = _ref.customTabRemoveId,
      isDeleteCustomTabLoading = _ref.isDeleteCustomTabLoading,
      isDeleteCustomTabMode = _ref.isDeleteCustomTabMode,
      onDeleteCustomTab = _ref.onDeleteCustomTab,
      onEndDeleteCustomTabMode = _ref.onEndDeleteCustomTabMode;
  return _react2.default.createElement(
    _modal.Modal,
    {
      isVisible: isDeleteCustomTabMode,
      onClose: onEndDeleteCustomTabMode,
      transitionName: "add-category"
    },
    _react2.default.createElement(
      "h2",
      null,
      "Are you sure you want to delete this tab?"
    ),
    _react2.default.createElement(
      "div",
      { className: _addCategoryModal2.default["button-container"] },
      _react2.default.createElement(
        _button.Button,
        { link: true, onClick: onEndDeleteCustomTabMode },
        "cancel"
      ),
      _react2.default.createElement(
        _button.Button,
        {
          danger: true,
          loading: isDeleteCustomTabLoading,
          onClick: function onClick() {
            return onDeleteCustomTab(customTabRemoveId);
          }
        },
        "Delete"
      )
    )
  );
};

DeleteCustomTabModal.defaultProps = {
  customTabRemoveId: null
};

DeleteCustomTabModal.propTypes = {
  customTabRemoveId: _react.PropTypes.string,
  isDeleteCustomTabLoading: _react.PropTypes.bool.isRequired,
  isDeleteCustomTabMode: _react.PropTypes.bool.isRequired,
  onDeleteCustomTab: _react.PropTypes.func.isRequired,
  onEndDeleteCustomTabMode: _react.PropTypes.func.isRequired
};

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeletePermanentlyModal = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _trashMultipleDocuments = __webpack_require__(515);

var _trashMultipleDocuments2 = _interopRequireDefault(_trashMultipleDocuments);

var _stringHelpers = __webpack_require__(68);

var _modal = __webpack_require__(27);

var _button = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeletePermanentlyModal = exports.DeletePermanentlyModal = function DeletePermanentlyModal(_ref) {
  var isDeletePermanentlyLoading = _ref.isDeletePermanentlyLoading,
      isDeletePermanentlyVisible = _ref.isDeletePermanentlyVisible,
      onDeletePermanently = _ref.onDeletePermanently,
      onHideDeletePermanently = _ref.onHideDeletePermanently,
      selectedIds = _ref.selectedIds;
  return _react2.default.createElement(
    _modal.Modal,
    {
      isVisible: isDeletePermanentlyVisible,
      onClose: onHideDeletePermanently,
      transitionName: "delete-permanently"
    },
    _react2.default.createElement(
      "div",
      null,
      _react2.default.createElement(
        "h3",
        null,
        "Delete ",
        (0, _stringHelpers.pluralize)(selectedIds.length, "documents", "document"),
        " permanently?"
      ),
      _react2.default.createElement(
        "p",
        null,
        "(You will not be able to access",
        (0, _stringHelpers.pluralize)(selectedIds.length, " these documents ", " this document ", false),
        "again)"
      ),
      _react2.default.createElement(
        "div",
        { className: _trashMultipleDocuments2.default.buttons },
        _react2.default.createElement(
          _button.Button,
          { link: true, onClick: onHideDeletePermanently },
          "cancel"
        ),
        _react2.default.createElement(
          _button.Button,
          {
            danger: true,
            loading: isDeletePermanentlyLoading,
            onClick: onDeletePermanently
          },
          "Delete Permanently"
        )
      )
    )
  );
};

DeletePermanentlyModal.propTypes = {
  isDeletePermanentlyLoading: _propTypes2.default.bool.isRequired,
  isDeletePermanentlyVisible: _propTypes2.default.bool.isRequired,
  onDeletePermanently: _propTypes2.default.func.isRequired,
  onHideDeletePermanently: _propTypes2.default.func.isRequired,
  selectedIds: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired
};

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AssignCategoriesForm = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _button = __webpack_require__(7);

var _reduxForm = __webpack_require__(35);

var _select = __webpack_require__(45);

var _customPropTypes = __webpack_require__(5);

var _activeFilterItem = __webpack_require__(116);

var _assignCategoriesForm = __webpack_require__(1325);

var _assignCategoriesForm2 = _interopRequireDefault(_assignCategoriesForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Form = function Form(props) {
  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(_reduxForm.FieldArray, {
      component: renderFormContents(props.accountId, props.categories, props.onCancel, props.onCreateCategory, props.onSave, props.isLoading),
      name: "selectedCategories"
    })
  );
};

Form.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  categories: _propTypes2.default.arrayOf(_customPropTypes.categoryType).isRequired,
  isLoading: _propTypes2.default.bool.isRequired,
  onCancel: _propTypes2.default.func.isRequired,
  onCreateCategory: _propTypes2.default.func.isRequired,
  onSave: _propTypes2.default.func.isRequired
};

var renderFormContents = function renderFormContents(accountId, categories, onCancel, onCreateCategory, onSave, isLoading) {
  return function (props) {
    return _react2.default.createElement(FormContents, _extends({}, props, {
      accountId: accountId,
      categories: categories,
      isLoading: isLoading,
      onCancel: onCancel,
      onCreateCategory: onCreateCategory,
      onSave: onSave
    }));
  };
};

var FormContents = function FormContents(_ref) {
  var accountId = _ref.accountId,
      categories = _ref.categories,
      fields = _ref.fields,
      isLoading = _ref.isLoading,
      onCancel = _ref.onCancel,
      onCreateCategory = _ref.onCreateCategory,
      onSave = _ref.onSave;
  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(_select.CreatableSelect, {
      accountId: accountId,
      createOption: onCreateCategory,
      data: mapCategories(categories, fields.getAll() || []),
      onChange: onChooseCategory(fields),
      placeholder: "Choose a category..."
    }),
    _react2.default.createElement(
      "div",
      { className: _assignCategoriesForm2.default["selected-categories-container"] },
      renderNoSelection(_ramda2.default.propOr(0, "length")(fields.getAll()), onSubmitCategories(fields, onCancel, onSave)),
      fields.map(function (fieldName, index) {
        return renderCategory(fieldName, index, fields);
      })
    ),
    _react2.default.createElement(
      "div",
      { className: _assignCategoriesForm2.default.actions },
      _react2.default.createElement(
        _button.Button,
        { link: true, onClick: function onClick() {
            fields.removeAll();onCancel();
          } },
        "cancel"
      ),
      _react2.default.createElement(
        _button.Button,
        {
          disabled: _ramda2.default.propOr(0, "length")(fields.getAll()) === 0,
          loading: isLoading,
          onClick: onSubmitCategories(fields, onCancel, onSave),
          primary: true
        },
        "Save"
      )
    )
  );
};

var onSubmitCategories = function onSubmitCategories(fields, onCancel, onSave) {
  return function () {
    onSave().then(function () {
      fields.removeAll();
      onCancel();
    });
  };
};

var renderNoSelection = function renderNoSelection(selectionCount, onSave) {
  if (selectionCount !== 0) {
    return null;
  }
  return _react2.default.createElement(
    "div",
    { className: _assignCategoriesForm2.default["no-selection"] },
    "No categories selected",
    _react2.default.createElement(
      "div",
      { className: _assignCategoriesForm2.default["no-selection--actions"] },
      _react2.default.createElement(
        _button.Button,
        { danger: true, link: true, onClick: onSave },
        "Remove existing categories"
      )
    )
  );
};

FormContents.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  categories: _propTypes2.default.arrayOf(_customPropTypes.categoryType).isRequired,
  fields: _propTypes2.default.shape({
    getAll: _propTypes2.default.func,
    push: _propTypes2.default.func
  }).isRequired,
  isLoading: _propTypes2.default.bool.isRequired,
  onCancel: _propTypes2.default.func.isRequired,
  onCreateCategory: _propTypes2.default.func.isRequired,
  onSave: _propTypes2.default.func.isRequired
};

var mapCategories = function mapCategories(categories, selectedNames) {
  return categories.filter(function (category) {
    return !selectedNames.includes(category.name);
  }).map(mapCategory);
};

var mapCategory = function mapCategory(category) {
  return { key: category.name, name: category.name };
};

var onChooseCategory = function onChooseCategory(fields) {
  return function (_ref2) {
    var name = _ref2.name;

    if (fields.getAll() === undefined) {
      fields.push(name);
      return;
    }

    if (!fields.getAll().includes(name)) {
      fields.push(name);
    }
  };
};

var renderCategory = function renderCategory(fieldName, index, fields) {
  var fieldContents = function fieldContents(_ref3) {
    var value = _ref3.input.value;
    return _react2.default.createElement(
      "div",
      { className: _assignCategoriesForm2.default["selected-item-container"] },
      _react2.default.createElement(_activeFilterItem.ActiveFilterItem, {
        name: value,
        onRemove: function onRemove() {
          fields.remove(index);
        }
      })
    );
  };

  fieldContents.propTypes = {
    input: _propTypes2.default.shape({ value: _propTypes2.default.string }).isRequired
  };

  return _react2.default.createElement(
    "span",
    { key: fieldName },
    _react2.default.createElement(_reduxForm.Field, {
      component: fieldContents,
      name: fieldName
    })
  );
};

var AssignCategoriesForm = exports.AssignCategoriesForm = (0, _reduxForm.reduxForm)({
  destroyOnUnmount: false,
  form: "batchCategoriesForm",
  keepDirtyOnReinitialize: true
})(Form);

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BatchDownloadForm = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reduxForm = __webpack_require__(35);

var _radioTab = __webpack_require__(847);

var _button = __webpack_require__(7);

var _textField = __webpack_require__(848);

var _activeFilterItem = __webpack_require__(116);

var _batchDownloadForm = __webpack_require__(1326);

var _batchDownloadForm2 = _interopRequireDefault(_batchDownloadForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var exportTypeOptions = [{ key: "csv", name: "CSV" }, { key: "pdf", name: "PDF" }];

var Form = function Form(props) {
  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      "div",
      null,
      "Choose an export type"
    ),
    _react2.default.createElement(_reduxForm.Field, {
      component: radioTabField,
      name: "exportType"
    }),
    _react2.default.createElement(
      "p",
      { className: _batchDownloadForm2.default.info },
      "Your export will take a few short minutes to prepare. We'll email you and any other recipients below when it's ready!"
    ),
    _react2.default.createElement(_reduxForm.FieldArray, {
      component: function component(p) {
        return renderFormContents(p, props.defaultEmail, props.onSave, props.onCancel, props.isLoading);
      },
      name: "emails"
    })
  );
};

Form.propTypes = {
  defaultEmail: _propTypes2.default.string.isRequired,
  isLoading: _propTypes2.default.bool.isRequired,
  onCancel: _propTypes2.default.func.isRequired,
  onSave: _propTypes2.default.func.isRequired
};

var radioTabField = function radioTabField(props) {
  return _react2.default.createElement(_radioTab.RadioTab, {
    onChange: function onChange(option) {
      return props.input.onChange(option.key);
    },
    options: exportTypeOptions,
    selectedOptionKey: props.input.value
  });
};

radioTabField.propTypes = {
  input: _propTypes2.default.shape({
    onChange: _propTypes2.default.func.isRequired,
    value: _propTypes2.default.string
  }).isRequired
};

var renderFormContents = function renderFormContents(props, defaultEmail, onSave, onCancel, isLoading) {
  var fields = props.fields;
  if (props.meta.pristine && (fields.getAll() || []).length === 0) {
    fields.push(defaultEmail);
  }
  var selectedEmailField = function selectedEmailField(email, index) {
    return _react2.default.createElement(
      "div",
      { className: _batchDownloadForm2.default["email-row"], key: email + "-" + index },
      _react2.default.createElement(_activeFilterItem.ActiveFilterItem, { name: email, onRemove: function onRemove() {
          return fields.remove(index);
        } })
    );
  };

  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(_reduxForm.Field, {
      component: function component(fieldProps) {
        return EmailTextField(fieldProps, fields);
      },
      name: "newEmail"
    }),
    _react2.default.createElement(
      "div",
      { className: _batchDownloadForm2.default["emails-container"] },
      (fields.getAll() || []).map(selectedEmailField)
    ),
    _react2.default.createElement(
      "div",
      { className: _batchDownloadForm2.default.actions },
      _react2.default.createElement(
        _button.Button,
        { link: true, onClick: onCancel },
        "cancel"
      ),
      _react2.default.createElement(
        _button.Button,
        {
          disabled: (props.fields.getAll() || []).length === 0,
          loading: isLoading,
          onClick: onSave,
          primary: true
        },
        "Send"
      )
    )
  );
};

renderFormContents.propTypes = {
  fields: _propTypes2.default.shape({
    getAll: _propTypes2.default.func
  }).isRequired,
  meta: _propTypes2.default.shape({
    pristine: _propTypes2.default.bool
  }).isRequired
};

var EmailTextField = function EmailTextField(props, fields) {
  var onSubmit = function onSubmit(e) {
    e.preventDefault();
    var value = props.input.value;
    if (value === "") {
      return;
    }
    fields.push(props.input.value);
    props.input.onChange("");
  };

  return _react2.default.createElement(
    "form",
    { className: _batchDownloadForm2.default["add-email-container"], onSubmit: onSubmit },
    _react2.default.createElement(
      "div",
      { className: _batchDownloadForm2.default["add-email_container__text-field-container"] },
      _react2.default.createElement(_textField.TextField, {
        onChange: props.input.onChange,
        placeholder: "Email...",
        type: "email",
        value: props.input.value
      })
    ),
    _react2.default.createElement(
      "div",
      { className: _batchDownloadForm2.default["add-email_container__button-container"] },
      _react2.default.createElement(
        _button.Button,
        { type: "submit" },
        "+"
      )
    )
  );
};

EmailTextField.propTypes = {
  input: _propTypes2.default.shape({
    onChange: _propTypes2.default.func,
    value: _propTypes2.default.string
  }).isRequired
};

var BatchDownloadForm = exports.BatchDownloadForm = (0, _reduxForm.reduxForm)({
  form: "batchDownloadDocumentsForm",
  initialValues: {
    exportType: "csv"
  }
})(Form);

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fieldWrapper = exports.BatchEditForm = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _checkbox = __webpack_require__(266);

var _button = __webpack_require__(7);

var _select = __webpack_require__(45);

var _customPropTypes = __webpack_require__(5);

var _reduxForm = __webpack_require__(35);

var _batchEditForm = __webpack_require__(1317);

var _batchEditForm2 = _interopRequireDefault(_batchEditForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StatelessBatchEditForm = function StatelessBatchEditForm(_ref) {
  var currencies = _ref.currencies,
      isLoading = _ref.isLoading,
      onSubmitBatchEdit = _ref.onSubmitBatchEdit,
      onClose = _ref.onClose,
      reset = _ref.reset,
      vendors = _ref.vendors;
  return _react2.default.createElement(
    "form",
    null,
    _react2.default.createElement(
      "div",
      { className: _batchEditForm2.default.section },
      _react2.default.createElement(
        "h4",
        null,
        "Vendor"
      ),
      _react2.default.createElement(
        "div",
        { className: _batchEditForm2.default["fields-container"] },
        _react2.default.createElement(_reduxForm.Field, {
          component: vendorFieldWrapper(mapVendors(vendors)),
          name: "vendor"
        })
      )
    ),
    _react2.default.createElement(
      "div",
      { className: _batchEditForm2.default.section },
      _react2.default.createElement(
        "h4",
        null,
        "Document type"
      ),
      _react2.default.createElement(
        "div",
        { className: _batchEditForm2.default["fields-container"] },
        _react2.default.createElement(_reduxForm.Field, {
          component: documentTypeFieldWrapper(),
          name: "documentType"
        })
      )
    ),
    _react2.default.createElement(
      "div",
      { className: _batchEditForm2.default.section },
      _react2.default.createElement(
        "h4",
        null,
        "Currency"
      ),
      _react2.default.createElement(
        "div",
        { className: _batchEditForm2.default["fields-container"] },
        _react2.default.createElement(_reduxForm.Field, {
          component: currencyFieldWrapper(currencyMapper(currencies)),
          name: "currency"
        })
      )
    ),
    _react2.default.createElement(
      "div",
      { className: _batchEditForm2.default.actions },
      _react2.default.createElement(
        _button.Button,
        { link: true, onClick: function onClick() {
            reset();onClose();
          } },
        "cancel"
      ),
      _react2.default.createElement(
        _button.Button,
        { loading: isLoading, onClick: onSubmitBatchEdit, primary: true },
        "Save"
      )
    )
  );
};

StatelessBatchEditForm.propTypes = {
  currencies: _propTypes2.default.arrayOf(_customPropTypes.currencyType).isRequired,
  isLoading: _propTypes2.default.bool.isRequired,
  onClose: _propTypes2.default.func.isRequired,
  onSubmitBatchEdit: _propTypes2.default.func.isRequired,
  reset: _propTypes2.default.func.isRequired,
  vendors: _propTypes2.default.arrayOf(_customPropTypes.vendorType).isRequired
};

var BatchEditForm = exports.BatchEditForm = (0, _reduxForm.reduxForm)({ form: "documentsBatchEdit" })(StatelessBatchEditForm);

var documentTypes = [{ key: "receipt", name: "Receipt" }, { key: "other", name: "Other" }];

var vendorFieldWrapper = function vendorFieldWrapper(vendors) {
  return function (props) {
    return fieldWrapper(props, vendors, "Vendor...", true);
  };
};
var documentTypeFieldWrapper = function documentTypeFieldWrapper() {
  return function (props) {
    return fieldWrapper(props, documentTypes, "Document type...");
  };
};
var currencyFieldWrapper = function currencyFieldWrapper(currencies) {
  return function (props) {
    return fieldWrapper(props, currencies, "Currency...");
  };
};

var fieldWrapper = exports.fieldWrapper = function fieldWrapper(_ref2, data, placeholder) {
  var _ref2$input = _ref2.input,
      _onChange = _ref2$input.onChange,
      value = _ref2$input.value,
      name = _ref2$input.name;
  var creatable = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return _react2.default.createElement(
    "div",
    { className: _batchEditForm2.default["fields-container__row"] },
    _react2.default.createElement(
      "div",
      null,
      _react2.default.createElement(_checkbox.Checkbox, {
        checked: value !== null && value !== "",
        disabled: value === null || value === "" || value === undefined,
        onChange: function onChange() {
          return _onChange("");
        }
      })
    ),
    _react2.default.createElement(
      "div",
      null,
      renderSelectComponent({ data: data, onChange: _onChange, placeholder: placeholder, value: value }, creatable)
    )
  );
};

var renderSelectComponent = function renderSelectComponent(props, isCreatable) {
  return isCreatable ? _react2.default.createElement(_select.CreatableSelect, _extends({}, props, { createOption: function createOption() {
      return null;
    } })) : _react2.default.createElement(_select.Select, props);
};

fieldWrapper.propTypes = {
  input: _propTypes2.default.shape({
    onChange: _propTypes2.default.func,
    value: _propTypes2.default.object
  }).isRequired
};

var currencyMapper = function currencyMapper(currencies) {
  return currencies.map(function (currency) {
    return { key: currency.code, name: currency.code };
  });
};

var mapVendors = function mapVendors(vendors) {
  return vendors.map(function (vendor) {
    return { key: vendor.name, name: vendor.name };
  });
};

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MergeDocumentsModal = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _customPropTypes = __webpack_require__(5);

var _button = __webpack_require__(7);

var _mergeDocumentsModal = __webpack_require__(1329);

var _mergeDocumentsModal2 = _interopRequireDefault(_mergeDocumentsModal);

var _modal = __webpack_require__(27);

var _mergeGrid = __webpack_require__(870);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MergeDocumentsModal = exports.MergeDocumentsModal = function MergeDocumentsModal(props) {
  return _react2.default.createElement(
    _modal.Modal,
    {
      isVisible: props.isMergeDocumentsMode,
      onClose: props.onEndMergeDocumentsMode,
      transitionName: "merge-documents"
    },
    _react2.default.createElement(ModalChild, _extends({}, props, { selectedDocuments: props.selectedDocuments }))
  );
};

MergeDocumentsModal.propTypes = {
  isMergeDocumentsMode: _propTypes2.default.bool.isRequired,
  onEndMergeDocumentsMode: _propTypes2.default.func.isRequired,
  selectedDocuments: _propTypes2.default.arrayOf(_customPropTypes.documentPropType).isRequired
};

var ModalChild = function ModalChild(_ref) {
  var columns = _ref.columns,
      isMergeDocumentsLoading = _ref.isMergeDocumentsLoading,
      onDeselectMergeDocument = _ref.onDeselectMergeDocument,
      onEndMergeDocumentsMode = _ref.onEndMergeDocumentsMode,
      onMergeDocuments = _ref.onMergeDocuments,
      onSelectMergeDocument = _ref.onSelectMergeDocument,
      onSelectMergeField = _ref.onSelectMergeField,
      mergeDocument = _ref.mergeDocument,
      preferredCurrency = _ref.preferredCurrency,
      selectedMergeDocumentId = _ref.selectedMergeDocumentId,
      selectedDocuments = _ref.selectedDocuments;

  var rows = getRow(selectedDocuments, selectedMergeDocumentId, preferredCurrency);
  if (selectedDocuments.length > 5) {
    return _react2.default.createElement(
      "div",
      { className: _mergeDocumentsModal2.default["error-container"] },
      _react2.default.createElement(
        "h1",
        null,
        "Too many documents selected."
      ),
      _react2.default.createElement(
        "p",
        null,
        "You can only merge 5 documents at a time."
      ),
      _react2.default.createElement(
        _button.Button,
        { onClick: onEndMergeDocumentsMode, primary: true },
        "OK"
      )
    );
  }
  return _react2.default.createElement(
    "div",
    { className: _mergeDocumentsModal2.default["grid-container"] },
    _react2.default.createElement(
      "h2",
      null,
      "Merge documents"
    ),
    _react2.default.createElement(
      "p",
      null,
      "Select a document that will be the basis of the merge, and/or select the individual fields that you would like to keep."
    ),
    _react2.default.createElement(_mergeGrid.MergeGrid, {
      columns: columns,
      firstRow: rows[0],
      onCellSelected: onSelectMergeField,
      onRowsDeselected: onDeselectMergeDocument,
      onRowsSelected: onSelectMergeDocument,
      rowHeight: 35,
      rows: rows,
      rowsCount: selectedDocuments.length,
      selectedFields: mergeDocument,
      sortColumn: "uploaded",
      sortDirection: "DESC",
      totalResults: selectedDocuments.length
    }),
    _react2.default.createElement(
      "div",
      { className: _mergeDocumentsModal2.default["merge-buttons"] },
      _react2.default.createElement(
        _button.Button,
        { link: true, onClick: onEndMergeDocumentsMode },
        "cancel"
      ),
      _react2.default.createElement(
        _button.Button,
        { loading: isMergeDocumentsLoading, onClick: function onClick() {
            return onMergeDocuments();
          }, primary: true },
        "Confirm merge"
      )
    )
  );
};

ModalChild.defaultProps = {
  mergeDocument: null,
  selectedMergeDocumentId: ""
};

ModalChild.propTypes = {
  columns: _propTypes2.default.arrayOf(_customPropTypes.dataType).isRequired,
  isMergeDocumentsLoading: _propTypes2.default.bool.isRequired,
  mergeDocument: _customPropTypes.mergeDocumentType,
  onDeselectMergeDocument: _propTypes2.default.func.isRequired,
  onEndMergeDocumentsMode: _propTypes2.default.func.isRequired,
  onMergeDocuments: _propTypes2.default.func.isRequired,
  onSelectMergeDocument: _propTypes2.default.func.isRequired,
  onSelectMergeField: _propTypes2.default.func.isRequired,
  preferredCurrency: _propTypes2.default.string.isRequired,
  selectedDocuments: _propTypes2.default.arrayOf(_customPropTypes.documentPropType).isRequired,
  selectedMergeDocumentId: _propTypes2.default.string
};

var getRow = function getRow(documents, selectedMergeDocumentId, preferredCurrency) {
  return documents.map(function (document) {
    return _ramda2.default.merge(document, {
      isSelected: selectedMergeDocumentId.includes(document.id),
      categories: JSON.stringify(document.categories),
      defaultCurrency: preferredCurrency,
      paymentType: JSON.stringify(document.paymentType)
    });
  });
};

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShareUrlModal = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactClipboard = __webpack_require__(735);

var _reactClipboard2 = _interopRequireDefault(_reactClipboard);

var _modal = __webpack_require__(27);

var _button = __webpack_require__(7);

var _shareUrlModal = __webpack_require__(1333);

var _shareUrlModal2 = _interopRequireDefault(_shareUrlModal);

var _validators = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShareUrlModal = exports.ShareUrlModal = function ShareUrlModal(props) {
  return _react2.default.createElement(
    _modal.Modal,
    {
      isVisible: props.isShareUrlVisible,
      onClose: props.onHideShareUrl,
      transitionName: "share-url"
    },
    renderShareUrlOrGenerator(props)
  );
};

ShareUrlModal.propTypes = {
  isShareUrlVisible: _propTypes2.default.bool.isRequired,
  onHideShareUrl: _propTypes2.default.func.isRequired
};

var renderShareUrlOrGenerator = function renderShareUrlOrGenerator(props) {
  if ((0, _validators.isValidValue)(props.shareUrl) || (0, _validators.isValidValue)(props.generatedShareUrl)) {
    return _react2.default.createElement(ShareUrl, props);
  }
  return _react2.default.createElement(GenerateShareUrl, props);
};

renderShareUrlOrGenerator.propTypes = {
  generatedShareUrl: _propTypes2.default.string.isRequired,
  shareUrl: _propTypes2.default.string.isRequired
};

var ShareUrl = function ShareUrl(_ref) {
  var generatedShareUrl = _ref.generatedShareUrl,
      onHideShareUrl = _ref.onHideShareUrl,
      onSetFlashMessage = _ref.onSetFlashMessage,
      shareUrl = _ref.shareUrl;
  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      "h3",
      null,
      "Copy the link below to share this document!"
    ),
    _react2.default.createElement("input", { className: _shareUrlModal2.default.link, readOnly: true, value: generatedShareUrl || shareUrl }),
    _react2.default.createElement(
      "div",
      { className: _shareUrlModal2.default.buttons },
      _react2.default.createElement(
        _button.Button,
        { link: true, onClick: onHideShareUrl },
        "cancel"
      ),
      _react2.default.createElement(
        _reactClipboard2.default,
        {
          className: _shareUrlModal2.default["copy-button"],
          "data-clipboard-text": generatedShareUrl || shareUrl,
          onClick: function onClick() {
            onHideShareUrl();onSetFlashMessage("URL is copied to clipboard");
          }
        },
        "Copy to Clipboard"
      )
    )
  );
};

ShareUrl.propTypes = {
  generatedShareUrl: _propTypes2.default.string.isRequired,
  onHideShareUrl: _propTypes2.default.func.isRequired,
  onSetFlashMessage: _propTypes2.default.func.isRequired,
  shareUrl: _propTypes2.default.string.isRequired
};

var GenerateShareUrl = function GenerateShareUrl(_ref2) {
  var accountId = _ref2.accountId,
      documentId = _ref2.documentId,
      onHideShareUrl = _ref2.onHideShareUrl,
      onGenerateShareUrl = _ref2.onGenerateShareUrl;
  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      "h3",
      null,
      "Generate a share URL!"
    ),
    _react2.default.createElement(
      "div",
      { className: _shareUrlModal2.default.buttons },
      _react2.default.createElement(
        _button.Button,
        { link: true, onClick: onHideShareUrl },
        "cancel"
      ),
      _react2.default.createElement(
        _button.Button,
        { onClick: function onClick() {
            return onGenerateShareUrl(accountId, documentId);
          }, primary: true },
        "Generate Share URL"
      )
    )
  );
};

GenerateShareUrl.defaultProps = {
  documentId: ""
};

GenerateShareUrl.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  documentId: _propTypes2.default.string,
  onGenerateShareUrl: _propTypes2.default.func.isRequired,
  onHideShareUrl: _propTypes2.default.func.isRequired
};

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrashMultipleDocumentsModal = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _modal = __webpack_require__(27);

var _button = __webpack_require__(7);

var _trashMultipleDocuments = __webpack_require__(515);

var _trashMultipleDocuments2 = _interopRequireDefault(_trashMultipleDocuments);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TrashMultipleDocumentsModal = exports.TrashMultipleDocumentsModal = function TrashMultipleDocumentsModal(_ref) {
  var isTrashMultipleDocumentsLoading = _ref.isTrashMultipleDocumentsLoading,
      isTrashMultipleDocumentsVisible = _ref.isTrashMultipleDocumentsVisible,
      onHideTrashMultipleDocuments = _ref.onHideTrashMultipleDocuments,
      onTrashMultipleDocuments = _ref.onTrashMultipleDocuments;
  return _react2.default.createElement(
    _modal.Modal,
    {
      isVisible: isTrashMultipleDocumentsVisible,
      onClose: onHideTrashMultipleDocuments,
      transitionName: "trash-multiple-documents"
    },
    _react2.default.createElement(
      "div",
      null,
      _react2.default.createElement(
        "h3",
        null,
        "Send documents to trash?"
      ),
      _react2.default.createElement(
        "div",
        { className: _trashMultipleDocuments2.default.buttons },
        _react2.default.createElement(
          _button.Button,
          { link: true, onClick: onHideTrashMultipleDocuments },
          "cancel"
        ),
        _react2.default.createElement(
          _button.Button,
          {
            danger: true,
            loading: isTrashMultipleDocumentsLoading,
            onClick: onTrashMultipleDocuments
          },
          "Trash"
        )
      )
    )
  );
};

TrashMultipleDocumentsModal.propTypes = {
  isTrashMultipleDocumentsLoading: _propTypes2.default.bool.isRequired,
  isTrashMultipleDocumentsVisible: _propTypes2.default.bool.isRequired,
  onHideTrashMultipleDocuments: _propTypes2.default.func.isRequired,
  onTrashMultipleDocuments: _propTypes2.default.func.isRequired
};

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FirstTimeBetaModal = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _firstTimeBetaModal = __webpack_require__(1335);

var _firstTimeBetaModal2 = _interopRequireDefault(_firstTimeBetaModal);

var _modal = __webpack_require__(27);

var _checkbox = __webpack_require__(266);

var _button = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FirstTimeBetaModal = exports.FirstTimeBetaModal = function FirstTimeBetaModal(_ref) {
  var isDontRemindBeta = _ref.isDontRemindBeta,
      isFirstTimeBetaMode = _ref.isFirstTimeBetaMode,
      onEndFirstTimeBetaMode = _ref.onEndFirstTimeBetaMode,
      onStartTour = _ref.onStartTour,
      onToggleBetaModal = _ref.onToggleBetaModal;
  return _react2.default.createElement(
    _modal.Modal,
    {
      isVisible: isFirstTimeBetaMode,
      onClose: onEndFirstTimeBetaMode,
      transitionName: "first-time-beta-modal"
    },
    _react2.default.createElement(
      "h1",
      null,
      "Welcome to the new Squirrel Street UI!"
    ),
    _react2.default.createElement(
      "h3",
      null,
      "We've been listening! Here's all the new stuff that you've been asking for:"
    ),
    _react2.default.createElement(
      "ul",
      null,
      _react2.default.createElement(
        "li",
        null,
        "New interface built with the latest web technologies"
      ),
      _react2.default.createElement(
        "li",
        null,
        "Merged other documents and documents into one filterable table"
      ),
      _react2.default.createElement(
        "li",
        null,
        "Ability to code and export from within the web app"
      ),
      _react2.default.createElement(
        "li",
        null,
        "Manage vendors as well as manage categories"
      ),
      _react2.default.createElement(
        "li",
        null,
        "Improved document editing and viewing"
      ),
      _react2.default.createElement(
        "li",
        null,
        "Ability to merge documents with granular document field control"
      ),
      _react2.default.createElement(
        "li",
        null,
        "Choose which columns you want displayed on your documents grid"
      ),
      _react2.default.createElement(
        "li",
        null,
        "Manage integrations from within the app"
      ),
      _react2.default.createElement(
        "li",
        null,
        "And much more!"
      )
    ),
    _react2.default.createElement(
      "div",
      { className: _firstTimeBetaModal2.default.actions },
      _react2.default.createElement(
        "div",
        { className: _firstTimeBetaModal2.default.checkbox },
        _react2.default.createElement(_checkbox.Checkbox, { checked: isDontRemindBeta, onChange: function onChange() {
            return onToggleBetaModal(!isDontRemindBeta);
          } }),
        _react2.default.createElement(
          "span",
          { className: _firstTimeBetaModal2.default["checkbox-text"] },
          "Don't remind me again"
        )
      ),
      _react2.default.createElement(
        _button.Button,
        { onClick: function onClick() {
            onEndFirstTimeBetaMode(isDontRemindBeta);onStartTour("overview");
          }, primary: true },
        "Start the tour!"
      ),
      _react2.default.createElement(
        _button.Button,
        { link: true, onClick: function onClick() {
            return onEndFirstTimeBetaMode(isDontRemindBeta);
          } },
        "Close"
      )
    )
  );
};

FirstTimeBetaModal.propTypes = {
  isDontRemindBeta: _propTypes2.default.bool.isRequired,
  isFirstTimeBetaMode: _propTypes2.default.bool.isRequired,
  onEndFirstTimeBetaMode: _propTypes2.default.func.isRequired,
  onStartTour: _propTypes2.default.func.isRequired,
  onToggleBetaModal: _propTypes2.default.func.isRequired
};

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AttachmentCellFormatter = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AttachmentCellFormatter = exports.AttachmentCellFormatter = function AttachmentCellFormatter(_ref) {
  var value = _ref.value;
  return _react2.default.createElement(
    "span",
    null,
    value.name
  );
};

AttachmentCellFormatter.propTypes = {
  value: _propTypes2.default.shape({
    name: _propTypes2.default.string,
    url: _propTypes2.default.string
  }).isRequired
};

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CategoryRuleCellFormatter = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _activeFilters = __webpack_require__(323);

var _activeFilters2 = _interopRequireDefault(_activeFilters);

var _activeFilterItem = __webpack_require__(116);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CategoryRuleCellFormatter = exports.CategoryRuleCellFormatter = function CategoryRuleCellFormatter(_ref) {
  var accountId = _ref.accountId,
      id = _ref.id,
      removeIncludeRule = _ref.removeIncludeRule,
      value = _ref.value;

  if ((value || []).length === 0) {
    return null;
  }
  return _react2.default.createElement(
    "div",
    { className: _activeFilters2.default["active-filter-group"] },
    mapRenderItem(accountId, id, removeIncludeRule, value.includeVendors)
  );
};

CategoryRuleCellFormatter.defaultProps = {
  value: []
};

CategoryRuleCellFormatter.propTypes = {
  accountId: _react.PropTypes.string.isRequired,
  id: _react.PropTypes.string.isRequired,
  removeIncludeRule: _react.PropTypes.func.isRequired,
  value: _react.PropTypes.shape({ includeVendors: _react.PropTypes.arrayOf(_react.PropTypes.object) })
};

var mapRenderItem = function mapRenderItem(accountId, categoryId, removeIncludeRule, value) {
  return value.map(function (item) {
    return renderItem(accountId, categoryId, item.id, removeIncludeRule, item.vendorName);
  });
};

var renderItem = function renderItem(accountId, categoryId, ruleId, onRemoveItem, name) {
  return _react2.default.createElement(
    "span",
    { key: name + "-" + ruleId, onClick: function onClick(e) {
        return e.stopPropagation();
      } },
    _react2.default.createElement(_activeFilterItem.ActiveFilterItem, { name: name, onRemove: function onRemove() {
        return onRemoveItem(accountId, categoryId, ruleId);
      } })
  );
};

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillableCellFormatter = exports.EnvelopeCellFormatter = exports.StatusCellFormatter = exports.SentCellFormatter = exports.ReceivedCellFormatter = exports.EnvelopeUploadedCellFormatter = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _envelope = __webpack_require__(447);

var _envelope2 = _interopRequireDefault(_envelope);

var _reactRouter = __webpack_require__(32);

var _validators = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EnvelopeUploadedCellFormatter = exports.EnvelopeUploadedCellFormatter = function EnvelopeUploadedCellFormatter(_ref) {
  var value = _ref.value;

  if (!(0, _validators.isValidValue)(value)) {
    return _react2.default.createElement(
      "span",
      null,
      "Not uploaded yet"
    );
  }
  return _react2.default.createElement(
    "span",
    { title: (0, _moment2.default)(value).fromNow() },
    (0, _moment2.default)(value).format("D MMMM YYYY")
  );
};

EnvelopeUploadedCellFormatter.defaultProps = {
  value: ""
};

EnvelopeUploadedCellFormatter.propTypes = {
  value: _propTypes2.default.string
};

var ReceivedCellFormatter = exports.ReceivedCellFormatter = function ReceivedCellFormatter(_ref2) {
  var value = _ref2.value;

  if (value === "") {
    return _react2.default.createElement(
      "span",
      null,
      "Not received yet"
    );
  }
  return _react2.default.createElement(
    "span",
    { title: (0, _moment2.default)(value).fromNow() },
    (0, _moment2.default)(value).format("D MMMM YYYY")
  );
};

ReceivedCellFormatter.defaultProps = EnvelopeUploadedCellFormatter.defaultProps;
ReceivedCellFormatter.propTypes = EnvelopeUploadedCellFormatter.propTypes;

var SentCellFormatter = exports.SentCellFormatter = function SentCellFormatter(_ref3) {
  var value = _ref3.value;

  if (!(0, _validators.isValidValue)(value)) {
    return _react2.default.createElement(
      "span",
      null,
      "Not sent yet"
    );
  }
  return _react2.default.createElement(
    "span",
    { title: (0, _moment2.default)(value).fromNow() },
    (0, _moment2.default)(value).format("D MMMM YYYY")
  );
};

SentCellFormatter.defaultProps = EnvelopeUploadedCellFormatter.defaultProps;
SentCellFormatter.propTypes = EnvelopeUploadedCellFormatter.propTypes;

var StatusCellFormatter = exports.StatusCellFormatter = function StatusCellFormatter(_ref4) {
  var value = _ref4.value;
  return _react2.default.createElement(
    "span",
    null,
    value.toUpperCase()
  );
};

StatusCellFormatter.defaultProps = EnvelopeUploadedCellFormatter.defaultProps;
StatusCellFormatter.propTypes = EnvelopeUploadedCellFormatter.propTypes;

var EnvelopeCellFormatter = exports.EnvelopeCellFormatter = function EnvelopeCellFormatter(_ref5) {
  var isLinkable = _ref5.isLinkable,
      onAddEnvelope = _ref5.onAddEnvelope,
      onSetFlashMessage = _ref5.onSetFlashMessage,
      slug = _ref5.slug,
      value = _ref5.value;

  if (isLinkable) {
    return _react2.default.createElement(
      "span",
      null,
      _react2.default.createElement(
        _reactRouter.Link,
        {
          onClick: function onClick() {
            onAddEnvelope(value);
            onSetFlashMessage("Filtering documents by envelope " + value);
          },
          to: "/accounts/" + slug + "/documents/all"
        },
        value
      )
    );
  }
  return _react2.default.createElement(
    "span",
    null,
    value
  );
};

EnvelopeCellFormatter.propTypes = {
  isLinkable: _propTypes2.default.bool.isRequired,
  onAddEnvelope: _propTypes2.default.func.isRequired,
  onSetFlashMessage: _propTypes2.default.func.isRequired,
  slug: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.string.isRequired
};

var BillableCellFormatter = exports.BillableCellFormatter = function BillableCellFormatter(_ref6) {
  var value = _ref6.value;

  if (value) {
    return _react2.default.createElement(_envelope2.default, { size: 15 });
  }
  return null;
};

BillableCellFormatter.propTypes = {
  value: _propTypes2.default.bool.isRequired
};

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputCellFormatter = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSizeme = __webpack_require__(386);

var _focusCellFormatters = __webpack_require__(325);

var _focusCellFormatters2 = _interopRequireDefault(_focusCellFormatters);

var _customPropTypes = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InputCell = function InputCell(_ref) {
  var accountId = _ref.accountId,
      document = _ref.document,
      documentCount = _ref.documentCount,
      field = _ref.field,
      isFocused = _ref.isFocused,
      onUpdateDocument = _ref.onUpdateDocument,
      onUpdateInlineDocument = _ref.onUpdateInlineDocument,
      rowIndex = _ref.rowIndex,
      size = _ref.size,
      value = _ref.value;

  if (isFocused && !(document.type === "other" && field === "invoiceNumber")) {
    return _react2.default.createElement(
      "div",
      null,
      _react2.default.createElement("input", {
        className: _focusCellFormatters2.default.input,
        defaultValue: value,
        onBlur: function onBlur(e) {
          return onUpdateInlineDocument({ accountId: accountId, document: document, field: field, value: e.target.value });
        },
        onChange: function onChange(e) {
          return onUpdateDocument(field, e.target.value);
        },
        type: "text"
      })
    );
  }
  var length = value ? value.length * 5 : 0;
  var tooltipStyle = rowIndex < documentCount / 2 ? _focusCellFormatters2.default["tooltip-bottom"] : _focusCellFormatters2.default["tooltip-top"];
  return _react2.default.createElement(
    "div",
    { className: _focusCellFormatters2.default.container },
    value,
    renderTooltip(length, size, value, tooltipStyle)
  );
};

InputCell.defaultProps = {
  value: null
};

InputCell.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  document: _customPropTypes.documentPropType.isRequired,
  documentCount: _propTypes2.default.number.isRequired,
  field: _propTypes2.default.string.isRequired,
  isFocused: _propTypes2.default.bool.isRequired,
  onUpdateDocument: _propTypes2.default.func.isRequired,
  onUpdateInlineDocument: _propTypes2.default.func.isRequired,
  rowIndex: _propTypes2.default.number.isRequired,
  size: _propTypes2.default.shape({ size: _propTypes2.default.number }).isRequired,
  value: _propTypes2.default.string
};

var InputCellFormatter = exports.InputCellFormatter = (0, _reactSizeme.withSize)()(InputCell);

var renderTooltip = function renderTooltip(length, size, value, tooltipStyle) {
  if (length > size.width) {
    return _react2.default.createElement(
      "div",
      { className: tooltipStyle },
      value
    );
  }
  return null;
};

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NameCellFormatter = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _nameCellFormatter = __webpack_require__(1336);

var _nameCellFormatter2 = _interopRequireDefault(_nameCellFormatter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NameCellFormatter = exports.NameCellFormatter = function NameCellFormatter(_ref) {
  var value = _ref.value;

  if (!value || value === "No Name") {
    return _react2.default.createElement(
      "span",
      { className: _nameCellFormatter2.default["no-name"] },
      "No Name"
    );
  }
  return _react2.default.createElement(
    "span",
    null,
    value
  );
};

NameCellFormatter.propTypes = {
  value: _propTypes2.default.string.isRequired
};

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimeCellFormatter = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _validators = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TimeCellFormatter = exports.TimeCellFormatter = function TimeCellFormatter(_ref) {
  var value = _ref.value;

  if (!(0, _validators.isValidValue)(value)) {
    return _react2.default.createElement("span", null);
  }
  return _react2.default.createElement(
    "span",
    { title: (0, _moment2.default)(value).fromNow() },
    (0, _moment2.default)(value).format("DD/MM/YY [at] h:mm a")
  );
};

TimeCellFormatter.defaultProps = {
  value: (0, _moment2.default)().format("DD/MM/YY")
};

TimeCellFormatter.propTypes = {
  value: _propTypes2.default.string
};

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TotalCellFormatter = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _validators = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TotalCellFormatter = exports.TotalCellFormatter = function TotalCellFormatter(_ref) {
  var value = _ref.value;

  if (!(0, _validators.isValidValue)(value)) {
    return _react2.default.createElement("span", null);
  }
  return _react2.default.createElement(
    "span",
    null,
    "$" + parseFloat(value / 100).toFixed(2)
  );
};

TotalCellFormatter.propTypes = {
  value: _propTypes2.default.number.isRequired
};

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TypeCellFormatter = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _typeCellFormatter = __webpack_require__(1338);

var _typeCellFormatter2 = _interopRequireDefault(_typeCellFormatter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TypeCellFormatter = exports.TypeCellFormatter = function TypeCellFormatter(_ref) {
  var value = _ref.value;

  var _getTypeValue = getTypeValue(value),
      type = _getTypeValue.type,
      tooltip = _getTypeValue.tooltip;

  return _react2.default.createElement(
    "div",
    { className: _typeCellFormatter2.default.container },
    type,
    _react2.default.createElement(
      "div",
      { className: _typeCellFormatter2.default.tooltip },
      tooltip
    )
  );
};

TypeCellFormatter.propTypes = {
  value: _propTypes2.default.string.isRequired
};

var getTypeValue = function getTypeValue(value) {
  switch (value) {
    case "receipt":
      return { type: "R", tooltip: "Receipt" };
    case "other":
      return { type: "O", tooltip: "Other Document" };
    case "business-card":
      return { type: "B", tooltip: "Business Card" };
    default:
      return { type: "?", tooltip: "Unknown document type" };
  }
};

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VendorRuleCellFormatter = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _categoryCell = __webpack_require__(511);

var _categoryCell2 = _interopRequireDefault(_categoryCell);

var _validators = __webpack_require__(36);

var _activeFilterItem = __webpack_require__(116);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VendorRuleCellFormatter = exports.VendorRuleCellFormatter = function VendorRuleCellFormatter(props) {
  if (!(0, _validators.isValidValue)(props.value)) {
    return null;
  }
  return _react2.default.createElement(
    "div",
    { className: _categoryCell2.default["active-filter-group"] },
    mapRenderItem(props)
  );
};

VendorRuleCellFormatter.defaultProps = {
  value: []
};

VendorRuleCellFormatter.propTypes = {
  value: _propTypes2.default.arrayOf(_propTypes2.default.object)
};

var mapRenderItem = function mapRenderItem(props) {
  return props.value.map(function (item) {
    return renderItem(props, item);
  });
};

var renderItem = function renderItem(props, item) {
  var rule = _ramda2.default.find(_ramda2.default.propEq("vendorName", props.vendorName))(item.rules.includeVendors);
  return _react2.default.createElement(
    "span",
    { key: item.name + "-" + item.id },
    _react2.default.createElement(_activeFilterItem.ActiveFilterItem, {
      name: item.name,
      onRemove: function onRemove() {
        return props.onDeleteIncludeRule(props.accountId, item, rule);
      }
    })
  );
};

renderItem.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  onDeleteIncludeRule: _propTypes2.default.func.isRequired,
  vendorName: _propTypes2.default.string.isRequired
};

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddCategoryModal = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _addCategoryModal = __webpack_require__(516);

var _addCategoryModal2 = _interopRequireDefault(_addCategoryModal);

var _modal = __webpack_require__(27);

var _button = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddCategoryModal = exports.AddCategoryModal = function AddCategoryModal(_ref) {
  var accountId = _ref.accountId,
      isAddCategoryVisible = _ref.isAddCategoryVisible,
      newCategory = _ref.newCategory,
      onCreateCategory = _ref.onCreateCategory,
      onHideAddCategory = _ref.onHideAddCategory,
      onUpdateNewCategoryName = _ref.onUpdateNewCategoryName;
  return _react2.default.createElement(
    _modal.Modal,
    {
      isVisible: isAddCategoryVisible,
      onClose: onHideAddCategory,
      transitionName: "add-category"
    },
    _react2.default.createElement(
      "h2",
      null,
      "Add new category"
    ),
    _react2.default.createElement(
      "div",
      { className: _addCategoryModal2.default["field-cell"] },
      _react2.default.createElement(
        "div",
        null,
        "Category Name"
      ),
      _react2.default.createElement("input", {
        className: _addCategoryModal2.default.fields,
        defaultValue: newCategory,
        onChange: function onChange(e) {
          return onUpdateNewCategoryName(e.target.value);
        }
      })
    ),
    _react2.default.createElement(
      "div",
      { className: _addCategoryModal2.default["button-container"] },
      _react2.default.createElement(
        _button.Button,
        { link: true, onClick: onHideAddCategory },
        "cancel"
      ),
      _react2.default.createElement(
        _button.Button,
        {
          onClick: function onClick() {
            onHideAddCategory();onCreateCategory(accountId, newCategory);
          },
          primary: true
        },
        "Add Category"
      )
    )
  );
};

AddCategoryModal.defaultProps = {
  newCategory: null
};

AddCategoryModal.propTypes = {
  accountId: _react.PropTypes.string.isRequired,
  isAddCategoryVisible: _react.PropTypes.bool.isRequired,
  newCategory: _react.PropTypes.string,
  onCreateCategory: _react.PropTypes.func.isRequired,
  onHideAddCategory: _react.PropTypes.func.isRequired,
  onUpdateNewCategoryName: _react.PropTypes.func.isRequired
};

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CategoryDropdown = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _dropdown = __webpack_require__(224);

var _dropdown2 = _interopRequireDefault(_dropdown);

var _grid = __webpack_require__(95);

var _grid2 = _interopRequireDefault(_grid);

var _customPropTypes = __webpack_require__(5);

var _button = __webpack_require__(7);

var _select = __webpack_require__(45);

var _activeFilterItem = __webpack_require__(116);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CategoryDropdown = exports.CategoryDropdown = function CategoryDropdown(_ref) {
  var accountId = _ref.accountId,
      focusedCategory = _ref.focusedCategory,
      isSaveCategoryLoading = _ref.isSaveCategoryLoading,
      newIncludeRules = _ref.newIncludeRules,
      onRemoveDropdownRule = _ref.onRemoveDropdownRule,
      onSaveCategory = _ref.onSaveCategory,
      onUnfocusCategory = _ref.onUnfocusCategory,
      onUpdateCategoryName = _ref.onUpdateCategoryName,
      onUpdateIncludeVendors = _ref.onUpdateIncludeVendors,
      rowHeight = _ref.rowHeight,
      vendors = _ref.vendors;

  if (focusedCategory === null) {
    return null;
  }
  var newStyle = { top: focusedCategory.style.top + rowHeight * 2.5 };
  return _react2.default.createElement(
    "div",
    { className: _dropdown2.default.container, key: focusedCategory.id, style: newStyle },
    _react2.default.createElement(
      "div",
      { className: _dropdown2.default.dropdown },
      _react2.default.createElement(
        "div",
        { className: _grid2.default["container-fluid"] },
        _react2.default.createElement(
          "div",
          { className: _dropdown2.default["categories-row"] + " " + _grid2.default.row },
          _react2.default.createElement(
            "div",
            { className: _grid2.default["col-md-6"] },
            _react2.default.createElement(
              "div",
              { className: _dropdown2.default["field-cell"] },
              _react2.default.createElement(
                "div",
                null,
                "Name"
              ),
              _react2.default.createElement("input", {
                className: _dropdown2.default.fields,
                defaultValue: focusedCategory.name,
                disabled: focusedCategory.type === "system",
                onBlur: function onBlur(e) {
                  return onUpdateCategoryName(e.target.value);
                },
                type: "text"
              })
            )
          ),
          _react2.default.createElement(
            "div",
            { className: _grid2.default["col-md-6"] },
            _react2.default.createElement(
              "div",
              { className: _dropdown2.default["field-cell"] },
              _react2.default.createElement(
                "div",
                null,
                "Vendors"
              ),
              _react2.default.createElement(_select.Select, {
                data: mapVendors(vendors),
                onChange: function onChange(e) {
                  onUpdateIncludeVendors(e);
                },
                placeholder: "Add a vendor rule"
              })
            ),
            _react2.default.createElement(
              "div",
              { className: _dropdown2.default["field-cell"] },
              _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement(
                  "div",
                  null,
                  "Vendor rules:"
                ),
                displayRulesMapper(focusedCategory.rules.includeVendors, newIncludeRules, onRemoveDropdownRule)
              )
            ),
            _react2.default.createElement(
              "div",
              { className: _dropdown2.default["actions-container"] },
              _react2.default.createElement(
                _button.Button,
                { link: true, onClick: function onClick() {
                    return onUnfocusCategory();
                  } },
                "cancel"
              ),
              _react2.default.createElement(
                _button.Button,
                {
                  loading: isSaveCategoryLoading,
                  onClick: function onClick() {
                    return onSaveCategory({ accountId: accountId, focusedCategory: focusedCategory, newIncludeRules: newIncludeRules });
                  },
                  primary: true
                },
                "Save"
              )
            )
          )
        )
      )
    )
  );
};

CategoryDropdown.defaultProps = {
  focusedCategory: null
};

CategoryDropdown.propTypes = {
  accountId: _react.PropTypes.string.isRequired,
  focusedCategory: _customPropTypes.categoryType,
  isSaveCategoryLoading: _react.PropTypes.bool.isRequired,
  newIncludeRules: _react.PropTypes.arrayOf(_customPropTypes.selectOptionType).isRequired,
  onRemoveDropdownRule: _react.PropTypes.func.isRequired,
  onSaveCategory: _react.PropTypes.func.isRequired,
  onUnfocusCategory: _react.PropTypes.func.isRequired,
  onUpdateCategoryName: _react.PropTypes.func.isRequired,
  onUpdateIncludeVendors: _react.PropTypes.func.isRequired,
  rowHeight: _react.PropTypes.number.isRequired,
  vendors: _react.PropTypes.arrayOf(_customPropTypes.vendorType).isRequired
};

var mapVendors = function mapVendors(vendors) {
  return vendors.map(function (vendor) {
    return { key: vendor.name, name: vendor.name };
  });
};

var displayRulesMapper = function displayRulesMapper(rules, newRules, onRemoveDropdownRule) {
  if (rules.length === 0 && newRules.length === 0) {
    return _react2.default.createElement(
      "h3",
      null,
      "No vendor rules"
    );
  }
  var existingRender = rules.map(function (rule) {
    return renderExistingRule(rule, onRemoveDropdownRule);
  });
  var newRender = newRules.map(function (rule) {
    return renderNewRule(rule, onRemoveDropdownRule);
  });
  return [existingRender, newRender];
};

var renderExistingRule = function renderExistingRule(rule, onRemoveDropdownRule) {
  return _react2.default.createElement(
    "span",
    { key: "" + rule.vendorName },
    _react2.default.createElement(_activeFilterItem.ActiveFilterItem, { name: rule.vendorName, onRemove: function onRemove() {
        onRemoveDropdownRule(rule);
      } })
  );
};

var renderNewRule = function renderNewRule(rule, onRemoveDropdownRule) {
  return _react2.default.createElement(
    "span",
    { key: "" + rule.name },
    _react2.default.createElement(_activeFilterItem.ActiveFilterItem, { name: rule.name, onRemove: function onRemove() {
        onRemoveDropdownRule(rule, true);
      } })
  );
};

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeleteCategoriesModal = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _deleteCategoriesModal = __webpack_require__(1341);

var _deleteCategoriesModal2 = _interopRequireDefault(_deleteCategoriesModal);

var _modal = __webpack_require__(27);

var _button = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeleteCategoriesModal = exports.DeleteCategoriesModal = function DeleteCategoriesModal(_ref) {
  var isDeleteCategoriesLoading = _ref.isDeleteCategoriesLoading,
      isDeleteCategoriesVisible = _ref.isDeleteCategoriesVisible,
      onDeleteCategories = _ref.onDeleteCategories,
      onHideDeleteCategories = _ref.onHideDeleteCategories,
      selectedCategoryIds = _ref.selectedCategoryIds;
  return _react2.default.createElement(
    _modal.Modal,
    {
      isVisible: isDeleteCategoriesVisible,
      onClose: onHideDeleteCategories,
      transitionName: "delete-categories"
    },
    _react2.default.createElement(
      "h2",
      null,
      "Permanently delete these categories?"
    ),
    _react2.default.createElement(
      "div",
      { className: _deleteCategoriesModal2.default.controls },
      _react2.default.createElement(
        _button.Button,
        { link: true, onClick: onHideDeleteCategories },
        "cancel"
      ),
      _react2.default.createElement(
        _button.Button,
        {
          danger: true,
          disabled: selectedCategoryIds.length === 0,
          loading: isDeleteCategoriesLoading,
          onClick: onDeleteCategories
        },
        "Delete Categories"
      )
    )
  );
};

DeleteCategoriesModal.propTypes = {
  isDeleteCategoriesLoading: _react.PropTypes.bool.isRequired,
  isDeleteCategoriesVisible: _react.PropTypes.bool.isRequired,
  onDeleteCategories: _react.PropTypes.func.isRequired,
  onHideDeleteCategories: _react.PropTypes.func.isRequired,
  selectedCategoryIds: _react.PropTypes.arrayOf(_react.PropTypes.string).isRequired
};

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ManageCategories = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactVirtualized = __webpack_require__(113);

var _customPropTypes = __webpack_require__(5);

var _manageCategories = __webpack_require__(517);

var _manageCategories2 = _interopRequireDefault(_manageCategories);

var _button = __webpack_require__(7);

var _automateInlineTabs = __webpack_require__(418);

var _addCategoryModal = __webpack_require__(890);

var _deleteCategoriesModal = __webpack_require__(892);

var _gridComponents = __webpack_require__(166);

var _categoryDropdown = __webpack_require__(891);

var _noItems = __webpack_require__(421);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ManageCategories = function ManageCategories(props) {
  return _react2.default.createElement(
    "div",
    { className: _manageCategories2.default.container },
    _react2.default.createElement(_automateInlineTabs.AutomateInlineTabs, { currentPage: "manage-categories", slug: props.slug }),
    _react2.default.createElement(
      "h1",
      null,
      "Manage Categories"
    ),
    _react2.default.createElement(
      "div",
      { className: _manageCategories2.default["controls-container"] },
      _react2.default.createElement(
        _button.Button,
        {
          danger: true,
          disabled: props.selectedCategoryIds.length === 0,
          onClick: props.onShowDeleteCategories
        },
        "Delete Categories"
      ),
      _react2.default.createElement(
        _button.Button,
        { onClick: props.onShowAddCategory, primary: true },
        "Add category"
      )
    ),
    _react2.default.createElement(
      "div",
      { className: _manageCategories2.default["grid-container"] },
      _react2.default.createElement(
        _reactVirtualized.AutoSizer,
        { disableHeight: true },
        function (_ref) {
          var width = _ref.width;
          return _react2.default.createElement(_reactVirtualized.MultiGrid, _extends({}, props, {
            cache: cache,
            cellRenderer: function cellRenderer(_ref2) {
              var gridProps = _objectWithoutProperties(_ref2, []);

              return _react2.default.createElement(_gridComponents.CellRenderer, _extends({}, gridProps, { newKey: gridProps.key }));
            },
            classNameBottomRightGrid: _manageCategories2.default["bottom-grid"],
            classNameTopRightGrid: _manageCategories2.default["top-grid"],
            columnCount: columns.length,
            columns: columns,
            columnWidth: function columnWidth(_ref3) {
              var index = _ref3.index;
              return getColumnWidth(index, width, columns.length);
            },
            deferredMeasurementCache: cache,
            documents: props.categories,
            fixedRowCount: 1,
            height: (0, _gridComponents.getGridHeight)(-1, props.categories.length, rowHeight),
            isRowFocusable: true,
            isSelectable: true,
            noContentRenderer: function noContentRenderer() {
              return _react2.default.createElement(_noItems.NoItems, { name: "categories" });
            },
            onFocusRow: props.onFocusCategory,
            rowCount: props.categories.length + 1,
            rowHeight: rowHeight,
            selectedDocumentIds: props.selectedCategoryIds,
            width: width
          }));
        }
      ),
      _react2.default.createElement(_categoryDropdown.CategoryDropdown, _extends({}, props, { rowHeight: rowHeight }))
    ),
    _react2.default.createElement(_addCategoryModal.AddCategoryModal, props),
    _react2.default.createElement(_deleteCategoriesModal.DeleteCategoriesModal, props)
  );
};

exports.ManageCategories = ManageCategories;
ManageCategories.defaultProps = {
  focusedCategory: null
};

ManageCategories.propTypes = {
  categories: _react.PropTypes.arrayOf(_customPropTypes.categoryType).isRequired,
  onFocusCategory: _react.PropTypes.func.isRequired,
  onShowAddCategory: _react.PropTypes.func.isRequired,
  onShowDeleteCategories: _react.PropTypes.func.isRequired,
  selectedCategoryIds: _react.PropTypes.arrayOf(_react.PropTypes.string).isRequired,
  slug: _react.PropTypes.string.isRequired
};

var rowHeight = 45;
var columns = [{
  key: "select",
  visible: true
}, {
  key: "name",
  name: "Name",
  sortable: true,
  visible: true
}, {
  key: "receipts",
  name: "Number of Receipts",
  sortable: true,
  visible: true
}, {
  key: "rules",
  name: "Always add to vendor",
  sortable: true,
  visible: true
}];

var getColumnWidth = function getColumnWidth(index, width, columnsLength) {
  switch (index) {
    case 0:
      return 75;
    default:
      return (width - 75) / (columnsLength - 1);
  }
};

var cache = new _reactVirtualized.CellMeasurerCache({
  defaultWidth: 300,
  minWidth: 250
});

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoEnvelopes = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _openSquirrel = __webpack_require__(328);

var _openSquirrel2 = _interopRequireDefault(_openSquirrel);

var _noEnvelopes = __webpack_require__(1344);

var _noEnvelopes2 = _interopRequireDefault(_noEnvelopes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NoEnvelopes = exports.NoEnvelopes = function NoEnvelopes() {
  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      "div",
      { className: _noEnvelopes2.default.container },
      _react2.default.createElement("img", { alt: "open arms squirrel", src: _openSquirrel2.default }),
      _react2.default.createElement(
        "h3",
        null,
        "It doesn't look like you have any envelopes. Click the request an envelope to get started!"
      )
    )
  );
};

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RequestEnvelopeModal = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _envelopeModals = __webpack_require__(518);

var _envelopeModals2 = _interopRequireDefault(_envelopeModals);

var _modal = __webpack_require__(27);

var _button = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RequestEnvelopeModal = exports.RequestEnvelopeModal = function RequestEnvelopeModal(_ref) {
  var accountId = _ref.accountId,
      isRequestEnvelopeVisible = _ref.isRequestEnvelopeVisible,
      onHideRequestEnvelope = _ref.onHideRequestEnvelope,
      onRequestEnvelope = _ref.onRequestEnvelope;
  return _react2.default.createElement(
    _modal.Modal,
    {
      isVisible: isRequestEnvelopeVisible,
      onClose: onHideRequestEnvelope,
      transitionName: "request-envelope"
    },
    _react2.default.createElement(
      "h2",
      null,
      "Need an extra Magic Envelope?"
    ),
    _react2.default.createElement(
      "div",
      { className: _envelopeModals2.default.controls },
      _react2.default.createElement(
        _button.Button,
        { link: true, onClick: onHideRequestEnvelope },
        "close"
      ),
      _react2.default.createElement(
        _button.Button,
        { onClick: function onClick() {
            return onRequestEnvelope(accountId);
          }, primary: true },
        "Request Envelope"
      )
    )
  );
};

RequestEnvelopeModal.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  isRequestEnvelopeVisible: _propTypes2.default.bool.isRequired,
  onHideRequestEnvelope: _propTypes2.default.func.isRequired,
  onRequestEnvelope: _propTypes2.default.func.isRequired
};

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SendEnvelopeModal = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _envelopeModals = __webpack_require__(518);

var _envelopeModals2 = _interopRequireDefault(_envelopeModals);

var _modal = __webpack_require__(27);

var _button = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SendEnvelopeModal = exports.SendEnvelopeModal = function SendEnvelopeModal(_ref) {
  var coversheetUrl = _ref.coversheetUrl,
      isSendEnvelopeVisible = _ref.isSendEnvelopeVisible,
      onHideSendEnvelope = _ref.onHideSendEnvelope;
  return _react2.default.createElement(
    _modal.Modal,
    {
      isVisible: isSendEnvelopeVisible,
      onClose: onHideSendEnvelope,
      transitionName: "send-envelope"
    },
    _react2.default.createElement(
      "h2",
      null,
      "Not using a Squirrel Street Magic Envelope?"
    ),
    _react2.default.createElement(
      "div",
      null,
      "Mail your documents with a coversheet to the address below."
    ),
    _react2.default.createElement(
      "div",
      { className: _envelopeModals2.default.address },
      _react2.default.createElement(
        "p",
        null,
        _react2.default.createElement(
          "strong",
          null,
          "Regular and Express Post"
        )
      ),
      _react2.default.createElement(
        "p",
        null,
        "Squirrel Street"
      ),
      _react2.default.createElement(
        "p",
        null,
        "PO Box 6488"
      ),
      _react2.default.createElement(
        "p",
        null,
        "FRENCHS FOREST NSW 2086"
      ),
      _react2.default.createElement(
        "p",
        null,
        "AUSTRALIA"
      )
    ),
    _react2.default.createElement(
      "div",
      null,
      "No printer? Make a simple coversheet with your name, phone and email address!"
    ),
    _react2.default.createElement(
      "div",
      { className: _envelopeModals2.default.controls },
      _react2.default.createElement(
        _button.Button,
        { link: true, onClick: onHideSendEnvelope },
        "close"
      ),
      _react2.default.createElement(
        _button.Button,
        { onClick: function onClick() {
            return window.open(coversheetUrl);
          }, primary: true },
        "Print Coversheet"
      )
    )
  );
};

SendEnvelopeModal.propTypes = {
  coversheetUrl: _propTypes2.default.string.isRequired,
  isSendEnvelopeVisible: _propTypes2.default.bool.isRequired,
  onHideSendEnvelope: _propTypes2.default.func.isRequired
};

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddVendorRulesModal = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _addVendorRulesModal = __webpack_require__(1345);

var _addVendorRulesModal2 = _interopRequireDefault(_addVendorRulesModal);

var _customPropTypes = __webpack_require__(5);

var _modal = __webpack_require__(27);

var _select = __webpack_require__(45);

var _button = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddVendorRulesModal = exports.AddVendorRulesModal = function AddVendorRulesModal(_ref) {
  var categories = _ref.categories,
      isAddVendorRulesLoading = _ref.isAddVendorRulesLoading,
      isAddVendorRulesMode = _ref.isAddVendorRulesMode,
      onAddVendorRules = _ref.onAddVendorRules,
      onEndAddVendorRulesMode = _ref.onEndAddVendorRulesMode,
      onSelectCategory = _ref.onSelectCategory,
      selectedCategory = _ref.selectedCategory,
      selectedVendorIds = _ref.selectedVendorIds;
  return _react2.default.createElement(
    _modal.Modal,
    {
      isVisible: isAddVendorRulesMode,
      onClose: onEndAddVendorRulesMode,
      transitionName: "add-vendor-rules"
    },
    _react2.default.createElement(
      "h2",
      null,
      "Add vendor rules"
    ),
    _react2.default.createElement(
      "div",
      { className: _addVendorRulesModal2.default["vendor-list"] },
      "Selected vendors: ",
      mapSelectedVendors(selectedVendorIds)
    ),
    _react2.default.createElement(
      "div",
      { className: _addVendorRulesModal2.default.actions },
      _react2.default.createElement(_select.Select, {
        data: mapCategories(categories),
        onChange: function onChange(e) {
          return onSelectCategory(e);
        },
        placeholder: "Select a category...",
        value: selectedCategory
      }),
      _react2.default.createElement(
        _button.Button,
        {
          disabled: !selectedCategory,
          loading: isAddVendorRulesLoading,
          onClick: function onClick() {
            return onAddVendorRules();
          },
          primary: true
        },
        "Add Rule"
      ),
      _react2.default.createElement(
        _button.Button,
        { link: true, onClick: onEndAddVendorRulesMode },
        "cancel"
      )
    )
  );
};

AddVendorRulesModal.defaultProps = {
  selectedCategory: null,
  selectedVendorIds: []
};

AddVendorRulesModal.propTypes = {
  categories: _propTypes2.default.arrayOf(_customPropTypes.categoryType).isRequired,
  isAddVendorRulesLoading: _propTypes2.default.bool.isRequired,
  isAddVendorRulesMode: _propTypes2.default.bool.isRequired,
  onAddVendorRules: _propTypes2.default.func.isRequired,
  onEndAddVendorRulesMode: _propTypes2.default.func.isRequired,
  onSelectCategory: _propTypes2.default.func.isRequired,
  selectedCategory: _customPropTypes.categoryType,
  selectedVendorIds: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

var mapCategories = function mapCategories(categories) {
  return categories.map(function (category) {
    return {
      key: category.name,
      name: category.name,
      info: category.id
    };
  });
};

var mapSelectedVendors = function mapSelectedVendors(vendors) {
  return vendors.map(function (vendor, index) {
    var comma = index === vendors.length - 1 ? "" : ",";
    return _react2.default.createElement(
      "span",
      { className: _addVendorRulesModal2.default.vendor, key: vendor },
      vendor,
      comma
    );
  });
};

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ManageVendors = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactVirtualized = __webpack_require__(113);

var _customPropTypes = __webpack_require__(5);

var _manageCategories = __webpack_require__(517);

var _manageCategories2 = _interopRequireDefault(_manageCategories);

var _button = __webpack_require__(7);

var _automateInlineTabs = __webpack_require__(418);

var _gridComponents = __webpack_require__(166);

var _noItems = __webpack_require__(421);

var _addVendorRulesModal = __webpack_require__(897);

var _mergeVendorsModal = __webpack_require__(899);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ManageVendors = function ManageVendors(_ref) {
  var accountId = _ref.accountId,
      categories = _ref.categories,
      isAddVendorRulesLoading = _ref.isAddVendorRulesLoading,
      isAddVendorRulesMode = _ref.isAddVendorRulesMode,
      isMergeVendorsLoading = _ref.isMergeVendorsLoading,
      isMergeVendorsMode = _ref.isMergeVendorsMode,
      onAddVendorRules = _ref.onAddVendorRules,
      onDeleteIncludeRule = _ref.onDeleteIncludeRule,
      onDeselectVendors = _ref.onDeselectVendors,
      onEndAddVendorRulesMode = _ref.onEndAddVendorRulesMode,
      onEndMergeVendorsMode = _ref.onEndMergeVendorsMode,
      onMergeVendors = _ref.onMergeVendors,
      onOrderBy = _ref.onOrderBy,
      onSelectCategory = _ref.onSelectCategory,
      onSelectMergeVendor = _ref.onSelectMergeVendor,
      onSelectVendors = _ref.onSelectVendors,
      onStartAddVendorRulesMode = _ref.onStartAddVendorRulesMode,
      onStartMergeVendorsMode = _ref.onStartMergeVendorsMode,
      orderBy = _ref.orderBy,
      orderDirection = _ref.orderDirection,
      selectedCategory = _ref.selectedCategory,
      selectedVendorIds = _ref.selectedVendorIds,
      selectedVendor = _ref.selectedVendor,
      slug = _ref.slug,
      vendors = _ref.vendors;
  return _react2.default.createElement(
    "div",
    { className: _manageCategories2.default.container },
    _react2.default.createElement(_automateInlineTabs.AutomateInlineTabs, { currentPage: "manage-vendors", slug: slug }),
    _react2.default.createElement(
      "h1",
      null,
      "Manage Vendors"
    ),
    _react2.default.createElement(
      "div",
      { className: _manageCategories2.default["controls-container"] },
      _react2.default.createElement(
        _button.Button,
        {
          disabled: selectedVendorIds.length < 2,
          onClick: onStartMergeVendorsMode,
          primary: true
        },
        "Merge Vendors"
      ),
      _react2.default.createElement(
        _button.Button,
        {
          disabled: !selectedVendorIds.length > 0,
          onClick: onStartAddVendorRulesMode,
          primary: true
        },
        "Add vendor rules"
      ),
      _react2.default.createElement(_addVendorRulesModal.AddVendorRulesModal, {
        categories: categories,
        isAddVendorRulesLoading: isAddVendorRulesLoading,
        isAddVendorRulesMode: isAddVendorRulesMode,
        onAddVendorRules: onAddVendorRules,
        onEndAddVendorRulesMode: onEndAddVendorRulesMode,
        onSelectCategory: onSelectCategory,
        selectedCategory: selectedCategory,
        selectedVendorIds: selectedVendorIds
      }),
      _react2.default.createElement(_mergeVendorsModal.MergeVendorsModal, {
        accountId: accountId,
        isMergeVendorsLoading: isMergeVendorsLoading,
        isMergeVendorsMode: isMergeVendorsMode,
        onEndMergeVendorsMode: onEndMergeVendorsMode,
        onMergeVendors: onMergeVendors,
        onSelectMergeVendor: onSelectMergeVendor,
        selectedVendor: selectedVendor,
        selectedVendorIds: selectedVendorIds
      })
    ),
    _react2.default.createElement(
      "div",
      { className: _manageCategories2.default["grid-container"] },
      _react2.default.createElement(
        _reactVirtualized.AutoSizer,
        { disableHeight: true },
        function (_ref2) {
          var width = _ref2.width;
          return _react2.default.createElement(_reactVirtualized.MultiGrid, {
            accountId: accountId,
            cache: cache,
            cellRenderer: function cellRenderer(_ref3) {
              var gridProps = _objectWithoutProperties(_ref3, []);

              return _react2.default.createElement(_gridComponents.CellRenderer, _extends({}, gridProps, { newKey: gridProps.key }));
            },
            classNameBottomRightGrid: _manageCategories2.default["bottom-grid"],
            classNameTopRightGrid: _manageCategories2.default["top-grid"],
            columnCount: columns.length,
            columns: columns,
            columnWidth: function columnWidth(_ref4) {
              var index = _ref4.index;
              return getColumnWidth(index, width, columns.length);
            },
            deferredMeasurementCache: cache,
            documents: vendors,
            fixedRowCount: 1,
            height: (0, _gridComponents.getGridHeight)(-1, vendors.length, 45),
            isManageVendorsPage: true,
            isRowFocusable: true,
            isSelectable: true,
            noContentRenderer: function noContentRenderer() {
              return _react2.default.createElement(_noItems.NoItems, { name: "vendors" });
            },
            onDeleteIncludeRule: onDeleteIncludeRule,
            onFocusRow: onSelectVendors,
            onOrderBy: onOrderBy,
            onRowsDeselected: onDeselectVendors,
            onRowsSelected: onSelectVendors,
            orderBy: orderBy,
            orderDirection: orderDirection,
            rowCount: vendors.length + 1,
            rowHeight: 45,
            selectedDocumentIds: selectedVendorIds,
            width: width
          });
        }
      )
    )
  );
};

exports.ManageVendors = ManageVendors;
ManageVendors.defaultProps = {
  selectedCategory: null,
  selectedVendorIds: [],
  selectedVendor: null
};

ManageVendors.propTypes = {
  accountId: _react.PropTypes.string.isRequired,
  categories: _react.PropTypes.arrayOf(_customPropTypes.categoryType).isRequired,
  isAddVendorRulesLoading: _react.PropTypes.bool.isRequired,
  isAddVendorRulesMode: _react.PropTypes.bool.isRequired,
  isMergeVendorsLoading: _react.PropTypes.bool.isRequired,
  isMergeVendorsMode: _react.PropTypes.bool.isRequired,
  onAddVendorRules: _react.PropTypes.func.isRequired,
  onDeleteIncludeRule: _react.PropTypes.func.isRequired,
  onDeselectVendors: _react.PropTypes.func.isRequired,
  onEndAddVendorRulesMode: _react.PropTypes.func.isRequired,
  onEndMergeVendorsMode: _react.PropTypes.func.isRequired,
  onMergeVendors: _react.PropTypes.func.isRequired,
  onOrderBy: _react.PropTypes.func.isRequired,
  onSelectCategory: _react.PropTypes.func.isRequired,
  onSelectMergeVendor: _react.PropTypes.func.isRequired,
  onSelectVendors: _react.PropTypes.func.isRequired,
  onStartAddVendorRulesMode: _react.PropTypes.func.isRequired,
  onStartMergeVendorsMode: _react.PropTypes.func.isRequired,
  orderBy: _react.PropTypes.string.isRequired,
  orderDirection: _react.PropTypes.string.isRequired,
  selectedCategory: _customPropTypes.categoryType,
  selectedVendor: _customPropTypes.selectOptionType,
  selectedVendorIds: _react.PropTypes.arrayOf(_react.PropTypes.string),
  slug: _react.PropTypes.string.isRequired,
  vendors: _react.PropTypes.arrayOf(_customPropTypes.vendorType).isRequired
};

var columns = [{
  key: "select",
  visible: true
}, {
  key: "name",
  name: "Vendors",
  sortable: true,
  visible: true
}, {
  key: "receipts",
  name: "Number of Receipts",
  sortable: true,
  visible: true
}, {
  key: "rules",
  name: "Vendor Rules",
  sortable: true,
  visible: true
}];

var getColumnWidth = function getColumnWidth(index, width, columnsLength) {
  switch (index) {
    case 0:
      return 75;
    default:
      return (width - 75) / (columnsLength - 1);
  }
};

var cache = new _reactVirtualized.CellMeasurerCache({
  defaultWidth: 300,
  minWidth: 250,
  fixedHeight: true
});

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MergeVendorsModal = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mergeVendorsModal = __webpack_require__(1346);

var _mergeVendorsModal2 = _interopRequireDefault(_mergeVendorsModal);

var _customPropTypes = __webpack_require__(5);

var _modal = __webpack_require__(27);

var _select = __webpack_require__(45);

var _button = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MergeVendorsModal = exports.MergeVendorsModal = function MergeVendorsModal(_ref) {
  var accountId = _ref.accountId,
      isMergeVendorsLoading = _ref.isMergeVendorsLoading,
      isMergeVendorsMode = _ref.isMergeVendorsMode,
      onEndMergeVendorsMode = _ref.onEndMergeVendorsMode,
      onMergeVendors = _ref.onMergeVendors,
      onSelectMergeVendor = _ref.onSelectMergeVendor,
      selectedVendor = _ref.selectedVendor,
      selectedVendorIds = _ref.selectedVendorIds;
  return _react2.default.createElement(
    _modal.Modal,
    {
      isVisible: isMergeVendorsMode,
      onClose: onEndMergeVendorsMode,
      transitionName: "merge-vendors"
    },
    _react2.default.createElement(
      "h2",
      null,
      "Merge Vendors"
    ),
    _react2.default.createElement(
      "div",
      null,
      "Choose which vendor you would to merge the other vendors into:"
    ),
    _react2.default.createElement(
      "div",
      { className: _mergeVendorsModal2.default.text },
      _react2.default.createElement(
        "small",
        null,
        "(This will retroactively update all documents with the old vendor name(s) to the new vendor name)"
      )
    ),
    _react2.default.createElement(_select.Select, {
      data: mapVendors(selectedVendorIds),
      onChange: function onChange(e) {
        return onSelectMergeVendor(e);
      },
      placeholder: "Select a vendor...",
      value: selectedVendor
    }),
    _react2.default.createElement(
      "div",
      { className: _mergeVendorsModal2.default.actions },
      _react2.default.createElement(
        _button.Button,
        { link: true, onClick: onEndMergeVendorsMode },
        "cancel"
      ),
      _react2.default.createElement(
        _button.Button,
        {
          loading: isMergeVendorsLoading,
          onClick: function onClick() {
            return onMergeVendors(accountId, selectedVendor, selectedVendorIds);
          },
          primary: true
        },
        "Merge Vendors"
      )
    )
  );
};

MergeVendorsModal.defaultProps = {
  selectedVendor: null
};

MergeVendorsModal.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  isMergeVendorsLoading: _propTypes2.default.bool.isRequired,
  isMergeVendorsMode: _propTypes2.default.bool.isRequired,
  onEndMergeVendorsMode: _propTypes2.default.func.isRequired,
  onMergeVendors: _propTypes2.default.func.isRequired,
  onSelectMergeVendor: _propTypes2.default.func.isRequired,
  selectedVendor: _customPropTypes.selectOptionType,
  selectedVendorIds: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired
};

var mapVendors = function mapVendors(vendors) {
  return vendors.map(function (vendor) {
    return {
      key: vendor,
      name: vendor
    };
  });
};

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Notifications = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _notifications = __webpack_require__(1347);

var _notifications2 = _interopRequireDefault(_notifications);

var _reactRouter = __webpack_require__(32);

var _fileTextO = __webpack_require__(448);

var _fileTextO2 = _interopRequireDefault(_fileTextO);

var _cloudUpload = __webpack_require__(446);

var _cloudUpload2 = _interopRequireDefault(_cloudUpload);

var _exclamationTriangle = __webpack_require__(276);

var _exclamationTriangle2 = _interopRequireDefault(_exclamationTriangle);

var _dropdownModal = __webpack_require__(165);

var _stringHelpers = __webpack_require__(68);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Notifications = exports.Notifications = function Notifications(_ref) {
  var accountSlug = _ref.accountSlug,
      exportFailedCount = _ref.exportFailedCount,
      isNotificationsMode = _ref.isNotificationsMode,
      onEndNotificationsMode = _ref.onEndNotificationsMode,
      pendingDocumentsCount = _ref.pendingDocumentsCount,
      queuedCount = _ref.queuedCount;
  return _react2.default.createElement(
    _dropdownModal.DropdownModal,
    {
      arrowSide: true,
      offsetLeft: -150,
      offsetTop: 30,
      onClose: onEndNotificationsMode,
      visible: isNotificationsMode,
      width: 250
    },
    _react2.default.createElement(
      "div",
      { className: _notifications2.default.container },
      _react2.default.createElement(
        _reactRouter.Link,
        { to: "/accounts/" + accountSlug + "/awaiting-digital" },
        _react2.default.createElement(_fileTextO2.default, { className: _notifications2.default.icon, size: 15 }),
        (0, _stringHelpers.pluralize)(pendingDocumentsCount, "documents", "document"),
        " awaiting processing"
      ),
      _react2.default.createElement(
        _reactRouter.Link,
        { to: "/accounts/" + accountSlug + "/documents/filter/category=Queued for Export" },
        _react2.default.createElement(_cloudUpload2.default, { className: _notifications2.default.icon, size: 15 }),
        (0, _stringHelpers.pluralize)(queuedCount, "documents", "document"),
        " queued for export"
      ),
      _react2.default.createElement(
        _reactRouter.Link,
        { to: "/accounts/" + accountSlug + "/documents/filter/category=Export failed" },
        _react2.default.createElement(_exclamationTriangle2.default, { className: _notifications2.default.icon, size: 15 }),
        (0, _stringHelpers.pluralize)(exportFailedCount, "documents", "document"),
        " failed to export"
      )
    )
  );
};

Notifications.propTypes = {
  accountSlug: _propTypes2.default.string.isRequired,
  exportFailedCount: _propTypes2.default.number.isRequired,
  isNotificationsMode: _propTypes2.default.bool.isRequired,
  onEndNotificationsMode: _propTypes2.default.func.isRequired,
  pendingDocumentsCount: _propTypes2.default.number.isRequired,
  queuedCount: _propTypes2.default.number.isRequired
};

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageNotFound = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pageNotFound = __webpack_require__(1348);

var _pageNotFound2 = _interopRequireDefault(_pageNotFound);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PageNotFound = exports.PageNotFound = function PageNotFound() {
  return _react2.default.createElement(
    "div",
    { className: _pageNotFound2.default.container },
    _react2.default.createElement(
      "h1",
      { className: _pageNotFound2.default.title },
      "Page Not Found"
    ),
    _react2.default.createElement(
      "a",
      { href: "/" },
      "Go to homepage"
    )
  );
};

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoReports = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _noDocuments = __webpack_require__(514);

var _noDocuments2 = _interopRequireDefault(_noDocuments);

var _squirrelGesturing = __webpack_require__(1398);

var _squirrelGesturing2 = _interopRequireDefault(_squirrelGesturing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NoReports = exports.NoReports = function NoReports(_ref) {
  var totalCount = _ref.totalCount;
  return totalCount === 0 ? blankSlate() : noResults();
};

NoReports.propTypes = {
  totalCount: _propTypes2.default.number.isRequired
};

var blankSlate = function blankSlate() {
  return _react2.default.createElement(
    "div",
    { className: _noDocuments2.default["blank-slate"] },
    _react2.default.createElement(
      "h3",
      null,
      "Darn! Looks like you haven't generated a report yet!"
    ),
    blankSlateText
  );
};

var noResults = function noResults() {
  return _react2.default.createElement(
    "div",
    { className: _noDocuments2.default["no-results"] },
    _react2.default.createElement(
      "h3",
      null,
      "No documents found"
    )
  );
};

var blankSlateText = _react2.default.createElement(
  "div",
  null,
  _react2.default.createElement("img", { alt: "squirrel gesturing", src: _squirrelGesturing2.default }),
  _react2.default.createElement(
    "div",
    null,
    "Use the form on the left hand side to generate custom CSV or PDF reports."
  )
);

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReportsForm = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _reactDatepicker = __webpack_require__(193);

var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);

var _reportsForm = __webpack_require__(1349);

var _reportsForm2 = _interopRequireDefault(_reportsForm);

__webpack_require__(508);

var _reduxForm = __webpack_require__(35);

var _customPropTypes = __webpack_require__(5);

var _select = __webpack_require__(45);

var _button = __webpack_require__(7);

var _financialYear = __webpack_require__(197);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StatelessReportsForm = function StatelessReportsForm(_ref) {
  var categories = _ref.categories,
      change = _ref.change,
      currency = _ref.currency,
      onSubmitReport = _ref.onSubmitReport,
      vendors = _ref.vendors;
  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      "h1",
      null,
      "Create a new report"
    ),
    _react2.default.createElement(
      "form",
      { onSubmit: function onSubmit(e) {
          e.preventDefault();onSubmitReport();
        } },
      renderFields("Name (optional)", textInput, "name", "Enter a report name"),
      renderDateRange(change, currency),
      renderFields("Category (optional)", multiSelectField, "categories", "Categories...", categories),
      renderFields("Vendor (optional)", multiSelectField, "vendors", "Vendors...", vendors),
      renderFields("Email (optional)", textInput, "email", "The report will be sent to this email address"),
      renderFields("Report Type", selectField, "type", "Choose a report type", reportTypes),
      _react2.default.createElement(
        "div",
        { className: _reportsForm2.default.actions },
        _react2.default.createElement(
          _button.Button,
          { primary: true, type: "submit" },
          "Create Report"
        )
      )
    )
  );
};

var ReportsForm = exports.ReportsForm = (0, _reduxForm.reduxForm)({ form: "reports" })(StatelessReportsForm);

StatelessReportsForm.propTypes = {
  categories: _propTypes2.default.arrayOf(_customPropTypes.categoryType).isRequired,
  change: _propTypes2.default.func.isRequired,
  currency: _propTypes2.default.string.isRequired,
  onSubmitReport: _propTypes2.default.func.isRequired,
  vendors: _propTypes2.default.arrayOf(_customPropTypes.vendorType).isRequired
};

var renderFields = function renderFields(title, component, name, placeholder) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  return _react2.default.createElement(
    "div",
    { className: _reportsForm2.default["fields-container"] },
    _react2.default.createElement(
      "h4",
      null,
      title
    ),
    _react2.default.createElement(_reduxForm.Field, {
      component: component,
      name: name,
      options: options,
      placeholder: placeholder
    })
  );
};

var renderDateRange = function renderDateRange(change, currency) {
  return _react2.default.createElement(
    "div",
    { className: _reportsForm2.default["fields-container"] },
    _react2.default.createElement(
      "h4",
      null,
      "Date Range"
    ),
    _react2.default.createElement(
      "div",
      { className: _reportsForm2.default["fields-container__row"] },
      _react2.default.createElement(_reduxForm.Field, {
        change: change,
        component: dateInput,
        currency: currency,
        name: "startDate",
        placeholder: "Start Date"
      }),
      _react2.default.createElement(_reduxForm.Field, {
        change: change,
        component: dateInput,
        currency: currency,
        name: "endDate",
        placeholder: "End Date"
      })
    )
  );
};

var textInput = function textInput(props) {
  return _react2.default.createElement(
    "div",
    { className: _reportsForm2.default["fields-container__row"] },
    _react2.default.createElement("input", _extends({}, props.input, { className: _reportsForm2.default.fields, placeholder: props.placeholder }))
  );
};

textInput.propTypes = {
  input: _customPropTypes.reduxFormInputType.isRequired,
  placeholder: _propTypes2.default.string.isRequired
};

var dateInput = function dateInput(_ref2) {
  var _ref2$input = _ref2.input,
      name = _ref2$input.name,
      onChange = _ref2$input.onChange,
      onFocus = _ref2$input.onFocus,
      value = _ref2$input.value,
      change = _ref2.change,
      currency = _ref2.currency,
      placeholder = _ref2.placeholder;

  var otherField = name === "startDate" ? "endDate" : "startDate";
  return _react2.default.createElement(
    _reactDatepicker2.default,
    {
      dateFormat: "DD/MM/YYYY",
      name: name,
      onChange: onChange,
      onFocus: onFocus,
      placeholderText: placeholder,
      selected: value ? (0, _moment2.default)(value) : null,
      value: value
    },
    _react2.default.createElement(
      "div",
      { className: _reportsForm2.default["financial-year"] },
      _react2.default.createElement(
        _button.Button,
        { link: true, onClick: function onClick() {
            return getFinancialYearRange(onChange, change, otherField, true, currency);
          } },
        "Last financial year"
      ),
      _react2.default.createElement(
        _button.Button,
        { link: true, onClick: function onClick() {
            return getFinancialYearRange(onChange, change, otherField, false, currency);
          } },
        "This financial year"
      )
    )
  );
};

dateInput.propTypes = textInput.propTypes;

var getFinancialYearRange = function getFinancialYearRange(onAddStartDate, onAddEndDate, otherField, isLast, currency) {
  var _ref3 = isLast ? (0, _financialYear.getLastFinancialYear)(currency) : (0, _financialYear.getThisFinancialYear)(currency),
      startDate = _ref3.startDate,
      endDate = _ref3.endDate;

  onAddStartDate(startDate);
  onAddEndDate(otherField, endDate);
};

var multiSelectField = function multiSelectField(props) {
  return _react2.default.createElement(
    "div",
    { className: _reportsForm2.default["fields-container__row"] },
    _react2.default.createElement(_select.MultiSelect, _extends({}, props, { options: mapData(props.options), placeholder: props.placeholder }))
  );
};

multiSelectField.propTypes = {
  options: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_customPropTypes.categoryType, _customPropTypes.vendorType])).isRequired,
  placeholder: _propTypes2.default.string.isRequired
};

var selectField = function selectField(_ref4) {
  var _ref4$input = _ref4.input,
      onChange = _ref4$input.onChange,
      value = _ref4$input.value,
      options = _ref4.options,
      placeholder = _ref4.placeholder;
  return _react2.default.createElement(
    "div",
    { className: _reportsForm2.default["fields-container__row"] },
    _react2.default.createElement(_select.SimpleSelect, {
      data: options,
      onChange: onChange,
      placeholder: placeholder,
      value: value
    })
  );
};

selectField.propTypes = {
  input: _customPropTypes.reduxFormInputType.isRequired,
  options: _propTypes2.default.arrayOf(_customPropTypes.selectOptionType).isRequired,
  placeholder: _propTypes2.default.string.isRequired
};

var mapData = function mapData(data) {
  return data.map(function (d) {
    return { key: d.name, name: d.name };
  });
};

var reportTypes = [{ key: "pdf", name: "PDF" }, { key: "csv", name: "Excel / CSV" }];

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReportsGrid = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reportsGrid = __webpack_require__(1350);

var _reportsGrid2 = _interopRequireDefault(_reportsGrid);

var _reactVirtualized = __webpack_require__(113);

var _gridComponents = __webpack_require__(166);

var _noReports = __webpack_require__(902);

var _customPropTypes = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ReportsGrid = function ReportsGrid(_ref) {
  var reports = _ref.reports;
  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      "h1",
      null,
      "Past Reports"
    ),
    _react2.default.createElement(
      "div",
      { className: _reportsGrid2.default["grid-container"] },
      _react2.default.createElement(
        _reactVirtualized.AutoSizer,
        { disableHeight: true },
        function (_ref2) {
          var width = _ref2.width;
          return _react2.default.createElement(_reactVirtualized.Grid, {
            cache: cache,
            cellRenderer: function cellRenderer(_ref3) {
              var gridProps = _objectWithoutProperties(_ref3, []);

              return _react2.default.createElement(_gridComponents.CellRenderer, _extends({}, gridProps, { newKey: gridProps.key }));
            },
            className: _reportsGrid2.default.grid,
            columnCount: columns.length,
            columns: columns,
            columnWidth: width / columns.length,
            documents: reports,
            fixedColumnCount: 1,
            fixedRowCount: 1,
            height: (0, _gridComponents.getGridHeight)(0, reports.length, 45),
            isRowFocusable: false,
            isSelectable: false,
            noContentRenderer: function noContentRenderer() {
              return _react2.default.createElement(_noReports.NoReports, { totalCount: reports.length });
            },
            rowCount: reports.length + 1,
            rowHeight: 45,
            selectedDocumentIds: [],
            width: width
          });
        }
      )
    )
  );
};

exports.ReportsGrid = ReportsGrid;
ReportsGrid.propTypes = {
  reports: _propTypes2.default.arrayOf(_customPropTypes.reportType).isRequired
};

var columns = [{
  key: "exported",
  name: "Date",
  visible: true
}, {
  key: "name",
  name: "Name",
  visible: true
}, {
  key: "to",
  name: "Type",
  visible: true
}, {
  key: "url",
  name: "Download",
  visible: true
}];

var cache = new _reactVirtualized.CellMeasurerCache({
  defaultWidth: 75,
  minWidth: 75,
  fixedHeight: true
});

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Reports = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _grid = __webpack_require__(95);

var _grid2 = _interopRequireDefault(_grid);

var _reports = __webpack_require__(1351);

var _reports2 = _interopRequireDefault(_reports);

var _customPropTypes = __webpack_require__(5);

var _reportsGrid = __webpack_require__(904);

var _reportsForm = __webpack_require__(903);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Reports = exports.Reports = function Reports(props) {
  return _react2.default.createElement(
    "div",
    { className: _reports2.default.container + " " + _grid2.default.row },
    _react2.default.createElement(
      "div",
      { className: _grid2.default["col-md-4"] },
      _react2.default.createElement(_reportsForm.ReportsForm, {
        categories: props.categories,
        currency: props.currency,
        onSubmitReport: props.onSubmitReport,
        vendors: props.vendors
      })
    ),
    _react2.default.createElement(
      "div",
      { className: _grid2.default["col-md-8"] },
      _react2.default.createElement(_reportsGrid.ReportsGrid, props)
    )
  );
};

Reports.propTypes = {
  categories: _propTypes2.default.arrayOf(_customPropTypes.categoryType).isRequired,
  currency: _propTypes2.default.string.isRequired,
  onSubmitReport: _propTypes2.default.func.isRequired,
  vendors: _propTypes2.default.arrayOf(_customPropTypes.vendorType).isRequired
};

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountNameAndEmailForm = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reduxForm = __webpack_require__(35);

var _accountNameAndEmailSettings = __webpack_require__(1352);

var _accountNameAndEmailSettings2 = _interopRequireDefault(_accountNameAndEmailSettings);

var _formElements = __webpack_require__(115);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StatelessAccountNameAndEmailForm = function StatelessAccountNameAndEmailForm(_ref) {
  var emailPin = _ref.emailPin,
      onSaveNameAndEmail = _ref.onSaveNameAndEmail,
      slug = _ref.slug;
  return _react2.default.createElement(
    "form",
    { onSubmit: function onSubmit(e) {
        e.preventDefault();onSaveNameAndEmail();
      } },
    _react2.default.createElement(
      "div",
      null,
      "This is the name for your account you will see in emails."
    ),
    _react2.default.createElement(
      "div",
      { className: _accountNameAndEmailSettings2.default["form-element"] },
      (0, _formElements.renderFormElement)("Account Name", "label", "text")
    ),
    _react2.default.createElement(
      "h2",
      null,
      "Submission Email Address"
    ),
    _react2.default.createElement(
      "div",
      null,
      "Use your Email Address to send documents, business cards and documents from anywhere. Your PIN is part of this address and makes it difficult for someone to spam your account."
    ),
    _react2.default.createElement(
      "div",
      { className: _accountNameAndEmailSettings2.default.email },
      (0, _formElements.renderFormElement)("Account slug", "slug", "text"),
      _react2.default.createElement(
        "span",
        null,
        "."
      ),
      (0, _formElements.renderFormNumberElement)("Email pin", "emailPin", "0", "9999", "1"),
      _react2.default.createElement(
        "span",
        null,
        "@sqrl.st"
      )
    ),
    _react2.default.createElement(
      "div",
      null,
      "Send your documents to: ",
      slug + "." + emailPin + "@sqrl.st"
    ),
    _react2.default.createElement(_formElements.FormButton, { text: "Save Changes" })
  );
};

StatelessAccountNameAndEmailForm.propTypes = {
  emailPin: _propTypes2.default.string.isRequired,
  onSaveNameAndEmail: _propTypes2.default.func.isRequired,
  slug: _propTypes2.default.string.isRequired
};

var AccountNameAndEmailForm = exports.AccountNameAndEmailForm = (0, _reduxForm.reduxForm)({ form: "accountNameAndEmailForm" })(StatelessAccountNameAndEmailForm);

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountNameAndEmailSettings = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _accountNameAndEmailForm = __webpack_require__(906);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AccountNameAndEmailSettings = exports.AccountNameAndEmailSettings = function AccountNameAndEmailSettings(props) {
  var initialValues = _ramda2.default.pick(["emailPin", "label", "slug"], props);
  initialValues.emailPin = parseInt(initialValues.emailPin, 10);
  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      "h1",
      null,
      "Account Name and Email Address"
    ),
    _react2.default.createElement(
      "h2",
      null,
      "Account Name"
    ),
    _react2.default.createElement(_accountNameAndEmailForm.AccountNameAndEmailForm, {
      emailPin: props.emailPin,
      initialValues: props,
      onSaveNameAndEmail: props.onSaveNameAndEmail,
      slug: props.slug
    })
  );
};

AccountNameAndEmailSettings.propTypes = {
  emailPin: _propTypes2.default.string.isRequired,
  onSaveNameAndEmail: _propTypes2.default.func.isRequired,
  slug: _propTypes2.default.string.isRequired
};

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountSettingsMenu = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _settingsMenus = __webpack_require__(520);

var _settingsMenus2 = _interopRequireDefault(_settingsMenus);

var _reactRouter = __webpack_require__(32);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AccountSettingsMenu = exports.AccountSettingsMenu = function AccountSettingsMenu(_ref) {
  var slug = _ref.slug,
      vip = _ref.vip;
  return _react2.default.createElement(
    "div",
    { className: _settingsMenus2.default.menu },
    _react2.default.createElement(
      "ul",
      null,
      renderMenuLinks(slug, "usage", "Account Usage"),
      renderMenuLinks(slug, "mail-in", "Mail-in Settings"),
      renderMenuLinks(slug, "tax", "Currency, Tax and Language Settings"),
      renderForNonVip(vip, slug, "billing-details", "Billing Settings"),
      renderForNonVip(vip, slug, "billing-history", "Billing History"),
      renderForNonVip(vip, slug, "subscription", "Subscription Settings"),
      renderMenuLinks(slug, "name", "Account Name and Submission Email"),
      renderForNonVip(vip, slug, "users", "Account Users")
    )
  );
};

AccountSettingsMenu.propTypes = {
  slug: _propTypes2.default.string.isRequired,
  vip: _propTypes2.default.bool.isRequired
};

var renderMenuLinks = function renderMenuLinks(slug, path, title) {
  return _react2.default.createElement(
    _reactRouter.Link,
    {
      activeClassName: _settingsMenus2.default["active-menu-item"],
      to: "/accounts/" + slug + "/settings/account/" + path
    },
    _react2.default.createElement(
      "li",
      null,
      title
    )
  );
};

var renderForNonVip = function renderForNonVip(vip, slug, path, title) {
  if (vip) {
    return null;
  }
  return renderMenuLinks(slug, path, title);
};

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountUsage = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _customPropTypes = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AccountUsage = exports.AccountUsage = function AccountUsage(_ref) {
  var planDetails = _ref.planDetails;
  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      "h1",
      null,
      "Account Usage"
    ),
    _react2.default.createElement(
      "div",
      null,
      _react2.default.createElement(
        "h2",
        null,
        "Current Usage"
      ),
      "Current mail-in and digital usage: ",
      " ",
      dateFormatter(planDetails.periodStart),
      " \u2013 ",
      dateFormatter(planDetails.periodEnd),
      "."
    ),
    _react2.default.createElement(
      "div",
      null,
      planDetails.totalProcessedCount,
      " items uploaded."
    ),
    _react2.default.createElement(
      "div",
      null,
      planDetails.billableEnvelopeCount,
      " Magic Envelopes received."
    ),
    _react2.default.createElement(
      "div",
      null,
      "Submissions currently in processing are not included in this usage total.",
      _react2.default.createElement("br", null),
      "They will be added when processing is complete.",
      _react2.default.createElement("br", null),
      "Envelopes are counted on the day they are received."
    ),
    _react2.default.createElement(
      "h2",
      null,
      "Excess Usage"
    ),
    _react2.default.createElement(
      "div",
      null,
      "Your current plan has a document excess usage fee of: $",
      planDetails.overageFeePerDocument,
      " per document,",
      _react2.default.createElement("br", null),
      "when you exceed ",
      planDetails.documentLimitPerMonth,
      " documents in a month.",
      _react2.default.createElement("br", null),
      "You have a Magic Envelope excess usage fee of:",
      _react2.default.createElement("br", null),
      "$5.50 per Magic Envelope received,",
      _react2.default.createElement("br", null),
      "when you exceed ",
      planDetails.envelopeLimitPerMonth,
      " Magic Envelopes in a month."
    ),
    "Learn more"
  );
};

AccountUsage.propTypes = {
  planDetails: _customPropTypes.planDetailsType.isRequired
};

var dateFormatter = function dateFormatter(date) {
  return (0, _moment2.default)(date).format("D MMMM YYYY");
};

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountUsers = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _accountUsers = __webpack_require__(1353);

var _accountUsers2 = _interopRequireDefault(_accountUsers);

var _button = __webpack_require__(7);

var _inviteUserModal = __webpack_require__(920);

var _removeSelfModal = __webpack_require__(926);

var _customPropTypes = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AccountUsers = exports.AccountUsers = function AccountUsers(_ref) {
  var accountId = _ref.accountId,
      currentUserId = _ref.currentUserId,
      isInviteUserVisible = _ref.isInviteUserVisible,
      isRemoveSelfVisible = _ref.isRemoveSelfVisible,
      newUser = _ref.newUser,
      onCreateUser = _ref.onCreateUser,
      onHideInviteUser = _ref.onHideInviteUser,
      onHideRemoveSelf = _ref.onHideRemoveSelf,
      onRemoveUser = _ref.onRemoveUser,
      onShowInviteUser = _ref.onShowInviteUser,
      onShowRemoveSelf = _ref.onShowRemoveSelf,
      users = _ref.users;

  var _splitUsers = splitUsers(users),
      current = _splitUsers.current,
      invited = _splitUsers.invited;

  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      "div",
      null,
      _react2.default.createElement(
        "h1",
        { className: _accountUsers2.default.title },
        "Account Users"
      ),
      _react2.default.createElement(
        "div",
        { className: _accountUsers2.default["invite-button"] },
        _react2.default.createElement(
          _button.Button,
          { onClick: onShowInviteUser, primary: true },
          "Invite User"
        )
      )
    ),
    _react2.default.createElement(
      "div",
      null,
      _react2.default.createElement(
        "h2",
        null,
        "Current Users:"
      ),
      renderCurrentUsers(current, onRemoveUser, accountId, currentUserId, onShowRemoveSelf),
      current.length === 0 && invited.length === 0 ? _react2.default.createElement(
        "h4",
        null,
        "No current users."
      ) : null
    ),
    _react2.default.createElement(
      "div",
      null,
      renderInvited(invited, onCreateUser, onRemoveUser, accountId)
    ),
    _react2.default.createElement(_inviteUserModal.InviteUserModal, {
      accountId: accountId,
      isInviteUserVisible: isInviteUserVisible,
      newUser: newUser,
      onCreateUser: onCreateUser,
      onHideInviteUser: onHideInviteUser
    }),
    _react2.default.createElement(_removeSelfModal.RemoveSelfModal, {
      accountId: accountId,
      currentUserId: currentUserId,
      isRemoveSelfVisible: isRemoveSelfVisible,
      onHideRemoveSelf: onHideRemoveSelf,
      onRemoveUser: onRemoveUser
    })
  );
};

AccountUsers.defaultProps = {
  newUser: null
};

AccountUsers.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  currentUserId: _propTypes2.default.string.isRequired,
  isInviteUserVisible: _propTypes2.default.bool.isRequired,
  isRemoveSelfVisible: _propTypes2.default.bool.isRequired,
  newUser: _customPropTypes.userType,
  onCreateUser: _propTypes2.default.func.isRequired,
  onHideInviteUser: _propTypes2.default.func.isRequired,
  onHideRemoveSelf: _propTypes2.default.func.isRequired,
  onRemoveUser: _propTypes2.default.func.isRequired,
  onShowInviteUser: _propTypes2.default.func.isRequired,
  onShowRemoveSelf: _propTypes2.default.func.isRequired,
  users: _propTypes2.default.arrayOf(_customPropTypes.userType).isRequired
};

var renderInvited = function renderInvited(users, onCreateUser, onRemoveUser, accountId) {
  if (users.length > 0) {
    return users.map(function (user) {
      return _react2.default.createElement(
        "div",
        { key: user.id },
        _react2.default.createElement(
          "div",
          null,
          user.firstName,
          " ",
          user.lastName
        ),
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            "small",
            null,
            "Email: ",
            user.email,
            " \xB7 not joined yet \xB7",
            _react2.default.createElement(
              _button.Button,
              { link: true, onClick: function onClick() {
                  return onCreateUser(accountId, user);
                } },
              "resend invitation"
            ),
            " \xB7",
            _react2.default.createElement(
              _button.Button,
              { link: true, onClick: function onClick() {
                  return onRemoveUser(accountId, user.id);
                } },
              "revoke invitation"
            )
          )
        )
      );
    });
  }
  return null;
};

var renderCurrentUsers = function renderCurrentUsers(users, onRemoveUser, accountId, currentUserId, onShowRemoveSelf) {
  if (users.length > 0) {
    return users.map(function (user) {
      return _react2.default.createElement(
        "div",
        { key: user.id },
        _react2.default.createElement(
          "div",
          null,
          user.firstName,
          " ",
          user.lastName
        ),
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            "small",
            null,
            "Email: ",
            user.email,
            " \xB7",
            checkIfSelf(accountId, onRemoveUser, user, currentUserId, onShowRemoveSelf)
          )
        )
      );
    });
  }
  return null;
};

var checkIfSelf = function checkIfSelf(accountId, onRemoveUser, user, currentUserId, onShowRemoveSelf) {
  if (user.id === currentUserId) {
    return _react2.default.createElement(
      _button.Button,
      { link: true, onClick: onShowRemoveSelf },
      "remove self from account"
    );
  }
  return _react2.default.createElement(
    _button.Button,
    { link: true, onClick: function onClick() {
        return onRemoveUser(accountId, user.id);
      } },
    "remove user"
  );
};

var splitUsers = function splitUsers(users) {
  var _selectStaff = selectStaff(users),
      staff = _selectStaff.staff,
      passedUsers = _selectStaff.passedUsers;

  var _selectCurrent = selectCurrent(passedUsers),
      current = _selectCurrent.current,
      invited = _selectCurrent.invited;

  return { staff: staff, current: current, invited: invited };
};

var selectStaff = function selectStaff(users) {
  var staff = users.filter(function (user) {
    return user.staff;
  });
  var passedUsers = _ramda2.default.difference(users, staff);
  return { staff: staff, passedUsers: passedUsers };
};

var selectCurrent = function selectCurrent(users) {
  var current = users.filter(function (user) {
    return user.confirmed;
  });
  var invited = _ramda2.default.difference(users, current);
  return { current: current, invited: invited };
};

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BetaSetting = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _betaSetting = __webpack_require__(1354);

var _betaSetting2 = _interopRequireDefault(_betaSetting);

var _button = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BetaSetting = exports.BetaSetting = function BetaSetting(props) {
  return _react2.default.createElement(
    "div",
    { className: _betaSetting2.default.container },
    _react2.default.createElement(
      "h1",
      null,
      "Default UI"
    ),
    _react2.default.createElement(
      "h3",
      null,
      "Set your default UI - The new UI (this UI) or the old UI"
    ),
    _react2.default.createElement(DefaultUIToggle, props)
  );
};

var DefaultUIToggle = function DefaultUIToggle(_ref) {
  var isBetaDefault = _ref.isBetaDefault,
      isUpdateDefaultInterfaceLoading = _ref.isUpdateDefaultInterfaceLoading,
      onUpdateDefaultInterface = _ref.onUpdateDefaultInterface;

  if (isBetaDefault) {
    return _react2.default.createElement(
      _button.Button,
      { danger: true, loading: isUpdateDefaultInterfaceLoading, onClick: function onClick() {
          return onUpdateDefaultInterface(false);
        } },
      "Set old UI as default"
    );
  }
  return _react2.default.createElement(
    _button.Button,
    { loading: isUpdateDefaultInterfaceLoading, onClick: function onClick() {
        return onUpdateDefaultInterface(true);
      }, primary: true },
    "Set this UI as default!"
  );
};

DefaultUIToggle.propTypes = {
  isBetaDefault: _propTypes2.default.bool.isRequired,
  isUpdateDefaultInterfaceLoading: _propTypes2.default.bool.isRequired,
  onUpdateDefaultInterface: _propTypes2.default.func.isRequired
};

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingDetails = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _billingDetails = __webpack_require__(1355);

var _billingDetails2 = _interopRequireDefault(_billingDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { NoBillingDetails } from "components/settings/no-billing-details";
// import { billingDetailsType } from "custom-prop-types";

var BillingDetails = exports.BillingDetails = function BillingDetails() {
  return _react2.default.createElement(
    "div",
    { className: _billingDetails2.default.construction },
    _react2.default.createElement(
      "h1",
      null,
      "This page is still under construction."
    ),
    _react2.default.createElement(
      "h3",
      null,
      "Please call us on 1300 00 1333 (AUS) or 0508 00 1333 (NZ) to update your billing details"
    )
  );
};

BillingDetails.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  onRedirectToBilling: _propTypes2.default.func.isRequired
};

// TODO: This is a temporary fix until the recurly.js library is implemented for PCI compliance
// export const BillingDetails = ({
//   accountId,
//   billingDetails,
//   isNoBillingDetails,
//   onSaveBillingDetails,
//   onUpdateBillingDetails,
//   slug
// }) => {
//   if (isNoBillingDetails) {
//     return <NoBillingDetails slug={ slug } />;
//   }
//   return (
//     <div>
//       <h1>Billing Details</h1>
//       <div className={ styles["card-form"] }>
//         <div className={ styles["form-title"] }>
//           <h2>Update Credit Card</h2>
//         </div>
//         { renderFormElement("First Name", billingDetails.name, onUpdateBillingDetails, "name") }
//         { renderFormElement("Last Name", billingDetails.surname, onUpdateBillingDetails, "surname") }
//         { renderFormElement(
//           "Card Number",
//           creditCardValue(billingDetails.cardNumber, billingDetails.lastFourDigits),
//           onUpdateBillingDetails,
//           "cardNumber"
//         ) }
//         <div className={ styles["field-cell"] }>
//           <div className={ styles["small-field"] }>
//             <div>Expiration</div>
//             <input
//               className={ `${styles.fields} ${styles.expiration}` }
//               maxLength={ "2" }
//               onChange={ (e) => { onUpdateBillingDetails("expiryMonth", e.target.value); } }
//               onFocus={ (e) => e.target.select() }
//               placeholder={ "MM" }
//               value={ billingDetails.expiryMonth }
//             />
//             <input
//               className={ `${styles.fields} ${styles.expiration} ${styles["expiration-right"]}` }
//               maxLength={ "4" }
//               onChange={ (e) => { onUpdateBillingDetails("expiryYear", e.target.value); } }
//               onFocus={ (e) => e.target.select() }
//               placeholder={ "YYYY" }
//               value={ billingDetails.expiryYear }
//             />
//           </div>
//           <div className={ styles["small-field"] }>
//             <div>Security Code</div>
//             <input
//               className={ `${styles.fields} ${styles.cvv}` }
//               maxLength={ "4" }
//               onChange={ (e) => { onUpdateBillingDetails("verificationValue", e.target.value); } }
//               onFocus={ (e) => e.target.select() }
//               placeholder={ "CVV" }
//             />
//           </div>
//         </div>
// { renderFormElement("Postcode", billingDetails.postcode, onUpdateBillingDetails, "postcode", "Your postcode") }
//         <div className={ `${styles.button} ${styles["field-cell"]}` }>
//           <Button
//             onClick={ () => onSaveBillingDetails(accountId, billingDetails) }
//             primary
//           >
//             Save Credit Card Details
//           </Button>
//         </div>
//       </div>
//     </div>
//   );
// };

// BillingDetails.defaultProps = {
//   billingDetails: null
// };

// BillingDetails.propTypes = {
//   accountId: PropTypes.string.isRequired,
//   billingDetails: billingDetailsType,
//   isNoBillingDetails: PropTypes.bool.isRequired,
//   onSaveBillingDetails: PropTypes.func.isRequired,
//   onUpdateBillingDetails: PropTypes.func.isRequired,
//   slug: PropTypes.string.isRequired
// };

// const creditCardValue = (value, lastFourDigits) => {
//   if (value === null || value === undefined) {
//     return `XXXX XXXX XXXX ${lastFourDigits}`;
//   }
//   return value;
// };

// const renderFormElement = (title, value, onUpdateBillingDetails, fieldName, placeholder) => (
//   <div className={ styles["field-cell"] }>
//     <div>{ title }</div>
//     <input
//       className={ styles.fields }
//       onChange={ (e) => { onUpdateBillingDetails(fieldName, e.target.value); } }
//       onFocus={ (e) => e.target.select() }
//       placeholder={ placeholder }
//       type="text"
//       value={ value }
//     />
//   </div>
// );

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingHistory = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDataGrid = __webpack_require__(1714);

var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);

var _billingHistory = __webpack_require__(1356);

var _billingHistory2 = _interopRequireDefault(_billingHistory);

var _paginationBar = __webpack_require__(422);

var _dateCellFormatter = __webpack_require__(269);

var _totalCellFormatter = __webpack_require__(887);

var _invoiceActionsFormatter = __webpack_require__(921);

var _noHistoricalInvoices = __webpack_require__(924);

var _customPropTypes = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BillingHistory = exports.BillingHistory = function BillingHistory(props) {
  if (props.displayInvoices.length === 0) {
    return _react2.default.createElement(_noHistoricalInvoices.NoHistoricalInvoices, null);
  }
  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      "h1",
      null,
      "Billing History"
    ),
    _react2.default.createElement(
      "div",
      { className: _billingHistory2.default["grid-container"] },
      _react2.default.createElement(_reactDataGrid2.default, {
        columns: columns,
        enableCellSelect: false,
        minHeight: props.displayInvoices.length * 35,
        rowGetter: getRow(props.displayInvoices),
        rowHeight: 35,
        rowsCount: props.displayInvoices.length
      }),
      _react2.default.createElement(_paginationBar.PaginationBar, _extends({}, props, {
        limit: props.pagination.limit,
        pageNumber: props.pagination.pageNumber,
        totalResults: props.invoices.length
      }))
    )
  );
};

BillingHistory.defaultProps = {
  displayInvoices: []
};

BillingHistory.propTypes = {
  displayInvoices: _propTypes2.default.arrayOf(_customPropTypes.invoiceType),
  invoices: _propTypes2.default.arrayOf(_customPropTypes.invoiceType).isRequired,
  pagination: _customPropTypes.paginationType.isRequired
};

var columns = [{
  formatter: _dateCellFormatter.DateCellFormatter,
  key: "createdAt",
  name: "Date"
}, {
  key: "invoiceNumber",
  name: "Invoice Number"
}, {
  formatter: _totalCellFormatter.TotalCellFormatter,
  key: "total",
  name: "Amount"
}, {
  formatter: _invoiceActionsFormatter.InvoiceActionsFormatter,
  key: "pdfUrl",
  name: "Download",
  getRowMetaData: function getRowMetaData(row) {
    return row;
  }
}];

var getRow = function getRow(invoices) {
  return function (index) {
    return invoices[index];
  };
};

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CancelSubscriptionModal = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _cancelSubscriptionModal = __webpack_require__(1357);

var _cancelSubscriptionModal2 = _interopRequireDefault(_cancelSubscriptionModal);

var _modal = __webpack_require__(27);

var _button = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CancelSubscriptionModal = exports.CancelSubscriptionModal = function CancelSubscriptionModal(_ref) {
  var accountId = _ref.accountId,
      isCancelSubscriptionVisible = _ref.isCancelSubscriptionVisible,
      isChangePlanLoading = _ref.isChangePlanLoading,
      onHideCancelSubscription = _ref.onHideCancelSubscription,
      onUpdatePlan = _ref.onUpdatePlan;
  return _react2.default.createElement(
    _modal.Modal,
    {
      isVisible: isCancelSubscriptionVisible,
      onClose: onHideCancelSubscription,
      transitionName: "cancel-subscription"
    },
    _react2.default.createElement(
      "h2",
      null,
      "Are you sure?"
    ),
    _react2.default.createElement(
      "span",
      null,
      "If you are, don't worry. You will still have access to your account "
    ),
    _react2.default.createElement(
      "span",
      null,
      "and you can still submit up to 5 documents / month, on us."
    ),
    _react2.default.createElement(
      "div",
      { className: _cancelSubscriptionModal2.default.controls },
      _react2.default.createElement(
        _button.Button,
        { link: true, onClick: onHideCancelSubscription },
        "cancel"
      ),
      _react2.default.createElement(
        _button.Button,
        {
          danger: true,
          loading: isChangePlanLoading,
          onClick: function onClick() {
            return onUpdatePlan(accountId, { planType: "DIY", subscriptionType: "MONTHLY" });
          }
        },
        "Cancel my subscription"
      )
    )
  );
};

CancelSubscriptionModal.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  isCancelSubscriptionVisible: _propTypes2.default.bool.isRequired,
  isChangePlanLoading: _propTypes2.default.bool.isRequired,
  onHideCancelSubscription: _propTypes2.default.func.isRequired,
  onUpdatePlan: _propTypes2.default.func.isRequired
};

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CurrencyTaxLanguageForm = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reduxForm = __webpack_require__(35);

var _customPropTypes = __webpack_require__(5);

var _currencyTaxLanguageSettings = __webpack_require__(1358);

var _currencyTaxLanguageSettings2 = _interopRequireDefault(_currencyTaxLanguageSettings);

var _formElements = __webpack_require__(115);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StatelessCTLForm = function StatelessCTLForm(_ref) {
  var currencies = _ref.currencies,
      onSaveCurrencyLocaleTax = _ref.onSaveCurrencyLocaleTax,
      supportedLocales = _ref.supportedLocales;
  return _react2.default.createElement(
    "form",
    { onSubmit: function onSubmit(e) {
        e.preventDefault();onSaveCurrencyLocaleTax();
      } },
    _react2.default.createElement(
      "h2",
      null,
      "Currency"
    ),
    _react2.default.createElement(
      "div",
      { className: _currencyTaxLanguageSettings2.default["input-field"] },
      (0, _formElements.renderFormElement)("Account Currency", "currency", "select", mapCurrencies(currencies))
    ),
    _react2.default.createElement(
      "div",
      { className: _currencyTaxLanguageSettings2.default.small },
      "In tables and reports, all documents and bills will be automatically converted to the above currency, in addition to displaying the original currency. We use historic conversion rates from the \xA0",
      _react2.default.createElement(
        "a",
        { href: "http://www.ecb.europa.eu/home/html/index.en.html", rel: "noopener noreferrer", target: "_blank" },
        "European Central Bank"
      ),
      ", but you are free to modify the rate on per-document basis."
    ),
    _react2.default.createElement(
      "div",
      { className: _currencyTaxLanguageSettings2.default["input-field"] },
      (0, _formElements.renderFormToggleElement)("Default Australian tax categories", "isDefaultCategories")
    ),
    _react2.default.createElement(
      "h2",
      null,
      "Account Tax Rate (GST)"
    ),
    _react2.default.createElement(
      "div",
      { className: _currencyTaxLanguageSettings2.default["input-field"] },
      (0, _formElements.renderFormNumberElement)("Tax %", "vat", "0", "100", ".01")
    ),
    _react2.default.createElement(
      "h2",
      null,
      "Language Settings"
    ),
    _react2.default.createElement(
      "div",
      { className: _currencyTaxLanguageSettings2.default["input-field"] },
      (0, _formElements.renderFormElement)("Default Account Language", "locale", "select", mapLocales(supportedLocales))
    ),
    _react2.default.createElement(
      "div",
      { className: _currencyTaxLanguageSettings2.default.small },
      "The language you choose is used to determine the date format (mm/dd/yyyy or dd/mm/yyyy) \xA0 on your documents, other documents and exports."
    ),
    _react2.default.createElement(_formElements.FormButton, { text: "Save Changes" })
  );
};

var CurrencyTaxLanguageForm = exports.CurrencyTaxLanguageForm = (0, _reduxForm.reduxForm)({ form: "currencyTaxLanguageForm" })(StatelessCTLForm);

StatelessCTLForm.propTypes = {
  currencies: _propTypes2.default.arrayOf(_customPropTypes.currencyType).isRequired,
  onSaveCurrencyLocaleTax: _propTypes2.default.func.isRequired,
  supportedLocales: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired
};

var mapCurrencies = function mapCurrencies(currencies) {
  return currencies.map(function (currency) {
    return { key: currency.code, name: currency.code };
  });
};
var mapLocales = function mapLocales(locales) {
  return locales.map(function (locale) {
    return { key: locale, name: "English (" + localeToCountry(locale) + ")" };
  });
};
var localeToCountry = function localeToCountry(locale) {
  return locale.split("-").pop();
};

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CurrencyTaxLanguageSettings = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _customPropTypes = __webpack_require__(5);

var _currencyTaxLanguageForm = __webpack_require__(915);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CurrencyTaxLanguageSettings = exports.CurrencyTaxLanguageSettings = function CurrencyTaxLanguageSettings(_ref) {
  var currency = _ref.currency,
      currencies = _ref.currencies,
      locale = _ref.locale,
      onSaveCurrencyLocaleTax = _ref.onSaveCurrencyLocaleTax,
      showUniversalCategorySet = _ref.showUniversalCategorySet,
      supportedLocales = _ref.supportedLocales,
      vat = _ref.vat;

  var mappedLocale = localeValueMapper(locale);
  var mappedCurrency = currencyValueMapper(currency);
  var tax = vat;
  var initialValues = {
    currency: mappedCurrency,
    vat: tax,
    locale: mappedLocale,
    isDefaultCategories: showUniversalCategorySet
  };
  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      "h1",
      null,
      "Currency Tax and Language Settings"
    ),
    _react2.default.createElement(_currencyTaxLanguageForm.CurrencyTaxLanguageForm, {
      currencies: currencies,
      initialValues: initialValues,
      onSaveCurrencyLocaleTax: onSaveCurrencyLocaleTax,
      supportedLocales: supportedLocales
    })
  );
};

CurrencyTaxLanguageSettings.propTypes = {
  currencies: _propTypes2.default.arrayOf(_customPropTypes.currencyType).isRequired,
  currency: _propTypes2.default.string.isRequired,
  locale: _propTypes2.default.string.isRequired,
  onSaveCurrencyLocaleTax: _propTypes2.default.func.isRequired,
  showUniversalCategorySet: _propTypes2.default.bool.isRequired,
  supportedLocales: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  vat: _propTypes2.default.number.isRequired
};

var currencyValueMapper = function currencyValueMapper(value) {
  return { key: value, name: value };
};
var localeValueMapper = function localeValueMapper(value) {
  return { key: value, name: "English (" + localeToCountry(value) + ")" };
};
var localeToCountry = function localeToCountry(locale) {
  return locale.split("-").pop();
};

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocReturn = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _docReturn = __webpack_require__(1359);

var _docReturn2 = _interopRequireDefault(_docReturn);

var _button = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DocReturn = exports.DocReturn = function DocReturn(_ref) {
  var accountId = _ref.accountId,
      docReturn = _ref.docReturn,
      isDocumentReturnLoading = _ref.isDocumentReturnLoading,
      onDisableDocReturn = _ref.onDisableDocReturn,
      onEnableDocReturn = _ref.onEnableDocReturn,
      vip = _ref.vip;

  if (vip) {
    return null;
  }
  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      "h2",
      null,
      "Document return"
    ),
    _react2.default.createElement(
      "div",
      null,
      "We will securely shred and recycle your processed mailed-in documents, or you can have your documents returned for just $11 per month."
    ),
    _react2.default.createElement(
      "div",
      { className: _docReturn2.default["button-container"] },
      renderDocReturnButton(accountId, docReturn, isDocumentReturnLoading, onDisableDocReturn, onEnableDocReturn)
    )
  );
};

DocReturn.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  docReturn: _propTypes2.default.bool.isRequired,
  isDocumentReturnLoading: _propTypes2.default.bool.isRequired,
  onDisableDocReturn: _propTypes2.default.func.isRequired,
  onEnableDocReturn: _propTypes2.default.func.isRequired,
  vip: _propTypes2.default.bool.isRequired
};

var renderDocReturnButton = function renderDocReturnButton(accountId, docReturn, isDocumentReturnLoading, onDisableDocReturn, onEnableDocReturn) {
  if (docReturn) {
    return _react2.default.createElement(
      _button.Button,
      {
        danger: true,
        loading: isDocumentReturnLoading,
        onClick: function onClick() {
          return onDisableDocReturn(accountId);
        }
      },
      "Turn off document return"
    );
  }
  return _react2.default.createElement(
    _button.Button,
    {
      loading: isDocumentReturnLoading,
      onClick: function onClick() {
        return onEnableDocReturn(accountId);
      },
      primary: true
    },
    "Return my documents ($11/month)"
  );
};

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FavouriteAccount = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reduxForm = __webpack_require__(35);

var _customPropTypes = __webpack_require__(5);

var _formElements = __webpack_require__(115);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FavouriteAccount = exports.FavouriteAccount = function FavouriteAccount(props) {
  var selectedAccount = props.accounts.find(function (account) {
    return account.id === props.favouriteAccountId;
  });
  var mappedAccounts = props.accounts.map(function (account) {
    return { key: account.id, name: account.label };
  });
  var initialValues = void 0;
  if (selectedAccount) {
    initialValues = { favouriteAccount: { key: selectedAccount.id, name: selectedAccount.label } };
  }
  mappedAccounts.unshift({ key: null, name: "No account" });
  return _react2.default.createElement(FavouriteAccountForm, _extends({}, props, {
    accounts: mappedAccounts,
    initialValues: selectedAccount ? initialValues : null
  }));
};

FavouriteAccount.propTypes = {
  accounts: _propTypes2.default.arrayOf(_customPropTypes.accountType).isRequired
};

var StatelessFavouriteAccountForm = function StatelessFavouriteAccountForm(_ref) {
  var accounts = _ref.accounts,
      onUpdateFavouriteAccount = _ref.onUpdateFavouriteAccount;
  return _react2.default.createElement(
    "form",
    { onSubmit: function onSubmit(e) {
        e.preventDefault();onUpdateFavouriteAccount();
      } },
    _react2.default.createElement(
      "h1",
      null,
      "Favourite Account"
    ),
    _react2.default.createElement(
      "p",
      null,
      "Set your favourite account!"
    ),
    _react2.default.createElement(
      "p",
      null,
      "This account will be the account that opens by default whenever you enter Squirrel Street."
    ),
    _react2.default.createElement(
      "p",
      null,
      "If left unset, Squirrel Street will open the account that you used last."
    ),
    (0, _formElements.renderFormElement)("Account List", "favouriteAccount", "select", accounts),
    _react2.default.createElement(_formElements.FormButton, { text: "Save Favourite Account" })
  );
};

StatelessFavouriteAccountForm.propTypes = {
  accounts: _propTypes2.default.arrayOf(_customPropTypes.accountType).isRequired,
  onUpdateFavouriteAccount: _propTypes2.default.func.isRequired
};

var FavouriteAccountForm = (0, _reduxForm.reduxForm)({ form: "favouriteAccountForm" })(StatelessFavouriteAccountForm);

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InviteUserForm = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reduxForm = __webpack_require__(35);

var _inviteUserModal = __webpack_require__(1360);

var _inviteUserModal2 = _interopRequireDefault(_inviteUserModal);

var _formElements = __webpack_require__(115);

var _button = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StatelessInviteUserForm = function StatelessInviteUserForm(_ref) {
  var onCreateUser = _ref.onCreateUser,
      onHideInviteUser = _ref.onHideInviteUser;
  return _react2.default.createElement(
    "form",
    { onSubmit: function onSubmit(e) {
        e.preventDefault();onCreateUser();onHideInviteUser();
      } },
    (0, _formElements.renderFormElement)("First Name", "firstName", "text"),
    (0, _formElements.renderFormElement)("Last Name", "lastName", "text"),
    (0, _formElements.renderFormElement)("Email", "email", "text"),
    _react2.default.createElement(
      "div",
      { className: _inviteUserModal2.default["button-container"] },
      _react2.default.createElement(
        "div",
        { className: _inviteUserModal2.default.cancel },
        _react2.default.createElement(
          _button.Button,
          { link: true, onClick: function onClick() {
              return onHideInviteUser();
            } },
          "cancel"
        )
      ),
      _react2.default.createElement(_formElements.FormButton, { text: "Invite user" })
    )
  );
};

StatelessInviteUserForm.propTypes = {
  onCreateUser: _propTypes2.default.func.isRequired,
  onHideInviteUser: _propTypes2.default.func.isRequired
};

var InviteUserForm = exports.InviteUserForm = (0, _reduxForm.reduxForm)({ form: "inviteUserForm" })(StatelessInviteUserForm);

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InviteUserModal = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _inviteUserForm = __webpack_require__(919);

var _modal = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InviteUserModal = exports.InviteUserModal = function InviteUserModal(_ref) {
  var isInviteUserVisible = _ref.isInviteUserVisible,
      onCreateUser = _ref.onCreateUser,
      onHideInviteUser = _ref.onHideInviteUser;
  return _react2.default.createElement(
    _modal.Modal,
    {
      isVisible: isInviteUserVisible,
      onClose: onHideInviteUser,
      transitionName: "invite-user"
    },
    _react2.default.createElement(
      "h2",
      null,
      "Invite User"
    ),
    _react2.default.createElement(_inviteUserForm.InviteUserForm, { onCreateUser: onCreateUser, onHideInviteUser: onHideInviteUser })
  );
};

InviteUserModal.defaultProps = {
  newUser: null
};

InviteUserModal.propTypes = {
  isInviteUserVisible: _propTypes2.default.bool.isRequired,
  onCreateUser: _propTypes2.default.func.isRequired,
  onHideInviteUser: _propTypes2.default.func.isRequired
};

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InvoiceActionsFormatter = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _button = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InvoiceActionsFormatter = exports.InvoiceActionsFormatter = function InvoiceActionsFormatter(row) {
  return _react2.default.createElement(
    "span",
    null,
    _react2.default.createElement(
      _button.Button,
      { link: true, onClick: function onClick() {
          return window.open(row.value);
        } },
      "Download"
    )
  );
};

InvoiceActionsFormatter.propTypes = {
  value: _propTypes2.default.string.isRequired
};

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MailInSettingsForm = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reduxForm = __webpack_require__(35);

var _mailInSettings = __webpack_require__(1361);

var _mailInSettings2 = _interopRequireDefault(_mailInSettings);

var _formElements = __webpack_require__(115);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StatelessMailInSettingsForm = function StatelessMailInSettingsForm(_ref) {
  var onSaveAddress = _ref.onSaveAddress;
  return _react2.default.createElement(
    "form",
    { className: _mailInSettings2.default.form, onSubmit: function onSubmit(e) {
        e.preventDefault();onSaveAddress();
      } },
    _react2.default.createElement(
      "h2",
      null,
      "Update your address:"
    ),
    (0, _formElements.renderFormElement)("First Name", "name", "text"),
    (0, _formElements.renderFormElement)("Last Name", "surname", "text"),
    (0, _formElements.renderFormElement)("Address Line 1", "streetLine1", "text"),
    (0, _formElements.renderFormElement)("Address Line 2", "streetLine2", "text"),
    (0, _formElements.renderFormElement)("City", "city", "text"),
    (0, _formElements.renderFormElement)("State", "region", "text"),
    (0, _formElements.renderFormElement)("Postcode", "postcode", "text"),
    (0, _formElements.renderFormElement)("Country", "country", "select", countries),
    _react2.default.createElement(_formElements.FormButton, { text: "Save Changes" })
  );
};

StatelessMailInSettingsForm.propTypes = { onSaveAddress: _propTypes2.default.func.isRequired };

var MailInSettingsForm = exports.MailInSettingsForm = (0, _reduxForm.reduxForm)({ form: "mailInSettingsForm" })(StatelessMailInSettingsForm);

var countries = [{ key: "AU", name: "AU" }, { key: "NZ", name: "NZ" }];

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MailInSettings = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _customPropTypes = __webpack_require__(5);

var _docReturn = __webpack_require__(917);

var _mailInSettingsForm = __webpack_require__(922);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MailInSettings = exports.MailInSettings = function MailInSettings(_ref) {
  var accountId = _ref.accountId,
      address = _ref.address,
      docReturn = _ref.docReturn,
      isDocumentReturnLoading = _ref.isDocumentReturnLoading,
      onDisableDocReturn = _ref.onDisableDocReturn,
      onEnableDocReturn = _ref.onEnableDocReturn,
      onSaveAddress = _ref.onSaveAddress,
      vip = _ref.vip;

  var initialValues = _ramda2.default.clone(address);
  initialValues.country = { key: address.country, name: address.country };
  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      "h1",
      null,
      "Mail-in Settings"
    ),
    _react2.default.createElement(_docReturn.DocReturn, {
      accountId: accountId,
      docReturn: docReturn,
      isDocumentReturnLoading: isDocumentReturnLoading,
      onDisableDocReturn: onDisableDocReturn,
      onEnableDocReturn: onEnableDocReturn,
      vip: vip
    }),
    _react2.default.createElement(_mailInSettingsForm.MailInSettingsForm, { initialValues: initialValues, onSaveAddress: onSaveAddress })
  );
};

MailInSettings.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  address: _customPropTypes.addressType.isRequired,
  docReturn: _propTypes2.default.bool.isRequired,
  isDocumentReturnLoading: _propTypes2.default.bool.isRequired,
  onDisableDocReturn: _propTypes2.default.func.isRequired,
  onEnableDocReturn: _propTypes2.default.func.isRequired,
  onSaveAddress: _propTypes2.default.func.isRequired,
  vip: _propTypes2.default.bool.isRequired
};

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoHistoricalInvoices = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _openSquirrel = __webpack_require__(328);

var _openSquirrel2 = _interopRequireDefault(_openSquirrel);

var _noSettings = __webpack_require__(1362);

var _noSettings2 = _interopRequireDefault(_noSettings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NoHistoricalInvoices = exports.NoHistoricalInvoices = function NoHistoricalInvoices() {
  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      "div",
      { className: _noSettings2.default.container },
      _react2.default.createElement("img", { alt: "open arms squirrel", className: _noSettings2.default.squirrel, src: _openSquirrel2.default }),
      _react2.default.createElement(
        "h3",
        null,
        "It doesn't look like you have any billing history."
      )
    )
  );
};

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Plans = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _subscriptionSettings = __webpack_require__(522);

var _subscriptionSettings2 = _interopRequireDefault(_subscriptionSettings);

var _customPropTypes = __webpack_require__(5);

var _button = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Plans = exports.Plans = function Plans(props) {
  return _react2.default.createElement(
    "div",
    { className: _subscriptionSettings2.default["rendered-plans"] },
    monthlyOrAnnualPlans(props)
  );
};

Plans.propTypes = {
  annualPlans: _propTypes2.default.arrayOf(_customPropTypes.planDetailsType).isRequired,
  monthlyPlans: _propTypes2.default.arrayOf(_customPropTypes.planDetailsType).isRequired,
  planDetails: _customPropTypes.planDetailsType.isRequired
};

var monthlyOrAnnualPlans = function monthlyOrAnnualPlans(props) {
  if (props.planDisplay === "monthly") {
    return mapPlans(props, props.monthlyPlans);
  }
  return mapPlans(props, props.annualPlans, true);
};

var mapPlans = function mapPlans(_ref, plans) {
  var planDetails = _ref.planDetails,
      onShowUpgradeDowngrade = _ref.onShowUpgradeDowngrade,
      onUpdatePlan = _ref.onUpdatePlan,
      accountId = _ref.accountId,
      isChangePlanLoading = _ref.isChangePlanLoading;
  var isAnnual = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return plans.map(function (plan) {
    return _react2.default.createElement(IndividualPlan, {
      accountId: accountId,
      isAnnual: isAnnual,
      isChangePlanLoading: isChangePlanLoading,
      key: "" + plan.planType + plan.subscriptionType,
      onShowUpgradeDowngrade: onShowUpgradeDowngrade,
      onUpdatePlan: onUpdatePlan,
      plan: plan,
      planDetails: planDetails
    });
  });
};

var IndividualPlan = function IndividualPlan(_ref2) {
  var isAnnual = _ref2.isAnnual,
      onShowUpgradeDowngrade = _ref2.onShowUpgradeDowngrade,
      plan = _ref2.plan,
      planDetails = _ref2.planDetails;

  var activePlanStyle = activePlan(planDetails, plan);
  return _react2.default.createElement(
    "div",
    { className: _subscriptionSettings2.default[activePlanStyle] + " " + _subscriptionSettings2.default.plan },
    _react2.default.createElement(
      "div",
      { className: _subscriptionSettings2.default.title + " " + _subscriptionSettings2.default.grid },
      _react2.default.createElement(
        "div",
        { className: _subscriptionSettings2.default.name },
        plan.planName
      )
    ),
    _react2.default.createElement(
      "div",
      { className: _subscriptionSettings2.default.price + " " + _subscriptionSettings2.default.grid },
      _react2.default.createElement(
        "div",
        null,
        priceForMonthlyOrAnnual(isAnnual, plan)
      ),
      _react2.default.createElement(
        "div",
        { className: _subscriptionSettings2.default.per },
        scheduleForBilling(isAnnual, plan)
      )
    ),
    _react2.default.createElement(
      "div",
      { className: _subscriptionSettings2.default.cell + " " + _subscriptionSettings2.default.grid },
      _react2.default.createElement(
        "strong",
        null,
        plan.documentLimitPerMonth
      ),
      " documents / month"
    ),
    _react2.default.createElement(
      "div",
      { className: _subscriptionSettings2.default.cell + " " + _subscriptionSettings2.default.grid },
      plan.includesPrepaidEnvelopes ? "Prepaid Magic Envelopes" : "Digital only"
    ),
    _react2.default.createElement(
      "div",
      { className: _subscriptionSettings2.default.turnaround + " " + _subscriptionSettings2.default.grid },
      displayTurnaroundTime(plan),
      _react2.default.createElement(
        "div",
        { className: _subscriptionSettings2.default.button },
        _react2.default.createElement(
          _button.Button,
          { onClick: function onClick() {
              return onShowUpgradeDowngrade(plan);
            }, primary: true },
          upgradeOrDowngrade(plan, planDetails)
        )
      )
    )
  );
};

IndividualPlan.propTypes = {
  isAnnual: _propTypes2.default.bool.isRequired,
  onShowUpgradeDowngrade: _propTypes2.default.func.isRequired,
  plan: _customPropTypes.planDetailsType.isRequired,
  planDetails: _customPropTypes.planDetailsType.isRequired
};

var activePlan = function activePlan(planDetails, plan) {
  if (planDetails.planType === plan.planName && planDetails.subscriptionType === plan.subscriptionType) {
    return "active";
  }
  return "column";
};

var priceForMonthlyOrAnnual = function priceForMonthlyOrAnnual(isAnnual, plan) {
  if (isAnnual) {
    var price = (parseFloat(plan.defaultPrice) / 12).toFixed(2);
    return price === "0.00" ? "Free" : "$" + price;
  }
  return plan.defaultPrice === "0.0" ? "Free" : "$" + plan.defaultPrice;
};

var scheduleForBilling = function scheduleForBilling(isAnnual, plan) {
  if (isAnnual) {
    return plan.planName === "DIY" ? " " : "Per Month, billed annually";
  }
  return plan.planName === "DIY" ? " " : "Per Month";
};

var displayTurnaroundTime = function displayTurnaroundTime(plan) {
  if (plan.planType === "DIY") {
    return "3-5 day turnaround";
  }
  if (plan.targetTurnaroundMinDays === plan.targetTurnaroundMaxDays) {
    return plan.targetTurnaroundMaxDays + " day turnaround";
  }
  return plan.targetTurnaroundMinDays + "-" + plan.targetTurnaroundMaxDays + " day turnaround";
};

var upgradeOrDowngrade = function upgradeOrDowngrade(plan, planDetails) {
  if (plan.documentLimitPerMonth > planDetails.documentLimitPerMonth) {
    return "Upgrade";
  }
  return "Downgrade";
};

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RemoveSelfModal = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _removeSelfModal = __webpack_require__(1363);

var _removeSelfModal2 = _interopRequireDefault(_removeSelfModal);

var _modal = __webpack_require__(27);

var _button = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RemoveSelfModal = exports.RemoveSelfModal = function RemoveSelfModal(_ref) {
  var accountId = _ref.accountId,
      currentUserId = _ref.currentUserId,
      isRemoveSelfVisible = _ref.isRemoveSelfVisible,
      onHideRemoveSelf = _ref.onHideRemoveSelf,
      onRemoveUser = _ref.onRemoveUser;
  return _react2.default.createElement(
    _modal.Modal,
    {
      isVisible: isRemoveSelfVisible,
      onClose: onHideRemoveSelf,
      transitionName: "remove-self-modal"
    },
    _react2.default.createElement(
      "h2",
      null,
      "Are you sure?"
    ),
    _react2.default.createElement(
      "div",
      null,
      "Are you sure you want to remove yourself from this account? You will no longer be able to access this account, unless re-invited."
    ),
    _react2.default.createElement(
      "div",
      null,
      "You will also be logged out of Squirrel Street."
    ),
    _react2.default.createElement(
      "div",
      { className: _removeSelfModal2.default["button-group"] },
      _react2.default.createElement(
        _button.Button,
        { link: true, onClick: onHideRemoveSelf },
        "cancel"
      ),
      _react2.default.createElement(
        _button.Button,
        { danger: true, onClick: function onClick() {
            return onRemoveUser(accountId, currentUserId);
          } },
        "Remove me from this account"
      )
    )
  );
};

RemoveSelfModal.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  currentUserId: _propTypes2.default.string.isRequired,
  isRemoveSelfVisible: _propTypes2.default.bool.isRequired,
  onHideRemoveSelf: _propTypes2.default.func.isRequired,
  onRemoveUser: _propTypes2.default.func.isRequired
};

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SettingsModal = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(32);

var _settingsModal = __webpack_require__(1364);

var _settingsModal2 = _interopRequireDefault(_settingsModal);

var _dropdownModal = __webpack_require__(165);

var _customPropTypes = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SettingsModal = exports.SettingsModal = function SettingsModal(_ref) {
  var isSettingsMode = _ref.isSettingsMode,
      onEndSettingsMode = _ref.onEndSettingsMode,
      onLogout = _ref.onLogout,
      selectedAccount = _ref.selectedAccount;
  return _react2.default.createElement(
    _dropdownModal.DropdownModal,
    {
      arrowSide: true,
      offsetLeft: -150,
      offsetTop: 30,
      onClose: onEndSettingsMode,
      visible: isSettingsMode,
      width: 165
    },
    _react2.default.createElement(
      "div",
      { className: _settingsModal2.default.links + " overview7" },
      _react2.default.createElement(
        _reactRouter.Link,
        {
          onClick: onEndSettingsMode,
          to: "/accounts/" + selectedAccount.slug + "/settings/account/usage"
        },
        "Settings"
      ),
      _react2.default.createElement(
        _reactRouter.Link,
        {
          onClick: onEndSettingsMode,
          to: "/accounts/" + selectedAccount.slug + "/manage-envelopes"
        },
        "Manage Envelopes"
      ),
      _react2.default.createElement(
        "a",
        { href: "https://support.squirrelstreet.com", rel: "noopener noreferrer", target: "_blank" },
        "Help"
      ),
      _react2.default.createElement(
        "a",
        { href: "https://app.squirrelstreet.com", rel: "noopener noreferrer" },
        "Go to old UI"
      ),
      _react2.default.createElement(
        "a",
        { "data-name": "logout-link", href: "#logout", onClick: onLogout },
        "Logout"
      )
    )
  );
};

SettingsModal.propTypes = {
  isSettingsMode: _propTypes2.default.bool.isRequired,
  onEndSettingsMode: _propTypes2.default.func.isRequired,
  onLogout: _propTypes2.default.func.isRequired,
  selectedAccount: _customPropTypes.accountType.isRequired
};

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscriptionSettings = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _subscriptionSettings = __webpack_require__(522);

var _subscriptionSettings2 = _interopRequireDefault(_subscriptionSettings);

var _customPropTypes = __webpack_require__(5);

var _plans = __webpack_require__(925);

var _button = __webpack_require__(7);

var _cancelSubscriptionModal = __webpack_require__(914);

var _upgradeDowngradeModal = __webpack_require__(929);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubscriptionSettings = exports.SubscriptionSettings = function SubscriptionSettings(_ref) {
  var accountId = _ref.accountId,
      cancelDate = _ref.cancelDate,
      isCancelSubscriptionVisible = _ref.isCancelSubscriptionVisible,
      isChangePlanLoading = _ref.isChangePlanLoading,
      isUpgradeDowngradeVisible = _ref.isUpgradeDowngradeVisible,
      onHideCancelSubscription = _ref.onHideCancelSubscription,
      onHideUpgradeDowngrade = _ref.onHideUpgradeDowngrade,
      onShowCancelSubscription = _ref.onShowCancelSubscription,
      onShowUpgradeDowngrade = _ref.onShowUpgradeDowngrade,
      onSetPlanDisplay = _ref.onSetPlanDisplay,
      onUpdatePlan = _ref.onUpdatePlan,
      pendingPlan = _ref.pendingPlan,
      plan = _ref.plan,
      plans = _ref.plans,
      planDetails = _ref.planDetails,
      planDisplay = _ref.planDisplay;

  var _splitAndOrderPlans = splitAndOrderPlans(plans),
      monthlyPlans = _splitAndOrderPlans.monthlyPlans,
      annualPlans = _splitAndOrderPlans.annualPlans;

  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      "div",
      { className: _subscriptionSettings2.default.toggle },
      _react2.default.createElement(
        "span",
        { className: toggleStyle("monthly", planDisplay), onClick: function onClick() {
            return onSetPlanDisplay("monthly");
          } },
        "Monthly Pricing"
      )
    ),
    renderPendingPlan(pendingPlan, cancelDate),
    _react2.default.createElement(
      "div",
      { className: _subscriptionSettings2.default["plan-container"] },
      _react2.default.createElement(_plans.Plans, {
        accountId: accountId,
        annualPlans: annualPlans,
        isChangePlanLoading: isChangePlanLoading,
        monthlyPlans: monthlyPlans,
        onShowUpgradeDowngrade: onShowUpgradeDowngrade,
        onUpdatePlan: onUpdatePlan,
        planDetails: planDetails,
        planDisplay: planDisplay
      })
    ),
    renderCancelSubscription(onShowCancelSubscription, planDetails, cancelDate),
    _react2.default.createElement(_cancelSubscriptionModal.CancelSubscriptionModal, {
      accountId: accountId,
      isCancelSubscriptionVisible: isCancelSubscriptionVisible,
      isChangePlanLoading: isChangePlanLoading,
      onHideCancelSubscription: onHideCancelSubscription,
      onUpdatePlan: onUpdatePlan
    }),
    _react2.default.createElement(_upgradeDowngradeModal.UpgradeDowngradeModal, {
      accountId: accountId,
      isChangePlanLoading: isChangePlanLoading,
      isUpgradeDowngradeVisible: isUpgradeDowngradeVisible,
      onHideUpgradeDowngrade: onHideUpgradeDowngrade,
      onUpdatePlan: onUpdatePlan,
      plan: plan
    })
  );
};

SubscriptionSettings.defaultProps = {
  cancelDate: null,
  pendingPlan: null,
  plan: null
};

SubscriptionSettings.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  cancelDate: _propTypes2.default.string,
  isCancelSubscriptionVisible: _propTypes2.default.bool.isRequired,
  isChangePlanLoading: _propTypes2.default.bool.isRequired,
  isUpgradeDowngradeVisible: _propTypes2.default.bool.isRequired,
  onHideCancelSubscription: _propTypes2.default.func.isRequired,
  onHideUpgradeDowngrade: _propTypes2.default.func.isRequired,
  onSetPlanDisplay: _propTypes2.default.func.isRequired,
  onShowCancelSubscription: _propTypes2.default.func.isRequired,
  onShowUpgradeDowngrade: _propTypes2.default.func.isRequired,
  onUpdatePlan: _propTypes2.default.func.isRequired,
  pendingPlan: _customPropTypes.planDetailsType,
  plan: _customPropTypes.planDetailsType,
  planDetails: _customPropTypes.planDetailsType.isRequired,
  planDisplay: _propTypes2.default.string.isRequired,
  plans: _propTypes2.default.arrayOf(_customPropTypes.planDetailsType).isRequired
};

var splitAndOrderPlans = function splitAndOrderPlans(plans) {
  var monthly = plans.filter(function (plan) {
    return plan.subscriptionType === "MONTHLY";
  });
  var annual = _ramda2.default.difference(plans, monthly);
  var sortByPlanSize = _ramda2.default.sortBy(_ramda2.default.prop("documentLimitPerMonth"));
  var monthlyPlans = _ramda2.default.drop(1, sortByPlanSize(monthly));
  var annualPlans = sortByPlanSize(annual);
  return { monthlyPlans: monthlyPlans, annualPlans: annualPlans };
};

var toggleStyle = function toggleStyle(schedule, planDisplay) {
  if (schedule === planDisplay) {
    return "" + _subscriptionSettings2.default["toggle-button--active"];
  }
  return "" + _subscriptionSettings2.default["toggle-button"];
};

var renderPendingPlan = function renderPendingPlan(pendingPlan, cancelDate) {
  if (cancelDate !== null) {
    return _react2.default.createElement(
      "div",
      { className: _subscriptionSettings2.default.cancel },
      _react2.default.createElement(
        "h3",
        null,
        _react2.default.createElement(
          "span",
          null,
          "Your subscription plan will change to the DIY plan on "
        ),
        _react2.default.createElement(
          "span",
          null,
          (0, _moment2.default)(cancelDate).format("DD/MM/YY")
        )
      )
    );
  }

  if (pendingPlan === null) {
    return null;
  }

  return _react2.default.createElement(
    "div",
    { className: _subscriptionSettings2.default.pending },
    _react2.default.createElement(
      "h3",
      null,
      _react2.default.createElement(
        "span",
        null,
        "Your subscription plan will change to the ",
        pendingPlan.planType,
        " "
      ),
      _react2.default.createElement(
        "span",
        null,
        pendingPlan.subscriptionType.toLowerCase(),
        " plan on "
      ),
      _react2.default.createElement(
        "span",
        null,
        (0, _moment2.default)(pendingPlan.periodStart).format("DD/MM/YY")
      )
    )
  );
};

var renderCancelSubscription = function renderCancelSubscription(onShowCancelSubscription, planDetails, cancelDate) {
  if (cancelDate !== null || planDetails === "DIY") {
    return null;
  }
  return _react2.default.createElement(
    "div",
    { className: _subscriptionSettings2.default.diy },
    _react2.default.createElement(
      _button.Button,
      { danger: true, onClick: onShowCancelSubscription },
      "Cancel subscription"
    )
  );
};

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpgradeDowngradeModal = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _customPropTypes = __webpack_require__(5);

var _upgradeDowngradeModal = __webpack_require__(1365);

var _upgradeDowngradeModal2 = _interopRequireDefault(_upgradeDowngradeModal);

var _modal = __webpack_require__(27);

var _button = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UpgradeDowngradeModal = exports.UpgradeDowngradeModal = function UpgradeDowngradeModal(_ref) {
  var accountId = _ref.accountId,
      isUpgradeDowngradeVisible = _ref.isUpgradeDowngradeVisible,
      isChangePlanLoading = _ref.isChangePlanLoading,
      onHideUpgradeDowngrade = _ref.onHideUpgradeDowngrade,
      onUpdatePlan = _ref.onUpdatePlan,
      plan = _ref.plan;
  return _react2.default.createElement(
    _modal.Modal,
    {
      isVisible: isUpgradeDowngradeVisible,
      onClose: onHideUpgradeDowngrade,
      transitionName: "upgrade-downgrade-subscription"
    },
    _react2.default.createElement(
      "h2",
      null,
      "Are you sure you want to change your plan?"
    ),
    _react2.default.createElement(
      "div",
      { className: _upgradeDowngradeModal2.default.controls },
      _react2.default.createElement(
        _button.Button,
        { link: true, onClick: onHideUpgradeDowngrade },
        "cancel"
      ),
      _react2.default.createElement(
        _button.Button,
        {
          loading: isChangePlanLoading,
          onClick: function onClick() {
            return onUpdatePlan(accountId, plan);
          },
          primary: true
        },
        "Change plan"
      )
    )
  );
};

UpgradeDowngradeModal.defaultProps = { plan: null };

UpgradeDowngradeModal.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  isChangePlanLoading: _propTypes2.default.bool.isRequired,
  isUpgradeDowngradeVisible: _propTypes2.default.bool.isRequired,
  onHideUpgradeDowngrade: _propTypes2.default.func.isRequired,
  onUpdatePlan: _propTypes2.default.func.isRequired,
  plan: _customPropTypes.planDetailsType
};

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserEmailForm = exports.UserNameForm = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reduxForm = __webpack_require__(35);

var _customPropTypes = __webpack_require__(5);

var _userSettings = __webpack_require__(523);

var _userSettings2 = _interopRequireDefault(_userSettings);

var _button = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StatelessUserNameForm = function StatelessUserNameForm(_ref) {
  var onSaveUserName = _ref.onSaveUserName;
  return _react2.default.createElement(
    "div",
    { className: _userSettings2.default["form-container"] },
    _react2.default.createElement(
      "form",
      { onSubmit: function onSubmit(e) {
          e.preventDefault();onSaveUserName();
        } },
      _react2.default.createElement(
        "h2",
        null,
        "Change your name:"
      ),
      renderFormElement("First Name", "name"),
      renderFormElement("Last Name", "surname"),
      _react2.default.createElement(
        _button.Button,
        { primary: true, type: "submit" },
        "Save Changes"
      )
    )
  );
};

StatelessUserNameForm.propTypes = {
  onSaveUserName: _propTypes2.default.func.isRequired
};

var UserNameForm = exports.UserNameForm = (0, _reduxForm.reduxForm)({ form: "userNameForm" })(StatelessUserNameForm);

var StatelessEmailForm = function StatelessEmailForm(_ref2) {
  var email = _ref2.email,
      onSaveUserEmail = _ref2.onSaveUserEmail;
  return _react2.default.createElement(
    "div",
    { className: _userSettings2.default["form-container"] },
    _react2.default.createElement(
      "form",
      { onSubmit: function onSubmit(e) {
          e.preventDefault();onSaveUserEmail();
        } },
      _react2.default.createElement(
        "h2",
        null,
        "Change your email:"
      ),
      _react2.default.createElement(
        "div",
        null,
        "Your current email address is: ",
        _react2.default.createElement(
          "strong",
          null,
          email
        )
      ),
      _react2.default.createElement(
        "div",
        null,
        renderFormElement("New Email", "newEmail"),
        renderFormElement("Confirm Email", "confirmEmail"),
        _react2.default.createElement(
          _button.Button,
          { primary: true, type: "submit" },
          "Save Changes"
        )
      )
    )
  );
};

StatelessEmailForm.propTypes = {
  email: _propTypes2.default.string.isRequired,
  onSaveUserEmail: _propTypes2.default.func.isRequired
};

var UserEmailForm = exports.UserEmailForm = (0, _reduxForm.reduxForm)({ form: "userEmailForm" })(StatelessEmailForm);

var renderFormElement = function renderFormElement(title, name) {
  return _react2.default.createElement(
    "div",
    { className: _userSettings2.default["fields-container"] },
    _react2.default.createElement(
      "h4",
      null,
      title
    ),
    _react2.default.createElement(_reduxForm.Field, {
      component: textInput,
      name: name,
      placeholder: title
    })
  );
};

var textInput = function textInput(props) {
  return _react2.default.createElement(
    "div",
    { className: _userSettings2.default["fields-container__row"] },
    _react2.default.createElement("input", _extends({}, props.input, { className: _userSettings2.default.fields, placeholder: props.placeholder }))
  );
};

textInput.propTypes = {
  input: _customPropTypes.reduxFormInputType.isRequired,
  placeholder: _propTypes2.default.string.isRequired
};

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserNameAndEmailSettings = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _userNameAndEmailForms = __webpack_require__(930);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserNameAndEmailSettings = exports.UserNameAndEmailSettings = function UserNameAndEmailSettings(_ref) {
  var email = _ref.email,
      firstName = _ref.firstName,
      lastName = _ref.lastName,
      onSaveUserEmail = _ref.onSaveUserEmail,
      onSaveUserName = _ref.onSaveUserName;
  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      "h1",
      null,
      "Name and Email"
    ),
    _react2.default.createElement(_userNameAndEmailForms.UserNameForm, { initialValues: { name: firstName, surname: lastName }, onSaveUserName: onSaveUserName }),
    _react2.default.createElement(_userNameAndEmailForms.UserEmailForm, { email: email, onSaveUserEmail: onSaveUserEmail })
  );
};

UserNameAndEmailSettings.propTypes = {
  email: _propTypes2.default.string.isRequired,
  firstName: _propTypes2.default.string.isRequired,
  lastName: _propTypes2.default.string.isRequired,
  onSaveUserEmail: _propTypes2.default.func.isRequired,
  onSaveUserName: _propTypes2.default.func.isRequired
};

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserPasswordSettings = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reduxForm = __webpack_require__(35);

var _customPropTypes = __webpack_require__(5);

var _userSettings = __webpack_require__(523);

var _userSettings2 = _interopRequireDefault(_userSettings);

var _button = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StatelessPasswordForm = function StatelessPasswordForm(_ref) {
  var onSavePassword = _ref.onSavePassword;
  return _react2.default.createElement(
    "div",
    { className: _userSettings2.default["form-container"] },
    _react2.default.createElement(
      "form",
      { onSubmit: function onSubmit(e) {
          e.preventDefault();onSavePassword();(0, _reduxForm.destroy)("userPasswordForm");
        } },
      _react2.default.createElement(
        "h1",
        null,
        "Change your password"
      ),
      renderInput("Current Password", "currentPassword"),
      renderInput("New password", "newPassword"),
      renderInput("Confirm new password", "newPasswordRepeated"),
      _react2.default.createElement(
        _button.Button,
        { primary: true, type: "submit" },
        "Save New Password"
      )
    )
  );
};

StatelessPasswordForm.propTypes = { onSavePassword: _propTypes2.default.func.isRequired };

var UserPasswordSettings = exports.UserPasswordSettings = (0, _reduxForm.reduxForm)({ form: "userPasswordForm" })(StatelessPasswordForm);

var renderInput = function renderInput(title, name) {
  return _react2.default.createElement(
    "div",
    { className: _userSettings2.default["fields-container"] },
    _react2.default.createElement(
      "h4",
      null,
      title
    ),
    _react2.default.createElement(_reduxForm.Field, {
      component: textInput,
      name: name,
      placeholder: title
    })
  );
};

var textInput = function textInput(props) {
  return _react2.default.createElement(
    "div",
    { className: _userSettings2.default["fields-container__row"] },
    _react2.default.createElement("input", _extends({}, props.input, { className: _userSettings2.default.fields, placeholder: props.placeholder, type: "password" }))
  );
};

textInput.propTypes = {
  input: _customPropTypes.reduxFormInputType.isRequired,
  placeholder: _propTypes2.default.string.isRequired
};

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserSettingsMenu = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _settingsMenus = __webpack_require__(520);

var _settingsMenus2 = _interopRequireDefault(_settingsMenus);

var _reactRouter = __webpack_require__(32);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { accountType } from "custom-prop-types";
var UserSettingsMenu = exports.UserSettingsMenu = function UserSettingsMenu(_ref) {
  var slug = _ref.slug;
  return _react2.default.createElement(
    "div",
    { className: _settingsMenus2.default.menu },
    _react2.default.createElement(
      "ul",
      null,
      renderMenuLinks(slug, "info", "Name and Email"),
      renderMenuLinks(slug, "password", "Change Password"),
      renderUISettingsPage(slug)
    )
  );
};

UserSettingsMenu.propTypes = {
  // accounts: PropTypes.arrayOf(accountType).isRequired,
  slug: _propTypes2.default.string.isRequired
};

var renderMenuLinks = function renderMenuLinks(slug, path, title) {
  return _react2.default.createElement(
    _reactRouter.Link,
    {
      activeClassName: _settingsMenus2.default["active-menu-item"],
      to: "/accounts/" + slug + "/settings/user/" + path
    },
    _react2.default.createElement(
      "li",
      null,
      title
    )
  );
};

var renderUISettingsPage = function renderUISettingsPage(slug) {
  if (true) {
    return null;
  }
  return renderMenuLinks(slug, "ui-settings", "UI Settings");
};

// const renderFavouriteAccount = (accounts, slug) => {
//   if (accounts.length < 2) {
//     return null;
//   }
//   return renderMenuLinks(slug, "favourite-account", "Set Favourite Account");
// };

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TourContent = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _tourContent = __webpack_require__(1366);

var _tourContent2 = _interopRequireDefault(_tourContent);

var _button = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TourContent = exports.TourContent = function TourContent(_ref) {
  var content = _ref.content,
      _ref$last = _ref.last,
      last = _ref$last === undefined ? false : _ref$last,
      _onClick = _ref.onClick;
  return _react2.default.createElement(
    "div",
    null,
    content,
    _react2.default.createElement(
      "div",
      { className: _tourContent2.default.navigation },
      _react2.default.createElement(
        _button.Button,
        { onClick: function onClick() {
            return _onClick();
          }, primary: true },
        last ? "Finish" : "Next"
      )
    )
  );
};

TourContent.defaultProps = {
  last: false
};

TourContent.propTypes = {
  content: _propTypes2.default.string.isRequired,
  last: _propTypes2.default.bool,
  onClick: _propTypes2.default.func.isRequired
};

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TourMenu = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _button = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TourMenu = exports.TourMenu = function TourMenu(_ref) {
  var totalCount = _ref.totalCount,
      onStartTour = _ref.onStartTour,
      pendingDocumentCount = _ref.pendingDocumentCount;
  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      "h3",
      null,
      "Walkthrough guides:"
    ),
    _react2.default.createElement(
      _button.Button,
      { link: true, onClick: function onClick() {
          return onStartTour("overview");
        } },
      "App Overview"
    ),
    renderUpload(pendingDocumentCount, onStartTour),
    _react2.default.createElement(
      _button.Button,
      { link: true, onClick: function onClick() {
          return onStartTour("manual");
        } },
      "Manual processing"
    ),
    renderDocuments(totalCount, onStartTour),
    _react2.default.createElement(
      _button.Button,
      { link: true, onClick: function onClick() {
          return onStartTour("automate");
        } },
      "Automation"
    )
  );
};

TourMenu.propTypes = {
  onStartTour: _propTypes2.default.func.isRequired,
  pendingDocumentCount: _propTypes2.default.number.isRequired,
  totalCount: _propTypes2.default.number.isRequired
};

var renderUpload = function renderUpload(pendingDocumentCount, onStartTour) {
  if (pendingDocumentCount === 0) {
    return null;
  }
  return _react2.default.createElement(
    _button.Button,
    { link: true, onClick: function onClick() {
        return onStartTour("upload");
      } },
    "Upload documents"
  );
};

var renderDocuments = function renderDocuments(totalCount, onStartTour) {
  if (totalCount === 0) {
    return null;
  }
  return _react2.default.createElement(
    _button.Button,
    { link: true, onClick: function onClick() {
        return onStartTour("documents");
      } },
    "View and edit documents"
  );
};

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTourSteps = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _tourContent = __webpack_require__(934);

var _reactRouter = __webpack_require__(32);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getTourSteps = exports.getTourSteps = function getTourSteps(props) {
  switch (props.tourName) {
    case "overview":
      return overviewSteps(props);
    case "upload":
      return uploadSteps(props);
    case "manual":
      return manualSteps(props);
    case "documents":
      return documentsSteps(props);
    case "automate":
      return automateSteps(props);
    default:
      return null;
  }
};

/* eslint react/prop-types: 0 */
var overviewSteps = function overviewSteps(props) {
  return [{
    selector: ".overview1",
    content: function content(_ref) {
      var goTo = _ref.goTo;
      return _react2.default.createElement(_tourContent.TourContent, {
        content: "From the dashboard you can view important account information such as usage and totals",
        onClick: function onClick() {
          return goTo(1);
        }
      });
    },
    position: "bottom"
  }, {
    selector: ".overview2",
    content: function content(_ref2) {
      var goTo = _ref2.goTo;
      return _react2.default.createElement(_tourContent.TourContent, {
        content: "This is where you can upload your documents, check the document processing queue,\n          manually process documents & get more information about the different types of document submission",
        onClick: function onClick() {
          return goTo(2);
        }
      });
    },
    position: "bottom"
  }, {
    selector: ".overview3",
    content: function content(_ref3) {
      var goTo = _ref3.goTo;
      return _react2.default.createElement(_tourContent.TourContent, {
        content: "From here you can view, search, edit, code, export all your documents and more!",
        onClick: function onClick() {
          return goTo(3);
        }
      });
    },
    position: "bottom"
  }, {
    selector: ".overview4",
    content: function content(_ref4) {
      var goTo = _ref4.goTo;
      return _react2.default.createElement(_tourContent.TourContent, {
        content: "From here you can manage all of your vendors, categories and set up automatic rule creation for them!",
        onClick: function onClick() {
          return goTo(4);
        }
      });
    },
    position: "bottom"
  }, {
    selector: ".overview5",
    content: function content(_ref5) {
      var goTo = _ref5.goTo;
      return _react2.default.createElement(_tourContent.TourContent, {
        content: "View and generate your reports!",
        onClick: function onClick() {
          return goTo(5);
        }
      });
    },
    position: "bottom"
  }, {
    selector: ".overview6",
    content: function content(_ref6) {
      var goTo = _ref6.goTo;
      return _react2.default.createElement(_tourContent.TourContent, {
        content: "This button opens the account menu",
        onClick: function onClick() {
          return goTo(6);
        }
      });
    },
    position: "bottom"
  }, {
    action: function action() {
      return props.onStartSettingsMode();
    },
    selector: ".overview7",
    content: function content(_ref7) {
      var goTo = _ref7.goTo;
      return _react2.default.createElement(_tourContent.TourContent, {
        content: "Here you can access all of your account and user settings, envelopes, support,\n          logout function and the old UI",
        last: true,
        onClick: function onClick() {
          goTo(0);props.onEndTour();props.onEndSettingsMode();
        }
      });
    },
    position: "bottom"
  }];
};

var uploadSteps = function uploadSteps(props) {
  return [{
    selector: ".upload1",
    content: function content(_ref8) {
      var goTo = _ref8.goTo;
      return _react2.default.createElement(_tourContent.TourContent, {
        content: "Go here to upload and manage processing documents",
        onClick: function onClick() {
          _reactRouter.browserHistory.push("/accounts/" + props.accountSlug.slug + "/upload");goTo(1);
        }
      });
    },
    position: "bottom"
  }, {
    selector: ".upload2",
    content: function content(_ref9) {
      var goTo = _ref9.goTo;
      return _react2.default.createElement(_tourContent.TourContent, {
        content: "On this screen we can upload documents directly as well as get\n          information about the other types of document submission",
        onClick: function onClick() {
          return goTo(2);
        }
      });
    },
    position: "center"
  }, {
    selector: ".upload3",
    content: function content(_ref10) {
      var goTo = _ref10.goTo;
      return _react2.default.createElement(_tourContent.TourContent, {
        content: "To upload directly via the web, simply click this button and select documents from your computer!",
        onClick: function onClick() {
          return goTo(3);
        }
      });
    },
    position: "bottom"
  }, {
    selector: ".upload4",
    content: function content(_ref11) {
      var goTo = _ref11.goTo;
      return _react2.default.createElement(_tourContent.TourContent, {
        content: "Otherwise you can download our mobile app to take pictures of documents to upload",
        onClick: function onClick() {
          return goTo(4);
        }
      });
    },
    position: "top"
  }, {
    selector: ".upload5",
    content: function content(_ref12) {
      var goTo = _ref12.goTo;
      return _react2.default.createElement(_tourContent.TourContent, {
        content: "Or via our dropbox integration",
        onClick: function onClick() {
          return goTo(5);
        }
      });
    },
    position: "top"
  }, {
    selector: ".upload6",
    content: function content(_ref13) {
      var goTo = _ref13.goTo;
      return _react2.default.createElement(_tourContent.TourContent, {
        content: "With one of our magic envelopes (depending on the plan), or via regular post.",
        onClick: function onClick() {
          return goTo(6);
        }
      });
    },
    position: "top"
  }, {
    selector: ".upload7",
    content: function content(_ref14) {
      var goTo = _ref14.goTo;
      return _react2.default.createElement(_tourContent.TourContent, {
        content: "And finally, you can upload through your Squirrelstreet submission email address",
        last: true,
        onClick: function onClick() {
          _reactRouter.browserHistory.push("/accounts/" + props.accountSlug.slug + "/dashboard");
          goTo(0);
          props.onEndTour();
        }
      });
    },
    position: "top"
  }];
};

var manualSteps = function manualSteps(props) {
  return [{
    selector: ".manual1",
    content: function content(_ref15) {
      var goTo = _ref15.goTo;
      return _react2.default.createElement(_tourContent.TourContent, {
        content: "If you would like to process your documents manually, you can do this from the submit page",
        onClick: function onClick() {
          _reactRouter.browserHistory.push("/accounts/" + props.accountSlug.slug + "/upload");goTo(1);
        }
      });
    },
    position: "bottom"
  }, {
    selector: ".manual2",
    content: function content(_ref16) {
      var goTo = _ref16.goTo;
      return _react2.default.createElement(_tourContent.TourContent, {
        content: "On this screen we can upload documents directly as well as get\n          information about the other types of document submission",
        onClick: function onClick() {
          return goTo(2);
        }
      });
    },
    position: "center"
  }, {
    selector: ".manual3",
    content: function content(_ref17) {
      var goTo = _ref17.goTo;
      return _react2.default.createElement(_tourContent.TourContent, {
        content: "From here, we can navigate to the 'Awaiting Processing' tab,\n            where we can manually process our documents",
        onClick: function onClick() {
          _reactRouter.browserHistory.push("/accounts/" + props.accountSlug.slug + "/awaiting-digital");goTo(3);
        }
      });
    },
    position: "bottom"
  }, {
    selector: ".manual4",
    content: function content(_ref18) {
      var goTo = _ref18.goTo;
      return _react2.default.createElement(_tourContent.TourContent, {
        content: "This is the document queue, where you can view all the documents that are awaiting processing",
        onClick: function onClick() {
          return goTo(4);
        }
      });
    },
    position: "right"
  }, {
    selector: ".manual5",
    content: function content(_ref19) {
      var goTo = _ref19.goTo;
      return _react2.default.createElement(_tourContent.TourContent, {
        content: "Here we can see the selected document from the document queue",
        onClick: function onClick() {
          return goTo(5);
        }
      });
    },
    position: "left"
  }, {
    selector: ".manual6",
    content: function content(_ref20) {
      var goTo = _ref20.goTo;
      return _react2.default.createElement(_tourContent.TourContent, {
        content: "Here we can cancel automatic processing, and process the document manually.\n          We can then add all the necessary details for this document,\n          and press save to have the document appear in the documents grid",
        onClick: function onClick() {
          return goTo(6);
        }
      });
    },
    position: "right"
  }, {
    selector: ".manual7",
    content: function content(_ref21) {
      var goTo = _ref21.goTo;
      return _react2.default.createElement(_tourContent.TourContent, {
        content: "We can set the default processing mode for all the documents in the list!\n          Simply click this button to toggle automatic and manual processing as default",
        last: true,
        onClick: function onClick() {
          _reactRouter.browserHistory.push("/accounts/" + props.accountSlug.slug + "/dashboard");
          goTo(0);
          props.onEndTour();
        }
      });
    },
    position: "left"
  }];
};

var documentsSteps = function documentsSteps(props) {
  return [{
    selector: ".documents1",
    content: function content(_ref22) {
      var goTo = _ref22.goTo;
      return _react2.default.createElement(_tourContent.TourContent, {
        content: "Let's go to the View and Export page!",
        onClick: function onClick() {
          _reactRouter.browserHistory.push("/accounts/" + props.accountSlug.slug + "/documents/all");
          goTo(1);
        }
      });
    },
    position: "bottom"
  }, {
    selector: ".documents2",
    content: function content(_ref23) {
      var goTo = _ref23.goTo;
      return _react2.default.createElement(_tourContent.TourContent, {
        content: "From this page we can view all the documents that have been uploaded into the account,\n          as well as perform actions on them such as editing, filtering and exporting.",
        onClick: function onClick() {
          props.onFocusDocument(props.documents[0], { top: 0 });goTo(2);
        }
      });
    },
    position: "center"
  }, {
    selector: ".documents3",
    content: function content(_ref24) {
      var goTo = _ref24.goTo;
      return _react2.default.createElement(_tourContent.TourContent, {
        content: "If we select a document in the grid, we can see all the editable document fields.\n          This includes inline editing for receipts (depending on the columns that have been selected).",
        onClick: function onClick() {
          return goTo(3);
        }
      });
    },
    position: "bottom"
  }, {
    selector: ".documents4",
    content: function content(_ref25) {
      var goTo = _ref25.goTo;
      return _react2.default.createElement(_tourContent.TourContent, {
        content: "And we can see the actual uploaded document here.",
        onClick: function onClick() {
          return goTo(4);
        }
      });
    },
    position: "left"
  }, {
    selector: ".documents5",
    content: function content(_ref26) {
      var goTo = _ref26.goTo;
      return _react2.default.createElement(_tourContent.TourContent, {
        content: "You can perform various actions such as editing visible columns,\n            filtering documents and exporting from here. If you select some documents,\n            extra document functions will appear here too",
        last: true,
        onClick: function onClick() {
          goTo(0);
          props.onEndTour();
          _reactRouter.browserHistory.push("/accounts/" + props.accountSlug.slug + "/dashboard");
        }
      });
    },
    position: "bottom"
  }];
};

var automateSteps = function automateSteps(props) {
  return [{
    selector: ".automate1",
    content: function content(_ref27) {
      var goTo = _ref27.goTo;
      return _react2.default.createElement(_tourContent.TourContent, {
        content: "Let's go to the automation page!",
        onClick: function onClick() {
          _reactRouter.browserHistory.push("/accounts/" + props.accountSlug.slug + "/automate/manage-categories");
          goTo(1);
        }
      });
    },
    position: "bottom"
  }, {
    selector: "body",
    content: function content(_ref28) {
      var goTo = _ref28.goTo;
      return _react2.default.createElement(_tourContent.TourContent, {
        content: "From here we can manage our account categories.\n          We can perform actions such as adding and removing categories,\n          and adding or removing categorization rules on a by category basis",
        onClick: function onClick() {
          return goTo(2);
        }
      });
    },
    position: "center"
  }, {
    selector: ".automate2",
    content: function content(_ref29) {
      var goTo = _ref29.goTo;
      return _react2.default.createElement(_tourContent.TourContent, {
        content: "From here we can navigate to the Manage Vendors page",
        onClick: function onClick() {
          _reactRouter.browserHistory.push("/accounts/" + props.accountSlug.slug + "/automate/manage-vendors");
          goTo(3);
        }
      });
    },
    position: "bottom"
  }, {
    selector: "body",
    content: function content(_ref30) {
      var goTo = _ref30.goTo;
      return _react2.default.createElement(_tourContent.TourContent, {
        content: "From here we can manage our account vendors; we can merge duplicate vendors, and\n          add and remove categorization rules on a by vendor basis.",
        onClick: function onClick() {
          goTo(0);
          props.onEndTour();
          _reactRouter.browserHistory.push("/accounts/" + props.accountSlug.slug + "/dashboard");
        }
      });
    },
    position: "center"
  }];
};

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActiveDigitalFilters = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _activeFilters = __webpack_require__(323);

var _activeFilters2 = _interopRequireDefault(_activeFilters);

var _customPropTypes = __webpack_require__(5);

var _activeFilterItem = __webpack_require__(116);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActiveDigitalFilters = exports.ActiveDigitalFilters = function ActiveDigitalFilters(_ref) {
  var accountId = _ref.accountId,
      onRemoveSourceFilter = _ref.onRemoveSourceFilter,
      onRemoveStuckStatusFilter = _ref.onRemoveStuckStatusFilter,
      sourceFilter = _ref.sourceFilter,
      statusFilter = _ref.statusFilter;

  var isEmptyResult = isEmpty(sourceFilter, statusFilter);
  if (isEmptyResult) {
    return null;
  }
  return _react2.default.createElement(
    "div",
    { className: _activeFilters2.default.container },
    renderSelectedItems("document source", sourceFilter, function () {
      return onRemoveSourceFilter(accountId);
    }),
    renderSelectedItems("processing status", statusFilter, function () {
      return onRemoveStuckStatusFilter(accountId);
    })
  );
};

ActiveDigitalFilters.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  onRemoveSourceFilter: _propTypes2.default.func.isRequired,
  onRemoveStuckStatusFilter: _propTypes2.default.func.isRequired,
  sourceFilter: _customPropTypes.dataType,
  statusFilter: _customPropTypes.dataType
};

ActiveDigitalFilters.defaultProps = {
  sourceFilter: null,
  statusFilter: null
};

var renderSelectedItems = function renderSelectedItems(name, item, onRemoveItem) {
  if (item === null) {
    return null;
  }
  return _react2.default.createElement(
    "div",
    { className: _activeFilters2.default["active-filter-group"] },
    _react2.default.createElement(
      "span",
      { className: _activeFilters2.default["group-title"] },
      "Selected ",
      name
    ),
    _react2.default.createElement(
      "div",
      null,
      renderItem(item, onRemoveItem, name)
    )
  );
};

var renderItem = function renderItem(item, onRemoveItem, name) {
  return _react2.default.createElement(
    "span",
    { key: name + "-" + item },
    _react2.default.createElement(_activeFilterItem.ActiveFilterItem, { name: "" + item.name, onRemove: onRemoveItem })
  );
};

var isEmpty = function isEmpty(sourceFilter, statusFilter) {
  return sourceFilter === null && statusFilter === null;
};

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlternativeUploadMethods = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactClipboard = __webpack_require__(735);

var _reactClipboard2 = _interopRequireDefault(_reactClipboard);

var _reactRouter = __webpack_require__(32);

var _alternativeUploadMethods = __webpack_require__(1367);

var _alternativeUploadMethods2 = _interopRequireDefault(_alternativeUploadMethods);

var _grid = __webpack_require__(95);

var _grid2 = _interopRequireDefault(_grid);

var _atIcon = __webpack_require__(1388);

var _atIcon2 = _interopRequireDefault(_atIcon);

var _cloudIcon = __webpack_require__(1389);

var _cloudIcon2 = _interopRequireDefault(_cloudIcon);

var _envelopeIcon = __webpack_require__(1390);

var _envelopeIcon2 = _interopRequireDefault(_envelopeIcon);

var _phoneIcon = __webpack_require__(1393);

var _phoneIcon2 = _interopRequireDefault(_phoneIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlternativeUploadMethods = exports.AlternativeUploadMethods = function AlternativeUploadMethods(_ref) {
  var slug = _ref.slug,
      onSetFlashMessage = _ref.onSetFlashMessage,
      submissionEmail = _ref.submissionEmail;

  var mobileText = "Send documents to Squirrel Street anytime,\n    anywhere with our free mobile applications for iPhone, iPad and Android.";
  var dropboxText = "Save time by simply dragging and dropping files into the Squirrel Street folder in Dropbox.";
  var envelopeText = "Fill one of our prepaid envelopes with your piles of paper clutter.\n    We'll do the rest of the work for you!";
  var emailText = "Forward emails from your online stores to Squirrel Street.\n    We'll filter the documents and store everything online.";

  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      "h3",
      { className: _alternativeUploadMethods2.default["upload-title"] },
      "Alternative Upload Methods:"
    ),
    _react2.default.createElement(
      "div",
      { className: _grid2.default.row },
      _react2.default.createElement(
        "div",
        { className: _grid2.default["col-md-3"] + " " + _alternativeUploadMethods2.default["upload-methods"] + " upload4" },
        _react2.default.createElement(
          "a",
          {
            className: _alternativeUploadMethods2.default["upload-image-container"],
            href: "https://itunes.apple.com/au/app/squirrel-street-receipt-tracker/id1044924996?mt=8",
            rel: "noopener noreferrer",
            target: "_blank"
          },
          _react2.default.createElement("img", { alt: "Mobile", className: _alternativeUploadMethods2.default["upload-image"], src: _phoneIcon2.default }),
          _react2.default.createElement(
            "div",
            { className: _alternativeUploadMethods2.default.tooltip },
            mobileText
          )
        ),
        _react2.default.createElement(
          "div",
          null,
          "Mobile"
        )
      ),
      _react2.default.createElement(
        "div",
        { className: _grid2.default["col-md-3"] + " " + _alternativeUploadMethods2.default["upload-methods"] + " upload5" },
        _react2.default.createElement(
          _reactRouter.Link,
          { className: _alternativeUploadMethods2.default["upload-image-container"], to: "/accounts/" + slug + "/settings/integration" },
          _react2.default.createElement("img", { alt: "Dropbox", className: _alternativeUploadMethods2.default["upload-image"], src: _cloudIcon2.default }),
          _react2.default.createElement(
            "div",
            { className: _alternativeUploadMethods2.default.tooltip },
            dropboxText
          )
        ),
        _react2.default.createElement(
          "div",
          null,
          "Dropbox"
        )
      ),
      _react2.default.createElement(
        "div",
        { className: _grid2.default["col-md-3"] + " " + _alternativeUploadMethods2.default["upload-methods"] + " upload6" },
        _react2.default.createElement(
          _reactRouter.Link,
          { className: _alternativeUploadMethods2.default["upload-image-container"], to: "/accounts/" + slug + "/manage-envelopes" },
          _react2.default.createElement("img", { alt: "Magic Envelope", className: _alternativeUploadMethods2.default["upload-image"], src: _envelopeIcon2.default }),
          _react2.default.createElement(
            "div",
            { className: _alternativeUploadMethods2.default.tooltip },
            envelopeText
          )
        ),
        _react2.default.createElement(
          "div",
          null,
          "Magic Envelope"
        )
      ),
      _react2.default.createElement(
        "div",
        { className: _grid2.default["col-md-3"] + " " + _alternativeUploadMethods2.default["upload-methods"] + " upload7" },
        _react2.default.createElement(
          _reactClipboard2.default,
          {
            className: _alternativeUploadMethods2.default["upload-image-container"],
            "data-clipboard-text": submissionEmail,
            onClick: function onClick() {
              onSetFlashMessage("Submission email address copied to clipboard");
            }
          },
          _react2.default.createElement("img", { alt: "Email", className: _alternativeUploadMethods2.default["upload-image"], src: _atIcon2.default }),
          _react2.default.createElement(
            "div",
            { className: _alternativeUploadMethods2.default.tooltip },
            emailText
          )
        ),
        _react2.default.createElement(
          "div",
          null,
          "Email"
        )
      )
    )
  );
};

AlternativeUploadMethods.propTypes = {
  onSetFlashMessage: _propTypes2.default.func.isRequired,
  slug: _propTypes2.default.string.isRequired,
  submissionEmail: _propTypes2.default.string.isRequired
};

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AwaitingProcessing = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reduxForm = __webpack_require__(35);

var _customPropTypes = __webpack_require__(5);

var _awaitingProcessing = __webpack_require__(1368);

var _awaitingProcessing2 = _interopRequireDefault(_awaitingProcessing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AwaitingProcessing = exports.AwaitingProcessing = function AwaitingProcessing(_ref) {
  var focusedDocument = _ref.focusedDocument,
      onFocusDocument = _ref.onFocusDocument,
      pendingDocuments = _ref.pendingDocuments;
  return _react2.default.createElement(
    "div",
    null,
    renderAwaitingProcessingList(focusedDocument, onFocusDocument, pendingDocuments)
  );
};

var renderAwaitingProcessingList = function renderAwaitingProcessingList(focusedDocument, onFocusDocument, pendingDocuments) {
  return _react2.default.createElement(
    "div",
    { className: _awaitingProcessing2.default["awaiting-processing-container"] + " manual4" },
    pendingDocuments.map(function (document) {
      return renderItem(document, focusedDocument, onFocusDocument);
    })
  );
};

var renderItem = function renderItem(document, focusedDocument, onFocusDocument) {
  var newCurrency = focusedDocument.currency || "AUD";
  var initialValues = {
    categories: focusedDocument.categories || [],
    cardNumber: null,
    currency: { key: newCurrency, name: newCurrency },
    formPaymentType: { key: "credit-card", name: "Card" },
    invoiceNumber: focusedDocument.invoiceNumber || "",
    issued: focusedDocument.issued || "",
    notes: focusedDocument.notes || "",
    tax: focusedDocument.tax || 0,
    total: focusedDocument.total || 0,
    vendor: focusedDocument.vendor || ""
  };
  return _react2.default.createElement(
    "div",
    {
      className: highlighter(document, focusedDocument),
      key: document.id,
      onClick: function onClick() {
        onFocusDocument(document);(0, _reduxForm.initialize)("pendingReceiptForm", initialValues);
      }
    },
    _react2.default.createElement(
      "div",
      null,
      getDocumentDisplayName(document)
    ),
    _react2.default.createElement(
      "div",
      { className: _awaitingProcessing2.default.stuck },
      renderStuckText(document)
    )
  );
};

var getDocumentDisplayName = function getDocumentDisplayName(document) {
  if (document.name) {
    return document.name;
  } else if (document.attachment) {
    return document.attachment.name;
  }
  return "Untitled Document";
};

var highlighter = function highlighter(document, focusedDocument) {
  if (focusedDocument === null || document.id !== focusedDocument.id) {
    return _awaitingProcessing2.default["pending-item"];
  }
  return _awaitingProcessing2.default["pending-item"] + " " + _awaitingProcessing2.default["active-pending-item"];
};

AwaitingProcessing.defaultProps = {
  focusedDocument: null
};

AwaitingProcessing.propTypes = {
  focusedDocument: _customPropTypes.documentPropType,
  onFocusDocument: _propTypes2.default.func.isRequired,
  pendingDocuments: _propTypes2.default.arrayOf(_customPropTypes.documentPropType).isRequired
};

var renderStuckText = function renderStuckText(document) {
  if (document.processingState === "NEEDS_OVERALL_PROCESSING" && document.queued_for_data_entry === false) {
    return "stuck document";
  }
  return null;
};

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CancelProcessingModal = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _button = __webpack_require__(7);

var _cancelProcessingModal = __webpack_require__(1369);

var _cancelProcessingModal2 = _interopRequireDefault(_cancelProcessingModal);

var _customPropTypes = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CancelProcessingModal = exports.CancelProcessingModal = function CancelProcessingModal(_ref) {
  var focusedDocument = _ref.focusedDocument,
      isVisible = _ref.isVisible,
      onCancelProcessing = _ref.onCancelProcessing;

  if (!isVisible || focusedDocument === null) {
    return null;
  }
  return _react2.default.createElement(
    "div",
    { className: _cancelProcessingModal2.default["cancel-processing-container"] },
    _react2.default.createElement(
      "div",
      { className: _cancelProcessingModal2.default["cancel-processing-content"] + " manual6" },
      _react2.default.createElement(
        "h3",
        null,
        "Processing..."
      ),
      _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "p",
          null,
          "This document is currently going through data verification"
        ),
        _react2.default.createElement(
          "div",
          { className: _cancelProcessingModal2.default["button-group"] },
          _react2.default.createElement(
            _button.Button,
            { danger: true, onClick: function onClick() {
                onCancelProcessing(focusedDocument);
              } },
            "Cancel Processing"
          ),
          _react2.default.createElement(
            "span",
            { className: _cancelProcessingModal2.default.small },
            "to enter data manually"
          )
        )
      )
    )
  );
};

CancelProcessingModal.defaultProps = {
  focusedDocument: null
};

CancelProcessingModal.propTypes = {
  focusedDocument: _customPropTypes.documentPropType,
  isVisible: _propTypes2.default.bool.isRequired,
  onCancelProcessing: _propTypes2.default.func.isRequired
};

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DigitalUploadFilters = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _customPropTypes = __webpack_require__(5);

var _select = __webpack_require__(45);

var _activeDigitalFilters = __webpack_require__(937);

var _documentFilters = __webpack_require__(324);

var _documentFilters2 = _interopRequireDefault(_documentFilters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DigitalUploadFilters = exports.DigitalUploadFilters = function DigitalUploadFilters(props) {
  return _react2.default.createElement(
    "div",
    { className: _documentFilters2.default.container },
    _react2.default.createElement(
      "h3",
      { className: _documentFilters2.default.title },
      "Filter by:"
    ),
    _react2.default.createElement(
      "div",
      { className: _documentFilters2.default["field-cell"] },
      _react2.default.createElement(
        "span",
        null,
        "Processing Status"
      ),
      _react2.default.createElement(_select.Select, {
        data: processingStatus,
        onChange: function onChange(e) {
          return props.onAddStuckStatusFilter(e);
        },
        placeholder: "Select the processing status...",
        value: props.statusFilter
      })
    ),
    _react2.default.createElement(
      "div",
      { className: _documentFilters2.default["field-cell"] },
      _react2.default.createElement(
        "span",
        null,
        "Document source"
      ),
      _react2.default.createElement(_select.Select, {
        data: processingSource,
        onChange: function onChange(e) {
          return props.onAddSourceFilter(e);
        },
        placeholder: "Select a document source...",
        value: props.sourceFilter
      })
    ),
    _react2.default.createElement(_activeDigitalFilters.ActiveDigitalFilters, props)
  );
};

DigitalUploadFilters.defaultProps = {
  sourceFilter: null,
  statusFilter: null
};

DigitalUploadFilters.propTypes = {
  onAddSourceFilter: _propTypes2.default.func.isRequired,
  onAddStuckStatusFilter: _propTypes2.default.func.isRequired,
  sourceFilter: _customPropTypes.dataType,
  statusFilter: _customPropTypes.dataType
};

var processingStatus = [{ key: "status_stuck", name: "Stuck documents" }, { key: "status_not_stuck", name: "Non stuck documents" }];

var processingSource = [{ key: "source_email", name: "Email" }, { key: "source_integration", name: "Digital uploads" }, { key: "source_mobile", name: "Mobile app" }];

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OtherFields = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _customPropTypes = __webpack_require__(5);

var _reduxForm = __webpack_require__(35);

var _formElements = __webpack_require__(115);

var _processingFields = __webpack_require__(326);

var _processingFields2 = _interopRequireDefault(_processingFields);

var _button = __webpack_require__(7);

var _processingFields3 = __webpack_require__(272);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PendingOtherDocumentForm = function PendingOtherDocumentForm(_ref) {
  var documentType = _ref.documentType,
      focusedDocument = _ref.focusedDocument,
      onChangeDocumentType = _ref.onChangeDocumentType,
      onReprocessPendingDocument = _ref.onReprocessPendingDocument,
      onSavePendingOtherDocument = _ref.onSavePendingOtherDocument,
      onShowTrashDocument = _ref.onShowTrashDocument;
  return _react2.default.createElement(
    "form",
    { onSubmit: function onSubmit(e) {
        e.preventDefault();onSavePendingOtherDocument();
      } },
    _react2.default.createElement(_processingFields3.DocumentTypeSelector, { documentType: documentType, onChangeDocumentType: onChangeDocumentType }),
    (0, _formElements.renderFormElement)("Name", "name", "text"),
    (0, _formElements.renderFormElement)("Date", "issued", "date"),
    (0, _formElements.renderFormElement)("Notes", "notes", "notes"),
    _react2.default.createElement(
      "div",
      { className: _processingFields2.default.trash },
      _react2.default.createElement(
        _button.Button,
        { danger: true, onClick: function onClick() {
            onShowTrashDocument();
          } },
        "Trash"
      ),
      _react2.default.createElement(
        "span",
        { className: _processingFields2.default.reprocess },
        _react2.default.createElement(
          _button.Button,
          { onClick: function onClick() {
              onReprocessPendingDocument(focusedDocument);
            } },
          "Process Automatically"
        )
      )
    ),
    _react2.default.createElement(
      "div",
      { className: _processingFields2.default.save },
      _react2.default.createElement(_formElements.FormButton, { text: "Save" })
    )
  );
};

PendingOtherDocumentForm.propTypes = {
  documentType: _propTypes2.default.string.isRequired,
  focusedDocument: _customPropTypes.documentPropType.isRequired,
  onChangeDocumentType: _propTypes2.default.func.isRequired,
  onReprocessPendingDocument: _propTypes2.default.func.isRequired,
  onSavePendingOtherDocument: _propTypes2.default.func.isRequired,
  onShowTrashDocument: _propTypes2.default.func.isRequired
};

var OtherFields = exports.OtherFields = (0, _reduxForm.reduxForm)({ form: "pendingOtherDocumentForm" })(PendingOtherDocumentForm);

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PendingDocumentsList = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _pendingDocumentsList = __webpack_require__(1370);

var _pendingDocumentsList2 = _interopRequireDefault(_pendingDocumentsList);

var _grid = __webpack_require__(95);

var _grid2 = _interopRequireDefault(_grid);

var _customPropTypes = __webpack_require__(5);

var _stringHelpers = __webpack_require__(68);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PendingDocumentsList = exports.PendingDocumentsList = function PendingDocumentsList(_ref) {
  var pendingDocuments = _ref.pendingDocuments;
  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      "div",
      { className: _pendingDocumentsList2.default["pending-documents-container"] },
      _react2.default.createElement(
        "div",
        { className: _grid2.default.row + " " + _pendingDocumentsList2.default["pending-titles"] },
        _react2.default.createElement(
          "div",
          { className: "" + _grid2.default["col-md-8"] },
          "File name:"
        ),
        _react2.default.createElement(
          "div",
          { className: "" + _grid2.default["col-md-4"] },
          "Uploaded At:"
        )
      ),
      _react2.default.createElement(
        "div",
        { className: _pendingDocumentsList2.default["pending-documents"] },
        renderList(pendingDocuments)
      )
    ),
    _react2.default.createElement(
      "div",
      { className: _pendingDocumentsList2.default.pending },
      _react2.default.createElement(
        "div",
        { className: _pendingDocumentsList2.default["number-pending"] },
        (0, _stringHelpers.pluralize)(pendingDocuments.length, "documents", "document"),
        " awaiting processing"
      )
    )
  );
};

var renderList = function renderList(pendingDocuments) {
  return pendingDocuments.map(function (document) {
    if (document.attachment === undefined || document.attachment === null) {
      return _react2.default.createElement(
        "div",
        { className: _grid2.default.row + " " + _pendingDocumentsList2.default["pending-item"], key: document.id },
        _react2.default.createElement(
          "div",
          { className: _grid2.default["col-md-8"] },
          "Untitled Document"
        ),
        _react2.default.createElement(
          "div",
          { className: _grid2.default["col-md-4"] },
          (0, _moment2.default)(document.uploaded).format("DD/MM/YYYY")
        )
      );
    }
    return _react2.default.createElement(
      "div",
      { className: _grid2.default.row + " " + _pendingDocumentsList2.default["pending-item"], key: document.id },
      _react2.default.createElement(
        "div",
        { className: _grid2.default["col-md-8"] },
        document.attachment.name
      ),
      _react2.default.createElement(
        "div",
        { className: _grid2.default["col-md-4"] },
        (0, _moment2.default)(document.uploaded).format("DD/MM/YYYY")
      )
    );
  });
};

PendingDocumentsList.propTypes = {
  pendingDocuments: _propTypes2.default.arrayOf(_customPropTypes.documentPropType).isRequired
};

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PendingDocuments = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _noDocuments = __webpack_require__(424);

var _customPropTypes = __webpack_require__(5);

var _grid = __webpack_require__(95);

var _grid2 = _interopRequireDefault(_grid);

var _filter = __webpack_require__(449);

var _filter2 = _interopRequireDefault(_filter);

var _pendingDocuments = __webpack_require__(1371);

var _pendingDocuments2 = _interopRequireDefault(_pendingDocuments);

var _stringHelpers = __webpack_require__(68);

var _awaitingProcessing = __webpack_require__(939);

var _processingFields = __webpack_require__(272);

var _processingViewer = __webpack_require__(946);

var _cancelProcessingModal = __webpack_require__(940);

var _trashDocumentModal = __webpack_require__(430);

var _processingToggle = __webpack_require__(945);

var _uploadInlineTabs = __webpack_require__(273);

var _digitalUploadFilters = __webpack_require__(941);

var _drawer = __webpack_require__(420);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PendingDocuments = exports.PendingDocuments = function PendingDocuments(props) {
  if (props.pendingDocuments.length === 0 && props.sourceFilter === null && props.statusFilter === null) {
    return _react2.default.createElement(
      "div",
      { className: _pendingDocuments2.default["no-pending-container"] },
      _react2.default.createElement(_uploadInlineTabs.UploadInlineTabs, { accountSlug: props.accountSlug, currentPage: "awaiting-digital" }),
      _react2.default.createElement(_noDocuments.NoPending, { accountSlug: props.accountSlug })
    );
  }
  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      _drawer.Drawer,
      {
        isDrawerMode: props.isFiltersMode,
        onEndDrawerMode: props.onEndFiltersMode
      },
      _react2.default.createElement(_digitalUploadFilters.DigitalUploadFilters, props)
    ),
    _react2.default.createElement(_uploadInlineTabs.UploadInlineTabs, { accountSlug: props.accountSlug, currentPage: "awaiting-digital" }),
    _react2.default.createElement(
      "div",
      { className: _pendingDocuments2.default["title-area"] },
      _react2.default.createElement(
        "h2",
        { className: _pendingDocuments2.default["processing-title"] },
        (0, _stringHelpers.pluralize)(props.pendingDocuments.length, "documents", "document") + " awaiting processing"
      ),
      _react2.default.createElement(
        "div",
        { className: _pendingDocuments2.default["processing-toggle"] },
        _react2.default.createElement(
          "button",
          { className: _pendingDocuments2.default.filters, onClick: props.onStartFiltersMode },
          _react2.default.createElement(_filter2.default, { className: _pendingDocuments2.default.icon, size: 15 }),
          "Filters"
        ),
        _react2.default.createElement(_processingToggle.ProcessingToggle, {
          isBeingCancelled: props.isBeingCancelled,
          isCancelProcessingLoading: props.isCancelProcessingLoading,
          onCancelProcessingAllDocuments: props.onCancelProcessingAllDocuments,
          onProcessAllDocuments: props.onProcessAllDocuments,
          pendingDocuments: props.pendingDocuments
        })
      )
    ),
    _react2.default.createElement(
      "div",
      { className: _grid2.default.row + " " + _pendingDocuments2.default["pending-documents-container"] },
      _react2.default.createElement(PendingDocumentsProcessingArea, props)
    )
  );
};

PendingDocuments.defaultProps = {
  focusedDocument: null,
  pendingDocuments: [],
  sourceFilter: null,
  statusFilter: null
};

PendingDocuments.propTypes = {
  accountSlug: _propTypes2.default.string.isRequired,
  isBeingCancelled: _propTypes2.default.bool.isRequired,
  isCancelProcessingLoading: _propTypes2.default.bool.isRequired,
  isFiltersMode: _propTypes2.default.bool.isRequired,
  onCancelProcessingAllDocuments: _propTypes2.default.func.isRequired,
  onEndFiltersMode: _propTypes2.default.func.isRequired,
  onProcessAllDocuments: _propTypes2.default.func.isRequired,
  onStartFiltersMode: _propTypes2.default.func.isRequired,
  pendingDocuments: _propTypes2.default.arrayOf(_customPropTypes.documentPropType),
  sourceFilter: _customPropTypes.dataType,
  statusFilter: _customPropTypes.dataType
};

var PendingDocumentsProcessingArea = function PendingDocumentsProcessingArea(props) {
  if (props.pendingDocuments.length === 0) {
    return _react2.default.createElement(
      "div",
      { className: _pendingDocuments2.default["no-pending-container"] + " " + _pendingDocuments2.default["no-filtered"] },
      _react2.default.createElement(_noDocuments.NoPendingFiltered, null)
    );
  }
  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      "div",
      { className: _grid2.default["col-md-3"] },
      _react2.default.createElement(_awaitingProcessing.AwaitingProcessing, {
        focusedDocument: props.focusedDocument,
        onFocusDocument: props.onFocusDocument,
        pendingDocuments: props.pendingDocuments
      })
    ),
    _react2.default.createElement(
      "div",
      { className: _grid2.default["col-md-4"] + " " + _pendingDocuments2.default["processing-fields"] },
      _react2.default.createElement(_cancelProcessingModal.CancelProcessingModal, {
        focusedDocument: props.focusedDocument,
        isVisible: props.focusedDocument.processingState !== "NEEDS_USER_PROCESSING",
        onCancelProcessing: props.onCancelProcessing
      }),
      _react2.default.createElement(_processingFields.ProcessingFields, {
        accountId: props.accountId,
        categories: props.categories,
        currencies: props.currencies,
        documentType: props.documentType,
        focusedDocument: props.focusedDocument,
        onChangeDocumentType: props.onChangeDocumentType,
        onCreateCategory: props.onCreateCategory,
        onReprocessPendingDocument: props.onReprocessPendingDocument,
        onSavePendingDocument: props.onSavePendingDocument,
        onSavePendingOtherDocument: props.onSavePendingOtherDocument,
        onShowTrashDocument: props.onShowTrashDocument,
        preferredCurrency: props.preferredCurrency,
        taxRate: props.taxRate,
        vendors: props.vendors
      })
    ),
    _react2.default.createElement(
      "div",
      { className: _grid2.default["col-md-5"] + " " + _pendingDocuments2.default["processing-viewer"] },
      _react2.default.createElement(_processingViewer.ProcessingViewer, {
        focusedDocument: props.focusedDocument
      })
    ),
    _react2.default.createElement(_trashDocumentModal.TrashDocumentModal, {
      accountId: props.accountId,
      focusedDocument: props.focusedDocument,
      isTrashDocumentVisible: props.isTrashDocumentVisible,
      onHideTrashDocument: props.onHideTrashDocument,
      onTrashDocument: props.onTrashPendingDocument
    })
  );
};

PendingDocumentsProcessingArea.defaultProps = {
  focusedDocument: null,
  pendingDocuments: []
};

PendingDocumentsProcessingArea.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  categories: _propTypes2.default.arrayOf(_customPropTypes.categoryType).isRequired,
  currencies: _propTypes2.default.arrayOf(_customPropTypes.currencyType).isRequired,
  documentType: _propTypes2.default.string.isRequired,
  focusedDocument: _customPropTypes.documentPropType,
  isTrashDocumentVisible: _propTypes2.default.bool.isRequired,
  onCancelProcessing: _propTypes2.default.func.isRequired,
  onChangeDocumentType: _propTypes2.default.func.isRequired,
  onCreateCategory: _propTypes2.default.func.isRequired,
  onFocusDocument: _propTypes2.default.func.isRequired,
  onHideTrashDocument: _propTypes2.default.func.isRequired,
  onReprocessPendingDocument: _propTypes2.default.func.isRequired,
  onSavePendingDocument: _propTypes2.default.func.isRequired,
  onSavePendingOtherDocument: _propTypes2.default.func.isRequired,
  onShowTrashDocument: _propTypes2.default.func.isRequired,
  onTrashPendingDocument: _propTypes2.default.func.isRequired,
  pendingDocuments: _propTypes2.default.arrayOf(_customPropTypes.documentPropType),
  preferredCurrency: _propTypes2.default.string.isRequired,
  taxRate: _propTypes2.default.number.isRequired,
  vendors: _propTypes2.default.arrayOf(_customPropTypes.vendorType).isRequired
};

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProcessingToggle = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _button = __webpack_require__(7);

var _customPropTypes = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProcessingToggle = exports.ProcessingToggle = function ProcessingToggle(_ref) {
  var isBeingCancelled = _ref.isBeingCancelled,
      isCancelProcessingLoading = _ref.isCancelProcessingLoading,
      onCancelProcessingAllDocuments = _ref.onCancelProcessingAllDocuments,
      onProcessAllDocuments = _ref.onProcessAllDocuments,
      pendingDocuments = _ref.pendingDocuments;

  if (isBeingCancelled) {
    return _react2.default.createElement(
      "span",
      { className: "manual7" },
      _react2.default.createElement(
        _button.Button,
        {
          loading: isCancelProcessingLoading,
          onClick: function onClick() {
            return onProcessAllDocuments(pendingDocuments);
          },
          primary: true
        },
        "Process Documents Automatically"
      )
    );
  }
  return _react2.default.createElement(
    "span",
    { className: "manual7" },
    _react2.default.createElement(
      _button.Button,
      {
        danger: true,
        loading: isCancelProcessingLoading,
        onClick: function onClick() {
          return onCancelProcessingAllDocuments(pendingDocuments);
        }
      },
      "Cancel Processing Documents"
    )
  );
};

ProcessingToggle.propTypes = {
  isBeingCancelled: _propTypes2.default.bool.isRequired,
  isCancelProcessingLoading: _propTypes2.default.bool.isRequired,
  onCancelProcessingAllDocuments: _propTypes2.default.func.isRequired,
  onProcessAllDocuments: _propTypes2.default.func.isRequired,
  pendingDocuments: _propTypes2.default.arrayOf(_customPropTypes.documentPropType).isRequired
};

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProcessingViewer = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _processingViewer = __webpack_require__(1372);

var _processingViewer2 = _interopRequireDefault(_processingViewer);

var _customPropTypes = __webpack_require__(5);

var _validators = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProcessingViewer = exports.ProcessingViewer = function ProcessingViewer(_ref) {
  var focusedDocument = _ref.focusedDocument;

  if ((0, _validators.isValidValue)(focusedDocument) && (0, _validators.isValidValue)(focusedDocument.attachment)) {
    return _react2.default.createElement("iframe", { className: _processingViewer2.default.framer + " manual5", src: focusedDocument.attachment.url });
  }
  return null;
};

ProcessingViewer.defaultProps = {
  focusedDocument: null
};

ProcessingViewer.propTypes = {
  focusedDocument: _customPropTypes.documentPropType
};

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReceiptFields = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _reduxForm = __webpack_require__(35);

var _customPropTypes = __webpack_require__(5);

var _processingFields = __webpack_require__(326);

var _processingFields2 = _interopRequireDefault(_processingFields);

var _button = __webpack_require__(7);

var _formElements = __webpack_require__(115);

var _processingFields3 = __webpack_require__(272);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PendingReceiptForm = function PendingReceiptForm(_ref) {
  var accountId = _ref.accountId,
      categories = _ref.categories,
      change = _ref.change,
      currencies = _ref.currencies,
      currency = _ref.currency,
      documentType = _ref.documentType,
      focusedDocument = _ref.focusedDocument,
      formPaymentType = _ref.formPaymentType,
      onChangeDocumentType = _ref.onChangeDocumentType,
      onCreateCategory = _ref.onCreateCategory,
      onReprocessPendingDocument = _ref.onReprocessPendingDocument,
      onSavePendingDocument = _ref.onSavePendingDocument,
      onShowTrashDocument = _ref.onShowTrashDocument,
      preferredCurrency = _ref.preferredCurrency,
      taxRate = _ref.taxRate,
      total = _ref.total;
  return _react2.default.createElement(
    "form",
    { onSubmit: function onSubmit(e) {
        e.preventDefault();onSavePendingDocument();
      } },
    _react2.default.createElement(_processingFields3.DocumentTypeSelector, { documentType: documentType, onChangeDocumentType: onChangeDocumentType }),
    (0, _formElements.renderFormElement)("Vendor", "vendor", "text"),
    (0, _formElements.renderFormElement)("Date", "issued", "date"),
    (0, _formElements.renderFormNumberElement)("Total", "total", null, null, ".01"),
    (0, _formElements.renderFormNumberElement)("Tax", "tax", null, null, ".01"),
    (0, _formElements.renderFormCalculateTaxElement)({ currency: currency, preferredCurrency: preferredCurrency, total: total, taxRate: taxRate, change: change }),
    (0, _formElements.renderFormElement)("Currency", "currency", "select", mapCurrencies(currencies)),
    (0, _formElements.renderPaymentTypeElement)(formPaymentType),
    (0, _formElements.renderFormElement)("Invoice Number", "invoiceNumber", "text"),
    (0, _formElements.renderFormElement)("Categories", "categories", "createable", categories, onCreateCategory, accountId),
    (0, _formElements.renderFormElement)("Notes", "notes", "notes"),
    _react2.default.createElement(
      "div",
      { className: _processingFields2.default.trash },
      _react2.default.createElement(
        _button.Button,
        { danger: true, onClick: function onClick() {
            onShowTrashDocument();
          } },
        "Trash"
      ),
      _react2.default.createElement(
        "span",
        { className: _processingFields2.default.reprocess },
        _react2.default.createElement(
          _button.Button,
          { onClick: function onClick() {
              onReprocessPendingDocument(focusedDocument);
            } },
          "Process Automatically"
        )
      )
    ),
    _react2.default.createElement(
      "div",
      { className: _processingFields2.default.save },
      _react2.default.createElement(_formElements.FormButton, { text: "Save" })
    )
  );
};

PendingReceiptForm.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  categories: _propTypes2.default.arrayOf(_customPropTypes.categoryType).isRequired,
  change: _propTypes2.default.func.isRequired,
  currencies: _propTypes2.default.arrayOf(_customPropTypes.currencyType).isRequired,
  currency: _customPropTypes.currencyType.isRequired,
  documentType: _propTypes2.default.string.isRequired,
  focusedDocument: _customPropTypes.focusedDocumentType.isRequired,
  formPaymentType: _customPropTypes.paymentTypeType.isRequired,
  onChangeDocumentType: _propTypes2.default.func.isRequired,
  onCreateCategory: _propTypes2.default.func.isRequired,
  onReprocessPendingDocument: _propTypes2.default.func.isRequired,
  onSavePendingDocument: _propTypes2.default.func.isRequired,
  onShowTrashDocument: _propTypes2.default.func.isRequired,
  preferredCurrency: _propTypes2.default.string.isRequired,
  taxRate: _propTypes2.default.number.isRequired,
  total: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired
};

var selector = (0, _reduxForm.formValueSelector)("pendingReceiptForm");
PendingReceiptForm = (0, _reactRedux.connect)(function (state) {
  var _selector = selector(state, "currency", "total", "tax", "formPaymentType"),
      currency = _selector.currency,
      total = _selector.total,
      tax = _selector.tax,
      formPaymentType = _selector.formPaymentType;

  return { currency: currency, total: total, tax: tax, formPaymentType: formPaymentType };
})(PendingReceiptForm);

var ReceiptFields = exports.ReceiptFields = (0, _reduxForm.reduxForm)({ form: "pendingReceiptForm" })(PendingReceiptForm);

var mapCurrencies = function mapCurrencies(currencies) {
  return currencies.map(function (currency) {
    return { name: currency.code, key: currency.code };
  });
};

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountRedirector = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _users = __webpack_require__(416);

var _bootstrapActions = __webpack_require__(60);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AccountRedirector = exports.AccountRedirector = function (_React$Component) {
  _inherits(AccountRedirector, _React$Component);

  function AccountRedirector() {
    _classCallCheck(this, AccountRedirector);

    return _possibleConstructorReturn(this, (AccountRedirector.__proto__ || Object.getPrototypeOf(AccountRedirector)).apply(this, arguments));
  }

  _createClass(AccountRedirector, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      return (0, _bootstrapActions.loadStoredAccountIds)().then(function (_ref) {
        var activeAccountId = _ref.activeAccountId,
            favouriteAccountId = _ref.favouriteAccountId;

        (0, _users.fetchCurrentUserAndAccounts)().then(function (_ref2) {
          var accounts = _ref2.accounts;

          var selectedAccount = (0, _bootstrapActions.findSelectedAccount)(accounts, activeAccountId, favouriteAccountId);
          document.location.href = "/accounts/" + selectedAccount.slug + "/documents/all";
        });
      });
    }
  }]);

  return AccountRedirector;
}(_react2.default.Component);

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppContainer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactour = __webpack_require__(1894);

var _reactour2 = _interopRequireDefault(_reactour);

var _appHeader = __webpack_require__(842);

var _reactRedux = __webpack_require__(11);

var _reactSticky = __webpack_require__(259);

var _tourSteps = __webpack_require__(936);

var _oauthActions = __webpack_require__(162);

var _appActions = __webpack_require__(25);

var _documentFiltersActions = __webpack_require__(136);

var _updateDocumentActions = __webpack_require__(163);

var _localStorage = __webpack_require__(138);

var _bootstrapActions = __webpack_require__(60);

var _customPropTypes = __webpack_require__(5);

var _unknownErrorMessage = __webpack_require__(849);

var _flashMessage = __webpack_require__(845);

var _loading = __webpack_require__(38);

var _firstTimeBetaModal = __webpack_require__(880);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var App = function (_React$Component) {
  _inherits(App, _React$Component);

  function App() {
    _classCallCheck(this, App);

    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
  }

  _createClass(App, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.init();
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.isLoading) {
        return _react2.default.createElement(_loading.Loading, null);
      }
      this.props.onFetchDocuments(this.props.selectedAccount.id, this.props.filters);
      return _react2.default.createElement(
        _reactSticky.StickyContainer,
        null,
        _react2.default.createElement(_flashMessage.FlashMessage, {
          message: this.props.flash.message,
          onHide: this.props.onHideFlash,
          type: this.props.flash.type
        }),
        _react2.default.createElement(
          _reactSticky.Sticky,
          { stickyStyle: { zIndex: 9999 } },
          _react2.default.createElement(_appHeader.AppHeader, this.props)
        ),
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(_firstTimeBetaModal.FirstTimeBetaModal, {
            isDontRemindBeta: this.props.isDontRemindBeta,
            isFirstTimeBetaMode: this.props.isFirstTimeBetaMode,
            onEndFirstTimeBetaMode: this.props.onEndFirstTimeBetaMode,
            onStartTour: this.props.onStartTour,
            onToggleBetaModal: this.props.onToggleBetaModal
          }),
          _react2.default.createElement(_unknownErrorMessage.UnknownErrorMessage, {
            accountSlug: this.props.selectedAccount.slug,
            isGlobalError: this.props.isGlobalError,
            onEndGlobalError: this.props.onEndGlobalError
          }),
          this.props.children
        ),
        _react2.default.createElement(_reactour2.default, {
          accentColor: "#750a88",
          isOpen: this.props.isTourOpen,
          onRequestClose: this.props.onEndTour,
          showButtons: false,
          showNavigation: false,
          steps: (0, _tourSteps.getTourSteps)(this.props)
        })
      );
    }
  }]);

  return App;
}(_react2.default.Component);

App.propTypes = {
  children: _propTypes2.default.element.isRequired,
  filters: _customPropTypes.documentFiltersType.isRequired,
  flash: _customPropTypes.flashType.isRequired,
  init: _propTypes2.default.func.isRequired,
  isDontRemindBeta: _propTypes2.default.bool.isRequired,
  isFirstTimeBetaMode: _propTypes2.default.bool.isRequired,
  isGlobalError: _propTypes2.default.bool.isRequired,
  isLoading: _propTypes2.default.bool.isRequired,
  isTourOpen: _propTypes2.default.bool.isRequired,
  onEndFirstTimeBetaMode: _propTypes2.default.func.isRequired,
  onEndGlobalError: _propTypes2.default.func.isRequired,
  onEndTour: _propTypes2.default.func.isRequired,
  onFetchDocuments: _propTypes2.default.func.isRequired,
  onHideFlash: _propTypes2.default.func.isRequired, // () => void
  onStartTour: _propTypes2.default.func.isRequired,
  onToggleBetaModal: _propTypes2.default.func.isRequired,
  selectedAccount: _customPropTypes.accountType
};

App.defaultProps = {
  selectedAccount: null
};

var matchStateToProps = function matchStateToProps(state) {
  return {
    accounts: state.app.accounts,
    accountSlug: state.app.selectedAccount,
    exportFailedCount: state.app.exportFailedCount,
    filters: state.documentFilters,
    flash: state.app.flash,
    isDontRemindBeta: state.app.isDontRemindBeta,
    isFirstTimeBetaMode: state.app.isFirstTimeBetaMode,
    isGlobalError: state.app.isGlobalError,
    isLoading: state.app.isLoading,
    isNotificationsMode: state.app.isNotificationsMode,
    isNotificationsViewed: state.app.isNotificationsViewed,
    isSettingsMode: state.app.isSettingsMode,
    isTourOpen: state.app.isTourOpen,
    isUploadDocumentsVisible: state.pendingDocuments.isUploadDocumentsVisible,
    isUploadLoading: state.pendingDocuments.isUploadLoading,
    oAuthToken: state.oauth.token,
    pendingDocuments: state.pendingDocuments.pendingDocuments,
    queuedCount: state.app.queuedCount,
    searchQueryString: state.documentFilters.searchQueryString,
    documents: state.documents.documents,
    selectedAccount: state.app.selectedAccount,
    tourName: state.app.tourName,
    user: state.app.user
  };
};

var matchDispatchToProps = function matchDispatchToProps(dispatch) {
  return {
    init: function init() {
      if (_localStorage.storage.isSet(_localStorage.OAUTH_TOKEN)) {
        dispatch((0, _oauthActions.setOauthTokenAction)(_localStorage.storage.get(_localStorage.OAUTH_TOKEN)));
        dispatch((0, _bootstrapActions.bootstrapAction)());
      } else {
        dispatch((0, _oauthActions.redirectToLoginAction)());
      }
    },
    onAddSearchQuery: function onAddSearchQuery(query) {
      return dispatch((0, _documentFiltersActions.addSearchQueryToFilterAction)(query));
    },
    onChangeSelectedAccount: function onChangeSelectedAccount(accountId, accountSlug) {
      return dispatch((0, _appActions.changeSelectedAccountAction)(accountId, accountSlug));
    },
    onEndFirstTimeBetaMode: function onEndFirstTimeBetaMode(toggle) {
      return dispatch((0, _appActions.endFirstTimeBetaModeAction)(toggle));
    },
    onEndGlobalError: function onEndGlobalError() {
      return dispatch((0, _appActions.endGlobalErrorAction)());
    },
    onEndNotificationsMode: function onEndNotificationsMode() {
      return dispatch((0, _appActions.endNotificationsModeAction)());
    },
    onEndSettingsMode: function onEndSettingsMode() {
      return dispatch((0, _appActions.endSettingsModeAction)());
    },
    onEndTour: function onEndTour() {
      return dispatch((0, _appActions.endTourAction)());
    },
    onFetchDocuments: function onFetchDocuments(accountId, filters) {
      return dispatch((0, _appActions.fetchDocumentsAction)(accountId, filters));
    },
    onFocusDocument: function onFocusDocument(document, style) {
      return dispatch((0, _updateDocumentActions.focusDocumentAction)(document, style));
    },
    onHideFlash: function onHideFlash() {
      return dispatch((0, _appActions.clearFlashMessageAction)());
    },
    onLogout: function onLogout() {
      return dispatch((0, _oauthActions.logoutAction)());
    },
    onStartNotificationsMode: function onStartNotificationsMode() {
      return dispatch((0, _appActions.startNotificationsModeAction)());
    },
    onStartSettingsMode: function onStartSettingsMode() {
      return dispatch((0, _appActions.startSettingsModeAction)());
    },
    onSetFlashMessage: function onSetFlashMessage(message, type) {
      return dispatch((0, _appActions.setFlashMessageAction)(message, type));
    },
    onStartTour: function onStartTour(tour) {
      return dispatch((0, _appActions.startTourAction)(tour));
    },
    onToggleBetaModal: function onToggleBetaModal(toggle) {
      return dispatch((0, _appActions.toggleBetaModalAction)(toggle));
    },
    onUpdateSearchQuery: function onUpdateSearchQuery(query) {
      return dispatch((0, _documentFiltersActions.updateSearchQueryAction)(query));
    },
    onUpdateStepIndex: function onUpdateStepIndex(index) {
      return dispatch((0, _appActions.updateStepIndexAction)(index));
    }
  };
};

var AppContainer = exports.AppContainer = (0, _reactRedux.connect)(matchStateToProps, matchDispatchToProps)(App);

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AwaitingMailinContainer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _reactRedux = __webpack_require__(11);

var _customPropTypes = __webpack_require__(5);

var _uploadInlineTabs = __webpack_require__(273);

var _manageEnvelopes = __webpack_require__(438);

var _envelopesActions = __webpack_require__(264);

var _trackingActions = __webpack_require__(26);

var _documentFiltersActions = __webpack_require__(136);

var _appActions = __webpack_require__(25);

var _manageEnvelopesContainer = __webpack_require__(439);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AwaitingMailinPage = function AwaitingMailinPage(props) {
  var envelopes = _ramda2.default.filter(function (envelope) {
    return envelope.status !== "uploaded" || envelope.status !== "returned";
  }, props.envelopes);
  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(_uploadInlineTabs.UploadInlineTabs, { accountSlug: props.slug, currentPage: "awaiting-mailin" }),
    _react2.default.createElement(_manageEnvelopes.ManageEnvelopes, _extends({}, props, {
      envelopes: (0, _manageEnvelopesContainer.mapEnvelopeUploadedKey)(envelopes),
      isAwaitingMailin: true,
      isLinkable: false,
      title: "Awaiting Mail In"
    }))
  );
};

AwaitingMailinPage.defaultProps = {
  envelopes: []
};

AwaitingMailinPage.propTypes = {
  envelopes: _propTypes2.default.arrayOf(_customPropTypes.envelopeType),
  slug: _propTypes2.default.string.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    accountId: state.app.selectedAccount.id,
    coversheetUrl: state.envelopes.coversheetUrl,
    envelopes: state.envelopes.envelopes,
    isLoading: state.envelopes.isLoading,
    isRequestEnvelopeVisible: state.envelopes.isRequestEnvelopeVisible,
    isSendEnvelopeVisible: state.envelopes.isSendEnvelopeVisible,
    slug: state.app.selectedAccount.slug
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    init: function init(accountId) {
      return dispatch((0, _envelopesActions.setCoversheetAction)(accountId));
    },
    trackPage: function trackPage() {
      return dispatch((0, _trackingActions.trackPageAction)("Awaiting mail in page"));
    },
    onAddEnvelope: function onAddEnvelope(code) {
      return dispatch((0, _documentFiltersActions.addEnvelopeToFilterAction)(code));
    },
    onHideRequestEnvelope: function onHideRequestEnvelope() {
      return dispatch((0, _envelopesActions.setRequestEnvelopeVisibilityAction)(false));
    },
    onHideSendEnvelope: function onHideSendEnvelope() {
      return dispatch((0, _envelopesActions.setSendEnvelopeVisibilityAction)(false));
    },
    onRequestEnvelope: function onRequestEnvelope(accountId) {
      return dispatch((0, _envelopesActions.requestEnvelopeAction)(accountId));
    },
    onSetFlashMessage: function onSetFlashMessage(message) {
      return dispatch((0, _appActions.setFlashMessageAction)(message));
    },
    onShowRequestEnvelope: function onShowRequestEnvelope() {
      return dispatch((0, _envelopesActions.setRequestEnvelopeVisibilityAction)(true));
    },
    onShowSendEnvelope: function onShowSendEnvelope() {
      return dispatch((0, _envelopesActions.setSendEnvelopeVisibilityAction)(true));
    }
  };
};

var AwaitingMailinContainer = exports.AwaitingMailinContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AwaitingMailinPage);

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomTabContainer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _trackingActions = __webpack_require__(26);

var _documentFiltersActions = __webpack_require__(136);

var _customTabsActions = __webpack_require__(160);

var _customTab = __webpack_require__(854);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CustomTabPage = function (_React$Component) {
  _inherits(CustomTabPage, _React$Component);

  function CustomTabPage() {
    _classCallCheck(this, CustomTabPage);

    return _possibleConstructorReturn(this, (CustomTabPage.__proto__ || Object.getPrototypeOf(CustomTabPage)).apply(this, arguments));
  }

  _createClass(CustomTabPage, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.props.trackPage();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.resetFilters();
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(_customTab.CustomTab, this.props);
    }
  }]);

  return CustomTabPage;
}(_react2.default.Component);

CustomTabPage.propTypes = {
  resetFilters: _propTypes2.default.func.isRequired,
  trackPage: _propTypes2.default.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    accountId: state.app.selectedAccount.id,
    accountSlug: state.app.selectedAccount.slug,
    allDocumentsTotal: state.documents.pagination.totalCount,
    cardNumbers: state.cardNumbers.cardNumbers,
    categories: state.categories.categories,
    currencies: state.currencies.currencies,
    customTabName: state.customTabs.customTabName,
    customTabs: state.customTabs.customTabs,
    endDate: state.documentFilters.endDate,
    envelopes: state.envelopes.envelopes,
    exportType: state.documentFilters.exportType,
    filters: state.documentFilters,
    isCreateCustomTabLoading: state.customTabs.isCreateCustomTabLoading,
    lastFourDigits: state.documentFilters.lastFourDigits,
    preferredCurrency: state.accountSettings.currency,
    searchQueryString: state.documentFilters.searchQueryString,
    selectedCardNumbers: state.documentFilters.selectedCardNumbers,
    selectedCategories: state.documentFilters.selectedCategories,
    selectedCurrencies: state.documentFilters.selectedCurrencies,
    selectedEnvelopes: state.documentFilters.selectedEnvelopes,
    selectedMergeDocumentId: state.documents.selectedMergeDocumentId,
    selectedPaymentTypes: state.documentFilters.selectedPaymentTypes,
    selectedDocumentIds: state.documents.selectedDocumentIds,
    selectedSearchQueryString: state.documentFilters.selectedSearchQueryString,
    selectedVendors: state.documentFilters.selectedVendors,
    startDate: state.documentFilters.startDate,
    type: state.documentFilters.type,
    vendors: state.vendors.vendors,
    viewedStatus: state.documentFilters.viewedStatus
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    trackPage: function trackPage() {
      return dispatch((0, _trackingActions.trackPageAction)("Custom tab page"));
    },
    resetFilters: function resetFilters() {
      return dispatch((0, _documentFiltersActions.resetFiltersAction)());
    },
    onAddCardNumber: function onAddCardNumber(data) {
      return dispatch((0, _documentFiltersActions.addCardNumberToFilterAction)(data.key));
    },
    onAddCategory: function onAddCategory(data) {
      return dispatch((0, _documentFiltersActions.addCategoryToFilterAction)(data.name));
    },
    onAddCurrency: function onAddCurrency(data) {
      return dispatch((0, _documentFiltersActions.addCurrencyToFilterAction)(data.key));
    },
    onAddDocumentType: function onAddDocumentType(data) {
      return dispatch((0, _documentFiltersActions.addDocumentTypeToFilterAction)(data.key));
    },
    onAddEndDate: function onAddEndDate(data) {
      return dispatch((0, _documentFiltersActions.addEndDateToFilterAction)(data));
    },
    onAddEnvelope: function onAddEnvelope(data) {
      return dispatch((0, _documentFiltersActions.addEnvelopeToFilterAction)(data.key));
    },
    onAddPaymentType: function onAddPaymentType(data) {
      return dispatch((0, _documentFiltersActions.addPaymentTypeToFilterAction)(data.key));
    },
    onAddSearchQuery: function onAddSearchQuery(query) {
      return dispatch((0, _documentFiltersActions.addSearchQueryToFilterAction)(query));
    },
    onAddStartDate: function onAddStartDate(data) {
      return dispatch((0, _documentFiltersActions.addStartDateToFilterAction)(data));
    },
    onAddVendor: function onAddVendor(data) {
      return dispatch((0, _documentFiltersActions.addVendorToFilterAction)(data.name));
    },
    onAddViewedStatus: function onAddViewedStatus(data) {
      return dispatch((0, _documentFiltersActions.addViewedStatusToFilterAction)(data.key));
    },
    onCreateCustomTab: function onCreateCustomTab(accountId, filters, tabName) {
      return dispatch((0, _customTabsActions.createCustomTabAction)(accountId, filters, tabName));
    },
    onClearExportType: function onClearExportType() {
      return dispatch((0, _documentFiltersActions.clearExportTypeFilterAction)());
    },
    onOrderBy: function onOrderBy(key) {
      return dispatch((0, _documentFiltersActions.orderByAction)(key));
    },
    onRemoveCardNumber: function onRemoveCardNumber(card) {
      return dispatch((0, _documentFiltersActions.removeCardNumberFromFilterAction)(card));
    },
    onRemoveCategory: function onRemoveCategory(name) {
      return dispatch((0, _documentFiltersActions.removeCategoryFromFilterAction)(name));
    },
    onRemoveCurrency: function onRemoveCurrency(data) {
      return dispatch((0, _documentFiltersActions.removeCurrencyFromFilterAction)(data));
    },
    onRemoveDocumentType: function onRemoveDocumentType() {
      return dispatch((0, _documentFiltersActions.removeDocumentTypeFromFilterAction)());
    },
    onRemoveEnvelope: function onRemoveEnvelope(name) {
      return dispatch((0, _documentFiltersActions.removeEnvelopeFromFilterAction)(name));
    },
    onRemoveSearchQuery: function onRemoveSearchQuery() {
      return dispatch((0, _documentFiltersActions.removeSearchQueryFromFilterAction)());
    },
    onRemovePaymentType: function onRemovePaymentType(name) {
      return dispatch((0, _documentFiltersActions.removePaymentTypeFromFilterAction)(name.toLowerCase()));
    },
    onRemoveVendor: function onRemoveVendor(name) {
      return dispatch((0, _documentFiltersActions.removeVendorFromFilterAction)(name));
    },
    onRemoveViewedStatus: function onRemoveViewedStatus() {
      return dispatch((0, _documentFiltersActions.removeViewedStatusFromFilterAction)());
    },
    onStartDeleteCustomTabMode: function onStartDeleteCustomTabMode(id) {
      return dispatch((0, _customTabsActions.startDeleteCustomTabModeAction)(id));
    },
    onUpdateCustomTabName: function onUpdateCustomTabName(name) {
      return dispatch((0, _customTabsActions.updateCustomTabNameAction)(name));
    },
    onUpdateSearchQuery: function onUpdateSearchQuery(query) {
      return dispatch((0, _documentFiltersActions.updateSearchQueryAction)(query));
    },
    onSetExportType: function onSetExportType(data) {
      return dispatch((0, _documentFiltersActions.setExportTypeFilterAction)(data.key));
    }
  };
};

var CustomTabContainer = exports.CustomTabContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CustomTabPage);

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DashboardContainer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _dashboardActions = __webpack_require__(408);

var _trackingActions = __webpack_require__(26);

var _appActions = __webpack_require__(25);

var _dashboard = __webpack_require__(850);

var _loading = __webpack_require__(38);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DashboardPage = function (_React$Component) {
  _inherits(DashboardPage, _React$Component);

  function DashboardPage() {
    _classCallCheck(this, DashboardPage);

    return _possibleConstructorReturn(this, (DashboardPage.__proto__ || Object.getPrototypeOf(DashboardPage)).apply(this, arguments));
  }

  _createClass(DashboardPage, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.props.init(this.props.accountId);
      this.props.trackPage();
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.isLoading) {
        return _react2.default.createElement(_loading.Loading, null);
      }
      return _react2.default.createElement(_dashboard.Dashboard, this.props);
    }
  }]);

  return DashboardPage;
}(_react2.default.Component);

DashboardPage.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  init: _propTypes2.default.func.isRequired,
  isLoading: _propTypes2.default.bool.isRequired,
  trackPage: _propTypes2.default.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    accountId: state.app.selectedAccount.id,
    documentCount: state.dashboard.documentCount,
    documentLimit: state.dashboard.documentLimit,
    envelopeCount: state.dashboard.envelopeCount,
    envelopeLimit: state.dashboard.envelopeLimit,
    isLoading: state.dashboard.isLoading,
    name: state.app.user.firstName,
    pendingDocumentCount: state.dashboard.pendingDocumentCount,
    totalCount: state.dashboard.totalCount,
    totalSumFiltered: state.dashboard.totalSumFiltered,
    vendorsCount: state.vendors.vendors.length
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    init: function init(accountId) {
      return dispatch((0, _dashboardActions.fetchDashboardDetailsAction)(accountId));
    },
    trackPage: function trackPage() {
      return dispatch((0, _trackingActions.trackPageAction)("Dashboard page"));
    },
    onEndTour: function onEndTour() {
      return dispatch((0, _appActions.endTourAction)());
    },
    onStartTour: function onStartTour(tour) {
      return dispatch((0, _appActions.startTourAction)(tour));
    }
  };
};

var DashboardContainer = exports.DashboardContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DashboardPage);

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentsContainer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _documentsContainer = __webpack_require__(1323);

var _documentsContainer2 = _interopRequireDefault(_documentsContainer);

var _inbox = __webpack_require__(869);

var _getFiltersFromUrl = __webpack_require__(1001);

var _appActions = __webpack_require__(25);

var _customTabsActions = __webpack_require__(160);

var _trackingActions = __webpack_require__(26);

var _documentsActions = __webpack_require__(161);

var _updateDocumentActions = __webpack_require__(163);

var _customPropTypes = __webpack_require__(5);

var _documentFiltersActions = __webpack_require__(136);

var _exportsActions = __webpack_require__(409);

var _categoriesActions = __webpack_require__(194);

var _loading = __webpack_require__(38);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DocumentsPage = function (_React$Component) {
  _inherits(DocumentsPage, _React$Component);

  function DocumentsPage() {
    _classCallCheck(this, DocumentsPage);

    return _possibleConstructorReturn(this, (DocumentsPage.__proto__ || Object.getPrototypeOf(DocumentsPage)).apply(this, arguments));
  }

  _createClass(DocumentsPage, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _props = this.props,
          accountId = _props.accountId,
          customTabs = _props.customTabs,
          filters = _props.filters,
          pagination = _props.pagination,
          route = _props.route,
          router = _props.router,
          preferredCurrency = _props.preferredCurrency;

      var activeFilters = (0, _getFiltersFromUrl.getFiltersFromUrl)(filters, route, router, preferredCurrency, customTabs);
      this.props.setFilters(activeFilters);
      this.props.init(accountId, activeFilters, pagination);
      this.props.splitCategories(this.props.categories);
      this.props.trackPage();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("keydown", this.props.onShiftPressed, false);
      document.addEventListener("keyup", this.props.onShiftReleased, false);
      this.props.onStartRefreshIntervals();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.resetFilters();
      this.props.onClearRefreshIntervals();
      this.props.onUnfocusDocument();
      this.props.onHideGLCodesPanel();
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.isLoading) {
        return _react2.default.createElement(_loading.Loading, null);
      }
      return _react2.default.createElement(
        "div",
        { className: _documentsContainer2.default.container },
        _react2.default.createElement(_inbox.Inbox, this.props)
      );
    }
  }]);

  return DocumentsPage;
}(_react2.default.Component);

DocumentsPage.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  categories: _propTypes2.default.arrayOf(_customPropTypes.categoryType),
  customTabs: _propTypes2.default.arrayOf(_customPropTypes.customTabType),
  filters: _customPropTypes.documentFiltersType.isRequired,
  init: _propTypes2.default.func.isRequired, // (accountId: string) => void
  isLoading: _propTypes2.default.bool.isRequired,
  onClearRefreshIntervals: _propTypes2.default.func.isRequired,
  onHideGLCodesPanel: _propTypes2.default.func.isRequired,
  onShiftPressed: _propTypes2.default.func.isRequired,
  onShiftReleased: _propTypes2.default.func.isRequired,
  onStartRefreshIntervals: _propTypes2.default.func.isRequired,
  onUnfocusDocument: _propTypes2.default.func.isRequired,
  pagination: _customPropTypes.paginationType.isRequired,
  preferredCurrency: _propTypes2.default.string.isRequired,
  resetFilters: _propTypes2.default.func.isRequired,
  route: _customPropTypes.routeType.isRequired,
  router: _customPropTypes.routerType.isRequired,
  setFilters: _propTypes2.default.func.isRequired,
  splitCategories: _propTypes2.default.func.isRequired,
  trackPage: _propTypes2.default.func.isRequired
};

DocumentsPage.defaultProps = {
  categories: [],
  customTabs: [],
  endDate: null,
  exportType: null,
  startDate: null
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    accountId: state.app.selectedAccount.id,
    accountSlug: state.app.selectedAccount.slug,
    allDocumentsTotal: state.documents.pagination.totalCount,
    cardNumbers: state.cardNumbers.cardNumbers,
    categories: state.categories.categories,
    columns: state.documents.columns,
    currencies: state.currencies.currencies,
    currentUser: state.app.user,
    customTabs: state.customTabs.customTabs,
    endDate: state.documentFilters.endDate,
    envelopes: state.envelopes.envelopes,
    exportType: state.documentFilters.exportType,
    filtersCount: state.documents.filtersCount,
    generatedShareUrl: state.documents.generatedShareUrl,
    glCodes: state.documents.glCodes,
    isChangeDocTypeVisible: state.documents.isChangeDocTypeVisible,
    isDocumentViewerVisible: state.documents.isDocumentViewerVisible,
    isBatchEditMode: state.documents.isBatchEditMode,
    isBatchCategoriesMode: state.documents.isBatchCategoriesMode,
    isBatchCategoriesLoading: state.documents.isBatchCategoriesLoading,
    isBatchDownloadLoading: state.documents.isBatchDownloadLoading,
    isBatchDownloadMode: state.documents.isBatchDownloadMode,
    isBatchEditLoading: state.documents.isBatchEditLoading,
    isFiltersDrawerMode: state.documents.isFiltersDrawerMode,
    isHamburgerMode: state.documents.isHamburgerMode,
    isDeletePermanentlyLoading: state.documents.isDeletePermanentlyLoading,
    isDeletePermanentlyVisible: state.documents.isDeletePermanentlyVisible,
    isDocViewerHamburgerMode: state.documents.isDocViewerHamburgerMode,
    isDraggable: state.documents.isDraggable,
    isExportMode: state.documents.isExportMode,
    isGLCodesLoading: state.documents.isGLCodesLoading,
    isGLCodesVisible: state.documents.isGLCodesVisible,
    isLoading: state.documents.isLoading,
    isMergeDocumentsLoading: state.documents.isMergeDocumentsLoading,
    isMergeDocumentsMode: state.documents.isMergeDocumentsMode,
    isEditColumnsVisible: state.documents.isEditColumnsVisible,
    isRestoreDocumentsLoading: state.documents.isRestoreDocumentsLoading,
    isShiftPressed: state.documents.isShiftPressed,
    isTrash: state.documentFilters.isTrash,
    isTrashMultipleDocumentsLoading: state.documents.isTrashMultipleDocumentsLoading,
    isTrashMultipleDocumentsVisible: state.documents.isTrashMultipleDocumentsVisible,
    isTrashDocumentVisible: state.documents.isTrashDocumentVisible,
    isShareUrlVisible: state.documents.isShareUrlVisible,
    filters: state.documentFilters,
    gridWidth: state.documents.gridWidth,
    lastFourDigits: state.documentFilters.lastFourDigits,
    mergeDocument: state.documents.mergeDocument,
    name: state.documentFilters.name,
    orderBy: state.documentFilters.orderBy,
    orderDirection: state.documentFilters.orderDirection,
    pagination: state.documents.pagination,
    preferredCurrency: state.accountSettings.currency,
    documents: state.documents.documents,
    searchQueryString: state.documentFilters.searchQueryString,
    selectedCardNumbers: state.documentFilters.selectedCardNumbers,
    selectedCategories: state.documentFilters.selectedCategories,
    selectedCurrencies: state.documentFilters.selectedCurrencies,
    selectedEnvelopes: state.documentFilters.selectedEnvelopes,
    selectedMergeDocumentId: state.documents.selectedMergeDocumentId,
    selectedName: state.documentFilters.selectedName,
    selectedPaymentTypes: state.documentFilters.selectedPaymentTypes,
    selectedDocumentIds: state.documents.selectedDocumentIds,
    selectedSearchQueryString: state.documentFilters.selectedSearchQueryString,
    focusedDocument: state.updateDocument,
    selectedAccount: state.app.selectedAccount,
    selectedVendors: state.documentFilters.selectedVendors,
    startDate: state.documentFilters.startDate,
    taxRate: state.accountSettings.vat,
    totalMax: state.documentFilters.totalMax,
    totalMin: state.documentFilters.totalMin,
    type: state.documentFilters.type,
    vendors: state.vendors.vendors,
    viewedStatus: state.documentFilters.viewedStatus
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    init: function init(accountId, filters, pagination) {
      dispatch((0, _documentsActions.fetchDocumentsAction)(accountId, filters, pagination));
    },
    trackPage: function trackPage() {
      return dispatch((0, _trackingActions.trackPageAction)("Inbox page"));
    },
    resetFilters: function resetFilters() {
      return dispatch((0, _documentFiltersActions.resetFiltersAction)());
    },
    setFilters: function setFilters(filters) {
      return dispatch((0, _documentFiltersActions.setFiltersAction)(filters));
    },
    onAddCardNumber: function onAddCardNumber(data) {
      return dispatch((0, _documentFiltersActions.addCardNumberToFilterAction)(data.key));
    },
    onAddCategory: function onAddCategory(data) {
      return dispatch((0, _documentFiltersActions.addCategoryToFilterAction)(data.name));
    },
    onAddCurrency: function onAddCurrency(data) {
      return dispatch((0, _documentFiltersActions.addCurrencyToFilterAction)(data.key));
    },
    onAddDocumentType: function onAddDocumentType(data) {
      return dispatch((0, _documentFiltersActions.addDocumentTypeToFilterAction)(data.key));
    },
    onAddEndDate: function onAddEndDate(data) {
      return dispatch((0, _documentFiltersActions.addEndDateToFilterAction)(data));
    },
    onAddEnvelope: function onAddEnvelope(data) {
      return dispatch((0, _documentFiltersActions.addEnvelopeToFilterAction)(data.key));
    },
    onAddIncludeRule: function onAddIncludeRule(data) {
      return dispatch((0, _exportsActions.addIncludeRuleAction)(data));
    },
    onAddNameToFilter: function onAddNameToFilter(name) {
      return dispatch((0, _documentFiltersActions.addNameToFilterAction)(name));
    },
    onAddPaymentType: function onAddPaymentType(data) {
      return dispatch((0, _documentFiltersActions.addPaymentTypeToFilterAction)(data.key));
    },
    onAddRuleError: function onAddRuleError() {
      return dispatch((0, _exportsActions.addRuleErrorAction)());
    },
    onAddSearchQuery: function onAddSearchQuery(query) {
      return dispatch((0, _documentFiltersActions.addSearchQueryToFilterAction)(query));
    },
    onAddStartDate: function onAddStartDate(data) {
      return dispatch((0, _documentFiltersActions.addStartDateToFilterAction)(data));
    },
    onAddTotalFilter: function onAddTotalFilter(type, value) {
      return dispatch((0, _documentFiltersActions.addTotalFilterAction)(type, value));
    },
    onAddVendor: function onAddVendor(data) {
      return dispatch((0, _documentFiltersActions.addVendorToFilterAction)(data.name));
    },
    onAddViewedStatus: function onAddViewedStatus(data) {
      return dispatch((0, _documentFiltersActions.addViewedStatusToFilterAction)(data.key));
    },
    onCalculateGST: function onCalculateGST(total, currency, taxRate) {
      return dispatch((0, _updateDocumentActions.calculateGSTAction)(total, currency, taxRate));
    },
    onChangeDocType: function onChangeDocType(accountId) {
      return dispatch((0, _updateDocumentActions.changeDocumentTypeAction)(accountId));
    },
    onChangeViewedSetting: function onChangeViewedSetting(isViewed) {
      return dispatch((0, _updateDocumentActions.submitChangeViewedSettingAction)(isViewed));
    },
    onClearExportType: function onClearExportType() {
      return dispatch((0, _documentFiltersActions.clearExportTypeFilterAction)());
    },
    onClearRefreshIntervals: function onClearRefreshIntervals() {
      return dispatch((0, _documentsActions.clearRefreshIntervalsAction)());
    },
    onCreateCategory: function onCreateCategory(accountId, category) {
      return dispatch((0, _categoriesActions.createCategoryAction)(accountId, category));
    },
    onDeletePermanently: function onDeletePermanently() {
      return dispatch((0, _documentsActions.deletePermanentlyAction)());
    },
    onDeselectAllDocuments: function onDeselectAllDocuments() {
      return dispatch((0, _documentsActions.deselectAllDocumentsAction)());
    },
    onEndBatchCategoriesMode: function onEndBatchCategoriesMode() {
      return dispatch((0, _documentsActions.endBatchCategoriesModeAction)());
    },
    onEndBatchDownloadMode: function onEndBatchDownloadMode() {
      return dispatch((0, _documentsActions.endBatchDownloadModeAction)());
    },
    onEndBatchEditMode: function onEndBatchEditMode() {
      return dispatch((0, _documentsActions.endBatchEditModeAction)());
    },
    onEndHamburgerMode: function onEndHamburgerMode() {
      return dispatch((0, _documentsActions.endHamburgerModeAction)());
    },
    onEndDocViewerHamburgerMode: function onEndDocViewerHamburgerMode() {
      return dispatch((0, _documentsActions.endDocViewerHamburgerModeAction)());
    },
    onEndDraggableMode: function onEndDraggableMode() {
      return dispatch((0, _documentsActions.endDraggabilityAction)());
    },
    onEndExportMode: function onEndExportMode() {
      return dispatch((0, _documentsActions.endExportModeAction)());
    },
    onEndFiltersDrawerMode: function onEndFiltersDrawerMode() {
      return dispatch((0, _documentsActions.endFiltersDrawerModeAction)());
    },
    onEndMergeDocumentsMode: function onEndMergeDocumentsMode() {
      return dispatch((0, _documentsActions.endMergeDocumentsModeAction)());
    },
    onExitTrash: function onExitTrash() {
      return dispatch((0, _documentFiltersActions.setTrashViewAction)(false));
    },
    onExportAll: function onExportAll(accountId) {
      return dispatch((0, _exportsActions.exportAllAction)(accountId));
    },
    onExportSelected: function onExportSelected(accountId, selectedDocumentIds) {
      return dispatch((0, _exportsActions.exportSelectedAction)(accountId, selectedDocumentIds));
    },
    onGenerateShareUrl: function onGenerateShareUrl(accountId, documentId) {
      return dispatch((0, _documentsActions.generateShareUrlAction)(accountId, documentId));
    },
    onHideChangeDocType: function onHideChangeDocType() {
      return dispatch((0, _documentsActions.setChangeDocumentTypeVisibilityAction)(false));
    },
    onHideDeletePermanently: function onHideDeletePermanently() {
      return dispatch((0, _documentsActions.setDeletePermanentlyVisibilityAction)(false));
    },
    onHideDocumentViewer: function onHideDocumentViewer() {
      return dispatch((0, _documentsActions.setDocumentViewerVisibilityAction)(false));
    },
    onHideEditColumns: function onHideEditColumns() {
      return dispatch((0, _documentsActions.setEditColumnsVisibilityAction)(false));
    },
    onHideGLCodesPanel: function onHideGLCodesPanel() {
      return dispatch((0, _documentsActions.hideGLCodesPanelAction)());
    },
    onHideTrashMultipleDocuments: function onHideTrashMultipleDocuments() {
      return dispatch((0, _documentsActions.setTrashMultipleDocumentsVisibilityAction)(false));
    },
    onHideTrashDocument: function onHideTrashDocument() {
      return dispatch((0, _documentsActions.setTrashDocumentVisibilityAction)(false));
    },
    onHideShareUrl: function onHideShareUrl() {
      return dispatch((0, _documentsActions.setShareUrlVisibilityAction)(false));
    },
    onLinkAccount: function onLinkAccount(slug) {
      return dispatch((0, _exportsActions.linkAccountAction)(slug));
    },
    onOrderBy: function onOrderBy(key) {
      return dispatch((0, _documentFiltersActions.orderByAction)(key));
    },
    onMapVendorRules: function onMapVendorRules(accountId, documents) {
      return dispatch((0, _documentsActions.mapVendorRulesAction)(accountId, documents));
    },
    onMergeDocuments: function onMergeDocuments() {
      return dispatch((0, _documentsActions.mergeDocumentsAction)());
    },
    onNextPage: function onNextPage() {
      return dispatch((0, _documentsActions.nextPageAction)());
    },
    onPreviousPage: function onPreviousPage() {
      return dispatch((0, _documentsActions.previousPageAction)());
    },
    onDocumentViewed: function onDocumentViewed(data) {
      return dispatch((0, _documentsActions.documentViewedAction)(data));
    },
    onRemoveCardNumber: function onRemoveCardNumber(card) {
      return dispatch((0, _documentFiltersActions.removeCardNumberFromFilterAction)(card));
    },
    onRemoveCategory: function onRemoveCategory(name) {
      return dispatch((0, _documentFiltersActions.removeCategoryFromFilterAction)(name));
    },
    onRemoveCurrency: function onRemoveCurrency(data) {
      return dispatch((0, _documentFiltersActions.removeCurrencyFromFilterAction)(data));
    },
    onRemoveDocumentType: function onRemoveDocumentType() {
      return dispatch((0, _documentFiltersActions.removeDocumentTypeFromFilterAction)());
    },
    onRemoveEnvelope: function onRemoveEnvelope(name) {
      return dispatch((0, _documentFiltersActions.removeEnvelopeFromFilterAction)(name));
    },
    onRemoveIncludeRule: function onRemoveIncludeRule(data) {
      return dispatch((0, _exportsActions.removeIncludeRuleAction)(data));
    },
    onRemoveSearchQuery: function onRemoveSearchQuery() {
      return dispatch((0, _documentFiltersActions.removeSearchQueryFromFilterAction)());
    },
    onRemoveNameFromFilter: function onRemoveNameFromFilter() {
      return dispatch((0, _documentFiltersActions.removeNameFromFilterAction)());
    },
    onRemovePaymentType: function onRemovePaymentType(name) {
      return dispatch((0, _documentFiltersActions.removePaymentTypeFromFilterAction)(name.toLowerCase()));
    },
    onRemoveVendor: function onRemoveVendor(name) {
      return dispatch((0, _documentFiltersActions.removeVendorFromFilterAction)(name));
    },
    onRemoveViewedStatus: function onRemoveViewedStatus() {
      return dispatch((0, _documentFiltersActions.removeViewedStatusFromFilterAction)());
    },
    onRestoreDocuments: function onRestoreDocuments() {
      return dispatch((0, _documentsActions.restoreDocumentsAction)());
    },
    onReturnToDefaultColumns: function onReturnToDefaultColumns() {
      return dispatch((0, _documentsActions.returnToDefaultColumnsAction)());
    },
    onRowsDeselected: function onRowsDeselected(ids) {
      return dispatch((0, _documentsActions.deselectDocumentsAction)(ids));
    },
    onRowsSelected: function onRowsSelected(ids) {
      return dispatch((0, _documentsActions.selectDocumentsAction)(ids));
    },
    onReprocessDocument: function onReprocessDocument(accountId) {
      return dispatch((0, _updateDocumentActions.reprocessDocumentAction)(accountId));
    },
    onSaveDocument: function onSaveDocument() {
      return dispatch((0, _updateDocumentActions.saveDocumentAction)());
    },
    onSelectAllDocuments: function onSelectAllDocuments(accountId, filters) {
      return dispatch((0, _documentsActions.selectAllDocumentsAction)(accountId, filters));
    },
    onSelectMergeField: function onSelectMergeField(field, data, id) {
      return dispatch((0, _documentsActions.selectMergeFieldAction)(field, data, id));
    },
    onSetFlashMessage: function onSetFlashMessage(message) {
      return dispatch((0, _appActions.setFlashMessageAction)(message));
    },
    onSetGlCode: function onSetGlCode(document, glCode) {
      return dispatch((0, _exportsActions.setGlCodeAction)(document, glCode));
    },
    onSetGridWidth: function onSetGridWidth(width) {
      return dispatch((0, _documentsActions.setGridWidthAction)(width));
    },
    onSetViewedDocumentUrl: function onSetViewedDocumentUrl(url) {
      return dispatch((0, _exportsActions.setViewedDocumentUrlAction)(url));
    },
    onShiftPressed: function onShiftPressed(e) {
      return dispatch((0, _documentsActions.shiftPressedAction)(e));
    },
    onShiftReleased: function onShiftReleased(e) {
      return dispatch((0, _documentsActions.shiftReleasedAction)(e));
    },
    onShowDocumentViewer: function onShowDocumentViewer() {
      return dispatch((0, _documentsActions.setDocumentViewerVisibilityAction)(true));
    },
    onShowGLCodesPanel: function onShowGLCodesPanel() {
      return dispatch((0, _documentsActions.showGLCodesPanelAction)());
    },
    onStartBatchDownloadMode: function onStartBatchDownloadMode() {
      return dispatch((0, _documentsActions.startBatchDownloadModeAction)());
    },
    onStartExportMode: function onStartExportMode() {
      return dispatch((0, _documentsActions.startExportModeAction)());
    },
    onStartFiltersDrawerMode: function onStartFiltersDrawerMode() {
      return dispatch((0, _documentsActions.startFiltersDrawerModeAction)());
    },
    onUpdateSearchQuery: function onUpdateSearchQuery(query) {
      return dispatch((0, _documentFiltersActions.updateSearchQueryAction)(query));
    },
    onFocusDocument: function onFocusDocument(row, style) {
      return dispatch((0, _updateDocumentActions.focusDocumentAction)(row, style));
    },
    onSetExportType: function onSetExportType(data) {
      return dispatch((0, _documentFiltersActions.setExportTypeFilterAction)(data.key));
    },
    onSetPaginationLimit: function onSetPaginationLimit(limit) {
      return dispatch((0, _documentsActions.setPaginationLimitAction)(limit));
    },
    onShowChangeDocType: function onShowChangeDocType() {
      return dispatch((0, _documentsActions.setChangeDocumentTypeVisibilityAction)(true));
    },
    onShowDeletePermanently: function onShowDeletePermanently() {
      return dispatch((0, _documentsActions.setDeletePermanentlyVisibilityAction)(true));
    },
    onShowEditColumns: function onShowEditColumns() {
      return dispatch((0, _documentsActions.setEditColumnsVisibilityAction)(true));
    },
    onShowTrash: function onShowTrash() {
      return dispatch((0, _documentFiltersActions.setTrashViewAction)(true));
    },
    onShowTrashMultipleDocuments: function onShowTrashMultipleDocuments() {
      return dispatch((0, _documentsActions.setTrashMultipleDocumentsVisibilityAction)(true));
    },
    onShowTrashDocument: function onShowTrashDocument() {
      return dispatch((0, _documentsActions.setTrashDocumentVisibilityAction)(true));
    },
    onShowShareUrl: function onShowShareUrl() {
      return dispatch((0, _documentsActions.setShareUrlVisibilityAction)(true));
    },
    onStartBatchEditMode: function onStartBatchEditMode() {
      return dispatch((0, _documentsActions.startBatchEditModeAction)());
    },
    onStartBatchCategoriesMode: function onStartBatchCategoriesMode() {
      return dispatch((0, _documentsActions.startBatchCategoriesModeAction)());
    },
    onStartDocViewerHamburgerMode: function onStartDocViewerHamburgerMode() {
      return dispatch((0, _documentsActions.startDocViewerHamburgerModeAction)());
    },
    onStartHamburgerMode: function onStartHamburgerMode() {
      return dispatch((0, _documentsActions.startHamburgerModeAction)());
    },
    onStartDeleteCustomTabMode: function onStartDeleteCustomTabMode(id) {
      return dispatch((0, _customTabsActions.startDeleteCustomTabModeAction)(id));
    },
    onStartDraggableMode: function onStartDraggableMode() {
      return dispatch((0, _documentsActions.startDraggabilityAction)());
    },
    onStartMergeDocumentsMode: function onStartMergeDocumentsMode(documents, mergeDocumentId) {
      return dispatch((0, _documentsActions.startMergeDocumentsModeAction)(documents, mergeDocumentId));
    },
    onStartRefreshIntervals: function onStartRefreshIntervals() {
      return dispatch((0, _documentsActions.startRefreshIntervalsAction)());
    },
    onSubmitBatchAssignCategories: function onSubmitBatchAssignCategories() {
      return dispatch((0, _documentsActions.submitBatchAssignCategoriesAction)());
    },
    onSubmitBatchDownloadDocuments: function onSubmitBatchDownloadDocuments() {
      return dispatch((0, _documentsActions.submitBatchDownloadDocumentsAction)());
    },
    onSubmitBatchEdit: function onSubmitBatchEdit() {
      return dispatch((0, _documentsActions.submitBatchEditAction)());
    },
    onToggleColumn: function onToggleColumn(key) {
      return dispatch((0, _documentsActions.toggleColumnAction)(key));
    },
    onTrashMultipleDocuments: function onTrashMultipleDocuments() {
      return dispatch((0, _documentsActions.trashMultipleDocumentsAction)());
    },
    onTrashDocument: function onTrashDocument(accountId, document) {
      return dispatch((0, _updateDocumentActions.trashDocumentAction)(accountId, document));
    },
    onUnfocusDocument: function onUnfocusDocument() {
      return dispatch((0, _updateDocumentActions.unfocusDocumentAction)());
    },
    onSelectMergeDocument: function onSelectMergeDocument(id) {
      return dispatch((0, _documentsActions.selectMergeDocumentAction)(id));
    },
    onDeselectMergeDocument: function onDeselectMergeDocument() {
      return dispatch((0, _documentsActions.deselectMergeDocumentAction)());
    },
    onUpdateDocument: function onUpdateDocument(field, value) {
      return dispatch((0, _updateDocumentActions.updateDocumentAction)(field, value));
    },
    onUpdateInlineDocument: function onUpdateInlineDocument(data) {
      return dispatch((0, _updateDocumentActions.updateInlineDocumentAction)(data));
    },
    onUpdateName: function onUpdateName(name) {
      return dispatch((0, _documentFiltersActions.updateNameAction)(name));
    },
    onUpdatePaymentType: function onUpdatePaymentType(field, value) {
      return dispatch((0, _updateDocumentActions.updatePaymentTypeAction)(field, value));
    },
    onUpdateTotalFilter: function onUpdateTotalFilter(type, value) {
      return dispatch((0, _documentFiltersActions.updateTotalFilterAction)(type, value));
    },
    splitCategories: function splitCategories(categories) {
      return dispatch((0, _exportsActions.splitCategoriesAction)(categories));
    }
  };
};

var DocumentsContainer = exports.DocumentsContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DocumentsPage);

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IssueTrackingFormContainer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _embed = __webpack_require__(818);

var typeformEmbed = _interopRequireWildcard(_embed);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */


var IssueTrackingFormContainer = exports.IssueTrackingFormContainer = function (_React$Component) {
  _inherits(IssueTrackingFormContainer, _React$Component);

  function IssueTrackingFormContainer(props) {
    _classCallCheck(this, IssueTrackingFormContainer);

    var _this = _possibleConstructorReturn(this, (IssueTrackingFormContainer.__proto__ || Object.getPrototypeOf(IssueTrackingFormContainer)).call(this, props));

    _this.el = null;
    return _this;
  }

  _createClass(IssueTrackingFormContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.el) {
        typeformEmbed.makeWidget(this.el, "https://alexwilliams261692.typeform.com/to/Agg0D2", {
          hideFooter: true,
          hideHeaders: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement("div", { ref: function ref(el) {
          return _this2.el = el;
        }, style: { width: "80%", height: "80vh", margin: "0 auto" } });
    }
  }]);

  return IssueTrackingFormContainer;
}(_react2.default.Component);

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ManageCategoriesContainer = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _manageCategories = __webpack_require__(893);

var _categoriesActions = __webpack_require__(194);

var _trackingActions = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ManageCategoriesPage = function ManageCategoriesPage(props) {
  props.trackPage();
  return _react2.default.createElement(_manageCategories.ManageCategories, props);
};

ManageCategoriesPage.propTypes = {
  trackPage: _propTypes2.default.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    accountId: state.app.selectedAccount.id,
    categories: state.categories.categories,
    focusedCategory: state.categories.focusedCategory,
    isAddCategoryVisible: state.categories.isAddCategoryVisible,
    isDeleteCategoriesLoading: state.categories.isDeleteCategoriesLoading,
    isDeleteCategoriesVisible: state.categories.isDeleteCategoriesVisible,
    isSaveCategoryLoading: state.categories.isSaveCategoryLoading,
    newCategory: state.categories.newCategory,
    newIncludeRules: state.categories.newIncludeRules,
    orderBy: state.categories.orderBy,
    orderDirection: state.categories.orderDirection,
    selectedCategoryIds: state.categories.selectedCategoryIds,
    slug: state.app.selectedAccount.slug,
    vendors: state.vendors.vendors
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    trackPage: function trackPage() {
      return dispatch((0, _trackingActions.trackPageAction)("Manage categories page"));
    },
    onCreateCategory: function onCreateCategory(accountId, category) {
      return dispatch((0, _categoriesActions.createCategoryAction)(accountId, category));
    },
    onDeleteCategories: function onDeleteCategories() {
      return dispatch((0, _categoriesActions.deleteCategoriesAction)());
    },
    onFocusCategory: function onFocusCategory(category, style) {
      return dispatch((0, _categoriesActions.focusCategoryAction)(category, style));
    },
    onHideAddCategory: function onHideAddCategory() {
      return dispatch((0, _categoriesActions.setAddCategoryVisibilityAction)(false));
    },
    onHideDeleteCategories: function onHideDeleteCategories() {
      return dispatch((0, _categoriesActions.setDeleteCategoriesVisibilityAction)(false));
    },
    onOrderBy: function onOrderBy(column) {
      return dispatch((0, _categoriesActions.orderCategoriesAction)(column));
    },
    onSaveCategory: function onSaveCategory(data) {
      return dispatch((0, _categoriesActions.saveCategoryChangesAction)(data));
    },
    onShowAddCategory: function onShowAddCategory() {
      return dispatch((0, _categoriesActions.setAddCategoryVisibilityAction)(true));
    },
    onShowDeleteCategories: function onShowDeleteCategories() {
      return dispatch((0, _categoriesActions.setDeleteCategoriesVisibilityAction)(true));
    },
    onUnfocusCategory: function onUnfocusCategory() {
      return dispatch((0, _categoriesActions.unfocusCategoryAction)());
    },
    onUpdateNewCategoryName: function onUpdateNewCategoryName(name) {
      return dispatch((0, _categoriesActions.updateNewCategoryNameAction)(name));
    },
    onUpdateCategoryName: function onUpdateCategoryName(name) {
      return dispatch((0, _categoriesActions.updateCategoryNameAction)(name));
    },
    onUpdateIncludeVendors: function onUpdateIncludeVendors(vendor) {
      return dispatch((0, _categoriesActions.updateIncludeVendorsAction)(vendor));
    },
    onRemoveDropdownRule: function onRemoveDropdownRule(rule, isNew) {
      return dispatch((0, _categoriesActions.removeDropdownRuleAction)(rule, isNew));
    },
    onRemoveIncludeRule: function onRemoveIncludeRule(accountId, categoryId, ruleId) {
      dispatch((0, _categoriesActions.removeIncludeRuleAction)(accountId, categoryId, ruleId));
    },
    onRowsDeselected: function onRowsDeselected(ids) {
      return dispatch((0, _categoriesActions.deselectCategoriesAction)(ids));
    },
    onRowsSelected: function onRowsSelected(ids) {
      return dispatch((0, _categoriesActions.selectCategoriesAction)(ids));
    }
  };
};

var ManageCategoriesContainer = exports.ManageCategoriesContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ManageCategoriesPage);

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ManageVendorsContainer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _manageVendors = __webpack_require__(898);

var _vendorsActions = __webpack_require__(412);

var _trackingActions = __webpack_require__(26);

var _loading = __webpack_require__(38);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ManageVendorsPage = function (_React$Component) {
  _inherits(ManageVendorsPage, _React$Component);

  function ManageVendorsPage() {
    _classCallCheck(this, ManageVendorsPage);

    return _possibleConstructorReturn(this, (ManageVendorsPage.__proto__ || Object.getPrototypeOf(ManageVendorsPage)).apply(this, arguments));
  }

  _createClass(ManageVendorsPage, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.props.init();
      this.props.trackPage();
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.isLoading) {
        return _react2.default.createElement(_loading.Loading, null);
      }
      return _react2.default.createElement(_manageVendors.ManageVendors, this.props);
    }
  }]);

  return ManageVendorsPage;
}(_react2.default.Component);

ManageVendorsPage.propTypes = {
  init: _propTypes2.default.func.isRequired,
  isLoading: _propTypes2.default.bool.isRequired,
  trackPage: _propTypes2.default.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    accountId: state.app.selectedAccount.id,
    categories: state.categories.categories,
    isAddVendorRulesLoading: state.vendors.isAddVendorRulesLoading,
    isAddVendorRulesMode: state.vendors.isAddVendorRulesMode,
    isLoading: state.vendors.isLoading,
    isMergeVendorsLoading: state.vendors.isMergeVendorsLoading,
    isMergeVendorsMode: state.vendors.isMergeVendorsMode,
    orderBy: state.vendors.orderBy,
    orderDirection: state.vendors.orderDirection,
    selectedCategory: state.vendors.selectedCategory,
    selectedVendorIds: state.vendors.selectedVendorIds,
    selectedVendor: state.vendors.selectedVendor,
    slug: state.app.selectedAccount.slug,
    vendors: state.vendors.vendors
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    init: function init() {
      return dispatch((0, _vendorsActions.fetchVendorsAction)());
    },
    trackPage: function trackPage() {
      return dispatch((0, _trackingActions.trackPageAction)("Manage Vendors page"));
    },
    onAddVendorRules: function onAddVendorRules() {
      return dispatch((0, _vendorsActions.addVendorRulesAction)());
    },
    onDeleteIncludeRule: function onDeleteIncludeRule(accountId, category, vendor) {
      return dispatch((0, _vendorsActions.deleteIncludeRuleAction)(accountId, category, vendor));
    },
    onDeselectVendors: function onDeselectVendors(ids) {
      return dispatch((0, _vendorsActions.deselectVendorsAction)(ids));
    },
    onEndAddVendorRulesMode: function onEndAddVendorRulesMode() {
      return dispatch((0, _vendorsActions.endAddVendorRulesModeAction)());
    },
    onEndMergeVendorsMode: function onEndMergeVendorsMode() {
      return dispatch((0, _vendorsActions.endMergeVendorsModeAction)());
    },
    onMergeVendors: function onMergeVendors(accountId, vendor, vendors) {
      return dispatch((0, _vendorsActions.mergeVendorsAction)(accountId, vendor, vendors));
    },
    onOrderBy: function onOrderBy(column) {
      return dispatch((0, _vendorsActions.orderVendorsAction)(column));
    },
    onSelectCategory: function onSelectCategory(category) {
      return dispatch((0, _vendorsActions.selectCategoryForRuleAction)(category));
    },
    onSelectMergeVendor: function onSelectMergeVendor(vendor) {
      return dispatch((0, _vendorsActions.selectMergeVendorAction)(vendor));
    },
    onSelectVendors: function onSelectVendors(ids) {
      return dispatch((0, _vendorsActions.selectVendorsAction)(ids));
    },
    onStartAddVendorRulesMode: function onStartAddVendorRulesMode() {
      return dispatch((0, _vendorsActions.startAddVendorRulesModeAction)());
    },
    onStartMergeVendorsMode: function onStartMergeVendorsMode() {
      return dispatch((0, _vendorsActions.startMergeVendorsModeAction)());
    }
  };
};

var ManageVendorsContainer = exports.ManageVendorsContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ManageVendorsPage);

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MyDocumentsContainer = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _deleteCustomTabModal = __webpack_require__(872);

var _customTabsActions = __webpack_require__(160);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MyDocumentsPage = function MyDocumentsPage(props) {
  return _react2.default.createElement(
    "div",
    null,
    props.children,
    _react2.default.createElement(_deleteCustomTabModal.DeleteCustomTabModal, props)
  );
};

MyDocumentsPage.propTypes = {
  children: _propTypes2.default.element.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    customTabRemoveId: state.customTabs.customTabRemoveId,
    isDeleteCustomTabLoading: state.customTabs.isDeleteCustomTabLoading,
    isDeleteCustomTabMode: state.customTabs.isDeleteCustomTabMode
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onDeleteCustomTab: function onDeleteCustomTab(id) {
      return dispatch((0, _customTabsActions.deleteCustomTabAction)(id));
    },
    onEndDeleteCustomTabMode: function onEndDeleteCustomTabMode() {
      return dispatch((0, _customTabsActions.endDeleteCustomTabModeAction)());
    }
  };
};

var MyDocumentsContainer = exports.MyDocumentsContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MyDocumentsPage);

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OauthContainer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _oauth = __webpack_require__(441);

var _reactRedux = __webpack_require__(11);

var _oauthActions = __webpack_require__(162);

var _loading = __webpack_require__(38);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OauthPage = function (_React$Component) {
  _inherits(OauthPage, _React$Component);

  function OauthPage() {
    _classCallCheck(this, OauthPage);

    return _possibleConstructorReturn(this, (OauthPage.__proto__ || Object.getPrototypeOf(OauthPage)).apply(this, arguments));
  }

  _createClass(OauthPage, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var hash = _ramda2.default.path(["location", "hash"], this.props);
      var data = (0, _oauth.parseOauthCallback)(hash);
      this.props.onNewOauthToken(data);
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(_loading.Loading, null);
    }
  }]);

  return OauthPage;
}(_react2.default.Component);

OauthPage.propTypes = {
  onNewOauthToken: _propTypes2.default.func.isRequired // ({ token: string, state: string }) => void
};

var matchStateToProps = function matchStateToProps() {
  return {};
};

var matchDispatchToProps = function matchDispatchToProps(dispatch) {
  return {
    onNewOauthToken: function onNewOauthToken(data) {
      dispatch((0, _oauthActions.newOauthTokenAction)(data));
    }
  };
};

var OauthContainer = exports.OauthContainer = (0, _reactRedux.connect)(matchStateToProps, matchDispatchToProps)(OauthPage);

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageNotFoundContainer = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pageNotFound = __webpack_require__(901);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PageNotFoundContainer = exports.PageNotFoundContainer = function PageNotFoundContainer() {
  return _react2.default.createElement(_pageNotFound.PageNotFound, null);
};

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PendingDocumentsContainer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _pendingDocuments = __webpack_require__(944);

var _pendingDocumentsActions = __webpack_require__(195);

var _categoriesActions = __webpack_require__(194);

var _trackingActions = __webpack_require__(26);

var _customPropTypes = __webpack_require__(5);

var _loading = __webpack_require__(38);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PendingDocumentsPage = function (_React$Component) {
  _inherits(PendingDocumentsPage, _React$Component);

  function PendingDocumentsPage() {
    _classCallCheck(this, PendingDocumentsPage);

    return _possibleConstructorReturn(this, (PendingDocumentsPage.__proto__ || Object.getPrototypeOf(PendingDocumentsPage)).apply(this, arguments));
  }

  _createClass(PendingDocumentsPage, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (this.props.pendingDocuments.length === 0) {
        this.props.init(this.props.accountId);
      }
      this.props.trackPage();
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.isLoading) {
        return _react2.default.createElement(_loading.Loading, null);
      }
      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(_pendingDocuments.PendingDocuments, this.props)
      );
    }
  }]);

  return PendingDocumentsPage;
}(_react2.default.Component);

PendingDocumentsPage.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  init: _propTypes2.default.func.isRequired,
  isLoading: _propTypes2.default.bool.isRequired,
  pendingDocuments: _propTypes2.default.arrayOf(_customPropTypes.documentPropType),
  trackPage: _propTypes2.default.func.isRequired
};

PendingDocumentsPage.defaultProps = {
  pendingDocuments: []
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    accountId: state.app.selectedAccount.id,
    accountSlug: state.app.selectedAccount.slug,
    categories: state.categories.categories,
    currencies: state.currencies.currencies,
    documentType: state.pendingDocuments.documentType,
    focusedDocument: state.pendingDocuments.focusedDocument,
    isBeingCancelled: state.pendingDocuments.isBeingCancelled,
    isCancelProcessingLoading: state.pendingDocuments.isCancelProcessingLoading,
    isCancelProcessingVisible: state.pendingDocuments.isCancelProcessingVisible,
    isFiltersMode: state.pendingDocuments.isFiltersMode,
    isLoading: state.pendingDocuments.isLoading,
    isTrashDocumentVisible: state.pendingDocuments.isTrashDocumentVisible,
    pendingDocuments: state.pendingDocuments.pendingDocuments,
    preferredCurrency: state.app.selectedAccount.preferredCurrency,
    sourceFilter: state.pendingDocuments.sourceFilter,
    statusFilter: state.pendingDocuments.statusFilter,
    taxRate: state.accountSettings.vat,
    vendors: state.vendors.vendors
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    init: function init(accountId) {
      return dispatch((0, _pendingDocumentsActions.fetchPendingDocumentsAction)(accountId));
    },
    trackPage: function trackPage() {
      return dispatch((0, _trackingActions.trackPageAction)("Awaiting processing page"));
    },
    onAddSourceFilter: function onAddSourceFilter(filter) {
      return dispatch((0, _pendingDocumentsActions.addSourceFilterAction)(filter));
    },
    onAddStuckStatusFilter: function onAddStuckStatusFilter(filter) {
      return dispatch((0, _pendingDocumentsActions.addStuckStatusFilterAction)(filter));
    },
    onCancelProcessing: function onCancelProcessing(document) {
      return dispatch((0, _pendingDocumentsActions.cancelProcessingAction)(document));
    },
    onCancelProcessingAllDocuments: function onCancelProcessingAllDocuments(pendingDocuments) {
      return dispatch((0, _pendingDocumentsActions.cancelProcessingAllDocumentsAction)(pendingDocuments));
    },
    onChangeDocumentType: function onChangeDocumentType(type) {
      return dispatch((0, _pendingDocumentsActions.changeDocumentTypeAction)(type));
    },
    onCreateCategory: function onCreateCategory(accountId, category) {
      return dispatch((0, _categoriesActions.createCategoryAction)(accountId, category));
    },
    onEndFiltersMode: function onEndFiltersMode() {
      return dispatch((0, _pendingDocumentsActions.endFiltersModeAction)());
    },
    onFocusDocument: function onFocusDocument(document) {
      return dispatch((0, _pendingDocumentsActions.focusPendingDocumentAction)(document));
    },
    onHideTrashDocument: function onHideTrashDocument() {
      return dispatch((0, _pendingDocumentsActions.setTrashDocumentVisibilityAction)(false));
    },
    onProcessAllDocuments: function onProcessAllDocuments(pendingDocuments) {
      return dispatch((0, _pendingDocumentsActions.processAllDocumentsAction)(pendingDocuments));
    },
    onRemoveSourceFilter: function onRemoveSourceFilter(accountId) {
      return dispatch((0, _pendingDocumentsActions.removeSourceFilterAction)(accountId));
    },
    onRemoveStuckStatusFilter: function onRemoveStuckStatusFilter(accountId) {
      return dispatch((0, _pendingDocumentsActions.removeStuckStatusFilterAction)(accountId));
    },
    onReprocessPendingDocument: function onReprocessPendingDocument(document) {
      return dispatch((0, _pendingDocumentsActions.reprocessPendingDocumentAction)(document));
    },
    onSavePendingOtherDocument: function onSavePendingOtherDocument() {
      return dispatch((0, _pendingDocumentsActions.savePendingOtherDocumentAction)());
    },
    onSavePendingDocument: function onSavePendingDocument() {
      return dispatch((0, _pendingDocumentsActions.savePendingDocumentAction)());
    },
    onShowTrashDocument: function onShowTrashDocument() {
      return dispatch((0, _pendingDocumentsActions.setTrashDocumentVisibilityAction)(true));
    },
    onStartFiltersMode: function onStartFiltersMode() {
      return dispatch((0, _pendingDocumentsActions.startFiltersModeAction)());
    },
    onTrashPendingDocument: function onTrashPendingDocument(accountId, document) {
      return dispatch((0, _pendingDocumentsActions.trashPendingDocumentAction)(accountId, document));
    }
  };
};

var PendingDocumentsContainer = exports.PendingDocumentsContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PendingDocumentsPage);

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReportsContainer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _reports = __webpack_require__(905);

var _reportsActions = __webpack_require__(410);

var _trackingActions = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReportsPage = function (_React$Component) {
  _inherits(ReportsPage, _React$Component);

  function ReportsPage() {
    _classCallCheck(this, ReportsPage);

    return _possibleConstructorReturn(this, (ReportsPage.__proto__ || Object.getPrototypeOf(ReportsPage)).apply(this, arguments));
  }

  _createClass(ReportsPage, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.props.init(this.props.accountId);
      this.props.trackPage();
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(_reports.Reports, this.props)
      );
    }
  }]);

  return ReportsPage;
}(_react2.default.Component);

ReportsPage.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  init: _propTypes2.default.func.isRequired,
  trackPage: _propTypes2.default.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    accountId: state.app.selectedAccount.id,
    categories: state.categories.categories,
    currency: state.accountSettings.currency,
    newReport: state.reports.newReport,
    reports: state.reports.reports,
    vendors: state.vendors.vendors
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    init: function init(accountId) {
      return dispatch((0, _reportsActions.fetchReportsAction)(accountId));
    },
    trackPage: function trackPage() {
      return dispatch((0, _trackingActions.trackPageAction)("Reports page"));
    },
    onSubmitReport: function onSubmitReport(e) {
      return dispatch((0, _reportsActions.submitReportAction)(e));
    }
  };
};

var ReportsContainer = exports.ReportsContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ReportsPage);

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SetUpIntegrationContainer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _integrationSettings = __webpack_require__(519);

var _integrationSettings2 = _interopRequireDefault(_integrationSettings);

var _trackingActions = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SetUpIntegrationPage = function (_React$Component) {
  _inherits(SetUpIntegrationPage, _React$Component);

  function SetUpIntegrationPage() {
    _classCallCheck(this, SetUpIntegrationPage);

    return _possibleConstructorReturn(this, (SetUpIntegrationPage.__proto__ || Object.getPrototypeOf(SetUpIntegrationPage)).apply(this, arguments));
  }

  _createClass(SetUpIntegrationPage, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.props.trackPage();
    }
  }, {
    key: "render",
    value: function render() {
      var iframeParams = "&showHeader=false&reauthorise=true&parent=digit";
      return _react2.default.createElement(
        "div",
        { className: _integrationSettings2.default.container },
        _react2.default.createElement(
          "div",
          { className: _integrationSettings2.default["iframe-container"] },
          _react2.default.createElement("iframe", {
            className: _integrationSettings2.default.iframe,
            src: "https://integrations.squirrelstreet.com/AccountingIntegration?" + "accountid=" + this.props.accountId + iframeParams
          })
        )
      );
    }
  }]);

  return SetUpIntegrationPage;
}(_react2.default.Component);

SetUpIntegrationPage.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  trackPage: _propTypes2.default.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    accountId: state.app.selectedAccount.id,
    accountSlug: state.app.selectedAccount.slug,
    categories: state.categories.categories
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    trackPage: function trackPage() {
      return dispatch((0, _trackingActions.trackPageAction)("Set up integration page"));
    }
  };
};

var SetUpIntegrationContainer = exports.SetUpIntegrationContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SetUpIntegrationPage);

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountNameAndEmailContainer = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _accountNameAndEmailSettings = __webpack_require__(907);

var _accountSettingsActions = __webpack_require__(67);

var _loading = __webpack_require__(38);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AccountNameAndEmailPage = function AccountNameAndEmailPage(props) {
  if (props.isLoading) {
    return _react2.default.createElement(_loading.Loading, null);
  }
  return _react2.default.createElement(_accountNameAndEmailSettings.AccountNameAndEmailSettings, props);
};

AccountNameAndEmailPage.propTypes = {
  isLoading: _propTypes2.default.bool.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    accountId: state.app.selectedAccount.id,
    emailPin: state.accountSettings.emailPin,
    isLoading: state.accountSettings.isLoading,
    label: state.accountSettings.label,
    slug: state.accountSettings.slug
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSaveNameAndEmail: function onSaveNameAndEmail() {
      return dispatch((0, _accountSettingsActions.saveAccountSettingsAction)());
    }
  };
};

var AccountNameAndEmailContainer = exports.AccountNameAndEmailContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AccountNameAndEmailPage);

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountSettingsContainer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _accountSettingsActions = __webpack_require__(67);

var _settingsInlineTabs = __webpack_require__(271);

var _grid = __webpack_require__(95);

var _grid2 = _interopRequireDefault(_grid);

var _settings = __webpack_require__(521);

var _settings2 = _interopRequireDefault(_settings);

var _accountSettingsMenu = __webpack_require__(908);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AccountSettings = function (_React$Component) {
  _inherits(AccountSettings, _React$Component);

  function AccountSettings() {
    _classCallCheck(this, AccountSettings);

    return _possibleConstructorReturn(this, (AccountSettings.__proto__ || Object.getPrototypeOf(AccountSettings)).apply(this, arguments));
  }

  _createClass(AccountSettings, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.props.init(this.props.accountId);
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: _settings2.default.container },
        _react2.default.createElement(_settingsInlineTabs.SettingsInlineTabs, { currentPage: "account", slug: this.props.slug }),
        _react2.default.createElement(
          "div",
          { className: _grid2.default.row },
          _react2.default.createElement("div", { className: _settings2.default["grid-spacing"] + " " + _grid2.default["col-md-1"] }),
          _react2.default.createElement(
            "div",
            { className: _settings2.default["grid-spacing"] + " " + _grid2.default["col-md-2"] },
            _react2.default.createElement(_accountSettingsMenu.AccountSettingsMenu, { slug: this.props.slug, vip: this.props.vip })
          ),
          _react2.default.createElement(
            "div",
            { className: _settings2.default["grid-spacing"] + " " + _grid2.default["col-md-8"] },
            _react2.default.createElement(
              "div",
              { className: _settings2.default["child-container"] },
              this.props.children
            )
          ),
          _react2.default.createElement("div", { className: _settings2.default["grid-spacing"] + " " + _grid2.default["col-md-1"] })
        )
      );
    }
  }]);

  return AccountSettings;
}(_react2.default.Component);

AccountSettings.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  children: _propTypes2.default.element.isRequired,
  init: _propTypes2.default.func.isRequired,
  slug: _propTypes2.default.string.isRequired,
  vip: _propTypes2.default.bool.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    accountId: state.app.selectedAccount.id,
    slug: state.accountSettings.slug,
    vip: state.accountSettings.vip
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    init: function init(accountId) {
      return dispatch((0, _accountSettingsActions.fetchAccountDetailsAction)(accountId));
    }
  };
};

var AccountSettingsContainer = exports.AccountSettingsContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AccountSettings);

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountUsageContainer = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _accountUsage = __webpack_require__(909);

var _loading = __webpack_require__(38);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AccountUsagePage = function AccountUsagePage(props) {
  if (props.isLoading) {
    return _react2.default.createElement(_loading.Loading, null);
  }
  return _react2.default.createElement(_accountUsage.AccountUsage, props);
};

AccountUsagePage.propTypes = {
  isLoading: _propTypes2.default.bool.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    isLoading: state.accountSettings.isLoading,
    planDetails: state.accountSettings.planDetails
  };
};

var AccountUsageContainer = exports.AccountUsageContainer = (0, _reactRedux.connect)(mapStateToProps)(AccountUsagePage);

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountUsersContainer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(32);

var _reactRedux = __webpack_require__(11);

var _accountUsers = __webpack_require__(910);

var _accountSettingsActions = __webpack_require__(67);

var _loading = __webpack_require__(38);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AccountUsersPage = function (_React$Component) {
  _inherits(AccountUsersPage, _React$Component);

  function AccountUsersPage() {
    _classCallCheck(this, AccountUsersPage);

    return _possibleConstructorReturn(this, (AccountUsersPage.__proto__ || Object.getPrototypeOf(AccountUsersPage)).apply(this, arguments));
  }

  _createClass(AccountUsersPage, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.props.init(this.props.accountId);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.isAccountUsersLoading) {
        return _react2.default.createElement(_loading.Loading, null);
      }
      if (this.props.vip) {
        return _reactRouter.browserHistory.push("/");
      }
      return _react2.default.createElement(_accountUsers.AccountUsers, this.props);
    }
  }]);

  return AccountUsersPage;
}(_react2.default.Component);

AccountUsersPage.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  init: _propTypes2.default.func.isRequired,
  isAccountUsersLoading: _propTypes2.default.bool.isRequired,
  vip: _propTypes2.default.bool.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    accountId: state.app.selectedAccount.id,
    currentUserId: state.app.user.id,
    isAccountUsersLoading: state.accountSettings.isAccountUsersLoading,
    isInviteUserVisible: state.accountSettings.isInviteUserVisible,
    isRemoveSelfVisible: state.accountSettings.isRemoveSelfVisible,
    users: state.accountSettings.users,
    vip: state.accountSettings.vip
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    init: function init(accountId) {
      return dispatch((0, _accountSettingsActions.fetchAccountUsersAction)(accountId));
    },
    onCreateUser: function onCreateUser() {
      return dispatch((0, _accountSettingsActions.createUserAction)());
    },
    onHideInviteUser: function onHideInviteUser() {
      return dispatch((0, _accountSettingsActions.setInviteUserVisibilityAction)(false));
    },
    onHideRemoveSelf: function onHideRemoveSelf() {
      return dispatch((0, _accountSettingsActions.setRemoveSelfVisibilityAction)(false));
    },
    onRemoveUser: function onRemoveUser(accountId, user) {
      return dispatch((0, _accountSettingsActions.removeUserAction)(accountId, user));
    },
    onShowInviteUser: function onShowInviteUser() {
      return dispatch((0, _accountSettingsActions.setInviteUserVisibilityAction)(true));
    },
    onShowRemoveSelf: function onShowRemoveSelf() {
      return dispatch((0, _accountSettingsActions.setRemoveSelfVisibilityAction)(true));
    }
  };
};

var AccountUsersContainer = exports.AccountUsersContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AccountUsersPage);

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BetaSettingsContainer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _userSettingsActions = __webpack_require__(137);

var _loading = __webpack_require__(38);

var _betaSetting = __webpack_require__(911);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BetaSettingsPage = function (_React$Component) {
  _inherits(BetaSettingsPage, _React$Component);

  function BetaSettingsPage() {
    _classCallCheck(this, BetaSettingsPage);

    return _possibleConstructorReturn(this, (BetaSettingsPage.__proto__ || Object.getPrototypeOf(BetaSettingsPage)).apply(this, arguments));
  }

  _createClass(BetaSettingsPage, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.props.init();
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.isLoading) {
        return _react2.default.createElement(_loading.Loading, null);
      }
      return _react2.default.createElement(_betaSetting.BetaSetting, this.props);
    }
  }]);

  return BetaSettingsPage;
}(_react2.default.Component);

BetaSettingsPage.propTypes = {
  init: _propTypes2.default.func.isRequired,
  isLoading: _propTypes2.default.bool.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    accounts: state.app.accounts,
    favouriteAccountId: state.userSettings.favouriteAccountId,
    isBetaDefault: state.userSettings.isBetaDefault,
    isLoading: state.userSettings.isBetaDefaultLoading,
    isUpdateDefaultInterfaceLoading: state.userSettings.isUpdateDefaultInterfaceLoading
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    init: function init() {
      return dispatch((0, _userSettingsActions.fetchDefaultInterfaceAction)());
    },
    onUpdateDefaultInterface: function onUpdateDefaultInterface(isBetaDefault) {
      return dispatch((0, _userSettingsActions.updateDefaultInterfaceAction)(isBetaDefault));
    }
  };
};

var BetaSettingsContainer = exports.BetaSettingsContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BetaSettingsPage);

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingDetailsContainer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _reactRouter = __webpack_require__(32);

var _billingDetails = __webpack_require__(912);

var _loading = __webpack_require__(38);

var _accountSettingsActions = __webpack_require__(67);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BillingDetailsPage = function (_React$Component) {
  _inherits(BillingDetailsPage, _React$Component);

  function BillingDetailsPage() {
    _classCallCheck(this, BillingDetailsPage);

    return _possibleConstructorReturn(this, (BillingDetailsPage.__proto__ || Object.getPrototypeOf(BillingDetailsPage)).apply(this, arguments));
  }

  _createClass(BillingDetailsPage, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.props.init(this.props.accountId);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.isBillingDetailsLoading) {
        return _react2.default.createElement(_loading.Loading, null);
      }
      if (this.props.vip) {
        return _reactRouter.browserHistory.push("/");
      }
      return _react2.default.createElement(_billingDetails.BillingDetails, this.props);
    }
  }]);

  return BillingDetailsPage;
}(_react2.default.Component);

BillingDetailsPage.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  init: _propTypes2.default.func.isRequired,
  isBillingDetailsLoading: _propTypes2.default.bool.isRequired,
  vip: _propTypes2.default.bool.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    accountId: state.app.selectedAccount.id,
    billingDetails: state.accountSettings.billingDetails,
    isBillingDetailsLoading: state.accountSettings.isBillingDetailsLoading,
    isNoBillingDetails: state.accountSettings.isNoBillingDetails,
    slug: state.accountSettings.slug,
    vip: state.accountSettings.vip
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    init: function init(accountId) {
      return dispatch((0, _accountSettingsActions.fetchBillingDetailsAction)(accountId));
    },
    onRedirectToBilling: function onRedirectToBilling(accountId) {
      return dispatch((0, _accountSettingsActions.redirectToBillingAction)(accountId));
    },
    onSaveBillingDetails: function onSaveBillingDetails(accountId, billingDetails) {
      return dispatch((0, _accountSettingsActions.saveBillingDetailsAction)(accountId, billingDetails));
    },
    onUpdateBillingDetails: function onUpdateBillingDetails(field, payload) {
      return dispatch((0, _accountSettingsActions.updateBillingDetailsAction)(field, payload));
    }
  };
};

var BillingDetailsContainer = exports.BillingDetailsContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BillingDetailsPage);

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingHistoryContainer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(32);

var _reactRedux = __webpack_require__(11);

var _billingHistory = __webpack_require__(913);

var _accountSettingsActions = __webpack_require__(67);

var _loading = __webpack_require__(38);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BillingHistoryPage = function (_React$Component) {
  _inherits(BillingHistoryPage, _React$Component);

  function BillingHistoryPage() {
    _classCallCheck(this, BillingHistoryPage);

    return _possibleConstructorReturn(this, (BillingHistoryPage.__proto__ || Object.getPrototypeOf(BillingHistoryPage)).apply(this, arguments));
  }

  _createClass(BillingHistoryPage, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.props.init(this.props.accountId);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.isBillingHistoryLoading) {
        return _react2.default.createElement(_loading.Loading, null);
      }
      if (this.props.vip) {
        return _reactRouter.browserHistory.push("/");
      }
      return _react2.default.createElement(_billingHistory.BillingHistory, this.props);
    }
  }]);

  return BillingHistoryPage;
}(_react2.default.Component);

BillingHistoryPage.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  init: _propTypes2.default.func.isRequired,
  isBillingHistoryLoading: _propTypes2.default.bool.isRequired,
  vip: _propTypes2.default.bool.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    accountId: state.app.selectedAccount.id,
    displayInvoices: state.accountSettings.pagination.displayInvoices,
    invoices: state.accountSettings.invoices,
    isBillingHistoryLoading: state.accountSettings.isBillingHistoryLoading,
    pagination: state.accountSettings.pagination,
    vip: state.accountSettings.vip
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    init: function init(accountId) {
      return dispatch((0, _accountSettingsActions.fetchBillingHistoryAction)(accountId));
    },
    onNextPage: function onNextPage() {
      return dispatch((0, _accountSettingsActions.nextPageAction)());
    },
    onPreviousPage: function onPreviousPage() {
      return dispatch((0, _accountSettingsActions.previousPageAction)());
    },
    onChangeLimit: function onChangeLimit(limit) {
      return dispatch((0, _accountSettingsActions.setPaginationLimitAction)(limit));
    }
  };
};

var BillingHistoryContainer = exports.BillingHistoryContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BillingHistoryPage);

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CurrencyTaxLanguageContainer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _currencyTaxLanguageSettings = __webpack_require__(916);

var _accountSettingsActions = __webpack_require__(67);

var _loading = __webpack_require__(38);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CurrencyTaxLanguagePage = function (_React$Component) {
  _inherits(CurrencyTaxLanguagePage, _React$Component);

  function CurrencyTaxLanguagePage() {
    _classCallCheck(this, CurrencyTaxLanguagePage);

    return _possibleConstructorReturn(this, (CurrencyTaxLanguagePage.__proto__ || Object.getPrototypeOf(CurrencyTaxLanguagePage)).apply(this, arguments));
  }

  _createClass(CurrencyTaxLanguagePage, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.props.init(this.props.accountId);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.isLocalesLoading) {
        return _react2.default.createElement(_loading.Loading, null);
      }
      return _react2.default.createElement(_currencyTaxLanguageSettings.CurrencyTaxLanguageSettings, this.props);
    }
  }]);

  return CurrencyTaxLanguagePage;
}(_react2.default.Component);

CurrencyTaxLanguagePage.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  init: _propTypes2.default.func.isRequired,
  isLocalesLoading: _propTypes2.default.bool.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    accountId: state.app.selectedAccount.id,
    currency: state.accountSettings.currency,
    currencies: state.currencies.currencies,
    isLocalesLoading: state.accountSettings.isLocalesLoading,
    locale: state.accountSettings.locale,
    showUniversalCategorySet: state.accountSettings.showUniversalCategorySet,
    supportedLocales: state.accountSettings.supportedLocales,
    vat: state.accountSettings.vat
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    init: function init(accountId) {
      return dispatch((0, _accountSettingsActions.fetchLocalesAction)(accountId));
    },
    onSaveCurrencyLocaleTax: function onSaveCurrencyLocaleTax() {
      return dispatch((0, _accountSettingsActions.saveCurrencyLocaleTaxAction)());
    }
  };
};

var CurrencyTaxLanguageContainer = exports.CurrencyTaxLanguageContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CurrencyTaxLanguagePage);

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FavouriteAccountContainer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _userSettingsActions = __webpack_require__(137);

var _loading = __webpack_require__(38);

var _favouriteAccount = __webpack_require__(918);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FavouriteAccountPage = function (_React$Component) {
  _inherits(FavouriteAccountPage, _React$Component);

  function FavouriteAccountPage() {
    _classCallCheck(this, FavouriteAccountPage);

    return _possibleConstructorReturn(this, (FavouriteAccountPage.__proto__ || Object.getPrototypeOf(FavouriteAccountPage)).apply(this, arguments));
  }

  _createClass(FavouriteAccountPage, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.props.init();
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.isLoading) {
        return _react2.default.createElement(_loading.Loading, null);
      }
      return _react2.default.createElement(_favouriteAccount.FavouriteAccount, this.props);
    }
  }]);

  return FavouriteAccountPage;
}(_react2.default.Component);

FavouriteAccountPage.propTypes = {
  init: _propTypes2.default.func.isRequired,
  isLoading: _propTypes2.default.bool.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    accounts: state.app.accounts,
    favouriteAccountId: state.userSettings.favouriteAccountId,
    isLoading: state.userSettings.isFavouriteAccountLoading
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    init: function init() {
      return dispatch((0, _userSettingsActions.fetchFavouriteAccountAction)());
    },
    onUpdateFavouriteAccount: function onUpdateFavouriteAccount() {
      return dispatch((0, _userSettingsActions.updateFavouriteAccountAction)());
    }
  };
};

var FavouriteAccountContainer = exports.FavouriteAccountContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(FavouriteAccountPage);

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IntegrationSettingsContainer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _integrationSettings = __webpack_require__(519);

var _integrationSettings2 = _interopRequireDefault(_integrationSettings);

var _trackingActions = __webpack_require__(26);

var _settingsInlineTabs = __webpack_require__(271);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IntegrationsPage = function (_React$Component) {
  _inherits(IntegrationsPage, _React$Component);

  function IntegrationsPage() {
    _classCallCheck(this, IntegrationsPage);

    return _possibleConstructorReturn(this, (IntegrationsPage.__proto__ || Object.getPrototypeOf(IntegrationsPage)).apply(this, arguments));
  }

  _createClass(IntegrationsPage, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.props.init(this.props.accountId);
      this.props.trackPage();
    }
  }, {
    key: "render",
    value: function render() {
      var iframeParams = "&showHeader=false&reauthorise=true&parent=digit";
      return _react2.default.createElement(
        "div",
        { className: _integrationSettings2.default.container },
        _react2.default.createElement(_settingsInlineTabs.SettingsInlineTabs, { currentPage: "integration", slug: this.props.accountId }),
        _react2.default.createElement(
          "div",
          { className: _integrationSettings2.default["iframe-container"] },
          _react2.default.createElement("iframe", {
            className: _integrationSettings2.default.iframe,
            src: "https://integrations.squirrelstreet.com/AccountingIntegration?" + "accountid=" + this.props.accountId + iframeParams
          })
        )
      );
    }
  }]);

  return IntegrationsPage;
}(_react2.default.Component);

IntegrationsPage.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  init: _propTypes2.default.func.isRequired,
  trackPage: _propTypes2.default.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    accountId: state.app.selectedAccount.id
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    init: function init() {
      return null;
    },
    trackPage: function trackPage() {
      return dispatch((0, _trackingActions.trackPageAction)("Integration settings page"));
    }
  };
};

var IntegrationSettingsContainer = exports.IntegrationSettingsContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(IntegrationsPage);

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MailInSettingsContainer = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _mailInSettings = __webpack_require__(923);

var _accountSettingsActions = __webpack_require__(67);

var _loading = __webpack_require__(38);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MailInSettingsPage = function MailInSettingsPage(props) {
  if (props.isLoading) {
    return _react2.default.createElement(_loading.Loading, null);
  }
  return _react2.default.createElement(_mailInSettings.MailInSettings, props);
};

MailInSettingsPage.propTypes = {
  isLoading: _propTypes2.default.bool.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    accountId: state.app.selectedAccount.id,
    address: state.accountSettings.address,
    docReturn: state.accountSettings.docReturn,
    isDocumentReturnLoading: state.accountSettings.isDocumentReturnLoading,
    isLoading: state.accountSettings.isLoading,
    slug: state.accountSettings.slug,
    vip: state.accountSettings.vip
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onDisableDocReturn: function onDisableDocReturn(accountId) {
      return dispatch((0, _accountSettingsActions.updateDocReturnAction)(accountId, false));
    },
    onEnableDocReturn: function onEnableDocReturn(accountId) {
      return dispatch((0, _accountSettingsActions.updateDocReturnAction)(accountId, true));
    },
    onSaveAddress: function onSaveAddress() {
      return dispatch((0, _accountSettingsActions.saveAddressAction)());
    }
  };
};

var MailInSettingsContainer = exports.MailInSettingsContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MailInSettingsPage);

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscriptionSettingsContainer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(32);

var _reactRedux = __webpack_require__(11);

var _subscriptionSettings = __webpack_require__(928);

var _accountSettingsActions = __webpack_require__(67);

var _loading = __webpack_require__(38);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SubscriptionSettingsPage = function (_React$Component) {
  _inherits(SubscriptionSettingsPage, _React$Component);

  function SubscriptionSettingsPage() {
    _classCallCheck(this, SubscriptionSettingsPage);

    return _possibleConstructorReturn(this, (SubscriptionSettingsPage.__proto__ || Object.getPrototypeOf(SubscriptionSettingsPage)).apply(this, arguments));
  }

  _createClass(SubscriptionSettingsPage, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.props.init(this.props.accountId);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.isLoading) {
        return _react2.default.createElement(_loading.Loading, null);
      }
      if (this.props.vip) {
        return _reactRouter.browserHistory.push("/");
      }
      return _react2.default.createElement(_subscriptionSettings.SubscriptionSettings, this.props);
    }
  }]);

  return SubscriptionSettingsPage;
}(_react2.default.Component);

SubscriptionSettingsPage.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  init: _propTypes2.default.func.isRequired,
  isLoading: _propTypes2.default.bool.isRequired,
  vip: _propTypes2.default.bool.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    accountId: state.app.selectedAccount.id,
    cancelDate: state.accountSettings.cancelDate,
    isCancelSubscriptionVisible: state.accountSettings.isCancelSubscriptionVisible,
    isChangePlanLoading: state.accountSettings.isChangePlanLoading,
    isLoading: state.accountSettings.isPlansLoading,
    isUpgradeDowngradeVisible: state.accountSettings.isUpgradeDowngradeVisible,
    pendingPlan: state.accountSettings.pendingPlan,
    plan: state.accountSettings.plan,
    plans: state.accountSettings.plans,
    planDetails: state.accountSettings.planDetails,
    planDisplay: state.accountSettings.planDisplay,
    vip: state.accountSettings.vip
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    init: function init(accountId) {
      return dispatch((0, _accountSettingsActions.fetchPlansAction)(accountId));
    },
    onHideCancelSubscription: function onHideCancelSubscription() {
      return dispatch((0, _accountSettingsActions.setCancelSubscriptionVisibilityAction)(false));
    },
    onHideUpgradeDowngrade: function onHideUpgradeDowngrade() {
      return dispatch((0, _accountSettingsActions.hideUpgradeDowngradeModalAction)());
    },
    onShowCancelSubscription: function onShowCancelSubscription() {
      return dispatch((0, _accountSettingsActions.setCancelSubscriptionVisibilityAction)(true));
    },
    onShowUpgradeDowngrade: function onShowUpgradeDowngrade(plan) {
      return dispatch((0, _accountSettingsActions.showUpgradeDowngradeModalAction)(plan));
    },
    onSetPlanDisplay: function onSetPlanDisplay(type) {
      return dispatch((0, _accountSettingsActions.setPlanTypeDisplayAction)(type));
    },
    onUpdatePlan: function onUpdatePlan(accountId, plan) {
      return dispatch((0, _accountSettingsActions.updatePlanAction)(accountId, plan));
    }
  };
};

var SubscriptionSettingsContainer = exports.SubscriptionSettingsContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SubscriptionSettingsPage);

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserNameAndEmailContainer = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _userSettingsActions = __webpack_require__(137);

var _userNameAndEmailSettings = __webpack_require__(931);

var _loading = __webpack_require__(38);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserNameAndEmailPage = function UserNameAndEmailPage(props) {
  if (props.isLoading) {
    return _react2.default.createElement(_loading.Loading, null);
  }
  return _react2.default.createElement(_userNameAndEmailSettings.UserNameAndEmailSettings, props);
};

UserNameAndEmailPage.propTypes = {
  isLoading: _propTypes2.default.bool.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    accountId: state.app.selectedAccount.id,
    confirmEmail: state.userSettings.confirmEmail,
    email: state.userSettings.email,
    firstName: state.userSettings.name,
    isLoading: state.userSettings.isUserNameLoading,
    lastName: state.userSettings.surname,
    newEmail: state.userSettings.newEmail
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSaveUserEmail: function onSaveUserEmail(userDetails) {
      return dispatch((0, _userSettingsActions.saveUserEmailAction)(userDetails));
    },
    onSaveUserName: function onSaveUserName(userDetails) {
      return dispatch((0, _userSettingsActions.saveUserNameAction)(userDetails));
    }
  };
};

var UserNameAndEmailContainer = exports.UserNameAndEmailContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UserNameAndEmailPage);

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserPasswordContainer = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(11);

var _userSettingsActions = __webpack_require__(137);

var _userPasswordSettings = __webpack_require__(932);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserPasswordPage = function UserPasswordPage(props) {
  return _react2.default.createElement(_userPasswordSettings.UserPasswordSettings, props);
};

var matchStateToProps = function matchStateToProps(state) {
  return {
    passwordDetails: state.userSettings.passwordDetails
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSavePassword: function onSavePassword(passwordDetails) {
      return dispatch((0, _userSettingsActions.saveNewPasswordAction)(passwordDetails));
    }
  };
};

var UserPasswordContainer = exports.UserPasswordContainer = (0, _reactRedux.connect)(matchStateToProps, mapDispatchToProps)(UserPasswordPage);

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserSettingsContainer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _customPropTypes = __webpack_require__(5);

var _userSettingsActions = __webpack_require__(137);

var _settingsInlineTabs = __webpack_require__(271);

var _grid = __webpack_require__(95);

var _grid2 = _interopRequireDefault(_grid);

var _settings = __webpack_require__(521);

var _settings2 = _interopRequireDefault(_settings);

var _userSettingsMenu = __webpack_require__(933);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserSettings = function (_React$Component) {
  _inherits(UserSettings, _React$Component);

  function UserSettings() {
    _classCallCheck(this, UserSettings);

    return _possibleConstructorReturn(this, (UserSettings.__proto__ || Object.getPrototypeOf(UserSettings)).apply(this, arguments));
  }

  _createClass(UserSettings, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.props.init();
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: _settings2.default.container },
        _react2.default.createElement(_settingsInlineTabs.SettingsInlineTabs, { currentPage: "user", slug: this.props.slug }),
        _react2.default.createElement(
          "div",
          { className: _grid2.default.row },
          _react2.default.createElement("div", { className: _settings2.default["grid-spacing"] + " " + _grid2.default["col-md-1"] }),
          _react2.default.createElement(
            "div",
            { className: _settings2.default["grid-spacing"] + " " + _grid2.default["col-md-2"] },
            _react2.default.createElement(_userSettingsMenu.UserSettingsMenu, { accounts: this.props.accounts, slug: this.props.slug })
          ),
          _react2.default.createElement(
            "div",
            { className: _settings2.default["grid-spacing"] + " " + _grid2.default["col-md-8"] },
            _react2.default.createElement(
              "div",
              { className: _settings2.default["child-container"] },
              this.props.children
            )
          ),
          _react2.default.createElement("div", { className: _settings2.default["grid-spacing"] + " " + _grid2.default["col-md-1"] })
        )
      );
    }
  }]);

  return UserSettings;
}(_react2.default.Component);

UserSettings.propTypes = {
  accounts: _propTypes2.default.arrayOf(_customPropTypes.accountType).isRequired,
  children: _propTypes2.default.element.isRequired,
  init: _propTypes2.default.func.isRequired,
  slug: _propTypes2.default.string.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    accounts: state.app.accounts,
    accountId: state.app.selectedAccount.id,
    slug: state.app.selectedAccount.slug
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    init: function init() {
      return dispatch((0, _userSettingsActions.fetchUserSettingsAction)());
    }
  };
};

var UserSettingsContainer = exports.UserSettingsContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UserSettings);

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UploadDocumentsContainer = exports.UploadDocumentsPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDropzone = __webpack_require__(1779);

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

var _reactRedux = __webpack_require__(11);

var _uploadDocuments = __webpack_require__(1373);

var _uploadDocuments2 = _interopRequireDefault(_uploadDocuments);

var _trackingActions = __webpack_require__(26);

var _button = __webpack_require__(7);

var _alternativeUploadMethods = __webpack_require__(938);

var _pendingDocumentsList = __webpack_require__(943);

var _customPropTypes = __webpack_require__(5);

var _pendingDocumentsActions = __webpack_require__(195);

var _accountSettingsActions = __webpack_require__(67);

var _appActions = __webpack_require__(25);

var _uploadInlineTabs = __webpack_require__(273);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UploadDocumentsPage = exports.UploadDocumentsPage = function (_React$Component) {
  _inherits(UploadDocumentsPage, _React$Component);

  function UploadDocumentsPage() {
    _classCallCheck(this, UploadDocumentsPage);

    return _possibleConstructorReturn(this, (UploadDocumentsPage.__proto__ || Object.getPrototypeOf(UploadDocumentsPage)).apply(this, arguments));
  }

  _createClass(UploadDocumentsPage, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.props.init(this.props.accountId);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var dropzoneRef = void 0;
      this.props.trackPage();
      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(_uploadInlineTabs.UploadInlineTabs, { accountSlug: this.props.accountSlug, currentPage: "upload" }),
        _react2.default.createElement(
          _reactDropzone2.default,
          {
            accept: mimeTypes,
            activeClassName: _uploadDocuments2.default["active-dropzone"],
            className: _uploadDocuments2.default.dropzone,
            disableClick: true,
            maxSize: 8388608,
            onDrop: function onDrop(files) {
              _this2.props.onDropDocument(_this2.props.accountId, files);
            },
            onDropRejected: function onDropRejected() {
              _this2.props.onDropRejected();
            },
            ref: function ref(node) {
              dropzoneRef = node;
            }
          },
          _react2.default.createElement(
            "div",
            { className: _uploadDocuments2.default["upload-modal"] },
            _react2.default.createElement(
              "div",
              { className: _uploadDocuments2.default["upload-content"], onClick: function onClick(e) {
                  return e.stopPropagation();
                } },
              _react2.default.createElement(
                "h1",
                { className: _uploadDocuments2.default["upload-title"] },
                "Upload Documents"
              ),
              _react2.default.createElement(
                "div",
                { className: _uploadDocuments2.default["upload-button"] },
                _react2.default.createElement(
                  "p",
                  null,
                  "Upload documents by dragging files anywhere on this page or select from your computer:"
                ),
                _react2.default.createElement(
                  "span",
                  { className: "upload3" },
                  _react2.default.createElement(
                    _button.Button,
                    { loading: this.props.isUploadLoading, onClick: function onClick() {
                        dropzoneRef.open();
                      }, primary: true },
                    "Select documents to upload"
                  )
                )
              ),
              _react2.default.createElement(
                "div",
                null,
                renderPendingDocumentsList(this.props.pendingDocuments, this.props.selectedAccount)
              ),
              _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement(_alternativeUploadMethods.AlternativeUploadMethods, {
                  onSetFlashMessage: this.props.onSetFlashMessage,
                  slug: this.props.accountSlug,
                  submissionEmail: this.props.submissionEmail
                })
              )
            )
          )
        )
      );
    }
  }]);

  return UploadDocumentsPage;
}(_react2.default.Component);

var mimeTypes = "image/jpeg, image/jpg, image/gif, image/png, image/tiff, application/pdf,\n  text/plain, application/msword, application/vnd.ms-excel, text/csv,\n  application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.wordprocessingml.document,\n  application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,\n  application/vnd.oasis.opendocument.text, application/vnd.oasis.opendocument.spreadsheet";

UploadDocumentsPage.propTypes = {
  accountId: _propTypes2.default.string.isRequired,
  accountSlug: _propTypes2.default.string.isRequired,
  init: _propTypes2.default.func.isRequired,
  isUploadLoading: _propTypes2.default.bool.isRequired,
  onDropDocument: _propTypes2.default.func.isRequired,
  onDropRejected: _propTypes2.default.func.isRequired,
  onSetFlashMessage: _propTypes2.default.func.isRequired,
  pendingDocuments: _propTypes2.default.arrayOf(_customPropTypes.documentPropType).isRequired,
  selectedAccount: _customPropTypes.accountType.isRequired,
  submissionEmail: _propTypes2.default.string.isRequired,
  trackPage: _propTypes2.default.func.isRequired
};

var renderPendingDocumentsList = function renderPendingDocumentsList(pendingDocuments, selectedAccount) {
  if (pendingDocuments === null || pendingDocuments === undefined || pendingDocuments.length === 0) {
    return null;
  }
  return _react2.default.createElement(_pendingDocumentsList.PendingDocumentsList, {
    pendingDocuments: pendingDocuments,
    selectedAccount: selectedAccount
  });
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    accountId: state.app.selectedAccount.id,
    accountSlug: state.app.selectedAccount.slug,
    isUploadLoading: state.pendingDocuments.isUploadLoading,
    pendingDocuments: state.pendingDocuments.pendingDocuments,
    selectedAccount: state.app.selectedAccount,
    submissionEmail: state.pendingDocuments.submissionEmail
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    init: function init(accountId) {
      return dispatch((0, _accountSettingsActions.fetchAccountDetailsAction)(accountId));
    },
    trackPage: function trackPage() {
      return dispatch((0, _trackingActions.trackPageAction)("Upload documents page"));
    },
    onDropDocument: function onDropDocument(accountId, files) {
      return dispatch((0, _pendingDocumentsActions.dropDocumentAction)(accountId, files));
    },
    onDropRejected: function onDropRejected() {
      return dispatch((0, _pendingDocumentsActions.dropRejectedAction)());
    },
    onSetFlashMessage: function onSetFlashMessage(message) {
      return dispatch((0, _appActions.setFlashMessageAction)(message));
    }
  };
};

var UploadDocumentsContainer = exports.UploadDocumentsContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UploadDocumentsPage);

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accountSettingsReducer = exports.initialState = undefined;

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _bootstrapActions = __webpack_require__(60);

var _accountSettingsActions = __webpack_require__(67);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = exports.initialState = {
  address: null,
  billingDetails: null,
  cancelDate: null,
  currency: "AUD",
  docReturn: false,
  dropboxEmail: null,
  emailPin: "",
  invoices: [],
  isAccountUsersLoading: true,
  isNoBillingDetails: false,
  isBillingDetailsLoading: true,
  isBillingHistoryLoading: true,
  isCancelSubscriptionVisible: false,
  isChangePlanLoading: false,
  isDocumentReturnLoading: false,
  isInviteUserVisible: false,
  isLocalesLoading: true,
  isLoading: true,
  isPlansLoading: true,
  isRemoveSelfVisible: false,
  isUpgradeDowngradeVisible: false,
  label: "",
  locale: "en-AU",
  maxUsers: null,
  pagination: {
    displayInvoices: [],
    invoicePages: [],
    pageNumber: 1,
    limit: 20
  },
  pendingPlan: null,
  plan: null,
  planDetails: null,
  planDisplay: "monthly",
  plans: [],
  showUniversalCategorySet: true,
  shredDocuments: false,
  slug: "",
  supportedLocales: [],
  users: [],
  vat: "10.00",
  vip: false
};

var accountSettingsReducer = exports.accountSettingsReducer = function accountSettingsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _bootstrapActions.BOOTSTRAP_ACCOUNT_SETTINGS:
      return _ramda2.default.merge(state, action.data.accountSettings);
    case _accountSettingsActions.SET_ACCOUNT_DETAILS:
      return stateForSetAccountDetails(state, action);
    case _accountSettingsActions.SET_PLAN_TYPE_DISPLAY:
      return _ramda2.default.merge(state, { planDisplay: action.data.type });
    case _accountSettingsActions.SET_PLANS:
      return _ramda2.default.merge(state, { plans: action.data.plans });
    case _accountSettingsActions.UPDATE_PLAN:
      return _ramda2.default.merge(state, { planDetails: action.data.plan, isCancelSubscriptionVisible: false });
    case _accountSettingsActions.SET_BILLING_HISTORY:
      return stateForSetBillingHistory(state, action);
    case _accountSettingsActions.SET_PAGINATION_LIMIT:
      return stateForSetPaginationLimit(state, action.data.limit);
    case _accountSettingsActions.NEXT_PAGE:
      return stateForNextPage(state);
    case _accountSettingsActions.PREVIOUS_PAGE:
      return stateForPreviousPage(state);
    case _accountSettingsActions.SET_BILLING_DETAILS:
      return _ramda2.default.merge(state, { isBillingDetailsLoading: false, billingDetails: action.data.billingDetails });
    case _accountSettingsActions.UPDATE_BILLING_DETAILS:
      return _ramda2.default.set(_ramda2.default.lensPath(["billingDetails", action.data.field]), action.data.payload, state);
    case _accountSettingsActions.SET_LOCALES:
      return _ramda2.default.merge(state, { supportedLocales: action.data.supportedLocales, isLocalesLoading: false });
    case _accountSettingsActions.SET_ACCOUNT_USERS:
      return _ramda2.default.merge(state, {
        isAccountUsersLoading: false,
        maxUsers: action.data.maxUsers,
        users: action.data.users
      });
    case _accountSettingsActions.USER_REMOVED:
      return stateForRemoveUser(state, action);
    case _accountSettingsActions.USER_CREATED:
      return _ramda2.default.merge(state, { users: _ramda2.default.append(action.data.newUser, state.users) });
    case _accountSettingsActions.SET_INVITE_USER_VISIBILITY:
      return _ramda2.default.merge(state, { isInviteUserVisible: action.data.visible });
    case _accountSettingsActions.NO_BILLING_DETAILS:
      return _ramda2.default.merge(state, { isNoBillingDetails: true, isBillingDetailsLoading: false });
    case _accountSettingsActions.SET_REMOVE_SELF_VISIBILTIY:
      return _ramda2.default.merge(state, { isRemoveSelfVisible: action.data.visible });
    case _accountSettingsActions.SET_DOC_RETURN_STATUS:
      return _ramda2.default.merge(state, { docReturn: action.data.isOn });
    case _accountSettingsActions.CHANGE_PLAN_LOADING:
      return _ramda2.default.merge(state, { isChangePlanLoading: true });
    case _accountSettingsActions.CHANGE_PLAN_LOADING_STOP:
      return _ramda2.default.merge(state, { isChangePlanLoading: false });
    case _accountSettingsActions.SET_PENDING_PLAN:
      return stateForSetPendingPlan(state, action);
    case _accountSettingsActions.SET_CANCEL_SUBSCRIPTION_VISIBILITY:
      return _ramda2.default.merge(state, { isCancelSubscriptionVisible: action.data.visible });
    case _accountSettingsActions.SHOW_UPGRADE_DOWNGRADE_MODAL:
      return _ramda2.default.merge(state, { isUpgradeDowngradeVisible: true, plan: action.data.plan });
    case _accountSettingsActions.HIDE_UPGRADE_DOWNGRADE_MODAL:
      return _ramda2.default.merge(state, { isUpgradeDowngradeVisible: false, plan: null });
    case _accountSettingsActions.UPDATE_ACCOUNT_NAME_AND_EMAIL:
      return _ramda2.default.merge(state, {
        label: action.data.settings.label,
        slug: action.data.settings.slug,
        emailPin: action.data.settings.emailPin
      });
    case _accountSettingsActions.UPDATE_ADDRESS:
      return _ramda2.default.merge(state, { address: action.data.newAddress });
    case _accountSettingsActions.UPDATE_CLT_SETTINGS:
      return _ramda2.default.merge(state, {
        currency: action.data.newSettings.currency,
        locale: action.data.newSettings.locale,
        vat: action.data.newSettings.vat
      });
    case _accountSettingsActions.DOCUMENT_RETURN_LOADING:
      return _ramda2.default.merge(state, { isDocumentReturnLoading: true });
    case _accountSettingsActions.DOCUMENT_RETURN_LOADING_STOP:
      return _ramda2.default.merge(state, { isDocumentReturnLoading: false });
    default:
      return state;
  }
};

var stateForSetBillingHistory = function stateForSetBillingHistory(state, action) {
  var newInvoices = action.data.invoices.filter(function (invoice) {
    return invoice.total !== 0;
  });
  var newPagination = _ramda2.default.clone(state.pagination);
  var invoicePages = _ramda2.default.splitEvery(newPagination.limit, newInvoices);
  newPagination.displayInvoices = invoicePages[newPagination.pageNumber - 1];
  newPagination.invoicePages = invoicePages;
  return _ramda2.default.merge(state, {
    isBillingHistoryLoading: false,
    invoices: action.data.invoices,
    pagination: newPagination
  });
};

var stateForSetAccountDetails = function stateForSetAccountDetails(state, action) {
  return _ramda2.default.merge(state, {
    address: action.data.accountDetails.address,
    dropboxEmail: action.data.accountDetails.dropboxEmail,
    emailPin: action.data.accountDetails.emailPin,
    isLoading: false,
    label: action.data.accountDetails.label,
    planDetails: action.data.planDetails,
    slug: action.data.accountDetails.slug,
    vip: action.data.accountDetails.vip
  });
};

var stateForSetPaginationLimit = function stateForSetPaginationLimit(state, limit) {
  var newPagination = _ramda2.default.clone(state.pagination);
  var invoicePages = _ramda2.default.splitEvery(limit, state.invoices);
  newPagination.displayInvoices = invoicePages[newPagination.pageNumber - 1];
  newPagination.invoicePages = invoicePages;
  newPagination.limit = limit;
  return _ramda2.default.merge(state, { pagination: newPagination });
};

var stateForNextPage = function stateForNextPage(state) {
  var pagination = state.pagination,
      invoices = state.invoices;

  var currentPage = pagination.pageNumber;
  var maxPage = Math.ceil(invoices.length / pagination.limit);

  if (currentPage >= maxPage) {
    return state;
  }
  return _ramda2.default.merge(state, {
    pagination: _ramda2.default.merge(state.pagination, {
      displayInvoices: state.pagination.invoicePages[currentPage],
      pageNumber: currentPage + 1
    })
  });
};

var stateForPreviousPage = function stateForPreviousPage(state) {
  var currentPage = state.pagination.pageNumber;
  if (currentPage <= 1) {
    return state;
  }
  return _ramda2.default.merge(state, {
    pagination: _ramda2.default.merge(state.pagination, {
      displayInvoices: state.pagination.invoicePages[currentPage - 2],
      pageNumber: currentPage - 1
    })
  });
};

var stateForRemoveUser = function stateForRemoveUser(state, action) {
  var newUsers = state.users.filter(function (user) {
    return user.id !== action.data.userId;
  });
  return _ramda2.default.merge(state, { users: newUsers });
};

var stateForSetPendingPlan = function stateForSetPendingPlan(state, action) {
  return _ramda2.default.merge(state, {
    cancelDate: action.data.cancelDate,
    pendingPlan: action.data.pendingPlan,
    isPlansLoading: false
  });
};

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appReducer = exports.initialState = undefined;

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _bootstrapActions = __webpack_require__(60);

var _appActions = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = exports.initialState = {
  accounts: [],
  exportFailedCount: 0,
  flash: { message: null, type: null },
  selectedAccount: null,
  isDontRemindBeta: false,
  isLoading: true,
  isFirstTimeBetaMode: false,
  isGlobalError: false,
  isNotificationsMode: false,
  isNotificationsViewed: false,
  isSettingsMode: false,
  isTourOpen: false,
  isUploadDocumentsVisible: false,
  isUploadError: false,
  pendingDocuments: [],
  queuedCount: 0,
  tourName: "",
  user: null
};

var appReducer = exports.appReducer = function appReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _bootstrapActions.BOOTSTRAP_CURRENT_USER_AND_ACCOUNTS:
      return _ramda2.default.merge(state, currentUserAndAccounts(action.data));
    case _bootstrapActions.LOADING_STOP:
      return _ramda2.default.merge(state, { isLoading: false });
    case _appActions.UNKNOWN_ERROR:
      return _ramda2.default.merge(state, { isLoading: false, isGlobalError: true });
    case _appActions.SET_FLASH_MESSAGE:
      return _ramda2.default.merge(state, {
        flash: {
          message: action.data.message,
          type: action.data.type || "success"
        }
      });
    case _appActions.CLEAR_FLASH_MESSAGE:
      return _ramda2.default.merge(state, { flash: initialState.flash });
    case _appActions.START_SETTINGS_MODE:
      return _ramda2.default.merge(state, { isSettingsMode: true });
    case _appActions.END_SETTINGS_MODE:
      return _ramda2.default.merge(state, { isSettingsMode: false });
    case _appActions.SET_PENDING_DOCUMENTS:
      return _ramda2.default.merge(state, { pendingDocuments: action.data.documents });
    case _appActions.SET_UPLOAD_DOCUMENTS_VISIBILITY:
      return _ramda2.default.merge(state, { isUploadDocumentsVisible: action.data.visible });
    case _appActions.START_NOTIFICATIONS_MODE:
      return _ramda2.default.merge(state, { isNotificationsMode: true, isNotificationsViewed: true });
    case _appActions.END_NOTIFICATIONS_MODE:
      return _ramda2.default.merge(state, { isNotificationsMode: false });
    case _appActions.SET_EXPORT_FAILED_COUNT:
      return _ramda2.default.merge(state, { exportFailedCount: action.data.exportFailedCount });
    case _appActions.SET_QUEUED_COUNT:
      return _ramda2.default.merge(state, { queuedCount: action.data.queuedCount });
    case _appActions.END_GLOBAL_ERROR:
      return _ramda2.default.merge(state, { isGlobalError: false });
    case _bootstrapActions.START_FIRST_TIME_BETA_MODE:
      return _ramda2.default.merge(state, { isFirstTimeBetaMode: true });
    case _appActions.END_FIRST_TIME_BETA_MODE:
      return _ramda2.default.merge(state, { isFirstTimeBetaMode: false });
    case _appActions.TOGGLE_BETA_MODAL:
      return _ramda2.default.merge(state, { isDontRemindBeta: action.data.toggle });
    case _appActions.START_TOUR:
      return _ramda2.default.merge(state, { isTourOpen: true, tourName: action.data.tour });
    case _appActions.END_TOUR:
      return _ramda2.default.merge(state, { isTourOpen: false, tourName: "" });
    default:
      return state;
  }
};

var currentUserAndAccounts = function currentUserAndAccounts(data) {
  return {
    accounts: _ramda2.default.pathOr([], ["accounts"], data),
    selectedAccount: _ramda2.default.pathOr(null, ["selectedAccount"], data),
    user: _ramda2.default.pathOr(null, ["user"], data)
  };
};

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cardNumbersReducer = exports.initialState = undefined;

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _bootstrapActions = __webpack_require__(60);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = exports.initialState = {
  cardNumbers: []
};

var cardNumbersReducer = exports.cardNumbersReducer = function cardNumbersReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _bootstrapActions.BOOTSTRAP_CARD_NUMBERS:
      return _ramda2.default.merge(state, { cardNumbers: action.data.cardNumbers });
    default:
      return state;
  }
};

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.categoriesReducer = exports.initialState = undefined;

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _bootstrapActions = __webpack_require__(60);

var _categoriesActions = __webpack_require__(194);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = exports.initialState = {
  categories: [],
  focusedCategory: null,
  isAddCategoryVisible: false,
  isDeleteCategoriesVisible: false,
  isDeleteCategoriesLoading: false,
  isSaveCategoryLoading: false,
  newCategory: null,
  newIncludeRules: [],
  orderBy: "name",
  orderDirection: "ASC",
  selectedCategoryIds: []
};

var categoriesReducer = exports.categoriesReducer = function categoriesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _bootstrapActions.BOOTSTRAP_CATEGORIES:
    case _categoriesActions.RELOAD_CATEGORIES:
      return _ramda2.default.merge(state, { categories: action.data.categories });
    case _categoriesActions.CREATE_CATEGORY:
      return _ramda2.default.merge(state, { categories: _ramda2.default.prepend(action.data, state.categories) });
    case _categoriesActions.SET_ADD_CATEGORY_VISIBILITY:
      return _ramda2.default.merge(state, { isAddCategoryVisible: action.data.visibility });
    case _categoriesActions.UPDATE_NEW_CATEGORY_NAME:
      return _ramda2.default.merge(state, { newCategory: action.data.name });
    case _categoriesActions.REMOVE_INCLUDE_RULE:
      return stateForRemoveIncludeRule(state, action);
    case _categoriesActions.SELECT_CATEGORIES:
      return stateForSelectCategories(state, action.data.categoryIds);
    case _categoriesActions.DESELECT_CATEGORIES:
      return stateForDeselectCategories(state, action.data.categoryIds);
    case _categoriesActions.DELETE_CATEGORIES_LOADING:
      return _ramda2.default.merge(state, { isDeleteCategoriesLoading: true });
    case _categoriesActions.DELETE_CATEGORIES_LOADING_STOP:
      return stateForDeleteCategoriesLoadingStop(state, action);
    case _categoriesActions.FOCUS_CATEGORY:
      return stateForFocusCategory(state, action);
    case _categoriesActions.UNFOCUS_CATEGORY:
      return _ramda2.default.merge(state, { focusedCategory: null });
    case _categoriesActions.UPDATE_CATEGORY_NAME:
      return _ramda2.default.set(_ramda2.default.lensPath(["focusedCategory", "name"]), action.data.name, state);
    case _categoriesActions.REMOVE_DROPDOWN_RULE:
      return stateForRemoveDropdownRule(state, action.data);
    case _categoriesActions.UPDATE_INCLUDE_VENDORS:
      return stateForUpdateIncludeVendors(state, action.data.vendor);
    case _categoriesActions.SET_DELETE_CATEGORIES_VISIBILITY:
      return _ramda2.default.merge(state, { isDeleteCategoriesVisible: action.data.visibility });
    case _categoriesActions.SAVE_CATEGORY_LOADING:
      return _ramda2.default.merge(state, { isSaveCategoryLoading: true });
    case _categoriesActions.SAVE_CATEGORY_LOADING_STOP:
      return _ramda2.default.merge(state, { isSaveCategoryLoading: false, focusedCategory: null });
    case _categoriesActions.ORDER_CATEGORIES:
      return stateForOrderCategories(state, action);
    default:
      return state;
  }
};

var stateForRemoveIncludeRule = function stateForRemoveIncludeRule(state, action) {
  var oldCategory = _ramda2.default.find(_ramda2.default.propEq("id", action.data.categoryId))(state.categories);
  var lens = _ramda2.default.lensPath(["rules", "includeVendors"]);
  var lensIndex = _ramda2.default.lensIndex(_ramda2.default.findIndex(_ramda2.default.propEq("id", action.data.categoryId))(state.categories));
  var newCategory = createNewCategory(oldCategory, lens, action.data.ruleId);
  return updateCategories(newCategory, lensIndex, state);
};

var createNewCategory = function createNewCategory(oldCategory, lens, ruleId) {
  var newRules = _ramda2.default.reject(_ramda2.default.propEq("id", ruleId), _ramda2.default.view(lens, oldCategory));
  return _ramda2.default.set(lens, newRules, oldCategory);
};

var updateCategories = function updateCategories(newCategory, lensIndex, state) {
  var newCategories = _ramda2.default.set(lensIndex, newCategory, state.categories);
  return _ramda2.default.merge(state, { categories: newCategories });
};

var stateForSelectCategories = function stateForSelectCategories(state, categoryIds) {
  var categoryIdsArray = typeof categoryIds === "string" ? [categoryIds] : categoryIds;
  var currentIds = state.selectedCategoryIds;
  var newIds = categoryIdsArray.filter(function (id) {
    var category = _ramda2.default.find(_ramda2.default.propEq("id", id))(state.categories);
    if (category.type === "system") {
      return null;
    }
    return !currentIds.includes(id);
  });
  var appendedIds = _ramda2.default.append(newIds, currentIds);
  return _ramda2.default.merge(state, { selectedCategoryIds: _ramda2.default.flatten(appendedIds) });
};

var stateForDeselectCategories = function stateForDeselectCategories(state, categoryIds) {
  var currentIds = state.selectedCategoryIds;
  var newIds = currentIds.filter(function (id) {
    return !categoryIds.includes(id);
  });
  return _ramda2.default.merge(state, { selectedCategoryIds: newIds });
};

var stateForUpdateIncludeVendors = function stateForUpdateIncludeVendors(state, vendor) {
  var lens = _ramda2.default.lensProp("newIncludeRules");
  return _ramda2.default.set(lens, _ramda2.default.append(vendor, _ramda2.default.view(lens, state)), state);
};

var stateForRemoveDropdownRule = function stateForRemoveDropdownRule(state, data) {
  var lens = _ramda2.default.lensPath(["focusedCategory", "rules", "includeVendors"]);
  var newLens = _ramda2.default.lensProp("newIncludeRules");
  if (data.isNew) {
    var _newRules = _ramda2.default.reject(_ramda2.default.propEq("name", data.rule.name), _ramda2.default.view(newLens, state));
    return _ramda2.default.set(newLens, _newRules, state);
  }
  var newRules = _ramda2.default.reject(_ramda2.default.propEq("id", data.rule.id), _ramda2.default.view(lens, state));
  return _ramda2.default.set(lens, newRules, state);
};

var stateForDeleteCategoriesLoadingStop = function stateForDeleteCategoriesLoadingStop(state) {
  return _ramda2.default.merge(state, {
    isDeleteCategoriesLoading: false,
    isDeleteCategoriesVisible: false,
    selectedCategoryIds: []
  });
};

var stateForFocusCategory = function stateForFocusCategory(state, action) {
  var newCategory = _ramda2.default.assoc("style", action.data.style, action.data.category);
  return _ramda2.default.merge(state, { focusedCategory: newCategory, newIncludeRules: [] });
};

var stateForOrderCategories = function stateForOrderCategories(state, action) {
  var column = action.data.column;
  switch (action.data.column) {
    case "name":
      return orderBy(state, column, function (a, b) {
        return b[column].localeCompare(a[column]);
      });
    case "receipts":
      return orderBy(state, column, function (a, b) {
        return b[column] - a[column];
      });
    case "rules":
      return orderBy(state, column, function (a, b) {
        return b[column].includeVendors.length - a[column].includeVendors.length;
      });
    default:
      return state.categories;
  }
};

var orderBy = function orderBy(state, column, sortFunction) {
  if (state.orderDirection === "ASC") {
    return _ramda2.default.merge(state, {
      orderBy: column,
      orderDirection: "DSC",
      categories: _ramda2.default.sort(sortFunction, state.categories)
    });
  }
  return _ramda2.default.merge(state, {
    orderBy: column,
    orderDirection: "ASC",
    categories: _ramda2.default.reverse(_ramda2.default.sort(sortFunction, state.categories))
  });
};

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.currenciesReducer = exports.initialState = undefined;

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _bootstrapActions = __webpack_require__(60);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = exports.initialState = {
  currencies: []
};

var currenciesReducer = exports.currenciesReducer = function currenciesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _bootstrapActions.BOOTSTRAP_CURRENCIES:
      return _ramda2.default.merge(state, { currencies: action.data.currencies });
    default:
      return state;
  }
};

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.customTabsReducer = exports.initialState = undefined;

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _bootstrapActions = __webpack_require__(60);

var _customTabsActions = __webpack_require__(160);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = exports.initialState = {
  customTabs: [],
  customTabName: "",
  customTabRemoveId: null,
  isCreateCustomTabLoading: false,
  isDeleteCustomTabLoading: false,
  isDeleteCustomTabMode: false
};

var customTabsReducer = exports.customTabsReducer = function customTabsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _bootstrapActions.BOOTSTRAP_CUSTOM_TABS:
      return _ramda2.default.merge(state, { customTabs: action.data.customTabs });
    case _customTabsActions.CUSTOM_TAB_CREATED:
      return stateForCustomTabCreated(state, action);
    case _customTabsActions.UPDATE_CUSTOM_TAB_NAME:
      return _ramda2.default.merge(state, { customTabName: action.data.name });
    case _customTabsActions.START_DELETE_CUSTOM_TAB_MODE:
      return _ramda2.default.merge(state, { isDeleteCustomTabMode: true, customTabRemoveId: action.data.id });
    case _customTabsActions.END_DELETE_CUSTOM_TAB_MODE:
      return _ramda2.default.merge(state, { isDeleteCustomTabMode: false, customTabRemoveId: null });
    case _customTabsActions.CUSTOM_TAB_DELETED:
      return stateForRemoveCustomTab(state, action);
    case _customTabsActions.CREATE_CUSTOM_TAB_LOADING:
      return _ramda2.default.merge(state, { isCreateCustomTabLoading: true });
    case _customTabsActions.CREATE_CUSTOM_TAB_LOADING_STOP:
      return _ramda2.default.merge(state, { isCreateCustomTabLoading: false });
    case _customTabsActions.DELETE_CUSTOM_TAB_LOADING:
      return _ramda2.default.merge(state, { isDeleteCustomTabLoading: true });
    case _customTabsActions.DELETE_CUSTOM_TAB_LOADING_STOP:
      return _ramda2.default.merge(state, { isDeleteCustomTabLoading: false });
    default:
      return state;
  }
};

var stateForCustomTabCreated = function stateForCustomTabCreated(state, action) {
  var newCustomTabs = _ramda2.default.append(action.data.customTab, state.customTabs);
  return _ramda2.default.merge(state, { customTabs: newCustomTabs, customTabName: "" });
};

var stateForRemoveCustomTab = function stateForRemoveCustomTab(state, action) {
  return _ramda2.default.merge(state, {
    customTabs: action.data.customTabs,
    isDeleteCustomTabMode: false,
    customTabRemoveId: null
  });
};

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dashboardReducer = exports.initialState = undefined;

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _dashboardActions = __webpack_require__(408);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = exports.initialState = {
  documentCount: 0,
  documentLimit: 0,
  envelopeCount: 0,
  envelopeLimit: 0,
  isLoading: true,
  pendingDocumentCount: 0,
  totalCount: 0,
  totalSumFiltered: null
};

var dashboardReducer = exports.dashboardReducer = function dashboardReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _dashboardActions.SET_USAGE_DETAILS:
      return stateForSetUsageDetails(state, action.data);
    case _dashboardActions.SET_DOCUMENT_USAGE_DETAILS:
      return stateForSetDocumentUsageDetails(state, action);
    case _dashboardActions.SET_PENDING_DOCUMENTS:
      return _ramda2.default.merge(state, { pendingDocumentCount: action.data.pendingDocumentCount });
    case _dashboardActions.DASHBOARD_LOADING_STOP:
      return _ramda2.default.merge(state, { isLoading: false });
    default:
      return state;
  }
};

var stateForSetUsageDetails = function stateForSetUsageDetails(state, data) {
  return _ramda2.default.merge(state, {
    documentCount: data.usageDetails.totalProcessedCount,
    documentLimit: data.usageDetails.documentLimitPerMonth,
    envelopeCount: data.usageDetails.billableEnvelopeCount,
    envelopeLimit: data.usageDetails.envelopeLimitPerMonth
  });
};

var stateForSetDocumentUsageDetails = function stateForSetDocumentUsageDetails(state, action) {
  return _ramda2.default.merge(state, {
    totalCount: action.data.totalCount,
    totalSumFiltered: action.data.totalSumFiltered.amount.toFixed(0)
  });
};

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.documentFiltersReducer = exports.initialState = undefined;

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _bootstrapActions = __webpack_require__(60);

var _documentFiltersActions = __webpack_require__(136);

var _customTabsActions = __webpack_require__(160);

var _documentsExportsFiltersFunctions = __webpack_require__(990);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = exports.initialState = {
  endDate: null,
  exportType: null,
  isExports: false,
  isTrash: false,
  lastFourDigits: null,
  name: "",
  processingState: "PROCESSED",
  orderDirection: "DESC",
  orderBy: "uploaded",
  startDate: null,
  searchQueryString: "",
  selectedCardNumbers: [],
  selectedCategories: [],
  selectedCurrencies: [],
  selectedEnvelopes: [],
  selectedName: "",
  selectedPaymentTypes: [],
  selectedSearchQueryString: null,
  selectedVendors: [],
  totalMin: "",
  totalMax: "",
  type: null,
  viewedStatus: ""
};

var documentFiltersReducer = exports.documentFiltersReducer = function documentFiltersReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _documentFiltersActions.ADD_VENDOR_TO_FILTER:
      return (0, _documentsExportsFiltersFunctions.addToSelectedVendors)(state, action.data.update);
    case _documentFiltersActions.REMOVE_VENDOR_FROM_FILTER:
      return (0, _documentsExportsFiltersFunctions.removeSelectedVendor)(state, action.data.update);
    case _documentFiltersActions.ADD_CATEGORY_TO_FILTER:
      return (0, _documentsExportsFiltersFunctions.addToSelectedCategories)(state, action.data.update);
    case _documentFiltersActions.REMOVE_CATEGORY_FROM_FILTER:
      return (0, _documentsExportsFiltersFunctions.removeSelectedCategory)(state, action.data.update);
    case _documentFiltersActions.ADD_PAYMENT_TYPE_TO_FILTER:
      return (0, _documentsExportsFiltersFunctions.addToSelectedPaymentTypes)(state, action.data.update);
    case _documentFiltersActions.REMOVE_PAYMENT_TYPE_FROM_FILTER:
      return (0, _documentsExportsFiltersFunctions.removeSelectedPaymentType)(state, action.data.update);
    case _documentFiltersActions.ADD_CURRENCY_TO_FILTER:
      return (0, _documentsExportsFiltersFunctions.addToSelectedCurrencies)(state, action.data.update);
    case _documentFiltersActions.REMOVE_CURRENCY_FROM_FILTER:
      return (0, _documentsExportsFiltersFunctions.removeSelectedCurrency)(state, action.data.update);
    case _documentFiltersActions.CLEAR_EXPORT_TYPE_FILTER:
      return _ramda2.default.merge(state, { exportType: null });
    case _documentFiltersActions.SET_EXPORT_TYPE_FILTER:
      return _ramda2.default.merge(state, { exportType: action.data.update });
    case _documentFiltersActions.ADD_ENVELOPE_TO_FILTER:
      return (0, _documentsExportsFiltersFunctions.addToSelectedEnvelopes)(state, action.data.update);
    case _documentFiltersActions.REMOVE_ENVELOPE_FROM_FILTER:
      return (0, _documentsExportsFiltersFunctions.removeSelectedEnvelope)(state, action.data.update);
    case _documentFiltersActions.ADD_START_DATE_TO_FILTER:
      return _ramda2.default.merge(state, { startDate: action.data.update });
    case _documentFiltersActions.ADD_END_DATE_TO_FILTER:
      return _ramda2.default.merge(state, { endDate: action.data.update });
    case _documentFiltersActions.ORDER_BY:
      return (0, _documentsExportsFiltersFunctions.stateForOrderBy)(state, action.data.key);
    case _bootstrapActions.BOOTSTRAP_DOCUMENTS_ORDER:
      return _ramda2.default.merge(state, action.data);
    case _documentFiltersActions.ADD_CARD_NUMBER_TO_FILTER:
      return (0, _documentsExportsFiltersFunctions.addToSelectedCardNumbers)(state, action.data.update);
    case _documentFiltersActions.REMOVE_CARD_NUMBER_FROM_FILTER:
      return (0, _documentsExportsFiltersFunctions.removeSelectedCardNumber)(state, action.data.update);
    case _documentFiltersActions.ADD_SEARCH_QUERY_TO_FILTER:
      return (0, _documentsExportsFiltersFunctions.stateForAddSearchQueryToFilter)(state, action.data.update);
    case _documentFiltersActions.ADD_VIEWED_STATUS_TO_FILTER:
      return _ramda2.default.merge(state, { viewedStatus: action.data.update });
    case _documentFiltersActions.REMOVE_VIEWED_STATUS_FROM_FILTER:
      return _ramda2.default.merge(state, { viewedStatus: "" });
    case _documentFiltersActions.REMOVE_SEARCH_QUERY_FROM_FILTER:
      return _ramda2.default.merge(state, { searchQueryString: "", selectedSearchQueryString: null });
    case _documentFiltersActions.UPDATE_SEARCH_QUERY:
      return _ramda2.default.merge(state, { searchQueryString: action.data.query });
    case _documentFiltersActions.SET_TRASH_VIEW:
      return _ramda2.default.merge(state, { isTrash: action.data.update });
    case _documentFiltersActions.ADD_DOCUMENT_TYPE_TO_FILTER:
      return _ramda2.default.merge(state, { type: action.data.update });
    case _documentFiltersActions.REMOVE_DOCUMENT_TYPE_FROM_FILTER:
      return _ramda2.default.merge(state, { type: null });
    case _documentFiltersActions.UPDATE_TOTAL_FILTER:
      return stateForUpdateTotalFilter(state, action);
    case _documentFiltersActions.SET_FILTERS:
      return _ramda2.default.merge(state, action.data.filters);
    case _documentFiltersActions.UPDATE_NAME:
      return _ramda2.default.merge(state, { name: action.data.name });
    case _documentFiltersActions.ADD_NAME_TO_FILTER:
      return _ramda2.default.merge(state, { selectedName: state.name });
    case _documentFiltersActions.REMOVE_NAME_FROM_FILTER:
      return _ramda2.default.merge(state, { name: "", selectedName: "" });
    case _documentFiltersActions.RESET_FILTERS:
    case _customTabsActions.CUSTOM_TAB_CREATED:
      return initialState;
    default:
      return state;
  }
};

var stateForUpdateTotalFilter = function stateForUpdateTotalFilter(state, action) {
  if (action.data.type === "min") {
    return _ramda2.default.merge(state, { totalMin: action.data.value });
  }
  return _ramda2.default.merge(state, { totalMax: action.data.value });
};

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.documentsReducer = undefined;

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _documentsActions = __webpack_require__(161);

var _updateDocumentActions = __webpack_require__(163);

var _exportsActions = __webpack_require__(409);

var _bootstrapActions = __webpack_require__(60);

var _columnObjects = __webpack_require__(270);

var _documentFunctions = __webpack_require__(989);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  columns: _columnObjects.columnObjects,
  documents: [],
  filtersCount: 0,
  generatedShareUrl: "",
  glCodes: [],
  gridWidth: 0,
  intervalIds: [],
  isLoading: false,
  isBatchEditMode: false,
  isBatchEditLoading: false,
  isBatchCategoriesMode: false,
  isBatchCategoriesLoading: false,
  isBatchDownloadMode: false,
  isBatchDownloadLoading: false,
  isChangeDocTypeVisible: false,
  isDeletePermanentlyLoading: false,
  isDeletePermanentlyVisible: false,
  isDocumentViewerVisible: true,
  isDocViewerHamburgerMode: false,
  isDraggable: false,
  isEditColumnsVisible: false,
  isExportMode: false,
  isFiltersDrawerMode: false,
  isGLCodesLoading: true,
  isGLCodesVisible: false,
  isHamburgerMode: false,
  isMergeDocumentsLoading: false,
  isMergeDocumentsMode: false,
  isRestoreDocumentsLoading: false,
  isShareUrlVisible: false,
  isShiftPressed: false,
  isTrashMultipleDocumentsLoading: false,
  isTrashMultipleDocumentsVisible: false,
  isTrashDocumentVisible: false,
  mergeDocument: null,
  pagination: {
    pageNumber: 1,
    limit: 20,
    totalCount: 0,
    totalCountFiltered: 0,
    totalSumFiltered: 0
  },
  selectedDocumentIds: [],
  selectedMergeDocumentId: ""
};

var documentsReducer = exports.documentsReducer = function documentsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _documentsActions.LOADING_START:
      return _ramda2.default.merge(state, { isLoading: true });
    case _documentsActions.SET_DOCUMENTS:
      return (0, _documentFunctions.stateForSetDocuments)(state, action);
    case _documentsActions.SET_PAGINATION_LIMIT:
      return (0, _documentFunctions.stateForSetPaginationLimit)(state, action.data.update);
    case _documentsActions.NEXT_PAGE:
      return (0, _documentFunctions.stateForNextPage)(state);
    case _documentsActions.PREVIOUS_PAGE:
      return (0, _documentFunctions.stateForPreviousPage)(state);
    case _documentsActions.TOGGLE_COLUMN:
      return (0, _documentFunctions.stateForToggleColumn)(state, action.data.key);
    case _documentsActions.SET_EDIT_COLUMNS_VISIBILITY:
      return _ramda2.default.merge(state, { isEditColumnsVisible: action.data.visible });
    case _bootstrapActions.BOOTSTRAP_VISIBLE_DOCUMENTS_COLUMNS:
      return (0, _documentFunctions.stateForVisibleColumns)(state, action.data.columnKeys);
    case _documentsActions.SELECT_DOCUMENTS:
      return (0, _documentFunctions.stateForSelectDocuments)(state, action.data.documentIds);
    case _documentsActions.DESELECT_DOCUMENTS:
      return (0, _documentFunctions.stateForDeselectDocuments)(state, action.data.documentIds);
    case _documentsActions.START_BATCH_EDIT_MODE:
      return _ramda2.default.set(_ramda2.default.lensProp("isBatchEditMode"), true, state);
    case _documentsActions.END_BATCH_EDIT_MODE:
      return _ramda2.default.set(_ramda2.default.lensProp("isBatchEditMode"), false, state);
    case _documentsActions.BATCH_EDIT_LOADING:
      return _ramda2.default.set(_ramda2.default.lensProp("isBatchEditLoading"), true, state);
    case _documentsActions.BATCH_EDIT_LOADING_STOP:
      return _ramda2.default.set(_ramda2.default.lensProp("isBatchEditLoading"), false, state);
    case _updateDocumentActions.SAVE_DOCUMENT:
    case _updateDocumentActions.UPDATE_DOCUMENT_INLINE:
    case _documentsActions.DOCUMENT_VIEWED:
    case _exportsActions.SET_GL_CODE:
      return (0, _documentFunctions.updateDocumentState)(state, action);
    case _documentsActions.START_BATCH_CATEGORIES_MODE:
      return _ramda2.default.set(_ramda2.default.lensProp("isBatchCategoriesMode"), true, state);
    case _documentsActions.END_BATCH_CATEGORIES_MODE:
      return _ramda2.default.set(_ramda2.default.lensProp("isBatchCategoriesMode"), false, state);
    case _documentsActions.BATCH_ASSIGN_CATEGORIES_LOADING:
      return _ramda2.default.set(_ramda2.default.lensProp("isBatchCategoriesLoading"), true, state);
    case _documentsActions.BATCH_ASSIGN_CATEGORIES_LOADING_STOP:
      return _ramda2.default.set(_ramda2.default.lensProp("isBatchCategoriesLoading"), false, state);
    case _documentsActions.START_BATCH_DOWNLOAD_MODE:
      return _ramda2.default.set(_ramda2.default.lensProp("isBatchDownloadMode"), true, state);
    case _documentsActions.END_BATCH_DOWNLOAD_MODE:
      return _ramda2.default.merge(state, { isBatchDownloadMode: false, isBatchDownloadLoading: false });
    case _documentsActions.START_BATCH_DOWNLOAD_LOADING:
      return _ramda2.default.set(_ramda2.default.lensProp("isBatchDownloadLoading"), true, state);
    case _documentsActions.SET_TRASH_DOCUMENT_VISIBILITY:
      return _ramda2.default.merge(state, { isTrashDocumentVisible: action.data.visible });
    case _documentsActions.SET_CHANGE_DOCUMENT_TYPE_VISIBILITY:
      return _ramda2.default.merge(state, { isChangeDocTypeVisible: action.data.visible });
    case _documentsActions.SET_SHARE_URL_VISIBILITY:
      return _ramda2.default.merge(state, { isShareUrlVisible: action.data.visible, generatedShareUrl: "" });
    case _documentsActions.START_MERGE_DOCUMENTS_MODE:
      return _ramda2.default.merge(state, { isMergeDocumentsMode: true, defaultMergeDocument: action.data.mergeDocument });
    case _documentsActions.END_MERGE_DOCUMENTS_MODE:
      return _ramda2.default.merge(state, { isMergeDocumentsMode: false, defaultMergeDocument: null });
    case _documentsActions.MERGE_DOCUMENTS_LOADING:
      return _ramda2.default.set(_ramda2.default.lensProp("isMergeDocumentsLoading"), true, state);
    case _documentsActions.MERGE_DOCUMENTS_LOADING_STOP:
      return _ramda2.default.set(_ramda2.default.lensProp("isMergeDocumentsLoading"), false, state);
    case _documentsActions.SET_TRASH_MULTIPLE_DOCUMENTS_VISIBILITY:
      return _ramda2.default.merge(state, { isTrashMultipleDocumentsVisible: action.data.visible });
    case _documentsActions.TRASH_MULTIPLE_DOCUMENTS_LOADING:
      return _ramda2.default.merge(state, { isTrashMultipleDocumentsLoading: true });
    case _documentsActions.TRASH_MULTIPLE_DOCUMENTS_LOADING_STOP:
      return _ramda2.default.merge(state, { isTrashMultipleDocumentsLoading: false });
    case _documentsActions.START_HAMBURGER_MODE:
      return _ramda2.default.merge(state, { isHamburgerMode: true });
    case _documentsActions.END_HAMBURGER_MODE:
      return _ramda2.default.merge(state, { isHamburgerMode: false });
    case _documentsActions.START_DOC_VIEWER_HAMBURGER_MODE:
      return _ramda2.default.merge(state, { isDocViewerHamburgerMode: true });
    case _documentsActions.END_DOC_VIEWER_HAMBURGER_MODE:
      return _ramda2.default.merge(state, { isDocViewerHamburgerMode: false });
    case _documentsActions.START_DRAGGABILITY:
      return _ramda2.default.merge(state, { isDraggable: true });
    case _documentsActions.END_DRAGGABILITY:
      return _ramda2.default.merge(state, { isDraggable: false, isGLCodesVisible: false });
    case _updateDocumentActions.UNFOCUS_DOCUMENT:
      return _ramda2.default.merge(state, { isDraggable: false, isDocViewerHamburgerMode: false });
    case _documentsActions.START_FILTERS_DRAWER_MODE:
      return _ramda2.default.merge(state, { isFiltersDrawerMode: true });
    case _documentsActions.END_FILTERS_DRAWER_MODE:
      return _ramda2.default.merge(state, { isFiltersDrawerMode: false });
    case _documentsActions.RESTORE_DOCUMENTS_LOADING:
      return _ramda2.default.merge(state, { isRestoreDocumentsLoading: true });
    case _documentsActions.RESTORE_DOCUMENTS_LOADING_STOP:
      return _ramda2.default.merge(state, { isRestoreDocumentsLoading: false });
    case _documentsActions.DELETE_DOCUMENTS_PERMANENTLY_LOADING:
      return _ramda2.default.merge(state, { isDeletePermanentlyLoading: true });
    case _documentsActions.DELETE_DOCUMENTS_PERMANENTLY_LOADING_STOP:
      return _ramda2.default.merge(state, { isDeletePermanentlyLoading: false });
    case _documentsActions.SET_DELETE_PERMANENTLY_VISIBILITY:
      return _ramda2.default.merge(state, { isDeletePermanentlyVisible: action.data.visible });
    case _exportsActions.UPDATE_CELL:
      return (0, _documentFunctions.updateDocumentState)(state, action);
    case _documentsActions.SELECT_MERGE_DOCUMENT:
      return (0, _documentFunctions.stateForSelectMergeDocument)(state, action);
    case _documentsActions.DESELECT_MERGE_DOCUMENT:
      return _ramda2.default.merge(state, { selectedMergeDocumentId: "" });
    case _documentsActions.SELECT_MERGE_FIELD:
      return (0, _documentFunctions.stateForSelectMergeField)(state, action);
    case _documentsActions.DESELECT_ALL_DOCUMENTS:
      return _ramda2.default.merge(state, { selectedDocumentIds: [] });
    case _documentsActions.SET_DOCUMENT_VIEWER_VISIBILITY:
      return _ramda2.default.merge(state, { isDocumentViewerVisible: action.data.visible });
    case _documentsActions.SELECT_ALL_DOCUMENTS:
      return _ramda2.default.merge(state, { selectedDocumentIds: action.data.documentIds, documents: action.data.documents });
    case _documentsActions.SHARE_URL_GENERATED:
      return (0, _documentFunctions.stateForShareUrlGenerated)(state, action.data.shareUrl);
    case _documentsActions.SET_DOCUMENT_RULES:
      return _ramda2.default.merge(state, { documents: action.data.newDocuments, isGLCodesLoading: false });
    case _documentsActions.SHOW_GL_CODES_PANEL:
      return _ramda2.default.merge(state, { isGLCodesVisible: true });
    case _documentsActions.HIDE_GL_CODES_PANEL:
      return _ramda2.default.merge(state, { isGLCodesVisible: false });
    case _exportsActions.SPLIT_CATEGORIES:
      return _ramda2.default.merge(state, { glCodes: action.data.strippedGlCodes });
    case _documentsActions.DEFAULT_COLUMNS:
      return _ramda2.default.merge(state, { columns: _columnObjects.columnObjects });
    case _documentsActions.SET_GRID_WIDTH:
      return _ramda2.default.merge(state, { gridWidth: action.data.width });
    case _documentsActions.REFRESH_DOCUMENTS:
      return _ramda2.default.merge(state, { documents: action.data.documents });
    case _documentsActions.SET_REFRESH_INTERVALS:
      return _ramda2.default.merge(state, { intervalIds: action.data.intervalIds });
    case _documentsActions.CLEAR_REFRESH_INTERVALS:
      return _ramda2.default.merge(state, { intervalIds: [] });
    case _documentsActions.START_EXPORT_MODE:
      return _ramda2.default.merge(state, { isExportMode: true });
    case _documentsActions.END_EXPORT_MODE:
      return _ramda2.default.merge(state, { isExportMode: false });
    case _documentsActions.SHIFT_PRESSED:
      return _ramda2.default.merge(state, { isShiftPressed: true });
    case _documentsActions.SHIFT_RELEASED:
      return _ramda2.default.merge(state, { isShiftPressed: false });
    default:
      return state;
  }
};

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.envelopesReducer = exports.initialState = undefined;

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _bootstrapActions = __webpack_require__(60);

var _envelopesActions = __webpack_require__(264);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = exports.initialState = {
  coversheetUrl: "",
  envelopes: [],
  isLoading: true,
  isRequestEnvelopeVisible: false,
  isSendEnvelopeVisible: false
};

var envelopesReducer = exports.envelopesReducer = function envelopesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _bootstrapActions.BOOTSTRAP_ENVELOPES:
      return _ramda2.default.merge(state, { envelopes: action.data.envelopes });
    case _envelopesActions.SET_COVERSHEET:
      return _ramda2.default.merge(state, { coversheetUrl: action.data.coversheetUrl, isLoading: false });
    case _envelopesActions.SET_SEND_ENVELOPE_VISIBILITY:
      return _ramda2.default.merge(state, { isSendEnvelopeVisible: action.data.visibility });
    case _envelopesActions.SET_REQUEST_ENVELOPE_VISIBILITY:
      return _ramda2.default.merge(state, { isRequestEnvelopeVisible: action.data.visibility });
    default:
      return state;
  }
};

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stateForToggleColumn = exports.stateForVisibleColumns = exports.stateForShareUrlGenerated = exports.stateForSelectMergeDocument = exports.stateForSelectMergeField = exports.updateDocumentState = exports.stateForDeselectDocuments = exports.stateForSelectDocuments = exports.stateForPreviousPage = exports.stateForNextPage = exports.stateForSetPaginationLimit = exports.stateForSetDocuments = undefined;

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var stateForSetDocuments = exports.stateForSetDocuments = function stateForSetDocuments(state, action) {
  var totalSumFiltered = action.data.totalSumFiltered;
  var newPagination = _ramda2.default.merge(state.pagination, {
    totalCount: action.data.totalCount,
    totalCountFiltered: action.data.totalCountFiltered,
    totalSumFiltered: totalSumFiltered ? totalSumFiltered.amount.toFixed(2) : "0.00",
    pageNumber: action.data.resetPageNumber ? 1 : state.pagination.pageNumber
  });
  return _ramda2.default.merge(state, {
    filtersCount: action.data.filtersCount,
    isBatchEditMode: false,
    isLoading: false,
    documents: _ramda2.default.path(["data", "documents"], action),
    pagination: newPagination,
    selectedDocumentIds: []
  });
};

var stateForSetPaginationLimit = exports.stateForSetPaginationLimit = function stateForSetPaginationLimit(state, limit) {
  var stateWithLimit = _ramda2.default.set(_ramda2.default.lensPath(["pagination", "limit"]), limit, state);
  return _ramda2.default.set(_ramda2.default.lensPath(["pagination", "pageNumber"]), 1, stateWithLimit);
};

var stateForNextPage = exports.stateForNextPage = function stateForNextPage(state) {
  var pagination = state.pagination;

  var currentPage = pagination.pageNumber;
  var maxPage = Math.ceil(pagination.totalCountFiltered / pagination.limit);

  if (currentPage >= maxPage) {
    return state;
  }
  return _ramda2.default.set(_ramda2.default.lensPath(["pagination", "pageNumber"]), currentPage + 1, state);
};

var stateForPreviousPage = exports.stateForPreviousPage = function stateForPreviousPage(state) {
  var currentPage = state.pagination.pageNumber;
  if (currentPage <= 1) {
    return state;
  }
  return _ramda2.default.set(_ramda2.default.lensPath(["pagination", "pageNumber"]), currentPage - 1, state);
};

var stateForSelectDocuments = exports.stateForSelectDocuments = function stateForSelectDocuments(state, documentIds) {
  var newDocumentIds = typeof documentIds === "string" ? [documentIds] : documentIds;
  var currentIds = state.selectedDocumentIds;
  var newIds = newDocumentIds.filter(function (id) {
    return !currentIds.includes(id);
  });
  var appendedIds = _ramda2.default.append(newIds, currentIds);
  return _ramda2.default.merge(state, { selectedDocumentIds: _ramda2.default.flatten(appendedIds) });
};

var stateForDeselectDocuments = exports.stateForDeselectDocuments = function stateForDeselectDocuments(state, documentIds) {
  var currentIds = state.selectedDocumentIds;
  var newIds = currentIds.filter(function (id) {
    return !documentIds.includes(id);
  });
  return _ramda2.default.merge(state, { selectedDocumentIds: newIds });
};

var updateDocumentState = exports.updateDocumentState = function updateDocumentState(state, action) {
  var updatedDocumentIndex = _ramda2.default.findIndex(_ramda2.default.propEq("id", action.data.document.id))(state.documents);
  var lens = _ramda2.default.lensIndex(updatedDocumentIndex);
  var oldDocument = _ramda2.default.findIndex(lens, state.documents);
  var updatedDocument = _ramda2.default.merge(oldDocument, action.data.document);
  var newDocuments = _ramda2.default.set(lens, updatedDocument, state.documents);
  return _ramda2.default.merge(state, { documents: newDocuments });
};

var stateForSelectMergeField = exports.stateForSelectMergeField = function stateForSelectMergeField(state, action) {
  var data = function data(str) {
    try {
      return JSON.parse(str);
    } catch (e) {
      return str;
    }
  };

  var mergeObject = {
    id: action.data.id,
    data: data(action.data.data)
  };
  return _ramda2.default.set(_ramda2.default.lensPath(["mergeDocument", action.data.field]), mergeObject, state);
};

var stateForSelectMergeDocument = exports.stateForSelectMergeDocument = function stateForSelectMergeDocument(state, action) {
  return _ramda2.default.merge(state, {
    selectedMergeDocumentId: action.data.id,
    mergeDocument: null
  });
};

var stateForShareUrlGenerated = exports.stateForShareUrlGenerated = function stateForShareUrlGenerated(state, shareUrl) {
  return _ramda2.default.merge(state, { generatedShareUrl: shareUrl });
};

var stateForVisibleColumns = exports.stateForVisibleColumns = function stateForVisibleColumns(state, columnKeys) {
  var newColumns = state.columns.map(function (col) {
    if (columnKeys.includes(col.key)) {
      return _ramda2.default.set(_ramda2.default.lensProp("visible"), true, col);
    }
    return _ramda2.default.set(_ramda2.default.lensProp("visible"), false, col);
  });

  return _ramda2.default.merge(state, { columns: newColumns });
};

var stateForToggleColumn = exports.stateForToggleColumn = function stateForToggleColumn(state, key) {
  var index = _ramda2.default.findIndex(_ramda2.default.propEq("key", key))(state.columns);
  var column = state.columns[index];
  var newColumn = _ramda2.default.set(_ramda2.default.lensProp("visible"), !column.visible, column);
  var newColumns = _ramda2.default.set(_ramda2.default.lensIndex(index), newColumn, state.columns);

  return _ramda2.default.merge(state, { columns: newColumns });
};

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stateForAddSearchQueryToFilter = exports.removeSelectedCardNumber = exports.addToSelectedCardNumbers = exports.removeSelectedCurrency = exports.removeSelectedEnvelope = exports.addToSelectedEnvelopes = exports.removeSelectedCategory = exports.removeSelectedPaymentType = exports.removeSelectedVendor = exports.addToSelectedCurrencies = exports.addToSelectedCategories = exports.addToSelectedPaymentTypes = exports.addToSelectedVendors = exports.stateForOrderBy = undefined;

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var stateForOrderBy = exports.stateForOrderBy = function stateForOrderBy(state, key) {
  if (key === state.orderBy) {
    var newDirection = state.orderDirection === "DESC" ? "ASC" : "DESC";
    return _ramda2.default.set(_ramda2.default.lensProp("orderDirection"), newDirection, state);
  }

  return _ramda2.default.merge(state, { orderBy: key, orderDirection: "ASC" });
};

var addToSelectedVendors = exports.addToSelectedVendors = function addToSelectedVendors(state, name) {
  var selectedVendors = state.selectedVendors;

  if (_ramda2.default.contains(name, selectedVendors)) {
    return state;
  }
  return _ramda2.default.merge(state, { selectedVendors: _ramda2.default.append(name, selectedVendors) });
};

var addToSelectedPaymentTypes = exports.addToSelectedPaymentTypes = function addToSelectedPaymentTypes(state, key) {
  var selectedPaymentTypes = state.selectedPaymentTypes;

  if (key === "none") {
    return _ramda2.default.merge(state, { selectedPaymentTypes: ["none"] });
  }

  if (_ramda2.default.contains(name, selectedPaymentTypes)) {
    return state;
  }
  var newSelectedPaymentTypes = _ramda2.default.append(key, selectedPaymentTypes).filter(function (type) {
    return type !== "none";
  });
  return _ramda2.default.merge(state, { selectedPaymentTypes: newSelectedPaymentTypes });
};

var addToSelectedCategories = exports.addToSelectedCategories = function addToSelectedCategories(state, name) {
  var selectedCategories = state.selectedCategories;

  if (_ramda2.default.contains(name, selectedCategories)) {
    return state;
  }
  return _ramda2.default.merge(state, { selectedCategories: _ramda2.default.append(name, selectedCategories) });
};

var addToSelectedCurrencies = exports.addToSelectedCurrencies = function addToSelectedCurrencies(state, key) {
  var selectedCurrencies = state.selectedCurrencies;

  if (_ramda2.default.contains(name, selectedCurrencies)) {
    return state;
  }
  return _ramda2.default.merge(state, { selectedCurrencies: _ramda2.default.append(key, selectedCurrencies) });
};

var removeSelectedVendor = exports.removeSelectedVendor = function removeSelectedVendor(state, name) {
  var selectedVendors = state.selectedVendors;

  var newSelectedVendors = selectedVendors.filter(function (vendor) {
    return vendor !== name;
  });
  return _ramda2.default.merge(state, { selectedVendors: newSelectedVendors });
};

var removeSelectedPaymentType = exports.removeSelectedPaymentType = function removeSelectedPaymentType(state, key) {
  if (key === "none") {
    return _ramda2.default.merge(state, { selectedPaymentTypes: [] });
  }
  var selectedPaymentTypes = state.selectedPaymentTypes;

  var newSelectedPaymentTypes = selectedPaymentTypes.filter(function (type) {
    return type !== key;
  });
  return _ramda2.default.merge(state, { selectedPaymentTypes: newSelectedPaymentTypes });
};

var removeSelectedCategory = exports.removeSelectedCategory = function removeSelectedCategory(state, name) {
  var selectedCategories = state.selectedCategories;

  var newSelectedCategories = selectedCategories.filter(function (category) {
    return category !== name;
  });
  return _ramda2.default.merge(state, { selectedCategories: newSelectedCategories });
};

var addToSelectedEnvelopes = exports.addToSelectedEnvelopes = function addToSelectedEnvelopes(state, code) {
  var selectedEnvelopes = state.selectedEnvelopes;

  if (_ramda2.default.contains(code, selectedEnvelopes)) {
    return state;
  }
  return _ramda2.default.merge(state, { selectedEnvelopes: _ramda2.default.append(code, selectedEnvelopes) });
};

var removeSelectedEnvelope = exports.removeSelectedEnvelope = function removeSelectedEnvelope(state, code) {
  var selectedEnvelopes = state.selectedEnvelopes;

  var newSelectedEnvelopes = selectedEnvelopes.filter(function (envelope) {
    return envelope !== code;
  });
  return _ramda2.default.merge(state, { selectedEnvelopes: newSelectedEnvelopes });
};

var removeSelectedCurrency = exports.removeSelectedCurrency = function removeSelectedCurrency(state, key) {
  var selectedCurrencies = state.selectedCurrencies;

  var newSelectedCurrencies = selectedCurrencies.filter(function (currency) {
    return currency !== key;
  });
  return _ramda2.default.merge(state, { selectedCurrencies: newSelectedCurrencies });
};

var addToSelectedCardNumbers = exports.addToSelectedCardNumbers = function addToSelectedCardNumbers(state, key) {
  var selectedCardNumbers = state.selectedCardNumbers;

  if (_ramda2.default.contains(key, selectedCardNumbers)) {
    return state;
  }
  return _ramda2.default.merge(state, { selectedCardNumbers: _ramda2.default.append(key, selectedCardNumbers) });
};

var removeSelectedCardNumber = exports.removeSelectedCardNumber = function removeSelectedCardNumber(state, key) {
  var selectedCardNumbers = state.selectedCardNumbers;

  var newSelectedCardNumbers = selectedCardNumbers.filter(function (card) {
    return card !== key;
  });
  return _ramda2.default.merge(state, { selectedCardNumbers: newSelectedCardNumbers });
};

var stateForAddSearchQueryToFilter = exports.stateForAddSearchQueryToFilter = function stateForAddSearchQueryToFilter(state, query) {
  if (query === "") {
    return _ramda2.default.merge(state, { selectedSearchQueryString: null });
  }
  return _ramda2.default.merge(state, {
    searchQueryString: "",
    selectedSearchQueryString: query
  });
};

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducers = undefined;

var _redux = __webpack_require__(100);

var _reduxForm = __webpack_require__(35);

var _appReducer = __webpack_require__(980);

var _oauthReducer = __webpack_require__(992);

var _documentsReducer = __webpack_require__(987);

var _documentFiltersReducer = __webpack_require__(986);

var _vendorsReducer = __webpack_require__(997);

var _categoriesReducer = __webpack_require__(982);

var _currenciesReducer = __webpack_require__(983);

var _envelopesReducer = __webpack_require__(988);

var _updateDocumentReducer = __webpack_require__(995);

var _accountSettingsReducer = __webpack_require__(979);

var _cardNumbersReducer = __webpack_require__(981);

var _userSettingsReducer = __webpack_require__(996);

var _reportsReducer = __webpack_require__(994);

var _dashboardReducer = __webpack_require__(985);

var _pendingDocumentsReducer = __webpack_require__(993);

var _customTabsReducer = __webpack_require__(984);

var reducers = exports.reducers = (0, _redux.combineReducers)({
  accountSettings: _accountSettingsReducer.accountSettingsReducer,
  app: _appReducer.appReducer,
  cardNumbers: _cardNumbersReducer.cardNumbersReducer,
  oauth: _oauthReducer.oauthReducer,
  form: _reduxForm.reducer,
  documents: _documentsReducer.documentsReducer,
  documentFilters: _documentFiltersReducer.documentFiltersReducer,
  vendors: _vendorsReducer.vendorsReducer,
  categories: _categoriesReducer.categoriesReducer,
  currencies: _currenciesReducer.currenciesReducer,
  envelopes: _envelopesReducer.envelopesReducer,
  updateDocument: _updateDocumentReducer.updateDocumentReducer,
  userSettings: _userSettingsReducer.userSettingsReducer,
  reports: _reportsReducer.reportsReducer,
  dashboard: _dashboardReducer.dashboardReducer,
  pendingDocuments: _pendingDocumentsReducer.pendingDocumentsReducer,
  customTabs: _customTabsReducer.customTabsReducer
});

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.oauthReducer = exports.initialState = undefined;

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _oauthActions = __webpack_require__(162);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = exports.initialState = {
  token: null,
  oauthState: null
};

var oauthReducer = exports.oauthReducer = function oauthReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _oauthActions.SET_OAUTH_STATE:
      return _ramda2.default.merge(state, { oauthState: action.data });
    case _oauthActions.SET_OAUTH_TOKEN:
      return _ramda2.default.merge(state, { oauthState: null, token: action.data });
    default:
      return state;
  }
};

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pendingDocumentsReducer = exports.initialState = undefined;

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _pendingDocumentsActions = __webpack_require__(195);

var _updateDocumentActions = __webpack_require__(163);

var _accountSettingsActions = __webpack_require__(67);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = exports.initialState = {
  documentType: "receipt",
  focusedDocument: null,
  isBeingCancelled: false,
  isCancelProcessingLoading: false,
  isCancelProcessingVisible: false,
  isFiltersMode: false,
  isLoading: false,
  isTrashDocumentVisible: false,
  isUploadLoading: false,
  pendingDocuments: [],
  pendingFilters: [],
  sourceFilter: null,
  statusFilter: null,
  submissionEmail: ""
};

var pendingDocumentsReducer = exports.pendingDocumentsReducer = function pendingDocumentsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _accountSettingsActions.SET_ACCOUNT_DETAILS:
      return _ramda2.default.merge(state, { submissionEmail: action.data.accountDetails.dropboxEmail });
    case _pendingDocumentsActions.DOCUMENT_UPLOADED:
      return _ramda2.default.merge(state, { pendingDocuments: _ramda2.default.prepend(action.data.data, state.pendingDocuments) });
    case _pendingDocumentsActions.SET_PENDING_DOCUMENTS:
      return stateForSetPendingDocuments(state, action);
    case _pendingDocumentsActions.LOADING_START:
      return _ramda2.default.merge(state, { isLoading: true });
    case _pendingDocumentsActions.FOCUS_PENDING_DOCUMENT:
      return stateForFocusPendingDocument(state, action);
    case _pendingDocumentsActions.CANCEL_PROCESSING:
      return stateForCancelProcessing(state, action);
    case _pendingDocumentsActions.SET_TRASH_DOCUMENT_VISIBILITY:
      return _ramda2.default.merge(state, { isTrashDocumentVisible: action.data.visibility });
    case _pendingDocumentsActions.CANCEL_PROCESSING_ALL_DOCUMENTS:
      return _ramda2.default.merge(state, { pendingDocuments: action.data.documents, isBeingCancelled: true });
    case _pendingDocumentsActions.PROCESS_ALL_DOCUMENTS:
      return _ramda2.default.merge(state, { pendingDocuments: action.data.documents, isBeingCancelled: false });
    case _pendingDocumentsActions.REPROCESS_PENDING_DOCUMENT:
      return _ramda2.default.merge(state, {
        focusedDocument: action.data.newDocument,
        isCancelProcessingVisible: true
      });
    case _pendingDocumentsActions.CHANGE_DOCUMENT_TYPE:
      return _ramda2.default.merge(state, { documentType: action.data.type });
    case _pendingDocumentsActions.UPLOAD_LOADING_START:
      return _ramda2.default.merge(state, { isUploadLoading: true });
    case _pendingDocumentsActions.UPLOAD_LOADING_END:
      return _ramda2.default.merge(state, { isUploadLoading: false });
    case _pendingDocumentsActions.CANCEL_PROCESSING_LOADING:
      return _ramda2.default.merge(state, { isCancelProcessingLoading: true });
    case _pendingDocumentsActions.CANCEL_PROCESSING_LOADING_STOP:
      return _ramda2.default.merge(state, { isCancelProcessingLoading: false });
    case _updateDocumentActions.REPROCESS_DOCUMENT:
      return stateForReprocessDocument(state, action);
    case _pendingDocumentsActions.ADD_STUCK_STATUS_FILTER:
      return _ramda2.default.merge(state, { statusFilter: action.data.filter });
    case _pendingDocumentsActions.ADD_SOURCE_FILTER:
      return _ramda2.default.merge(state, { sourceFilter: action.data.filter });
    case _pendingDocumentsActions.REMOVE_STUCK_STATUS_FILTER:
      return _ramda2.default.merge(state, { statusFilter: null });
    case _pendingDocumentsActions.REMOVE_SOURCE_FILTER:
      return _ramda2.default.merge(state, { sourceFilter: null });
    case _pendingDocumentsActions.START_FILTERS_MODE:
      return _ramda2.default.merge(state, { isFiltersMode: true });
    case _pendingDocumentsActions.END_FILTERS_MODE:
      return _ramda2.default.merge(state, { isFiltersMode: false });
    default:
      return state;
  }
};

var stateForFocusPendingDocument = function stateForFocusPendingDocument(state, action) {
  var visibility = action.data.document.processingState !== "NEEDS_USER_PROCESSING";
  return _ramda2.default.merge(state, {
    focusedDocument: action.data.document,
    isCancelProcessingVisible: visibility
  });
};

var stateForSetPendingDocuments = function stateForSetPendingDocuments(state, action) {
  var visibility = true;
  if ((action.data.newDocuments[0] || []).processingState === "NEEDS_USER_PROCESSING") {
    visibility = false;
  }
  return _ramda2.default.merge(state, {
    focusedDocument: action.data.newDocuments[0],
    isCancelProcessingVisible: visibility,
    isLoading: false,
    pendingDocuments: action.data.newDocuments
  });
};

var stateForReprocessDocument = function stateForReprocessDocument(state, action) {
  var newPendingDocuments = _ramda2.default.append(action.data.newDocument, state.pendingDocuments);
  return _ramda2.default.merge(state, { pendingDocuments: newPendingDocuments });
};

var stateForCancelProcessing = function stateForCancelProcessing(state, action) {
  var updatedDocumentIndex = _ramda2.default.findIndex(_ramda2.default.propEq("id", action.data.newDocument.id))(state.pendingDocuments);
  var lens = _ramda2.default.lensIndex(updatedDocumentIndex);
  var oldDocument = _ramda2.default.findIndex(lens, state.pendingDocuments);
  var updatedDocument = _ramda2.default.merge(oldDocument, action.data.newDocument);
  var newPendingDocuments = _ramda2.default.set(lens, updatedDocument, state.pendingDocuments);
  return _ramda2.default.merge(state, {
    focusedDocument: action.data.newDocument,
    isCancelProcessingVisible: false,
    pendingDocuments: newPendingDocuments
  });
};

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportsReducer = exports.initialState = undefined;

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _reportsActions = __webpack_require__(410);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = exports.initialState = {
  reports: []
};

var reportsReducer = exports.reportsReducer = function reportsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _reportsActions.SET_REPORTS:
      return stateForSetReports(state, action);
    default:
      return state;
  }
};

var stateForSetReports = function stateForSetReports(state, action) {
  var newReports = action.data.reports.map(function (report) {
    if (report.name === null || report.name === undefined) {
      return _ramda2.default.set(_ramda2.default.lensProp("name"), "", report);
    }
    return report;
  });
  return _ramda2.default.merge(state, { reports: newReports });
};

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateDocumentReducer = exports.initialState = undefined;

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _updateDocumentActions = __webpack_require__(163);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = exports.initialState = {
  attachment: null,
  categories: [],
  currency: "",
  downloadUrl: "",
  issued: "",
  id: null,
  invoiceNumber: "",
  name: "",
  notes: "",
  paymentType: { type: "other" },
  processingState: "PROCESSED",
  shareUrl: "",
  style: null,
  tax: 0,
  total: 0,
  type: "",
  vendor: ""
};

var updateDocumentReducer = exports.updateDocumentReducer = function updateDocumentReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _updateDocumentActions.FOCUS_DOCUMENT:
      return stateForFocusDocument(state, action);
    case _updateDocumentActions.UPDATE_PAYMENT_TYPE:
      return stateForUpdatePaymentType(state, action);
    case _updateDocumentActions.UPDATE_DOCUMENT:
    case _updateDocumentActions.UPDATE_DOCUMENT_INLINE:
      return _ramda2.default.merge(state, _defineProperty({}, action.data.field, action.data.value));
    case _updateDocumentActions.UNFOCUS_DOCUMENT:
    case _updateDocumentActions.SAVE_DOCUMENT:
      return initialState;
    default:
      return state;
  }
};

var stateForFocusDocument = function stateForFocusDocument(state, action) {
  var document = _ramda2.default.merge(initialState, action.data.row);
  return _ramda2.default.merge(document, { style: action.data.style });
};

var stateForUpdatePaymentType = function stateForUpdatePaymentType(state, action) {
  var newPaymentType = _ramda2.default.set(_ramda2.default.lensProp(action.data.field), action.data.value, state.paymentType);
  return _ramda2.default.merge(state, { paymentType: newPaymentType });
};

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userSettingsReducer = exports.initialState = undefined;

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _userSettingsActions = __webpack_require__(137);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = exports.initialState = {
  email: null,
  favouriteAccountId: null,
  isBetaDefault: false,
  isBetaDefaultLoading: true,
  isFavouriteAccountLoading: true,
  isUpdateDefaultInterfaceLoading: false,
  isUserNameLoading: true,
  name: null,
  surname: null
};

var userSettingsReducer = exports.userSettingsReducer = function userSettingsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _userSettingsActions.SET_USER_SETTINGS:
      return stateForSetUserSettings(state, action);
    case _userSettingsActions.UPDATE_USER_EMAIL:
      return _ramda2.default.merge(state, { email: action.data.email });
    case _userSettingsActions.UPDATE_USER_NAME:
      return _ramda2.default.merge(state, { name: action.data.userDetails.name, surname: action.data.userDetails.surname });
    case _userSettingsActions.SET_FAVOURITE_ACCOUNT:
      return _ramda2.default.merge(state, { favouriteAccountId: action.data.accountId, isFavouriteAccountLoading: false });
    case _userSettingsActions.UPDATE_FAVOURITE_ACCOUNT:
      return _ramda2.default.merge(state, { favouriteAccountId: action.data.accountId });
    case _userSettingsActions.UPDATE_DEFAULT_INTERFACE:
    case _userSettingsActions.SET_DEFAULT_INTERFACE:
      return _ramda2.default.merge(state, { isBetaDefault: action.data.isBetaDefault, isBetaDefaultLoading: false });
    case _userSettingsActions.UPDATE_DEFAULT_INTERFACE_LOADING:
      return _ramda2.default.merge(state, { isUpdateDefaultInterfaceLoading: true });
    case _userSettingsActions.UPDATE_DEFAULT_INTERFACE_LOADING_STOP:
      return _ramda2.default.merge(state, { isUpdateDefaultInterfaceLoading: false });
    default:
      return state;
  }
};

var stateForSetUserSettings = function stateForSetUserSettings(state, action) {
  return _ramda2.default.merge(state, {
    email: action.data.email,
    isUserNameLoading: false,
    name: action.data.name,
    surname: action.data.surname
  });
};

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.vendorsReducer = exports.initialState = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _bootstrapActions = __webpack_require__(60);

var _vendorsActions = __webpack_require__(412);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = exports.initialState = {
  isAddVendorRulesLoading: false,
  isAddVendorRulesMode: false,
  isLoading: true,
  isMergeVendorsLoading: false,
  isMergeVendorsMode: false,
  orderBy: "name",
  orderDirection: "ASC",
  selectedCategory: null,
  selectedVendorIds: [],
  selectedVendor: null,
  vendors: []
};

var vendorsReducer = exports.vendorsReducer = function vendorsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _bootstrapActions.BOOTSTRAP_VENDORS:
    case _vendorsActions.MERGE_VENDORS:
      return _ramda2.default.merge(state, { vendors: action.data.vendors });
    case _vendorsActions.LOADING_START:
      return _ramda2.default.merge(state, { isLoading: true });
    case _vendorsActions.LOADING_STOP:
      return _ramda2.default.merge(state, { isLoading: false });
    case _vendorsActions.FETCH_VENDORS:
      return _ramda2.default.merge(state, { vendors: action.data.newVendors, isLoading: false });
    case _vendorsActions.SELECT_VENDORS:
      return stateForSelectVendors(state, action.data.vendorIds);
    case _vendorsActions.DESELECT_VENDORS:
      return stateForDeselectVendors(state, action.data.vendorIds);
    case _vendorsActions.ADD_VENDOR_RULES:
      return stateForAddVendorRules(state, action);
    case _vendorsActions.ADD_VENDOR_RULES_LOADING:
      return _ramda2.default.merge(state, { isAddVendorRulesLoading: true });
    case _vendorsActions.ADD_VENDOR_RULES_LOADING_STOP:
      return _ramda2.default.merge(state, { isAddVendorRulesLoading: false });
    case _vendorsActions.START_ADD_VENDOR_RULES_MODE:
      return _ramda2.default.merge(state, { isAddVendorRulesMode: true });
    case _vendorsActions.END_ADD_VENDOR_RULES_MODE:
      return _ramda2.default.merge(state, { isAddVendorRulesMode: false });
    case _vendorsActions.SELECT_CATEGORY_FOR_RULE:
      return _ramda2.default.merge(state, { selectedCategory: action.data.category });
    case _vendorsActions.DELETE_VENDOR_RULE:
      return stateForDeleteVendorRule(state, action);
    case _vendorsActions.ORDER_VENDORS:
      return stateForOrderVendors(state, action);
    case _vendorsActions.START_MERGE_VENDORS_MODE:
      return _ramda2.default.merge(state, { isMergeVendorsMode: true });
    case _vendorsActions.END_MERGE_VENDORS_MODE:
      return _ramda2.default.merge(state, { isMergeVendorsMode: false });
    case _vendorsActions.SELECT_MERGE_VENDOR:
      return _ramda2.default.merge(state, { selectedVendor: action.data.vendor });
    case _vendorsActions.MERGE_VENDORS_LOADING_START:
      return _ramda2.default.merge(state, { isMergeVendorsLoading: true });
    case _vendorsActions.MERGE_VENDORS_LOADING_STOP:
      return stateForMergeVendorsLoadingStop(state);
    default:
      return state;
  }
};

var stateForSelectVendors = function stateForSelectVendors(state, vendorIds) {
  var vendorIdsArray = vendorIds;
  if (typeof vendorIds === "string") {
    vendorIdsArray = [vendorIds];
  }
  if ((typeof vendorIds === "undefined" ? "undefined" : _typeof(vendorIds)) === "object" && vendorIds.id) {
    vendorIdsArray = [vendorIds.id];
  }
  var currentIds = state.selectedVendorIds;
  var newIds = vendorIdsArray.filter(function (id) {
    return !currentIds.includes(id);
  });
  var appendedIds = _ramda2.default.append(newIds, currentIds);
  return _ramda2.default.merge(state, { selectedVendorIds: _ramda2.default.flatten(appendedIds) });
};

var stateForDeselectVendors = function stateForDeselectVendors(state, vendorIds) {
  var currentIds = state.selectedVendorIds;
  var newIds = currentIds.filter(function (id) {
    return !vendorIds.includes(id);
  });
  return _ramda2.default.merge(state, { selectedVendorIds: newIds });
};

var stateForAddVendorRules = function stateForAddVendorRules(state, action) {
  var category = _ramda2.default.find(_ramda2.default.propEq("id", action.data.category.info))(action.data.categories);
  var newVendors = state.vendors.map(function (vendor) {
    if (action.data.vendors.indexOf(vendor.name) > -1) {
      var newIncludeRules = _ramda2.default.append(action.data.vendorRule, vendor.rules.includeVendors);
      var newCategory = _ramda2.default.set(_ramda2.default.lensPath(["rules", "includeVendors"]), newIncludeRules, category);
      return _ramda2.default.set(_ramda2.default.lensProp("rules"), _ramda2.default.append(newCategory, vendor.rules), vendor);
    }
    return vendor;
  });
  return _ramda2.default.merge(state, { vendors: newVendors });
};

var stateForDeleteVendorRule = function stateForDeleteVendorRule(state, action) {
  var index = _ramda2.default.findIndex(_ramda2.default.propEq("name", action.data.vendor.vendorName))(state.vendors);
  var vendor = _ramda2.default.find(_ramda2.default.propEq("name", action.data.vendor.vendorName))(state.vendors);
  var newRules = _ramda2.default.reject(_ramda2.default.propEq("id", action.data.category.id), vendor.rules);
  var newVendor = _ramda2.default.set(_ramda2.default.lensProp("rules"), newRules, vendor);
  var newVendors = _ramda2.default.update(index, newVendor, state.vendors);
  return _ramda2.default.merge(state, { vendors: newVendors });
};

var stateForOrderVendors = function stateForOrderVendors(state, action) {
  var column = action.data.column;
  switch (action.data.column) {
    case "name":
      return orderBy(state, column, function (a, b) {
        return b[column].localeCompare(a[column]);
      });
    case "receipts":
      return orderBy(state, column, function (a, b) {
        return b[column] - a[column];
      });
    case "rules":
      return orderBy(state, column, function (a, b) {
        return b[column].length - a[column].length;
      });
    default:
      return state.vendors;
  }
};

var orderBy = function orderBy(state, column, sortFunction) {
  if (state.orderDirection === "ASC") {
    return _ramda2.default.merge(state, {
      orderBy: column,
      orderDirection: "DSC",
      vendors: _ramda2.default.sort(sortFunction, state.vendors)
    });
  }
  return _ramda2.default.merge(state, {
    orderBy: column,
    orderDirection: "ASC",
    vendors: _ramda2.default.reverse(_ramda2.default.sort(sortFunction, state.vendors))
  });
};

var stateForMergeVendorsLoadingStop = function stateForMergeVendorsLoadingStop(state) {
  return _ramda2.default.merge(state, {
    isMergeVendorsLoading: false,
    isMergeVendorsMode: false,
    selectedVendor: null,
    selectedVendorIds: []
  });
};

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(32);

var _customPropTypes = __webpack_require__(5);

var _appContainer = __webpack_require__(949);

var _accountRedirector = __webpack_require__(948);

var _documentsContainer = __webpack_require__(953);

var _pendingDocumentsContainer = __webpack_require__(960);

var _pageNotFoundContainer = __webpack_require__(959);

var _oauthContainer = __webpack_require__(958);

var _reportsContainer = __webpack_require__(961);

var _accountSettingsContainer = __webpack_require__(964);

var _accountUsageContainer = __webpack_require__(965);

var _mailInSettingsContainer = __webpack_require__(973);

var _subscriptionSettingsContainer = __webpack_require__(974);

var _billingDetailsContainer = __webpack_require__(968);

var _billingHistoryContainer = __webpack_require__(969);

var _accountNameAndEmailContainer = __webpack_require__(963);

var _currencyTaxLanguageContainer = __webpack_require__(970);

var _accountUsersContainer = __webpack_require__(966);

var _userSettingsContainer = __webpack_require__(977);

var _userPasswordContainer = __webpack_require__(976);

var _userNameAndEmailContainer = __webpack_require__(975);

var _manageEnvelopesContainer = __webpack_require__(439);

var _dashboardContainer = __webpack_require__(952);

var _manageCategoriesContainer = __webpack_require__(955);

var _uploadDocumentsContainer = __webpack_require__(978);

var _manageVendorsContainer = __webpack_require__(956);

var _integrationSettingsContainer = __webpack_require__(972);

var _betaSettingsContainer = __webpack_require__(967);

var _favouriteAccountContainer = __webpack_require__(971);

var _setUpIntegrationContainer = __webpack_require__(962);

var _customTabContainer = __webpack_require__(951);

var _myDocumentsContainer = __webpack_require__(957);

var _awaitingMailinContainer = __webpack_require__(950);

var _issueTrackingFormContainer = __webpack_require__(954);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = _react2.default.createElement(
  _reactRouter.Router,
  { history: _reactRouter.browserHistory },
  _react2.default.createElement(
    _reactRouter.Route,
    { component: _appContainer.AppContainer, path: "/accounts/:accountSlug" },
    _react2.default.createElement(_reactRouter.Route, { component: _dashboardContainer.DashboardContainer, path: "dashboard" }),
    _react2.default.createElement(_reactRouter.Route, { component: _uploadDocumentsContainer.UploadDocumentsContainer, path: "upload" }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "documents", to: "documents/all" }),
    _react2.default.createElement(
      _reactRouter.Route,
      { component: _myDocumentsContainer.MyDocumentsContainer, path: "documents" },
      _react2.default.createElement(_reactRouter.Route, { component: function component(props) {
          return createElement(_documentsContainer.DocumentsContainer, props);
        }, exact: true, path: "all" }),
      _react2.default.createElement(_reactRouter.Route, { component: function component(props) {
          return createElement(_documentsContainer.DocumentsContainer, props);
        }, path: "filter/:filter" }),
      _react2.default.createElement(_reactRouter.Route, { component: function component(props) {
          return createElement(_documentsContainer.DocumentsContainer, props);
        }, path: "this-financial-year" }),
      _react2.default.createElement(_reactRouter.Route, { component: function component(props) {
          return createElement(_documentsContainer.DocumentsContainer, props);
        }, path: "custom/:customTab" }),
      _react2.default.createElement(_reactRouter.Route, { component: _customTabContainer.CustomTabContainer, path: "custom-tab" }),
      _react2.default.createElement(_reactRouter.Route, { component: _setUpIntegrationContainer.SetUpIntegrationContainer, path: "set-up-integration" }),
      _react2.default.createElement(_reactRouter.Route, { path: ":envelopeCode" })
    ),
    _react2.default.createElement(_reactRouter.Route, { component: _reportsContainer.ReportsContainer, path: "reports" }),
    _react2.default.createElement(_reactRouter.Route, { component: _manageEnvelopesContainer.ManageEnvelopesContainer, path: "manage-envelopes" }),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: "settings" },
      _react2.default.createElement(
        _reactRouter.Route,
        { component: _accountSettingsContainer.AccountSettingsContainer, path: "account" },
        _react2.default.createElement(_reactRouter.Route, { component: _accountUsageContainer.AccountUsageContainer, path: "usage" }),
        _react2.default.createElement(_reactRouter.Route, { component: _mailInSettingsContainer.MailInSettingsContainer, path: "mail-in" }),
        _react2.default.createElement(_reactRouter.Route, { component: _subscriptionSettingsContainer.SubscriptionSettingsContainer, path: "subscription" }),
        _react2.default.createElement(_reactRouter.Route, { component: _billingDetailsContainer.BillingDetailsContainer, path: "billing-details" }),
        _react2.default.createElement(_reactRouter.Route, { component: _billingHistoryContainer.BillingHistoryContainer, path: "billing-history" }),
        _react2.default.createElement(_reactRouter.Route, { component: _accountNameAndEmailContainer.AccountNameAndEmailContainer, path: "name" }),
        _react2.default.createElement(_reactRouter.Route, { component: _currencyTaxLanguageContainer.CurrencyTaxLanguageContainer, path: "tax" }),
        _react2.default.createElement(_reactRouter.Route, { component: _accountUsersContainer.AccountUsersContainer, path: "users" })
      ),
      _react2.default.createElement(
        _reactRouter.Route,
        { component: _userSettingsContainer.UserSettingsContainer, path: "user" },
        _react2.default.createElement(_reactRouter.Route, { component: _userNameAndEmailContainer.UserNameAndEmailContainer, path: "info" }),
        _react2.default.createElement(_reactRouter.Route, { component: _userPasswordContainer.UserPasswordContainer, path: "password" }),
        _react2.default.createElement(_reactRouter.Route, { component: _betaSettingsContainer.BetaSettingsContainer, path: "ui-settings" }),
        _react2.default.createElement(_reactRouter.Route, { component: _favouriteAccountContainer.FavouriteAccountContainer, path: "favourite-account" })
      ),
      _react2.default.createElement(_reactRouter.Route, { component: _integrationSettingsContainer.IntegrationSettingsContainer, path: "integration" })
    ),
    _react2.default.createElement(_reactRouter.Route, { component: _pendingDocumentsContainer.PendingDocumentsContainer, path: "awaiting-digital" }),
    _react2.default.createElement(_reactRouter.Route, { component: _awaitingMailinContainer.AwaitingMailinContainer, path: "awaiting-mailin" }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "automate", to: "automate/manage-categories" }),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: "automate" },
      _react2.default.createElement(_reactRouter.Route, { component: _manageCategoriesContainer.ManageCategoriesContainer, path: "manage-categories" }),
      _react2.default.createElement(_reactRouter.Route, { component: _manageVendorsContainer.ManageVendorsContainer, path: "manage-vendors" })
    ),
    _react2.default.createElement(_reactRouter.Route, { component: _issueTrackingFormContainer.IssueTrackingFormContainer, path: "issue-tracking-form" })
  ),
  _react2.default.createElement(_reactRouter.Route, { component: _accountRedirector.AccountRedirector, path: "/" }),
  _react2.default.createElement(_reactRouter.Route, { component: _oauthContainer.OauthContainer, path: "/oauth" }),
  _react2.default.createElement(_reactRouter.Redirect, { from: "/documents/all", to: "/" }),
  _react2.default.createElement(_reactRouter.Route, { component: _pageNotFoundContainer.PageNotFoundContainer, path: "*" })
);

var createElement = function createElement(Component, props) {
  if (props.router.params.customTab) {
    return _react2.default.createElement(Component, _extends({ key: props.router.params.customTab + "RouteComponent" }, props));
  }
  return _react2.default.createElement(Component, _extends({ key: props.location.key + "RouteComponent" }, props));
};

createElement.propTypes = {
  location: _propTypes2.default.shape({ key: _propTypes2.default.string }).isRequired,
  router: _customPropTypes.routerType.isRequired
};

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var preferredCurrencySymbol = exports.preferredCurrencySymbol = function preferredCurrencySymbol(currencies, preferredCurrency) {
  return currencies.find(function (symbol) {
    return symbol.code === preferredCurrency;
  }).symbol;
};

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var doubleEncode = exports.doubleEncode = function doubleEncode(string) {
  return encodeURIComponent(encodeURIComponent(string));
};

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFiltersFromUrl = undefined;

var _ramda = __webpack_require__(6);

var _ramda2 = _interopRequireDefault(_ramda);

var _financialYear = __webpack_require__(197);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getFiltersFromUrl = exports.getFiltersFromUrl = function getFiltersFromUrl(filters, route, router, currency, customTabs) {
  if (route.path === "this-financial-year") {
    return _ramda2.default.merge(filters, (0, _financialYear.getThisFinancialYear)(currency));
  }

  if (route.path === "custom/:customTab") {
    return _ramda2.default.find(_ramda2.default.propEq("id", router.params.customTab))(customTabs).filters;
  }

  if (!router.params.filter || route.path === "all") {
    return filters;
  }

  return getFiltersFromQueryString(filters, router.params.filter);
};

var getFiltersFromQueryString = function getFiltersFromQueryString(filters, qs) {
  var pairs = qs.split("&");
  var result = {};
  pairs.forEach(function (p) {
    var pair = p.split("=");
    var key = pair[0];
    var value = decodeURIComponent(pair[1] || "");

    if (result[key]) {
      if (Object.prototype.toString.call(result[key]) === "[object Array]") {
        result[key].push(value);
      } else {
        result[key] = [result[key], value];
      }
    } else {
      result[key] = value;
    }
  });
  var smoothedResult = smoothFilters(result);
  return updateFilters(filters, JSON.parse(JSON.stringify(smoothedResult)));
};

var updateFilters = function updateFilters(filters, newFilters) {
  return _ramda2.default.merge(filters, newFilters);
};

var smoothFilters = function smoothFilters(filters) {
  var newFilters = { selectedCategories: [] };
  if (filters.category) {
    newFilters.selectedCategories.push(filters.category);
  }
  if (filters.or_category) {
    newFilters.selectedCategories.push(filters.or_category);
  }
  return newFilters;
};

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var calculateGST = exports.calculateGST = function calculateGST(total, currency, taxRate) {
  return parseFloat((total - total / (1 + taxRate / 100)).toFixed(2));
};

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__(24);

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaAngleLeft = function FaAngleLeft(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm26.5 12.1q0 0.3-0.2 0.6l-8.8 8.7 8.8 8.8q0.2 0.2 0.2 0.5t-0.2 0.5l-1.1 1.1q-0.3 0.3-0.6 0.3t-0.5-0.3l-10.4-10.4q-0.2-0.2-0.2-0.5t0.2-0.5l10.4-10.4q0.3-0.2 0.5-0.2t0.6 0.2l1.1 1.1q0.2 0.2 0.2 0.5z' })
        )
    );
};

exports.default = FaAngleLeft;

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__(24);

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaAngleUp = function FaAngleUp(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31 26.4q0 0.3-0.2 0.5l-1.1 1.2q-0.3 0.2-0.6 0.2t-0.5-0.2l-8.7-8.8-8.8 8.8q-0.2 0.2-0.5 0.2t-0.5-0.2l-1.2-1.2q-0.2-0.2-0.2-0.5t0.2-0.5l10.4-10.4q0.3-0.2 0.6-0.2t0.5 0.2l10.4 10.4q0.2 0.2 0.2 0.5z' })
        )
    );
};

exports.default = FaAngleUp;

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__(24);

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaAt = function FaAt(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm24.7 17.3q0-2.4-1.2-3.8t-3.3-1.3q-1.4 0-2.8 0.6t-2.4 1.9-1.8 3.1-0.7 4q0 2.5 1.2 3.9t3.4 1.3q2.1 0 3.9-1.5t2.7-3.7 1-4.5z m12.6 2.7q0 2.5-0.8 4.4t-2.2 3-3 1.7-3.2 0.6q-0.1 0-0.4 0t-0.3 0q-2.1 0-3.2-1.2-0.6-0.7-0.7-1.8-1.2 1.4-3 2.4t-3.8 1q-3.6 0-5.6-2.1t-2-6q0-3.5 1.5-6.5t4-4.7 5.5-1.7q1.9 0 3.4 0.7t2.4 2.3l0-0.5 0.3-1.2q0-0.1 0.1-0.3t0.2-0.1h2.7q0.1 0 0.3 0.2 0.1 0.2 0 0.4l-2.7 13.7q-0.1 0.5-0.1 1.1 0 0.8 0.3 1.1t1 0.3q0.6 0 1.3-0.1t1.6-0.5 1.7-1.2 1.3-1.9 0.5-3.1q0-6.5-3.9-10.4t-10.4-3.9q-2.9 0-5.5 1.1t-4.6 3.1-3 4.5-1.1 5.6 1.1 5.5 3 4.6 4.6 3 5.5 1.2q5.1 0 9.1-3.2 0.2-0.2 0.5-0.2t0.5 0.3l0.9 1.1q0.2 0.2 0.2 0.5-0.1 0.3-0.3 0.5-2.3 1.8-5.1 2.8t-5.8 1q-3.4 0-6.6-1.3t-5.5-3.7-3.6-5.5-1.4-6.6 1.4-6.7 3.6-5.4 5.5-3.7 6.6-1.3q7.7 0 12.5 4.7t4.7 12.4z' })
        )
    );
};

exports.default = FaAt;

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__(24);

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaBellO = function FaBellO(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20.4 37.9q0-0.4-0.4-0.4-1.3 0-2.3-1t-0.9-2.2q0-0.4-0.4-0.4t-0.3 0.4q0 1.6 1.1 2.8t2.8 1.1q0.4 0 0.4-0.3z m-14.9-6.5h29q-5.9-6.7-5.9-18.5 0-1.2-0.6-2.4t-1.5-2.3-2.7-1.8-3.8-0.7-3.8 0.7-2.7 1.8-1.5 2.3-0.6 2.4q0 11.8-5.9 18.5z m33.1 0q0 1.2-0.9 2t-2 0.9h-10q0 2.4-1.7 4t-4 1.7-4-1.7-1.7-4h-10q-1.2 0-2-0.9t-0.9-2q1.1-0.9 2.1-1.9t1.9-2.7 1.6-3.5 1.1-4.6 0.5-5.8q0-3.4 2.6-6.3t6.8-3.6q-0.1-0.4-0.1-0.9 0-0.8 0.6-1.5t1.5-0.6 1.5 0.6 0.6 1.5q0 0.5-0.1 0.9 4.2 0.6 6.8 3.6t2.6 6.3q0 3.1 0.5 5.8t1.1 4.6 1.6 3.5 1.9 2.7 2.1 1.9z' })
        )
    );
};

exports.default = FaBellO;

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__(24);

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaBook = function FaBook(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm38.1 10.7q0.9 1.2 0.4 2.9l-6.1 20.2q-0.5 1.4-1.8 2.4t-2.7 0.9h-20.6q-1.7 0-3.3-1.2t-2.2-2.9q-0.6-1.5-0.1-2.8 0-0.1 0.1-0.6t0.1-0.9q0-0.1-0.1-0.4t-0.1-0.5q0.1-0.2 0.2-0.4t0.4-0.6 0.4-0.5q0.5-0.8 1-2t0.6-2.1q0.1-0.2 0-0.6t0-0.7q0.1-0.2 0.4-0.6t0.4-0.5q0.5-0.8 0.9-2.1t0.6-2q0-0.2-0.1-0.7t0-0.6q0.1-0.3 0.5-0.7t0.5-0.5q0.4-0.6 1-1.9t0.6-2.1q0-0.2-0.1-0.6t0-0.6q0-0.2 0.2-0.4t0.4-0.5 0.4-0.5q0.1-0.2 0.3-0.6t0.4-0.8 0.3-0.8 0.5-0.7 0.5-0.6 0.9-0.2 1 0.1l0 0.1q0.8-0.2 1.1-0.2h17q1.7 0 2.6 1.2t0.4 2.9l-6.2 20.2q-0.8 2.7-1.6 3.5t-2.8 0.7h-19.4q-0.6 0-0.9 0.4-0.2 0.3 0 0.9 0.5 1.6 3.2 1.6h20.6q0.7 0 1.3-0.4t0.8-0.9l6.7-22q0.1-0.5 0.1-1.3 0.8 0.3 1.3 1z m-23.8 0q-0.1 0.3 0.1 0.5t0.4 0.2h13.6q0.3 0 0.6-0.2t0.3-0.5l0.5-1.4q0.1-0.3 0-0.5t-0.5-0.2h-13.6q-0.2 0-0.5 0.2t-0.4 0.5z m-1.8 5.7q-0.1 0.3 0 0.5t0.5 0.2h13.5q0.3 0 0.6-0.2t0.4-0.5l0.5-1.4q0-0.3-0.1-0.5t-0.4-0.2h-13.6q-0.3 0-0.6 0.2t-0.4 0.5z' })
        )
    );
};

exports.default = FaBook;

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__(24);

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaCog = function FaCog(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm25.9 20q0-2.4-1.7-4t-4.1-1.7-4 1.7-1.7 4 1.7 4 4 1.7 4.1-1.7 1.7-4z m11.4-2.4v4.9q0 0.3-0.2 0.5t-0.4 0.3l-4.2 0.6q-0.4 1.3-0.8 2.1 0.7 1.1 2.3 3.1 0.3 0.2 0.3 0.5t-0.2 0.5q-0.6 0.9-2.2 2.4t-2.1 1.6q-0.3 0-0.6-0.2l-3.1-2.4q-1 0.5-2 0.9-0.4 3-0.7 4.1-0.1 0.6-0.8 0.6h-4.9q-0.3 0-0.6-0.1t-0.2-0.5l-0.7-4.1q-1.1-0.4-2-0.9l-3.1 2.4q-0.2 0.2-0.6 0.2-0.3 0-0.5-0.2-2.8-2.6-3.7-3.8-0.2-0.2-0.2-0.5 0-0.2 0.2-0.5 0.3-0.5 1.1-1.5t1.2-1.5q-0.6-1.2-0.9-2.3l-4.1-0.6q-0.2 0-0.4-0.2t-0.2-0.6v-4.9q0-0.3 0.2-0.5t0.4-0.3l4.2-0.7q0.3-1 0.8-2-0.9-1.3-2.4-3.1-0.2-0.3-0.2-0.5 0-0.2 0.2-0.5 0.6-0.8 2.2-2.4t2.1-1.6q0.3 0 0.6 0.2l3.1 2.4q1-0.5 2-0.9 0.4-3 0.7-4.1 0.1-0.6 0.8-0.6h4.9q0.3 0 0.6 0.1t0.2 0.5l0.7 4.1q1 0.4 2 0.9l3.1-2.4q0.2-0.2 0.6-0.2 0.3 0 0.5 0.2 2.9 2.6 3.7 3.8 0.2 0.2 0.2 0.5 0 0.2-0.2 0.5-0.4 0.5-1.2 1.5t-1.2 1.5q0.6 1.2 1 2.2l4 0.7q0.3 0 0.5 0.2t0.2 0.6z' })
        )
    );
};

exports.default = FaCog;

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__(24);

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaDownload = function FaDownload(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30.1 30q0-0.6-0.5-1t-1-0.4-1 0.4-0.4 1 0.4 1 1 0.4 1-0.4 0.5-1z m5.7 0q0-0.6-0.4-1t-1-0.4-1 0.4-0.5 1 0.5 1 1 0.4 1-0.4 0.4-1z m2.8-5v7.1q0 0.9-0.6 1.6t-1.5 0.6h-32.9q-0.8 0-1.5-0.6t-0.6-1.6v-7.1q0-0.9 0.6-1.5t1.5-0.6h10.4l3 3q1.3 1.2 3.1 1.2t3-1.2l3-3h10.4q0.9 0 1.5 0.6t0.6 1.5z m-7.2-12.7q0.4 0.9-0.3 1.6l-10 10q-0.4 0.4-1 0.4t-1-0.4l-10-10q-0.7-0.7-0.3-1.6 0.3-0.9 1.3-0.9h5.7v-10q0-0.6 0.4-1t1-0.4h5.7q0.6 0 1 0.4t0.5 1v10h5.7q0.9 0 1.3 0.9z' })
        )
    );
};

exports.default = FaDownload;

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__(24);

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaExchange = function FaExchange(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm40 26.4v4.3q0 0.3-0.2 0.5t-0.5 0.2h-30.7v4.3q0 0.3-0.2 0.5t-0.5 0.2q-0.3 0-0.6-0.2l-7.1-7.1q-0.2-0.2-0.2-0.5 0-0.3 0.2-0.5l7.1-7.2q0.2-0.2 0.6-0.2 0.2 0 0.5 0.2t0.2 0.5v4.3h30.7q0.3 0 0.5 0.2t0.2 0.5z m0-12.1q0 0.3-0.2 0.5l-7.1 7.1q-0.2 0.2-0.6 0.2-0.2 0-0.5-0.2t-0.2-0.5v-4.3h-30.7q-0.3 0-0.5-0.2t-0.2-0.5v-4.3q0-0.2 0.2-0.5t0.5-0.2h30.7v-4.3q0-0.3 0.2-0.5t0.5-0.2q0.3 0 0.6 0.3l7.1 7.1q0.2 0.2 0.2 0.5z' })
        )
    );
};

exports.default = FaExchange;

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__(24);

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaLongArrowUp = function FaLongArrowUp(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.6 11q-0.2 0.4-0.7 0.4h-5v27.9q0 0.3-0.2 0.5t-0.5 0.2h-4.3q-0.3 0-0.5-0.2t-0.2-0.5v-27.9h-5q-0.5 0-0.6-0.4t0.1-0.8l7.8-8.6q0.2-0.2 0.5-0.2 0.3 0 0.5 0.2l8 8.6q0.3 0.4 0.1 0.8z' })
        )
    );
};

exports.default = FaLongArrowUp;

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__(24);

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaQuestion = function FaQuestion(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm23.2 28v5.4q0 0.4-0.3 0.6t-0.6 0.3h-5.3q-0.4 0-0.7-0.3t-0.2-0.6v-5.4q0-0.3 0.2-0.6t0.7-0.3h5.3q0.4 0 0.6 0.3t0.3 0.6z m7.1-13.4q0 1.2-0.4 2.3t-0.8 1.7-1.2 1.3-1.3 1-1.3 0.8q-0.9 0.5-1.6 1.4t-0.6 1.5q0 0.4-0.2 0.8t-0.7 0.3h-5.3q-0.4 0-0.6-0.4t-0.2-0.8v-1q0-1.9 1.4-3.5t3.2-2.5q1.3-0.6 1.9-1.2t0.5-1.7q0-0.9-1-1.7t-2.4-0.7q-1.4 0-2.4 0.7-0.8 0.5-2.4 2.5-0.3 0.4-0.7 0.4-0.2 0-0.5-0.2l-3.7-2.8q-0.3-0.2-0.3-0.5t0.1-0.6q3.5-6 10.3-6 1.8 0 3.6 0.7t3.3 1.9 2.4 2.8 0.9 3.5z' })
        )
    );
};

exports.default = FaQuestion;

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__(24);

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaTimesCircle = function FaTimesCircle(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.6 25q0-0.5-0.4-1l-4-4 4-4q0.4-0.5 0.4-1 0-0.6-0.4-1.1l-2-2q-0.4-0.4-1-0.4-0.6 0-1 0.4l-4.1 4.1-4-4.1q-0.4-0.4-1-0.4-0.6 0-1 0.4l-2 2q-0.5 0.5-0.5 1.1 0 0.5 0.5 1l4 4-4 4q-0.5 0.5-0.5 1 0 0.7 0.5 1.1l2 2q0.4 0.4 1 0.4 0.6 0 1-0.4l4-4.1 4.1 4.1q0.4 0.4 1 0.4 0.6 0 1-0.4l2-2q0.4-0.4 0.4-1z m8.7-5q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
        )
    );
};

exports.default = FaTimesCircle;

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__(24);

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaTrash = function FaTrash(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm15.9 30.7v-15.7q0-0.3-0.2-0.5t-0.5-0.2h-1.4q-0.3 0-0.5 0.2t-0.2 0.5v15.7q0 0.3 0.2 0.5t0.5 0.2h1.4q0.3 0 0.5-0.2t0.2-0.5z m5.7 0v-15.7q0-0.3-0.2-0.5t-0.5-0.2h-1.4q-0.3 0-0.5 0.2t-0.2 0.5v15.7q0 0.3 0.2 0.5t0.5 0.2h1.4q0.3 0 0.5-0.2t0.2-0.5z m5.8 0v-15.7q0-0.3-0.2-0.5t-0.6-0.2h-1.4q-0.3 0-0.5 0.2t-0.2 0.5v15.7q0 0.3 0.2 0.5t0.5 0.2h1.4q0.4 0 0.6-0.2t0.2-0.5z m-12.2-22.1h10l-1.1-2.6q-0.1-0.2-0.3-0.3h-7.1q-0.2 0.1-0.4 0.3z m20.7 0.7v1.4q0 0.3-0.2 0.5t-0.5 0.2h-2.1v21.2q0 1.8-1.1 3.2t-2.5 1.3h-18.6q-1.4 0-2.5-1.3t-1-3.1v-21.3h-2.2q-0.3 0-0.5-0.2t-0.2-0.5v-1.4q0-0.3 0.2-0.5t0.5-0.2h6.9l1.6-3.8q0.3-0.8 1.2-1.4t1.7-0.5h7.2q0.9 0 1.8 0.5t1.2 1.4l1.5 3.8h6.9q0.3 0 0.5 0.2t0.2 0.5z' })
        )
    );
};

exports.default = FaTrash;

/***/ }),
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1024);

module.exports = function batchProcessorMaker(options) {
    options             = options || {};
    var reporter        = options.reporter;
    var asyncProcess    = utils.getOption(options, "async", true);
    var autoProcess     = utils.getOption(options, "auto", true);

    if(autoProcess && !asyncProcess) {
        reporter && reporter.warn("Invalid options combination. auto=true and async=false is invalid. Setting async=true.");
        asyncProcess = true;
    }

    var batch = Batch();
    var asyncFrameHandler;
    var isProcessing = false;

    function addFunction(level, fn) {
        if(!isProcessing && autoProcess && asyncProcess && batch.size() === 0) {
            // Since this is async, it is guaranteed to be executed after that the fn is added to the batch.
            // This needs to be done before, since we're checking the size of the batch to be 0.
            processBatchAsync();
        }

        batch.add(level, fn);
    }

    function processBatch() {
        // Save the current batch, and create a new batch so that incoming functions are not added into the currently processing batch.
        // Continue processing until the top-level batch is empty (functions may be added to the new batch while processing, and so on).
        isProcessing = true;
        while (batch.size()) {
            var processingBatch = batch;
            batch = Batch();
            processingBatch.process();
        }
        isProcessing = false;
    }

    function forceProcessBatch(localAsyncProcess) {
        if (isProcessing) {
            return;
        }

        if(localAsyncProcess === undefined) {
            localAsyncProcess = asyncProcess;
        }

        if(asyncFrameHandler) {
            cancelFrame(asyncFrameHandler);
            asyncFrameHandler = null;
        }

        if(localAsyncProcess) {
            processBatchAsync();
        } else {
            processBatch();
        }
    }

    function processBatchAsync() {
        asyncFrameHandler = requestFrame(processBatch);
    }

    function clearBatch() {
        batch           = {};
        batchSize       = 0;
        topLevel        = 0;
        bottomLevel     = 0;
    }

    function cancelFrame(listener) {
        // var cancel = window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame || window.clearTimeout;
        var cancel = clearTimeout;
        return cancel(listener);
    }

    function requestFrame(callback) {
        // var raf = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function(fn) { return window.setTimeout(fn, 20); };
        var raf = function(fn) { return setTimeout(fn, 0); };
        return raf(callback);
    }

    return {
        add: addFunction,
        force: forceProcessBatch
    };
};

function Batch() {
    var batch       = {};
    var size        = 0;
    var topLevel    = 0;
    var bottomLevel = 0;

    function add(level, fn) {
        if(!fn) {
            fn = level;
            level = 0;
        }

        if(level > topLevel) {
            topLevel = level;
        } else if(level < bottomLevel) {
            bottomLevel = level;
        }

        if(!batch[level]) {
            batch[level] = [];
        }

        batch[level].push(fn);
        size++;
    }

    function process() {
        for(var level = bottomLevel; level <= topLevel; level++) {
            var fns = batch[level];

            for(var i = 0; i < fns.length; i++) {
                var fn = fns[i];
                fn();
            }
        }
    }

    function getSize() {
        return size;
    }

    return {
        add: add,
        process: process,
        size: getSize
    };
}


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = module.exports = {};

utils.getOption = getOption;

function getOption(options, name, defaultValue) {
    var value = options[name];

    if((value === undefined || value === null) && defaultValue !== undefined) {
        return defaultValue;
    }

    return value;
}


/***/ }),
/* 1025 */,
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(1977)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module, require('select'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.select);
        global.clipboardAction = mod.exports;
    }
})(this, function (module, _select) {
    'use strict';

    var _select2 = _interopRequireDefault(_select);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    var ClipboardAction = function () {
        /**
         * @param {Object} options
         */
        function ClipboardAction(options) {
            _classCallCheck(this, ClipboardAction);

            this.resolveOptions(options);
            this.initSelection();
        }

        /**
         * Defines base properties passed from constructor.
         * @param {Object} options
         */


        _createClass(ClipboardAction, [{
            key: 'resolveOptions',
            value: function resolveOptions() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                this.action = options.action;
                this.container = options.container;
                this.emitter = options.emitter;
                this.target = options.target;
                this.text = options.text;
                this.trigger = options.trigger;

                this.selectedText = '';
            }
        }, {
            key: 'initSelection',
            value: function initSelection() {
                if (this.text) {
                    this.selectFake();
                } else if (this.target) {
                    this.selectTarget();
                }
            }
        }, {
            key: 'selectFake',
            value: function selectFake() {
                var _this = this;

                var isRTL = document.documentElement.getAttribute('dir') == 'rtl';

                this.removeFake();

                this.fakeHandlerCallback = function () {
                    return _this.removeFake();
                };
                this.fakeHandler = this.container.addEventListener('click', this.fakeHandlerCallback) || true;

                this.fakeElem = document.createElement('textarea');
                // Prevent zooming on iOS
                this.fakeElem.style.fontSize = '12pt';
                // Reset box model
                this.fakeElem.style.border = '0';
                this.fakeElem.style.padding = '0';
                this.fakeElem.style.margin = '0';
                // Move element out of screen horizontally
                this.fakeElem.style.position = 'absolute';
                this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px';
                // Move element to the same position vertically
                var yPosition = window.pageYOffset || document.documentElement.scrollTop;
                this.fakeElem.style.top = yPosition + 'px';

                this.fakeElem.setAttribute('readonly', '');
                this.fakeElem.value = this.text;

                this.container.appendChild(this.fakeElem);

                this.selectedText = (0, _select2.default)(this.fakeElem);
                this.copyText();
            }
        }, {
            key: 'removeFake',
            value: function removeFake() {
                if (this.fakeHandler) {
                    this.container.removeEventListener('click', this.fakeHandlerCallback);
                    this.fakeHandler = null;
                    this.fakeHandlerCallback = null;
                }

                if (this.fakeElem) {
                    this.container.removeChild(this.fakeElem);
                    this.fakeElem = null;
                }
            }
        }, {
            key: 'selectTarget',
            value: function selectTarget() {
                this.selectedText = (0, _select2.default)(this.target);
                this.copyText();
            }
        }, {
            key: 'copyText',
            value: function copyText() {
                var succeeded = void 0;

                try {
                    succeeded = document.execCommand(this.action);
                } catch (err) {
                    succeeded = false;
                }

                this.handleResult(succeeded);
            }
        }, {
            key: 'handleResult',
            value: function handleResult(succeeded) {
                this.emitter.emit(succeeded ? 'success' : 'error', {
                    action: this.action,
                    text: this.selectedText,
                    trigger: this.trigger,
                    clearSelection: this.clearSelection.bind(this)
                });
            }
        }, {
            key: 'clearSelection',
            value: function clearSelection() {
                if (this.trigger) {
                    this.trigger.focus();
                }

                window.getSelection().removeAllRanges();
            }
        }, {
            key: 'destroy',
            value: function destroy() {
                this.removeFake();
            }
        }, {
            key: 'action',
            set: function set() {
                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'copy';

                this._action = action;

                if (this._action !== 'copy' && this._action !== 'cut') {
                    throw new Error('Invalid "action" value, use either "copy" or "cut"');
                }
            },
            get: function get() {
                return this._action;
            }
        }, {
            key: 'target',
            set: function set(target) {
                if (target !== undefined) {
                    if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && target.nodeType === 1) {
                        if (this.action === 'copy' && target.hasAttribute('disabled')) {
                            throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                        }

                        if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
                            throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                        }

                        this._target = target;
                    } else {
                        throw new Error('Invalid "target" value, use a valid Element');
                    }
                }
            },
            get: function get() {
                return this._target;
            }
        }]);

        return ClipboardAction;
    }();

    module.exports = ClipboardAction;
});

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(1026), __webpack_require__(1984), __webpack_require__(1402)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module, require('./clipboard-action'), require('tiny-emitter'), require('good-listener'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.clipboardAction, global.tinyEmitter, global.goodListener);
        global.clipboard = mod.exports;
    }
})(this, function (module, _clipboardAction, _tinyEmitter, _goodListener) {
    'use strict';

    var _clipboardAction2 = _interopRequireDefault(_clipboardAction);

    var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);

    var _goodListener2 = _interopRequireDefault(_goodListener);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    function _possibleConstructorReturn(self, call) {
        if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var Clipboard = function (_Emitter) {
        _inherits(Clipboard, _Emitter);

        /**
         * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
         * @param {Object} options
         */
        function Clipboard(trigger, options) {
            _classCallCheck(this, Clipboard);

            var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this));

            _this.resolveOptions(options);
            _this.listenClick(trigger);
            return _this;
        }

        /**
         * Defines if attributes would be resolved using internal setter functions
         * or custom functions that were passed in the constructor.
         * @param {Object} options
         */


        _createClass(Clipboard, [{
            key: 'resolveOptions',
            value: function resolveOptions() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
                this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
                this.text = typeof options.text === 'function' ? options.text : this.defaultText;
                this.container = _typeof(options.container) === 'object' ? options.container : document.body;
            }
        }, {
            key: 'listenClick',
            value: function listenClick(trigger) {
                var _this2 = this;

                this.listener = (0, _goodListener2.default)(trigger, 'click', function (e) {
                    return _this2.onClick(e);
                });
            }
        }, {
            key: 'onClick',
            value: function onClick(e) {
                var trigger = e.delegateTarget || e.currentTarget;

                if (this.clipboardAction) {
                    this.clipboardAction = null;
                }

                this.clipboardAction = new _clipboardAction2.default({
                    action: this.action(trigger),
                    target: this.target(trigger),
                    text: this.text(trigger),
                    container: this.container,
                    trigger: trigger,
                    emitter: this
                });
            }
        }, {
            key: 'defaultAction',
            value: function defaultAction(trigger) {
                return getAttributeValue('action', trigger);
            }
        }, {
            key: 'defaultTarget',
            value: function defaultTarget(trigger) {
                var selector = getAttributeValue('target', trigger);

                if (selector) {
                    return document.querySelector(selector);
                }
            }
        }, {
            key: 'defaultText',
            value: function defaultText(trigger) {
                return getAttributeValue('text', trigger);
            }
        }, {
            key: 'destroy',
            value: function destroy() {
                this.listener.destroy();

                if (this.clipboardAction) {
                    this.clipboardAction.destroy();
                    this.clipboardAction = null;
                }
            }
        }], [{
            key: 'isSupported',
            value: function isSupported() {
                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];

                var actions = typeof action === 'string' ? [action] : action;
                var support = !!document.queryCommandSupported;

                actions.forEach(function (action) {
                    support = support && !!document.queryCommandSupported(action);
                });

                return support;
            }
        }]);

        return Clipboard;
    }(_tinyEmitter2.default);

    /**
     * Helper function to retrieve attribute value.
     * @param {String} suffix
     * @param {Element} element
     */
    function getAttributeValue(suffix, element) {
        var attribute = 'data-clipboard-' + suffix;

        if (!element.hasAttribute(attribute)) {
            return;
        }

        return element.getAttribute(attribute);
    }

    module.exports = Clipboard;
});

/***/ }),
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */
/***/ (function(module, exports) {

var DOCUMENT_NODE_TYPE = 9;

/**
 * A polyfill for Element.matches()
 */
if (typeof Element !== 'undefined' && !Element.prototype.matches) {
    var proto = Element.prototype;

    proto.matches = proto.matchesSelector ||
                    proto.mozMatchesSelector ||
                    proto.msMatchesSelector ||
                    proto.oMatchesSelector ||
                    proto.webkitMatchesSelector;
}

/**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */
function closest (element, selector) {
    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
        if (typeof element.matches === 'function' &&
            element.matches(selector)) {
          return element;
        }
        element = element.parentNode;
    }
}

module.exports = closest;


/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

var closest = __webpack_require__(1280);

/**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function _delegate(element, selector, type, callback, useCapture) {
    var listenerFn = listener.apply(this, arguments);

    element.addEventListener(type, listenerFn, useCapture);

    return {
        destroy: function() {
            element.removeEventListener(type, listenerFn, useCapture);
        }
    }
}

/**
 * Delegates event to a selector.
 *
 * @param {Element|String|Array} [elements]
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function delegate(elements, selector, type, callback, useCapture) {
    // Handle the regular Element usage
    if (typeof elements.addEventListener === 'function') {
        return _delegate.apply(null, arguments);
    }

    // Handle Element-less usage, it defaults to global delegation
    if (typeof type === 'function') {
        // Use `document` as the first parameter, then apply arguments
        // This is a short way to .unshift `arguments` without running into deoptimizations
        return _delegate.bind(null, document).apply(null, arguments);
    }

    // Handle Selector-based usage
    if (typeof elements === 'string') {
        elements = document.querySelectorAll(elements);
    }

    // Handle Array-like based usage
    return Array.prototype.map.call(elements, function (element) {
        return _delegate(element, selector, type, callback, useCapture);
    });
}

/**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */
function listener(element, selector, type, callback) {
    return function(e) {
        e.delegateTarget = closest(e.target, selector);

        if (e.delegateTarget) {
            callback.call(element, e);
        }
    }
}

module.exports = delegate;


/***/ }),
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Resize detection strategy that injects objects to elements in order to detect resize events.
 * Heavily inspired by: http://www.backalleycoder.com/2013/03/18/cross-browser-event-based-element-resize-detection/
 */



var browserDetector = __webpack_require__(506);

module.exports = function(options) {
    options             = options || {};
    var reporter        = options.reporter;
    var batchProcessor  = options.batchProcessor;
    var getState        = options.stateHandler.getState;

    if(!reporter) {
        throw new Error("Missing required dependency: reporter.");
    }

    /**
     * Adds a resize event listener to the element.
     * @public
     * @param {element} element The element that should have the listener added.
     * @param {function} listener The listener callback to be called for each resize event of the element. The element will be given as a parameter to the listener callback.
     */
    function addListener(element, listener) {
        if(!getObject(element)) {
            throw new Error("Element is not detectable by this strategy.");
        }

        function listenerProxy() {
            listener(element);
        }

        if(browserDetector.isIE(8)) {
            //IE 8 does not support object, but supports the resize event directly on elements.
            getState(element).object = {
                proxy: listenerProxy
            };
            element.attachEvent("onresize", listenerProxy);
        } else {
            var object = getObject(element);
            object.contentDocument.defaultView.addEventListener("resize", listenerProxy);
        }
    }

    /**
     * Makes an element detectable and ready to be listened for resize events. Will call the callback when the element is ready to be listened for resize changes.
     * @private
     * @param {object} options Optional options object.
     * @param {element} element The element to make detectable
     * @param {function} callback The callback to be called when the element is ready to be listened for resize changes. Will be called with the element as first parameter.
     */
    function makeDetectable(options, element, callback) {
        if (!callback) {
            callback = element;
            element = options;
            options = null;
        }

        options = options || {};
        var debug = options.debug;

        function injectObject(element, callback) {
            var OBJECT_STYLE = "display: block; position: absolute; top: 0; left: 0; width: 100%; height: 100%; border: none; padding: 0; margin: 0; opacity: 0; z-index: -1000; pointer-events: none;";

            //The target element needs to be positioned (everything except static) so the absolute positioned object will be positioned relative to the target element.

            // Position altering may be performed directly or on object load, depending on if style resolution is possible directly or not.
            var positionCheckPerformed = false;

            // The element may not yet be attached to the DOM, and therefore the style object may be empty in some browsers.
            // Since the style object is a reference, it will be updated as soon as the element is attached to the DOM.
            var style = window.getComputedStyle(element);
            var width = element.offsetWidth;
            var height = element.offsetHeight;

            getState(element).startSize = {
                width: width,
                height: height
            };

            function mutateDom() {
                function alterPositionStyles() {
                    if(style.position === "static") {
                        element.style.position = "relative";

                        var removeRelativeStyles = function(reporter, element, style, property) {
                            function getNumericalValue(value) {
                                return value.replace(/[^-\d\.]/g, "");
                            }

                            var value = style[property];

                            if(value !== "auto" && getNumericalValue(value) !== "0") {
                                reporter.warn("An element that is positioned static has style." + property + "=" + value + " which is ignored due to the static positioning. The element will need to be positioned relative, so the style." + property + " will be set to 0. Element: ", element);
                                element.style[property] = 0;
                            }
                        };

                        //Check so that there are no accidental styles that will make the element styled differently now that is is relative.
                        //If there are any, set them to 0 (this should be okay with the user since the style properties did nothing before [since the element was positioned static] anyway).
                        removeRelativeStyles(reporter, element, style, "top");
                        removeRelativeStyles(reporter, element, style, "right");
                        removeRelativeStyles(reporter, element, style, "bottom");
                        removeRelativeStyles(reporter, element, style, "left");
                    }
                }

                function onObjectLoad() {
                    // The object has been loaded, which means that the element now is guaranteed to be attached to the DOM.
                    if (!positionCheckPerformed) {
                        alterPositionStyles();
                    }

                    /*jshint validthis: true */

                    function getDocument(element, callback) {
                        //Opera 12 seem to call the object.onload before the actual document has been created.
                        //So if it is not present, poll it with an timeout until it is present.
                        //TODO: Could maybe be handled better with object.onreadystatechange or similar.
                        if(!element.contentDocument) {
                            setTimeout(function checkForObjectDocument() {
                                getDocument(element, callback);
                            }, 100);

                            return;
                        }

                        callback(element.contentDocument);
                    }

                    //Mutating the object element here seems to fire another load event.
                    //Mutating the inner document of the object element is fine though.
                    var objectElement = this;

                    //Create the style element to be added to the object.
                    getDocument(objectElement, function onObjectDocumentReady(objectDocument) {
                        //Notify that the element is ready to be listened to.
                        callback(element);
                    });
                }

                // The element may be detached from the DOM, and some browsers does not support style resolving of detached elements.
                // The alterPositionStyles needs to be delayed until we know the element has been attached to the DOM (which we are sure of when the onObjectLoad has been fired), if style resolution is not possible.
                if (style.position !== "") {
                    alterPositionStyles(style);
                    positionCheckPerformed = true;
                }

                //Add an object element as a child to the target element that will be listened to for resize events.
                var object = document.createElement("object");
                object.style.cssText = OBJECT_STYLE;
                object.tabIndex = -1;
                object.type = "text/html";
                object.onload = onObjectLoad;

                //Safari: This must occur before adding the object to the DOM.
                //IE: Does not like that this happens before, even if it is also added after.
                if(!browserDetector.isIE()) {
                    object.data = "about:blank";
                }

                element.appendChild(object);
                getState(element).object = object;

                //IE: This must occur after adding the object to the DOM.
                if(browserDetector.isIE()) {
                    object.data = "about:blank";
                }
            }

            if(batchProcessor) {
                batchProcessor.add(mutateDom);
            } else {
                mutateDom();
            }
        }

        if(browserDetector.isIE(8)) {
            //IE 8 does not support objects properly. Luckily they do support the resize event.
            //So do not inject the object and notify that the element is already ready to be listened to.
            //The event handler for the resize event is attached in the utils.addListener instead.
            callback(element);
        } else {
            injectObject(element, callback);
        }
    }

    /**
     * Returns the child object of the target element.
     * @private
     * @param {element} element The target element.
     * @returns The object element of the target.
     */
    function getObject(element) {
        return getState(element).object;
    }

    function uninstall(element) {
        if(browserDetector.isIE(8)) {
            element.detachEvent("onresize", getState(element).object.proxy);
        } else {
            element.removeChild(getObject(element));
        }
        delete getState(element).object;
    }

    return {
        makeDetectable: makeDetectable,
        addListener: addListener,
        uninstall: uninstall
    };
};


/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Resize detection strategy that injects divs to elements in order to detect resize events on scroll events.
 * Heavily inspired by: https://github.com/marcj/css-element-queries/blob/master/src/ResizeSensor.js
 */



var forEach = __webpack_require__(507).forEach;

module.exports = function(options) {
    options             = options || {};
    var reporter        = options.reporter;
    var batchProcessor  = options.batchProcessor;
    var getState        = options.stateHandler.getState;
    var hasState        = options.stateHandler.hasState;
    var idHandler       = options.idHandler;

    if (!batchProcessor) {
        throw new Error("Missing required dependency: batchProcessor");
    }

    if (!reporter) {
        throw new Error("Missing required dependency: reporter.");
    }

    //TODO: Could this perhaps be done at installation time?
    var scrollbarSizes = getScrollbarSizes();

    // Inject the scrollbar styling that prevents them from appearing sometimes in Chrome.
    // The injected container needs to have a class, so that it may be styled with CSS (pseudo elements).
    var styleId = "erd_scroll_detection_scrollbar_style";
    var detectionContainerClass = "erd_scroll_detection_container";
    injectScrollStyle(styleId, detectionContainerClass);

    function getScrollbarSizes() {
        var width = 500;
        var height = 500;

        var child = document.createElement("div");
        child.style.cssText = "position: absolute; width: " + width*2 + "px; height: " + height*2 + "px; visibility: hidden; margin: 0; padding: 0;";

        var container = document.createElement("div");
        container.style.cssText = "position: absolute; width: " + width + "px; height: " + height + "px; overflow: scroll; visibility: none; top: " + -width*3 + "px; left: " + -height*3 + "px; visibility: hidden; margin: 0; padding: 0;";

        container.appendChild(child);

        document.body.insertBefore(container, document.body.firstChild);

        var widthSize = width - container.clientWidth;
        var heightSize = height - container.clientHeight;

        document.body.removeChild(container);

        return {
            width: widthSize,
            height: heightSize
        };
    }

    function injectScrollStyle(styleId, containerClass) {
        function injectStyle(style, method) {
            method = method || function (element) {
                document.head.appendChild(element);
            };

            var styleElement = document.createElement("style");
            styleElement.innerHTML = style;
            styleElement.id = styleId;
            method(styleElement);
            return styleElement;
        }

        if (!document.getElementById(styleId)) {
            var containerAnimationClass = containerClass + "_animation";
            var containerAnimationActiveClass = containerClass + "_animation_active";
            var style = "/* Created by the element-resize-detector library. */\n";
            style += "." + containerClass + " > div::-webkit-scrollbar { display: none; }\n\n";
            style += "." + containerAnimationActiveClass + " { -webkit-animation-duration: 0.1s; animation-duration: 0.1s; -webkit-animation-name: " + containerAnimationClass + "; animation-name: " + containerAnimationClass + "; }\n";
            style += "@-webkit-keyframes " + containerAnimationClass +  " { 0% { opacity: 1; } 50% { opacity: 0; } 100% { opacity: 1; } }\n";
            style += "@keyframes " + containerAnimationClass +          " { 0% { opacity: 1; } 50% { opacity: 0; } 100% { opacity: 1; } }";
            injectStyle(style);
        }
    }

    function addAnimationClass(element) {
        element.className += " " + detectionContainerClass + "_animation_active";
    }

    function addEvent(el, name, cb) {
        if (el.addEventListener) {
            el.addEventListener(name, cb);
        } else if(el.attachEvent) {
            el.attachEvent("on" + name, cb);
        } else {
            return reporter.error("[scroll] Don't know how to add event listeners.");
        }
    }

    function removeEvent(el, name, cb) {
        if (el.removeEventListener) {
            el.removeEventListener(name, cb);
        } else if(el.detachEvent) {
            el.detachEvent("on" + name, cb);
        } else {
            return reporter.error("[scroll] Don't know how to remove event listeners.");
        }
    }

    function getExpandElement(element) {
        return getState(element).container.childNodes[0].childNodes[0].childNodes[0];
    }

    function getShrinkElement(element) {
        return getState(element).container.childNodes[0].childNodes[0].childNodes[1];
    }

    /**
     * Adds a resize event listener to the element.
     * @public
     * @param {element} element The element that should have the listener added.
     * @param {function} listener The listener callback to be called for each resize event of the element. The element will be given as a parameter to the listener callback.
     */
    function addListener(element, listener) {
        var listeners = getState(element).listeners;

        if (!listeners.push) {
            throw new Error("Cannot add listener to an element that is not detectable.");
        }

        getState(element).listeners.push(listener);
    }

    /**
     * Makes an element detectable and ready to be listened for resize events. Will call the callback when the element is ready to be listened for resize changes.
     * @private
     * @param {object} options Optional options object.
     * @param {element} element The element to make detectable
     * @param {function} callback The callback to be called when the element is ready to be listened for resize changes. Will be called with the element as first parameter.
     */
    function makeDetectable(options, element, callback) {
        if (!callback) {
            callback = element;
            element = options;
            options = null;
        }

        options = options || {};

        function debug() {
            if (options.debug) {
                var args = Array.prototype.slice.call(arguments);
                args.unshift(idHandler.get(element), "Scroll: ");
                if (reporter.log.apply) {
                    reporter.log.apply(null, args);
                } else {
                    for (var i = 0; i < args.length; i++) {
                        reporter.log(args[i]);
                    }
                }
            }
        }

        function isDetached(element) {
            function isInDocument(element) {
                return element === element.ownerDocument.body || element.ownerDocument.body.contains(element);
            }

            if (!isInDocument(element)) {
                return true;
            }

            // FireFox returns null style in hidden iframes. See https://github.com/wnr/element-resize-detector/issues/68 and https://bugzilla.mozilla.org/show_bug.cgi?id=795520
            if (window.getComputedStyle(element) === null) {
                return true;
            }

            return false;
        }

        function isUnrendered(element) {
            // Check the absolute positioned container since the top level container is display: inline.
            var container = getState(element).container.childNodes[0];
            var style = window.getComputedStyle(container);
            return !style.width || style.width.indexOf("px") === -1; //Can only compute pixel value when rendered.
        }

        function getStyle() {
            // Some browsers only force layouts when actually reading the style properties of the style object, so make sure that they are all read here,
            // so that the user of the function can be sure that it will perform the layout here, instead of later (important for batching).
            var elementStyle            = window.getComputedStyle(element);
            var style                   = {};
            style.position              = elementStyle.position;
            style.width                 = element.offsetWidth;
            style.height                = element.offsetHeight;
            style.top                   = elementStyle.top;
            style.right                 = elementStyle.right;
            style.bottom                = elementStyle.bottom;
            style.left                  = elementStyle.left;
            style.widthCSS              = elementStyle.width;
            style.heightCSS             = elementStyle.height;
            return style;
        }

        function storeStartSize() {
            var style = getStyle();
            getState(element).startSize = {
                width: style.width,
                height: style.height
            };
            debug("Element start size", getState(element).startSize);
        }

        function initListeners() {
            getState(element).listeners = [];
        }

        function storeStyle() {
            debug("storeStyle invoked.");
            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }

            var style = getStyle();
            getState(element).style = style;
        }

        function storeCurrentSize(element, width, height) {
            getState(element).lastWidth = width;
            getState(element).lastHeight  = height;
        }

        function getExpandChildElement(element) {
            return getExpandElement(element).childNodes[0];
        }

        function getWidthOffset() {
            return 2 * scrollbarSizes.width + 1;
        }

        function getHeightOffset() {
            return 2 * scrollbarSizes.height + 1;
        }

        function getExpandWidth(width) {
            return width + 10 + getWidthOffset();
        }

        function getExpandHeight(height) {
            return height + 10 + getHeightOffset();
        }

        function getShrinkWidth(width) {
            return width * 2 + getWidthOffset();
        }

        function getShrinkHeight(height) {
            return height * 2 + getHeightOffset();
        }

        function positionScrollbars(element, width, height) {
            var expand          = getExpandElement(element);
            var shrink          = getShrinkElement(element);
            var expandWidth     = getExpandWidth(width);
            var expandHeight    = getExpandHeight(height);
            var shrinkWidth     = getShrinkWidth(width);
            var shrinkHeight    = getShrinkHeight(height);
            expand.scrollLeft   = expandWidth;
            expand.scrollTop    = expandHeight;
            shrink.scrollLeft   = shrinkWidth;
            shrink.scrollTop    = shrinkHeight;
        }

        function injectContainerElement() {
            var container = getState(element).container;

            if (!container) {
                container                   = document.createElement("div");
                container.className         = detectionContainerClass;
                container.style.cssText     = "visibility: hidden; display: inline; width: 0px; height: 0px; z-index: -1; overflow: hidden; margin: 0; padding: 0;";
                getState(element).container = container;
                addAnimationClass(container);
                element.appendChild(container);

                var onAnimationStart = function () {
                    getState(element).onRendered && getState(element).onRendered();
                };

                addEvent(container, "animationstart", onAnimationStart);

                // Store the event handler here so that they may be removed when uninstall is called.
                // See uninstall function for an explanation why it is needed.
                getState(element).onAnimationStart = onAnimationStart;
            }

            return container;
        }

        function injectScrollElements() {
            function alterPositionStyles() {
                var style = getState(element).style;

                if(style.position === "static") {
                    element.style.position = "relative";

                    var removeRelativeStyles = function(reporter, element, style, property) {
                        function getNumericalValue(value) {
                            return value.replace(/[^-\d\.]/g, "");
                        }

                        var value = style[property];

                        if(value !== "auto" && getNumericalValue(value) !== "0") {
                            reporter.warn("An element that is positioned static has style." + property + "=" + value + " which is ignored due to the static positioning. The element will need to be positioned relative, so the style." + property + " will be set to 0. Element: ", element);
                            element.style[property] = 0;
                        }
                    };

                    //Check so that there are no accidental styles that will make the element styled differently now that is is relative.
                    //If there are any, set them to 0 (this should be okay with the user since the style properties did nothing before [since the element was positioned static] anyway).
                    removeRelativeStyles(reporter, element, style, "top");
                    removeRelativeStyles(reporter, element, style, "right");
                    removeRelativeStyles(reporter, element, style, "bottom");
                    removeRelativeStyles(reporter, element, style, "left");
                }
            }

            function getLeftTopBottomRightCssText(left, top, bottom, right) {
                left = (!left ? "0" : (left + "px"));
                top = (!top ? "0" : (top + "px"));
                bottom = (!bottom ? "0" : (bottom + "px"));
                right = (!right ? "0" : (right + "px"));

                return "left: " + left + "; top: " + top + "; right: " + right + "; bottom: " + bottom + ";";
            }

            debug("Injecting elements");

            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }

            alterPositionStyles();

            var rootContainer = getState(element).container;

            if (!rootContainer) {
                rootContainer = injectContainerElement();
            }

            // Due to this WebKit bug https://bugs.webkit.org/show_bug.cgi?id=80808 (currently fixed in Blink, but still present in WebKit browsers such as Safari),
            // we need to inject two containers, one that is width/height 100% and another that is left/top -1px so that the final container always is 1x1 pixels bigger than
            // the targeted element.
            // When the bug is resolved, "containerContainer" may be removed.

            // The outer container can occasionally be less wide than the targeted when inside inline elements element in WebKit (see https://bugs.webkit.org/show_bug.cgi?id=152980).
            // This should be no problem since the inner container either way makes sure the injected scroll elements are at least 1x1 px.

            var scrollbarWidth          = scrollbarSizes.width;
            var scrollbarHeight         = scrollbarSizes.height;
            var containerContainerStyle = "position: absolute; flex: none; overflow: hidden; z-index: -1; visibility: hidden; width: 100%; height: 100%; left: 0px; top: 0px;";
            var containerStyle          = "position: absolute; flex: none; overflow: hidden; z-index: -1; visibility: hidden; " + getLeftTopBottomRightCssText(-(1 + scrollbarWidth), -(1 + scrollbarHeight), -scrollbarHeight, -scrollbarWidth);
            var expandStyle             = "position: absolute; flex: none; overflow: scroll; z-index: -1; visibility: hidden; width: 100%; height: 100%;";
            var shrinkStyle             = "position: absolute; flex: none; overflow: scroll; z-index: -1; visibility: hidden; width: 100%; height: 100%;";
            var expandChildStyle        = "position: absolute; left: 0; top: 0;";
            var shrinkChildStyle        = "position: absolute; width: 200%; height: 200%;";

            var containerContainer      = document.createElement("div");
            var container               = document.createElement("div");
            var expand                  = document.createElement("div");
            var expandChild             = document.createElement("div");
            var shrink                  = document.createElement("div");
            var shrinkChild             = document.createElement("div");

            // Some browsers choke on the resize system being rtl, so force it to ltr. https://github.com/wnr/element-resize-detector/issues/56
            // However, dir should not be set on the top level container as it alters the dimensions of the target element in some browsers.
            containerContainer.dir              = "ltr";

            containerContainer.style.cssText    = containerContainerStyle;
            containerContainer.className        = detectionContainerClass;
            container.className                 = detectionContainerClass;
            container.style.cssText             = containerStyle;
            expand.style.cssText                = expandStyle;
            expandChild.style.cssText           = expandChildStyle;
            shrink.style.cssText                = shrinkStyle;
            shrinkChild.style.cssText           = shrinkChildStyle;

            expand.appendChild(expandChild);
            shrink.appendChild(shrinkChild);
            container.appendChild(expand);
            container.appendChild(shrink);
            containerContainer.appendChild(container);
            rootContainer.appendChild(containerContainer);

            function onExpandScroll() {
                getState(element).onExpand && getState(element).onExpand();
            }

            function onShrinkScroll() {
                getState(element).onShrink && getState(element).onShrink();
            }

            addEvent(expand, "scroll", onExpandScroll);
            addEvent(shrink, "scroll", onShrinkScroll);

            // Store the event handlers here so that they may be removed when uninstall is called.
            // See uninstall function for an explanation why it is needed.
            getState(element).onExpandScroll = onExpandScroll;
            getState(element).onShrinkScroll = onShrinkScroll;
        }

        function registerListenersAndPositionElements() {
            function updateChildSizes(element, width, height) {
                var expandChild             = getExpandChildElement(element);
                var expandWidth             = getExpandWidth(width);
                var expandHeight            = getExpandHeight(height);
                expandChild.style.width     = expandWidth + "px";
                expandChild.style.height    = expandHeight + "px";
            }

            function updateDetectorElements(done) {
                var width           = element.offsetWidth;
                var height          = element.offsetHeight;

                debug("Storing current size", width, height);

                // Store the size of the element sync here, so that multiple scroll events may be ignored in the event listeners.
                // Otherwise the if-check in handleScroll is useless.
                storeCurrentSize(element, width, height);

                // Since we delay the processing of the batch, there is a risk that uninstall has been called before the batch gets to execute.
                // Since there is no way to cancel the fn executions, we need to add an uninstall guard to all fns of the batch.

                batchProcessor.add(0, function performUpdateChildSizes() {
                    if (!getState(element)) {
                        debug("Aborting because element has been uninstalled");
                        return;
                    }

                    if (!areElementsInjected()) {
                        debug("Aborting because element container has not been initialized");
                        return;
                    }

                    if (options.debug) {
                        var w = element.offsetWidth;
                        var h = element.offsetHeight;

                        if (w !== width || h !== height) {
                            reporter.warn(idHandler.get(element), "Scroll: Size changed before updating detector elements.");
                        }
                    }

                    updateChildSizes(element, width, height);
                });

                batchProcessor.add(1, function updateScrollbars() {
                    if (!getState(element)) {
                        debug("Aborting because element has been uninstalled");
                        return;
                    }

                    if (!areElementsInjected()) {
                        debug("Aborting because element container has not been initialized");
                        return;
                    }

                    positionScrollbars(element, width, height);
                });

                if (done) {
                    batchProcessor.add(2, function () {
                        if (!getState(element)) {
                            debug("Aborting because element has been uninstalled");
                            return;
                        }

                        if (!areElementsInjected()) {
                          debug("Aborting because element container has not been initialized");
                          return;
                        }

                        done();
                    });
                }
            }

            function areElementsInjected() {
                return !!getState(element).container;
            }

            function notifyListenersIfNeeded() {
                function isFirstNotify() {
                    return getState(element).lastNotifiedWidth === undefined;
                }

                debug("notifyListenersIfNeeded invoked");

                var state = getState(element);

                // Don't notify the if the current size is the start size, and this is the first notification.
                if (isFirstNotify() && state.lastWidth === state.startSize.width && state.lastHeight === state.startSize.height) {
                    return debug("Not notifying: Size is the same as the start size, and there has been no notification yet.");
                }

                // Don't notify if the size already has been notified.
                if (state.lastWidth === state.lastNotifiedWidth && state.lastHeight === state.lastNotifiedHeight) {
                    return debug("Not notifying: Size already notified");
                }


                debug("Current size not notified, notifying...");
                state.lastNotifiedWidth = state.lastWidth;
                state.lastNotifiedHeight = state.lastHeight;
                forEach(getState(element).listeners, function (listener) {
                    listener(element);
                });
            }

            function handleRender() {
                debug("startanimation triggered.");

                if (isUnrendered(element)) {
                    debug("Ignoring since element is still unrendered...");
                    return;
                }

                debug("Element rendered.");
                var expand = getExpandElement(element);
                var shrink = getShrinkElement(element);
                if (expand.scrollLeft === 0 || expand.scrollTop === 0 || shrink.scrollLeft === 0 || shrink.scrollTop === 0) {
                    debug("Scrollbars out of sync. Updating detector elements...");
                    updateDetectorElements(notifyListenersIfNeeded);
                }
            }

            function handleScroll() {
                debug("Scroll detected.");

                if (isUnrendered(element)) {
                    // Element is still unrendered. Skip this scroll event.
                    debug("Scroll event fired while unrendered. Ignoring...");
                    return;
                }

                var width = element.offsetWidth;
                var height = element.offsetHeight;

                if (width !== getState(element).lastWidth || height !== getState(element).lastHeight) {
                    debug("Element size changed.");
                    updateDetectorElements(notifyListenersIfNeeded);
                } else {
                    debug("Element size has not changed (" + width + "x" + height + ").");
                }
            }

            debug("registerListenersAndPositionElements invoked.");

            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }

            getState(element).onRendered = handleRender;
            getState(element).onExpand = handleScroll;
            getState(element).onShrink = handleScroll;

            var style = getState(element).style;
            updateChildSizes(element, style.width, style.height);
        }

        function finalizeDomMutation() {
            debug("finalizeDomMutation invoked.");

            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }

            var style = getState(element).style;
            storeCurrentSize(element, style.width, style.height);
            positionScrollbars(element, style.width, style.height);
        }

        function ready() {
            callback(element);
        }

        function install() {
            debug("Installing...");
            initListeners();
            storeStartSize();

            batchProcessor.add(0, storeStyle);
            batchProcessor.add(1, injectScrollElements);
            batchProcessor.add(2, registerListenersAndPositionElements);
            batchProcessor.add(3, finalizeDomMutation);
            batchProcessor.add(4, ready);
        }

        debug("Making detectable...");

        if (isDetached(element)) {
            debug("Element is detached");

            injectContainerElement();

            debug("Waiting until element is attached...");

            getState(element).onRendered = function () {
                debug("Element is now attached");
                install();
            };
        } else {
            install();
        }
    }

    function uninstall(element) {
        var state = getState(element);

        if (!state) {
            // Uninstall has been called on a non-erd element.
            return;
        }

        // Uninstall may have been called in the following scenarios:
        // (1) Right between the sync code and async batch (here state.busy = true, but nothing have been registered or injected).
        // (2) In the ready callback of the last level of the batch by another element (here, state.busy = true, but all the stuff has been injected).
        // (3) After the installation process (here, state.busy = false and all the stuff has been injected).
        // So to be on the safe side, let's check for each thing before removing.

        // We need to remove the event listeners, because otherwise the event might fire on an uninstall element which results in an error when trying to get the state of the element.
        state.onExpandScroll && removeEvent(getExpandElement(element), "scroll", state.onExpandScroll);
        state.onShrinkScroll && removeEvent(getShrinkElement(element), "scroll", state.onShrinkScroll);
        state.onAnimationStart && removeEvent(state.container, "animationstart", state.onAnimationStart);

        state.container && element.removeChild(state.container);
    }

    return {
        makeDetectable: makeDetectable,
        addListener: addListener,
        uninstall: uninstall
    };
};


/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var forEach                 = __webpack_require__(507).forEach;
var elementUtilsMaker       = __webpack_require__(1290);
var listenerHandlerMaker    = __webpack_require__(1293);
var idGeneratorMaker        = __webpack_require__(1291);
var idHandlerMaker          = __webpack_require__(1292);
var reporterMaker           = __webpack_require__(1294);
var browserDetector         = __webpack_require__(506);
var batchProcessorMaker     = __webpack_require__(1023);
var stateHandler            = __webpack_require__(1295);

//Detection strategies.
var objectStrategyMaker     = __webpack_require__(1287);
var scrollStrategyMaker     = __webpack_require__(1288);

function isCollection(obj) {
    return Array.isArray(obj) || obj.length !== undefined;
}

function toArray(collection) {
    if (!Array.isArray(collection)) {
        var array = [];
        forEach(collection, function (obj) {
            array.push(obj);
        });
        return array;
    } else {
        return collection;
    }
}

function isElement(obj) {
    return obj && obj.nodeType === 1;
}

/**
 * @typedef idHandler
 * @type {object}
 * @property {function} get Gets the resize detector id of the element.
 * @property {function} set Generate and sets the resize detector id of the element.
 */

/**
 * @typedef Options
 * @type {object}
 * @property {boolean} callOnAdd    Determines if listeners should be called when they are getting added.
                                    Default is true. If true, the listener is guaranteed to be called when it has been added.
                                    If false, the listener will not be guarenteed to be called when it has been added (does not prevent it from being called).
 * @property {idHandler} idHandler  A custom id handler that is responsible for generating, setting and retrieving id's for elements.
                                    If not provided, a default id handler will be used.
 * @property {reporter} reporter    A custom reporter that handles reporting logs, warnings and errors.
                                    If not provided, a default id handler will be used.
                                    If set to false, then nothing will be reported.
 * @property {boolean} debug        If set to true, the the system will report debug messages as default for the listenTo method.
 */

/**
 * Creates an element resize detector instance.
 * @public
 * @param {Options?} options Optional global options object that will decide how this instance will work.
 */
module.exports = function(options) {
    options = options || {};

    //idHandler is currently not an option to the listenTo function, so it should not be added to globalOptions.
    var idHandler;

    if (options.idHandler) {
        // To maintain compatability with idHandler.get(element, readonly), make sure to wrap the given idHandler
        // so that readonly flag always is true when it's used here. This may be removed next major version bump.
        idHandler = {
            get: function (element) { return options.idHandler.get(element, true); },
            set: options.idHandler.set
        };
    } else {
        var idGenerator = idGeneratorMaker();
        var defaultIdHandler = idHandlerMaker({
            idGenerator: idGenerator,
            stateHandler: stateHandler
        });
        idHandler = defaultIdHandler;
    }

    //reporter is currently not an option to the listenTo function, so it should not be added to globalOptions.
    var reporter = options.reporter;

    if(!reporter) {
        //If options.reporter is false, then the reporter should be quiet.
        var quiet = reporter === false;
        reporter = reporterMaker(quiet);
    }

    //batchProcessor is currently not an option to the listenTo function, so it should not be added to globalOptions.
    var batchProcessor = getOption(options, "batchProcessor", batchProcessorMaker({ reporter: reporter }));

    //Options to be used as default for the listenTo function.
    var globalOptions = {};
    globalOptions.callOnAdd     = !!getOption(options, "callOnAdd", true);
    globalOptions.debug         = !!getOption(options, "debug", false);

    var eventListenerHandler    = listenerHandlerMaker(idHandler);
    var elementUtils            = elementUtilsMaker({
        stateHandler: stateHandler
    });

    //The detection strategy to be used.
    var detectionStrategy;
    var desiredStrategy = getOption(options, "strategy", "object");
    var strategyOptions = {
        reporter: reporter,
        batchProcessor: batchProcessor,
        stateHandler: stateHandler,
        idHandler: idHandler
    };

    if(desiredStrategy === "scroll") {
        if (browserDetector.isLegacyOpera()) {
            reporter.warn("Scroll strategy is not supported on legacy Opera. Changing to object strategy.");
            desiredStrategy = "object";
        } else if (browserDetector.isIE(9)) {
            reporter.warn("Scroll strategy is not supported on IE9. Changing to object strategy.");
            desiredStrategy = "object";
        }
    }

    if(desiredStrategy === "scroll") {
        detectionStrategy = scrollStrategyMaker(strategyOptions);
    } else if(desiredStrategy === "object") {
        detectionStrategy = objectStrategyMaker(strategyOptions);
    } else {
        throw new Error("Invalid strategy name: " + desiredStrategy);
    }

    //Calls can be made to listenTo with elements that are still being installed.
    //Also, same elements can occur in the elements list in the listenTo function.
    //With this map, the ready callbacks can be synchronized between the calls
    //so that the ready callback can always be called when an element is ready - even if
    //it wasn't installed from the function itself.
    var onReadyCallbacks = {};

    /**
     * Makes the given elements resize-detectable and starts listening to resize events on the elements. Calls the event callback for each event for each element.
     * @public
     * @param {Options?} options Optional options object. These options will override the global options. Some options may not be overriden, such as idHandler.
     * @param {element[]|element} elements The given array of elements to detect resize events of. Single element is also valid.
     * @param {function} listener The callback to be executed for each resize event for each element.
     */
    function listenTo(options, elements, listener) {
        function onResizeCallback(element) {
            var listeners = eventListenerHandler.get(element);
            forEach(listeners, function callListenerProxy(listener) {
                listener(element);
            });
        }

        function addListener(callOnAdd, element, listener) {
            eventListenerHandler.add(element, listener);

            if(callOnAdd) {
                listener(element);
            }
        }

        //Options object may be omitted.
        if(!listener) {
            listener = elements;
            elements = options;
            options = {};
        }

        if(!elements) {
            throw new Error("At least one element required.");
        }

        if(!listener) {
            throw new Error("Listener required.");
        }

        if (isElement(elements)) {
            // A single element has been passed in.
            elements = [elements];
        } else if (isCollection(elements)) {
            // Convert collection to array for plugins.
            // TODO: May want to check so that all the elements in the collection are valid elements.
            elements = toArray(elements);
        } else {
            return reporter.error("Invalid arguments. Must be a DOM element or a collection of DOM elements.");
        }

        var elementsReady = 0;

        var callOnAdd = getOption(options, "callOnAdd", globalOptions.callOnAdd);
        var onReadyCallback = getOption(options, "onReady", function noop() {});
        var debug = getOption(options, "debug", globalOptions.debug);

        forEach(elements, function attachListenerToElement(element) {
            if (!stateHandler.getState(element)) {
                stateHandler.initState(element);
                idHandler.set(element);
            }

            var id = idHandler.get(element);

            debug && reporter.log("Attaching listener to element", id, element);

            if(!elementUtils.isDetectable(element)) {
                debug && reporter.log(id, "Not detectable.");
                if(elementUtils.isBusy(element)) {
                    debug && reporter.log(id, "System busy making it detectable");

                    //The element is being prepared to be detectable. Do not make it detectable.
                    //Just add the listener, because the element will soon be detectable.
                    addListener(callOnAdd, element, listener);
                    onReadyCallbacks[id] = onReadyCallbacks[id] || [];
                    onReadyCallbacks[id].push(function onReady() {
                        elementsReady++;

                        if(elementsReady === elements.length) {
                            onReadyCallback();
                        }
                    });
                    return;
                }

                debug && reporter.log(id, "Making detectable...");
                //The element is not prepared to be detectable, so do prepare it and add a listener to it.
                elementUtils.markBusy(element, true);
                return detectionStrategy.makeDetectable({ debug: debug }, element, function onElementDetectable(element) {
                    debug && reporter.log(id, "onElementDetectable");

                    if (stateHandler.getState(element)) {
                        elementUtils.markAsDetectable(element);
                        elementUtils.markBusy(element, false);
                        detectionStrategy.addListener(element, onResizeCallback);
                        addListener(callOnAdd, element, listener);

                        // Since the element size might have changed since the call to "listenTo", we need to check for this change,
                        // so that a resize event may be emitted.
                        // Having the startSize object is optional (since it does not make sense in some cases such as unrendered elements), so check for its existance before.
                        // Also, check the state existance before since the element may have been uninstalled in the installation process.
                        var state = stateHandler.getState(element);
                        if (state && state.startSize) {
                            var width = element.offsetWidth;
                            var height = element.offsetHeight;
                            if (state.startSize.width !== width || state.startSize.height !== height) {
                                onResizeCallback(element);
                            }
                        }

                        if(onReadyCallbacks[id]) {
                            forEach(onReadyCallbacks[id], function(callback) {
                                callback();
                            });
                        }
                    } else {
                        // The element has been unisntalled before being detectable.
                        debug && reporter.log(id, "Element uninstalled before being detectable.");
                    }

                    delete onReadyCallbacks[id];

                    elementsReady++;
                    if(elementsReady === elements.length) {
                        onReadyCallback();
                    }
                });
            }

            debug && reporter.log(id, "Already detecable, adding listener.");

            //The element has been prepared to be detectable and is ready to be listened to.
            addListener(callOnAdd, element, listener);
            elementsReady++;
        });

        if(elementsReady === elements.length) {
            onReadyCallback();
        }
    }

    function uninstall(elements) {
        if(!elements) {
            return reporter.error("At least one element is required.");
        }

        if (isElement(elements)) {
            // A single element has been passed in.
            elements = [elements];
        } else if (isCollection(elements)) {
            // Convert collection to array for plugins.
            // TODO: May want to check so that all the elements in the collection are valid elements.
            elements = toArray(elements);
        } else {
            return reporter.error("Invalid arguments. Must be a DOM element or a collection of DOM elements.");
        }

        forEach(elements, function (element) {
            eventListenerHandler.removeAllListeners(element);
            detectionStrategy.uninstall(element);
            stateHandler.cleanState(element);
        });
    }

    return {
        listenTo: listenTo,
        removeListener: eventListenerHandler.removeListener,
        removeAllListeners: eventListenerHandler.removeAllListeners,
        uninstall: uninstall
    };
};

function getOption(options, name, defaultValue) {
    var value = options[name];

    if((value === undefined || value === null) && defaultValue !== undefined) {
        return defaultValue;
    }

    return value;
}


/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(options) {
    var getState = options.stateHandler.getState;

    /**
     * Tells if the element has been made detectable and ready to be listened for resize events.
     * @public
     * @param {element} The element to check.
     * @returns {boolean} True or false depending on if the element is detectable or not.
     */
    function isDetectable(element) {
        var state = getState(element);
        return state && !!state.isDetectable;
    }

    /**
     * Marks the element that it has been made detectable and ready to be listened for resize events.
     * @public
     * @param {element} The element to mark.
     */
    function markAsDetectable(element) {
        getState(element).isDetectable = true;
    }

    /**
     * Tells if the element is busy or not.
     * @public
     * @param {element} The element to check.
     * @returns {boolean} True or false depending on if the element is busy or not.
     */
    function isBusy(element) {
        return !!getState(element).busy;
    }

    /**
     * Marks the object is busy and should not be made detectable.
     * @public
     * @param {element} element The element to mark.
     * @param {boolean} busy If the element is busy or not.
     */
    function markBusy(element, busy) {
        getState(element).busy = !!busy;
    }

    return {
        isDetectable: isDetectable,
        markAsDetectable: markAsDetectable,
        isBusy: isBusy,
        markBusy: markBusy
    };
};


/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function() {
    var idCount = 1;

    /**
     * Generates a new unique id in the context.
     * @public
     * @returns {number} A unique id in the context.
     */
    function generate() {
        return idCount++;
    }

    return {
        generate: generate
    };
};


/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(options) {
    var idGenerator     = options.idGenerator;
    var getState        = options.stateHandler.getState;

    /**
     * Gets the resize detector id of the element.
     * @public
     * @param {element} element The target element to get the id of.
     * @returns {string|number|null} The id of the element. Null if it has no id.
     */
    function getId(element) {
        var state = getState(element);

        if (state && state.id !== undefined) {
            return state.id;
        }

        return null;
    }

    /**
     * Sets the resize detector id of the element. Requires the element to have a resize detector state initialized.
     * @public
     * @param {element} element The target element to set the id of.
     * @returns {string|number|null} The id of the element.
     */
    function setId(element) {
        var state = getState(element);

        if (!state) {
            throw new Error("setId required the element to have a resize detection state.");
        }

        var id = idGenerator.generate();

        state.id = id;

        return id;
    }

    return {
        get: getId,
        set: setId
    };
};


/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(idHandler) {
    var eventListeners = {};

    /**
     * Gets all listeners for the given element.
     * @public
     * @param {element} element The element to get all listeners for.
     * @returns All listeners for the given element.
     */
    function getListeners(element) {
        var id = idHandler.get(element);

        if (id === undefined) {
            return [];
        }

        return eventListeners[id] || [];
    }

    /**
     * Stores the given listener for the given element. Will not actually add the listener to the element.
     * @public
     * @param {element} element The element that should have the listener added.
     * @param {function} listener The callback that the element has added.
     */
    function addListener(element, listener) {
        var id = idHandler.get(element);

        if(!eventListeners[id]) {
            eventListeners[id] = [];
        }

        eventListeners[id].push(listener);
    }

    function removeListener(element, listener) {
        var listeners = getListeners(element);
        for (var i = 0, len = listeners.length; i < len; ++i) {
            if (listeners[i] === listener) {
              listeners.splice(i, 1);
              break;
            }
        }
    }

    function removeAllListeners(element) {
      var listeners = getListeners(element);
      if (!listeners) { return; }
      listeners.length = 0;
    }

    return {
        get: getListeners,
        add: addListener,
        removeListener: removeListener,
        removeAllListeners: removeAllListeners
    };
};


/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* global console: false */

/**
 * Reporter that handles the reporting of logs, warnings and errors.
 * @public
 * @param {boolean} quiet Tells if the reporter should be quiet or not.
 */
module.exports = function(quiet) {
    function noop() {
        //Does nothing.
    }

    var reporter = {
        log: noop,
        warn: noop,
        error: noop
    };

    if(!quiet && window.console) {
        var attachFunction = function(reporter, name) {
            //The proxy is needed to be able to call the method with the console context,
            //since we cannot use bind.
            reporter[name] = function reporterProxy() {
                var f = console[name];
                if (f.apply) { //IE9 does not support console.log.apply :)
                    f.apply(console, arguments);
                } else {
                    for (var i = 0; i < arguments.length; i++) {
                        f(arguments[i]);
                    }
                }
            };
        };

        attachFunction(reporter, "log");
        attachFunction(reporter, "warn");
        attachFunction(reporter, "error");
    }

    return reporter;
};

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var prop = "_erd";

function initState(element) {
    element[prop] = {};
    return getState(element);
}

function getState(element) {
    return element[prop];
}

function cleanState(element) {
    delete element[prop];
}

module.exports = {
    initState: initState,
    getState: getState,
    cleanState: cleanState
};


/***/ }),
/* 1296 */,
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 1298 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"app-header__container___188mk","content":"app-header__content___3L0FA","logo":"app-header__logo___1yM3W","navigation-panel__container":"app-header__navigation-panel__container___2xGJg","beta-banner":"app-header__beta-banner___389ga","navigation-panel__selected":"app-header__navigation-panel__selected___F24KT","account-details":"app-header__account-details___1ky42","select-container":"app-header__select-container___ML7qn","Select":"app-header__Select___1wCA-","Select-control":"app-header__Select-control___22jEF","logout":"app-header__logout___2E-gp","dropdown":"app-header__dropdown___2D76x","upload-button":"app-header__upload-button___1R4Da","notifications-button":"app-header__notifications-button___19-63","unviewed":"app-header__unviewed___3nNs1","search":"app-header__search___2Rq3H","search-button":"app-header__search-button___efPUn","fields":"app-header__fields___H3qxl"};

/***/ }),
/* 1299 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1300 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button":"button__button___2TYs6","button--primary":"button__button--primary___3ikoY","button--danger":"button__button--danger___1WUc3","button--link":"button__button--link___22M3J","button--danger-link":"button__button--danger-link___deZsS","invisible":"button__invisible___3cMwI","loading-container":"button__loading-container___3x9sn"};

/***/ }),
/* 1301 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"checkbox__container___3CSIJ","container--checked":"checkbox__container--checked___nHjxw"};

/***/ }),
/* 1302 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"title":"columns-editor__title___HKR6j","selection-container":"columns-editor__selection-container___1BmkS","cell":"columns-editor__cell___3ntK8"};

/***/ }),
/* 1303 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"end-date-container":"date-range__end-date-container___329Mi","start-date-container":"date-range__start-date-container___23Gfe","financial-year":"date-range__financial-year___39iyt"};

/***/ }),
/* 1304 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"drawer-container":"drawer__drawer-container___3oJL4","drawer":"drawer__drawer___2-8Ew","slide":"drawer__slide___1X0xH","close-drawer":"drawer__close-drawer___2ZnXC","close":"drawer__close___1EUSp"};

/***/ }),
/* 1305 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"dropdown-modal__wrapper___1C_QT","container":"dropdown-modal__container___2Z2qv","fadein":"dropdown-modal__fadein___3w_H6","background":"dropdown-modal__background___2dIo-","arrow-side":"dropdown-modal__arrow-side___2GGgQ","fadein-fadeout":"dropdown-modal__fadein-fadeout___TRqI-"};

/***/ }),
/* 1306 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"flash-message__container___2Qpd8","container--success":"flash-message__container--success___3fef9","container--error":"flash-message__container--error___1PG-J","fadein-fadeout":"flash-message__fadein-fadeout___8rx2_","fadein":"flash-message__fadein___mm62r"};

/***/ }),
/* 1307 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"inline-tabs__container___26DBh","tab":"inline-tabs__tab___3HOyk","tab--selected":"inline-tabs__tab--selected___36bhg","custom-tab-container":"inline-tabs__custom-tab-container___1ELg6","name":"inline-tabs__name___3yGoM","delete":"inline-tabs__delete___14_kI"};

/***/ }),
/* 1308 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"item-box__container___1KZGO","text":"item-box__text___3aNDr","small":"item-box__small___2IUOe","denominator":"item-box__denominator___2K-JP"};

/***/ }),
/* 1309 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"loading":"loading__loading___2FzLv","spinner":"loading__spinner___3EBql"};

/***/ }),
/* 1310 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modal":"modal__modal___70lnK","modal-container":"modal__modal-container___23_k7","modal-box":"modal__modal-box___2QLVG","draggable-modal-container":"modal__draggable-modal-container___2ka3s","draggable-mode":"modal__draggable-mode___3hX_T","example-enter":"modal__example-enter___3qGZ9","example-enter-active":"modal__example-enter-active___UV1NV","example-leave":"modal__example-leave___2rVx6","example-leave-active":"modal__example-leave-active___374B1","example-appear":"modal__example-appear___2yq5T","example-appear-active":"modal__example-appear-active___2EBP2"};

/***/ }),
/* 1311 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"pagination-bar__container___3mJF9","limit-controls":"pagination-bar__limit-controls___3qqDy","page-numbers":"pagination-bar__page-numbers___1mVbV","previous-button":"pagination-bar__previous-button___3DbLb","next-button":"pagination-bar__next-button___2n14R"};

/***/ }),
/* 1312 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"radio-tab__container___3hfOm","option":"radio-tab__option___1LoSP","option--selected":"radio-tab__option--selected___3S45n"};

/***/ }),
/* 1313 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1314 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"text-field__container___3a5Rr","clear-button":"text-field__clear-button___riAoC","input":"text-field__input___1ZYZ-","input--clearable":"text-field__input--clearable___1f5vx"};

/***/ }),
/* 1315 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"unknown-error-message__container___3iC9w","inner":"unknown-error-message__inner___1bSz4","five-hundred":"unknown-error-message__five-hundred___2-weY","close":"unknown-error-message__close___3qRYX"};

/***/ }),
/* 1316 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"active-filter-item__container___1pXKe","remove-button":"active-filter-item__remove-button___2j_8V"};

/***/ }),
/* 1317 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"section":"batch-edit-form__section___1rYVg","fields-container":"batch-edit-form__fields-container___11lUm","fields-container__row":"batch-edit-form__fields-container__row___38yry","actions":"batch-edit-form__actions___w2SaQ"};

/***/ }),
/* 1318 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"categories-actions-container":"categories-actions-panel__categories-actions-container___3dTKS","panel":"categories-actions-panel__panel___Ey2AV","categories-title":"categories-actions-panel__categories-title___1JRUJ","export-documents":"categories-actions-panel__export-documents___Q5X2h","rule-creation":"categories-actions-panel__rule-creation___3p6I0","open-document":"categories-actions-panel__open-document___2rS89","squirrel":"categories-actions-panel__squirrel___3QMM0","no-integration":"categories-actions-panel__no-integration___1f3YS","rule-tooltip":"categories-actions-panel__rule-tooltip___3NpbV","error":"categories-actions-panel__error___2BC3D","tooltip":"categories-actions-panel__tooltip___RMt60","error-tooltip":"categories-actions-panel__error-tooltip___2AvOw","none":"categories-actions-panel__none___1rI68","warning":"categories-actions-panel__warning___qzm-C","red":"categories-actions-panel__red___3NOp5"};

/***/ }),
/* 1319 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"buttons":"change-doctype-modal__buttons___2EDZ7"};

/***/ }),
/* 1320 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"title":"custom-tab-filters__title___5--84","field-cell":"custom-tab-filters__field-cell___MfaS2","container":"custom-tab-filters__container___3ktm2","payment-type":"custom-tab-filters__payment-type___A3Un8","action":"custom-tab-filters__action___27DQ8","input-field":"custom-tab-filters__input-field___2j0k9","search-field":"custom-tab-filters__search-field___1PM9x","search":"custom-tab-filters__search___3veT1","search-button":"custom-tab-filters__search-button___1SGD3","name":"custom-tab-filters__name___pNM6C"};

/***/ }),
/* 1321 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"custom-tab__container___2F6-u","filters-container":"custom-tab__filters-container___2rptP","active":"custom-tab__active___1i5gK"};

/***/ }),
/* 1322 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"standard-action-panel__container":"data-grid-actions-panel__standard-action-panel__container___3el9Z","results-found":"data-grid-actions-panel__results-found___32Ed-","actions":"data-grid-actions-panel__actions___3P6kP","export-button":"data-grid-actions-panel__export-button___1hrBk","exports":"data-grid-actions-panel__exports___1MPXm","active-filters":"data-grid-actions-panel__active-filters___l4cDR","filters":"data-grid-actions-panel__filters___Jqg1X","trash":"data-grid-actions-panel__trash___Rb6Fa","exports-actions":"data-grid-actions-panel__exports-actions___1cpmC","exports-filter":"data-grid-actions-panel__exports-filter___2KA7X","document":"data-grid-actions-panel__document___37KqU","icon":"data-grid-actions-panel__icon___2swRy","total":"data-grid-actions-panel__total___22ruj","buttons":"data-grid-actions-panel__buttons___2NNWm","exit-trash":"data-grid-actions-panel__exit-trash___1ckW8"};

/***/ }),
/* 1323 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"documents-container__container___Mde0R"};

/***/ }),
/* 1324 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button":"export-button__button___2BiPp"};

/***/ }),
/* 1325 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"selected-categories-container":"assign-categories-form__selected-categories-container___3-UjD","no-selection":"assign-categories-form__no-selection___2FWoa","no-selection--actions":"assign-categories-form__no-selection--actions___23rJ_","actions":"assign-categories-form__actions___2oNBc","selected-item-container":"assign-categories-form__selected-item-container___E9--q"};

/***/ }),
/* 1326 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"info":"batch-download-form__info___HYFYi","actions":"batch-download-form__actions___3J-9Z","add-email-container":"batch-download-form__add-email-container___1toh8","add-email_container__text-field-container":"batch-download-form__add-email_container__text-field-container___2HCW0","add-email_container__button-container":"batch-download-form__add-email_container__button-container___TtePH","emails-container":"batch-download-form__emails-container___3WbS8","email-row":"batch-download-form__email-row___2yX3W"};

/***/ }),
/* 1327 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"gst-button":"gst-calculator__gst-button___3hDTP"};

/***/ }),
/* 1328 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"inbox__container___2OzVW","bottom-grid":"inbox__bottom-grid___1-pjV","top-grid":"inbox__top-grid___2vLZG","gl-grid":"inbox__gl-grid___3DvyA","gl-panel":"inbox__gl-panel___3ojWi"};

/***/ }),
/* 1329 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"merge-buttons":"merge-documents-modal__merge-buttons___1rhiM","grid-container":"merge-documents-modal__grid-container___3gOKP","error-container":"merge-documents-modal__error-container___3g2xL"};

/***/ }),
/* 1330 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"table":"merge-grid__table___2J7FR","td":"merge-grid__td___MxVst","td__active":"merge-grid__td__active___3XYiQ","tr":"merge-grid__tr___aqB9_","thead":"merge-grid__thead___28mIk","th":"merge-grid__th___22bEK","selected-row":"merge-grid__selected-row___2uQG4"};

/***/ }),
/* 1331 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"payment-type-container":"payment-type-filter-field__payment-type-container___a0iBA","shared-select":"payment-type-filter-field__shared-select___1R0Ai","lastFourDigits":"payment-type-filter-field__lastFourDigits___3ftyy","payment-title":"payment-type-filter-field__payment-title___zerFY","digits-title":"payment-type-filter-field__digits-title___3zkIf"};

/***/ }),
/* 1332 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"viewed-buttons":"set-viewed-display__viewed-buttons___o7Yu6","button":"set-viewed-display__button___2x6vt"};

/***/ }),
/* 1333 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"buttons":"share-url-modal__buttons___2LGAy","copy-button":"share-url-modal__copy-button___1BmVE","link":"share-url-modal__link___SO6eC"};

/***/ }),
/* 1334 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"buttons":"trash-document-modal__buttons___3ytTm"};

/***/ }),
/* 1335 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"checkbox":"first-time-beta-modal__checkbox___1fheq","checkbox-text":"first-time-beta-modal__checkbox-text___NZJwt","actions":"first-time-beta-modal__actions___1EH1D"};

/***/ }),
/* 1336 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"no-name":"name-cell-formatter__no-name___1QD0F"};

/***/ }),
/* 1337 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"selected":"select-cell-formatter__selected___lWY5A","checkbox":"select-cell-formatter__checkbox___RXlB0"};

/***/ }),
/* 1338 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"type-cell-formatter__container___11LVr","tooltip":"type-cell-formatter__tooltip___2jTtt"};

/***/ }),
/* 1339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"upload-source-cell-formatter__container___3_1Qn","tooltip":"upload-source-cell-formatter__tooltip___KO_CX"};

/***/ }),
/* 1340 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header-content":"grid-components__header-content___3NfU6","main-cells":"grid-components__main-cells___LOkAq","focused":"grid-components__focused___gInyu","odd-row":"grid-components__odd-row___1iyhF","even-row":"grid-components__even-row___1-KLA","select-all":"grid-components__select-all___1Og8d","header":"grid-components__header___p397a","sortable":"grid-components__sortable___2u4q7","overflow":"grid-components__overflow___18Jfh","up":"grid-components__up___WDmjd","down":"grid-components__down___1x2yH","unviewed":"grid-components__unviewed___sMIqY"};

/***/ }),
/* 1341 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"controls":"delete-categories-modal__controls___1-yl5"};

/***/ }),
/* 1342 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"title":"no-categories__title___2TvCv"};

/***/ }),
/* 1343 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"manage-envelopes__container___HjnPB","title":"manage-envelopes__title___2Vd7G","actions-panel":"manage-envelopes__actions-panel___1vyZO","envelope-actions":"manage-envelopes__envelope-actions___3bY3j","grid":"manage-envelopes__grid___2WQjJ"};

/***/ }),
/* 1344 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"no-envelopes__container___1VGTy"};

/***/ }),
/* 1345 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"actions":"add-vendor-rules-modal__actions___2uFV4","vendor-list":"add-vendor-rules-modal__vendor-list___1aGMA","vendor":"add-vendor-rules-modal__vendor___3GaaL"};

/***/ }),
/* 1346 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"actions":"merge-vendors-modal__actions___32hAS","text":"merge-vendors-modal__text___2l1M3"};

/***/ }),
/* 1347 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"notifications__container___19Yzg","icon":"notifications__icon___1hgC_"};

/***/ }),
/* 1348 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"page-not-found__container___1D2Jx","title":"page-not-found__title___3c5jS"};

/***/ }),
/* 1349 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"field-cell":"reports-form__field-cell___2L7tx","fields":"reports-form__fields___1iB5M","fields-container":"reports-form__fields-container___1IFyW","fields-container__row":"reports-form__fields-container__row___24ZNm","actions":"reports-form__actions___Nu54g","financial-year":"reports-form__financial-year___2Eb84"};

/***/ }),
/* 1350 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"grid-container":"reports-grid__grid-container___1OKRj"};

/***/ }),
/* 1351 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"reports__container___8OSiY"};

/***/ }),
/* 1352 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"form-element":"account-name-and-email-settings__form-element___3v6i-","email":"account-name-and-email-settings__email___3kXSi"};

/***/ }),
/* 1353 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"title":"account-users__title___1GYHP","invite-button":"account-users__invite-button___3xCR3"};

/***/ }),
/* 1354 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"beta-setting__container___3pPnU"};

/***/ }),
/* 1355 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"card-form":"billing-details__card-form___1QRI9","form-title":"billing-details__form-title___1Ihhn","field-cell":"billing-details__field-cell___1toGQ","fields":"billing-details__fields___2pPKs","small-field":"billing-details__small-field___3D1AG","expiration":"billing-details__expiration___12DBQ","expiration-right":"billing-details__expiration-right___2UhqG","cvv":"billing-details__cvv___1pZ0A","button":"billing-details__button___3oRtL","construction":"billing-details__construction___3g2t-"};

/***/ }),
/* 1356 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"grid-container":"billing-history__grid-container___37kVC"};

/***/ }),
/* 1357 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"controls":"cancel-subscription-modal__controls___2JHXd"};

/***/ }),
/* 1358 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"input-field":"currency-tax-language-settings__input-field___3sKFR","small":"currency-tax-language-settings__small___GfAw-"};

/***/ }),
/* 1359 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button-container":"doc-return__button-container___Pqan2"};

/***/ }),
/* 1360 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button-container":"invite-user-modal__button-container___3zB1f","cancel":"invite-user-modal__cancel___375tX"};

/***/ }),
/* 1361 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"form":"mail-in-settings__form___268cu"};

/***/ }),
/* 1362 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"no-settings__container___1Dydx","squirrel":"no-settings__squirrel___328w0"};

/***/ }),
/* 1363 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button-group":"remove-self-modal__button-group___1fPsn"};

/***/ }),
/* 1364 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"links":"settings-modal__links___2mKbe"};

/***/ }),
/* 1365 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"controls":"upgrade-downgrade-modal__controls___2fE0l"};

/***/ }),
/* 1366 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"navigation":"tour-content__navigation___2SeKf"};

/***/ }),
/* 1367 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"upload-methods":"alternative-upload-methods__upload-methods___pczqT","upload-title":"alternative-upload-methods__upload-title___2RQrV","upload-image":"alternative-upload-methods__upload-image___1s4-r","upload-image-container":"alternative-upload-methods__upload-image-container___1cf_I","tooltip":"alternative-upload-methods__tooltip___15fs9"};

/***/ }),
/* 1368 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"awaiting-processing-container":"awaiting-processing__awaiting-processing-container___RObRy","pending-item":"awaiting-processing__pending-item___DtFPI","active-pending-item":"awaiting-processing__active-pending-item___1rnxZ","stuck":"awaiting-processing__stuck___2yxo4"};

/***/ }),
/* 1369 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"cancel-processing-container":"cancel-processing-modal__cancel-processing-container___wy1zA","cancel-processing-content":"cancel-processing-modal__cancel-processing-content___sboEd","button-group":"cancel-processing-modal__button-group___t44bN","small":"cancel-processing-modal__small___2lyQb"};

/***/ }),
/* 1370 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"pending-documents-container":"pending-documents-list__pending-documents-container___2Bz6Q","pending-documents":"pending-documents-list__pending-documents___Rc0Bu","pending-titles":"pending-documents-list__pending-titles___2h5Wv","pending-item":"pending-documents-list__pending-item___1PPrg","pending-button":"pending-documents-list__pending-button___1kkj9","link":"pending-documents-list__link___32EEn","number-pending":"pending-documents-list__number-pending___N1mkL"};

/***/ }),
/* 1371 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"title-area":"pending-documents__title-area___nrzQ-","pending-documents-container":"pending-documents__pending-documents-container___37KGl","processing-title":"pending-documents__processing-title___ULw1i","processing-fields":"pending-documents__processing-fields___2Mv4P","processing-viewer":"pending-documents__processing-viewer___1Ioi9","processing-toggle":"pending-documents__processing-toggle___1ES8B","filters":"pending-documents__filters___aFAhl","processing-filters":"pending-documents__processing-filters___2rZ7V","filters-title":"pending-documents__filters-title___2ZNTP","no-pending-container":"pending-documents__no-pending-container___38yE8","no-filtered":"pending-documents__no-filtered___dGyXA"};

/***/ }),
/* 1372 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"framer":"processing-viewer__framer___jueaV"};

/***/ }),
/* 1373 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"upload-modal":"upload-documents__upload-modal___3EmPi","upload-content":"upload-documents__upload-content___2Ygms","upload-title":"upload-documents__upload-title___1XNw0","dropzone":"upload-documents__dropzone___3ax4I","active-dropzone":"upload-documents__active-dropzone___3yga9","upload-button":"upload-documents__upload-button___1L0Fm"};

/***/ }),
/* 1374 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"upload-inline-tabs__container___75k8M"};

/***/ }),
/* 1375 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Select-animation-fadeIn":"virtualized-select__Select-animation-fadeIn___JaSwB","Select-animation-spin":"virtualized-select__Select-animation-spin___1iZDv"};

/***/ }),
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/img/app-store-logo.1cfd5dba4a.svg";

/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/img/at-icon.80540a5226.png";

/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/img/cloud-icon.3ebfc8a970.png";

/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/img/envelope-icon.df2f362be8.png";

/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/img/loading-white.db26bb9bb7.svg";

/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/img/myob-icon.a55c99b872.svg";

/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/img/phone-icon.3257170414.png";

/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/img/qbo-icon.da93ab0b42.svg";

/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/img/remove-button.0438aa182a.svg";

/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/img/saasu-icon.56dc58e0d8.svg";

/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/img/sage-icon.4485d2b24c.svg";

/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/img/squirrel-gesturing.ed063316c1.svg";

/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/img/squirrelstreet-logo-header.ff4aa2652b.png";

/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/img/xero-icon.b2a9cfa0ed.svg";

/***/ }),
/* 1401 */
/***/ (function(module, exports) {

/**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.node = function(value) {
    return value !== undefined
        && value instanceof HTMLElement
        && value.nodeType === 1;
};

/**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.nodeList = function(value) {
    var type = Object.prototype.toString.call(value);

    return value !== undefined
        && (type === '[object NodeList]' || type === '[object HTMLCollection]')
        && ('length' in value)
        && (value.length === 0 || exports.node(value[0]));
};

/**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.string = function(value) {
    return typeof value === 'string'
        || value instanceof String;
};

/**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.fn = function(value) {
    var type = Object.prototype.toString.call(value);

    return type === '[object Function]';
};


/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

var is = __webpack_require__(1401);
var delegate = __webpack_require__(1281);

/**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listen(target, type, callback) {
    if (!target && !type && !callback) {
        throw new Error('Missing required arguments');
    }

    if (!is.string(type)) {
        throw new TypeError('Second argument must be a String');
    }

    if (!is.fn(callback)) {
        throw new TypeError('Third argument must be a Function');
    }

    if (is.node(target)) {
        return listenNode(target, type, callback);
    }
    else if (is.nodeList(target)) {
        return listenNodeList(target, type, callback);
    }
    else if (is.string(target)) {
        return listenSelector(target, type, callback);
    }
    else {
        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
    }
}

/**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNode(node, type, callback) {
    node.addEventListener(type, callback);

    return {
        destroy: function() {
            node.removeEventListener(type, callback);
        }
    }
}

/**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNodeList(nodeList, type, callback) {
    Array.prototype.forEach.call(nodeList, function(node) {
        node.addEventListener(type, callback);
    });

    return {
        destroy: function() {
            Array.prototype.forEach.call(nodeList, function(node) {
                node.removeEventListener(type, callback);
            });
        }
    }
}

/**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenSelector(selector, type, callback) {
    return delegate(document.body, selector, type, callback);
}

module.exports = listen;


/***/ }),
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */
/***/ (function(module, exports) {

/**
 * lodash 3.9.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var funcTag = '[object Function]';

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var fnToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative(value) ? value : undefined;
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in older versions of Chrome and Safari which return 'function' for regexes
  // and Safari 8 equivalents which return 'object' for typed array constructors.
  return isObject(value) && objToString.call(value) == funcTag;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction(value)) {
    return reIsNative.test(fnToString.call(value));
  }
  return isObjectLike(value) && reIsHostCtor.test(value);
}

module.exports = getNative;


/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(92)))

/***/ }),
/* 1508 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

module.exports = isArguments;


/***/ }),
/* 1509 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var arrayTag = '[object Array]',
    funcTag = '[object Function]';

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var fnToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/* Native method references for those with the same name as other `lodash` methods. */
var nativeIsArray = getNative(Array, 'isArray');

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(function() { return arguments; }());
 * // => false
 */
var isArray = nativeIsArray || function(value) {
  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
};

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in older versions of Chrome and Safari which return 'function' for regexes
  // and Safari 8 equivalents which return 'object' for typed array constructors.
  return isObject(value) && objToString.call(value) == funcTag;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction(value)) {
    return reIsNative.test(fnToString.call(value));
  }
  return isObjectLike(value) && reIsHostCtor.test(value);
}

module.exports = isArray;


/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.1.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var getNative = __webpack_require__(1506),
    isArguments = __webpack_require__(1508),
    isArray = __webpack_require__(1509);

/** Used to detect unsigned integer values. */
var reIsUint = /^\d+$/;

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/* Native method references for those with the same name as other `lodash` methods. */
var nativeKeys = getNative(Object, 'keys');

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Checks if `value` is array-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value));
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
  length = length == null ? MAX_SAFE_INTEGER : length;
  return value > -1 && value % 1 == 0 && value < length;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * A fallback implementation of `Object.keys` which creates an array of the
 * own enumerable property names of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function shimKeys(object) {
  var props = keysIn(object),
      propsLength = props.length,
      length = propsLength && object.length;

  var allowIndexes = !!length && isLength(length) &&
    (isArray(object) || isArguments(object));

  var index = -1,
      result = [];

  while (++index < propsLength) {
    var key = props[index];
    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
var keys = !nativeKeys ? shimKeys : function(object) {
  var Ctor = object == null ? undefined : object.constructor;
  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
      (typeof object != 'function' && isArrayLike(object))) {
    return shimKeys(object);
  }
  return isObject(object) ? nativeKeys(object) : [];
};

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  if (object == null) {
    return [];
  }
  if (!isObject(object)) {
    object = Object(object);
  }
  var length = object.length;
  length = (length && isLength(length) &&
    (isArray(object) || isArguments(object)) && length) || 0;

  var Ctor = object.constructor,
      index = -1,
      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
      result = Array(length),
      skipIndexes = length > 0;

  while (++index < length) {
    result[index] = (index + '');
  }
  for (var key in object) {
    if (!(skipIndexes && isIndex(key, length)) &&
        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = keys;


/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} props The property identifiers to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, props) {
  object = Object(object);
  return basePickBy(object, props, function(value, key) {
    return key in object;
  });
}

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} props The property identifiers to pick from.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, props, predicate) {
  var index = -1,
      length = props.length,
      result = {};

  while (++index < length) {
    var key = props[index],
        value = object[key];

    if (predicate(value, key)) {
      result[key] = value;
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [props] The property identifiers to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = baseRest(function(object, props) {
  return object == null ? {} : basePick(object, arrayMap(baseFlatten(props, 1), toKey));
});

module.exports = pick;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(92)))

/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = throttle;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(92)))

/***/ }),
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */,
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */,
/* 1575 */,
/* 1576 */,
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */,
/* 1585 */,
/* 1586 */,
/* 1587 */,
/* 1588 */,
/* 1589 */,
/* 1590 */,
/* 1591 */,
/* 1592 */,
/* 1593 */,
/* 1594 */,
/* 1595 */,
/* 1596 */,
/* 1597 */,
/* 1598 */,
/* 1599 */,
/* 1600 */,
/* 1601 */,
/* 1602 */,
/* 1603 */,
/* 1604 */,
/* 1605 */,
/* 1606 */,
/* 1607 */,
/* 1608 */,
/* 1609 */,
/* 1610 */,
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */,
/* 1615 */,
/* 1616 */,
/* 1617 */,
/* 1618 */,
/* 1619 */,
/* 1620 */,
/* 1621 */,
/* 1622 */,
/* 1623 */,
/* 1624 */,
/* 1625 */,
/* 1626 */,
/* 1627 */,
/* 1628 */,
/* 1629 */,
/* 1630 */,
/* 1631 */,
/* 1632 */,
/* 1633 */,
/* 1634 */,
/* 1635 */,
/* 1636 */,
/* 1637 */,
/* 1638 */,
/* 1639 */,
/* 1640 */,
/* 1641 */,
/* 1642 */,
/* 1643 */,
/* 1644 */,
/* 1645 */,
/* 1646 */,
/* 1647 */,
/* 1648 */,
/* 1649 */,
/* 1650 */,
/* 1651 */,
/* 1652 */,
/* 1653 */,
/* 1654 */,
/* 1655 */,
/* 1656 */,
/* 1657 */,
/* 1658 */,
/* 1659 */,
/* 1660 */,
/* 1661 */,
/* 1662 */,
/* 1663 */,
/* 1664 */,
/* 1665 */,
/* 1666 */,
/* 1667 */,
/* 1668 */,
/* 1669 */,
/* 1670 */,
/* 1671 */,
/* 1672 */,
/* 1673 */,
/* 1674 */,
/* 1675 */,
/* 1676 */,
/* 1677 */,
/* 1678 */,
/* 1679 */,
/* 1680 */,
/* 1681 */,
/* 1682 */,
/* 1683 */,
/* 1684 */,
/* 1685 */,
/* 1686 */,
/* 1687 */,
/* 1688 */,
/* 1689 */,
/* 1690 */,
/* 1691 */,
/* 1692 */,
/* 1693 */,
/* 1694 */,
/* 1695 */,
/* 1696 */,
/* 1697 */,
/* 1698 */,
/* 1699 */,
/* 1700 */,
/* 1701 */,
/* 1702 */,
/* 1703 */,
/* 1704 */,
/* 1705 */,
/* 1706 */,
/* 1707 */,
/* 1708 */,
/* 1709 */,
/* 1710 */,
/* 1711 */,
/* 1712 */,
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(0), __webpack_require__(44));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["ReactDataGrid"] = factory(require("react"), require("react-dom"));
	else
		root["ReactDataGrid"] = factory(root["React"], root["ReactDOM"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_10__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(131);


/***/ }),
/* 1 */,
/* 2 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */

	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;

	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };

	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(148)();
	}


/***/ }),
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */

	(function () {
		'use strict';

		var hasOwn = {}.hasOwnProperty;

		function classNames () {
			var classes = [];

			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;

				var argType = typeof arg;

				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}

			return classes.join(' ');
		}

		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 7 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = {
	  getColumn: function getColumn(columns, idx) {
	    if (Array.isArray(columns)) {
	      return columns[idx];
	    } else if (typeof Immutable !== 'undefined') {
	      return columns.get(idx);
	    }
	  },
	  spliceColumn: function spliceColumn(metrics, idx, column) {
	    if (Array.isArray(metrics.columns)) {
	      metrics.columns.splice(idx, 1, column);
	    } else if (typeof Immutable !== 'undefined') {
	      metrics.columns = metrics.columns.splice(idx, 1, column);
	    }
	    return metrics;
	  },
	  getSize: function getSize(columns) {
	    if (Array.isArray(columns)) {
	      return columns.length;
	    } else if (typeof Immutable !== 'undefined') {
	      return columns.size;
	    }
	  },


	  // Logic extented to allow for functions to be passed down in column.editable
	  // this allows us to deicde whether we can be edting from a cell level
	  canEdit: function canEdit(col, rowData, enableCellSelect) {
	    if (!col) return false;
	    if (col.editable != null && typeof col.editable === 'function') {
	      return enableCellSelect === true && col.editable(rowData);
	    }
	    return enableCellSelect === true && (!!col.editor || !!col.editable);
	  },
	  getValue: function getValue(column, property) {
	    var value = void 0;
	    if (column.toJSON && column.get) {
	      value = column.get(property);
	    } else {
	      value = column[property];
	    }
	    return value;
	  }
	};

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];

		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};

		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];

	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}

		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();

		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

		var styles = listToStyles(list);
		addStylesToDom(styles, options);

		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}

	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}

	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}

	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}

	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}

	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}

	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}

	function addStyle(obj, options) {
		var styleElement, update, remove;

		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}

		update(obj);

		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}

	var replaceText = (function () {
		var textStore = [];

		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();

	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;

		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}

	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;

		if(media) {
			styleElement.setAttribute("media", media)
		}

		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}

	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;

		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}

		var blob = new Blob([css], { type: "text/css" });

		var oldSrc = linkElement.href;

		linkElement.href = URL.createObjectURL(blob);

		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 10 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_10__;

/***/ }),
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _propTypes = __webpack_require__(3);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	module.exports = {
	  selected: _propTypes2['default'].object.isRequired,
	  copied: _propTypes2['default'].object,
	  dragged: _propTypes2['default'].object,
	  onCellClick: _propTypes2['default'].func.isRequired,
	  onCellDoubleClick: _propTypes2['default'].func.isRequired,
	  onCommit: _propTypes2['default'].func.isRequired,
	  onCommitCancel: _propTypes2['default'].func.isRequired,
	  handleDragEnterRow: _propTypes2['default'].func.isRequired,
	  handleTerminateDrag: _propTypes2['default'].func.isRequired,
	  getCellActions: _propTypes2['default'].func
	};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _propTypes = __webpack_require__(3);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	var ExcelColumnShape = {
	  name: _propTypes2['default'].node.isRequired,
	  key: _propTypes2['default'].string.isRequired,
	  width: _propTypes2['default'].number.isRequired,
	  filterable: _propTypes2['default'].bool
	};

	module.exports = ExcelColumnShape;

/***/ }),
/* 14 */,
/* 15 */
/***/ (function(module, exports) {

	"use strict";

	function createObjectWithProperties(originalObj, properties) {
	  var result = {};
	  for (var _iterator = properties, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	    var _ref;

	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }

	    var property = _ref;

	    if (property in originalObj) {
	      result[property] = originalObj[property];
	    }
	  }
	  return result;
	}

	module.exports = createObjectWithProperties;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(142);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(9)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../node_modules/css-loader/index.js!./react-data-grid-header.css", function() {
				var newContent = require("!!../node_modules/css-loader/index.js!./react-data-grid-header.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */

	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.Immutable = factory());
	}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;

	  function createClass(ctor, superClass) {
	    if (superClass) {
	      ctor.prototype = Object.create(superClass.prototype);
	    }
	    ctor.prototype.constructor = ctor;
	  }

	  function Iterable(value) {
	      return isIterable(value) ? value : Seq(value);
	    }


	  createClass(KeyedIterable, Iterable);
	    function KeyedIterable(value) {
	      return isKeyed(value) ? value : KeyedSeq(value);
	    }


	  createClass(IndexedIterable, Iterable);
	    function IndexedIterable(value) {
	      return isIndexed(value) ? value : IndexedSeq(value);
	    }


	  createClass(SetIterable, Iterable);
	    function SetIterable(value) {
	      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
	    }



	  function isIterable(maybeIterable) {
	    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
	  }

	  function isKeyed(maybeKeyed) {
	    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
	  }

	  function isIndexed(maybeIndexed) {
	    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
	  }

	  function isAssociative(maybeAssociative) {
	    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
	  }

	  function isOrdered(maybeOrdered) {
	    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
	  }

	  Iterable.isIterable = isIterable;
	  Iterable.isKeyed = isKeyed;
	  Iterable.isIndexed = isIndexed;
	  Iterable.isAssociative = isAssociative;
	  Iterable.isOrdered = isOrdered;

	  Iterable.Keyed = KeyedIterable;
	  Iterable.Indexed = IndexedIterable;
	  Iterable.Set = SetIterable;


	  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

	  // Used for setting prototype methods that IE8 chokes on.
	  var DELETE = 'delete';

	  // Constants describing the size of trie nodes.
	  var SHIFT = 5; // Resulted in best performance after ______?
	  var SIZE = 1 << SHIFT;
	  var MASK = SIZE - 1;

	  // A consistent shared value representing "not set" which equals nothing other
	  // than itself, and nothing that could be provided externally.
	  var NOT_SET = {};

	  // Boolean references, Rough equivalent of `bool &`.
	  var CHANGE_LENGTH = { value: false };
	  var DID_ALTER = { value: false };

	  function MakeRef(ref) {
	    ref.value = false;
	    return ref;
	  }

	  function SetRef(ref) {
	    ref && (ref.value = true);
	  }

	  // A function which returns a value representing an "owner" for transient writes
	  // to tries. The return value will only ever equal itself, and will not equal
	  // the return of any subsequent call of this function.
	  function OwnerID() {}

	  // http://jsperf.com/copy-array-inline
	  function arrCopy(arr, offset) {
	    offset = offset || 0;
	    var len = Math.max(0, arr.length - offset);
	    var newArr = new Array(len);
	    for (var ii = 0; ii < len; ii++) {
	      newArr[ii] = arr[ii + offset];
	    }
	    return newArr;
	  }

	  function ensureSize(iter) {
	    if (iter.size === undefined) {
	      iter.size = iter.__iterate(returnTrue);
	    }
	    return iter.size;
	  }

	  function wrapIndex(iter, index) {
	    // This implements "is array index" which the ECMAString spec defines as:
	    //
	    //     A String property name P is an array index if and only if
	    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
	    //     to 2^32−1.
	    //
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
	    if (typeof index !== 'number') {
	      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
	      if ('' + uint32Index !== index || uint32Index === 4294967295) {
	        return NaN;
	      }
	      index = uint32Index;
	    }
	    return index < 0 ? ensureSize(iter) + index : index;
	  }

	  function returnTrue() {
	    return true;
	  }

	  function wholeSlice(begin, end, size) {
	    return (begin === 0 || (size !== undefined && begin <= -size)) &&
	      (end === undefined || (size !== undefined && end >= size));
	  }

	  function resolveBegin(begin, size) {
	    return resolveIndex(begin, size, 0);
	  }

	  function resolveEnd(end, size) {
	    return resolveIndex(end, size, size);
	  }

	  function resolveIndex(index, size, defaultIndex) {
	    return index === undefined ?
	      defaultIndex :
	      index < 0 ?
	        Math.max(0, size + index) :
	        size === undefined ?
	          index :
	          Math.min(size, index);
	  }

	  /* global Symbol */

	  var ITERATE_KEYS = 0;
	  var ITERATE_VALUES = 1;
	  var ITERATE_ENTRIES = 2;

	  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator';

	  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;


	  function Iterator(next) {
	      this.next = next;
	    }

	    Iterator.prototype.toString = function() {
	      return '[Iterator]';
	    };


	  Iterator.KEYS = ITERATE_KEYS;
	  Iterator.VALUES = ITERATE_VALUES;
	  Iterator.ENTRIES = ITERATE_ENTRIES;

	  Iterator.prototype.inspect =
	  Iterator.prototype.toSource = function () { return this.toString(); }
	  Iterator.prototype[ITERATOR_SYMBOL] = function () {
	    return this;
	  };


	  function iteratorValue(type, k, v, iteratorResult) {
	    var value = type === 0 ? k : type === 1 ? v : [k, v];
	    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
	      value: value, done: false
	    });
	    return iteratorResult;
	  }

	  function iteratorDone() {
	    return { value: undefined, done: true };
	  }

	  function hasIterator(maybeIterable) {
	    return !!getIteratorFn(maybeIterable);
	  }

	  function isIterator(maybeIterator) {
	    return maybeIterator && typeof maybeIterator.next === 'function';
	  }

	  function getIterator(iterable) {
	    var iteratorFn = getIteratorFn(iterable);
	    return iteratorFn && iteratorFn.call(iterable);
	  }

	  function getIteratorFn(iterable) {
	    var iteratorFn = iterable && (
	      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
	      iterable[FAUX_ITERATOR_SYMBOL]
	    );
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }

	  function isArrayLike(value) {
	    return value && typeof value.length === 'number';
	  }

	  createClass(Seq, Iterable);
	    function Seq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        isIterable(value) ? value.toSeq() : seqFromValue(value);
	    }

	    Seq.of = function(/*...values*/) {
	      return Seq(arguments);
	    };

	    Seq.prototype.toSeq = function() {
	      return this;
	    };

	    Seq.prototype.toString = function() {
	      return this.__toString('Seq {', '}');
	    };

	    Seq.prototype.cacheResult = function() {
	      if (!this._cache && this.__iterateUncached) {
	        this._cache = this.entrySeq().toArray();
	        this.size = this._cache.length;
	      }
	      return this;
	    };

	    // abstract __iterateUncached(fn, reverse)

	    Seq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, true);
	    };

	    // abstract __iteratorUncached(type, reverse)

	    Seq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, true);
	    };



	  createClass(KeyedSeq, Seq);
	    function KeyedSeq(value) {
	      return value === null || value === undefined ?
	        emptySequence().toKeyedSeq() :
	        isIterable(value) ?
	          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
	          keyedSeqFromValue(value);
	    }

	    KeyedSeq.prototype.toKeyedSeq = function() {
	      return this;
	    };



	  createClass(IndexedSeq, Seq);
	    function IndexedSeq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
	    }

	    IndexedSeq.of = function(/*...values*/) {
	      return IndexedSeq(arguments);
	    };

	    IndexedSeq.prototype.toIndexedSeq = function() {
	      return this;
	    };

	    IndexedSeq.prototype.toString = function() {
	      return this.__toString('Seq [', ']');
	    };

	    IndexedSeq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, false);
	    };

	    IndexedSeq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, false);
	    };



	  createClass(SetSeq, Seq);
	    function SetSeq(value) {
	      return (
	        value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value
	      ).toSetSeq();
	    }

	    SetSeq.of = function(/*...values*/) {
	      return SetSeq(arguments);
	    };

	    SetSeq.prototype.toSetSeq = function() {
	      return this;
	    };



	  Seq.isSeq = isSeq;
	  Seq.Keyed = KeyedSeq;
	  Seq.Set = SetSeq;
	  Seq.Indexed = IndexedSeq;

	  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';

	  Seq.prototype[IS_SEQ_SENTINEL] = true;



	  createClass(ArraySeq, IndexedSeq);
	    function ArraySeq(array) {
	      this._array = array;
	      this.size = array.length;
	    }

	    ArraySeq.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
	    };

	    ArraySeq.prototype.__iterate = function(fn, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };

	    ArraySeq.prototype.__iterator = function(type, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
	      );
	    };



	  createClass(ObjectSeq, KeyedSeq);
	    function ObjectSeq(object) {
	      var keys = Object.keys(object);
	      this._object = object;
	      this._keys = keys;
	      this.size = keys.length;
	    }

	    ObjectSeq.prototype.get = function(key, notSetValue) {
	      if (notSetValue !== undefined && !this.has(key)) {
	        return notSetValue;
	      }
	      return this._object[key];
	    };

	    ObjectSeq.prototype.has = function(key) {
	      return this._object.hasOwnProperty(key);
	    };

	    ObjectSeq.prototype.__iterate = function(fn, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        if (fn(object[key], key, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };

	    ObjectSeq.prototype.__iterator = function(type, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, key, object[key]);
	      });
	    };

	  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;


	  createClass(IterableSeq, IndexedSeq);
	    function IterableSeq(iterable) {
	      this._iterable = iterable;
	      this.size = iterable.length || iterable.size;
	    }

	    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      var iterations = 0;
	      if (isIterator(iterator)) {
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (fn(step.value, iterations++, this) === false) {
	            break;
	          }
	        }
	      }
	      return iterations;
	    };

	    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      if (!isIterator(iterator)) {
	        return new Iterator(iteratorDone);
	      }
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step : iteratorValue(type, iterations++, step.value);
	      });
	    };



	  createClass(IteratorSeq, IndexedSeq);
	    function IteratorSeq(iterator) {
	      this._iterator = iterator;
	      this._iteratorCache = [];
	    }

	    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      while (iterations < cache.length) {
	        if (fn(cache[iterations], iterations++, this) === false) {
	          return iterations;
	        }
	      }
	      var step;
	      while (!(step = iterator.next()).done) {
	        var val = step.value;
	        cache[iterations] = val;
	        if (fn(val, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };

	    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      return new Iterator(function()  {
	        if (iterations >= cache.length) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          cache[iterations] = step.value;
	        }
	        return iteratorValue(type, iterations, cache[iterations++]);
	      });
	    };




	  // # pragma Helper functions

	  function isSeq(maybeSeq) {
	    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
	  }

	  var EMPTY_SEQ;

	  function emptySequence() {
	    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
	  }

	  function keyedSeqFromValue(value) {
	    var seq =
	      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
	      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
	      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
	      typeof value === 'object' ? new ObjectSeq(value) :
	      undefined;
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of [k, v] entries, '+
	        'or keyed object: ' + value
	      );
	    }
	    return seq;
	  }

	  function indexedSeqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value);
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values: ' + value
	      );
	    }
	    return seq;
	  }

	  function seqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value) ||
	      (typeof value === 'object' && new ObjectSeq(value));
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values, or keyed object: ' + value
	      );
	    }
	    return seq;
	  }

	  function maybeIndexedSeqFromValue(value) {
	    return (
	      isArrayLike(value) ? new ArraySeq(value) :
	      isIterator(value) ? new IteratorSeq(value) :
	      hasIterator(value) ? new IterableSeq(value) :
	      undefined
	    );
	  }

	  function seqIterate(seq, fn, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    }
	    return seq.__iterateUncached(fn, reverse);
	  }

	  function seqIterator(seq, type, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
	      });
	    }
	    return seq.__iteratorUncached(type, reverse);
	  }

	  function fromJS(json, converter) {
	    return converter ?
	      fromJSWith(converter, json, '', {'': json}) :
	      fromJSDefault(json);
	  }

	  function fromJSWith(converter, json, key, parentJSON) {
	    if (Array.isArray(json)) {
	      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    if (isPlainObj(json)) {
	      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    return json;
	  }

	  function fromJSDefault(json) {
	    if (Array.isArray(json)) {
	      return IndexedSeq(json).map(fromJSDefault).toList();
	    }
	    if (isPlainObj(json)) {
	      return KeyedSeq(json).map(fromJSDefault).toMap();
	    }
	    return json;
	  }

	  function isPlainObj(value) {
	    return value && (value.constructor === Object || value.constructor === undefined);
	  }

	  /**
	   * An extension of the "same-value" algorithm as [described for use by ES6 Map
	   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
	   *
	   * NaN is considered the same as NaN, however -0 and 0 are considered the same
	   * value, which is different from the algorithm described by
	   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
	   *
	   * This is extended further to allow Objects to describe the values they
	   * represent, by way of `valueOf` or `equals` (and `hashCode`).
	   *
	   * Note: because of this extension, the key equality of Immutable.Map and the
	   * value equality of Immutable.Set will differ from ES6 Map and Set.
	   *
	   * ### Defining custom values
	   *
	   * The easiest way to describe the value an object represents is by implementing
	   * `valueOf`. For example, `Date` represents a value by returning a unix
	   * timestamp for `valueOf`:
	   *
	   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
	   *     var date2 = new Date(1234567890000);
	   *     date1.valueOf(); // 1234567890000
	   *     assert( date1 !== date2 );
	   *     assert( Immutable.is( date1, date2 ) );
	   *
	   * Note: overriding `valueOf` may have other implications if you use this object
	   * where JavaScript expects a primitive, such as implicit string coercion.
	   *
	   * For more complex types, especially collections, implementing `valueOf` may
	   * not be performant. An alternative is to implement `equals` and `hashCode`.
	   *
	   * `equals` takes another object, presumably of similar type, and returns true
	   * if the it is equal. Equality is symmetrical, so the same result should be
	   * returned if this and the argument are flipped.
	   *
	   *     assert( a.equals(b) === b.equals(a) );
	   *
	   * `hashCode` returns a 32bit integer number representing the object which will
	   * be used to determine how to store the value object in a Map or Set. You must
	   * provide both or neither methods, one must not exist without the other.
	   *
	   * Also, an important relationship between these methods must be upheld: if two
	   * values are equal, they *must* return the same hashCode. If the values are not
	   * equal, they might have the same hashCode; this is called a hash collision,
	   * and while undesirable for performance reasons, it is acceptable.
	   *
	   *     if (a.equals(b)) {
	   *       assert( a.hashCode() === b.hashCode() );
	   *     }
	   *
	   * All Immutable collections implement `equals` and `hashCode`.
	   *
	   */
	  function is(valueA, valueB) {
	    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	      return true;
	    }
	    if (!valueA || !valueB) {
	      return false;
	    }
	    if (typeof valueA.valueOf === 'function' &&
	        typeof valueB.valueOf === 'function') {
	      valueA = valueA.valueOf();
	      valueB = valueB.valueOf();
	      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	        return true;
	      }
	      if (!valueA || !valueB) {
	        return false;
	      }
	    }
	    if (typeof valueA.equals === 'function' &&
	        typeof valueB.equals === 'function' &&
	        valueA.equals(valueB)) {
	      return true;
	    }
	    return false;
	  }

	  function deepEqual(a, b) {
	    if (a === b) {
	      return true;
	    }

	    if (
	      !isIterable(b) ||
	      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
	      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
	      isKeyed(a) !== isKeyed(b) ||
	      isIndexed(a) !== isIndexed(b) ||
	      isOrdered(a) !== isOrdered(b)
	    ) {
	      return false;
	    }

	    if (a.size === 0 && b.size === 0) {
	      return true;
	    }

	    var notAssociative = !isAssociative(a);

	    if (isOrdered(a)) {
	      var entries = a.entries();
	      return b.every(function(v, k)  {
	        var entry = entries.next().value;
	        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
	      }) && entries.next().done;
	    }

	    var flipped = false;

	    if (a.size === undefined) {
	      if (b.size === undefined) {
	        if (typeof a.cacheResult === 'function') {
	          a.cacheResult();
	        }
	      } else {
	        flipped = true;
	        var _ = a;
	        a = b;
	        b = _;
	      }
	    }

	    var allEqual = true;
	    var bSize = b.__iterate(function(v, k)  {
	      if (notAssociative ? !a.has(v) :
	          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
	        allEqual = false;
	        return false;
	      }
	    });

	    return allEqual && a.size === bSize;
	  }

	  createClass(Repeat, IndexedSeq);

	    function Repeat(value, times) {
	      if (!(this instanceof Repeat)) {
	        return new Repeat(value, times);
	      }
	      this._value = value;
	      this.size = times === undefined ? Infinity : Math.max(0, times);
	      if (this.size === 0) {
	        if (EMPTY_REPEAT) {
	          return EMPTY_REPEAT;
	        }
	        EMPTY_REPEAT = this;
	      }
	    }

	    Repeat.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Repeat []';
	      }
	      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
	    };

	    Repeat.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._value : notSetValue;
	    };

	    Repeat.prototype.includes = function(searchValue) {
	      return is(this._value, searchValue);
	    };

	    Repeat.prototype.slice = function(begin, end) {
	      var size = this.size;
	      return wholeSlice(begin, end, size) ? this :
	        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
	    };

	    Repeat.prototype.reverse = function() {
	      return this;
	    };

	    Repeat.prototype.indexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return 0;
	      }
	      return -1;
	    };

	    Repeat.prototype.lastIndexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return this.size;
	      }
	      return -1;
	    };

	    Repeat.prototype.__iterate = function(fn, reverse) {
	      for (var ii = 0; ii < this.size; ii++) {
	        if (fn(this._value, ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };

	    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
	      );
	    };

	    Repeat.prototype.equals = function(other) {
	      return other instanceof Repeat ?
	        is(this._value, other._value) :
	        deepEqual(other);
	    };


	  var EMPTY_REPEAT;

	  function invariant(condition, error) {
	    if (!condition) throw new Error(error);
	  }

	  createClass(Range, IndexedSeq);

	    function Range(start, end, step) {
	      if (!(this instanceof Range)) {
	        return new Range(start, end, step);
	      }
	      invariant(step !== 0, 'Cannot step a Range by 0');
	      start = start || 0;
	      if (end === undefined) {
	        end = Infinity;
	      }
	      step = step === undefined ? 1 : Math.abs(step);
	      if (end < start) {
	        step = -step;
	      }
	      this._start = start;
	      this._end = end;
	      this._step = step;
	      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
	      if (this.size === 0) {
	        if (EMPTY_RANGE) {
	          return EMPTY_RANGE;
	        }
	        EMPTY_RANGE = this;
	      }
	    }

	    Range.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Range []';
	      }
	      return 'Range [ ' +
	        this._start + '...' + this._end +
	        (this._step !== 1 ? ' by ' + this._step : '') +
	      ' ]';
	    };

	    Range.prototype.get = function(index, notSetValue) {
	      return this.has(index) ?
	        this._start + wrapIndex(this, index) * this._step :
	        notSetValue;
	    };

	    Range.prototype.includes = function(searchValue) {
	      var possibleIndex = (searchValue - this._start) / this._step;
	      return possibleIndex >= 0 &&
	        possibleIndex < this.size &&
	        possibleIndex === Math.floor(possibleIndex);
	    };

	    Range.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      begin = resolveBegin(begin, this.size);
	      end = resolveEnd(end, this.size);
	      if (end <= begin) {
	        return new Range(0, 0);
	      }
	      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
	    };

	    Range.prototype.indexOf = function(searchValue) {
	      var offsetValue = searchValue - this._start;
	      if (offsetValue % this._step === 0) {
	        var index = offsetValue / this._step;
	        if (index >= 0 && index < this.size) {
	          return index
	        }
	      }
	      return -1;
	    };

	    Range.prototype.lastIndexOf = function(searchValue) {
	      return this.indexOf(searchValue);
	    };

	    Range.prototype.__iterate = function(fn, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(value, ii, this) === false) {
	          return ii + 1;
	        }
	        value += reverse ? -step : step;
	      }
	      return ii;
	    };

	    Range.prototype.__iterator = function(type, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      var ii = 0;
	      return new Iterator(function()  {
	        var v = value;
	        value += reverse ? -step : step;
	        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
	      });
	    };

	    Range.prototype.equals = function(other) {
	      return other instanceof Range ?
	        this._start === other._start &&
	        this._end === other._end &&
	        this._step === other._step :
	        deepEqual(this, other);
	    };


	  var EMPTY_RANGE;

	  createClass(Collection, Iterable);
	    function Collection() {
	      throw TypeError('Abstract');
	    }


	  createClass(KeyedCollection, Collection);function KeyedCollection() {}

	  createClass(IndexedCollection, Collection);function IndexedCollection() {}

	  createClass(SetCollection, Collection);function SetCollection() {}


	  Collection.Keyed = KeyedCollection;
	  Collection.Indexed = IndexedCollection;
	  Collection.Set = SetCollection;

	  var imul =
	    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
	    Math.imul :
	    function imul(a, b) {
	      a = a | 0; // int
	      b = b | 0; // int
	      var c = a & 0xffff;
	      var d = b & 0xffff;
	      // Shift by 0 fixes the sign on the high part.
	      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
	    };

	  // v8 has an optimization for storing 31-bit signed numbers.
	  // Values which have either 00 or 11 as the high order bits qualify.
	  // This function drops the highest order bit in a signed number, maintaining
	  // the sign bit.
	  function smi(i32) {
	    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
	  }

	  function hash(o) {
	    if (o === false || o === null || o === undefined) {
	      return 0;
	    }
	    if (typeof o.valueOf === 'function') {
	      o = o.valueOf();
	      if (o === false || o === null || o === undefined) {
	        return 0;
	      }
	    }
	    if (o === true) {
	      return 1;
	    }
	    var type = typeof o;
	    if (type === 'number') {
	      if (o !== o || o === Infinity) {
	        return 0;
	      }
	      var h = o | 0;
	      if (h !== o) {
	        h ^= o * 0xFFFFFFFF;
	      }
	      while (o > 0xFFFFFFFF) {
	        o /= 0xFFFFFFFF;
	        h ^= o;
	      }
	      return smi(h);
	    }
	    if (type === 'string') {
	      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
	    }
	    if (typeof o.hashCode === 'function') {
	      return o.hashCode();
	    }
	    if (type === 'object') {
	      return hashJSObj(o);
	    }
	    if (typeof o.toString === 'function') {
	      return hashString(o.toString());
	    }
	    throw new Error('Value type ' + type + ' cannot be hashed.');
	  }

	  function cachedHashString(string) {
	    var hash = stringHashCache[string];
	    if (hash === undefined) {
	      hash = hashString(string);
	      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
	        STRING_HASH_CACHE_SIZE = 0;
	        stringHashCache = {};
	      }
	      STRING_HASH_CACHE_SIZE++;
	      stringHashCache[string] = hash;
	    }
	    return hash;
	  }

	  // http://jsperf.com/hashing-strings
	  function hashString(string) {
	    // This is the hash from JVM
	    // The hash code for a string is computed as
	    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
	    // where s[i] is the ith character of the string and n is the length of
	    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
	    // (exclusive) by dropping high bits.
	    var hash = 0;
	    for (var ii = 0; ii < string.length; ii++) {
	      hash = 31 * hash + string.charCodeAt(ii) | 0;
	    }
	    return smi(hash);
	  }

	  function hashJSObj(obj) {
	    var hash;
	    if (usingWeakMap) {
	      hash = weakMap.get(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }

	    hash = obj[UID_HASH_KEY];
	    if (hash !== undefined) {
	      return hash;
	    }

	    if (!canDefineProperty) {
	      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
	      if (hash !== undefined) {
	        return hash;
	      }

	      hash = getIENodeHash(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }

	    hash = ++objHashUID;
	    if (objHashUID & 0x40000000) {
	      objHashUID = 0;
	    }

	    if (usingWeakMap) {
	      weakMap.set(obj, hash);
	    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
	      throw new Error('Non-extensible objects are not allowed as keys.');
	    } else if (canDefineProperty) {
	      Object.defineProperty(obj, UID_HASH_KEY, {
	        'enumerable': false,
	        'configurable': false,
	        'writable': false,
	        'value': hash
	      });
	    } else if (obj.propertyIsEnumerable !== undefined &&
	               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
	      // Since we can't define a non-enumerable property on the object
	      // we'll hijack one of the less-used non-enumerable properties to
	      // save our hash on it. Since this is a function it will not show up in
	      // `JSON.stringify` which is what we want.
	      obj.propertyIsEnumerable = function() {
	        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
	      };
	      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
	    } else if (obj.nodeType !== undefined) {
	      // At this point we couldn't get the IE `uniqueID` to use as a hash
	      // and we couldn't use a non-enumerable property to exploit the
	      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
	      // itself.
	      obj[UID_HASH_KEY] = hash;
	    } else {
	      throw new Error('Unable to set a non-enumerable property on object.');
	    }

	    return hash;
	  }

	  // Get references to ES5 object methods.
	  var isExtensible = Object.isExtensible;

	  // True if Object.defineProperty works as expected. IE8 fails this test.
	  var canDefineProperty = (function() {
	    try {
	      Object.defineProperty({}, '@', {});
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }());

	  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
	  // and avoid memory leaks from the IE cloneNode bug.
	  function getIENodeHash(node) {
	    if (node && node.nodeType > 0) {
	      switch (node.nodeType) {
	        case 1: // Element
	          return node.uniqueID;
	        case 9: // Document
	          return node.documentElement && node.documentElement.uniqueID;
	      }
	    }
	  }

	  // If possible, use a WeakMap.
	  var usingWeakMap = typeof WeakMap === 'function';
	  var weakMap;
	  if (usingWeakMap) {
	    weakMap = new WeakMap();
	  }

	  var objHashUID = 0;

	  var UID_HASH_KEY = '__immutablehash__';
	  if (typeof Symbol === 'function') {
	    UID_HASH_KEY = Symbol(UID_HASH_KEY);
	  }

	  var STRING_HASH_CACHE_MIN_STRLEN = 16;
	  var STRING_HASH_CACHE_MAX_SIZE = 255;
	  var STRING_HASH_CACHE_SIZE = 0;
	  var stringHashCache = {};

	  function assertNotInfinite(size) {
	    invariant(
	      size !== Infinity,
	      'Cannot perform this action with an infinite size.'
	    );
	  }

	  createClass(Map, KeyedCollection);

	    // @pragma Construction

	    function Map(value) {
	      return value === null || value === undefined ? emptyMap() :
	        isMap(value) && !isOrdered(value) ? value :
	        emptyMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }

	    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
	      return emptyMap().withMutations(function(map ) {
	        for (var i = 0; i < keyValues.length; i += 2) {
	          if (i + 1 >= keyValues.length) {
	            throw new Error('Missing value for key: ' + keyValues[i]);
	          }
	          map.set(keyValues[i], keyValues[i + 1]);
	        }
	      });
	    };

	    Map.prototype.toString = function() {
	      return this.__toString('Map {', '}');
	    };

	    // @pragma Access

	    Map.prototype.get = function(k, notSetValue) {
	      return this._root ?
	        this._root.get(0, undefined, k, notSetValue) :
	        notSetValue;
	    };

	    // @pragma Modification

	    Map.prototype.set = function(k, v) {
	      return updateMap(this, k, v);
	    };

	    Map.prototype.setIn = function(keyPath, v) {
	      return this.updateIn(keyPath, NOT_SET, function()  {return v});
	    };

	    Map.prototype.remove = function(k) {
	      return updateMap(this, k, NOT_SET);
	    };

	    Map.prototype.deleteIn = function(keyPath) {
	      return this.updateIn(keyPath, function()  {return NOT_SET});
	    };

	    Map.prototype.update = function(k, notSetValue, updater) {
	      return arguments.length === 1 ?
	        k(this) :
	        this.updateIn([k], notSetValue, updater);
	    };

	    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
	      if (!updater) {
	        updater = notSetValue;
	        notSetValue = undefined;
	      }
	      var updatedValue = updateInDeepMap(
	        this,
	        forceIterator(keyPath),
	        notSetValue,
	        updater
	      );
	      return updatedValue === NOT_SET ? undefined : updatedValue;
	    };

	    Map.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._root = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyMap();
	    };

	    // @pragma Composition

	    Map.prototype.merge = function(/*...iters*/) {
	      return mergeIntoMapWith(this, undefined, arguments);
	    };

	    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, merger, iters);
	    };

	    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.merge === 'function' ?
	          m.merge.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };

	    Map.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoMapWith(this, deepMerger, arguments);
	    };

	    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
	    };

	    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.mergeDeep === 'function' ?
	          m.mergeDeep.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };

	    Map.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator));
	    };

	    Map.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator, mapper));
	    };

	    // @pragma Mutability

	    Map.prototype.withMutations = function(fn) {
	      var mutable = this.asMutable();
	      fn(mutable);
	      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
	    };

	    Map.prototype.asMutable = function() {
	      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
	    };

	    Map.prototype.asImmutable = function() {
	      return this.__ensureOwner();
	    };

	    Map.prototype.wasAltered = function() {
	      return this.__altered;
	    };

	    Map.prototype.__iterator = function(type, reverse) {
	      return new MapIterator(this, type, reverse);
	    };

	    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      this._root && this._root.iterate(function(entry ) {
	        iterations++;
	        return fn(entry[1], entry[0], this$0);
	      }, reverse);
	      return iterations;
	    };

	    Map.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeMap(this.size, this._root, ownerID, this.__hash);
	    };


	  function isMap(maybeMap) {
	    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
	  }

	  Map.isMap = isMap;

	  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';

	  var MapPrototype = Map.prototype;
	  MapPrototype[IS_MAP_SENTINEL] = true;
	  MapPrototype[DELETE] = MapPrototype.remove;
	  MapPrototype.removeIn = MapPrototype.deleteIn;


	  // #pragma Trie Nodes



	    function ArrayMapNode(ownerID, entries) {
	      this.ownerID = ownerID;
	      this.entries = entries;
	    }

	    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };

	    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;

	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;

	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }

	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);

	      if (removed && entries.length === 1) {
	        return; // undefined
	      }

	      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
	        return createNodes(ownerID, entries, key, value);
	      }

	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);

	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }

	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }

	      return new ArrayMapNode(ownerID, newEntries);
	    };




	    function BitmapIndexedNode(ownerID, bitmap, nodes) {
	      this.ownerID = ownerID;
	      this.bitmap = bitmap;
	      this.nodes = nodes;
	    }

	    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
	      var bitmap = this.bitmap;
	      return (bitmap & bit) === 0 ? notSetValue :
	        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
	    };

	    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var bit = 1 << keyHashFrag;
	      var bitmap = this.bitmap;
	      var exists = (bitmap & bit) !== 0;

	      if (!exists && value === NOT_SET) {
	        return this;
	      }

	      var idx = popCount(bitmap & (bit - 1));
	      var nodes = this.nodes;
	      var node = exists ? nodes[idx] : undefined;
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);

	      if (newNode === node) {
	        return this;
	      }

	      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
	        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
	      }

	      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
	        return nodes[idx ^ 1];
	      }

	      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
	        return newNode;
	      }

	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
	      var newNodes = exists ? newNode ?
	        setIn(nodes, idx, newNode, isEditable) :
	        spliceOut(nodes, idx, isEditable) :
	        spliceIn(nodes, idx, newNode, isEditable);

	      if (isEditable) {
	        this.bitmap = newBitmap;
	        this.nodes = newNodes;
	        return this;
	      }

	      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
	    };




	    function HashArrayMapNode(ownerID, count, nodes) {
	      this.ownerID = ownerID;
	      this.count = count;
	      this.nodes = nodes;
	    }

	    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var node = this.nodes[idx];
	      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
	    };

	    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var removed = value === NOT_SET;
	      var nodes = this.nodes;
	      var node = nodes[idx];

	      if (removed && !node) {
	        return this;
	      }

	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	      if (newNode === node) {
	        return this;
	      }

	      var newCount = this.count;
	      if (!node) {
	        newCount++;
	      } else if (!newNode) {
	        newCount--;
	        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
	          return packNodes(ownerID, nodes, newCount, idx);
	        }
	      }

	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newNodes = setIn(nodes, idx, newNode, isEditable);

	      if (isEditable) {
	        this.count = newCount;
	        this.nodes = newNodes;
	        return this;
	      }

	      return new HashArrayMapNode(ownerID, newCount, newNodes);
	    };




	    function HashCollisionNode(ownerID, keyHash, entries) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entries = entries;
	    }

	    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };

	    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }

	      var removed = value === NOT_SET;

	      if (keyHash !== this.keyHash) {
	        if (removed) {
	          return this;
	        }
	        SetRef(didAlter);
	        SetRef(didChangeSize);
	        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
	      }

	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;

	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }

	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);

	      if (removed && len === 2) {
	        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
	      }

	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);

	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }

	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }

	      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
	    };




	    function ValueNode(ownerID, keyHash, entry) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entry = entry;
	    }

	    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
	    };

	    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	      var keyMatch = is(key, this.entry[0]);
	      if (keyMatch ? value === this.entry[1] : removed) {
	        return this;
	      }

	      SetRef(didAlter);

	      if (removed) {
	        SetRef(didChangeSize);
	        return; // undefined
	      }

	      if (keyMatch) {
	        if (ownerID && ownerID === this.ownerID) {
	          this.entry[1] = value;
	          return this;
	        }
	        return new ValueNode(ownerID, this.keyHash, [key, value]);
	      }

	      SetRef(didChangeSize);
	      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
	    };



	  // #pragma Iterators

	  ArrayMapNode.prototype.iterate =
	  HashCollisionNode.prototype.iterate = function (fn, reverse) {
	    var entries = this.entries;
	    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
	      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
	        return false;
	      }
	    }
	  }

	  BitmapIndexedNode.prototype.iterate =
	  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
	    var nodes = this.nodes;
	    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
	      var node = nodes[reverse ? maxIndex - ii : ii];
	      if (node && node.iterate(fn, reverse) === false) {
	        return false;
	      }
	    }
	  }

	  ValueNode.prototype.iterate = function (fn, reverse) {
	    return fn(this.entry);
	  }

	  createClass(MapIterator, Iterator);

	    function MapIterator(map, type, reverse) {
	      this._type = type;
	      this._reverse = reverse;
	      this._stack = map._root && mapIteratorFrame(map._root);
	    }

	    MapIterator.prototype.next = function() {
	      var type = this._type;
	      var stack = this._stack;
	      while (stack) {
	        var node = stack.node;
	        var index = stack.index++;
	        var maxIndex;
	        if (node.entry) {
	          if (index === 0) {
	            return mapIteratorValue(type, node.entry);
	          }
	        } else if (node.entries) {
	          maxIndex = node.entries.length - 1;
	          if (index <= maxIndex) {
	            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
	          }
	        } else {
	          maxIndex = node.nodes.length - 1;
	          if (index <= maxIndex) {
	            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
	            if (subNode) {
	              if (subNode.entry) {
	                return mapIteratorValue(type, subNode.entry);
	              }
	              stack = this._stack = mapIteratorFrame(subNode, stack);
	            }
	            continue;
	          }
	        }
	        stack = this._stack = this._stack.__prev;
	      }
	      return iteratorDone();
	    };


	  function mapIteratorValue(type, entry) {
	    return iteratorValue(type, entry[0], entry[1]);
	  }

	  function mapIteratorFrame(node, prev) {
	    return {
	      node: node,
	      index: 0,
	      __prev: prev
	    };
	  }

	  function makeMap(size, root, ownerID, hash) {
	    var map = Object.create(MapPrototype);
	    map.size = size;
	    map._root = root;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }

	  var EMPTY_MAP;
	  function emptyMap() {
	    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
	  }

	  function updateMap(map, k, v) {
	    var newRoot;
	    var newSize;
	    if (!map._root) {
	      if (v === NOT_SET) {
	        return map;
	      }
	      newSize = 1;
	      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
	    } else {
	      var didChangeSize = MakeRef(CHANGE_LENGTH);
	      var didAlter = MakeRef(DID_ALTER);
	      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
	      if (!didAlter.value) {
	        return map;
	      }
	      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
	    }
	    if (map.__ownerID) {
	      map.size = newSize;
	      map._root = newRoot;
	      map.__hash = undefined;
	      map.__altered = true;
	      return map;
	    }
	    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
	  }

	  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    if (!node) {
	      if (value === NOT_SET) {
	        return node;
	      }
	      SetRef(didAlter);
	      SetRef(didChangeSize);
	      return new ValueNode(ownerID, keyHash, [key, value]);
	    }
	    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
	  }

	  function isLeafNode(node) {
	    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
	  }

	  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
	    if (node.keyHash === keyHash) {
	      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
	    }

	    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
	    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;

	    var newNode;
	    var nodes = idx1 === idx2 ?
	      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
	      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);

	    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
	  }

	  function createNodes(ownerID, entries, key, value) {
	    if (!ownerID) {
	      ownerID = new OwnerID();
	    }
	    var node = new ValueNode(ownerID, hash(key), [key, value]);
	    for (var ii = 0; ii < entries.length; ii++) {
	      var entry = entries[ii];
	      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
	    }
	    return node;
	  }

	  function packNodes(ownerID, nodes, count, excluding) {
	    var bitmap = 0;
	    var packedII = 0;
	    var packedNodes = new Array(count);
	    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
	      var node = nodes[ii];
	      if (node !== undefined && ii !== excluding) {
	        bitmap |= bit;
	        packedNodes[packedII++] = node;
	      }
	    }
	    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
	  }

	  function expandNodes(ownerID, nodes, bitmap, including, node) {
	    var count = 0;
	    var expandedNodes = new Array(SIZE);
	    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
	      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
	    }
	    expandedNodes[including] = node;
	    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
	  }

	  function mergeIntoMapWith(map, merger, iterables) {
	    var iters = [];
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = KeyedIterable(value);
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    return mergeIntoCollectionWith(map, merger, iters);
	  }

	  function deepMerger(existing, value, key) {
	    return existing && existing.mergeDeep && isIterable(value) ?
	      existing.mergeDeep(value) :
	      is(existing, value) ? existing : value;
	  }

	  function deepMergerWith(merger) {
	    return function(existing, value, key)  {
	      if (existing && existing.mergeDeepWith && isIterable(value)) {
	        return existing.mergeDeepWith(merger, value);
	      }
	      var nextValue = merger(existing, value, key);
	      return is(existing, nextValue) ? existing : nextValue;
	    };
	  }

	  function mergeIntoCollectionWith(collection, merger, iters) {
	    iters = iters.filter(function(x ) {return x.size !== 0});
	    if (iters.length === 0) {
	      return collection;
	    }
	    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
	      return collection.constructor(iters[0]);
	    }
	    return collection.withMutations(function(collection ) {
	      var mergeIntoMap = merger ?
	        function(value, key)  {
	          collection.update(key, NOT_SET, function(existing )
	            {return existing === NOT_SET ? value : merger(existing, value, key)}
	          );
	        } :
	        function(value, key)  {
	          collection.set(key, value);
	        }
	      for (var ii = 0; ii < iters.length; ii++) {
	        iters[ii].forEach(mergeIntoMap);
	      }
	    });
	  }

	  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
	    var isNotSet = existing === NOT_SET;
	    var step = keyPathIter.next();
	    if (step.done) {
	      var existingValue = isNotSet ? notSetValue : existing;
	      var newValue = updater(existingValue);
	      return newValue === existingValue ? existing : newValue;
	    }
	    invariant(
	      isNotSet || (existing && existing.set),
	      'invalid keyPath'
	    );
	    var key = step.value;
	    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
	    var nextUpdated = updateInDeepMap(
	      nextExisting,
	      keyPathIter,
	      notSetValue,
	      updater
	    );
	    return nextUpdated === nextExisting ? existing :
	      nextUpdated === NOT_SET ? existing.remove(key) :
	      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
	  }

	  function popCount(x) {
	    x = x - ((x >> 1) & 0x55555555);
	    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
	    x = (x + (x >> 4)) & 0x0f0f0f0f;
	    x = x + (x >> 8);
	    x = x + (x >> 16);
	    return x & 0x7f;
	  }

	  function setIn(array, idx, val, canEdit) {
	    var newArray = canEdit ? array : arrCopy(array);
	    newArray[idx] = val;
	    return newArray;
	  }

	  function spliceIn(array, idx, val, canEdit) {
	    var newLen = array.length + 1;
	    if (canEdit && idx + 1 === newLen) {
	      array[idx] = val;
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        newArray[ii] = val;
	        after = -1;
	      } else {
	        newArray[ii] = array[ii + after];
	      }
	    }
	    return newArray;
	  }

	  function spliceOut(array, idx, canEdit) {
	    var newLen = array.length - 1;
	    if (canEdit && idx === newLen) {
	      array.pop();
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        after = 1;
	      }
	      newArray[ii] = array[ii + after];
	    }
	    return newArray;
	  }

	  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
	  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
	  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;

	  createClass(List, IndexedCollection);

	    // @pragma Construction

	    function List(value) {
	      var empty = emptyList();
	      if (value === null || value === undefined) {
	        return empty;
	      }
	      if (isList(value)) {
	        return value;
	      }
	      var iter = IndexedIterable(value);
	      var size = iter.size;
	      if (size === 0) {
	        return empty;
	      }
	      assertNotInfinite(size);
	      if (size > 0 && size < SIZE) {
	        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
	      }
	      return empty.withMutations(function(list ) {
	        list.setSize(size);
	        iter.forEach(function(v, i)  {return list.set(i, v)});
	      });
	    }

	    List.of = function(/*...values*/) {
	      return this(arguments);
	    };

	    List.prototype.toString = function() {
	      return this.__toString('List [', ']');
	    };

	    // @pragma Access

	    List.prototype.get = function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      if (index >= 0 && index < this.size) {
	        index += this._origin;
	        var node = listNodeFor(this, index);
	        return node && node.array[index & MASK];
	      }
	      return notSetValue;
	    };

	    // @pragma Modification

	    List.prototype.set = function(index, value) {
	      return updateList(this, index, value);
	    };

	    List.prototype.remove = function(index) {
	      return !this.has(index) ? this :
	        index === 0 ? this.shift() :
	        index === this.size - 1 ? this.pop() :
	        this.splice(index, 1);
	    };

	    List.prototype.insert = function(index, value) {
	      return this.splice(index, 0, value);
	    };

	    List.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = this._origin = this._capacity = 0;
	        this._level = SHIFT;
	        this._root = this._tail = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyList();
	    };

	    List.prototype.push = function(/*...values*/) {
	      var values = arguments;
	      var oldSize = this.size;
	      return this.withMutations(function(list ) {
	        setListBounds(list, 0, oldSize + values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(oldSize + ii, values[ii]);
	        }
	      });
	    };

	    List.prototype.pop = function() {
	      return setListBounds(this, 0, -1);
	    };

	    List.prototype.unshift = function(/*...values*/) {
	      var values = arguments;
	      return this.withMutations(function(list ) {
	        setListBounds(list, -values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(ii, values[ii]);
	        }
	      });
	    };

	    List.prototype.shift = function() {
	      return setListBounds(this, 1);
	    };

	    // @pragma Composition

	    List.prototype.merge = function(/*...iters*/) {
	      return mergeIntoListWith(this, undefined, arguments);
	    };

	    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, merger, iters);
	    };

	    List.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoListWith(this, deepMerger, arguments);
	    };

	    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, deepMergerWith(merger), iters);
	    };

	    List.prototype.setSize = function(size) {
	      return setListBounds(this, 0, size);
	    };

	    // @pragma Iteration

	    List.prototype.slice = function(begin, end) {
	      var size = this.size;
	      if (wholeSlice(begin, end, size)) {
	        return this;
	      }
	      return setListBounds(
	        this,
	        resolveBegin(begin, size),
	        resolveEnd(end, size)
	      );
	    };

	    List.prototype.__iterator = function(type, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      return new Iterator(function()  {
	        var value = values();
	        return value === DONE ?
	          iteratorDone() :
	          iteratorValue(type, index++, value);
	      });
	    };

	    List.prototype.__iterate = function(fn, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      var value;
	      while ((value = values()) !== DONE) {
	        if (fn(value, index++, this) === false) {
	          break;
	        }
	      }
	      return index;
	    };

	    List.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        return this;
	      }
	      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
	    };


	  function isList(maybeList) {
	    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
	  }

	  List.isList = isList;

	  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';

	  var ListPrototype = List.prototype;
	  ListPrototype[IS_LIST_SENTINEL] = true;
	  ListPrototype[DELETE] = ListPrototype.remove;
	  ListPrototype.setIn = MapPrototype.setIn;
	  ListPrototype.deleteIn =
	  ListPrototype.removeIn = MapPrototype.removeIn;
	  ListPrototype.update = MapPrototype.update;
	  ListPrototype.updateIn = MapPrototype.updateIn;
	  ListPrototype.mergeIn = MapPrototype.mergeIn;
	  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  ListPrototype.withMutations = MapPrototype.withMutations;
	  ListPrototype.asMutable = MapPrototype.asMutable;
	  ListPrototype.asImmutable = MapPrototype.asImmutable;
	  ListPrototype.wasAltered = MapPrototype.wasAltered;



	    function VNode(array, ownerID) {
	      this.array = array;
	      this.ownerID = ownerID;
	    }

	    // TODO: seems like these methods are very similar

	    VNode.prototype.removeBefore = function(ownerID, level, index) {
	      if (index === level ? 1 << level : 0 || this.array.length === 0) {
	        return this;
	      }
	      var originIndex = (index >>> level) & MASK;
	      if (originIndex >= this.array.length) {
	        return new VNode([], ownerID);
	      }
	      var removingFirst = originIndex === 0;
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[originIndex];
	        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && removingFirst) {
	          return this;
	        }
	      }
	      if (removingFirst && !newChild) {
	        return this;
	      }
	      var editable = editableVNode(this, ownerID);
	      if (!removingFirst) {
	        for (var ii = 0; ii < originIndex; ii++) {
	          editable.array[ii] = undefined;
	        }
	      }
	      if (newChild) {
	        editable.array[originIndex] = newChild;
	      }
	      return editable;
	    };

	    VNode.prototype.removeAfter = function(ownerID, level, index) {
	      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
	        return this;
	      }
	      var sizeIndex = ((index - 1) >>> level) & MASK;
	      if (sizeIndex >= this.array.length) {
	        return this;
	      }

	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[sizeIndex];
	        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
	          return this;
	        }
	      }

	      var editable = editableVNode(this, ownerID);
	      editable.array.splice(sizeIndex + 1);
	      if (newChild) {
	        editable.array[sizeIndex] = newChild;
	      }
	      return editable;
	    };



	  var DONE = {};

	  function iterateList(list, reverse) {
	    var left = list._origin;
	    var right = list._capacity;
	    var tailPos = getTailOffset(right);
	    var tail = list._tail;

	    return iterateNodeOrLeaf(list._root, list._level, 0);

	    function iterateNodeOrLeaf(node, level, offset) {
	      return level === 0 ?
	        iterateLeaf(node, offset) :
	        iterateNode(node, level, offset);
	    }

	    function iterateLeaf(node, offset) {
	      var array = offset === tailPos ? tail && tail.array : node && node.array;
	      var from = offset > left ? 0 : left - offset;
	      var to = right - offset;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        if (from === to) {
	          return DONE;
	        }
	        var idx = reverse ? --to : from++;
	        return array && array[idx];
	      };
	    }

	    function iterateNode(node, level, offset) {
	      var values;
	      var array = node && node.array;
	      var from = offset > left ? 0 : (left - offset) >> level;
	      var to = ((right - offset) >> level) + 1;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        do {
	          if (values) {
	            var value = values();
	            if (value !== DONE) {
	              return value;
	            }
	            values = null;
	          }
	          if (from === to) {
	            return DONE;
	          }
	          var idx = reverse ? --to : from++;
	          values = iterateNodeOrLeaf(
	            array && array[idx], level - SHIFT, offset + (idx << level)
	          );
	        } while (true);
	      };
	    }
	  }

	  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
	    var list = Object.create(ListPrototype);
	    list.size = capacity - origin;
	    list._origin = origin;
	    list._capacity = capacity;
	    list._level = level;
	    list._root = root;
	    list._tail = tail;
	    list.__ownerID = ownerID;
	    list.__hash = hash;
	    list.__altered = false;
	    return list;
	  }

	  var EMPTY_LIST;
	  function emptyList() {
	    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
	  }

	  function updateList(list, index, value) {
	    index = wrapIndex(list, index);

	    if (index !== index) {
	      return list;
	    }

	    if (index >= list.size || index < 0) {
	      return list.withMutations(function(list ) {
	        index < 0 ?
	          setListBounds(list, index).set(0, value) :
	          setListBounds(list, 0, index + 1).set(index, value)
	      });
	    }

	    index += list._origin;

	    var newTail = list._tail;
	    var newRoot = list._root;
	    var didAlter = MakeRef(DID_ALTER);
	    if (index >= getTailOffset(list._capacity)) {
	      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
	    } else {
	      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
	    }

	    if (!didAlter.value) {
	      return list;
	    }

	    if (list.__ownerID) {
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
	  }

	  function updateVNode(node, ownerID, level, index, value, didAlter) {
	    var idx = (index >>> level) & MASK;
	    var nodeHas = node && idx < node.array.length;
	    if (!nodeHas && value === undefined) {
	      return node;
	    }

	    var newNode;

	    if (level > 0) {
	      var lowerNode = node && node.array[idx];
	      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
	      if (newLowerNode === lowerNode) {
	        return node;
	      }
	      newNode = editableVNode(node, ownerID);
	      newNode.array[idx] = newLowerNode;
	      return newNode;
	    }

	    if (nodeHas && node.array[idx] === value) {
	      return node;
	    }

	    SetRef(didAlter);

	    newNode = editableVNode(node, ownerID);
	    if (value === undefined && idx === newNode.array.length - 1) {
	      newNode.array.pop();
	    } else {
	      newNode.array[idx] = value;
	    }
	    return newNode;
	  }

	  function editableVNode(node, ownerID) {
	    if (ownerID && node && ownerID === node.ownerID) {
	      return node;
	    }
	    return new VNode(node ? node.array.slice() : [], ownerID);
	  }

	  function listNodeFor(list, rawIndex) {
	    if (rawIndex >= getTailOffset(list._capacity)) {
	      return list._tail;
	    }
	    if (rawIndex < 1 << (list._level + SHIFT)) {
	      var node = list._root;
	      var level = list._level;
	      while (node && level > 0) {
	        node = node.array[(rawIndex >>> level) & MASK];
	        level -= SHIFT;
	      }
	      return node;
	    }
	  }

	  function setListBounds(list, begin, end) {
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	    var owner = list.__ownerID || new OwnerID();
	    var oldOrigin = list._origin;
	    var oldCapacity = list._capacity;
	    var newOrigin = oldOrigin + begin;
	    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
	    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
	      return list;
	    }

	    // If it's going to end after it starts, it's empty.
	    if (newOrigin >= newCapacity) {
	      return list.clear();
	    }

	    var newLevel = list._level;
	    var newRoot = list._root;

	    // New origin might need creating a higher root.
	    var offsetShift = 0;
	    while (newOrigin + offsetShift < 0) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
	      newLevel += SHIFT;
	      offsetShift += 1 << newLevel;
	    }
	    if (offsetShift) {
	      newOrigin += offsetShift;
	      oldOrigin += offsetShift;
	      newCapacity += offsetShift;
	      oldCapacity += offsetShift;
	    }

	    var oldTailOffset = getTailOffset(oldCapacity);
	    var newTailOffset = getTailOffset(newCapacity);

	    // New size might need creating a higher root.
	    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
	      newLevel += SHIFT;
	    }

	    // Locate or create the new tail.
	    var oldTail = list._tail;
	    var newTail = newTailOffset < oldTailOffset ?
	      listNodeFor(list, newCapacity - 1) :
	      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;

	    // Merge Tail into tree.
	    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
	      newRoot = editableVNode(newRoot, owner);
	      var node = newRoot;
	      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
	        var idx = (oldTailOffset >>> level) & MASK;
	        node = node.array[idx] = editableVNode(node.array[idx], owner);
	      }
	      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
	    }

	    // If the size has been reduced, there's a chance the tail needs to be trimmed.
	    if (newCapacity < oldCapacity) {
	      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
	    }

	    // If the new origin is within the tail, then we do not need a root.
	    if (newOrigin >= newTailOffset) {
	      newOrigin -= newTailOffset;
	      newCapacity -= newTailOffset;
	      newLevel = SHIFT;
	      newRoot = null;
	      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);

	    // Otherwise, if the root has been trimmed, garbage collect.
	    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
	      offsetShift = 0;

	      // Identify the new top root node of the subtree of the old root.
	      while (newRoot) {
	        var beginIndex = (newOrigin >>> newLevel) & MASK;
	        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
	          break;
	        }
	        if (beginIndex) {
	          offsetShift += (1 << newLevel) * beginIndex;
	        }
	        newLevel -= SHIFT;
	        newRoot = newRoot.array[beginIndex];
	      }

	      // Trim the new sides of the new root.
	      if (newRoot && newOrigin > oldOrigin) {
	        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
	      }
	      if (newRoot && newTailOffset < oldTailOffset) {
	        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
	      }
	      if (offsetShift) {
	        newOrigin -= offsetShift;
	        newCapacity -= offsetShift;
	      }
	    }

	    if (list.__ownerID) {
	      list.size = newCapacity - newOrigin;
	      list._origin = newOrigin;
	      list._capacity = newCapacity;
	      list._level = newLevel;
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
	  }

	  function mergeIntoListWith(list, merger, iterables) {
	    var iters = [];
	    var maxSize = 0;
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = IndexedIterable(value);
	      if (iter.size > maxSize) {
	        maxSize = iter.size;
	      }
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    if (maxSize > list.size) {
	      list = list.setSize(maxSize);
	    }
	    return mergeIntoCollectionWith(list, merger, iters);
	  }

	  function getTailOffset(size) {
	    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
	  }

	  createClass(OrderedMap, Map);

	    // @pragma Construction

	    function OrderedMap(value) {
	      return value === null || value === undefined ? emptyOrderedMap() :
	        isOrderedMap(value) ? value :
	        emptyOrderedMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }

	    OrderedMap.of = function(/*...values*/) {
	      return this(arguments);
	    };

	    OrderedMap.prototype.toString = function() {
	      return this.__toString('OrderedMap {', '}');
	    };

	    // @pragma Access

	    OrderedMap.prototype.get = function(k, notSetValue) {
	      var index = this._map.get(k);
	      return index !== undefined ? this._list.get(index)[1] : notSetValue;
	    };

	    // @pragma Modification

	    OrderedMap.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._map.clear();
	        this._list.clear();
	        return this;
	      }
	      return emptyOrderedMap();
	    };

	    OrderedMap.prototype.set = function(k, v) {
	      return updateOrderedMap(this, k, v);
	    };

	    OrderedMap.prototype.remove = function(k) {
	      return updateOrderedMap(this, k, NOT_SET);
	    };

	    OrderedMap.prototype.wasAltered = function() {
	      return this._map.wasAltered() || this._list.wasAltered();
	    };

	    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._list.__iterate(
	        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
	        reverse
	      );
	    };

	    OrderedMap.prototype.__iterator = function(type, reverse) {
	      return this._list.fromEntrySeq().__iterator(type, reverse);
	    };

	    OrderedMap.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      var newList = this._list.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        this._list = newList;
	        return this;
	      }
	      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
	    };


	  function isOrderedMap(maybeOrderedMap) {
	    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
	  }

	  OrderedMap.isOrderedMap = isOrderedMap;

	  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
	  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;



	  function makeOrderedMap(map, list, ownerID, hash) {
	    var omap = Object.create(OrderedMap.prototype);
	    omap.size = map ? map.size : 0;
	    omap._map = map;
	    omap._list = list;
	    omap.__ownerID = ownerID;
	    omap.__hash = hash;
	    return omap;
	  }

	  var EMPTY_ORDERED_MAP;
	  function emptyOrderedMap() {
	    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
	  }

	  function updateOrderedMap(omap, k, v) {
	    var map = omap._map;
	    var list = omap._list;
	    var i = map.get(k);
	    var has = i !== undefined;
	    var newMap;
	    var newList;
	    if (v === NOT_SET) { // removed
	      if (!has) {
	        return omap;
	      }
	      if (list.size >= SIZE && list.size >= map.size * 2) {
	        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
	        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
	        if (omap.__ownerID) {
	          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
	        }
	      } else {
	        newMap = map.remove(k);
	        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
	      }
	    } else {
	      if (has) {
	        if (v === list.get(i)[1]) {
	          return omap;
	        }
	        newMap = map;
	        newList = list.set(i, [k, v]);
	      } else {
	        newMap = map.set(k, list.size);
	        newList = list.set(list.size, [k, v]);
	      }
	    }
	    if (omap.__ownerID) {
	      omap.size = newMap.size;
	      omap._map = newMap;
	      omap._list = newList;
	      omap.__hash = undefined;
	      return omap;
	    }
	    return makeOrderedMap(newMap, newList);
	  }

	  createClass(ToKeyedSequence, KeyedSeq);
	    function ToKeyedSequence(indexed, useKeys) {
	      this._iter = indexed;
	      this._useKeys = useKeys;
	      this.size = indexed.size;
	    }

	    ToKeyedSequence.prototype.get = function(key, notSetValue) {
	      return this._iter.get(key, notSetValue);
	    };

	    ToKeyedSequence.prototype.has = function(key) {
	      return this._iter.has(key);
	    };

	    ToKeyedSequence.prototype.valueSeq = function() {
	      return this._iter.valueSeq();
	    };

	    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
	      var reversedSequence = reverseFactory(this, true);
	      if (!this._useKeys) {
	        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
	      }
	      return reversedSequence;
	    };

	    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
	      var mappedSequence = mapFactory(this, mapper, context);
	      if (!this._useKeys) {
	        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
	      }
	      return mappedSequence;
	    };

	    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var ii;
	      return this._iter.__iterate(
	        this._useKeys ?
	          function(v, k)  {return fn(v, k, this$0)} :
	          ((ii = reverse ? resolveSize(this) : 0),
	            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
	        reverse
	      );
	    };

	    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
	      if (this._useKeys) {
	        return this._iter.__iterator(type, reverse);
	      }
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var ii = reverse ? resolveSize(this) : 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
	      });
	    };

	  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;


	  createClass(ToIndexedSequence, IndexedSeq);
	    function ToIndexedSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }

	    ToIndexedSequence.prototype.includes = function(value) {
	      return this._iter.includes(value);
	    };

	    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
	    };

	    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, iterations++, step.value, step)
	      });
	    };



	  createClass(ToSetSequence, SetSeq);
	    function ToSetSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }

	    ToSetSequence.prototype.has = function(key) {
	      return this._iter.includes(key);
	    };

	    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
	    };

	    ToSetSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, step.value, step.value, step);
	      });
	    };



	  createClass(FromEntriesSequence, KeyedSeq);
	    function FromEntriesSequence(entries) {
	      this._iter = entries;
	      this.size = entries.size;
	    }

	    FromEntriesSequence.prototype.entrySeq = function() {
	      return this._iter.toSeq();
	    };

	    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(entry ) {
	        // Check if entry exists first so array access doesn't throw for holes
	        // in the parent iteration.
	        if (entry) {
	          validateEntry(entry);
	          var indexedIterable = isIterable(entry);
	          return fn(
	            indexedIterable ? entry.get(1) : entry[1],
	            indexedIterable ? entry.get(0) : entry[0],
	            this$0
	          );
	        }
	      }, reverse);
	    };

	    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          // Check if entry exists first so array access doesn't throw for holes
	          // in the parent iteration.
	          if (entry) {
	            validateEntry(entry);
	            var indexedIterable = isIterable(entry);
	            return iteratorValue(
	              type,
	              indexedIterable ? entry.get(0) : entry[0],
	              indexedIterable ? entry.get(1) : entry[1],
	              step
	            );
	          }
	        }
	      });
	    };


	  ToIndexedSequence.prototype.cacheResult =
	  ToKeyedSequence.prototype.cacheResult =
	  ToSetSequence.prototype.cacheResult =
	  FromEntriesSequence.prototype.cacheResult =
	    cacheResultThrough;


	  function flipFactory(iterable) {
	    var flipSequence = makeSequence(iterable);
	    flipSequence._iter = iterable;
	    flipSequence.size = iterable.size;
	    flipSequence.flip = function()  {return iterable};
	    flipSequence.reverse = function () {
	      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
	      reversedSequence.flip = function()  {return iterable.reverse()};
	      return reversedSequence;
	    };
	    flipSequence.has = function(key ) {return iterable.includes(key)};
	    flipSequence.includes = function(key ) {return iterable.has(key)};
	    flipSequence.cacheResult = cacheResultThrough;
	    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
	    }
	    flipSequence.__iteratorUncached = function(type, reverse) {
	      if (type === ITERATE_ENTRIES) {
	        var iterator = iterable.__iterator(type, reverse);
	        return new Iterator(function()  {
	          var step = iterator.next();
	          if (!step.done) {
	            var k = step.value[0];
	            step.value[0] = step.value[1];
	            step.value[1] = k;
	          }
	          return step;
	        });
	      }
	      return iterable.__iterator(
	        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
	        reverse
	      );
	    }
	    return flipSequence;
	  }


	  function mapFactory(iterable, mapper, context) {
	    var mappedSequence = makeSequence(iterable);
	    mappedSequence.size = iterable.size;
	    mappedSequence.has = function(key ) {return iterable.has(key)};
	    mappedSequence.get = function(key, notSetValue)  {
	      var v = iterable.get(key, NOT_SET);
	      return v === NOT_SET ?
	        notSetValue :
	        mapper.call(context, v, key, iterable);
	    };
	    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(
	        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
	        reverse
	      );
	    }
	    mappedSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var key = entry[0];
	        return iteratorValue(
	          type,
	          key,
	          mapper.call(context, entry[1], key, iterable),
	          step
	        );
	      });
	    }
	    return mappedSequence;
	  }


	  function reverseFactory(iterable, useKeys) {
	    var reversedSequence = makeSequence(iterable);
	    reversedSequence._iter = iterable;
	    reversedSequence.size = iterable.size;
	    reversedSequence.reverse = function()  {return iterable};
	    if (iterable.flip) {
	      reversedSequence.flip = function () {
	        var flipSequence = flipFactory(iterable);
	        flipSequence.reverse = function()  {return iterable.flip()};
	        return flipSequence;
	      };
	    }
	    reversedSequence.get = function(key, notSetValue) 
	      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
	    reversedSequence.has = function(key )
	      {return iterable.has(useKeys ? key : -1 - key)};
	    reversedSequence.includes = function(value ) {return iterable.includes(value)};
	    reversedSequence.cacheResult = cacheResultThrough;
	    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
	    };
	    reversedSequence.__iterator =
	      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
	    return reversedSequence;
	  }


	  function filterFactory(iterable, predicate, context, useKeys) {
	    var filterSequence = makeSequence(iterable);
	    if (useKeys) {
	      filterSequence.has = function(key ) {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
	      };
	      filterSequence.get = function(key, notSetValue)  {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
	          v : notSetValue;
	      };
	    }
	    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      }, reverse);
	      return iterations;
	    };
	    filterSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          var key = entry[0];
	          var value = entry[1];
	          if (predicate.call(context, value, key, iterable)) {
	            return iteratorValue(type, useKeys ? key : iterations++, value, step);
	          }
	        }
	      });
	    }
	    return filterSequence;
	  }


	  function countByFactory(iterable, grouper, context) {
	    var groups = Map().asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        0,
	        function(a ) {return a + 1}
	      );
	    });
	    return groups.asImmutable();
	  }


	  function groupByFactory(iterable, grouper, context) {
	    var isKeyedIter = isKeyed(iterable);
	    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
	      );
	    });
	    var coerce = iterableClass(iterable);
	    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
	  }


	  function sliceFactory(iterable, begin, end, useKeys) {
	    var originalSize = iterable.size;

	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      if (end === Infinity) {
	        end = originalSize;
	      } else {
	        end = end | 0;
	      }
	    }

	    if (wholeSlice(begin, end, originalSize)) {
	      return iterable;
	    }

	    var resolvedBegin = resolveBegin(begin, originalSize);
	    var resolvedEnd = resolveEnd(end, originalSize);

	    // begin or end will be NaN if they were provided as negative numbers and
	    // this iterable's size is unknown. In that case, cache first so there is
	    // a known size and these do not resolve to NaN.
	    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
	      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
	    }

	    // Note: resolvedEnd is undefined when the original sequence's length is
	    // unknown and this slice did not supply an end and should contain all
	    // elements after resolvedBegin.
	    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
	    var resolvedSize = resolvedEnd - resolvedBegin;
	    var sliceSize;
	    if (resolvedSize === resolvedSize) {
	      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
	    }

	    var sliceSeq = makeSequence(iterable);

	    // If iterable.size is undefined, the size of the realized sliceSeq is
	    // unknown at this point unless the number of items to slice is 0
	    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;

	    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
	      sliceSeq.get = function (index, notSetValue) {
	        index = wrapIndex(this, index);
	        return index >= 0 && index < sliceSize ?
	          iterable.get(index + resolvedBegin, notSetValue) :
	          notSetValue;
	      }
	    }

	    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (sliceSize === 0) {
	        return 0;
	      }
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var skipped = 0;
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k)  {
	        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
	                 iterations !== sliceSize;
	        }
	      });
	      return iterations;
	    };

	    sliceSeq.__iteratorUncached = function(type, reverse) {
	      if (sliceSize !== 0 && reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      // Don't bother instantiating parent iterator if taking 0.
	      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
	      var skipped = 0;
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (skipped++ < resolvedBegin) {
	          iterator.next();
	        }
	        if (++iterations > sliceSize) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (useKeys || type === ITERATE_VALUES) {
	          return step;
	        } else if (type === ITERATE_KEYS) {
	          return iteratorValue(type, iterations - 1, undefined, step);
	        } else {
	          return iteratorValue(type, iterations - 1, step.value[1], step);
	        }
	      });
	    }

	    return sliceSeq;
	  }


	  function takeWhileFactory(iterable, predicate, context) {
	    var takeSequence = makeSequence(iterable);
	    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c) 
	        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
	      );
	      return iterations;
	    };
	    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterating = true;
	      return new Iterator(function()  {
	        if (!iterating) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var k = entry[0];
	        var v = entry[1];
	        if (!predicate.call(context, v, k, this$0)) {
	          iterating = false;
	          return iteratorDone();
	        }
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return takeSequence;
	  }


	  function skipWhileFactory(iterable, predicate, context, useKeys) {
	    var skipSequence = makeSequence(iterable);
	    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      });
	      return iterations;
	    };
	    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var skipping = true;
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step, k, v;
	        do {
	          step = iterator.next();
	          if (step.done) {
	            if (useKeys || type === ITERATE_VALUES) {
	              return step;
	            } else if (type === ITERATE_KEYS) {
	              return iteratorValue(type, iterations++, undefined, step);
	            } else {
	              return iteratorValue(type, iterations++, step.value[1], step);
	            }
	          }
	          var entry = step.value;
	          k = entry[0];
	          v = entry[1];
	          skipping && (skipping = predicate.call(context, v, k, this$0));
	        } while (skipping);
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return skipSequence;
	  }


	  function concatFactory(iterable, values) {
	    var isKeyedIterable = isKeyed(iterable);
	    var iters = [iterable].concat(values).map(function(v ) {
	      if (!isIterable(v)) {
	        v = isKeyedIterable ?
	          keyedSeqFromValue(v) :
	          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
	      } else if (isKeyedIterable) {
	        v = KeyedIterable(v);
	      }
	      return v;
	    }).filter(function(v ) {return v.size !== 0});

	    if (iters.length === 0) {
	      return iterable;
	    }

	    if (iters.length === 1) {
	      var singleton = iters[0];
	      if (singleton === iterable ||
	          isKeyedIterable && isKeyed(singleton) ||
	          isIndexed(iterable) && isIndexed(singleton)) {
	        return singleton;
	      }
	    }

	    var concatSeq = new ArraySeq(iters);
	    if (isKeyedIterable) {
	      concatSeq = concatSeq.toKeyedSeq();
	    } else if (!isIndexed(iterable)) {
	      concatSeq = concatSeq.toSetSeq();
	    }
	    concatSeq = concatSeq.flatten(true);
	    concatSeq.size = iters.reduce(
	      function(sum, seq)  {
	        if (sum !== undefined) {
	          var size = seq.size;
	          if (size !== undefined) {
	            return sum + size;
	          }
	        }
	      },
	      0
	    );
	    return concatSeq;
	  }


	  function flattenFactory(iterable, depth, useKeys) {
	    var flatSequence = makeSequence(iterable);
	    flatSequence.__iterateUncached = function(fn, reverse) {
	      var iterations = 0;
	      var stopped = false;
	      function flatDeep(iter, currentDepth) {var this$0 = this;
	        iter.__iterate(function(v, k)  {
	          if ((!depth || currentDepth < depth) && isIterable(v)) {
	            flatDeep(v, currentDepth + 1);
	          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
	            stopped = true;
	          }
	          return !stopped;
	        }, reverse);
	      }
	      flatDeep(iterable, 0);
	      return iterations;
	    }
	    flatSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(type, reverse);
	      var stack = [];
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (iterator) {
	          var step = iterator.next();
	          if (step.done !== false) {
	            iterator = stack.pop();
	            continue;
	          }
	          var v = step.value;
	          if (type === ITERATE_ENTRIES) {
	            v = v[1];
	          }
	          if ((!depth || stack.length < depth) && isIterable(v)) {
	            stack.push(iterator);
	            iterator = v.__iterator(type, reverse);
	          } else {
	            return useKeys ? step : iteratorValue(type, iterations++, v, step);
	          }
	        }
	        return iteratorDone();
	      });
	    }
	    return flatSequence;
	  }


	  function flatMapFactory(iterable, mapper, context) {
	    var coerce = iterableClass(iterable);
	    return iterable.toSeq().map(
	      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
	    ).flatten(true);
	  }


	  function interposeFactory(iterable, separator) {
	    var interposedSequence = makeSequence(iterable);
	    interposedSequence.size = iterable.size && iterable.size * 2 -1;
	    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k) 
	        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
	        fn(v, iterations++, this$0) !== false},
	        reverse
	      );
	      return iterations;
	    };
	    interposedSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      var step;
	      return new Iterator(function()  {
	        if (!step || iterations % 2) {
	          step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	        }
	        return iterations % 2 ?
	          iteratorValue(type, iterations++, separator) :
	          iteratorValue(type, iterations++, step.value, step);
	      });
	    };
	    return interposedSequence;
	  }


	  function sortFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    var isKeyedIterable = isKeyed(iterable);
	    var index = 0;
	    var entries = iterable.toSeq().map(
	      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
	    ).toArray();
	    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
	      isKeyedIterable ?
	      function(v, i)  { entries[i].length = 2; } :
	      function(v, i)  { entries[i] = v[1]; }
	    );
	    return isKeyedIterable ? KeyedSeq(entries) :
	      isIndexed(iterable) ? IndexedSeq(entries) :
	      SetSeq(entries);
	  }


	  function maxFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    if (mapper) {
	      var entry = iterable.toSeq()
	        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
	        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
	      return entry && entry[0];
	    } else {
	      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
	    }
	  }

	  function maxCompare(comparator, a, b) {
	    var comp = comparator(b, a);
	    // b is considered the new max if the comparator declares them equal, but
	    // they are not equal and b is in fact a nullish value.
	    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
	  }


	  function zipWithFactory(keyIter, zipper, iters) {
	    var zipSequence = makeSequence(keyIter);
	    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
	    // Note: this a generic base implementation of __iterate in terms of
	    // __iterator which may be more generically useful in the future.
	    zipSequence.__iterate = function(fn, reverse) {
	      /* generic:
	      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        iterations++;
	        if (fn(step.value[1], step.value[0], this) === false) {
	          break;
	        }
	      }
	      return iterations;
	      */
	      // indexed:
	      var iterator = this.__iterator(ITERATE_VALUES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        if (fn(step.value, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	    zipSequence.__iteratorUncached = function(type, reverse) {
	      var iterators = iters.map(function(i )
	        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
	      );
	      var iterations = 0;
	      var isDone = false;
	      return new Iterator(function()  {
	        var steps;
	        if (!isDone) {
	          steps = iterators.map(function(i ) {return i.next()});
	          isDone = steps.some(function(s ) {return s.done});
	        }
	        if (isDone) {
	          return iteratorDone();
	        }
	        return iteratorValue(
	          type,
	          iterations++,
	          zipper.apply(null, steps.map(function(s ) {return s.value}))
	        );
	      });
	    };
	    return zipSequence
	  }


	  // #pragma Helper Functions

	  function reify(iter, seq) {
	    return isSeq(iter) ? seq : iter.constructor(seq);
	  }

	  function validateEntry(entry) {
	    if (entry !== Object(entry)) {
	      throw new TypeError('Expected [K, V] tuple: ' + entry);
	    }
	  }

	  function resolveSize(iter) {
	    assertNotInfinite(iter.size);
	    return ensureSize(iter);
	  }

	  function iterableClass(iterable) {
	    return isKeyed(iterable) ? KeyedIterable :
	      isIndexed(iterable) ? IndexedIterable :
	      SetIterable;
	  }

	  function makeSequence(iterable) {
	    return Object.create(
	      (
	        isKeyed(iterable) ? KeyedSeq :
	        isIndexed(iterable) ? IndexedSeq :
	        SetSeq
	      ).prototype
	    );
	  }

	  function cacheResultThrough() {
	    if (this._iter.cacheResult) {
	      this._iter.cacheResult();
	      this.size = this._iter.size;
	      return this;
	    } else {
	      return Seq.prototype.cacheResult.call(this);
	    }
	  }

	  function defaultComparator(a, b) {
	    return a > b ? 1 : a < b ? -1 : 0;
	  }

	  function forceIterator(keyPath) {
	    var iter = getIterator(keyPath);
	    if (!iter) {
	      // Array might not be iterable in this environment, so we need a fallback
	      // to our wrapped type.
	      if (!isArrayLike(keyPath)) {
	        throw new TypeError('Expected iterable or array-like: ' + keyPath);
	      }
	      iter = getIterator(Iterable(keyPath));
	    }
	    return iter;
	  }

	  createClass(Record, KeyedCollection);

	    function Record(defaultValues, name) {
	      var hasInitialized;

	      var RecordType = function Record(values) {
	        if (values instanceof RecordType) {
	          return values;
	        }
	        if (!(this instanceof RecordType)) {
	          return new RecordType(values);
	        }
	        if (!hasInitialized) {
	          hasInitialized = true;
	          var keys = Object.keys(defaultValues);
	          setProps(RecordTypePrototype, keys);
	          RecordTypePrototype.size = keys.length;
	          RecordTypePrototype._name = name;
	          RecordTypePrototype._keys = keys;
	          RecordTypePrototype._defaultValues = defaultValues;
	        }
	        this._map = Map(values);
	      };

	      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
	      RecordTypePrototype.constructor = RecordType;

	      return RecordType;
	    }

	    Record.prototype.toString = function() {
	      return this.__toString(recordName(this) + ' {', '}');
	    };

	    // @pragma Access

	    Record.prototype.has = function(k) {
	      return this._defaultValues.hasOwnProperty(k);
	    };

	    Record.prototype.get = function(k, notSetValue) {
	      if (!this.has(k)) {
	        return notSetValue;
	      }
	      var defaultVal = this._defaultValues[k];
	      return this._map ? this._map.get(k, defaultVal) : defaultVal;
	    };

	    // @pragma Modification

	    Record.prototype.clear = function() {
	      if (this.__ownerID) {
	        this._map && this._map.clear();
	        return this;
	      }
	      var RecordType = this.constructor;
	      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
	    };

	    Record.prototype.set = function(k, v) {
	      if (!this.has(k)) {
	        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
	      }
	      if (this._map && !this._map.has(k)) {
	        var defaultVal = this._defaultValues[k];
	        if (v === defaultVal) {
	          return this;
	        }
	      }
	      var newMap = this._map && this._map.set(k, v);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };

	    Record.prototype.remove = function(k) {
	      if (!this.has(k)) {
	        return this;
	      }
	      var newMap = this._map && this._map.remove(k);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };

	    Record.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };

	    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
	    };

	    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
	    };

	    Record.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map && this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return makeRecord(this, newMap, ownerID);
	    };


	  var RecordPrototype = Record.prototype;
	  RecordPrototype[DELETE] = RecordPrototype.remove;
	  RecordPrototype.deleteIn =
	  RecordPrototype.removeIn = MapPrototype.removeIn;
	  RecordPrototype.merge = MapPrototype.merge;
	  RecordPrototype.mergeWith = MapPrototype.mergeWith;
	  RecordPrototype.mergeIn = MapPrototype.mergeIn;
	  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
	  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
	  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  RecordPrototype.setIn = MapPrototype.setIn;
	  RecordPrototype.update = MapPrototype.update;
	  RecordPrototype.updateIn = MapPrototype.updateIn;
	  RecordPrototype.withMutations = MapPrototype.withMutations;
	  RecordPrototype.asMutable = MapPrototype.asMutable;
	  RecordPrototype.asImmutable = MapPrototype.asImmutable;


	  function makeRecord(likeRecord, map, ownerID) {
	    var record = Object.create(Object.getPrototypeOf(likeRecord));
	    record._map = map;
	    record.__ownerID = ownerID;
	    return record;
	  }

	  function recordName(record) {
	    return record._name || record.constructor.name || 'Record';
	  }

	  function setProps(prototype, names) {
	    try {
	      names.forEach(setProp.bind(undefined, prototype));
	    } catch (error) {
	      // Object.defineProperty failed. Probably IE8.
	    }
	  }

	  function setProp(prototype, name) {
	    Object.defineProperty(prototype, name, {
	      get: function() {
	        return this.get(name);
	      },
	      set: function(value) {
	        invariant(this.__ownerID, 'Cannot set on an immutable record.');
	        this.set(name, value);
	      }
	    });
	  }

	  createClass(Set, SetCollection);

	    // @pragma Construction

	    function Set(value) {
	      return value === null || value === undefined ? emptySet() :
	        isSet(value) && !isOrdered(value) ? value :
	        emptySet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }

	    Set.of = function(/*...values*/) {
	      return this(arguments);
	    };

	    Set.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };

	    Set.prototype.toString = function() {
	      return this.__toString('Set {', '}');
	    };

	    // @pragma Access

	    Set.prototype.has = function(value) {
	      return this._map.has(value);
	    };

	    // @pragma Modification

	    Set.prototype.add = function(value) {
	      return updateSet(this, this._map.set(value, true));
	    };

	    Set.prototype.remove = function(value) {
	      return updateSet(this, this._map.remove(value));
	    };

	    Set.prototype.clear = function() {
	      return updateSet(this, this._map.clear());
	    };

	    // @pragma Composition

	    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
	      iters = iters.filter(function(x ) {return x.size !== 0});
	      if (iters.length === 0) {
	        return this;
	      }
	      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
	        return this.constructor(iters[0]);
	      }
	      return this.withMutations(function(set ) {
	        for (var ii = 0; ii < iters.length; ii++) {
	          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
	        }
	      });
	    };

	    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (!iters.every(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };

	    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (iters.some(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };

	    Set.prototype.merge = function() {
	      return this.union.apply(this, arguments);
	    };

	    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return this.union.apply(this, iters);
	    };

	    Set.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator));
	    };

	    Set.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator, mapper));
	    };

	    Set.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };

	    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
	    };

	    Set.prototype.__iterator = function(type, reverse) {
	      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
	    };

	    Set.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return this.__make(newMap, ownerID);
	    };


	  function isSet(maybeSet) {
	    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
	  }

	  Set.isSet = isSet;

	  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';

	  var SetPrototype = Set.prototype;
	  SetPrototype[IS_SET_SENTINEL] = true;
	  SetPrototype[DELETE] = SetPrototype.remove;
	  SetPrototype.mergeDeep = SetPrototype.merge;
	  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
	  SetPrototype.withMutations = MapPrototype.withMutations;
	  SetPrototype.asMutable = MapPrototype.asMutable;
	  SetPrototype.asImmutable = MapPrototype.asImmutable;

	  SetPrototype.__empty = emptySet;
	  SetPrototype.__make = makeSet;

	  function updateSet(set, newMap) {
	    if (set.__ownerID) {
	      set.size = newMap.size;
	      set._map = newMap;
	      return set;
	    }
	    return newMap === set._map ? set :
	      newMap.size === 0 ? set.__empty() :
	      set.__make(newMap);
	  }

	  function makeSet(map, ownerID) {
	    var set = Object.create(SetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }

	  var EMPTY_SET;
	  function emptySet() {
	    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
	  }

	  createClass(OrderedSet, Set);

	    // @pragma Construction

	    function OrderedSet(value) {
	      return value === null || value === undefined ? emptyOrderedSet() :
	        isOrderedSet(value) ? value :
	        emptyOrderedSet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }

	    OrderedSet.of = function(/*...values*/) {
	      return this(arguments);
	    };

	    OrderedSet.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };

	    OrderedSet.prototype.toString = function() {
	      return this.__toString('OrderedSet {', '}');
	    };


	  function isOrderedSet(maybeOrderedSet) {
	    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
	  }

	  OrderedSet.isOrderedSet = isOrderedSet;

	  var OrderedSetPrototype = OrderedSet.prototype;
	  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;

	  OrderedSetPrototype.__empty = emptyOrderedSet;
	  OrderedSetPrototype.__make = makeOrderedSet;

	  function makeOrderedSet(map, ownerID) {
	    var set = Object.create(OrderedSetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }

	  var EMPTY_ORDERED_SET;
	  function emptyOrderedSet() {
	    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
	  }

	  createClass(Stack, IndexedCollection);

	    // @pragma Construction

	    function Stack(value) {
	      return value === null || value === undefined ? emptyStack() :
	        isStack(value) ? value :
	        emptyStack().unshiftAll(value);
	    }

	    Stack.of = function(/*...values*/) {
	      return this(arguments);
	    };

	    Stack.prototype.toString = function() {
	      return this.__toString('Stack [', ']');
	    };

	    // @pragma Access

	    Stack.prototype.get = function(index, notSetValue) {
	      var head = this._head;
	      index = wrapIndex(this, index);
	      while (head && index--) {
	        head = head.next;
	      }
	      return head ? head.value : notSetValue;
	    };

	    Stack.prototype.peek = function() {
	      return this._head && this._head.value;
	    };

	    // @pragma Modification

	    Stack.prototype.push = function(/*...values*/) {
	      if (arguments.length === 0) {
	        return this;
	      }
	      var newSize = this.size + arguments.length;
	      var head = this._head;
	      for (var ii = arguments.length - 1; ii >= 0; ii--) {
	        head = {
	          value: arguments[ii],
	          next: head
	        };
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };

	    Stack.prototype.pushAll = function(iter) {
	      iter = IndexedIterable(iter);
	      if (iter.size === 0) {
	        return this;
	      }
	      assertNotInfinite(iter.size);
	      var newSize = this.size;
	      var head = this._head;
	      iter.reverse().forEach(function(value ) {
	        newSize++;
	        head = {
	          value: value,
	          next: head
	        };
	      });
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };

	    Stack.prototype.pop = function() {
	      return this.slice(1);
	    };

	    Stack.prototype.unshift = function(/*...values*/) {
	      return this.push.apply(this, arguments);
	    };

	    Stack.prototype.unshiftAll = function(iter) {
	      return this.pushAll(iter);
	    };

	    Stack.prototype.shift = function() {
	      return this.pop.apply(this, arguments);
	    };

	    Stack.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._head = undefined;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyStack();
	    };

	    Stack.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      var resolvedBegin = resolveBegin(begin, this.size);
	      var resolvedEnd = resolveEnd(end, this.size);
	      if (resolvedEnd !== this.size) {
	        // super.slice(begin, end);
	        return IndexedCollection.prototype.slice.call(this, begin, end);
	      }
	      var newSize = this.size - resolvedBegin;
	      var head = this._head;
	      while (resolvedBegin--) {
	        head = head.next;
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };

	    // @pragma Mutability

	    Stack.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeStack(this.size, this._head, ownerID, this.__hash);
	    };

	    // @pragma Iteration

	    Stack.prototype.__iterate = function(fn, reverse) {
	      if (reverse) {
	        return this.reverse().__iterate(fn);
	      }
	      var iterations = 0;
	      var node = this._head;
	      while (node) {
	        if (fn(node.value, iterations++, this) === false) {
	          break;
	        }
	        node = node.next;
	      }
	      return iterations;
	    };

	    Stack.prototype.__iterator = function(type, reverse) {
	      if (reverse) {
	        return this.reverse().__iterator(type);
	      }
	      var iterations = 0;
	      var node = this._head;
	      return new Iterator(function()  {
	        if (node) {
	          var value = node.value;
	          node = node.next;
	          return iteratorValue(type, iterations++, value);
	        }
	        return iteratorDone();
	      });
	    };


	  function isStack(maybeStack) {
	    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
	  }

	  Stack.isStack = isStack;

	  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';

	  var StackPrototype = Stack.prototype;
	  StackPrototype[IS_STACK_SENTINEL] = true;
	  StackPrototype.withMutations = MapPrototype.withMutations;
	  StackPrototype.asMutable = MapPrototype.asMutable;
	  StackPrototype.asImmutable = MapPrototype.asImmutable;
	  StackPrototype.wasAltered = MapPrototype.wasAltered;


	  function makeStack(size, head, ownerID, hash) {
	    var map = Object.create(StackPrototype);
	    map.size = size;
	    map._head = head;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }

	  var EMPTY_STACK;
	  function emptyStack() {
	    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
	  }

	  /**
	   * Contributes additional methods to a constructor
	   */
	  function mixin(ctor, methods) {
	    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
	    Object.keys(methods).forEach(keyCopier);
	    Object.getOwnPropertySymbols &&
	      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
	    return ctor;
	  }

	  Iterable.Iterator = Iterator;

	  mixin(Iterable, {

	    // ### Conversion to other types

	    toArray: function() {
	      assertNotInfinite(this.size);
	      var array = new Array(this.size || 0);
	      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
	      return array;
	    },

	    toIndexedSeq: function() {
	      return new ToIndexedSequence(this);
	    },

	    toJS: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
	      ).__toJS();
	    },

	    toJSON: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
	      ).__toJS();
	    },

	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, true);
	    },

	    toMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Map(this.toKeyedSeq());
	    },

	    toObject: function() {
	      assertNotInfinite(this.size);
	      var object = {};
	      this.__iterate(function(v, k)  { object[k] = v; });
	      return object;
	    },

	    toOrderedMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedMap(this.toKeyedSeq());
	    },

	    toOrderedSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
	    },

	    toSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Set(isKeyed(this) ? this.valueSeq() : this);
	    },

	    toSetSeq: function() {
	      return new ToSetSequence(this);
	    },

	    toSeq: function() {
	      return isIndexed(this) ? this.toIndexedSeq() :
	        isKeyed(this) ? this.toKeyedSeq() :
	        this.toSetSeq();
	    },

	    toStack: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Stack(isKeyed(this) ? this.valueSeq() : this);
	    },

	    toList: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return List(isKeyed(this) ? this.valueSeq() : this);
	    },


	    // ### Common JavaScript methods and properties

	    toString: function() {
	      return '[Iterable]';
	    },

	    __toString: function(head, tail) {
	      if (this.size === 0) {
	        return head + tail;
	      }
	      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
	    },


	    // ### ES6 Collection methods (ES6 Array and Map)

	    concat: function() {var values = SLICE$0.call(arguments, 0);
	      return reify(this, concatFactory(this, values));
	    },

	    includes: function(searchValue) {
	      return this.some(function(value ) {return is(value, searchValue)});
	    },

	    entries: function() {
	      return this.__iterator(ITERATE_ENTRIES);
	    },

	    every: function(predicate, context) {
	      assertNotInfinite(this.size);
	      var returnValue = true;
	      this.__iterate(function(v, k, c)  {
	        if (!predicate.call(context, v, k, c)) {
	          returnValue = false;
	          return false;
	        }
	      });
	      return returnValue;
	    },

	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, true));
	    },

	    find: function(predicate, context, notSetValue) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[1] : notSetValue;
	    },

	    forEach: function(sideEffect, context) {
	      assertNotInfinite(this.size);
	      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
	    },

	    join: function(separator) {
	      assertNotInfinite(this.size);
	      separator = separator !== undefined ? '' + separator : ',';
	      var joined = '';
	      var isFirst = true;
	      this.__iterate(function(v ) {
	        isFirst ? (isFirst = false) : (joined += separator);
	        joined += v !== null && v !== undefined ? v.toString() : '';
	      });
	      return joined;
	    },

	    keys: function() {
	      return this.__iterator(ITERATE_KEYS);
	    },

	    map: function(mapper, context) {
	      return reify(this, mapFactory(this, mapper, context));
	    },

	    reduce: function(reducer, initialReduction, context) {
	      assertNotInfinite(this.size);
	      var reduction;
	      var useFirst;
	      if (arguments.length < 2) {
	        useFirst = true;
	      } else {
	        reduction = initialReduction;
	      }
	      this.__iterate(function(v, k, c)  {
	        if (useFirst) {
	          useFirst = false;
	          reduction = v;
	        } else {
	          reduction = reducer.call(context, reduction, v, k, c);
	        }
	      });
	      return reduction;
	    },

	    reduceRight: function(reducer, initialReduction, context) {
	      var reversed = this.toKeyedSeq().reverse();
	      return reversed.reduce.apply(reversed, arguments);
	    },

	    reverse: function() {
	      return reify(this, reverseFactory(this, true));
	    },

	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, true));
	    },

	    some: function(predicate, context) {
	      return !this.every(not(predicate), context);
	    },

	    sort: function(comparator) {
	      return reify(this, sortFactory(this, comparator));
	    },

	    values: function() {
	      return this.__iterator(ITERATE_VALUES);
	    },


	    // ### More sequential methods

	    butLast: function() {
	      return this.slice(0, -1);
	    },

	    isEmpty: function() {
	      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
	    },

	    count: function(predicate, context) {
	      return ensureSize(
	        predicate ? this.toSeq().filter(predicate, context) : this
	      );
	    },

	    countBy: function(grouper, context) {
	      return countByFactory(this, grouper, context);
	    },

	    equals: function(other) {
	      return deepEqual(this, other);
	    },

	    entrySeq: function() {
	      var iterable = this;
	      if (iterable._cache) {
	        // We cache as an entries array, so we can just return the cache!
	        return new ArraySeq(iterable._cache);
	      }
	      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
	      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
	      return entriesSequence;
	    },

	    filterNot: function(predicate, context) {
	      return this.filter(not(predicate), context);
	    },

	    findEntry: function(predicate, context, notSetValue) {
	      var found = notSetValue;
	      this.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          found = [k, v];
	          return false;
	        }
	      });
	      return found;
	    },

	    findKey: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry && entry[0];
	    },

	    findLast: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
	    },

	    findLastEntry: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
	    },

	    findLastKey: function(predicate, context) {
	      return this.toKeyedSeq().reverse().findKey(predicate, context);
	    },

	    first: function() {
	      return this.find(returnTrue);
	    },

	    flatMap: function(mapper, context) {
	      return reify(this, flatMapFactory(this, mapper, context));
	    },

	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, true));
	    },

	    fromEntrySeq: function() {
	      return new FromEntriesSequence(this);
	    },

	    get: function(searchKey, notSetValue) {
	      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
	    },

	    getIn: function(searchKeyPath, notSetValue) {
	      var nested = this;
	      // Note: in an ES6 environment, we would prefer:
	      // for (var key of searchKeyPath) {
	      var iter = forceIterator(searchKeyPath);
	      var step;
	      while (!(step = iter.next()).done) {
	        var key = step.value;
	        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
	        if (nested === NOT_SET) {
	          return notSetValue;
	        }
	      }
	      return nested;
	    },

	    groupBy: function(grouper, context) {
	      return groupByFactory(this, grouper, context);
	    },

	    has: function(searchKey) {
	      return this.get(searchKey, NOT_SET) !== NOT_SET;
	    },

	    hasIn: function(searchKeyPath) {
	      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
	    },

	    isSubset: function(iter) {
	      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
	      return this.every(function(value ) {return iter.includes(value)});
	    },

	    isSuperset: function(iter) {
	      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
	      return iter.isSubset(this);
	    },

	    keyOf: function(searchValue) {
	      return this.findKey(function(value ) {return is(value, searchValue)});
	    },

	    keySeq: function() {
	      return this.toSeq().map(keyMapper).toIndexedSeq();
	    },

	    last: function() {
	      return this.toSeq().reverse().first();
	    },

	    lastKeyOf: function(searchValue) {
	      return this.toKeyedSeq().reverse().keyOf(searchValue);
	    },

	    max: function(comparator) {
	      return maxFactory(this, comparator);
	    },

	    maxBy: function(mapper, comparator) {
	      return maxFactory(this, comparator, mapper);
	    },

	    min: function(comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
	    },

	    minBy: function(mapper, comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
	    },

	    rest: function() {
	      return this.slice(1);
	    },

	    skip: function(amount) {
	      return this.slice(Math.max(0, amount));
	    },

	    skipLast: function(amount) {
	      return reify(this, this.toSeq().reverse().skip(amount).reverse());
	    },

	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, true));
	    },

	    skipUntil: function(predicate, context) {
	      return this.skipWhile(not(predicate), context);
	    },

	    sortBy: function(mapper, comparator) {
	      return reify(this, sortFactory(this, comparator, mapper));
	    },

	    take: function(amount) {
	      return this.slice(0, Math.max(0, amount));
	    },

	    takeLast: function(amount) {
	      return reify(this, this.toSeq().reverse().take(amount).reverse());
	    },

	    takeWhile: function(predicate, context) {
	      return reify(this, takeWhileFactory(this, predicate, context));
	    },

	    takeUntil: function(predicate, context) {
	      return this.takeWhile(not(predicate), context);
	    },

	    valueSeq: function() {
	      return this.toIndexedSeq();
	    },


	    // ### Hashable Object

	    hashCode: function() {
	      return this.__hash || (this.__hash = hashIterable(this));
	    }


	    // ### Internal

	    // abstract __iterate(fn, reverse)

	    // abstract __iterator(type, reverse)
	  });

	  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

	  var IterablePrototype = Iterable.prototype;
	  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
	  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
	  IterablePrototype.__toJS = IterablePrototype.toArray;
	  IterablePrototype.__toStringMapper = quoteString;
	  IterablePrototype.inspect =
	  IterablePrototype.toSource = function() { return this.toString(); };
	  IterablePrototype.chain = IterablePrototype.flatMap;
	  IterablePrototype.contains = IterablePrototype.includes;

	  mixin(KeyedIterable, {

	    // ### More sequential methods

	    flip: function() {
	      return reify(this, flipFactory(this));
	    },

	    mapEntries: function(mapper, context) {var this$0 = this;
	      var iterations = 0;
	      return reify(this,
	        this.toSeq().map(
	          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
	        ).fromEntrySeq()
	      );
	    },

	    mapKeys: function(mapper, context) {var this$0 = this;
	      return reify(this,
	        this.toSeq().flip().map(
	          function(k, v)  {return mapper.call(context, k, v, this$0)}
	        ).flip()
	      );
	    }

	  });

	  var KeyedIterablePrototype = KeyedIterable.prototype;
	  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
	  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
	  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
	  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};



	  mixin(IndexedIterable, {

	    // ### Conversion to other types

	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, false);
	    },


	    // ### ES6 Collection methods (ES6 Array and Map)

	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, false));
	    },

	    findIndex: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },

	    indexOf: function(searchValue) {
	      var key = this.keyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },

	    lastIndexOf: function(searchValue) {
	      var key = this.lastKeyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },

	    reverse: function() {
	      return reify(this, reverseFactory(this, false));
	    },

	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, false));
	    },

	    splice: function(index, removeNum /*, ...values*/) {
	      var numArgs = arguments.length;
	      removeNum = Math.max(removeNum | 0, 0);
	      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
	        return this;
	      }
	      // If index is negative, it should resolve relative to the size of the
	      // collection. However size may be expensive to compute if not cached, so
	      // only call count() if the number is in fact negative.
	      index = resolveBegin(index, index < 0 ? this.count() : this.size);
	      var spliced = this.slice(0, index);
	      return reify(
	        this,
	        numArgs === 1 ?
	          spliced :
	          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
	      );
	    },


	    // ### More collection methods

	    findLastIndex: function(predicate, context) {
	      var entry = this.findLastEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },

	    first: function() {
	      return this.get(0);
	    },

	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, false));
	    },

	    get: function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      return (index < 0 || (this.size === Infinity ||
	          (this.size !== undefined && index > this.size))) ?
	        notSetValue :
	        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
	    },

	    has: function(index) {
	      index = wrapIndex(this, index);
	      return index >= 0 && (this.size !== undefined ?
	        this.size === Infinity || index < this.size :
	        this.indexOf(index) !== -1
	      );
	    },

	    interpose: function(separator) {
	      return reify(this, interposeFactory(this, separator));
	    },

	    interleave: function(/*...iterables*/) {
	      var iterables = [this].concat(arrCopy(arguments));
	      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
	      var interleaved = zipped.flatten(true);
	      if (zipped.size) {
	        interleaved.size = zipped.size * iterables.length;
	      }
	      return reify(this, interleaved);
	    },

	    keySeq: function() {
	      return Range(0, this.size);
	    },

	    last: function() {
	      return this.get(-1);
	    },

	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, false));
	    },

	    zip: function(/*, ...iterables */) {
	      var iterables = [this].concat(arrCopy(arguments));
	      return reify(this, zipWithFactory(this, defaultZipper, iterables));
	    },

	    zipWith: function(zipper/*, ...iterables */) {
	      var iterables = arrCopy(arguments);
	      iterables[0] = this;
	      return reify(this, zipWithFactory(this, zipper, iterables));
	    }

	  });

	  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
	  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;



	  mixin(SetIterable, {

	    // ### ES6 Collection methods (ES6 Array and Map)

	    get: function(value, notSetValue) {
	      return this.has(value) ? value : notSetValue;
	    },

	    includes: function(value) {
	      return this.has(value);
	    },


	    // ### More sequential methods

	    keySeq: function() {
	      return this.valueSeq();
	    }

	  });

	  SetIterable.prototype.has = IterablePrototype.includes;
	  SetIterable.prototype.contains = SetIterable.prototype.includes;


	  // Mixin subclasses

	  mixin(KeyedSeq, KeyedIterable.prototype);
	  mixin(IndexedSeq, IndexedIterable.prototype);
	  mixin(SetSeq, SetIterable.prototype);

	  mixin(KeyedCollection, KeyedIterable.prototype);
	  mixin(IndexedCollection, IndexedIterable.prototype);
	  mixin(SetCollection, SetIterable.prototype);


	  // #pragma Helper functions

	  function keyMapper(v, k) {
	    return k;
	  }

	  function entryMapper(v, k) {
	    return [k, v];
	  }

	  function not(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    }
	  }

	  function neg(predicate) {
	    return function() {
	      return -predicate.apply(this, arguments);
	    }
	  }

	  function quoteString(value) {
	    return typeof value === 'string' ? JSON.stringify(value) : String(value);
	  }

	  function defaultZipper() {
	    return arrCopy(arguments);
	  }

	  function defaultNegComparator(a, b) {
	    return a < b ? 1 : a > b ? -1 : 0;
	  }

	  function hashIterable(iterable) {
	    if (iterable.size === Infinity) {
	      return 0;
	    }
	    var ordered = isOrdered(iterable);
	    var keyed = isKeyed(iterable);
	    var h = ordered ? 1 : 0;
	    var size = iterable.__iterate(
	      keyed ?
	        ordered ?
	          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
	          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
	        ordered ?
	          function(v ) { h = 31 * h + hash(v) | 0; } :
	          function(v ) { h = h + hash(v) | 0; }
	    );
	    return murmurHashOfSize(size, h);
	  }

	  function murmurHashOfSize(size, h) {
	    h = imul(h, 0xCC9E2D51);
	    h = imul(h << 15 | h >>> -15, 0x1B873593);
	    h = imul(h << 13 | h >>> -13, 5);
	    h = (h + 0xE6546B64 | 0) ^ size;
	    h = imul(h ^ h >>> 16, 0x85EBCA6B);
	    h = imul(h ^ h >>> 13, 0xC2B2AE35);
	    h = smi(h ^ h >>> 16);
	    return h;
	  }

	  function hashMerge(a, b) {
	    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
	  }

	  var Immutable = {

	    Iterable: Iterable,

	    Seq: Seq,
	    Collection: Collection,
	    Map: Map,
	    OrderedMap: OrderedMap,
	    List: List,
	    Stack: Stack,
	    Set: Set,
	    OrderedSet: OrderedSet,

	    Record: Record,
	    Range: Range,
	    Repeat: Repeat,

	    is: is,
	    fromJS: fromJS

	  };

	  return Immutable;

	}));

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	'use strict';

	var isFunction = function isFunction(functionToCheck) {
	  var getType = {};
	  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	};

	module.exports = isFunction;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(141);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(9)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../node_modules/css-loader/index.js!./react-data-grid-core.css", function() {
				var newContent = require("!!../node_modules/css-loader/index.js!./react-data-grid-core.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(143);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(9)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../node_modules/css-loader/index.js!./react-data-grid-row.css", function() {
				var newContent = require("!!../node_modules/css-loader/index.js!./react-data-grid-row.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _keymirror = __webpack_require__(144);

	var _keymirror2 = _interopRequireDefault(_keymirror);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	var constants = {
	  UpdateActions: (0, _keymirror2['default'])({
	    CELL_UPDATE: null,
	    COLUMN_FILL: null,
	    COPY_PASTE: null,
	    CELL_DRAG: null
	  }),
	  DragItemTypes: {
	    Column: 'column'
	  },
	  CellExpand: {
	    DOWN_TRIANGLE: String.fromCharCode('9660'),
	    RIGHT_TRIANGLE: String.fromCharCode('9654')
	  }
	};

	module.exports = constants;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var shallowCloneObject = __webpack_require__(53);
	var sameColumn = __webpack_require__(109);
	var ColumnUtils = __webpack_require__(7);
	var getScrollbarSize = __webpack_require__(33);
	var isColumnsImmutable = __webpack_require__(55);

	function setColumnWidths(columns, totalWidth) {
	  return columns.map(function (column) {
	    var colInfo = Object.assign({}, column);
	    if (column.width) {
	      if (/^([0-9]+)%$/.exec(column.width.toString())) {
	        colInfo.width = Math.floor(column.width / 100 * totalWidth);
	      }
	    }
	    return colInfo;
	  });
	}

	function setDefferedColumnWidths(columns, unallocatedWidth, minColumnWidth) {
	  var defferedColumns = columns.filter(function (c) {
	    return !c.width;
	  });
	  return columns.map(function (column) {
	    if (!column.width && column.width !== 0) {
	      if (unallocatedWidth <= 0) {
	        column.width = minColumnWidth;
	      } else {
	        var columnWidth = Math.floor(unallocatedWidth / ColumnUtils.getSize(defferedColumns));
	        if (columnWidth < minColumnWidth) {
	          column.width = minColumnWidth;
	        } else {
	          column.width = columnWidth;
	        }
	      }
	    }
	    return column;
	  });
	}

	function setColumnOffsets(columns) {
	  var left = 0;
	  return columns.map(function (column) {
	    column.left = left;
	    left += column.width;
	    return column;
	  });
	}

	/**
	 * Update column metrics calculation.
	 *
	 * @param {ColumnMetricsType} metrics
	 */
	function recalculate(metrics) {
	  // compute width for columns which specify width
	  var columns = setColumnWidths(metrics.columns, metrics.totalWidth);

	  var unallocatedWidth = columns.filter(function (c) {
	    return c.width;
	  }).reduce(function (w, column) {
	    return w - column.width;
	  }, metrics.totalWidth);
	  unallocatedWidth -= getScrollbarSize();

	  var width = columns.filter(function (c) {
	    return c.width;
	  }).reduce(function (w, column) {
	    return w + column.width;
	  }, 0);

	  // compute width for columns which doesn't specify width
	  columns = setDefferedColumnWidths(columns, unallocatedWidth, metrics.minColumnWidth);

	  // compute left offset
	  columns = setColumnOffsets(columns);

	  return {
	    columns: columns,
	    width: width,
	    totalWidth: metrics.totalWidth,
	    minColumnWidth: metrics.minColumnWidth
	  };
	}

	/**
	 * Update column metrics calculation by resizing a column.
	 *
	 * @param {ColumnMetricsType} metrics
	 * @param {Column} column
	 * @param {number} width
	 */
	function resizeColumn(metrics, index, width) {
	  var column = ColumnUtils.getColumn(metrics.columns, index);
	  var metricsClone = shallowCloneObject(metrics);
	  metricsClone.columns = metrics.columns.slice(0);

	  var updatedColumn = shallowCloneObject(column);
	  updatedColumn.width = Math.max(width, metricsClone.minColumnWidth);

	  metricsClone = ColumnUtils.spliceColumn(metricsClone, index, updatedColumn);

	  return recalculate(metricsClone);
	}

	function areColumnsImmutable(prevColumns, nextColumns) {
	  return isColumnsImmutable(prevColumns) && isColumnsImmutable(nextColumns);
	}

	function compareEachColumn(prevColumns, nextColumns, isSameColumn) {
	  var i = void 0;
	  var len = void 0;
	  var column = void 0;
	  var prevColumnsByKey = {};
	  var nextColumnsByKey = {};

	  if (ColumnUtils.getSize(prevColumns) !== ColumnUtils.getSize(nextColumns)) {
	    return false;
	  }

	  for (i = 0, len = ColumnUtils.getSize(prevColumns); i < len; i++) {
	    column = prevColumns[i];
	    prevColumnsByKey[column.key] = column;
	  }

	  for (i = 0, len = ColumnUtils.getSize(nextColumns); i < len; i++) {
	    column = nextColumns[i];
	    nextColumnsByKey[column.key] = column;
	    var prevColumn = prevColumnsByKey[column.key];
	    if (prevColumn === undefined || !isSameColumn(prevColumn, column)) {
	      return false;
	    }
	  }

	  for (i = 0, len = ColumnUtils.getSize(prevColumns); i < len; i++) {
	    column = prevColumns[i];
	    var nextColumn = nextColumnsByKey[column.key];
	    if (nextColumn === undefined) {
	      return false;
	    }
	  }
	  return true;
	}

	function sameColumns(prevColumns, nextColumns, isSameColumn) {
	  if (areColumnsImmutable(prevColumns, nextColumns)) {
	    return prevColumns === nextColumns;
	  }

	  return compareEachColumn(prevColumns, nextColumns, isSameColumn);
	}

	module.exports = { recalculate: recalculate, resizeColumn: resizeColumn, sameColumn: sameColumn, sameColumns: sameColumns };

/***/ }),
/* 33 */
/***/ (function(module, exports) {

	'use strict';

	var size = void 0;

	function getScrollbarSize() {
	  if (size === undefined) {
	    var outer = document.createElement('div');
	    outer.style.width = '50px';
	    outer.style.height = '50px';
	    outer.style.position = 'absolute';
	    outer.style.top = '-200px';
	    outer.style.left = '-200px';

	    var inner = document.createElement('div');
	    inner.style.height = '100px';
	    inner.style.width = '100%';

	    outer.appendChild(inner);
	    document.body.appendChild(outer);

	    var outerWidth = outer.clientWidth;
	    outer.style.overflowY = 'scroll';
	    var innerWidth = inner.clientWidth;

	    document.body.removeChild(outer);

	    size = outerWidth - innerWidth;
	  }

	  return size;
	}

	module.exports = getScrollbarSize;

/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(139);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(9)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../node_modules/css-loader/index.js!./react-data-grid-cell.css", function() {
				var newContent = require("!!../node_modules/css-loader/index.js!./react-data-grid-cell.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _underscore = __webpack_require__(79);

	var _underscore2 = _interopRequireDefault(_underscore);

	var _propTypes = __webpack_require__(3);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	var _CellAction = __webpack_require__(106);

	var _CellAction2 = _interopRequireDefault(_CellAction);

	var _CellExpand = __webpack_require__(107);

	var _CellExpand2 = _interopRequireDefault(_CellExpand);

	var _ChildRowDeleteButton = __webpack_require__(108);

	var _ChildRowDeleteButton2 = _interopRequireDefault(_ChildRowDeleteButton);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var React = __webpack_require__(2);

	var joinClasses = __webpack_require__(6);
	var EditorContainer = __webpack_require__(125);
	var ExcelColumn = __webpack_require__(13);
	var isFunction = __webpack_require__(20);
	var CellMetaDataShape = __webpack_require__(12);
	var SimpleCellFormatter = __webpack_require__(52);
	var ColumnUtils = __webpack_require__(7);
	var createObjectWithProperties = __webpack_require__(15);

	__webpack_require__(38);

	// The list of the propTypes that we want to include in the Cell div
	var knownDivPropertyKeys = ['height', 'tabIndex', 'value'];

	var Cell = function (_React$Component) {
	  _inherits(Cell, _React$Component);

	  function Cell() {
	    var _temp, _this, _ret;

	    _classCallCheck(this, Cell);

	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }

	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      isCellValueChanging: false,
	      isLockChanging: false
	    }, _this.onCellClick = function (e) {
	      var meta = _this.props.cellMetaData;
	      if (meta != null && meta.onCellClick && typeof meta.onCellClick === 'function') {
	        meta.onCellClick({ rowIdx: _this.props.rowIdx, idx: _this.props.idx }, e);
	      }
	    }, _this.onCellFocus = function () {
	      var meta = _this.props.cellMetaData;
	      if (meta != null && meta.onCellFocus && typeof meta.onCellFocus === 'function') {
	        meta.onCellFocus({ rowIdx: _this.props.rowIdx, idx: _this.props.idx });
	      }
	    }, _this.onCellContextMenu = function () {
	      var meta = _this.props.cellMetaData;
	      if (meta != null && meta.onCellContextMenu && typeof meta.onCellContextMenu === 'function') {
	        meta.onCellContextMenu({ rowIdx: _this.props.rowIdx, idx: _this.props.idx });
	      }
	    }, _this.onCellDoubleClick = function (e) {
	      var meta = _this.props.cellMetaData;
	      if (meta != null && meta.onCellDoubleClick && typeof meta.onCellDoubleClick === 'function') {
	        meta.onCellDoubleClick({ rowIdx: _this.props.rowIdx, idx: _this.props.idx }, e);
	      }
	    }, _this.onCellExpand = function (e) {
	      e.stopPropagation();
	      var meta = _this.props.cellMetaData;
	      if (meta != null && meta.onCellExpand != null) {
	        meta.onCellExpand({ rowIdx: _this.props.rowIdx, idx: _this.props.idx, rowData: _this.props.rowData, expandArgs: _this.props.expandableOptions });
	      }
	    }, _this.onCellKeyDown = function (e) {
	      if (_this.canExpand() && e.key === 'Enter') {
	        _this.onCellExpand(e);
	      }
	    }, _this.onDeleteSubRow = function () {
	      var meta = _this.props.cellMetaData;
	      if (meta != null && meta.onDeleteSubRow != null) {
	        meta.onDeleteSubRow({ rowIdx: _this.props.rowIdx, idx: _this.props.idx, rowData: _this.props.rowData, expandArgs: _this.props.expandableOptions });
	      }
	    }, _this.onDragHandleDoubleClick = function (e) {
	      e.stopPropagation();
	      var meta = _this.props.cellMetaData;
	      if (meta != null && meta.onDragHandleDoubleClick && typeof meta.onDragHandleDoubleClick === 'function') {
	        meta.onDragHandleDoubleClick({ rowIdx: _this.props.rowIdx, idx: _this.props.idx, rowData: _this.getRowData(), e: e });
	      }
	    }, _this.onDragOver = function (e) {
	      e.preventDefault();
	    }, _this.getStyle = function () {
	      var style = {
	        position: 'absolute',
	        width: _this.props.column.width,
	        height: _this.props.height,
	        left: _this.props.column.left,
	        contain: 'layout'
	      };
	      return style;
	    }, _this.getFormatter = function () {
	      var col = _this.props.column;
	      if (_this.isActive()) {
	        return React.createElement(EditorContainer, { rowData: _this.getRowData(), rowIdx: _this.props.rowIdx, value: _this.props.value, idx: _this.props.idx, cellMetaData: _this.props.cellMetaData, column: col, height: _this.props.height });
	      }

	      return _this.props.column.formatter;
	    }, _this.getRowData = function () {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;

	      return props.rowData.toJSON ? props.rowData.toJSON() : props.rowData;
	    }, _this.getFormatterDependencies = function () {
	      // convention based method to get corresponding Id or Name of any Name or Id property
	      if (typeof _this.props.column.getRowMetaData === 'function') {
	        return _this.props.column.getRowMetaData(_this.getRowData(), _this.props.column);
	      }
	    }, _this.getCellClass = function () {
	      var className = joinClasses(_this.props.column.cellClass, 'react-grid-Cell', _this.props.className, _this.props.column.locked ? 'react-grid-Cell--locked' : null);
	      var extraClasses = joinClasses({
	        'row-selected': _this.props.isRowSelected,
	        editing: _this.isActive(),
	        copied: _this.isCopied() || _this.wasDraggedOver() || _this.isDraggedOverUpwards() || _this.isDraggedOverDownwards(),
	        'is-dragged-over-up': _this.isDraggedOverUpwards(),
	        'is-dragged-over-down': _this.isDraggedOverDownwards(),
	        'was-dragged-over': _this.wasDraggedOver(),
	        'cell-tooltip': _this.props.tooltip ? true : false,
	        'rdg-child-cell': _this.props.expandableOptions && _this.props.expandableOptions.subRowDetails && _this.props.expandableOptions.treeDepth > 0,
	        'last-column': _this.props.column.isLastColumn
	      });
	      return joinClasses(className, extraClasses);
	    }, _this.getUpdateCellClass = function () {
	      return _this.props.column.getUpdateCellClass ? _this.props.column.getUpdateCellClass(_this.props.selectedColumn, _this.props.column, _this.state.isCellValueChanging) : '';
	    }, _this.isColumnSelected = function () {
	      var meta = _this.props.cellMetaData;
	      if (meta == null) {
	        return false;
	      }

	      return meta.selected && meta.selected.idx === _this.props.idx;
	    }, _this.isSelected = function () {
	      var meta = _this.props.cellMetaData;
	      if (meta == null) {
	        return false;
	      }

	      return meta.selected && meta.selected.rowIdx === _this.props.rowIdx && meta.selected.idx === _this.props.idx;
	    }, _this.isActive = function () {
	      var meta = _this.props.cellMetaData;
	      if (meta == null) {
	        return false;
	      }
	      return _this.isSelected() && meta.selected.active === true;
	    }, _this.isCellSelectionChanging = function (nextProps) {
	      var meta = _this.props.cellMetaData;
	      if (meta == null) {
	        return false;
	      }
	      var nextSelected = nextProps.cellMetaData.selected;
	      if (meta.selected && nextSelected) {
	        return _this.props.idx === nextSelected.idx || _this.props.idx === meta.selected.idx;
	      }

	      return true;
	    }, _this.isCellSelectEnabled = function () {
	      var meta = _this.props.cellMetaData;
	      if (meta == null) {
	        return false;
	      }
	      return meta.enableCellSelect;
	    }, _this.hasChangedDependentValues = function (nextProps) {
	      var currentColumn = _this.props.column;
	      var hasChangedDependentValues = false;

	      if (currentColumn.getRowMetaData) {
	        var currentRowMetaData = currentColumn.getRowMetaData(_this.getRowData(), currentColumn);
	        var nextColumn = nextProps.column;
	        var nextRowMetaData = nextColumn.getRowMetaData(_this.getRowData(nextProps), nextColumn);

	        hasChangedDependentValues = !_underscore2['default'].isEqual(currentRowMetaData, nextRowMetaData);
	      }

	      return hasChangedDependentValues;
	    }, _this.applyUpdateClass = function () {
	      var updateCellClass = _this.getUpdateCellClass();
	      // -> removing the class
	      if (updateCellClass != null && updateCellClass !== '') {
	        var cellDOMNode = _this.node;
	        if (cellDOMNode.classList) {
	          cellDOMNode.classList.remove(updateCellClass);
	          // -> and re-adding the class
	          cellDOMNode.classList.add(updateCellClass);
	        } else if (cellDOMNode.className.indexOf(updateCellClass) === -1) {
	          // IE9 doesn't support classList, nor (I think) altering element.className
	          // without replacing it wholesale.
	          cellDOMNode.className = cellDOMNode.className + ' ' + updateCellClass;
	        }
	      }
	    }, _this.setScrollLeft = function (scrollLeft) {
	      var node = _this.node;
	      if (node) {
	        var transform = 'translate3d(' + scrollLeft + 'px, 0px, 0px)';
	        node.style.webkitTransform = transform;
	        node.style.transform = transform;
	      }
	    }, _this.removeScroll = function () {
	      var node = _this.node;
	      if (node) {
	        node.style.webkitTransform = null;
	        node.style.transform = null;
	      }
	    }, _this.isCopied = function () {
	      var copied = _this.props.cellMetaData.copied;
	      return copied && copied.rowIdx === _this.props.rowIdx && copied.idx === _this.props.idx;
	    }, _this.isDraggedOver = function () {
	      var dragged = _this.props.cellMetaData.dragged;
	      return dragged && dragged.overRowIdx === _this.props.rowIdx && dragged.idx === _this.props.idx;
	    }, _this.wasDraggedOver = function () {
	      var dragged = _this.props.cellMetaData.dragged;
	      return dragged && (dragged.overRowIdx < _this.props.rowIdx && _this.props.rowIdx < dragged.rowIdx || dragged.overRowIdx > _this.props.rowIdx && _this.props.rowIdx > dragged.rowIdx) && dragged.idx === _this.props.idx;
	    }, _this.isDraggedCellChanging = function (nextProps) {
	      var isChanging = void 0;
	      var dragged = _this.props.cellMetaData.dragged;
	      var nextDragged = nextProps.cellMetaData.dragged;
	      if (dragged) {
	        isChanging = nextDragged && _this.props.idx === nextDragged.idx || dragged && _this.props.idx === dragged.idx;
	        return isChanging;
	      }

	      return false;
	    }, _this.isCopyCellChanging = function (nextProps) {
	      var isChanging = void 0;
	      var copied = _this.props.cellMetaData.copied;
	      var nextCopied = nextProps.cellMetaData.copied;
	      if (copied) {
	        isChanging = nextCopied && _this.props.idx === nextCopied.idx || copied && _this.props.idx === copied.idx;
	        return isChanging;
	      }
	      return false;
	    }, _this.isDraggedOverUpwards = function () {
	      var dragged = _this.props.cellMetaData.dragged;
	      return !_this.isSelected() && _this.isDraggedOver() && _this.props.rowIdx < dragged.rowIdx;
	    }, _this.isDraggedOverDownwards = function () {
	      var dragged = _this.props.cellMetaData.dragged;
	      return !_this.isSelected() && _this.isDraggedOver() && _this.props.rowIdx > dragged.rowIdx;
	    }, _this.isFocusedOnBody = function () {
	      return document.activeElement == null || document.activeElement.nodeName && typeof document.activeElement.nodeName === 'string' && document.activeElement.nodeName.toLowerCase() === 'body';
	    }, _this.isFocusedOnCell = function () {
	      return document.activeElement && document.activeElement.className.indexOf('react-grid-Cell') !== -1;
	    }, _this.checkFocus = function () {
	      if (_this.isSelected() && !_this.isActive()) {
	        if (_this.props.isScrolling && !_this.props.cellMetaData.isScrollingVerticallyWithKeyboard && !_this.props.cellMetaData.isScrollingHorizontallyWithKeyboard) {
	          return;
	        }
	        // If the enableCellAutoFocus is set in the ReactDataGrid props, it will allow the cell to take focus when the browser is focused on the body.
	        // Otherwise, only focus to the current cell if the currently active node in the document is within the data grid.
	        // Meaning focus should not be stolen from elements that the grid doesnt control.
	        var cellAutoFocusEnabled = _this.props.cellMetaData && _this.props.cellMetaData.enableCellAutoFocus;
	        var dataGridDOMNode = _this.props.cellMetaData && _this.props.cellMetaData.getDataGridDOMNode ? _this.props.cellMetaData.getDataGridDOMNode() : null;
	        if (_this.isFocusedOnCell() || cellAutoFocusEnabled && _this.isFocusedOnBody() || dataGridDOMNode && dataGridDOMNode.contains(document.activeElement)) {
	          var cellDOMNode = _this.node;
	          if (cellDOMNode) {
	            cellDOMNode.focus();
	          }
	        }
	      }
	    }, _this.canEdit = function () {
	      return _this.props.column.editor != null || _this.props.column.editable;
	    }, _this.canExpand = function () {
	      return _this.props.expandableOptions && _this.props.expandableOptions.canExpand;
	    }, _this.createColumEventCallBack = function (onColumnEvent, info) {
	      return function (e) {
	        onColumnEvent(e, info);
	      };
	    }, _this.createCellEventCallBack = function (gridEvent, columnEvent) {
	      return function (e) {
	        gridEvent(e);
	        columnEvent(e);
	      };
	    }, _this.createEventDTO = function (gridEvents, columnEvents, onColumnEvent) {
	      var allEvents = Object.assign({}, gridEvents);

	      for (var eventKey in columnEvents) {
	        if (columnEvents.hasOwnProperty(eventKey)) {
	          var event = columnEvents[event];
	          var eventInfo = { idx: _this.props.idx, rowIdx: _this.props.rowIdx, rowId: _this.props.rowData[_this.props.cellMetaData.rowKey], name: eventKey };
	          var eventCallback = _this.createColumEventCallBack(onColumnEvent, eventInfo);

	          if (allEvents.hasOwnProperty(eventKey)) {
	            var currentEvent = allEvents[eventKey];
	            allEvents[eventKey] = _this.createCellEventCallBack(currentEvent, eventCallback);
	          } else {
	            allEvents[eventKey] = eventCallback;
	          }
	        }
	      }

	      return allEvents;
	    }, _this.getEvents = function () {
	      var columnEvents = _this.props.column ? Object.assign({}, _this.props.column.events) : undefined;
	      var onColumnEvent = _this.props.cellMetaData ? _this.props.cellMetaData.onColumnEvent : undefined;
	      var gridEvents = {
	        onClick: _this.onCellClick,
	        onFocus: _this.onCellFocus,
	        onDoubleClick: _this.onCellDoubleClick,
	        onContextMenu: _this.onCellContextMenu,
	        onDragOver: _this.onDragOver
	      };

	      if (!columnEvents || !onColumnEvent) {
	        return gridEvents;
	      }

	      return _this.createEventDTO(gridEvents, columnEvents, onColumnEvent);
	    }, _this.getKnownDivProps = function () {
	      return createObjectWithProperties(_this.props, knownDivPropertyKeys);
	    }, _this.renderCellContent = function (props) {
	      var CellContent = void 0;
	      var Formatter = _this.getFormatter();
	      if (React.isValidElement(Formatter)) {
	        props.dependentValues = _this.getFormatterDependencies();
	        CellContent = React.cloneElement(Formatter, props);
	      } else if (isFunction(Formatter)) {
	        CellContent = React.createElement(Formatter, { value: _this.props.value, dependentValues: _this.getFormatterDependencies() });
	      } else {
	        CellContent = React.createElement(SimpleCellFormatter, { value: _this.props.value });
	      }
	      var isExpandCell = _this.props.expandableOptions ? _this.props.expandableOptions.field === _this.props.column.key : false;
	      var treeDepth = _this.props.expandableOptions ? _this.props.expandableOptions.treeDepth : 0;
	      var marginLeft = _this.props.expandableOptions && isExpandCell ? _this.props.expandableOptions.treeDepth * 30 : 0;
	      var cellExpander = void 0;
	      var cellDeleter = void 0;
	      if (_this.canExpand()) {
	        cellExpander = React.createElement(_CellExpand2['default'], { expandableOptions: _this.props.expandableOptions, onCellExpand: _this.onCellExpand });
	      }

	      var isDeleteSubRowEnabled = _this.props.cellMetaData.onDeleteSubRow ? true : false;

	      if (treeDepth > 0 && isExpandCell) {
	        cellDeleter = React.createElement(_ChildRowDeleteButton2['default'], { treeDepth: treeDepth, cellHeight: _this.props.height, siblingIndex: _this.props.expandableOptions.subRowDetails.siblingIndex, numberSiblings: _this.props.expandableOptions.subRowDetails.numberSiblings, onDeleteSubRow: _this.onDeleteSubRow, isDeleteSubRowEnabled: isDeleteSubRowEnabled });
	      }
	      return React.createElement(
	        'div',
	        { className: 'react-grid-Cell__value' },
	        cellDeleter,
	        React.createElement(
	          'div',
	          { style: { marginLeft: marginLeft } },
	          React.createElement(
	            'span',
	            null,
	            CellContent
	          ),
	          ' ',
	          _this.props.cellControls,
	          ' ',
	          cellExpander
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }

	  Cell.prototype.componentDidMount = function componentDidMount() {
	    this.checkFocus();
	  };

	  Cell.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    this.setState({
	      isCellValueChanging: this.props.isCellValueChanging(this.props.value, nextProps.value),
	      isLockChanging: this.props.column.locked !== nextProps.column.locked
	    });
	  };

	  Cell.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.checkFocus();
	    var dragged = this.props.cellMetaData.dragged;
	    if (dragged && dragged.complete === true) {
	      this.props.cellMetaData.handleTerminateDrag();
	    }
	    if (this.state.isCellValueChanging && this.props.selectedColumn != null) {
	      this.applyUpdateClass();
	    }
	    if (this.state.isLockChanging && !this.props.column.locked) {
	      this.removeScroll();
	    }
	  };

	  Cell.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    var shouldUpdate = this.props.column.width !== nextProps.column.width || this.props.column.left !== nextProps.column.left || this.props.column.cellClass !== nextProps.column.cellClass || this.props.height !== nextProps.height || this.props.rowIdx !== nextProps.rowIdx || this.isCellSelectionChanging(nextProps) || this.isDraggedCellChanging(nextProps) || this.isCopyCellChanging(nextProps) || this.props.isRowSelected !== nextProps.isRowSelected || this.isSelected() || this.props.isCellValueChanging(this.props.value, nextProps.value) || this.props.forceUpdate === true || this.props.className !== nextProps.className || this.props.expandableOptions !== nextProps.expandableOptions || this.hasChangedDependentValues(nextProps) || this.props.column.locked !== nextProps.column.locked;
	    return shouldUpdate;
	  };

	  Cell.prototype.getCellActions = function getCellActions() {
	    var _props = this.props,
	        cellMetaData = _props.cellMetaData,
	        column = _props.column,
	        rowData = _props.rowData;

	    if (cellMetaData && cellMetaData.getCellActions) {
	      var cellActions = cellMetaData.getCellActions(column, rowData);
	      if (cellActions && cellActions.length) {
	        return cellActions.map(function (action, index) {
	          return React.createElement(_CellAction2['default'], { key: index, action: action, isFirst: index === 0 });
	        });
	      }
	      return null;
	    }
	    return null;
	  };

	  Cell.prototype.render = function render() {
	    var _this2 = this;

	    if (this.props.column.hidden) {
	      return null;
	    }

	    var style = this.getStyle();

	    var className = this.getCellClass();

	    var cellActions = this.getCellActions();

	    var cellContent = this.props.children || this.renderCellContent({
	      value: this.props.value,
	      column: this.props.column,
	      rowIdx: this.props.rowIdx,
	      isExpanded: this.props.isExpanded
	    });

	    var dragHandle = !this.isActive() && ColumnUtils.canEdit(this.props.column, this.props.rowData, this.props.cellMetaData.enableCellSelect) ? React.createElement(
	      'div',
	      { className: 'drag-handle', draggable: 'true', onDoubleClick: this.onDragHandleDoubleClick },
	      React.createElement('span', { style: { display: 'none' } })
	    ) : null;
	    var events = this.getEvents();
	    var tooltip = this.props.tooltip ? React.createElement(
	      'span',
	      { className: 'cell-tooltip-text' },
	      this.props.tooltip
	    ) : null;

	    return React.createElement(
	      'div',
	      _extends({}, this.getKnownDivProps(), { className: className, style: style }, events, { ref: function ref(node) {
	          _this2.node = node;
	        } }),
	      cellActions,
	      cellContent,
	      dragHandle,
	      tooltip
	    );
	  };

	  return Cell;
	}(React.Component);

	Cell.propTypes = {
	  rowIdx: _propTypes2['default'].number.isRequired,
	  idx: _propTypes2['default'].number.isRequired,
	  selected: _propTypes2['default'].shape({
	    idx: _propTypes2['default'].number.isRequired
	  }),
	  selectedColumn: _propTypes2['default'].object,
	  height: _propTypes2['default'].number,
	  tabIndex: _propTypes2['default'].number,
	  column: _propTypes2['default'].shape(ExcelColumn).isRequired,
	  value: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number, _propTypes2['default'].object, _propTypes2['default'].bool]),
	  isExpanded: _propTypes2['default'].bool,
	  isRowSelected: _propTypes2['default'].bool,
	  cellMetaData: _propTypes2['default'].shape(CellMetaDataShape).isRequired,
	  handleDragStart: _propTypes2['default'].func,
	  className: _propTypes2['default'].string,
	  cellControls: _propTypes2['default'].any,
	  rowData: _propTypes2['default'].object.isRequired,
	  forceUpdate: _propTypes2['default'].bool,
	  expandableOptions: _propTypes2['default'].object.isRequired,
	  isScrolling: _propTypes2['default'].bool.isRequired,
	  tooltip: _propTypes2['default'].string,
	  isCellValueChanging: _propTypes2['default'].func,
	  children: _propTypes2['default'].oneOfType([_propTypes2['default'].arrayOf(_propTypes2['default'].node), _propTypes2['default'].node])
	};
	Cell.defaultProps = {
	  tabIndex: 0,
	  isExpanded: false,
	  value: '',
	  isCellValueChanging: function isCellValueChanging(value, nextValue) {
	    return value !== nextValue;
	  }
	};


	module.exports = Cell;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _propTypes = __webpack_require__(3);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var React = __webpack_require__(2);
	var ReactDOM = __webpack_require__(10);
	var joinClasses = __webpack_require__(6);
	var ExcelColumn = __webpack_require__(13);
	var ResizeHandle = __webpack_require__(121);
	__webpack_require__(16);

	function simpleCellRenderer(objArgs) {
	  var headerText = objArgs.column.rowType === 'header' ? objArgs.column.name : '';
	  return React.createElement(
	    'div',
	    { className: 'widget-HeaderCell__value' },
	    headerText
	  );
	}

	var HeaderCell = function (_React$Component) {
	  _inherits(HeaderCell, _React$Component);

	  function HeaderCell() {
	    var _temp, _this, _ret;

	    _classCallCheck(this, HeaderCell);

	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }

	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = { resizing: false }, _this.onDragStart = function (e) {
	      _this.setState({ resizing: true });
	      // need to set dummy data for FF
	      if (e && e.dataTransfer && e.dataTransfer.setData) e.dataTransfer.setData('text/plain', 'dummy');
	    }, _this.onDrag = function (e) {
	      var resize = _this.props.onResize || null; // for flows sake, doesnt recognise a null check direct
	      if (resize) {
	        var _width = _this.getWidthFromMouseEvent(e);
	        if (_width > 0) {
	          resize(_this.props.column, _width);
	        }
	      }
	    }, _this.onDragEnd = function (e) {
	      var width = _this.getWidthFromMouseEvent(e);
	      _this.props.onResizeEnd(_this.props.column, width);
	      _this.setState({ resizing: false });
	    }, _this.getWidthFromMouseEvent = function (e) {
	      var right = e.pageX || e.touches && e.touches[0] && e.touches[0].pageX || e.changedTouches && e.changedTouches[e.changedTouches.length - 1].pageX;
	      var left = ReactDOM.findDOMNode(_this).getBoundingClientRect().left;
	      return right - left;
	    }, _this.getCell = function () {
	      if (React.isValidElement(_this.props.renderer)) {
	        // if it is a string, it's an HTML element, and column is not a valid property, so only pass height
	        if (typeof _this.props.renderer.type === 'string') {
	          return React.cloneElement(_this.props.renderer, { height: _this.props.height });
	        }
	        return React.cloneElement(_this.props.renderer, { column: _this.props.column, height: _this.props.height });
	      }
	      return _this.props.renderer({ column: _this.props.column });
	    }, _this.getStyle = function () {
	      return {
	        width: _this.props.column.width,
	        left: _this.props.column.left,
	        display: 'inline-block',
	        position: 'absolute',
	        height: _this.props.height,
	        margin: 0,
	        textOverflow: 'ellipsis',
	        whiteSpace: 'nowrap'
	      };
	    }, _this.setScrollLeft = function (scrollLeft) {
	      var node = ReactDOM.findDOMNode(_this);
	      node.style.webkitTransform = 'translate3d(' + scrollLeft + 'px, 0px, 0px)';
	      node.style.transform = 'translate3d(' + scrollLeft + 'px, 0px, 0px)';
	    }, _this.removeScroll = function () {
	      var node = ReactDOM.findDOMNode(_this);
	      if (node) {
	        var transform = 'none';
	        node.style.webkitTransform = transform;
	        node.style.transform = transform;
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }

	  HeaderCell.prototype.render = function render() {
	    var resizeHandle = void 0;
	    if (this.props.column.resizable) {
	      resizeHandle = React.createElement(ResizeHandle, {
	        onDrag: this.onDrag,
	        onDragStart: this.onDragStart,
	        onDragEnd: this.onDragEnd
	      });
	    }
	    var className = joinClasses({
	      'react-grid-HeaderCell': true,
	      'react-grid-HeaderCell--resizing': this.state.resizing,
	      'react-grid-HeaderCell--locked': this.props.column.locked
	    });
	    className = joinClasses(className, this.props.className, this.props.column.cellClass);
	    var cell = this.getCell();
	    return React.createElement(
	      'div',
	      { className: className, style: this.getStyle() },
	      cell,
	      resizeHandle
	    );
	  };

	  return HeaderCell;
	}(React.Component);

	HeaderCell.propTypes = {
	  renderer: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].element]).isRequired,
	  column: _propTypes2['default'].shape(ExcelColumn).isRequired,
	  onResize: _propTypes2['default'].func.isRequired,
	  height: _propTypes2['default'].number.isRequired,
	  onResizeEnd: _propTypes2['default'].func.isRequired,
	  className: _propTypes2['default'].string
	};
	HeaderCell.defaultProps = {
	  renderer: simpleCellRenderer
	};


	module.exports = HeaderCell;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _OverflowCell = __webpack_require__(117);

	var _OverflowCell2 = _interopRequireDefault(_OverflowCell);

	var _RowComparer = __webpack_require__(44);

	var _RowComparer2 = _interopRequireDefault(_RowComparer);

	var _propTypes = __webpack_require__(3);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var React = __webpack_require__(2);

	var joinClasses = __webpack_require__(6);
	var Cell = __webpack_require__(41);
	var columnUtils = __webpack_require__(7);
	var cellMetaDataShape = __webpack_require__(12);
	var createObjectWithProperties = __webpack_require__(15);
	__webpack_require__(30);

	var CellExpander = function (_React$Component) {
	  _inherits(CellExpander, _React$Component);

	  function CellExpander() {
	    _classCallCheck(this, CellExpander);

	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }

	  CellExpander.prototype.render = function render() {
	    return React.createElement(Cell, this.props);
	  };

	  return CellExpander;
	}(React.Component);

	// The list of the propTypes that we want to include in the Row div


	var knownDivPropertyKeys = ['height'];

	var Row = function (_React$Component2) {
	  _inherits(Row, _React$Component2);

	  function Row() {
	    var _temp, _this2, _ret;

	    _classCallCheck(this, Row);

	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }

	    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, _React$Component2.call.apply(_React$Component2, [this].concat(args))), _this2), _this2.handleDragEnter = function () {
	      var handleDragEnterRow = _this2.props.cellMetaData.handleDragEnterRow;
	      if (handleDragEnterRow) {
	        handleDragEnterRow(_this2.props.idx);
	      }
	    }, _this2.getSelectedColumn = function () {
	      if (_this2.props.cellMetaData) {
	        var selected = _this2.props.cellMetaData.selected;
	        if (selected && selected.idx) {
	          return columnUtils.getColumn(_this2.props.columns, selected.idx);
	        }
	      }
	    }, _this2.getCellRenderer = function (columnKey) {
	      var CellRenderer = _this2.props.cellRenderer;
	      if (_this2.props.subRowDetails && _this2.props.subRowDetails.field === columnKey) {
	        return CellExpander;
	      }
	      return CellRenderer;
	    }, _this2.getCell = function (column, i, selectedColumn) {
	      var CellRenderer = _this2.props.cellRenderer;
	      var _this2$props = _this2.props,
	          colVisibleStart = _this2$props.colVisibleStart,
	          colVisibleEnd = _this2$props.colVisibleEnd,
	          idx = _this2$props.idx,
	          cellMetaData = _this2$props.cellMetaData;
	      var key = column.key,
	          formatter = column.formatter,
	          locked = column.locked;

	      var baseCellProps = { key: key + '-' + idx, idx: i, rowIdx: idx, height: _this2.getRowHeight(), column: column, cellMetaData: cellMetaData };

	      if ((i < colVisibleStart || i > colVisibleEnd) && !locked) {
	        return React.createElement(_OverflowCell2['default'], _extends({ ref: function ref(node) {
	            return _this2[key] = node;
	          } }, baseCellProps));
	      }

	      var _this2$props2 = _this2.props,
	          row = _this2$props2.row,
	          isSelected = _this2$props2.isSelected;

	      var cellProps = {
	        ref: function ref(node) {
	          return _this2[key] = node;
	        },
	        value: _this2.getCellValue(key || i),
	        rowData: row,
	        isRowSelected: isSelected,
	        expandableOptions: _this2.getExpandableOptions(key),
	        selectedColumn: selectedColumn,
	        formatter: formatter,
	        isScrolling: _this2.props.isScrolling
	      };

	      return React.createElement(CellRenderer, _extends({}, baseCellProps, cellProps));
	    }, _this2.getCells = function () {
	      var cells = [];
	      var lockedCells = [];
	      var selectedColumn = _this2.getSelectedColumn();
	      var lastColumnIdx = _this2.props.columns.size - 1;
	      if (_this2.props.columns) {
	        _this2.props.columns.forEach(function (column, i) {
	          if (i === lastColumnIdx) {
	            column.isLastColumn = true;
	          }
	          var cell = _this2.getCell(column, i, selectedColumn);
	          if (column.locked) {
	            lockedCells.push(cell);
	          } else {
	            cells.push(cell);
	          }
	        });
	      }

	      return cells.concat(lockedCells);
	    }, _this2.getRowHeight = function () {
	      var rows = _this2.props.expandedRows || null;
	      if (rows && _this2.props.idx) {
	        var row = rows[_this2.props.idx] || null;
	        if (row) {
	          return row.height;
	        }
	      }
	      return _this2.props.height;
	    }, _this2.getCellValue = function (key) {
	      var val = void 0;
	      if (key === 'select-row') {
	        return _this2.props.isSelected;
	      } else if (typeof _this2.props.row.get === 'function') {
	        val = _this2.props.row.get(key);
	      } else {
	        val = _this2.props.row[key];
	      }
	      return val;
	    }, _this2.isContextMenuDisplayed = function () {
	      if (_this2.props.cellMetaData) {
	        var selected = _this2.props.cellMetaData.selected;
	        if (selected && selected.contextMenuDisplayed && selected.rowIdx === _this2.props.idx) {
	          return true;
	        }
	      }
	      return false;
	    }, _this2.getExpandableOptions = function (columnKey) {
	      var subRowDetails = _this2.props.subRowDetails;
	      if (subRowDetails) {
	        return { canExpand: subRowDetails && subRowDetails.field === columnKey && (subRowDetails.children && subRowDetails.children.length > 0 || subRowDetails.group === true), field: subRowDetails.field, expanded: subRowDetails && subRowDetails.expanded, children: subRowDetails && subRowDetails.children, treeDepth: subRowDetails ? subRowDetails.treeDepth : 0, subRowDetails: subRowDetails };
	      }
	      return {};
	    }, _this2.setScrollLeft = function (scrollLeft) {
	      _this2.props.columns.forEach(function (column) {
	        if (column.locked) {
	          if (!_this2[column.key]) return;
	          _this2[column.key].setScrollLeft(scrollLeft);
	        }
	      });
	    }, _this2.getKnownDivProps = function () {
	      return createObjectWithProperties(_this2.props, knownDivPropertyKeys);
	    }, _this2.renderCell = function (props) {
	      if (typeof _this2.props.cellRenderer === 'function') {
	        _this2.props.cellRenderer.call(_this2, props);
	      }
	      if (React.isValidElement(_this2.props.cellRenderer)) {
	        return React.cloneElement(_this2.props.cellRenderer, props);
	      }

	      return _this2.props.cellRenderer(props);
	    }, _temp), _possibleConstructorReturn(_this2, _ret);
	  }

	  Row.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    return (0, _RowComparer2['default'])(nextProps, this.props);
	  };

	  Row.prototype.render = function render() {
	    var className = joinClasses('react-grid-Row', 'react-grid-Row--' + (this.props.idx % 2 === 0 ? 'even' : 'odd'), {
	      'row-selected': this.props.isSelected,
	      'row-context-menu': this.isContextMenuDisplayed()
	    }, this.props.extraClasses);

	    var style = {
	      height: this.getRowHeight(this.props),
	      overflow: 'hidden',
	      contain: 'layout'
	    };

	    var cells = this.getCells();
	    return React.createElement(
	      'div',
	      _extends({}, this.getKnownDivProps(), { className: className, style: style, onDragEnter: this.handleDragEnter }),
	      React.isValidElement(this.props.row) ? this.props.row : cells
	    );
	  };

	  return Row;
	}(React.Component);

	Row.displayName = 'Row';
	Row.propTypes = {
	  height: _propTypes2['default'].number.isRequired,
	  columns: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].array]).isRequired,
	  row: _propTypes2['default'].any.isRequired,
	  cellRenderer: _propTypes2['default'].func,
	  cellMetaData: _propTypes2['default'].shape(cellMetaDataShape),
	  isSelected: _propTypes2['default'].bool,
	  idx: _propTypes2['default'].number.isRequired,
	  expandedRows: _propTypes2['default'].arrayOf(_propTypes2['default'].object),
	  extraClasses: _propTypes2['default'].string,
	  forceUpdate: _propTypes2['default'].bool,
	  subRowDetails: _propTypes2['default'].object,
	  isRowHovered: _propTypes2['default'].bool,
	  colVisibleStart: _propTypes2['default'].number.isRequired,
	  colVisibleEnd: _propTypes2['default'].number.isRequired,
	  colDisplayStart: _propTypes2['default'].number.isRequired,
	  colDisplayEnd: _propTypes2['default'].number.isRequired,
	  isScrolling: _propTypes2['default'].bool.isRequired
	};
	Row.defaultProps = {
	  cellRenderer: Cell,
	  isSelected: false,
	  height: 35
	};


	module.exports = Row;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;
	exports.shouldRowUpdate = undefined;

	var _ColumnMetrics = __webpack_require__(32);

	var _ColumnMetrics2 = _interopRequireDefault(_ColumnMetrics);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function doesRowContainSelectedCell(props) {
	  var selected = props.cellMetaData.selected;
	  if (selected && selected.rowIdx === props.idx) {
	    return true;
	  }
	  return false;
	}

	function willRowBeDraggedOver(props) {
	  var dragged = props.cellMetaData.dragged;
	  return dragged != null && (dragged.rowIdx >= 0 || dragged.complete === true);
	}

	function hasRowBeenCopied(props) {
	  var copied = props.cellMetaData.copied;
	  return copied != null && copied.rowIdx === props.idx;
	}

	var shouldRowUpdate = exports.shouldRowUpdate = function shouldRowUpdate(nextProps, currentProps) {
	  return !_ColumnMetrics2['default'].sameColumns(currentProps.columns, nextProps.columns, _ColumnMetrics2['default'].sameColumn) || doesRowContainSelectedCell(currentProps) || doesRowContainSelectedCell(nextProps) || willRowBeDraggedOver(nextProps) || nextProps.row !== currentProps.row || currentProps.colDisplayStart !== nextProps.colDisplayStart || currentProps.colDisplayEnd !== nextProps.colDisplayEnd || currentProps.colVisibleStart !== nextProps.colVisibleStart || currentProps.colVisibleEnd !== nextProps.colVisibleEnd || hasRowBeenCopied(currentProps) || currentProps.isSelected !== nextProps.isSelected || nextProps.height !== currentProps.height || currentProps.isOver !== nextProps.isOver || currentProps.expandedRows !== nextProps.expandedRows || currentProps.canDrop !== nextProps.canDrop || currentProps.forceUpdate === true || currentProps.extraClasses !== nextProps.extraClasses;
	};

	exports['default'] = shouldRowUpdate;

/***/ }),
/* 45 */
/***/ (function(module, exports) {

	'use strict';

	var RowUtils = {
	  get: function get(row, property) {
	    if (typeof row.get === 'function') {
	      return row.get(property);
	    }

	    return row[property];
	  },
	  isRowSelected: function isRowSelected(keys, indexes, isSelectedKey, rowData, rowIdx) {
	    if (indexes && Object.prototype.toString.call(indexes) === '[object Array]') {
	      return indexes.indexOf(rowIdx) > -1;
	    } else if (keys && keys.rowKey && keys.values && Object.prototype.toString.call(keys.values) === '[object Array]') {
	      return keys.values.indexOf(rowData[keys.rowKey]) > -1;
	    } else if (isSelectedKey && rowData && typeof isSelectedKey === 'string') {
	      return rowData[isSelectedKey];
	    }
	    return false;
	  }
	};

	module.exports = RowUtils;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;
	exports.SimpleRowsContainer = exports.getNewContextMenuProps = exports.DEFAULT_CONTEXT_MENU_ID = undefined;

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _propTypes = __webpack_require__(3);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var DEFAULT_CONTEXT_MENU_ID = exports.DEFAULT_CONTEXT_MENU_ID = 'rgdContextMenu';

	var SimpleRowsContainer = function SimpleRowsContainer(props) {
	  return _react2['default'].createElement(
	    'div',
	    { key: 'rows-container' },
	    props.rows
	  );
	};

	SimpleRowsContainer.propTypes = {
	  width: _propTypes2['default'].number,
	  rows: _propTypes2['default'].array
	};

	var getNewContextMenuProps = exports.getNewContextMenuProps = function getNewContextMenuProps(_ref) {
	  var contextMenu = _ref.contextMenu,
	      rowIdx = _ref.rowIdx,
	      idx = _ref.idx;
	  return {
	    rowIdx: rowIdx, idx: idx, id: contextMenu.props.id || DEFAULT_CONTEXT_MENU_ID
	  };
	};

	var RowsContainer = function (_React$Component) {
	  _inherits(RowsContainer, _React$Component);

	  function RowsContainer(props) {
	    _classCallCheck(this, RowsContainer);

	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

	    _this.plugins = props.window ? props.window.ReactDataGridPlugins : window.ReactDataGridPlugins;
	    return _this;
	  }

	  RowsContainer.prototype.validatePlugin = function validatePlugin() {
	    if (!this.plugins) {
	      throw new Error('You need to include ReactDataGrid UiPlugins in order to initialise context menu');
	    }
	  };

	  RowsContainer.prototype.hasContextMenu = function hasContextMenu() {
	    return this.props.contextMenu && _react2['default'].isValidElement(this.props.contextMenu);
	  };

	  RowsContainer.prototype.renderRowsWithContextMenu = function renderRowsWithContextMenu() {
	    var ContextMenuTrigger = this.plugins.Menu.ContextMenuTrigger;

	    var newProps = getNewContextMenuProps(this.props);
	    var contextMenu = _react2['default'].cloneElement(this.props.contextMenu, newProps);
	    // Initialise the context menu if it is available
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        ContextMenuTrigger,
	        { id: newProps.id },
	        _react2['default'].createElement(SimpleRowsContainer, this.props)
	      ),
	      contextMenu
	    );
	  };

	  RowsContainer.prototype.render = function render() {
	    if (this.hasContextMenu()) {
	      this.validatePlugin();
	      return this.renderRowsWithContextMenu();
	    }

	    return _react2['default'].createElement(SimpleRowsContainer, this.props);
	  };

	  return RowsContainer;
	}(_react2['default'].Component);

	RowsContainer.propTypes = {
	  contextMenu: _propTypes2['default'].element,
	  rowIdx: _propTypes2['default'].number,
	  idx: _propTypes2['default'].number,
	  window: _propTypes2['default'].object
	};

	exports['default'] = RowsContainer;
	exports.SimpleRowsContainer = SimpleRowsContainer;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _propTypes = __webpack_require__(3);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var React = __webpack_require__(2);

	var joinClasses = __webpack_require__(6);
	var DEFINE_SORT = {
	  ASC: 'ASC',
	  DESC: 'DESC',
	  NONE: 'NONE'
	};

	var SortableHeaderCell = function (_React$Component) {
	  _inherits(SortableHeaderCell, _React$Component);

	  function SortableHeaderCell() {
	    var _temp, _this, _ret;

	    _classCallCheck(this, SortableHeaderCell);

	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }

	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onClick = function () {
	      var direction = void 0;
	      var _this$props = _this.props,
	          sortDirection = _this$props.sortDirection,
	          sortDescendingFirst = _this$props.sortDescendingFirst;

	      switch (sortDirection) {
	        default:
	        case null:
	        case undefined:
	        case DEFINE_SORT.NONE:
	          direction = sortDescendingFirst ? DEFINE_SORT.DESC : DEFINE_SORT.ASC;
	          break;
	        case DEFINE_SORT.ASC:
	          direction = sortDescendingFirst ? DEFINE_SORT.NONE : DEFINE_SORT.DESC;
	          break;
	        case DEFINE_SORT.DESC:
	          direction = sortDescendingFirst ? DEFINE_SORT.ASC : DEFINE_SORT.NONE;
	          break;
	      }
	      _this.props.onSort(_this.props.columnKey, direction);
	    }, _this.getSortByText = function () {
	      var unicodeKeys = {
	        ASC: '9650',
	        DESC: '9660'
	      };
	      return _this.props.sortDirection === 'NONE' ? '' : String.fromCharCode(unicodeKeys[_this.props.sortDirection]);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }

	  SortableHeaderCell.prototype.render = function render() {
	    var className = joinClasses({
	      'react-grid-HeaderCell-sortable': true,
	      'react-grid-HeaderCell-sortable--ascending': this.props.sortDirection === 'ASC',
	      'react-grid-HeaderCell-sortable--descending': this.props.sortDirection === 'DESC'
	    });
	    var content = this.props.headerRenderer ? this.props.headerRenderer : this.props.column.name;
	    return React.createElement(
	      'div',
	      { className: className,
	        onClick: this.onClick,
	        style: { cursor: 'pointer' } },
	      React.createElement(
	        'span',
	        { className: 'pull-right' },
	        this.getSortByText()
	      ),
	      content
	    );
	  };

	  return SortableHeaderCell;
	}(React.Component);

	SortableHeaderCell.propTypes = {
	  columnKey: _propTypes2['default'].string.isRequired,
	  column: _propTypes2['default'].shape({ name: _propTypes2['default'].node }),
	  onSort: _propTypes2['default'].func.isRequired,
	  sortDirection: _propTypes2['default'].oneOf(Object.keys(DEFINE_SORT)),
	  headerRenderer: _propTypes2['default'].node,
	  sortDescendingFirst: _propTypes2['default'].bool
	};


	module.exports = SortableHeaderCell;
	module.exports.DEFINE_SORT = DEFINE_SORT;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _propTypes = __webpack_require__(3);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var React = __webpack_require__(2);

	__webpack_require__(71);

	var CheckboxEditor = function (_React$Component) {
	  _inherits(CheckboxEditor, _React$Component);

	  function CheckboxEditor() {
	    var _temp, _this, _ret;

	    _classCallCheck(this, CheckboxEditor);

	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }

	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleChange = function (e) {
	      _this.props.column.onCellChange(_this.props.rowIdx, _this.props.column.key, _this.props.dependentValues, e);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }

	  CheckboxEditor.prototype.render = function render() {
	    var checked = this.props.value != null ? this.props.value : false;
	    var checkboxName = 'checkbox' + this.props.rowIdx;
	    return React.createElement(
	      'div',
	      { className: 'react-grid-checkbox-container checkbox-align', onClick: this.handleChange },
	      React.createElement('input', { className: 'react-grid-checkbox', type: 'checkbox', name: checkboxName, checked: checked }),
	      React.createElement('label', { htmlFor: checkboxName, className: 'react-grid-checkbox-label' })
	    );
	  };

	  return CheckboxEditor;
	}(React.Component);

	CheckboxEditor.propTypes = {
	  value: _propTypes2['default'].bool,
	  rowIdx: _propTypes2['default'].number,
	  column: _propTypes2['default'].shape({
	    key: _propTypes2['default'].string,
	    onCellChange: _propTypes2['default'].func
	  }),
	  dependentValues: _propTypes2['default'].object
	};


	module.exports = CheckboxEditor;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _propTypes = __webpack_require__(3);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var React = __webpack_require__(2);
	var ReactDOM = __webpack_require__(10);
	var ExcelColumn = __webpack_require__(13);

	var EditorBase = function (_React$Component) {
	  _inherits(EditorBase, _React$Component);

	  function EditorBase() {
	    _classCallCheck(this, EditorBase);

	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }

	  EditorBase.prototype.getStyle = function getStyle() {
	    return {
	      width: '100%'
	    };
	  };

	  EditorBase.prototype.getValue = function getValue() {
	    var updated = {};
	    updated[this.props.column.key] = this.getInputNode().value;
	    return updated;
	  };

	  EditorBase.prototype.getInputNode = function getInputNode() {
	    var domNode = ReactDOM.findDOMNode(this);
	    if (domNode.tagName === 'INPUT') {
	      return domNode;
	    }

	    return domNode.querySelector('input:not([type=hidden])');
	  };

	  EditorBase.prototype.inheritContainerStyles = function inheritContainerStyles() {
	    return true;
	  };

	  return EditorBase;
	}(React.Component);

	EditorBase.propTypes = {
	  onKeyDown: _propTypes2['default'].func.isRequired,
	  value: _propTypes2['default'].any.isRequired,
	  onBlur: _propTypes2['default'].func.isRequired,
	  column: _propTypes2['default'].shape(ExcelColumn).isRequired,
	  commit: _propTypes2['default'].func.isRequired
	};

	module.exports = EditorBase;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var React = __webpack_require__(2);
	var EditorBase = __webpack_require__(49);

	var SimpleTextEditor = function (_EditorBase) {
	  _inherits(SimpleTextEditor, _EditorBase);

	  function SimpleTextEditor() {
	    _classCallCheck(this, SimpleTextEditor);

	    return _possibleConstructorReturn(this, _EditorBase.apply(this, arguments));
	  }

	  SimpleTextEditor.prototype.render = function render() {
	    var _this2 = this;

	    return React.createElement('input', { ref: function ref(node) {
	        return _this2.input = node;
	      }, type: 'text', onBlur: this.props.onBlur, className: 'form-control', defaultValue: this.props.value });
	  };

	  return SimpleTextEditor;
	}(EditorBase);

	module.exports = SimpleTextEditor;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _propTypes = __webpack_require__(3);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	var SelectAll = function SelectAll(props) {
	  return _react2['default'].createElement(
	    'div',
	    { className: 'react-grid-checkbox-container checkbox-align' },
	    _react2['default'].createElement('input', {
	      className: 'react-grid-checkbox',
	      type: 'checkbox',
	      name: 'select-all-checkbox',
	      id: 'select-all-checkbox',
	      ref: props.inputRef,
	      onChange: props.onChange
	    }),
	    _react2['default'].createElement('label', { htmlFor: 'select-all-checkbox', className: 'react-grid-checkbox-label' })
	  );
	};

	SelectAll.propTypes = {
	  onChange: _propTypes2['default'].func,
	  inputRef: _propTypes2['default'].func
	};

	exports['default'] = SelectAll;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _propTypes = __webpack_require__(3);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var React = __webpack_require__(2);

	var SimpleCellFormatter = function (_React$Component) {
	  _inherits(SimpleCellFormatter, _React$Component);

	  function SimpleCellFormatter() {
	    _classCallCheck(this, SimpleCellFormatter);

	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }

	  SimpleCellFormatter.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    return nextProps.value !== this.props.value;
	  };

	  SimpleCellFormatter.prototype.render = function render() {
	    return React.createElement(
	      'div',
	      { title: this.props.value },
	      this.props.value
	    );
	  };

	  return SimpleCellFormatter;
	}(React.Component);

	SimpleCellFormatter.propTypes = {
	  value: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number, _propTypes2['default'].object, _propTypes2['default'].bool]).isRequired
	};


	module.exports = SimpleCellFormatter;

/***/ }),
/* 53 */
/***/ (function(module, exports) {

	"use strict";

	function shallowCloneObject(obj) {
	  var result = {};
	  for (var k in obj) {
	    if (obj.hasOwnProperty(k)) {
	      result[k] = obj[k];
	    }
	  }
	  return result;
	}

	module.exports = shallowCloneObject;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var _immutable = __webpack_require__(19);

	module.exports = {
	  isEmptyArray: __webpack_require__(132),
	  isEmptyObject: __webpack_require__(133),
	  isFunction: __webpack_require__(20),
	  isImmutableCollection: __webpack_require__(134),
	  getMixedTypeValueRetriever: __webpack_require__(136),
	  isColumnsImmutable: __webpack_require__(55),
	  isImmutableMap: __webpack_require__(135),
	  last: function last(arrayOrList) {
	    if (arrayOrList == null) {
	      throw new Error('arrayOrCollection is null');
	    }

	    if (_immutable.List.isList(arrayOrList)) {
	      return arrayOrList.last();
	    }

	    if (Array.isArray(arrayOrList)) {
	      return arrayOrList[arrayOrList.length - 1];
	    }

	    throw new Error('Cant get last of: ' + (typeof arrayOrList === 'undefined' ? 'undefined' : _typeof(arrayOrList)));
	  }
	};

/***/ }),
/* 55 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = function isColumnsImmutable(columns) {
	  return typeof Immutable !== 'undefined' && columns instanceof Immutable.List;
	};

/***/ }),
/* 56 */
/***/ (function(module, exports) {

	'use strict';

	exports.__esModule = true;
	function isKeyPrintable(keycode) {
	  var valid = keycode > 47 && keycode < 58 || // number keys
	  keycode === 32 || keycode === 13 || // spacebar & return key(s) (if you want to allow carriage returns)
	  keycode > 64 && keycode < 91 || // letter keys
	  keycode > 95 && keycode < 112 || // numpad keys
	  keycode > 185 && keycode < 193 || // ;=,-./` (in order)
	  keycode > 218 && keycode < 223; // [\]' (in order)

	  return valid;
	}

	function isCtrlKeyHeldDown(e) {
	  return (e.ctrlKey === true || e.metaKey === true) && e.key !== 'Control';
	}

	exports.isKeyPrintable = isKeyPrintable;
	exports.isCtrlKeyHeldDown = isCtrlKeyHeldDown;

/***/ }),
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {

	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

	    if(ret !== void 0) {
	        return !!ret;
	    }

	    if(objA === objB) {
	        return true;
	    }

	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }

	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);

	    if(keysA.length !== keysB.length) {
	        return false;
	    }

	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {

	        var key = keysA[idx];

	        if(!bHasOwnProperty(key)) {
	            return false;
	        }

	        var valueA = objA[key];
	        var valueB = objB[key];

	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }

	    }

	    return true;

	};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(140);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(9)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../node_modules/css-loader/index.js!./react-data-grid-checkbox.css", function() {
				var newContent = require("!!../node_modules/css-loader/index.js!./react-data-grid-checkbox.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
	//     http://underscorejs.org
	//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	//     Underscore may be freely distributed under the MIT license.

	(function() {

	  // Baseline setup
	  // --------------

	  // Establish the root object, `window` in the browser, or `exports` on the server.
	  var root = this;

	  // Save the previous value of the `_` variable.
	  var previousUnderscore = root._;

	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;

	  // Create quick reference variables for speed access to core prototypes.
	  var
	    push             = ArrayProto.push,
	    slice            = ArrayProto.slice,
	    toString         = ObjProto.toString,
	    hasOwnProperty   = ObjProto.hasOwnProperty;

	  // All **ECMAScript 5** native function implementations that we hope to use
	  // are declared here.
	  var
	    nativeIsArray      = Array.isArray,
	    nativeKeys         = Object.keys,
	    nativeBind         = FuncProto.bind,
	    nativeCreate       = Object.create;

	  // Naked function reference for surrogate-prototype-swapping.
	  var Ctor = function(){};

	  // Create a safe reference to the Underscore object for use below.
	  var _ = function(obj) {
	    if (obj instanceof _) return obj;
	    if (!(this instanceof _)) return new _(obj);
	    this._wrapped = obj;
	  };

	  // Export the Underscore object for **Node.js**, with
	  // backwards-compatibility for the old `require()` API. If we're in
	  // the browser, add `_` as a global object.
	  if (true) {
	    if (typeof module !== 'undefined' && module.exports) {
	      exports = module.exports = _;
	    }
	    exports._ = _;
	  } else {
	    root._ = _;
	  }

	  // Current version.
	  _.VERSION = '1.8.3';

	  // Internal function that returns an efficient (for current engines) version
	  // of the passed-in callback, to be repeatedly applied in other Underscore
	  // functions.
	  var optimizeCb = function(func, context, argCount) {
	    if (context === void 0) return func;
	    switch (argCount == null ? 3 : argCount) {
	      case 1: return function(value) {
	        return func.call(context, value);
	      };
	      case 2: return function(value, other) {
	        return func.call(context, value, other);
	      };
	      case 3: return function(value, index, collection) {
	        return func.call(context, value, index, collection);
	      };
	      case 4: return function(accumulator, value, index, collection) {
	        return func.call(context, accumulator, value, index, collection);
	      };
	    }
	    return function() {
	      return func.apply(context, arguments);
	    };
	  };

	  // A mostly-internal function to generate callbacks that can be applied
	  // to each element in a collection, returning the desired result — either
	  // identity, an arbitrary callback, a property matcher, or a property accessor.
	  var cb = function(value, context, argCount) {
	    if (value == null) return _.identity;
	    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
	    if (_.isObject(value)) return _.matcher(value);
	    return _.property(value);
	  };
	  _.iteratee = function(value, context) {
	    return cb(value, context, Infinity);
	  };

	  // An internal function for creating assigner functions.
	  var createAssigner = function(keysFunc, undefinedOnly) {
	    return function(obj) {
	      var length = arguments.length;
	      if (length < 2 || obj == null) return obj;
	      for (var index = 1; index < length; index++) {
	        var source = arguments[index],
	            keys = keysFunc(source),
	            l = keys.length;
	        for (var i = 0; i < l; i++) {
	          var key = keys[i];
	          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
	        }
	      }
	      return obj;
	    };
	  };

	  // An internal function for creating a new object that inherits from another.
	  var baseCreate = function(prototype) {
	    if (!_.isObject(prototype)) return {};
	    if (nativeCreate) return nativeCreate(prototype);
	    Ctor.prototype = prototype;
	    var result = new Ctor;
	    Ctor.prototype = null;
	    return result;
	  };

	  var property = function(key) {
	    return function(obj) {
	      return obj == null ? void 0 : obj[key];
	    };
	  };

	  // Helper for collection methods to determine whether a collection
	  // should be iterated as an array or as an object
	  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
	  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
	  var getLength = property('length');
	  var isArrayLike = function(collection) {
	    var length = getLength(collection);
	    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
	  };

	  // Collection Functions
	  // --------------------

	  // The cornerstone, an `each` implementation, aka `forEach`.
	  // Handles raw objects in addition to array-likes. Treats all
	  // sparse array-likes as if they were dense.
	  _.each = _.forEach = function(obj, iteratee, context) {
	    iteratee = optimizeCb(iteratee, context);
	    var i, length;
	    if (isArrayLike(obj)) {
	      for (i = 0, length = obj.length; i < length; i++) {
	        iteratee(obj[i], i, obj);
	      }
	    } else {
	      var keys = _.keys(obj);
	      for (i = 0, length = keys.length; i < length; i++) {
	        iteratee(obj[keys[i]], keys[i], obj);
	      }
	    }
	    return obj;
	  };

	  // Return the results of applying the iteratee to each element.
	  _.map = _.collect = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length,
	        results = Array(length);
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      results[index] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  };

	  // Create a reducing function iterating left or right.
	  function createReduce(dir) {
	    // Optimized iterator function as using arguments.length
	    // in the main function will deoptimize the, see #1991.
	    function iterator(obj, iteratee, memo, keys, index, length) {
	      for (; index >= 0 && index < length; index += dir) {
	        var currentKey = keys ? keys[index] : index;
	        memo = iteratee(memo, obj[currentKey], currentKey, obj);
	      }
	      return memo;
	    }

	    return function(obj, iteratee, memo, context) {
	      iteratee = optimizeCb(iteratee, context, 4);
	      var keys = !isArrayLike(obj) && _.keys(obj),
	          length = (keys || obj).length,
	          index = dir > 0 ? 0 : length - 1;
	      // Determine the initial value if none is provided.
	      if (arguments.length < 3) {
	        memo = obj[keys ? keys[index] : index];
	        index += dir;
	      }
	      return iterator(obj, iteratee, memo, keys, index, length);
	    };
	  }

	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`.
	  _.reduce = _.foldl = _.inject = createReduce(1);

	  // The right-associative version of reduce, also known as `foldr`.
	  _.reduceRight = _.foldr = createReduce(-1);

	  // Return the first value which passes a truth test. Aliased as `detect`.
	  _.find = _.detect = function(obj, predicate, context) {
	    var key;
	    if (isArrayLike(obj)) {
	      key = _.findIndex(obj, predicate, context);
	    } else {
	      key = _.findKey(obj, predicate, context);
	    }
	    if (key !== void 0 && key !== -1) return obj[key];
	  };

	  // Return all the elements that pass a truth test.
	  // Aliased as `select`.
	  _.filter = _.select = function(obj, predicate, context) {
	    var results = [];
	    predicate = cb(predicate, context);
	    _.each(obj, function(value, index, list) {
	      if (predicate(value, index, list)) results.push(value);
	    });
	    return results;
	  };

	  // Return all the elements for which a truth test fails.
	  _.reject = function(obj, predicate, context) {
	    return _.filter(obj, _.negate(cb(predicate)), context);
	  };

	  // Determine whether all of the elements match a truth test.
	  // Aliased as `all`.
	  _.every = _.all = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (!predicate(obj[currentKey], currentKey, obj)) return false;
	    }
	    return true;
	  };

	  // Determine if at least one element in the object matches a truth test.
	  // Aliased as `any`.
	  _.some = _.any = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (predicate(obj[currentKey], currentKey, obj)) return true;
	    }
	    return false;
	  };

	  // Determine if the array or object contains a given item (using `===`).
	  // Aliased as `includes` and `include`.
	  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
	    if (!isArrayLike(obj)) obj = _.values(obj);
	    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
	    return _.indexOf(obj, item, fromIndex) >= 0;
	  };

	  // Invoke a method (with arguments) on every item in a collection.
	  _.invoke = function(obj, method) {
	    var args = slice.call(arguments, 2);
	    var isFunc = _.isFunction(method);
	    return _.map(obj, function(value) {
	      var func = isFunc ? method : value[method];
	      return func == null ? func : func.apply(value, args);
	    });
	  };

	  // Convenience version of a common use case of `map`: fetching a property.
	  _.pluck = function(obj, key) {
	    return _.map(obj, _.property(key));
	  };

	  // Convenience version of a common use case of `filter`: selecting only objects
	  // containing specific `key:value` pairs.
	  _.where = function(obj, attrs) {
	    return _.filter(obj, _.matcher(attrs));
	  };

	  // Convenience version of a common use case of `find`: getting the first object
	  // containing specific `key:value` pairs.
	  _.findWhere = function(obj, attrs) {
	    return _.find(obj, _.matcher(attrs));
	  };

	  // Return the maximum element (or element-based computation).
	  _.max = function(obj, iteratee, context) {
	    var result = -Infinity, lastComputed = -Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value > result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };

	  // Return the minimum element (or element-based computation).
	  _.min = function(obj, iteratee, context) {
	    var result = Infinity, lastComputed = Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value < result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed < lastComputed || computed === Infinity && result === Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };

	  // Shuffle a collection, using the modern version of the
	  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
	  _.shuffle = function(obj) {
	    var set = isArrayLike(obj) ? obj : _.values(obj);
	    var length = set.length;
	    var shuffled = Array(length);
	    for (var index = 0, rand; index < length; index++) {
	      rand = _.random(0, index);
	      if (rand !== index) shuffled[index] = shuffled[rand];
	      shuffled[rand] = set[index];
	    }
	    return shuffled;
	  };

	  // Sample **n** random values from a collection.
	  // If **n** is not specified, returns a single random element.
	  // The internal `guard` argument allows it to work with `map`.
	  _.sample = function(obj, n, guard) {
	    if (n == null || guard) {
	      if (!isArrayLike(obj)) obj = _.values(obj);
	      return obj[_.random(obj.length - 1)];
	    }
	    return _.shuffle(obj).slice(0, Math.max(0, n));
	  };

	  // Sort the object's values by a criterion produced by an iteratee.
	  _.sortBy = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    return _.pluck(_.map(obj, function(value, index, list) {
	      return {
	        value: value,
	        index: index,
	        criteria: iteratee(value, index, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index - right.index;
	    }), 'value');
	  };

	  // An internal function used for aggregate "group by" operations.
	  var group = function(behavior) {
	    return function(obj, iteratee, context) {
	      var result = {};
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index) {
	        var key = iteratee(value, index, obj);
	        behavior(result, value, key);
	      });
	      return result;
	    };
	  };

	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  _.groupBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
	  });

	  // Indexes the object's values by a criterion, similar to `groupBy`, but for
	  // when you know that your index values will be unique.
	  _.indexBy = group(function(result, value, key) {
	    result[key] = value;
	  });

	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  _.countBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key]++; else result[key] = 1;
	  });

	  // Safely create a real, live array from anything iterable.
	  _.toArray = function(obj) {
	    if (!obj) return [];
	    if (_.isArray(obj)) return slice.call(obj);
	    if (isArrayLike(obj)) return _.map(obj, _.identity);
	    return _.values(obj);
	  };

	  // Return the number of elements in an object.
	  _.size = function(obj) {
	    if (obj == null) return 0;
	    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
	  };

	  // Split a collection into two arrays: one whose elements all satisfy the given
	  // predicate, and one whose elements all do not satisfy the predicate.
	  _.partition = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var pass = [], fail = [];
	    _.each(obj, function(value, key, obj) {
	      (predicate(value, key, obj) ? pass : fail).push(value);
	    });
	    return [pass, fail];
	  };

	  // Array Functions
	  // ---------------

	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. Aliased as `head` and `take`. The **guard** check
	  // allows it to work with `_.map`.
	  _.first = _.head = _.take = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[0];
	    return _.initial(array, array.length - n);
	  };

	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N.
	  _.initial = function(array, n, guard) {
	    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
	  };

	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array.
	  _.last = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[array.length - 1];
	    return _.rest(array, Math.max(0, array.length - n));
	  };

	  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
	  // Especially useful on the arguments object. Passing an **n** will return
	  // the rest N values in the array.
	  _.rest = _.tail = _.drop = function(array, n, guard) {
	    return slice.call(array, n == null || guard ? 1 : n);
	  };

	  // Trim out all falsy values from an array.
	  _.compact = function(array) {
	    return _.filter(array, _.identity);
	  };

	  // Internal implementation of a recursive `flatten` function.
	  var flatten = function(input, shallow, strict, startIndex) {
	    var output = [], idx = 0;
	    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
	      var value = input[i];
	      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
	        //flatten current level of array or arguments object
	        if (!shallow) value = flatten(value, shallow, strict);
	        var j = 0, len = value.length;
	        output.length += len;
	        while (j < len) {
	          output[idx++] = value[j++];
	        }
	      } else if (!strict) {
	        output[idx++] = value;
	      }
	    }
	    return output;
	  };

	  // Flatten out an array, either recursively (by default), or just one level.
	  _.flatten = function(array, shallow) {
	    return flatten(array, shallow, false);
	  };

	  // Return a version of the array that does not contain the specified value(s).
	  _.without = function(array) {
	    return _.difference(array, slice.call(arguments, 1));
	  };

	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // Aliased as `unique`.
	  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
	    if (!_.isBoolean(isSorted)) {
	      context = iteratee;
	      iteratee = isSorted;
	      isSorted = false;
	    }
	    if (iteratee != null) iteratee = cb(iteratee, context);
	    var result = [];
	    var seen = [];
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var value = array[i],
	          computed = iteratee ? iteratee(value, i, array) : value;
	      if (isSorted) {
	        if (!i || seen !== computed) result.push(value);
	        seen = computed;
	      } else if (iteratee) {
	        if (!_.contains(seen, computed)) {
	          seen.push(computed);
	          result.push(value);
	        }
	      } else if (!_.contains(result, value)) {
	        result.push(value);
	      }
	    }
	    return result;
	  };

	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  _.union = function() {
	    return _.uniq(flatten(arguments, true, true));
	  };

	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  _.intersection = function(array) {
	    var result = [];
	    var argsLength = arguments.length;
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var item = array[i];
	      if (_.contains(result, item)) continue;
	      for (var j = 1; j < argsLength; j++) {
	        if (!_.contains(arguments[j], item)) break;
	      }
	      if (j === argsLength) result.push(item);
	    }
	    return result;
	  };

	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  _.difference = function(array) {
	    var rest = flatten(arguments, true, true, 1);
	    return _.filter(array, function(value){
	      return !_.contains(rest, value);
	    });
	  };

	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  _.zip = function() {
	    return _.unzip(arguments);
	  };

	  // Complement of _.zip. Unzip accepts an array of arrays and groups
	  // each array's elements on shared indices
	  _.unzip = function(array) {
	    var length = array && _.max(array, getLength).length || 0;
	    var result = Array(length);

	    for (var index = 0; index < length; index++) {
	      result[index] = _.pluck(array, index);
	    }
	    return result;
	  };

	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values.
	  _.object = function(list, values) {
	    var result = {};
	    for (var i = 0, length = getLength(list); i < length; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  };

	  // Generator function to create the findIndex and findLastIndex functions
	  function createPredicateIndexFinder(dir) {
	    return function(array, predicate, context) {
	      predicate = cb(predicate, context);
	      var length = getLength(array);
	      var index = dir > 0 ? 0 : length - 1;
	      for (; index >= 0 && index < length; index += dir) {
	        if (predicate(array[index], index, array)) return index;
	      }
	      return -1;
	    };
	  }

	  // Returns the first index on an array-like that passes a predicate test
	  _.findIndex = createPredicateIndexFinder(1);
	  _.findLastIndex = createPredicateIndexFinder(-1);

	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  _.sortedIndex = function(array, obj, iteratee, context) {
	    iteratee = cb(iteratee, context, 1);
	    var value = iteratee(obj);
	    var low = 0, high = getLength(array);
	    while (low < high) {
	      var mid = Math.floor((low + high) / 2);
	      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
	    }
	    return low;
	  };

	  // Generator function to create the indexOf and lastIndexOf functions
	  function createIndexFinder(dir, predicateFind, sortedIndex) {
	    return function(array, item, idx) {
	      var i = 0, length = getLength(array);
	      if (typeof idx == 'number') {
	        if (dir > 0) {
	            i = idx >= 0 ? idx : Math.max(idx + length, i);
	        } else {
	            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
	        }
	      } else if (sortedIndex && idx && length) {
	        idx = sortedIndex(array, item);
	        return array[idx] === item ? idx : -1;
	      }
	      if (item !== item) {
	        idx = predicateFind(slice.call(array, i, length), _.isNaN);
	        return idx >= 0 ? idx + i : -1;
	      }
	      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
	        if (array[idx] === item) return idx;
	      }
	      return -1;
	    };
	  }

	  // Return the position of the first occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
	  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](http://docs.python.org/library/functions.html#range).
	  _.range = function(start, stop, step) {
	    if (stop == null) {
	      stop = start || 0;
	      start = 0;
	    }
	    step = step || 1;

	    var length = Math.max(Math.ceil((stop - start) / step), 0);
	    var range = Array(length);

	    for (var idx = 0; idx < length; idx++, start += step) {
	      range[idx] = start;
	    }

	    return range;
	  };

	  // Function (ahem) Functions
	  // ------------------

	  // Determines whether to execute a function as a constructor
	  // or a normal function with the provided arguments
	  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
	    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
	    var self = baseCreate(sourceFunc.prototype);
	    var result = sourceFunc.apply(self, args);
	    if (_.isObject(result)) return result;
	    return self;
	  };

	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
	  // available.
	  _.bind = function(func, context) {
	    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
	    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
	    var args = slice.call(arguments, 2);
	    var bound = function() {
	      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
	    };
	    return bound;
	  };

	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context. _ acts
	  // as a placeholder, allowing any combination of arguments to be pre-filled.
	  _.partial = function(func) {
	    var boundArgs = slice.call(arguments, 1);
	    var bound = function() {
	      var position = 0, length = boundArgs.length;
	      var args = Array(length);
	      for (var i = 0; i < length; i++) {
	        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
	      }
	      while (position < arguments.length) args.push(arguments[position++]);
	      return executeBound(func, bound, this, this, args);
	    };
	    return bound;
	  };

	  // Bind a number of an object's methods to that object. Remaining arguments
	  // are the method names to be bound. Useful for ensuring that all callbacks
	  // defined on an object belong to it.
	  _.bindAll = function(obj) {
	    var i, length = arguments.length, key;
	    if (length <= 1) throw new Error('bindAll must be passed function names');
	    for (i = 1; i < length; i++) {
	      key = arguments[i];
	      obj[key] = _.bind(obj[key], obj);
	    }
	    return obj;
	  };

	  // Memoize an expensive function by storing its results.
	  _.memoize = function(func, hasher) {
	    var memoize = function(key) {
	      var cache = memoize.cache;
	      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
	      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
	      return cache[address];
	    };
	    memoize.cache = {};
	    return memoize;
	  };

	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  _.delay = function(func, wait) {
	    var args = slice.call(arguments, 2);
	    return setTimeout(function(){
	      return func.apply(null, args);
	    }, wait);
	  };

	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  _.defer = _.partial(_.delay, _, 1);

	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time. Normally, the throttled function will run
	  // as much as it can, without ever going more than once per `wait` duration;
	  // but if you'd like to disable the execution on the leading edge, pass
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.
	  _.throttle = function(func, wait, options) {
	    var context, args, result;
	    var timeout = null;
	    var previous = 0;
	    if (!options) options = {};
	    var later = function() {
	      previous = options.leading === false ? 0 : _.now();
	      timeout = null;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    };
	    return function() {
	      var now = _.now();
	      if (!previous && options.leading === false) previous = now;
	      var remaining = wait - (now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0 || remaining > wait) {
	        if (timeout) {
	          clearTimeout(timeout);
	          timeout = null;
	        }
	        previous = now;
	        result = func.apply(context, args);
	        if (!timeout) context = args = null;
	      } else if (!timeout && options.trailing !== false) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	  };

	  // Returns a function, that, as long as it continues to be invoked, will not
	  // be triggered. The function will be called after it stops being called for
	  // N milliseconds. If `immediate` is passed, trigger the function on the
	  // leading edge, instead of the trailing.
	  _.debounce = function(func, wait, immediate) {
	    var timeout, args, context, timestamp, result;

	    var later = function() {
	      var last = _.now() - timestamp;

	      if (last < wait && last >= 0) {
	        timeout = setTimeout(later, wait - last);
	      } else {
	        timeout = null;
	        if (!immediate) {
	          result = func.apply(context, args);
	          if (!timeout) context = args = null;
	        }
	      }
	    };

	    return function() {
	      context = this;
	      args = arguments;
	      timestamp = _.now();
	      var callNow = immediate && !timeout;
	      if (!timeout) timeout = setTimeout(later, wait);
	      if (callNow) {
	        result = func.apply(context, args);
	        context = args = null;
	      }

	      return result;
	    };
	  };

	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  _.wrap = function(func, wrapper) {
	    return _.partial(wrapper, func);
	  };

	  // Returns a negated version of the passed-in predicate.
	  _.negate = function(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    };
	  };

	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  _.compose = function() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function() {
	      var i = start;
	      var result = args[start].apply(this, arguments);
	      while (i--) result = args[i].call(this, result);
	      return result;
	    };
	  };

	  // Returns a function that will only be executed on and after the Nth call.
	  _.after = function(times, func) {
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  };

	  // Returns a function that will only be executed up to (but not including) the Nth call.
	  _.before = function(times, func) {
	    var memo;
	    return function() {
	      if (--times > 0) {
	        memo = func.apply(this, arguments);
	      }
	      if (times <= 1) func = null;
	      return memo;
	    };
	  };

	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  _.once = _.partial(_.before, 2);

	  // Object Functions
	  // ----------------

	  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
	  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
	                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

	  function collectNonEnumProps(obj, keys) {
	    var nonEnumIdx = nonEnumerableProps.length;
	    var constructor = obj.constructor;
	    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;

	    // Constructor is a special case.
	    var prop = 'constructor';
	    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

	    while (nonEnumIdx--) {
	      prop = nonEnumerableProps[nonEnumIdx];
	      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
	        keys.push(prop);
	      }
	    }
	  }

	  // Retrieve the names of an object's own properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`
	  _.keys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    if (nativeKeys) return nativeKeys(obj);
	    var keys = [];
	    for (var key in obj) if (_.has(obj, key)) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };

	  // Retrieve all the property names of an object.
	  _.allKeys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    var keys = [];
	    for (var key in obj) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };

	  // Retrieve the values of an object's properties.
	  _.values = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var values = Array(length);
	    for (var i = 0; i < length; i++) {
	      values[i] = obj[keys[i]];
	    }
	    return values;
	  };

	  // Returns the results of applying the iteratee to each element of the object
	  // In contrast to _.map it returns an object
	  _.mapObject = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys =  _.keys(obj),
	          length = keys.length,
	          results = {},
	          currentKey;
	      for (var index = 0; index < length; index++) {
	        currentKey = keys[index];
	        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
	      }
	      return results;
	  };

	  // Convert an object into a list of `[key, value]` pairs.
	  _.pairs = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var pairs = Array(length);
	    for (var i = 0; i < length; i++) {
	      pairs[i] = [keys[i], obj[keys[i]]];
	    }
	    return pairs;
	  };

	  // Invert the keys and values of an object. The values must be serializable.
	  _.invert = function(obj) {
	    var result = {};
	    var keys = _.keys(obj);
	    for (var i = 0, length = keys.length; i < length; i++) {
	      result[obj[keys[i]]] = keys[i];
	    }
	    return result;
	  };

	  // Return a sorted list of the function names available on the object.
	  // Aliased as `methods`
	  _.functions = _.methods = function(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (_.isFunction(obj[key])) names.push(key);
	    }
	    return names.sort();
	  };

	  // Extend a given object with all the properties in passed-in object(s).
	  _.extend = createAssigner(_.allKeys);

	  // Assigns a given object with all the own properties in the passed-in object(s)
	  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
	  _.extendOwn = _.assign = createAssigner(_.keys);

	  // Returns the first key on an object that passes a predicate test
	  _.findKey = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = _.keys(obj), key;
	    for (var i = 0, length = keys.length; i < length; i++) {
	      key = keys[i];
	      if (predicate(obj[key], key, obj)) return key;
	    }
	  };

	  // Return a copy of the object only containing the whitelisted properties.
	  _.pick = function(object, oiteratee, context) {
	    var result = {}, obj = object, iteratee, keys;
	    if (obj == null) return result;
	    if (_.isFunction(oiteratee)) {
	      keys = _.allKeys(obj);
	      iteratee = optimizeCb(oiteratee, context);
	    } else {
	      keys = flatten(arguments, false, false, 1);
	      iteratee = function(value, key, obj) { return key in obj; };
	      obj = Object(obj);
	    }
	    for (var i = 0, length = keys.length; i < length; i++) {
	      var key = keys[i];
	      var value = obj[key];
	      if (iteratee(value, key, obj)) result[key] = value;
	    }
	    return result;
	  };

	   // Return a copy of the object without the blacklisted properties.
	  _.omit = function(obj, iteratee, context) {
	    if (_.isFunction(iteratee)) {
	      iteratee = _.negate(iteratee);
	    } else {
	      var keys = _.map(flatten(arguments, false, false, 1), String);
	      iteratee = function(value, key) {
	        return !_.contains(keys, key);
	      };
	    }
	    return _.pick(obj, iteratee, context);
	  };

	  // Fill in a given object with default properties.
	  _.defaults = createAssigner(_.allKeys, true);

	  // Creates an object that inherits from the given prototype object.
	  // If additional properties are provided then they will be added to the
	  // created object.
	  _.create = function(prototype, props) {
	    var result = baseCreate(prototype);
	    if (props) _.extendOwn(result, props);
	    return result;
	  };

	  // Create a (shallow-cloned) duplicate of an object.
	  _.clone = function(obj) {
	    if (!_.isObject(obj)) return obj;
	    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
	  };

	  // Invokes interceptor with the obj, and then returns obj.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  _.tap = function(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  };

	  // Returns whether an object has a given set of `key:value` pairs.
	  _.isMatch = function(object, attrs) {
	    var keys = _.keys(attrs), length = keys.length;
	    if (object == null) return !length;
	    var obj = Object(object);
	    for (var i = 0; i < length; i++) {
	      var key = keys[i];
	      if (attrs[key] !== obj[key] || !(key in obj)) return false;
	    }
	    return true;
	  };


	  // Internal recursive comparison function for `isEqual`.
	  var eq = function(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a === 1 / b;
	    // A strict comparison is necessary because `null == undefined`.
	    if (a == null || b == null) return a === b;
	    // Unwrap any wrapped objects.
	    if (a instanceof _) a = a._wrapped;
	    if (b instanceof _) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b)) return false;
	    switch (className) {
	      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
	      case '[object RegExp]':
	      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return '' + a === '' + b;
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive.
	        // Object(NaN) is equivalent to NaN
	        if (+a !== +a) return +b !== +b;
	        // An `egal` comparison is performed for other numeric values.
	        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a === +b;
	    }

	    var areArrays = className === '[object Array]';
	    if (!areArrays) {
	      if (typeof a != 'object' || typeof b != 'object') return false;

	      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	      // from different frames are.
	      var aCtor = a.constructor, bCtor = b.constructor;
	      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
	                               _.isFunction(bCtor) && bCtor instanceof bCtor)
	                          && ('constructor' in a && 'constructor' in b)) {
	        return false;
	      }
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] === a) return bStack[length] === b;
	    }

	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);

	    // Recursively compare objects and arrays.
	    if (areArrays) {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      length = a.length;
	      if (length !== b.length) return false;
	      // Deep compare the contents, ignoring non-numeric properties.
	      while (length--) {
	        if (!eq(a[length], b[length], aStack, bStack)) return false;
	      }
	    } else {
	      // Deep compare objects.
	      var keys = _.keys(a), key;
	      length = keys.length;
	      // Ensure that both objects contain the same number of properties before comparing deep equality.
	      if (_.keys(b).length !== length) return false;
	      while (length--) {
	        // Deep compare each member
	        key = keys[length];
	        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	  };

	  // Perform a deep comparison to check if two objects are equal.
	  _.isEqual = function(a, b) {
	    return eq(a, b);
	  };

	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  _.isEmpty = function(obj) {
	    if (obj == null) return true;
	    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
	    return _.keys(obj).length === 0;
	  };

	  // Is a given value a DOM element?
	  _.isElement = function(obj) {
	    return !!(obj && obj.nodeType === 1);
	  };

	  // Is a given value an array?
	  // Delegates to ECMA5's native Array.isArray
	  _.isArray = nativeIsArray || function(obj) {
	    return toString.call(obj) === '[object Array]';
	  };

	  // Is a given variable an object?
	  _.isObject = function(obj) {
	    var type = typeof obj;
	    return type === 'function' || type === 'object' && !!obj;
	  };

	  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
	  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
	    _['is' + name] = function(obj) {
	      return toString.call(obj) === '[object ' + name + ']';
	    };
	  });

	  // Define a fallback version of the method in browsers (ahem, IE < 9), where
	  // there isn't any inspectable "Arguments" type.
	  if (!_.isArguments(arguments)) {
	    _.isArguments = function(obj) {
	      return _.has(obj, 'callee');
	    };
	  }

	  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
	  // IE 11 (#1621), and in Safari 8 (#1929).
	  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
	    _.isFunction = function(obj) {
	      return typeof obj == 'function' || false;
	    };
	  }

	  // Is a given object a finite number?
	  _.isFinite = function(obj) {
	    return isFinite(obj) && !isNaN(parseFloat(obj));
	  };

	  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
	  _.isNaN = function(obj) {
	    return _.isNumber(obj) && obj !== +obj;
	  };

	  // Is a given value a boolean?
	  _.isBoolean = function(obj) {
	    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
	  };

	  // Is a given value equal to null?
	  _.isNull = function(obj) {
	    return obj === null;
	  };

	  // Is a given variable undefined?
	  _.isUndefined = function(obj) {
	    return obj === void 0;
	  };

	  // Shortcut function for checking if an object has a given property directly
	  // on itself (in other words, not on a prototype).
	  _.has = function(obj, key) {
	    return obj != null && hasOwnProperty.call(obj, key);
	  };

	  // Utility Functions
	  // -----------------

	  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
	  // previous owner. Returns a reference to the Underscore object.
	  _.noConflict = function() {
	    root._ = previousUnderscore;
	    return this;
	  };

	  // Keep the identity function around for default iteratees.
	  _.identity = function(value) {
	    return value;
	  };

	  // Predicate-generating functions. Often useful outside of Underscore.
	  _.constant = function(value) {
	    return function() {
	      return value;
	    };
	  };

	  _.noop = function(){};

	  _.property = property;

	  // Generates a function for a given object that returns a given property.
	  _.propertyOf = function(obj) {
	    return obj == null ? function(){} : function(key) {
	      return obj[key];
	    };
	  };

	  // Returns a predicate for checking whether an object has a given set of
	  // `key:value` pairs.
	  _.matcher = _.matches = function(attrs) {
	    attrs = _.extendOwn({}, attrs);
	    return function(obj) {
	      return _.isMatch(obj, attrs);
	    };
	  };

	  // Run a function **n** times.
	  _.times = function(n, iteratee, context) {
	    var accum = Array(Math.max(0, n));
	    iteratee = optimizeCb(iteratee, context, 1);
	    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
	    return accum;
	  };

	  // Return a random integer between min and max (inclusive).
	  _.random = function(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  };

	  // A (possibly faster) way to get the current timestamp as an integer.
	  _.now = Date.now || function() {
	    return new Date().getTime();
	  };

	   // List of HTML entities for escaping.
	  var escapeMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#x27;',
	    '`': '&#x60;'
	  };
	  var unescapeMap = _.invert(escapeMap);

	  // Functions for escaping and unescaping strings to/from HTML interpolation.
	  var createEscaper = function(map) {
	    var escaper = function(match) {
	      return map[match];
	    };
	    // Regexes for identifying a key that needs to be escaped
	    var source = '(?:' + _.keys(map).join('|') + ')';
	    var testRegexp = RegExp(source);
	    var replaceRegexp = RegExp(source, 'g');
	    return function(string) {
	      string = string == null ? '' : '' + string;
	      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	    };
	  };
	  _.escape = createEscaper(escapeMap);
	  _.unescape = createEscaper(unescapeMap);

	  // If the value of the named `property` is a function then invoke it with the
	  // `object` as context; otherwise, return it.
	  _.result = function(object, property, fallback) {
	    var value = object == null ? void 0 : object[property];
	    if (value === void 0) {
	      value = fallback;
	    }
	    return _.isFunction(value) ? value.call(object) : value;
	  };

	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  _.uniqueId = function(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  };

	  // By default, Underscore uses ERB-style template delimiters, change the
	  // following template settings to use alternative delimiters.
	  _.templateSettings = {
	    evaluate    : /<%([\s\S]+?)%>/g,
	    interpolate : /<%=([\s\S]+?)%>/g,
	    escape      : /<%-([\s\S]+?)%>/g
	  };

	  // When customizing `templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;

	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'":      "'",
	    '\\':     '\\',
	    '\r':     'r',
	    '\n':     'n',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };

	  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;

	  var escapeChar = function(match) {
	    return '\\' + escapes[match];
	  };

	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  // NB: `oldSettings` only exists for backwards compatibility.
	  _.template = function(text, settings, oldSettings) {
	    if (!settings && oldSettings) settings = oldSettings;
	    settings = _.defaults({}, settings, _.templateSettings);

	    // Combine delimiters into one regular expression via alternation.
	    var matcher = RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');

	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset).replace(escaper, escapeChar);
	      index = offset + match.length;

	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      } else if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      } else if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }

	      // Adobe VMs need the match returned to produce the correct offest.
	      return match;
	    });
	    source += "';\n";

	    // If a variable is not specified, place data values in local scope.
	    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + 'return __p;\n';

	    try {
	      var render = new Function(settings.variable || 'obj', '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }

	    var template = function(data) {
	      return render.call(this, data, _);
	    };

	    // Provide the compiled source as a convenience for precompilation.
	    var argument = settings.variable || 'obj';
	    template.source = 'function(' + argument + '){\n' + source + '}';

	    return template;
	  };

	  // Add a "chain" function. Start chaining a wrapped Underscore object.
	  _.chain = function(obj) {
	    var instance = _(obj);
	    instance._chain = true;
	    return instance;
	  };

	  // OOP
	  // ---------------
	  // If Underscore is called as a function, it returns a wrapped object that
	  // can be used OO-style. This wrapper holds altered versions of all the
	  // underscore functions. Wrapped objects may be chained.

	  // Helper function to continue chaining intermediate results.
	  var result = function(instance, obj) {
	    return instance._chain ? _(obj).chain() : obj;
	  };

	  // Add your own custom functions to the Underscore object.
	  _.mixin = function(obj) {
	    _.each(_.functions(obj), function(name) {
	      var func = _[name] = obj[name];
	      _.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return result(this, func.apply(_, args));
	      };
	    });
	  };

	  // Add all of the Underscore functions to the wrapper object.
	  _.mixin(_);

	  // Add all mutator Array functions to the wrapper.
	  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      var obj = this._wrapped;
	      method.apply(obj, arguments);
	      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
	      return result(this, obj);
	    };
	  });

	  // Add all accessor Array functions to the wrapper.
	  _.each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      return result(this, method.apply(this._wrapped, arguments));
	    };
	  });

	  // Extracts the result from a wrapped and chained object.
	  _.prototype.value = function() {
	    return this._wrapped;
	  };

	  // Provide unwrapping proxy for some methods used in engine operations
	  // such as arithmetic and JSON stringification.
	  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

	  _.prototype.toString = function() {
	    return '' + this._wrapped;
	  };

	  // AMD registration happens at the end for compatibility with AMD loaders
	  // that may not enforce next-turn semantics on modules. Even though general
	  // practice for AMD registration is to be anonymous, underscore registers
	  // as a named module because, like jQuery, it is a base library that is
	  // popular enough to be bundled in a third party lib, but not be part of
	  // an AMD load request. Those cases could generate an error when an
	  // anonymous define() is called outside of a loader request.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	}.call(this));


/***/ }),
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _propTypes = __webpack_require__(3);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	var _scrollUtils = __webpack_require__(137);

	var _shallowequal = __webpack_require__(70);

	var _shallowequal2 = _interopRequireDefault(_shallowequal);

	var _RowsContainer = __webpack_require__(46);

	var _RowsContainer2 = _interopRequireDefault(_RowsContainer);

	var _RowGroup = __webpack_require__(122);

	var _RowGroup2 = _interopRequireDefault(_RowGroup);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var React = __webpack_require__(2);
	var joinClasses = __webpack_require__(6);

	var Row = __webpack_require__(43);
	var cellMetaDataShape = __webpack_require__(12);
	var RowUtils = __webpack_require__(45);

	__webpack_require__(21);

	var Canvas = function (_React$Component) {
	  _inherits(Canvas, _React$Component);

	  function Canvas() {
	    var _temp, _this, _ret;

	    _classCallCheck(this, Canvas);

	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }

	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      displayStart: _this.props.displayStart,
	      displayEnd: _this.props.displayEnd,
	      scrollingTimeout: null
	    }, _this._currentRowsLength = 0, _this._currentRowsRange = { start: 0, end: 0 }, _this._scroll = { scrollTop: 0, scrollLeft: 0 }, _this.appendScrollShim = function () {
	      if (!_this._scrollShim) {
	        var size = _this._scrollShimSize();
	        var shim = (0, _scrollUtils.createScrollShim)(size);
	        _this.canvas.appendChild(shim);
	        _this._scrollShim = shim;
	      }
	      _this._scheduleRemoveScrollShim();
	    }, _this._scrollShimSize = function () {
	      return {
	        width: _this.props.width,
	        height: _this.props.length * _this.props.rowHeight
	      };
	    }, _this._scheduleRemoveScrollShim = function () {
	      if (_this._scheduleRemoveScrollShimTimer) {
	        clearTimeout(_this._scheduleRemoveScrollShimTimer);
	      }
	      _this._scheduleRemoveScrollShimTimer = setTimeout(_this._removeScrollShim, 200);
	    }, _this._removeScrollShim = function () {
	      if (_this._scrollShim) {
	        _this._scrollShim.parentNode.removeChild(_this._scrollShim);
	        _this._scrollShim = undefined;
	      }
	    }, _this.onRows = function () {
	      if (_this._currentRowsRange !== { start: 0, end: 0 }) {
	        _this.props.onRows(_this._currentRowsRange);
	        _this._currentRowsRange = { start: 0, end: 0 };
	      }
	    }, _this.onScroll = function (e) {
	      if (_this.canvas !== e.target) {
	        return;
	      }
	      _this.appendScrollShim();
	      var scrollLeft = e.target.scrollLeft;
	      var scrollTop = e.target.scrollTop;
	      var scroll = { scrollTop: scrollTop, scrollLeft: scrollLeft };
	      _this._scroll = scroll;
	      _this.props.onScroll(scroll);
	    }, _this.getRows = function (displayStart, displayEnd) {
	      _this._currentRowsRange = { start: displayStart, end: displayEnd };
	      if (Array.isArray(_this.props.rowGetter)) {
	        return _this.props.rowGetter.slice(displayStart, displayEnd);
	      }
	      var rows = [];
	      var i = displayStart;
	      while (i < displayEnd) {
	        var row = _this.props.rowGetter(i);
	        var subRowDetails = {};
	        if (_this.props.getSubRowDetails) {
	          subRowDetails = _this.props.getSubRowDetails(row);
	        }
	        rows.push({ row: row, subRowDetails: subRowDetails });
	        i++;
	      }
	      return rows;
	    }, _this.getScrollbarWidth = function () {
	      // Get the scrollbar width
	      var scrollbarWidth = _this.canvas.offsetWidth - _this.canvas.clientWidth;
	      return scrollbarWidth;
	    }, _this.getScroll = function () {
	      var _this$canvas = _this.canvas,
	          scrollTop = _this$canvas.scrollTop,
	          scrollLeft = _this$canvas.scrollLeft;

	      return { scrollTop: scrollTop, scrollLeft: scrollLeft };
	    }, _this.isRowSelected = function (idx, row) {
	      // Use selectedRows if set
	      if (_this.props.selectedRows !== null) {
	        var selectedRows = _this.props.selectedRows.filter(function (r) {
	          var rowKeyValue = row.get ? row.get(_this.props.rowKey) : row[_this.props.rowKey];
	          return r[_this.props.rowKey] === rowKeyValue;
	        });
	        return selectedRows.length > 0 && selectedRows[0].isSelected;
	      }

	      // Else use new rowSelection props
	      if (_this.props.rowSelection) {
	        var _this$props$rowSelect = _this.props.rowSelection,
	            keys = _this$props$rowSelect.keys,
	            indexes = _this$props$rowSelect.indexes,
	            isSelectedKey = _this$props$rowSelect.isSelectedKey;

	        return RowUtils.isRowSelected(keys, indexes, isSelectedKey, row, idx);
	      }

	      return false;
	    }, _this.setScrollLeft = function (scrollLeft) {
	      if (_this._currentRowsLength !== 0) {
	        if (!_this.rows) return;
	        for (var i = 0, len = _this._currentRowsLength; i < len; i++) {
	          if (_this.rows[i]) {
	            var row = _this.getRowByRef(i);
	            if (row && row.setScrollLeft) {
	              row.setScrollLeft(scrollLeft);
	            }
	          }
	        }
	      }
	    }, _this.getRowByRef = function (i) {
	      // check if wrapped with React DND drop target
	      var wrappedRow = _this.rows[i].getDecoratedComponentInstance ? _this.rows[i].getDecoratedComponentInstance(i) : null;
	      if (wrappedRow) {
	        return wrappedRow.row;
	      }
	      return _this.rows[i];
	    }, _this.renderRow = function (props) {
	      var row = props.row;
	      if (row.__metaData && row.__metaData.getRowRenderer) {
	        return row.__metaData.getRowRenderer(_this.props, props.idx);
	      }
	      if (row.__metaData && row.__metaData.isGroup) {
	        return React.createElement(_RowGroup2['default'], _extends({}, props, row.__metaData, {
	          name: row.name,
	          renderer: _this.props.rowGroupRenderer }));
	      }
	      var RowsRenderer = _this.props.rowRenderer;
	      if (typeof RowsRenderer === 'function') {
	        return React.createElement(RowsRenderer, props);
	      }

	      if (React.isValidElement(_this.props.rowRenderer)) {
	        return React.cloneElement(_this.props.rowRenderer, props);
	      }
	    }, _this.renderPlaceholder = function (key, height) {
	      // just renders empty cells
	      // if we wanted to show gridlines, we'd need classes and position as with renderScrollingPlaceholder
	      return React.createElement(
	        'div',
	        { key: key, style: { height: height } },
	        _this.props.columns.map(function (column, idx) {
	          return React.createElement('div', { style: { width: column.width }, key: idx });
	        })
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }

	  Canvas.prototype.componentWillMount = function componentWillMount() {
	    this.rows = [];
	    this._currentRowsLength = 0;
	    this._currentRowsRange = { start: 0, end: 0 };
	    this._scroll = { scrollTop: 0, scrollLeft: 0 };
	  };

	  Canvas.prototype.componentDidMount = function componentDidMount() {
	    this.onRows();
	  };

	  Canvas.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.displayStart !== this.state.displayStart || nextProps.displayEnd !== this.state.displayEnd) {
	      this.setState({
	        displayStart: nextProps.displayStart,
	        displayEnd: nextProps.displayEnd
	      });
	    }
	  };

	  Canvas.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	    var shouldUpdate = nextState.displayStart !== this.state.displayStart || nextState.displayEnd !== this.state.displayEnd || nextState.scrollingTimeout !== this.state.scrollingTimeout || this.props.scrollToRowIndex !== nextProps.scrollToRowIndex || nextProps.rowsCount !== this.props.rowsCount || nextProps.rowHeight !== this.props.rowHeight || nextProps.columns !== this.props.columns || nextProps.width !== this.props.width || nextProps.height !== this.props.height || nextProps.cellMetaData !== this.props.cellMetaData || this.props.colDisplayStart !== nextProps.colDisplayStart || this.props.colDisplayEnd !== nextProps.colDisplayEnd || this.props.colVisibleStart !== nextProps.colVisibleStart || this.props.colVisibleEnd !== nextProps.colVisibleEnd || !(0, _shallowequal2['default'])(nextProps.style, this.props.style) || this.props.isScrolling !== nextProps.isScrolling;
	    return shouldUpdate;
	  };

	  Canvas.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._currentRowsLength = 0;
	    this._currentRowsRange = { start: 0, end: 0 };
	    this._scroll = { scrollTop: 0, scrollLeft: 0 };
	  };

	  Canvas.prototype.componentDidUpdate = function componentDidUpdate() {
	    if (this._scroll.scrollTop !== 0 && this._scroll.scrollLeft !== 0) {
	      this.setScrollLeft(this._scroll.scrollLeft);
	    }
	    if (this.props.scrollToRowIndex !== 0) {
	      this.canvas.scrollTop = Math.min(this.props.scrollToRowIndex * this.props.rowHeight, this.props.rowsCount * this.props.rowHeight - this.props.height);
	    }
	    this.onRows();
	  };

	  Canvas.prototype.render = function render() {
	    var _this2 = this;

	    var _state = this.state,
	        displayStart = _state.displayStart,
	        displayEnd = _state.displayEnd;
	    var _props = this.props,
	        rowHeight = _props.rowHeight,
	        rowsCount = _props.rowsCount;


	    var rows = this.getRows(displayStart, displayEnd).map(function (r, idx) {
	      return _this2.renderRow({
	        key: 'row-' + (displayStart + idx),
	        ref: function ref(node) {
	          return _this2.rows[idx] = node;
	        },
	        idx: displayStart + idx,
	        visibleStart: _this2.props.visibleStart,
	        visibleEnd: _this2.props.visibleEnd,
	        row: r.row,
	        height: rowHeight,
	        onMouseOver: _this2.onMouseOver,
	        columns: _this2.props.columns,
	        isSelected: _this2.isRowSelected(displayStart + idx, r.row, displayStart, displayEnd),
	        expandedRows: _this2.props.expandedRows,
	        cellMetaData: _this2.props.cellMetaData,
	        subRowDetails: r.subRowDetails,
	        colVisibleStart: _this2.props.colVisibleStart,
	        colVisibleEnd: _this2.props.colVisibleEnd,
	        colDisplayStart: _this2.props.colDisplayStart,
	        colDisplayEnd: _this2.props.colDisplayEnd,
	        isScrolling: _this2.props.isScrolling
	      });
	    });

	    this._currentRowsLength = rows.length;

	    if (displayStart > 0) {
	      rows.unshift(this.renderPlaceholder('top', displayStart * rowHeight));
	    }

	    if (rowsCount - displayEnd > 0) {
	      rows.push(this.renderPlaceholder('bottom', (rowsCount - displayEnd) * rowHeight));
	    }

	    var style = {
	      position: 'absolute',
	      top: 0,
	      left: 0,
	      overflowX: 'auto',
	      overflowY: 'scroll',
	      width: this.props.totalWidth,
	      height: this.props.height
	    };

	    return React.createElement(
	      'div',
	      {
	        ref: function ref(div) {
	          _this2.canvas = div;
	        },
	        style: style,
	        onScroll: this.onScroll,
	        className: joinClasses('react-grid-Canvas', this.props.className, { opaque: this.props.cellMetaData.selected && this.props.cellMetaData.selected.active }) },
	      React.createElement(_RowsContainer2['default'], {
	        width: this.props.width,
	        rows: rows,
	        contextMenu: this.props.contextMenu,
	        rowIdx: this.props.cellMetaData.selected.rowIdx,
	        idx: this.props.cellMetaData.selected.idx })
	    );
	  };

	  return Canvas;
	}(React.Component);

	Canvas.displayName = 'Canvas';
	Canvas.propTypes = {
	  rowRenderer: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].element]),
	  rowHeight: _propTypes2['default'].number.isRequired,
	  height: _propTypes2['default'].number.isRequired,
	  width: _propTypes2['default'].number,
	  totalWidth: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  style: _propTypes2['default'].string,
	  className: _propTypes2['default'].string,
	  displayStart: _propTypes2['default'].number.isRequired,
	  displayEnd: _propTypes2['default'].number.isRequired,
	  visibleStart: _propTypes2['default'].number.isRequired,
	  visibleEnd: _propTypes2['default'].number.isRequired,
	  colVisibleStart: _propTypes2['default'].number.isRequired,
	  colVisibleEnd: _propTypes2['default'].number.isRequired,
	  colDisplayStart: _propTypes2['default'].number.isRequired,
	  colDisplayEnd: _propTypes2['default'].number.isRequired,
	  rowsCount: _propTypes2['default'].number.isRequired,
	  rowGetter: _propTypes2['default'].oneOfType([_propTypes2['default'].func.isRequired, _propTypes2['default'].array.isRequired]),
	  expandedRows: _propTypes2['default'].array,
	  onRows: _propTypes2['default'].func,
	  onScroll: _propTypes2['default'].func,
	  columns: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].array]).isRequired,
	  cellMetaData: _propTypes2['default'].shape(cellMetaDataShape).isRequired,
	  selectedRows: _propTypes2['default'].array,
	  rowKey: _propTypes2['default'].string,
	  rowScrollTimeout: _propTypes2['default'].number,
	  scrollToRowIndex: _propTypes2['default'].number,
	  contextMenu: _propTypes2['default'].element,
	  getSubRowDetails: _propTypes2['default'].func,
	  rowSelection: _propTypes2['default'].oneOfType([_propTypes2['default'].shape({
	    indexes: _propTypes2['default'].arrayOf(_propTypes2['default'].number).isRequired
	  }), _propTypes2['default'].shape({
	    isSelectedKey: _propTypes2['default'].string.isRequired
	  }), _propTypes2['default'].shape({
	    keys: _propTypes2['default'].shape({
	      values: _propTypes2['default'].array.isRequired,
	      rowKey: _propTypes2['default'].string.isRequired
	    }).isRequired
	  })]),
	  rowGroupRenderer: _propTypes2['default'].func,
	  isScrolling: _propTypes2['default'].bool,
	  length: _propTypes2['default'].number
	};
	Canvas.defaultProps = {
	  rowRenderer: Row,
	  onRows: function onRows() {},
	  selectedRows: [],
	  rowScrollTimeout: 0
	};


	module.exports = Canvas;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _classnames = __webpack_require__(6);

	var _classnames2 = _interopRequireDefault(_classnames);

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _propTypes = __webpack_require__(3);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	var _CellActionShape = __webpack_require__(118);

	var _CellActionShape2 = _interopRequireDefault(_CellActionShape);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var CellAction = function (_React$Component) {
	  _inherits(CellAction, _React$Component);

	  function CellAction() {
	    var _temp, _this, _ret;

	    _classCallCheck(this, CellAction);

	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }

	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = { isMenuOpen: false }, _this.onToggleMenu = function () {
	      _this.setState(function (prevState) {
	        return { isMenuOpen: !prevState.isMenuOpen };
	      });
	    }, _this.onHideMenu = function () {
	      _this.setState({ isMenuOpen: false });
	    }, _this.onGetMenuOptions = function () {
	      return _this.props.action.actions.map(function (action, index) {
	        return _react2['default'].createElement(
	          'span',
	          { key: index, onClick: action.callback },
	          action.text
	        );
	      });
	    }, _this.isActionMenu = function () {
	      return !_this.props.action.callback && _this.props.action.actions && _this.props.action.actions.length;
	    }, _this.onActionButtonBlur = function () {
	      if (_this.isActionMenu()) {
	        _this.onHideMenu();
	      }
	    }, _this.onActionIconClick = function () {
	      if (!_this.isActionMenu()) {
	        _this.props.action.callback();
	      } else if (_this.props.action.actions && _this.props.action.actions.length) {
	        _this.onToggleMenu();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }

	  CellAction.prototype.render = function render() {
	    var isActionMenu = this.isActionMenu();

	    var cellActionClasses = (0, _classnames2['default'])('rdg-cell-action', {
	      'rdg-cell-action-last': this.props.isFirst
	    });

	    var actionButtonClasses = (0, _classnames2['default'])('rdg-cell-action-button', {
	      'rdg-cell-action-button-toggled': this.state.isMenuOpen
	    });

	    return _react2['default'].createElement(
	      'div',
	      { className: cellActionClasses, onMouseLeave: this.onActionButtonBlur },
	      _react2['default'].createElement(
	        'div',
	        { className: actionButtonClasses, onClick: this.onActionIconClick },
	        _react2['default'].createElement('span', { className: this.props.action.icon })
	      ),
	      isActionMenu && this.state.isMenuOpen && _react2['default'].createElement(
	        'div',
	        { className: 'rdg-cell-action-menu' },
	        this.onGetMenuOptions()
	      )
	    );
	  };

	  return CellAction;
	}(_react2['default'].Component);

	CellAction.propTypes = {
	  action: _propTypes2['default'].shape(_CellActionShape2['default']).isRequired,
	  isFirst: _propTypes2['default'].bool.isRequired
	};
	exports['default'] = CellAction;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _propTypes = __webpack_require__(3);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	var _AppConstants = __webpack_require__(31);

	var _AppConstants2 = _interopRequireDefault(_AppConstants);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var CellExpand = function (_React$Component) {
	  _inherits(CellExpand, _React$Component);

	  function CellExpand(props) {
	    _classCallCheck(this, CellExpand);

	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

	    _this.onCellExpand = function (e) {
	      _this.setState({ expanded: !_this.state.expanded });
	      _this.props.onCellExpand(e);
	    };

	    var expanded = props.expandableOptions && props.expandableOptions.expanded;
	    _this.state = { expanded: expanded };
	    return _this;
	  }

	  CellExpand.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var expanded = nextProps.expandableOptions && nextProps.expandableOptions.expanded;
	    if (this.state.expanded !== expanded) {
	      this.setState({ expanded: expanded });
	    }
	  };

	  CellExpand.prototype.render = function render() {
	    return _react2['default'].createElement(
	      'span',
	      { className: 'rdg-cell-expand', onClick: this.onCellExpand },
	      this.state.expanded ? _AppConstants2['default'].CellExpand.DOWN_TRIANGLE : _AppConstants2['default'].CellExpand.RIGHT_TRIANGLE
	    );
	  };

	  return CellExpand;
	}(_react2['default'].Component);

	CellExpand.propTypes = {
	  expandableOptions: _propTypes2['default'].object.isRequired,
	  onCellExpand: _propTypes2['default'].func.isRequired
	};
	exports['default'] = CellExpand;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _classnames = __webpack_require__(6);

	var _classnames2 = _interopRequireDefault(_classnames);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	var ChildRowDeleteButton = function ChildRowDeleteButton(_ref) {
	  var treeDepth = _ref.treeDepth,
	      cellHeight = _ref.cellHeight,
	      siblingIndex = _ref.siblingIndex,
	      numberSiblings = _ref.numberSiblings,
	      onDeleteSubRow = _ref.onDeleteSubRow,
	      isDeleteSubRowEnabled = _ref.isDeleteSubRowEnabled,
	      _ref$allowAddChildRow = _ref.allowAddChildRow,
	      allowAddChildRow = _ref$allowAddChildRow === undefined ? true : _ref$allowAddChildRow;

	  var lastSibling = siblingIndex === numberSiblings - 1;
	  var className = (0, _classnames2['default'])({ 'rdg-child-row-action-cross': allowAddChildRow === true || !lastSibling }, { 'rdg-child-row-action-cross-last': allowAddChildRow === false && (lastSibling || numberSiblings === 1) });
	  var height = 12;
	  var width = 12;
	  var left = treeDepth * 15;
	  var top = (cellHeight - 12) / 2;
	  return _react2['default'].createElement(
	    'div',
	    null,
	    _react2['default'].createElement('div', { className: className }),
	    isDeleteSubRowEnabled && _react2['default'].createElement(
	      'div',
	      { style: { left: left, top: top, width: width, height: height }, className: 'rdg-child-row-btn', onClick: onDeleteSubRow },
	      _react2['default'].createElement('div', { className: 'glyphicon glyphicon-remove-sign' })
	    )
	  );
	};

	exports['default'] = ChildRowDeleteButton;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var isValidElement = __webpack_require__(2).isValidElement;

	module.exports = function sameColumn(a, b) {
	  var k = void 0;

	  for (k in a) {
	    if (a.hasOwnProperty(k)) {
	      if (typeof a[k] === 'function' && typeof b[k] === 'function' || isValidElement(a[k]) && isValidElement(b[k])) {
	        continue;
	      }
	      if (!b.hasOwnProperty(k) || a[k] !== b[k]) {
	        return false;
	      }
	    }
	  }

	  for (k in b) {
	    if (b.hasOwnProperty(k) && !a.hasOwnProperty(k)) {
	      return false;
	    }
	  }

	  return true;
	};

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _propTypes = __webpack_require__(3);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var React = __webpack_require__(2);

	var createObjectWithProperties = __webpack_require__(15);
	__webpack_require__(16);

	// The list of the propTypes that we want to include in the Draggable div
	var knownDivPropertyKeys = ['onDragStart', 'onDragEnd', 'onDrag', 'style'];

	var Draggable = function (_React$Component) {
	  _inherits(Draggable, _React$Component);

	  function Draggable() {
	    var _temp, _this, _ret;

	    _classCallCheck(this, Draggable);

	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }

	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      drag: null
	    }, _this.onMouseDown = function (e) {
	      var drag = _this.props.onDragStart(e);
	      if (e.preventDefault) {
	        e.preventDefault();
	      }

	      if (drag === null && e.button !== 0) {
	        return;
	      }

	      window.addEventListener('mouseup', _this.onMouseUp);
	      window.addEventListener('mousemove', _this.onMouseMove);
	      window.addEventListener('touchend', _this.onMouseUp);
	      window.addEventListener('touchmove', _this.onMouseMove);

	      _this.setState({ drag: drag });
	    }, _this.onMouseMove = function (e) {
	      if (_this.state.drag === null) {
	        return;
	      }

	      if (e.preventDefault) {
	        e.preventDefault();
	      }

	      _this.props.onDrag(e);
	    }, _this.onMouseUp = function (e) {
	      _this.cleanUp();
	      _this.props.onDragEnd(e, _this.state.drag);
	      _this.setState({ drag: null });
	    }, _this.cleanUp = function () {
	      window.removeEventListener('mouseup', _this.onMouseUp);
	      window.removeEventListener('mousemove', _this.onMouseMove);
	      window.removeEventListener('touchend', _this.onMouseUp);
	      window.removeEventListener('touchmove', _this.onMouseMove);
	    }, _this.getKnownDivProps = function () {
	      return createObjectWithProperties(_this.props, knownDivPropertyKeys);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }

	  Draggable.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.cleanUp();
	  };

	  Draggable.prototype.render = function render() {
	    return React.createElement('div', _extends({}, this.getKnownDivProps(), {
	      onMouseDown: this.onMouseDown,
	      onTouchStart: this.onMouseDown,
	      className: 'react-grid-HeaderCell__draggable' }));
	  };

	  return Draggable;
	}(React.Component);

	Draggable.propTypes = {
	  onDragStart: _propTypes2['default'].func,
	  onDragEnd: _propTypes2['default'].func,
	  onDrag: _propTypes2['default'].func,
	  component: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].constructor]),
	  style: _propTypes2['default'].object
	};
	Draggable.defaultProps = {
	  onDragStart: function onDragStart() {
	    return true;
	  },
	  onDragEnd: function onDragEnd() {},
	  onDrag: function onDrag() {}
	};


	module.exports = Draggable;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _propTypes = __webpack_require__(3);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	var _ColumnUtils = __webpack_require__(7);

	var _ColumnUtils2 = _interopRequireDefault(_ColumnUtils);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var EmptyChildRow = function (_React$Component) {
	  _inherits(EmptyChildRow, _React$Component);

	  function EmptyChildRow() {
	    _classCallCheck(this, EmptyChildRow);

	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));

	    _this.onAddSubRow = _this.onAddSubRow.bind(_this);
	    return _this;
	  }

	  EmptyChildRow.prototype.onAddSubRow = function onAddSubRow() {
	    this.props.onAddSubRow(this.props.parentRowId);
	  };

	  EmptyChildRow.prototype.getFixedColumnsWidth = function getFixedColumnsWidth() {
	    var fixedWidth = 0;
	    var size = _ColumnUtils2['default'].getSize(this.props.columns);
	    for (var i = 0; i < size; i++) {
	      var column = _ColumnUtils2['default'].getColumn(this.props.columns, i);
	      if (column) {
	        if (_ColumnUtils2['default'].getValue(column, 'locked')) {
	          fixedWidth += _ColumnUtils2['default'].getValue(column, 'width');
	        }
	      }
	    }
	    return fixedWidth;
	  };

	  EmptyChildRow.prototype.render = function render() {
	    var _this2 = this;

	    var _props = this.props,
	        cellHeight = _props.cellHeight,
	        treeDepth = _props.treeDepth;

	    var height = 12;
	    var width = 12;
	    var left = treeDepth * 15;
	    var top = (cellHeight - 12) / 2;
	    var style = {
	      height: cellHeight,
	      borderBottom: '1px solid #dddddd'
	    };
	    var expandColumn = _ColumnUtils2['default'].getColumn(this.props.columns.filter(function (c) {
	      return c.key === _this2.props.expandColumnKey;
	    }), 0);

	    var cellLeft = expandColumn ? expandColumn.left : 0;
	    return _react2['default'].createElement(
	      'div',
	      { className: 'react-grid-Row rdg-add-child-row-container', style: style },
	      _react2['default'].createElement(
	        'div',
	        { className: 'react-grid-Cell', style: { position: 'absolute', height: cellHeight, width: '100%', left: cellLeft } },
	        _react2['default'].createElement(
	          'div',
	          { className: 'rdg-empty-child-row', style: { marginLeft: '30px', lineHeight: cellHeight + 'px' } },
	          _react2['default'].createElement('div', { className: '\'rdg-child-row-action-cross rdg-child-row-action-cross-last' }),
	          _react2['default'].createElement(
	            'div',
	            { style: { left: left, top: top, width: width, height: height }, className: 'rdg-child-row-btn', onClick: this.onAddSubRow },
	            _react2['default'].createElement('div', { className: 'glyphicon glyphicon-plus-sign' })
	          )
	        )
	      )
	    );
	  };

	  return EmptyChildRow;
	}(_react2['default'].Component);

	EmptyChildRow.propTypes = {
	  treeDepth: _propTypes2['default'].number.isRequired,
	  cellHeight: _propTypes2['default'].number.isRequired,
	  onAddSubRow: _propTypes2['default'].func.isRequired,
	  parentRowId: _propTypes2['default'].number,
	  columns: _propTypes2['default'].array.isRequired,
	  expandColumnKey: _propTypes2['default'].string.isRequired
	};

	exports['default'] = EmptyChildRow;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _propTypes = __webpack_require__(3);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var React = __webpack_require__(2);
	var ReactDOM = __webpack_require__(10);

	var Header = __webpack_require__(113);
	var Viewport = __webpack_require__(123);
	var cellMetaDataShape = __webpack_require__(12);
	__webpack_require__(21);

	var Grid = function (_React$Component) {
	  _inherits(Grid, _React$Component);

	  function Grid() {
	    var _temp, _this, _ret;

	    _classCallCheck(this, Grid);

	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }

	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.getStyle = function () {
	      return {
	        overflow: 'hidden',
	        outline: 0,
	        position: 'relative',
	        minHeight: _this.props.minHeight
	      };
	    }, _this._onScroll = function () {
	      if (_this._scrollLeft !== undefined) {
	        _this.header.setScrollLeft(_this._scrollLeft);
	        if (_this.viewport) {
	          _this.viewport.setScrollLeft(_this._scrollLeft);
	        }
	      }
	    }, _this.onScroll = function (props) {
	      if (_this._scrollLeft !== props.scrollLeft) {
	        _this._scrollLeft = props.scrollLeft;
	        _this._onScroll();
	      }
	    }, _this.onHeaderScroll = function (e) {
	      var scrollLeft = e.target.scrollLeft;
	      if (_this._scrollLeft !== scrollLeft) {
	        _this._scrollLeft = scrollLeft;
	        _this.header.setScrollLeft(scrollLeft);
	        var canvas = ReactDOM.findDOMNode(_this.viewport.canvas);
	        canvas.scrollLeft = scrollLeft;
	        _this.viewport.canvas.setScrollLeft(scrollLeft);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }

	  Grid.prototype.componentDidMount = function componentDidMount() {
	    this._scrollLeft = this.viewport ? this.viewport.getScroll().scrollLeft : 0;
	    this._onScroll();
	  };

	  Grid.prototype.componentDidUpdate = function componentDidUpdate() {
	    this._onScroll();
	  };

	  Grid.prototype.componentWillMount = function componentWillMount() {
	    this._scrollLeft = undefined;
	  };

	  Grid.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._scrollLeft = undefined;
	  };

	  Grid.prototype.render = function render() {
	    var _this2 = this;

	    var headerRows = this.props.headerRows || [{ ref: function ref(node) {
	        return _this2.row = node;
	      } }];
	    var EmptyRowsView = this.props.emptyRowsView;

	    return React.createElement(
	      'div',
	      { style: this.getStyle(), className: 'react-grid-Grid' },
	      React.createElement(Header, {
	        ref: function ref(input) {
	          _this2.header = input;
	        },
	        columnMetrics: this.props.columnMetrics,
	        onColumnResize: this.props.onColumnResize,
	        height: this.props.rowHeight,
	        totalWidth: this.props.totalWidth,
	        headerRows: headerRows,
	        sortColumn: this.props.sortColumn,
	        sortDirection: this.props.sortDirection,
	        draggableHeaderCell: this.props.draggableHeaderCell,
	        onSort: this.props.onSort,
	        onHeaderDrop: this.props.onHeaderDrop,
	        onScroll: this.onHeaderScroll,
	        getValidFilterValues: this.props.getValidFilterValues,
	        cellMetaData: this.props.cellMetaData
	      }),
	      this.props.rowsCount >= 1 || this.props.rowsCount === 0 && !this.props.emptyRowsView ? React.createElement(
	        'div',
	        {
	          ref: function ref(node) {
	            _this2.viewPortContainer = node;
	          },
	          tabIndex: this.props.tabIndex,
	          onKeyDown: this.props.onViewportKeydown,
	          onKeyUp: this.props.onViewportKeyup,
	          onClick: this.props.onViewportClick,
	          onDoubleClick: this.props.onViewportDoubleClick,
	          onDragStart: this.props.onViewportDragStart,
	          onDragEnd: this.props.onViewportDragEnd },
	        React.createElement(Viewport, {
	          ref: function ref(node) {
	            _this2.viewport = node;
	          },
	          rowKey: this.props.rowKey,
	          width: this.props.columnMetrics.width,
	          rowHeight: this.props.rowHeight,
	          rowRenderer: this.props.rowRenderer,
	          rowGetter: this.props.rowGetter,
	          rowsCount: this.props.rowsCount,
	          selectedRows: this.props.selectedRows,
	          expandedRows: this.props.expandedRows,
	          columnMetrics: this.props.columnMetrics,
	          totalWidth: this.props.totalWidth,
	          onScroll: this.onScroll,
	          onRows: this.props.onRows,
	          cellMetaData: this.props.cellMetaData,
	          rowOffsetHeight: this.props.rowOffsetHeight || this.props.rowHeight * headerRows.length,
	          minHeight: this.props.minHeight,
	          rowScrollTimeout: this.props.rowScrollTimeout,
	          scrollToRowIndex: this.props.scrollToRowIndex,
	          contextMenu: this.props.contextMenu,
	          rowSelection: this.props.rowSelection,
	          getSubRowDetails: this.props.getSubRowDetails,
	          rowGroupRenderer: this.props.rowGroupRenderer,
	          overScan: this.props.overScan
	        })
	      ) : React.createElement(
	        'div',
	        { ref: function ref(node) {
	            _this2.emptyView = node;
	          }, className: 'react-grid-Empty' },
	        React.createElement(EmptyRowsView, null)
	      )
	    );
	  };

	  return Grid;
	}(React.Component);

	Grid.displayName = 'Grid';
	Grid.propTypes = {
	  rowGetter: _propTypes2['default'].oneOfType([_propTypes2['default'].array, _propTypes2['default'].func]).isRequired,
	  columns: _propTypes2['default'].oneOfType([_propTypes2['default'].array, _propTypes2['default'].object]),
	  tabIndex: _propTypes2['default'].number,
	  columnMetrics: _propTypes2['default'].object,
	  minHeight: _propTypes2['default'].number,
	  totalWidth: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  headerRows: _propTypes2['default'].oneOfType([_propTypes2['default'].array, _propTypes2['default'].func]),
	  rowHeight: _propTypes2['default'].number,
	  rowRenderer: _propTypes2['default'].oneOfType([_propTypes2['default'].element, _propTypes2['default'].func]),
	  emptyRowsView: _propTypes2['default'].func,
	  expandedRows: _propTypes2['default'].oneOfType([_propTypes2['default'].array, _propTypes2['default'].func]),
	  selectedRows: _propTypes2['default'].oneOfType([_propTypes2['default'].array, _propTypes2['default'].func]),
	  rowSelection: _propTypes2['default'].oneOfType([_propTypes2['default'].shape({
	    indexes: _propTypes2['default'].arrayOf(_propTypes2['default'].number).isRequired
	  }), _propTypes2['default'].shape({
	    isSelectedKey: _propTypes2['default'].string.isRequired
	  }), _propTypes2['default'].shape({
	    keys: _propTypes2['default'].shape({
	      values: _propTypes2['default'].array.isRequired,
	      rowKey: _propTypes2['default'].string.isRequired
	    }).isRequired
	  })]),
	  rowsCount: _propTypes2['default'].number,
	  onRows: _propTypes2['default'].func,
	  sortColumn: _propTypes2['default'].string,
	  sortDirection: _propTypes2['default'].oneOf(['ASC', 'DESC', 'NONE']),
	  rowOffsetHeight: _propTypes2['default'].number.isRequired,
	  onViewportKeydown: _propTypes2['default'].func.isRequired,
	  onViewportKeyup: _propTypes2['default'].func,
	  onViewportDragStart: _propTypes2['default'].func.isRequired,
	  onViewportDragEnd: _propTypes2['default'].func.isRequired,
	  onViewportClick: _propTypes2['default'].func.isRequired,
	  onViewportDoubleClick: _propTypes2['default'].func.isRequired,
	  onColumnResize: _propTypes2['default'].func,
	  onSort: _propTypes2['default'].func,
	  onHeaderDrop: _propTypes2['default'].func,
	  cellMetaData: _propTypes2['default'].shape(cellMetaDataShape),
	  rowKey: _propTypes2['default'].string.isRequired,
	  rowScrollTimeout: _propTypes2['default'].number,
	  scrollToRowIndex: _propTypes2['default'].number,
	  contextMenu: _propTypes2['default'].element,
	  getSubRowDetails: _propTypes2['default'].func,
	  draggableHeaderCell: _propTypes2['default'].func,
	  getValidFilterValues: _propTypes2['default'].func,
	  rowGroupRenderer: _propTypes2['default'].func,
	  overScan: _propTypes2['default'].object
	};
	Grid.defaultProps = {
	  rowHeight: 35,
	  minHeight: 350,
	  tabIndex: 0
	};


	module.exports = Grid;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _propTypes = __webpack_require__(3);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var React = __webpack_require__(2);
	var ReactDOM = __webpack_require__(10);
	var joinClasses = __webpack_require__(6);
	var shallowCloneObject = __webpack_require__(53);
	var ColumnMetrics = __webpack_require__(32);
	var ColumnUtils = __webpack_require__(7);
	var HeaderRow = __webpack_require__(115);
	var getScrollbarSize = __webpack_require__(33);

	var createObjectWithProperties = __webpack_require__(15);
	var cellMetaDataShape = __webpack_require__(12);
	__webpack_require__(16);

	// The list of the propTypes that we want to include in the Header div
	var knownDivPropertyKeys = ['height', 'onScroll'];

	var Header = function (_React$Component) {
	  _inherits(Header, _React$Component);

	  function Header() {
	    var _temp, _this, _ret;

	    _classCallCheck(this, Header);

	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }

	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = { resizing: null }, _this.onColumnResize = function (column, width) {
	      var state = _this.state.resizing || _this.props;

	      var pos = _this.getColumnPosition(column);

	      if (pos != null) {
	        var _resizing = {
	          columnMetrics: shallowCloneObject(state.columnMetrics)
	        };
	        _resizing.columnMetrics = ColumnMetrics.resizeColumn(_resizing.columnMetrics, pos, width);

	        // we don't want to influence scrollLeft while resizing
	        if (_resizing.columnMetrics.totalWidth < state.columnMetrics.totalWidth) {
	          _resizing.columnMetrics.totalWidth = state.columnMetrics.totalWidth;
	        }

	        _resizing.column = ColumnUtils.getColumn(_resizing.columnMetrics.columns, pos);
	        _this.setState({ resizing: _resizing });
	      }
	    }, _this.onColumnResizeEnd = function (column, width) {
	      var pos = _this.getColumnPosition(column);
	      if (pos !== null && _this.props.onColumnResize) {
	        _this.props.onColumnResize(pos, width || column.width);
	      }
	    }, _this.getHeaderRows = function () {
	      var columnMetrics = _this.getColumnMetrics();
	      var resizeColumn = void 0;
	      if (_this.state.resizing) {
	        resizeColumn = _this.state.resizing.column;
	      }
	      var headerRows = [];
	      _this.props.headerRows.forEach(function (row, index) {
	        // To allow header filters to be visible
	        var rowHeight = 'auto';
	        if (row.rowType === 'filter') {
	          rowHeight = '500px';
	        }
	        var scrollbarSize = getScrollbarSize() > 0 ? getScrollbarSize() : 0;
	        var updatedWidth = isNaN(_this.props.totalWidth - scrollbarSize) ? _this.props.totalWidth : _this.props.totalWidth - scrollbarSize;
	        var headerRowStyle = {
	          position: 'absolute',
	          top: _this.getCombinedHeaderHeights(index),
	          left: 0,
	          width: updatedWidth,
	          overflowX: 'hidden',
	          minHeight: rowHeight
	        };

	        headerRows.push(React.createElement(HeaderRow, {
	          key: row.ref,
	          ref: function ref(node) {
	            return row.rowType === 'filter' ? _this.filterRow = node : _this.row = node;
	          },
	          rowType: row.rowType,
	          style: headerRowStyle,
	          onColumnResize: _this.onColumnResize,
	          onColumnResizeEnd: _this.onColumnResizeEnd,
	          width: columnMetrics.width,
	          height: row.height || _this.props.height,
	          columns: columnMetrics.columns,
	          resizing: resizeColumn,
	          draggableHeaderCell: _this.props.draggableHeaderCell,
	          filterable: row.filterable,
	          onFilterChange: row.onFilterChange,
	          onHeaderDrop: _this.props.onHeaderDrop,
	          sortColumn: _this.props.sortColumn,
	          sortDirection: _this.props.sortDirection,
	          onSort: _this.props.onSort,
	          onScroll: _this.props.onScroll,
	          getValidFilterValues: _this.props.getValidFilterValues
	        }));
	      });
	      return headerRows;
	    }, _this.getColumnMetrics = function () {
	      var columnMetrics = void 0;
	      if (_this.state.resizing) {
	        columnMetrics = _this.state.resizing.columnMetrics;
	      } else {
	        columnMetrics = _this.props.columnMetrics;
	      }
	      return columnMetrics;
	    }, _this.getColumnPosition = function (column) {
	      var columnMetrics = _this.getColumnMetrics();
	      var pos = -1;
	      columnMetrics.columns.forEach(function (c, idx) {
	        if (c.key === column.key) {
	          pos = idx;
	        }
	      });
	      return pos === -1 ? null : pos;
	    }, _this.getCombinedHeaderHeights = function (until) {
	      var stopAt = _this.props.headerRows.length;
	      if (typeof until !== 'undefined') {
	        stopAt = until;
	      }

	      var height = 0;
	      for (var index = 0; index < stopAt; index++) {
	        height += _this.props.headerRows[index].height || _this.props.height;
	      }
	      return height;
	    }, _this.getStyle = function () {
	      return {
	        position: 'relative',
	        height: _this.getCombinedHeaderHeights()
	      };
	    }, _this.setScrollLeft = function (scrollLeft) {
	      var node = ReactDOM.findDOMNode(_this.row);
	      node.scrollLeft = scrollLeft;
	      _this.row.setScrollLeft(scrollLeft);
	      if (_this.filterRow) {
	        var nodeFilters = ReactDOM.findDOMNode(_this.filterRow);
	        nodeFilters.scrollLeft = scrollLeft;
	        _this.filterRow.setScrollLeft(scrollLeft);
	      }
	    }, _this.getKnownDivProps = function () {
	      return createObjectWithProperties(_this.props, knownDivPropertyKeys);
	    }, _this.onHeaderClick = function () {
	      _this.props.cellMetaData.onCellClick({ rowIdx: -1, idx: -1 });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }

	  Header.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
	    this.setState({ resizing: null });
	  };

	  Header.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	    var update = !ColumnMetrics.sameColumns(this.props.columnMetrics.columns, nextProps.columnMetrics.columns, ColumnMetrics.sameColumn) || this.props.totalWidth !== nextProps.totalWidth || this.props.headerRows.length !== nextProps.headerRows.length || this.state.resizing !== nextState.resizing || this.props.sortColumn !== nextProps.sortColumn || this.props.sortDirection !== nextProps.sortDirection;
	    return update;
	  };

	  // Set the cell selection to -1 x -1 when clicking on the header


	  Header.prototype.render = function render() {
	    var className = joinClasses({
	      'react-grid-Header': true,
	      'react-grid-Header--resizing': !!this.state.resizing
	    });
	    var headerRows = this.getHeaderRows();

	    return React.createElement(
	      'div',
	      _extends({}, this.getKnownDivProps(), { style: this.getStyle(), className: className, onClick: this.onHeaderClick }),
	      headerRows
	    );
	  };

	  return Header;
	}(React.Component);

	Header.propTypes = {
	  columnMetrics: _propTypes2['default'].shape({ width: _propTypes2['default'].number.isRequired, columns: _propTypes2['default'].any }).isRequired,
	  totalWidth: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  height: _propTypes2['default'].number.isRequired,
	  headerRows: _propTypes2['default'].array.isRequired,
	  sortColumn: _propTypes2['default'].string,
	  sortDirection: _propTypes2['default'].oneOf(['ASC', 'DESC', 'NONE']),
	  onSort: _propTypes2['default'].func,
	  onColumnResize: _propTypes2['default'].func,
	  onScroll: _propTypes2['default'].func,
	  onHeaderDrop: _propTypes2['default'].func,
	  draggableHeaderCell: _propTypes2['default'].func,
	  getValidFilterValues: _propTypes2['default'].func,
	  cellMetaData: _propTypes2['default'].shape(cellMetaDataShape)
	};


	module.exports = Header;

/***/ }),
/* 114 */
/***/ (function(module, exports) {

	"use strict";

	var HeaderCellType = {
	  SORTABLE: 0,
	  FILTERABLE: 1,
	  NONE: 2,
	  CHECKBOX: 3
	};

	module.exports = HeaderCellType;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _propTypes = __webpack_require__(3);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var React = __webpack_require__(2);
	var shallowEqual = __webpack_require__(70);
	var BaseHeaderCell = __webpack_require__(42);
	var getScrollbarSize = __webpack_require__(33);
	var ExcelColumn = __webpack_require__(13);
	var columnUtils = __webpack_require__(7);
	var SortableHeaderCell = __webpack_require__(47);
	var FilterableHeaderCell = __webpack_require__(124);
	var HeaderCellType = __webpack_require__(114);
	var createObjectWithProperties = __webpack_require__(15);
	__webpack_require__(16);

	var HeaderRowStyle = {
	  overflow: _propTypes2['default'].string,
	  width: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  height: _propTypes2['default'].number,
	  position: _propTypes2['default'].string
	};

	// The list of the propTypes that we want to include in the HeaderRow div
	var knownDivPropertyKeys = ['width', 'height', 'style', 'onScroll'];

	var HeaderRow = function (_React$Component) {
	  _inherits(HeaderRow, _React$Component);

	  function HeaderRow() {
	    var _temp, _this, _ret;

	    _classCallCheck(this, HeaderRow);

	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }

	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.getHeaderCellType = function (column) {
	      if (column.filterable) {
	        if (_this.props.filterable) return HeaderCellType.FILTERABLE;
	      }

	      if (column.sortable && column.rowType !== 'filter') return HeaderCellType.SORTABLE;

	      return HeaderCellType.NONE;
	    }, _this.getFilterableHeaderCell = function (column) {
	      var FilterRenderer = FilterableHeaderCell;
	      if (column.filterRenderer !== undefined) {
	        FilterRenderer = column.filterRenderer;
	      }
	      return React.createElement(FilterRenderer, _extends({}, _this.props, { onChange: _this.props.onFilterChange }));
	    }, _this.getSortableHeaderCell = function (column) {
	      var sortDirection = _this.props.sortColumn === column.key ? _this.props.sortDirection : SortableHeaderCell.DEFINE_SORT.NONE;
	      var sortDescendingFirst = column.sortDescendingFirst === undefined ? false : column.sortDescendingFirst;
	      return React.createElement(SortableHeaderCell, { columnKey: column.key, onSort: _this.props.onSort, sortDirection: sortDirection, sortDescendingFirst: sortDescendingFirst, headerRenderer: column.headerRenderer });
	    }, _this.getHeaderRenderer = function (column) {
	      var renderer = void 0;
	      if (column.headerRenderer && !column.sortable && !_this.props.filterable) {
	        renderer = column.headerRenderer;
	      } else {
	        var headerCellType = _this.getHeaderCellType(column);
	        switch (headerCellType) {
	          case HeaderCellType.SORTABLE:
	            renderer = _this.getSortableHeaderCell(column);
	            break;
	          case HeaderCellType.FILTERABLE:
	            renderer = _this.getFilterableHeaderCell(column);
	            break;
	          default:
	            break;
	        }
	      }
	      return renderer;
	    }, _this.getStyle = function () {
	      return {
	        overflow: 'hidden',
	        width: '100%',
	        height: _this.props.height,
	        position: 'absolute'
	      };
	    }, _this.getCells = function () {
	      var cells = [];
	      var lockedCells = [];

	      var _loop = function _loop(i, len) {
	        var column = Object.assign({ rowType: _this.props.rowType }, columnUtils.getColumn(_this.props.columns, i));
	        var _renderer = _this.getHeaderRenderer(column);
	        if (column.key === 'select-row' && _this.props.rowType === 'filter') {
	          _renderer = React.createElement('div', null);
	        }
	        var HeaderCell = column.draggable ? _this.props.draggableHeaderCell : BaseHeaderCell;
	        var cell = React.createElement(HeaderCell, {
	          ref: function ref(node) {
	            return _this.cells[i] = node;
	          },
	          key: i,
	          height: _this.props.height,
	          column: column,
	          renderer: _renderer,
	          resizing: _this.props.resizing === column,
	          onResize: _this.props.onColumnResize,
	          onResizeEnd: _this.props.onColumnResizeEnd,
	          onHeaderDrop: _this.props.onHeaderDrop
	        });
	        if (column.locked) {
	          lockedCells.push(cell);
	        } else {
	          cells.push(cell);
	        }
	      };

	      for (var i = 0, len = columnUtils.getSize(_this.props.columns); i < len; i++) {
	        _loop(i, len);
	      }

	      return cells.concat(lockedCells);
	    }, _this.setScrollLeft = function (scrollLeft) {
	      _this.props.columns.forEach(function (column, i) {
	        if (column.locked) {
	          _this.cells[i].setScrollLeft(scrollLeft);
	        } else {
	          if (_this.cells[i] && _this.cells[i].removeScroll) {
	            _this.cells[i].removeScroll();
	          }
	        }
	      });
	    }, _this.getKnownDivProps = function () {
	      return createObjectWithProperties(_this.props, knownDivPropertyKeys);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }

	  HeaderRow.prototype.componentWillMount = function componentWillMount() {
	    this.cells = [];
	  };

	  HeaderRow.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    return nextProps.width !== this.props.width || nextProps.height !== this.props.height || nextProps.columns !== this.props.columns || !shallowEqual(nextProps.style, this.props.style) || this.props.sortColumn !== nextProps.sortColumn || this.props.sortDirection !== nextProps.sortDirection;
	  };

	  HeaderRow.prototype.render = function render() {
	    var cellsStyle = {
	      width: this.props.width ? this.props.width + getScrollbarSize() : '100%',
	      height: this.props.height,
	      whiteSpace: 'nowrap',
	      overflowX: 'hidden',
	      overflowY: 'hidden'
	    };

	    var cells = this.getCells();
	    return React.createElement(
	      'div',
	      _extends({}, this.getKnownDivProps(), { className: 'react-grid-HeaderRow' }),
	      React.createElement(
	        'div',
	        { style: cellsStyle },
	        cells
	      )
	    );
	  };

	  return HeaderRow;
	}(React.Component);

	HeaderRow.displayName = 'HeaderRow';
	HeaderRow.propTypes = {
	  width: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  height: _propTypes2['default'].number.isRequired,
	  columns: _propTypes2['default'].oneOfType([_propTypes2['default'].array, _propTypes2['default'].object]).isRequired,
	  onColumnResize: _propTypes2['default'].func,
	  onSort: _propTypes2['default'].func.isRequired,
	  onColumnResizeEnd: _propTypes2['default'].func,
	  style: _propTypes2['default'].shape(HeaderRowStyle),
	  sortColumn: _propTypes2['default'].string,
	  sortDirection: _propTypes2['default'].oneOf(Object.keys(SortableHeaderCell.DEFINE_SORT)),
	  cellRenderer: _propTypes2['default'].func,
	  headerCellRenderer: _propTypes2['default'].func,
	  filterable: _propTypes2['default'].bool,
	  onFilterChange: _propTypes2['default'].func,
	  resizing: _propTypes2['default'].object,
	  onScroll: _propTypes2['default'].func,
	  rowType: _propTypes2['default'].string,
	  draggableHeaderCell: _propTypes2['default'].func,
	  onHeaderDrop: _propTypes2['default'].func
	};


	module.exports = HeaderRow;

/***/ }),
/* 116 */
/***/ (function(module, exports) {

	"use strict";

	module.exports = {
	  Backspace: 8,
	  Tab: 9,
	  Enter: 13,
	  Shift: 16,
	  Ctrl: 17,
	  Alt: 18,
	  PauseBreak: 19,
	  CapsLock: 20,
	  Escape: 27,
	  PageUp: 33,
	  PageDown: 34,
	  End: 35,
	  Home: 36,
	  LeftArrow: 37,
	  UpArrow: 38,
	  RightArrow: 39,
	  DownArrow: 40,
	  Insert: 45,
	  Delete: 46,
	  0: 48,
	  1: 49,
	  2: 50,
	  3: 51,
	  4: 52,
	  5: 53,
	  6: 54,
	  7: 55,
	  8: 56,
	  9: 57,
	  a: 65,
	  b: 66,
	  c: 67,
	  d: 68,
	  e: 69,
	  f: 70,
	  g: 71,
	  h: 72,
	  i: 73,
	  j: 74,
	  k: 75,
	  l: 76,
	  m: 77,
	  n: 78,
	  o: 79,
	  p: 80,
	  q: 81,
	  r: 82,
	  s: 83,
	  t: 84,
	  u: 85,
	  v: 86,
	  w: 87,
	  x: 88,
	  y: 89,
	  z: 90,
	  LeftWindowKey: 91,
	  RightWindowKey: 92,
	  SelectKey: 93,
	  NumPad0: 96,
	  NumPad1: 97,
	  NumPad2: 98,
	  NumPad3: 99,
	  NumPad4: 100,
	  NumPad5: 101,
	  NumPad6: 102,
	  NumPad7: 103,
	  NumPad8: 104,
	  NumPad9: 105,
	  Multiply: 106,
	  Add: 107,
	  Subtract: 109,
	  DecimalPoint: 110,
	  Divide: 111,
	  F1: 112,
	  F2: 113,
	  F3: 114,
	  F4: 115,
	  F5: 116,
	  F6: 117,
	  F7: 118,
	  F8: 119,
	  F9: 120,
	  F10: 121,
	  F12: 123,
	  NumLock: 144,
	  ScrollLock: 145,
	  SemiColon: 186,
	  EqualSign: 187,
	  Comma: 188,
	  Dash: 189,
	  Period: 190,
	  ForwardSlash: 191,
	  GraveAccent: 192,
	  OpenBracket: 219,
	  BackSlash: 220,
	  CloseBracket: 221,
	  SingleQuote: 222
	};

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;
	exports.OverflowCellComponent = undefined;

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _propTypes = __webpack_require__(3);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	var _focusableComponentWrapper = __webpack_require__(127);

	var _focusableComponentWrapper2 = _interopRequireDefault(_focusableComponentWrapper);

	__webpack_require__(38);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var OverflowCell = function (_React$Component) {
	  _inherits(OverflowCell, _React$Component);

	  function OverflowCell() {
	    _classCallCheck(this, OverflowCell);

	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }

	  OverflowCell.prototype.getStyle = function getStyle() {
	    var style = {
	      position: 'absolute',
	      width: this.props.column.width,
	      height: this.props.height,
	      left: this.props.column.left,
	      border: '1px solid #eee'
	    };
	    return style;
	  };

	  OverflowCell.prototype.render = function render() {
	    return _react2['default'].createElement('div', { tabIndex: '-1', style: this.getStyle(), width: '100%', className: 'react-grid-Cell' });
	  };

	  return OverflowCell;
	}(_react2['default'].Component);

	OverflowCell.isSelected = function (props) {
	  var cellMetaData = props.cellMetaData,
	      rowIdx = props.rowIdx,
	      idx = props.idx;

	  if (cellMetaData == null) {
	    return false;
	  }

	  var selected = cellMetaData.selected;


	  return selected && selected.rowIdx === rowIdx && selected.idx === idx;
	};

	OverflowCell.isScrolling = function (props) {
	  return props.cellMetaData.isScrollingHorizontallyWithKeyboard;
	};

	OverflowCell.propTypes = {
	  rowIdx: _propTypes2['default'].number,
	  idx: _propTypes2['default'].number,
	  height: _propTypes2['default'].number,
	  column: _propTypes2['default'].object,
	  cellMetaData: _propTypes2['default'].object
	};

	OverflowCell.displayName = 'Cell';

	var OverflowCellComponent = OverflowCell;
	exports['default'] = (0, _focusableComponentWrapper2['default'])(OverflowCell);
	exports.OverflowCellComponent = OverflowCellComponent;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _propTypes = __webpack_require__(3);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	var CellActionShape = {
	  icon: _propTypes2['default'].string.isRequired,
	  callback: _propTypes2['default'].func,
	  actions: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	    text: _propTypes2['default'].string,
	    callback: _propTypes2['default'].func
	  }))
	};

	exports['default'] = CellActionShape;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _ExcelColumn = __webpack_require__(13);

	var _ExcelColumn2 = _interopRequireDefault(_ExcelColumn);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	exports['default'] = { ExcelColumn: _ExcelColumn2['default'] };

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _propTypes = __webpack_require__(3);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	var _SelectAll = __webpack_require__(51);

	var _SelectAll2 = _interopRequireDefault(_SelectAll);

	var _AppConstants = __webpack_require__(31);

	var _AppConstants2 = _interopRequireDefault(_AppConstants);

	var _SortableHeaderCell = __webpack_require__(47);

	var _keyboardUtils = __webpack_require__(56);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var React = __webpack_require__(2);

	var BaseGrid = __webpack_require__(112);
	var CheckboxEditor = __webpack_require__(48);
	var RowUtils = __webpack_require__(45);
	var ColumnUtils = __webpack_require__(7);
	var KeyCodes = __webpack_require__(116);
	var isFunction = __webpack_require__(20);

	var ColumnMetrics = __webpack_require__(32);
	__webpack_require__(21);
	__webpack_require__(71);

	if (!Object.assign) {
	  Object.assign = __webpack_require__(147);
	}

	var ReactDataGrid = function (_React$Component) {
	  _inherits(ReactDataGrid, _React$Component);

	  function ReactDataGrid(props, context) {
	    _classCallCheck(this, ReactDataGrid);

	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

	    _initialiseProps.call(_this);

	    var columnMetrics = _this.createColumnMetrics();
	    var initialState = { columnMetrics: columnMetrics, selectedRows: [], copied: null, expandedRows: [], canFilter: false, columnFilters: {}, sortDirection: null, sortColumn: null, dragged: null, scrollOffset: 0, lastRowIdxUiSelected: -1 };
	    if (props.enableCellSelect) {
	      initialState.selected = { rowIdx: 0, idx: 0 };
	    } else {
	      initialState.selected = { rowIdx: -1, idx: -1 };
	    }

	    if (_this.props.sortColumn && _this.props.sortDirection) {
	      initialState.sortColumn = _this.props.sortColumn;
	      initialState.sortDirection = _this.props.sortDirection;
	    }

	    _this.state = initialState;
	    return _this;
	  }

	  ReactDataGrid.prototype.componentWillMount = function componentWillMount() {
	    this._mounted = true;
	  };

	  ReactDataGrid.prototype.componentDidMount = function componentDidMount() {
	    if (window.addEventListener) {
	      window.addEventListener('resize', this.metricsUpdated);
	    } else {
	      window.attachEvent('resize', this.metricsUpdated);
	    }
	    this.metricsUpdated();
	  };

	  ReactDataGrid.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._mounted = false;
	    window.removeEventListener('resize', this.metricsUpdated);
	  };

	  ReactDataGrid.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.columns) {
	      if (!ColumnMetrics.sameColumns(this.props.columns, nextProps.columns, this.props.columnEquality) || nextProps.minWidth !== this.props.minWidth) {
	        var columnMetrics = this.createColumnMetrics(nextProps);
	        this.setState({ columnMetrics: columnMetrics });
	      }
	    }
	  };

	  // return false if not a shift select so can be handled as normal row selection


	  // columnKey not used here as this function will select the whole row,
	  // but needed to match the function signature in the CheckboxEditor


	  ReactDataGrid.prototype.render = function render() {
	    var _this2 = this;

	    var cellMetaData = {
	      rowKey: this.props.rowKey,
	      selected: this.state.selected,
	      dragged: this.state.dragged,
	      hoveredRowIdx: this.state.hoveredRowIdx,
	      onCellClick: this.onCellClick,
	      onCellFocus: this.onCellFocus,
	      onCellContextMenu: this.onCellContextMenu,
	      onCellDoubleClick: this.onCellDoubleClick,
	      onCommit: this.onCellCommit,
	      onCommitCancel: this.setInactive,
	      copied: this.state.copied,
	      handleDragEnterRow: this.handleDragEnter,
	      handleTerminateDrag: this.handleTerminateDrag,
	      enableCellSelect: this.props.enableCellSelect,
	      onColumnEvent: this.onColumnEvent,
	      openCellEditor: this.openCellEditor,
	      onDragHandleDoubleClick: this.onDragHandleDoubleClick,
	      onCellExpand: this.onCellExpand,
	      onRowExpandToggle: this.onRowExpandToggle,
	      onRowHover: this.onRowHover,
	      getDataGridDOMNode: this.getDataGridDOMNode,
	      getCellActions: this.props.getCellActions,
	      onDeleteSubRow: this.props.onDeleteSubRow,
	      onAddSubRow: this.props.onAddSubRow,
	      isScrollingVerticallyWithKeyboard: this.isKeyDown(KeyCodes.DownArrow) || this.isKeyDown(KeyCodes.UpArrow),
	      isScrollingHorizontallyWithKeyboard: this.isKeyDown(KeyCodes.LeftArrow) || this.isKeyDown(KeyCodes.RightArrow) || this.isKeyDown(KeyCodes.Tab),
	      enableCellAutoFocus: this.props.enableCellAutoFocus
	    };

	    var toolbar = this.renderToolbar();
	    var containerWidth = this.props.minWidth || this.gridWidth();
	    var gridWidth = containerWidth - this.state.scrollOffset;

	    // depending on the current lifecycle stage, gridWidth() may not initialize correctly
	    // this also handles cases where it always returns undefined -- such as when inside a div with display:none
	    // eg Bootstrap tabs and collapses
	    if (typeof containerWidth === 'undefined' || isNaN(containerWidth) || containerWidth === 0) {
	      containerWidth = '100%';
	    }
	    if (typeof gridWidth === 'undefined' || isNaN(gridWidth) || gridWidth === 0) {
	      gridWidth = '100%';
	    }
	    return React.createElement(
	      'div',
	      { className: 'react-grid-Container', style: { width: containerWidth },
	        ref: function ref(node) {
	          _this2.grid = node;
	        } },
	      toolbar,
	      React.createElement(
	        'div',
	        { className: 'react-grid-Main' },
	        React.createElement(BaseGrid, _extends({
	          ref: function ref(node) {
	            return _this2.base = node;
	          }
	        }, this.props, {
	          rowKey: this.props.rowKey,
	          headerRows: this.getHeaderRows(),
	          columnMetrics: this.state.columnMetrics,
	          rowGetter: this.props.rowGetter,
	          rowsCount: this.props.rowsCount,
	          rowHeight: this.props.rowHeight,
	          cellMetaData: cellMetaData,
	          selectedRows: this.getSelectedRows(),
	          rowSelection: this.getRowSelectionProps(),
	          expandedRows: this.state.expandedRows,
	          rowOffsetHeight: this.getRowOffsetHeight(),
	          sortColumn: this.state.sortColumn,
	          sortDirection: this.state.sortDirection,
	          onSort: this.handleSort,
	          minHeight: this.props.minHeight,
	          totalWidth: gridWidth,
	          onViewportKeydown: this.onKeyDown,
	          onViewportKeyup: this.onKeyUp,
	          onViewportDragStart: this.onDragStart,
	          onViewportDragEnd: this.handleDragEnd,
	          onViewportClick: this.deselect,
	          onViewportDoubleClick: this.deselect,
	          onColumnResize: this.onColumnResize,
	          rowScrollTimeout: this.props.rowScrollTimeout,
	          scrollToRowIndex: this.props.scrollToRowIndex,
	          contextMenu: this.props.contextMenu,
	          overScan: this.props.overScan }))
	      )
	    );
	  };

	  return ReactDataGrid;
	}(React.Component);

	ReactDataGrid.displayName = 'ReactDataGrid';
	ReactDataGrid.propTypes = {
	  rowHeight: _propTypes2['default'].number.isRequired,
	  headerRowHeight: _propTypes2['default'].number,
	  headerFiltersHeight: _propTypes2['default'].number,
	  minHeight: _propTypes2['default'].number.isRequired,
	  minWidth: _propTypes2['default'].number,
	  enableRowSelect: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].string]),
	  onRowUpdated: _propTypes2['default'].func,
	  rowGetter: _propTypes2['default'].func.isRequired,
	  rowsCount: _propTypes2['default'].number.isRequired,
	  toolbar: _propTypes2['default'].element,
	  enableCellSelect: _propTypes2['default'].bool,
	  columns: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].array]).isRequired,
	  onFilter: _propTypes2['default'].func,
	  onCellCopyPaste: _propTypes2['default'].func,
	  onCellsDragged: _propTypes2['default'].func,
	  getCellActions: _propTypes2['default'].func,
	  onAddFilter: _propTypes2['default'].func,
	  onGridSort: _propTypes2['default'].func,
	  sortColumn: _propTypes2['default'].string,
	  sortDirection: _propTypes2['default'].oneOf(Object.keys(_SortableHeaderCell.DEFINE_SORT)),
	  onDragHandleDoubleClick: _propTypes2['default'].func,
	  onGridRowsUpdated: _propTypes2['default'].func,
	  onRowSelect: _propTypes2['default'].func,
	  rowKey: _propTypes2['default'].string,
	  rowScrollTimeout: _propTypes2['default'].number,
	  scrollToRowIndex: _propTypes2['default'].number,
	  onClearFilters: _propTypes2['default'].func,
	  contextMenu: _propTypes2['default'].element,
	  cellNavigationMode: _propTypes2['default'].oneOf(['none', 'loopOverRow', 'changeRow']),
	  onCellSelected: _propTypes2['default'].func,
	  onCellDeSelected: _propTypes2['default'].func,
	  onCellExpand: _propTypes2['default'].func,
	  enableDragAndDrop: _propTypes2['default'].bool,
	  tabIndex: _propTypes2['default'].number,
	  onRowExpandToggle: _propTypes2['default'].func,
	  draggableHeaderCell: _propTypes2['default'].func,
	  getValidFilterValues: _propTypes2['default'].func,
	  rowSelection: _propTypes2['default'].shape({
	    enableShiftSelect: _propTypes2['default'].bool,
	    onRowsSelected: _propTypes2['default'].func,
	    onRowsDeselected: _propTypes2['default'].func,
	    showCheckbox: _propTypes2['default'].bool,
	    selectBy: _propTypes2['default'].oneOfType([_propTypes2['default'].shape({
	      indexes: _propTypes2['default'].arrayOf(_propTypes2['default'].number).isRequired
	    }), _propTypes2['default'].shape({
	      isSelectedKey: _propTypes2['default'].string.isRequired
	    }), _propTypes2['default'].shape({
	      keys: _propTypes2['default'].shape({
	        values: _propTypes2['default'].array.isRequired,
	        rowKey: _propTypes2['default'].string.isRequired
	      }).isRequired
	    })]).isRequired
	  }),
	  onRowClick: _propTypes2['default'].func,
	  onRowDoubleClick: _propTypes2['default'].func,
	  onGridKeyUp: _propTypes2['default'].func,
	  onGridKeyDown: _propTypes2['default'].func,
	  rowGroupRenderer: _propTypes2['default'].func,
	  rowActionsCell: _propTypes2['default'].func,
	  onCheckCellIsEditable: _propTypes2['default'].func,
	  /* called before cell is set active, returns a boolean to determine whether cell is editable */
	  overScan: _propTypes2['default'].object,
	  onDeleteSubRow: _propTypes2['default'].func,
	  onAddSubRow: _propTypes2['default'].func,
	  enableCellAutoFocus: _propTypes2['default'].bool,
	  onBeforeEdit: _propTypes2['default'].func,
	  selectAllRenderer: _propTypes2['default'].object,
	  minColumnWidth: _propTypes2['default'].number,
	  columnEquality: _propTypes2['default'].func,
	  onColumnResize: _propTypes2['default'].func
	};
	ReactDataGrid.defaultProps = {
	  enableCellSelect: false,
	  tabIndex: -1,
	  rowHeight: 35,
	  headerFiltersHeight: 45,
	  enableRowSelect: false,
	  minHeight: 350,
	  rowKey: 'id',
	  rowScrollTimeout: 0,
	  scrollToRowIndex: 0,
	  cellNavigationMode: 'none',
	  overScan: {
	    colsStart: 5,
	    colsEnd: 5,
	    rowsStart: 5,
	    rowsEnd: 5
	  },
	  enableCellAutoFocus: true,
	  onBeforeEdit: function onBeforeEdit() {},
	  minColumnWidth: 80,
	  columnEquality: ColumnMetrics.sameColumn
	};

	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;

	  this.gridWidth = function () {
	    return _this3.grid ? _this3.grid.parentElement.offsetWidth : 0;
	  };

	  this.getTotalWidth = function () {
	    var totalWidth = 0;
	    if (_this3._mounted) {
	      totalWidth = _this3.gridWidth();
	    } else {
	      totalWidth = ColumnUtils.getSize(_this3.props.columns) * _this3.props.minColumnWidth;
	    }
	    return totalWidth;
	  };

	  this.getColumnMetricsType = function (metrics) {
	    var totalWidth = metrics.totalWidth || _this3.getTotalWidth();
	    var currentMetrics = {
	      columns: metrics.columns,
	      totalWidth: totalWidth,
	      minColumnWidth: metrics.minColumnWidth
	    };
	    var updatedMetrics = ColumnMetrics.recalculate(currentMetrics);
	    return updatedMetrics;
	  };

	  this.getColumn = function (idx) {
	    var columns = _this3.state.columnMetrics.columns;
	    if (Array.isArray(columns)) {
	      return columns[idx];
	    } else if (typeof Immutable !== 'undefined') {
	      return columns.get(idx);
	    }
	  };

	  this.getSize = function () {
	    var columns = _this3.state.columnMetrics.columns;
	    if (Array.isArray(columns)) {
	      return columns.length;
	    } else if (typeof Immutable !== 'undefined') {
	      return columns.size;
	    }
	  };

	  this.metricsUpdated = function () {
	    var columnMetrics = _this3.createColumnMetrics();
	    _this3.setState({ columnMetrics: columnMetrics });
	  };

	  this.createColumnMetrics = function () {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this3.props;

	    var gridColumns = _this3.setupGridColumns(props);
	    return _this3.getColumnMetricsType({
	      columns: gridColumns,
	      minColumnWidth: _this3.props.minColumnWidth,
	      totalWidth: props.minWidth
	    });
	  };

	  this.onColumnResize = function (index, width) {
	    var columnMetrics = ColumnMetrics.resizeColumn(_this3.state.columnMetrics, index, width);
	    _this3.setState({ columnMetrics: columnMetrics });
	    if (_this3.props.onColumnResize) {
	      _this3.props.onColumnResize(index, width);
	    }
	  };

	  this.onKeyDown = function (e) {
	    if ((0, _keyboardUtils.isCtrlKeyHeldDown)(e)) {
	      _this3.checkAndCall('onPressKeyWithCtrl', e);
	    } else if (_this3.isKeyExplicitlyHandled(e.key)) {
	      // break up individual keyPress events to have their own specific callbacks
	      var callBack = 'onPress' + e.key;
	      _this3.checkAndCall(callBack, e);
	    } else if ((0, _keyboardUtils.isKeyPrintable)(e.keyCode)) {
	      _this3.checkAndCall('onPressChar', e);
	    }

	    // Track which keys are currently down for shift clicking etc
	    _this3._keysDown = _this3._keysDown || {};
	    _this3._keysDown[e.keyCode] = true;
	    if (isFunction(_this3.props.onGridKeyDown)) {
	      _this3.props.onGridKeyDown(e);
	    }
	  };

	  this.onKeyUp = function (e) {
	    // Track which keys are currently down for shift clicking etc
	    _this3._keysDown = _this3._keysDown || {};
	    delete _this3._keysDown[e.keyCode];

	    if (isFunction(_this3.props.onGridKeyUp)) {
	      _this3.props.onGridKeyUp(e);
	    }
	  };

	  this.isKeyDown = function (keyCode) {
	    if (!_this3._keysDown) return false;
	    return keyCode in _this3._keysDown;
	  };

	  this.isSingleKeyDown = function (keyCode) {
	    if (!_this3._keysDown) return false;
	    return keyCode in _this3._keysDown && Object.keys(_this3._keysDown).length === 1;
	  };

	  this.checkAndCall = function (methodName, args) {
	    if (typeof _this3[methodName] === 'function') {
	      _this3[methodName](args);
	    }
	  };

	  this.isKeyExplicitlyHandled = function (key) {
	    return typeof _this3['onPress' + key] === 'function';
	  };

	  this.hasSelectedCellChanged = function (selected) {
	    var previouslySelected = Object.assign({}, _this3.state.selected);
	    return previouslySelected.rowIdx !== selected.rowIdx || previouslySelected.idx !== selected.idx || previouslySelected.active === false;
	  };

	  this.onContextMenuHide = function () {
	    document.removeEventListener('click', _this3.onContextMenuHide);
	    var newSelected = Object.assign({}, _this3.state.selected, { contextMenuDisplayed: false });
	    _this3.setState({ selected: newSelected });
	  };

	  this.onColumnEvent = function (ev, columnEvent) {
	    var idx = columnEvent.idx,
	        name = columnEvent.name;


	    if (name && typeof idx !== 'undefined') {
	      var column = _this3.getColumn(idx);

	      if (column && column.events && column.events[name] && typeof column.events[name] === 'function') {
	        var eventArgs = {
	          idx: idx,
	          rowIdx: columnEvent.rowIdx,
	          rowId: columnEvent.rowId,
	          column: column
	        };

	        column.events[name](ev, eventArgs);
	      }
	    }
	  };

	  this.onSelect = function (selected) {
	    if (_this3.state.selected.rowIdx !== selected.rowIdx || _this3.state.selected.idx !== selected.idx || _this3.state.selected.active === false) {
	      var _idx = selected.idx;
	      var _rowIdx = selected.rowIdx;
	      if (_this3.isCellWithinBounds(selected)) {
	        var oldSelection = _this3.state.selected;
	        _this3.setState({ selected: selected }, function () {
	          if (typeof _this3.props.onCellDeSelected === 'function') {
	            _this3.props.onCellDeSelected(oldSelection);
	          }
	          if (typeof _this3.props.onCellSelected === 'function') {
	            _this3.props.onCellSelected(selected);
	          }
	        });
	      } else if (_rowIdx === -1 && _idx === -1) {
	        // When it's outside of the grid, set rowIdx anyway
	        _this3.setState({ selected: { idx: _idx, rowIdx: _rowIdx } });
	      }
	    }
	  };

	  this.onCellClick = function (cell, e) {
	    _this3.onSelect({ rowIdx: cell.rowIdx, idx: cell.idx });

	    if (_this3.props.onRowClick && typeof _this3.props.onRowClick === 'function') {
	      _this3.props.onRowClick(cell.rowIdx, _this3.props.rowGetter(cell.rowIdx), _this3.getColumn(cell.idx));
	    }

	    if (e) {
	      e.stopPropagation();
	    }
	  };

	  this.onCellFocus = function (cell) {
	    _this3.onSelect(cell);
	  };

	  this.onCellContextMenu = function (cell) {
	    _this3.onSelect({ rowIdx: cell.rowIdx, idx: cell.idx, contextMenuDisplayed: _this3.props.contextMenu });
	    if (_this3.props.contextMenu) {
	      document.addEventListener('click', _this3.onContextMenuHide);
	    }
	  };

	  this.onCellDoubleClick = function (cell, e) {
	    _this3.onSelect({ rowIdx: cell.rowIdx, idx: cell.idx });
	    if (_this3.props.onRowDoubleClick && typeof _this3.props.onRowDoubleClick === 'function') {
	      _this3.props.onRowDoubleClick(cell.rowIdx, _this3.props.rowGetter(cell.rowIdx), _this3.getColumn(cell.idx));
	    }
	    _this3.setActive();
	    if (e) {
	      e.stopPropagation();
	    }
	  };

	  this.onPressArrowUp = function (e) {
	    _this3.moveSelectedCell(e, -1, 0);
	  };

	  this.onPressArrowDown = function (e) {
	    _this3.moveSelectedCell(e, 1, 0);
	  };

	  this.onPressArrowLeft = function (e) {
	    _this3.moveSelectedCell(e, 0, -1);
	  };

	  this.onPressArrowRight = function (e) {
	    _this3.moveSelectedCell(e, 0, 1);
	  };

	  this.isFocusedOnCell = function () {
	    return document.activeElement && document.activeElement.classList && document.activeElement.classList.contains('react-grid-Cell');
	  };

	  this.isFocusedOnTable = function () {
	    var domNode = _this3.getDataGridDOMNode();
	    return domNode && domNode.contains(document.activeElement);
	  };

	  this.exitGrid = function (oldSelectedCell, newSelectedValue) {
	    _this3.setState({ selected: newSelectedValue }, function () {
	      if (typeof _this3.props.onCellDeSelected === 'function') {
	        _this3.props.onCellDeSelected(oldSelectedCell);
	      }
	    });
	  };

	  this.enterGrid = function (newSelectedValue) {
	    _this3.setState({ selected: newSelectedValue }, function () {
	      if (typeof _this3.props.onCellSelected === 'function') {
	        _this3.props.onCellSelected(newSelectedValue);
	      }
	    });
	  };

	  this.onPressTab = function (e) {
	    // Scenario 0a: When there are no rows in the grid, pressing tab needs to allow the browser to handle it
	    if (_this3.props.rowsCount === 0) {
	      return;
	    }
	    // Scenario 0b: When we're editing a cell
	    var idx = _this3.state.selected.idx;
	    var rowIdx = _this3.state.selected.rowIdx;
	    if (_this3.state.selected.active === true) {
	      // if we are in a position to leave the grid, stop editing but stay in that cell
	      if (_this3.canExitGrid(e)) {
	        _this3.moveSelectedCell(e, 0, 0);
	        return;
	      }
	      // otherwise move left or right as appropriate
	      _this3.moveSelectedCell(e, 0, e.shiftKey ? -1 : 1);
	      return;
	    }
	    var shift = e.shiftKey === true;
	    // Scenario 1: we're at a cell where we can exit the grid
	    if (_this3.canExitGrid(e) && _this3.isFocusedOnCell()) {
	      if (shift && idx >= 0) {
	        _this3.exitGrid({ idx: idx, rowIdx: rowIdx }, { idx: -1, rowIdx: rowIdx, exitedLeft: true });
	        return;
	      } else if (!shift && idx >= 0) {
	        _this3.exitGrid({ idx: idx, rowIdx: rowIdx }, { idx: -1, rowIdx: rowIdx });
	        return;
	      }
	    }
	    // Scenario 2: we're on the div surrounding the grid and press shift+Tab
	    // and we just exited left, so we want to let the browser handle it
	    // KNOWN ISSUE: Focus on the table can come from either side and at this point we can't know how
	    // they user arrived, so it is possible that exitLeft gets set and then the user clicks out of the table
	    // and they won't be able to Shift+Tab around the site to re-enter the table from the right.
	    if (_this3.isFocusedOnTable() && !_this3.isFocusedOnCell() && shift && _this3.state.selected.exitedLeft) {
	      _this3.enterGrid({ idx: idx, rowIdx: rowIdx });
	      return;
	    }
	    // Scenario 3: we're on the div surrounding the grid and we want to enter the grid
	    if (!_this3.isFocusedOnCell()) {
	      // Scenario 3A: idx has been set to -1 (eg can happen when clicking into the filter box)
	      // we want to go to the first cell in the row if we press Tab
	      // we want to go to the last cell in the row if we press Shift+Tab
	      if (idx === -1) {
	        _this3.moveSelectedCell(e, rowIdx === -1 ? 1 : 0, shift ? _this3.getNbrColumns() : 1);
	        return;
	      }
	      // otherwise, there is a selected cell in the table already, and
	      // we want to trigger it to focus - setting selected in state will update
	      // the cell props, and checkFocus will be called
	      _this3.enterGrid({ idx: idx, rowIdx: rowIdx, changeSomething: true });
	      // make sure the browser doesn't handle it
	      e.preventDefault();
	      return;
	    }
	    _this3.moveSelectedCell(e, 0, e.shiftKey ? -1 : 1);
	  };

	  this.onPressEnter = function (e) {
	    _this3.setActive(e.key);
	  };

	  this.onPressDelete = function (e) {
	    _this3.setActive(e.key);
	  };

	  this.onPressEscape = function (e) {
	    _this3.setInactive(e.key);
	    _this3.handleCancelCopy();
	  };

	  this.onPressBackspace = function (e) {
	    _this3.setActive(e.key);
	  };

	  this.onPressChar = function (e) {
	    if ((0, _keyboardUtils.isKeyPrintable)(e.keyCode)) {
	      _this3.setActive(e.keyCode);
	    }
	  };

	  this.onPressKeyWithCtrl = function (e) {
	    var keys = {
	      KeyCode_c: 99,
	      KeyCode_C: 67,
	      KeyCode_V: 86,
	      KeyCode_v: 118
	    };

	    var rowIdx = _this3.state.selected.rowIdx;
	    var row = _this3.props.rowGetter(rowIdx);

	    var idx = _this3.state.selected.idx;
	    var col = _this3.getColumn(idx);

	    if (ColumnUtils.canEdit(col, row, _this3.props.enableCellSelect)) {
	      if (e.keyCode === keys.KeyCode_c || e.keyCode === keys.KeyCode_C) {
	        var _value = _this3.getSelectedValue();
	        _this3.handleCopy({ value: _value });
	      } else if (e.keyCode === keys.KeyCode_v || e.keyCode === keys.KeyCode_V) {
	        _this3.handlePaste();
	      }
	    }
	  };

	  this.onGridRowsUpdated = function (cellKey, fromRow, toRow, updated, action, originRow) {
	    var rowIds = [];

	    for (var i = fromRow; i <= toRow; i++) {
	      rowIds.push(_this3.props.rowGetter(i)[_this3.props.rowKey]);
	    }

	    var fromRowData = _this3.props.rowGetter(action === 'COPY_PASTE' ? originRow : fromRow);
	    var fromRowId = fromRowData[_this3.props.rowKey];
	    var toRowId = _this3.props.rowGetter(toRow)[_this3.props.rowKey];
	    _this3.props.onGridRowsUpdated({ cellKey: cellKey, fromRow: fromRow, toRow: toRow, fromRowId: fromRowId, toRowId: toRowId, rowIds: rowIds, updated: updated, action: action, fromRowData: fromRowData });
	  };

	  this.onCellCommit = function (commit) {
	    var selected = Object.assign({}, _this3.state.selected);
	    selected.active = false;
	    var expandedRows = _this3.state.expandedRows;
	    // if(commit.changed && commit.changed.expandedHeight){
	    //   expandedRows = this.expandRow(commit.rowIdx, commit.changed.expandedHeight);
	    // }
	    _this3.setState({ selected: selected, expandedRows: expandedRows });

	    if (_this3.props.onRowUpdated) {
	      _this3.props.onRowUpdated(commit);
	    }

	    var targetRow = commit.rowIdx;

	    if (_this3.props.onGridRowsUpdated) {
	      _this3.onGridRowsUpdated(commit.cellKey, targetRow, targetRow, commit.updated, _AppConstants2['default'].UpdateActions.CELL_UPDATE);
	    }
	  };

	  this.onDragStart = function (e) {
	    var idx = _this3.state.selected.idx;
	    // To prevent dragging down/up when reordering rows.
	    var isViewportDragging = e && e.target && e.target.className;
	    if (idx > -1 && isViewportDragging) {
	      var _value2 = _this3.getSelectedValue();
	      _this3.handleDragStart({ idx: _this3.state.selected.idx, rowIdx: _this3.state.selected.rowIdx, value: _value2 });
	      // need to set dummy data for FF
	      if (e && e.dataTransfer) {
	        if (e.dataTransfer.setData) {
	          e.dataTransfer.dropEffect = 'move';
	          e.dataTransfer.effectAllowed = 'move';
	          e.dataTransfer.setData('text/plain', '');
	        }
	      }
	    }
	  };

	  this.onToggleFilter = function () {
	    // setState() does not immediately mutate this.state but creates a pending state transition.
	    // Therefore if you want to do something after the state change occurs, pass it in as a callback function.
	    _this3.setState({ canFilter: !_this3.state.canFilter }, function () {
	      if (_this3.state.canFilter === false && _this3.props.onClearFilters) {
	        _this3.props.onClearFilters();
	      }
	    });
	  };

	  this.onDragHandleDoubleClick = function (e) {
	    if (_this3.props.onDragHandleDoubleClick) {
	      _this3.props.onDragHandleDoubleClick(e);
	    }

	    if (_this3.props.onGridRowsUpdated) {
	      var _this3$onGridRowsUpda;

	      var cellKey = _this3.getColumn(e.idx).key;
	      _this3.onGridRowsUpdated(cellKey, e.rowIdx, _this3.props.rowsCount - 1, (_this3$onGridRowsUpda = {}, _this3$onGridRowsUpda[cellKey] = e.rowData[cellKey], _this3$onGridRowsUpda), _AppConstants2['default'].UpdateActions.COLUMN_FILL);
	    }
	  };

	  this.onCellExpand = function (args) {
	    if (_this3.props.onCellExpand) {
	      _this3.props.onCellExpand(args);
	    }
	  };

	  this.onRowExpandToggle = function (args) {
	    if (typeof _this3.props.onRowExpandToggle === 'function') {
	      _this3.props.onRowExpandToggle(args);
	    }
	  };

	  this.isCellWithinBounds = function (_ref) {
	    var idx = _ref.idx,
	        rowIdx = _ref.rowIdx;

	    return idx >= 0 && rowIdx >= 0 && idx < ColumnUtils.getSize(_this3.state.columnMetrics.columns) && rowIdx < _this3.props.rowsCount;
	  };

	  this.handleDragStart = function (dragged) {
	    if (!_this3.dragEnabled()) {
	      return;
	    }
	    if (_this3.isCellWithinBounds(dragged)) {
	      _this3.setState({ dragged: dragged });
	    }
	  };

	  this.handleDragEnd = function () {
	    if (!_this3.dragEnabled()) {
	      return;
	    }
	    var _state = _this3.state,
	        selected = _state.selected,
	        dragged = _state.dragged;

	    var column = _this3.getColumn(_this3.state.selected.idx);
	    if (selected && dragged && column) {
	      var cellKey = column.key;
	      var fromRow = selected.rowIdx < dragged.overRowIdx ? selected.rowIdx : dragged.overRowIdx;
	      var toRow = selected.rowIdx > dragged.overRowIdx ? selected.rowIdx : dragged.overRowIdx;
	      if (_this3.props.onCellsDragged) {
	        _this3.props.onCellsDragged({ cellKey: cellKey, fromRow: fromRow, toRow: toRow, value: dragged.value });
	      }
	      if (_this3.props.onGridRowsUpdated) {
	        var _this3$onGridRowsUpda2;

	        _this3.onGridRowsUpdated(cellKey, fromRow, toRow, (_this3$onGridRowsUpda2 = {}, _this3$onGridRowsUpda2[cellKey] = dragged.value, _this3$onGridRowsUpda2), _AppConstants2['default'].UpdateActions.CELL_DRAG);
	      }
	    }
	    _this3.setState({ dragged: { complete: true } });
	  };

	  this.handleDragEnter = function (row) {
	    if (!_this3.dragEnabled() || _this3.state.dragged == null) {
	      return;
	    }
	    var dragged = _this3.state.dragged;
	    dragged.overRowIdx = row;
	    _this3.setState({ dragged: dragged });
	  };

	  this.handleTerminateDrag = function () {
	    if (!_this3.dragEnabled()) {
	      return;
	    }
	    _this3.setState({ dragged: null });
	  };

	  this.handlePaste = function () {
	    if (!_this3.copyPasteEnabled() || !_this3.state.copied) {
	      return;
	    }
	    var selected = _this3.state.selected;
	    var cellKey = _this3.getColumn(_this3.state.selected.idx).key;
	    var textToCopy = _this3.state.textToCopy;
	    var fromRow = _this3.state.copied.rowIdx;
	    var toRow = selected.rowIdx;

	    if (_this3.props.onCellCopyPaste) {
	      _this3.props.onCellCopyPaste({ cellKey: cellKey, rowIdx: toRow, value: textToCopy, fromRow: fromRow, toRow: toRow });
	    }

	    if (_this3.props.onGridRowsUpdated) {
	      var _this3$onGridRowsUpda3;

	      _this3.onGridRowsUpdated(cellKey, toRow, toRow, (_this3$onGridRowsUpda3 = {}, _this3$onGridRowsUpda3[cellKey] = textToCopy, _this3$onGridRowsUpda3), _AppConstants2['default'].UpdateActions.COPY_PASTE, fromRow);
	    }
	  };

	  this.handleCancelCopy = function () {
	    _this3.setState({ copied: null });
	  };

	  this.handleCopy = function (args) {
	    if (!_this3.copyPasteEnabled()) {
	      return;
	    }
	    var textToCopy = args.value;
	    var selected = _this3.state.selected;
	    var copied = { idx: selected.idx, rowIdx: selected.rowIdx };
	    _this3.setState({ textToCopy: textToCopy, copied: copied });
	  };

	  this.handleSort = function (columnKey, direction) {
	    _this3.setState({ sortDirection: direction, sortColumn: columnKey }, function () {
	      this.props.onGridSort(columnKey, direction);
	    });
	  };

	  this.getSelectedRow = function (rows, key) {
	    var selectedRow = rows.filter(function (r) {
	      if (r[_this3.props.rowKey] === key) {
	        return true;
	      }
	      return false;
	    });
	    if (selectedRow.length > 0) {
	      return selectedRow[0];
	    }
	  };

	  this.useNewRowSelection = function () {
	    return _this3.props.rowSelection && _this3.props.rowSelection.selectBy;
	  };

	  this.handleShiftSelect = function (rowIdx) {
	    if (_this3.state.lastRowIdxUiSelected > -1 && _this3.isSingleKeyDown(KeyCodes.Shift)) {
	      var _props$rowSelection$s = _this3.props.rowSelection.selectBy,
	          keys = _props$rowSelection$s.keys,
	          indexes = _props$rowSelection$s.indexes,
	          isSelectedKey = _props$rowSelection$s.isSelectedKey;

	      var isPreviouslySelected = RowUtils.isRowSelected(keys, indexes, isSelectedKey, _this3.props.rowGetter(rowIdx), rowIdx);

	      if (isPreviouslySelected) return false;

	      var handled = false;

	      if (rowIdx > _this3.state.lastRowIdxUiSelected) {
	        var rowsSelected = [];

	        for (var i = _this3.state.lastRowIdxUiSelected + 1; i <= rowIdx; i++) {
	          rowsSelected.push({ rowIdx: i, row: _this3.props.rowGetter(i) });
	        }

	        if (typeof _this3.props.rowSelection.onRowsSelected === 'function') {
	          _this3.props.rowSelection.onRowsSelected(rowsSelected);
	        }

	        handled = true;
	      } else if (rowIdx < _this3.state.lastRowIdxUiSelected) {
	        var _rowsSelected = [];

	        for (var _i = rowIdx; _i <= _this3.state.lastRowIdxUiSelected - 1; _i++) {
	          _rowsSelected.push({ rowIdx: _i, row: _this3.props.rowGetter(_i) });
	        }

	        if (typeof _this3.props.rowSelection.onRowsSelected === 'function') {
	          _this3.props.rowSelection.onRowsSelected(_rowsSelected);
	        }

	        handled = true;
	      }

	      if (handled) {
	        _this3.setState({ lastRowIdxUiSelected: rowIdx });
	      }

	      return handled;
	    }

	    return false;
	  };

	  this.handleNewRowSelect = function (rowIdx, rowData) {
	    if (_this3.selectAllCheckbox && _this3.selectAllCheckbox.checked === true) {
	      _this3.selectAllCheckbox.checked = false;
	    }

	    var _props$rowSelection$s2 = _this3.props.rowSelection.selectBy,
	        keys = _props$rowSelection$s2.keys,
	        indexes = _props$rowSelection$s2.indexes,
	        isSelectedKey = _props$rowSelection$s2.isSelectedKey;

	    var isPreviouslySelected = RowUtils.isRowSelected(keys, indexes, isSelectedKey, rowData, rowIdx);

	    _this3.setState({ lastRowIdxUiSelected: isPreviouslySelected ? -1 : rowIdx, selected: { rowIdx: rowIdx, idx: 0 } });

	    if (isPreviouslySelected && typeof _this3.props.rowSelection.onRowsDeselected === 'function') {
	      _this3.props.rowSelection.onRowsDeselected([{ rowIdx: rowIdx, row: rowData }]);
	    } else if (!isPreviouslySelected && typeof _this3.props.rowSelection.onRowsSelected === 'function') {
	      _this3.props.rowSelection.onRowsSelected([{ rowIdx: rowIdx, row: rowData }]);
	    }
	  };

	  this.handleRowSelect = function (rowIdx, columnKey, rowData, e) {
	    e.stopPropagation();

	    if (_this3.useNewRowSelection()) {
	      if (_this3.props.rowSelection.enableShiftSelect === true) {
	        if (!_this3.handleShiftSelect(rowIdx)) {
	          _this3.handleNewRowSelect(rowIdx, rowData);
	        }
	      } else {
	        _this3.handleNewRowSelect(rowIdx, rowData);
	      }
	    } else {
	      // Fallback to old onRowSelect handler
	      var selectedRows = _this3.props.enableRowSelect === 'single' ? [] : _this3.state.selectedRows.slice(0);
	      var selectedRow = _this3.getSelectedRow(selectedRows, rowData[_this3.props.rowKey]);
	      if (selectedRow) {
	        selectedRow.isSelected = !selectedRow.isSelected;
	      } else {
	        rowData.isSelected = true;
	        selectedRows.push(rowData);
	      }
	      _this3.setState({ selectedRows: selectedRows, selected: { rowIdx: rowIdx, idx: 0 } });
	      if (_this3.props.onRowSelect) {
	        _this3.props.onRowSelect(selectedRows.filter(function (r) {
	          return r.isSelected === true;
	        }));
	      }
	    }
	  };

	  this.handleCheckboxChange = function (e) {
	    var allRowsSelected = void 0;
	    if (e.currentTarget instanceof HTMLInputElement && e.currentTarget.checked === true) {
	      allRowsSelected = true;
	    } else {
	      allRowsSelected = false;
	    }
	    if (_this3.useNewRowSelection()) {
	      var _props$rowSelection$s3 = _this3.props.rowSelection.selectBy,
	          keys = _props$rowSelection$s3.keys,
	          indexes = _props$rowSelection$s3.indexes,
	          isSelectedKey = _props$rowSelection$s3.isSelectedKey;


	      if (allRowsSelected && typeof _this3.props.rowSelection.onRowsSelected === 'function') {
	        var selectedRows = [];
	        for (var i = 0; i < _this3.props.rowsCount; i++) {
	          var rowData = _this3.props.rowGetter(i);
	          if (!RowUtils.isRowSelected(keys, indexes, isSelectedKey, rowData, i)) {
	            selectedRows.push({ rowIdx: i, row: rowData });
	          }
	        }

	        if (selectedRows.length > 0) {
	          _this3.props.rowSelection.onRowsSelected(selectedRows);
	        }
	      } else if (!allRowsSelected && typeof _this3.props.rowSelection.onRowsDeselected === 'function') {
	        var deselectedRows = [];
	        for (var _i2 = 0; _i2 < _this3.props.rowsCount; _i2++) {
	          var _rowData = _this3.props.rowGetter(_i2);
	          if (RowUtils.isRowSelected(keys, indexes, isSelectedKey, _rowData, _i2)) {
	            deselectedRows.push({ rowIdx: _i2, row: _rowData });
	          }
	        }

	        if (deselectedRows.length > 0) {
	          _this3.props.rowSelection.onRowsDeselected(deselectedRows);
	        }
	      }
	    } else {
	      var _selectedRows = [];
	      for (var _i3 = 0; _i3 < _this3.props.rowsCount; _i3++) {
	        var row = Object.assign({}, _this3.props.rowGetter(_i3), { isSelected: allRowsSelected });
	        _selectedRows.push(row);
	      }
	      _this3.setState({ selectedRows: _selectedRows });
	      if (typeof _this3.props.onRowSelect === 'function') {
	        _this3.props.onRowSelect(_selectedRows.filter(function (r) {
	          return r.isSelected === true;
	        }));
	      }
	    }
	  };

	  this.getScrollOffSet = function () {
	    var scrollOffset = 0;
	    if (_this3.grid) {
	      var canvas = _this3.grid.querySelector('.react-grid-Canvas');
	      if (canvas) {
	        scrollOffset = canvas.offsetWidth - canvas.clientWidth;
	      }
	    }
	    _this3.setState({ scrollOffset: scrollOffset });
	  };

	  this.getRowOffsetHeight = function () {
	    var offsetHeight = 0;
	    _this3.getHeaderRows().forEach(function (row) {
	      return offsetHeight += parseFloat(row.height, 10);
	    });
	    return offsetHeight;
	  };

	  this.getHeaderRows = function () {
	    var rows = [{ ref: function ref(node) {
	        return _this3.row = node;
	      }, height: _this3.props.headerRowHeight || _this3.props.rowHeight, rowType: 'header' }];
	    if (_this3.state.canFilter === true) {
	      rows.push({
	        ref: function ref(node) {
	          return _this3.filterRow = node;
	        },
	        filterable: true,
	        onFilterChange: _this3.props.onAddFilter,
	        height: _this3.props.headerFiltersHeight,
	        rowType: 'filter'
	      });
	    }
	    return rows;
	  };

	  this.getInitialSelectedRows = function () {
	    var selectedRows = [];
	    for (var i = 0; i < _this3.props.rowsCount; i++) {
	      selectedRows.push(false);
	    }
	    return selectedRows;
	  };

	  this.getRowSelectionProps = function () {
	    if (_this3.props.rowSelection) {
	      return _this3.props.rowSelection.selectBy;
	    }

	    return null;
	  };

	  this.getSelectedRows = function () {
	    if (_this3.props.rowSelection) {
	      return null;
	    }

	    return _this3.state.selectedRows.filter(function (r) {
	      return r.isSelected === true;
	    });
	  };

	  this.getSelectedValue = function () {
	    var rowIdx = _this3.state.selected.rowIdx;
	    var idx = _this3.state.selected.idx;
	    var cellKey = _this3.getColumn(idx).key;
	    var row = _this3.props.rowGetter(rowIdx);
	    return RowUtils.get(row, cellKey);
	  };

	  this.canExitGrid = function (e) {
	    // When the cellNavigationMode is 'none', you can exit the grid if you're at the start or end of the row
	    // When the cellNavigationMode is 'changeRow', you can exit the grid if you're at the first or last cell of the grid
	    // When the cellNavigationMode is 'loopOverRow', there is no logical exit point so you can't exit the grid
	    var atLastCellInRow = _this3.isAtLastCellInRow(_this3.getNbrColumns());
	    var atFirstCellInRow = _this3.isAtFirstCellInRow();
	    var atLastRow = _this3.isAtLastRow();
	    var atFirstRow = _this3.isAtFirstRow();
	    var shift = e.shiftKey === true;
	    var cellNavigationMode = _this3.props.cellNavigationMode;

	    if (shift) {
	      if (cellNavigationMode === 'none') {
	        if (atFirstCellInRow) {
	          return true;
	        }
	      } else if (cellNavigationMode === 'changeRow') {
	        if (atFirstCellInRow && atFirstRow) {
	          return true;
	        }
	      }
	    } else {
	      if (cellNavigationMode === 'none') {
	        if (atLastCellInRow) {
	          return true;
	        }
	      } else if (cellNavigationMode === 'changeRow') {
	        if (atLastCellInRow && atLastRow) {
	          return true;
	        }
	      }
	    }
	    return false;
	  };

	  this.moveSelectedCell = function (e, rowDelta, cellDelta) {
	    // we need to prevent default as we control grid scroll
	    // otherwise it moves every time you left/right which is janky
	    e.preventDefault();
	    var rowIdx = void 0;
	    var idx = void 0;
	    var cellNavigationMode = _this3.props.cellNavigationMode;

	    if (cellNavigationMode !== 'none') {
	      var _calculateNextSelecti = _this3.calculateNextSelectionPosition(cellNavigationMode, cellDelta, rowDelta);

	      idx = _calculateNextSelecti.idx;
	      rowIdx = _calculateNextSelecti.rowIdx;
	    } else {
	      rowIdx = _this3.state.selected.rowIdx + rowDelta;
	      idx = _this3.state.selected.idx + cellDelta;
	    }
	    _this3.scrollToColumn(idx);
	    _this3.onSelect({ idx: idx, rowIdx: rowIdx });
	  };

	  this.getNbrColumns = function () {
	    var _props = _this3.props,
	        columns = _props.columns,
	        enableRowSelect = _props.enableRowSelect;

	    return enableRowSelect ? columns.length + 1 : columns.length;
	  };

	  this.getDataGridDOMNode = function () {
	    return _this3.grid;
	  };

	  this.calculateNextSelectionPosition = function (cellNavigationMode, cellDelta, rowDelta) {
	    var _rowDelta = rowDelta;
	    var idx = _this3.state.selected.idx + cellDelta;
	    var nbrColumns = _this3.getNbrColumns();
	    if (cellDelta > 0) {
	      if (_this3.isAtLastCellInRow(nbrColumns)) {
	        if (cellNavigationMode === 'changeRow') {
	          _rowDelta = _this3.isAtLastRow() ? rowDelta : rowDelta + 1;
	          idx = _this3.isAtLastRow() ? idx : 0;
	        } else {
	          idx = 0;
	        }
	      }
	    } else if (cellDelta < 0) {
	      if (_this3.isAtFirstCellInRow()) {
	        if (cellNavigationMode === 'changeRow') {
	          _rowDelta = _this3.isAtFirstRow() ? rowDelta : rowDelta - 1;
	          idx = _this3.isAtFirstRow() ? 0 : nbrColumns - 1;
	        } else {
	          idx = nbrColumns - 1;
	        }
	      }
	    }
	    var rowIdx = _this3.state.selected.rowIdx + _rowDelta;
	    return { idx: idx, rowIdx: rowIdx };
	  };

	  this.isAtLastCellInRow = function (nbrColumns) {
	    return _this3.state.selected.idx === nbrColumns - 1;
	  };

	  this.isAtLastRow = function () {
	    return _this3.state.selected.rowIdx === _this3.props.rowsCount - 1;
	  };

	  this.isAtFirstCellInRow = function () {
	    return _this3.state.selected.idx === 0;
	  };

	  this.isAtFirstRow = function () {
	    return _this3.state.selected.rowIdx === 0;
	  };

	  this.openCellEditor = function (rowIdx, idx) {
	    var row = _this3.props.rowGetter(rowIdx);
	    var col = _this3.getColumn(idx);

	    if (!ColumnUtils.canEdit(col, row, _this3.props.enableCellSelect)) {
	      return;
	    }

	    var selected = { rowIdx: rowIdx, idx: idx };
	    if (_this3.hasSelectedCellChanged(selected)) {
	      _this3.setState({ selected: selected }, function () {
	        _this3.setActive('Enter');
	      });
	    } else {
	      _this3.setActive('Enter');
	    }
	  };

	  this.scrollToColumn = function (colIdx) {
	    if (_this3.grid) {
	      var canvas = _this3.grid.querySelector('.react-grid-Canvas');
	      if (canvas) {
	        var left = 0;
	        var locked = 0;

	        for (var i = 0; i < colIdx; i++) {
	          var column = _this3.getColumn(i);
	          if (column) {
	            if (column.width) {
	              left += column.width;
	            }
	            if (column.locked) {
	              locked += column.width;
	            }
	          }
	        }

	        var selectedColumn = _this3.getColumn(colIdx);
	        if (selectedColumn) {
	          var scrollLeft = left - locked - canvas.scrollLeft;
	          var scrollRight = left + selectedColumn.width - canvas.scrollLeft;

	          if (scrollLeft < 0) {
	            canvas.scrollLeft += scrollLeft;
	          } else if (scrollRight > canvas.clientWidth) {
	            var scrollAmount = scrollRight - canvas.clientWidth;
	            canvas.scrollLeft += scrollAmount;
	          }
	        }
	      }
	    }
	  };

	  this.deselect = function () {
	    var selected = { rowIdx: -1, idx: -1 };
	    _this3.setState({ selected: selected });
	  };

	  this.setActive = function (keyPressed) {
	    var rowIdx = _this3.state.selected.rowIdx;
	    var row = _this3.props.rowGetter(rowIdx);

	    var idx = _this3.state.selected.idx;
	    var column = _this3.getColumn(idx);

	    if (ColumnUtils.canEdit(column, row, _this3.props.enableCellSelect) && !_this3.isActive()) {
	      var selected = Object.assign({}, _this3.state.selected, { idx: idx, rowIdx: rowIdx, active: true, initialKeyCode: keyPressed });
	      var showEditor = true;
	      if (typeof _this3.props.onCheckCellIsEditable === 'function') {
	        var args = Object.assign({}, { row: row, column: column }, selected);
	        showEditor = _this3.props.onCheckCellIsEditable(args);
	      }
	      if (showEditor !== false) {
	        if (column.locked) {
	          _this3.setState({ selected: selected });
	        } else {
	          _this3.setState({ selected: selected }, function () {
	            _this3.scrollToColumn(idx);
	          });
	        }
	        _this3.props.onBeforeEdit();
	        _this3.handleCancelCopy();
	      }
	    }
	  };

	  this.setInactive = function () {
	    var rowIdx = _this3.state.selected.rowIdx;
	    var row = _this3.props.rowGetter(rowIdx);

	    var idx = _this3.state.selected.idx;
	    var col = _this3.getColumn(idx);

	    if (ColumnUtils.canEdit(col, row, _this3.props.enableCellSelect) && _this3.isActive()) {
	      var selected = Object.assign({}, _this3.state.selected, { idx: idx, rowIdx: rowIdx, active: false });
	      _this3.setState({ selected: selected });
	    }
	  };

	  this.isActive = function () {
	    return _this3.state.selected.active === true;
	  };

	  this.setupGridColumns = function () {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this3.props;
	    var columns = props.columns;

	    if (_this3._cachedColumns === columns) {
	      return _this3._cachedComputedColumns;
	    }

	    _this3._cachedColumns = columns;

	    var cols = columns.slice(0);
	    var unshiftedCols = {};
	    if (_this3.props.rowActionsCell || props.enableRowSelect && !_this3.props.rowSelection || props.rowSelection && props.rowSelection.showCheckbox !== false) {
	      var SelectAllComponent = _this3.props.selectAllRenderer || _SelectAll2['default'];
	      var SelectAllRenderer = React.createElement(SelectAllComponent, { onChange: _this3.handleCheckboxChange, inputRef: function inputRef(grid) {
	          return _this3.selectAllCheckbox = grid;
	        } });
	      var headerRenderer = props.enableRowSelect === 'single' ? null : SelectAllRenderer;
	      var Formatter = _this3.props.rowActionsCell ? _this3.props.rowActionsCell : CheckboxEditor;
	      var selectColumn = {
	        key: 'select-row',
	        name: '',
	        formatter: React.createElement(Formatter, { rowSelection: _this3.props.rowSelection }),
	        onCellChange: _this3.handleRowSelect,
	        filterable: false,
	        headerRenderer: headerRenderer,
	        width: 60,
	        locked: true,
	        getRowMetaData: function getRowMetaData(rowData) {
	          return rowData;
	        },
	        cellClass: _this3.props.rowActionsCell ? 'rdg-row-actions-cell' : ''
	      };
	      unshiftedCols = cols.unshift(selectColumn);
	      cols = unshiftedCols > 0 ? cols : unshiftedCols;
	    }
	    _this3._cachedComputedColumns = cols;

	    return _this3._cachedComputedColumns;
	  };

	  this.copyPasteEnabled = function () {
	    return _this3.props.onCellCopyPaste !== null;
	  };

	  this.dragEnabled = function () {
	    return _this3.props.onGridRowsUpdated !== undefined || _this3.props.onCellsDragged !== undefined;
	  };

	  this.renderToolbar = function () {
	    var Toolbar = _this3.props.toolbar;
	    var toolBarProps = { columns: _this3.props.columns, onToggleFilter: _this3.onToggleFilter, numberOfRows: _this3.props.rowsCount };
	    if (React.isValidElement(Toolbar)) {
	      return React.cloneElement(Toolbar, toolBarProps);
	    } else if (isFunction(Toolbar)) {
	      return React.createElement(Toolbar, toolBarProps);
	    }
	  };
	};

	module.exports = ReactDataGrid;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var React = __webpack_require__(2);
	var Draggable = __webpack_require__(110);
	__webpack_require__(16);

	var style = {
	  position: 'absolute',
	  top: 0,
	  right: 0,
	  width: 6,
	  height: '100%'
	};

	var ResizeHandle = function (_React$Component) {
	  _inherits(ResizeHandle, _React$Component);

	  function ResizeHandle() {
	    _classCallCheck(this, ResizeHandle);

	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }

	  ResizeHandle.prototype.render = function render() {
	    return React.createElement(Draggable, _extends({}, this.props, {
	      className: 'react-grid-HeaderCell__resizeHandle',
	      style: style
	    }));
	  };

	  return ResizeHandle;
	}(React.Component);

	module.exports = ResizeHandle;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _propTypes = __webpack_require__(3);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	var _utils = __webpack_require__(54);

	var _utils2 = _interopRequireDefault(_utils);

	__webpack_require__(30);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var cellMetaDataShape = __webpack_require__(12);

	var RowGroup = function (_Component) {
	  _inherits(RowGroup, _Component);

	  function RowGroup(props) {
	    _classCallCheck(this, RowGroup);

	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

	    _this.onRowExpandToggle = _this.onRowExpandToggle.bind(_this);
	    _this.onRowExpandClick = _this.onRowExpandClick.bind(_this);
	    _this.setScrollLeft = _this.setScrollLeft.bind(_this);
	    return _this;
	  }

	  RowGroup.prototype.onRowExpandToggle = function onRowExpandToggle(expand) {
	    var shouldExpand = expand == null ? !this.props.isExpanded : expand;
	    var meta = this.props.cellMetaData;
	    if (meta != null && meta.onRowExpandToggle && typeof meta.onRowExpandToggle === 'function') {
	      meta.onRowExpandToggle({ rowIdx: this.props.idx, shouldExpand: shouldExpand, columnGroupName: this.props.columnGroupName, name: this.props.name });
	    }
	  };

	  RowGroup.prototype.onRowExpandClick = function onRowExpandClick() {
	    this.onRowExpandToggle(!this.props.isExpanded);
	  };

	  RowGroup.prototype.setScrollLeft = function setScrollLeft(scrollLeft) {
	    if (this.rowGroupRenderer) {
	      this.rowGroupRenderer.setScrollLeft ? this.rowGroupRenderer.setScrollLeft(scrollLeft) : null;
	    }
	  };

	  RowGroup.prototype.render = function render() {
	    var _this2 = this;

	    var lastColumn = _utils2['default'].last(this.props.columns);

	    var style = { width: lastColumn.left + lastColumn.width };

	    return _react2['default'].createElement(
	      'div',
	      { style: style, className: 'react-grid-row-group' },
	      _react2['default'].createElement(this.props.renderer, _extends({ ref: function ref(node) {
	          _this2.rowGroupRenderer = node;
	        } }, this.props, { onRowExpandClick: this.onRowExpandClick, onRowExpandToggle: this.onRowExpandToggle }))
	    );
	  };

	  return RowGroup;
	}(_react.Component);

	RowGroup.propTypes = {
	  height: _propTypes2['default'].number.isRequired,
	  columns: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].array]).isRequired,
	  row: _propTypes2['default'].any.isRequired,
	  cellRenderer: _propTypes2['default'].func,
	  cellMetaData: _propTypes2['default'].shape(cellMetaDataShape),
	  isSelected: _propTypes2['default'].bool,
	  idx: _propTypes2['default'].number.isRequired,
	  expandedRows: _propTypes2['default'].arrayOf(_propTypes2['default'].object),
	  extraClasses: _propTypes2['default'].string,
	  forceUpdate: _propTypes2['default'].bool,
	  subRowDetails: _propTypes2['default'].object,
	  isRowHovered: _propTypes2['default'].bool,
	  colVisibleStart: _propTypes2['default'].number.isRequired,
	  colVisibleEnd: _propTypes2['default'].number.isRequired,
	  colDisplayStart: _propTypes2['default'].number.isRequired,
	  colDisplayEnd: _propTypes2['default'].number.isRequired,
	  isScrolling: _propTypes2['default'].bool.isRequired,
	  columnGroupName: _propTypes2['default'].string.isRequired,
	  isExpanded: _propTypes2['default'].bool.isRequired,
	  treeDepth: _propTypes2['default'].number.isRequired,
	  name: _propTypes2['default'].string.isRequired,
	  renderer: _propTypes2['default'].func
	};

	var DefaultRowGroupRenderer = function DefaultRowGroupRenderer(props) {
	  var treeDepth = props.treeDepth || 0;
	  var marginLeft = treeDepth * 20;

	  var style = {
	    height: '50px',
	    border: '1px solid #dddddd',
	    paddingTop: '15px',
	    paddingLeft: '5px'
	  };

	  var onKeyDown = function onKeyDown(e) {
	    if (e.key === 'ArrowLeft') {
	      props.onRowExpandToggle(false);
	    }
	    if (e.key === 'ArrowRight') {
	      props.onRowExpandToggle(true);
	    }
	    if (e.key === 'Enter') {
	      props.onRowExpandToggle(!props.isExpanded);
	    }
	  };
	  return _react2['default'].createElement(
	    'div',
	    { style: style, onKeyDown: onKeyDown, tabIndex: 0 },
	    _react2['default'].createElement(
	      'span',
	      { className: 'row-expand-icon', style: { float: 'left', marginLeft: marginLeft, cursor: 'pointer' }, onClick: props.onRowExpandClick },
	      props.isExpanded ? String.fromCharCode('9660') : String.fromCharCode('9658')
	    ),
	    _react2['default'].createElement(
	      'strong',
	      null,
	      props.columnGroupName,
	      ': ',
	      props.name
	    )
	  );
	};

	DefaultRowGroupRenderer.propTypes = {
	  onRowExpandClick: _propTypes2['default'].func.isRequired,
	  onRowExpandToggle: _propTypes2['default'].func.isRequired,
	  isExpanded: _propTypes2['default'].bool.isRequired,
	  treeDepth: _propTypes2['default'].number.isRequired,
	  name: _propTypes2['default'].string.isRequired,
	  columnGroupName: _propTypes2['default'].string.isRequired,
	  hideColumnName: _propTypes2['default'].bool
	};

	RowGroup.defaultProps = {
	  renderer: DefaultRowGroupRenderer
	};

	exports['default'] = RowGroup;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _propTypes = __webpack_require__(3);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	var _ColumnUtils = __webpack_require__(7);

	var _ColumnUtils2 = _interopRequireDefault(_ColumnUtils);

	var _viewportUtils = __webpack_require__(138);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var React = __webpack_require__(2);
	var Canvas = __webpack_require__(105);
	var cellMetaDataShape = __webpack_require__(12);

	var Viewport = function (_React$Component) {
	  _inherits(Viewport, _React$Component);

	  function Viewport() {
	    var _temp, _this, _ret;

	    _classCallCheck(this, Viewport);

	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }

	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = (0, _viewportUtils.getGridState)(_this.props), _this.onScroll = function (scroll) {
	      _this.updateScroll(scroll.scrollTop, scroll.scrollLeft, _this.state.height, _this.props.rowHeight, _this.props.rowsCount);

	      if (_this.props.onScroll) {
	        _this.props.onScroll({ scrollTop: scroll.scrollTop, scrollLeft: scroll.scrollLeft });
	      }
	    }, _this.getScroll = function () {
	      return _this.canvas.getScroll();
	    }, _this.setScrollLeft = function (scrollLeft) {
	      _this.canvas.setScrollLeft(scrollLeft);
	    }, _this.getDOMNodeOffsetWidth = function () {
	      return _this.viewport ? _this.viewport.offsetWidth : 0;
	    }, _this.clearScrollTimer = function () {
	      if (_this.resetScrollStateTimeoutId) {
	        clearTimeout(_this.resetScrollStateTimeoutId);
	      }
	    }, _this.resetScrollStateAfterDelay = function () {
	      _this.clearScrollTimer();
	      _this.resetScrollStateTimeoutId = setTimeout(_this.resetScrollStateAfterDelayCallback, 500);
	    }, _this.resetScrollStateAfterDelayCallback = function () {
	      _this.resetScrollStateTimeoutId = null;
	      _this.setState({
	        isScrolling: false
	      });
	    }, _this.updateScroll = function (scrollTop, scrollLeft, height, rowHeight, length, width) {
	      _this.resetScrollStateAfterDelay();
	      var nextScrollState = (0, _viewportUtils.getNextScrollState)(_this.props, _this.getDOMNodeOffsetWidth, scrollTop, scrollLeft, height, rowHeight, length, width);

	      _this.setState(nextScrollState);
	    }, _this.metricsUpdated = function () {
	      var height = _this.viewportHeight();
	      var width = _this.viewportWidth();
	      if (height) {
	        _this.updateScroll(_this.state.scrollTop, _this.state.scrollLeft, height, _this.props.rowHeight, _this.props.rowsCount, width);
	      }
	    }, _this.viewportHeight = function () {
	      return _this.viewport ? _this.viewport.offsetHeight : 0;
	    }, _this.viewportWidth = function () {
	      return _this.viewport ? _this.viewport.offsetWidth : 0;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }

	  Viewport.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.rowHeight !== nextProps.rowHeight || this.props.minHeight !== nextProps.minHeight) {
	      var newState = (0, _viewportUtils.getGridState)(nextProps);
	      this.updateScroll(newState.scrollTop, newState.scrollLeft, newState.height, nextProps.rowHeight, nextProps.rowsCount);
	    } else if (_ColumnUtils2['default'].getSize(this.props.columnMetrics.columns) !== _ColumnUtils2['default'].getSize(nextProps.columnMetrics.columns)) {
	      this.setState((0, _viewportUtils.getGridState)(nextProps));
	    } else if (this.props.rowsCount !== nextProps.rowsCount) {
	      this.updateScroll(this.state.scrollTop, this.state.scrollLeft, this.state.height, nextProps.rowHeight, nextProps.rowsCount);
	      // Added to fix the hiding of the bottom scrollbar when showing the filters.
	    } else if (this.props.rowOffsetHeight !== nextProps.rowOffsetHeight) {
	      // The value of height can be positive or negative and will be added to the current height to cater for changes in the header height (due to the filer)
	      var height = this.props.rowOffsetHeight - nextProps.rowOffsetHeight;

	      this.updateScroll(this.state.scrollTop, this.state.scrollLeft, this.state.height + height, nextProps.rowHeight, nextProps.rowsCount);
	    }
	  };

	  Viewport.prototype.componentDidMount = function componentDidMount() {
	    if (window.addEventListener) {
	      window.addEventListener('resize', this.metricsUpdated);
	    } else {
	      window.attachEvent('resize', this.metricsUpdated);
	    }
	    this.metricsUpdated();
	  };

	  Viewport.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener('resize', this.metricsUpdated);
	    this.clearScrollTimer();
	  };

	  Viewport.prototype.render = function render() {
	    var _this2 = this;

	    var style = {
	      padding: 0,
	      bottom: 0,
	      left: 0,
	      right: 0,
	      overflow: 'hidden',
	      position: 'absolute',
	      top: this.props.rowOffsetHeight
	    };
	    return React.createElement(
	      'div',
	      {
	        className: 'react-grid-Viewport',
	        style: style,
	        ref: function ref(node) {
	          _this2.viewport = node;
	        } },
	      React.createElement(Canvas, {
	        ref: function ref(node) {
	          return _this2.canvas = node;
	        },
	        rowKey: this.props.rowKey,
	        totalWidth: this.props.totalWidth,
	        width: this.props.columnMetrics.width,
	        rowGetter: this.props.rowGetter,
	        rowsCount: this.props.rowsCount,
	        selectedRows: this.props.selectedRows,
	        expandedRows: this.props.expandedRows,
	        columns: this.props.columnMetrics.columns,
	        rowRenderer: this.props.rowRenderer,
	        displayStart: this.state.displayStart,
	        displayEnd: this.state.displayEnd,
	        visibleStart: this.state.visibleStart,
	        visibleEnd: this.state.visibleEnd,
	        colVisibleStart: this.state.colVisibleStart,
	        colVisibleEnd: this.state.colVisibleEnd,
	        colDisplayStart: this.state.colDisplayStart,
	        colDisplayEnd: this.state.colDisplayEnd,
	        cellMetaData: this.props.cellMetaData,
	        height: this.state.height,
	        rowHeight: this.props.rowHeight,
	        onScroll: this.onScroll,
	        onRows: this.props.onRows,
	        rowScrollTimeout: this.props.rowScrollTimeout,
	        scrollToRowIndex: this.props.scrollToRowIndex,
	        contextMenu: this.props.contextMenu,
	        rowSelection: this.props.rowSelection,
	        getSubRowDetails: this.props.getSubRowDetails,
	        rowGroupRenderer: this.props.rowGroupRenderer,
	        isScrolling: this.state.isScrolling || false
	      })
	    );
	  };

	  return Viewport;
	}(React.Component);

	Viewport.displayName = 'Viewport';
	Viewport.propTypes = {
	  rowOffsetHeight: _propTypes2['default'].number.isRequired,
	  totalWidth: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]).isRequired,
	  columnMetrics: _propTypes2['default'].object.isRequired,
	  rowGetter: _propTypes2['default'].oneOfType([_propTypes2['default'].array, _propTypes2['default'].func]).isRequired,
	  selectedRows: _propTypes2['default'].array,
	  rowSelection: _propTypes2['default'].oneOfType([_propTypes2['default'].shape({
	    indexes: _propTypes2['default'].arrayOf(_propTypes2['default'].number).isRequired
	  }), _propTypes2['default'].shape({
	    isSelectedKey: _propTypes2['default'].string.isRequired
	  }), _propTypes2['default'].shape({
	    keys: _propTypes2['default'].shape({
	      values: _propTypes2['default'].array.isRequired,
	      rowKey: _propTypes2['default'].string.isRequired
	    }).isRequired
	  })]),
	  expandedRows: _propTypes2['default'].array,
	  rowRenderer: _propTypes2['default'].oneOfType([_propTypes2['default'].element, _propTypes2['default'].func]),
	  rowsCount: _propTypes2['default'].number.isRequired,
	  rowHeight: _propTypes2['default'].number.isRequired,
	  onRows: _propTypes2['default'].func,
	  onScroll: _propTypes2['default'].func,
	  minHeight: _propTypes2['default'].number,
	  cellMetaData: _propTypes2['default'].shape(cellMetaDataShape),
	  rowKey: _propTypes2['default'].string.isRequired,
	  rowScrollTimeout: _propTypes2['default'].number,
	  scrollToRowIndex: _propTypes2['default'].number,
	  contextMenu: _propTypes2['default'].element,
	  getSubRowDetails: _propTypes2['default'].func,
	  rowGroupRenderer: _propTypes2['default'].func
	};
	Viewport.defaultProps = {
	  rowHeight: 30
	};


	module.exports = Viewport;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _propTypes = __webpack_require__(3);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var React = __webpack_require__(2);
	var ExcelColumn = __webpack_require__(13);

	var FilterableHeaderCell = function (_React$Component) {
	  _inherits(FilterableHeaderCell, _React$Component);

	  function FilterableHeaderCell() {
	    var _temp, _this, _ret;

	    _classCallCheck(this, FilterableHeaderCell);

	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }

	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = { filterTerm: '' }, _this.handleChange = function (e) {
	      var val = e.target.value;
	      _this.setState({ filterTerm: val });
	      _this.props.onChange({ filterTerm: val, column: _this.props.column });
	    }, _this.renderInput = function () {
	      if (_this.props.column.filterable === false) {
	        return React.createElement('span', null);
	      }

	      var inputKey = 'header-filter-' + _this.props.column.key;
	      return React.createElement('input', { key: inputKey, type: 'text', className: 'form-control input-sm', placeholder: 'Search', value: _this.state.filterTerm, onChange: _this.handleChange });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }

	  FilterableHeaderCell.prototype.render = function render() {
	    return React.createElement(
	      'div',
	      null,
	      React.createElement(
	        'div',
	        { className: 'form-group' },
	        this.renderInput()
	      )
	    );
	  };

	  return FilterableHeaderCell;
	}(React.Component);

	FilterableHeaderCell.propTypes = {
	  onChange: _propTypes2['default'].func.isRequired,
	  column: _propTypes2['default'].shape(ExcelColumn)
	};


	module.exports = FilterableHeaderCell;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _propTypes = __webpack_require__(3);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	var _keyboardUtils = __webpack_require__(56);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var React = __webpack_require__(2);

	var joinClasses = __webpack_require__(6);
	var SimpleTextEditor = __webpack_require__(50);
	var isFunction = __webpack_require__(20);


	__webpack_require__(21);

	var EditorContainer = function (_React$Component) {
	  _inherits(EditorContainer, _React$Component);

	  function EditorContainer() {
	    var _temp, _this, _ret;

	    _classCallCheck(this, EditorContainer);

	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }

	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
	  }

	  EditorContainer.prototype.componentDidMount = function componentDidMount() {
	    var inputNode = this.getInputNode();
	    if (inputNode !== undefined) {
	      this.setTextInputFocus();
	      if (!this.getEditor().disableContainerStyles) {
	        inputNode.className += ' editor-main';
	        inputNode.style.height = this.props.height - 1 + 'px';
	      }
	    }
	  };

	  EditorContainer.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (!this.changeCommitted && !this.changeCanceled) {
	      this.commit({ key: 'Enter' });
	    }
	  };

	  EditorContainer.prototype.render = function render() {
	    return React.createElement(
	      'div',
	      { className: this.getContainerClass(), onBlur: this.handleBlur, onKeyDown: this.onKeyDown, onContextMenu: this.handleRightClick },
	      this.createEditor(),
	      this.renderStatusIcon()
	    );
	  };

	  return EditorContainer;
	}(React.Component);

	EditorContainer.displayName = 'EditorContainer';
	EditorContainer.propTypes = {
	  rowIdx: _propTypes2['default'].number,
	  rowData: _propTypes2['default'].object.isRequired,
	  value: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number, _propTypes2['default'].object, _propTypes2['default'].bool]).isRequired,
	  cellMetaData: _propTypes2['default'].shape({
	    selected: _propTypes2['default'].object.isRequired,
	    copied: _propTypes2['default'].object,
	    dragged: _propTypes2['default'].object,
	    onCellClick: _propTypes2['default'].func,
	    onCellDoubleClick: _propTypes2['default'].func,
	    onCommitCancel: _propTypes2['default'].func,
	    onCommit: _propTypes2['default'].func
	  }).isRequired,
	  column: _propTypes2['default'].object.isRequired,
	  height: _propTypes2['default'].number.isRequired,
	  onGridKeyDown: _propTypes2['default'].func
	};

	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;

	  this.state = { isInvalid: false };
	  this.changeCommitted = false;
	  this.changeCanceled = false;

	  this.isKeyExplicitlyHandled = function (key) {
	    return isFunction(_this2['onPress' + key]);
	  };

	  this.checkAndCall = function (methodName, args) {
	    if (isFunction(_this2[methodName])) {
	      _this2[methodName](args);
	    }
	  };

	  this.onKeyDown = function (e) {
	    if ((0, _keyboardUtils.isCtrlKeyHeldDown)(e)) {
	      _this2.checkAndCall('onPressKeyWithCtrl', e);
	    } else if (_this2.isKeyExplicitlyHandled(e.key)) {
	      // break up individual keyPress events to have their own specific callbacks
	      var callBack = 'onPress' + e.key;
	      _this2.checkAndCall(callBack, e);
	    } else if ((0, _keyboardUtils.isKeyPrintable)(e.keyCode)) {
	      _this2.checkAndCall('onPressChar', e);
	    }

	    // Track which keys are currently down for shift clicking etc
	    _this2._keysDown = _this2._keysDown || {};
	    _this2._keysDown[e.keyCode] = true;
	    if (isFunction(_this2.props.onGridKeyDown)) {
	      _this2.props.onGridKeyDown(e);
	    }
	  };

	  this.createEditorRef = function (ref) {
	    _this2.editor = ref;
	  };

	  this.createEditor = function () {
	    var editorProps = {
	      ref: _this2.createEditorRef,
	      column: _this2.props.column,
	      value: _this2.getInitialValue(),
	      onCommit: _this2.commit,
	      onCommitCancel: _this2.commitCancel,
	      rowMetaData: _this2.getRowMetaData(),
	      rowData: _this2.props.rowData,
	      height: _this2.props.height,
	      onBlur: _this2.commit,
	      onOverrideKeyDown: _this2.onKeyDown
	    };

	    var CustomEditor = _this2.props.column.editor;
	    // return custom column editor or SimpleEditor if none specified
	    if (React.isValidElement(CustomEditor)) {
	      return React.cloneElement(CustomEditor, editorProps);
	    }
	    if (isFunction(CustomEditor)) {
	      return React.createElement(CustomEditor, _extends({ ref: _this2.createEditorRef }, editorProps));
	    }

	    return React.createElement(SimpleTextEditor, { ref: _this2.createEditorRef, column: _this2.props.column, value: _this2.getInitialValue(), onBlur: _this2.commit, rowMetaData: _this2.getRowMetaData(), onKeyDown: function onKeyDown() {}, commit: function commit() {} });
	  };

	  this.onPressEnter = function () {
	    _this2.commit({ key: 'Enter' });
	  };

	  this.onPressTab = function () {
	    _this2.commit({ key: 'Tab' });
	  };

	  this.onPressEscape = function (e) {
	    if (!_this2.editorIsSelectOpen()) {
	      _this2.commitCancel();
	    } else {
	      // prevent event from bubbling if editor has results to select
	      e.stopPropagation();
	    }
	  };

	  this.onPressArrowDown = function (e) {
	    if (_this2.editorHasResults()) {
	      // dont want to propogate as that then moves us round the grid
	      e.stopPropagation();
	    } else {
	      _this2.commit(e);
	    }
	  };

	  this.onPressArrowUp = function (e) {
	    if (_this2.editorHasResults()) {
	      // dont want to propogate as that then moves us round the grid
	      e.stopPropagation();
	    } else {
	      _this2.commit(e);
	    }
	  };

	  this.onPressArrowLeft = function (e) {
	    // prevent event propogation. this disables left cell navigation
	    if (!_this2.isCaretAtBeginningOfInput()) {
	      e.stopPropagation();
	    } else {
	      _this2.commit(e);
	    }
	  };

	  this.onPressArrowRight = function (e) {
	    // prevent event propogation. this disables right cell navigation
	    if (!_this2.isCaretAtEndOfInput()) {
	      e.stopPropagation();
	    } else {
	      _this2.commit(e);
	    }
	  };

	  this.editorHasResults = function () {
	    if (isFunction(_this2.getEditor().hasResults)) {
	      return _this2.getEditor().hasResults();
	    }

	    return false;
	  };

	  this.editorIsSelectOpen = function () {
	    if (isFunction(_this2.getEditor().isSelectOpen)) {
	      return _this2.getEditor().isSelectOpen();
	    }

	    return false;
	  };

	  this.getRowMetaData = function () {
	    // clone row data so editor cannot actually change this
	    // convention based method to get corresponding Id or Name of any Name or Id property
	    if (typeof _this2.props.column.getRowMetaData === 'function') {
	      return _this2.props.column.getRowMetaData(_this2.props.rowData, _this2.props.column);
	    }
	  };

	  this.getEditor = function () {
	    return _this2.editor;
	  };

	  this.getInputNode = function () {
	    return _this2.getEditor().getInputNode();
	  };

	  this.getInitialValue = function () {
	    var selected = _this2.props.cellMetaData.selected;
	    var keyCode = selected.initialKeyCode;
	    if (keyCode === 'Delete' || keyCode === 'Backspace') {
	      return '';
	    } else if (keyCode === 'Enter') {
	      return _this2.props.value;
	    }

	    var text = keyCode ? String.fromCharCode(keyCode) : _this2.props.value;
	    return text;
	  };

	  this.getContainerClass = function () {
	    return joinClasses({
	      'has-error': _this2.state.isInvalid === true
	    });
	  };

	  this.commit = function (args) {
	    var opts = args || {};
	    var updated = _this2.getEditor().getValue();
	    if (_this2.isNewValueValid(updated)) {
	      _this2.changeCommitted = true;
	      var cellKey = _this2.props.column.key;
	      _this2.props.cellMetaData.onCommit({ cellKey: cellKey, rowIdx: _this2.props.rowIdx, updated: updated, key: opts.key });
	    }
	  };

	  this.commitCancel = function () {
	    _this2.changeCanceled = true;
	    _this2.props.cellMetaData.onCommitCancel();
	  };

	  this.isNewValueValid = function (value) {
	    if (isFunction(_this2.getEditor().validate)) {
	      var isValid = _this2.getEditor().validate(value);
	      _this2.setState({ isInvalid: !isValid });
	      return isValid;
	    }

	    return true;
	  };

	  this.setCaretAtEndOfInput = function () {
	    var input = _this2.getInputNode();
	    // taken from http://stackoverflow.com/questions/511088/use-javascript-to-place-cursor-at-end-of-text-in-text-input-element
	    var txtLength = input.value.length;
	    if (input.setSelectionRange) {
	      input.setSelectionRange(txtLength, txtLength);
	    } else if (input.createTextRange) {
	      var fieldRange = input.createTextRange();
	      fieldRange.moveStart('character', txtLength);
	      fieldRange.collapse();
	      fieldRange.select();
	    }
	  };

	  this.isCaretAtBeginningOfInput = function () {
	    var inputNode = _this2.getInputNode();
	    return inputNode.selectionStart === inputNode.selectionEnd && inputNode.selectionStart === 0;
	  };

	  this.isCaretAtEndOfInput = function () {
	    var inputNode = _this2.getInputNode();
	    return inputNode.selectionStart === inputNode.value.length;
	  };

	  this.isBodyClicked = function (e) {
	    var relatedTarget = _this2.getRelatedTarget(e);
	    return relatedTarget === null;
	  };

	  this.isViewportClicked = function (e) {
	    var relatedTarget = _this2.getRelatedTarget(e);
	    return relatedTarget.className.indexOf('react-grid-Viewport') > -1;
	  };

	  this.isClickInsideEditor = function (e) {
	    var relatedTarget = _this2.getRelatedTarget(e);
	    return e.currentTarget.contains(relatedTarget) || relatedTarget.className.indexOf('editing') > -1 || relatedTarget.className.indexOf('react-grid-Cell') > -1;
	  };

	  this.getRelatedTarget = function (e) {
	    return e.relatedTarget || e.explicitOriginalTarget || document.activeElement; // IE11
	  };

	  this.handleRightClick = function (e) {
	    e.stopPropagation();
	  };

	  this.handleBlur = function (e) {
	    e.stopPropagation();
	    if (_this2.isBodyClicked(e)) {
	      _this2.commit(e);
	    }

	    if (!_this2.isBodyClicked(e)) {
	      // prevent null reference
	      if (_this2.isViewportClicked(e) || !_this2.isClickInsideEditor(e)) {
	        _this2.commit(e);
	      }
	    }
	  };

	  this.setTextInputFocus = function () {
	    var selected = _this2.props.cellMetaData.selected;
	    var keyCode = selected.initialKeyCode;
	    var inputNode = _this2.getInputNode();
	    inputNode.focus();
	    if (inputNode.tagName === 'INPUT') {
	      if (!(0, _keyboardUtils.isKeyPrintable)(keyCode)) {
	        inputNode.focus();
	        inputNode.select();
	      } else {
	        inputNode.select();
	      }
	    }
	  };

	  this.renderStatusIcon = function () {
	    if (_this2.state.isInvalid === true) {
	      return React.createElement('span', { className: 'glyphicon glyphicon-remove form-control-feedback' });
	    }
	  };
	};

	module.exports = EditorContainer;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	module.exports = {
	  CheckboxEditor: __webpack_require__(48),
	  EditorBase: __webpack_require__(49),
	  SimpleTextEditor: __webpack_require__(50)
	};

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _reactDom = __webpack_require__(10);

	var _reactDom2 = _interopRequireDefault(_reactDom);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/prop-types */


	var focusableComponentWrapper = function focusableComponentWrapper(WrappedComponent) {
	  return function (_Component) {
	    _inherits(ComponentWrapper, _Component);

	    function ComponentWrapper() {
	      _classCallCheck(this, ComponentWrapper);

	      var _this = _possibleConstructorReturn(this, _Component.call(this));

	      _this.checkFocus = _this.checkFocus.bind(_this);
	      _this.state = { isScrolling: false };
	      return _this;
	    }

	    ComponentWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	      return WrappedComponent.isSelected(this.props) !== WrappedComponent.isSelected(nextProps);
	    };

	    ComponentWrapper.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var isScrolling = WrappedComponent.isScrolling(nextProps);
	      if (isScrolling && !this.state.isScrolling) {
	        this.setState({ isScrolling: isScrolling });
	      }
	    };

	    ComponentWrapper.prototype.componentDidMount = function componentDidMount() {
	      this.checkFocus();
	    };

	    ComponentWrapper.prototype.componentDidUpdate = function componentDidUpdate() {
	      this.checkFocus();
	    };

	    ComponentWrapper.prototype.checkFocus = function checkFocus() {
	      if (WrappedComponent.isSelected(this.props) && this.state.isScrolling) {
	        this.focus();
	        this.setState({ isScrolling: false });
	      }
	    };

	    ComponentWrapper.prototype.focus = function focus() {
	      _reactDom2['default'].findDOMNode(this).focus();
	    };

	    ComponentWrapper.prototype.render = function render() {
	      return _react2['default'].createElement(WrappedComponent, _extends({}, this.props, this.state));
	    };

	    return ComponentWrapper;
	  }(_react.Component);
	};

	exports['default'] = focusableComponentWrapper;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	module.exports = {
	  SimpleCellFormatter: __webpack_require__(52),
	  SelectAll: __webpack_require__(51)
	};

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _GridPropHelpers = __webpack_require__(130);

	var _GridPropHelpers2 = _interopRequireDefault(_GridPropHelpers);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	module.exports = {
	  test: { GridPropHelpers: _GridPropHelpers2['default'] }
	};

/***/ }),
/* 130 */
/***/ (function(module, exports) {

	'use strict';

	var _rows = [];
	for (var i = 0; i < 1000; i++) {
	  _rows.push({
	    id: i,
	    title: 'Title ' + i,
	    count: i * 1000
	  });
	}
	module.exports = {
	  columns: [{
	    key: 'id',
	    name: 'ID',
	    width: 100
	  }, {
	    key: 'title',
	    name: 'Title',
	    width: 100
	  }, {
	    key: 'count',
	    name: 'Count',
	    width: 100
	  }],
	  rowGetter: function rowGetter(i) {
	    return _rows[i];
	  },
	  rowsCount: function rowsCount() {
	    return _rows.length;
	  },
	  cellMetaData: {
	    selected: { idx: 2, rowIdx: 3 },
	    dragged: null,
	    copied: null
	  }
	};

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _RowComparer = __webpack_require__(44);

	var _RowComparer2 = _interopRequireDefault(_RowComparer);

	var _RowsContainer = __webpack_require__(46);

	var _RowsContainer2 = _interopRequireDefault(_RowsContainer);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	var Grid = __webpack_require__(120);

	module.exports = Grid;
	module.exports.Row = __webpack_require__(43);
	module.exports.Cell = __webpack_require__(41);
	module.exports.HeaderCell = __webpack_require__(42);
	module.exports.RowComparer = _RowComparer2['default'];
	module.exports.EmptyChildRow = __webpack_require__(111);
	module.exports.RowsContainer = _RowsContainer2['default'];
	module.exports.editors = __webpack_require__(126);
	module.exports.formatters = __webpack_require__(128);
	module.exports.utils = __webpack_require__(54);
	module.exports.shapes = __webpack_require__(119);
	module.exports._constants = __webpack_require__(31);
	module.exports._helpers = __webpack_require__(129);

/***/ }),
/* 132 */
/***/ (function(module, exports) {

	"use strict";

	var isEmptyArray = function isEmptyArray(obj) {
	  return Array.isArray(obj) && obj.length === 0;
	};

	module.exports = isEmptyArray;

/***/ }),
/* 133 */
/***/ (function(module, exports) {

	"use strict";

	function isEmpty(obj) {
	  return Object.keys(obj).length === 0 && obj.constructor === Object;
	}

	module.exports = isEmpty;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _immutable = __webpack_require__(19);

	var isImmutableCollection = function isImmutableCollection(objToVerify) {
	  return _immutable.Iterable.isIterable(objToVerify);
	};

	module.exports = isImmutableCollection;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _immutable = __webpack_require__(19);

	module.exports = _immutable.Map.isMap;

/***/ }),
/* 136 */
/***/ (function(module, exports) {

	"use strict";

	var getMixedTypeValueRetriever = function getMixedTypeValueRetriever(isImmutable) {
	  var retObj = {};
	  var retriever = function retriever(item, key) {
	    return item[key];
	  };
	  var immutableRetriever = function immutableRetriever(immutable, key) {
	    return immutable.get(key);
	  };

	  retObj.getValue = isImmutable ? immutableRetriever : retriever;

	  return retObj;
	};

	module.exports = getMixedTypeValueRetriever;

/***/ }),
/* 137 */
/***/ (function(module, exports) {

	'use strict';

	exports.__esModule = true;
	function createScrollShim(size) {
	  var shim = document.createElement('div');
	  if (shim.classList) {
	    shim.classList.add('react-grid-ScrollShim'); // flow - not compatible with HTMLElement
	  } else {
	    shim.className += ' react-grid-ScrollShim';
	  }
	  shim.style.position = 'absolute';
	  shim.style.top = 0;
	  shim.style.left = 0;
	  shim.style.width = size.width + 'px';
	  shim.style.height = size.height + 'px';

	  return shim;
	}

	exports.createScrollShim = createScrollShim;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;
	exports.getRenderedColumnCount = exports.getNextScrollState = exports.getGridState = undefined;

	var _ColumnUtils = __webpack_require__(7);

	var _ColumnUtils2 = _interopRequireDefault(_ColumnUtils);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	var min = Math.min;
	var max = Math.max;
	var floor = Math.floor;
	var ceil = Math.ceil;

	function getGridState(props) {
	  var totalNumberColumns = _ColumnUtils2['default'].getSize(props.columnMetrics.columns);
	  var canvasHeight = props.minHeight - props.rowOffsetHeight;
	  var renderedRowsCount = ceil((props.minHeight - props.rowHeight) / props.rowHeight);
	  var totalRowCount = min(renderedRowsCount * 4, props.rowsCount);
	  return {
	    displayStart: 0,
	    displayEnd: totalRowCount,
	    visibleStart: 0,
	    visibleEnd: totalRowCount,
	    height: canvasHeight,
	    scrollTop: 0,
	    scrollLeft: 0,
	    colVisibleStart: 0,
	    colVisibleEnd: totalNumberColumns,
	    colDisplayStart: 0,
	    colDisplayEnd: totalNumberColumns
	  };
	}

	function getRenderedColumnCount(props, getDOMNodeOffsetWidth, displayStart, width) {
	  var remainingWidth = width && width > 0 ? width : props.columnMetrics.totalWidth;
	  if (remainingWidth === 0) {
	    remainingWidth = getDOMNodeOffsetWidth();
	  }
	  var columnIndex = displayStart;
	  var columnCount = 0;
	  while (remainingWidth > 0) {
	    var column = _ColumnUtils2['default'].getColumn(props.columnMetrics.columns, columnIndex);

	    if (!column) {
	      break;
	    }

	    columnCount++;
	    columnIndex++;
	    remainingWidth -= column.width;
	  }
	  return columnCount;
	}

	function getVisibleColStart(props, scrollLeft) {
	  var remainingScroll = scrollLeft;
	  var columnIndex = -1;
	  while (remainingScroll >= 0) {
	    columnIndex++;
	    remainingScroll -= _ColumnUtils2['default'].getColumn(props.columnMetrics.columns, columnIndex).width;
	  }
	  return columnIndex;
	}

	function getNextScrollState(props, getDOMNodeOffsetWidth, scrollTop, scrollLeft, height, rowHeight, length, width) {
	  var isScrolling = true;
	  var renderedRowsCount = ceil(height / rowHeight);
	  var visibleStart = max(0, floor(scrollTop / rowHeight));
	  var visibleEnd = min(visibleStart + renderedRowsCount, length);
	  var displayStart = max(0, visibleStart - props.overScan.rowsStart);
	  var displayEnd = min(visibleEnd + props.overScan.rowsEnd, length);
	  var totalNumberColumns = _ColumnUtils2['default'].getSize(props.columnMetrics.columns);
	  var colVisibleStart = totalNumberColumns > 0 ? max(0, getVisibleColStart(props, scrollLeft)) : 0;
	  var renderedColumnCount = getRenderedColumnCount(props, getDOMNodeOffsetWidth, colVisibleStart, width);
	  var colVisibleEnd = renderedColumnCount !== 0 ? colVisibleStart + renderedColumnCount : totalNumberColumns;
	  var colDisplayStart = max(0, colVisibleStart - props.overScan.colsStart);
	  var colDisplayEnd = min(colVisibleEnd + props.overScan.colsEnd, totalNumberColumns);

	  var nextScrollState = {
	    visibleStart: visibleStart,
	    visibleEnd: visibleEnd,
	    displayStart: displayStart,
	    displayEnd: displayEnd,
	    height: height,
	    scrollTop: scrollTop,
	    scrollLeft: scrollLeft,
	    colVisibleStart: colVisibleStart,
	    colVisibleEnd: colVisibleEnd,
	    colDisplayStart: colDisplayStart,
	    colDisplayEnd: colDisplayEnd,
	    isScrolling: isScrolling
	  };

	  return nextScrollState;
	}

	exports.getGridState = getGridState;
	exports.getNextScrollState = getNextScrollState;
	exports.getRenderedColumnCount = getRenderedColumnCount;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(8)();
	// imports


	// module
	exports.push([module.id, ".react-grid-Cell{background-color:#fff;padding-left:8px;padding-right:8px;border-right:1px solid #eee;border-bottom:1px solid #ddd}.react-grid-Cell:focus{outline:2px solid #66afe9;outline-offset:-2px}.react-grid-Cell--locked:focus{z-index:100}.react-grid-Cell:focus .drag-handle{position:absolute;bottom:-5px;right:-4px;background:#66afe9;width:8px;height:8px;border:1px solid #fff;border-right:0;border-bottom:0;z-index:8;cursor:crosshair;cursor:-webkit-grab}.react-grid-Cell:not(.editing) .react-grid-Cell__value{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.react-grid-Cell:not(.editing):not(.rdg-child-cell) .react-grid-Cell__value{position:relative;top:50%;transform:translateY(-50%)}.rdg-child-cell .react-grid-Cell__value{line-height:35px}.react-grid-Cell.readonly{background-color:#000}.react-grid-Cell.copied{background:rgba(0,0,255,.2)!important}.react-grid-Cell--locked:last-of-type{border-right:1px solid #ddd;box-shadow:none}.react-grid-Cell:hover:focus .drag-handle .glyphicon-arrow-down{display:\"block\"}.react-grid-Cell.is-dragged-over-down{border-right:1px dashed #000;border-left:1px dashed #000;border-bottom:1px dashed #000}.react-grid-Cell.is-dragged-over-up{border-right:1px dashed #000;border-left:1px dashed #000;border-top:1px dashed #000}.react-grid-Cell.is-dragged-over-up .drag-handle{top:-5px}.react-grid-Cell:hover{background:#eee}.react-grid-cell .form-control-feedback{color:#a94442;position:absolute;top:0;right:10px;z-index:1000000;display:block;width:34px;height:34px}.react-grid-Cell.was-dragged-over{border-right:1px dashed #000;border-left:1px dashed #000}.react-grid-Cell:hover:focus .drag-handle{position:absolute;bottom:-8px;right:-7px;background:#fff;width:16px;height:16px;border:1px solid #66afe9;z-index:8;cursor:crosshair;cursor:-webkit-grab}.react-grid-Row.row-selected .react-grid-Cell{background-color:#dbecfa}.react-grid-Cell.editing{padding:0;overflow:visible!important}.react-grid-Cell--locked.editing{z-index:100}.react-grid-Cell.editing .has-error input{border:2px solid red!important;border-radius:2px!important}.react-grid-Cell__value ul{margin-top:0;margin-bottom:0;display:inline-block}.react-grid-Cell__value .btn-sm{padding:0}.cell-tooltip{position:relative;display:inline-block}.cell-tooltip:hover{z-index:101}.cell-tooltip .cell-tooltip-text{visibility:hidden;width:150px;background-color:#000;color:#fff;text-align:center;border-radius:6px;padding:5px 0;position:absolute;z-index:1;bottom:-150%;left:50%;margin-left:-60px;opacity:1s}.cell-tooltip:hover .cell-tooltip-text{visibility:visible;opacity:.8}.cell-tooltip .cell-tooltip-text:after{content:\" \";position:absolute;bottom:100%;left:50%;margin-left:-5px;border-width:5px;border-style:solid;border-color:transparent transparent #000}.react-grid-Canvas.opaque .react-grid-Cell.cell-tooltip:hover .cell-tooltip-text{visibility:hidden}.rdg-cell-expand{top:0;right:20px;position:absolute;cursor:pointer}.rdg-child-row-action-cross-last:before,.rdg-child-row-action-cross:before,rdg-child-row-action-cross-last:after,rdg-child-row-action-cross:after{content:\"\";position:absolute;background:grey;height:50%}.rdg-child-row-action-cross:before{left:21px;width:1px;height:35px}.rdg-child-row-action-cross-last:before{left:21px;width:1px}.rdg-child-row-action-cross-last:after,.rdg-child-row-action-cross:after{top:50%;left:20px;height:1px;width:15px;content:\"\";position:absolute;background:grey}.rdg-child-row-action-cross:hover{background:red}.rdg-child-row-btn{position:absolute;cursor:pointer;border:1px solid grey;border-radius:14px;z-index:3;background:#fff}.rdg-child-row-btn div{font-size:12px;text-align:center;line-height:19px;color:grey;height:20px;width:20px;position:absolute;top:60%;left:53%;margin-top:-10px;margin-left:-10px}.rdg-empty-child-row:hover .glyphicon-plus-sign,.rdg-empty-child-row:hover a{color:green}.rdg-child-row-btn .glyphicon-remove-sign:hover{color:red}.last-column .cell-tooltip-text{right:100%;left:0!important}.rdg-cell-action{float:right;height:100%}.rdg-cell-action-last{margin-right:-8px}.rdg-cell-action-button{width:35px;height:100%;text-align:center;position:relative;display:table}.rdg-cell-action-button>span{display:table-cell;vertical-align:middle}.rdg-cell-action-button:hover{background-color:#fff}.rdg-cell-action-button-toggled{background-color:#fff;border-right:1px solid #ccc;border-left:1px solid #ccc}.rdg-cell-action-button-toggled:after{content:\"\";height:1px;position:absolute;bottom:-1px;left:0;right:0;background:inherit;z-index:10001}.rdg-cell-action-menu{position:absolute;top:100%;right:0;z-index:1000;float:left;min-width:160px;padding:5px 0;font-size:14px;text-align:left;list-style:none;background-color:#fff;-webkit-background-clip:padding-box;background-clip:padding-box;border:1px solid #ccc}.rdg-cell-action-menu>span{display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.42857143;color:#333;white-space:nowrap}.rdg-cell-action-menu>span:hover{color:#262626;text-decoration:none;background-color:#f5f5f5}", ""]);

	// exports


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(8)();
	// imports


	// module
	exports.push([module.id, ".radio-custom,.react-grid-checkbox{opacity:0;position:absolute}.radio-custom,.radio-custom-label,.react-grid-checkbox,.react-grid-checkbox-label{display:inline-block;vertical-align:middle;cursor:pointer}.radio-custom-label,.react-grid-checkbox-label{position:relative}.radio-custom+.radio-custom-label:before,.react-grid-checkbox+.react-grid-checkbox-label:before{content:\"\";background:#fff;border:2px solid #ddd;display:inline-block;vertical-align:middle;width:20px;height:20px;text-align:center}.react-grid-checkbox:checked+.react-grid-checkbox-label:before{background:#005295;box-shadow:inset 0 0 0 4px #fff}.radio-custom:focus+.radio-custom-label,.react-grid-checkbox:focus+.react-grid-checkbox-label{outline:1px solid #ddd}.react-grid-HeaderCell input[type=checkbox]{z-index:99999}.react-grid-HeaderCell>.react-grid-checkbox-container{padding:0 10px;height:100%}.react-grid-HeaderCell>.react-grid-checkbox-container>.react-grid-checkbox-label{margin:0;position:relative;top:50%;transform:translateY(-50%)}.radio-custom+.radio-custom-label:before{border-radius:50%}.radio-custom:checked+.radio-custom-label:before{background:#ccc;box-shadow:inset 0 0 0 4px #fff}.checkbox-align{text-align:center}", ""]);

	// exports


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(8)();
	// imports


	// module
	exports.push([module.id, ".react-grid-Container{clear:both;margin-top:0;padding:0}.react-grid-Main{background-color:#fff;color:inherit;padding:0;outline:1px solid #e7eaec;clear:both}.react-grid-Grid{border:1px solid #ddd}.react-grid-Canvas,.react-grid-Grid{background-color:#fff}.react-grid-Cell input.editor-main,select.editor-main{display:block;width:100%;height:34px;padding:6px 12px;font-size:14px;line-height:1.42857143;color:#555;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}input.editor-main:focus,select.editor-main:focus{border-color:#66afe9;border:2px solid #66afe9;background:#eee;border-radius:4px}.react-grid-Cell input.editor-main::-moz-placeholder,select.editor-main::-moz-placeholder{color:#999;opacity:1}.react-grid-Cell input.editor-main:-ms-input-placeholder,select.editor-main:-ms-input-placeholder{color:#999}.react-grid-Cell input.editor-main::-webkit-input-placeholder,select.editor-main::-webkit-input-placeholder{color:#999}.react-grid-Cell input.editor-main[disabled],.react-grid-Cell input.editor-main[readonly],fieldset[disabled] .react-grid-Cell input.editor-main,fieldset[disabled] select.editor-main,select.editor-main[disabled],select.editor-main[readonly]{cursor:not-allowed;background-color:#eee;opacity:1}textarea.react-grid-Cell input.editor-main,textareaselect.editor-main{height:auto}.react-grid-ScrollShim{z-index:10002}", ""]);

	// exports


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(8)();
	// imports


	// module
	exports.push([module.id, ".react-grid-Header{box-shadow:0 0 4px 0 #ddd;background:#f9f9f9}.react-grid-Header--resizing{cursor:ew-resize}.react-grid-HeaderCell,.react-grid-HeaderRow{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.react-grid-HeaderCell{background:#f9f9f9;padding:8px;font-weight:700;border-right:1px solid #ddd;border-bottom:1px solid #ddd}.react-grid-HeaderCell__value{white-space:nowrap;text-overflow:ellipsis;overflow:hidden;position:relative;top:50%;transform:translateY(-50%)}.react-grid-HeaderCell__resizeHandle:hover{cursor:ew-resize;background:#ddd}.react-grid-HeaderCell--locked:last-of-type{box-shadow:none}.react-grid-HeaderCell--resizing .react-grid-HeaderCell__resizeHandle{background:#ddd}.react-grid-HeaderCell__draggable{cursor:col-resize}.rdg-can-drop>.react-grid-HeaderCell{background:#ececec}.react-grid-HeaderCell .Select{max-height:30px;font-size:12px;font-weight:400}.react-grid-HeaderCell .Select-control{max-height:30px;border:1px solid #ccc;color:#555;border-radius:3px}.react-grid-HeaderCell .is-focused:not(.is-open)>.Select-control{border-color:#66afe9;outline:0;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.react-grid-HeaderCell .Select-control .Select-placeholder{line-height:20px;color:#999;padding:4px}.react-grid-HeaderCell .Select-control .Select-input{max-height:28px;padding:4px;margin-left:0}.react-grid-HeaderCell .Select-control .Select-input input{padding:0;height:100%}.react-grid-HeaderCell .Select-control .Select-arrow-zone .Select-arrow{border-color:gray transparent transparent;border-width:4px 4px 2.5px}.react-grid-HeaderCell .Select-control .Select-value{padding:4px;line-height:20px!important}.react-grid-HeaderCell .Select--multi .Select-control .Select-value{padding:0;line-height:16px!important;max-height:20px}.react-grid-HeaderCell .Select--multi .Select-control .Select-value .Select-value-icon,.react-grid-HeaderCell .Select--multi .Select-control .Select-value .Select-value-label{max-height:20px}.react-grid-HeaderCell .Select-control .Select-value .Select-value-label{color:#555!important}.react-grid-HeaderCell .Select-menu-outer .Select-option{padding:4px;line-height:20px}.react-grid-HeaderCell .Select-menu-outer .Select-menu .Select-option.is-focused,.react-grid-HeaderCell .Select-menu-outer .Select-menu .Select-option.is-selected{color:#555}", ""]);

	// exports


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(8)();
	// imports


	// module
	exports.push([module.id, ".react-grid-Row.row-context-menu .react-grid-Cell,.react-grid-Row:hover .react-grid-Cell{background-color:#f9f9f9}.react-grid-Row:hover .rdg-row-index{display:none}.react-grid-Row:hover .rdg-actions-checkbox{display:block}.react-grid-Row:hover .rdg-drag-row-handle{cursor:move;cursor:grab;cursor:-moz-grab;cursor:-webkit-grab;width:12px;height:30px;margin-left:0;background-image:url(\"data:image/svg+xml;base64, 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\");background-repeat:no-repeat}.react-grid-Row.row-selected,.react-grid-Row .row-selected{background-color:#dbecfa}.react-grid-row-group .row-expand-icon:hover{color:#777}.react-grid-row-index{padding:0 18px}.rdg-row-index{display:block;text-align:center}.rdg-row-actions-cell{padding:0}.rdg-actions-checkbox{display:none;text-align:center}.rdg-actions-checkbox.selected{display:block}.rdg-dragging{cursor:-webkit-grabbing;cursor:-moz-grabbing;cursor:grabbing}.rdg-dragged-row{border-bottom:1px solid #000}", ""]);

	// exports


/***/ }),
/* 144 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 */

	"use strict";

	/**
	 * Constructs an enumeration with keys equal to their value.
	 *
	 * For example:
	 *
	 *   var COLORS = keyMirror({blue: null, red: null});
	 *   var myColor = COLORS.blue;
	 *   var isColorValid = !!COLORS[myColor];
	 *
	 * The last line could not be performed if the values of the generated enum were
	 * not equal to their keys.
	 *
	 *   Input:  {key1: val1, key2: val2}
	 *   Output: {key1: key1, key2: key2}
	 *
	 * @param {object} obj
	 * @return {object}
	 */
	var keyMirror = function(obj) {
	  var ret = {};
	  var key;
	  if (!(obj instanceof Object && !Array.isArray(obj))) {
	    throw new Error('keyMirror(...): Argument must be an object.');
	  }
	  for (key in obj) {
	    if (!obj.hasOwnProperty(key)) {
	      continue;
	    }
	    ret[key] = key;
	  }
	  return ret;
	};

	module.exports = keyMirror;


/***/ }),
/* 145 */
/***/ (function(module, exports) {

	"use strict";

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */

	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}

	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};

	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};

	module.exports = emptyFunction;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */

	'use strict';

	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */

	var validateFormat = function validateFormat(format) {};

	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}

	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);

	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }

	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}

	module.exports = invariant;

/***/ }),
/* 147 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/

	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}

			// Detect buggy property enumeration order in older V8 versions.

			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}

			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}

	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);

			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */

	'use strict';

	var emptyFunction = __webpack_require__(145);
	var invariant = __webpack_require__(146);
	var ReactPropTypesSecret = __webpack_require__(149);

	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,

	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };

	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};


/***/ }),
/* 149 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */

	'use strict';

	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

	module.exports = ReactPropTypesSecret;


/***/ })
/******/ ])
});
;

/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1713);

/***/ }),
/* 1715 */,
/* 1716 */,
/* 1717 */,
/* 1718 */,
/* 1719 */,
/* 1720 */,
/* 1721 */,
/* 1722 */,
/* 1723 */,
/* 1724 */,
/* 1725 */,
/* 1726 */,
/* 1727 */,
/* 1728 */,
/* 1729 */,
/* 1730 */,
/* 1731 */,
/* 1732 */,
/* 1733 */,
/* 1734 */,
/* 1735 */,
/* 1736 */,
/* 1737 */,
/* 1738 */,
/* 1739 */,
/* 1740 */,
/* 1741 */,
/* 1742 */,
/* 1743 */,
/* 1744 */,
/* 1745 */,
/* 1746 */,
/* 1747 */,
/* 1748 */,
/* 1749 */,
/* 1750 */,
/* 1751 */,
/* 1752 */,
/* 1753 */,
/* 1754 */,
/* 1755 */,
/* 1756 */,
/* 1757 */,
/* 1758 */,
/* 1759 */,
/* 1760 */,
/* 1761 */,
/* 1762 */,
/* 1763 */,
/* 1764 */,
/* 1765 */,
/* 1766 */,
/* 1767 */,
/* 1768 */,
/* 1769 */,
/* 1770 */,
/* 1771 */,
/* 1772 */,
/* 1773 */,
/* 1774 */,
/* 1775 */,
/* 1776 */,
/* 1777 */,
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(44), __webpack_require__(0));
	else if(typeof define === 'function' && define.amd)
		define(["react-dom", "react"], factory);
	else if(typeof exports === 'object')
		exports["ReactDraggable"] = factory(require("react-dom"), require("react"));
	else
		root["ReactDraggable"] = factory(root["ReactDOM"], root["React"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_6__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 12);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findInArray = findInArray;
exports.isFunction = isFunction;
exports.isNum = isNum;
exports.int = int;
exports.dontSetMe = dontSetMe;

// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
function findInArray(array /*: Array<any> | TouchList*/, callback /*: Function*/) /*: any*/ {
  for (var i = 0, length = array.length; i < length; i++) {
    if (callback.apply(callback, [array[i], i, array])) return array[i];
  }
}

function isFunction(func /*: any*/) /*: boolean*/ {
  return typeof func === 'function' || Object.prototype.toString.call(func) === '[object Function]';
}

function isNum(num /*: any*/) /*: boolean*/ {
  return typeof num === 'number' && !isNaN(num);
}

function int(a /*: string*/) /*: number*/ {
  return parseInt(a, 10);
}

function dontSetMe(props /*: Object*/, propName /*: string*/, componentName /*: string*/) {
  if (props[propName]) {
    return new Error('Invalid prop ' + propName + ' passed to ' + componentName + ' - do not set this, set it on the child.');
  }
}

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production') {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.matchesSelector = matchesSelector;
exports.matchesSelectorAndParentsTo = matchesSelectorAndParentsTo;
exports.addEvent = addEvent;
exports.removeEvent = removeEvent;
exports.outerHeight = outerHeight;
exports.outerWidth = outerWidth;
exports.innerHeight = innerHeight;
exports.innerWidth = innerWidth;
exports.offsetXYFromParent = offsetXYFromParent;
exports.createCSSTransform = createCSSTransform;
exports.createSVGTransform = createSVGTransform;
exports.getTouch = getTouch;
exports.getTouchIdentifier = getTouchIdentifier;
exports.addUserSelectStyles = addUserSelectStyles;
exports.removeUserSelectStyles = removeUserSelectStyles;
exports.styleHacks = styleHacks;
exports.addClassName = addClassName;
exports.removeClassName = removeClassName;

var _shims = __webpack_require__(0);

var _getPrefix = __webpack_require__(19);

var _getPrefix2 = _interopRequireDefault(_getPrefix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*:: import type {ControlPosition, MouseTouchEvent} from './types';*/


var matchesSelectorFunc = '';
function matchesSelector(el /*: Node*/, selector /*: string*/) /*: boolean*/ {
  if (!matchesSelectorFunc) {
    matchesSelectorFunc = (0, _shims.findInArray)(['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'], function (method) {
      // $FlowIgnore: Doesn't think elements are indexable
      return (0, _shims.isFunction)(el[method]);
    });
  }

  // Might not be found entirely (not an Element?) - in that case, bail
  // $FlowIgnore: Doesn't think elements are indexable
  if (!(0, _shims.isFunction)(el[matchesSelectorFunc])) return false;

  // $FlowIgnore: Doesn't think elements are indexable
  return el[matchesSelectorFunc](selector);
}

// Works up the tree to the draggable itself attempting to match selector.
function matchesSelectorAndParentsTo(el /*: Node*/, selector /*: string*/, baseNode /*: Node*/) /*: boolean*/ {
  var node = el;
  do {
    if (matchesSelector(node, selector)) return true;
    if (node === baseNode) return false;
    node = node.parentNode;
  } while (node);

  return false;
}

function addEvent(el /*: ?Node*/, event /*: string*/, handler /*: Function*/) /*: void*/ {
  if (!el) {
    return;
  }
  if (el.attachEvent) {
    el.attachEvent('on' + event, handler);
  } else if (el.addEventListener) {
    el.addEventListener(event, handler, true);
  } else {
    // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = handler;
  }
}

function removeEvent(el /*: ?Node*/, event /*: string*/, handler /*: Function*/) /*: void*/ {
  if (!el) {
    return;
  }
  if (el.detachEvent) {
    el.detachEvent('on' + event, handler);
  } else if (el.removeEventListener) {
    el.removeEventListener(event, handler, true);
  } else {
    // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = null;
  }
}

function outerHeight(node /*: HTMLElement*/) /*: number*/ {
  // This is deliberately excluding margin for our calculations, since we are using
  // offsetTop which is including margin. See getBoundPosition
  var height = node.clientHeight;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  height += (0, _shims.int)(computedStyle.borderTopWidth);
  height += (0, _shims.int)(computedStyle.borderBottomWidth);
  return height;
}

function outerWidth(node /*: HTMLElement*/) /*: number*/ {
  // This is deliberately excluding margin for our calculations, since we are using
  // offsetLeft which is including margin. See getBoundPosition
  var width = node.clientWidth;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  width += (0, _shims.int)(computedStyle.borderLeftWidth);
  width += (0, _shims.int)(computedStyle.borderRightWidth);
  return width;
}
function innerHeight(node /*: HTMLElement*/) /*: number*/ {
  var height = node.clientHeight;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  height -= (0, _shims.int)(computedStyle.paddingTop);
  height -= (0, _shims.int)(computedStyle.paddingBottom);
  return height;
}

function innerWidth(node /*: HTMLElement*/) /*: number*/ {
  var width = node.clientWidth;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  width -= (0, _shims.int)(computedStyle.paddingLeft);
  width -= (0, _shims.int)(computedStyle.paddingRight);
  return width;
}

// Get from offsetParent
function offsetXYFromParent(evt /*: {clientX: number, clientY: number}*/, offsetParent /*: HTMLElement*/) /*: ControlPosition*/ {
  var isBody = offsetParent === offsetParent.ownerDocument.body;
  var offsetParentRect = isBody ? { left: 0, top: 0 } : offsetParent.getBoundingClientRect();

  var x = evt.clientX + offsetParent.scrollLeft - offsetParentRect.left;
  var y = evt.clientY + offsetParent.scrollTop - offsetParentRect.top;

  return { x: x, y: y };
}

function createCSSTransform(_ref) /*: Object*/ {
  var x = _ref.x,
      y = _ref.y;

  // Replace unitless items with px
  return _defineProperty({}, (0, _getPrefix.browserPrefixToKey)('transform', _getPrefix2.default), 'translate(' + x + 'px,' + y + 'px)');
}

function createSVGTransform(_ref3) /*: string*/ {
  var x = _ref3.x,
      y = _ref3.y;

  return 'translate(' + x + ',' + y + ')';
}

function getTouch(e /*: MouseTouchEvent*/, identifier /*: number*/) /*: ?{clientX: number, clientY: number}*/ {
  return e.targetTouches && (0, _shims.findInArray)(e.targetTouches, function (t) {
    return identifier === t.identifier;
  }) || e.changedTouches && (0, _shims.findInArray)(e.changedTouches, function (t) {
    return identifier === t.identifier;
  });
}

function getTouchIdentifier(e /*: MouseTouchEvent*/) /*: ?number*/ {
  if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
  if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
}

// User-select Hacks:
//
// Useful for preventing blue highlights all over everything when dragging.

// Note we're passing `document` b/c we could be iframed
function addUserSelectStyles(doc /*: ?Document*/) {
  if (!doc) return;
  var styleEl = doc.getElementById('react-draggable-style-el');
  if (!styleEl) {
    styleEl = doc.createElement('style');
    styleEl.type = 'text/css';
    styleEl.id = 'react-draggable-style-el';
    styleEl.innerHTML = '.react-draggable-transparent-selection *::-moz-selection {background: transparent;}\n';
    styleEl.innerHTML += '.react-draggable-transparent-selection *::selection {background: transparent;}\n';
    doc.getElementsByTagName('head')[0].appendChild(styleEl);
  }
  if (doc.body) addClassName(doc.body, 'react-draggable-transparent-selection');
}

function removeUserSelectStyles(doc /*: ?Document*/) {
  try {
    if (doc && doc.body) removeClassName(doc.body, 'react-draggable-transparent-selection');
    window.getSelection().removeAllRanges(); // remove selection caused by scroll
  } catch (e) {
    // probably IE
  }
}

function styleHacks() /*: Object*/ {
  var childStyle /*: Object*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  // Workaround IE pointer events; see #51
  // https://github.com/mzabriskie/react-draggable/issues/51#issuecomment-103488278
  return _extends({
    touchAction: 'none'
  }, childStyle);
}

function addClassName(el /*: HTMLElement*/, className /*: string*/) {
  if (el.classList) {
    el.classList.add(className);
  } else {
    if (!el.className.match(new RegExp('(?:^|\\s)' + className + '(?!\\S)'))) {
      el.className += ' ' + className;
    }
  }
}

function removeClassName(el /*: HTMLElement*/, className /*: string*/) {
  if (el.classList) {
    el.classList.remove(className);
  } else {
    el.className = el.className.replace(new RegExp('(?:^|\\s)' + className + '(?!\\S)', 'g'), '');
  }
}

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_6__;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production') {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = __webpack_require__(14)(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(17)();
}


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(1);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production') {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBoundPosition = getBoundPosition;
exports.snapToGrid = snapToGrid;
exports.canDragX = canDragX;
exports.canDragY = canDragY;
exports.getControlPosition = getControlPosition;
exports.createCoreData = createCoreData;
exports.createDraggableData = createDraggableData;

var _shims = __webpack_require__(0);

var _reactDom = __webpack_require__(4);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _domFns = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*:: import type Draggable from '../Draggable';*/
/*:: import type {Bounds, ControlPosition, DraggableData, MouseTouchEvent} from './types';*/
/*:: import type DraggableCore from '../DraggableCore';*/
function getBoundPosition(draggable /*: Draggable*/, x /*: number*/, y /*: number*/) /*: [number, number]*/ {
  // If no bounds, short-circuit and move on
  if (!draggable.props.bounds) return [x, y];

  // Clone new bounds
  var bounds = draggable.props.bounds;

  bounds = typeof bounds === 'string' ? bounds : cloneBounds(bounds);
  var node = findDOMNode(draggable);

  if (typeof bounds === 'string') {
    var ownerDocument = node.ownerDocument;

    var ownerWindow = ownerDocument.defaultView;
    var boundNode = void 0;
    if (bounds === 'parent') {
      boundNode = node.parentNode;
    } else {
      boundNode = ownerDocument.querySelector(bounds);
    }
    if (!(boundNode instanceof HTMLElement)) {
      throw new Error('Bounds selector "' + bounds + '" could not find an element.');
    }
    var nodeStyle = ownerWindow.getComputedStyle(node);
    var boundNodeStyle = ownerWindow.getComputedStyle(boundNode);
    // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.
    bounds = {
      left: -node.offsetLeft + (0, _shims.int)(boundNodeStyle.paddingLeft) + (0, _shims.int)(nodeStyle.marginLeft),
      top: -node.offsetTop + (0, _shims.int)(boundNodeStyle.paddingTop) + (0, _shims.int)(nodeStyle.marginTop),
      right: (0, _domFns.innerWidth)(boundNode) - (0, _domFns.outerWidth)(node) - node.offsetLeft + (0, _shims.int)(boundNodeStyle.paddingRight) - (0, _shims.int)(nodeStyle.marginRight),
      bottom: (0, _domFns.innerHeight)(boundNode) - (0, _domFns.outerHeight)(node) - node.offsetTop + (0, _shims.int)(boundNodeStyle.paddingBottom) - (0, _shims.int)(nodeStyle.marginBottom)
    };
  }

  // Keep x and y below right and bottom limits...
  if ((0, _shims.isNum)(bounds.right)) x = Math.min(x, bounds.right);
  if ((0, _shims.isNum)(bounds.bottom)) y = Math.min(y, bounds.bottom);

  // But above left and top limits.
  if ((0, _shims.isNum)(bounds.left)) x = Math.max(x, bounds.left);
  if ((0, _shims.isNum)(bounds.top)) y = Math.max(y, bounds.top);

  return [x, y];
}

function snapToGrid(grid /*: [number, number]*/, pendingX /*: number*/, pendingY /*: number*/) /*: [number, number]*/ {
  var x = Math.round(pendingX / grid[0]) * grid[0];
  var y = Math.round(pendingY / grid[1]) * grid[1];
  return [x, y];
}

function canDragX(draggable /*: Draggable*/) /*: boolean*/ {
  return draggable.props.axis === 'both' || draggable.props.axis === 'x';
}

function canDragY(draggable /*: Draggable*/) /*: boolean*/ {
  return draggable.props.axis === 'both' || draggable.props.axis === 'y';
}

// Get {x, y} positions from event.
function getControlPosition(e /*: MouseTouchEvent*/, touchIdentifier /*: ?number*/, draggableCore /*: DraggableCore*/) /*: ?ControlPosition*/ {
  var touchObj = typeof touchIdentifier === 'number' ? (0, _domFns.getTouch)(e, touchIdentifier) : null;
  if (typeof touchIdentifier === 'number' && !touchObj) return null; // not the right touch
  var node = findDOMNode(draggableCore);
  // User can provide an offsetParent if desired.
  var offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
  return (0, _domFns.offsetXYFromParent)(touchObj || e, offsetParent);
}

// Create an data object exposed by <DraggableCore>'s events
function createCoreData(draggable /*: DraggableCore*/, x /*: number*/, y /*: number*/) /*: DraggableData*/ {
  var state = draggable.state;
  var isStart = !(0, _shims.isNum)(state.lastX);
  var node = findDOMNode(draggable);

  if (isStart) {
    // If this is our first move, use the x and y as last coords.
    return {
      node: node,
      deltaX: 0, deltaY: 0,
      lastX: x, lastY: y,
      x: x, y: y
    };
  } else {
    // Otherwise calculate proper values.
    return {
      node: node,
      deltaX: x - state.lastX, deltaY: y - state.lastY,
      lastX: state.lastX, lastY: state.lastY,
      x: x, y: y
    };
  }
}

// Create an data exposed by <Draggable>'s events
function createDraggableData(draggable /*: Draggable*/, coreData /*: DraggableData*/) /*: DraggableData*/ {
  return {
    node: coreData.node,
    x: draggable.state.x + coreData.deltaX,
    y: draggable.state.y + coreData.deltaY,
    deltaX: coreData.deltaX,
    deltaY: coreData.deltaY,
    lastX: draggable.state.x,
    lastY: draggable.state.y
  };
}

// A lot faster than stringify/parse
function cloneBounds(bounds /*: Bounds*/) /*: Bounds*/ {
  return {
    left: bounds.left,
    top: bounds.top,
    right: bounds.right,
    bottom: bounds.bottom
  };
}

function findDOMNode(draggable /*: Draggable | DraggableCore*/) /*: HTMLElement*/ {
  var node = _reactDom2.default.findDOMNode(draggable);
  if (!node) {
    throw new Error('<DraggableCore>: Unmounted during event!');
  }
  // $FlowIgnore we can't assert on HTMLElement due to tests... FIXME
  return node;
}

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(6);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(4);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _domFns = __webpack_require__(5);

var _positionFns = __webpack_require__(9);

var _shims = __webpack_require__(0);

var _log = __webpack_require__(11);

var _log2 = _interopRequireDefault(_log);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*:: import type {EventHandler, MouseTouchEvent} from './utils/types';*/


// Simple abstraction for dragging events names.
/*:: import type {Element as ReactElement} from 'react';*/
var eventsFor = {
  touch: {
    start: 'touchstart',
    move: 'touchmove',
    stop: 'touchend'
  },
  mouse: {
    start: 'mousedown',
    move: 'mousemove',
    stop: 'mouseup'
  }
};

// Default to mouse events.
var dragEventFor = eventsFor.mouse;

/*:: type DraggableCoreState = {
  dragging: boolean,
  lastX: number,
  lastY: number,
  touchIdentifier: ?number
};*/
/*:: export type DraggableBounds = {
  left: number,
  right: number,
  top: number,
  bottom: number,
};*/
/*:: export type DraggableData = {
  node: HTMLElement,
  x: number, y: number,
  deltaX: number, deltaY: number,
  lastX: number, lastY: number,
};*/
/*:: export type DraggableEventHandler = (e: MouseEvent, data: DraggableData) => void;*/
/*:: export type ControlPosition = {x: number, y: number};*/


//
// Define <DraggableCore>.
//
// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
// work well with libraries that require more control over the element.
//

/*:: export type DraggableCoreProps = {
  allowAnyClick: boolean,
  cancel: string,
  children: ReactElement<any>,
  disabled: boolean,
  enableUserSelectHack: boolean,
  offsetParent: HTMLElement,
  grid: [number, number],
  handle: string,
  onStart: DraggableEventHandler,
  onDrag: DraggableEventHandler,
  onStop: DraggableEventHandler,
  onMouseDown: (e: MouseEvent) => void,
};*/

var DraggableCore = function (_React$Component) {
  _inherits(DraggableCore, _React$Component);

  function DraggableCore() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DraggableCore);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DraggableCore.__proto__ || Object.getPrototypeOf(DraggableCore)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      dragging: false,
      // Used while dragging to determine deltas.
      lastX: NaN, lastY: NaN,
      touchIdentifier: null
    }, _this.handleDragStart = function (e) {
      // Make it possible to attach event handlers on top of this one.
      _this.props.onMouseDown(e);

      // Only accept left-clicks.
      if (!_this.props.allowAnyClick && typeof e.button === 'number' && e.button !== 0) return false;

      // Get nodes. Be sure to grab relative document (could be iframed)
      var thisNode = _reactDom2.default.findDOMNode(_this);
      if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) {
        throw new Error('<DraggableCore> not mounted on DragStart!');
      }
      var ownerDocument = thisNode.ownerDocument;

      // Short circuit if handle or cancel prop was provided and selector doesn't match.

      if (_this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || _this.props.handle && !(0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.handle, thisNode) || _this.props.cancel && (0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.cancel, thisNode)) {
        return;
      }

      // Set touch identifier in component state if this is a touch event. This allows us to
      // distinguish between individual touches on multitouch screens by identifying which
      // touchpoint was set to this element.
      var touchIdentifier = (0, _domFns.getTouchIdentifier)(e);
      _this.setState({ touchIdentifier: touchIdentifier });

      // Get the current drag point from the event. This is used as the offset.
      var position = (0, _positionFns.getControlPosition)(e, touchIdentifier, _this);
      if (position == null) return; // not possible but satisfies flow
      var x = position.x,
          y = position.y;

      // Create an event object with all the data parents need to make a decision here.

      var coreEvent = (0, _positionFns.createCoreData)(_this, x, y);

      (0, _log2.default)('DraggableCore: handleDragStart: %j', coreEvent);

      // Call event handler. If it returns explicit false, cancel.
      (0, _log2.default)('calling', _this.props.onStart);
      var shouldUpdate = _this.props.onStart(e, coreEvent);
      if (shouldUpdate === false) return;

      // Add a style to the body to disable user-select. This prevents text from
      // being selected all over the page.
      if (_this.props.enableUserSelectHack) (0, _domFns.addUserSelectStyles)(ownerDocument);

      // Initiate dragging. Set the current x and y as offsets
      // so we know how much we've moved during the drag. This allows us
      // to drag elements around even if they have been moved, without issue.
      _this.setState({
        dragging: true,

        lastX: x,
        lastY: y
      });

      // Add events to the document directly so we catch when the user's mouse/touch moves outside of
      // this element. We use different events depending on whether or not we have detected that this
      // is a touch-capable device.
      (0, _domFns.addEvent)(ownerDocument, dragEventFor.move, _this.handleDrag);
      (0, _domFns.addEvent)(ownerDocument, dragEventFor.stop, _this.handleDragStop);
    }, _this.handleDrag = function (e) {

      // Prevent scrolling on mobile devices, like ipad/iphone.
      if (e.type === 'touchmove') e.preventDefault();

      // Get the current drag point from the event. This is used as the offset.
      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _this);
      if (position == null) return;
      var x = position.x,
          y = position.y;

      // Snap to grid if prop has been provided

      if (Array.isArray(_this.props.grid)) {
        var _deltaX = x - _this.state.lastX,
            _deltaY = y - _this.state.lastY;

        var _snapToGrid = (0, _positionFns.snapToGrid)(_this.props.grid, _deltaX, _deltaY);

        var _snapToGrid2 = _slicedToArray(_snapToGrid, 2);

        _deltaX = _snapToGrid2[0];
        _deltaY = _snapToGrid2[1];

        if (!_deltaX && !_deltaY) return; // skip useless drag
        x = _this.state.lastX + _deltaX, y = _this.state.lastY + _deltaY;
      }

      var coreEvent = (0, _positionFns.createCoreData)(_this, x, y);

      (0, _log2.default)('DraggableCore: handleDrag: %j', coreEvent);

      // Call event handler. If it returns explicit false, trigger end.
      var shouldUpdate = _this.props.onDrag(e, coreEvent);
      if (shouldUpdate === false) {
        try {
          // $FlowIgnore
          _this.handleDragStop(new MouseEvent('mouseup'));
        } catch (err) {
          // Old browsers
          var event = ((document.createEvent('MouseEvents') /*: any*/) /*: MouseTouchEvent*/);
          // I see why this insanity was deprecated
          // $FlowIgnore
          event.initMouseEvent('mouseup', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
          _this.handleDragStop(event);
        }
        return;
      }

      _this.setState({
        lastX: x,
        lastY: y
      });
    }, _this.handleDragStop = function (e) {
      if (!_this.state.dragging) return;

      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _this);
      if (position == null) return;
      var x = position.x,
          y = position.y;

      var coreEvent = (0, _positionFns.createCoreData)(_this, x, y);

      var thisNode = _reactDom2.default.findDOMNode(_this);
      if (thisNode) {
        // Remove user-select hack
        if (_this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(thisNode.ownerDocument);
      }

      (0, _log2.default)('DraggableCore: handleDragStop: %j', coreEvent);

      // Reset the el.
      _this.setState({
        dragging: false,
        lastX: NaN,
        lastY: NaN
      });

      // Call event handler
      _this.props.onStop(e, coreEvent);

      if (thisNode) {
        // Remove event handlers
        (0, _log2.default)('DraggableCore: Removing handlers');
        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.move, _this.handleDrag);
        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.stop, _this.handleDragStop);
      }
    }, _this.onMouseDown = function (e) {
      dragEventFor = eventsFor.mouse; // on touchscreen laptops we could switch back to mouse

      return _this.handleDragStart(e);
    }, _this.onMouseUp = function (e) {
      dragEventFor = eventsFor.mouse;

      return _this.handleDragStop(e);
    }, _this.onTouchStart = function (e) {
      // We're on a touch device now, so change the event handlers
      dragEventFor = eventsFor.touch;

      return _this.handleDragStart(e);
    }, _this.onTouchEnd = function (e) {
      // We're on a touch device now, so change the event handlers
      dragEventFor = eventsFor.touch;

      return _this.handleDragStop(e);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DraggableCore, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // Remove any leftover event handlers. Remove both touch and mouse handlers in case
      // some browser quirk caused a touch event to fire during a mouse move, or vice versa.
      var thisNode = _reactDom2.default.findDOMNode(this);
      if (thisNode) {
        var ownerDocument = thisNode.ownerDocument;

        (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.move, this.handleDrag);
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.move, this.handleDrag);
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.stop, this.handleDragStop);
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.stop, this.handleDragStop);
        if (this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(ownerDocument);
      }
    }

    // Same as onMouseDown (start drag), but now consider this a touch device.

  }, {
    key: 'render',
    value: function render() {
      // Reuse the child provided
      // This makes it flexible to use whatever element is wanted (div, ul, etc)
      return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), {
        style: (0, _domFns.styleHacks)(this.props.children.props.style),

        // Note: mouseMove handler is attached to document so it will still function
        // when the user drags quickly and leaves the bounds of the element.
        onMouseDown: this.onMouseDown,
        onTouchStart: this.onTouchStart,
        onMouseUp: this.onMouseUp,
        onTouchEnd: this.onTouchEnd
      });
    }
  }]);

  return DraggableCore;
}(_react2.default.Component);

DraggableCore.displayName = 'DraggableCore';
DraggableCore.propTypes = {
  /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */
  allowAnyClick: _propTypes2.default.bool,

  /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */
  disabled: _propTypes2.default.bool,

  /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */
  enableUserSelectHack: _propTypes2.default.bool,

  /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */
  offsetParent: function offsetParent(props /*: DraggableCoreProps*/, propName /*: $Keys<DraggableCoreProps>*/) {
    if (process.browser === true && props[propName] && props[propName].nodeType !== 1) {
      throw new Error('Draggable\'s offsetParent must be a DOM Node.');
    }
  },

  /**
   * `grid` specifies the x and y that dragging should snap to.
   */
  grid: _propTypes2.default.arrayOf(_propTypes2.default.number),

  /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */
  handle: _propTypes2.default.string,

  /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */
  cancel: _propTypes2.default.string,

  /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onStart: _propTypes2.default.func,

  /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onDrag: _propTypes2.default.func,

  /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */
  onStop: _propTypes2.default.func,

  /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */
  onMouseDown: _propTypes2.default.func,

  /**
   * These properties should be defined on the child, not here.
   */
  className: _shims.dontSetMe,
  style: _shims.dontSetMe,
  transform: _shims.dontSetMe
};
DraggableCore.defaultProps = {
  allowAnyClick: false, // by default only accept left click
  cancel: null,
  disabled: false,
  enableUserSelectHack: true,
  offsetParent: null,
  handle: null,
  grid: null,
  transform: null,
  onStart: function onStart() {},
  onDrag: function onDrag() {},
  onStop: function onStop() {},
  onMouseDown: function onMouseDown() {}
};
exports.default = DraggableCore;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(20)))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = log;

/*eslint no-console:0*/
function log() {
  var _console;

  if (undefined) (_console = console).log.apply(_console, arguments);
}

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Draggable = __webpack_require__(13).default;

// Previous versions of this lib exported <Draggable> as the root export. As to not break
// them, or TypeScript, we export *both* as the root and as 'default'.
// See https://github.com/mzabriskie/react-draggable/pull/254
// and https://github.com/mzabriskie/react-draggable/issues/266
module.exports = Draggable;
module.exports.default = Draggable;
module.exports.DraggableCore = __webpack_require__(10).default;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(6);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(4);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = __webpack_require__(18);

var _classnames2 = _interopRequireDefault(_classnames);

var _domFns = __webpack_require__(5);

var _positionFns = __webpack_require__(9);

var _shims = __webpack_require__(0);

var _DraggableCore = __webpack_require__(10);

var _DraggableCore2 = _interopRequireDefault(_DraggableCore);

var _log = __webpack_require__(11);

var _log2 = _interopRequireDefault(_log);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*:: import type {ControlPosition, DraggableBounds, DraggableCoreProps} from './DraggableCore';*/
/*:: import type {DraggableEventHandler} from './utils/types';*/
/*:: import type {Element as ReactElement} from 'react';*/
/*:: type DraggableState = {
  dragging: boolean,
  dragged: boolean,
  x: number, y: number,
  slackX: number, slackY: number,
  isElementSVG: boolean
};*/


//
// Define <Draggable>
//

/*:: export type DraggableProps = {
  ...$Exact<DraggableCoreProps>,
  axis: 'both' | 'x' | 'y' | 'none',
  bounds: DraggableBounds | string | false,
  defaultClassName: string,
  defaultClassNameDragging: string,
  defaultClassNameDragged: string,
  defaultPosition: ControlPosition,
  position: ControlPosition,
};*/

var Draggable = function (_React$Component) {
  _inherits(Draggable, _React$Component);

  function Draggable(props /*: DraggableProps*/) {
    _classCallCheck(this, Draggable);

    var _this = _possibleConstructorReturn(this, (Draggable.__proto__ || Object.getPrototypeOf(Draggable)).call(this, props));

    _this.onDragStart = function (e, coreData) {
      (0, _log2.default)('Draggable: onDragStart: %j', coreData);

      // Short-circuit if user's callback killed it.
      var shouldStart = _this.props.onStart(e, (0, _positionFns.createDraggableData)(_this, coreData));
      // Kills start event on core as well, so move handlers are never bound.
      if (shouldStart === false) return false;

      _this.setState({ dragging: true, dragged: true });
    };

    _this.onDrag = function (e, coreData) {
      if (!_this.state.dragging) return false;
      (0, _log2.default)('Draggable: onDrag: %j', coreData);

      var uiData = (0, _positionFns.createDraggableData)(_this, coreData);

      var newState /*: $Shape<DraggableState>*/ = {
        x: uiData.x,
        y: uiData.y
      };

      // Keep within bounds.
      if (_this.props.bounds) {
        // Save original x and y.
        var _x = newState.x,
            _y = newState.y;

        // Add slack to the values used to calculate bound position. This will ensure that if
        // we start removing slack, the element won't react to it right away until it's been
        // completely removed.

        newState.x += _this.state.slackX;
        newState.y += _this.state.slackY;

        // Get bound position. This will ceil/floor the x and y within the boundaries.

        var _getBoundPosition = (0, _positionFns.getBoundPosition)(_this, newState.x, newState.y),
            _getBoundPosition2 = _slicedToArray(_getBoundPosition, 2),
            newStateX = _getBoundPosition2[0],
            newStateY = _getBoundPosition2[1];

        newState.x = newStateX;
        newState.y = newStateY;

        // Recalculate slack by noting how much was shaved by the boundPosition handler.
        newState.slackX = _this.state.slackX + (_x - newState.x);
        newState.slackY = _this.state.slackY + (_y - newState.y);

        // Update the event we fire to reflect what really happened after bounds took effect.
        uiData.x = newState.x;
        uiData.y = newState.y;
        uiData.deltaX = newState.x - _this.state.x;
        uiData.deltaY = newState.y - _this.state.y;
      }

      // Short-circuit if user's callback killed it.
      var shouldUpdate = _this.props.onDrag(e, uiData);
      if (shouldUpdate === false) return false;

      _this.setState(newState);
    };

    _this.onDragStop = function (e, coreData) {
      if (!_this.state.dragging) return false;

      // Short-circuit if user's callback killed it.
      var shouldStop = _this.props.onStop(e, (0, _positionFns.createDraggableData)(_this, coreData));
      if (shouldStop === false) return false;

      (0, _log2.default)('Draggable: onDragStop: %j', coreData);

      var newState /*: $Shape<DraggableState>*/ = {
        dragging: false,
        slackX: 0,
        slackY: 0
      };

      // If this is a controlled component, the result of this operation will be to
      // revert back to the old position. We expect a handler on `onDragStop`, at the least.
      var controlled = Boolean(_this.props.position);
      if (controlled) {
        var _this$props$position = _this.props.position,
            _x2 = _this$props$position.x,
            _y2 = _this$props$position.y;

        newState.x = _x2;
        newState.y = _y2;
      }

      _this.setState(newState);
    };

    _this.state = {
      // Whether or not we are currently dragging.
      dragging: false,

      // Whether or not we have been dragged before.
      dragged: false,

      // Current transform x and y.
      x: props.position ? props.position.x : props.defaultPosition.x,
      y: props.position ? props.position.y : props.defaultPosition.y,

      // Used for compensating for out-of-bounds drags
      slackX: 0, slackY: 0,

      // Can only determine if SVG after mounting
      isElementSVG: false
    };
    return _this;
  }

  _createClass(Draggable, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.position && !(this.props.onDrag || this.props.onStop)) {
        // eslint-disable-next-line
        console.warn('A `position` was applied to this <Draggable>, without drag handlers. This will make this ' + 'component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the ' + '`position` of this element.');
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Check to see if the element passed is an instanceof SVGElement
      if (typeof window.SVGElement !== 'undefined' && _reactDom2.default.findDOMNode(this) instanceof window.SVGElement) {
        this.setState({ isElementSVG: true });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps /*: Object*/) {
      // Set x/y if position has changed
      if (nextProps.position && (!this.props.position || nextProps.position.x !== this.props.position.x || nextProps.position.y !== this.props.position.y)) {
        this.setState({ x: nextProps.position.x, y: nextProps.position.y });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.setState({ dragging: false }); // prevents invariant if unmounted while dragging
    }
  }, {
    key: 'render',
    value: function render() /*: ReactElement<any>*/ {
      var _classNames;

      var style = {},
          svgTransform = null;

      // If this is controlled, we don't want to move it - unless it's dragging.
      var controlled = Boolean(this.props.position);
      var draggable = !controlled || this.state.dragging;

      var position = this.props.position || this.props.defaultPosition;
      var transformOpts = {
        // Set left if horizontal drag is enabled
        x: (0, _positionFns.canDragX)(this) && draggable ? this.state.x : position.x,

        // Set top if vertical drag is enabled
        y: (0, _positionFns.canDragY)(this) && draggable ? this.state.y : position.y
      };

      // If this element was SVG, we use the `transform` attribute.
      if (this.state.isElementSVG) {
        svgTransform = (0, _domFns.createSVGTransform)(transformOpts);
      } else {
        // Add a CSS transform to move the element around. This allows us to move the element around
        // without worrying about whether or not it is relatively or absolutely positioned.
        // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
        // has a clean slate.
        style = (0, _domFns.createCSSTransform)(transformOpts);
      }

      var _props = this.props,
          defaultClassName = _props.defaultClassName,
          defaultClassNameDragging = _props.defaultClassNameDragging,
          defaultClassNameDragged = _props.defaultClassNameDragged;


      var children = _react2.default.Children.only(this.props.children);

      // Mark with class while dragging
      var className = (0, _classnames2.default)(children.props.className || '', defaultClassName, (_classNames = {}, _defineProperty(_classNames, defaultClassNameDragging, this.state.dragging), _defineProperty(_classNames, defaultClassNameDragged, this.state.dragged), _classNames));

      // Reuse the child provided
      // This makes it flexible to use whatever element is wanted (div, ul, etc)
      return _react2.default.createElement(
        _DraggableCore2.default,
        _extends({}, this.props, { onStart: this.onDragStart, onDrag: this.onDrag, onStop: this.onDragStop }),
        _react2.default.cloneElement(children, {
          className: className,
          style: _extends({}, children.props.style, style),
          transform: svgTransform
        })
      );
    }
  }]);

  return Draggable;
}(_react2.default.Component);

Draggable.displayName = 'Draggable';
Draggable.propTypes = _extends({}, _DraggableCore2.default.propTypes, {

  /**
   * `axis` determines which axis the draggable can move.
   *
   *  Note that all callbacks will still return data as normal. This only
   *  controls flushing to the DOM.
   *
   * 'both' allows movement horizontally and vertically.
   * 'x' limits movement to horizontal axis.
   * 'y' limits movement to vertical axis.
   * 'none' limits all movement.
   *
   * Defaults to 'both'.
   */
  axis: _propTypes2.default.oneOf(['both', 'x', 'y', 'none']),

  /**
   * `bounds` determines the range of movement available to the element.
   * Available values are:
   *
   * 'parent' restricts movement within the Draggable's parent node.
   *
   * Alternatively, pass an object with the following properties, all of which are optional:
   *
   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
   *
   * All values are in px.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable bounds={{right: 300, bottom: 300}}>
   *              <div>Content</div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */
  bounds: _propTypes2.default.oneOfType([_propTypes2.default.shape({
    left: _propTypes2.default.number,
    right: _propTypes2.default.number,
    top: _propTypes2.default.number,
    bottom: _propTypes2.default.number
  }), _propTypes2.default.string, _propTypes2.default.oneOf([false])]),

  defaultClassName: _propTypes2.default.string,
  defaultClassNameDragging: _propTypes2.default.string,
  defaultClassNameDragged: _propTypes2.default.string,

  /**
   * `defaultPosition` specifies the x and y that the dragged item should start at
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */
  defaultPosition: _propTypes2.default.shape({
    x: _propTypes2.default.number,
    y: _propTypes2.default.number
  }),

  /**
   * `position`, if present, defines the current position of the element.
   *
   *  This is similar to how form elements in React work - if no `position` is supplied, the component
   *  is uncontrolled.
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable position={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */
  position: _propTypes2.default.shape({
    x: _propTypes2.default.number,
    y: _propTypes2.default.number
  }),

  /**
   * These properties should be defined on the child, not here.
   */
  className: _shims.dontSetMe,
  style: _shims.dontSetMe,
  transform: _shims.dontSetMe
});
Draggable.defaultProps = _extends({}, _DraggableCore2.default.defaultProps, {
  axis: 'both',
  bounds: false,
  defaultClassName: 'react-draggable',
  defaultClassNameDragging: 'react-draggable-dragging',
  defaultClassNameDragged: 'react-draggable-dragged',
  defaultPosition: { x: 0, y: 0 },
  position: null
});
exports.default = Draggable;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(1);
var invariant = __webpack_require__(2);
var warning = __webpack_require__(8);
var assign = __webpack_require__(15);

var ReactPropTypesSecret = __webpack_require__(3);
var checkPropTypes = __webpack_require__(16);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production') {
  var invariant = __webpack_require__(2);
  var warning = __webpack_require__(8);
  var ReactPropTypesSecret = __webpack_require__(3);
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(1);
var invariant = __webpack_require__(2);
var ReactPropTypesSecret = __webpack_require__(3);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPrefix = getPrefix;
exports.browserPrefixToKey = browserPrefixToKey;
exports.browserPrefixToStyle = browserPrefixToStyle;
var prefixes = ['Moz', 'Webkit', 'O', 'ms'];
function getPrefix() /*: string*/ {
  var prop /*: string*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';

  // Checking specifically for 'window.document' is for pseudo-browser server-side
  // environments that define 'window' as the global context.
  // E.g. React-rails (see https://github.com/reactjs/react-rails/pull/84)
  if (typeof window === 'undefined' || typeof window.document === 'undefined') return '';

  var style = window.document.documentElement.style;

  if (prop in style) return '';

  for (var i = 0; i < prefixes.length; i++) {
    if (browserPrefixToKey(prop, prefixes[i]) in style) return prefixes[i];
  }

  return '';
}

function browserPrefixToKey(prop /*: string*/, prefix /*: string*/) /*: string*/ {
  return prefix ? '' + prefix + kebabToTitleCase(prop) : prop;
}

function browserPrefixToStyle(prop /*: string*/, prefix /*: string*/) /*: string*/ {
  return prefix ? '-' + prefix.toLowerCase() + '-' + prop : prop;
}

function kebabToTitleCase(str /*: string*/) /*: string*/ {
  var out = '';
  var shouldCapitalize = true;
  for (var i = 0; i < str.length; i++) {
    if (shouldCapitalize) {
      out += str[i].toUpperCase();
      shouldCapitalize = false;
    } else if (str[i] === '-') {
      shouldCapitalize = true;
    } else {
      out += str[i];
    }
  }
  return out;
}

// Default export is the prefix itself, like 'Moz', 'Webkit', etc
// Note that you may have to re-test for certain things; for instance, Chrome 50
// can handle unprefixed `transform`, but not unprefixed `user-select`
exports.default = getPrefix();

/***/ }),
/* 20 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=react-draggable.js.map

/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(0), __webpack_require__(1));
	else if(typeof define === 'function' && define.amd)
		define(["react", "prop-types"], factory);
	else if(typeof exports === 'object')
		exports["Dropzone"] = factory(require("react"), require("prop-types"));
	else
		root["Dropzone"] = factory(root["react"], root["prop-types"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _attrAccept = __webpack_require__(4);
	
	var _attrAccept2 = _interopRequireDefault(_attrAccept);
	
	var _getDataTransferItems = __webpack_require__(5);
	
	var _getDataTransferItems2 = _interopRequireDefault(_getDataTransferItems);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint prefer-template: 0 */
	
	var supportMultiple = typeof document !== 'undefined' && document && document.createElement ? 'multiple' in document.createElement('input') : true;
	
	function fileAccepted(file, accept) {
	  // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
	  // that MIME type will always be accepted
	  return file.type === 'application/x-moz-file' || (0, _attrAccept2.default)(file, accept);
	}
	
	var Dropzone = function (_React$Component) {
	  _inherits(Dropzone, _React$Component);
	
	  _createClass(Dropzone, null, [{
	    key: 'onDocumentDragOver',
	    value: function onDocumentDragOver(evt) {
	      // allow the entire document to be a drag target
	      evt.preventDefault();
	    }
	  }]);
	
	  function Dropzone(props, context) {
	    _classCallCheck(this, Dropzone);
	
	    var _this = _possibleConstructorReturn(this, (Dropzone.__proto__ || Object.getPrototypeOf(Dropzone)).call(this, props, context));
	
	    _this.renderChildren = function (children, isDragActive, isDragReject) {
	      if (typeof children === 'function') {
	        return children(_extends({}, _this.state, { isDragActive: isDragActive, isDragReject: isDragReject }));
	      }
	      return children;
	    };
	
	    _this.onClick = _this.onClick.bind(_this);
	    _this.onDocumentDrop = _this.onDocumentDrop.bind(_this);
	    _this.onDragStart = _this.onDragStart.bind(_this);
	    _this.onDragEnter = _this.onDragEnter.bind(_this);
	    _this.onDragLeave = _this.onDragLeave.bind(_this);
	    _this.onDragOver = _this.onDragOver.bind(_this);
	    _this.onDrop = _this.onDrop.bind(_this);
	    _this.onFileDialogCancel = _this.onFileDialogCancel.bind(_this);
	    _this.setRef = _this.setRef.bind(_this);
	    _this.setRefs = _this.setRefs.bind(_this);
	    _this.onInputElementClick = _this.onInputElementClick.bind(_this);
	    _this.isFileDialogActive = false;
	    _this.state = {
	      draggedFiles: [],
	      acceptedFiles: [],
	      rejectedFiles: []
	    };
	    return _this;
	  }
	
	  _createClass(Dropzone, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var preventDropOnDocument = this.props.preventDropOnDocument;
	
	      this.dragTargets = [];
	
	      if (preventDropOnDocument) {
	        document.addEventListener('dragover', Dropzone.onDocumentDragOver, false);
	        document.addEventListener('drop', this.onDocumentDrop, false);
	      }
	      this.fileInputEl.addEventListener('click', this.onInputElementClick, false);
	      // Tried implementing addEventListener, but didn't work out
	      document.body.onfocus = this.onFileDialogCancel;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var preventDropOnDocument = this.props.preventDropOnDocument;
	
	      if (preventDropOnDocument) {
	        document.removeEventListener('dragover', Dropzone.onDocumentDragOver);
	        document.removeEventListener('drop', this.onDocumentDrop);
	      }
	      this.fileInputEl.removeEventListener('click', this.onInputElementClick, false);
	      // Can be replaced with removeEventListener, if addEventListener works
	      document.body.onfocus = null;
	    }
	  }, {
	    key: 'onDocumentDrop',
	    value: function onDocumentDrop(evt) {
	      if (this.node.contains(evt.target)) {
	        // if we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
	        return;
	      }
	      evt.preventDefault();
	      this.dragTargets = [];
	    }
	  }, {
	    key: 'onDragStart',
	    value: function onDragStart(evt) {
	      if (this.props.onDragStart) {
	        this.props.onDragStart.call(this, evt);
	      }
	    }
	  }, {
	    key: 'onDragEnter',
	    value: function onDragEnter(evt) {
	      evt.preventDefault();
	
	      // Count the dropzone and any children that are entered.
	      if (this.dragTargets.indexOf(evt.target) === -1) {
	        this.dragTargets.push(evt.target);
	      }
	
	      this.setState({ draggedFiles: (0, _getDataTransferItems2.default)(evt) });
	
	      if (this.props.onDragEnter) {
	        this.props.onDragEnter.call(this, evt);
	      }
	    }
	  }, {
	    key: 'onDragOver',
	    value: function onDragOver(evt) {
	      // eslint-disable-line class-methods-use-this
	      evt.preventDefault();
	      evt.stopPropagation();
	      try {
	        evt.dataTransfer.dropEffect = 'copy'; // eslint-disable-line no-param-reassign
	      } catch (err) {
	        // continue regardless of error
	      }
	
	      if (this.props.onDragOver) {
	        this.props.onDragOver.call(this, evt);
	      }
	      return false;
	    }
	  }, {
	    key: 'onDragLeave',
	    value: function onDragLeave(evt) {
	      var _this2 = this;
	
	      evt.preventDefault();
	
	      // Only deactivate once the dropzone and all children have been left.
	      this.dragTargets = this.dragTargets.filter(function (el) {
	        return el !== evt.target && _this2.node.contains(el);
	      });
	      if (this.dragTargets.length > 0) {
	        return;
	      }
	
	      // Clear dragging files state
	      this.setState({ draggedFiles: [] });
	
	      if (this.props.onDragLeave) {
	        this.props.onDragLeave.call(this, evt);
	      }
	    }
	  }, {
	    key: 'onDrop',
	    value: function onDrop(evt) {
	      var _this3 = this;
	
	      var _props = this.props,
	          onDrop = _props.onDrop,
	          onDropAccepted = _props.onDropAccepted,
	          onDropRejected = _props.onDropRejected,
	          multiple = _props.multiple,
	          disablePreview = _props.disablePreview,
	          accept = _props.accept;
	
	      var fileList = (0, _getDataTransferItems2.default)(evt);
	      var acceptedFiles = [];
	      var rejectedFiles = [];
	
	      // Stop default browser behavior
	      evt.preventDefault();
	
	      // Reset the counter along with the drag on a drop.
	      this.dragTargets = [];
	      this.isFileDialogActive = false;
	
	      fileList.forEach(function (file) {
	        if (!disablePreview) {
	          try {
	            file.preview = window.URL.createObjectURL(file); // eslint-disable-line no-param-reassign
	          } catch (err) {
	            if (process.env.NODE_ENV !== 'production') {
	              console.error('Failed to generate preview for file', file, err); // eslint-disable-line no-console
	            }
	          }
	        }
	
	        if (fileAccepted(file, accept) && _this3.fileMatchSize(file)) {
	          acceptedFiles.push(file);
	        } else {
	          rejectedFiles.push(file);
	        }
	      });
	
	      if (!multiple) {
	        // if not in multi mode add any extra accepted files to rejected.
	        // This will allow end users to easily ignore a multi file drop in "single" mode.
	        rejectedFiles.push.apply(rejectedFiles, _toConsumableArray(acceptedFiles.splice(1)));
	      }
	
	      if (onDrop) {
	        onDrop.call(this, acceptedFiles, rejectedFiles, evt);
	      }
	
	      if (rejectedFiles.length > 0 && onDropRejected) {
	        onDropRejected.call(this, rejectedFiles, evt);
	      }
	
	      if (acceptedFiles.length > 0 && onDropAccepted) {
	        onDropAccepted.call(this, acceptedFiles, evt);
	      }
	
	      // Clear files value
	      this.draggedFiles = null;
	
	      // Reset drag state
	      this.setState({
	        draggedFiles: [],
	        acceptedFiles: acceptedFiles,
	        rejectedFiles: rejectedFiles
	      });
	    }
	  }, {
	    key: 'onClick',
	    value: function onClick(evt) {
	      var _props2 = this.props,
	          onClick = _props2.onClick,
	          disableClick = _props2.disableClick;
	
	      if (!disableClick) {
	        evt.stopPropagation();
	
	        if (onClick) {
	          onClick.call(this, evt);
	        }
	
	        // in IE11/Edge the file-browser dialog is blocking, ensure this is behind setTimeout
	        // this is so react can handle state changes in the onClick prop above above
	        // see: https://github.com/okonet/react-dropzone/issues/450
	        setTimeout(this.open.bind(this), 0);
	      }
	    }
	  }, {
	    key: 'onInputElementClick',
	    value: function onInputElementClick(evt) {
	      evt.stopPropagation();
	      if (this.props.inputProps && this.props.inputProps.onClick) {
	        this.props.inputProps.onClick();
	      }
	    }
	  }, {
	    key: 'onFileDialogCancel',
	    value: function onFileDialogCancel() {
	      // timeout will not recognize context of this method
	      var onFileDialogCancel = this.props.onFileDialogCancel;
	      var fileInputEl = this.fileInputEl;
	      var isFileDialogActive = this.isFileDialogActive;
	      // execute the timeout only if the onFileDialogCancel is defined and FileDialog
	      // is opened in the browser
	
	      if (onFileDialogCancel && isFileDialogActive) {
	        setTimeout(function () {
	          // Returns an object as FileList
	          var FileList = fileInputEl.files;
	          if (!FileList.length) {
	            isFileDialogActive = false;
	            onFileDialogCancel();
	          }
	        }, 300);
	      }
	    }
	  }, {
	    key: 'setRef',
	    value: function setRef(ref) {
	      this.node = ref;
	    }
	  }, {
	    key: 'setRefs',
	    value: function setRefs(ref) {
	      this.fileInputEl = ref;
	    }
	  }, {
	    key: 'fileMatchSize',
	    value: function fileMatchSize(file) {
	      return file.size <= this.props.maxSize && file.size >= this.props.minSize;
	    }
	  }, {
	    key: 'allFilesAccepted',
	    value: function allFilesAccepted(files) {
	      var _this4 = this;
	
	      return files.every(function (file) {
	        return fileAccepted(file, _this4.props.accept);
	      });
	    }
	
	    /**
	     * Open system file upload dialog.
	     *
	     * @public
	     */
	
	  }, {
	    key: 'open',
	    value: function open() {
	      this.isFileDialogActive = true;
	      this.fileInputEl.value = null;
	      this.fileInputEl.click();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          accept = _props3.accept,
	          activeClassName = _props3.activeClassName,
	          inputProps = _props3.inputProps,
	          multiple = _props3.multiple,
	          name = _props3.name,
	          rejectClassName = _props3.rejectClassName,
	          children = _props3.children,
	          rest = _objectWithoutProperties(_props3, ['accept', 'activeClassName', 'inputProps', 'multiple', 'name', 'rejectClassName', 'children']);
	
	      var activeStyle = rest.activeStyle,
	          className = rest.className,
	          rejectStyle = rest.rejectStyle,
	          style = rest.style,
	          props = _objectWithoutProperties(rest, ['activeStyle', 'className', 'rejectStyle', 'style']);
	
	      var draggedFiles = this.state.draggedFiles;
	
	      var filesCount = draggedFiles.length;
	      var isMultipleAllowed = multiple || filesCount <= 1;
	      var isDragActive = filesCount > 0 && this.allFilesAccepted(draggedFiles);
	      var isDragReject = filesCount > 0 && (!isDragActive || !isMultipleAllowed);
	
	      className = className || '';
	
	      if (isDragActive && activeClassName) {
	        className += ' ' + activeClassName;
	      }
	      if (isDragReject && rejectClassName) {
	        className += ' ' + rejectClassName;
	      }
	
	      if (!className && !style && !activeStyle && !rejectStyle) {
	        style = {
	          width: 200,
	          height: 200,
	          borderWidth: 2,
	          borderColor: '#666',
	          borderStyle: 'dashed',
	          borderRadius: 5
	        };
	        activeStyle = {
	          borderStyle: 'solid',
	          borderColor: '#6c6',
	          backgroundColor: '#eee'
	        };
	        rejectStyle = {
	          borderStyle: 'solid',
	          borderColor: '#c66',
	          backgroundColor: '#eee'
	        };
	      }
	
	      var appliedStyle = void 0;
	      if (activeStyle && isDragActive) {
	        appliedStyle = _extends({}, style, activeStyle);
	      } else if (rejectStyle && isDragReject) {
	        appliedStyle = _extends({}, style, rejectStyle);
	      } else {
	        appliedStyle = _extends({}, style);
	      }
	
	      var inputAttributes = {
	        accept: accept,
	        type: 'file',
	        style: { display: 'none' },
	        multiple: supportMultiple && multiple,
	        ref: this.setRefs,
	        onChange: this.onDrop
	      };
	
	      if (name && name.length) {
	        inputAttributes.name = name;
	      }
	
	      // Remove custom properties before passing them to the wrapper div element
	      var customProps = ['acceptedFiles', 'preventDropOnDocument', 'disablePreview', 'disableClick', 'onDropAccepted', 'onDropRejected', 'onFileDialogCancel', 'maxSize', 'minSize'];
	      var divProps = _extends({}, props);
	      customProps.forEach(function (prop) {
	        return delete divProps[prop];
	      });
	
	      return _react2.default.createElement(
	        'div',
	        _extends({
	          className: className,
	          style: appliedStyle
	        }, divProps /* expand user provided props first so event handlers are never overridden */, {
	          onClick: this.onClick,
	          onDragStart: this.onDragStart,
	          onDragEnter: this.onDragEnter,
	          onDragOver: this.onDragOver,
	          onDragLeave: this.onDragLeave,
	          onDrop: this.onDrop,
	          ref: this.setRef
	        }),
	        this.renderChildren(children, isDragActive, isDragReject),
	        _react2.default.createElement('input', _extends({}, inputProps /* expand user provided inputProps first so inputAttributes override them */, inputAttributes))
	      );
	    }
	  }]);
	
	  return Dropzone;
	}(_react2.default.Component);
	
	Dropzone.propTypes = {
	  /**
	   * Allow specific types of files. See https://github.com/okonet/attr-accept for more information.
	   * Keep in mind that mime type determination is not reliable accross platforms. CSV files,
	   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
	   * Windows. In some cases there might not be a mime type set at all.
	   * See: https://github.com/okonet/react-dropzone/issues/276
	   */
	  accept: _propTypes2.default.string,
	
	  /**
	   * Contents of the dropzone
	   */
	  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
	
	  /**
	   * Disallow clicking on the dropzone container to open file dialog
	   */
	  disableClick: _propTypes2.default.bool,
	
	  /**
	   * Enable/disable preview generation
	   */
	  disablePreview: _propTypes2.default.bool,
	
	  /**
	   * If false, allow dropped items to take over the current browser window
	   */
	  preventDropOnDocument: _propTypes2.default.bool,
	
	  /**
	   * Pass additional attributes to the `<input type="file"/>` tag
	   */
	  inputProps: _propTypes2.default.object,
	
	  /**
	   * Allow dropping multiple files
	   */
	  multiple: _propTypes2.default.bool,
	
	  /**
	   * `name` attribute for the input tag
	   */
	  name: _propTypes2.default.string,
	
	  /**
	   * Maximum file size
	   */
	  maxSize: _propTypes2.default.number,
	
	  /**
	   * Minimum file size
	   */
	  minSize: _propTypes2.default.number,
	
	  /**
	   * className
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * className for accepted state
	   */
	  activeClassName: _propTypes2.default.string,
	
	  /**
	   * className for rejected state
	   */
	  rejectClassName: _propTypes2.default.string,
	
	  /**
	   * CSS styles to apply
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * CSS styles to apply when drop will be accepted
	   */
	  activeStyle: _propTypes2.default.object,
	
	  /**
	   * CSS styles to apply when drop will be rejected
	   */
	  rejectStyle: _propTypes2.default.object,
	
	  /**
	   * onClick callback
	   * @param {Event} event
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * onDrop callback
	   */
	  onDrop: _propTypes2.default.func,
	
	  /**
	   * onDropAccepted callback
	   */
	  onDropAccepted: _propTypes2.default.func,
	
	  /**
	   * onDropRejected callback
	   */
	  onDropRejected: _propTypes2.default.func,
	
	  /**
	   * onDragStart callback
	   */
	  onDragStart: _propTypes2.default.func,
	
	  /**
	   * onDragEnter callback
	   */
	  onDragEnter: _propTypes2.default.func,
	
	  /**
	   * onDragOver callback
	   */
	  onDragOver: _propTypes2.default.func,
	
	  /**
	   * onDragLeave callback
	   */
	  onDragLeave: _propTypes2.default.func,
	
	  /**
	   * Provide a callback on clicking the cancel button of the file dialog
	   */
	  onFileDialogCancel: _propTypes2.default.func
	};
	
	Dropzone.defaultProps = {
	  preventDropOnDocument: true,
	  disablePreview: false,
	  disableClick: false,
	  multiple: true,
	  maxSize: Infinity,
	  minSize: 0
	};
	
	exports.default = Dropzone;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	module.exports=function(t){function n(e){if(r[e])return r[e].exports;var o=r[e]={exports:{},id:e,loaded:!1};return t[e].call(o.exports,o,o.exports,n),o.loaded=!0,o.exports}var r={};return n.m=t,n.c=r,n.p="",n(0)}([function(t,n,r){"use strict";n.__esModule=!0,r(8),r(9),n["default"]=function(t,n){if(t&&n){var r=function(){var r=Array.isArray(n)?n:n.split(","),e=t.name||"",o=t.type||"",i=o.replace(/\/.*$/,"");return{v:r.some(function(t){var n=t.trim();return"."===n.charAt(0)?e.toLowerCase().endsWith(n.toLowerCase()):/\/\*$/.test(n)?i===n.replace(/\/.*$/,""):o===n})}}();if("object"==typeof r)return r.v}return!0},t.exports=n["default"]},function(t,n){var r=t.exports={version:"1.2.2"};"number"==typeof __e&&(__e=r)},function(t,n){var r=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=r)},function(t,n,r){var e=r(2),o=r(1),i=r(4),u=r(19),c="prototype",f=function(t,n){return function(){return t.apply(n,arguments)}},s=function(t,n,r){var a,p,l,y,d=t&s.G,h=t&s.P,v=d?e:t&s.S?e[n]||(e[n]={}):(e[n]||{})[c],x=d?o:o[n]||(o[n]={});d&&(r=n);for(a in r)p=!(t&s.F)&&v&&a in v,l=(p?v:r)[a],y=t&s.B&&p?f(l,e):h&&"function"==typeof l?f(Function.call,l):l,v&&!p&&u(v,a,l),x[a]!=l&&i(x,a,y),h&&((x[c]||(x[c]={}))[a]=l)};e.core=o,s.F=1,s.G=2,s.S=4,s.P=8,s.B=16,s.W=32,t.exports=s},function(t,n,r){var e=r(5),o=r(18);t.exports=r(22)?function(t,n,r){return e.setDesc(t,n,o(1,r))}:function(t,n,r){return t[n]=r,t}},function(t,n){var r=Object;t.exports={create:r.create,getProto:r.getPrototypeOf,isEnum:{}.propertyIsEnumerable,getDesc:r.getOwnPropertyDescriptor,setDesc:r.defineProperty,setDescs:r.defineProperties,getKeys:r.keys,getNames:r.getOwnPropertyNames,getSymbols:r.getOwnPropertySymbols,each:[].forEach}},function(t,n){var r=0,e=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++r+e).toString(36))}},function(t,n,r){var e=r(20)("wks"),o=r(2).Symbol;t.exports=function(t){return e[t]||(e[t]=o&&o[t]||(o||r(6))("Symbol."+t))}},function(t,n,r){r(26),t.exports=r(1).Array.some},function(t,n,r){r(25),t.exports=r(1).String.endsWith},function(t,n){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,n){var r={}.toString;t.exports=function(t){return r.call(t).slice(8,-1)}},function(t,n,r){var e=r(10);t.exports=function(t,n,r){if(e(t),void 0===n)return t;switch(r){case 1:return function(r){return t.call(n,r)};case 2:return function(r,e){return t.call(n,r,e)};case 3:return function(r,e,o){return t.call(n,r,e,o)}}return function(){return t.apply(n,arguments)}}},function(t,n){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,n,r){t.exports=function(t){var n=/./;try{"/./"[t](n)}catch(e){try{return n[r(7)("match")]=!1,!"/./"[t](n)}catch(o){}}return!0}},function(t,n){t.exports=function(t){try{return!!t()}catch(n){return!0}}},function(t,n){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,n,r){var e=r(16),o=r(11),i=r(7)("match");t.exports=function(t){var n;return e(t)&&(void 0!==(n=t[i])?!!n:"RegExp"==o(t))}},function(t,n){t.exports=function(t,n){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:n}}},function(t,n,r){var e=r(2),o=r(4),i=r(6)("src"),u="toString",c=Function[u],f=(""+c).split(u);r(1).inspectSource=function(t){return c.call(t)},(t.exports=function(t,n,r,u){"function"==typeof r&&(o(r,i,t[n]?""+t[n]:f.join(String(n))),"name"in r||(r.name=n)),t===e?t[n]=r:(u||delete t[n],o(t,n,r))})(Function.prototype,u,function(){return"function"==typeof this&&this[i]||c.call(this)})},function(t,n,r){var e=r(2),o="__core-js_shared__",i=e[o]||(e[o]={});t.exports=function(t){return i[t]||(i[t]={})}},function(t,n,r){var e=r(17),o=r(13);t.exports=function(t,n,r){if(e(n))throw TypeError("String#"+r+" doesn't accept regex!");return String(o(t))}},function(t,n,r){t.exports=!r(15)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,n){var r=Math.ceil,e=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?e:r)(t)}},function(t,n,r){var e=r(23),o=Math.min;t.exports=function(t){return t>0?o(e(t),9007199254740991):0}},function(t,n,r){"use strict";var e=r(3),o=r(24),i=r(21),u="endsWith",c=""[u];e(e.P+e.F*r(14)(u),"String",{endsWith:function(t){var n=i(this,t,u),r=arguments,e=r.length>1?r[1]:void 0,f=o(n.length),s=void 0===e?f:Math.min(o(e),f),a=String(t);return c?c.call(n,a,s):n.slice(s-a.length,s)===a}})},function(t,n,r){var e=r(5),o=r(3),i=r(1).Array||Array,u={},c=function(t,n){e.each.call(t.split(","),function(t){void 0==n&&t in i?u[t]=i[t]:t in[]&&(u[t]=r(12)(Function.call,[][t],n))})};c("pop,reverse,shift,keys,values,entries",1),c("indexOf,every,some,forEach,map,filter,find,findIndex,includes",3),c("join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill"),o(o.S,"Array",u)}]);

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDataTransferFiles;
	function getDataTransferFiles(event) {
	  var dataTransferItemsList = [];
	  if (event.dataTransfer) {
	    var dt = event.dataTransfer;
	    if (dt.files && dt.files.length) {
	      dataTransferItemsList = dt.files;
	    } else if (dt.items && dt.items.length) {
	      // During the drag even the dataTransfer.files is null
	      // but Chrome implements some drag store, which is accesible via dataTransfer.items
	      dataTransferItemsList = dt.items;
	    }
	  } else if (event.target && event.target.files) {
	    dataTransferItemsList = event.target.files;
	  }
	  // Convert from DataTransferItemsList to the native Array
	  return Array.prototype.slice.call(dataTransferItemsList);
	}
	module.exports = exports["default"];

/***/ })
/******/ ])
});
;
//# sourceMappingURL=index.js.map

/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__(24);

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaAngleRight = function FaAngleRight(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm26.3 21.4q0 0.3-0.2 0.5l-10.4 10.4q-0.3 0.3-0.6 0.3t-0.5-0.3l-1.1-1.1q-0.2-0.2-0.2-0.5t0.2-0.5l8.8-8.8-8.8-8.7q-0.2-0.3-0.2-0.6t0.2-0.5l1.1-1.1q0.3-0.2 0.5-0.2t0.6 0.2l10.4 10.4q0.2 0.2 0.2 0.5z' })
        )
    );
};

exports.default = FaAngleRight;
module.exports = exports['default'];

/***/ }),
/* 1781 */,
/* 1782 */,
/* 1783 */,
/* 1784 */,
/* 1785 */,
/* 1786 */,
/* 1787 */,
/* 1788 */,
/* 1789 */,
/* 1790 */,
/* 1791 */,
/* 1792 */,
/* 1793 */,
/* 1794 */,
/* 1795 */,
/* 1796 */,
/* 1797 */,
/* 1798 */,
/* 1799 */,
/* 1800 */,
/* 1801 */,
/* 1802 */,
/* 1803 */,
/* 1804 */,
/* 1805 */,
/* 1806 */,
/* 1807 */,
/* 1808 */,
/* 1809 */,
/* 1810 */,
/* 1811 */,
/* 1812 */,
/* 1813 */,
/* 1814 */,
/* 1815 */,
/* 1816 */,
/* 1817 */,
/* 1818 */,
/* 1819 */,
/* 1820 */,
/* 1821 */,
/* 1822 */,
/* 1823 */,
/* 1824 */,
/* 1825 */,
/* 1826 */,
/* 1827 */,
/* 1828 */,
/* 1829 */,
/* 1830 */,
/* 1831 */,
/* 1832 */,
/* 1833 */,
/* 1834 */,
/* 1835 */,
/* 1836 */,
/* 1837 */,
/* 1838 */,
/* 1839 */,
/* 1840 */,
/* 1841 */,
/* 1842 */,
/* 1843 */,
/* 1844 */,
/* 1845 */,
/* 1846 */,
/* 1847 */,
/* 1848 */,
/* 1849 */,
/* 1850 */,
/* 1851 */,
/* 1852 */,
/* 1853 */,
/* 1854 */,
/* 1855 */,
/* 1856 */,
/* 1857 */,
/* 1858 */,
/* 1859 */,
/* 1860 */,
/* 1861 */,
/* 1862 */,
/* 1863 */,
/* 1864 */,
/* 1865 */,
/* 1866 */,
/* 1867 */,
/* 1868 */,
/* 1869 */,
/* 1870 */,
/* 1871 */,
/* 1872 */,
/* 1873 */,
/* 1874 */,
/* 1875 */,
/* 1876 */,
/* 1877 */,
/* 1878 */,
/* 1879 */,
/* 1880 */,
/* 1881 */,
/* 1882 */,
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _reactDom = _interopRequireDefault(__webpack_require__(44));

var _exenv = _interopRequireDefault(__webpack_require__(1297));

var _TourPortal = _interopRequireDefault(__webpack_require__(1884));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var renderSubtreeIntoContainer = _reactDom.default.unstable_renderSubtreeIntoContainer;
var SafeHTMLElement = _exenv.default.canUseDOM ? window.HTMLElement : {};

function getParentElement(parentSelector) {
  return parentSelector();
}

var Tour =
/*#__PURE__*/
function (_Component) {
  _inherits(Tour, _Component);

  function Tour() {
    _classCallCheck(this, Tour);

    return _possibleConstructorReturn(this, _getPrototypeOf(Tour).apply(this, arguments));
  }

  _createClass(Tour, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.node = document.createElement('div');
      this.node.className = this.props.portalClassName;
      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);
      this.renderPortal(this.props);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var currentParent = getParentElement(this.props.parentSelector);
      var newParent = getParentElement(nextProps.parentSelector);

      if (newParent !== currentParent) {
        currentParent.removeChild(this.node);
        newParent.appendChild(this.node);
      }

      this.renderPortal(nextProps);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removePortal();
    }
  }, {
    key: "renderPortal",
    value: function renderPortal(props) {
      if (props.isOpen) {
        document.body.classList.add('reactour__body');
      } else {
        document.body.classList.remove('reactour__body');
      }

      this.portal = renderSubtreeIntoContainer(this, _react.default.createElement(_TourPortal.default, props), this.node);
    }
  }, {
    key: "removePortal",
    value: function removePortal() {
      _reactDom.default.unmountComponentAtNode(this.node);

      var parent = getParentElement(this.props.parentSelector);
      parent.removeChild(this.node);
      document.body.classList.remove('reactour__body');
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return Tour;
}(_react.Component);

_defineProperty(Tour, "propTypes", {
  isOpen: _propTypes.default.bool.isRequired,
  portalClassName: _propTypes.default.string,
  appElement: _propTypes.default.instanceOf(SafeHTMLElement),
  onAfterOpen: _propTypes.default.func,
  onRequestClose: _propTypes.default.func,
  closeWithMask: _propTypes.default.bool,
  parentSelector: _propTypes.default.func
});

_defineProperty(Tour, "defaultProps", {
  isOpen: false,
  portalClassName: 'reactour-portal',
  closeWithMask: true,
  parentSelector: function parentSelector() {
    return document.body;
  }
});

var _default = Tour;
exports.default = _default;

/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(76));

var _scrollSmooth = _interopRequireDefault(__webpack_require__(1975));

var _scrollparent = _interopRequireDefault(__webpack_require__(1976));

var _index = __webpack_require__(1893);

var hx = _interopRequireWildcard(__webpack_require__(393));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TourPortal =
/*#__PURE__*/
function (_Component) {
  _inherits(TourPortal, _Component);

  function TourPortal() {
    var _this;

    _classCallCheck(this, TourPortal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TourPortal).call(this));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "showStep", function () {
      var steps = _this.props.steps;
      var current = _this.state.current;
      var step = steps[current];
      var node = step.selector ? document.querySelector(step.selector) : null;

      var stepCallback = function stepCallback(o) {
        if (step.action && typeof step.action === 'function') {
          step.action(o);
        }
      };

      if (step.observe) {
        var target = document.querySelector(step.observe);
        var config = {
          attributes: true,
          childList: true,
          characterData: true
        };

        _this.setState(function (prevState) {
          if (prevState.observer) {
            setTimeout(function () {
              prevState.observer.disconnect();
            }, 0);
          }

          return {
            observer: new MutationObserver(function (mutations) {
              mutations.forEach(function (mutation) {
                if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                  var cb = function cb() {
                    return stepCallback(mutation.addedNodes[0]);
                  };

                  setTimeout(function () {
                    return _this.calculateNode(mutation.addedNodes[0], step.position, cb);
                  }, 100);
                } else if (mutation.type === 'childList' && mutation.removedNodes.length > 0) {
                  var _cb = function _cb() {
                    return stepCallback(node);
                  };

                  _this.calculateNode(node, step.position, _cb);
                }
              });
            })
          };
        }, function () {
          return _this.state.observer.observe(target, config);
        });
      } else {
        if (_this.state.observer) {
          _this.state.observer.disconnect();

          _this.setState({
            observer: null
          });
        }
      }

      if (node) {
        var cb = function cb() {
          return stepCallback(node);
        };

        _this.calculateNode(node, step.position, cb);
      } else {
        _this.setState(setNodeState(null, _this.helper, step.position), stepCallback);

        step.selector && console.warn("Doesn't find a DOM node '".concat(step.selector, "'.\n                    Please check the 'steps' Tour prop Array at position: ").concat(current + 1, "."));
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "calculateNode", function (node, stepPosition, cb) {
      var _this$props = _this.props,
          scrollDuration = _this$props.scrollDuration,
          inViewThreshold = _this$props.inViewThreshold,
          scrollOffset = _this$props.scrollOffset;
      var attrs = hx.getNodeRect(node);
      var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
      var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

      if (!hx.inView(_objectSpread({}, attrs, {
        w: w,
        h: h,
        threshold: inViewThreshold
      }))) {
        var parentScroll = (0, _scrollparent.default)(node);

        _scrollSmooth.default.to(node, {
          context: hx.isBody(parentScroll) ? window : parentScroll,
          duration: scrollDuration,
          offset: scrollOffset || -(h / 2),
          callback: function callback(nd) {
            _this.setState(setNodeState(nd, _this.helper, stepPosition), cb);
          }
        });
      } else {
        _this.setState(setNodeState(node, _this.helper, stepPosition), cb);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "maskClickHandler", function (e) {
      var _this$props2 = _this.props,
          closeWithMask = _this$props2.closeWithMask,
          onRequestClose = _this$props2.onRequestClose;

      if (closeWithMask && !e.target.classList.contains(CN.mask.disableInteraction)) {
        onRequestClose(e);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "nextStep", function () {
      var _this$props3 = _this.props,
          steps = _this$props3.steps,
          getCurrentStep = _this$props3.getCurrentStep;

      _this.setState(function (prevState) {
        var nextStep = prevState.current < steps.length - 1 ? prevState.current + 1 : prevState.current;

        if (typeof getCurrentStep === 'function') {
          getCurrentStep(nextStep);
        }

        return {
          current: nextStep
        };
      }, _this.showStep);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "prevStep", function () {
      var getCurrentStep = _this.props.getCurrentStep;

      _this.setState(function (prevState) {
        var nextStep = prevState.current > 0 ? prevState.current - 1 : prevState.current;

        if (typeof getCurrentStep === 'function') {
          getCurrentStep(nextStep);
        }

        return {
          current: nextStep
        };
      }, _this.showStep);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "gotoStep", function (n) {
      var _this$props4 = _this.props,
          steps = _this$props4.steps,
          getCurrentStep = _this$props4.getCurrentStep;

      _this.setState(function (prevState) {
        var nextStep = steps[n] ? n : prevState.current;

        if (typeof getCurrentStep === 'function') {
          getCurrentStep(nextStep);
        }

        return {
          current: nextStep
        };
      }, _this.showStep);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "keyDownHandler", function (e) {
      var _this$props5 = _this.props,
          onRequestClose = _this$props5.onRequestClose,
          nextStep = _this$props5.nextStep,
          prevStep = _this$props5.prevStep,
          disableKeyboardNavigation = _this$props5.disableKeyboardNavigation;
      e.stopPropagation();

      if (disableKeyboardNavigation) {
        return;
      }

      if (e.keyCode === 27) {
        // esc
        e.preventDefault();
        onRequestClose();
      }

      if (e.keyCode === 39) {
        // right
        e.preventDefault();
        typeof nextStep === 'function' ? nextStep() : _this.nextStep();
      }

      if (e.keyCode === 37) {
        // left
        e.preventDefault();
        typeof prevStep === 'function' ? prevStep() : _this.prevStep();
      }
    });

    _this.state = {
      isOpen: false,
      current: 0,
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      width: 0,
      height: 0,
      w: 0,
      h: 0,
      inDOM: false,
      observer: null
    };
    return _this;
  }

  _createClass(TourPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props6 = this.props,
          isOpen = _this$props6.isOpen,
          startAt = _this$props6.startAt;

      if (isOpen) {
        this.open(startAt);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this$props7 = this.props,
          isOpen = _this$props7.isOpen,
          update = _this$props7.update,
          updateDelay = _this$props7.updateDelay;

      if (!isOpen && nextProps.isOpen) {
        this.open(nextProps.startAt);
      } else if (isOpen && !nextProps.isOpen) {
        this.close();
      }

      if (isOpen && update !== nextProps.update) {
        if (nextProps.steps[this.state.current]) {
          setTimeout(this.showStep, updateDelay);
        } else {
          this.props.onRequestClose();
        }
      }

      if (isOpen && nextProps.isOpen && this.state.current !== nextProps.goToStep) {
        this.gotoStep(nextProps.goToStep);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var isOpen = this.props.isOpen;

      if (isOpen) {
        this.close();
      }

      if (this.state.observer) {
        this.state.observer.disconnect();
      }
    }
  }, {
    key: "open",
    value: function open(startAt) {
      var _this2 = this;

      var onAfterOpen = this.props.onAfterOpen;
      this.setState(function (prevState) {
        return {
          isOpen: true,
          current: startAt !== undefined ? startAt : prevState.current
        };
      }, function () {
        _this2.showStep();

        _this2.helper.focus();

        if (onAfterOpen) {
          onAfterOpen();
        }
      }); // TODO: debounce it.

      window.addEventListener('resize', this.showStep, false);
      window.addEventListener('keydown', this.keyDownHandler, false);
    }
  }, {
    key: "close",
    value: function close() {
      this.setState(function (prevState) {
        if (prevState.observer) {
          prevState.observer.disconnect();
        }

        return {
          isOpen: false,
          observer: null
        };
      }, this.onBeforeClose);
      window.removeEventListener('resize', this.showStep);
      window.removeEventListener('keydown', this.keyDownHandler);
    }
  }, {
    key: "onBeforeClose",
    value: function onBeforeClose() {
      var onBeforeClose = this.props.onBeforeClose;

      if (onBeforeClose) {
        onBeforeClose();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props8 = this.props,
          className = _this$props8.className,
          steps = _this$props8.steps,
          maskClassName = _this$props8.maskClassName,
          showButtons = _this$props8.showButtons,
          showNavigation = _this$props8.showNavigation,
          showNavigationNumber = _this$props8.showNavigationNumber,
          showNumber = _this$props8.showNumber,
          onRequestClose = _this$props8.onRequestClose,
          maskSpace = _this$props8.maskSpace,
          lastStepNextButton = _this$props8.lastStepNextButton,
          nextButton = _this$props8.nextButton,
          prevButton = _this$props8.prevButton,
          badgeContent = _this$props8.badgeContent,
          highlightedMaskClassName = _this$props8.highlightedMaskClassName,
          disableInteraction = _this$props8.disableInteraction,
          disableDotsNavigation = _this$props8.disableDotsNavigation,
          nextStep = _this$props8.nextStep,
          prevStep = _this$props8.prevStep,
          rounded = _this$props8.rounded,
          accentColor = _this$props8.accentColor;
      var _this$state = this.state,
          isOpen = _this$state.isOpen,
          current = _this$state.current,
          inDOM = _this$state.inDOM,
          targetTop = _this$state.top,
          targetRight = _this$state.right,
          targetBottom = _this$state.bottom,
          targetLeft = _this$state.left,
          targetWidth = _this$state.width,
          targetHeight = _this$state.height,
          windowWidth = _this$state.w,
          windowHeight = _this$state.h,
          helperWidth = _this$state.helperWidth,
          helperHeight = _this$state.helperHeight,
          helperPosition = _this$state.helperPosition;

      if (isOpen) {
        return _react.default.createElement("div", null, _react.default.createElement("div", {
          ref: function ref(c) {
            return _this3.mask = c;
          },
          onClick: this.maskClickHandler,
          className: (0, _classnames.default)(CN.mask.base, _defineProperty({}, CN.mask.isOpen, isOpen))
        }, _react.default.createElement(_index.SvgMask, {
          windowWidth: windowWidth,
          windowHeight: windowHeight,
          targetWidth: targetWidth,
          targetHeight: targetHeight,
          targetTop: targetTop,
          targetLeft: targetLeft,
          padding: maskSpace,
          rounded: rounded,
          className: maskClassName,
          disableInteraction: disableInteraction && steps[current].stepInteraction ? !steps[current].stepInteraction : disableInteraction,
          disableInteractionClassName: "".concat(CN.mask.disableInteraction, " ").concat(highlightedMaskClassName)
        })), _react.default.createElement(_index.Guide, {
          innerRef: function innerRef(c) {
            return _this3.helper = c;
          },
          targetHeight: targetHeight,
          targetWidth: targetWidth,
          targetTop: targetTop,
          targetRight: targetRight,
          targetBottom: targetBottom,
          targetLeft: targetLeft,
          windowWidth: windowWidth,
          windowHeight: windowHeight,
          helperWidth: helperWidth,
          helperHeight: helperHeight,
          helperPosition: helperPosition,
          padding: maskSpace,
          tabIndex: -1,
          current: current,
          style: steps[current].style ? steps[current].style : {},
          rounded: rounded,
          className: (0, _classnames.default)(CN.helper.base, className, _defineProperty({}, CN.helper.isOpen, isOpen)),
          accentColor: accentColor
        }, steps[current] && (typeof steps[current].content === 'function' ? steps[current].content({
          goTo: this.gotoStep,
          inDOM: inDOM,
          step: current + 1
        }) : steps[current].content), showNumber && _react.default.createElement(_index.Badge, {
          "data-tour-elem": "badge"
        }, typeof badgeContent === 'function' ? badgeContent(current + 1, steps.length) : current + 1), (showButtons || showNavigation) && _react.default.createElement(_index.Controls, {
          "data-tour-elem": "controls"
        }, showButtons && _react.default.createElement(_index.Arrow, {
          onClick: typeof prevStep === 'function' ? prevStep : this.prevStep,
          disabled: current === 0,
          label: prevButton ? prevButton : null
        }), showNavigation && _react.default.createElement(_index.Navigation, {
          "data-tour-elem": "navigation"
        }, steps.map(function (s, i) {
          return _react.default.createElement(_index.Dot, {
            key: "".concat(s.selector ? s.selector : 'undef', "_").concat(i),
            onClick: function onClick() {
              return _this3.gotoStep(i);
            },
            current: current,
            index: i,
            disabled: current === i || disableDotsNavigation,
            showNumber: showNavigationNumber,
            "data-tour-elem": "dot"
          });
        })), showButtons && _react.default.createElement(_index.Arrow, {
          onClick: current === steps.length - 1 ? lastStepNextButton ? onRequestClose : function () {} : typeof nextStep === 'function' ? nextStep : this.nextStep,
          disabled: !lastStepNextButton && current === steps.length - 1,
          inverted: true,
          label: lastStepNextButton && current === steps.length - 1 ? lastStepNextButton : nextButton ? nextButton : null
        })), _react.default.createElement(_index.Close, {
          onClick: onRequestClose
        })), this.props.children);
      }

      return _react.default.createElement("div", null);
    }
  }]);

  return TourPortal;
}(_react.Component);

_defineProperty(TourPortal, "propTypes", {
  badgeContent: _propTypes.default.func,
  highlightedMaskClassName: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element]),
  className: _propTypes.default.string,
  closeWithMask: _propTypes.default.bool,
  inViewThreshold: _propTypes.default.number,
  isOpen: _propTypes.default.bool.isRequired,
  lastStepNextButton: _propTypes.default.node,
  maskClassName: _propTypes.default.string,
  maskSpace: _propTypes.default.number,
  nextButton: _propTypes.default.node,
  onAfterOpen: _propTypes.default.func,
  onBeforeClose: _propTypes.default.func,
  onRequestClose: _propTypes.default.func,
  prevButton: _propTypes.default.node,
  scrollDuration: _propTypes.default.number,
  scrollOffset: _propTypes.default.number,
  showButtons: _propTypes.default.bool,
  showNavigation: _propTypes.default.bool,
  showNavigationNumber: _propTypes.default.bool,
  showNumber: _propTypes.default.bool,
  startAt: _propTypes.default.number,
  goToStep: _propTypes.default.number,
  getCurrentStep: _propTypes.default.func,
  nextStep: _propTypes.default.func,
  prevStep: _propTypes.default.func,
  steps: _propTypes.default.arrayOf(_propTypes.default.shape({
    selector: _propTypes.default.string,
    content: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.func]).isRequired,
    position: _propTypes.default.oneOf(['top', 'right', 'bottom', 'left', 'center']),
    action: _propTypes.default.func,
    style: _propTypes.default.object,
    stepInteraction: _propTypes.default.bool
  })),
  update: _propTypes.default.string,
  updateDelay: _propTypes.default.number,
  disableInteraction: _propTypes.default.bool,
  disableDotsNavigation: _propTypes.default.bool,
  disableKeyboardNavigation: _propTypes.default.bool,
  rounded: _propTypes.default.number,
  accentColor: _propTypes.default.string
});

_defineProperty(TourPortal, "defaultProps", {
  onAfterOpen: function onAfterOpen() {
    document.body.style.overflowY = 'hidden';
  },
  onBeforeClose: function onBeforeClose() {
    document.body.style.overflowY = 'auto';
  },
  showNavigation: true,
  showNavigationNumber: true,
  showButtons: true,
  showNumber: true,
  scrollDuration: 1,
  maskSpace: 10,
  updateDelay: 1,
  disableInteraction: false,
  rounded: 0,
  accentColor: '#007aff'
});

var CN = {
  mask: {
    base: 'reactour__mask',
    isOpen: 'reactour__mask--is-open',
    disableInteraction: 'reactour__mask--disable-interaction'
  },
  helper: {
    base: 'reactour__helper',
    isOpen: 'reactour__helper--is-open'
  }
};

var setNodeState = function setNodeState(node, helper, position) {
  var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

  var _hx$getNodeRect = hx.getNodeRect(helper),
      helperWidth = _hx$getNodeRect.width,
      helperHeight = _hx$getNodeRect.height;

  var attrs = node ? hx.getNodeRect(node) : {
    top: h + 10,
    right: w / 2 + 9,
    bottom: h / 2 + 9,
    left: w / 2 - helperWidth / 2,
    width: 0,
    height: 0,
    w: w,
    h: h,
    helperPosition: 'center'
  };
  return function update() {
    return _objectSpread({
      w: w,
      h: h,
      helperWidth: helperWidth,
      helperHeight: helperHeight,
      helperPosition: position
    }, attrs, {
      inDOM: node ? true : false
    });
  };
};

var _default = TourPortal;
exports.default = _default;

/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _styledComponents = _interopRequireDefault(__webpack_require__(98));

var _SvgButton = _interopRequireDefault(__webpack_require__(797));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n\n  ", ";\n  ", ";\n\n  &:hover {\n    color: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-size: 12px;\n  line-height: 1;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Label = _styledComponents.default.span(_templateObject());

function Arrow(_ref) {
  var className = _ref.className,
      onClick = _ref.onClick,
      inverted = _ref.inverted,
      label = _ref.label,
      disabled = _ref.disabled;
  return _react.default.createElement(_SvgButton.default, {
    className: className,
    onClick: onClick,
    "data-tour-elem": "".concat(inverted ? 'right' : 'left', "-arrow"),
    disabled: disabled
  }, label ? _react.default.createElement(Label, null, label) : _react.default.createElement("svg", {
    viewBox: "0 0 18.4 14.4"
  }, _react.default.createElement("path", {
    d: inverted ? 'M17 7.2H1M10.8 1L17 7.2l-6.2 6.2' : 'M1.4 7.2h16M7.6 1L1.4 7.2l6.2 6.2',
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10"
  })));
}

Arrow.propTypes = {
  className: _propTypes.default.string.isRequired,
  onClick: _propTypes.default.func.isRequired,
  inverted: _propTypes.default.bool,
  label: _propTypes.default.node,
  disabled: _propTypes.default.bool
};

var _default = (0, _styledComponents.default)(Arrow)(_templateObject2(), function (props) {
  return props.disabled ? '#caccce' : '#646464';
}, function (props) {
  return props.inverted ? 'margin-left: 24px;' : 'margin-right: 24px;';
}, function (props) {
  return !props.label && "\n    width: 16px;\n    height: 12px;\n    flex: 0 0 16px;\n  ";
}, function (props) {
  return props.disabled ? '#caccce' : '#000';
});

exports.default = _default;

/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(__webpack_require__(98));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  font-family: monospace;\n  background-color: var(--reactour-accent);\n  height: 1.875em;\n  line-height: 2;\n  padding-left: 0.8125em;\n  padding-right: 0.8125em;\n  font-size: 1em;\n  border-radius: 1.625em;\n  color: white;\n  text-align: center;\n  box-shadow: 0 0.25em 0.5em rgba(0, 0, 0, 0.3);\n  top: -0.8125em;\n  left: -0.8125em;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Badge = _styledComponents.default.span(_templateObject());

var _default = Badge;
exports.default = _default;

/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _styledComponents = _interopRequireDefault(__webpack_require__(98));

var _SvgButton = _interopRequireDefault(__webpack_require__(797));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 22px;\n  right: 22px;\n  width: 9px;\n  height: 9px;\n  color: #5e5e5e;\n  &:hover {\n    color: #000;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function Close(_ref) {
  var className = _ref.className,
      onClick = _ref.onClick;
  return _react.default.createElement(_SvgButton.default, {
    className: className,
    onClick: onClick
  }, _react.default.createElement("svg", {
    viewBox: "0 0 9.1 9.1"
  }, _react.default.createElement("path", {
    fill: "currentColor",
    d: "M5.9 4.5l2.8-2.8c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0L4.5 3.1 1.7.3C1.3-.1.7-.1.3.3c-.4.4-.4 1 0 1.4l2.8 2.8L.3 7.4c-.4.4-.4 1 0 1.4.2.2.4.3.7.3s.5-.1.7-.3L4.5 6l2.8 2.8c.3.2.5.3.8.3s.5-.1.7-.3c.4-.4.4-1 0-1.4L5.9 4.5z"
  })));
}

Close.propTypes = {
  className: _propTypes.default.string.isRequired,
  onClick: _propTypes.default.func.isRequired
};
var StyledClose = (0, _styledComponents.default)(Close)(_templateObject());
var _default = StyledClose;
exports.default = _default;

/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(__webpack_require__(98));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  margin-top: 24px;\n  align-items: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Controls = _styledComponents.default.div(_templateObject());

var _default = Controls;
exports.default = _default;

/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(__webpack_require__(98));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  counter-increment: dot;\n  width: 8px;\n  height: 8px;\n  border: 1px solid;\n  border-radius: 100%;\n  padding: 0;\n  display: block;\n  margin: 4px;\n  outline: 0;\n  transition: opacity 0.3s, transform 0.3s;\n  cursor: ", ";\n  transform: scale(", ");\n  color: ", ";\n  background-color: ", ";\n\n  &:before {\n    content: counter(dot);\n    position: absolute;\n    bottom: calc(100% + 0.25em);\n    left: 50%;\n    opacity: 0;\n    transform: translate(-50%, 1em);\n    transition: 0.3s;\n    display: ", ";\n  }\n\n  &:hover {\n    background-color: currentColor;\n\n    &:before {\n      opacity: 0.5;\n      transform: translate(-50%, -2px);\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Dot = _styledComponents.default.button(_templateObject(), function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, function (props) {
  return props.current === props.index ? 1.25 : 1;
}, function (props) {
  return props.current === props.index ? 'var(--reactour-accent)' : '#caccce';
}, function (props) {
  return props.current === props.index ? 'var(--reactour-accent)' : 'transparent';
}, function (props) {
  return props.showNumber ? 'block' : 'none';
});

var _default = Dot;
exports.default = _default;

/***/ }),
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(__webpack_require__(98));

var hx = _interopRequireWildcard(__webpack_require__(393));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  --reactour-accent: ", ";\n  position: fixed;\n  background-color: #fff;\n  transition: transform 0.3s;\n  padding: 24px 30px;\n  box-shadow: 0 0.5em 3em rgba(0, 0, 0, 0.3);\n  top: 0;\n  left: 0;\n  color: inherit;\n  z-index: 1000000;\n  max-width: 331px;\n  min-width: 150px;\n  outline: 0;\n  padding-right: 40px;\n  border-radius: ", "px;\n\n  transform: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Guide = _styledComponents.default.div(_templateObject(), function (props) {
  return props.accentColor;
}, function (props) {
  return props.rounded;
}, function (props) {
  var targetTop = props.targetTop,
      targetRight = props.targetRight,
      targetBottom = props.targetBottom,
      targetLeft = props.targetLeft,
      windowWidth = props.windowWidth,
      windowHeight = props.windowHeight,
      helperWidth = props.helperWidth,
      helperHeight = props.helperHeight,
      helperPosition = props.helperPosition,
      padding = props.padding;
  var available = {
    left: targetLeft,
    right: windowWidth - targetRight,
    top: targetTop,
    bottom: windowHeight - targetBottom
  };

  var couldPositionAt = function couldPositionAt(position) {
    return available[position] > (hx.isHoriz(position) ? helperWidth + padding * 2 : helperHeight + padding * 2);
  };

  var autoPosition = function autoPosition(coords) {
    var positionsOrder = hx.bestPositionOf(available);

    for (var j = 0; j < positionsOrder.length; j++) {
      if (couldPositionAt(positionsOrder[j])) {
        return coords[positionsOrder[j]];
      }
    }

    return coords.center;
  };

  var pos = function pos(helperPosition) {
    var hX = hx.isOutsideX(targetLeft + helperWidth, windowWidth) ? hx.isOutsideX(targetRight + padding, windowWidth) ? targetRight - helperWidth : targetRight - helperWidth + padding : targetLeft - padding;
    var x = hX > padding ? hX : padding;
    var hY = hx.isOutsideY(targetTop + helperHeight, windowHeight) ? hx.isOutsideY(targetBottom + padding, windowHeight) ? targetBottom - helperHeight : targetBottom - helperHeight + padding : targetTop - padding;
    var y = hY > padding ? hY : padding;
    var coords = {
      top: [x, targetTop - helperHeight - padding * 2],
      right: [targetRight + padding * 2, y],
      bottom: [x, targetBottom + padding * 2],
      left: [targetLeft - helperWidth - padding * 2, y],
      center: [windowWidth / 2 - helperWidth / 2, windowHeight / 2 - helperHeight / 2]
    };

    if (helperPosition === 'center' || couldPositionAt(helperPosition)) {
      return coords[helperPosition];
    }

    return autoPosition(coords);
  };

  var p = pos(helperPosition);
  return "translate(".concat(p[0], "px, ").concat(p[1], "px)");
});

var _default = Guide;
exports.default = _default;

/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(__webpack_require__(98));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  counter-reset: dot;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Navigation = _styledComponents.default.nav(_templateObject());

var _default = Navigation;
exports.default = _default;

/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SvgMask;

var _react = _interopRequireDefault(__webpack_require__(0));

var _styledComponents = _interopRequireDefault(__webpack_require__(98));

var hx = _interopRequireWildcard(__webpack_require__(393));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  opacity: 0.7;\n  width: 100%;\n  left: 0;\n  top: 0;\n  height: 100%;\n  position: fixed;\n  z-index: 99999;\n  pointer-events: none;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SvgMaskWrapper = _styledComponents.default.div(_templateObject());

function SvgMask(_ref) {
  var windowWidth = _ref.windowWidth,
      windowHeight = _ref.windowHeight,
      targetWidth = _ref.targetWidth,
      targetHeight = _ref.targetHeight,
      targetTop = _ref.targetTop,
      targetLeft = _ref.targetLeft,
      padding = _ref.padding,
      rounded = _ref.rounded,
      disableInteraction = _ref.disableInteraction,
      disableInteractionClassName = _ref.disableInteractionClassName,
      className = _ref.className;
  var width = hx.safe(targetWidth + padding * 2);
  var height = hx.safe(targetHeight + padding * 2);
  var top = hx.safe(targetTop - padding);
  var left = hx.safe(targetLeft - padding);
  return _react.default.createElement(SvgMaskWrapper, null, _react.default.createElement("svg", {
    width: windowWidth,
    height: windowHeight,
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, _react.default.createElement("defs", null, _react.default.createElement("mask", {
    id: "mask-main"
  }, _react.default.createElement("rect", {
    x: 0,
    y: 0,
    width: windowWidth,
    height: windowHeight,
    fill: "white"
  }), _react.default.createElement("rect", {
    x: left,
    y: top,
    width: width,
    height: height,
    fill: "black"
  }), _react.default.createElement("rect", {
    x: left - 1,
    y: top - 1,
    width: rounded,
    height: rounded,
    fill: "white"
  }), _react.default.createElement("circle", {
    cx: left + rounded,
    cy: top + rounded,
    r: rounded,
    fill: "black"
  }), _react.default.createElement("rect", {
    x: left + width - rounded + 1,
    y: top - 1,
    width: rounded,
    height: rounded,
    fill: "white"
  }), _react.default.createElement("circle", {
    cx: left + width - rounded,
    cy: top + rounded,
    r: rounded,
    fill: "black"
  }), _react.default.createElement("rect", {
    x: left - 1,
    y: top + height - rounded + 1,
    width: rounded,
    height: rounded,
    fill: "white"
  }), _react.default.createElement("circle", {
    cx: left + rounded,
    cy: top + height - rounded,
    r: rounded,
    fill: "black"
  }), _react.default.createElement("rect", {
    x: left + width - rounded + 1,
    y: top + height - rounded + 1,
    width: rounded,
    height: rounded,
    fill: "white"
  }), _react.default.createElement("circle", {
    cx: left + width - rounded,
    cy: top + height - rounded,
    r: rounded,
    fill: "black "
  })), _react.default.createElement("clipPath", {
    id: "clip-path"
  }, _react.default.createElement("rect", {
    x: 0,
    y: 0,
    width: windowWidth,
    height: top
  }), _react.default.createElement("rect", {
    x: 0,
    y: top,
    width: left,
    height: height
  }), _react.default.createElement("rect", {
    x: targetLeft + targetWidth + padding,
    y: top,
    width: hx.safe(windowWidth - targetWidth - left),
    height: height
  }), _react.default.createElement("rect", {
    x: 0,
    y: targetTop + targetHeight + padding,
    width: windowWidth,
    height: hx.safe(windowHeight - targetHeight - top)
  }))), _react.default.createElement("rect", {
    x: 0,
    y: 0,
    width: windowWidth,
    height: windowHeight,
    fill: "#000000",
    mask: "url(#mask-main)"
  }), _react.default.createElement("rect", {
    x: 0,
    y: 0,
    width: windowWidth,
    height: windowHeight,
    fill: "#000000",
    clipPath: "url(#clip-path)",
    pointerEvents: "auto"
  }), _react.default.createElement("rect", {
    x: left,
    y: top,
    width: width,
    height: height,
    pointerEvents: "auto",
    fill: "transparent",
    display: disableInteraction ? 'block' : 'none',
    className: disableInteractionClassName
  })));
}

SvgMask.propTypes = {
  windowWidth: _propTypes.default.number.isRequired,
  windowHeight: _propTypes.default.number.isRequired,
  targetWidth: _propTypes.default.number.isRequired,
  targetHeight: _propTypes.default.number.isRequired,
  targetTop: _propTypes.default.number.isRequired,
  targetLeft: _propTypes.default.number.isRequired,
  padding: _propTypes.default.number.isRequired,
  rounded: _propTypes.default.number.isRequired,
  disableInteraction: _propTypes.default.bool.isRequired,
  disableInteractionClassName: _propTypes.default.string.isRequired
};

/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Arrow", {
  enumerable: true,
  get: function get() {
    return _Arrow.default;
  }
});
Object.defineProperty(exports, "Close", {
  enumerable: true,
  get: function get() {
    return _Close.default;
  }
});
Object.defineProperty(exports, "Guide", {
  enumerable: true,
  get: function get() {
    return _Guide.default;
  }
});
Object.defineProperty(exports, "Badge", {
  enumerable: true,
  get: function get() {
    return _Badge.default;
  }
});
Object.defineProperty(exports, "Controls", {
  enumerable: true,
  get: function get() {
    return _Controls.default;
  }
});
Object.defineProperty(exports, "Navigation", {
  enumerable: true,
  get: function get() {
    return _Navigation.default;
  }
});
Object.defineProperty(exports, "Dot", {
  enumerable: true,
  get: function get() {
    return _Dot.default;
  }
});
Object.defineProperty(exports, "SvgMask", {
  enumerable: true,
  get: function get() {
    return _SvgMask.default;
  }
});

var _Arrow = _interopRequireDefault(__webpack_require__(1885));

var _Close = _interopRequireDefault(__webpack_require__(1887));

var _Guide = _interopRequireDefault(__webpack_require__(1890));

var _Badge = _interopRequireDefault(__webpack_require__(1886));

var _Controls = _interopRequireDefault(__webpack_require__(1888));

var _Navigation = _interopRequireDefault(__webpack_require__(1891));

var _Dot = _interopRequireDefault(__webpack_require__(1889));

var _SvgMask = _interopRequireDefault(__webpack_require__(1892));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Tour = _interopRequireDefault(__webpack_require__(1883));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _Tour.default;
exports.default = _default;

/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var compose = __webpack_require__(100).compose;

exports.__esModule = true;
exports.composeWithDevTools = (
   false ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ :
    function() {
      if (arguments.length === 0) return undefined;
      if (typeof arguments[0] === 'object') return compose;
      return compose.apply(null, arguments);
    }
);

exports.devToolsEnhancer = (
   false ?
    window.__REDUX_DEVTOOLS_EXTENSION__ :
    function() { return function(noop) { return noop; } }
);


/***/ }),
/* 1896 */,
/* 1897 */,
/* 1898 */,
/* 1899 */,
/* 1900 */,
/* 1901 */,
/* 1902 */,
/* 1903 */,
/* 1904 */,
/* 1905 */,
/* 1906 */,
/* 1907 */,
/* 1908 */,
/* 1909 */,
/* 1910 */,
/* 1911 */,
/* 1912 */,
/* 1913 */,
/* 1914 */,
/* 1915 */,
/* 1916 */,
/* 1917 */,
/* 1918 */,
/* 1919 */,
/* 1920 */,
/* 1921 */,
/* 1922 */,
/* 1923 */,
/* 1924 */,
/* 1925 */,
/* 1926 */,
/* 1927 */,
/* 1928 */,
/* 1929 */,
/* 1930 */,
/* 1931 */,
/* 1932 */,
/* 1933 */,
/* 1934 */,
/* 1935 */,
/* 1936 */,
/* 1937 */,
/* 1938 */,
/* 1939 */,
/* 1940 */,
/* 1941 */,
/* 1942 */,
/* 1943 */,
/* 1944 */,
/* 1945 */,
/* 1946 */,
/* 1947 */,
/* 1948 */,
/* 1949 */,
/* 1950 */,
/* 1951 */,
/* 1952 */,
/* 1953 */,
/* 1954 */,
/* 1955 */,
/* 1956 */,
/* 1957 */,
/* 1958 */,
/* 1959 */,
/* 1960 */,
/* 1961 */,
/* 1962 */,
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function getAliasProperties(fields) {
  if (!fields.previousId) return ['userId', 'options'];

  return ['userId', 'previousId', 'options'];
}

function validateAliasFields(fields) {
  if (!fields.userId) return new Error('missing userId field for EventTypes.alias');

  return null;
}

function extractFields(obj, keys) {
  return keys.map(function (key) {
    return obj[key];
  });
}

function extractAliasFields(fields) {
  var props = getAliasProperties(fields);

  var err = validateAliasFields(fields);
  if (err) return err;

  return extractFields(fields, props);
}

exports.extractAliasFields = extractAliasFields;

/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultClient = exports.defaultMapper = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _types = __webpack_require__(808);

var _types2 = _interopRequireDefault(_types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var page = _types2.default.page;


var defaultMapper = {
  mapper: {
    '@@router/INIT_PATH': page,
    '@@router/UPDATE_PATH': page,
    '@@router/LOCATION_CHANGE': page,
    '@@reduxReactRouter/initRoutes': page,
    '@@reduxReactRouter/routerDidChange': page,
    '@@reduxReactRouter/replaceRoutes': page
  }
};

var defaultClient = function defaultClient() {
  var root = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) === 'object' && self.self === self && self || (typeof global === 'undefined' ? 'undefined' : _typeof(global)) === 'object' && global.global === global && global || undefined;

  return root.analytics;
};

exports.defaultMapper = defaultMapper;
exports.defaultClient = defaultClient;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(92)))

/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function getGroupProperties() {
  return ['groupId', 'traits', 'options'];
}

function validateGroupFields(fields) {
  if (!fields.groupId) return new Error('missing groupId field for EventTypes.alias');

  return null;
}

function extractFields(obj, keys) {
  return keys.map(function (key) {
    return key === 'traits' ? obj[key] || {} : obj[key];
  });
}

function extractGroupFields(fields) {
  var props = getGroupProperties(fields);

  var err = validateGroupFields(fields);
  if (err) return err;

  return extractFields(fields, props);
}

exports.extractGroupFields = extractGroupFields;

/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function getIdentifyProperties(fields) {
  if (!fields.userId) return ['traits', 'options'];

  return ['userId', 'traits', 'options'];
}

function extractFields(obj, keys) {
  return keys.map(function (key) {
    return key === 'traits' ? obj[key] || {} : obj[key];
  });
}

function extractIdentifyFields(fields) {
  // all fields are optional for identify events
  if (!fields) {
    return [];
  }

  var props = getIdentifyProperties(fields);

  return extractFields(fields, props);
}

exports.extractIdentifyFields = extractIdentifyFields;

/***/ }),
/* 1967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function validatePageFields(fields) {
  if (fields.category && !fields.name) {
    return new Error('missing name field for EventTypes.page');
  }

  return null;
}

function getPageProperties(fields) {
  if (fields.category) return ['category', 'name', 'properties', 'options'];
  if (!fields.name) return ['properties', 'options'];

  return ['name', 'properties', 'options'];
}

function extractFields(obj, keys) {
  return keys.map(function (key) {
    return key === 'properties' ? obj[key] || {} : obj[key];
  });
}

function extractPageFields(fields) {
  // all fields are optional for page events
  if (!fields) {
    return [];
  }

  var err = validatePageFields(fields);
  if (err) return err;

  var props = getPageProperties(fields);

  return extractFields(fields, props);
}

exports.extractPageFields = extractPageFields;

/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function validateTrackFields(fields, actionType) {
  if (typeof actionType !== 'string' && !fields.event) {
    return new Error('missing event field for EventTypes.track');
  }

  return null;
}

function getTrackProperties(fields) {
  if (!fields.properties) return ['event', 'options'];

  return ['event', 'properties', 'options'];
}

function extractFields(obj, keys, actionType) {
  return keys.map(function (key) {
    return key === 'event' ? obj[key] || actionType : obj[key];
  });
}

function extractTrackFields(fields, actionType) {
  var props = getTrackProperties(fields);

  var err = validateTrackFields(fields, actionType);
  if (err) return err;

  return extractFields(fields, props, actionType);
}

exports.extractTrackFields = extractTrackFields;

/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.warn = warn;
function warn() {
  var ENV = typeof process !== 'undefined' && "production" || 'development';

  if (ENV === 'development' || ENV === 'test') {
    var _console;

    (_console = console).warn.apply(_console, arguments);
  }
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(176)))

/***/ }),
/* 1970 */,
/* 1971 */,
/* 1972 */,
/* 1973 */,
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _scrollSmooth = __webpack_require__(812);

var _scrollSmooth2 = _interopRequireDefault(_scrollSmooth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[href^="#"]:not([href="#"]';
  var config = arguments[1];

  var links = document.querySelectorAll(query);

  Array.from(links).map(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var dest = document.getElementById(e.target.hash.substring(1));
      if (!dest) return;
      (0, _scrollSmooth2.default)(dest, _extends({}, config));
    }, false);
  });
};

module.exports = exports['default'];

/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _scrollSmooth = __webpack_require__(812);

var _scrollSmooth2 = _interopRequireDefault(_scrollSmooth);

var _tools = __webpack_require__(813);

var _anchorScroll = __webpack_require__(1974);

var _anchorScroll2 = _interopRequireDefault(_anchorScroll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  to: _scrollSmooth2.default,
  calcEndPoint: _tools.calcEndPoint,
  anchorScroll: _anchorScroll2.default
};
module.exports = exports['default'];

/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof module === "object" && module.exports) {
    module.exports = factory();
  } else {
    root.Scrollparent = factory();
  }
}(this, function () {
  var regex = /(auto|scroll)/;

  var parents = function (node, ps) {
    if (node.parentNode === null) { return ps; }

    return parents(node.parentNode, ps.concat([node]));
  };

  var style = function (node, prop) {
    return getComputedStyle(node, null).getPropertyValue(prop);
  };

  var overflow = function (node) {
    return style(node, "overflow") + style(node, "overflow-y") + style(node, "overflow-x");
  };

  var scroll = function (node) {
   return regex.test(overflow(node));
  };

  var scrollParent = function (node) {
    if (!(node instanceof HTMLElement || node instanceof SVGElement)) {
      return ;
    }

    var ps = parents(node.parentNode, []);

    for (var i = 0; i < ps.length; i += 1) {
      if (scroll(ps[i])) {
        return ps[i];
      }
    }

    return document.scrollingElement || document.documentElement;
  };

  return scrollParent;
}));


/***/ }),
/* 1977 */
/***/ (function(module, exports) {

function select(element) {
    var selectedText;

    if (element.nodeName === 'SELECT') {
        element.focus();

        selectedText = element.value;
    }
    else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
        var isReadOnly = element.hasAttribute('readonly');

        if (!isReadOnly) {
            element.setAttribute('readonly', '');
        }

        element.select();
        element.setSelectionRange(0, element.value.length);

        if (!isReadOnly) {
            element.removeAttribute('readonly');
        }

        selectedText = element.value;
    }
    else {
        if (element.hasAttribute('contenteditable')) {
            element.focus();
        }

        var selection = window.getSelection();
        var range = document.createRange();

        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);

        selectedText = selection.toString();
    }

    return selectedText;
}

module.exports = select;


/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fetchKeys = __webpack_require__(1510);

module.exports = function shallowEqual(objA, objB, compare, compareContext) {

    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

    if (ret !== void 0) {
        return !!ret;
    }

    if (objA === objB) {
        return true;
    }

    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
        return false;
    }

    var keysA = fetchKeys(objA);
    var keysB = fetchKeys(objB);

    var len = keysA.length;
    if (len !== keysB.length) {
        return false;
    }

    compareContext = compareContext || null;

    // Test for A's keys different from B.
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    for (var i = 0; i < len; i++) {
        var key = keysA[i];
        if (!bHasOwnProperty(key)) {
            return false;
        }
        var valueA = objA[key];
        var valueB = objB[key];

        var _ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (_ret === false || _ret === void 0 && valueA !== valueB) {
            return false;
        }
    }

    return true;
};

/***/ }),
/* 1979 */,
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

(function (factory) {
	 true ? (module['exports'] = factory()) :
		typeof define === 'function' && define['amd'] ? define(factory()) :
			(window['stylisRuleSheet'] = factory())
}(function () {

	'use strict'

	return function (insertRule) {
		var delimiter = '/*|*/'
		var needle = delimiter+'}'

		function toSheet (block) {
			if (block)
				try {
					insertRule(block + '}')
				} catch (e) {}
		}

		return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64)
						return insertRule(content+';'), ''
					break
				// selector
				case 2:
					if (ns === 0)
						return content + delimiter
					break
				// at-rule
				case 3:
					switch (ns) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0]+content), ''
						default:
							return content + (at === 0 ? delimiter : '')
					}
				case -2:
					content.split(needle).forEach(toSheet)
			}
		}
	}
}))


/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

/*
 *          __        ___
 *    _____/ /___  __/ (_)____
 *   / ___/ __/ / / / / / ___/
 *  (__  ) /_/ /_/ / / (__  )
 * /____/\__/\__, /_/_/____/
 *          /____/
 *
 * light - weight css preprocessor @licence MIT
 */
(function (factory) {/* eslint-disable */
	 true ? (module['exports'] = factory(null)) :
		typeof define === 'function' && define['amd'] ? define(factory(null)) :
			(window['stylis'] = factory(null))
}(/** @param {*=} options */function factory (options) {/* eslint-disable */

	'use strict'

	/**
	 * Notes
	 *
	 * The ['<method name>'] pattern is used to support closure compiler
	 * the jsdoc signatures are also used to the same effect
	 *
	 * ----
	 *
	 * int + int + int === n4 [faster]
	 *
	 * vs
	 *
	 * int === n1 && int === n2 && int === n3
	 *
	 * ----
	 *
	 * switch (int) { case ints...} [faster]
	 *
	 * vs
	 *
	 * if (int == 1 && int === 2 ...)
	 *
	 * ----
	 *
	 * The (first*n1 + second*n2 + third*n3) format used in the property parser
	 * is a simple way to hash the sequence of characters
	 * taking into account the index they occur in
	 * since any number of 3 character sequences could produce duplicates.
	 *
	 * On the other hand sequences that are directly tied to the index of the character
	 * resolve a far more accurate measure, it's also faster
	 * to evaluate one condition in a switch statement
	 * than three in an if statement regardless of the added math.
	 *
	 * This allows the vendor prefixer to be both small and fast.
	 */

	var nullptn = /^\0+/g /* matches leading null characters */
	var formatptn = /[\0\r\f]/g /* matches new line, null and formfeed characters */
	var colonptn = /: */g /* splits animation rules */
	var cursorptn = /zoo|gra/ /* assert cursor varient */
	var transformptn = /([,: ])(transform)/g /* vendor prefix transform, older webkit */
	var animationptn = /,+\s*(?![^(]*[)])/g /* splits multiple shorthand notation animations */
	var propertiesptn = / +\s*(?![^(]*[)])/g /* animation properties */
	var elementptn = / *[\0] */g /* selector elements */
	var selectorptn = /,\r+?/g /* splits selectors */
	var andptn = /([\t\r\n ])*\f?&/g /* match & */
	var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g /* matches :global(.*) */
	var invalidptn = /\W+/g /* removes invalid characters from keyframes */
	var keyframeptn = /@(k\w+)\s*(\S*)\s*/ /* matches @keyframes $1 */
	var plcholdrptn = /::(place)/g /* match ::placeholder varient */
	var readonlyptn = /:(read-only)/g /* match :read-only varient */
	var beforeptn = /\s+(?=[{\];=:>])/g /* matches \s before ] ; = : */
	var afterptn = /([[}=:>])\s+/g /* matches \s after characters [ } = : */
	var tailptn = /(\{[^{]+?);(?=\})/g /* matches tail semi-colons ;} */
	var whiteptn = /\s{2,}/g /* matches repeating whitespace */
	var pseudoptn = /([^\(])(:+) */g /* pseudo element */
	var writingptn = /[svh]\w+-[tblr]{2}/ /* match writing mode property values */
	var gradientptn = /([\w-]+t\()/g /* match *gradient property */
	var supportsptn = /\(\s*(.*)\s*\)/g /* match supports (groups) */
	var propertyptn = /([\s\S]*?);/g /* match properties leading semicolon */
	var selfptn = /-self|flex-/g /* match flex- and -self in align-self: flex-*; */
	var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/ /* extrats :readonly or :placholder from selector */
	var trimptn = /[ \t]+$/ /* match tail whitspace */
	var dimensionptn = /stretch|:\s*\w+\-(?:conte|avail)/ /* match max/min/fit-content, fill-available */
	var imgsrcptn = /([^-])(image-set\()/

	/* vendors */
	var webkit = '-webkit-'
	var moz = '-moz-'
	var ms = '-ms-'

	/* character codes */
	var SEMICOLON = 59 /* ; */
	var CLOSEBRACES = 125 /* } */
	var OPENBRACES = 123 /* { */
	var OPENPARENTHESES = 40 /* ( */
	var CLOSEPARENTHESES = 41 /* ) */
	var OPENBRACKET = 91 /* [ */
	var CLOSEBRACKET = 93 /* ] */
	var NEWLINE = 10 /* \n */
	var CARRIAGE = 13 /* \r */
	var TAB = 9 /* \t */
	var AT = 64 /* @ */
	var SPACE = 32 /*   */
	var AND = 38 /* & */
	var DASH = 45 /* - */
	var UNDERSCORE = 95 /* _ */
	var STAR = 42 /* * */
	var COMMA = 44 /* , */
	var COLON = 58 /* : */
	var SINGLEQUOTE = 39 /* ' */
	var DOUBLEQUOTE = 34 /* " */
	var FOWARDSLASH = 47 /* / */
	var GREATERTHAN = 62 /* > */
	var PLUS = 43 /* + */
	var TILDE = 126 /* ~ */
	var NULL = 0 /* \0 */
	var FORMFEED = 12 /* \f */
	var VERTICALTAB = 11 /* \v */

	/* special identifiers */
	var KEYFRAME = 107 /* k */
	var MEDIA = 109 /* m */
	var SUPPORTS = 115 /* s */
	var PLACEHOLDER = 112 /* p */
	var READONLY = 111 /* o */
	var IMPORT = 105 /* <at>i */
	var CHARSET = 99 /* <at>c */
	var DOCUMENT = 100 /* <at>d */
	var PAGE = 112 /* <at>p */

	var column = 1 /* current column */
	var line = 1 /* current line numebr */
	var pattern = 0 /* :pattern */

	var cascade = 1 /* #id h1 h2 vs h1#id h2#id  */
	var prefix = 1 /* vendor prefix */
	var escape = 1 /* escape :global() pattern */
	var compress = 0 /* compress output */
	var semicolon = 0 /* no/semicolon option */
	var preserve = 0 /* preserve empty selectors */

	/* empty reference */
	var array = []

	/* plugins */
	var plugins = []
	var plugged = 0
	var should = null

	/* plugin context */
	var POSTS = -2
	var PREPS = -1
	var UNKWN = 0
	var PROPS = 1
	var BLCKS = 2
	var ATRUL = 3

	/* plugin newline context */
	var unkwn = 0

	/* keyframe animation */
	var keyed = 1
	var key = ''

	/* selector namespace */
	var nscopealt = ''
	var nscope = ''

	/**
	 * Compile
	 *
	 * @param {Array<string>} parent
	 * @param {Array<string>} current
	 * @param {string} body
	 * @param {number} id
	 * @param {number} depth
	 * @return {string}
	 */
	function compile (parent, current, body, id, depth) {
		var bracket = 0 /* brackets [] */
		var comment = 0 /* comments /* // or /* */
		var parentheses = 0 /* functions () */
		var quote = 0 /* quotes '', "" */

		var first = 0 /* first character code */
		var second = 0 /* second character code */
		var code = 0 /* current character code */
		var tail = 0 /* previous character code */
		var trail = 0 /* character before previous code */
		var peak = 0 /* previous non-whitespace code */

		var counter = 0 /* count sequence termination */
		var context = 0 /* track current context */
		var atrule = 0 /* track @at-rule context */
		var pseudo = 0 /* track pseudo token index */
		var caret = 0 /* current character index */
		var format = 0 /* control character formating context */
		var insert = 0 /* auto semicolon insertion */
		var invert = 0 /* inverted selector pattern */
		var length = 0 /* generic length address */
		var eof = body.length /* end of file(length) */
		var eol = eof - 1 /* end of file(characters) */

		var char = '' /* current character */
		var chars = '' /* current buffer of characters */
		var child = '' /* next buffer of characters */
		var out = '' /* compiled body */
		var children = '' /* compiled children */
		var flat = '' /* compiled leafs */
		var selector /* generic selector address */
		var result /* generic address */

		// ...build body
		while (caret < eof) {
			code = body.charCodeAt(caret)

			// eof varient
			if (caret === eol) {
				// last character + noop context, add synthetic padding for noop context to terminate
				if (comment + quote + parentheses + bracket !== 0) {
					if (comment !== 0) {
						code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH
					}

					quote = parentheses = bracket = 0
					eof++
					eol++
				}
			}

			if (comment + quote + parentheses + bracket === 0) {
				// eof varient
				if (caret === eol) {
					if (format > 0) {
						chars = chars.replace(formatptn, '')
					}

					if (chars.trim().length > 0) {
						switch (code) {
							case SPACE:
							case TAB:
							case SEMICOLON:
							case CARRIAGE:
							case NEWLINE: {
								break
							}
							default: {
								chars += body.charAt(caret)
							}
						}

						code = SEMICOLON
					}
				}

				// auto semicolon insertion
				if (insert === 1) {
					switch (code) {
						// false flags
						case OPENBRACES:
						case CLOSEBRACES:
						case SEMICOLON:
						case DOUBLEQUOTE:
						case SINGLEQUOTE:
						case OPENPARENTHESES:
						case CLOSEPARENTHESES:
						case COMMA: {
							insert = 0
						}
						// ignore
						case TAB:
						case CARRIAGE:
						case NEWLINE:
						case SPACE: {
							break
						}
						// valid
						default: {
							insert = 0
							length = caret
							first = code
							caret--
							code = SEMICOLON

							while (length < eof) {
								switch (body.charCodeAt(length++)) {
									case NEWLINE:
									case CARRIAGE:
									case SEMICOLON: {
										++caret
										code = first
										length = eof
										break
									}
									case COLON: {
										if (format > 0) {
											++caret
											code = first
										}
									}
									case OPENBRACES: {
										length = eof
									}
								}
							}
						}
					}
				}

				// token varient
				switch (code) {
					case OPENBRACES: {
						chars = chars.trim()
						first = chars.charCodeAt(0)
						counter = 1
						length = ++caret

						while (caret < eof) {
							switch (code = body.charCodeAt(caret)) {
								case OPENBRACES: {
									counter++
									break
								}
								case CLOSEBRACES: {
									counter--
									break
								}
								case FOWARDSLASH: {
									switch (second = body.charCodeAt(caret + 1)) {
										// /*, //
										case STAR:
										case FOWARDSLASH: {
											caret = delimited(second, caret, eol, body)
										}
									}
									break
								}
								// given "[" === 91 & "]" === 93 hence forth 91 + 1 + 1 === 93
								case OPENBRACKET: {
									code++
								}
								// given "(" === 40 & ")" === 41 hence forth 40 + 1 === 41
								case OPENPARENTHESES: {
									code++
								}
								// quote tail delimiter is identical to the head delimiter hence noop,
								// fallthrough clauses have been shited to the correct tail delimiter
								case DOUBLEQUOTE:
								case SINGLEQUOTE: {
									while (caret++ < eol) {
										if (body.charCodeAt(caret) === code) {
											break
										}
									}
								}
							}

							if (counter === 0) {
								break
							}

							caret++
						}

						child = body.substring(length, caret)

						if (first === NULL) {
							first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0)
						}

						switch (first) {
							// @at-rule
							case AT: {
								if (format > 0) {
									chars = chars.replace(formatptn, '')
								}

								second = chars.charCodeAt(1)

								switch (second) {
									case DOCUMENT:
									case MEDIA:
									case SUPPORTS:
									case DASH: {
										selector = current
										break
									}
									default: {
										selector = array
									}
								}

								child = compile(current, selector, child, second, depth+1)
								length = child.length

								// preserve empty @at-rule
								if (preserve > 0 && length === 0) {
									length = chars.length
								}

								// execute plugins, @at-rule context
								if (plugged > 0) {
									selector = select(array, chars, invert)
									result = proxy(ATRUL, child, selector, current, line, column, length, second, depth, id)
									chars = selector.join('')

									if (result !== void 0) {
										if ((length = (child = result.trim()).length) === 0) {
											second = 0
											child = ''
										}
									}
								}

								if (length > 0) {
									switch (second) {
										case SUPPORTS: {
											chars = chars.replace(supportsptn, supports)
										}
										case DOCUMENT:
										case MEDIA:
										case DASH: {
											child = chars + '{' + child + '}'
											break
										}
										case KEYFRAME: {
											chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''))
											child = chars + '{' + child + '}'

											if (prefix === 1 || (prefix === 2 && vendor('@'+child, 3))) {
												child = '@' + webkit + child + '@' + child
											} else {
												child = '@' + child
											}
											break
										}
										default: {
											child = chars + child

											if (id === PAGE) {
												child = (out += child, '')
											}
										}
									}
								} else {
									child = ''
								}

								break
							}
							// selector
							default: {
								child = compile(current, select(current, chars, invert), child, id, depth+1)
							}
						}

						children += child

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						atrule = 0
						chars = ''
						child = ''
						code = body.charCodeAt(++caret)
						break
					}
					case CLOSEBRACES:
					case SEMICOLON: {
						chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim()

						if ((length = chars.length) > 1) {
							// monkey-patch missing colon
							if (pseudo === 0) {
								first = chars.charCodeAt(0)

								// first character is a letter or dash, buffer has a space character
								if ((first === DASH || first > 96 && first < 123)) {
									length = (chars = chars.replace(' ', ':')).length
								}
							}

							// execute plugins, property context
							if (plugged > 0) {
								if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth, id)) !== void 0) {
									if ((length = (chars = result.trim()).length) === 0) {
										chars = '\0\0'
									}
								}
							}

							first = chars.charCodeAt(0)
							second = chars.charCodeAt(1)

							switch (first) {
								case NULL: {
									break
								}
								case AT: {
									if (second === IMPORT || second === CHARSET) {
										flat += chars + body.charAt(caret)
										break
									}
								}
								default: {
									if (chars.charCodeAt(length-1) === COLON) {
										break
									}

									out += property(chars, first, second, chars.charCodeAt(2))
								}
							}
						}

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						chars = ''
						code = body.charCodeAt(++caret)
						break
					}
				}
			}

			// parse characters
			switch (code) {
				case CARRIAGE:
				case NEWLINE: {
					// auto insert semicolon
					if (comment + quote + parentheses + bracket + semicolon === 0) {
						// valid non-whitespace characters that
						// may precede a newline
						switch (peak) {
							case CLOSEPARENTHESES:
							case SINGLEQUOTE:
							case DOUBLEQUOTE:
							case AT:
							case TILDE:
							case GREATERTHAN:
							case STAR:
							case PLUS:
							case FOWARDSLASH:
							case DASH:
							case COLON:
							case COMMA:
							case SEMICOLON:
							case OPENBRACES:
							case CLOSEBRACES: {
								break
							}
							default: {
								// current buffer has a colon
								if (pseudo > 0) {
									insert = 1
								}
							}
						}
					}

					// terminate line comment
					if (comment === FOWARDSLASH) {
						comment = 0
					} else if (cascade + context === 0 && id !== KEYFRAME && chars.length > 0) {
						format = 1
						chars += '\0'
					}

					// execute plugins, newline context
					if (plugged * unkwn > 0) {
						proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth, id)
					}

					// next line, reset column position
					column = 1
					line++
					break
				}
				case SEMICOLON:
				case CLOSEBRACES: {
					if (comment + quote + parentheses + bracket === 0) {
						column++
						break
					}
				}
				default: {
					// increment column position
					column++

					// current character
					char = body.charAt(caret)

					// remove comments, escape functions, strings, attributes and prepare selectors
					switch (code) {
						case TAB:
						case SPACE: {
							if (quote + bracket + comment === 0) {
								switch (tail) {
									case COMMA:
									case COLON:
									case TAB:
									case SPACE: {
										char = ''
										break
									}
									default: {
										if (code !== SPACE) {
											char = ' '
										}
									}
								}
							}
							break
						}
						// escape breaking control characters
						case NULL: {
							char = '\\0'
							break
						}
						case FORMFEED: {
							char = '\\f'
							break
						}
						case VERTICALTAB: {
							char = '\\v'
							break
						}
						// &
						case AND: {
							// inverted selector pattern i.e html &
							if (quote + comment + bracket === 0 && cascade > 0) {
								invert = 1
								format = 1
								char = '\f' + char
							}
							break
						}
						// ::p<l>aceholder, l
						// :read-on<l>y, l
						case 108: {
							if (quote + comment + bracket + pattern === 0 && pseudo > 0) {
								switch (caret - pseudo) {
									// ::placeholder
									case 2: {
										if (tail === PLACEHOLDER && body.charCodeAt(caret-3) === COLON) {
											pattern = tail
										}
									}
									// :read-only
									case 8: {
										if (trail === READONLY) {
											pattern = trail
										}
									}
								}
							}
							break
						}
						// :<pattern>
						case COLON: {
							if (quote + comment + bracket === 0) {
								pseudo = caret
							}
							break
						}
						// selectors
						case COMMA: {
							if (comment + parentheses + quote + bracket === 0) {
								format = 1
								char += '\r'
							}
							break
						}
						// quotes
						case DOUBLEQUOTE: {
							if (comment === 0) {
								quote = quote === code ? 0 : (quote === 0 ? code : quote)
							}
							break
						}
						case SINGLEQUOTE: {
							if (comment === 0) {
								quote = quote === code ? 0 : (quote === 0 ? code : quote)
							}
							break
						}
						// attributes
						case OPENBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket++
							}
							break
						}
						case CLOSEBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket--
							}
							break
						}
						// functions
						case CLOSEPARENTHESES: {
							if (quote + comment + bracket === 0) {
								parentheses--
							}
							break
						}
						case OPENPARENTHESES: {
							if (quote + comment + bracket === 0) {
								if (context === 0) {
									switch (tail*2 + trail*3) {
										// :matches
										case 533: {
											break
										}
										// :global, :not, :nth-child etc...
										default: {
											counter = 0
											context = 1
										}
									}
								}

								parentheses++
							}
							break
						}
						case AT: {
							if (comment + parentheses + quote + bracket + pseudo + atrule === 0) {
								atrule = 1
							}
							break
						}
						// block/line comments
						case STAR:
						case FOWARDSLASH: {
							if (quote + bracket + parentheses > 0) {
								break
							}

							switch (comment) {
								// initialize line/block comment context
								case 0: {
									switch (code*2 + body.charCodeAt(caret+1)*3) {
										// //
										case 235: {
											comment = FOWARDSLASH
											break
										}
										// /*
										case 220: {
											length = caret
											comment = STAR
											break
										}
									}
									break
								}
								// end block comment context
								case STAR: {
									if (code === FOWARDSLASH && tail === STAR && length + 2 !== caret) {
										// /*<!> ... */, !
										if (body.charCodeAt(length+2) === 33) {
											out += body.substring(length, caret+1)
										}
										char = ''
										comment = 0
									}
								}
							}
						}
					}

					// ignore comment blocks
					if (comment === 0) {
						// aggressive isolation mode, divide each individual selector
						// including selectors in :not function but excluding selectors in :global function
						if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) {
							switch (code) {
								case COMMA:
								case TILDE:
								case GREATERTHAN:
								case PLUS:
								case CLOSEPARENTHESES:
								case OPENPARENTHESES: {
									if (context === 0) {
										// outside of an isolated context i.e nth-child(<...>)
										switch (tail) {
											case TAB:
											case SPACE:
											case NEWLINE:
											case CARRIAGE: {
												char = char + '\0'
												break
											}
											default: {
												char = '\0' + char + (code === COMMA ? '' : '\0')
											}
										}
										format = 1
									} else {
										// within an isolated context, sleep untill it's terminated
										switch (code) {
											case OPENPARENTHESES: {
												// :globa<l>(
												if (pseudo + 7 === caret && tail === 108) {
													pseudo = 0
												}
												context = ++counter
												break
											}
											case CLOSEPARENTHESES: {
												if ((context = --counter) === 0) {
													format = 1
													char += '\0'
												}
												break
											}
										}
									}
									break
								}
								case TAB:
								case SPACE: {
									switch (tail) {
										case NULL:
										case OPENBRACES:
										case CLOSEBRACES:
										case SEMICOLON:
										case COMMA:
										case FORMFEED:
										case TAB:
										case SPACE:
										case NEWLINE:
										case CARRIAGE: {
											break
										}
										default: {
											// ignore in isolated contexts
											if (context === 0) {
												format = 1
												char += '\0'
											}
										}
									}
								}
							}
						}

						// concat buffer of characters
						chars += char

						// previous non-whitespace character code
						if (code !== SPACE && code !== TAB) {
							peak = code
						}
					}
				}
			}

			// tail character codes
			trail = tail
			tail = code

			// visit every character
			caret++
		}

		length = out.length

		// preserve empty selector
 		if (preserve > 0) {
 			if (length === 0 && children.length === 0 && (current[0].length === 0) === false) {
 				if (id !== MEDIA || (current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0])) {
					length = current.join(',').length + 2
 				}
 			}
		}

		if (length > 0) {
			// cascade isolation mode?
			selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current

			// execute plugins, block context
			if (plugged > 0) {
				result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth, id)

				if (result !== void 0 && (out = result).length === 0) {
					return flat + out + children
				}
			}

			out = selector.join(',') + '{' + out + '}'

			if (prefix*pattern !== 0) {
				if (prefix === 2 && !vendor(out, 2))
					pattern = 0

				switch (pattern) {
					// ::read-only
					case READONLY: {
						out = out.replace(readonlyptn, ':'+moz+'$1')+out
						break
					}
					// ::placeholder
					case PLACEHOLDER: {
						out = (
							out.replace(plcholdrptn, '::' + webkit + 'input-$1') +
							out.replace(plcholdrptn, '::' + moz + '$1') +
							out.replace(plcholdrptn, ':' + ms + 'input-$1') + out
						)
						break
					}
				}

				pattern = 0
			}
		}

		return flat + out + children
	}

	/**
	 * Select
	 *
	 * @param {Array<string>} parent
	 * @param {string} current
	 * @param {number} invert
	 * @return {Array<string>}
	 */
	function select (parent, current, invert) {
		var selectors = current.trim().split(selectorptn)
		var out = selectors

		var length = selectors.length
		var l = parent.length

		switch (l) {
			// 0-1 parent selectors
			case 0:
			case 1: {
				for (var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i) {
					out[i] = scope(selector, out[i], invert, l).trim()
				}
				break
			}
			// >2 parent selectors, nested
			default: {
				for (var i = 0, j = 0, out = []; i < length; ++i) {
					for (var k = 0; k < l; ++k) {
						out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim()
					}
				}
			}
		}

		return out
	}

	/**
	 * Scope
	 *
	 * @param {string} parent
	 * @param {string} current
	 * @param {number} invert
	 * @param {number} level
	 * @return {string}
	 */
	function scope (parent, current, invert, level) {
		var selector = current
		var code = selector.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (selector = selector.trim()).charCodeAt(0)
		}

		switch (code) {
			// &
			case AND: {
				switch (cascade + level) {
					case 0:
					case 1: {
						if (parent.trim().length === 0) {
							break
						}
					}
					default: {
						return selector.replace(andptn, '$1'+parent.trim())
					}
				}
				break
			}
			// :
			case COLON: {
				switch (selector.charCodeAt(1)) {
					// g in :global
					case 103: {
						if (escape > 0 && cascade > 0) {
							return selector.replace(escapeptn, '$1').replace(andptn, '$1'+nscope)
						}
						break
					}
					default: {
						// :hover
						return parent.trim() + selector.replace(andptn, '$1'+parent.trim())
					}
				}
			}
			default: {
				// html &
				if (invert*cascade > 0 && selector.indexOf('\f') > 0) {
					return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1')+parent.trim())
				}
			}
		}

		return parent + selector
	}

	/**
	 * Property
	 *
	 * @param {string} input
	 * @param {number} first
	 * @param {number} second
	 * @param {number} third
	 * @return {string}
	 */
	function property (input, first, second, third) {
		var index = 0
		var out = input + ';'
		var hash = (first*2) + (second*3) + (third*4)
		var cache

		// animation: a, n, i characters
		if (hash === 944) {
			return animation(out)
		} else if (prefix === 0 || (prefix === 2 && !vendor(out, 1))) {
			return out
		}

		// vendor prefix
		switch (hash) {
			// text-decoration/text-size-adjust/text-shadow/text-align/text-transform: t, e, x
			case 1015: {
				// text-shadow/text-align/text-transform, a
				return out.charCodeAt(10) === 97 ? webkit + out + out : out
			}
			// filter/fill f, i, l
			case 951: {
				// filter, t
				return out.charCodeAt(3) === 116 ? webkit + out + out : out
			}
			// color/column, c, o, l
			case 963: {
				// column, n
				return out.charCodeAt(5) === 110 ? webkit + out + out : out
			}
			// box-decoration-break, b, o, x
			case 1009: {
				if (out.charCodeAt(4) !== 100) {
					break
				}
			}
			// mask, m, a, s
			// clip-path, c, l, i
			case 969:
			case 942: {
				return webkit + out + out
			}
			// appearance: a, p, p
			case 978: {
				return webkit + out + moz + out + out
			}
			// hyphens: h, y, p
			// user-select: u, s, e
			case 1019:
			case 983: {
				return webkit + out + moz + out + ms + out + out
			}
			// background/backface-visibility, b, a, c
			case 883: {
				// backface-visibility, -
				if (out.charCodeAt(8) === DASH) {
					return webkit + out + out
				}

				// image-set(...)
				if (out.indexOf('image-set(', 11) > 0) {
					return out.replace(imgsrcptn, '$1'+webkit+'$2') + out
				}

				return out
			}
			// flex: f, l, e
			case 932: {
				if (out.charCodeAt(4) === DASH) {
					switch (out.charCodeAt(5)) {
						// flex-grow, g
						case 103: {
							return webkit + 'box-' + out.replace('-grow', '') + webkit + out + ms + out.replace('grow', 'positive') + out
						}
						// flex-shrink, s
						case 115: {
							return webkit + out + ms + out.replace('shrink', 'negative') + out
						}
						// flex-basis, b
						case 98: {
							return webkit + out + ms + out.replace('basis', 'preferred-size') + out
						}
					}
				}

				return webkit + out + ms + out + out
			}
			// order: o, r, d
			case 964: {
				return webkit + out + ms + 'flex' + '-' + out + out
			}
			// justify-items/justify-content, j, u, s
			case 1023: {
				// justify-content, c
				if (out.charCodeAt(8) !== 99) {
					break
				}

				cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify')
				return webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out
			}
			// cursor, c, u, r
			case 1005: {
				return cursorptn.test(out) ? out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out : out
			}
			// writing-mode, w, r, i
			case 1000: {
				cache = out.substring(13).trim()
				index = cache.indexOf('-') + 1

				switch (cache.charCodeAt(0)+cache.charCodeAt(index)) {
					// vertical-lr
					case 226: {
						cache = out.replace(writingptn, 'tb')
						break
					}
					// vertical-rl
					case 232: {
						cache = out.replace(writingptn, 'tb-rl')
						break
					}
					// horizontal-tb
					case 220: {
						cache = out.replace(writingptn, 'lr')
						break
					}
					default: {
						return out
					}
				}

				return webkit + out + ms + cache + out
			}
			// position: sticky
			case 1017: {
				if (out.indexOf('sticky', 9) === -1) {
					return out
				}
			}
			// display(flex/inline-flex/inline-box): d, i, s
			case 975: {
				index = (out = input).length - 10
				cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim()

				switch (hash = cache.charCodeAt(0) + (cache.charCodeAt(7)|0)) {
					// inline-
					case 203: {
						// inline-box
						if (cache.charCodeAt(8) < 111) {
							break
						}
					}
					// inline-box/sticky
					case 115: {
						out = out.replace(cache, webkit+cache)+';'+out
						break
					}
					// inline-flex
					// flex
					case 207:
					case 102: {
						out = (
							out.replace(cache, webkit+(hash > 102 ? 'inline-' : '')+'box')+';'+
							out.replace(cache, webkit+cache)+';'+
							out.replace(cache, ms+cache+'box')+';'+
							out
						)
					}
				}

				return out + ';'
			}
			// align-items, align-center, align-self: a, l, i, -
			case 938: {
				if (out.charCodeAt(5) === DASH) {
					switch (out.charCodeAt(6)) {
						// align-items, i
						case 105: {
							cache = out.replace('-items', '')
							return webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out
						}
						// align-self, s
						case 115: {
							return webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out
						}
						// align-content
						default: {
							return webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '').replace(selfptn, '') + out
						}
					}
				}
				break
			}
			// min/max
			case 973:
			case 989: {
				// min-/max- height/width/block-size/inline-size
				if (out.charCodeAt(3) !== DASH || out.charCodeAt(4) === 122) {
					break
				}
			}
			// height/width: min-content / width: max-content
			case 931:
			case 953: {
				if (dimensionptn.test(input) === true) {
					// stretch
					if ((cache = input.substring(input.indexOf(':') + 1)).charCodeAt(0) === 115)
						return property(input.replace('stretch', 'fill-available'), first, second, third).replace(':fill-available', ':stretch')
					else
						return out.replace(cache, webkit + cache) + out.replace(cache, moz + cache.replace('fill-', '')) + out
				}
				break
			}
			// transform, transition: t, r, a
			case 962: {
				out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out

				// transitions
				if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) {
					return out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out
				}

				break
			}
		}

		return out
	}

	/**
	 * Vendor
	 *
	 * @param {string} content
	 * @param {number} context
	 * @return {boolean}
	 */
	function vendor (content, context) {
		var index = content.indexOf(context === 1 ? ':' : '{')
		var key = content.substring(0, context !== 3 ? index : 10)
		var value = content.substring(index + 1, content.length - 1)

		return should(context !== 2 ? key : key.replace(pseudofmt, '$1'), value, context)
	}

	/**
	 * Supports
	 *
	 * @param {string} match
	 * @param {string} group
	 * @return {string}
	 */
	function supports (match, group) {
		var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2))

		return out !== group+';' ? out.replace(propertyptn, ' or ($1)').substring(4) : '('+group+')'
	}

	/**
	 * Animation
	 *
	 * @param {string} input
	 * @return {string}
	 */
	function animation (input) {
		var length = input.length
		var index = input.indexOf(':', 9) + 1
		var declare = input.substring(0, index).trim()
		var out = input.substring(index, length-1).trim()

		switch (input.charCodeAt(9)*keyed) {
			case 0: {
				break
			}
			// animation-*, -
			case DASH: {
				// animation-name, n
				if (input.charCodeAt(10) !== 110) {
					break
				}
			}
			// animation/animation-name
			default: {
				// split in case of multiple animations
				var list = out.split((out = '', animationptn))

				for (var i = 0, index = 0, length = list.length; i < length; index = 0, ++i) {
					var value = list[i]
					var items = value.split(propertiesptn)

					while (value = items[index]) {
						var peak = value.charCodeAt(0)

						if (keyed === 1 && (
							// letters
							(peak > AT && peak < 90) || (peak > 96 && peak < 123) || peak === UNDERSCORE ||
							// dash but not in sequence i.e --
							(peak === DASH && value.charCodeAt(1) !== DASH)
						)) {
							// not a number/function
							switch (isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)) {
								case 1: {
									switch (value) {
										// not a valid reserved keyword
										case 'infinite': case 'alternate': case 'backwards': case 'running':
										case 'normal': case 'forwards': case 'both': case 'none': case 'linear':
										case 'ease': case 'ease-in': case 'ease-out': case 'ease-in-out':
										case 'paused': case 'reverse': case 'alternate-reverse': case 'inherit':
										case 'initial': case 'unset': case 'step-start': case 'step-end': {
											break
										}
										default: {
											value += key
										}
									}
								}
							}
						}

						items[index++] = value
					}

					out += (i === 0 ? '' : ',') + items.join(' ')
				}
			}
		}

		out = declare + out + ';'

		if (prefix === 1 || (prefix === 2 && vendor(out, 1)))
			return webkit + out + out

		return out
	}

	/**
	 * Isolate
	 *
	 * @param {Array<string>} current
	 */
	function isolate (current) {
		for (var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i) {
			// split individual elements in a selector i.e h1 h2 === [h1, h2]
			var elements = current[i].split(elementptn)
			var out = ''

			for (var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j) {
				// empty element
				if ((size = (element = elements[j]).length) === 0 && l > 1) {
					continue
				}

				tail = out.charCodeAt(out.length-1)
				code = element.charCodeAt(0)
				padding = ''

				if (j !== 0) {
					// determine if we need padding
					switch (tail) {
						case STAR:
						case TILDE:
						case GREATERTHAN:
						case PLUS:
						case SPACE:
						case OPENPARENTHESES:  {
							break
						}
						default: {
							padding = ' '
						}
					}
				}

				switch (code) {
					case AND: {
						element = padding + nscopealt
					}
					case TILDE:
					case GREATERTHAN:
					case PLUS:
					case SPACE:
					case CLOSEPARENTHESES:
					case OPENPARENTHESES: {
						break
					}
					case OPENBRACKET: {
						element = padding + element + nscopealt
						break
					}
					case COLON: {
						switch (element.charCodeAt(1)*2 + element.charCodeAt(2)*3) {
							// :global
							case 530: {
								if (escape > 0) {
									element = padding + element.substring(8, size - 1)
									break
								}
							}
							// :hover, :nth-child(), ...
							default: {
								if (j < 1 || elements[j-1].length < 1) {
									element = padding + nscopealt + element
								}
							}
						}
						break
					}
					case COMMA: {
						padding = ''
					}
					default: {
						if (size > 1 && element.indexOf(':') > 0) {
							element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2')
						} else {
							element = padding + element + nscopealt
						}
					}
				}

				out += element
			}

			selector[i] = out.replace(formatptn, '').trim()
		}

		return selector
	}

	/**
	 * Proxy
	 *
	 * @param {number} context
	 * @param {string} content
	 * @param {Array<string>} selectors
	 * @param {Array<string>} parents
	 * @param {number} line
	 * @param {number} column
	 * @param {number} length
	 * @param {number} id
	 * @param {number} depth
	 * @param {number} at
	 * @return {(string|void|*)}
	 */
	function proxy (context, content, selectors, parents, line, column, length, id, depth, at) {
		for (var i = 0, out = content, next; i < plugged; ++i) {
			switch (next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth, at)) {
				case void 0:
				case false:
				case true:
				case null: {
					break
				}
				default: {
					out = next
				}
			}
		}

		switch (out) {
			case void 0:
			case false:
			case true:
			case null:
			case content: {
				break
			}
			default: {
				return out
			}
		}
	}

	/**
	 * @param {number} code
	 * @param {number} index
	 * @param {number} length
	 * @param {string} body
	 * @return {number}
	 */
	function delimited (code, index, length, body) {
		for (var i = index + 1; i < length; ++i) {
			switch (body.charCodeAt(i)) {
				// /*
				case FOWARDSLASH: {
					if (code === STAR) {
						if (body.charCodeAt(i - 1) === STAR &&  index + 2 !== i) {
							return i + 1
						}
					}
					break
				}
				// //
				case NEWLINE: {
					if (code === FOWARDSLASH) {
						return i + 1
					}
				}
			}
		}

		return i
	}

	/**
	 * @param {number} type
	 * @param {number} index
	 * @param {number} length
	 * @param {number} find
	 * @param {string} body
	 * @return {number}
	 */
	function match (type, index, length, body) {
		for (var i = index + 1; i < length; ++i) {
			switch (body.charCodeAt(i)) {
				case type: {
					return i
				}
			}
		}

		return i
	}

	/**
	 * Minify
	 *
	 * @param {(string|*)} output
	 * @return {string}
	 */
	function minify (output) {
		return output
			.replace(formatptn, '')
			.replace(beforeptn, '')
			.replace(afterptn, '$1')
			.replace(tailptn, '$1')
			.replace(whiteptn, ' ')
	}

	/**
	 * Use
	 *
	 * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
	 */
	function use (plugin) {
		switch (plugin) {
			case void 0:
			case null: {
				plugged = plugins.length = 0
				break
			}
			default: {
				switch (plugin.constructor) {
					case Array: {
						for (var i = 0, length = plugin.length; i < length; ++i) {
							use(plugin[i])
						}
						break
					}
					case Function: {
						plugins[plugged++] = plugin
						break
					}
					case Boolean: {
						unkwn = !!plugin|0
					}
				}
			}
 		}

 		return use
	}

	/**
	 * Set
	 *
	 * @param {*} options
	 */
	function set (options) {
		for (var name in options) {
			var value = options[name]
			switch (name) {
				case 'keyframe': keyed = value|0; break
				case 'global': escape = value|0; break
				case 'cascade': cascade = value|0; break
				case 'compress': compress = value|0; break
				case 'semicolon': semicolon = value|0; break
				case 'preserve': preserve = value|0; break
				case 'prefix':
					should = null

					if (!value) {
						prefix = 0
					} else if (typeof value !== 'function') {
						prefix = 1
					} else {
						prefix = 2
						should = value
					}
			}
		}

		return set
	}

	/**
	 * Stylis
	 *
	 * @param {string} selector
	 * @param {string} input
	 * @return {*}
	 */
	function stylis (selector, input) {
		if (this !== void 0 && this.constructor === stylis) {
			return factory(selector)
		}

		// setup
		var ns = selector
		var code = ns.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (ns = ns.trim()).charCodeAt(0)
		}

		// keyframe/animation namespace
		if (keyed > 0) {
			key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-')
		}

		// reset, used to assert if a plugin is moneky-patching the return value
		code = 1

		// cascade/isolate
		if (cascade === 1) {
			nscope = ns
		} else {
			nscopealt = ns
		}

		var selectors = [nscope]
		var result

		// execute plugins, pre-process context
		if (plugged > 0) {
			result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0, 0)

			if (result !== void 0 && typeof result === 'string') {
				input = result
			}
		}

		// build
		var output = compile(array, selectors, input, 0, 0)

		// execute plugins, post-process context
		if (plugged > 0) {
			result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0, 0)

			// bypass minification
			if (result !== void 0 && typeof(output = result) !== 'string') {
				code = 0
			}
		}

		// reset
		key = ''
		nscope = ''
		nscopealt = ''
		pattern = 0
		line = 1
		column = 1

		return compress*code === 0 ? output : minify(output)
	}

	stylis['use'] = use
	stylis['set'] = set

	if (options !== void 0) {
		set(options)
	}

	return stylis
}));


/***/ }),
/* 1982 */,
/* 1983 */,
/* 1984 */
/***/ (function(module, exports) {

function E () {
  // Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
  on: function (name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function (name, callback, ctx) {
    var self = this;
    function listener () {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    };

    listener._ = callback
    return this.on(name, listener, ctx);
  },

  emit: function (name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function (name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    (liveEvents.length)
      ? e[name] = liveEvents
      : delete e[name];

    return this;
  }
};

module.exports = E;


/***/ }),
/* 1985 */,
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(814);


/***/ })
],[1986]);


// WEBPACK FOOTER //
// js/app.f605b460a89862c6ebfd.js